(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8abc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8abc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3hyzP", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $263dc7dcf0670b1f$export$ffb0004e005737fa; }, function (v) { return $263dc7dcf0670b1f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $263dc7dcf0670b1f$export$34b9dba7ce09269b; }, function (v) { return $263dc7dcf0670b1f$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $263dc7dcf0670b1f$export$25062201e9e25d76; }, function (v) { return $263dc7dcf0670b1f$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $263dc7dcf0670b1f$export$ffb0004e005737fa;
var $263dc7dcf0670b1f$export$34b9dba7ce09269b;
var $263dc7dcf0670b1f$export$25062201e9e25d76;
"use strict";

var $33gHU = parcelRequire("33gHU");
var $263dc7dcf0670b1f$var$k = Symbol.for("react.element"), $263dc7dcf0670b1f$var$l = Symbol.for("react.fragment"), $263dc7dcf0670b1f$var$m = Object.prototype.hasOwnProperty, $263dc7dcf0670b1f$var$n = $33gHU.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $263dc7dcf0670b1f$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $263dc7dcf0670b1f$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$263dc7dcf0670b1f$var$m.call(a, b) && !$263dc7dcf0670b1f$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $263dc7dcf0670b1f$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $263dc7dcf0670b1f$var$n.current
    };
}
$263dc7dcf0670b1f$export$ffb0004e005737fa = $263dc7dcf0670b1f$var$l;
$263dc7dcf0670b1f$export$34b9dba7ce09269b = $263dc7dcf0670b1f$var$q;
$263dc7dcf0670b1f$export$25062201e9e25d76 = $263dc7dcf0670b1f$var$q;

});
parcelRegister("33gHU", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hQyZI"));

});
parcelRegister("hQyZI", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $cfe2702563eccd2a$export$dca3b0875bd9a954; }, function (v) { return $cfe2702563eccd2a$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $cfe2702563eccd2a$export$16fa2f45be04daa8; }, function (v) { return $cfe2702563eccd2a$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cfe2702563eccd2a$export$ffb0004e005737fa; }, function (v) { return $cfe2702563eccd2a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $cfe2702563eccd2a$export$e2c29f18771995cb; }, function (v) { return $cfe2702563eccd2a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $cfe2702563eccd2a$export$221d75b3f55bb0bd; }, function (v) { return $cfe2702563eccd2a$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cfe2702563eccd2a$export$5f8d39834fd61797; }, function (v) { return $cfe2702563eccd2a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cfe2702563eccd2a$export$74bf444e3cd11ea5; }, function (v) { return $cfe2702563eccd2a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $cfe2702563eccd2a$export$ae55be85d98224ed; }, function (v) { return $cfe2702563eccd2a$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $cfe2702563eccd2a$export$3ba232387fd5d6dd; }, function (v) { return $cfe2702563eccd2a$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $cfe2702563eccd2a$export$e530037191fcd5d7; }, function (v) { return $cfe2702563eccd2a$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $cfe2702563eccd2a$export$fd42f52fd3ae1109; }, function (v) { return $cfe2702563eccd2a$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $cfe2702563eccd2a$export$c8a8987d4410bf2d; }, function (v) { return $cfe2702563eccd2a$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $cfe2702563eccd2a$export$d38cd72104c1f0e9; }, function (v) { return $cfe2702563eccd2a$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $cfe2702563eccd2a$export$7d1e3a5e95ceca43; }, function (v) { return $cfe2702563eccd2a$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $cfe2702563eccd2a$export$257a8862b851cb5b; }, function (v) { return $cfe2702563eccd2a$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $cfe2702563eccd2a$export$a8257692ac88316c; }, function (v) { return $cfe2702563eccd2a$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $cfe2702563eccd2a$export$488013bae63b21da; }, function (v) { return $cfe2702563eccd2a$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $cfe2702563eccd2a$export$7c73462e0d25e514; }, function (v) { return $cfe2702563eccd2a$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $cfe2702563eccd2a$export$7568632d0d33d16d; }, function (v) { return $cfe2702563eccd2a$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $cfe2702563eccd2a$export$88948ce120ea2619; }, function (v) { return $cfe2702563eccd2a$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $cfe2702563eccd2a$export$35808ee640e87ca7; }, function (v) { return $cfe2702563eccd2a$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $cfe2702563eccd2a$export$fae74005e78b1a27; }, function (v) { return $cfe2702563eccd2a$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $cfe2702563eccd2a$export$dc8fbce3eb94dc1e; }, function (v) { return $cfe2702563eccd2a$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $cfe2702563eccd2a$export$6a7bc4e911dc01cf; }, function (v) { return $cfe2702563eccd2a$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $cfe2702563eccd2a$export$6d9c69b0de29b591; }, function (v) { return $cfe2702563eccd2a$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $cfe2702563eccd2a$export$f680877a34711e37; }, function (v) { return $cfe2702563eccd2a$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $cfe2702563eccd2a$export$d5a552a76deda3c2; }, function (v) { return $cfe2702563eccd2a$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $cfe2702563eccd2a$export$aaabe4eda9ed9969; }, function (v) { return $cfe2702563eccd2a$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $cfe2702563eccd2a$export$e5c5a5f917a5871c; }, function (v) { return $cfe2702563eccd2a$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $cfe2702563eccd2a$export$1538c33de8887b59; }, function (v) { return $cfe2702563eccd2a$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $cfe2702563eccd2a$export$13e3392192263954; }, function (v) { return $cfe2702563eccd2a$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $cfe2702563eccd2a$export$b8f5890fc79d6aca; }, function (v) { return $cfe2702563eccd2a$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $cfe2702563eccd2a$export$60241385465d0a34; }, function (v) { return $cfe2702563eccd2a$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $cfe2702563eccd2a$export$306c0aa65ff9ec16; }, function (v) { return $cfe2702563eccd2a$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $cfe2702563eccd2a$export$7b286972b8d8ccbf; }, function (v) { return $cfe2702563eccd2a$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $cfe2702563eccd2a$export$83d89fbfd8236492; }, function (v) { return $cfe2702563eccd2a$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $gnDeW = parcelRequire("gnDeW");
var $cfe2702563eccd2a$export$dca3b0875bd9a954;
var $cfe2702563eccd2a$export$16fa2f45be04daa8;
var $cfe2702563eccd2a$export$ffb0004e005737fa;
var $cfe2702563eccd2a$export$e2c29f18771995cb;
var $cfe2702563eccd2a$export$221d75b3f55bb0bd;
var $cfe2702563eccd2a$export$5f8d39834fd61797;
var $cfe2702563eccd2a$export$74bf444e3cd11ea5;
var $cfe2702563eccd2a$export$ae55be85d98224ed;
var $cfe2702563eccd2a$export$3ba232387fd5d6dd;
var $cfe2702563eccd2a$export$e530037191fcd5d7;
var $cfe2702563eccd2a$export$fd42f52fd3ae1109;
var $cfe2702563eccd2a$export$c8a8987d4410bf2d;
var $cfe2702563eccd2a$export$d38cd72104c1f0e9;
var $cfe2702563eccd2a$export$7d1e3a5e95ceca43;
var $cfe2702563eccd2a$export$257a8862b851cb5b;
var $cfe2702563eccd2a$export$a8257692ac88316c;
var $cfe2702563eccd2a$export$488013bae63b21da;
var $cfe2702563eccd2a$export$7c73462e0d25e514;
var $cfe2702563eccd2a$export$7568632d0d33d16d;
var $cfe2702563eccd2a$export$88948ce120ea2619;
var $cfe2702563eccd2a$export$35808ee640e87ca7;
var $cfe2702563eccd2a$export$fae74005e78b1a27;
var $cfe2702563eccd2a$export$dc8fbce3eb94dc1e;
var $cfe2702563eccd2a$export$6a7bc4e911dc01cf;
var $cfe2702563eccd2a$export$6d9c69b0de29b591;
var $cfe2702563eccd2a$export$f680877a34711e37;
var $cfe2702563eccd2a$export$d5a552a76deda3c2;
var $cfe2702563eccd2a$export$aaabe4eda9ed9969;
var $cfe2702563eccd2a$export$e5c5a5f917a5871c;
var $cfe2702563eccd2a$export$1538c33de8887b59;
var $cfe2702563eccd2a$export$13e3392192263954;
var $cfe2702563eccd2a$export$b8f5890fc79d6aca;
var $cfe2702563eccd2a$export$60241385465d0a34;
var $cfe2702563eccd2a$export$306c0aa65ff9ec16;
var $cfe2702563eccd2a$export$7b286972b8d8ccbf;
var $cfe2702563eccd2a$export$83d89fbfd8236492;
"use strict";
var $cfe2702563eccd2a$var$l = Symbol.for("react.element"), $cfe2702563eccd2a$var$n = Symbol.for("react.portal"), $cfe2702563eccd2a$var$p = Symbol.for("react.fragment"), $cfe2702563eccd2a$var$q = Symbol.for("react.strict_mode"), $cfe2702563eccd2a$var$r = Symbol.for("react.profiler"), $cfe2702563eccd2a$var$t = Symbol.for("react.provider"), $cfe2702563eccd2a$var$u = Symbol.for("react.context"), $cfe2702563eccd2a$var$v = Symbol.for("react.forward_ref"), $cfe2702563eccd2a$var$w = Symbol.for("react.suspense"), $cfe2702563eccd2a$var$x = Symbol.for("react.memo"), $cfe2702563eccd2a$var$y = Symbol.for("react.lazy"), $cfe2702563eccd2a$var$z = Symbol.iterator;
function $cfe2702563eccd2a$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $cfe2702563eccd2a$var$z && a[$cfe2702563eccd2a$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $cfe2702563eccd2a$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $cfe2702563eccd2a$var$C = Object.assign, $cfe2702563eccd2a$var$D = {};
function $cfe2702563eccd2a$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $cfe2702563eccd2a$var$D;
    this.updater = e || $cfe2702563eccd2a$var$B;
}
$cfe2702563eccd2a$var$E.prototype.isReactComponent = {};
$cfe2702563eccd2a$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$cfe2702563eccd2a$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $cfe2702563eccd2a$var$F() {}
$cfe2702563eccd2a$var$F.prototype = $cfe2702563eccd2a$var$E.prototype;
function $cfe2702563eccd2a$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $cfe2702563eccd2a$var$D;
    this.updater = e || $cfe2702563eccd2a$var$B;
}
var $cfe2702563eccd2a$var$H = $cfe2702563eccd2a$var$G.prototype = new $cfe2702563eccd2a$var$F;
$cfe2702563eccd2a$var$H.constructor = $cfe2702563eccd2a$var$G;
$cfe2702563eccd2a$var$C($cfe2702563eccd2a$var$H, $cfe2702563eccd2a$var$E.prototype);
$cfe2702563eccd2a$var$H.isPureReactComponent = !0;
var $cfe2702563eccd2a$var$I = Array.isArray, $cfe2702563eccd2a$var$J = Object.prototype.hasOwnProperty, $cfe2702563eccd2a$var$K = {
    current: null
}, $cfe2702563eccd2a$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $cfe2702563eccd2a$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$cfe2702563eccd2a$var$J.call(b, d) && !$cfe2702563eccd2a$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $cfe2702563eccd2a$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $cfe2702563eccd2a$var$K.current
    };
}
function $cfe2702563eccd2a$var$N(a, b) {
    return {
        $$typeof: $cfe2702563eccd2a$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $cfe2702563eccd2a$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cfe2702563eccd2a$var$l;
}
function $cfe2702563eccd2a$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $cfe2702563eccd2a$var$P = /\/+/g;
function $cfe2702563eccd2a$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $cfe2702563eccd2a$var$escape("" + a.key) : b.toString(36);
}
function $cfe2702563eccd2a$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $gnDeW._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $cfe2702563eccd2a$var$l:
                case $cfe2702563eccd2a$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $cfe2702563eccd2a$var$Q(h, 0) : d, $cfe2702563eccd2a$var$I(c) ? (e = "", null != a && (e = a.replace($cfe2702563eccd2a$var$P, "$&/") + "/"), $cfe2702563eccd2a$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($cfe2702563eccd2a$var$O(c) && (c = $cfe2702563eccd2a$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($cfe2702563eccd2a$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($cfe2702563eccd2a$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $cfe2702563eccd2a$var$Q(k, g);
        h += $cfe2702563eccd2a$var$R(k, b, e, f, c);
    }
    else if (f = $cfe2702563eccd2a$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $cfe2702563eccd2a$var$Q(k, g++), h += $cfe2702563eccd2a$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $cfe2702563eccd2a$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $cfe2702563eccd2a$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $cfe2702563eccd2a$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $cfe2702563eccd2a$var$U = {
    current: null
}, $cfe2702563eccd2a$var$V = {
    transition: null
}, $cfe2702563eccd2a$var$W = {
    ReactCurrentDispatcher: $cfe2702563eccd2a$var$U,
    ReactCurrentBatchConfig: $cfe2702563eccd2a$var$V,
    ReactCurrentOwner: $cfe2702563eccd2a$var$K
};
function $cfe2702563eccd2a$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$cfe2702563eccd2a$export$dca3b0875bd9a954 = {
    map: $cfe2702563eccd2a$var$S,
    forEach: function forEach(a, b, e) {
        $cfe2702563eccd2a$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $cfe2702563eccd2a$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $cfe2702563eccd2a$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$cfe2702563eccd2a$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$cfe2702563eccd2a$export$16fa2f45be04daa8 = $cfe2702563eccd2a$var$E;
$cfe2702563eccd2a$export$ffb0004e005737fa = $cfe2702563eccd2a$var$p;
$cfe2702563eccd2a$export$e2c29f18771995cb = $cfe2702563eccd2a$var$r;
$cfe2702563eccd2a$export$221d75b3f55bb0bd = $cfe2702563eccd2a$var$G;
$cfe2702563eccd2a$export$5f8d39834fd61797 = $cfe2702563eccd2a$var$q;
$cfe2702563eccd2a$export$74bf444e3cd11ea5 = $cfe2702563eccd2a$var$w;
$cfe2702563eccd2a$export$ae55be85d98224ed = $cfe2702563eccd2a$var$W;
$cfe2702563eccd2a$export$3ba232387fd5d6dd = $cfe2702563eccd2a$var$X;
$cfe2702563eccd2a$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $cfe2702563eccd2a$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $cfe2702563eccd2a$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$cfe2702563eccd2a$var$J.call(b, f) && !$cfe2702563eccd2a$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $cfe2702563eccd2a$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$cfe2702563eccd2a$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $cfe2702563eccd2a$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $cfe2702563eccd2a$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$cfe2702563eccd2a$export$c8a8987d4410bf2d = $cfe2702563eccd2a$var$M;
$cfe2702563eccd2a$export$d38cd72104c1f0e9 = function(a) {
    var b = $cfe2702563eccd2a$var$M.bind(null, a);
    b.type = a;
    return b;
};
$cfe2702563eccd2a$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$cfe2702563eccd2a$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $cfe2702563eccd2a$var$v,
        render: a
    };
};
$cfe2702563eccd2a$export$a8257692ac88316c = $cfe2702563eccd2a$var$O;
$cfe2702563eccd2a$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $cfe2702563eccd2a$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $cfe2702563eccd2a$var$T
    };
};
$cfe2702563eccd2a$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $cfe2702563eccd2a$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$cfe2702563eccd2a$export$7568632d0d33d16d = function(a) {
    var b = $cfe2702563eccd2a$var$V.transition;
    $cfe2702563eccd2a$var$V.transition = {};
    try {
        a();
    } finally{
        $cfe2702563eccd2a$var$V.transition = b;
    }
};
$cfe2702563eccd2a$export$88948ce120ea2619 = $cfe2702563eccd2a$var$X;
$cfe2702563eccd2a$export$35808ee640e87ca7 = function(a, b) {
    return $cfe2702563eccd2a$var$U.current.useCallback(a, b);
};
$cfe2702563eccd2a$export$fae74005e78b1a27 = function(a) {
    return $cfe2702563eccd2a$var$U.current.useContext(a);
};
$cfe2702563eccd2a$export$dc8fbce3eb94dc1e = function() {};
$cfe2702563eccd2a$export$6a7bc4e911dc01cf = function(a) {
    return $cfe2702563eccd2a$var$U.current.useDeferredValue(a);
};
$cfe2702563eccd2a$export$6d9c69b0de29b591 = function(a, b) {
    return $cfe2702563eccd2a$var$U.current.useEffect(a, b);
};
$cfe2702563eccd2a$export$f680877a34711e37 = function() {
    return $cfe2702563eccd2a$var$U.current.useId();
};
$cfe2702563eccd2a$export$d5a552a76deda3c2 = function(a, b, e) {
    return $cfe2702563eccd2a$var$U.current.useImperativeHandle(a, b, e);
};
$cfe2702563eccd2a$export$aaabe4eda9ed9969 = function(a, b) {
    return $cfe2702563eccd2a$var$U.current.useInsertionEffect(a, b);
};
$cfe2702563eccd2a$export$e5c5a5f917a5871c = function(a, b) {
    return $cfe2702563eccd2a$var$U.current.useLayoutEffect(a, b);
};
$cfe2702563eccd2a$export$1538c33de8887b59 = function(a, b) {
    return $cfe2702563eccd2a$var$U.current.useMemo(a, b);
};
$cfe2702563eccd2a$export$13e3392192263954 = function(a, b, e) {
    return $cfe2702563eccd2a$var$U.current.useReducer(a, b, e);
};
$cfe2702563eccd2a$export$b8f5890fc79d6aca = function(a) {
    return $cfe2702563eccd2a$var$U.current.useRef(a);
};
$cfe2702563eccd2a$export$60241385465d0a34 = function(a) {
    return $cfe2702563eccd2a$var$U.current.useState(a);
};
$cfe2702563eccd2a$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $cfe2702563eccd2a$var$U.current.useSyncExternalStore(a, b, e);
};
$cfe2702563eccd2a$export$7b286972b8d8ccbf = function() {
    return $cfe2702563eccd2a$var$U.current.useTransition();
};
$cfe2702563eccd2a$export$83d89fbfd8236492 = "18.3.1";

});
parcelRegister("gnDeW", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $becd3b9499501ed5$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $becd3b9499501ed5$export$5f0017c582d45a2d; });
function $becd3b9499501ed5$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});




parcelRegister("b0lSM", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "isObservableObject", function () { return isObservableObject; });
$parcel$export(module.exports, "isObservableArray", function () { return isObservableArray; });
$parcel$export(module.exports, "isObservableMap", function () { return isObservableMap; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "_allowStateChanges", function () { return allowStateChanges; });
$parcel$export(module.exports, "autorun", function () { return autorun; });
$parcel$export(module.exports, "untracked", function () { return untracked; });
$parcel$export(module.exports, "_getGlobalState", function () { return getGlobalState; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "reaction", function () { return reaction; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "values", function () { return values; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });

var $gnDeW = parcelRequire("gnDeW");
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value);
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
function isES6Map(thing) {
    return thing instanceof Map;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function ownKeys(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if ((typeof key === "undefined" ? "undefined" : (0, $gnDeW._)(key)) === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $gnDeW._)(key)) === "symbol" ? key : String(key);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.isPendingUnobservation = false;
        this.isBeingObserved = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // onBecomeObservedListeners
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return Atom;
}();
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    // Backwards/Legacy behavior, expects makeObservable(this)
    if (kind == "field") {
        addInitializer(function() {
            storeAnnotation(this, name, ann);
        });
        return;
    }
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var _Symbol$toPrimitive;
var CREATE = "create";
_Symbol$toPrimitive = Symbol.toPrimitive;
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    _inheritsLoose(ObservableValue, _Atom);
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
var _Symbol$toPrimitive$1;
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ _Symbol$toPrimitive$1 = Symbol.toPrimitive;
var ComputedValue = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    // during tracking it's an array with new observed observers
    // N.B: unminified as it is used by MST
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        this.newObserving_ = null;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive$1] = function() {
        return this.valueOf();
    };
    _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        }
    ]);
    return ComputedValue;
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue_ === 0) {
            dep.diffValue_ = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue_ === 0) removeObserver(_dep, derivation);
        _dep.diffValue_ = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue_ === 1) {
            _dep2.diffValue_ = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    this.version = 6;
    this.UNCHANGED = {};
    this.trackingDerivation = null;
    this.trackingContext = null;
    this.runId = 0;
    this.mobxGuid = 0;
    this.inBatch = 0;
    this.pendingUnobservations = [];
    this.pendingReactions = [];
    this.isRunningReactions = false;
    this.allowStateChanges = false;
    this.allowStateReads = true;
    this.enforceActions = true;
    this.spyListeners = [];
    this.globalReactionErrorHandlers = [];
    this.computedRequiresReaction = false;
    this.reactionRequiresObservable = false;
    this.observableRequiresReaction = false;
    this.disableErrorBoundaries = false;
    this.suppressReactionErrors = false;
    this.useProxies = true;
    this.verifyProxies = false;
    this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "	".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.isDisposed_ = false;
        this.isScheduled_ = false;
        this.isTrackPending_ = false;
        this.isRunning_ = false;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled_) {
            this.isScheduled_ = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.isScheduled = function isScheduled() {
        return this.isScheduled_;
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed_) {
            startBatch();
            this.isScheduled_ = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending_ = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed_) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning_ = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning_ = false;
        this.isTrackPending_ = false;
        if (this.isDisposed_) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed_) {
            this.isDisposed_ = true;
            if (!this.isRunning_) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return Reaction;
}();
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts2$signal, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed_) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2$signal = _opts2.signal) != null && _opts2$signal.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts4$signal, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed_) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4$signal = _opts4.signal) != null && _opts4$signal.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed_) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null ? void 0 : (_opts$signal3 = opts.signal) == null ? void 0 : _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if ((typeof name === "undefined" ? "undefined" : (0, $gnDeW._)(name)) === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    // this is the prop that gets proxied, so can't replace it!
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var _Symbol$iterator, _Symbol$toStringTag;
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
var ObservableMap = /*#__PURE__*/ function() {
    // hasMap, not hashMap >-).
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[_Symbol$iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (other.constructor !== Map) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
    return ObservableMap;
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var _Symbol$iterator$1, _Symbol$toStringTag$1;
var ObservableSetMarker = {};
_Symbol$iterator$1 = Symbol.iterator;
_Symbol$toStringTag$1 = Symbol.toStringTag;
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
        // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[_Symbol$iterator$1] = function() {
        return this.values();
    };
    _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag$1,
            get: function get() {
                return "Set";
            }
        }
    ]);
    return ObservableSet;
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_, _this$pendingKeys_$ge;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_$ge = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_$ge.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2, _this$pendingKeys_2$g;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2$g = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2$g.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray, _Symbol$toStringTag, _Symbol$iterator) {
    _inheritsLoose(LegacyObservableArray, _StubArray);
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _assertThisInitialized(_this);
            addHiddenFinalProp(_assertThisInitialized(_this), $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_assertThisInitialized(_this), "0", ENTRY_0);
        });
        return _this;
    }
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[_Symbol$iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
    return LegacyObservableArray;
}(StubArray, Symbol.toStringTag, Symbol.iterator);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a === "undefined" ? "undefined" : (0, $gnDeW._)(a);
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("b6033", function(module, exports) {

$parcel$export(module.exports, "Timestamp", function () { return Timestamp; });
$parcel$export(module.exports, "collection", function () { return collection; });
$parcel$export(module.exports, "doc", function () { return doc; });
$parcel$export(module.exports, "getFirestore", function () { return getFirestore; });
$parcel$export(module.exports, "setDoc", function () { return setDoc; });
$parcel$export(module.exports, "deleteDoc", function () { return deleteDoc; });
$parcel$export(module.exports, "onSnapshot", function () { return onSnapshot; });

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $2xfp5 = parcelRequire("2xfp5");

var $6rpfc = parcelRequire("6rpfc");

var $jLCbM = parcelRequire("jLCbM");

var $laF8D = parcelRequire("laF8D");

var $iNfU4 = parcelRequire("iNfU4");

var $hSCyS = parcelRequire("hSCyS");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $gnDeW = parcelRequire("gnDeW");

var $etlBe = parcelRequire("etlBe");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");

var $lF1I7 = parcelRequire("lF1I7");

var $ilNGG = parcelRequire("ilNGG");

var $e5K63 = parcelRequire("e5K63");

var $3DJ6n = parcelRequire("3DJ6n");

var $gQ5gw = parcelRequire("gQ5gw");

var $iFOaV = parcelRequire("iFOaV");

var $2B9VL = parcelRequire("2B9VL");

var $hZFWO = parcelRequire("hZFWO");

var $9iKK3 = parcelRequire("9iKK3");
var $81404ad005fd14bc$require$Buffer = $9iKK3.Buffer;
var S = "@firebase/firestore";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ var User = /*#__PURE__*/ function() {
    "use strict";
    function User(e) {
        (0, $19mwo._)(this, User);
        this.uid = e;
    }
    (0, $6rpfc._)(User, [
        {
            key: "isAuthenticated",
            value: function isAuthenticated() {
                return null != this.uid;
            }
        },
        {
            /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ key: "toKey",
            value: function toKey() {
                return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e.uid === this.uid;
            }
        }
    ]);
    return User;
}();
/** A user with a null UID. */ User.UNAUTHENTICATED = new User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
User.GOOGLE_CREDENTIALS = new User("google-credentials-uid"), User.FIRST_PARTY = new User("first-party-uid"), User.MOCK_USER = new User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var b = "10.12.3";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var D = new (0, $3DJ6n.Logger)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function __PRIVATE_getLogLevel() {
    return D.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function setLogLevel(e) {
    D.setLogLevel(e);
}
function __PRIVATE_logDebug(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    if (D.logLevel <= (0, $3DJ6n.LogLevel).DEBUG) {
        var _D;
        var n = t.map(__PRIVATE_argToString);
        (_D = D).debug.apply(_D, [
            "Firestore (".concat(b, "): ").concat(e)
        ].concat((0, $3jzhD._)(n)));
    }
}
function __PRIVATE_logError(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    if (D.logLevel <= (0, $3DJ6n.LogLevel).ERROR) {
        var _D;
        var n = t.map(__PRIVATE_argToString);
        (_D = D).error.apply(_D, [
            "Firestore (".concat(b, "): ").concat(e)
        ].concat((0, $3jzhD._)(n)));
    }
}
/**
 * @internal
 */ function __PRIVATE_logWarn(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    if (D.logLevel <= (0, $3DJ6n.LogLevel).WARN) {
        var _D;
        var n = t.map(__PRIVATE_argToString);
        (_D = D).warn.apply(_D, [
            "Firestore (".concat(b, "): ").concat(e)
        ].concat((0, $3jzhD._)(n)));
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function __PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function fail() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Unexpected state";
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    var t = "FIRESTORE (".concat(b, ") INTERNAL ASSERTION FAILED: ") + e;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw __PRIVATE_logError(t), new Error(t);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */ function __PRIVATE_hardAssert(e, t) {
    e || fail();
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function __PRIVATE_debugAssert(e, t) {
    e || fail();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function __PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var C = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ var FirestoreError = /*#__PURE__*/ function(FirebaseError) {
    "use strict";
    (0, $iNfU4._)(FirestoreError, FirebaseError);
    var _super = (0, $k1NN5._)(FirestoreError);
    function FirestoreError(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t) {
        (0, $19mwo._)(this, FirestoreError);
        var _this;
        _this = _super.call(this, e, t), _this.code = e, _this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        _this.toString = function() {
            return "".concat(_this.name, ": [code=").concat(_this.code, "]: ").concat(_this.message);
        };
        return (0, $hSCyS._)(_this);
    }
    return FirestoreError;
}((0, $gQ5gw.FirebaseError));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_Deferred = function __PRIVATE_Deferred() {
    "use strict";
    var _this = this;
    (0, $19mwo._)(this, __PRIVATE_Deferred);
    this.promise = new Promise(function(e, t) {
        _this.resolve = e, _this.reject = t;
    });
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_OAuthToken = function __PRIVATE_OAuthToken(e, t) {
    "use strict";
    (0, $19mwo._)(this, __PRIVATE_OAuthToken);
    this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", "Bearer ".concat(e));
};
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ var __PRIVATE_EmptyAuthCredentialsProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_EmptyAuthCredentialsProvider() {
        (0, $19mwo._)(this, __PRIVATE_EmptyAuthCredentialsProvider);
    }
    (0, $6rpfc._)(__PRIVATE_EmptyAuthCredentialsProvider, [
        {
            key: "getToken",
            value: function getToken() {
                return Promise.resolve(null);
            }
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {}
        },
        {
            key: "start",
            value: function start(e, t) {
                // Fire with initial user.
                e.enqueueRetryable(function() {
                    return t(User.UNAUTHENTICATED);
                });
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {}
        }
    ]);
    return __PRIVATE_EmptyAuthCredentialsProvider;
}();
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ var __PRIVATE_EmulatorAuthCredentialsProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_EmulatorAuthCredentialsProvider(e) {
        (0, $19mwo._)(this, __PRIVATE_EmulatorAuthCredentialsProvider);
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    (0, $6rpfc._)(__PRIVATE_EmulatorAuthCredentialsProvider, [
        {
            key: "getToken",
            value: function getToken() {
                return Promise.resolve(this.token);
            }
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {}
        },
        {
            key: "start",
            value: function start(e, t) {
                var _this = this;
                this.changeListener = t, // Fire with initial user.
                e.enqueueRetryable(function() {
                    return t(_this.token.user);
                });
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                this.changeListener = null;
            }
        }
    ]);
    return __PRIVATE_EmulatorAuthCredentialsProvider;
}();
var __PRIVATE_FirebaseAuthCredentialsProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_FirebaseAuthCredentialsProvider(e) {
        (0, $19mwo._)(this, __PRIVATE_FirebaseAuthCredentialsProvider);
        this.t = e, /** Tracks the current User. */ this.currentUser = User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    (0, $6rpfc._)(__PRIVATE_FirebaseAuthCredentialsProvider, [
        {
            key: "start",
            value: function start(e, t) {
                var _this = this;
                var n = this.i;
                // A change listener that prevents double-firing for the same token change.
                var __PRIVATE_guardedChangeListener = function(e) {
                    return _this.i !== n ? (n = _this.i, t(e)) : Promise.resolve();
                };
                // A promise that can be waited on to block on the next token change.
                // This promise is re-created after each change.
                var r = new __PRIVATE_Deferred;
                this.o = function() {
                    _this.i++, _this.currentUser = _this.u(), r.resolve(), r = new __PRIVATE_Deferred, e.enqueueRetryable(function() {
                        return __PRIVATE_guardedChangeListener(_this.currentUser);
                    });
                };
                var __PRIVATE_awaitNextToken = function() {
                    var t = r;
                    var _this1 = _this;
                    e.enqueueRetryable(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        t.promise
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        4,
                                        __PRIVATE_guardedChangeListener(_this1.currentUser)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }));
                }, __PRIVATE_registerAuth = function(e) {
                    __PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth detected"), _this.auth = e, _this.auth.addAuthTokenListener(_this.o), __PRIVATE_awaitNextToken();
                };
                this.t.onInit(function(e) {
                    return __PRIVATE_registerAuth(e);
                }), // Our users can initialize Auth right after Firestore, so we give it
                // a chance to register itself with the component framework before we
                // determine whether to start up in unauthenticated mode.
                setTimeout(function() {
                    if (!_this.auth) {
                        var e = _this.t.getImmediate({
                            optional: !0
                        });
                        e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                        (__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new __PRIVATE_Deferred);
                    }
                }, 0), __PRIVATE_awaitNextToken();
            }
        },
        {
            key: "getToken",
            value: function getToken() {
                var _this = this;
                // Take note of the current value of the tokenCounter so that this method
                // can fail (with an ABORTED error) if there is a token change while the
                // request is outstanding.
                var e = this.i, t = this.forceRefresh;
                return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then(function(t) {
                    return(// Cancel the request since the token changed while the request was
                    // outstanding so the response is potentially for a previous user (which
                    // user, we can't be sure).
                    _this.i !== e ? (__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), _this.getToken()) : t ? (__PRIVATE_hardAssert("string" == typeof t.accessToken), new __PRIVATE_OAuthToken(t.accessToken, _this.currentUser)) : null);
                }) : Promise.resolve(null);
            }
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {
                this.forceRefresh = !0;
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                this.auth && this.auth.removeAuthTokenListener(this.o);
            }
        },
        {
            // Auth.getUid() can return null even with a user logged in. It is because
            // getUid() is synchronous, but the auth code populating Uid is asynchronous.
            // This method should only be called in the AuthTokenListener callback
            // to guarantee to get the actual user.
            key: "u",
            value: function u() {
                var e = this.auth && this.auth.getUid();
                return __PRIVATE_hardAssert(null === e || "string" == typeof e), new User(e);
            }
        }
    ]);
    return __PRIVATE_FirebaseAuthCredentialsProvider;
}();
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ var __PRIVATE_FirstPartyToken = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_FirstPartyToken(e, t, n) {
        (0, $19mwo._)(this, __PRIVATE_FirstPartyToken);
        this.l = e, this.h = t, this.P = n, this.type = "FirstParty", this.user = User.FIRST_PARTY, this.I = new Map;
    }
    (0, $6rpfc._)(__PRIVATE_FirstPartyToken, [
        {
            /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ key: "T",
            value: function T() {
                return this.P ? this.P() : null;
            }
        },
        {
            key: "headers",
            get: function get() {
                this.I.set("X-Goog-AuthUser", this.l);
                // Use array notation to prevent minification
                var e = this.T();
                return e && this.I.set("Authorization", e), this.h && this.I.set("X-Goog-Iam-Authorization-Token", this.h), this.I;
            }
        }
    ]);
    return __PRIVATE_FirstPartyToken;
}();
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ var __PRIVATE_FirstPartyAuthCredentialsProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_FirstPartyAuthCredentialsProvider(e, t, n) {
        (0, $19mwo._)(this, __PRIVATE_FirstPartyAuthCredentialsProvider);
        this.l = e, this.h = t, this.P = n;
    }
    (0, $6rpfc._)(__PRIVATE_FirstPartyAuthCredentialsProvider, [
        {
            key: "getToken",
            value: function getToken() {
                return Promise.resolve(new __PRIVATE_FirstPartyToken(this.l, this.h, this.P));
            }
        },
        {
            key: "start",
            value: function start(e, t) {
                // Fire with initial uid.
                e.enqueueRetryable(function() {
                    return t(User.FIRST_PARTY);
                });
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {}
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {}
        }
    ]);
    return __PRIVATE_FirstPartyAuthCredentialsProvider;
}();
var AppCheckToken = function AppCheckToken(e) {
    "use strict";
    (0, $19mwo._)(this, AppCheckToken);
    this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
};
var __PRIVATE_FirebaseAppCheckTokenProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_FirebaseAppCheckTokenProvider(e) {
        (0, $19mwo._)(this, __PRIVATE_FirebaseAppCheckTokenProvider);
        this.A = e, this.forceRefresh = !1, this.appCheck = null, this.R = null;
    }
    (0, $6rpfc._)(__PRIVATE_FirebaseAppCheckTokenProvider, [
        {
            key: "start",
            value: function start(e, t) {
                var _this = this;
                var onTokenChanged = function(e) {
                    null != e.error && __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "Error getting App Check token; using placeholder token instead. Error: ".concat(e.error.message));
                    var n = e.token !== _this.R;
                    return _this.R = e.token, __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "Received ".concat(n ? "new" : "existing", " token.")), n ? t(e.token) : Promise.resolve();
                };
                this.o = function(t) {
                    e.enqueueRetryable(function() {
                        return onTokenChanged(t);
                    });
                };
                var __PRIVATE_registerAppCheck = function(e) {
                    __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck detected"), _this.appCheck = e, _this.appCheck.addTokenListener(_this.o);
                };
                this.A.onInit(function(e) {
                    return __PRIVATE_registerAppCheck(e);
                }), // Our users can initialize AppCheck after Firestore, so we give it
                // a chance to register itself with the component framework.
                setTimeout(function() {
                    if (!_this.appCheck) {
                        var e = _this.A.getImmediate({
                            optional: !0
                        });
                        e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                        __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
                    }
                }, 0);
            }
        },
        {
            key: "getToken",
            value: function getToken() {
                var _this = this;
                var e = this.forceRefresh;
                return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then(function(e) {
                    return e ? (__PRIVATE_hardAssert("string" == typeof e.token), _this.R = e.token, new AppCheckToken(e.token)) : null;
                }) : Promise.resolve(null);
            }
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {
                this.forceRefresh = !0;
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                this.appCheck && this.appCheck.removeTokenListener(this.o);
            }
        }
    ]);
    return __PRIVATE_FirebaseAppCheckTokenProvider;
}();
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ var __PRIVATE_EmptyAppCheckTokenProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_EmptyAppCheckTokenProvider() {
        (0, $19mwo._)(this, __PRIVATE_EmptyAppCheckTokenProvider);
    }
    (0, $6rpfc._)(__PRIVATE_EmptyAppCheckTokenProvider, [
        {
            key: "getToken",
            value: function getToken() {
                return Promise.resolve(new AppCheckToken(""));
            }
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {}
        },
        {
            key: "start",
            value: function start(e, t) {}
        },
        {
            key: "shutdown",
            value: function shutdown() {}
        }
    ]);
    return __PRIVATE_EmptyAppCheckTokenProvider;
}();
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function __PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    var t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(var t1 = 0; t1 < e; t1++)n[t1] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ var __PRIVATE_AutoId = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_AutoId() {
        (0, $19mwo._)(this, __PRIVATE_AutoId);
    }
    (0, $6rpfc._)(__PRIVATE_AutoId, null, [
        {
            key: "newId",
            value: function newId() {
                // Alphanumeric characters
                var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = Math.floor(256 / e.length) * e.length;
                // The largest byte value that is a multiple of `char.length`.
                var n = "";
                for(; n.length < 20;){
                    var r = __PRIVATE_randomBytes(40);
                    for(var i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
                    // be evenly mapped to indices of `chars` via a modulo operation.
                    n.length < 20 && r[i] < t && (n += e.charAt(r[i] % e.length));
                }
                return n;
            }
        }
    ]);
    return __PRIVATE_AutoId;
}();
function __PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Helper to compare arrays using isEqual(). */ function __PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every(function(e, r) {
        return n(e, t[r]);
    });
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function __PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ var Timestamp = /*#__PURE__*/ function() {
    "use strict";
    function Timestamp(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t) {
        (0, $19mwo._)(this, Timestamp);
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new FirestoreError(C.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new FirestoreError(C.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < -62135596800) throw new FirestoreError(C.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new FirestoreError(C.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    (0, $6rpfc._)(Timestamp, [
        {
            /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ key: "toDate",
            value: function toDate() {
                return new Date(this.toMillis());
            }
        },
        {
            /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ key: "toMillis",
            value: function toMillis() {
                return 1e3 * this.seconds + this.nanoseconds / 1e6;
            }
        },
        {
            key: "_compareTo",
            value: function _compareTo(e) {
                return this.seconds === e.seconds ? __PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : __PRIVATE_primitiveComparator(this.seconds, e.seconds);
            }
        },
        {
            /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ key: "isEqual",
            value: function isEqual(e) {
                return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
            }
        },
        {
            /** Returns a textual representation of this `Timestamp`. */ key: "toString",
            value: function toString() {
                return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
            }
        },
        {
            /** Returns a JSON-serializable representation of this `Timestamp`. */ key: "toJSON",
            value: function toJSON() {
                return {
                    seconds: this.seconds,
                    nanoseconds: this.nanoseconds
                };
            }
        },
        {
            /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ key: "valueOf",
            value: function valueOf() {
                // This method returns a string of the form <seconds>.<nanoseconds> where
                // <seconds> is translated to have a non-negative value and both <seconds>
                // and <nanoseconds> are left-padded with zeroes to be a consistent length.
                // Strings with this format then have a lexiographical ordering that matches
                // the expected ordering. The <seconds> translation is done to avoid having
                // a leading negative sign (i.e. a leading '-' character) in its string
                // representation, which would affect its lexiographical ordering.
                var e = this.seconds - -62135596800;
                // Note: Up to 12 decimal digits are required to represent all valid
                // 'seconds' values.
                return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
            }
        }
    ], [
        {
            key: "now",
            value: /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ function now() {
                return Timestamp.fromMillis(Date.now());
            }
        },
        {
            key: "fromDate",
            value: /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ function fromDate(e) {
                return Timestamp.fromMillis(e.getTime());
            }
        },
        {
            key: "fromMillis",
            value: /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ function fromMillis(e) {
                var t = Math.floor(e / 1e3), n = Math.floor(1e6 * (e - 1e3 * t));
                return new Timestamp(t, n);
            }
        }
    ]);
    return Timestamp;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ var SnapshotVersion = /*#__PURE__*/ function() {
    "use strict";
    function SnapshotVersion(e) {
        (0, $19mwo._)(this, SnapshotVersion);
        this.timestamp = e;
    }
    (0, $6rpfc._)(SnapshotVersion, [
        {
            key: "compareTo",
            value: function compareTo(e) {
                return this.timestamp._compareTo(e.timestamp);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return this.timestamp.isEqual(e.timestamp);
            }
        },
        {
            /** Returns a number representation of the version for use in spec tests. */ key: "toMicroseconds",
            value: function toMicroseconds() {
                // Convert to microseconds.
                return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "SnapshotVersion(" + this.timestamp.toString() + ")";
            }
        },
        {
            key: "toTimestamp",
            value: function toTimestamp() {
                return this.timestamp;
            }
        }
    ], [
        {
            key: "fromTimestamp",
            value: function fromTimestamp(e) {
                return new SnapshotVersion(e);
            }
        },
        {
            key: "min",
            value: function min() {
                return new SnapshotVersion(new Timestamp(0, 0));
            }
        },
        {
            key: "max",
            value: function max() {
                return new SnapshotVersion(new Timestamp(253402300799, 999999999));
            }
        }
    ]);
    return SnapshotVersion;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Path represents an ordered sequence of string segments.
 */ var BasePath = /*#__PURE__*/ function() {
    "use strict";
    function BasePath(e, t, n) {
        (0, $19mwo._)(this, BasePath);
        void 0 === t ? t = 0 : t > e.length && fail(), void 0 === n ? n = e.length - t : n > e.length - t && fail(), this.segments = e, this.offset = t, this.len = n;
    }
    (0, $6rpfc._)(BasePath, [
        {
            key: "length",
            get: function get() {
                return this.len;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return 0 === BasePath.comparator(this, e);
            }
        },
        {
            key: "child",
            value: function child(e) {
                var t = this.segments.slice(this.offset, this.limit());
                return e instanceof BasePath ? e.forEach(function(e) {
                    t.push(e);
                }) : t.push(e), this.construct(t);
            }
        },
        {
            /** The index of one past the last segment of the path. */ key: "limit",
            value: function limit() {
                return this.offset + this.length;
            }
        },
        {
            key: "popFirst",
            value: function popFirst(e) {
                return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
            }
        },
        {
            key: "popLast",
            value: function popLast() {
                return this.construct(this.segments, this.offset, this.length - 1);
            }
        },
        {
            key: "firstSegment",
            value: function firstSegment() {
                return this.segments[this.offset];
            }
        },
        {
            key: "lastSegment",
            value: function lastSegment() {
                return this.get(this.length - 1);
            }
        },
        {
            key: "get",
            value: function get(e) {
                return this.segments[this.offset + e];
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return 0 === this.length;
            }
        },
        {
            key: "isPrefixOf",
            value: function isPrefixOf(e) {
                if (e.length < this.length) return !1;
                for(var t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
                return !0;
            }
        },
        {
            key: "isImmediateParentOf",
            value: function isImmediateParentOf(e) {
                if (this.length + 1 !== e.length) return !1;
                for(var t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
                return !0;
            }
        },
        {
            key: "forEach",
            value: function forEach(e) {
                for(var t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                return this.segments.slice(this.offset, this.limit());
            }
        }
    ], [
        {
            key: "comparator",
            value: function comparator(e, t) {
                var n = Math.min(e.length, t.length);
                for(var r = 0; r < n; r++){
                    var n1 = e.get(r), i = t.get(r);
                    if (n1 < i) return -1;
                    if (n1 > i) return 1;
                }
                return e.length < t.length ? -1 : e.length > t.length ? 1 : 0;
            }
        }
    ]);
    return BasePath;
}();
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ var ResourcePath = /*#__PURE__*/ function(BasePath) {
    "use strict";
    (0, $iNfU4._)(ResourcePath, BasePath);
    var _super = (0, $k1NN5._)(ResourcePath);
    function ResourcePath() {
        (0, $19mwo._)(this, ResourcePath);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ResourcePath, [
        {
            key: "construct",
            value: function construct(e, t, n) {
                return new ResourcePath(e, t, n);
            }
        },
        {
            key: "canonicalString",
            value: function canonicalString() {
                // NOTE: The client is ignorant of any path segments containing escape
                // sequences (e.g. __id123__) and just passes them through raw (they exist
                // for legacy reasons and should not be used frequently).
                return this.toArray().join("/");
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.canonicalString();
            }
        },
        {
            /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ key: "toUriEncodedString",
            value: function toUriEncodedString() {
                return this.toArray().map(encodeURIComponent).join("/");
            }
        }
    ], [
        {
            key: "fromString",
            value: /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ function fromString() {
                for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
                    e[_key] = arguments[_key];
                }
                // NOTE: The client is ignorant of any path segments containing escape
                // sequences (e.g. __id123__) and just passes them through raw (they exist
                // for legacy reasons and should not be used frequently).
                var t = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var n = _step.value;
                        var // Strip leading and traling slashed.
                        _t;
                        if (n.indexOf("//") >= 0) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid segment (".concat(n, "). Paths must not contain // in them."));
                        (_t = t).push.apply(_t, (0, $3jzhD._)(n.split("/").filter(function(e) {
                            return e.length > 0;
                        })));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new ResourcePath(t);
            }
        },
        {
            key: "emptyPath",
            value: function emptyPath() {
                return new ResourcePath([]);
            }
        }
    ]);
    return ResourcePath;
}(BasePath);
var v = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ var FieldPath$1 = /*#__PURE__*/ function(BasePath) {
    "use strict";
    (0, $iNfU4._)(FieldPath$1, BasePath);
    var _super = (0, $k1NN5._)(FieldPath$1);
    function FieldPath$1() {
        (0, $19mwo._)(this, FieldPath$1);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(FieldPath$1, [
        {
            key: "construct",
            value: function construct(e, t, n) {
                return new FieldPath$1(e, t, n);
            }
        },
        {
            key: "canonicalString",
            value: function canonicalString() {
                return this.toArray().map(function(e) {
                    return e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), FieldPath$1.isValidIdentifier(e) || (e = "`" + e + "`"), e;
                }).join(".");
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.canonicalString();
            }
        },
        {
            /**
     * Returns true if this field references the key of a document.
     */ key: "isKeyField",
            value: function isKeyField() {
                return 1 === this.length && "__name__" === this.get(0);
            }
        }
    ], [
        {
            key: "isValidIdentifier",
            value: /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ function isValidIdentifier(e) {
                return v.test(e);
            }
        },
        {
            key: "keyField",
            value: /**
     * The field designating the key of a document.
     */ function keyField() {
                return new FieldPath$1([
                    "__name__"
                ]);
            }
        },
        {
            key: "fromServerFormat",
            value: /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ function fromServerFormat(e) {
                var t = [];
                var n = "", r = 0;
                var __PRIVATE_addCurrentSegment = function() {
                    if (0 === n.length) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid field path (".concat(e, "). Paths must not be empty, begin with '.', end with '.', or contain '..'"));
                    t.push(n), n = "";
                };
                var i = !1;
                for(; r < e.length;){
                    var t1 = e[r];
                    if ("\\" === t1) {
                        if (r + 1 === e.length) throw new FirestoreError(C.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                        var t2 = e[r + 1];
                        if ("\\" !== t2 && "." !== t2 && "`" !== t2) throw new FirestoreError(C.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                        n += t2, r += 2;
                    } else "`" === t1 ? (i = !i, r++) : "." !== t1 || i ? (n += t1, r++) : (__PRIVATE_addCurrentSegment(), r++);
                }
                if (__PRIVATE_addCurrentSegment(), i) throw new FirestoreError(C.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
                return new FieldPath$1(t);
            }
        },
        {
            key: "emptyPath",
            value: function emptyPath() {
                return new FieldPath$1([]);
            }
        }
    ]);
    return FieldPath$1;
}(BasePath);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ var DocumentKey = /*#__PURE__*/ function() {
    "use strict";
    function DocumentKey(e) {
        (0, $19mwo._)(this, DocumentKey);
        this.path = e;
    }
    (0, $6rpfc._)(DocumentKey, [
        {
            key: "collectionGroup",
            get: function get() {
                return this.path.popLast().lastSegment();
            }
        },
        {
            /** Returns true if the document is in the specified collectionId. */ key: "hasCollectionId",
            value: function hasCollectionId(e) {
                return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
            }
        },
        {
            /** Returns the collection group (i.e. the name of the parent collection) for this key. */ key: "getCollectionGroup",
            value: function getCollectionGroup() {
                return this.path.get(this.path.length - 2);
            }
        },
        {
            /** Returns the fully qualified path to the parent collection. */ key: "getCollectionPath",
            value: function getCollectionPath() {
                return this.path.popLast();
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return null !== e && 0 === ResourcePath.comparator(this.path, e.path);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.path.toString();
            }
        }
    ], [
        {
            key: "fromPath",
            value: function fromPath(e) {
                return new DocumentKey(ResourcePath.fromString(e));
            }
        },
        {
            key: "fromName",
            value: function fromName(e) {
                return new DocumentKey(ResourcePath.fromString(e).popFirst(5));
            }
        },
        {
            key: "empty",
            value: function empty() {
                return new DocumentKey(ResourcePath.emptyPath());
            }
        },
        {
            key: "comparator",
            value: function comparator(e, t) {
                return ResourcePath.comparator(e.path, t.path);
            }
        },
        {
            key: "isDocumentKey",
            value: function isDocumentKey(e) {
                return e.length % 2 == 0;
            }
        },
        {
            key: "fromSegments",
            value: /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ function fromSegments(e) {
                return new DocumentKey(new ResourcePath(e.slice()));
            }
        }
    ]);
    return DocumentKey;
}();
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ var FieldIndex = function FieldIndex(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r) {
    "use strict";
    (0, $19mwo._)(this, FieldIndex);
    this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
};
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function __PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find(function(e) {
        return 2 /* IndexKind.CONTAINS */  === e.kind;
    });
}
/** Returns all directional (ascending/descending) segments for this index. */ function __PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter(function(e) {
        return 2 /* IndexKind.CONTAINS */  !== e.kind;
    });
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function __PRIVATE_fieldIndexSemanticComparator(e, t) {
    var n = __PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(var r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = __PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return __PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ FieldIndex.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ var IndexSegment = function IndexSegment(/** The field path of the component. */ e, /** The fields sorting order. */ t) {
    "use strict";
    (0, $19mwo._)(this, IndexSegment);
    this.fieldPath = e, this.kind = t;
};
function __PRIVATE_indexSegmentComparator(e, t) {
    var n = FieldPath$1.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : __PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ var IndexState = /*#__PURE__*/ function() {
    "use strict";
    function IndexState(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t) {
        (0, $19mwo._)(this, IndexState);
        this.sequenceNumber = e, this.offset = t;
    }
    (0, $6rpfc._)(IndexState, null, [
        {
            key: "empty",
            value: /** The state of an index that has not yet been backfilled. */ function empty() {
                return new IndexState(0, IndexOffset.min());
            }
        }
    ]);
    return IndexState;
}();
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function __PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    var n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = SnapshotVersion.fromTimestamp(1e9 === r ? new Timestamp(n + 1, 0) : new Timestamp(n, r));
    return new IndexOffset(i, DocumentKey.empty(), t);
}
/** Creates a new offset based on the provided document. */ function __PRIVATE_newIndexOffsetFromDocument(e) {
    return new IndexOffset(e.readTime, e.key, -1);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ var IndexOffset = /*#__PURE__*/ function() {
    "use strict";
    function IndexOffset(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n) {
        (0, $19mwo._)(this, IndexOffset);
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    (0, $6rpfc._)(IndexOffset, null, [
        {
            key: "min",
            value: /** Returns an offset that sorts before all regular offsets. */ function min() {
                return new IndexOffset(SnapshotVersion.min(), DocumentKey.empty(), -1);
            }
        },
        {
            key: "max",
            value: /** Returns an offset that sorts after all regular offsets. */ function max() {
                return new IndexOffset(SnapshotVersion.max(), DocumentKey.empty(), -1);
            }
        }
    ]);
    return IndexOffset;
}();
function __PRIVATE_indexOffsetComparator(e, t) {
    var n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = DocumentKey.comparator(e.documentKey, t.documentKey), 0 !== n ? n : __PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var F = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ var PersistenceTransaction = /*#__PURE__*/ function() {
    "use strict";
    function PersistenceTransaction() {
        (0, $19mwo._)(this, PersistenceTransaction);
        this.onCommittedListeners = [];
    }
    (0, $6rpfc._)(PersistenceTransaction, [
        {
            key: "addOnCommittedListener",
            value: function addOnCommittedListener(e) {
                this.onCommittedListeners.push(e);
            }
        },
        {
            key: "raiseOnCommittedEvent",
            value: function raiseOnCommittedEvent() {
                this.onCommittedListeners.forEach(function(e) {
                    return e();
                });
            }
        }
    ]);
    return PersistenceTransaction;
}();
function __PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    return ___PRIVATE_ignoreIfPrimaryLeaseLoss.apply(this, arguments);
}
function ___PRIVATE_ignoreIfPrimaryLeaseLoss() {
    ___PRIVATE_ignoreIfPrimaryLeaseLoss = /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ (0, $9OZ9j._)(function(e) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            if (e.code !== C.FAILED_PRECONDITION || e.message !== F) throw e;
            __PRIVATE_logDebug("LocalStore", "Unexpectedly lost primary lease");
            return [
                2
            ];
        });
    });
    return ___PRIVATE_ignoreIfPrimaryLeaseLoss.apply(this, arguments);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ var PersistencePromise = /*#__PURE__*/ function() {
    "use strict";
    function PersistencePromise(e) {
        var _this = this;
        (0, $19mwo._)(this, PersistencePromise);
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e(function(e) {
            _this.isDone = !0, _this.result = e, _this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            _this.nextCallback(e);
        }, function(e) {
            _this.isDone = !0, _this.error = e, _this.catchCallback && _this.catchCallback(e);
        });
    }
    (0, $6rpfc._)(PersistencePromise, [
        {
            key: "catch",
            value: function _catch(e) {
                return this.next(void 0, e);
            }
        },
        {
            key: "next",
            value: function next(e, t) {
                var _this = this;
                return this.callbackAttached && fail(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new PersistencePromise(function(n, r) {
                    _this.nextCallback = function(t) {
                        _this.wrapSuccess(e, t).next(n, r);
                    }, _this.catchCallback = function(e) {
                        _this.wrapFailure(t, e).next(n, r);
                    };
                });
            }
        },
        {
            key: "toPromise",
            value: function toPromise() {
                var _this = this;
                return new Promise(function(e, t) {
                    _this.next(e, t);
                });
            }
        },
        {
            key: "wrapUserFunction",
            value: function wrapUserFunction(e) {
                try {
                    var t = e();
                    return t instanceof PersistencePromise ? t : PersistencePromise.resolve(t);
                } catch (e) {
                    return PersistencePromise.reject(e);
                }
            }
        },
        {
            key: "wrapSuccess",
            value: function wrapSuccess(e, t) {
                return e ? this.wrapUserFunction(function() {
                    return e(t);
                }) : PersistencePromise.resolve(t);
            }
        },
        {
            key: "wrapFailure",
            value: function wrapFailure(e, t) {
                return e ? this.wrapUserFunction(function() {
                    return e(t);
                }) : PersistencePromise.reject(t);
            }
        }
    ], [
        {
            key: "resolve",
            value: function resolve(e) {
                return new PersistencePromise(function(t, n) {
                    t(e);
                });
            }
        },
        {
            key: "reject",
            value: function reject(e) {
                return new PersistencePromise(function(t, n) {
                    n(e);
                });
            }
        },
        {
            key: "waitFor",
            value: function waitFor(// Accept all Promise types in waitFor().
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            e) {
                return new PersistencePromise(function(t, n) {
                    var r = 0, i = 0, s = !1;
                    e.forEach(function(e) {
                        ++r, e.next(function() {
                            ++i, s && i === r && t();
                        }, function(e) {
                            return n(e);
                        });
                    }), s = !0, i === r && t();
                });
            }
        },
        {
            key: "or",
            value: /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ function or(e) {
                var t = PersistencePromise.resolve(!1);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var n = _step.value;
                        t = t.next(function(e) {
                            return e ? PersistencePromise.resolve(e) : n();
                        });
                    };
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return t;
            }
        },
        {
            key: "forEach",
            value: function forEach(e, t) {
                var _this = this;
                var n = [];
                return e.forEach(function(e, r) {
                    n.push(t.call(_this, e, r));
                }), this.waitFor(n);
            }
        },
        {
            key: "mapArray",
            value: /**
     * Concurrently map all array elements through asynchronous function.
     */ function mapArray(e, t) {
                return new PersistencePromise(function(n, r) {
                    var _loop = function(_) {
                        var a = _;
                        t(e[a]).next(function(e) {
                            s[a] = e, ++o, o === i && n(s);
                        }, function(e) {
                            return r(e);
                        });
                    };
                    var i = e.length, s = new Array(i);
                    var o = 0;
                    for(var _ = 0; _ < i; _++)_loop(_);
                });
            }
        },
        {
            key: "doWhile",
            value: /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ function doWhile(e, t) {
                return new PersistencePromise(function(n, r) {
                    var process = function() {
                        !0 === e() ? t().next(function() {
                            process();
                        }, r) : n();
                    };
                    process();
                });
            }
        }
    ]);
    return PersistencePromise;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by SimpleDb.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ var __PRIVATE_SimpleDbTransaction = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SimpleDbTransaction(e, t) {
        var _this = this;
        (0, $19mwo._)(this, __PRIVATE_SimpleDbTransaction);
        this.action = e, this.transaction = t, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.V = new __PRIVATE_Deferred, this.transaction.oncomplete = function() {
            _this.V.resolve();
        }, this.transaction.onabort = function() {
            t.error ? _this.V.reject(new __PRIVATE_IndexedDbTransactionError(e, t.error)) : _this.V.resolve();
        }, this.transaction.onerror = function(t) {
            var n = __PRIVATE_checkForAndReportiOSError(t.target.error);
            _this.V.reject(new __PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    (0, $6rpfc._)(__PRIVATE_SimpleDbTransaction, [
        {
            key: "m",
            get: function get() {
                return this.V.promise;
            }
        },
        {
            key: "abort",
            value: function abort(e) {
                e && this.V.reject(e), this.aborted || (__PRIVATE_logDebug("SimpleDb", "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
            }
        },
        {
            key: "g",
            value: function g() {
                // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
                // speed up index DB processing if the event loop remains blocks.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var e = this.transaction;
                this.aborted || "function" != typeof e.commit || e.commit();
            }
        },
        {
            /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ key: "store",
            value: function store(e) {
                var t = this.transaction.objectStore(e);
                return new __PRIVATE_SimpleDbStore(t);
            }
        }
    ], [
        {
            key: "open",
            value: function open(e, t, n, r) {
                try {
                    return new __PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
                } catch (e) {
                    throw new __PRIVATE_IndexedDbTransactionError(t, e);
                }
            }
        }
    ]);
    return __PRIVATE_SimpleDbTransaction;
}();
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ var __PRIVATE_SimpleDb = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SimpleDb(e, t, n) {
        (0, $19mwo._)(this, __PRIVATE_SimpleDb);
        this.name = e, this.version = t, this.p = n;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === __PRIVATE_SimpleDb.S((0, $gQ5gw.getUA)()) && __PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    (0, $6rpfc._)(__PRIVATE_SimpleDb, [
        {
            key: "M",
            value: /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ function M(e) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _tmp;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.db;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                __PRIVATE_logDebug("SimpleDb", "Opening database:", _this.name);
                                return [
                                    4,
                                    new Promise(function(t, n) {
                                        // TODO(mikelehen): Investigate browser compatibility.
                                        // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
                                        // suggests IE9 and older WebKit browsers handle upgrade
                                        // differently. They expect setVersion, as described here:
                                        // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
                                        var r = indexedDB.open(_this.name, _this.version);
                                        r.onsuccess = function(e) {
                                            var n = e.target.result;
                                            t(n);
                                        }, r.onblocked = function() {
                                            n(new __PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
                                        }, r.onerror = function(t) {
                                            var r = t.target.error;
                                            "VersionError" === r.name ? n(new FirestoreError(C.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new FirestoreError(C.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new __PRIVATE_IndexedDbTransactionError(e, r));
                                        }, r.onupgradeneeded = function(e) {
                                            __PRIVATE_logDebug("SimpleDb", 'Database "' + _this.name + '" requires upgrade from version:', e.oldVersion);
                                            var t = e.target.result;
                                            _this.p.O(t, r.transaction, e.oldVersion, _this.version).next(function() {
                                                __PRIVATE_logDebug("SimpleDb", "Database upgrade to version " + _this.version + " complete");
                                            });
                                        };
                                    })
                                ];
                            case 1:
                                _tmp = _this.db = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    (_tmp, _this.N && (_this.db.onversionchange = function(e) {
                                        return _this.N(e);
                                    }), _this.db)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "L",
            value: function L(e) {
                this.N = e, this.db && (this.db.onversionchange = function(t) {
                    return e(t);
                });
            }
        },
        {
            key: "runTransaction",
            value: function runTransaction(e, t, n, r) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _loop, i, s, _ret;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _loop = function() {
                                    var _$t, s1, _tmp, e1, _$t1, _$n;
                                    return (0, $lF1I7.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                ++s;
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    4,
                                                    ,
                                                    5
                                                ]);
                                                return [
                                                    4,
                                                    _this.M(e)
                                                ];
                                            case 2:
                                                _this.db = _state.sent();
                                                _$t = __PRIVATE_SimpleDbTransaction.open(_this.db, e, i ? "readonly" : "readwrite", n), s1 = r(_$t).next(function(e) {
                                                    return _$t.g(), e;
                                                }).catch(function(e) {
                                                    return(// Abort the transaction if there was an error.
                                                    _$t.abort(e), PersistencePromise.reject(e));
                                                }).toPromise();
                                                _tmp = {};
                                                s1.catch(function() {});
                                                // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                                                // fire), but still return the original transactionFnResult back to the
                                                // caller.
                                                return [
                                                    4,
                                                    _$t.m
                                                ];
                                            case 3:
                                                // As noted above, errors are propagated by aborting the transaction. So
                                                // we swallow any error here to avoid the browser logging it as unhandled.
                                                return [
                                                    2,
                                                    (_tmp.v = (_state.sent(), s1), _tmp)
                                                ];
                                            case 4:
                                                e1 = _state.sent();
                                                _$t1 = e1, _$n = "FirebaseError" !== _$t1.name && s < 3;
                                                // TODO(schmidt-sebastian): We could probably be smarter about this and
                                                // not retry exceptions that are likely unrecoverable (such as quota
                                                // exceeded errors).
                                                // Note: We cannot use an instanceof check for FirestoreException, since the
                                                // exception is wrapped in a generic error by our async/await handling.
                                                if (__PRIVATE_logDebug("SimpleDb", "Transaction failed with error:", _$t1.message, "Retrying:", _$n), _this.close(), !_$n) return [
                                                    2,
                                                    {
                                                        v: Promise.reject(_$t1)
                                                    }
                                                ];
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 5:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                i = "readonly" === t;
                                s = 0;
                                _state.label = 1;
                            case 1:
                                return [
                                    5,
                                    (0, $lF1I7.__values)(_loop())
                                ];
                            case 2:
                                _ret = _state.sent();
                                if ((0, $gnDeW._)(_ret) === "object") return [
                                    2,
                                    _ret.v
                                ];
                                _state.label = 3;
                            case 3:
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "close",
            value: function close() {
                this.db && this.db.close(), this.db = void 0;
            }
        }
    ], [
        {
            key: "delete",
            value: /** Deletes the specified database. */ function _delete(e) {
                return __PRIVATE_logDebug("SimpleDb", "Removing database:", e), __PRIVATE_wrapRequest(window.indexedDB.deleteDatabase(e)).toPromise();
            }
        },
        {
            key: "D",
            value: /** Returns true if IndexedDB is available in the current environment. */ function D() {
                if (!(0, $gQ5gw.isIndexedDBAvailable)()) return !1;
                if (__PRIVATE_SimpleDb.C()) return !0;
                // We extensively use indexed array values and compound keys,
                // which IE and Edge do not support. However, they still have indexedDB
                // defined on the window, so we need to check for them here and make sure
                // to return that persistence is not enabled for those browsers.
                // For tracking support of this feature, see here:
                // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
                // Check the UA string to find out the browser.
                var e = (0, $gQ5gw.getUA)(), t = __PRIVATE_SimpleDb.S(e), n = 0 < t && t < 10, r = __PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
                // IE 10
                // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
                // IE 11
                // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
                // Edge
                // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
                // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
                // iOS Safari: Disable for users running iOS version < 10.
                return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
            }
        },
        {
            key: "C",
            value: /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ function C() {
                var e;
                return "undefined" != typeof $hZFWO && "YES" === (null === (e = $hZFWO.__PRIVATE_env) || void 0 === e ? void 0 : e.v);
            }
        },
        {
            key: "F",
            value: /** Helper to get a typed SimpleDbStore from a transaction. */ function F(e, t) {
                return e.store(t);
            }
        },
        {
            key: "S",
            value: // visible for testing
            /** Parse User Agent to determine iOS version. Returns -1 if not found. */ function S(e) {
                var t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
                return Number(n);
            }
        }
    ]);
    return __PRIVATE_SimpleDb;
}();
/** Parse User Agent to determine Android version. Returns -1 if not found. */ function __PRIVATE_getAndroidVersion(e) {
    var t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ var __PRIVATE_IterationController = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IterationController(e) {
        (0, $19mwo._)(this, __PRIVATE_IterationController);
        this.B = e, this.k = !1, this.q = null;
    }
    (0, $6rpfc._)(__PRIVATE_IterationController, [
        {
            key: "isDone",
            get: function get() {
                return this.k;
            }
        },
        {
            key: "K",
            get: function get() {
                return this.q;
            }
        },
        {
            key: "cursor",
            set: function set(e) {
                this.B = e;
            }
        },
        {
            /**
     * This function can be called to stop iteration at any point.
     */ key: "done",
            value: function done() {
                this.k = !0;
            }
        },
        {
            /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ key: "$",
            value: function $(e) {
                this.q = e;
            }
        },
        {
            /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ key: "delete",
            value: function _delete() {
                return __PRIVATE_wrapRequest(this.B.delete());
            }
        }
    ]);
    return __PRIVATE_IterationController;
}();
/** An error that wraps exceptions that thrown during IndexedDB execution. */ var __PRIVATE_IndexedDbTransactionError = /*#__PURE__*/ function(FirestoreError) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_IndexedDbTransactionError, FirestoreError);
    var _super = (0, $k1NN5._)(__PRIVATE_IndexedDbTransactionError);
    function __PRIVATE_IndexedDbTransactionError(e, t) {
        (0, $19mwo._)(this, __PRIVATE_IndexedDbTransactionError);
        var _this;
        _this = _super.call(this, C.UNAVAILABLE, "IndexedDB transaction '".concat(e, "' failed: ").concat(t)), _this.name = "IndexedDbTransactionError";
        return (0, $hSCyS._)(_this);
    }
    return __PRIVATE_IndexedDbTransactionError;
}(FirestoreError);
/** Verifies whether `e` is an IndexedDbTransactionError. */ function __PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ var __PRIVATE_SimpleDbStore = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SimpleDbStore(e) {
        (0, $19mwo._)(this, __PRIVATE_SimpleDbStore);
        this.store = e;
    }
    (0, $6rpfc._)(__PRIVATE_SimpleDbStore, [
        {
            key: "put",
            value: function put(e, t) {
                var n;
                return void 0 !== t ? (__PRIVATE_logDebug("SimpleDb", "PUT", this.store.name, e, t), n = this.store.put(t, e)) : (__PRIVATE_logDebug("SimpleDb", "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), __PRIVATE_wrapRequest(n);
            }
        },
        {
            /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ key: "add",
            value: function add(e) {
                __PRIVATE_logDebug("SimpleDb", "ADD", this.store.name, e, e);
                return __PRIVATE_wrapRequest(this.store.add(e));
            }
        },
        {
            /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ key: "get",
            value: function get(e) {
                var _this = this;
                // We're doing an unsafe cast to ValueType.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return __PRIVATE_wrapRequest(this.store.get(e)).next(function(t) {
                    return(// Normalize nonexistence to null.
                    void 0 === t && (t = null), __PRIVATE_logDebug("SimpleDb", "GET", _this.store.name, e, t), t);
                });
            }
        },
        {
            key: "delete",
            value: function _delete(e) {
                __PRIVATE_logDebug("SimpleDb", "DELETE", this.store.name, e);
                return __PRIVATE_wrapRequest(this.store.delete(e));
            }
        },
        {
            /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ key: "count",
            value: function count() {
                __PRIVATE_logDebug("SimpleDb", "COUNT", this.store.name);
                return __PRIVATE_wrapRequest(this.store.count());
            }
        },
        {
            key: "U",
            value: function U(e, t) {
                var n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
                // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
                // 20% faster.
                if ("function" == typeof r.getAll) {
                    var _$e = r.getAll(n.range);
                    return new PersistencePromise(function(t, n) {
                        _$e.onerror = function(e) {
                            n(e.target.error);
                        }, _$e.onsuccess = function(e) {
                            t(e.target.result);
                        };
                    });
                }
                {
                    var _$e1 = this.cursor(n), _$t = [];
                    return this.W(_$e1, function(e, n) {
                        _$t.push(n);
                    }).next(function() {
                        return _$t;
                    });
                }
            }
        },
        {
            /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ key: "G",
            value: function G(e, t) {
                var n = this.store.getAll(e, null === t ? void 0 : t);
                return new PersistencePromise(function(e, t) {
                    n.onerror = function(e) {
                        t(e.target.error);
                    }, n.onsuccess = function(t) {
                        e(t.target.result);
                    };
                });
            }
        },
        {
            key: "j",
            value: function j(e, t) {
                __PRIVATE_logDebug("SimpleDb", "DELETE ALL", this.store.name);
                var n = this.options(e, t);
                n.H = !1;
                var r = this.cursor(n);
                return this.W(r, function(e, t, n) {
                    return n.delete();
                });
            }
        },
        {
            key: "J",
            value: function J(e, t) {
                var n;
                t ? n = e : (n = {}, t = e);
                var r = this.cursor(n);
                return this.W(r, t);
            }
        },
        {
            /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ key: "Y",
            value: function Y(e) {
                var t = this.cursor({});
                return new PersistencePromise(function(n, r) {
                    t.onerror = function(e) {
                        var t = __PRIVATE_checkForAndReportiOSError(e.target.error);
                        r(t);
                    }, t.onsuccess = function(t) {
                        var r = t.target.result;
                        r ? e(r.primaryKey, r.value).next(function(e) {
                            e ? r.continue() : n();
                        }) : n();
                    };
                });
            }
        },
        {
            key: "W",
            value: function W(e, t) {
                var n = [];
                return new PersistencePromise(function(r, i) {
                    e.onerror = function(e) {
                        i(e.target.error);
                    }, e.onsuccess = function(e) {
                        var i = e.target.result;
                        if (!i) return void r();
                        var s = new __PRIVATE_IterationController(i), o = t(i.primaryKey, i.value, s);
                        if (o instanceof PersistencePromise) {
                            var _$e = o.catch(function(e) {
                                return s.done(), PersistencePromise.reject(e);
                            });
                            n.push(_$e);
                        }
                        s.isDone ? r() : null === s.K ? i.continue() : i.continue(s.K);
                    };
                }).next(function() {
                    return PersistencePromise.waitFor(n);
                });
            }
        },
        {
            key: "options",
            value: function options(e, t) {
                var n;
                return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
                    index: n,
                    range: t
                };
            }
        },
        {
            key: "cursor",
            value: function cursor(e) {
                var t = "next";
                if (e.reverse && (t = "prev"), e.index) {
                    var n = this.store.index(e.index);
                    return e.H ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
                }
                return this.store.openCursor(e.range, t);
            }
        }
    ]);
    return __PRIVATE_SimpleDbStore;
}();
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function __PRIVATE_wrapRequest(e) {
    return new PersistencePromise(function(t, n) {
        e.onsuccess = function(e) {
            var n = e.target.result;
            t(n);
        }, e.onerror = function(e) {
            var t = __PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
var M = !1;
function __PRIVATE_checkForAndReportiOSError(e) {
    var t = __PRIVATE_SimpleDb.S((0, $gQ5gw.getUA)());
    if (t >= 12.2 && t < 13) {
        var t1 = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t1) >= 0) {
            // Wrap error in a more descriptive one.
            var _$e = new FirestoreError("internal", "IOS_INDEXEDDB_BUG1: IndexedDb has thrown '".concat(t1, "'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround."));
            return M || (M = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(function() {
                throw _$e;
            }, 0)), _$e;
        }
    }
    return e;
}
/** This class is responsible for the scheduling of Index Backfiller. */ var __PRIVATE_IndexBackfillerScheduler = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexBackfillerScheduler(e, t) {
        (0, $19mwo._)(this, __PRIVATE_IndexBackfillerScheduler);
        this.asyncQueue = e, this.Z = t, this.task = null;
    }
    (0, $6rpfc._)(__PRIVATE_IndexBackfillerScheduler, [
        {
            key: "start",
            value: function start() {
                this.X(15e3);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.task && (this.task.cancel(), this.task = null);
            }
        },
        {
            key: "started",
            get: function get() {
                return null !== this.task;
            }
        },
        {
            key: "X",
            value: function X(e) {
                var _this = this;
                __PRIVATE_logDebug("IndexBackfiller", "Scheduled in ".concat(e, "ms")), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, /*#__PURE__*/ (0, $9OZ9j._)(function() {
                    var _tmp, _, _1, e, _tmp1;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.task = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    7
                                ]);
                                _tmp = [
                                    "IndexBackfiller"
                                ];
                                _1 = (_ = "Documents written: ").concat;
                                return [
                                    4,
                                    _this.Z.ee()
                                ];
                            case 2:
                                __PRIVATE_logDebug.apply(void 0, _tmp.concat([
                                    _1.apply(_, [
                                        _state.sent()
                                    ])
                                ]));
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                e = _state.sent();
                                if (!__PRIVATE_isIndexedDbTransactionError(e)) return [
                                    3,
                                    4
                                ];
                                _tmp1 = __PRIVATE_logDebug("IndexBackfiller", "Ignoring IndexedDB error during index backfill: ", e);
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    __PRIVATE_ignoreIfPrimaryLeaseLoss(e)
                                ];
                            case 5:
                                _tmp1 = _state.sent();
                                _state.label = 6;
                            case 6:
                                _tmp1;
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    4,
                                    _this.X(6e4)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }));
            }
        }
    ]);
    return __PRIVATE_IndexBackfillerScheduler;
}();
/** Implements the steps for backfilling indexes. */ var __PRIVATE_IndexBackfiller = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexBackfiller(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t) {
        (0, $19mwo._)(this, __PRIVATE_IndexBackfiller);
        this.localStore = e, this.persistence = t;
    }
    (0, $6rpfc._)(__PRIVATE_IndexBackfiller, [
        {
            key: "ee",
            value: function ee() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 50;
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", function(t) {
                                return _this.te(t, e);
                            })
                        ];
                    });
                })();
            }
        },
        {
            /** Writes index entries until the cap is reached. Returns the number of documents processed. */ key: "te",
            value: function te(e, t) {
                var _this = this;
                var n = new Set;
                var r = t, i = !0;
                return PersistencePromise.doWhile(function() {
                    return !0 === i && r > 0;
                }, function() {
                    return _this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next(function(t) {
                        if (null !== t && !n.has(t)) return __PRIVATE_logDebug("IndexBackfiller", "Processing collection: ".concat(t)), _this.ne(e, t, r).next(function(e) {
                            r -= e, n.add(t);
                        });
                        i = !1;
                    });
                }).next(function() {
                    return t - r;
                });
            }
        },
        {
            /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ key: "ne",
            value: function ne(e, t, n) {
                var _this = this;
                // Use the earliest offset of all field indexes to query the local cache.
                return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next(function(r) {
                    return _this.localStore.localDocuments.getNextDocuments(e, t, r, n).next(function(n) {
                        var i = n.changes;
                        return _this.localStore.indexManager.updateIndexEntries(e, i).next(function() {
                            return _this.re(r, n);
                        }).next(function(n) {
                            return __PRIVATE_logDebug("IndexBackfiller", "Updating offset: ".concat(n)), _this.localStore.indexManager.updateCollectionGroup(e, t, n);
                        }).next(function() {
                            return i.size;
                        });
                    });
                });
            }
        },
        {
            /** Returns the next offset based on the provided documents. */ key: "re",
            value: function re(e, t) {
                var n = e;
                return t.changes.forEach(function(e, t) {
                    var r = __PRIVATE_newIndexOffsetFromDocument(t);
                    __PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
                }), new IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
            }
        }
    ]);
    return __PRIVATE_IndexBackfiller;
}();
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ var __PRIVATE_ListenSequence = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_ListenSequence(e, t) {
        var _this = this;
        (0, $19mwo._)(this, __PRIVATE_ListenSequence);
        this.previousValue = e, t && (t.sequenceNumberHandler = function(e) {
            return _this.ie(e);
        }, this.se = function(e) {
            return t.writeSequenceNumber(e);
        });
    }
    (0, $6rpfc._)(__PRIVATE_ListenSequence, [
        {
            key: "ie",
            value: function ie(e) {
                return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
            }
        },
        {
            key: "next",
            value: function next() {
                var e = ++this.previousValue;
                return this.se && this.se(e), e;
            }
        }
    ]);
    return __PRIVATE_ListenSequence;
}();
__PRIVATE_ListenSequence.oe = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function __PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function __PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function __PRIVATE_encodeResourcePath(e) {
    var t = "";
    for(var n = 0; n < e.length; n++)t.length > 0 && (t = __PRIVATE_encodeSeparator(t)), t = __PRIVATE_encodeSegment(e.get(n), t);
    return __PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function __PRIVATE_encodeSegment(e, t) {
    var n = t;
    var r = e.length;
    for(var _$t = 0; _$t < r; _$t++){
        var r1 = e.charAt(_$t);
        switch(r1){
            case "\0":
                n += "\x01\x10";
                break;
            case "\x01":
                n += "\x01\x11";
                break;
            default:
                n += r1;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function __PRIVATE_encodeSeparator(e) {
    return e + "\x01\x01";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function __PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    var t = e.length;
    if (__PRIVATE_hardAssert(t >= 2), 2 === t) return __PRIVATE_hardAssert("\x01" === e.charAt(0) && "\x01" === e.charAt(1)), ResourcePath.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    var __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    var r = "";
    for(var i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        var t1 = e.indexOf("\x01", i);
        (t1 < 0 || t1 > __PRIVATE_lastReasonableEscapeIndex) && fail();
        switch(e.charAt(t1 + 1)){
            case "\x01":
                var s = e.substring(i, t1);
                var o = void 0;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = s : (r += s, o = r, r = ""), n.push(o);
                break;
            case "\x10":
                r += e.substring(i, t1), r += "\0";
                break;
            case "\x11":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t1 + 1);
                break;
            default:
                fail();
        }
        i = t1 + 2;
    }
    return new ResourcePath(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var x = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function __PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        __PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function __PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        __PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ var O = {}, N = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], L = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], B = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], k = [
    "canonicalId",
    "targetId"
], q = [
    "targetId",
    "path"
], Q = [
    "path",
    "targetId"
], K = [
    "collectionId",
    "parent"
], $ = [
    "indexId",
    "uid"
], U = [
    "uid",
    "sequenceNumber"
], W = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], G = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], z = [
    "userId",
    "collectionPath",
    "documentId"
], j = [
    "userId",
    "collectionPath",
    "largestBatchId"
], H = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], J = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocuments",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries"
], Y = (0, $3jzhD._)(J).concat([
    "documentOverlays"
]), Z = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocumentsV14",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries",
    "documentOverlays"
], X = Z, ee = (0, $3jzhD._)(X).concat([
    "indexConfiguration",
    "indexState",
    "indexEntries"
]), te = ee;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_IndexedDbTransaction = /*#__PURE__*/ function(PersistenceTransaction) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_IndexedDbTransaction, PersistenceTransaction);
    var _super = (0, $k1NN5._)(__PRIVATE_IndexedDbTransaction);
    function __PRIVATE_IndexedDbTransaction(e, t) {
        (0, $19mwo._)(this, __PRIVATE_IndexedDbTransaction);
        var _this;
        _this = _super.call(this), _this._e = e, _this.currentSequenceNumber = t;
        return (0, $hSCyS._)(_this);
    }
    return __PRIVATE_IndexedDbTransaction;
}(PersistenceTransaction);
function __PRIVATE_getStore(e, t) {
    var n = __PRIVATE_debugCast(e);
    return __PRIVATE_SimpleDb.F(n._e, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_objectSize(e) {
    var t = 0;
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function forEach(e, t) {
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function __PRIVATE_mapToArray(e, t) {
    var n = [];
    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}
function isEmpty(e) {
    for(var t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
var SortedMap = /*#__PURE__*/ function() {
    "use strict";
    function SortedMap(e, t) {
        (0, $19mwo._)(this, SortedMap);
        this.comparator = e, this.root = t || LLRBNode.EMPTY;
    }
    (0, $6rpfc._)(SortedMap, [
        {
            // Returns a copy of the map, with the specified key/value added or replaced.
            key: "insert",
            value: function insert(e, t) {
                return new SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, LLRBNode.BLACK, null, null));
            }
        },
        {
            // Returns a copy of the map, with the specified key removed.
            key: "remove",
            value: function remove(e) {
                return new SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, LLRBNode.BLACK, null, null));
            }
        },
        {
            // Returns the value of the node with the given key, or null.
            key: "get",
            value: function get(e) {
                var t = this.root;
                for(; !t.isEmpty();){
                    var n = this.comparator(e, t.key);
                    if (0 === n) return t.value;
                    n < 0 ? t = t.left : n > 0 && (t = t.right);
                }
                return null;
            }
        },
        {
            // Returns the index of the element in this sorted map, or -1 if it doesn't
            // exist.
            key: "indexOf",
            value: function indexOf(e) {
                // Number of nodes that were pruned when descending right
                var t = 0, n = this.root;
                for(; !n.isEmpty();){
                    var r = this.comparator(e, n.key);
                    if (0 === r) return t + n.left.size;
                    r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
                    (t += n.left.size + 1, n = n.right);
                }
                // Node not found
                return -1;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.root.isEmpty();
            }
        },
        {
            key: "size",
            get: // Returns the total number of nodes in the map.
            function get() {
                return this.root.size;
            }
        },
        {
            // Returns the minimum key in the map.
            key: "minKey",
            value: function minKey() {
                return this.root.minKey();
            }
        },
        {
            // Returns the maximum key in the map.
            key: "maxKey",
            value: function maxKey() {
                return this.root.maxKey();
            }
        },
        {
            // Traverses the map in key order and calls the specified action function
            // for each key/value pair. If action returns true, traversal is aborted.
            // Returns the first truthy value returned by action, or the last falsey
            // value returned by action.
            key: "inorderTraversal",
            value: function inorderTraversal(e) {
                return this.root.inorderTraversal(e);
            }
        },
        {
            key: "forEach",
            value: function forEach(e) {
                this.inorderTraversal(function(t, n) {
                    return e(t, n), !1;
                });
            }
        },
        {
            key: "toString",
            value: function toString() {
                var e = [];
                return this.inorderTraversal(function(t, n) {
                    return e.push("".concat(t, ":").concat(n)), !1;
                }), "{".concat(e.join(", "), "}");
            }
        },
        {
            // Traverses the map in reverse key order and calls the specified action
            // function for each key/value pair. If action returns true, traversal is
            // aborted.
            // Returns the first truthy value returned by action, or the last falsey
            // value returned by action.
            key: "reverseTraversal",
            value: function reverseTraversal(e) {
                return this.root.reverseTraversal(e);
            }
        },
        {
            // Returns an iterator over the SortedMap.
            key: "getIterator",
            value: function getIterator() {
                return new SortedMapIterator(this.root, null, this.comparator, !1);
            }
        },
        {
            key: "getIteratorFrom",
            value: function getIteratorFrom(e) {
                return new SortedMapIterator(this.root, e, this.comparator, !1);
            }
        },
        {
            key: "getReverseIterator",
            value: function getReverseIterator() {
                return new SortedMapIterator(this.root, null, this.comparator, !0);
            }
        },
        {
            key: "getReverseIteratorFrom",
            value: function getReverseIteratorFrom(e) {
                return new SortedMapIterator(this.root, e, this.comparator, !0);
            }
        }
    ]);
    return SortedMap;
}();
// end SortedMap
// An iterator over an LLRBNode.
var SortedMapIterator = /*#__PURE__*/ function() {
    "use strict";
    function SortedMapIterator(e, t, n, r) {
        (0, $19mwo._)(this, SortedMapIterator);
        this.isReverse = r, this.nodeStack = [];
        var i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    (0, $6rpfc._)(SortedMapIterator, [
        {
            key: "getNext",
            value: function getNext() {
                var e = this.nodeStack.pop();
                var t = {
                    key: e.key,
                    value: e.value
                };
                if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
                else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
                return t;
            }
        },
        {
            key: "hasNext",
            value: function hasNext() {
                return this.nodeStack.length > 0;
            }
        },
        {
            key: "peek",
            value: function peek() {
                if (0 === this.nodeStack.length) return null;
                var e = this.nodeStack[this.nodeStack.length - 1];
                return {
                    key: e.key,
                    value: e.value
                };
            }
        }
    ]);
    return SortedMapIterator;
}();
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
var LLRBNode = /*#__PURE__*/ function() {
    "use strict";
    function LLRBNode(e, t, n, r, i) {
        (0, $19mwo._)(this, LLRBNode);
        this.key = e, this.value = t, this.color = null != n ? n : LLRBNode.RED, this.left = null != r ? r : LLRBNode.EMPTY, this.right = null != i ? i : LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    (0, $6rpfc._)(LLRBNode, [
        {
            // Returns a copy of the current node, optionally replacing pieces of it.
            key: "copy",
            value: function copy(e, t, n, r, i) {
                return new LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return !1;
            }
        },
        {
            // Traverses the tree in key order and calls the specified action function
            // for each node. If action returns true, traversal is aborted.
            // Returns the first truthy value returned by action, or the last falsey
            // value returned by action.
            key: "inorderTraversal",
            value: function inorderTraversal(e) {
                return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
            }
        },
        {
            // Traverses the tree in reverse key order and calls the specified action
            // function for each node. If action returns true, traversal is aborted.
            // Returns the first truthy value returned by action, or the last falsey
            // value returned by action.
            key: "reverseTraversal",
            value: function reverseTraversal(e) {
                return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
            }
        },
        {
            // Returns the minimum node in the tree.
            key: "min",
            value: function min() {
                return this.left.isEmpty() ? this : this.left.min();
            }
        },
        {
            // Returns the maximum key in the tree.
            key: "minKey",
            value: function minKey() {
                return this.min().key;
            }
        },
        {
            // Returns the maximum key in the tree.
            key: "maxKey",
            value: function maxKey() {
                return this.right.isEmpty() ? this.key : this.right.maxKey();
            }
        },
        {
            // Returns new tree, with the key/value added.
            key: "insert",
            value: function insert(e, t, n) {
                var r = this;
                var i = n(e, r.key);
                return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
            }
        },
        {
            key: "removeMin",
            value: function removeMin() {
                if (this.left.isEmpty()) return LLRBNode.EMPTY;
                var e = this;
                return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
            }
        },
        {
            // Returns new tree, with the specified item removed.
            key: "remove",
            value: function remove(e, t) {
                var n, r = this;
                if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
                else {
                    if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                        if (r.right.isEmpty()) return LLRBNode.EMPTY;
                        n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
                    }
                    r = r.copy(null, null, null, null, r.right.remove(e, t));
                }
                return r.fixUp();
            }
        },
        {
            key: "isRed",
            value: function isRed() {
                return this.color;
            }
        },
        {
            // Returns new tree after performing any needed rotations.
            key: "fixUp",
            value: function fixUp() {
                var e = this;
                return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
            }
        },
        {
            key: "moveRedLeft",
            value: function moveRedLeft() {
                var e = this.colorFlip();
                return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
            }
        },
        {
            key: "moveRedRight",
            value: function moveRedRight() {
                var e = this.colorFlip();
                return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
            }
        },
        {
            key: "rotateLeft",
            value: function rotateLeft() {
                var e = this.copy(null, null, LLRBNode.RED, null, this.right.left);
                return this.right.copy(null, null, this.color, e, null);
            }
        },
        {
            key: "rotateRight",
            value: function rotateRight() {
                var e = this.copy(null, null, LLRBNode.RED, this.left.right, null);
                return this.left.copy(null, null, this.color, null, e);
            }
        },
        {
            key: "colorFlip",
            value: function colorFlip() {
                var e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
                return this.copy(null, null, !this.color, e, t);
            }
        },
        {
            // For testing.
            key: "checkMaxDepth",
            value: function checkMaxDepth() {
                var e = this.check();
                return Math.pow(2, e) <= this.size + 1;
            }
        },
        {
            // In a balanced RB tree, the black-depth (number of black nodes) from root to
            // leaves is equal on both sides.  This function verifies that or asserts.
            key: "check",
            value: function check() {
                if (this.isRed() && this.left.isRed()) throw fail();
                if (this.right.isRed()) throw fail();
                var e = this.left.check();
                if (e !== this.right.check()) throw fail();
                return e + (this.isRed() ? 0 : 1);
            }
        }
    ]);
    return LLRBNode;
}();
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
LLRBNode.EMPTY = null, LLRBNode.RED = !0, LLRBNode.BLACK = !1;
// end LLRBEmptyNode
LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
/*#__PURE__*/ (function() {
    "use strict";
    function LLRBEmptyNode() {
        (0, $19mwo._)(this, LLRBEmptyNode);
        this.size = 0;
    }
    (0, $6rpfc._)(LLRBEmptyNode, [
        {
            key: "key",
            get: function get() {
                throw fail();
            }
        },
        {
            key: "value",
            get: function get() {
                throw fail();
            }
        },
        {
            key: "color",
            get: function get() {
                throw fail();
            }
        },
        {
            key: "left",
            get: function get() {
                throw fail();
            }
        },
        {
            key: "right",
            get: function get() {
                throw fail();
            }
        },
        {
            // Returns a copy of the current node.
            key: "copy",
            value: function copy(e, t, n, r, i) {
                return this;
            }
        },
        {
            // Returns a copy of the tree, with the specified key/value added.
            key: "insert",
            value: function insert(e, t, n) {
                return new LLRBNode(e, t);
            }
        },
        {
            // Returns a copy of the tree, with the specified key removed.
            key: "remove",
            value: function remove(e, t) {
                return this;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return !0;
            }
        },
        {
            key: "inorderTraversal",
            value: function inorderTraversal(e) {
                return !1;
            }
        },
        {
            key: "reverseTraversal",
            value: function reverseTraversal(e) {
                return !1;
            }
        },
        {
            key: "minKey",
            value: function minKey() {
                return null;
            }
        },
        {
            key: "maxKey",
            value: function maxKey() {
                return null;
            }
        },
        {
            key: "isRed",
            value: function isRed() {
                return !1;
            }
        },
        {
            // For testing.
            key: "checkMaxDepth",
            value: function checkMaxDepth() {
                return !0;
            }
        },
        {
            key: "check",
            value: function check() {
                return 0;
            }
        }
    ]);
    return LLRBEmptyNode;
}());
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ var SortedSet = /*#__PURE__*/ function() {
    "use strict";
    function SortedSet(e) {
        (0, $19mwo._)(this, SortedSet);
        this.comparator = e, this.data = new SortedMap(this.comparator);
    }
    (0, $6rpfc._)(SortedSet, [
        {
            key: "has",
            value: function has(e) {
                return null !== this.data.get(e);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.data.minKey();
            }
        },
        {
            key: "last",
            value: function last() {
                return this.data.maxKey();
            }
        },
        {
            key: "size",
            get: function get() {
                return this.data.size;
            }
        },
        {
            key: "indexOf",
            value: function indexOf(e) {
                return this.data.indexOf(e);
            }
        },
        {
            /** Iterates elements in order defined by "comparator" */ key: "forEach",
            value: function forEach(e) {
                this.data.inorderTraversal(function(t, n) {
                    return e(t), !1;
                });
            }
        },
        {
            /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ key: "forEachInRange",
            value: function forEachInRange(e, t) {
                var n = this.data.getIteratorFrom(e[0]);
                for(; n.hasNext();){
                    var r = n.getNext();
                    if (this.comparator(r.key, e[1]) >= 0) return;
                    t(r.key);
                }
            }
        },
        {
            /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ key: "forEachWhile",
            value: function forEachWhile(e, t) {
                var n;
                for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
                    if (!e(n.getNext().key)) return;
                }
            }
        },
        {
            /** Finds the least element greater than or equal to `elem`. */ key: "firstAfterOrEqual",
            value: function firstAfterOrEqual(e) {
                var t = this.data.getIteratorFrom(e);
                return t.hasNext() ? t.getNext().key : null;
            }
        },
        {
            key: "getIterator",
            value: function getIterator() {
                return new SortedSetIterator(this.data.getIterator());
            }
        },
        {
            key: "getIteratorFrom",
            value: function getIteratorFrom(e) {
                return new SortedSetIterator(this.data.getIteratorFrom(e));
            }
        },
        {
            /** Inserts or updates an element */ key: "add",
            value: function add(e) {
                return this.copy(this.data.remove(e).insert(e, !0));
            }
        },
        {
            /** Deletes an element */ key: "delete",
            value: function _delete(e) {
                return this.has(e) ? this.copy(this.data.remove(e)) : this;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.data.isEmpty();
            }
        },
        {
            key: "unionWith",
            value: function unionWith(e) {
                var t = this;
                // Make sure `result` always refers to the larger one of the two sets.
                return t.size < e.size && (t = e, e = this), e.forEach(function(e) {
                    t = t.add(e);
                }), t;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                if (!(e instanceof SortedSet)) return !1;
                if (this.size !== e.size) return !1;
                var t = this.data.getIterator(), n = e.data.getIterator();
                for(; t.hasNext();){
                    var _$e = t.getNext().key, r = n.getNext().key;
                    if (0 !== this.comparator(_$e, r)) return !1;
                }
                return !0;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var e = [];
                return this.forEach(function(t) {
                    e.push(t);
                }), e;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var e = [];
                return this.forEach(function(t) {
                    return e.push(t);
                }), "SortedSet(" + e.toString() + ")";
            }
        },
        {
            key: "copy",
            value: function copy(e) {
                var t = new SortedSet(this.comparator);
                return t.data = e, t;
            }
        }
    ]);
    return SortedSet;
}();
var SortedSetIterator = /*#__PURE__*/ function() {
    "use strict";
    function SortedSetIterator(e) {
        (0, $19mwo._)(this, SortedSetIterator);
        this.iter = e;
    }
    (0, $6rpfc._)(SortedSetIterator, [
        {
            key: "getNext",
            value: function getNext() {
                return this.iter.getNext().key;
            }
        },
        {
            key: "hasNext",
            value: function hasNext() {
                return this.iter.hasNext();
            }
        }
    ]);
    return SortedSetIterator;
}();
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function __PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ var FieldMask = /*#__PURE__*/ function() {
    "use strict";
    function FieldMask(e) {
        (0, $19mwo._)(this, FieldMask);
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort(FieldPath$1.comparator);
    }
    (0, $6rpfc._)(FieldMask, [
        {
            /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ key: "unionWith",
            value: function unionWith(e) {
                var t = new SortedSet(FieldPath$1.comparator);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        t = t.add(_$e);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = e[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var n = _step1.value;
                        t = t.add(n);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return new FieldMask(t.toArray());
            }
        },
        {
            /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ key: "covers",
            value: function covers(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        if (t.isPrefixOf(e)) return !0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return !1;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return __PRIVATE_arrayEquals(this.fields, e.fields, function(e, t) {
                    return e.isEqual(t);
                });
            }
        }
    ], [
        {
            key: "empty",
            value: function empty() {
                return new FieldMask([]);
            }
        }
    ]);
    return FieldMask;
}();
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ var __PRIVATE_Base64DecodeError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_Base64DecodeError, Error1);
    var _super = (0, $k1NN5._)(__PRIVATE_Base64DecodeError);
    function __PRIVATE_Base64DecodeError() {
        (0, $19mwo._)(this, __PRIVATE_Base64DecodeError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments))), _this.name = "Base64DecodeError";
        return (0, $hSCyS._)(_this);
    }
    return __PRIVATE_Base64DecodeError;
}((0, $etlBe._)(Error));
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function __PRIVATE_isBase64Available() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ var ByteString = /*#__PURE__*/ function() {
    "use strict";
    function ByteString(e) {
        (0, $19mwo._)(this, ByteString);
        this.binaryString = e;
    }
    (0, $6rpfc._)(ByteString, [
        {
            key: Symbol.iterator,
            value: function value() {
                var _this = this;
                var e = 0;
                return {
                    next: function() {
                        return e < _this.binaryString.length ? {
                            value: _this.binaryString.charCodeAt(e++),
                            done: !1
                        } : {
                            value: void 0,
                            done: !0
                        };
                    }
                };
            }
        },
        {
            key: "toBase64",
            value: function toBase64() {
                return function __PRIVATE_encodeBase64(e) {
                    return btoa(e);
                }(this.binaryString);
            }
        },
        {
            key: "toUint8Array",
            value: function toUint8Array() {
                return function __PRIVATE_uint8ArrayFromBinaryString(e) {
                    var t = new Uint8Array(e.length);
                    for(var n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
                    return t;
                }(this.binaryString);
            }
        },
        {
            key: "approximateByteSize",
            value: function approximateByteSize() {
                return 2 * this.binaryString.length;
            }
        },
        {
            key: "compareTo",
            value: function compareTo(e) {
                return __PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return this.binaryString === e.binaryString;
            }
        }
    ], [
        {
            key: "fromBase64String",
            value: function fromBase64String(e) {
                var t = function __PRIVATE_decodeBase64(e) {
                    try {
                        return atob(e);
                    } catch (e) {
                        // Check that `DOMException` is defined before using it to avoid
                        // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                        // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                        throw "undefined" != typeof DOMException && e instanceof DOMException ? new __PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
                    }
                }(e);
                return new ByteString(t);
            }
        },
        {
            key: "fromUint8Array",
            value: function fromUint8Array(e) {
                // TODO(indexing); Remove the copy of the byte string here as this method
                // is frequently called during indexing.
                var t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
                    var t = "";
                    for(var n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
                    return t;
                }(e);
                return new ByteString(t);
            }
        }
    ]);
    return ByteString;
}();
ByteString.EMPTY_BYTE_STRING = new ByteString("");
var ne = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function __PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if (__PRIVATE_hardAssert(!!e), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        var t = 0;
        var n = ne.exec(e);
        if (__PRIVATE_hardAssert(!!n), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            var _$e = n[1];
            _$e = (_$e + "000000000").substr(0, 9), t = Number(_$e);
        }
        // Parse the date to get the seconds.
        var r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: __PRIVATE_normalizeNumber(e.seconds),
        nanos: __PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function __PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function __PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? ByteString.fromBase64String(e) : ByteString.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ function __PRIVATE_isServerTimestamp(e) {
    var t, n;
    return "server_timestamp" === (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function __PRIVATE_getPreviousValue(e) {
    var t = e.mapValue.fields.__previous_value__;
    return __PRIVATE_isServerTimestamp(t) ? __PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function __PRIVATE_getLocalWriteTime(e) {
    var t = __PRIVATE_normalizeTimestamp(e.mapValue.fields.__local_write_time__.timestampValue);
    return new Timestamp(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var DatabaseInfo = function DatabaseInfo(e, t, n, r, i, s, o, _, a) {
    "use strict";
    (0, $19mwo._)(this, DatabaseInfo);
    this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = o, this.longPollingOptions = _, this.useFetchStreams = a;
};
/** The default database name for a project. */ /**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ var DatabaseId = /*#__PURE__*/ function() {
    "use strict";
    function DatabaseId(e, t) {
        (0, $19mwo._)(this, DatabaseId);
        this.projectId = e, this.database = t || "(default)";
    }
    (0, $6rpfc._)(DatabaseId, [
        {
            key: "isDefaultDatabase",
            get: function get() {
                return "(default)" === this.database;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof DatabaseId && e.projectId === this.projectId && e.database === this.database;
            }
        }
    ], [
        {
            key: "empty",
            value: function empty() {
                return new DatabaseId("", "");
            }
        }
    ]);
    return DatabaseId;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var re = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: "__max__"
            }
        }
    }
}, ie = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function __PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? __PRIVATE_isServerTimestamp(e) ? 4 /* TypeOrder.ServerTimestampValue */  : __PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : 10 /* TypeOrder.ObjectValue */  : fail();
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function __PRIVATE_valueEquals(e, t) {
    if (e === t) return !0;
    var n = __PRIVATE_typeOrder(e);
    if (n !== __PRIVATE_typeOrder(t)) return !1;
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return __PRIVATE_getLocalWriteTime(e).isEqual(__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                var n = __PRIVATE_normalizeTimestamp(e.timestampValue), r = __PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return __PRIVATE_normalizeByteString(e.bytesValue).isEqual(__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return __PRIVATE_normalizeNumber(e.geoPointValue.latitude) === __PRIVATE_normalizeNumber(t.geoPointValue.latitude) && __PRIVATE_normalizeNumber(e.geoPointValue.longitude) === __PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t) {
                if ("integerValue" in e && "integerValue" in t) return __PRIVATE_normalizeNumber(e.integerValue) === __PRIVATE_normalizeNumber(t.integerValue);
                if ("doubleValue" in e && "doubleValue" in t) {
                    var n = __PRIVATE_normalizeNumber(e.doubleValue), r = __PRIVATE_normalizeNumber(t.doubleValue);
                    return n === r ? __PRIVATE_isNegativeZero(n) === __PRIVATE_isNegativeZero(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(e, t);
        case 9 /* TypeOrder.ArrayValue */ :
            return __PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], __PRIVATE_valueEquals);
        case 10 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t) {
                var n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
                if (__PRIVATE_objectSize(n) !== __PRIVATE_objectSize(r)) return !1;
                for(var _$e in n)if (n.hasOwnProperty(_$e) && (void 0 === r[_$e] || !__PRIVATE_valueEquals(n[_$e], r[_$e]))) return !1;
                return !0;
            }(e, t);
        default:
            return fail();
    }
}
function __PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find(function(e) {
        return __PRIVATE_valueEquals(e, t);
    });
}
function __PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    var n = __PRIVATE_typeOrder(e), r = __PRIVATE_typeOrder(t);
    if (n !== r) return __PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return __PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                var n = __PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = __PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return __PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return __PRIVATE_compareTimestamps(__PRIVATE_getLocalWriteTime(e), __PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return __PRIVATE_primitiveComparator(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                var n = __PRIVATE_normalizeByteString(e), r = __PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                var n = e.split("/"), r = t.split("/");
                for(var _$e = 0; _$e < n.length && _$e < r.length; _$e++){
                    var _$t = __PRIVATE_primitiveComparator(n[_$e], r[_$e]);
                    if (0 !== _$t) return _$t;
                }
                return __PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                var n = __PRIVATE_primitiveComparator(__PRIVATE_normalizeNumber(e.latitude), __PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return __PRIVATE_primitiveComparator(__PRIVATE_normalizeNumber(e.longitude), __PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_compareArrays(e, t) {
                var n = e.values || [], r = t.values || [];
                for(var _$e = 0; _$e < n.length && _$e < r.length; ++_$e){
                    var _$t = __PRIVATE_valueCompare(n[_$e], r[_$e]);
                    if (_$t) return _$t;
                }
                return __PRIVATE_primitiveComparator(n.length, r.length);
            }(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === re.mapValue && t === re.mapValue) return 0;
                if (e === re.mapValue) return 1;
                if (t === re.mapValue) return -1;
                var n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(var _$e = 0; _$e < r.length && _$e < s.length; ++_$e){
                    var _$t = __PRIVATE_primitiveComparator(r[_$e], s[_$e]);
                    if (0 !== _$t) return _$t;
                    var o = __PRIVATE_valueCompare(n[r[_$e]], i[s[_$e]]);
                    if (0 !== o) return o;
                }
                return __PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw fail();
    }
}
function __PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return __PRIVATE_primitiveComparator(e, t);
    var n = __PRIVATE_normalizeTimestamp(e), r = __PRIVATE_normalizeTimestamp(t), i = __PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : __PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function canonicalId(e) {
    return __PRIVATE_canonifyValue(e);
}
function __PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        var t = __PRIVATE_normalizeTimestamp(e);
        return "time(".concat(t.seconds, ",").concat(t.nanos, ")");
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return __PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return DocumentKey.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return "geo(".concat(e.latitude, ",").concat(e.longitude, ")");
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        var t = "[", n = !0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (e.values || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                n ? n = !1 : t += ",", t += __PRIVATE_canonifyValue(r);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        var t = Object.keys(e.fields || {}).sort();
        var n = "{", r = !0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var i = _step.value;
                r ? r = !1 : n += ",", n += "".concat(i, ":").concat(__PRIVATE_canonifyValue(e.fields[i]));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return n + "}";
    }(e.mapValue) : fail();
}
function __PRIVATE_estimateByteSize(e) {
    switch(__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            var t = __PRIVATE_getPreviousValue(e);
            return t ? 16 + __PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return __PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce(function(e, t) {
                    return e + __PRIVATE_estimateByteSize(t);
                }, 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                var t = 0;
                return forEach(e.fields, function(e, n) {
                    t += e.length + __PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw fail();
    }
}
function __PRIVATE_refValue(e, t) {
    return {
        referenceValue: "projects/".concat(e.projectId, "/databases/").concat(e.database, "/documents/").concat(t.path.canonicalString())
    };
}
/** Returns true if `value` is an IntegerValue . */ function isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is a NullValue. */ function __PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function __PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function __PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Creates a deep copy of `source`. */ function __PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: Object.assign({}, e.geoPointValue)
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: Object.assign({}, e.timestampValue)
    };
    if (e.mapValue) {
        var t = {
            mapValue: {
                fields: {}
            }
        };
        return forEach(e.mapValue.fields, function(e, n) {
            return t.mapValue.fields[e] = __PRIVATE_deepClone(n);
        }), t;
    }
    if (e.arrayValue) {
        var t1 = {
            arrayValue: {
                values: []
            }
        };
        for(var n = 0; n < (e.arrayValue.values || []).length; ++n)t1.arrayValue.values[n] = __PRIVATE_deepClone(e.arrayValue.values[n]);
        return t1;
    }
    return Object.assign({}, e);
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function __PRIVATE_isMaxValue(e) {
    return "__max__" === (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue;
}
/** Returns the lowest value for the given value type (inclusive). */ function __PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? ie : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? __PRIVATE_refValue(DatabaseId.empty(), DocumentKey.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? {
        mapValue: {}
    } : fail();
}
/** Returns the largest value for the given value type (exclusive). */ function __PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? __PRIVATE_refValue(DatabaseId.empty(), DocumentKey.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? {
        mapValue: {}
    } : "mapValue" in e ? re : fail();
}
function __PRIVATE_lowerBoundCompare(e, t) {
    var n = __PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function __PRIVATE_upperBoundCompare(e, t) {
    var n = __PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ var ObjectValue = /*#__PURE__*/ function() {
    "use strict";
    function ObjectValue(e) {
        (0, $19mwo._)(this, ObjectValue);
        this.value = e;
    }
    (0, $6rpfc._)(ObjectValue, [
        {
            /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ key: "field",
            value: function field(e) {
                if (e.isEmpty()) return this.value;
                {
                    var t = this.value;
                    for(var n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !__PRIVATE_isMapValue(t)) return null;
                    return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
                }
            }
        },
        {
            /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ key: "set",
            value: function set(e, t) {
                this.getFieldsMap(e.popLast())[e.lastSegment()] = __PRIVATE_deepClone(t);
            }
        },
        {
            /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ key: "setAll",
            value: function setAll(e) {
                var _this = this;
                var t = FieldPath$1.emptyPath(), n = {}, r = [];
                e.forEach(function(e, i) {
                    if (!t.isImmediateParentOf(i)) {
                        // Insert the accumulated changes at this parent location
                        var _$e = _this.getFieldsMap(t);
                        _this.applyChanges(_$e, n, r), n = {}, r = [], t = i.popLast();
                    }
                    e ? n[i.lastSegment()] = __PRIVATE_deepClone(e) : r.push(i.lastSegment());
                });
                var i = this.getFieldsMap(t);
                this.applyChanges(i, n, r);
            }
        },
        {
            /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ key: "delete",
            value: function _delete(e) {
                var t = this.field(e.popLast());
                __PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return __PRIVATE_valueEquals(this.value, e.value);
            }
        },
        {
            /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ key: "getFieldsMap",
            value: function getFieldsMap(e) {
                var t = this.value;
                t.mapValue.fields || (t.mapValue = {
                    fields: {}
                });
                for(var n = 0; n < e.length; ++n){
                    var r = t.mapValue.fields[e.get(n)];
                    __PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                        mapValue: {
                            fields: {}
                        }
                    }, t.mapValue.fields[e.get(n)] = r), t = r;
                }
                return t.mapValue.fields;
            }
        },
        {
            /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ key: "applyChanges",
            value: function applyChanges(e, t, n) {
                forEach(t, function(t, n) {
                    return e[t] = n;
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$t = _step.value;
                        delete e[_$t];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new ObjectValue(__PRIVATE_deepClone(this.value));
            }
        }
    ], [
        {
            key: "empty",
            value: function empty() {
                return new ObjectValue({
                    mapValue: {}
                });
            }
        }
    ]);
    return ObjectValue;
}();
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function __PRIVATE_extractFieldMask(e) {
    var t = [];
    return forEach(e.fields, function(e, n) {
        var r = new FieldPath$1([
            e
        ]);
        if (__PRIVATE_isMapValue(n)) {
            var _$e = __PRIVATE_extractFieldMask(n.mapValue).fields;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (0 === _$e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else try {
                // For nested and non-empty ObjectValues, add the FieldPath of the
                // leaf nodes.
                for(var _iterator = _$e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$n = _step.value;
                    t.push(r.child(_$n));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new FieldMask(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ var MutableDocument = /*#__PURE__*/ function() {
    "use strict";
    function MutableDocument(e, t, n, r, i, s, o) {
        (0, $19mwo._)(this, MutableDocument);
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = o;
    }
    (0, $6rpfc._)(MutableDocument, [
        {
            /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ key: "convertToFoundDocument",
            value: function convertToFoundDocument(e, t) {
                // If a document is switching state from being an invalid or deleted
                // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
                // update from Watch or due to applying a local set mutation on top
                // of a deleted document, our best guess about its createTime would be the
                // version at which the document transitioned to a FOUND_DOCUMENT.
                return !this.createTime.isEqual(SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
            }
        },
        {
            /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ key: "convertToNoDocument",
            value: function convertToNoDocument(e) {
                return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = ObjectValue.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
            }
        },
        {
            /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ key: "convertToUnknownDocument",
            value: function convertToUnknownDocument(e) {
                return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = ObjectValue.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
            }
        },
        {
            key: "setHasCommittedMutations",
            value: function setHasCommittedMutations() {
                return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
            }
        },
        {
            key: "setHasLocalMutations",
            value: function setHasLocalMutations() {
                return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = SnapshotVersion.min(), this;
            }
        },
        {
            key: "setReadTime",
            value: function setReadTime(e) {
                return this.readTime = e, this;
            }
        },
        {
            key: "hasLocalMutations",
            get: function get() {
                return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
            }
        },
        {
            key: "hasCommittedMutations",
            get: function get() {
                return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
            }
        },
        {
            key: "hasPendingWrites",
            get: function get() {
                return this.hasLocalMutations || this.hasCommittedMutations;
            }
        },
        {
            key: "isValidDocument",
            value: function isValidDocument() {
                return 0 /* DocumentType.INVALID */  !== this.documentType;
            }
        },
        {
            key: "isFoundDocument",
            value: function isFoundDocument() {
                return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
            }
        },
        {
            key: "isNoDocument",
            value: function isNoDocument() {
                return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
            }
        },
        {
            key: "isUnknownDocument",
            value: function isUnknownDocument() {
                return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
            }
        },
        {
            key: "mutableCopy",
            value: function mutableCopy() {
                return new MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "Document(".concat(this.key, ", ").concat(this.version, ", ").concat(JSON.stringify(this.data.value), ", {createTime: ").concat(this.createTime, "}), {documentType: ").concat(this.documentType, "}), {documentState: ").concat(this.documentState, "})");
            }
        }
    ], [
        {
            key: "newInvalidDocument",
            value: /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ function newInvalidDocument(e) {
                return new MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ SnapshotVersion.min(), /* readTime */ SnapshotVersion.min(), /* createTime */ SnapshotVersion.min(), ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
            }
        },
        {
            key: "newFoundDocument",
            value: /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ function newFoundDocument(e, t, n, r) {
                return new MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
            }
        },
        {
            key: "newNoDocument",
            value: /** Creates a new document that is known to not exist at the given version. */ function newNoDocument(e, t) {
                return new MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ SnapshotVersion.min(), /* createTime */ SnapshotVersion.min(), ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
            }
        },
        {
            key: "newUnknownDocument",
            value: /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ function newUnknownDocument(e, t) {
                return new MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ SnapshotVersion.min(), /* createTime */ SnapshotVersion.min(), ObjectValue.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
            }
        }
    ]);
    return MutableDocument;
}();
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ var Bound = function Bound(e, t) {
    "use strict";
    (0, $19mwo._)(this, Bound);
    this.position = e, this.inclusive = t;
};
function __PRIVATE_boundCompareToDocument(e, t, n) {
    var r = 0;
    for(var i = 0; i < e.position.length; i++){
        var s = t[i], o = e.position[i];
        if (s.field.isKeyField()) r = DocumentKey.comparator(DocumentKey.fromName(o.referenceValue), n.key);
        else r = __PRIVATE_valueCompare(o, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function __PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for(var n = 0; n < e.position.length; n++){
        if (!__PRIVATE_valueEquals(e.position[n], t.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ var OrderBy = function OrderBy(e) {
    "use strict";
    var t = arguments.length > 1 && arguments[1] !== void 0 /* Direction.ASCENDING */  ? arguments[1] : "asc";
    (0, $19mwo._)(this, OrderBy);
    this.field = e, this.dir = t;
};
function __PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Filter = function Filter() {
    "use strict";
    (0, $19mwo._)(this, Filter);
};
var FieldFilter = /*#__PURE__*/ function(Filter) {
    "use strict";
    (0, $iNfU4._)(FieldFilter, Filter);
    var _super = (0, $k1NN5._)(FieldFilter);
    function FieldFilter(e, t, n) {
        (0, $19mwo._)(this, FieldFilter);
        var _this;
        _this = _super.call(this), _this.field = e, _this.op = t, _this.value = n;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(FieldFilter, [
        {
            key: "matches",
            value: function matches(e) {
                var t = e.data.field(this.field);
                // Types do not have to match in NOT_EQUAL filters.
                return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && this.matchesComparison(__PRIVATE_valueCompare(t, this.value)) : null !== t && __PRIVATE_typeOrder(this.value) === __PRIVATE_typeOrder(t) && this.matchesComparison(__PRIVATE_valueCompare(t, this.value));
            // Only compare types with matching backend order (such as double and int).
            }
        },
        {
            key: "matchesComparison",
            value: function matchesComparison(e) {
                switch(this.op){
                    case "<" /* Operator.LESS_THAN */ :
                        return e < 0;
                    case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                        return e <= 0;
                    case "==" /* Operator.EQUAL */ :
                        return 0 === e;
                    case "!=" /* Operator.NOT_EQUAL */ :
                        return 0 !== e;
                    case ">" /* Operator.GREATER_THAN */ :
                        return e > 0;
                    case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                        return e >= 0;
                    default:
                        return fail();
                }
            }
        },
        {
            key: "isInequality",
            value: function isInequality() {
                return [
                    "<" /* Operator.LESS_THAN */ ,
                    "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
                    ">" /* Operator.GREATER_THAN */ ,
                    ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ].indexOf(this.op) >= 0;
            }
        },
        {
            key: "getFlattenedFilters",
            value: function getFlattenedFilters() {
                return [
                    this
                ];
            }
        },
        {
            key: "getFilters",
            value: function getFilters() {
                return [
                    this
                ];
            }
        }
    ], [
        {
            key: "create",
            value: /**
     * Creates a filter based on the provided arguments.
     */ function create(e, t, n) {
                return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new __PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new __PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new __PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new __PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new __PRIVATE_ArrayContainsAnyFilter(e, n) : new FieldFilter(e, t, n);
            }
        },
        {
            key: "createKeyFieldInFilter",
            value: function createKeyFieldInFilter(e, t, n) {
                return "in" /* Operator.IN */  === t ? new __PRIVATE_KeyFieldInFilter(e, n) : new __PRIVATE_KeyFieldNotInFilter(e, n);
            }
        }
    ]);
    return FieldFilter;
}(Filter);
var CompositeFilter = /*#__PURE__*/ function(Filter) {
    "use strict";
    (0, $iNfU4._)(CompositeFilter, Filter);
    var _super = (0, $k1NN5._)(CompositeFilter);
    function CompositeFilter(e, t) {
        (0, $19mwo._)(this, CompositeFilter);
        var _this;
        _this = _super.call(this), _this.filters = e, _this.op = t, _this.ae = null;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(CompositeFilter, [
        {
            key: "matches",
            value: function matches(e) {
                return __PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find(function(t) {
                    return !t.matches(e);
                }) : void 0 !== this.filters.find(function(t) {
                    return t.matches(e);
                });
            }
        },
        {
            key: "getFlattenedFilters",
            value: function getFlattenedFilters() {
                return null !== this.ae || (this.ae = this.filters.reduce(function(e, t) {
                    return e.concat(t.getFlattenedFilters());
                }, [])), this.ae;
            }
        },
        {
            // Returns a mutable copy of `this.filters`
            key: "getFilters",
            value: function getFilters() {
                return Object.assign([], this.filters);
            }
        }
    ], [
        {
            key: "create",
            value: /**
     * Creates a filter based on the provided arguments.
     */ function create(e, t) {
                return new CompositeFilter(e, t);
            }
        }
    ]);
    return CompositeFilter;
}(Filter);
function __PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function __PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function __PRIVATE_compositeFilterIsFlatConjunction(e) {
    return __PRIVATE_compositeFilterIsFlat(e) && __PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function __PRIVATE_compositeFilterIsFlat(e) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e.filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            if (t instanceof CompositeFilter) return !1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return !0;
}
function __PRIVATE_canonifyFilter(e) {
    if (e instanceof FieldFilter) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + canonicalId(e.value);
    if (__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map(function(e) {
        return __PRIVATE_canonifyFilter(e);
    }).join(",");
    {
        // filter instanceof CompositeFilter
        var t = e.filters.map(function(e) {
            return __PRIVATE_canonifyFilter(e);
        }).join(",");
        return "".concat(e.op, "(").concat(t, ")");
    }
}
function __PRIVATE_filterEquals(e, t) {
    return e instanceof FieldFilter ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof FieldFilter && e.op === t.op && e.field.isEqual(t.field) && __PRIVATE_valueEquals(e.value, t.value);
    }(e, t) : e instanceof CompositeFilter ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof CompositeFilter && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce(function(e, n, r) {
            return e && __PRIVATE_filterEquals(n, t.filters[r]);
        }, !0);
        return !1;
    }(e, t) : void fail();
}
function __PRIVATE_compositeFilterWithAddedFilters(e, t) {
    var n = e.filters.concat(t);
    return CompositeFilter.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function __PRIVATE_stringifyFilter(e) {
    return e instanceof FieldFilter ? function __PRIVATE_stringifyFieldFilter(e) {
        return "".concat(e.field.canonicalString(), " ").concat(e.op, " ").concat(canonicalId(e.value));
    }(e) : e instanceof CompositeFilter ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map(__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
var __PRIVATE_KeyFieldFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_KeyFieldFilter, FieldFilter);
    var _super = (0, $k1NN5._)(__PRIVATE_KeyFieldFilter);
    function __PRIVATE_KeyFieldFilter(e, t, n) {
        (0, $19mwo._)(this, __PRIVATE_KeyFieldFilter);
        var _this;
        _this = _super.call(this, e, t, n), _this.key = DocumentKey.fromName(n.referenceValue);
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_KeyFieldFilter, [
        {
            key: "matches",
            value: function matches(e) {
                var t = DocumentKey.comparator(e.key, this.key);
                return this.matchesComparison(t);
            }
        }
    ]);
    return __PRIVATE_KeyFieldFilter;
}(FieldFilter);
/** Filter that matches on key fields within an array. */ var __PRIVATE_KeyFieldInFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_KeyFieldInFilter, FieldFilter);
    var _super = (0, $k1NN5._)(__PRIVATE_KeyFieldInFilter);
    function __PRIVATE_KeyFieldInFilter(e, t) {
        (0, $19mwo._)(this, __PRIVATE_KeyFieldInFilter);
        var _this;
        _this = _super.call(this, e, "in" /* Operator.IN */ , t), _this.keys = __PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_KeyFieldInFilter, [
        {
            key: "matches",
            value: function matches(e) {
                return this.keys.some(function(t) {
                    return t.isEqual(e.key);
                });
            }
        }
    ]);
    return __PRIVATE_KeyFieldInFilter;
}(FieldFilter);
/** Filter that matches on key fields not present within an array. */ var __PRIVATE_KeyFieldNotInFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_KeyFieldNotInFilter, FieldFilter);
    var _super = (0, $k1NN5._)(__PRIVATE_KeyFieldNotInFilter);
    function __PRIVATE_KeyFieldNotInFilter(e, t) {
        (0, $19mwo._)(this, __PRIVATE_KeyFieldNotInFilter);
        var _this;
        _this = _super.call(this, e, "not-in" /* Operator.NOT_IN */ , t), _this.keys = __PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_KeyFieldNotInFilter, [
        {
            key: "matches",
            value: function matches(e) {
                return !this.keys.some(function(t) {
                    return t.isEqual(e.key);
                });
            }
        }
    ]);
    return __PRIVATE_KeyFieldNotInFilter;
}(FieldFilter);
function __PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    var n;
    return ((null === (n = t.arrayValue) || void 0 === n ? void 0 : n.values) || []).map(function(e) {
        return DocumentKey.fromName(e.referenceValue);
    });
}
/** A Filter that implements the array-contains operator. */ var __PRIVATE_ArrayContainsFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_ArrayContainsFilter, FieldFilter);
    var _super = (0, $k1NN5._)(__PRIVATE_ArrayContainsFilter);
    function __PRIVATE_ArrayContainsFilter(e, t) {
        (0, $19mwo._)(this, __PRIVATE_ArrayContainsFilter);
        return _super.call(this, e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    (0, $6rpfc._)(__PRIVATE_ArrayContainsFilter, [
        {
            key: "matches",
            value: function matches(e) {
                var t = e.data.field(this.field);
                return isArray(t) && __PRIVATE_arrayValueContains(t.arrayValue, this.value);
            }
        }
    ]);
    return __PRIVATE_ArrayContainsFilter;
}(FieldFilter);
/** A Filter that implements the IN operator. */ var __PRIVATE_InFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_InFilter, FieldFilter);
    var _super = (0, $k1NN5._)(__PRIVATE_InFilter);
    function __PRIVATE_InFilter(e, t) {
        (0, $19mwo._)(this, __PRIVATE_InFilter);
        return _super.call(this, e, "in" /* Operator.IN */ , t);
    }
    (0, $6rpfc._)(__PRIVATE_InFilter, [
        {
            key: "matches",
            value: function matches(e) {
                var t = e.data.field(this.field);
                return null !== t && __PRIVATE_arrayValueContains(this.value.arrayValue, t);
            }
        }
    ]);
    return __PRIVATE_InFilter;
}(FieldFilter);
/** A Filter that implements the not-in operator. */ var __PRIVATE_NotInFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_NotInFilter, FieldFilter);
    var _super = (0, $k1NN5._)(__PRIVATE_NotInFilter);
    function __PRIVATE_NotInFilter(e, t) {
        (0, $19mwo._)(this, __PRIVATE_NotInFilter);
        return _super.call(this, e, "not-in" /* Operator.NOT_IN */ , t);
    }
    (0, $6rpfc._)(__PRIVATE_NotInFilter, [
        {
            key: "matches",
            value: function matches(e) {
                if (__PRIVATE_arrayValueContains(this.value.arrayValue, {
                    nullValue: "NULL_VALUE"
                })) return !1;
                var t = e.data.field(this.field);
                return null !== t && !__PRIVATE_arrayValueContains(this.value.arrayValue, t);
            }
        }
    ]);
    return __PRIVATE_NotInFilter;
}(FieldFilter);
/** A Filter that implements the array-contains-any operator. */ var __PRIVATE_ArrayContainsAnyFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_ArrayContainsAnyFilter, FieldFilter);
    var _super = (0, $k1NN5._)(__PRIVATE_ArrayContainsAnyFilter);
    function __PRIVATE_ArrayContainsAnyFilter(e, t) {
        (0, $19mwo._)(this, __PRIVATE_ArrayContainsAnyFilter);
        return _super.call(this, e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    (0, $6rpfc._)(__PRIVATE_ArrayContainsAnyFilter, [
        {
            key: "matches",
            value: function matches(e) {
                var _this = this;
                var t = e.data.field(this.field);
                return !(!isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some(function(e) {
                    return __PRIVATE_arrayValueContains(_this.value.arrayValue, e);
                });
            }
        }
    ]);
    return __PRIVATE_ArrayContainsAnyFilter;
}(FieldFilter);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
var __PRIVATE_TargetImpl = function __PRIVATE_TargetImpl(e) {
    "use strict";
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
    (0, $19mwo._)(this, __PRIVATE_TargetImpl);
    this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = o, this.ue = null;
};
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function __PRIVATE_newTarget(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
    return new __PRIVATE_TargetImpl(e, t, n, r, i, s, o);
}
function __PRIVATE_canonifyTarget(e) {
    var t = __PRIVATE_debugCast(e);
    if (null === t.ue) {
        var _$e = t.path.canonicalString();
        null !== t.collectionGroup && (_$e += "|cg:" + t.collectionGroup), _$e += "|f:", _$e += t.filters.map(function(e) {
            return __PRIVATE_canonifyFilter(e);
        }).join(","), _$e += "|ob:", _$e += t.orderBy.map(function(e) {
            return function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            }(e);
        }).join(","), __PRIVATE_isNullOrUndefined(t.limit) || (_$e += "|l:", _$e += t.limit), t.startAt && (_$e += "|lb:", _$e += t.startAt.inclusive ? "b:" : "a:", _$e += t.startAt.position.map(function(e) {
            return canonicalId(e);
        }).join(",")), t.endAt && (_$e += "|ub:", _$e += t.endAt.inclusive ? "a:" : "b:", _$e += t.endAt.position.map(function(e) {
            return canonicalId(e);
        }).join(",")), t.ue = _$e;
    }
    return t.ue;
}
function __PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for(var n = 0; n < e.orderBy.length; n++)if (!__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for(var n1 = 0; n1 < e.filters.length; n1++)if (!__PRIVATE_filterEquals(e.filters[n1], t.filters[n1])) return !1;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!__PRIVATE_boundEquals(e.startAt, t.startAt) && __PRIVATE_boundEquals(e.endAt, t.endAt);
}
function __PRIVATE_targetIsDocumentTarget(e) {
    return DocumentKey.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function __PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter(function(e) {
        return e instanceof FieldFilter && e.field.isEqual(t);
    });
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function __PRIVATE_targetGetAscendingBound(e, t, n) {
    var r = ie, i = !0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Process all filters to find a value for the current field segment
        for(var _iterator = __PRIVATE_targetGetFieldFiltersForPath(e, t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$n = _step.value;
            var _$e = ie, _$t = !0;
            switch(_$n.op){
                case "<" /* Operator.LESS_THAN */ :
                case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                    _$e = __PRIVATE_valuesGetLowerBound(_$n.value);
                    break;
                case "==" /* Operator.EQUAL */ :
                case "in" /* Operator.IN */ :
                case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                    _$e = _$n.value;
                    break;
                case ">" /* Operator.GREATER_THAN */ :
                    _$e = _$n.value, _$t = !1;
                    break;
                case "!=" /* Operator.NOT_EQUAL */ :
                case "not-in" /* Operator.NOT_IN */ :
                    _$e = ie;
            }
            __PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: _$e,
                inclusive: _$t
            }) < 0 && (r = _$e, i = _$t);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(var s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            var _$e1 = n.position[s];
            __PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: _$e1,
                inclusive: n.inclusive
            }) < 0 && (r = _$e1, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function __PRIVATE_targetGetDescendingBound(e, t, n) {
    var r = re, i = !0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Process all filters to find a value for the current field segment
        for(var _iterator = __PRIVATE_targetGetFieldFiltersForPath(e, t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$n = _step.value;
            var _$e = re, _$t = !0;
            switch(_$n.op){
                case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                case ">" /* Operator.GREATER_THAN */ :
                    _$e = __PRIVATE_valuesGetUpperBound(_$n.value), _$t = !1;
                    break;
                case "==" /* Operator.EQUAL */ :
                case "in" /* Operator.IN */ :
                case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                    _$e = _$n.value;
                    break;
                case "<" /* Operator.LESS_THAN */ :
                    _$e = _$n.value, _$t = !1;
                    break;
                case "!=" /* Operator.NOT_EQUAL */ :
                case "not-in" /* Operator.NOT_IN */ :
                    _$e = re;
            }
            __PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: _$e,
                inclusive: _$t
            }) > 0 && (r = _$e, i = _$t);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(var s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            var _$e1 = n.position[s];
            __PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: _$e1,
                inclusive: n.inclusive
            }) > 0 && (r = _$e1, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ var __PRIVATE_QueryImpl = function __PRIVATE_QueryImpl(e) {
    "use strict";
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, s = arguments.length > 5 && arguments[5] !== void 0 /* LimitType.First */  ? arguments[5] : "F", o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, _ = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
    (0, $19mwo._)(this, __PRIVATE_QueryImpl);
    this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = o, this.endAt = _, this.ce = null, // The corresponding `Target` of this `Query` instance, for use with
    // non-aggregate queries.
    this.le = null, // The corresponding `Target` of this `Query` instance, for use with
    // aggregate queries. Unlike targets for non-aggregate queries,
    // aggregate query targets do not contain normalized order-bys, they only
    // contain explicit order-bys.
    this.he = null, this.startAt, this.endAt;
};
/** Creates a new Query instance with the options provided. */ function __PRIVATE_newQuery(e, t, n, r, i, s, o, _) {
    return new __PRIVATE_QueryImpl(e, t, n, r, i, s, o, _);
}
/** Creates a new Query for a query that matches all documents at `path` */ function __PRIVATE_newQueryForPath(e) {
    return new __PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function __PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function __PRIVATE_isCollectionGroupQuery(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function __PRIVATE_queryNormalizedOrderBy(e) {
    var t = __PRIVATE_debugCast(e);
    if (null === t.ce) {
        t.ce = [];
        var _$e = new Set;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Any explicit order by fields should be added as is.
            for(var _iterator = t.explicitOrderBy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var n = _step.value;
                t.ce.push(n), _$e.add(n.field.canonicalString());
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // The order of the implicit ordering always matches the last explicit order by.
        var n1 = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            var t = new SortedSet(FieldPath$1.comparator);
            return e.filters.forEach(function(e) {
                e.getFlattenedFilters().forEach(function(e) {
                    e.isInequality() && (t = t.add(e.field));
                });
            }), t;
        }(t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        r.forEach(function(r) {
            _$e.has(r.canonicalString()) || r.isKeyField() || t.ce.push(new OrderBy(r, n1));
        }), // Add the document key field to the last if it is not explicitly ordered.
        _$e.has(FieldPath$1.keyField().canonicalString()) || t.ce.push(new OrderBy(FieldPath$1.keyField(), n1));
    }
    return t.ce;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function __PRIVATE_queryToTarget(e) {
    var t = __PRIVATE_debugCast(e);
    return t.le || (t.le = __PRIVATE__queryToTarget(t, __PRIVATE_queryNormalizedOrderBy(e))), t.le;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function __PRIVATE_queryToAggregateTarget(e) {
    var t = __PRIVATE_debugCast(e);
    return t.he || // Do not include implicit order-bys for aggregate queries.
    (t.he = __PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.he;
}
function __PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return __PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map(function(e) {
            var _$t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new OrderBy(e.field, _$t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        var n = e.endAt ? new Bound(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new Bound(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return __PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function __PRIVATE_queryWithAddedFilter(e, t) {
    var n = e.filters.concat([
        t
    ]);
    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function __PRIVATE_queryWithLimit(e, t, n) {
    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function __PRIVATE_queryEquals(e, t) {
    return __PRIVATE_targetEquals(__PRIVATE_queryToTarget(e), __PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function __PRIVATE_canonifyQuery(e) {
    return "".concat(__PRIVATE_canonifyTarget(__PRIVATE_queryToTarget(e)), "|lt:").concat(e.limitType);
}
function __PRIVATE_stringifyQuery(e) {
    return "Query(target=".concat(function __PRIVATE_stringifyTarget(e) {
        var t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += ", filters: [".concat(e.filters.map(function(e) {
            return __PRIVATE_stringifyFilter(e);
        }).join(", "), "]")), __PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += ", orderBy: [".concat(e.orderBy.map(function(e) {
            return function __PRIVATE_stringifyOrderBy(e) {
                return "".concat(e.field.canonicalString(), " (").concat(e.dir, ")");
            }(e);
        }).join(", "), "]")), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map(function(e) {
            return canonicalId(e);
        }).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map(function(e) {
            return canonicalId(e);
        }).join(",")), "Target(".concat(t, ")");
    }(__PRIVATE_queryToTarget(e)), "; limitType=").concat(e.limitType, ")");
}
/** Returns whether `doc` matches the constraints of `query`. */ function __PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        var n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : DocumentKey.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
            // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
            // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
            // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
            // A document with content of {b:1} matches the filters, but does not match the orderBy because
            // it's missing the field 'a'.
            for(var _iterator = __PRIVATE_queryNormalizedOrderBy(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var n = _step.value;
                // order-by key always matches
                if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = e.filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var n = _step.value;
                if (!n.matches(t)) return !1;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            var r = __PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, __PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            var r = __PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, __PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        return !0;
    }(e, t);
}
function __PRIVATE_queryCollectionGroup(e) {
    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function __PRIVATE_newQueryComparator(e) {
    return function(t, n) {
        var r = !1;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = __PRIVATE_queryNormalizedOrderBy(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var i = _step.value;
                var _$e = __PRIVATE_compareDocs(i, t, n);
                if (0 !== _$e) return _$e;
                r = r || i.field.isKeyField();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return 0;
    };
}
function __PRIVATE_compareDocs(e, t, n) {
    var r = e.field.isKeyField() ? DocumentKey.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        var r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? __PRIVATE_valueCompare(r, i) : fail();
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return fail();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ var ObjectMap = /*#__PURE__*/ function() {
    "use strict";
    function ObjectMap(e, t) {
        (0, $19mwo._)(this, ObjectMap);
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    (0, $6rpfc._)(ObjectMap, [
        {
            /** Get a value for this key, or undefined if it does not exist. */ key: "get",
            value: function get(e) {
                var t = this.mapKeyFn(e), n = this.inner[t];
                if (void 0 !== n) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $2MTYX._)(_step.value, 2), t1 = _step_value[0], r = _step_value[1];
                            if (this.equalsFn(t1, e)) return r;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "has",
            value: function has(e) {
                return void 0 !== this.get(e);
            }
        },
        {
            /** Put this key and value in the map. */ key: "set",
            value: function set(e, t) {
                var n = this.mapKeyFn(e), r = this.inner[n];
                if (void 0 === r) return this.inner[n] = [
                    [
                        e,
                        t
                    ]
                ], void this.innerSize++;
                for(var n1 = 0; n1 < r.length; n1++)if (this.equalsFn(r[n1][0], e)) // This is updating an existing entry and does not increase `innerSize`.
                return void (r[n1] = [
                    e,
                    t
                ]);
                r.push([
                    e,
                    t
                ]), this.innerSize++;
            }
        },
        {
            /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ key: "delete",
            value: function _delete(e) {
                var t = this.mapKeyFn(e), n = this.inner[t];
                if (void 0 === n) return !1;
                for(var r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
                return !1;
            }
        },
        {
            key: "forEach",
            value: function forEach1(e) {
                forEach(this.inner, function(t, n) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $2MTYX._)(_step.value, 2), t1 = _step_value[0], r = _step_value[1];
                            e(t1, r);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty1() {
                return isEmpty(this.inner);
            }
        },
        {
            key: "size",
            value: function size() {
                return this.innerSize;
            }
        }
    ]);
    return ObjectMap;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var se = new SortedMap(DocumentKey.comparator);
function __PRIVATE_mutableDocumentMap() {
    return se;
}
var oe = new SortedMap(DocumentKey.comparator);
function documentMap() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    var t = oe;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            t = t.insert(n.key, n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return t;
}
function __PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    var t = oe;
    return e.forEach(function(e, n) {
        return t = t.insert(e, n.overlayedDocument);
    }), t;
}
function __PRIVATE_newOverlayMap() {
    return __PRIVATE_newDocumentKeyMap();
}
function __PRIVATE_newMutationMap() {
    return __PRIVATE_newDocumentKeyMap();
}
function __PRIVATE_newDocumentKeyMap() {
    return new ObjectMap(function(e) {
        return e.toString();
    }, function(e, t) {
        return e.isEqual(t);
    });
}
var _e = new SortedMap(DocumentKey.comparator);
var ae = new SortedSet(DocumentKey.comparator);
function __PRIVATE_documentKeySet() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    var t = ae;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            t = t.add(n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return t;
}
var ue = new SortedSet(__PRIVATE_primitiveComparator);
function __PRIVATE_targetIdSet() {
    return ue;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function __PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: __PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function __PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function toNumber(e, t) {
    return isSafeInteger(t) ? __PRIVATE_toInteger(t) : __PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ var TransformOperation = function TransformOperation() {
    "use strict";
    (0, $19mwo._)(this, TransformOperation);
    // Make sure that the structural type of `TransformOperation` is unique.
    // See https://github.com/microsoft/TypeScript/issues/5451
    this._ = void 0;
};
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function __PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof __PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        var _$n = {
            fields: {
                __type__: {
                    stringValue: "server_timestamp"
                },
                __local_write_time__: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && __PRIVATE_isServerTimestamp(t) && (t = __PRIVATE_getPreviousValue(t)), t && (_$n.fields.__previous_value__ = t), {
            mapValue: _$n
        };
    }(n, t) : e instanceof __PRIVATE_ArrayUnionTransformOperation ? __PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof __PRIVATE_ArrayRemoveTransformOperation ? __PRIVATE_applyArrayRemoveTransformOperation(e, t) : function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        var _$n = __PRIVATE_computeTransformOperationBaseValue(e, t), r = asNumber(_$n) + asNumber(e.Pe);
        return isInteger(_$n) && isInteger(e.Pe) ? __PRIVATE_toInteger(r) : __PRIVATE_toDouble(e.serializer, r);
    }(e, t);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function __PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof __PRIVATE_ArrayUnionTransformOperation ? __PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof __PRIVATE_ArrayRemoveTransformOperation ? __PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function __PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof __PRIVATE_NumericIncrementTransformOperation ? /** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function __PRIVATE_isNumber(e) {
        return isInteger(e) || function __PRIVATE_isDouble(e) {
            return !!e && "doubleValue" in e;
        }(e);
    }(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ var __PRIVATE_ServerTimestampTransform = /*#__PURE__*/ function(TransformOperation) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_ServerTimestampTransform, TransformOperation);
    var _super = (0, $k1NN5._)(__PRIVATE_ServerTimestampTransform);
    function __PRIVATE_ServerTimestampTransform() {
        (0, $19mwo._)(this, __PRIVATE_ServerTimestampTransform);
        return _super.apply(this, arguments);
    }
    return __PRIVATE_ServerTimestampTransform;
}(TransformOperation);
/** Transforms an array value via a union operation. */ var __PRIVATE_ArrayUnionTransformOperation = /*#__PURE__*/ function(TransformOperation) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_ArrayUnionTransformOperation, TransformOperation);
    var _super = (0, $k1NN5._)(__PRIVATE_ArrayUnionTransformOperation);
    function __PRIVATE_ArrayUnionTransformOperation(e) {
        (0, $19mwo._)(this, __PRIVATE_ArrayUnionTransformOperation);
        var _this;
        _this = _super.call(this), _this.elements = e;
        return (0, $hSCyS._)(_this);
    }
    return __PRIVATE_ArrayUnionTransformOperation;
}(TransformOperation);
function __PRIVATE_applyArrayUnionTransformOperation(e, t) {
    var n = __PRIVATE_coercedFieldValuesArray(t);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _$t = _step.value;
            n.some(function(e) {
                return __PRIVATE_valueEquals(e, _$t);
            }) || n.push(_$t);
        };
        for(var _iterator = e.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ var __PRIVATE_ArrayRemoveTransformOperation = /*#__PURE__*/ function(TransformOperation) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_ArrayRemoveTransformOperation, TransformOperation);
    var _super = (0, $k1NN5._)(__PRIVATE_ArrayRemoveTransformOperation);
    function __PRIVATE_ArrayRemoveTransformOperation(e) {
        (0, $19mwo._)(this, __PRIVATE_ArrayRemoveTransformOperation);
        var _this;
        _this = _super.call(this), _this.elements = e;
        return (0, $hSCyS._)(_this);
    }
    return __PRIVATE_ArrayRemoveTransformOperation;
}(TransformOperation);
function __PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    var n = __PRIVATE_coercedFieldValuesArray(t);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _$t = _step.value;
            n = n.filter(function(e) {
                return !__PRIVATE_valueEquals(e, _$t);
            });
        };
        for(var _iterator = e.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ var __PRIVATE_NumericIncrementTransformOperation = /*#__PURE__*/ function(TransformOperation) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_NumericIncrementTransformOperation, TransformOperation);
    var _super = (0, $k1NN5._)(__PRIVATE_NumericIncrementTransformOperation);
    function __PRIVATE_NumericIncrementTransformOperation(e, t) {
        (0, $19mwo._)(this, __PRIVATE_NumericIncrementTransformOperation);
        var _this;
        _this = _super.call(this), _this.serializer = e, _this.Pe = t;
        return (0, $hSCyS._)(_this);
    }
    return __PRIVATE_NumericIncrementTransformOperation;
}(TransformOperation);
function asNumber(e) {
    return __PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function __PRIVATE_coercedFieldValuesArray(e) {
    return isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ var FieldTransform = function FieldTransform(e, t) {
    "use strict";
    (0, $19mwo._)(this, FieldTransform);
    this.field = e, this.transform = t;
};
function __PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof __PRIVATE_ArrayUnionTransformOperation && t instanceof __PRIVATE_ArrayUnionTransformOperation || e instanceof __PRIVATE_ArrayRemoveTransformOperation && t instanceof __PRIVATE_ArrayRemoveTransformOperation ? __PRIVATE_arrayEquals(e.elements, t.elements, __PRIVATE_valueEquals) : e instanceof __PRIVATE_NumericIncrementTransformOperation && t instanceof __PRIVATE_NumericIncrementTransformOperation ? __PRIVATE_valueEquals(e.Pe, t.Pe) : e instanceof __PRIVATE_ServerTimestampTransform && t instanceof __PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ var MutationResult = function MutationResult(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t) {
    "use strict";
    (0, $19mwo._)(this, MutationResult);
    this.version = e, this.transformResults = t;
};
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ var Precondition = /*#__PURE__*/ function() {
    "use strict";
    function Precondition(e, t) {
        (0, $19mwo._)(this, Precondition);
        this.updateTime = e, this.exists = t;
    }
    (0, $6rpfc._)(Precondition, [
        {
            key: "isNone",
            get: /** Returns whether this Precondition is empty. */ function get() {
                return void 0 === this.updateTime && void 0 === this.exists;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
            }
        }
    ], [
        {
            key: "none",
            value: /** Creates a new empty Precondition. */ function none() {
                return new Precondition;
            }
        },
        {
            key: "exists",
            value: /** Creates a new Precondition with an exists flag. */ function exists(e) {
                return new Precondition(void 0, e);
            }
        },
        {
            key: "updateTime",
            value: /** Creates a new Precondition based on a version a document exists at. */ function updateTime(e) {
                return new Precondition(e);
            }
        }
    ]);
    return Precondition;
}();
/** Returns true if the preconditions is valid for the given document. */ function __PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ var Mutation = function Mutation() {
    "use strict";
    (0, $19mwo._)(this, Mutation);
};
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function __PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new __PRIVATE_DeleteMutation(e.key, Precondition.none()) : new __PRIVATE_SetMutation(e.key, e.data, Precondition.none());
    {
        var n = e.data, r = ObjectValue.empty();
        var i = new SortedSet(FieldPath$1.comparator);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$e = _step.value;
                if (!i.has(_$e)) {
                    var _$t = n.field(_$e);
                    // If we are deleting a nested field, we take the immediate parent as
                    // the mask used to construct the resulting mutation.
                    // Justification: Nested fields can create parent fields implicitly. If
                    // only a leaf entry is deleted in later mutations, the parent field
                    // should still remain, but we may have lost this information.
                    // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
                    // This leaves the final result (foo, {}). Despite the fact that `doc`
                    // has the correct result, `foo` is not in `mask`, and the resulting
                    // mutation would miss `foo`.
                    null === _$t && _$e.length > 1 && (_$e = _$e.popLast(), _$t = n.field(_$e)), null === _$t ? r.delete(_$e) : r.set(_$e, _$t), i = i.add(_$e);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return new __PRIVATE_PatchMutation(e.key, r, new FieldMask(i.toArray()), Precondition.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function __PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof __PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        var r = e.value.clone(), i = __PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof __PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        var r = __PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll(__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function __PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof __PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        var i = e.value.clone(), s = __PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof __PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        var i = __PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll(__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map(function(e) {
            return e.field;
        }));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if (__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function __PRIVATE_mutationExtractBaseValue(e, t) {
    var n = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e.fieldTransforms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            var _$e = t.data.field(r.field), i = __PRIVATE_computeTransformOperationBaseValue(r.transform, _$e || null);
            null != i && (null === n && (n = ObjectValue.empty()), n.set(r.field, i));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return n || null;
}
function __PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && __PRIVATE_arrayEquals(e, t, function(e, t) {
            return __PRIVATE_fieldTransformEquals(e, t);
        });
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ var __PRIVATE_SetMutation = /*#__PURE__*/ function(Mutation) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_SetMutation, Mutation);
    var _super = (0, $k1NN5._)(__PRIVATE_SetMutation);
    function __PRIVATE_SetMutation(e, t, n) {
        var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
        (0, $19mwo._)(this, __PRIVATE_SetMutation);
        var _this;
        _this = _super.call(this), _this.key = e, _this.value = t, _this.precondition = n, _this.fieldTransforms = r, _this.type = 0 /* MutationType.Set */ ;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_SetMutation, [
        {
            key: "getFieldMask",
            value: function getFieldMask() {
                return null;
            }
        }
    ]);
    return __PRIVATE_SetMutation;
}(Mutation);
var __PRIVATE_PatchMutation = /*#__PURE__*/ function(Mutation) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_PatchMutation, Mutation);
    var _super = (0, $k1NN5._)(__PRIVATE_PatchMutation);
    function __PRIVATE_PatchMutation(e, t, n, r) {
        var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [];
        (0, $19mwo._)(this, __PRIVATE_PatchMutation);
        var _this;
        _this = _super.call(this), _this.key = e, _this.data = t, _this.fieldMask = n, _this.precondition = r, _this.fieldTransforms = i, _this.type = 1 /* MutationType.Patch */ ;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_PatchMutation, [
        {
            key: "getFieldMask",
            value: function getFieldMask() {
                return this.fieldMask;
            }
        }
    ]);
    return __PRIVATE_PatchMutation;
}(Mutation);
function __PRIVATE_getPatch(e) {
    var t = new Map;
    return e.fieldMask.fields.forEach(function(n) {
        if (!n.isEmpty()) {
            var r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function __PRIVATE_serverTransformResults(e, t, n) {
    var r = new Map;
    __PRIVATE_hardAssert(e.length === n.length);
    for(var i = 0; i < n.length; i++){
        var s = e[i], o = s.transform, _ = t.data.field(s.field);
        r.set(s.field, __PRIVATE_applyTransformOperationToRemoteDocument(o, _, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function __PRIVATE_localTransformResults(e, t, n) {
    var r = new Map;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var i = _step.value;
            var _$e = i.transform, s = n.data.field(i.field);
            r.set(i.field, __PRIVATE_applyTransformOperationToLocalView(_$e, s, t));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ var __PRIVATE_DeleteMutation = /*#__PURE__*/ function(Mutation) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_DeleteMutation, Mutation);
    var _super = (0, $k1NN5._)(__PRIVATE_DeleteMutation);
    function __PRIVATE_DeleteMutation(e, t) {
        (0, $19mwo._)(this, __PRIVATE_DeleteMutation);
        var _this;
        _this = _super.call(this), _this.key = e, _this.precondition = t, _this.type = 2 /* MutationType.Delete */ , _this.fieldTransforms = [];
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_DeleteMutation, [
        {
            key: "getFieldMask",
            value: function getFieldMask() {
                return null;
            }
        }
    ]);
    return __PRIVATE_DeleteMutation;
}(Mutation);
var __PRIVATE_VerifyMutation = /*#__PURE__*/ function(Mutation) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_VerifyMutation, Mutation);
    var _super = (0, $k1NN5._)(__PRIVATE_VerifyMutation);
    function __PRIVATE_VerifyMutation(e, t) {
        (0, $19mwo._)(this, __PRIVATE_VerifyMutation);
        var _this;
        _this = _super.call(this), _this.key = e, _this.precondition = t, _this.type = 3 /* MutationType.Verify */ , _this.fieldTransforms = [];
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_VerifyMutation, [
        {
            key: "getFieldMask",
            value: function getFieldMask() {
                return null;
            }
        }
    ]);
    return __PRIVATE_VerifyMutation;
}(Mutation);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ var MutationBatch = /*#__PURE__*/ function() {
    "use strict";
    function MutationBatch(e, t, n, r) {
        (0, $19mwo._)(this, MutationBatch);
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    (0, $6rpfc._)(MutationBatch, [
        {
            /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ key: "applyToRemoteDocument",
            value: function applyToRemoteDocument(e, t) {
                var n = t.mutationResults;
                for(var _$t = 0; _$t < this.mutations.length; _$t++){
                    var r = this.mutations[_$t];
                    if (r.key.isEqual(e.key)) __PRIVATE_mutationApplyToRemoteDocument(r, e, n[_$t]);
                }
            }
        },
        {
            /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ key: "applyToLocalView",
            value: function applyToLocalView(e, t) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // First, apply the base state. This allows us to apply non-idempotent
                    // transform against a consistent set of values.
                    for(var _iterator = this.baseMutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var n = _step.value;
                        n.key.isEqual(e.key) && (t = __PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // Second, apply all user-provided mutations.
                    for(var _iterator1 = this.mutations[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var n1 = _step1.value;
                        n1.key.isEqual(e.key) && (t = __PRIVATE_mutationApplyToLocalView(n1, e, t, this.localWriteTime));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return t;
            }
        },
        {
            /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ key: "applyToLocalDocumentSet",
            value: function applyToLocalDocumentSet(e, t) {
                var _this = this;
                // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
                // directly (as done in `applyToLocalView()`), we can reduce the complexity
                // to O(n).
                var n = __PRIVATE_newMutationMap();
                return this.mutations.forEach(function(r) {
                    var i = e.get(r.key), s = i.overlayedDocument;
                    // TODO(mutabledocuments): This method should take a MutableDocumentMap
                    // and we should remove this cast.
                    var o = _this.applyToLocalView(s, i.mutatedFields);
                    // Set mutatedFields to null if the document is only from local mutations.
                    // This creates a Set or Delete mutation, instead of trying to create a
                    // patch mutation as the overlay.
                    o = t.has(r.key) ? null : o;
                    var _ = __PRIVATE_calculateOverlayMutation(s, o);
                    null !== _ && n.set(r.key, _), s.isValidDocument() || s.convertToNoDocument(SnapshotVersion.min());
                }), n;
            }
        },
        {
            key: "keys",
            value: function keys() {
                return this.mutations.reduce(function(e, t) {
                    return e.add(t.key);
                }, __PRIVATE_documentKeySet());
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return this.batchId === e.batchId && __PRIVATE_arrayEquals(this.mutations, e.mutations, function(e, t) {
                    return __PRIVATE_mutationEquals(e, t);
                }) && __PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, function(e, t) {
                    return __PRIVATE_mutationEquals(e, t);
                });
            }
        }
    ]);
    return MutationBatch;
}();
/** The result of applying a mutation batch to the backend. */ var MutationBatchResult = /*#__PURE__*/ function() {
    "use strict";
    function MutationBatchResult(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r) {
        (0, $19mwo._)(this, MutationBatchResult);
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    (0, $6rpfc._)(MutationBatchResult, null, [
        {
            key: "from",
            value: /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ function from(e, t, n) {
                __PRIVATE_hardAssert(e.mutations.length === n.length);
                var r = function __PRIVATE_documentVersionMap() {
                    return _e;
                }();
                var i = e.mutations;
                for(var _$e = 0; _$e < i.length; _$e++)r = r.insert(i[_$e].key, n[_$e].version);
                return new MutationBatchResult(e, t, n, r);
            }
        }
    ]);
    return MutationBatchResult;
}();
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ var Overlay = /*#__PURE__*/ function() {
    "use strict";
    function Overlay(e, t) {
        (0, $19mwo._)(this, Overlay);
        this.largestBatchId = e, this.mutation = t;
    }
    (0, $6rpfc._)(Overlay, [
        {
            key: "getKey",
            value: function getKey() {
                return this.mutation.key;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return null !== e && this.mutation === e.mutation;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "Overlay{\n      largestBatchId: ".concat(this.largestBatchId, ",\n      mutation: ").concat(this.mutation.toString(), "\n    }");
            }
        }
    ]);
    return Overlay;
}();
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ var __PRIVATE_AggregateImpl = function __PRIVATE_AggregateImpl(e, t, n) {
    "use strict";
    (0, $19mwo._)(this, __PRIVATE_AggregateImpl);
    this.alias = e, this.aggregateType = t, this.fieldPath = n;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var ExistenceFilter = function ExistenceFilter(e, t) {
    "use strict";
    (0, $19mwo._)(this, ExistenceFilter);
    this.count = e, this.unchangedNames = t;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var ce, le;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function __PRIVATE_isPermanentError(e) {
    switch(e){
        default:
            return fail();
        case C.CANCELLED:
        case C.UNKNOWN:
        case C.DEADLINE_EXCEEDED:
        case C.RESOURCE_EXHAUSTED:
        case C.INTERNAL:
        case C.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case C.UNAUTHENTICATED:
            return !1;
        case C.INVALID_ARGUMENT:
        case C.NOT_FOUND:
        case C.ALREADY_EXISTS:
        case C.PERMISSION_DENIED:
        case C.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case C.ABORTED:
        case C.OUT_OF_RANGE:
        case C.UNIMPLEMENTED:
        case C.DATA_LOSS:
            return !0;
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function __PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return __PRIVATE_logError("GRPC error has no .code"), C.UNKNOWN;
    switch(e){
        case ce.OK:
            return C.OK;
        case ce.CANCELLED:
            return C.CANCELLED;
        case ce.UNKNOWN:
            return C.UNKNOWN;
        case ce.DEADLINE_EXCEEDED:
            return C.DEADLINE_EXCEEDED;
        case ce.RESOURCE_EXHAUSTED:
            return C.RESOURCE_EXHAUSTED;
        case ce.INTERNAL:
            return C.INTERNAL;
        case ce.UNAVAILABLE:
            return C.UNAVAILABLE;
        case ce.UNAUTHENTICATED:
            return C.UNAUTHENTICATED;
        case ce.INVALID_ARGUMENT:
            return C.INVALID_ARGUMENT;
        case ce.NOT_FOUND:
            return C.NOT_FOUND;
        case ce.ALREADY_EXISTS:
            return C.ALREADY_EXISTS;
        case ce.PERMISSION_DENIED:
            return C.PERMISSION_DENIED;
        case ce.FAILED_PRECONDITION:
            return C.FAILED_PRECONDITION;
        case ce.ABORTED:
            return C.ABORTED;
        case ce.OUT_OF_RANGE:
            return C.OUT_OF_RANGE;
        case ce.UNIMPLEMENTED:
            return C.UNIMPLEMENTED;
        case ce.DATA_LOSS:
            return C.DATA_LOSS;
        default:
            return fail();
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ (le = ce || (ce = {}))[le.OK = 0] = "OK", le[le.CANCELLED = 1] = "CANCELLED", le[le.UNKNOWN = 2] = "UNKNOWN", le[le.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", le[le.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", le[le.NOT_FOUND = 5] = "NOT_FOUND", le[le.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", le[le.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", le[le.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", le[le.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", le[le.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", le[le.ABORTED = 10] = "ABORTED", le[le.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", le[le.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", le[le.INTERNAL = 13] = "INTERNAL", le[le.UNAVAILABLE = 14] = "UNAVAILABLE", le[le.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ var he = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance the instance to set.
 */ /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function __PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Pe = new (0, $iFOaV.Integer)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function __PRIVATE_getMd5HashValue(e) {
    var t = __PRIVATE_newTextEncoder().encode(e), n = new (0, $iFOaV.Md5);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function __PRIVATE_get64BitUints(e) {
    var t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $iFOaV.Integer)([
            n,
            r
        ], 0),
        new (0, $iFOaV.Integer)([
            i,
            s
        ], 0)
    ];
}
var BloomFilter = /*#__PURE__*/ function() {
    "use strict";
    function BloomFilter(e, t, n) {
        (0, $19mwo._)(this, BloomFilter);
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new __PRIVATE_BloomFilterError("Invalid padding: ".concat(t));
        if (n < 0) throw new __PRIVATE_BloomFilterError("Invalid hash count: ".concat(n));
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new __PRIVATE_BloomFilterError("Invalid hash count: ".concat(n));
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new __PRIVATE_BloomFilterError("Invalid padding when bitmap length is 0: ".concat(t));
        this.Ie = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.Te = (0, $iFOaV.Integer).fromNumber(this.Ie);
    }
    (0, $6rpfc._)(BloomFilter, [
        {
            // Calculate the ith hash value based on the hashed 64bit integers,
            // and calculate its corresponding bit index in the bitmap to be checked.
            key: "Ee",
            value: function Ee(e, t, n) {
                // Calculate hashed value h(i) = h1 + (i * h2).
                var r = e.add(t.multiply((0, $iFOaV.Integer).fromNumber(n)));
                // Wrap if hash value overflow 64bit.
                return 1 === r.compare(Pe) && (r = new (0, $iFOaV.Integer)([
                    r.getBits(0),
                    r.getBits(1)
                ], 0)), r.modulo(this.Te).toNumber();
            }
        },
        {
            // Return whether the bit on the given index in the bitmap is set to 1.
            key: "de",
            value: function de(e) {
                return 0 != (this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
            }
        },
        {
            key: "mightContain",
            value: function mightContain(e) {
                // Empty bitmap should always return false on membership check.
                if (0 === this.Ie) return !1;
                var t = __PRIVATE_getMd5HashValue(e), _$__PRIVATE_get64BitUints = (0, $2MTYX._)(__PRIVATE_get64BitUints(t), 2), n = _$__PRIVATE_get64BitUints[0], r = _$__PRIVATE_get64BitUints[1];
                for(var _$e = 0; _$e < this.hashCount; _$e++){
                    var t1 = this.Ee(n, r, _$e);
                    if (!this.de(t1)) return !1;
                }
                return !0;
            }
        },
        {
            key: "insert",
            value: function insert(e) {
                if (0 === this.Ie) return;
                var t = __PRIVATE_getMd5HashValue(e), _$__PRIVATE_get64BitUints = (0, $2MTYX._)(__PRIVATE_get64BitUints(t), 2), n = _$__PRIVATE_get64BitUints[0], r = _$__PRIVATE_get64BitUints[1];
                for(var _$e = 0; _$e < this.hashCount; _$e++){
                    var t1 = this.Ee(n, r, _$e);
                    this.Ae(t1);
                }
            }
        },
        {
            key: "Ae",
            value: function Ae(e) {
                var t = Math.floor(e / 8), n = e % 8;
                this.bitmap[t] |= 1 << n;
            }
        }
    ], [
        {
            key: "create",
            value: /** Create bloom filter for testing purposes only. */ function create(e, t, n) {
                var r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new BloomFilter(i, r, t);
                return n.forEach(function(e) {
                    return s.insert(e);
                }), s;
            }
        }
    ]);
    return BloomFilter;
}();
var __PRIVATE_BloomFilterError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_BloomFilterError, Error1);
    var _super = (0, $k1NN5._)(__PRIVATE_BloomFilterError);
    function __PRIVATE_BloomFilterError() {
        (0, $19mwo._)(this, __PRIVATE_BloomFilterError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments))), _this.name = "BloomFilterError";
        return (0, $hSCyS._)(_this);
    }
    return __PRIVATE_BloomFilterError;
}((0, $etlBe._)(Error));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ var RemoteEvent = /*#__PURE__*/ function() {
    "use strict";
    function RemoteEvent(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i) {
        (0, $19mwo._)(this, RemoteEvent);
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
    }
    (0, $6rpfc._)(RemoteEvent, null, [
        {
            key: "createSynthesizedRemoteEventForCurrentChange",
            value: /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
            function createSynthesizedRemoteEventForCurrentChange(e, t, n) {
                var r = new Map;
                return r.set(e, TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new RemoteEvent(SnapshotVersion.min(), r, new SortedMap(__PRIVATE_primitiveComparator), __PRIVATE_mutableDocumentMap(), __PRIVATE_documentKeySet());
            }
        }
    ]);
    return RemoteEvent;
}();
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ var TargetChange = /*#__PURE__*/ function() {
    "use strict";
    function TargetChange(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i) {
        (0, $19mwo._)(this, TargetChange);
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    (0, $6rpfc._)(TargetChange, null, [
        {
            key: "createSynthesizedTargetChangeForCurrentChange",
            value: /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ function createSynthesizedTargetChangeForCurrentChange(e, t, n) {
                return new TargetChange(n, t, __PRIVATE_documentKeySet(), __PRIVATE_documentKeySet(), __PRIVATE_documentKeySet());
            }
        }
    ]);
    return TargetChange;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ var __PRIVATE_DocumentWatchChange = function __PRIVATE_DocumentWatchChange(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r) {
    "use strict";
    (0, $19mwo._)(this, __PRIVATE_DocumentWatchChange);
    this.Re = e, this.removedTargetIds = t, this.key = n, this.Ve = r;
};
var __PRIVATE_ExistenceFilterChange = function __PRIVATE_ExistenceFilterChange(e, t) {
    "use strict";
    (0, $19mwo._)(this, __PRIVATE_ExistenceFilterChange);
    this.targetId = e, this.me = t;
};
var __PRIVATE_WatchTargetChange = function __PRIVATE_WatchTargetChange(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t) {
    "use strict";
    var /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ByteString.EMPTY_BYTE_STRING, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    (0, $19mwo._)(this, __PRIVATE_WatchTargetChange);
    this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
};
/** Tracks the internal state of a Watch target. */ var __PRIVATE_TargetState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TargetState() {
        (0, $19mwo._)(this, __PRIVATE_TargetState);
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.fe = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.ge = __PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.pe = ByteString.EMPTY_BYTE_STRING, this.ye = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.we = !0;
    }
    (0, $6rpfc._)(__PRIVATE_TargetState, [
        {
            key: "current",
            get: /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ function get() {
                return this.ye;
            }
        },
        {
            key: "resumeToken",
            get: /** The last resume token sent to us for this target. */ function get() {
                return this.pe;
            }
        },
        {
            key: "Se",
            get: /** Whether this target has pending target adds or target removes. */ function get() {
                return 0 !== this.fe;
            }
        },
        {
            key: "be",
            get: /** Whether we have modified any state that should trigger a snapshot. */ function get() {
                return this.we;
            }
        },
        {
            /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ key: "De",
            value: function De(e) {
                e.approximateByteSize() > 0 && (this.we = !0, this.pe = e);
            }
        },
        {
            /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ key: "Ce",
            value: function Ce() {
                var e = __PRIVATE_documentKeySet(), t = __PRIVATE_documentKeySet(), n = __PRIVATE_documentKeySet();
                return this.ge.forEach(function(r, i) {
                    switch(i){
                        case 0 /* ChangeType.Added */ :
                            e = e.add(r);
                            break;
                        case 2 /* ChangeType.Modified */ :
                            t = t.add(r);
                            break;
                        case 1 /* ChangeType.Removed */ :
                            n = n.add(r);
                            break;
                        default:
                            fail();
                    }
                }), new TargetChange(this.pe, this.ye, e, t, n);
            }
        },
        {
            /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ key: "ve",
            value: function ve() {
                this.we = !1, this.ge = __PRIVATE_snapshotChangesMap();
            }
        },
        {
            key: "Fe",
            value: function Fe(e, t) {
                this.we = !0, this.ge = this.ge.insert(e, t);
            }
        },
        {
            key: "Me",
            value: function Me(e) {
                this.we = !0, this.ge = this.ge.remove(e);
            }
        },
        {
            key: "xe",
            value: function xe() {
                this.fe += 1;
            }
        },
        {
            key: "Oe",
            value: function Oe() {
                this.fe -= 1, __PRIVATE_hardAssert(this.fe >= 0);
            }
        },
        {
            key: "Ne",
            value: function Ne() {
                this.we = !0, this.ye = !0;
            }
        }
    ]);
    return __PRIVATE_TargetState;
}();
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ var __PRIVATE_WatchChangeAggregator = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_WatchChangeAggregator(e) {
        (0, $19mwo._)(this, __PRIVATE_WatchChangeAggregator);
        this.Le = e, /** The internal state of all tracked targets. */ this.Be = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.ke = __PRIVATE_mutableDocumentMap(), /** A mapping of document keys to their set of target IDs. */ this.qe = __PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Qe = new SortedMap(__PRIVATE_primitiveComparator);
    }
    (0, $6rpfc._)(__PRIVATE_WatchChangeAggregator, [
        {
            /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ key: "Ke",
            value: function Ke(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e.Re[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        e.Ve && e.Ve.isFoundDocument() ? this.$e(t, e.Ve) : this.Ue(t, e.key, e.Ve);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = e.removedTargetIds[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var t1 = _step1.value;
                        this.Ue(t1, e.key, e.Ve);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            /** Processes and adds the WatchTargetChange to the current set of changes. */ key: "We",
            value: function We(e) {
                var _this = this;
                this.forEachTarget(e, function(t) {
                    var n = _this.Ge(t);
                    switch(e.state){
                        case 0 /* WatchTargetChangeState.NoChange */ :
                            _this.ze(t) && n.De(e.resumeToken);
                            break;
                        case 1 /* WatchTargetChangeState.Added */ :
                            // We need to decrement the number of pending acks needed from watch
                            // for this targetId.
                            n.Oe(), n.Se || // We have a freshly added target, so we need to reset any state
                            // that we had previously. This can happen e.g. when remove and add
                            // back a target for existence filter mismatches.
                            n.ve(), n.De(e.resumeToken);
                            break;
                        case 2 /* WatchTargetChangeState.Removed */ :
                            // We need to keep track of removed targets to we can post-filter and
                            // remove any target changes.
                            // We need to decrement the number of pending acks needed from watch
                            // for this targetId.
                            n.Oe(), n.Se || _this.removeTarget(t);
                            break;
                        case 3 /* WatchTargetChangeState.Current */ :
                            _this.ze(t) && (n.Ne(), n.De(e.resumeToken));
                            break;
                        case 4 /* WatchTargetChangeState.Reset */ :
                            _this.ze(t) && // Reset the target and synthesizes removes for all existing
                            // documents. The backend will re-add any documents that still
                            // match the target before it sends the next global snapshot.
                            (_this.je(t), n.De(e.resumeToken));
                            break;
                        default:
                            fail();
                    }
                });
            }
        },
        {
            /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ key: "forEachTarget",
            value: function forEachTarget(e, t) {
                var _this = this;
                e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.Be.forEach(function(e, n) {
                    _this.ze(n) && t(n);
                });
            }
        },
        {
            /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ key: "He",
            value: function He(e) {
                var t = e.targetId, n = e.me.count, r = this.Je(t);
                if (r) {
                    var i = r.target;
                    if (__PRIVATE_targetIsDocumentTarget(i)) {
                        if (0 === n) {
                            // The existence filter told us the document does not exist. We deduce
                            // that this document does not exist and apply a deleted document to
                            // our updates. Without applying this deleted document there might be
                            // another query that will raise this document as part of a snapshot
                            // until it is resolved, essentially exposing inconsistency between
                            // queries.
                            var _$e = new DocumentKey(i.path);
                            this.Ue(t, _$e, MutableDocument.newNoDocument(_$e, SnapshotVersion.min()));
                        } else __PRIVATE_hardAssert(1 === n);
                    } else {
                        var r1 = this.Ye(t);
                        // Existence filter mismatch. Mark the documents as being in limbo, and
                        // raise a snapshot with `isFromCache:true`.
                        if (r1 !== n) {
                            // Apply bloom filter to identify and mark removed documents.
                            var n1 = this.Ze(e), i1 = n1 ? this.Xe(n1, e, r1) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                            if (0 /* BloomFilterApplicationStatus.Success */  !== i1) {
                                // If bloom filter application fails, we reset the mapping and
                                // trigger re-run of the query.
                                this.je(t);
                                var _$e1 = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i1 ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                                this.Qe = this.Qe.insert(t, _$e1);
                            }
                            null == he || he.et(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                                var s, o, _, a, u, c;
                                var l = {
                                    localCacheCount: e,
                                    existenceFilterCount: t.count,
                                    databaseId: n.database,
                                    projectId: n.projectId
                                }, h = t.unchangedNames;
                                h && (l.bloomFilter = {
                                    applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                                    hashCount: null !== (s = null == h ? void 0 : h.hashCount) && void 0 !== s ? s : 0,
                                    bitmapLength: null !== (a = null === (_ = null === (o = null == h ? void 0 : h.bits) || void 0 === o ? void 0 : o.bitmap) || void 0 === _ ? void 0 : _.length) && void 0 !== a ? a : 0,
                                    padding: null !== (c = null === (u = null == h ? void 0 : h.bits) || void 0 === u ? void 0 : u.padding) && void 0 !== c ? c : 0,
                                    mightContain: function(e) {
                                        var _$t;
                                        return null !== (_$t = null == r ? void 0 : r.mightContain(e)) && void 0 !== _$t && _$t;
                                    }
                                });
                                return l;
                            }(r1, e.me, this.Le.tt(), n1, i1));
                        }
                    }
                }
            }
        },
        {
            /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ key: "Ze",
            value: function Ze(e) {
                var t = e.me.unchangedNames;
                if (!t || !t.bits) return null;
                var _t_bits = t.bits, tmp = _t_bits.bitmap, n = tmp === void 0 ? "" : tmp, tmp1 = _t_bits.padding, r = tmp1 === void 0 ? 0 : tmp1, tmp2 = t.hashCount, i = tmp2 === void 0 ? 0 : tmp2;
                var s, o;
                try {
                    s = __PRIVATE_normalizeByteString(n).toUint8Array();
                } catch (e) {
                    if (e instanceof __PRIVATE_Base64DecodeError) return __PRIVATE_logWarn("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
                    throw e;
                }
                try {
                    // BloomFilter throws error if the inputs are invalid.
                    o = new BloomFilter(s, r, i);
                } catch (e) {
                    return __PRIVATE_logWarn(e instanceof __PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
                }
                return 0 === o.Ie ? null : o;
            }
        },
        {
            /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ key: "Xe",
            value: function Xe(e, t, n) {
                return t.me.count === n - this.nt(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
            }
        },
        {
            /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ key: "nt",
            value: function nt(e, t) {
                var _this = this;
                var n = this.Le.getRemoteKeysForTarget(t);
                var r = 0;
                return n.forEach(function(n) {
                    var i = _this.Le.tt(), s = "projects/".concat(i.projectId, "/databases/").concat(i.database, "/documents/").concat(n.path.canonicalString());
                    e.mightContain(s) || (_this.Ue(t, n, /*updatedDocument=*/ null), r++);
                }), r;
            }
        },
        {
            /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ key: "rt",
            value: function rt(e) {
                var _this = this;
                var t = new Map;
                this.Be.forEach(function(n, r) {
                    var i = _this.Je(r);
                    if (i) {
                        if (n.current && __PRIVATE_targetIsDocumentTarget(i.target)) {
                            // Document queries for document that don't exist can produce an empty
                            // result set. To update our local cache, we synthesize a document
                            // delete if we have not previously received the document. This
                            // resolves the limbo state of the document, removing it from
                            // limboDocumentRefs.
                            // TODO(dimond): Ideally we would have an explicit lookup target
                            // instead resulting in an explicit delete message and we could
                            // remove this special logic.
                            var t1 = new DocumentKey(i.target.path);
                            null !== _this.ke.get(t1) || _this.it(r, t1) || _this.Ue(r, t1, MutableDocument.newNoDocument(t1, e));
                        }
                        n.be && (t.set(r, n.Ce()), n.ve());
                    }
                });
                var n = __PRIVATE_documentKeySet();
                // We extract the set of limbo-only document updates as the GC logic
                // special-cases documents that do not appear in the target cache.
                // TODO(gsoltis): Expand on this comment once GC is available in the JS
                // client.
                this.qe.forEach(function(e, t) {
                    var r = !0;
                    t.forEachWhile(function(e) {
                        var _$t = _this.Je(e);
                        return !_$t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === _$t.purpose || (r = !1, !1);
                    }), r && (n = n.add(e));
                }), this.ke.forEach(function(t, n) {
                    return n.setReadTime(e);
                });
                var r = new RemoteEvent(e, t, this.Qe, this.ke, n);
                return this.ke = __PRIVATE_mutableDocumentMap(), this.qe = __PRIVATE_documentTargetMap(), this.Qe = new SortedMap(__PRIVATE_primitiveComparator), r;
            }
        },
        {
            /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
            key: "$e",
            value: function $e(e, t) {
                if (!this.ze(e)) return;
                var n = this.it(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
                this.Ge(e).Fe(t.key, n), this.ke = this.ke.insert(t.key, t), this.qe = this.qe.insert(t.key, this.st(t.key).add(e));
            }
        },
        {
            /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
            key: "Ue",
            value: function Ue(e, t, n) {
                if (!this.ze(e)) return;
                var r = this.Ge(e);
                this.it(e, t) ? r.Fe(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
                // snapshot, so we can just ignore the change.
                r.Me(t), this.qe = this.qe.insert(t, this.st(t).delete(e)), n && (this.ke = this.ke.insert(t, n));
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(e) {
                this.Be.delete(e);
            }
        },
        {
            /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ key: "Ye",
            value: function Ye(e) {
                var t = this.Ge(e).Ce();
                return this.Le.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
            }
        },
        {
            /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ key: "xe",
            value: function xe(e) {
                this.Ge(e).xe();
            }
        },
        {
            key: "Ge",
            value: function Ge(e) {
                var t = this.Be.get(e);
                return t || (t = new __PRIVATE_TargetState, this.Be.set(e, t)), t;
            }
        },
        {
            key: "st",
            value: function st(e) {
                var t = this.qe.get(e);
                return t || (t = new SortedSet(__PRIVATE_primitiveComparator), this.qe = this.qe.insert(e, t)), t;
            }
        },
        {
            /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ key: "ze",
            value: function ze(e) {
                var t = null !== this.Je(e);
                return t || __PRIVATE_logDebug("WatchChangeAggregator", "Detected inactive target", e), t;
            }
        },
        {
            /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ key: "Je",
            value: function Je(e) {
                var t = this.Be.get(e);
                return t && t.Se ? null : this.Le.ot(e);
            }
        },
        {
            /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ key: "je",
            value: function je(e) {
                var _this = this;
                this.Be.set(e, new __PRIVATE_TargetState);
                this.Le.getRemoteKeysForTarget(e).forEach(function(t) {
                    _this.Ue(e, t, /*updatedDocument=*/ null);
                });
            }
        },
        {
            /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ key: "it",
            value: function it(e, t) {
                return this.Le.getRemoteKeysForTarget(e).has(t);
            }
        }
    ]);
    return __PRIVATE_WatchChangeAggregator;
}();
function __PRIVATE_documentTargetMap() {
    return new SortedMap(DocumentKey.comparator);
}
function __PRIVATE_snapshotChangesMap() {
    return new SortedMap(DocumentKey.comparator);
}
var Ie = function() {
    var e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
}(), Te = function() {
    var e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
}(), Ee = function() {
    var e = {
        and: "AND",
        or: "OR"
    };
    return e;
}();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ var JsonProtoSerializer = function JsonProtoSerializer(e, t) {
    "use strict";
    (0, $19mwo._)(this, JsonProtoSerializer);
    this.databaseId = e, this.useProto3Json = t;
};
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function __PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || __PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function toTimestamp(e, t) {
    if (e.useProto3Json) return "".concat(new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", ""), ".").concat(("000000000" + t.nanoseconds).slice(-9), "Z");
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function __PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function __PRIVATE_toVersion(e, t) {
    return toTimestamp(e, t.toTimestamp());
}
function __PRIVATE_fromVersion(e) {
    return __PRIVATE_hardAssert(!!e), SnapshotVersion.fromTimestamp(function fromTimestamp(e) {
        var t = __PRIVATE_normalizeTimestamp(e);
        return new Timestamp(t.seconds, t.nanos);
    }(e));
}
function __PRIVATE_toResourceName(e, t) {
    return __PRIVATE_toResourcePath(e, t).canonicalString();
}
function __PRIVATE_toResourcePath(e, t) {
    var n = (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new ResourcePath([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents");
    return void 0 === t ? n : n.child(t);
}
function __PRIVATE_fromResourceName(e) {
    var t = ResourcePath.fromString(e);
    return __PRIVATE_hardAssert(__PRIVATE_isValidResourceName(t)), t;
}
function __PRIVATE_toName(e, t) {
    return __PRIVATE_toResourceName(e.databaseId, t.path);
}
function fromName(e, t) {
    var n = __PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new FirestoreError(C.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new FirestoreError(C.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new DocumentKey(__PRIVATE_extractLocalPathFromResourceName(n));
}
function __PRIVATE_toQueryPath(e, t) {
    return __PRIVATE_toResourceName(e.databaseId, t);
}
function __PRIVATE_fromQueryPath(e) {
    var t = __PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? ResourcePath.emptyPath() : __PRIVATE_extractLocalPathFromResourceName(t);
}
function __PRIVATE_getEncodedDatabaseId(e) {
    return new ResourcePath([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function __PRIVATE_extractLocalPathFromResourceName(e) {
    return __PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4)), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function __PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: __PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function __PRIVATE_fromDocument(e, t, n) {
    var r = fromName(e, t.name), i = __PRIVATE_fromVersion(t.updateTime), s = t.createTime ? __PRIVATE_fromVersion(t.createTime) : SnapshotVersion.min(), o = new ObjectValue({
        mapValue: {
            fields: t.fields
        }
    }), _ = MutableDocument.newFoundDocument(r, i, s, o);
    return n && _.setHasCommittedMutations(), n ? _.setHasCommittedMutations() : _;
}
function __PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        __PRIVATE_hardAssert(!!t.found), t.found.name, t.found.updateTime;
        var n = fromName(e, t.found.name), r = __PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? __PRIVATE_fromVersion(t.found.createTime) : SnapshotVersion.min(), s = new ObjectValue({
            mapValue: {
                fields: t.found.fields
            }
        });
        return MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        __PRIVATE_hardAssert(!!t.missing), __PRIVATE_hardAssert(!!t.readTime);
        var n = fromName(e, t.missing), r = __PRIVATE_fromVersion(t.readTime);
        return MutableDocument.newNoDocument(n, r);
    }(e, t) : fail();
}
function __PRIVATE_fromWatchChange(e, t) {
    var n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        var r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : fail();
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? (__PRIVATE_hardAssert(void 0 === t || "string" == typeof t), ByteString.fromBase64String(t || "")) : (__PRIVATE_hardAssert(void 0 === t || // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof $81404ad005fd14bc$require$Buffer || t instanceof Uint8Array), ByteString.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), o = t.targetChange.cause, _ = o && function __PRIVATE_fromRpcStatus(e) {
            var _$t = void 0 === e.code ? C.UNKNOWN : __PRIVATE_mapCodeFromRpcCode(e.code);
            return new FirestoreError(_$t, e.message || "");
        }(o);
        n = new __PRIVATE_WatchTargetChange(r, i, s, _ || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        var r1 = t.documentChange;
        r1.document, r1.document.name, r1.document.updateTime;
        var i1 = fromName(e, r1.document.name), s1 = __PRIVATE_fromVersion(r1.document.updateTime), o1 = r1.document.createTime ? __PRIVATE_fromVersion(r1.document.createTime) : SnapshotVersion.min(), _1 = new ObjectValue({
            mapValue: {
                fields: r1.document.fields
            }
        }), a = MutableDocument.newFoundDocument(i1, s1, o1, _1), u = r1.targetIds || [], c = r1.removedTargetIds || [];
        n = new __PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        var r2 = t.documentDelete;
        r2.document;
        var i2 = fromName(e, r2.document), s2 = r2.readTime ? __PRIVATE_fromVersion(r2.readTime) : SnapshotVersion.min(), o2 = MutableDocument.newNoDocument(i2, s2), _2 = r2.removedTargetIds || [];
        n = new __PRIVATE_DocumentWatchChange([], _2, o2.key, o2);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        var r3 = t.documentRemove;
        r3.document;
        var i3 = fromName(e, r3.document), s3 = r3.removedTargetIds || [];
        n = new __PRIVATE_DocumentWatchChange([], s3, i3, null);
    } else {
        if (!("filter" in t)) return fail();
        {
            t.filter;
            var _$e = t.filter;
            _$e.targetId;
            var tmp = _$e.count, r4 = tmp === void 0 ? 0 : tmp, i4 = _$e.unchangedNames, s4 = new ExistenceFilter(r4, i4), o3 = _$e.targetId;
            n = new __PRIVATE_ExistenceFilterChange(o3, s4);
        }
    }
    return n;
}
function toMutation(e, t) {
    var n;
    if (t instanceof __PRIVATE_SetMutation) n = {
        update: __PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof __PRIVATE_DeleteMutation) n = {
        delete: __PRIVATE_toName(e, t.key)
    };
    else if (t instanceof __PRIVATE_PatchMutation) n = {
        update: __PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: __PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof __PRIVATE_VerifyMutation)) return fail();
        n = {
            verify: __PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map(function(e) {
        return function __PRIVATE_toFieldTransform(e, t) {
            var n = t.transform;
            if (n instanceof __PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof __PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof __PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof __PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.Pe
            };
            throw fail();
        }(0, e);
    })), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: __PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : fail();
    }(e, t.precondition)), n;
}
function __PRIVATE_fromMutation(e, t) {
    var n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? Precondition.updateTime(__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? Precondition.exists(e.exists) : Precondition.none();
    }(t.currentDocument) : Precondition.none(), r = t.updateTransforms ? t.updateTransforms.map(function(t) {
        return function __PRIVATE_fromFieldTransform(e, t) {
            var n = null;
            if ("setToServerValue" in t) __PRIVATE_hardAssert("REQUEST_TIME" === t.setToServerValue), n = new __PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                var _$e = t.appendMissingElements.values || [];
                n = new __PRIVATE_ArrayUnionTransformOperation(_$e);
            } else if ("removeAllFromArray" in t) {
                var _$e1 = t.removeAllFromArray.values || [];
                n = new __PRIVATE_ArrayRemoveTransformOperation(_$e1);
            } else "increment" in t ? n = new __PRIVATE_NumericIncrementTransformOperation(e, t.increment) : fail();
            var r = FieldPath$1.fromServerFormat(t.fieldPath);
            return new FieldTransform(r, n);
        }(e, t);
    }) : [];
    if (t.update) {
        t.update.name;
        var i = fromName(e, t.update.name), s = new ObjectValue({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            var _$e = function __PRIVATE_fromDocumentMask(e) {
                var _$t = e.fieldPaths || [];
                return new FieldMask(_$t.map(function(e) {
                    return FieldPath$1.fromServerFormat(e);
                }));
            }(t.updateMask);
            return new __PRIVATE_PatchMutation(i, s, _$e, n, r);
        }
        return new __PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        var r1 = fromName(e, t.delete);
        return new __PRIVATE_DeleteMutation(r1, n);
    }
    if (t.verify) {
        var r2 = fromName(e, t.verify);
        return new __PRIVATE_VerifyMutation(r2, n);
    }
    return fail();
}
function __PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? (__PRIVATE_hardAssert(void 0 !== t), e.map(function(e) {
        return function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            var n = e.updateTime ? __PRIVATE_fromVersion(e.updateTime) : __PRIVATE_fromVersion(t);
            return n.isEqual(SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = __PRIVATE_fromVersion(t)), new MutationResult(n, e.transformResults || []);
        }(e, t);
    })) : [];
}
function __PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            __PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function __PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    var n = {
        structuredQuery: {}
    }, r = t.path;
    var i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: !0
        }
    ]) : (i = r.popLast(), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]), n.parent = __PRIVATE_toQueryPath(e, i);
    var s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return __PRIVATE_toFilter(CompositeFilter.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    var o = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map(function(e) {
            return(// visible for testing
            function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    direction: __PRIVATE_toDirection(e.dir)
                };
            }(e));
        });
    }(t.orderBy);
    o && (n.structuredQuery.orderBy = o);
    var _ = __PRIVATE_toInt32Proto(e, t.limit);
    return null !== _ && (n.structuredQuery.limit = _), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        _t: n,
        parent: i
    };
}
function __PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    var _$__PRIVATE_toQueryTarget = __PRIVATE_toQueryTarget(e, t), i = _$__PRIVATE_toQueryTarget._t, s = _$__PRIVATE_toQueryTarget.parent, o = {}, _ = [];
    var a = 0;
    return n.forEach(function(e) {
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        var _$t = r ? e.alias : "aggregate_" + a++;
        o[_$t] = e.alias, "count" === e.aggregateType ? _.push({
            alias: _$t,
            count: {}
        }) : "avg" === e.aggregateType ? _.push({
            alias: _$t,
            avg: {
                field: __PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && _.push({
            alias: _$t,
            sum: {
                field: __PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    }), {
        request: {
            structuredAggregationQuery: {
                aggregations: _,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        ut: o,
        parent: s
    };
}
function __PRIVATE_convertQueryTargetToQuery(e) {
    var t = __PRIVATE_fromQueryPath(e.parent);
    var n = e.structuredQuery, r = n.from ? n.from.length : 0;
    var i = null;
    if (r > 0) {
        __PRIVATE_hardAssert(1 === r);
        var _$e = n.from[0];
        _$e.allDescendants ? i = _$e.collectionId : t = t.child(_$e.collectionId);
    }
    var s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        var t = __PRIVATE_fromFilter(e);
        if (t instanceof CompositeFilter && __PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    var o = [];
    n.orderBy && (o = function __PRIVATE_fromOrder(e) {
        return e.map(function(e) {
            return function __PRIVATE_fromPropertyOrder(e) {
                return new OrderBy(__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            }(e);
        });
    }(n.orderBy));
    var _ = null;
    n.limit && (_ = function __PRIVATE_fromInt32Proto(e) {
        var t;
        return t = "object" == typeof e ? e.value : e, __PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    var a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        var t = !!e.before, n = e.values || [];
        return new Bound(n, t);
    }(n.startAt));
    var u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        var t = !e.before, n = e.values || [];
        return new Bound(n, t);
    }(n.endAt)), __PRIVATE_newQuery(t, i, o, s, _, "F" /* LimitType.First */ , a, u);
}
function __PRIVATE_toListenRequestLabels(e, t) {
    var n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return fail();
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function __PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                var t = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return FieldFilter.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                var n = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return FieldFilter.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                var r = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return FieldFilter.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                var i = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return FieldFilter.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            default:
                return fail();
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return FieldFilter.create(__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                default:
                    return fail();
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return CompositeFilter.create(e.compositeFilter.filters.map(function(e) {
            return __PRIVATE_fromFilter(e);
        }), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return fail();
            }
        }(e.compositeFilter.op));
    }(e) : fail();
}
function __PRIVATE_toDirection(e) {
    return Ie[e];
}
function __PRIVATE_toOperatorName(e) {
    return Te[e];
}
function __PRIVATE_toCompositeOperatorName(e) {
    return Ee[e];
}
function __PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function __PRIVATE_fromFieldPathReference(e) {
    return FieldPath$1.fromServerFormat(e.fieldPath);
}
function __PRIVATE_toFilter(e) {
    return e instanceof FieldFilter ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if (__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if (__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if (__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if (__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: __PRIVATE_toFieldPathReference(e.field),
                op: __PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof CompositeFilter ? function __PRIVATE_toCompositeFilter(e) {
        var t = e.getFilters().map(function(e) {
            return __PRIVATE_toFilter(e);
        });
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: __PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : fail();
}
function __PRIVATE_toDocumentMask(e) {
    var t = [];
    return e.fields.forEach(function(e) {
        return t.push(e.canonicalString());
    }), {
        fieldPaths: t
    };
}
function __PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ var TargetData = /*#__PURE__*/ function() {
    "use strict";
    function TargetData(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r) {
        var /** The latest snapshot version seen for this target. */ i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : SnapshotVersion.min(), s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : SnapshotVersion.min(), o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : ByteString.EMPTY_BYTE_STRING, _ = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
        (0, $19mwo._)(this, TargetData);
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = o, this.expectedCount = _;
    }
    (0, $6rpfc._)(TargetData, [
        {
            /** Creates a new target data instance with an updated sequence number. */ key: "withSequenceNumber",
            value: function withSequenceNumber(e) {
                return new TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
            }
        },
        {
            /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ key: "withResumeToken",
            value: function withResumeToken(e, t) {
                return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
            }
        },
        {
            /**
     * Creates a new target data instance with an updated expected count.
     */ key: "withExpectedCount",
            value: function withExpectedCount(e) {
                return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
            }
        },
        {
            /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ key: "withLastLimboFreeSnapshotVersion",
            value: function withLastLimboFreeSnapshotVersion(e) {
                return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
            }
        }
    ]);
    return TargetData;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ var __PRIVATE_LocalSerializer = function __PRIVATE_LocalSerializer(e) {
    "use strict";
    (0, $19mwo._)(this, __PRIVATE_LocalSerializer);
    this.ct = e;
};
/** Decodes a remote document from storage locally to a Document. */ function __PRIVATE_fromDbRemoteDocument(e, t) {
    var n;
    if (t.document) n = __PRIVATE_fromDocument(e.ct, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        var _$e = DocumentKey.fromSegments(t.noDocument.path), r = __PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = MutableDocument.newNoDocument(_$e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return fail();
        {
            var _$e1 = DocumentKey.fromSegments(t.unknownDocument.path), r1 = __PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = MutableDocument.newUnknownDocument(_$e1, r1);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        var _$t = new Timestamp(e[0], e[1]);
        return SnapshotVersion.fromTimestamp(_$t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function __PRIVATE_toDbRemoteDocument(e, t) {
    var n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: __PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: __PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: toTimestamp(e, t.version.toTimestamp()),
            createTime: toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.ct, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: __PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return fail();
        r.unknownDocument = {
            path: n.path.toArray(),
            version: __PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function __PRIVATE_toDbTimestampKey(e) {
    var t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function __PRIVATE_toDbTimestamp(e) {
    var t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function __PRIVATE_fromDbTimestamp(e) {
    var t = new Timestamp(e.seconds, e.nanoseconds);
    return SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function __PRIVATE_fromDbMutationBatch(e, t) {
    var n = (t.baseMutations || []).map(function(t) {
        return __PRIVATE_fromMutation(e.ct, t);
    });
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(var e1 = 0; e1 < t.mutations.length - 1; ++e1){
        var n1 = t.mutations[e1];
        if (e1 + 1 < t.mutations.length && void 0 !== t.mutations[e1 + 1].transform) {
            var r = t.mutations[e1 + 1];
            n1.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e1 + 1, 1), ++e1;
        }
    }
    var r1 = t.mutations.map(function(t) {
        return __PRIVATE_fromMutation(e.ct, t);
    }), i = Timestamp.fromMillis(t.localWriteTimeMs);
    return new MutationBatch(t.batchId, i, n, r1);
}
/** Decodes a DbTarget into TargetData */ function __PRIVATE_fromDbTarget(e) {
    var t = __PRIVATE_fromDbTimestamp(e.readTime), n = void 0 !== e.lastLimboFreeSnapshotVersion ? __PRIVATE_fromDbTimestamp(e.lastLimboFreeSnapshotVersion) : SnapshotVersion.min();
    var r;
    return r = /**
 * A helper function for figuring out what kind of query has been stored.
 */ function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(e.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        return __PRIVATE_hardAssert(1 === e.documents.length), __PRIVATE_queryToTarget(__PRIVATE_newQueryForPath(__PRIVATE_fromQueryPath(e.documents[0])));
    }(e.query) : function __PRIVATE_fromQueryTarget(e) {
        return __PRIVATE_queryToTarget(__PRIVATE_convertQueryTargetToQuery(e));
    }(e.query), new TargetData(r, e.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.lastListenSequenceNumber, t, n, ByteString.fromBase64String(e.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function __PRIVATE_toDbTarget(e, t) {
    var n = __PRIVATE_toDbTimestamp(t.snapshotVersion), r = __PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    var i;
    i = __PRIVATE_targetIsDocumentTarget(t.target) ? __PRIVATE_toDocumentsTarget(e.ct, t.target) : __PRIVATE_toQueryTarget(e.ct, t.target)._t;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    var s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: __PRIVATE_canonifyTarget(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function __PRIVATE_fromBundledQuery(e) {
    var t = __PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? __PRIVATE_queryWithLimit(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function __PRIVATE_fromDbDocumentOverlay(e, t) {
    return new Overlay(t.largestBatchId, __PRIVATE_fromMutation(e.ct, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function __PRIVATE_toDbDocumentOverlayKey(e, t) {
    var n = t.path.lastSegment();
    return [
        e,
        __PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function __PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: __PRIVATE_toDbTimestamp(r.readTime),
        documentKey: __PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_IndexedDbBundleCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbBundleCache() {
        (0, $19mwo._)(this, __PRIVATE_IndexedDbBundleCache);
    }
    (0, $6rpfc._)(__PRIVATE_IndexedDbBundleCache, [
        {
            key: "getBundleMetadata",
            value: function getBundleMetadata(e, t) {
                return __PRIVATE_bundlesStore(e).get(t).next(function(e) {
                    if (e) return function __PRIVATE_fromDbBundle(e) {
                        return {
                            id: e.bundleId,
                            createTime: __PRIVATE_fromDbTimestamp(e.createTime),
                            version: e.version
                        };
                    }(e);
                });
            }
        },
        {
            key: "saveBundleMetadata",
            value: function saveBundleMetadata(e, t) {
                return __PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
                    return {
                        bundleId: e.id,
                        createTime: __PRIVATE_toDbTimestamp(__PRIVATE_fromVersion(e.createTime)),
                        version: e.version
                    };
                }(t));
            }
        },
        {
            key: "getNamedQuery",
            value: function getNamedQuery(e, t) {
                return __PRIVATE_namedQueriesStore(e).get(t).next(function(e) {
                    if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                        return {
                            name: e.name,
                            query: __PRIVATE_fromBundledQuery(e.bundledQuery),
                            readTime: __PRIVATE_fromDbTimestamp(e.readTime)
                        };
                    }(e);
                });
            }
        },
        {
            key: "saveNamedQuery",
            value: function saveNamedQuery(e, t) {
                return __PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
                    return {
                        name: e.name,
                        readTime: __PRIVATE_toDbTimestamp(__PRIVATE_fromVersion(e.readTime)),
                        bundledQuery: e.bundledQuery
                    };
                }(t));
            }
        }
    ]);
    return __PRIVATE_IndexedDbBundleCache;
}();
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function __PRIVATE_bundlesStore(e) {
    return __PRIVATE_getStore(e, "bundles");
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function __PRIVATE_namedQueriesStore(e) {
    return __PRIVATE_getStore(e, "namedQueries");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ var __PRIVATE_IndexedDbDocumentOverlayCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbDocumentOverlayCache(e, t) {
        (0, $19mwo._)(this, __PRIVATE_IndexedDbDocumentOverlayCache);
        this.serializer = e, this.userId = t;
    }
    (0, $6rpfc._)(__PRIVATE_IndexedDbDocumentOverlayCache, [
        {
            key: "getOverlay",
            value: function getOverlay(e, t) {
                var _this = this;
                return __PRIVATE_documentOverlayStore(e).get(__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next(function(e) {
                    return e ? __PRIVATE_fromDbDocumentOverlay(_this.serializer, e) : null;
                });
            }
        },
        {
            key: "getOverlays",
            value: function getOverlays(e, t) {
                var _this = this;
                var n = __PRIVATE_newOverlayMap();
                return PersistencePromise.forEach(t, function(t) {
                    return _this.getOverlay(e, t).next(function(e) {
                        null !== e && n.set(t, e);
                    });
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "saveOverlays",
            value: function saveOverlays(e, t, n) {
                var _this = this;
                var r = [];
                return n.forEach(function(n, i) {
                    var s = new Overlay(t, i);
                    r.push(_this.ht(e, s));
                }), PersistencePromise.waitFor(r);
            }
        },
        {
            key: "removeOverlaysForBatchId",
            value: function removeOverlaysForBatchId(e, t, n) {
                var _this = this;
                var r = new Set;
                // Get the set of unique collection paths.
                t.forEach(function(e) {
                    return r.add(__PRIVATE_encodeResourcePath(e.getCollectionPath()));
                });
                var i = [];
                return r.forEach(function(t) {
                    var r = IDBKeyRange.bound([
                        _this.userId,
                        t,
                        n
                    ], [
                        _this.userId,
                        t,
                        n + 1
                    ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
                    i.push(__PRIVATE_documentOverlayStore(e).j("collectionPathOverlayIndex", r));
                }), PersistencePromise.waitFor(i);
            }
        },
        {
            key: "getOverlaysForCollection",
            value: function getOverlaysForCollection(e, t, n) {
                var _this = this;
                var r = __PRIVATE_newOverlayMap(), i = __PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
                    this.userId,
                    i,
                    n
                ], [
                    this.userId,
                    i,
                    Number.POSITIVE_INFINITY
                ], /*lowerOpen=*/ !0);
                return __PRIVATE_documentOverlayStore(e).U("collectionPathOverlayIndex", s).next(function(e) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$t = _step.value;
                            var _$e = __PRIVATE_fromDbDocumentOverlay(_this.serializer, _$t);
                            r.set(_$e.getKey(), _$e);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return r;
                });
            }
        },
        {
            key: "getOverlaysForCollectionGroup",
            value: function getOverlaysForCollectionGroup(e, t, n, r) {
                var _this = this;
                var i = __PRIVATE_newOverlayMap();
                var s;
                // We want batch IDs larger than `sinceBatchId`, and so the lower bound
                // is not inclusive.
                var o = IDBKeyRange.bound([
                    this.userId,
                    t,
                    n
                ], [
                    this.userId,
                    t,
                    Number.POSITIVE_INFINITY
                ], /*lowerOpen=*/ !0);
                return __PRIVATE_documentOverlayStore(e).J({
                    index: "collectionGroupOverlayIndex",
                    range: o
                }, function(e, t, n) {
                    // We do not want to return partial batch overlays, even if the size
                    // of the result set exceeds the given `count` argument. Therefore, we
                    // continue to aggregate results even after the result size exceeds
                    // `count` if there are more overlays from the `currentBatchId`.
                    var o = __PRIVATE_fromDbDocumentOverlay(_this.serializer, t);
                    i.size() < r || o.largestBatchId === s ? (i.set(o.getKey(), o), s = o.largestBatchId) : n.done();
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "ht",
            value: function ht(e, t) {
                return __PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
                    var _$__PRIVATE_toDbDocumentOverlayKey = (0, $2MTYX._)(__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key), 3), r = _$__PRIVATE_toDbDocumentOverlayKey[0], i = _$__PRIVATE_toDbDocumentOverlayKey[1], s = _$__PRIVATE_toDbDocumentOverlayKey[2];
                    return {
                        userId: t,
                        collectionPath: i,
                        documentId: s,
                        collectionGroup: n.mutation.key.getCollectionGroup(),
                        largestBatchId: n.largestBatchId,
                        overlayMutation: toMutation(e.ct, n.mutation)
                    };
                }(this.serializer, this.userId, t));
            }
        }
    ], [
        {
            key: "lt",
            value: function lt(e, t) {
                var n = t.uid || "";
                return new __PRIVATE_IndexedDbDocumentOverlayCache(e, n);
            }
        }
    ]);
    return __PRIVATE_IndexedDbDocumentOverlayCache;
}();
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function __PRIVATE_documentOverlayStore(e) {
    return __PRIVATE_getStore(e, "documentOverlays");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ var __PRIVATE_FirestoreIndexValueWriter = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_FirestoreIndexValueWriter() {
        (0, $19mwo._)(this, __PRIVATE_FirestoreIndexValueWriter);
    }
    (0, $6rpfc._)(__PRIVATE_FirestoreIndexValueWriter, [
        {
            // The write methods below short-circuit writing terminators for values
            // containing a (terminating) truncated value.
            // As an example, consider the resulting encoding for:
            // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
            // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
            // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
            /** Writes an index value.  */ key: "Pt",
            value: function Pt(e, t) {
                this.It(e, t), // Write separator to split index values
                // (see go/firestore-storage-format#encodings).
                t.Tt();
            }
        },
        {
            key: "It",
            value: function It(e, t) {
                if ("nullValue" in e) this.Et(t, 5);
                else if ("booleanValue" in e) this.Et(t, 10), t.dt(e.booleanValue ? 1 : 0);
                else if ("integerValue" in e) this.Et(t, 15), t.dt(__PRIVATE_normalizeNumber(e.integerValue));
                else if ("doubleValue" in e) {
                    var n = __PRIVATE_normalizeNumber(e.doubleValue);
                    isNaN(n) ? this.Et(t, 13) : (this.Et(t, 15), __PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
                    t.dt(0) : t.dt(n));
                } else if ("timestampValue" in e) {
                    var n1 = e.timestampValue;
                    this.Et(t, 20), "string" == typeof n1 && (n1 = __PRIVATE_normalizeTimestamp(n1)), t.At("".concat(n1.seconds || "")), t.dt(n1.nanos || 0);
                } else if ("stringValue" in e) this.Rt(e.stringValue, t), this.Vt(t);
                else if ("bytesValue" in e) this.Et(t, 30), t.ft(__PRIVATE_normalizeByteString(e.bytesValue)), this.Vt(t);
                else if ("referenceValue" in e) this.gt(e.referenceValue, t);
                else if ("geoPointValue" in e) {
                    var n2 = e.geoPointValue;
                    this.Et(t, 45), t.dt(n2.latitude || 0), t.dt(n2.longitude || 0);
                } else "mapValue" in e ? __PRIVATE_isMaxValue(e) ? this.Et(t, Number.MAX_SAFE_INTEGER) : (this.yt(e.mapValue, t), this.Vt(t)) : "arrayValue" in e ? (this.wt(e.arrayValue, t), this.Vt(t)) : fail();
            }
        },
        {
            key: "Rt",
            value: function Rt(e, t) {
                this.Et(t, 25), this.St(e, t);
            }
        },
        {
            key: "St",
            value: function St(e, t) {
                t.At(e);
            }
        },
        {
            key: "yt",
            value: function yt(e, t) {
                var n = e.fields || {};
                this.Et(t, 55);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(n)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        this.Rt(_$e, t), this.It(n[_$e], t);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "wt",
            value: function wt(e, t) {
                var n = e.values || [];
                this.Et(t, 50);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        this.It(_$e, t);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "gt",
            value: function gt(e, t) {
                var _this = this;
                this.Et(t, 37);
                DocumentKey.fromName(e).path.forEach(function(e) {
                    _this.Et(t, 60), _this.St(e, t);
                });
            }
        },
        {
            key: "Et",
            value: function Et(e, t) {
                e.dt(t);
            }
        },
        {
            key: "Vt",
            value: function Vt(e) {
                // While the SDK does not implement truncation, the truncation marker is
                // used to terminate all variable length values (which are strings, bytes,
                // references, arrays and maps).
                e.dt(2);
            }
        }
    ]);
    return __PRIVATE_FirestoreIndexValueWriter;
}();
__PRIVATE_FirestoreIndexValueWriter.bt = new __PRIVATE_FirestoreIndexValueWriter;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function __PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    var t = 0;
    return e >> 4 == 0 && // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 == 0 && // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 == 0 && // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function __PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    var t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        var t = 0;
        for(var n = 0; n < 8; ++n){
            var r = __PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ var __PRIVATE_OrderedCodeWriter = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_OrderedCodeWriter() {
        (0, $19mwo._)(this, __PRIVATE_OrderedCodeWriter);
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    (0, $6rpfc._)(__PRIVATE_OrderedCodeWriter, [
        {
            key: "Dt",
            value: function Dt(e) {
                var t = e[Symbol.iterator]();
                var n = t.next();
                for(; !n.done;)this.Ct(n.value), n = t.next();
                this.vt();
            }
        },
        {
            key: "Ft",
            value: function Ft(e) {
                var t = e[Symbol.iterator]();
                var n = t.next();
                for(; !n.done;)this.Mt(n.value), n = t.next();
                this.xt();
            }
        },
        {
            /** Writes utf8 bytes into this byte sequence, ascending. */ key: "Ot",
            value: function Ot(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        var _$e = t.charCodeAt(0);
                        if (_$e < 128) this.Ct(_$e);
                        else if (_$e < 2048) this.Ct(960 | _$e >>> 6), this.Ct(128 | 63 & _$e);
                        else if (t < "\ud800" || "\udbff" < t) this.Ct(480 | _$e >>> 12), this.Ct(128 | 63 & _$e >>> 6), this.Ct(128 | 63 & _$e);
                        else {
                            var _$e1 = t.codePointAt(0);
                            this.Ct(240 | _$e1 >>> 18), this.Ct(128 | 63 & _$e1 >>> 12), this.Ct(128 | 63 & _$e1 >>> 6), this.Ct(128 | 63 & _$e1);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.vt();
            }
        },
        {
            /** Writes utf8 bytes into this byte sequence, descending */ key: "Nt",
            value: function Nt(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        var _$e = t.charCodeAt(0);
                        if (_$e < 128) this.Mt(_$e);
                        else if (_$e < 2048) this.Mt(960 | _$e >>> 6), this.Mt(128 | 63 & _$e);
                        else if (t < "\ud800" || "\udbff" < t) this.Mt(480 | _$e >>> 12), this.Mt(128 | 63 & _$e >>> 6), this.Mt(128 | 63 & _$e);
                        else {
                            var _$e1 = t.codePointAt(0);
                            this.Mt(240 | _$e1 >>> 18), this.Mt(128 | 63 & _$e1 >>> 12), this.Mt(128 | 63 & _$e1 >>> 6), this.Mt(128 | 63 & _$e1);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.xt();
            }
        },
        {
            key: "Lt",
            value: function Lt(e) {
                // Values are encoded with a single byte length prefix, followed by the
                // actual value in big-endian format with leading 0 bytes dropped.
                var t = this.Bt(e), n = __PRIVATE_unsignedNumLength(t);
                this.kt(1 + n), this.buffer[this.position++] = 255 & n;
                // Write the length
                for(var _$e = t.length - n; _$e < t.length; ++_$e)this.buffer[this.position++] = 255 & t[_$e];
            }
        },
        {
            key: "qt",
            value: function qt(e) {
                // Values are encoded with a single byte length prefix, followed by the
                // inverted value in big-endian format with leading 0 bytes dropped.
                var t = this.Bt(e), n = __PRIVATE_unsignedNumLength(t);
                this.kt(1 + n), this.buffer[this.position++] = ~(255 & n);
                // Write the length
                for(var _$e = t.length - n; _$e < t.length; ++_$e)this.buffer[this.position++] = ~(255 & t[_$e]);
            }
        },
        {
            /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ key: "Qt",
            value: function Qt() {
                this.Kt(255), this.Kt(255);
            }
        },
        {
            /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ key: "$t",
            value: function $t() {
                this.Ut(255), this.Ut(255);
            }
        },
        {
            /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ key: "reset",
            value: function reset() {
                this.position = 0;
            }
        },
        {
            key: "seed",
            value: function seed(e) {
                this.kt(e.length), this.buffer.set(e, this.position), this.position += e.length;
            }
        },
        {
            /** Makes a copy of the encoded bytes in this buffer.  */ key: "Wt",
            value: function Wt() {
                return this.buffer.slice(0, this.position);
            }
        },
        {
            /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ key: "Bt",
            value: function Bt(e) {
                var t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
                    var t = new DataView(new ArrayBuffer(8));
                    return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
                }(e), n = 0 != (128 & t[0]);
                // Check if the first bit is set. We use a bit mask since value[0] is
                // encoded as a number from 0 to 255.
                // Revert the two complement to get natural ordering
                t[0] ^= n ? 255 : 128;
                for(var _$e = 1; _$e < t.length; ++_$e)t[_$e] ^= n ? 255 : 0;
                return t;
            }
        },
        {
            /** Writes a single byte ascending to the buffer. */ key: "Ct",
            value: function Ct(e) {
                var t = 255 & e;
                0 === t ? (this.Kt(0), this.Kt(255)) : 255 === t ? (this.Kt(255), this.Kt(0)) : this.Kt(t);
            }
        },
        {
            /** Writes a single byte descending to the buffer.  */ key: "Mt",
            value: function Mt(e) {
                var t = 255 & e;
                0 === t ? (this.Ut(0), this.Ut(255)) : 255 === t ? (this.Ut(255), this.Ut(0)) : this.Ut(e);
            }
        },
        {
            key: "vt",
            value: function vt() {
                this.Kt(0), this.Kt(1);
            }
        },
        {
            key: "xt",
            value: function xt() {
                this.Ut(0), this.Ut(1);
            }
        },
        {
            key: "Kt",
            value: function Kt(e) {
                this.kt(1), this.buffer[this.position++] = e;
            }
        },
        {
            key: "Ut",
            value: function Ut(e) {
                this.kt(1), this.buffer[this.position++] = ~e;
            }
        },
        {
            key: "kt",
            value: function kt(e) {
                var t = e + this.position;
                if (t <= this.buffer.length) return;
                // Try doubling.
                var n = 2 * this.buffer.length;
                // Still not big enough? Just allocate the right size.
                n < t && (n = t);
                // Create the new buffer.
                var r = new Uint8Array(n);
                r.set(this.buffer), this.buffer = r;
            }
        }
    ]);
    return __PRIVATE_OrderedCodeWriter;
}();
var __PRIVATE_AscendingIndexByteEncoder = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_AscendingIndexByteEncoder(e) {
        (0, $19mwo._)(this, __PRIVATE_AscendingIndexByteEncoder);
        this.Gt = e;
    }
    (0, $6rpfc._)(__PRIVATE_AscendingIndexByteEncoder, [
        {
            key: "ft",
            value: function ft(e) {
                this.Gt.Dt(e);
            }
        },
        {
            key: "At",
            value: function At(e) {
                this.Gt.Ot(e);
            }
        },
        {
            key: "dt",
            value: function dt(e) {
                this.Gt.Lt(e);
            }
        },
        {
            key: "Tt",
            value: function Tt() {
                this.Gt.Qt();
            }
        }
    ]);
    return __PRIVATE_AscendingIndexByteEncoder;
}();
var __PRIVATE_DescendingIndexByteEncoder = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_DescendingIndexByteEncoder(e) {
        (0, $19mwo._)(this, __PRIVATE_DescendingIndexByteEncoder);
        this.Gt = e;
    }
    (0, $6rpfc._)(__PRIVATE_DescendingIndexByteEncoder, [
        {
            key: "ft",
            value: function ft(e) {
                this.Gt.Ft(e);
            }
        },
        {
            key: "At",
            value: function At(e) {
                this.Gt.Nt(e);
            }
        },
        {
            key: "dt",
            value: function dt(e) {
                this.Gt.qt(e);
            }
        },
        {
            key: "Tt",
            value: function Tt() {
                this.Gt.$t();
            }
        }
    ]);
    return __PRIVATE_DescendingIndexByteEncoder;
}();
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ var __PRIVATE_IndexByteEncoder = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexByteEncoder() {
        (0, $19mwo._)(this, __PRIVATE_IndexByteEncoder);
        this.Gt = new __PRIVATE_OrderedCodeWriter, this.zt = new __PRIVATE_AscendingIndexByteEncoder(this.Gt), this.jt = new __PRIVATE_DescendingIndexByteEncoder(this.Gt);
    }
    (0, $6rpfc._)(__PRIVATE_IndexByteEncoder, [
        {
            key: "seed",
            value: function seed(e) {
                this.Gt.seed(e);
            }
        },
        {
            key: "Ht",
            value: function Ht(e) {
                return 0 /* IndexKind.ASCENDING */  === e ? this.zt : this.jt;
            }
        },
        {
            key: "Wt",
            value: function Wt() {
                return this.Gt.Wt();
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.Gt.reset();
            }
        }
    ]);
    return __PRIVATE_IndexByteEncoder;
}();
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ var __PRIVATE_IndexEntry = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexEntry(e, t, n, r) {
        (0, $19mwo._)(this, __PRIVATE_IndexEntry);
        this.indexId = e, this.documentKey = t, this.arrayValue = n, this.directionalValue = r;
    }
    (0, $6rpfc._)(__PRIVATE_IndexEntry, [
        {
            /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ key: "Jt",
            value: function Jt() {
                var e = this.directionalValue.length, t = 0 === e || 255 === this.directionalValue[e - 1] ? e + 1 : e, n = new Uint8Array(t);
                return n.set(this.directionalValue, 0), t !== e ? n.set([
                    0
                ], this.directionalValue.length) : ++n[n.length - 1], new __PRIVATE_IndexEntry(this.indexId, this.documentKey, this.arrayValue, n);
            }
        }
    ]);
    return __PRIVATE_IndexEntry;
}();
function __PRIVATE_indexEntryComparator(e, t) {
    var n = e.indexId - t.indexId;
    return 0 !== n ? n : (n = __PRIVATE_compareByteArrays(e.arrayValue, t.arrayValue), 0 !== n ? n : (n = __PRIVATE_compareByteArrays(e.directionalValue, t.directionalValue), 0 !== n ? n : DocumentKey.comparator(e.documentKey, t.documentKey)));
}
function __PRIVATE_compareByteArrays(e, t) {
    for(var n = 0; n < e.length && n < t.length; ++n){
        var r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light query planner for Firestore.
 *
 * This class matches a `FieldIndex` against a Firestore Query `Target`. It
 * determines whether a given index can be used to serve the specified target.
 *
 * The following table showcases some possible index configurations:
 *
 * Query                                               | Index
 * -----------------------------------------------------------------------------
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC, b DESC
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC
 * where('a', '==', 'a').where('b', '==', 'b')         | b DESC
 * where('a', '>=', 'a').orderBy('a')                  | a ASC
 * where('a', '>=', 'a').orderBy('a', 'desc')          | a DESC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC, b ASC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS, b ASCENDING
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS
 */ var __PRIVATE_TargetIndexMatcher = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TargetIndexMatcher(e) {
        (0, $19mwo._)(this, __PRIVATE_TargetIndexMatcher);
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.Yt = new SortedSet(function(e, t) {
            return FieldPath$1.comparator(e.field, t.field);
        }), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.Zt = e.orderBy, this.Xt = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = e.filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var t = _step.value;
                var _$e = t;
                _$e.isInequality() ? this.Yt = this.Yt.add(_$e) : this.Xt.push(_$e);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    (0, $6rpfc._)(__PRIVATE_TargetIndexMatcher, [
        {
            key: "en",
            get: function get() {
                return this.Yt.size > 1;
            }
        },
        {
            /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ key: "tn",
            value: function tn(e) {
                if (__PRIVATE_hardAssert(e.collectionGroup === this.collectionId), this.en) // Only single inequality is supported for now.
                // TODO(Add support for multiple inequality query): b/298441043
                return !1;
                // If there is an array element, find a matching filter.
                var t = __PRIVATE_fieldIndexGetArraySegment(e);
                if (void 0 !== t && !this.nn(t)) return !1;
                var n = __PRIVATE_fieldIndexGetDirectionalSegments(e);
                var r = new Set, i = 0, s = 0;
                // Process all equalities first. Equalities can appear out of order.
                for(; i < n.length && this.nn(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
                // If we already have processed all segments, all segments are used to serve
                // the equality filters and we do not need to map any segments to the
                // target's inequality and orderBy clauses.
                if (i === n.length) return !0;
                if (this.Yt.size > 0) {
                    // Only a single inequality is currently supported. Get the only entry in the set.
                    var _$e = this.Yt.getIterator().getNext();
                    // If there is an inequality filter and the field was not in one of the
                    // equality filters above, the next segment must match both the filter
                    // and the first orderBy clause.
                    if (!r.has(_$e.field.canonicalString())) {
                        var t1 = n[i];
                        if (!this.rn(_$e, t1) || !this.sn(this.Zt[s++], t1)) return !1;
                    }
                    ++i;
                }
                // All remaining segments need to represent the prefix of the target's
                // orderBy.
                for(; i < n.length; ++i){
                    var _$e1 = n[i];
                    if (s >= this.Zt.length || !this.sn(this.Zt[s++], _$e1)) return !1;
                }
                return !0;
            }
        },
        {
            /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */ key: "on",
            value: function on() {
                if (this.en) return null;
                // We want to make sure only one segment created for one field. For example,
                // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
                // once.
                var e = new SortedSet(FieldPath$1.comparator);
                var t = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.Xt[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var n = _step.value;
                        if (n.field.isKeyField()) continue;
                        if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new IndexSegment(n.field, 2 /* IndexKind.CONTAINS */ ));
                        else {
                            if (e.has(n.field)) continue;
                            e = e.add(n.field), t.push(new IndexSegment(n.field, 0 /* IndexKind.ASCENDING */ ));
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // Note: We do not explicitly check `this.inequalityFilter` but rather rely
                    // on the target defining an appropriate "order by" to ensure that the
                    // required index segment is added. The query engine would reject a query
                    // with an inequality filter that lacks the required order-by clause.
                    for(var _iterator1 = this.Zt[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var n1 = _step1.value;
                        // Stop adding more segments if we see a order-by on key. Typically this
                        // is the default implicit order-by which is covered in the index_entry
                        // table as a separate column. If it is not the default order-by, the
                        // generated index will be missing some segments optimized for order-bys,
                        // which is probably fine.
                        n1.field.isKeyField() || e.has(n1.field) || (e = e.add(n1.field), t.push(new IndexSegment(n1.field, "asc" /* Direction.ASCENDING */  === n1.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return new FieldIndex(FieldIndex.UNKNOWN_ID, this.collectionId, t, IndexState.empty());
            }
        },
        {
            key: "nn",
            value: function nn(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.Xt[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        if (this.rn(t, e)) return !0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return !1;
            }
        },
        {
            key: "rn",
            value: function rn(e, t) {
                if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
                var n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
                return 2 /* IndexKind.CONTAINS */  === t.kind === n;
            }
        },
        {
            key: "sn",
            value: function sn(e, t) {
                return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
            }
        }
    ]);
    return __PRIVATE_TargetIndexMatcher;
}();
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function __PRIVATE_computeInExpansion(e) {
    var t, n;
    if (__PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter), e instanceof FieldFilter) {
        if (e instanceof __PRIVATE_InFilter) {
            var r = (null === (n = null === (t = e.value.arrayValue) || void 0 === t ? void 0 : t.values) || void 0 === n ? void 0 : n.map(function(t) {
                return FieldFilter.create(e.field, "==" /* Operator.EQUAL */ , t);
            })) || [];
            return CompositeFilter.create(r, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    var r1 = e.filters.map(function(e) {
        return __PRIVATE_computeInExpansion(e);
    });
    return CompositeFilter.create(r1, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter the composite filter to calculate DNF transform for.
 * @return the terms in the DNF transform.
 */ function __PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    var t = __PRIVATE_computeDistributedNormalForm(__PRIVATE_computeInExpansion(e));
    return __PRIVATE_hardAssert(__PRIVATE_isDisjunctiveNormalForm(t)), __PRIVATE_isSingleFieldFilter(t) || __PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function __PRIVATE_isSingleFieldFilter(e) {
    return e instanceof FieldFilter;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function __PRIVATE_isFlatConjunction(e) {
    return e instanceof CompositeFilter && __PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function __PRIVATE_isDisjunctiveNormalForm(e) {
    return __PRIVATE_isSingleFieldFilter(e) || __PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof CompositeFilter && __PRIVATE_compositeFilterIsDisjunction(e)) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e.getFilters()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var t = _step.value;
                    if (!__PRIVATE_isSingleFieldFilter(t) && !__PRIVATE_isFlatConjunction(t)) return !1;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return !0;
        }
        return !1;
    }(e);
}
function __PRIVATE_computeDistributedNormalForm(e) {
    if (__PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter), e instanceof FieldFilter) return e;
    if (1 === e.filters.length) return __PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    var t = e.filters.map(function(e) {
        return __PRIVATE_computeDistributedNormalForm(e);
    });
    var n = CompositeFilter.create(t, e.op);
    return n = __PRIVATE_applyAssociation(n), __PRIVATE_isDisjunctiveNormalForm(n) ? n : (__PRIVATE_hardAssert(n instanceof CompositeFilter), __PRIVATE_hardAssert(__PRIVATE_compositeFilterIsConjunction(n)), __PRIVATE_hardAssert(n.filters.length > 1), n.filters.reduce(function(e, t) {
        return __PRIVATE_applyDistribution(e, t);
    }));
}
function __PRIVATE_applyDistribution(e, t) {
    var n;
    return __PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter), __PRIVATE_hardAssert(t instanceof FieldFilter || t instanceof CompositeFilter), // FieldFilter FieldFilter
    n = e instanceof FieldFilter ? t instanceof FieldFilter ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return CompositeFilter.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : __PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof FieldFilter ? __PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if (__PRIVATE_hardAssert(e.filters.length > 0 && t.filters.length > 0), __PRIVATE_compositeFilterIsConjunction(e) && __PRIVATE_compositeFilterIsConjunction(t)) return __PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        var n = __PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = __PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map(function(e) {
            return __PRIVATE_applyDistribution(e, r);
        });
        return CompositeFilter.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), __PRIVATE_applyAssociation(n);
}
function __PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if (__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return __PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        var n = t.filters.map(function(t) {
            return __PRIVATE_applyDistribution(e, t);
        });
        return CompositeFilter.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function __PRIVATE_applyAssociation(e) {
    if (__PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter), e instanceof FieldFilter) return e;
    var t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return __PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if (__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    var n = t.map(function(e) {
        return __PRIVATE_applyAssociation(e);
    }), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach(function(t) {
        var // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        _r;
        t instanceof FieldFilter ? r.push(t) : t instanceof CompositeFilter && (t.op === e.op ? (_r = r).push.apply(_r, (0, $3jzhD._)(t.filters)) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : CompositeFilter.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ var __PRIVATE_MemoryIndexManager = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryIndexManager() {
        (0, $19mwo._)(this, __PRIVATE_MemoryIndexManager);
        this._n = new __PRIVATE_MemoryCollectionParentIndex;
    }
    (0, $6rpfc._)(__PRIVATE_MemoryIndexManager, [
        {
            key: "addToCollectionParentIndex",
            value: function addToCollectionParentIndex(e, t) {
                return this._n.add(t), PersistencePromise.resolve();
            }
        },
        {
            key: "getCollectionParents",
            value: function getCollectionParents(e, t) {
                return PersistencePromise.resolve(this._n.getEntries(t));
            }
        },
        {
            key: "addFieldIndex",
            value: function addFieldIndex(e, t) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve();
            }
        },
        {
            key: "deleteFieldIndex",
            value: function deleteFieldIndex(e, t) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve();
            }
        },
        {
            key: "deleteAllFieldIndexes",
            value: function deleteAllFieldIndexes(e) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve();
            }
        },
        {
            key: "createTargetIndexes",
            value: function createTargetIndexes(e, t) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve();
            }
        },
        {
            key: "getDocumentsMatchingTarget",
            value: function getDocumentsMatchingTarget(e, t) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve(null);
            }
        },
        {
            key: "getIndexType",
            value: function getIndexType(e, t) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve(0 /* IndexType.NONE */ );
            }
        },
        {
            key: "getFieldIndexes",
            value: function getFieldIndexes(e, t) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve([]);
            }
        },
        {
            key: "getNextCollectionGroupToUpdate",
            value: function getNextCollectionGroupToUpdate(e) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve(null);
            }
        },
        {
            key: "getMinOffset",
            value: function getMinOffset(e, t) {
                return PersistencePromise.resolve(IndexOffset.min());
            }
        },
        {
            key: "getMinOffsetFromCollectionGroup",
            value: function getMinOffsetFromCollectionGroup(e, t) {
                return PersistencePromise.resolve(IndexOffset.min());
            }
        },
        {
            key: "updateCollectionGroup",
            value: function updateCollectionGroup(e, t, n) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve();
            }
        },
        {
            key: "updateIndexEntries",
            value: function updateIndexEntries(e, t) {
                // Field indices are not supported with memory persistence.
                return PersistencePromise.resolve();
            }
        }
    ]);
    return __PRIVATE_MemoryIndexManager;
}();
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ var __PRIVATE_MemoryCollectionParentIndex = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryCollectionParentIndex() {
        (0, $19mwo._)(this, __PRIVATE_MemoryCollectionParentIndex);
        this.index = {};
    }
    (0, $6rpfc._)(__PRIVATE_MemoryCollectionParentIndex, [
        {
            // Returns false if the entry already existed.
            key: "add",
            value: function add(e) {
                var t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new SortedSet(ResourcePath.comparator), i = !r.has(n);
                return this.index[t] = r.add(n), i;
            }
        },
        {
            key: "has",
            value: function has(e) {
                var t = e.lastSegment(), n = e.popLast(), r = this.index[t];
                return r && r.has(n);
            }
        },
        {
            key: "getEntries",
            value: function getEntries(e) {
                return (this.index[e] || new SortedSet(ResourcePath.comparator)).toArray();
            }
        }
    ]);
    return __PRIVATE_MemoryCollectionParentIndex;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var de = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ var __PRIVATE_IndexedDbIndexManager = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbIndexManager(e, t) {
        (0, $19mwo._)(this, __PRIVATE_IndexedDbIndexManager);
        this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.an = new __PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.un = new ObjectMap(function(e) {
            return __PRIVATE_canonifyTarget(e);
        }, function(e, t) {
            return __PRIVATE_targetEquals(e, t);
        }), this.uid = e.uid || "";
    }
    (0, $6rpfc._)(__PRIVATE_IndexedDbIndexManager, [
        {
            /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ key: "addToCollectionParentIndex",
            value: function addToCollectionParentIndex(e, t) {
                var _this = this;
                if (!this.an.has(t)) {
                    var n = t.lastSegment(), r = t.popLast();
                    e.addOnCommittedListener(function() {
                        // Add the collection to the in memory cache only if the transaction was
                        // successfully committed.
                        _this.an.add(t);
                    });
                    var i = {
                        collectionId: n,
                        parent: __PRIVATE_encodeResourcePath(r)
                    };
                    return __PRIVATE_collectionParentsStore(e).put(i);
                }
                return PersistencePromise.resolve();
            }
        },
        {
            key: "getCollectionParents",
            value: function getCollectionParents(e, t) {
                var n = [], r = IDBKeyRange.bound([
                    t,
                    ""
                ], [
                    __PRIVATE_immediateSuccessor(t),
                    ""
                ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
                return __PRIVATE_collectionParentsStore(e).U(r).next(function(e) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var r = _step.value;
                            // This collectionId guard shouldn't be necessary (and isn't as long
                            // as we're running in a real browser), but there's a bug in
                            // indexeddbshim that breaks our range in our tests running in node:
                            // https://github.com/axemclion/IndexedDBShim/issues/334
                            if (r.collectionId !== t) break;
                            n.push(__PRIVATE_decodeResourcePath(r.parent));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return n;
                });
            }
        },
        {
            key: "addFieldIndex",
            value: function addFieldIndex(e, t) {
                var _this = this;
                // TODO(indexing): Verify that the auto-incrementing index ID works in
                // Safari & Firefox.
                var n = __PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
                    return {
                        indexId: e.indexId,
                        collectionGroup: e.collectionGroup,
                        fields: e.fields.map(function(e) {
                            return [
                                e.fieldPath.canonicalString(),
                                e.kind
                            ];
                        })
                    };
                }(t);
                delete r.indexId;
                // `indexId` is auto-populated by IndexedDb
                var i = n.add(r);
                if (t.indexState) {
                    var n1 = __PRIVATE_indexStateStore(e);
                    return i.next(function(e) {
                        n1.put(__PRIVATE_toDbIndexState(e, _this.uid, t.indexState.sequenceNumber, t.indexState.offset));
                    });
                }
                return i.next();
            }
        },
        {
            key: "deleteFieldIndex",
            value: function deleteFieldIndex(e, t) {
                var n = __PRIVATE_indexConfigurationStore(e), r = __PRIVATE_indexStateStore(e), i = __PRIVATE_indexEntriesStore(e);
                return n.delete(t.indexId).next(function() {
                    return r.delete(IDBKeyRange.bound([
                        t.indexId
                    ], [
                        t.indexId + 1
                    ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0));
                }).next(function() {
                    return i.delete(IDBKeyRange.bound([
                        t.indexId
                    ], [
                        t.indexId + 1
                    ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0));
                });
            }
        },
        {
            key: "deleteAllFieldIndexes",
            value: function deleteAllFieldIndexes(e) {
                var t = __PRIVATE_indexConfigurationStore(e), n = __PRIVATE_indexEntriesStore(e), r = __PRIVATE_indexStateStore(e);
                return t.j().next(function() {
                    return n.j();
                }).next(function() {
                    return r.j();
                });
            }
        },
        {
            key: "createTargetIndexes",
            value: function createTargetIndexes(e, t) {
                var _this = this;
                return PersistencePromise.forEach(this.cn(t), function(t) {
                    return _this.getIndexType(e, t).next(function(n) {
                        if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                            var _$n = new __PRIVATE_TargetIndexMatcher(t).on();
                            if (null != _$n) return _this.addFieldIndex(e, _$n);
                        }
                    });
                });
            }
        },
        {
            key: "getDocumentsMatchingTarget",
            value: function getDocumentsMatchingTarget(e, t) {
                var _this = this;
                var n = __PRIVATE_indexEntriesStore(e);
                var r = !0;
                var i = new Map;
                return PersistencePromise.forEach(this.cn(t), function(t) {
                    return _this.ln(e, t).next(function(e) {
                        r && (r = !!e), i.set(t, e);
                    });
                }).next(function() {
                    if (r) {
                        var _$e = __PRIVATE_documentKeySet();
                        var r1 = [];
                        return PersistencePromise.forEach(i, function(i, s) {
                            __PRIVATE_logDebug("IndexedDbIndexManager", "Using index ".concat(function __PRIVATE_fieldIndexToString(e) {
                                return "id=".concat(e.indexId, "|cg=").concat(e.collectionGroup, "|f=").concat(e.fields.map(function(e) {
                                    return "".concat(e.fieldPath, ":").concat(e.kind);
                                }).join(","));
                            }(i), " to execute ").concat(__PRIVATE_canonifyTarget(t)));
                            var o = function __PRIVATE_targetGetArrayValues(e, t) {
                                var n = __PRIVATE_fieldIndexGetArraySegment(t);
                                if (void 0 === n) return null;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = __PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$t = _step.value;
                                        switch(_$t.op){
                                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                                return _$t.value.arrayValue.values || [];
                                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                                return [
                                                    _$t.value
                                                ];
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return null;
                            }(s, i), _ = function __PRIVATE_targetGetNotInValues(e, t) {
                                var n = new Map;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator = __PRIVATE_fieldIndexGetDirectionalSegments(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                        var r = _step.value;
                                        try {
                                            for(var _iterator1 = __PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                                var _$t = _step1.value;
                                                switch(_$t.op){
                                                    case "==" /* Operator.EQUAL */ :
                                                    case "in" /* Operator.IN */ :
                                                        // Encode equality prefix, which is encoded in the index value before
                                                        // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                                        // `value != 'ab'`).
                                                        n.set(r.fieldPath.canonicalString(), _$t.value);
                                                        break;
                                                    case "not-in" /* Operator.NOT_IN */ :
                                                    case "!=" /* Operator.NOT_EQUAL */ :
                                                        // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                                        // segments and hence we can return early here.
                                                        return n.set(r.fieldPath.canonicalString(), _$t.value), Array.from(n.values());
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                return null;
                            }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                                var n = [];
                                var r = !0;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    // For each segment, retrieve a lower bound if there is a suitable filter or
                                    // startAt.
                                    for(var _iterator = __PRIVATE_fieldIndexGetDirectionalSegments(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$i = _step.value;
                                        var _$t = 0 /* IndexKind.ASCENDING */  === _$i.kind ? __PRIVATE_targetGetAscendingBound(e, _$i.fieldPath, e.startAt) : __PRIVATE_targetGetDescendingBound(e, _$i.fieldPath, e.startAt);
                                        n.push(_$t.value), r && (r = _$t.inclusive);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return new Bound(n, r);
                            }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                                var n = [];
                                var r = !0;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    // For each segment, retrieve an upper bound if there is a suitable filter or
                                    // endAt.
                                    for(var _iterator = __PRIVATE_fieldIndexGetDirectionalSegments(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$i = _step.value;
                                        var _$t = 0 /* IndexKind.ASCENDING */  === _$i.kind ? __PRIVATE_targetGetDescendingBound(e, _$i.fieldPath, e.endAt) : __PRIVATE_targetGetAscendingBound(e, _$i.fieldPath, e.endAt);
                                        n.push(_$t.value), r && (r = _$t.inclusive);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return new Bound(n, r);
                            }(s, i), c = _this.hn(i, s, a), l = _this.hn(i, s, u), h = _this.Pn(i, s, _), P = _this.In(i.indexId, o, c, a.inclusive, l, u.inclusive, h);
                            return PersistencePromise.forEach(P, function(i) {
                                return n.G(i, t.limit).next(function(t) {
                                    t.forEach(function(t) {
                                        var n = DocumentKey.fromSegments(t.documentKey);
                                        _$e.has(n) || (_$e = _$e.add(n), r1.push(n));
                                    });
                                });
                            });
                        }).next(function() {
                            return r1;
                        });
                    }
                    return PersistencePromise.resolve(null);
                });
            }
        },
        {
            key: "cn",
            value: function cn(e) {
                var t = this.un.get(e);
                if (t) return t;
                if (0 === e.filters.length) t = [
                    e
                ];
                else t = __PRIVATE_getDnfTerms(CompositeFilter.create(e.filters, "and" /* CompositeOperator.AND */ )).map(function(t) {
                    return __PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt);
                });
                return this.un.set(e, t), t;
            }
        },
        {
            /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ key: "In",
            value: function In(e, t, n, r, i, s, o) {
                var _this = this, _loop = function(c) {
                    var _u;
                    var _ = t ? _this.Tn(t[c / a]) : de, l = _this.En(e, _, n[c % a], r), h = _this.dn(e, _, i[c % a], s), P = o.map(function(t) {
                        return _this1.En(e, _, t, /* inclusive= */ !0);
                    });
                    (_u = u).push.apply(_u, (0, $3jzhD._)(_this.createRange(l, h, P)));
                };
                var _this1 = this;
                // The number of total index scans we union together. This is similar to a
                // distributed normal form, but adapted for array values. We create a single
                // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
                // combined with the values from the query bounds.
                var _ = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = _ / (null != t ? t.length : 1), u = [];
                for(var c = 0; c < _; ++c)_loop(c);
                return u;
            }
        },
        {
            /** Generates the lower bound for `arrayValue` and `directionalValue`. */ key: "En",
            value: function En(e, t, n, r) {
                var i = new __PRIVATE_IndexEntry(e, DocumentKey.empty(), t, n);
                return r ? i : i.Jt();
            }
        },
        {
            /** Generates the upper bound for `arrayValue` and `directionalValue`. */ key: "dn",
            value: function dn(e, t, n, r) {
                var i = new __PRIVATE_IndexEntry(e, DocumentKey.empty(), t, n);
                return r ? i.Jt() : i;
            }
        },
        {
            key: "ln",
            value: function ln(e, t) {
                var n = new __PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
                return this.getFieldIndexes(e, r).next(function(e) {
                    // Return the index with the most number of segments.
                    var _$t = null;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var r = _step.value;
                            n.tn(r) && (!_$t || r.fields.length > _$t.fields.length) && (_$t = r);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return _$t;
                });
            }
        },
        {
            key: "getIndexType",
            value: function getIndexType(e, t) {
                var _this = this;
                var n = 2 /* IndexType.FULL */ ;
                var r = this.cn(t);
                return PersistencePromise.forEach(r, function(t) {
                    return _this.ln(e, t).next(function(e) {
                        e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                            var _$t = new SortedSet(FieldPath$1.comparator), n = !1;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator = e.filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                    var r = _step.value;
                                    try {
                                        for(var _iterator1 = r.getFlattenedFilters()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                            var _$e = _step1.value;
                                            // __name__ is not an explicit segment of any index, so we don't need to
                                            // count it.
                                            _$e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                                            // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                                            // though these are on the same field, they should be counted as two
                                            // separate segments in an index.
                                            ("array-contains" /* Operator.ARRAY_CONTAINS */  === _$e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === _$e.op ? n = !0 : _$t = _$t.add(_$e.field));
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(var _iterator2 = e.orderBy[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var n1 = _step2.value;
                                    // __name__ is not an explicit segment of any index, so we don't need to
                                    // count it.
                                    n1.field.isKeyField() || (_$t = _$t.add(n1.field));
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                            return _$t.size + (n ? 1 : 0);
                        }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
                    });
                }).next(function() {
                    return(// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
                    // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
                    // and apply the limit in memory as a post-processing step.
                    function __PRIVATE_targetHasLimit(e) {
                        return null !== e.limit;
                    }(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
                });
            }
        },
        {
            /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ key: "An",
            value: function An(e, t) {
                var n = new __PRIVATE_IndexByteEncoder;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = __PRIVATE_fieldIndexGetDirectionalSegments(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var r = _step.value;
                        var _$e = t.data.field(r.fieldPath);
                        if (null == _$e) return null;
                        var i = n.Ht(r.kind);
                        __PRIVATE_FirestoreIndexValueWriter.bt.Pt(_$e, i);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return n.Wt();
            }
        },
        {
            /** Encodes a single value to the ascending index format. */ key: "Tn",
            value: function Tn(e) {
                var t = new __PRIVATE_IndexByteEncoder;
                return __PRIVATE_FirestoreIndexValueWriter.bt.Pt(e, t.Ht(0 /* IndexKind.ASCENDING */ )), t.Wt();
            }
        },
        {
            /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ key: "Rn",
            value: function Rn(e, t) {
                var n = new __PRIVATE_IndexByteEncoder;
                return __PRIVATE_FirestoreIndexValueWriter.bt.Pt(__PRIVATE_refValue(this.databaseId, t), n.Ht(function __PRIVATE_fieldIndexGetKeyOrder(e) {
                    var _$t = __PRIVATE_fieldIndexGetDirectionalSegments(e);
                    return 0 === _$t.length ? 0 /* IndexKind.ASCENDING */  : _$t[_$t.length - 1].kind;
                }(e))), n.Wt();
            }
        },
        {
            /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ key: "Pn",
            value: function Pn(e, t, n) {
                if (null === n) return [];
                var r = [];
                r.push(new __PRIVATE_IndexByteEncoder);
                var i = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = __PRIVATE_fieldIndexGetDirectionalSegments(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var s = _step.value;
                        var _$e = n[i++];
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = r[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$n = _step1.value;
                                if (this.Vn(t, s.fieldPath) && isArray(_$e)) r = this.mn(r, s, _$e);
                                else {
                                    var _$t = _$n.Ht(s.kind);
                                    __PRIVATE_FirestoreIndexValueWriter.bt.Pt(_$e, _$t);
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this.fn(r);
            }
        },
        {
            /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ key: "hn",
            value: function hn(e, t, n) {
                return this.Pn(e, t, n.position);
            }
        },
        {
            /** Returns the byte representation for the provided encoders. */ key: "fn",
            value: function fn(e) {
                var t = [];
                for(var n = 0; n < e.length; ++n)t[n] = e[n].Wt();
                return t;
            }
        },
        {
            /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ key: "mn",
            value: function mn(e, t, n) {
                var r = (0, $3jzhD._)(e), i = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = (n.arrayValue.values || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var _$e = _step.value;
                        try {
                            for(var _iterator1 = r[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var _$n = _step1.value;
                                var r1 = new __PRIVATE_IndexByteEncoder;
                                r1.seed(_$n.Wt()), __PRIVATE_FirestoreIndexValueWriter.bt.Pt(_$e, r1.Ht(t.kind)), i.push(r1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return i;
            }
        },
        {
            key: "Vn",
            value: function Vn(e, t) {
                return !!e.filters.find(function(e) {
                    return e instanceof FieldFilter && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op);
                });
            }
        },
        {
            key: "getFieldIndexes",
            value: function getFieldIndexes(e, t) {
                var _this = this;
                var n = __PRIVATE_indexConfigurationStore(e), r = __PRIVATE_indexStateStore(e);
                return (t ? n.U("collectionGroupIndex", IDBKeyRange.bound(t, t)) : n.U()).next(function(e) {
                    var _$t = [];
                    return PersistencePromise.forEach(e, function(e) {
                        return r.get([
                            e.indexId,
                            _this.uid
                        ]).next(function(n) {
                            _$t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                                var _$n = t ? new IndexState(t.sequenceNumber, new IndexOffset(__PRIVATE_fromDbTimestamp(t.readTime), new DocumentKey(__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : IndexState.empty(), r = e.fields.map(function(param) {
                                    var _param = (0, $2MTYX._)(param, 2), _$e = _param[0], _$t = _param[1];
                                    return new IndexSegment(FieldPath$1.fromServerFormat(_$e), _$t);
                                });
                                return new FieldIndex(e.indexId, e.collectionGroup, r, _$n);
                            }(e, n));
                        });
                    }).next(function() {
                        return _$t;
                    });
                });
            }
        },
        {
            key: "getNextCollectionGroupToUpdate",
            value: function getNextCollectionGroupToUpdate(e) {
                return this.getFieldIndexes(e).next(function(e) {
                    return 0 === e.length ? null : (e.sort(function(e, t) {
                        var n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                        return 0 !== n ? n : __PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
                    }), e[0].collectionGroup);
                });
            }
        },
        {
            key: "updateCollectionGroup",
            value: function updateCollectionGroup(e, t, n) {
                var _this = this;
                var r = __PRIVATE_indexConfigurationStore(e), i = __PRIVATE_indexStateStore(e);
                return this.gn(e).next(function(e) {
                    return r.U("collectionGroupIndex", IDBKeyRange.bound(t, t)).next(function(t) {
                        return PersistencePromise.forEach(t, function(t) {
                            return i.put(__PRIVATE_toDbIndexState(t.indexId, _this.uid, e, n));
                        });
                    });
                });
            }
        },
        {
            key: "updateIndexEntries",
            value: function updateIndexEntries(e, t) {
                var _this = this;
                // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
                // it could be used across different IndexedDB transactions. As any cached
                // data might be invalidated by other multi-tab clients, we can only trust
                // data within a single IndexedDB transaction. We therefore add a cache
                // here.
                var n = new Map;
                return PersistencePromise.forEach(t, function(t, r) {
                    var i = n.get(t.collectionGroup);
                    return (i ? PersistencePromise.resolve(i) : _this.getFieldIndexes(e, t.collectionGroup)).next(function(i) {
                        return n.set(t.collectionGroup, i), PersistencePromise.forEach(i, function(n) {
                            return _this.pn(e, t, n).next(function(t) {
                                var _$i = _this.yn(r, n);
                                return t.isEqual(_$i) ? PersistencePromise.resolve() : _this.wn(e, r, n, t, _$i);
                            });
                        });
                    });
                });
            }
        },
        {
            key: "Sn",
            value: function Sn(e, t, n, r) {
                return __PRIVATE_indexEntriesStore(e).put({
                    indexId: r.indexId,
                    uid: this.uid,
                    arrayValue: r.arrayValue,
                    directionalValue: r.directionalValue,
                    orderedDocumentKey: this.Rn(n, t.key),
                    documentKey: t.key.path.toArray()
                });
            }
        },
        {
            key: "bn",
            value: function bn(e, t, n, r) {
                return __PRIVATE_indexEntriesStore(e).delete([
                    r.indexId,
                    this.uid,
                    r.arrayValue,
                    r.directionalValue,
                    this.Rn(n, t.key),
                    t.key.path.toArray()
                ]);
            }
        },
        {
            key: "pn",
            value: function pn(e, t, n) {
                var r = __PRIVATE_indexEntriesStore(e);
                var i = new SortedSet(__PRIVATE_indexEntryComparator);
                return r.J({
                    index: "documentKeyIndex",
                    range: IDBKeyRange.only([
                        n.indexId,
                        this.uid,
                        this.Rn(n, t)
                    ])
                }, function(e, r) {
                    i = i.add(new __PRIVATE_IndexEntry(n.indexId, t, r.arrayValue, r.directionalValue));
                }).next(function() {
                    return i;
                });
            }
        },
        {
            /** Creates the index entries for the given document. */ key: "yn",
            value: function yn(e, t) {
                var n = new SortedSet(__PRIVATE_indexEntryComparator);
                var r = this.An(t, e);
                if (null == r) return n;
                var i = __PRIVATE_fieldIndexGetArraySegment(t);
                if (null != i) {
                    var s = e.data.field(i.fieldPath);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (isArray(s)) try {
                        for(var _iterator = (s.arrayValue.values || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i1 = _step.value;
                            n = n.add(new __PRIVATE_IndexEntry(t.indexId, e.key, this.Tn(i1), r));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else n = n.add(new __PRIVATE_IndexEntry(t.indexId, e.key, de, r));
                return n;
            }
        },
        {
            /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ key: "wn",
            value: function wn(e, t, n, r, i) {
                var _this = this;
                __PRIVATE_logDebug("IndexedDbIndexManager", "Updating index entries for document '%s'", t.key);
                var s = [];
                return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
                    var s = e.getIterator(), o = t.getIterator();
                    var _ = __PRIVATE_advanceIterator(s), a = __PRIVATE_advanceIterator(o);
                    // Walk through the two sets at the same time, using the ordering defined by
                    // `comparator`.
                    for(; _ || a;){
                        var _$e = !1, _$t = !1;
                        if (_ && a) {
                            var _$r = n(_, a);
                            _$r < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            _$t = !0 : _$r > 0 && // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            (_$e = !0);
                        } else null != _ ? _$t = !0 : _$e = !0;
                        _$e ? (r(a), a = __PRIVATE_advanceIterator(o)) : _$t ? (i(_), _ = __PRIVATE_advanceIterator(s)) : (_ = __PRIVATE_advanceIterator(s), a = __PRIVATE_advanceIterator(o));
                    }
                }(r, i, __PRIVATE_indexEntryComparator, /* onAdd= */ function(r) {
                    s.push(_this.Sn(e, t, n, r));
                }, /* onRemove= */ function(r) {
                    s.push(_this.bn(e, t, n, r));
                }), PersistencePromise.waitFor(s);
            }
        },
        {
            key: "gn",
            value: function gn(e) {
                var t = 1;
                return __PRIVATE_indexStateStore(e).J({
                    index: "sequenceNumberIndex",
                    reverse: !0,
                    range: IDBKeyRange.upperBound([
                        this.uid,
                        Number.MAX_SAFE_INTEGER
                    ])
                }, function(e, n, r) {
                    r.done(), t = n.sequenceNumber + 1;
                }).next(function() {
                    return t;
                });
            }
        },
        {
            /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ key: "createRange",
            value: function createRange(e, t, n) {
                // The notIn values need to be sorted and unique so that we can return a
                // sorted set of non-overlapping ranges.
                n = n.sort(function(e, t) {
                    return __PRIVATE_indexEntryComparator(e, t);
                }).filter(function(e, t, n) {
                    return !t || 0 !== __PRIVATE_indexEntryComparator(e, n[t - 1]);
                });
                var r = [];
                r.push(e);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var _$n = __PRIVATE_indexEntryComparator(i, e), s = __PRIVATE_indexEntryComparator(i, t);
                        if (0 === _$n) // `notInValue` is the lower bound. We therefore need to raise the bound
                        // to the next value.
                        r[0] = e.Jt();
                        else if (_$n > 0 && s < 0) // `notInValue` is in the middle of the range
                        r.push(i), r.push(i.Jt());
                        else if (s > 0) break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                r.push(t);
                var i1 = [];
                for(var _$e = 0; _$e < r.length; _$e += 2){
                    // If we encounter two bounds that will create an unmatchable key range,
                    // then we return an empty set of key ranges.
                    if (this.Dn(r[_$e], r[_$e + 1])) return [];
                    var _$t = [
                        r[_$e].indexId,
                        this.uid,
                        r[_$e].arrayValue,
                        r[_$e].directionalValue,
                        de,
                        []
                    ], _$n1 = [
                        r[_$e + 1].indexId,
                        this.uid,
                        r[_$e + 1].arrayValue,
                        r[_$e + 1].directionalValue,
                        de,
                        []
                    ];
                    i1.push(IDBKeyRange.bound(_$t, _$n1));
                }
                return i1;
            }
        },
        {
            key: "Dn",
            value: function Dn(e, t) {
                // If lower bound is greater than the upper bound, then the key
                // range can never be matched.
                return __PRIVATE_indexEntryComparator(e, t) > 0;
            }
        },
        {
            key: "getMinOffsetFromCollectionGroup",
            value: function getMinOffsetFromCollectionGroup(e, t) {
                return this.getFieldIndexes(e, t).next(__PRIVATE_getMinOffsetFromFieldIndexes);
            }
        },
        {
            key: "getMinOffset",
            value: function getMinOffset(e, t) {
                var _this = this;
                return PersistencePromise.mapArray(this.cn(t), function(t) {
                    return _this.ln(e, t).next(function(e) {
                        return e || fail();
                    });
                }).next(__PRIVATE_getMinOffsetFromFieldIndexes);
            }
        }
    ]);
    return __PRIVATE_IndexedDbIndexManager;
}();
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function __PRIVATE_collectionParentsStore(e) {
    return __PRIVATE_getStore(e, "collectionParents");
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function __PRIVATE_indexEntriesStore(e) {
    return __PRIVATE_getStore(e, "indexEntries");
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function __PRIVATE_indexConfigurationStore(e) {
    return __PRIVATE_getStore(e, "indexConfiguration");
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function __PRIVATE_indexStateStore(e) {
    return __PRIVATE_getStore(e, "indexState");
}
function __PRIVATE_getMinOffsetFromFieldIndexes(e) {
    __PRIVATE_hardAssert(0 !== e.length);
    var t = e[0].indexState.offset, n = t.largestBatchId;
    for(var r = 1; r < e.length; r++){
        var i = e[r].indexState.offset;
        __PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Ae = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
};
var LruParams = /*#__PURE__*/ function() {
    "use strict";
    function LruParams(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n) {
        (0, $19mwo._)(this, LruParams);
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
    (0, $6rpfc._)(LruParams, null, [
        {
            key: "withCacheSize",
            value: function withCacheSize(e) {
                return new LruParams(e, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
            }
        }
    ]);
    return LruParams;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function removeMutationBatch(e, t, n) {
    var r = e.store("mutations"), i = e.store("documentMutations"), s = [], o = IDBKeyRange.only(n.batchId);
    var _ = 0;
    var a = r.J({
        range: o
    }, function(e, t, n) {
        return _++, n.delete();
    });
    s.push(a.next(function() {
        __PRIVATE_hardAssert(1 === _);
    }));
    var u = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = n.mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$e = _step.value;
            var r1 = __PRIVATE_newDbDocumentMutationKey(t, _$e.key.path, n.batchId);
            s.push(i.delete(r1)), u.push(_$e.key);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return PersistencePromise.waitFor(s).next(function() {
        return u;
    });
}
/**
 * Returns an approximate size for the given document.
 */ function __PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    var t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw fail();
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, LruParams.DEFAULT = new LruParams(41943040, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), LruParams.DISABLED = new LruParams(-1, 0, 0);
var __PRIVATE_IndexedDbMutationQueue = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbMutationQueue(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r) {
        (0, $19mwo._)(this, __PRIVATE_IndexedDbMutationQueue);
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.Cn = {};
    }
    (0, $6rpfc._)(__PRIVATE_IndexedDbMutationQueue, [
        {
            key: "checkEmpty",
            value: function checkEmpty(e) {
                var t = !0;
                var n = IDBKeyRange.bound([
                    this.userId,
                    Number.NEGATIVE_INFINITY
                ], [
                    this.userId,
                    Number.POSITIVE_INFINITY
                ]);
                return __PRIVATE_mutationsStore(e).J({
                    index: "userMutationsIndex",
                    range: n
                }, function(e, n, r) {
                    t = !1, r.done();
                }).next(function() {
                    return t;
                });
            }
        },
        {
            key: "addMutationBatch",
            value: function addMutationBatch(e, t, n, r) {
                var _this = this;
                var i = __PRIVATE_documentMutationsStore(e), s = __PRIVATE_mutationsStore(e);
                // The IndexedDb implementation in Chrome (and Firefox) does not handle
                // compound indices that include auto-generated keys correctly. To ensure
                // that the index entry is added correctly in all browsers, we perform two
                // writes: The first write is used to retrieve the next auto-generated Batch
                // ID, and the second write populates the index and stores the actual
                // mutation batch.
                // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
                // We write an empty object to obtain key
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return s.add({}).next(function(o) {
                    __PRIVATE_hardAssert("number" == typeof o);
                    var _ = new MutationBatch(o, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                        var _$r = n.baseMutations.map(function(t) {
                            return toMutation(e.ct, t);
                        }), i = n.mutations.map(function(t) {
                            return toMutation(e.ct, t);
                        });
                        return {
                            userId: t,
                            batchId: n.batchId,
                            localWriteTimeMs: n.localWriteTime.toMillis(),
                            baseMutations: _$r,
                            mutations: i
                        };
                    }(_this.serializer, _this.userId, _), u = [];
                    var c = new SortedSet(function(e, t) {
                        return __PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString());
                    });
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$e = _step.value;
                            var _$t = __PRIVATE_newDbDocumentMutationKey(_this.userId, _$e.key.path, o);
                            c = c.add(_$e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(_$t, O));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return c.forEach(function(t) {
                        u.push(_this.indexManager.addToCollectionParentIndex(e, t));
                    }), e.addOnCommittedListener(function() {
                        _this.Cn[o] = _.keys();
                    }), PersistencePromise.waitFor(u).next(function() {
                        return _;
                    });
                });
            }
        },
        {
            key: "lookupMutationBatch",
            value: function lookupMutationBatch(e, t) {
                var _this = this;
                return __PRIVATE_mutationsStore(e).get(t).next(function(e) {
                    return e ? (__PRIVATE_hardAssert(e.userId === _this.userId), __PRIVATE_fromDbMutationBatch(_this.serializer, e)) : null;
                });
            }
        },
        {
            /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
            key: "vn",
            value: function vn(e, t) {
                var _this = this;
                return this.Cn[t] ? PersistencePromise.resolve(this.Cn[t]) : this.lookupMutationBatch(e, t).next(function(e) {
                    if (e) {
                        var n = e.keys();
                        return _this.Cn[t] = n, n;
                    }
                    return null;
                });
            }
        },
        {
            key: "getNextMutationBatchAfterBatchId",
            value: function getNextMutationBatchAfterBatchId(e, t) {
                var _this = this;
                var n = t + 1, r = IDBKeyRange.lowerBound([
                    this.userId,
                    n
                ]);
                var i = null;
                return __PRIVATE_mutationsStore(e).J({
                    index: "userMutationsIndex",
                    range: r
                }, function(e, t, r) {
                    t.userId === _this.userId && (__PRIVATE_hardAssert(t.batchId >= n), i = __PRIVATE_fromDbMutationBatch(_this.serializer, t)), r.done();
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "getHighestUnacknowledgedBatchId",
            value: function getHighestUnacknowledgedBatchId(e) {
                var t = IDBKeyRange.upperBound([
                    this.userId,
                    Number.POSITIVE_INFINITY
                ]);
                var n = -1;
                return __PRIVATE_mutationsStore(e).J({
                    index: "userMutationsIndex",
                    range: t,
                    reverse: !0
                }, function(e, t, r) {
                    n = t.batchId, r.done();
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "getAllMutationBatches",
            value: function getAllMutationBatches(e) {
                var _this = this;
                var t = IDBKeyRange.bound([
                    this.userId,
                    -1
                ], [
                    this.userId,
                    Number.POSITIVE_INFINITY
                ]);
                return __PRIVATE_mutationsStore(e).U("userMutationsIndex", t).next(function(e) {
                    return e.map(function(e) {
                        return __PRIVATE_fromDbMutationBatch(_this.serializer, e);
                    });
                });
            }
        },
        {
            key: "getAllMutationBatchesAffectingDocumentKey",
            value: function getAllMutationBatchesAffectingDocumentKey(e, t) {
                var _this = this;
                // Scan the document-mutation index starting with a prefix starting with
                // the given documentKey.
                var n = __PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
                return __PRIVATE_documentMutationsStore(e).J({
                    range: r
                }, function(n, r, s) {
                    var _n = (0, $2MTYX._)(n, 3), o = _n[0], _ = _n[1], a = _n[2], u = __PRIVATE_decodeResourcePath(_);
                    // Only consider rows matching exactly the specific key of
                    // interest. Note that because we order by path first, and we
                    // order terminators before path separators, we'll encounter all
                    // the index rows for documentKey contiguously. In particular, all
                    // the rows for documentKey will occur before any rows for
                    // documents nested in a subcollection beneath documentKey so we
                    // can stop as soon as we hit any such row.
                    if (o === _this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
                    return __PRIVATE_mutationsStore(e).get(a).next(function(e) {
                        if (!e) throw fail();
                        __PRIVATE_hardAssert(e.userId === _this.userId), i.push(__PRIVATE_fromDbMutationBatch(_this.serializer, e));
                    });
                    s.done();
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "getAllMutationBatchesAffectingDocumentKeys",
            value: function getAllMutationBatchesAffectingDocumentKeys(e, t) {
                var _this = this;
                var n = new SortedSet(__PRIVATE_primitiveComparator);
                var r = [];
                return t.forEach(function(t) {
                    var i = __PRIVATE_newDbDocumentMutationPrefixForPath(_this.userId, t.path), s = IDBKeyRange.lowerBound(i), o = __PRIVATE_documentMutationsStore(e).J({
                        range: s
                    }, function(e, r, i) {
                        var _e = (0, $2MTYX._)(e, 3), s = _e[0], o = _e[1], _ = _e[2], a = __PRIVATE_decodeResourcePath(o);
                        // Only consider rows matching exactly the specific key of
                        // interest. Note that because we order by path first, and we
                        // order terminators before path separators, we'll encounter all
                        // the index rows for documentKey contiguously. In particular, all
                        // the rows for documentKey will occur before any rows for
                        // documents nested in a subcollection beneath documentKey so we
                        // can stop as soon as we hit any such row.
                        s === _this.userId && t.path.isEqual(a) ? n = n.add(_) : i.done();
                    });
                    r.push(o);
                }), PersistencePromise.waitFor(r).next(function() {
                    return _this.Fn(e, n);
                });
            }
        },
        {
            key: "getAllMutationBatchesAffectingQuery",
            value: function getAllMutationBatchesAffectingQuery(e, t) {
                var _this = this;
                var n = t.path, r = n.length + 1, i = __PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
                // Collect up unique batchIDs encountered during a scan of the index. Use a
                // SortedSet to accumulate batch IDs so they can be traversed in order in a
                // scan of the main table.
                var o = new SortedSet(__PRIVATE_primitiveComparator);
                return __PRIVATE_documentMutationsStore(e).J({
                    range: s
                }, function(e, t, i) {
                    var _e = (0, $2MTYX._)(e, 3), s = _e[0], _ = _e[1], a = _e[2], u = __PRIVATE_decodeResourcePath(_);
                    s === _this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
                    // query path can't be matches. For example, a query on 'rooms'
                    // can't match the document /rooms/abc/messages/xyx.
                    // TODO(mcg): we'll need a different scanner when we implement
                    // ancestor queries.
                    u.length === r && (o = o.add(a)) : i.done();
                }).next(function() {
                    return _this.Fn(e, o);
                });
            }
        },
        {
            key: "Fn",
            value: function Fn(e, t) {
                var _this = this;
                var n = [], r = [];
                // TODO(rockwood): Implement this using iterate.
                return t.forEach(function(t) {
                    r.push(__PRIVATE_mutationsStore(e).get(t).next(function(e) {
                        if (null === e) throw fail();
                        __PRIVATE_hardAssert(e.userId === _this.userId), n.push(__PRIVATE_fromDbMutationBatch(_this.serializer, e));
                    }));
                }), PersistencePromise.waitFor(r).next(function() {
                    return n;
                });
            }
        },
        {
            key: "removeMutationBatch",
            value: function removeMutationBatch1(e, t) {
                var _this = this;
                return removeMutationBatch(e._e, this.userId, t).next(function(n) {
                    return e.addOnCommittedListener(function() {
                        _this.Mn(t.batchId);
                    }), PersistencePromise.forEach(n, function(t) {
                        return _this.referenceDelegate.markPotentiallyOrphaned(e, t);
                    });
                });
            }
        },
        {
            /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
            key: "Mn",
            value: function Mn(e) {
                delete this.Cn[e];
            }
        },
        {
            key: "performConsistencyCheck",
            value: function performConsistencyCheck(e) {
                var _this = this;
                return this.checkEmpty(e).next(function(t) {
                    if (!t) return PersistencePromise.resolve();
                    // Verify that there are no entries in the documentMutations index if
                    // the queue is empty.
                    var n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                        return [
                            e
                        ];
                    }(_this.userId)), r = [];
                    return __PRIVATE_documentMutationsStore(e).J({
                        range: n
                    }, function(e, t, n) {
                        if (e[0] === _this.userId) {
                            var _$t = __PRIVATE_decodeResourcePath(e[1]);
                            r.push(_$t);
                        } else n.done();
                    }).next(function() {
                        __PRIVATE_hardAssert(0 === r.length);
                    });
                });
            }
        },
        {
            key: "containsKey",
            value: function containsKey(e, t) {
                return __PRIVATE_mutationQueueContainsKey(e, this.userId, t);
            }
        },
        {
            // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
            /** Returns the mutation queue's metadata from IndexedDb. */ key: "xn",
            value: function xn(e) {
                var _this = this;
                return __PRIVATE_mutationQueuesStore(e).get(this.userId).next(function(e) {
                    return e || {
                        userId: _this.userId,
                        lastAcknowledgedBatchId: -1,
                        lastStreamToken: ""
                    };
                });
            }
        }
    ], [
        {
            key: "lt",
            value: /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ function lt(e, t, n, r) {
                // TODO(mcg): Figure out what constraints there are on userIDs
                // In particular, are there any reserved characters? are empty ids allowed?
                // For the moment store these together in the same mutations table assuming
                // that empty userIDs aren't allowed.
                __PRIVATE_hardAssert("" !== e.uid);
                var i = e.isAuthenticated() ? e.uid : "";
                return new __PRIVATE_IndexedDbMutationQueue(i, t, n, r);
            }
        }
    ]);
    return __PRIVATE_IndexedDbMutationQueue;
}();
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function __PRIVATE_mutationQueueContainsKey(e, t, n) {
    var r = __PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    var o = !1;
    return __PRIVATE_documentMutationsStore(e).J({
        range: s,
        H: !0
    }, function(e, n, r) {
        var _e = (0, $2MTYX._)(e, 3), s = _e[0], _ = _e[1], /*batchID*/ a = _e[2];
        s === t && _ === i && (o = !0), r.done();
    }).next(function() {
        return o;
    });
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function __PRIVATE_mutationsStore(e) {
    return __PRIVATE_getStore(e, "mutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function __PRIVATE_documentMutationsStore(e) {
    return __PRIVATE_getStore(e, "documentMutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function __PRIVATE_mutationQueuesStore(e) {
    return __PRIVATE_getStore(e, "mutationQueues");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ var __PRIVATE_TargetIdGenerator = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TargetIdGenerator(e) {
        (0, $19mwo._)(this, __PRIVATE_TargetIdGenerator);
        this.On = e;
    }
    (0, $6rpfc._)(__PRIVATE_TargetIdGenerator, [
        {
            key: "next",
            value: function next() {
                return this.On += 2, this.On;
            }
        }
    ], [
        {
            key: "Nn",
            value: function Nn() {
                // The target cache generator must return '2' in its first call to `next()`
                // as there is no differentiation in the protocol layer between an unset
                // number and the number '0'. If we were to sent a target with target ID
                // '0', the backend would consider it unset and replace it with its own ID.
                return new __PRIVATE_TargetIdGenerator(0);
            }
        },
        {
            key: "Ln",
            value: function Ln() {
                // Sync engine assigns target IDs for limbo document detection.
                return new __PRIVATE_TargetIdGenerator(-1);
            }
        }
    ]);
    return __PRIVATE_TargetIdGenerator;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_IndexedDbTargetCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbTargetCache(e, t) {
        (0, $19mwo._)(this, __PRIVATE_IndexedDbTargetCache);
        this.referenceDelegate = e, this.serializer = t;
    }
    (0, $6rpfc._)(__PRIVATE_IndexedDbTargetCache, [
        {
            // PORTING NOTE: We don't cache global metadata for the target cache, since
            // some of it (in particular `highestTargetId`) can be modified by secondary
            // tabs. We could perhaps be more granular (and e.g. still cache
            // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
            // to IndexedDb whenever we need to read metadata. We can revisit if it turns
            // out to have a meaningful performance impact.
            key: "allocateTargetId",
            value: function allocateTargetId(e) {
                var _this = this;
                return this.Bn(e).next(function(t) {
                    var n = new __PRIVATE_TargetIdGenerator(t.highestTargetId);
                    return t.highestTargetId = n.next(), _this.kn(e, t).next(function() {
                        return t.highestTargetId;
                    });
                });
            }
        },
        {
            key: "getLastRemoteSnapshotVersion",
            value: function getLastRemoteSnapshotVersion(e) {
                return this.Bn(e).next(function(e) {
                    return SnapshotVersion.fromTimestamp(new Timestamp(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds));
                });
            }
        },
        {
            key: "getHighestSequenceNumber",
            value: function getHighestSequenceNumber(e) {
                return this.Bn(e).next(function(e) {
                    return e.highestListenSequenceNumber;
                });
            }
        },
        {
            key: "setTargetsMetadata",
            value: function setTargetsMetadata(e, t, n) {
                var _this = this;
                return this.Bn(e).next(function(r) {
                    return r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), _this.kn(e, r);
                });
            }
        },
        {
            key: "addTargetData",
            value: function addTargetData(e, t) {
                var _this = this;
                return this.qn(e, t).next(function() {
                    return _this.Bn(e).next(function(n) {
                        return n.targetCount += 1, _this.Qn(t, n), _this.kn(e, n);
                    });
                });
            }
        },
        {
            key: "updateTargetData",
            value: function updateTargetData(e, t) {
                return this.qn(e, t);
            }
        },
        {
            key: "removeTargetData",
            value: function removeTargetData(e, t) {
                var _this = this;
                return this.removeMatchingKeysForTargetId(e, t.targetId).next(function() {
                    return __PRIVATE_targetsStore(e).delete(t.targetId);
                }).next(function() {
                    return _this.Bn(e);
                }).next(function(t) {
                    return __PRIVATE_hardAssert(t.targetCount > 0), t.targetCount -= 1, _this.kn(e, t);
                });
            }
        },
        {
            /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ key: "removeTargets",
            value: function removeTargets(e, t, n) {
                var _this = this;
                var r = 0;
                var i = [];
                return __PRIVATE_targetsStore(e).J(function(s, o) {
                    var _ = __PRIVATE_fromDbTarget(o);
                    _.sequenceNumber <= t && null === n.get(_.targetId) && (r++, i.push(_this.removeTargetData(e, _)));
                }).next(function() {
                    return PersistencePromise.waitFor(i);
                }).next(function() {
                    return r;
                });
            }
        },
        {
            /**
     * Call provided function with each `TargetData` that we have cached.
     */ key: "forEachTarget",
            value: function forEachTarget(e, t) {
                return __PRIVATE_targetsStore(e).J(function(e, n) {
                    var r = __PRIVATE_fromDbTarget(n);
                    t(r);
                });
            }
        },
        {
            key: "Bn",
            value: function Bn(e) {
                return __PRIVATE_globalTargetStore(e).get("targetGlobalKey").next(function(e) {
                    return __PRIVATE_hardAssert(null !== e), e;
                });
            }
        },
        {
            key: "kn",
            value: function kn(e, t) {
                return __PRIVATE_globalTargetStore(e).put("targetGlobalKey", t);
            }
        },
        {
            key: "qn",
            value: function qn(e, t) {
                return __PRIVATE_targetsStore(e).put(__PRIVATE_toDbTarget(this.serializer, t));
            }
        },
        {
            /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ key: "Qn",
            value: function Qn(e, t) {
                var n = !1;
                return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
            }
        },
        {
            key: "getTargetCount",
            value: function getTargetCount(e) {
                return this.Bn(e).next(function(e) {
                    return e.targetCount;
                });
            }
        },
        {
            key: "getTargetData",
            value: function getTargetData(e, t) {
                // Iterating by the canonicalId may yield more than one result because
                // canonicalId values are not required to be unique per target. This query
                // depends on the queryTargets index to be efficient.
                var n = __PRIVATE_canonifyTarget(t), r = IDBKeyRange.bound([
                    n,
                    Number.NEGATIVE_INFINITY
                ], [
                    n,
                    Number.POSITIVE_INFINITY
                ]);
                var i = null;
                return __PRIVATE_targetsStore(e).J({
                    range: r,
                    index: "queryTargetsIndex"
                }, function(e, n, r) {
                    var s = __PRIVATE_fromDbTarget(n);
                    // After finding a potential match, check that the target is
                    // actually equal to the requested target.
                    __PRIVATE_targetEquals(t, s.target) && (i = s, r.done());
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "addMatchingKeys",
            value: function addMatchingKeys(e, t, n) {
                var _this = this;
                // PORTING NOTE: The reverse index (documentsTargets) is maintained by
                // IndexedDb.
                var r = [], i = __PRIVATE_documentTargetStore(e);
                return t.forEach(function(t) {
                    var s = __PRIVATE_encodeResourcePath(t.path);
                    r.push(i.put({
                        targetId: n,
                        path: s
                    })), r.push(_this.referenceDelegate.addReference(e, n, t));
                }), PersistencePromise.waitFor(r);
            }
        },
        {
            key: "removeMatchingKeys",
            value: function removeMatchingKeys(e, t, n) {
                var _this = this;
                // PORTING NOTE: The reverse index (documentsTargets) is maintained by
                // IndexedDb.
                var r = __PRIVATE_documentTargetStore(e);
                return PersistencePromise.forEach(t, function(t) {
                    var i = __PRIVATE_encodeResourcePath(t.path);
                    return PersistencePromise.waitFor([
                        r.delete([
                            n,
                            i
                        ]),
                        _this.referenceDelegate.removeReference(e, n, t)
                    ]);
                });
            }
        },
        {
            key: "removeMatchingKeysForTargetId",
            value: function removeMatchingKeysForTargetId(e, t) {
                var n = __PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
                    t
                ], [
                    t + 1
                ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
                return n.delete(r);
            }
        },
        {
            key: "getMatchingKeysForTargetId",
            value: function getMatchingKeysForTargetId(e, t) {
                var n = IDBKeyRange.bound([
                    t
                ], [
                    t + 1
                ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = __PRIVATE_documentTargetStore(e);
                var i = __PRIVATE_documentKeySet();
                return r.J({
                    range: n,
                    H: !0
                }, function(e, t, n) {
                    var r = __PRIVATE_decodeResourcePath(e[1]), s = new DocumentKey(r);
                    i = i.add(s);
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "containsKey",
            value: function containsKey(e, t) {
                var n = __PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
                    n
                ], [
                    __PRIVATE_immediateSuccessor(n)
                ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
                var i = 0;
                return __PRIVATE_documentTargetStore(e).J({
                    index: "documentTargetsIndex",
                    H: !0,
                    range: r
                }, function(param, n, r) {
                    var _param = (0, $2MTYX._)(param, 2), _$e = _param[0], _$t = _param[1];
                    // Having a sentinel row for a document does not count as containing that document;
                    // For the target cache, containing the document means the document is part of some
                    // target.
                    0 !== _$e && (i++, r.done());
                }).next(function() {
                    return i > 0;
                });
            }
        },
        {
            /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
            key: "ot",
            value: function ot(e, t) {
                return __PRIVATE_targetsStore(e).get(t).next(function(e) {
                    return e ? __PRIVATE_fromDbTarget(e) : null;
                });
            }
        }
    ]);
    return __PRIVATE_IndexedDbTargetCache;
}();
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function __PRIVATE_targetsStore(e) {
    return __PRIVATE_getStore(e, "targets");
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function __PRIVATE_globalTargetStore(e) {
    return __PRIVATE_getStore(e, "targetGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function __PRIVATE_documentTargetStore(e) {
    return __PRIVATE_getStore(e, "targetDocuments");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_bufferEntryComparator(param, param1) {
    var _param = (0, $2MTYX._)(param, 2), e = _param[0], t = _param[1], _param1 = (0, $2MTYX._)(param1, 2), n = _param1[0], r = _param1[1];
    var i = __PRIVATE_primitiveComparator(e, n);
    return 0 === i ? __PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ var __PRIVATE_RollingSequenceNumberBuffer = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_RollingSequenceNumberBuffer(e) {
        (0, $19mwo._)(this, __PRIVATE_RollingSequenceNumberBuffer);
        this.Kn = e, this.buffer = new SortedSet(__PRIVATE_bufferEntryComparator), this.$n = 0;
    }
    (0, $6rpfc._)(__PRIVATE_RollingSequenceNumberBuffer, [
        {
            key: "Un",
            value: function Un() {
                return ++this.$n;
            }
        },
        {
            key: "Wn",
            value: function Wn(e) {
                var t = [
                    e,
                    this.Un()
                ];
                if (this.buffer.size < this.Kn) this.buffer = this.buffer.add(t);
                else {
                    var _$e = this.buffer.last();
                    __PRIVATE_bufferEntryComparator(t, _$e) < 0 && (this.buffer = this.buffer.delete(_$e).add(t));
                }
            }
        },
        {
            key: "maxValue",
            get: function get() {
                // Guaranteed to be non-empty. If we decide we are not collecting any
                // sequence numbers, nthSequenceNumber below short-circuits. If we have
                // decided that we are collecting n sequence numbers, it's because n is some
                // percentage of the existing sequence numbers. That means we should never
                // be in a situation where we are collecting sequence numbers but don't
                // actually have any.
                return this.buffer.last()[0];
            }
        }
    ]);
    return __PRIVATE_RollingSequenceNumberBuffer;
}();
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ var __PRIVATE_LruScheduler = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_LruScheduler(e, t, n) {
        (0, $19mwo._)(this, __PRIVATE_LruScheduler);
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.Gn = null;
    }
    (0, $6rpfc._)(__PRIVATE_LruScheduler, [
        {
            key: "start",
            value: function start() {
                -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.zn(6e4);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.Gn && (this.Gn.cancel(), this.Gn = null);
            }
        },
        {
            key: "started",
            get: function get() {
                return null !== this.Gn;
            }
        },
        {
            key: "zn",
            value: function zn(e) {
                var _this = this;
                __PRIVATE_logDebug("LruGarbageCollector", "Garbage collection scheduled in ".concat(e, "ms")), this.Gn = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, /*#__PURE__*/ (0, $9OZ9j._)(function() {
                    var e, _tmp;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.Gn = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    _this.localStore.collectGarbage(_this.garbageCollector)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                e = _state.sent();
                                if (!__PRIVATE_isIndexedDbTransactionError(e)) return [
                                    3,
                                    4
                                ];
                                _tmp = __PRIVATE_logDebug("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", e);
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    __PRIVATE_ignoreIfPrimaryLeaseLoss(e)
                                ];
                            case 5:
                                _tmp = _state.sent();
                                _state.label = 6;
                            case 6:
                                _tmp;
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    4,
                                    _this.zn(3e5)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }));
            }
        }
    ]);
    return __PRIVATE_LruScheduler;
}();
/**
 * Implements the steps for LRU garbage collection.
 */ var __PRIVATE_LruGarbageCollectorImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_LruGarbageCollectorImpl(e, t) {
        (0, $19mwo._)(this, __PRIVATE_LruGarbageCollectorImpl);
        this.jn = e, this.params = t;
    }
    (0, $6rpfc._)(__PRIVATE_LruGarbageCollectorImpl, [
        {
            key: "calculateTargetCount",
            value: function calculateTargetCount(e, t) {
                return this.jn.Hn(e).next(function(e) {
                    return Math.floor(t / 100 * e);
                });
            }
        },
        {
            key: "nthSequenceNumber",
            value: function nthSequenceNumber(e, t) {
                var _this = this;
                if (0 === t) return PersistencePromise.resolve(__PRIVATE_ListenSequence.oe);
                var n = new __PRIVATE_RollingSequenceNumberBuffer(t);
                return this.jn.forEachTarget(e, function(e) {
                    return n.Wn(e.sequenceNumber);
                }).next(function() {
                    return _this.jn.Jn(e, function(e) {
                        return n.Wn(e);
                    });
                }).next(function() {
                    return n.maxValue;
                });
            }
        },
        {
            key: "removeTargets",
            value: function removeTargets(e, t, n) {
                return this.jn.removeTargets(e, t, n);
            }
        },
        {
            key: "removeOrphanedDocuments",
            value: function removeOrphanedDocuments(e, t) {
                return this.jn.removeOrphanedDocuments(e, t);
            }
        },
        {
            key: "collect",
            value: function collect(e, t) {
                var _this = this;
                return -1 === this.params.cacheSizeCollectionThreshold ? (__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; disabled"), PersistencePromise.resolve(Ae)) : this.getCacheSize(e).next(function(n) {
                    return n < _this.params.cacheSizeCollectionThreshold ? (__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; Cache size ".concat(n, " is lower than threshold ").concat(_this.params.cacheSizeCollectionThreshold)), Ae) : _this.Yn(e, t);
                });
            }
        },
        {
            key: "getCacheSize",
            value: function getCacheSize(e) {
                return this.jn.getCacheSize(e);
            }
        },
        {
            key: "Yn",
            value: function Yn(e, t) {
                var _this = this;
                var n, r, i, s, o, a, u;
                var c = Date.now();
                return this.calculateTargetCount(e, this.params.percentileToCollect).next(function(t) {
                    return(// Cap at the configured max
                    t > _this.params.maximumSequenceNumbersToCollect ? (__PRIVATE_logDebug("LruGarbageCollector", "Capping sequence numbers to collect down to the maximum of ".concat(_this.params.maximumSequenceNumbersToCollect, " from ").concat(t)), r = _this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), _this.nthSequenceNumber(e, r));
                }).next(function(r) {
                    return n = r, o = Date.now(), _this.removeTargets(e, n, t);
                }).next(function(t) {
                    return i = t, a = Date.now(), _this.removeOrphanedDocuments(e, n);
                }).next(function(e) {
                    if (u = Date.now(), __PRIVATE_getLogLevel() <= (0, $3DJ6n.LogLevel).DEBUG) __PRIVATE_logDebug("LruGarbageCollector", "LRU Garbage Collection\n	Counted targets in ".concat(s - c, "ms\n	Determined least recently used ").concat(r, " in ") + (o - s) + "ms\n" + "	Removed ".concat(i, " targets in ") + (a - o) + "ms\n" + "	Removed ".concat(e, " documents in ") + (u - a) + "ms\n" + "Total Duration: ".concat(u - c, "ms"));
                    return PersistencePromise.resolve({
                        didRun: !0,
                        sequenceNumbersCollected: r,
                        targetsRemoved: i,
                        documentsRemoved: e
                    });
                });
            }
        }
    ]);
    return __PRIVATE_LruGarbageCollectorImpl;
}();
function __PRIVATE_newLruGarbageCollector(e, t) {
    return new __PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ var __PRIVATE_IndexedDbLruDelegateImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbLruDelegateImpl(e, t) {
        (0, $19mwo._)(this, __PRIVATE_IndexedDbLruDelegateImpl);
        this.db = e, this.garbageCollector = __PRIVATE_newLruGarbageCollector(this, t);
    }
    (0, $6rpfc._)(__PRIVATE_IndexedDbLruDelegateImpl, [
        {
            key: "Hn",
            value: function Hn(e) {
                var t = this.Zn(e);
                return this.db.getTargetCache().getTargetCount(e).next(function(e) {
                    return t.next(function(t) {
                        return e + t;
                    });
                });
            }
        },
        {
            key: "Zn",
            value: function Zn(e) {
                var t = 0;
                return this.Jn(e, function(e) {
                    t++;
                }).next(function() {
                    return t;
                });
            }
        },
        {
            key: "forEachTarget",
            value: function forEachTarget(e, t) {
                return this.db.getTargetCache().forEachTarget(e, t);
            }
        },
        {
            key: "Jn",
            value: function Jn(e, t) {
                return this.Xn(e, function(e, n) {
                    return t(n);
                });
            }
        },
        {
            key: "addReference",
            value: function addReference(e, t, n) {
                return __PRIVATE_writeSentinelKey(e, n);
            }
        },
        {
            key: "removeReference",
            value: function removeReference(e, t, n) {
                return __PRIVATE_writeSentinelKey(e, n);
            }
        },
        {
            key: "removeTargets",
            value: function removeTargets(e, t, n) {
                return this.db.getTargetCache().removeTargets(e, t, n);
            }
        },
        {
            key: "markPotentiallyOrphaned",
            value: function markPotentiallyOrphaned(e, t) {
                return __PRIVATE_writeSentinelKey(e, t);
            }
        },
        {
            /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ key: "er",
            value: function er(e, t) {
                return function __PRIVATE_mutationQueuesContainKey(e, t) {
                    var n = !1;
                    return __PRIVATE_mutationQueuesStore(e).Y(function(r) {
                        return __PRIVATE_mutationQueueContainsKey(e, r, t).next(function(e) {
                            return e && (n = !0), PersistencePromise.resolve(!e);
                        });
                    }).next(function() {
                        return n;
                    });
                }(e, t);
            }
        },
        {
            key: "removeOrphanedDocuments",
            value: function removeOrphanedDocuments(e, t) {
                var _this = this;
                var n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
                var i = 0;
                return this.Xn(e, function(s, o) {
                    if (o <= t) {
                        var _$t = _this.er(e, s).next(function(t) {
                            if (!t) // Our size accounting requires us to read all documents before
                            // removing them.
                            return i++, n.getEntry(e, s).next(function() {
                                return n.removeEntry(s, SnapshotVersion.min()), __PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                                    return [
                                        0,
                                        __PRIVATE_encodeResourcePath(e.path)
                                    ];
                                }(s));
                            });
                        });
                        r.push(_$t);
                    }
                }).next(function() {
                    return PersistencePromise.waitFor(r);
                }).next(function() {
                    return n.apply(e);
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(e, t) {
                var n = t.withSequenceNumber(e.currentSequenceNumber);
                return this.db.getTargetCache().updateTargetData(e, n);
            }
        },
        {
            key: "updateLimboDocument",
            value: function updateLimboDocument(e, t) {
                return __PRIVATE_writeSentinelKey(e, t);
            }
        },
        {
            /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ key: "Xn",
            value: function Xn(e, t) {
                var n = __PRIVATE_documentTargetStore(e);
                var r, i = __PRIVATE_ListenSequence.oe;
                return n.J({
                    index: "documentTargetsIndex"
                }, function(param, param1) {
                    var _param = (0, $2MTYX._)(param, 2), _$e = _param[0], n = _param[1], s = param1.path, o = param1.sequenceNumber;
                    0 === _$e ? // if nextToReport is valid, report it, this is a new key so the
                    // last one must not be a member of any targets.
                    (i !== __PRIVATE_ListenSequence.oe && t(new DocumentKey(__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
                    // might report, if we don't find any targets for this document.
                    // Note that the sequence number must be defined when the targetId
                    // is 0.
                    i = o, r = s) : // set nextToReport to be invalid, we know we don't need to report
                    // this one since we found a target for it.
                    i = __PRIVATE_ListenSequence.oe;
                }).next(function() {
                    // Since we report sequence numbers after getting to the next key, we
                    // need to check if the last key we iterated over was an orphaned
                    // document and report it.
                    i !== __PRIVATE_ListenSequence.oe && t(new DocumentKey(__PRIVATE_decodeResourcePath(r)), i);
                });
            }
        },
        {
            key: "getCacheSize",
            value: function getCacheSize(e) {
                return this.db.getRemoteDocumentCache().getSize(e);
            }
        }
    ]);
    return __PRIVATE_IndexedDbLruDelegateImpl;
}();
function __PRIVATE_writeSentinelKey(e, t) {
    return __PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: __PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ var RemoteDocumentChangeBuffer = /*#__PURE__*/ function() {
    "use strict";
    function RemoteDocumentChangeBuffer() {
        (0, $19mwo._)(this, RemoteDocumentChangeBuffer);
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new ObjectMap(function(e) {
            return e.toString();
        }, function(e, t) {
            return e.isEqual(t);
        }), this.changesApplied = !1;
    }
    (0, $6rpfc._)(RemoteDocumentChangeBuffer, [
        {
            /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ key: "addEntry",
            value: function addEntry(e) {
                this.assertNotApplied(), this.changes.set(e.key, e);
            }
        },
        {
            /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ key: "removeEntry",
            value: function removeEntry(e, t) {
                this.assertNotApplied(), this.changes.set(e, MutableDocument.newInvalidDocument(e).setReadTime(t));
            }
        },
        {
            /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ key: "getEntry",
            value: function getEntry(e, t) {
                this.assertNotApplied();
                var n = this.changes.get(t);
                return void 0 !== n ? PersistencePromise.resolve(n) : this.getFromCache(e, t);
            }
        },
        {
            /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ key: "getEntries",
            value: function getEntries(e, t) {
                return this.getAllFromCache(e, t);
            }
        },
        {
            /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ key: "apply",
            value: function apply(e) {
                return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
            }
        },
        {
            /** Helper to assert this.changes is not null  */ key: "assertNotApplied",
            value: function assertNotApplied() {}
        }
    ]);
    return RemoteDocumentChangeBuffer;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ var __PRIVATE_IndexedDbRemoteDocumentCacheImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbRemoteDocumentCacheImpl(e) {
        (0, $19mwo._)(this, __PRIVATE_IndexedDbRemoteDocumentCacheImpl);
        this.serializer = e;
    }
    (0, $6rpfc._)(__PRIVATE_IndexedDbRemoteDocumentCacheImpl, [
        {
            key: "setIndexManager",
            value: function setIndexManager(e) {
                this.indexManager = e;
            }
        },
        {
            /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ key: "addEntry",
            value: function addEntry(e, t, n) {
                return __PRIVATE_remoteDocumentsStore(e).put(n);
            }
        },
        {
            /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ key: "removeEntry",
            value: function removeEntry(e, t, n) {
                return __PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
                    var _$n = e.path.toArray();
                    return [
                        /* prefix path */ _$n.slice(0, _$n.length - 2),
                        /* collection id */ _$n[_$n.length - 2],
                        __PRIVATE_toDbTimestampKey(t),
                        /* document id */ _$n[_$n.length - 1]
                    ];
                }(t, n));
            }
        },
        {
            /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ key: "updateMetadata",
            value: function updateMetadata(e, t) {
                var _this = this;
                return this.getMetadata(e).next(function(n) {
                    return n.byteSize += t, _this.tr(e, n);
                });
            }
        },
        {
            key: "getEntry",
            value: function getEntry(e, t) {
                var _this = this;
                var n = MutableDocument.newInvalidDocument(t);
                return __PRIVATE_remoteDocumentsStore(e).J({
                    index: "documentKeyIndex",
                    range: IDBKeyRange.only(__PRIVATE_dbKey(t))
                }, function(e, r) {
                    n = _this.nr(t, r);
                }).next(function() {
                    return n;
                });
            }
        },
        {
            /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ key: "rr",
            value: function rr(e, t) {
                var _this = this;
                var n = {
                    size: 0,
                    document: MutableDocument.newInvalidDocument(t)
                };
                return __PRIVATE_remoteDocumentsStore(e).J({
                    index: "documentKeyIndex",
                    range: IDBKeyRange.only(__PRIVATE_dbKey(t))
                }, function(e, r) {
                    n = {
                        document: _this.nr(t, r),
                        size: __PRIVATE_dbDocumentSize(r)
                    };
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "getEntries",
            value: function getEntries(e, t) {
                var _this = this;
                var n = __PRIVATE_mutableDocumentMap();
                return this.ir(e, t, function(e, t) {
                    var r = _this.nr(e, t);
                    n = n.insert(e, r);
                }).next(function() {
                    return n;
                });
            }
        },
        {
            /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ key: "sr",
            value: function sr(e, t) {
                var _this = this;
                var n = __PRIVATE_mutableDocumentMap(), r = new SortedMap(DocumentKey.comparator);
                return this.ir(e, t, function(e, t) {
                    var i = _this.nr(e, t);
                    n = n.insert(e, i), r = r.insert(e, __PRIVATE_dbDocumentSize(t));
                }).next(function() {
                    return {
                        documents: n,
                        _r: r
                    };
                });
            }
        },
        {
            key: "ir",
            value: function ir(e, t, n) {
                if (t.isEmpty()) return PersistencePromise.resolve();
                var r = new SortedSet(__PRIVATE_dbKeyComparator);
                t.forEach(function(e) {
                    return r = r.add(e);
                });
                var i = IDBKeyRange.bound(__PRIVATE_dbKey(r.first()), __PRIVATE_dbKey(r.last())), s = r.getIterator();
                var o = s.getNext();
                return __PRIVATE_remoteDocumentsStore(e).J({
                    index: "documentKeyIndex",
                    range: i
                }, function(e, t, r) {
                    var i = DocumentKey.fromSegments((0, $3jzhD._)(t.prefixPath).concat([
                        t.collectionGroup,
                        t.documentId
                    ]));
                    // Go through keys not found in cache.
                    for(; o && __PRIVATE_dbKeyComparator(o, i) < 0;)n(o, null), o = s.getNext();
                    o && o.isEqual(i) && // Key found in cache.
                    (n(o, t), o = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
                    o ? r.$(__PRIVATE_dbKey(o)) : r.done();
                }).next(function() {
                    // The rest of the keys are not in the cache. One case where `iterate`
                    // above won't go through them is when the cache is empty.
                    for(; o;)n(o, null), o = s.hasNext() ? s.getNext() : null;
                });
            }
        },
        {
            key: "getDocumentsMatchingQuery",
            value: function getDocumentsMatchingQuery(e, t, n, r, i) {
                var _this = this;
                var s = t.path, o = [
                    s.popLast().toArray(),
                    s.lastSegment(),
                    __PRIVATE_toDbTimestampKey(n.readTime),
                    n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
                ], _ = [
                    s.popLast().toArray(),
                    s.lastSegment(),
                    [
                        Number.MAX_SAFE_INTEGER,
                        Number.MAX_SAFE_INTEGER
                    ],
                    ""
                ];
                return __PRIVATE_remoteDocumentsStore(e).U(IDBKeyRange.bound(o, _, !0)).next(function(e) {
                    null == i || i.incrementDocumentReadCount(e.length);
                    var _$n = __PRIVATE_mutableDocumentMap();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$i = _step.value;
                            var _$e = _this.nr(DocumentKey.fromSegments(_$i.prefixPath.concat(_$i.collectionGroup, _$i.documentId)), _$i);
                            _$e.isFoundDocument() && (__PRIVATE_queryMatches(t, _$e) || r.has(_$e.key)) && // Either the document matches the given query, or it is mutated.
                            (_$n = _$n.insert(_$e.key, _$e));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return _$n;
                });
            }
        },
        {
            key: "getAllFromCollectionGroup",
            value: function getAllFromCollectionGroup(e, t, n, r) {
                var _this = this;
                var i = __PRIVATE_mutableDocumentMap();
                var s = __PRIVATE_dbCollectionGroupKey(t, n), o = __PRIVATE_dbCollectionGroupKey(t, IndexOffset.max());
                return __PRIVATE_remoteDocumentsStore(e).J({
                    index: "collectionGroupIndex",
                    range: IDBKeyRange.bound(s, o, !0)
                }, function(e, t, n) {
                    var s = _this.nr(DocumentKey.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
                    i = i.insert(s.key, s), i.size === r && n.done();
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "newChangeBuffer",
            value: function newChangeBuffer(e) {
                return new __PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
            }
        },
        {
            key: "getSize",
            value: function getSize(e) {
                return this.getMetadata(e).next(function(e) {
                    return e.byteSize;
                });
            }
        },
        {
            key: "getMetadata",
            value: function getMetadata(e) {
                return __PRIVATE_documentGlobalStore(e).get("remoteDocumentGlobalKey").next(function(e) {
                    return __PRIVATE_hardAssert(!!e), e;
                });
            }
        },
        {
            key: "tr",
            value: function tr(e, t) {
                return __PRIVATE_documentGlobalStore(e).put("remoteDocumentGlobalKey", t);
            }
        },
        {
            /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ key: "nr",
            value: function nr(e, t) {
                if (t) {
                    var _$e = __PRIVATE_fromDbRemoteDocument(this.serializer, t);
                    // Whether the document is a sentinel removal and should only be used in the
                    // `getNewDocumentChanges()`
                    if (!(_$e.isNoDocument() && _$e.version.isEqual(SnapshotVersion.min()))) return _$e;
                }
                return MutableDocument.newInvalidDocument(e);
            }
        }
    ]);
    return __PRIVATE_IndexedDbRemoteDocumentCacheImpl;
}();
/** Creates a new IndexedDbRemoteDocumentCache. */ function __PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new __PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ var __PRIVATE_IndexedDbRemoteDocumentChangeBuffer = /*#__PURE__*/ function(RemoteDocumentChangeBuffer) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_IndexedDbRemoteDocumentChangeBuffer, RemoteDocumentChangeBuffer);
    var _super = (0, $k1NN5._)(__PRIVATE_IndexedDbRemoteDocumentChangeBuffer);
    function __PRIVATE_IndexedDbRemoteDocumentChangeBuffer(e, t) {
        (0, $19mwo._)(this, __PRIVATE_IndexedDbRemoteDocumentChangeBuffer);
        var _this;
        _this = _super.call(this), _this.ar = e, _this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        _this.ur = new ObjectMap(function(e) {
            return e.toString();
        }, function(e, t) {
            return e.isEqual(t);
        });
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_IndexedDbRemoteDocumentChangeBuffer, [
        {
            key: "applyChanges",
            value: function applyChanges(e) {
                var _this = this;
                var t = [];
                var n = 0, r = new SortedSet(function(e, t) {
                    return __PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString());
                });
                return this.changes.forEach(function(i, s) {
                    var o = _this.ur.get(i);
                    if (t.push(_this.ar.removeEntry(e, i, o.readTime)), s.isValidDocument()) {
                        var _ = __PRIVATE_toDbRemoteDocument(_this.ar.serializer, s);
                        r = r.add(i.path.popLast());
                        var a = __PRIVATE_dbDocumentSize(_);
                        n += a - o.size, t.push(_this.ar.addEntry(e, i, _));
                    } else if (n -= o.size, _this.trackRemovals) {
                        // In order to track removals, we store a "sentinel delete" in the
                        // RemoteDocumentCache. This entry is represented by a NoDocument
                        // with a version of 0 and ignored by `maybeDecodeDocument()` but
                        // preserved in `getNewDocumentChanges()`.
                        var n1 = __PRIVATE_toDbRemoteDocument(_this.ar.serializer, s.convertToNoDocument(SnapshotVersion.min()));
                        t.push(_this.ar.addEntry(e, i, n1));
                    }
                }), r.forEach(function(n) {
                    t.push(_this.ar.indexManager.addToCollectionParentIndex(e, n));
                }), t.push(this.ar.updateMetadata(e, n)), PersistencePromise.waitFor(t);
            }
        },
        {
            key: "getFromCache",
            value: function getFromCache(e, t) {
                var _this = this;
                // Record the size of everything we load from the cache so we can compute a delta later.
                return this.ar.rr(e, t).next(function(e) {
                    return _this.ur.set(t, {
                        size: e.size,
                        readTime: e.document.readTime
                    }), e.document;
                });
            }
        },
        {
            key: "getAllFromCache",
            value: function getAllFromCache(e, t) {
                var _this = this;
                // Record the size of everything we load from the cache so we can compute
                // a delta later.
                return this.ar.sr(e, t).next(function(param) {
                    var _$e = param.documents, _$t = param._r;
                    return(// Note: `getAllFromCache` returns two maps instead of a single map from
                    // keys to `DocumentSizeEntry`s. This is to allow returning the
                    // `MutableDocumentMap` directly, without a conversion.
                    _$t.forEach(function(t, n) {
                        _this.ur.set(t, {
                            size: n,
                            readTime: _$e.get(t).readTime
                        });
                    }), _$e);
                });
            }
        }
    ]);
    return __PRIVATE_IndexedDbRemoteDocumentChangeBuffer;
}(RemoteDocumentChangeBuffer);
function __PRIVATE_documentGlobalStore(e) {
    return __PRIVATE_getStore(e, "remoteDocumentGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function __PRIVATE_remoteDocumentsStore(e) {
    return __PRIVATE_getStore(e, "remoteDocumentsV14");
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function __PRIVATE_dbKey(e) {
    var t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function __PRIVATE_dbCollectionGroupKey(e, t) {
    var n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        __PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function __PRIVATE_dbKeyComparator(e, t) {
    var n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    var i = 0;
    for(var _$e = 0; _$e < n.length - 2 && _$e < r.length - 2; ++_$e)if (i = __PRIVATE_primitiveComparator(n[_$e], r[_$e]), i) return i;
    return i = __PRIVATE_primitiveComparator(n.length, r.length), i || (i = __PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || __PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ var OverlayedDocument = function OverlayedDocument(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t) {
    "use strict";
    (0, $19mwo._)(this, OverlayedDocument);
    this.overlayedDocument = e, this.mutatedFields = t;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ var LocalDocumentsView = /*#__PURE__*/ function() {
    "use strict";
    function LocalDocumentsView(e, t, n, r) {
        (0, $19mwo._)(this, LocalDocumentsView);
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    (0, $6rpfc._)(LocalDocumentsView, [
        {
            /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ key: "getDocument",
            value: function getDocument(e, t) {
                var _this = this;
                var n = null;
                return this.documentOverlayCache.getOverlay(e, t).next(function(r) {
                    return n = r, _this.remoteDocumentCache.getEntry(e, t);
                }).next(function(e) {
                    return null !== n && __PRIVATE_mutationApplyToLocalView(n.mutation, e, FieldMask.empty(), Timestamp.now()), e;
                });
            }
        },
        {
            /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ key: "getDocuments",
            value: function getDocuments(e, t) {
                var _this = this;
                return this.remoteDocumentCache.getEntries(e, t).next(function(t) {
                    return _this.getLocalViewOfDocuments(e, t, __PRIVATE_documentKeySet()).next(function() {
                        return t;
                    });
                });
            }
        },
        {
            /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ key: "getLocalViewOfDocuments",
            value: function getLocalViewOfDocuments(e, t) {
                var _this = this;
                var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : __PRIVATE_documentKeySet();
                var r = __PRIVATE_newOverlayMap();
                return this.populateOverlays(e, r, t).next(function() {
                    return _this.computeViews(e, t, r, n).next(function(e) {
                        var _$t = documentMap();
                        return e.forEach(function(e, n) {
                            _$t = _$t.insert(e, n.overlayedDocument);
                        }), _$t;
                    });
                });
            }
        },
        {
            /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ key: "getOverlayedDocuments",
            value: function getOverlayedDocuments(e, t) {
                var _this = this;
                var n = __PRIVATE_newOverlayMap();
                return this.populateOverlays(e, n, t).next(function() {
                    return _this.computeViews(e, t, n, __PRIVATE_documentKeySet());
                });
            }
        },
        {
            /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ key: "populateOverlays",
            value: function populateOverlays(e, t, n) {
                var r = [];
                return n.forEach(function(e) {
                    t.has(e) || r.push(e);
                }), this.documentOverlayCache.getOverlays(e, r).next(function(e) {
                    e.forEach(function(e, n) {
                        t.set(e, n);
                    });
                });
            }
        },
        {
            /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */ key: "computeViews",
            value: function computeViews(e, t, n, r) {
                var i = __PRIVATE_mutableDocumentMap();
                var s = __PRIVATE_newDocumentKeyMap(), o = function __PRIVATE_newOverlayedDocumentMap() {
                    return __PRIVATE_newDocumentKeyMap();
                }();
                return t.forEach(function(e, t) {
                    var o = n.get(t.key);
                    // Recalculate an overlay if the document's existence state changed due to
                    // a remote event *and* the overlay is a PatchMutation. This is because
                    // document existence state can change if some patch mutation's
                    // preconditions are met.
                    // NOTE: we recalculate when `overlay` is undefined as well, because there
                    // might be a patch mutation whose precondition does not match before the
                    // change (hence overlay is undefined), but would now match.
                    r.has(t.key) && (void 0 === o || o.mutation instanceof __PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== o ? (s.set(t.key, o.mutation.getFieldMask()), __PRIVATE_mutationApplyToLocalView(o.mutation, t, o.mutation.getFieldMask(), Timestamp.now())) : // no overlay exists
                    // Using EMPTY to indicate there is no overlay for the document.
                    s.set(t.key, FieldMask.empty());
                }), this.recalculateAndSaveOverlays(e, i).next(function(e) {
                    return e.forEach(function(e, t) {
                        return s.set(e, t);
                    }), t.forEach(function(e, t) {
                        var n;
                        return o.set(e, new OverlayedDocument(t, null !== (n = s.get(e)) && void 0 !== n ? n : null));
                    }), o;
                });
            }
        },
        {
            key: "recalculateAndSaveOverlays",
            value: function recalculateAndSaveOverlays(e, t) {
                var _this = this;
                var n = __PRIVATE_newDocumentKeyMap();
                // A reverse lookup map from batch id to the documents within that batch.
                var r = new SortedMap(function(e, t) {
                    return e - t;
                }), i = __PRIVATE_documentKeySet();
                return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next(function(e) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        var _loop = function() {
                            var i = _step.value;
                            i.keys().forEach(function(e) {
                                var s = t.get(e);
                                if (null === s) return;
                                var o = n.get(e) || FieldMask.empty();
                                o = i.applyToLocalView(s, o), n.set(e, o);
                                var _ = (r.get(i.batchId) || __PRIVATE_documentKeySet()).add(e);
                                r = r.insert(i.batchId, _);
                            });
                        };
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }).next(function() {
                    var _loop = function() {
                        var r = o.getNext(), _ = r.key, a = r.value, u = __PRIVATE_newMutationMap();
                        a.forEach(function(e) {
                            if (!i.has(e)) {
                                var r = __PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                                null !== r && u.set(e, r), i = i.add(e);
                            }
                        }), s.push(_this.documentOverlayCache.saveOverlays(e, _, u));
                    };
                    var s = [], o = r.getReverseIterator();
                    // Iterate in descending order of batch IDs, and skip documents that are
                    // already saved.
                    for(; o.hasNext();)_loop();
                    return PersistencePromise.waitFor(s);
                }).next(function() {
                    return n;
                });
            }
        },
        {
            /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ key: "recalculateAndSaveOverlaysForDocumentKeys",
            value: function recalculateAndSaveOverlaysForDocumentKeys(e, t) {
                var _this = this;
                return this.remoteDocumentCache.getEntries(e, t).next(function(t) {
                    return _this.recalculateAndSaveOverlays(e, t);
                });
            }
        },
        {
            /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ key: "getDocumentsMatchingQuery",
            value: function getDocumentsMatchingQuery(e, t, n, r) {
                /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function __PRIVATE_isDocumentQuery$1(e) {
                    return DocumentKey.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
                }(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : __PRIVATE_isCollectionGroupQuery(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
            }
        },
        {
            /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ key: "getNextDocuments",
            value: function getNextDocuments(e, t, n, r) {
                var _this = this;
                return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next(function(i) {
                    var s = r - i.size > 0 ? _this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : PersistencePromise.resolve(__PRIVATE_newOverlayMap());
                    // The callsite will use the largest batch ID together with the latest read time to create
                    // a new index offset. Since we only process batch IDs if all remote documents have been read,
                    // no overlay will increase the overall read time. This is why we only need to special case
                    // the batch id.
                    var o = -1, _ = i;
                    return s.next(function(t) {
                        return PersistencePromise.forEach(t, function(t, n) {
                            return o < n.largestBatchId && (o = n.largestBatchId), i.get(t) ? PersistencePromise.resolve() : _this.remoteDocumentCache.getEntry(e, t).next(function(e) {
                                _ = _.insert(t, e);
                            });
                        }).next(function() {
                            return _this.populateOverlays(e, t, i);
                        }).next(function() {
                            return _this.computeViews(e, _, t, __PRIVATE_documentKeySet());
                        }).next(function(e) {
                            return {
                                batchId: o,
                                changes: __PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                            };
                        });
                    });
                });
            }
        },
        {
            key: "getDocumentsMatchingDocumentQuery",
            value: function getDocumentsMatchingDocumentQuery(e, t) {
                // Just do a simple document lookup.
                return this.getDocument(e, new DocumentKey(t)).next(function(e) {
                    var _$t = documentMap();
                    return e.isFoundDocument() && (_$t = _$t.insert(e.key, e)), _$t;
                });
            }
        },
        {
            key: "getDocumentsMatchingCollectionGroupQuery",
            value: function getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
                var _this = this;
                var i = t.collectionGroup;
                var s = documentMap();
                return this.indexManager.getCollectionParents(e, i).next(function(o) {
                    return PersistencePromise.forEach(o, function(o) {
                        var _ = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                            return new __PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                        }(t, o.child(i));
                        return _this.getDocumentsMatchingCollectionQuery(e, _, n, r).next(function(e) {
                            e.forEach(function(e, t) {
                                s = s.insert(e, t);
                            });
                        });
                    }).next(function() {
                        return s;
                    });
                });
            }
        },
        {
            key: "getDocumentsMatchingCollectionQuery",
            value: function getDocumentsMatchingCollectionQuery(e, t, n, r) {
                var _this = this;
                // Query the remote documents and overlay mutations.
                var i;
                return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next(function(s) {
                    return i = s, _this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r);
                }).next(function(e) {
                    // As documents might match the query because of their overlay we need to
                    // include documents for all overlays in the initial document set.
                    i.forEach(function(t, n) {
                        var r = n.getKey();
                        null === e.get(r) && (e = e.insert(r, MutableDocument.newInvalidDocument(r)));
                    });
                    // Apply the overlays and match against the query.
                    var _$n = documentMap();
                    return e.forEach(function(e, r) {
                        var s = i.get(e);
                        void 0 !== s && __PRIVATE_mutationApplyToLocalView(s.mutation, r, FieldMask.empty(), Timestamp.now()), // Finally, insert the documents that still match the query
                        __PRIVATE_queryMatches(t, r) && (_$n = _$n.insert(e, r));
                    }), _$n;
                });
            }
        }
    ]);
    return LocalDocumentsView;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_MemoryBundleCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryBundleCache(e) {
        (0, $19mwo._)(this, __PRIVATE_MemoryBundleCache);
        this.serializer = e, this.cr = new Map, this.lr = new Map;
    }
    (0, $6rpfc._)(__PRIVATE_MemoryBundleCache, [
        {
            key: "getBundleMetadata",
            value: function getBundleMetadata(e, t) {
                return PersistencePromise.resolve(this.cr.get(t));
            }
        },
        {
            key: "saveBundleMetadata",
            value: function saveBundleMetadata(e, t) {
                return this.cr.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
                    return {
                        id: e.id,
                        version: e.version,
                        createTime: __PRIVATE_fromVersion(e.createTime)
                    };
                }(t)), PersistencePromise.resolve();
            }
        },
        {
            key: "getNamedQuery",
            value: function getNamedQuery(e, t) {
                return PersistencePromise.resolve(this.lr.get(t));
            }
        },
        {
            key: "saveNamedQuery",
            value: function saveNamedQuery(e, t) {
                return this.lr.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
                    return {
                        name: e.name,
                        query: __PRIVATE_fromBundledQuery(e.bundledQuery),
                        readTime: __PRIVATE_fromVersion(e.readTime)
                    };
                }(t)), PersistencePromise.resolve();
            }
        }
    ]);
    return __PRIVATE_MemoryBundleCache;
}();
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ var __PRIVATE_MemoryDocumentOverlayCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryDocumentOverlayCache() {
        (0, $19mwo._)(this, __PRIVATE_MemoryDocumentOverlayCache);
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new SortedMap(DocumentKey.comparator), this.hr = new Map;
    }
    (0, $6rpfc._)(__PRIVATE_MemoryDocumentOverlayCache, [
        {
            key: "getOverlay",
            value: function getOverlay(e, t) {
                return PersistencePromise.resolve(this.overlays.get(t));
            }
        },
        {
            key: "getOverlays",
            value: function getOverlays(e, t) {
                var _this = this;
                var n = __PRIVATE_newOverlayMap();
                return PersistencePromise.forEach(t, function(t) {
                    return _this.getOverlay(e, t).next(function(e) {
                        null !== e && n.set(t, e);
                    });
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "saveOverlays",
            value: function saveOverlays(e, t, n) {
                var _this = this;
                return n.forEach(function(n, r) {
                    _this.ht(e, t, r);
                }), PersistencePromise.resolve();
            }
        },
        {
            key: "removeOverlaysForBatchId",
            value: function removeOverlaysForBatchId(e, t, n) {
                var _this = this;
                var r = this.hr.get(n);
                return void 0 !== r && (r.forEach(function(e) {
                    return _this.overlays = _this.overlays.remove(e);
                }), this.hr.delete(n)), PersistencePromise.resolve();
            }
        },
        {
            key: "getOverlaysForCollection",
            value: function getOverlaysForCollection(e, t, n) {
                var r = __PRIVATE_newOverlayMap(), i = t.length + 1, s = new DocumentKey(t.child("")), o = this.overlays.getIteratorFrom(s);
                for(; o.hasNext();){
                    var e1 = o.getNext().value, s1 = e1.getKey();
                    if (!t.isPrefixOf(s1.path)) break;
                    // Documents from sub-collections
                    s1.path.length === i && e1.largestBatchId > n && r.set(e1.getKey(), e1);
                }
                return PersistencePromise.resolve(r);
            }
        },
        {
            key: "getOverlaysForCollectionGroup",
            value: function getOverlaysForCollectionGroup(e, t, n, r) {
                var i = new SortedMap(function(e, t) {
                    return e - t;
                });
                var s = this.overlays.getIterator();
                for(; s.hasNext();){
                    var e1 = s.getNext().value;
                    if (e1.getKey().getCollectionGroup() === t && e1.largestBatchId > n) {
                        var _$t = i.get(e1.largestBatchId);
                        null === _$t && (_$t = __PRIVATE_newOverlayMap(), i = i.insert(e1.largestBatchId, _$t)), _$t.set(e1.getKey(), e1);
                    }
                }
                var o = __PRIVATE_newOverlayMap(), _ = i.getIterator();
                for(; _.hasNext();){
                    if (_.getNext().value.forEach(function(e, t) {
                        return o.set(e, t);
                    }), o.size() >= r) break;
                }
                return PersistencePromise.resolve(o);
            }
        },
        {
            key: "ht",
            value: function ht(e, t, n) {
                // Remove the association of the overlay to its batch id.
                var r = this.overlays.get(n.key);
                if (null !== r) {
                    var e1 = this.hr.get(r.largestBatchId).delete(n.key);
                    this.hr.set(r.largestBatchId, e1);
                }
                this.overlays = this.overlays.insert(n.key, new Overlay(t, n));
                // Create the association of this overlay to the given largestBatchId.
                var i = this.hr.get(t);
                void 0 === i && (i = __PRIVATE_documentKeySet(), this.hr.set(t, i)), this.hr.set(t, i.add(n.key));
            }
        }
    ]);
    return __PRIVATE_MemoryDocumentOverlayCache;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ var __PRIVATE_ReferenceSet = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_ReferenceSet() {
        (0, $19mwo._)(this, __PRIVATE_ReferenceSet);
        // A set of outstanding references to a document sorted by key.
        this.Pr = new SortedSet(__PRIVATE_DocReference.Ir), // A set of outstanding references to a document sorted by target id.
        this.Tr = new SortedSet(__PRIVATE_DocReference.Er);
    }
    (0, $6rpfc._)(__PRIVATE_ReferenceSet, [
        {
            /** Returns true if the reference set contains no references. */ key: "isEmpty",
            value: function isEmpty() {
                return this.Pr.isEmpty();
            }
        },
        {
            /** Adds a reference to the given document key for the given ID. */ key: "addReference",
            value: function addReference(e, t) {
                var n = new __PRIVATE_DocReference(e, t);
                this.Pr = this.Pr.add(n), this.Tr = this.Tr.add(n);
            }
        },
        {
            /** Add references to the given document keys for the given ID. */ key: "dr",
            value: function dr(e, t) {
                var _this = this;
                e.forEach(function(e) {
                    return _this.addReference(e, t);
                });
            }
        },
        {
            /**
     * Removes a reference to the given document key for the given
     * ID.
     */ key: "removeReference",
            value: function removeReference(e, t) {
                this.Ar(new __PRIVATE_DocReference(e, t));
            }
        },
        {
            key: "Rr",
            value: function Rr(e, t) {
                var _this = this;
                e.forEach(function(e) {
                    return _this.removeReference(e, t);
                });
            }
        },
        {
            /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ key: "Vr",
            value: function Vr(e) {
                var _this = this;
                var t = new DocumentKey(new ResourcePath([])), n = new __PRIVATE_DocReference(t, e), r = new __PRIVATE_DocReference(t, e + 1), i = [];
                return this.Tr.forEachInRange([
                    n,
                    r
                ], function(e) {
                    _this.Ar(e), i.push(e.key);
                }), i;
            }
        },
        {
            key: "mr",
            value: function mr() {
                var _this = this;
                this.Pr.forEach(function(e) {
                    return _this.Ar(e);
                });
            }
        },
        {
            key: "Ar",
            value: function Ar(e) {
                this.Pr = this.Pr.delete(e), this.Tr = this.Tr.delete(e);
            }
        },
        {
            key: "gr",
            value: function gr(e) {
                var t = new DocumentKey(new ResourcePath([])), n = new __PRIVATE_DocReference(t, e), r = new __PRIVATE_DocReference(t, e + 1);
                var i = __PRIVATE_documentKeySet();
                return this.Tr.forEachInRange([
                    n,
                    r
                ], function(e) {
                    i = i.add(e.key);
                }), i;
            }
        },
        {
            key: "containsKey",
            value: function containsKey(e) {
                var t = new __PRIVATE_DocReference(e, 0), n = this.Pr.firstAfterOrEqual(t);
                return null !== n && e.isEqual(n.key);
            }
        }
    ]);
    return __PRIVATE_ReferenceSet;
}();
var __PRIVATE_DocReference = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_DocReference(e, t) {
        (0, $19mwo._)(this, __PRIVATE_DocReference);
        this.key = e, this.pr = t;
    }
    (0, $6rpfc._)(__PRIVATE_DocReference, null, [
        {
            key: "Ir",
            value: /** Compare by key then by ID */ function Ir(e, t) {
                return DocumentKey.comparator(e.key, t.key) || __PRIVATE_primitiveComparator(e.pr, t.pr);
            }
        },
        {
            key: "Er",
            value: /** Compare by ID then by key */ function Er(e, t) {
                return __PRIVATE_primitiveComparator(e.pr, t.pr) || DocumentKey.comparator(e.key, t.key);
            }
        }
    ]);
    return __PRIVATE_DocReference;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_MemoryMutationQueue = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryMutationQueue(e, t) {
        (0, $19mwo._)(this, __PRIVATE_MemoryMutationQueue);
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.yr = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.wr = new SortedSet(__PRIVATE_DocReference.Ir);
    }
    (0, $6rpfc._)(__PRIVATE_MemoryMutationQueue, [
        {
            key: "checkEmpty",
            value: function checkEmpty(e) {
                return PersistencePromise.resolve(0 === this.mutationQueue.length);
            }
        },
        {
            key: "addMutationBatch",
            value: function addMutationBatch(e, t, n, r) {
                var i = this.yr;
                this.yr++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
                var s = new MutationBatch(i, t, n, r);
                this.mutationQueue.push(s);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Track references by document key and index collection parents.
                    for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$t = _step.value;
                        this.wr = this.wr.add(new __PRIVATE_DocReference(_$t.key, i)), this.indexManager.addToCollectionParentIndex(e, _$t.key.path.popLast());
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return PersistencePromise.resolve(s);
            }
        },
        {
            key: "lookupMutationBatch",
            value: function lookupMutationBatch(e, t) {
                return PersistencePromise.resolve(this.Sr(t));
            }
        },
        {
            key: "getNextMutationBatchAfterBatchId",
            value: function getNextMutationBatchAfterBatchId(e, t) {
                var n = t + 1, r = this.br(n), i = r < 0 ? 0 : r;
                // The requested batchId may still be out of range so normalize it to the
                // start of the queue.
                return PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
            }
        },
        {
            key: "getHighestUnacknowledgedBatchId",
            value: function getHighestUnacknowledgedBatchId() {
                return PersistencePromise.resolve(0 === this.mutationQueue.length ? -1 : this.yr - 1);
            }
        },
        {
            key: "getAllMutationBatches",
            value: function getAllMutationBatches(e) {
                return PersistencePromise.resolve(this.mutationQueue.slice());
            }
        },
        {
            key: "getAllMutationBatchesAffectingDocumentKey",
            value: function getAllMutationBatchesAffectingDocumentKey(e, t) {
                var _this = this;
                var n = new __PRIVATE_DocReference(t, 0), r = new __PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
                return this.wr.forEachInRange([
                    n,
                    r
                ], function(e) {
                    var _$t = _this.Sr(e.pr);
                    i.push(_$t);
                }), PersistencePromise.resolve(i);
            }
        },
        {
            key: "getAllMutationBatchesAffectingDocumentKeys",
            value: function getAllMutationBatchesAffectingDocumentKeys(e, t) {
                var _this = this;
                var n = new SortedSet(__PRIVATE_primitiveComparator);
                return t.forEach(function(e) {
                    var _$t = new __PRIVATE_DocReference(e, 0), r = new __PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
                    _this.wr.forEachInRange([
                        _$t,
                        r
                    ], function(e) {
                        n = n.add(e.pr);
                    });
                }), PersistencePromise.resolve(this.Dr(n));
            }
        },
        {
            key: "getAllMutationBatchesAffectingQuery",
            value: function getAllMutationBatchesAffectingQuery(e, t) {
                // Use the query path as a prefix for testing if a document matches the
                // query.
                var n = t.path, r = n.length + 1;
                // Construct a document reference for actually scanning the index. Unlike
                // the prefix the document key in this reference must have an even number of
                // segments. The empty segment can be used a suffix of the query path
                // because it precedes all other segments in an ordered traversal.
                var i = n;
                DocumentKey.isDocumentKey(i) || (i = i.child(""));
                var s = new __PRIVATE_DocReference(new DocumentKey(i), 0);
                // Find unique batchIDs referenced by all documents potentially matching the
                // query.
                var o = new SortedSet(__PRIVATE_primitiveComparator);
                return this.wr.forEachWhile(function(e) {
                    var _$t = e.key.path;
                    return !!n.isPrefixOf(_$t) && // Rows with document keys more than one segment longer than the query
                    // path can't be matches. For example, a query on 'rooms' can't match
                    // the document /rooms/abc/messages/xyx.
                    // TODO(mcg): we'll need a different scanner when we implement
                    // ancestor queries.
                    (_$t.length === r && (o = o.add(e.pr)), !0);
                }, s), PersistencePromise.resolve(this.Dr(o));
            }
        },
        {
            key: "Dr",
            value: function Dr(e) {
                var _this = this;
                // Construct an array of matching batches, sorted by batchID to ensure that
                // multiple mutations affecting the same document key are applied in order.
                var t = [];
                return e.forEach(function(e) {
                    var n = _this.Sr(e);
                    null !== n && t.push(n);
                }), t;
            }
        },
        {
            key: "removeMutationBatch",
            value: function removeMutationBatch(e, t) {
                var _this = this;
                __PRIVATE_hardAssert(0 === this.Cr(t.batchId, "removed")), this.mutationQueue.shift();
                var n = this.wr;
                return PersistencePromise.forEach(t.mutations, function(r) {
                    var i = new __PRIVATE_DocReference(r.key, t.batchId);
                    return n = n.delete(i), _this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
                }).next(function() {
                    _this.wr = n;
                });
            }
        },
        {
            key: "Mn",
            value: function Mn(e) {
            // No-op since the memory mutation queue does not maintain a separate cache.
            }
        },
        {
            key: "containsKey",
            value: function containsKey(e, t) {
                var n = new __PRIVATE_DocReference(t, 0), r = this.wr.firstAfterOrEqual(n);
                return PersistencePromise.resolve(t.isEqual(r && r.key));
            }
        },
        {
            key: "performConsistencyCheck",
            value: function performConsistencyCheck(e) {
                return this.mutationQueue.length, PersistencePromise.resolve();
            }
        },
        {
            /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ key: "Cr",
            value: function Cr(e, t) {
                return this.br(e);
            }
        },
        {
            /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ key: "br",
            value: function br(e) {
                if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
                return 0;
                // Examine the front of the queue to figure out the difference between the
                // batchId and indexes in the array. Note that since the queue is ordered
                // by batchId, if the first batch has a larger batchId then the requested
                // batchId doesn't exist in the queue.
                return e - this.mutationQueue[0].batchId;
            }
        },
        {
            /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */ key: "Sr",
            value: function Sr(e) {
                var t = this.br(e);
                if (t < 0 || t >= this.mutationQueue.length) return null;
                return this.mutationQueue[t];
            }
        }
    ]);
    return __PRIVATE_MemoryMutationQueue;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ var __PRIVATE_MemoryRemoteDocumentCacheImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryRemoteDocumentCacheImpl(e) {
        (0, $19mwo._)(this, __PRIVATE_MemoryRemoteDocumentCacheImpl);
        this.vr = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new SortedMap(DocumentKey.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    (0, $6rpfc._)(__PRIVATE_MemoryRemoteDocumentCacheImpl, [
        {
            key: "setIndexManager",
            value: function setIndexManager(e) {
                this.indexManager = e;
            }
        },
        {
            /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ key: "addEntry",
            value: function addEntry(e, t) {
                var n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.vr(t);
                return this.docs = this.docs.insert(n, {
                    document: t.mutableCopy(),
                    size: s
                }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
            }
        },
        {
            /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ key: "removeEntry",
            value: function removeEntry(e) {
                var t = this.docs.get(e);
                t && (this.docs = this.docs.remove(e), this.size -= t.size);
            }
        },
        {
            key: "getEntry",
            value: function getEntry(e, t) {
                var n = this.docs.get(t);
                return PersistencePromise.resolve(n ? n.document.mutableCopy() : MutableDocument.newInvalidDocument(t));
            }
        },
        {
            key: "getEntries",
            value: function getEntries(e, t) {
                var _this = this;
                var n = __PRIVATE_mutableDocumentMap();
                return t.forEach(function(e) {
                    var _$t = _this.docs.get(e);
                    n = n.insert(e, _$t ? _$t.document.mutableCopy() : MutableDocument.newInvalidDocument(e));
                }), PersistencePromise.resolve(n);
            }
        },
        {
            key: "getDocumentsMatchingQuery",
            value: function getDocumentsMatchingQuery(e, t, n, r) {
                var i = __PRIVATE_mutableDocumentMap();
                // Documents are ordered by key, so we can use a prefix scan to narrow down
                // the documents we need to match the query against.
                var s = t.path, o = new DocumentKey(s.child("")), _ = this.docs.getIteratorFrom(o);
                for(; _.hasNext();){
                    var __getNext = _.getNext(), e1 = __getNext.key, __getNext_value = __getNext.value, o1 = __getNext_value.document;
                    if (!s.isPrefixOf(e1.path)) break;
                    e1.path.length > s.length + 1 || __PRIVATE_indexOffsetComparator(__PRIVATE_newIndexOffsetFromDocument(o1), n) <= 0 || (r.has(o1.key) || __PRIVATE_queryMatches(t, o1)) && (i = i.insert(o1.key, o1.mutableCopy()));
                }
                return PersistencePromise.resolve(i);
            }
        },
        {
            key: "getAllFromCollectionGroup",
            value: function getAllFromCollectionGroup(e, t, n, r) {
                // This method should only be called from the IndexBackfiller if persistence
                // is enabled.
                fail();
            }
        },
        {
            key: "Fr",
            value: function Fr(e, t) {
                return PersistencePromise.forEach(this.docs, function(e) {
                    return t(e);
                });
            }
        },
        {
            key: "newChangeBuffer",
            value: function newChangeBuffer(e) {
                // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
                // a separate changelog and does not need special handling for removals.
                return new __PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
            }
        },
        {
            key: "getSize",
            value: function getSize(e) {
                return PersistencePromise.resolve(this.size);
            }
        }
    ]);
    return __PRIVATE_MemoryRemoteDocumentCacheImpl;
}();
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ var __PRIVATE_MemoryRemoteDocumentChangeBuffer = /*#__PURE__*/ function(RemoteDocumentChangeBuffer) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_MemoryRemoteDocumentChangeBuffer, RemoteDocumentChangeBuffer);
    var _super = (0, $k1NN5._)(__PRIVATE_MemoryRemoteDocumentChangeBuffer);
    function __PRIVATE_MemoryRemoteDocumentChangeBuffer(e) {
        (0, $19mwo._)(this, __PRIVATE_MemoryRemoteDocumentChangeBuffer);
        var _this;
        _this = _super.call(this), _this.ar = e;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_MemoryRemoteDocumentChangeBuffer, [
        {
            key: "applyChanges",
            value: function applyChanges(e) {
                var _this = this;
                var t = [];
                return this.changes.forEach(function(n, r) {
                    r.isValidDocument() ? t.push(_this.ar.addEntry(e, r)) : _this.ar.removeEntry(n);
                }), PersistencePromise.waitFor(t);
            }
        },
        {
            key: "getFromCache",
            value: function getFromCache(e, t) {
                return this.ar.getEntry(e, t);
            }
        },
        {
            key: "getAllFromCache",
            value: function getAllFromCache(e, t) {
                return this.ar.getEntries(e, t);
            }
        }
    ]);
    return __PRIVATE_MemoryRemoteDocumentChangeBuffer;
}(RemoteDocumentChangeBuffer);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_MemoryTargetCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryTargetCache(e) {
        (0, $19mwo._)(this, __PRIVATE_MemoryTargetCache);
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.Mr = new ObjectMap(function(e) {
            return __PRIVATE_canonifyTarget(e);
        }, __PRIVATE_targetEquals), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.Or = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.Nr = new __PRIVATE_ReferenceSet, this.targetCount = 0, this.Lr = __PRIVATE_TargetIdGenerator.Nn();
    }
    (0, $6rpfc._)(__PRIVATE_MemoryTargetCache, [
        {
            key: "forEachTarget",
            value: function forEachTarget(e, t) {
                return this.Mr.forEach(function(e, n) {
                    return t(n);
                }), PersistencePromise.resolve();
            }
        },
        {
            key: "getLastRemoteSnapshotVersion",
            value: function getLastRemoteSnapshotVersion(e) {
                return PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
            }
        },
        {
            key: "getHighestSequenceNumber",
            value: function getHighestSequenceNumber(e) {
                return PersistencePromise.resolve(this.Or);
            }
        },
        {
            key: "allocateTargetId",
            value: function allocateTargetId(e) {
                return this.highestTargetId = this.Lr.next(), PersistencePromise.resolve(this.highestTargetId);
            }
        },
        {
            key: "setTargetsMetadata",
            value: function setTargetsMetadata(e, t, n) {
                return n && (this.lastRemoteSnapshotVersion = n), t > this.Or && (this.Or = t), PersistencePromise.resolve();
            }
        },
        {
            key: "qn",
            value: function qn(e) {
                this.Mr.set(e.target, e);
                var t = e.targetId;
                t > this.highestTargetId && (this.Lr = new __PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.Or && (this.Or = e.sequenceNumber);
            }
        },
        {
            key: "addTargetData",
            value: function addTargetData(e, t) {
                return this.qn(t), this.targetCount += 1, PersistencePromise.resolve();
            }
        },
        {
            key: "updateTargetData",
            value: function updateTargetData(e, t) {
                return this.qn(t), PersistencePromise.resolve();
            }
        },
        {
            key: "removeTargetData",
            value: function removeTargetData(e, t) {
                return this.Mr.delete(t.target), this.Nr.Vr(t.targetId), this.targetCount -= 1, PersistencePromise.resolve();
            }
        },
        {
            key: "removeTargets",
            value: function removeTargets(e, t, n) {
                var _this = this;
                var r = 0;
                var i = [];
                return this.Mr.forEach(function(s, o) {
                    o.sequenceNumber <= t && null === n.get(o.targetId) && (_this.Mr.delete(s), i.push(_this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
                }), PersistencePromise.waitFor(i).next(function() {
                    return r;
                });
            }
        },
        {
            key: "getTargetCount",
            value: function getTargetCount(e) {
                return PersistencePromise.resolve(this.targetCount);
            }
        },
        {
            key: "getTargetData",
            value: function getTargetData(e, t) {
                var n = this.Mr.get(t) || null;
                return PersistencePromise.resolve(n);
            }
        },
        {
            key: "addMatchingKeys",
            value: function addMatchingKeys(e, t, n) {
                return this.Nr.dr(t, n), PersistencePromise.resolve();
            }
        },
        {
            key: "removeMatchingKeys",
            value: function removeMatchingKeys(e, t, n) {
                this.Nr.Rr(t, n);
                var r = this.persistence.referenceDelegate, i = [];
                return r && t.forEach(function(t) {
                    i.push(r.markPotentiallyOrphaned(e, t));
                }), PersistencePromise.waitFor(i);
            }
        },
        {
            key: "removeMatchingKeysForTargetId",
            value: function removeMatchingKeysForTargetId(e, t) {
                return this.Nr.Vr(t), PersistencePromise.resolve();
            }
        },
        {
            key: "getMatchingKeysForTargetId",
            value: function getMatchingKeysForTargetId(e, t) {
                var n = this.Nr.gr(t);
                return PersistencePromise.resolve(n);
            }
        },
        {
            key: "containsKey",
            value: function containsKey(e, t) {
                return PersistencePromise.resolve(this.Nr.containsKey(t));
            }
        }
    ]);
    return __PRIVATE_MemoryTargetCache;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ var __PRIVATE_MemoryPersistence = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryPersistence(e, t) {
        var _this = this;
        (0, $19mwo._)(this, __PRIVATE_MemoryPersistence);
        this.Br = {}, this.overlays = {}, this.kr = new __PRIVATE_ListenSequence(0), this.qr = !1, this.qr = !0, this.referenceDelegate = e(this), this.Qr = new __PRIVATE_MemoryTargetCache(this);
        this.indexManager = new __PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new __PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }(function(e) {
            return _this.referenceDelegate.Kr(e);
        }), this.serializer = new __PRIVATE_LocalSerializer(t), this.$r = new __PRIVATE_MemoryBundleCache(this.serializer);
    }
    (0, $6rpfc._)(__PRIVATE_MemoryPersistence, [
        {
            key: "start",
            value: function start() {
                return Promise.resolve();
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                // No durable state to ensure is closed on shutdown.
                return this.qr = !1, Promise.resolve();
            }
        },
        {
            key: "started",
            get: function get() {
                return this.qr;
            }
        },
        {
            key: "setDatabaseDeletedListener",
            value: function setDatabaseDeletedListener() {
            // No op.
            }
        },
        {
            key: "setNetworkEnabled",
            value: function setNetworkEnabled() {
            // No op.
            }
        },
        {
            key: "getIndexManager",
            value: function getIndexManager(e) {
                // We do not currently support indices for memory persistence, so we can
                // return the same shared instance of the memory index manager.
                return this.indexManager;
            }
        },
        {
            key: "getDocumentOverlayCache",
            value: function getDocumentOverlayCache(e) {
                var t = this.overlays[e.toKey()];
                return t || (t = new __PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
            }
        },
        {
            key: "getMutationQueue",
            value: function getMutationQueue(e, t) {
                var n = this.Br[e.toKey()];
                return n || (n = new __PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this.Br[e.toKey()] = n), n;
            }
        },
        {
            key: "getTargetCache",
            value: function getTargetCache() {
                return this.Qr;
            }
        },
        {
            key: "getRemoteDocumentCache",
            value: function getRemoteDocumentCache() {
                return this.remoteDocumentCache;
            }
        },
        {
            key: "getBundleCache",
            value: function getBundleCache() {
                return this.$r;
            }
        },
        {
            key: "runTransaction",
            value: function runTransaction(e, t, n) {
                var _this = this;
                __PRIVATE_logDebug("MemoryPersistence", "Starting transaction:", e);
                var r = new __PRIVATE_MemoryTransaction(this.kr.next());
                return this.referenceDelegate.Ur(), n(r).next(function(e) {
                    return _this.referenceDelegate.Wr(r).next(function() {
                        return e;
                    });
                }).toPromise().then(function(e) {
                    return r.raiseOnCommittedEvent(), e;
                });
            }
        },
        {
            key: "Gr",
            value: function Gr(e, t) {
                return PersistencePromise.or(Object.values(this.Br).map(function(n) {
                    return function() {
                        return n.containsKey(e, t);
                    };
                }));
            }
        }
    ]);
    return __PRIVATE_MemoryPersistence;
}();
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ var __PRIVATE_MemoryTransaction = /*#__PURE__*/ function(PersistenceTransaction) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_MemoryTransaction, PersistenceTransaction);
    var _super = (0, $k1NN5._)(__PRIVATE_MemoryTransaction);
    function __PRIVATE_MemoryTransaction(e) {
        (0, $19mwo._)(this, __PRIVATE_MemoryTransaction);
        var _this;
        _this = _super.call(this), _this.currentSequenceNumber = e;
        return (0, $hSCyS._)(_this);
    }
    return __PRIVATE_MemoryTransaction;
}(PersistenceTransaction);
var __PRIVATE_MemoryEagerDelegate = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryEagerDelegate(e) {
        (0, $19mwo._)(this, __PRIVATE_MemoryEagerDelegate);
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.zr = new __PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.jr = null;
    }
    (0, $6rpfc._)(__PRIVATE_MemoryEagerDelegate, [
        {
            key: "Jr",
            get: function get() {
                if (this.jr) return this.jr;
                throw fail();
            }
        },
        {
            key: "addReference",
            value: function addReference(e, t, n) {
                return this.zr.addReference(n, t), this.Jr.delete(n.toString()), PersistencePromise.resolve();
            }
        },
        {
            key: "removeReference",
            value: function removeReference(e, t, n) {
                return this.zr.removeReference(n, t), this.Jr.add(n.toString()), PersistencePromise.resolve();
            }
        },
        {
            key: "markPotentiallyOrphaned",
            value: function markPotentiallyOrphaned(e, t) {
                return this.Jr.add(t.toString()), PersistencePromise.resolve();
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(e, t) {
                var _this = this;
                this.zr.Vr(t.targetId).forEach(function(e) {
                    return _this.Jr.add(e.toString());
                });
                var n = this.persistence.getTargetCache();
                return n.getMatchingKeysForTargetId(e, t.targetId).next(function(e) {
                    e.forEach(function(e) {
                        return _this.Jr.add(e.toString());
                    });
                }).next(function() {
                    return n.removeTargetData(e, t);
                });
            }
        },
        {
            key: "Ur",
            value: function Ur() {
                this.jr = new Set;
            }
        },
        {
            key: "Wr",
            value: function Wr(e) {
                var _this = this;
                // Remove newly orphaned documents.
                var t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
                return PersistencePromise.forEach(this.Jr, function(n) {
                    var r = DocumentKey.fromPath(n);
                    return _this.Yr(e, r).next(function(e) {
                        e || t.removeEntry(r, SnapshotVersion.min());
                    });
                }).next(function() {
                    return _this.jr = null, t.apply(e);
                });
            }
        },
        {
            key: "updateLimboDocument",
            value: function updateLimboDocument(e, t) {
                var _this = this;
                return this.Yr(e, t).next(function(e) {
                    e ? _this.Jr.delete(t.toString()) : _this.Jr.add(t.toString());
                });
            }
        },
        {
            key: "Kr",
            value: function Kr(e) {
                // For eager GC, we don't care about the document size, there are no size thresholds.
                return 0;
            }
        },
        {
            key: "Yr",
            value: function Yr(e, t) {
                var _this = this;
                return PersistencePromise.or([
                    function() {
                        return PersistencePromise.resolve(_this.zr.containsKey(t));
                    },
                    function() {
                        return _this.persistence.getTargetCache().containsKey(e, t);
                    },
                    function() {
                        return _this.persistence.Gr(e, t);
                    }
                ]);
            }
        }
    ], [
        {
            key: "Hr",
            value: function Hr(e) {
                return new __PRIVATE_MemoryEagerDelegate(e);
            }
        }
    ]);
    return __PRIVATE_MemoryEagerDelegate;
}();
var __PRIVATE_MemoryLruDelegate = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryLruDelegate(e, t) {
        (0, $19mwo._)(this, __PRIVATE_MemoryLruDelegate);
        this.persistence = e, this.Zr = new ObjectMap(function(e) {
            return __PRIVATE_encodeResourcePath(e.path);
        }, function(e, t) {
            return e.isEqual(t);
        }), this.garbageCollector = __PRIVATE_newLruGarbageCollector(this, t);
    }
    (0, $6rpfc._)(__PRIVATE_MemoryLruDelegate, [
        {
            // No-ops, present so memory persistence doesn't have to care which delegate
            // it has.
            key: "Ur",
            value: function Ur() {}
        },
        {
            key: "Wr",
            value: function Wr(e) {
                return PersistencePromise.resolve();
            }
        },
        {
            key: "forEachTarget",
            value: function forEachTarget(e, t) {
                return this.persistence.getTargetCache().forEachTarget(e, t);
            }
        },
        {
            key: "Hn",
            value: function Hn(e) {
                var t = this.Zn(e);
                return this.persistence.getTargetCache().getTargetCount(e).next(function(e) {
                    return t.next(function(t) {
                        return e + t;
                    });
                });
            }
        },
        {
            key: "Zn",
            value: function Zn(e) {
                var t = 0;
                return this.Jn(e, function(e) {
                    t++;
                }).next(function() {
                    return t;
                });
            }
        },
        {
            key: "Jn",
            value: function Jn(e, t) {
                var _this = this;
                return PersistencePromise.forEach(this.Zr, function(n, r) {
                    return _this.er(e, n, r).next(function(e) {
                        return e ? PersistencePromise.resolve() : t(r);
                    });
                });
            }
        },
        {
            key: "removeTargets",
            value: function removeTargets(e, t, n) {
                return this.persistence.getTargetCache().removeTargets(e, t, n);
            }
        },
        {
            key: "removeOrphanedDocuments",
            value: function removeOrphanedDocuments(e, t) {
                var _this = this;
                var n = 0;
                var r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
                return r.Fr(e, function(r) {
                    return _this.er(e, r, t).next(function(e) {
                        e || (n++, i.removeEntry(r, SnapshotVersion.min()));
                    });
                }).next(function() {
                    return i.apply(e);
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "markPotentiallyOrphaned",
            value: function markPotentiallyOrphaned(e, t) {
                return this.Zr.set(t, e.currentSequenceNumber), PersistencePromise.resolve();
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(e, t) {
                var n = t.withSequenceNumber(e.currentSequenceNumber);
                return this.persistence.getTargetCache().updateTargetData(e, n);
            }
        },
        {
            key: "addReference",
            value: function addReference(e, t, n) {
                return this.Zr.set(n, e.currentSequenceNumber), PersistencePromise.resolve();
            }
        },
        {
            key: "removeReference",
            value: function removeReference(e, t, n) {
                return this.Zr.set(n, e.currentSequenceNumber), PersistencePromise.resolve();
            }
        },
        {
            key: "updateLimboDocument",
            value: function updateLimboDocument(e, t) {
                return this.Zr.set(t, e.currentSequenceNumber), PersistencePromise.resolve();
            }
        },
        {
            key: "Kr",
            value: function Kr(e) {
                var t = e.key.toString().length;
                return e.isFoundDocument() && (t += __PRIVATE_estimateByteSize(e.data.value)), t;
            }
        },
        {
            key: "er",
            value: function er(e, t, n) {
                var _this = this;
                return PersistencePromise.or([
                    function() {
                        return _this.persistence.Gr(e, t);
                    },
                    function() {
                        return _this.persistence.getTargetCache().containsKey(e, t);
                    },
                    function() {
                        var e = _this.Zr.get(t);
                        return PersistencePromise.resolve(void 0 !== e && e > n);
                    }
                ]);
            }
        },
        {
            key: "getCacheSize",
            value: function getCacheSize(e) {
                return this.persistence.getRemoteDocumentCache().getSize(e);
            }
        }
    ], [
        {
            key: "Hr",
            value: function Hr(e, t) {
                return new __PRIVATE_MemoryLruDelegate(e, t);
            }
        }
    ]);
    return __PRIVATE_MemoryLruDelegate;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ var __PRIVATE_SchemaConverter = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SchemaConverter(e) {
        (0, $19mwo._)(this, __PRIVATE_SchemaConverter);
        this.serializer = e;
    }
    (0, $6rpfc._)(__PRIVATE_SchemaConverter, [
        {
            /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ key: "O",
            value: function O(e, t, n, r) {
                var _this = this;
                var i = new __PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
                n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
                    e.createObjectStore("owner");
                }(e), function __PRIVATE_createMutationQueue(e) {
                    e.createObjectStore("mutationQueues", {
                        keyPath: "userId"
                    });
                    e.createObjectStore("mutations", {
                        keyPath: "batchId",
                        autoIncrement: !0
                    }).createIndex("userMutationsIndex", x, {
                        unique: !0
                    }), e.createObjectStore("documentMutations");
                }(e), __PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
                    e.createObjectStore("remoteDocuments");
                }(e));
                // Migration 2 to populate the targetGlobal object no longer needed since
                // migration 3 unconditionally clears it.
                var s = PersistencePromise.resolve();
                return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
                // potentially have corrupt data.
                (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
                    e.deleteObjectStore("targetDocuments"), e.deleteObjectStore("targets"), e.deleteObjectStore("targetGlobal");
                }(e), __PRIVATE_createQueryCache(e)), s = s.next(function() {
                    return(/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                        var _$t = e.store("targetGlobal"), _$n = {
                            highestTargetId: 0,
                            highestListenSequenceNumber: 0,
                            lastRemoteSnapshotVersion: SnapshotVersion.min().toTimestamp(),
                            targetCount: 0
                        };
                        return _$t.put("targetGlobalKey", _$n);
                    }(i));
                })), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
                // mutation batch IDs (this was previously ensured internally by the
                // client). To migrate to the new schema, we have to read all mutations
                // and write them back out. We preserve the existing batch IDs to guarantee
                // consistency with other object stores. Any further mutation batch IDs will
                // be auto-generated.
                (s = s.next(function() {
                    return function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                        return t.store("mutations").U().next(function(n) {
                            e.deleteObjectStore("mutations");
                            e.createObjectStore("mutations", {
                                keyPath: "batchId",
                                autoIncrement: !0
                            }).createIndex("userMutationsIndex", x, {
                                unique: !0
                            });
                            var _$r = t.store("mutations"), i = n.map(function(e) {
                                return _$r.put(e);
                            });
                            return PersistencePromise.waitFor(i);
                        });
                    }(e, i);
                })), s = s.next(function() {
                    !function __PRIVATE_createClientMetadataStore(e) {
                        e.createObjectStore("clientMetadata", {
                            keyPath: "clientId"
                        });
                    }(e);
                })), n < 5 && r >= 5 && (s = s.next(function() {
                    return _this.Xr(i);
                })), n < 6 && r >= 6 && (s = s.next(function() {
                    return function __PRIVATE_createDocumentGlobalStore(e) {
                        e.createObjectStore("remoteDocumentGlobal");
                    }(e), _this.ei(i);
                })), n < 7 && r >= 7 && (s = s.next(function() {
                    return _this.ti(i);
                })), n < 8 && r >= 8 && (s = s.next(function() {
                    return _this.ni(e, i);
                })), n < 9 && r >= 9 && (s = s.next(function() {
                    // Multi-Tab used to manage its own changelog, but this has been moved
                    // to the DbRemoteDocument object store itself. Since the previous change
                    // log only contained transient data, we can drop its object store.
                    !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                        e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
                    }(e);
                // Note: Schema version 9 used to create a read time index for the
                // RemoteDocumentCache. This is now done with schema version 13.
                })), n < 10 && r >= 10 && (s = s.next(function() {
                    return _this.ri(i);
                })), n < 11 && r >= 11 && (s = s.next(function() {
                    !function __PRIVATE_createBundlesStore(e) {
                        e.createObjectStore("bundles", {
                            keyPath: "bundleId"
                        });
                    }(e), function __PRIVATE_createNamedQueriesStore(e) {
                        e.createObjectStore("namedQueries", {
                            keyPath: "name"
                        });
                    }(e);
                })), n < 12 && r >= 12 && (s = s.next(function() {
                    !function __PRIVATE_createDocumentOverlayStore(e) {
                        var _$t = e.createObjectStore("documentOverlays", {
                            keyPath: z
                        });
                        _$t.createIndex("collectionPathOverlayIndex", j, {
                            unique: !1
                        }), _$t.createIndex("collectionGroupOverlayIndex", H, {
                            unique: !1
                        });
                    }(e);
                })), n < 13 && r >= 13 && (s = s.next(function() {
                    return function __PRIVATE_createRemoteDocumentCache(e) {
                        var _$t = e.createObjectStore("remoteDocumentsV14", {
                            keyPath: N
                        });
                        _$t.createIndex("documentKeyIndex", L), _$t.createIndex("collectionGroupIndex", B);
                    }(e);
                }).next(function() {
                    return _this.ii(e, i);
                }).next(function() {
                    return e.deleteObjectStore("remoteDocuments");
                })), n < 14 && r >= 14 && (s = s.next(function() {
                    return _this.si(e, i);
                })), n < 15 && r >= 15 && (s = s.next(function() {
                    return function __PRIVATE_createFieldIndex(e) {
                        e.createObjectStore("indexConfiguration", {
                            keyPath: "indexId",
                            autoIncrement: !0
                        }).createIndex("collectionGroupIndex", "collectionGroup", {
                            unique: !1
                        });
                        e.createObjectStore("indexState", {
                            keyPath: $
                        }).createIndex("sequenceNumberIndex", U, {
                            unique: !1
                        });
                        e.createObjectStore("indexEntries", {
                            keyPath: W
                        }).createIndex("documentKeyIndex", G, {
                            unique: !1
                        });
                    }(e);
                })), n < 16 && r >= 16 && // Clear the object stores to remove possibly corrupted index entries
                (s = s.next(function() {
                    t.objectStore("indexState").clear();
                }).next(function() {
                    t.objectStore("indexEntries").clear();
                })), s;
            }
        },
        {
            key: "ei",
            value: function ei(e) {
                var t = 0;
                return e.store("remoteDocuments").J(function(e, n) {
                    t += __PRIVATE_dbDocumentSize(n);
                }).next(function() {
                    var n = {
                        byteSize: t
                    };
                    return e.store("remoteDocumentGlobal").put("remoteDocumentGlobalKey", n);
                });
            }
        },
        {
            key: "Xr",
            value: function Xr(e) {
                var _this = this;
                var t = e.store("mutationQueues"), n = e.store("mutations");
                return t.U().next(function(t) {
                    return PersistencePromise.forEach(t, function(t) {
                        var r = IDBKeyRange.bound([
                            t.userId,
                            -1
                        ], [
                            t.userId,
                            t.lastAcknowledgedBatchId
                        ]);
                        return n.U("userMutationsIndex", r).next(function(n) {
                            return PersistencePromise.forEach(n, function(n) {
                                __PRIVATE_hardAssert(n.userId === t.userId);
                                var r = __PRIVATE_fromDbMutationBatch(_this.serializer, n);
                                return removeMutationBatch(e, t.userId, r).next(function() {});
                            });
                        });
                    });
                });
            }
        },
        {
            /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ key: "ti",
            value: function ti(e) {
                var t = e.store("targetDocuments"), n = e.store("remoteDocuments");
                return e.store("targetGlobal").get("targetGlobalKey").next(function(e) {
                    var r = [];
                    return n.J(function(n, i) {
                        var s = new ResourcePath(n), o = function __PRIVATE_sentinelKey(e) {
                            return [
                                0,
                                __PRIVATE_encodeResourcePath(e)
                            ];
                        }(s);
                        r.push(t.get(o).next(function(n) {
                            return n ? PersistencePromise.resolve() : function(n) {
                                return t.put({
                                    targetId: 0,
                                    path: __PRIVATE_encodeResourcePath(n),
                                    sequenceNumber: e.highestListenSequenceNumber
                                });
                            }(s);
                        }));
                    }).next(function() {
                        return PersistencePromise.waitFor(r);
                    });
                });
            }
        },
        {
            key: "ni",
            value: function ni(e, t) {
                // Create the index.
                e.createObjectStore("collectionParents", {
                    keyPath: K
                });
                var n = t.store("collectionParents"), r = new __PRIVATE_MemoryCollectionParentIndex, addEntry = function(e) {
                    if (r.add(e)) {
                        var _$t = e.lastSegment(), r1 = e.popLast();
                        return n.put({
                            collectionId: _$t,
                            parent: __PRIVATE_encodeResourcePath(r1)
                        });
                    }
                };
                // Helper to add an index entry iff we haven't already written it.
                // Index existing remote documents.
                return t.store("remoteDocuments").J({
                    H: !0
                }, function(e, t) {
                    var n = new ResourcePath(e);
                    return addEntry(n.popLast());
                }).next(function() {
                    return t.store("documentMutations").J({
                        H: !0
                    }, function(param, r) {
                        var _param = (0, $2MTYX._)(param, 3), _$e = _param[0], _$t = _param[1], n = _param[2];
                        var i = __PRIVATE_decodeResourcePath(_$t);
                        return addEntry(i.popLast());
                    });
                });
            }
        },
        {
            key: "ri",
            value: function ri(e) {
                var _this = this;
                var t = e.store("targets");
                return t.J(function(e, n) {
                    var r = __PRIVATE_fromDbTarget(n), i = __PRIVATE_toDbTarget(_this.serializer, r);
                    return t.put(i);
                });
            }
        },
        {
            key: "ii",
            value: function ii(e, t) {
                var n = t.store("remoteDocuments"), r = [];
                return n.J(function(e, n) {
                    var i = t.store("remoteDocumentsV14"), s = (function __PRIVATE_extractKey(e) {
                        return e.document ? new DocumentKey(ResourcePath.fromString(e.document.name).popFirst(5)) : e.noDocument ? DocumentKey.fromSegments(e.noDocument.path) : e.unknownDocument ? DocumentKey.fromSegments(e.unknownDocument.path) : fail();
                    })(n).path.toArray(), o = {
                        prefixPath: s.slice(0, s.length - 2),
                        collectionGroup: s[s.length - 2],
                        documentId: s[s.length - 1],
                        readTime: n.readTime || [
                            0,
                            0
                        ],
                        unknownDocument: n.unknownDocument,
                        noDocument: n.noDocument,
                        document: n.document,
                        hasCommittedMutations: !!n.hasCommittedMutations
                    };
                    r.push(i.put(o));
                }).next(function() {
                    return PersistencePromise.waitFor(r);
                });
            }
        },
        {
            key: "si",
            value: function si(e, t) {
                var _this = this;
                var n = t.store("mutations"), r = __PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new __PRIVATE_MemoryPersistence(__PRIVATE_MemoryEagerDelegate.Hr, this.serializer.ct);
                return n.U().next(function(e) {
                    var n = new Map;
                    return e.forEach(function(e) {
                        var _$t;
                        var r = null !== (_$t = n.get(e.userId)) && void 0 !== _$t ? _$t : __PRIVATE_documentKeySet();
                        __PRIVATE_fromDbMutationBatch(_this.serializer, e).keys().forEach(function(e) {
                            return r = r.add(e);
                        }), n.set(e.userId, r);
                    }), PersistencePromise.forEach(n, function(e, n) {
                        var s = new User(n), o = __PRIVATE_IndexedDbDocumentOverlayCache.lt(_this.serializer, s), _ = i.getIndexManager(s), a = __PRIVATE_IndexedDbMutationQueue.lt(s, _this.serializer, _, i.referenceDelegate);
                        return new LocalDocumentsView(r, a, o, _).recalculateAndSaveOverlaysForDocumentKeys(new __PRIVATE_IndexedDbTransaction(t, __PRIVATE_ListenSequence.oe), e).next();
                    });
                });
            }
        }
    ]);
    return __PRIVATE_SchemaConverter;
}();
function __PRIVATE_createQueryCache(e) {
    e.createObjectStore("targetDocuments", {
        keyPath: q
    }).createIndex("documentTargetsIndex", Q, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore("targets", {
        keyPath: "targetId"
    }).createIndex("queryTargetsIndex", k, {
        unique: !0
    }), e.createObjectStore("targetGlobal");
}
var Re = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ var __PRIVATE_IndexedDbPersistence = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbPersistence(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, s, o, _, a, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ u) {
        var c = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : 16;
        (0, $19mwo._)(this, __PRIVATE_IndexedDbPersistence);
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this.oi = i, this.window = s, this.document = o, this._i = a, this.ai = u, this.ui = c, this.kr = null, this.qr = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.ci = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.li = null, /** The client metadata refresh task. */ this.hi = null, /** The last time we garbage collected the client metadata object store. */ this.Pi = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.Ii = function(e) {
            return Promise.resolve();
        }, !__PRIVATE_IndexedDbPersistence.D()) throw new FirestoreError(C.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new __PRIVATE_IndexedDbLruDelegateImpl(this, r), this.Ti = t + "main", this.serializer = new __PRIVATE_LocalSerializer(_), this.Ei = new __PRIVATE_SimpleDb(this.Ti, this.ui, new __PRIVATE_SchemaConverter(this.serializer)), this.Qr = new __PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = __PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.$r = new __PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.di = this.window.localStorage : (this.di = null, !1 === u && __PRIVATE_logError("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    (0, $6rpfc._)(__PRIVATE_IndexedDbPersistence, [
        {
            /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ key: "start",
            value: function start() {
                var _this = this;
                // NOTE: This is expected to fail sometimes (in the case of another tab
                // already having the persistence lock), so it's the first thing we should
                // do.
                return this.Ai().then(function() {
                    if (!_this.isPrimary && !_this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
                    // obtain the primary lease.
                    throw new FirestoreError(C.FAILED_PRECONDITION, Re);
                    return _this.Ri(), _this.Vi(), _this.mi(), _this.runTransaction("getHighestListenSequenceNumber", "readonly", function(e) {
                        return _this.Qr.getHighestSequenceNumber(e);
                    });
                }).then(function(e) {
                    _this.kr = new __PRIVATE_ListenSequence(e, _this._i);
                }).then(function() {
                    _this.qr = !0;
                }).catch(function(e) {
                    return _this.Ei && _this.Ei.close(), Promise.reject(e);
                });
            }
        },
        {
            /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ key: "fi",
            value: function fi(e) {
                var _this = this;
                return this.Ii = function() {
                    var _ref = (0, $9OZ9j._)(function(t) {
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            if (_this.started) return [
                                2,
                                e(t)
                            ];
                            return [
                                2
                            ];
                        });
                    });
                    return function(t) {
                        return _ref.apply(this, arguments);
                    };
                }(), e(this.isPrimary);
            }
        },
        {
            /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ key: "setDatabaseDeletedListener",
            value: function setDatabaseDeletedListener(e) {
                this.Ei.L(function() {
                    var _ref = (0, $9OZ9j._)(function(t) {
                        var _tmp;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    // Check if an attempt is made to delete IndexedDB.
                                    _tmp = null === t.newVersion;
                                    if (!_tmp) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        e()
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    _tmp;
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(t) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ key: "setNetworkEnabled",
            value: function setNetworkEnabled(e) {
                var _this = this;
                this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
                // lease update will be propagated via `primaryStateListener`.
                this.oi.enqueueAndForget(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                    var _tmp;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.started;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.Ai()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })));
            }
        },
        {
            /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ key: "Ai",
            value: function Ai() {
                var _this = this;
                return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", function(e) {
                    return __PRIVATE_clientMetadataStore(e).put({
                        clientId: _this.clientId,
                        updateTimeMs: Date.now(),
                        networkEnabled: _this.networkEnabled,
                        inForeground: _this.inForeground
                    }).next(function() {
                        if (_this.isPrimary) return _this.gi(e).next(function(e) {
                            e || (_this.isPrimary = !1, _this.oi.enqueueRetryable(function() {
                                return _this.Ii(!1);
                            }));
                        });
                    }).next(function() {
                        return _this.pi(e);
                    }).next(function(t) {
                        return _this.isPrimary && !t ? _this.yi(e).next(function() {
                            return !1;
                        }) : !!t && _this.wi(e).next(function() {
                            return !0;
                        });
                    });
                }).catch(function(e) {
                    if (__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
                    // IndexedDB will verify the lease.
                    return __PRIVATE_logDebug("IndexedDbPersistence", "Failed to extend owner lease: ", e), _this.isPrimary;
                    if (!_this.allowTabSynchronization) throw e;
                    return __PRIVATE_logDebug("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
                }).then(function(e) {
                    _this.isPrimary !== e && _this.oi.enqueueRetryable(function() {
                        return _this.Ii(e);
                    }), _this.isPrimary = e;
                });
            }
        },
        {
            key: "gi",
            value: function gi(e) {
                var _this = this;
                return __PRIVATE_primaryClientStore(e).get("owner").next(function(e) {
                    return PersistencePromise.resolve(_this.Si(e));
                });
            }
        },
        {
            key: "bi",
            value: function bi(e) {
                return __PRIVATE_clientMetadataStore(e).delete(this.clientId);
            }
        },
        {
            key: "Di",
            value: /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ function Di() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.isPrimary && !_this.Ci(_this.Pi, 18e5))) return [
                                    3,
                                    2
                                ];
                                _this.Pi = Date.now();
                                return [
                                    4,
                                    _this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", function(e) {
                                        var t = __PRIVATE_getStore(e, "clientMetadata");
                                        return t.U().next(function(e) {
                                            var n = _this.vi(e, 18e5), r = e.filter(function(e) {
                                                return -1 === n.indexOf(e);
                                            });
                                            // Delete metadata for clients that are no longer considered active.
                                            return PersistencePromise.forEach(r, function(e) {
                                                return t.delete(e.clientId);
                                            }).next(function() {
                                                return r;
                                            });
                                        });
                                    }).catch(function() {
                                        return [];
                                    })
                                ];
                            case 1:
                                e = _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                // Delete potential leftover entries that may continue to mark the
                                // inactive clients as zombied in LocalStorage.
                                // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
                                // the client atomically, but we can't. So we opt to delete the IndexedDb
                                // entries first to avoid potentially reviving a zombied client.
                                if (_this.di) try {
                                    for(_iterator = e[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        t = _step.value;
                                        _this.di.removeItem(_this.Fi(t.clientId));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ key: "mi",
            value: function mi() {
                var _this = this;
                this.hi = this.oi.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, function() {
                    return _this.Ai().then(function() {
                        return _this.Di();
                    }).then(function() {
                        return _this.mi();
                    });
                });
            }
        },
        {
            /** Checks whether `client` is the local client. */ key: "Si",
            value: function Si(e) {
                return !!e && e.ownerId === this.clientId;
            }
        },
        {
            /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ key: "pi",
            value: function pi(e) {
                var _this = this;
                if (this.ai) return PersistencePromise.resolve(!0);
                return __PRIVATE_primaryClientStore(e).get("owner").next(function(t) {
                    // A client is eligible for the primary lease if:
                    // - its network is enabled and the client's tab is in the foreground.
                    // - its network is enabled and no other client's tab is in the
                    //   foreground.
                    // - every clients network is disabled and the client's tab is in the
                    //   foreground.
                    // - every clients network is disabled and no other client's tab is in
                    //   the foreground.
                    // - the `forceOwningTab` setting was passed in.
                    if (null !== t && _this.Ci(t.leaseTimestampMs, 5e3) && !_this.Mi(t.ownerId)) {
                        if (_this.Si(t) && _this.networkEnabled) return !0;
                        if (!_this.Si(t)) {
                            if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                            // not opted into multi-tab synchronization. If this happens at
                            // client startup, we reject the Promise returned by
                            // `enablePersistence()` and the user can continue to use Firestore
                            // with in-memory persistence.
                            // If this fails during a lease refresh, we will instead block the
                            // AsyncQueue from executing further operations. Note that this is
                            // acceptable since mixing & matching different `synchronizeTabs`
                            // settings is not supported.
                            // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                            // no longer be turned off.
                            throw new FirestoreError(C.FAILED_PRECONDITION, Re);
                            return !1;
                        }
                    }
                    return !(!_this.networkEnabled || !_this.inForeground) || __PRIVATE_clientMetadataStore(e).U().next(function(e) {
                        return void 0 === _this.vi(e, 5e3).find(function(e) {
                            if (_this.clientId !== e.clientId) {
                                var _$t = !_this.networkEnabled && e.networkEnabled, n = !_this.inForeground && e.inForeground, r = _this.networkEnabled === e.networkEnabled;
                                if (_$t || n && r) return !0;
                            }
                            return !1;
                        });
                    });
                }).next(function(e) {
                    return _this.isPrimary !== e && __PRIVATE_logDebug("IndexedDbPersistence", "Client ".concat(e ? "is" : "is not", " eligible for a primary lease.")), e;
                });
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // The shutdown() operations are idempotent and can be called even when
                                // start() aborted (e.g. because it couldn't acquire the persistence lease).
                                _this.qr = !1, _this.xi(), _this.hi && (_this.hi.cancel(), _this.hi = null), _this.Oi(), _this.Ni();
                                // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
                                // has obtained the primary lease.
                                return [
                                    4,
                                    _this.Ei.runTransaction("shutdown", "readwrite", [
                                        "owner",
                                        "clientMetadata"
                                    ], function(e) {
                                        var t = new __PRIVATE_IndexedDbTransaction(e, __PRIVATE_ListenSequence.oe);
                                        return _this.yi(t).next(function() {
                                            return _this.bi(t);
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent(), _this.Ei.close(), // Remove the entry marking the client as zombied from LocalStorage since
                                // we successfully deleted its metadata from IndexedDb.
                                _this.Li();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ key: "vi",
            value: function vi(e, t) {
                var _this = this;
                return e.filter(function(e) {
                    return _this.Ci(e.updateTimeMs, t) && !_this.Mi(e.clientId);
                });
            }
        },
        {
            /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ key: "Bi",
            value: function Bi() {
                var _this = this;
                return this.runTransaction("getActiveClients", "readonly", function(e) {
                    return __PRIVATE_clientMetadataStore(e).U().next(function(e) {
                        return _this.vi(e, 18e5).map(function(e) {
                            return e.clientId;
                        });
                    });
                });
            }
        },
        {
            key: "started",
            get: function get() {
                return this.qr;
            }
        },
        {
            key: "getMutationQueue",
            value: function getMutationQueue(e, t) {
                return __PRIVATE_IndexedDbMutationQueue.lt(e, this.serializer, t, this.referenceDelegate);
            }
        },
        {
            key: "getTargetCache",
            value: function getTargetCache() {
                return this.Qr;
            }
        },
        {
            key: "getRemoteDocumentCache",
            value: function getRemoteDocumentCache() {
                return this.remoteDocumentCache;
            }
        },
        {
            key: "getIndexManager",
            value: function getIndexManager(e) {
                return new __PRIVATE_IndexedDbIndexManager(e, this.serializer.ct.databaseId);
            }
        },
        {
            key: "getDocumentOverlayCache",
            value: function getDocumentOverlayCache(e) {
                return __PRIVATE_IndexedDbDocumentOverlayCache.lt(this.serializer, e);
            }
        },
        {
            key: "getBundleCache",
            value: function getBundleCache() {
                return this.$r;
            }
        },
        {
            key: "runTransaction",
            value: function runTransaction(e, t, n) {
                var _this = this;
                __PRIVATE_logDebug("IndexedDbPersistence", "Starting transaction:", e);
                var r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
                    return 16 === e ? te : 15 === e ? ee : 14 === e ? X : 13 === e ? Z : 12 === e ? Y : 11 === e ? J : void fail();
                }(this.ui);
                var s;
                // Do all transactions as readwrite against all object stores, since we
                // are the only reader/writer.
                return this.Ei.runTransaction(e, r, i, function(r) {
                    return s = new __PRIVATE_IndexedDbTransaction(r, _this.kr ? _this.kr.next() : __PRIVATE_ListenSequence.oe), "readwrite-primary" === t ? _this.gi(s).next(function(e) {
                        return !!e || _this.pi(s);
                    }).next(function(t) {
                        if (!t) throw __PRIVATE_logError("Failed to obtain primary lease for action '".concat(e, "'.")), _this.isPrimary = !1, _this.oi.enqueueRetryable(function() {
                            return _this.Ii(!1);
                        }), new FirestoreError(C.FAILED_PRECONDITION, F);
                        return n(s);
                    }).next(function(e) {
                        return _this.wi(s).next(function() {
                            return e;
                        });
                    }) : _this.ki(s).next(function() {
                        return n(s);
                    });
                }).then(function(e) {
                    return s.raiseOnCommittedEvent(), e;
                });
            }
        },
        {
            /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
            // be turned off.
            key: "ki",
            value: function ki(e) {
                var _this = this;
                return __PRIVATE_primaryClientStore(e).get("owner").next(function(e) {
                    if (null !== e && _this.Ci(e.leaseTimestampMs, 5e3) && !_this.Mi(e.ownerId) && !_this.Si(e) && !(_this.ai || _this.allowTabSynchronization && e.allowTabSynchronization)) throw new FirestoreError(C.FAILED_PRECONDITION, Re);
                });
            }
        },
        {
            /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ key: "wi",
            value: function wi(e) {
                var t = {
                    ownerId: this.clientId,
                    allowTabSynchronization: this.allowTabSynchronization,
                    leaseTimestampMs: Date.now()
                };
                return __PRIVATE_primaryClientStore(e).put("owner", t);
            }
        },
        {
            /** Checks the primary lease and removes it if we are the current primary. */ key: "yi",
            value: function yi(e) {
                var _this = this;
                var t = __PRIVATE_primaryClientStore(e);
                return t.get("owner").next(function(e) {
                    return _this.Si(e) ? (__PRIVATE_logDebug("IndexedDbPersistence", "Releasing primary lease."), t.delete("owner")) : PersistencePromise.resolve();
                });
            }
        },
        {
            /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ key: "Ci",
            value: function Ci(e, t) {
                var n = Date.now();
                return !(e < n - t) && (!(e > n) || (__PRIVATE_logError("Detected an update time that is in the future: ".concat(e, " > ").concat(n)), !1));
            }
        },
        {
            key: "Ri",
            value: function Ri() {
                var _this = this;
                null !== this.document && "function" == typeof this.document.addEventListener && (this.li = function() {
                    _this.oi.enqueueAndForget(function() {
                        return _this.inForeground = "visible" === _this.document.visibilityState, _this.Ai();
                    });
                }, this.document.addEventListener("visibilitychange", this.li), this.inForeground = "visible" === this.document.visibilityState);
            }
        },
        {
            key: "Oi",
            value: function Oi() {
                this.li && (this.document.removeEventListener("visibilitychange", this.li), this.li = null);
            }
        },
        {
            /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ key: "Vi",
            value: function Vi() {
                var _this = this;
                var e;
                "function" == typeof (null === (e = this.window) || void 0 === e ? void 0 : e.addEventListener) && (this.ci = function() {
                    // Note: In theory, this should be scheduled on the AsyncQueue since it
                    // accesses internal state. We execute this code directly during shutdown
                    // to make sure it gets a chance to run.
                    _this.xi();
                    var e = /(?:Version|Mobile)\/1[456]/;
                    (0, $gQ5gw.isSafari)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
                    // trigger a bug that prevents Safari from re-opening IndexedDB during
                    // the next page load.
                    // See https://bugs.webkit.org/show_bug.cgi?id=226547
                    _this.oi.enterRestrictedMode(/* purgeExistingTasks= */ !0), _this.oi.enqueueAndForget(function() {
                        return _this.shutdown();
                    });
                }, this.window.addEventListener("pagehide", this.ci));
            }
        },
        {
            key: "Ni",
            value: function Ni() {
                this.ci && (this.window.removeEventListener("pagehide", this.ci), this.ci = null);
            }
        },
        {
            /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ key: "Mi",
            value: function Mi(e) {
                var t;
                try {
                    var n = null !== (null === (t = this.di) || void 0 === t ? void 0 : t.getItem(this.Fi(e)));
                    return __PRIVATE_logDebug("IndexedDbPersistence", "Client '".concat(e, "' ").concat(n ? "is" : "is not", " zombied in LocalStorage")), n;
                } catch (e) {
                    // Gracefully handle if LocalStorage isn't working.
                    return __PRIVATE_logError("IndexedDbPersistence", "Failed to get zombied client id.", e), !1;
                }
            }
        },
        {
            /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ key: "xi",
            value: function xi() {
                if (this.di) try {
                    this.di.setItem(this.Fi(this.clientId), String(Date.now()));
                } catch (e) {
                    // Gracefully handle if LocalStorage isn't available / working.
                    __PRIVATE_logError("Failed to set zombie client id.", e);
                }
            }
        },
        {
            /** Removes the zombied client entry if it exists. */ key: "Li",
            value: function Li() {
                if (this.di) try {
                    this.di.removeItem(this.Fi(this.clientId));
                } catch (e) {
                // Ignore
                }
            }
        },
        {
            key: "Fi",
            value: function Fi(e) {
                return "firestore_zombie_".concat(this.persistenceKey, "_").concat(e);
            }
        }
    ], [
        {
            key: "D",
            value: function D() {
                return __PRIVATE_SimpleDb.D();
            }
        }
    ]);
    return __PRIVATE_IndexedDbPersistence;
}();
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function __PRIVATE_primaryClientStore(e) {
    return __PRIVATE_getStore(e, "owner");
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function __PRIVATE_clientMetadataStore(e) {
    return __PRIVATE_getStore(e, "clientMetadata");
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function __PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    var n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ var __PRIVATE_LocalViewChanges = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_LocalViewChanges(e, t, n, r) {
        (0, $19mwo._)(this, __PRIVATE_LocalViewChanges);
        this.targetId = e, this.fromCache = t, this.qi = n, this.Qi = r;
    }
    (0, $6rpfc._)(__PRIVATE_LocalViewChanges, null, [
        {
            key: "Ki",
            value: function Ki(e, t) {
                var n = __PRIVATE_documentKeySet(), r = __PRIVATE_documentKeySet();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t.docChanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        switch(_$e.type){
                            case 0 /* ChangeType.Added */ :
                                n = n.add(_$e.doc.key);
                                break;
                            case 1 /* ChangeType.Removed */ :
                                r = r.add(_$e.doc.key);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new __PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
            }
        }
    ]);
    return __PRIVATE_LocalViewChanges;
}();
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ var QueryContext = /*#__PURE__*/ function() {
    "use strict";
    function QueryContext() {
        (0, $19mwo._)(this, QueryContext);
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    (0, $6rpfc._)(QueryContext, [
        {
            key: "documentReadCount",
            get: function get() {
                return this._documentReadCount;
            }
        },
        {
            key: "incrementDocumentReadCount",
            value: function incrementDocumentReadCount(e) {
                this._documentReadCount += e;
            }
        }
    ]);
    return QueryContext;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ var __PRIVATE_QueryEngine = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_QueryEngine() {
        (0, $19mwo._)(this, __PRIVATE_QueryEngine);
        this.$i = !1, this.Ui = !1, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.Wi = 100, this.Gi = /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */ function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0, $gQ5gw.isSafari)() ? 8 : __PRIVATE_getAndroidVersion((0, $gQ5gw.getUA)()) > 0 ? 6 : 4;
        }();
    }
    (0, $6rpfc._)(__PRIVATE_QueryEngine, [
        {
            /** Sets the document view to query against. */ key: "initialize",
            value: function initialize(e, t) {
                this.zi = e, this.indexManager = t, this.$i = !0;
            }
        },
        {
            /** Returns all local documents matching the specified query. */ key: "getDocumentsMatchingQuery",
            value: function getDocumentsMatchingQuery(e, t, n, r) {
                var _this = this;
                // Stores the result from executing the query; using this object is more
                // convenient than passing the result between steps of the persistence
                // transaction and improves readability comparatively.
                var i = {
                    result: null
                };
                return this.ji(e, t).next(function(e) {
                    i.result = e;
                }).next(function() {
                    if (!i.result) return _this.Hi(e, t, r, n).next(function(e) {
                        i.result = e;
                    });
                }).next(function() {
                    if (i.result) return;
                    var n = new QueryContext;
                    return _this.Ji(e, t, n).next(function(r) {
                        if (i.result = r, _this.Ui) return _this.Yi(e, t, n, r.size);
                    });
                }).next(function() {
                    return i.result;
                });
            }
        },
        {
            key: "Yi",
            value: function Yi(e, t, n, r) {
                return n.documentReadCount < this.Wi ? (__PRIVATE_getLogLevel() <= (0, $3DJ6n.LogLevel).DEBUG && __PRIVATE_logDebug("QueryEngine", "SDK will not create cache indexes for query:", __PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.Wi, "documents"), PersistencePromise.resolve()) : (__PRIVATE_getLogLevel() <= (0, $3DJ6n.LogLevel).DEBUG && __PRIVATE_logDebug("QueryEngine", "Query:", __PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.Gi * r ? (__PRIVATE_getLogLevel() <= (0, $3DJ6n.LogLevel).DEBUG && __PRIVATE_logDebug("QueryEngine", "The SDK decides to create cache indexes for query:", __PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, __PRIVATE_queryToTarget(t))) : PersistencePromise.resolve());
            }
        },
        {
            /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ key: "ji",
            value: function ji(e, t) {
                var _this = this;
                if (__PRIVATE_queryMatchesAllDocuments(t)) // Queries that match all documents don't benefit from using
                // key-based lookups. It is more efficient to scan all documents in a
                // collection, rather than to perform individual lookups.
                return PersistencePromise.resolve(null);
                var n = __PRIVATE_queryToTarget(t);
                return this.indexManager.getIndexType(e, n).next(function(r) {
                    return 0 /* IndexType.NONE */  === r ? null : (null !== t.limit && 1 /* IndexType.PARTIAL */  === r && // We cannot apply a limit for targets that are served using a partial
                    // index. If a partial index will be used to serve the target, the
                    // query may return a superset of documents that match the target
                    // (e.g. if the index doesn't include all the target's filters), or
                    // may return the correct set of documents in the wrong order (e.g. if
                    // the index doesn't include a segment for one of the orderBys).
                    // Therefore, a limit should not be applied in such cases.
                    (t = __PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ ), n = __PRIVATE_queryToTarget(t)), _this.indexManager.getDocumentsMatchingTarget(e, n).next(function(r) {
                        var i = __PRIVATE_documentKeySet.apply(void 0, (0, $3jzhD._)(r));
                        return _this.zi.getDocuments(e, i).next(function(r) {
                            return _this.indexManager.getMinOffset(e, n).next(function(n) {
                                var s = _this.Zi(t, r);
                                return _this.Xi(t, s, i, n.readTime) ? _this.ji(e, __PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ )) : _this.es(e, s, t, n);
                            });
                        });
                    }));
                });
            }
        },
        {
            /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ key: "Hi",
            value: function Hi(e, t, n, r) {
                var _this = this;
                return __PRIVATE_queryMatchesAllDocuments(t) || r.isEqual(SnapshotVersion.min()) ? PersistencePromise.resolve(null) : this.zi.getDocuments(e, n).next(function(i) {
                    var s = _this.Zi(t, i);
                    return _this.Xi(t, s, n, r) ? PersistencePromise.resolve(null) : (__PRIVATE_getLogLevel() <= (0, $3DJ6n.LogLevel).DEBUG && __PRIVATE_logDebug("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), __PRIVATE_stringifyQuery(t)), _this.es(e, s, t, __PRIVATE_newIndexOffsetSuccessorFromReadTime(r, -1)).next(function(e) {
                        return e;
                    }));
                });
            // Queries that have never seen a snapshot without limbo free documents
            // should also be run as a full collection scan.
            }
        },
        {
            /** Applies the query filter and sorting to the provided documents.  */ key: "Zi",
            value: function Zi(e, t) {
                // Sort the documents and re-apply the query filter since previously
                // matching documents do not necessarily still match the query.
                var n = new SortedSet(__PRIVATE_newQueryComparator(e));
                return t.forEach(function(t, r) {
                    __PRIVATE_queryMatches(e, r) && (n = n.add(r));
                }), n;
            }
        },
        {
            /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ key: "Xi",
            value: function Xi(e, t, n, r) {
                if (null === e.limit) // Queries without limits do not need to be refilled.
                return !1;
                if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
                // longer matches.
                return !0;
                // Limit queries are not eligible for index-free query execution if there is
                // a potential that an older document from cache now sorts before a document
                // that was previously part of the limit. This, however, can only happen if
                // the document at the edge of the limit goes out of limit.
                // If a document that is not the limit boundary sorts differently,
                // the boundary of the limit itself did not change and documents from cache
                // will continue to be "rejected" by this boundary. Therefore, we can ignore
                // any modifications that don't affect the last document.
                var i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
                return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
            }
        },
        {
            key: "Ji",
            value: function Ji(e, t, n) {
                return __PRIVATE_getLogLevel() <= (0, $3DJ6n.LogLevel).DEBUG && __PRIVATE_logDebug("QueryEngine", "Using full collection scan to execute query:", __PRIVATE_stringifyQuery(t)), this.zi.getDocumentsMatchingQuery(e, t, IndexOffset.min(), n);
            }
        },
        {
            /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ key: "es",
            value: function es(e, t, n, r) {
                // Retrieve all results for documents that were updated since the offset.
                return this.zi.getDocumentsMatchingQuery(e, n, r).next(function(e) {
                    return(// Merge with existing results
                    t.forEach(function(t) {
                        e = e.insert(t.key, t);
                    }), e);
                });
            }
        }
    ]);
    return __PRIVATE_QueryEngine;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ var __PRIVATE_LocalStoreImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_LocalStoreImpl(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
        (0, $19mwo._)(this, __PRIVATE_LocalStoreImpl);
        this.persistence = e, this.ts = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.ns = new SortedMap(__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.rs = new ObjectMap(function(e) {
            return __PRIVATE_canonifyTarget(e);
        }, __PRIVATE_targetEquals), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.ss = new Map, this.os = e.getRemoteDocumentCache(), this.Qr = e.getTargetCache(), this.$r = e.getBundleCache(), this._s(n);
    }
    (0, $6rpfc._)(__PRIVATE_LocalStoreImpl, [
        {
            key: "_s",
            value: function _s(e) {
                // TODO(indexing): Add spec tests that test these components change after a
                // user change
                this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new LocalDocumentsView(this.os, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.os.setIndexManager(this.indexManager), this.ts.initialize(this.localDocuments, this.indexManager);
            }
        },
        {
            key: "collectGarbage",
            value: function collectGarbage(e) {
                var _this = this;
                return this.persistence.runTransaction("Collect garbage", "readwrite-primary", function(t) {
                    return e.collect(t, _this.ns);
                });
            }
        }
    ]);
    return __PRIVATE_LocalStoreImpl;
}();
function __PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new __PRIVATE_LocalStoreImpl(e, t, n, r);
}
function __PRIVATE_localStoreHandleUserChange(e, t) {
    return ___PRIVATE_localStoreHandleUserChange.apply(this, arguments);
}
function ___PRIVATE_localStoreHandleUserChange() {
    ___PRIVATE_localStoreHandleUserChange = /**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
    // change.
    (0, $9OZ9j._)(function(e, t) {
        var n;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    return [
                        4,
                        n.persistence.runTransaction("Handle user change", "readonly", function(e) {
                            // Swap out the mutation queue, grabbing the pending mutation batches
                            // before and after.
                            var r;
                            return n.mutationQueue.getAllMutationBatches(e).next(function(i) {
                                return r = i, n._s(t), n.mutationQueue.getAllMutationBatches(e);
                            }).next(function(t) {
                                var i = [], s = [];
                                // Union the old/new changed keys.
                                var o = __PRIVATE_documentKeySet();
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$e = _step.value;
                                        i.push(_$e.batchId);
                                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        try {
                                            for(var _iterator1 = _$e.mutations[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                var _$t = _step1.value;
                                                o = o.add(_$t.key);
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                try {
                                    for(var _iterator2 = t[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                        var _$e1 = _step2.value;
                                        s.push(_$e1.batchId);
                                        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                        try {
                                            for(var _iterator3 = _$e1.mutations[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                                var _$t1 = _step3.value;
                                                o = o.add(_$t1.key);
                                            }
                                        } catch (err) {
                                            _didIteratorError3 = true;
                                            _iteratorError3 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                                    _iterator3.return();
                                                }
                                            } finally{
                                                if (_didIteratorError3) {
                                                    throw _iteratorError3;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                            _iterator2.return();
                                        }
                                    } finally{
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                                // Return the set of all (potentially) changed documents and the list
                                // of mutation batch IDs that were affected by change.
                                return n.localDocuments.getDocuments(e, o).next(function(e) {
                                    return {
                                        us: e,
                                        removedBatchIds: i,
                                        addedBatchIds: s
                                    };
                                });
                            });
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return ___PRIVATE_localStoreHandleUserChange.apply(this, arguments);
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function __PRIVATE_localStoreAcknowledgeBatch(e, t) {
    var n = __PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", function(e) {
        var r = t.batch.keys(), i = n.os.newChangeBuffer({
            trackRemovals: !0
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            var i = n.batch, s = i.keys();
            var o = PersistencePromise.resolve();
            return s.forEach(function(e) {
                o = o.next(function() {
                    return r.getEntry(t, e);
                }).next(function(t) {
                    var s = n.docVersions.get(e);
                    __PRIVATE_hardAssert(null !== s), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), o.next(function() {
                return e.mutationQueue.removeMutationBatch(t, i);
            });
        })(n, e, t, i).next(function() {
            return i.apply(e);
        }).next(function() {
            return n.mutationQueue.performConsistencyCheck(e);
        }).next(function() {
            return n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId);
        }).next(function() {
            return n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                var _$t = __PRIVATE_documentKeySet();
                for(var n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (_$t = _$t.add(e.batch.mutations[n].key));
                return _$t;
            }(t));
        }).next(function() {
            return n.localDocuments.getDocuments(e, r);
        });
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    var t = __PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", function(e) {
        return t.Qr.getLastRemoteSnapshotVersion(e);
    });
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function __PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    var n = __PRIVATE_debugCast(e), r = t.snapshotVersion;
    var i = n.ns;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", function(e) {
        var s = n.os.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.ns;
        var o = [];
        t.targetChanges.forEach(function(s, _) {
            var a = i.get(_);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.Qr.removeMatchingKeys(e, s.removedDocuments, _).next(function() {
                return n.Qr.addMatchingKeys(e, s.addedDocuments, _);
            }));
            var u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(_) ? u = u.withResumeToken(ByteString.EMPTY_BYTE_STRING, SnapshotVersion.min()).withLastLimboFreeSnapshotVersion(SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(_, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                if (t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds() >= 3e8) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                return n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0;
            }(a, u, s) && o.push(n.Qr.updateTargetData(e, u));
        });
        var _ = __PRIVATE_mutableDocumentMap(), a = __PRIVATE_documentKeySet();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach(function(r) {
            t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push(__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next(function(e) {
            _ = e.cs, a = e.ls;
        })), !r.isEqual(SnapshotVersion.min())) {
            var _$t = n.Qr.getLastRemoteSnapshotVersion(e).next(function(t) {
                return n.Qr.setTargetsMetadata(e, e.currentSequenceNumber, r);
            });
            o.push(_$t);
        }
        return PersistencePromise.waitFor(o).next(function() {
            return s.apply(e);
        }).next(function() {
            return n.localDocuments.getLocalViewOfDocuments(e, _, a);
        }).next(function() {
            return _;
        });
    }).then(function(e) {
        return n.ns = i, e;
    });
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function __PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    var r = __PRIVATE_documentKeySet(), i = __PRIVATE_documentKeySet();
    return n.forEach(function(e) {
        return r = r.add(e);
    }), t.getEntries(e, r).next(function(e) {
        var r = __PRIVATE_mutableDocumentMap();
        return n.forEach(function(n, s) {
            var o = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual(SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !o.isValidDocument() || s.version.compareTo(o.version) > 0 || 0 === s.version.compareTo(o.version) && o.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : __PRIVATE_logDebug("LocalStore", "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", s.version);
        }), {
            cs: r,
            ls: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function __PRIVATE_localStoreGetNextMutationBatch(e, t) {
    var n = __PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", function(e) {
        return void 0 === t && (t = -1), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t);
    });
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function __PRIVATE_localStoreAllocateTarget(e, t) {
    var n = __PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", function(e) {
        var r;
        return n.Qr.getTargetData(e, t).next(function(i) {
            return i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, PersistencePromise.resolve(r)) : n.Qr.allocateTargetId(e).next(function(i) {
                return r = new TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.Qr.addTargetData(e, r).next(function() {
                    return r;
                });
            });
        });
    }).then(function(e) {
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        var r = n.ns.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.ns = n.ns.insert(e.targetId, e), n.rs.set(t, e.targetId)), e;
    });
}
function __PRIVATE_localStoreReleaseTarget(e, t, n) {
    return ___PRIVATE_localStoreReleaseTarget.apply(this, arguments);
}
function ___PRIVATE_localStoreReleaseTarget() {
    ___PRIVATE_localStoreReleaseTarget = /**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
    /**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
    (0, $9OZ9j._)(function(e, t, n) {
        var r, i, s, _tmp, e1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_debugCast(e), i = r.ns.get(t), s = n ? "readwrite" : "readwrite-primary";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp = n;
                    if (_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        r.persistence.runTransaction("Release target", s, function(e) {
                            return r.persistence.referenceDelegate.removeTarget(e, i);
                        })
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    _tmp;
                    return [
                        3,
                        5
                    ];
                case 4:
                    e1 = _state.sent();
                    if (!__PRIVATE_isIndexedDbTransactionError(e1)) throw e1;
                    // All `releaseTarget` does is record the final metadata state for the
                    // target, but we've been recording this periodically during target
                    // activity. If we lose this write this could cause a very slight
                    // difference in the order of target deletion during GC, but we
                    // don't define exact LRU semantics so this is acceptable.
                    __PRIVATE_logDebug("LocalStore", "Failed to update sequence numbers for target ".concat(t, ": ").concat(e1));
                    return [
                        3,
                        5
                    ];
                case 5:
                    r.ns = r.ns.remove(t), r.rs.delete(i.target);
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_localStoreReleaseTarget.apply(this, arguments);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function __PRIVATE_localStoreExecuteQuery(e, t, n) {
    var r = __PRIVATE_debugCast(e);
    var i = SnapshotVersion.min(), s = __PRIVATE_documentKeySet();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    function(e) {
        return (function __PRIVATE_localStoreGetTargetData(e, t, n) {
            var r = __PRIVATE_debugCast(e), i = r.rs.get(n);
            return void 0 !== i ? PersistencePromise.resolve(r.ns.get(i)) : r.Qr.getTargetData(t, n);
        })(r, e, __PRIVATE_queryToTarget(t)).next(function(t) {
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.Qr.getMatchingKeysForTargetId(e, t.targetId).next(function(e) {
                s = e;
            });
        }).next(function() {
            return r.ts.getDocumentsMatchingQuery(e, t, n ? i : SnapshotVersion.min(), n ? s : __PRIVATE_documentKeySet());
        }).next(function(e) {
            return __PRIVATE_setMaxReadTime(r, __PRIVATE_queryCollectionGroup(t), e), {
                documents: e,
                hs: s
            };
        });
    });
}
// PORTING NOTE: Multi-Tab only.
function __PRIVATE_localStoreGetCachedTarget(e, t) {
    var n = __PRIVATE_debugCast(e), r = __PRIVATE_debugCast(n.Qr), i = n.ns.get(t);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", function(e) {
        return r.ot(e, t).next(function(e) {
            return e ? e.target : null;
        });
    });
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    var n = __PRIVATE_debugCast(e), r = n.ss.get(t) || SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", function(e) {
        return n.os.getAllFromCollectionGroup(e, t, __PRIVATE_newIndexOffsetSuccessorFromReadTime(r, -1), /* limit= */ Number.MAX_SAFE_INTEGER);
    }).then(function(e) {
        return __PRIVATE_setMaxReadTime(n, t, e), e;
    });
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_setMaxReadTime(e, t, n) {
    var r = e.ss.get(t) || SnapshotVersion.min();
    n.forEach(function(e, t) {
        t.readTime.compareTo(r) > 0 && (r = t.readTime);
    }), e.ss.set(t, r);
}
function __PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    return ___PRIVATE_localStoreApplyBundledDocuments.apply(this, arguments);
}
function ___PRIVATE_localStoreApplyBundledDocuments() {
    ___PRIVATE_localStoreApplyBundledDocuments = /**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ (0, $9OZ9j._)(function(e, t, n, r) {
        var i, s, o, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e, _$n, _$r, _, a;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = __PRIVATE_debugCast(e);
                    s = __PRIVATE_documentKeySet(), o = __PRIVATE_mutableDocumentMap();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = n[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _$e = _step.value;
                            _$n = t.Ps(_$e.metadata.name);
                            _$e.document && (s = s.add(_$n));
                            _$r = t.Is(_$e);
                            _$r.setReadTime(t.Ts(_$e.metadata.readTime)), o = o.insert(_$n, _$r);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    _ = i.os.newChangeBuffer({
                        trackRemovals: !0
                    });
                    return [
                        4,
                        __PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
                            // It is OK that the path used for the query is not valid, because this will
                            // not be read and queried.
                            return __PRIVATE_queryToTarget(__PRIVATE_newQueryForPath(ResourcePath.fromString("__bundle__/docs/".concat(e))));
                        }(r))
                    ];
                case 1:
                    a = _state.sent();
                    // Allocates a target to hold all document keys from the bundle, such that
                    // they will not get garbage collected right away.
                    return [
                        2,
                        i.persistence.runTransaction("Apply bundle documents", "readwrite", function(e) {
                            return __PRIVATE_populateDocumentChangeBuffer(e, _, o).next(function(t) {
                                return _.apply(e), t;
                            }).next(function(t) {
                                return i.Qr.removeMatchingKeysForTargetId(e, a.targetId).next(function() {
                                    return i.Qr.addMatchingKeys(e, s, a.targetId);
                                }).next(function() {
                                    return i.localDocuments.getLocalViewOfDocuments(e, t.cs, t.ls);
                                }).next(function() {
                                    return t.cs;
                                });
                            });
                        })
                    ];
            }
        });
    });
    return ___PRIVATE_localStoreApplyBundledDocuments.apply(this, arguments);
}
function __PRIVATE_localStoreSaveNamedQuery(e, t) {
    return ___PRIVATE_localStoreSaveNamedQuery.apply(this, arguments);
}
function ___PRIVATE_localStoreSaveNamedQuery() {
    ___PRIVATE_localStoreSaveNamedQuery = /**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ (0, $9OZ9j._)(function(e, t) {
        var n, r, i;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : __PRIVATE_documentKeySet();
                    return [
                        4,
                        __PRIVATE_localStoreAllocateTarget(e, __PRIVATE_queryToTarget(__PRIVATE_fromBundledQuery(t.bundledQuery)))
                    ];
                case 1:
                    r = _state.sent(), i = __PRIVATE_debugCast(e);
                    return [
                        2,
                        i.persistence.runTransaction("Save named query", "readwrite", function(e) {
                            var s = __PRIVATE_fromVersion(t.readTime);
                            // Simply save the query itself if it is older than what the SDK already
                            // has.
                            if (r.snapshotVersion.compareTo(s) >= 0) return i.$r.saveNamedQuery(e, t);
                            // Update existing target data because the query from the bundle is newer.
                            var o = r.withResumeToken(ByteString.EMPTY_BYTE_STRING, s);
                            return i.ns = i.ns.insert(o.targetId, o), i.Qr.updateTargetData(e, o).next(function() {
                                return i.Qr.removeMatchingKeysForTargetId(e, r.targetId);
                            }).next(function() {
                                return i.Qr.addMatchingKeys(e, n, r.targetId);
                            }).next(function() {
                                return i.$r.saveNamedQuery(e, t);
                            });
                        })
                    ];
            }
        });
    });
    return ___PRIVATE_localStoreSaveNamedQuery.apply(this, arguments);
}
/** Assembles the key for a client state in WebStorage */ function createWebStorageClientStateKey(e, t) {
    return "firestore_clients_".concat(e, "_").concat(t);
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
/** Assembles the key for a mutation batch in WebStorage */ function createWebStorageMutationBatchKey(e, t, n) {
    var r = "firestore_mutations_".concat(e, "_").concat(n);
    return t.isAuthenticated() && (r += "_".concat(t.uid)), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
/** Assembles the key for a query state in WebStorage */ function createWebStorageQueryTargetMetadataKey(e, t) {
    return "firestore_targets_".concat(e, "_").concat(t);
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
var __PRIVATE_MutationMetadata = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MutationMetadata(e, t, n, r) {
        (0, $19mwo._)(this, __PRIVATE_MutationMetadata);
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    (0, $6rpfc._)(__PRIVATE_MutationMetadata, [
        {
            key: "ds",
            value: function ds() {
                var e = {
                    state: this.state,
                    updateTimeMs: Date.now()
                };
                return this.error && (e.error = {
                    code: this.error.code,
                    message: this.error.message
                }), JSON.stringify(e);
            }
        }
    ], [
        {
            key: "Es",
            value: /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ function Es(e, t, n) {
                var r = JSON.parse(n);
                var i, s = "object" == typeof r && -1 !== [
                    "pending",
                    "acknowledged",
                    "rejected"
                ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
                return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new FirestoreError(r.error.code, r.error.message))), s ? new __PRIVATE_MutationMetadata(e, t, r.state, i) : (__PRIVATE_logError("SharedClientState", "Failed to parse mutation state for ID '".concat(t, "': ").concat(n)), null);
            }
        }
    ]);
    return __PRIVATE_MutationMetadata;
}();
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
var __PRIVATE_QueryTargetMetadata = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_QueryTargetMetadata(e, t, n) {
        (0, $19mwo._)(this, __PRIVATE_QueryTargetMetadata);
        this.targetId = e, this.state = t, this.error = n;
    }
    (0, $6rpfc._)(__PRIVATE_QueryTargetMetadata, [
        {
            key: "ds",
            value: function ds() {
                var e = {
                    state: this.state,
                    updateTimeMs: Date.now()
                };
                return this.error && (e.error = {
                    code: this.error.code,
                    message: this.error.message
                }), JSON.stringify(e);
            }
        }
    ], [
        {
            key: "Es",
            value: /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ function Es(e, t) {
                var n = JSON.parse(t);
                var r, i = "object" == typeof n && -1 !== [
                    "not-current",
                    "current",
                    "rejected"
                ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
                return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new FirestoreError(n.error.code, n.error.message))), i ? new __PRIVATE_QueryTargetMetadata(e, n.state, r) : (__PRIVATE_logError("SharedClientState", "Failed to parse target state for ID '".concat(e, "': ").concat(t)), null);
            }
        }
    ]);
    return __PRIVATE_QueryTargetMetadata;
}();
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ var __PRIVATE_RemoteClientState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_RemoteClientState(e, t) {
        (0, $19mwo._)(this, __PRIVATE_RemoteClientState);
        this.clientId = e, this.activeTargetIds = t;
    }
    (0, $6rpfc._)(__PRIVATE_RemoteClientState, null, [
        {
            key: "Es",
            value: /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ function Es(e, t) {
                var n = JSON.parse(t);
                var r = "object" == typeof n && n.activeTargetIds instanceof Array, i = __PRIVATE_targetIdSet();
                for(var _$e = 0; r && _$e < n.activeTargetIds.length; ++_$e)r = isSafeInteger(n.activeTargetIds[_$e]), i = i.add(n.activeTargetIds[_$e]);
                return r ? new __PRIVATE_RemoteClientState(e, i) : (__PRIVATE_logError("SharedClientState", "Failed to parse client data for instance '".concat(e, "': ").concat(t)), null);
            }
        }
    ]);
    return __PRIVATE_RemoteClientState;
}();
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ var __PRIVATE_SharedOnlineState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SharedOnlineState(e, t) {
        (0, $19mwo._)(this, __PRIVATE_SharedOnlineState);
        this.clientId = e, this.onlineState = t;
    }
    (0, $6rpfc._)(__PRIVATE_SharedOnlineState, null, [
        {
            key: "Es",
            value: /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ function Es(e) {
                var t = JSON.parse(e);
                return "object" == typeof t && -1 !== [
                    "Unknown",
                    "Online",
                    "Offline"
                ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new __PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : (__PRIVATE_logError("SharedClientState", "Failed to parse online state: ".concat(e)), null);
            }
        }
    ]);
    return __PRIVATE_SharedOnlineState;
}();
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
var __PRIVATE_LocalClientState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_LocalClientState() {
        (0, $19mwo._)(this, __PRIVATE_LocalClientState);
        this.activeTargetIds = __PRIVATE_targetIdSet();
    }
    (0, $6rpfc._)(__PRIVATE_LocalClientState, [
        {
            key: "As",
            value: function As(e) {
                this.activeTargetIds = this.activeTargetIds.add(e);
            }
        },
        {
            key: "Rs",
            value: function Rs(e) {
                this.activeTargetIds = this.activeTargetIds.delete(e);
            }
        },
        {
            /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ key: "ds",
            value: function ds() {
                var e = {
                    activeTargetIds: this.activeTargetIds.toArray(),
                    updateTimeMs: Date.now()
                };
                return JSON.stringify(e);
            }
        }
    ]);
    return __PRIVATE_LocalClientState;
}();
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ var __PRIVATE_WebStorageSharedClientState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_WebStorageSharedClientState(e, t, n, r, i) {
        (0, $19mwo._)(this, __PRIVATE_WebStorageSharedClientState);
        this.window = e, this.oi = t, this.persistenceKey = n, this.Vs = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.fs = this.gs.bind(this), this.ps = new SortedMap(__PRIVATE_primitiveComparator), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.ys = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        var s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.ws = createWebStorageClientStateKey(this.persistenceKey, this.Vs), this.Ss = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return "firestore_sequence_number_".concat(e);
        }(this.persistenceKey), this.ps = this.ps.insert(this.Vs, new __PRIVATE_LocalClientState), this.bs = new RegExp("^firestore_clients_".concat(s, "_([^_]*)$")), this.Ds = new RegExp("^firestore_mutations_".concat(s, "_(\\d+)(?:_(.*))?$")), this.Cs = new RegExp("^firestore_targets_".concat(s, "_(\\d+)$")), this.vs = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return "firestore_online_state_".concat(e);
        }(this.persistenceKey), this.Fs = function createBundleLoadedKey(e) {
            return "firestore_bundle_loaded_v2_".concat(e);
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.fs);
    }
    (0, $6rpfc._)(__PRIVATE_WebStorageSharedClientState, [
        {
            key: "start",
            value: function start() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t, e1, n, t1, e2, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, e3;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.syncEngine.Bi()
                                ];
                            case 1:
                                e = _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = e[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        t = _step.value;
                                        if (t === _this.Vs) continue;
                                        e1 = _this.getItem(createWebStorageClientStateKey(_this.persistenceKey, t));
                                        if (e1) {
                                            n = __PRIVATE_RemoteClientState.Es(t, e1);
                                            n && (_this.ps = _this.ps.insert(n.clientId, n));
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _this.Ms();
                                // Check if there is an existing online state and call the callback handler
                                // if applicable.
                                t1 = _this.storage.getItem(_this.vs);
                                if (t1) {
                                    e2 = _this.xs(t1);
                                    e2 && _this.Os(e2);
                                }
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = _this.ys[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        e3 = _step1.value;
                                        _this.gs(e3);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                _this.ys = [], // Register a window unload hook to remove the client metadata entry from
                                // WebStorage even if `shutdown()` was not called.
                                _this.window.addEventListener("pagehide", function() {
                                    return _this.shutdown();
                                }), _this.started = !0;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "writeSequenceNumber",
            value: function writeSequenceNumber(e) {
                this.setItem(this.Ss, JSON.stringify(e));
            }
        },
        {
            key: "getAllActiveQueryTargets",
            value: function getAllActiveQueryTargets() {
                return this.Ns(this.ps);
            }
        },
        {
            key: "isActiveQueryTarget",
            value: function isActiveQueryTarget(e) {
                var t = !1;
                return this.ps.forEach(function(n, r) {
                    r.activeTargetIds.has(e) && (t = !0);
                }), t;
            }
        },
        {
            key: "addPendingMutation",
            value: function addPendingMutation(e) {
                this.Ls(e, "pending");
            }
        },
        {
            key: "updateMutationState",
            value: function updateMutationState(e, t, n) {
                this.Ls(e, t, n), // Once a final mutation result is observed by other clients, they no longer
                // access the mutation's metadata entry. Since WebStorage replays events
                // in order, it is safe to delete the entry right after updating it.
                this.Bs(e);
            }
        },
        {
            key: "addLocalQueryTarget",
            value: function addLocalQueryTarget(e) {
                var t = "not-current";
                // Lookup an existing query state if the target ID was already registered
                // by another tab
                if (this.isActiveQueryTarget(e)) {
                    var n = this.storage.getItem(createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
                    if (n) {
                        var r = __PRIVATE_QueryTargetMetadata.Es(e, n);
                        r && (t = r.state);
                    }
                }
                return this.ks.As(e), this.Ms(), t;
            }
        },
        {
            key: "removeLocalQueryTarget",
            value: function removeLocalQueryTarget(e) {
                this.ks.Rs(e), this.Ms();
            }
        },
        {
            key: "isLocalQueryTarget",
            value: function isLocalQueryTarget(e) {
                return this.ks.activeTargetIds.has(e);
            }
        },
        {
            key: "clearQueryState",
            value: function clearQueryState(e) {
                this.removeItem(createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            }
        },
        {
            key: "updateQueryState",
            value: function updateQueryState(e, t, n) {
                this.qs(e, t, n);
            }
        },
        {
            key: "handleUserChange",
            value: function handleUserChange(e, t, n) {
                var _this = this;
                t.forEach(function(e) {
                    _this.Bs(e);
                }), this.currentUser = e, n.forEach(function(e) {
                    _this.addPendingMutation(e);
                });
            }
        },
        {
            key: "setOnlineState",
            value: function setOnlineState(e) {
                this.Qs(e);
            }
        },
        {
            key: "notifyBundleLoaded",
            value: function notifyBundleLoaded(e) {
                this.Ks(e);
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                this.started && (this.window.removeEventListener("storage", this.fs), this.removeItem(this.ws), this.started = !1);
            }
        },
        {
            key: "getItem",
            value: function getItem(e) {
                var t = this.storage.getItem(e);
                return __PRIVATE_logDebug("SharedClientState", "READ", e, t), t;
            }
        },
        {
            key: "setItem",
            value: function setItem(e, t) {
                __PRIVATE_logDebug("SharedClientState", "SET", e, t), this.storage.setItem(e, t);
            }
        },
        {
            key: "removeItem",
            value: function removeItem(e) {
                __PRIVATE_logDebug("SharedClientState", "REMOVE", e), this.storage.removeItem(e);
            }
        },
        {
            key: "gs",
            value: function gs(e) {
                // Note: The function is typed to take Event to be interface-compatible with
                // `Window.addEventListener`.
                var t = e;
                if (t.storageArea === this.storage) {
                    if (__PRIVATE_logDebug("SharedClientState", "EVENT", t.key, t.newValue), t.key === this.ws) return void __PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
                    var _this = this;
                    this.oi.enqueueRetryable(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                        var _$e, _$e1, _$e2, _$e3, _$e4, _$e5, _$e6;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!_this.started) return [
                                        3,
                                        8
                                    ];
                                    if (!(null !== t.key)) return [
                                        3,
                                        7
                                    ];
                                    if (!_this.bs.test(t.key)) return [
                                        3,
                                        1
                                    ];
                                    if (null == t.newValue) {
                                        _$e = _this.$s(t.key);
                                        return [
                                            2,
                                            _this.Us(_$e, null)
                                        ];
                                    }
                                    {
                                        _$e1 = _this.Ws(t.key, t.newValue);
                                        if (_$e1) return [
                                            2,
                                            _this.Us(_$e1.clientId, _$e1)
                                        ];
                                    }
                                    return [
                                        3,
                                        7
                                    ];
                                case 1:
                                    if (!_this.Ds.test(t.key)) return [
                                        3,
                                        2
                                    ];
                                    if (null !== t.newValue) {
                                        _$e2 = _this.Gs(t.key, t.newValue);
                                        if (_$e2) return [
                                            2,
                                            _this.zs(_$e2)
                                        ];
                                    }
                                    return [
                                        3,
                                        7
                                    ];
                                case 2:
                                    if (!_this.Cs.test(t.key)) return [
                                        3,
                                        3
                                    ];
                                    if (null !== t.newValue) {
                                        _$e3 = _this.js(t.key, t.newValue);
                                        if (_$e3) return [
                                            2,
                                            _this.Hs(_$e3)
                                        ];
                                    }
                                    return [
                                        3,
                                        7
                                    ];
                                case 3:
                                    if (!(t.key === _this.vs)) return [
                                        3,
                                        4
                                    ];
                                    if (null !== t.newValue) {
                                        _$e4 = _this.xs(t.newValue);
                                        if (_$e4) return [
                                            2,
                                            _this.Os(_$e4)
                                        ];
                                    }
                                    return [
                                        3,
                                        7
                                    ];
                                case 4:
                                    if (!(t.key === _this.Ss)) return [
                                        3,
                                        5
                                    ];
                                    _$e5 = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                        var t = __PRIVATE_ListenSequence.oe;
                                        if (null != e) try {
                                            var n = JSON.parse(e);
                                            __PRIVATE_hardAssert("number" == typeof n), t = n;
                                        } catch (e) {
                                            __PRIVATE_logError("SharedClientState", "Failed to read sequence number from WebStorage", e);
                                        }
                                        return t;
                                    }(t.newValue);
                                    _$e5 !== __PRIVATE_ListenSequence.oe && _this.sequenceNumberHandler(_$e5);
                                    return [
                                        3,
                                        7
                                    ];
                                case 5:
                                    if (!(t.key === _this.Fs)) return [
                                        3,
                                        7
                                    ];
                                    _$e6 = _this.Js(t.newValue);
                                    return [
                                        4,
                                        Promise.all(_$e6.map(function(e) {
                                            return _this.syncEngine.Ys(e);
                                        }))
                                    ];
                                case 6:
                                    _state.sent();
                                    _state.label = 7;
                                case 7:
                                    return [
                                        3,
                                        9
                                    ];
                                case 8:
                                    _this.ys.push(t);
                                    _state.label = 9;
                                case 9:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }));
                }
            }
        },
        {
            key: "ks",
            get: function get() {
                return this.ps.get(this.Vs);
            }
        },
        {
            key: "Ms",
            value: function Ms() {
                this.setItem(this.ws, this.ks.ds());
            }
        },
        {
            key: "Ls",
            value: function Ls(e, t, n) {
                var r = new __PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
                this.setItem(i, r.ds());
            }
        },
        {
            key: "Bs",
            value: function Bs(e) {
                var t = createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
                this.removeItem(t);
            }
        },
        {
            key: "Qs",
            value: function Qs(e) {
                var t = {
                    clientId: this.Vs,
                    onlineState: e
                };
                this.storage.setItem(this.vs, JSON.stringify(t));
            }
        },
        {
            key: "qs",
            value: function qs(e, t, n) {
                var r = createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new __PRIVATE_QueryTargetMetadata(e, t, n);
                this.setItem(r, i.ds());
            }
        },
        {
            key: "Ks",
            value: function Ks(e) {
                var t = JSON.stringify(Array.from(e));
                this.setItem(this.Fs, t);
            }
        },
        {
            /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ key: "$s",
            value: function $s(e) {
                var t = this.bs.exec(e);
                return t ? t[1] : null;
            }
        },
        {
            /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ key: "Ws",
            value: function Ws(e, t) {
                var n = this.$s(e);
                return __PRIVATE_RemoteClientState.Es(n, t);
            }
        },
        {
            /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ key: "Gs",
            value: function Gs(e, t) {
                var n = this.Ds.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
                return __PRIVATE_MutationMetadata.Es(new User(i), r, t);
            }
        },
        {
            /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ key: "js",
            value: function js(e, t) {
                var n = this.Cs.exec(e), r = Number(n[1]);
                return __PRIVATE_QueryTargetMetadata.Es(r, t);
            }
        },
        {
            /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ key: "xs",
            value: function xs(e) {
                return __PRIVATE_SharedOnlineState.Es(e);
            }
        },
        {
            key: "Js",
            value: function Js(e) {
                return JSON.parse(e);
            }
        },
        {
            key: "zs",
            value: function zs(e) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        if (e.user.uid === _this.currentUser.uid) return [
                            2,
                            _this.syncEngine.Zs(e.batchId, e.state, e.error)
                        ];
                        __PRIVATE_logDebug("SharedClientState", "Ignoring mutation for non-active user ".concat(e.user.uid));
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "Hs",
            value: function Hs(e) {
                return this.syncEngine.Xs(e.targetId, e.state, e.error);
            }
        },
        {
            key: "Us",
            value: function Us(e, t) {
                var _this = this;
                var n = t ? this.ps.insert(e, t) : this.ps.remove(e), r = this.Ns(this.ps), i = this.Ns(n), s = [], o = [];
                return i.forEach(function(e) {
                    r.has(e) || s.push(e);
                }), r.forEach(function(e) {
                    i.has(e) || o.push(e);
                }), this.syncEngine.eo(s, o).then(function() {
                    _this.ps = n;
                });
            }
        },
        {
            key: "Os",
            value: function Os(e) {
                // We check whether the client that wrote this online state is still active
                // by comparing its client ID to the list of clients kept active in
                // IndexedDb. If a client does not update their IndexedDb client state
                // within 5 seconds, it is considered inactive and we don't emit an online
                // state event.
                this.ps.get(e.clientId) && this.onlineStateHandler(e.onlineState);
            }
        },
        {
            key: "Ns",
            value: function Ns(e) {
                var t = __PRIVATE_targetIdSet();
                return e.forEach(function(e, n) {
                    t = t.unionWith(n.activeTargetIds);
                }), t;
            }
        }
    ], [
        {
            key: "D",
            value: /** Returns 'true' if WebStorage is available in the current environment. */ function D(e) {
                return !(!e || !e.localStorage);
            }
        }
    ]);
    return __PRIVATE_WebStorageSharedClientState;
}();
var __PRIVATE_MemorySharedClientState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemorySharedClientState() {
        (0, $19mwo._)(this, __PRIVATE_MemorySharedClientState);
        this.no = new __PRIVATE_LocalClientState, this.ro = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    (0, $6rpfc._)(__PRIVATE_MemorySharedClientState, [
        {
            key: "addPendingMutation",
            value: function addPendingMutation(e) {
            // No op.
            }
        },
        {
            key: "updateMutationState",
            value: function updateMutationState(e, t, n) {
            // No op.
            }
        },
        {
            key: "addLocalQueryTarget",
            value: function addLocalQueryTarget(e) {
                return this.no.As(e), this.ro[e] || "not-current";
            }
        },
        {
            key: "updateQueryState",
            value: function updateQueryState(e, t, n) {
                this.ro[e] = t;
            }
        },
        {
            key: "removeLocalQueryTarget",
            value: function removeLocalQueryTarget(e) {
                this.no.Rs(e);
            }
        },
        {
            key: "isLocalQueryTarget",
            value: function isLocalQueryTarget(e) {
                return this.no.activeTargetIds.has(e);
            }
        },
        {
            key: "clearQueryState",
            value: function clearQueryState(e) {
                delete this.ro[e];
            }
        },
        {
            key: "getAllActiveQueryTargets",
            value: function getAllActiveQueryTargets() {
                return this.no.activeTargetIds;
            }
        },
        {
            key: "isActiveQueryTarget",
            value: function isActiveQueryTarget(e) {
                return this.no.activeTargetIds.has(e);
            }
        },
        {
            key: "start",
            value: function start() {
                return this.no = new __PRIVATE_LocalClientState, Promise.resolve();
            }
        },
        {
            key: "handleUserChange",
            value: function handleUserChange(e, t, n) {
            // No op.
            }
        },
        {
            key: "setOnlineState",
            value: function setOnlineState(e) {
            // No op.
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {}
        },
        {
            key: "writeSequenceNumber",
            value: function writeSequenceNumber(e) {}
        },
        {
            key: "notifyBundleLoaded",
            value: function notifyBundleLoaded(e) {
            // No op.
            }
        }
    ]);
    return __PRIVATE_MemorySharedClientState;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_NoopConnectivityMonitor = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_NoopConnectivityMonitor() {
        (0, $19mwo._)(this, __PRIVATE_NoopConnectivityMonitor);
    }
    (0, $6rpfc._)(__PRIVATE_NoopConnectivityMonitor, [
        {
            key: "io",
            value: function io(e) {
            // No-op.
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
            // No-op.
            }
        }
    ]);
    return __PRIVATE_NoopConnectivityMonitor;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Browser implementation of ConnectivityMonitor.
 */ var __PRIVATE_BrowserConnectivityMonitor = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_BrowserConnectivityMonitor() {
        var _this = this;
        (0, $19mwo._)(this, __PRIVATE_BrowserConnectivityMonitor);
        this.so = function() {
            return _this.oo();
        }, this._o = function() {
            return _this.ao();
        }, this.uo = [], this.co();
    }
    (0, $6rpfc._)(__PRIVATE_BrowserConnectivityMonitor, [
        {
            key: "io",
            value: function io(e) {
                this.uo.push(e);
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                window.removeEventListener("online", this.so), window.removeEventListener("offline", this._o);
            }
        },
        {
            key: "co",
            value: function co() {
                window.addEventListener("online", this.so), window.addEventListener("offline", this._o);
            }
        },
        {
            key: "oo",
            value: function oo() {
                __PRIVATE_logDebug("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.uo[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var e = _step.value;
                        e(0 /* NetworkStatus.AVAILABLE */ );
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "ao",
            value: function ao() {
                __PRIVATE_logDebug("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.uo[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var e = _step.value;
                        e(1 /* NetworkStatus.UNAVAILABLE */ );
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "D",
            value: // TODO(chenbrian): Consider passing in window either into this component or
            // here for testing via FakeWindow.
            /** Checks that all used attributes of window are available. */ function D() {
                return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
            }
        }
    ]);
    return __PRIVATE_BrowserConnectivityMonitor;
}();
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ var Ve = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @return the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function __PRIVATE_generateUniqueDebugId() {
    return null === Ve ? Ve = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : Ve++, "0x" + Ve.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var me = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ var __PRIVATE_StreamBridge = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_StreamBridge(e) {
        (0, $19mwo._)(this, __PRIVATE_StreamBridge);
        this.lo = e.lo, this.ho = e.ho;
    }
    (0, $6rpfc._)(__PRIVATE_StreamBridge, [
        {
            key: "Po",
            value: function Po(e) {
                this.Io = e;
            }
        },
        {
            key: "To",
            value: function To(e) {
                this.Eo = e;
            }
        },
        {
            key: "Ao",
            value: function Ao(e) {
                this.Ro = e;
            }
        },
        {
            key: "onMessage",
            value: function onMessage(e) {
                this.Vo = e;
            }
        },
        {
            key: "close",
            value: function close() {
                this.ho();
            }
        },
        {
            key: "send",
            value: function send(e) {
                this.lo(e);
            }
        },
        {
            key: "mo",
            value: function mo() {
                this.Io();
            }
        },
        {
            key: "fo",
            value: function fo() {
                this.Eo();
            }
        },
        {
            key: "po",
            value: function po(e) {
                this.Ro(e);
            }
        },
        {
            key: "yo",
            value: function yo(e) {
                this.Vo(e);
            }
        }
    ]);
    return __PRIVATE_StreamBridge;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var fe = "WebChannelConnection";
var __PRIVATE_WebChannelConnection = /*#__PURE__*/ function(__PRIVATE_RestConnection) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_WebChannelConnection, __PRIVATE_RestConnection);
    var _super = (0, $k1NN5._)(__PRIVATE_WebChannelConnection);
    function __PRIVATE_WebChannelConnection(e) {
        (0, $19mwo._)(this, __PRIVATE_WebChannelConnection);
        var _this;
        _this = _super.call(this, e), _this.forceLongPolling = e.forceLongPolling, _this.autoDetectLongPolling = e.autoDetectLongPolling, _this.useFetchStreams = e.useFetchStreams, _this.longPollingOptions = e.longPollingOptions;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_WebChannelConnection, [
        {
            key: "Mo",
            value: function Mo(e, t, n, r) {
                var i = __PRIVATE_generateUniqueDebugId();
                return new Promise(function(s, o) {
                    var _ = new (0, $2B9VL.XhrIo);
                    _.setWithCredentials(!0), _.listenOnce((0, $2B9VL.EventType).COMPLETE, function() {
                        try {
                            switch(_.getLastErrorCode()){
                                case (0, $2B9VL.ErrorCode).NO_ERROR:
                                    var _$t = _.getResponseJson();
                                    __PRIVATE_logDebug(fe, "XHR for RPC '".concat(e, "' ").concat(i, " received:"), JSON.stringify(_$t)), s(_$t);
                                    break;
                                case (0, $2B9VL.ErrorCode).TIMEOUT:
                                    __PRIVATE_logDebug(fe, "RPC '".concat(e, "' ").concat(i, " timed out")), o(new FirestoreError(C.DEADLINE_EXCEEDED, "Request time out"));
                                    break;
                                case (0, $2B9VL.ErrorCode).HTTP_ERROR:
                                    var _$n = _.getStatus();
                                    if (__PRIVATE_logDebug(fe, "RPC '".concat(e, "' ").concat(i, " failed with status:"), _$n, "response text:", _.getResponseText()), _$n > 0) {
                                        var _$e = _.getResponseJson();
                                        Array.isArray(_$e) && (_$e = _$e[0]);
                                        var _$t1 = null == _$e ? void 0 : _$e.error;
                                        if (_$t1 && _$t1.status && _$t1.message) {
                                            var _$e1 = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                                var _$t = e.toLowerCase().replace(/_/g, "-");
                                                return Object.values(C).indexOf(_$t) >= 0 ? _$t : C.UNKNOWN;
                                            }(_$t1.status);
                                            o(new FirestoreError(_$e1, _$t1.message));
                                        } else o(new FirestoreError(C.UNKNOWN, "Server responded with status " + _.getStatus()));
                                    } else // If we received an HTTP_ERROR but there's no status code,
                                    // it's most probably a connection issue
                                    o(new FirestoreError(C.UNAVAILABLE, "Connection failed."));
                                    break;
                                default:
                                    fail();
                            }
                        } finally{
                            __PRIVATE_logDebug(fe, "RPC '".concat(e, "' ").concat(i, " completed."));
                        }
                    });
                    var a = JSON.stringify(r);
                    __PRIVATE_logDebug(fe, "RPC '".concat(e, "' ").concat(i, " sending request:"), r), _.send(t, "POST", a, n, 15);
                });
            }
        },
        {
            key: "Oo",
            value: function Oo(e, t, n) {
                var r = __PRIVATE_generateUniqueDebugId(), i = [
                    this.wo,
                    "/",
                    "google.firestore.v1.Firestore",
                    "/",
                    e,
                    "/channel"
                ], s = (0, $2B9VL.createWebChannelTransport)(), o = (0, $2B9VL.getStatEventTarget)(), _ = {
                    // Required for backend stickiness, routing behavior is based on this
                    // parameter.
                    httpSessionIdParam: "gsessionid",
                    initMessageHeaders: {},
                    messageUrlParams: {
                        // This param is used to improve routing and project isolation by the
                        // backend and must be included in every request.
                        database: "projects/".concat(this.databaseId.projectId, "/databases/").concat(this.databaseId.database)
                    },
                    sendRawJson: !0,
                    supportsCrossDomainXhr: !0,
                    internalChannelParams: {
                        // Override the default timeout (randomized between 10-20 seconds) since
                        // a large write batch on a slow internet connection may take a long
                        // time to send to the backend. Rather than have WebChannel impose a
                        // tight timeout which could lead to infinite timeouts and retries, we
                        // set it very large (5-10 minutes) and rely on the browser's builtin
                        // timeouts to kick in if the request isn't working.
                        forwardChannelRequestTimeoutMs: 6e5
                    },
                    forceLongPolling: this.forceLongPolling,
                    detectBufferingProxy: this.autoDetectLongPolling
                }, a = this.longPollingOptions.timeoutSeconds;
                void 0 !== a && (_.longPollingTimeout = Math.round(1e3 * a)), this.useFetchStreams && (_.xmlHttpFactory = new (0, $2B9VL.FetchXmlHttpFactory)({})), this.Fo(_.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
                // (Authorization, etc.) will trigger the browser to make a CORS preflight
                // request because the XHR will no longer meet the criteria for a "simple"
                // CORS request:
                // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
                // Therefore to avoid the CORS preflight request (an extra network
                // roundtrip), we use the encodeInitMessageHeaders option to specify that
                // the headers should instead be encoded in the request's POST payload,
                // which is recognized by the webchannel backend.
                _.encodeInitMessageHeaders = !0;
                var u = i.join("");
                __PRIVATE_logDebug(fe, "Creating RPC '".concat(e, "' stream ").concat(r, ": ").concat(u), _);
                var c = s.createWebChannel(u, _);
                // WebChannel supports sending the first message with the handshake - saving
                // a network round trip. However, it will have to call send in the same
                // JS event loop as open. In order to enforce this, we delay actually
                // opening the WebChannel until send is called. Whether we have called
                // open is tracked with this variable.
                var l = !1, h = !1;
                // A flag to determine whether the stream was closed (by us or through an
                // error/close event) to avoid delivering multiple close events or sending
                // on a closed stream
                var P = new __PRIVATE_StreamBridge({
                    lo: function(t) {
                        h ? __PRIVATE_logDebug(fe, "Not sending because RPC '".concat(e, "' stream ").concat(r, " is closed:"), t) : (l || (__PRIVATE_logDebug(fe, "Opening RPC '".concat(e, "' stream ").concat(r, " transport.")), c.open(), l = !0), __PRIVATE_logDebug(fe, "RPC '".concat(e, "' stream ").concat(r, " sending:"), t), c.send(t));
                    },
                    ho: function() {
                        return c.close();
                    }
                }), __PRIVATE_unguardedEventListen = function(e, t, n) {
                    // TODO(dimond): closure typing seems broken because WebChannel does
                    // not implement goog.events.Listenable
                    e.listen(t, function(e) {
                        try {
                            n(e);
                        } catch (e) {
                            setTimeout(function() {
                                throw e;
                            }, 0);
                        }
                    });
                };
                // Closure events are guarded and exceptions are swallowed, so catch any
                // exception and rethrow using a setTimeout so they become visible again.
                // Note that eventually this function could go away if we are confident
                // enough the code is exception free.
                return __PRIVATE_unguardedEventListen(c, (0, $2B9VL.WebChannel).EventType.OPEN, function() {
                    h || (__PRIVATE_logDebug(fe, "RPC '".concat(e, "' stream ").concat(r, " transport opened.")), P.mo());
                }), __PRIVATE_unguardedEventListen(c, (0, $2B9VL.WebChannel).EventType.CLOSE, function() {
                    h || (h = !0, __PRIVATE_logDebug(fe, "RPC '".concat(e, "' stream ").concat(r, " transport closed")), P.po());
                }), __PRIVATE_unguardedEventListen(c, (0, $2B9VL.WebChannel).EventType.ERROR, function(t) {
                    h || (h = !0, __PRIVATE_logWarn(fe, "RPC '".concat(e, "' stream ").concat(r, " transport errored:"), t), P.po(new FirestoreError(C.UNAVAILABLE, "The operation could not be completed")));
                }), __PRIVATE_unguardedEventListen(c, (0, $2B9VL.WebChannel).EventType.MESSAGE, function(t) {
                    var _$n;
                    if (!h) {
                        var i = t.data[0];
                        __PRIVATE_hardAssert(!!i);
                        // TODO(b/35143891): There is a bug in One Platform that caused errors
                        // (and only errors) to be wrapped in an extra array. To be forward
                        // compatible with the bug we need to check either condition. The latter
                        // can be removed once the fix has been rolled out.
                        // Use any because msgData.error is not typed.
                        var s = i, o = s.error || (null === (_$n = s[0]) || void 0 === _$n ? void 0 : _$n.error);
                        if (o) {
                            __PRIVATE_logDebug(fe, "RPC '".concat(e, "' stream ").concat(r, " received error:"), o);
                            // error.status will be a string like 'OK' or 'NOT_FOUND'.
                            var _$t = o.status;
                            var _$n1 = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                                // lookup by string
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                var _$t = ce[e];
                                if (void 0 !== _$t) return __PRIVATE_mapCodeFromRpcCode(_$t);
                            }(_$t), i1 = o.message;
                            void 0 === _$n1 && (_$n1 = C.INTERNAL, i1 = "Unknown error status: " + _$t + " with message " + o.message), // Mark closed so no further events are propagated
                            h = !0, P.po(new FirestoreError(_$n1, i1)), c.close();
                        } else __PRIVATE_logDebug(fe, "RPC '".concat(e, "' stream ").concat(r, " received:"), i), P.yo(i);
                    }
                }), __PRIVATE_unguardedEventListen(o, (0, $2B9VL.Event).STAT_EVENT, function(t) {
                    t.stat === (0, $2B9VL.Stat).PROXY ? __PRIVATE_logDebug(fe, "RPC '".concat(e, "' stream ").concat(r, " detected buffering proxy")) : t.stat === (0, $2B9VL.Stat).NOPROXY && __PRIVATE_logDebug(fe, "RPC '".concat(e, "' stream ").concat(r, " detected no buffering proxy"));
                }), setTimeout(function() {
                    // Technically we could/should wait for the WebChannel opened event,
                    // but because we want to send the first message with the WebChannel
                    // handshake we pretend the channel opened here (asynchronously), and
                    // then delay the actual open until the first message is sent.
                    P.fo();
                }, 0), P;
            }
        }
    ]);
    return __PRIVATE_WebChannelConnection;
}(/**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_RestConnection(e) {
        (0, $19mwo._)(this, __PRIVATE_RestConnection);
        this.databaseInfo = e, this.databaseId = e.databaseId;
        var t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.wo = t + "://" + e.host, this.So = "projects/".concat(n, "/databases/").concat(r), this.bo = "(default)" === this.databaseId.database ? "project_id=".concat(n) : "project_id=".concat(n, "&database_id=").concat(r);
    }
    (0, $6rpfc._)(__PRIVATE_RestConnection, [
        {
            key: "Do",
            get: function get() {
                // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
                // where to run the query, and expect the `request` to NOT specify the "path".
                return !1;
            }
        },
        {
            key: "Co",
            value: function Co(e, t, n, r, i) {
                var s = __PRIVATE_generateUniqueDebugId(), o = this.vo(e, t.toUriEncodedString());
                __PRIVATE_logDebug("RestConnection", "Sending RPC '".concat(e, "' ").concat(s, ":"), o, n);
                var _ = {
                    "google-cloud-resource-prefix": this.So,
                    "x-goog-request-params": this.bo
                };
                return this.Fo(_, r, i), this.Mo(e, o, _, n).then(function(t) {
                    return __PRIVATE_logDebug("RestConnection", "Received RPC '".concat(e, "' ").concat(s, ": "), t), t;
                }, function(t) {
                    throw __PRIVATE_logWarn("RestConnection", "RPC '".concat(e, "' ").concat(s, " failed with error: "), t, "url: ", o, "request:", n), t;
                });
            }
        },
        {
            key: "xo",
            value: function xo(e, t, n, r, i, s) {
                // The REST API automatically aggregates all of the streamed results, so we
                // can just use the normal invoke() method.
                return this.Co(e, t, n, r, i);
            }
        },
        {
            /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ key: "Fo",
            value: function Fo(e, t, n) {
                e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
                // so we need to get its value when we need it in a function.
                function __PRIVATE_getGoogApiClientValue() {
                    return "gl-js/ fire/" + b;
                }(), // Content-Type: text/plain will avoid preflight requests which might
                // mess with CORS and redirects by proxies. If we add custom headers
                // we will need to change this code to potentially use the $httpOverwrite
                // parameter supported by ESF to avoid triggering preflight requests.
                e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach(function(t, n) {
                    return e[n] = t;
                }), n && n.headers.forEach(function(t, n) {
                    return e[n] = t;
                });
            }
        },
        {
            key: "vo",
            value: function vo(e, t) {
                var n = me[e];
                return "".concat(this.wo, "/v1/").concat(t, ":").concat(n);
            }
        },
        {
            /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ key: "terminate",
            value: function terminate() {
            // No-op
            }
        }
    ]);
    return __PRIVATE_RestConnection;
}());
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function __PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_newSerializer(e) {
    return new JsonProtoSerializer(e, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ var __PRIVATE_ExponentialBackoff = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_ExponentialBackoff(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t) {
        var /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e3, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1.5, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 6e4;
        (0, $19mwo._)(this, __PRIVATE_ExponentialBackoff);
        this.oi = e, this.timerId = t, this.No = n, this.Lo = r, this.Bo = i, this.ko = 0, this.qo = null, /** The last backoff attempt, as epoch milliseconds. */ this.Qo = Date.now(), this.reset();
    }
    (0, $6rpfc._)(__PRIVATE_ExponentialBackoff, [
        {
            /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ key: "reset",
            value: function reset() {
                this.ko = 0;
            }
        },
        {
            /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ key: "Ko",
            value: function Ko() {
                this.ko = this.Bo;
            }
        },
        {
            /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ key: "$o",
            value: function $o(e) {
                var _this = this;
                // Cancel any pending backoff operation.
                this.cancel();
                // First schedule using the current base (which may be 0 and should be
                // honored as such).
                var t = Math.floor(this.ko + this.Uo()), n = Math.max(0, Date.now() - this.Qo), r = Math.max(0, t - n);
                // Guard against lastAttemptTime being in the future due to a clock change.
                r > 0 && __PRIVATE_logDebug("ExponentialBackoff", "Backing off for ".concat(r, " ms (base delay: ").concat(this.ko, " ms, delay with jitter: ").concat(t, " ms, last attempt: ").concat(n, " ms ago)")), this.qo = this.oi.enqueueAfterDelay(this.timerId, r, function() {
                    return _this.Qo = Date.now(), e();
                }), // Apply backoff factor to determine next delay and ensure it is within
                // bounds.
                this.ko *= this.Lo, this.ko < this.No && (this.ko = this.No), this.ko > this.Bo && (this.ko = this.Bo);
            }
        },
        {
            key: "Wo",
            value: function Wo() {
                null !== this.qo && (this.qo.skipDelay(), this.qo = null);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                null !== this.qo && (this.qo.cancel(), this.qo = null);
            }
        },
        {
            /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ key: "Uo",
            value: function Uo() {
                return (Math.random() - .5) * this.ko;
            }
        }
    ]);
    return __PRIVATE_ExponentialBackoff;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ var __PRIVATE_PersistentStream = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_PersistentStream(e, t, n, r, i, s, o, _) {
        (0, $19mwo._)(this, __PRIVATE_PersistentStream);
        this.oi = e, this.Go = n, this.zo = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = o, this.listener = _, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.jo = 0, this.Ho = null, this.Jo = null, this.stream = null, this.Yo = new __PRIVATE_ExponentialBackoff(e, t);
    }
    (0, $6rpfc._)(__PRIVATE_PersistentStream, [
        {
            /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ key: "Zo",
            value: function Zo() {
                return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.Xo();
            }
        },
        {
            /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ key: "Xo",
            value: function Xo() {
                return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
            }
        },
        {
            /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ key: "start",
            value: function start() {
                4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.e_();
            }
        },
        {
            key: "stop",
            value: /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ function stop() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _tmp;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.Zo();
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.close(0 /* PersistentStreamState.Initial */ )
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ key: "t_",
            value: function t_() {
                this.state = 0 /* PersistentStreamState.Initial */ , this.Yo.reset();
            }
        },
        {
            /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ key: "n_",
            value: function n_() {
                var _this = this;
                // Starts the idle time if we are in state 'Open' and are not yet already
                // running a timer (in which case the previous idle timeout still applies).
                this.Xo() && null === this.Ho && (this.Ho = this.oi.enqueueAfterDelay(this.Go, 6e4, function() {
                    return _this.r_();
                }));
            }
        },
        {
            /** Sends a message to the underlying stream. */ key: "i_",
            value: function i_(e) {
                this.s_(), this.stream.send(e);
            }
        },
        {
            key: "r_",
            value: /** Called by the idle timer when the stream should close due to inactivity. */ function r_() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        if (_this.Xo()) // When timing out an idle stream there's no reason to force the stream into backoff when
                        // it restarts so set the stream state to Initial instead of Error.
                        return [
                            2,
                            _this.close(0 /* PersistentStreamState.Initial */ )
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            /** Marks the stream as active again. */ key: "s_",
            value: function s_() {
                this.Ho && (this.Ho.cancel(), this.Ho = null);
            }
        },
        {
            /** Cancels the health check delayed operation. */ key: "o_",
            value: function o_() {
                this.Jo && (this.Jo.cancel(), this.Jo = null);
            }
        },
        {
            key: "close",
            value: /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ function close(e, t) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Cancel any outstanding timers (they're guaranteed not to execute).
                                _this.s_(), _this.o_(), _this.Yo.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
                                // underlying stream), guaranteeing they won't execute.
                                _this.jo++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
                                _this.Yo.reset() : t && t.code === C.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
                                (__PRIVATE_logError(t.toString()), __PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), _this.Yo.Ko()) : t && t.code === C.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== _this.state && // "unauthenticated" error means the token was rejected. This should rarely
                                // happen since both Auth and AppCheck ensure a sufficient TTL when we
                                // request a token. If a user manually resets their system clock this can
                                // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
                                // before we received the first message and we need to invalidate the token
                                // to ensure that we fetch a new token.
                                (_this.authCredentialsProvider.invalidateToken(), _this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
                                null !== _this.stream && (_this.__(), _this.stream.close(), _this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
                                // inhibit backoff or otherwise manipulate the state in its non-started state.
                                _this.state = e;
                                // Notify the listener that the stream closed.
                                return [
                                    4,
                                    _this.listener.Ao(t)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ key: "__",
            value: function __() {}
        },
        {
            key: "auth",
            value: function auth() {
                var _this = this;
                this.state = 1 /* PersistentStreamState.Starting */ ;
                var e = this.a_(this.jo), t = this.jo;
                // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
                Promise.all([
                    this.authCredentialsProvider.getToken(),
                    this.appCheckCredentialsProvider.getToken()
                ]).then(function(param) {
                    var _param = (0, $2MTYX._)(param, 2), e = _param[0], n = _param[1];
                    // Stream can be stopped while waiting for authentication.
                    // TODO(mikelehen): We really should just use dispatchIfNotClosed
                    // and let this dispatch onto the queue, but that opened a spec test can
                    // of worms that I don't want to deal with in this PR.
                    _this.jo === t && // Normally we'd have to schedule the callback on the AsyncQueue.
                    // However, the following calls are safe to be called outside the
                    // AsyncQueue since they don't chain asynchronous calls
                    _this.u_(e, n);
                }, function(t) {
                    e(function() {
                        var e = new FirestoreError(C.UNKNOWN, "Fetching auth token failed: " + t.message);
                        return _this.c_(e);
                    });
                });
            }
        },
        {
            key: "u_",
            value: function u_(e, t) {
                var _this = this;
                var n = this.a_(this.jo);
                this.stream = this.l_(e, t), this.stream.Po(function() {
                    n(function() {
                        return _this.listener.Po();
                    });
                }), this.stream.To(function() {
                    n(function() {
                        return _this.state = 2 /* PersistentStreamState.Open */ , _this.Jo = _this.oi.enqueueAfterDelay(_this.zo, 1e4, function() {
                            return _this.Xo() && (_this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve();
                        }), _this.listener.To();
                    });
                }), this.stream.Ao(function(e) {
                    n(function() {
                        return _this.c_(e);
                    });
                }), this.stream.onMessage(function(e) {
                    n(function() {
                        return _this.onMessage(e);
                    });
                });
            }
        },
        {
            key: "e_",
            value: function e_() {
                var _this = this;
                this.state = 5 /* PersistentStreamState.Backoff */ , this.Yo.$o(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        _this.state = 0 /* PersistentStreamState.Initial */ , _this.start();
                        return [
                            2
                        ];
                    });
                }));
            }
        },
        {
            // Visible for tests
            key: "c_",
            value: function c_(e) {
                // In theory the stream could close cleanly, however, in our current model
                // we never expect this to happen because if we stop a stream ourselves,
                // this callback will never be called. To prevent cases where we retry
                // without a backoff accidentally, we set the stream to error in all cases.
                return __PRIVATE_logDebug("PersistentStream", "close with error: ".concat(e)), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
            }
        },
        {
            /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ key: "a_",
            value: function a_(e) {
                var _this = this;
                return function(t) {
                    _this.oi.enqueueAndForget(function() {
                        return _this.jo === e ? t() : (__PRIVATE_logDebug("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve());
                    });
                };
            }
        }
    ]);
    return __PRIVATE_PersistentStream;
}();
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ var __PRIVATE_PersistentListenStream = /*#__PURE__*/ function(__PRIVATE_PersistentStream) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_PersistentListenStream, __PRIVATE_PersistentStream);
    var _super = (0, $k1NN5._)(__PRIVATE_PersistentListenStream);
    function __PRIVATE_PersistentListenStream(e, t, n, r, i, s) {
        (0, $19mwo._)(this, __PRIVATE_PersistentListenStream);
        var _this;
        _this = _super.call(this, e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), _this.serializer = i;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_PersistentListenStream, [
        {
            key: "l_",
            value: function l_(e, t) {
                return this.connection.Oo("Listen", e, t);
            }
        },
        {
            key: "onMessage",
            value: function onMessage(e) {
                // A successful response means the stream is healthy
                this.Yo.reset();
                var t = __PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
                    // We have only reached a consistent snapshot for the entire stream if there
                    // is a read_time set and it applies to all targets (i.e. the list of
                    // targets is empty). The backend is guaranteed to send such responses.
                    if (!("targetChange" in e)) return SnapshotVersion.min();
                    var t = e.targetChange;
                    return t.targetIds && t.targetIds.length ? SnapshotVersion.min() : t.readTime ? __PRIVATE_fromVersion(t.readTime) : SnapshotVersion.min();
                }(e);
                return this.listener.h_(t, n);
            }
        },
        {
            /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ key: "P_",
            value: function P_(e) {
                var t = {};
                t.database = __PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
                    var n;
                    var r = t.target;
                    if (n = __PRIVATE_targetIsDocumentTarget(r) ? {
                        documents: __PRIVATE_toDocumentsTarget(e, r)
                    } : {
                        query: __PRIVATE_toQueryTarget(e, r)._t
                    }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                        n.resumeToken = __PRIVATE_toBytes(e, t.resumeToken);
                        var r1 = __PRIVATE_toInt32Proto(e, t.expectedCount);
                        null !== r1 && (n.expectedCount = r1);
                    } else if (t.snapshotVersion.compareTo(SnapshotVersion.min()) > 0) {
                        // TODO(wuandy): Consider removing above check because it is most likely true.
                        // Right now, many tests depend on this behaviour though (leaving min() out
                        // of serialization).
                        n.readTime = toTimestamp(e, t.snapshotVersion.toTimestamp());
                        var r2 = __PRIVATE_toInt32Proto(e, t.expectedCount);
                        null !== r2 && (n.expectedCount = r2);
                    }
                    return n;
                }(this.serializer, e);
                var n = __PRIVATE_toListenRequestLabels(this.serializer, e);
                n && (t.labels = n), this.i_(t);
            }
        },
        {
            /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ key: "I_",
            value: function I_(e) {
                var t = {};
                t.database = __PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.i_(t);
            }
        }
    ]);
    return __PRIVATE_PersistentListenStream;
}(__PRIVATE_PersistentStream);
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ var __PRIVATE_PersistentWriteStream = /*#__PURE__*/ function(__PRIVATE_PersistentStream) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_PersistentWriteStream, __PRIVATE_PersistentStream);
    var _super = (0, $k1NN5._)(__PRIVATE_PersistentWriteStream);
    function __PRIVATE_PersistentWriteStream(e, t, n, r, i, s) {
        (0, $19mwo._)(this, __PRIVATE_PersistentWriteStream);
        var _this;
        _this = _super.call(this, e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), _this.serializer = i, _this.T_ = !1;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_PersistentWriteStream, [
        {
            key: "E_",
            get: /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ function get() {
                return this.T_;
            }
        },
        {
            // Override of PersistentStream.start
            key: "start",
            value: function start() {
                this.T_ = !1, this.lastStreamToken = void 0, (0, $jLCbM._)((0, $laF8D._)(__PRIVATE_PersistentWriteStream.prototype), "start", this).call(this);
            }
        },
        {
            key: "__",
            value: function __() {
                this.T_ && this.d_([]);
            }
        },
        {
            key: "l_",
            value: function l_(e, t) {
                return this.connection.Oo("Write", e, t);
            }
        },
        {
            key: "onMessage",
            value: function onMessage(e) {
                if (// Always capture the last stream token.
                __PRIVATE_hardAssert(!!e.streamToken), this.lastStreamToken = e.streamToken, this.T_) {
                    // A successful first write response means the stream is healthy,
                    // Note, that we could consider a successful handshake healthy, however,
                    // the write itself might be causing an error we want to back off from.
                    this.Yo.reset();
                    var t = __PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = __PRIVATE_fromVersion(e.commitTime);
                    return this.listener.A_(n, t);
                }
                // The first response is always the handshake response
                return __PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length), this.T_ = !0, this.listener.R_();
            }
        },
        {
            /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ key: "V_",
            value: function V_() {
                // TODO(dimond): Support stream resumption. We intentionally do not set the
                // stream token on the handshake, ignoring any stream token we might have.
                var e = {};
                e.database = __PRIVATE_getEncodedDatabaseId(this.serializer), this.i_(e);
            }
        },
        {
            /** Sends a group of mutations to the Firestore backend to apply. */ key: "d_",
            value: function d_(e) {
                var _this = this;
                var t = {
                    streamToken: this.lastStreamToken,
                    writes: e.map(function(e) {
                        return toMutation(_this.serializer, e);
                    })
                };
                this.i_(t);
            }
        }
    ]);
    return __PRIVATE_PersistentWriteStream;
}(__PRIVATE_PersistentStream);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ /**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ var __PRIVATE_DatastoreImpl = /*#__PURE__*/ function(_Datastore) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_DatastoreImpl, _Datastore);
    var _super = (0, $k1NN5._)(__PRIVATE_DatastoreImpl);
    function __PRIVATE_DatastoreImpl(e, t, n, r) {
        (0, $19mwo._)(this, __PRIVATE_DatastoreImpl);
        var _this;
        _this = _super.call(this), _this.authCredentials = e, _this.appCheckCredentials = t, _this.connection = n, _this.serializer = r, _this.m_ = !1;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_DatastoreImpl, [
        {
            key: "f_",
            value: function f_() {
                if (this.m_) throw new FirestoreError(C.FAILED_PRECONDITION, "The client has already been terminated.");
            }
        },
        {
            /** Invokes the provided RPC with auth and AppCheck tokens. */ key: "Co",
            value: function Co(e, t, n, r) {
                var _this = this;
                return this.f_(), Promise.all([
                    this.authCredentials.getToken(),
                    this.appCheckCredentials.getToken()
                ]).then(function(param) {
                    var _param = (0, $2MTYX._)(param, 2), i = _param[0], s = _param[1];
                    return _this.connection.Co(e, __PRIVATE_toResourcePath(t, n), r, i, s);
                }).catch(function(e) {
                    throw "FirebaseError" === e.name ? (e.code === C.UNAUTHENTICATED && (_this.authCredentials.invalidateToken(), _this.appCheckCredentials.invalidateToken()), e) : new FirestoreError(C.UNKNOWN, e.toString());
                });
            }
        },
        {
            /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ key: "xo",
            value: function xo(e, t, n, r, i) {
                var _this = this;
                return this.f_(), Promise.all([
                    this.authCredentials.getToken(),
                    this.appCheckCredentials.getToken()
                ]).then(function(param) {
                    var _param = (0, $2MTYX._)(param, 2), s = _param[0], o = _param[1];
                    return _this.connection.xo(e, __PRIVATE_toResourcePath(t, n), r, s, o, i);
                }).catch(function(e) {
                    throw "FirebaseError" === e.name ? (e.code === C.UNAUTHENTICATED && (_this.authCredentials.invalidateToken(), _this.appCheckCredentials.invalidateToken()), e) : new FirestoreError(C.UNKNOWN, e.toString());
                });
            }
        },
        {
            key: "terminate",
            value: function terminate() {
                this.m_ = !0, this.connection.terminate();
            }
        }
    ]);
    return __PRIVATE_DatastoreImpl;
}(function Datastore() {
    "use strict";
    (0, $19mwo._)(this, Datastore);
});
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ var __PRIVATE_OnlineStateTracker = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_OnlineStateTracker(e, t) {
        (0, $19mwo._)(this, __PRIVATE_OnlineStateTracker);
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.g_ = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this.p_ = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.y_ = !0;
    }
    (0, $6rpfc._)(__PRIVATE_OnlineStateTracker, [
        {
            /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ key: "w_",
            value: function w_() {
                var _this = this;
                0 === this.g_ && (this.S_("Unknown" /* OnlineState.Unknown */ ), this.p_ = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, function() {
                    return _this.p_ = null, _this.b_("Backend didn't respond within 10 seconds."), _this.S_("Offline" /* OnlineState.Offline */ ), Promise.resolve();
                }));
            }
        },
        {
            /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ key: "D_",
            value: function D_(e) {
                "Online" /* OnlineState.Online */  === this.state ? this.S_("Unknown" /* OnlineState.Unknown */ ) : (this.g_++, this.g_ >= 1 && (this.C_(), this.b_("Connection failed 1 times. Most recent error: ".concat(e.toString())), this.S_("Offline" /* OnlineState.Offline */ )));
            }
        },
        {
            /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ key: "set",
            value: function set(e) {
                this.C_(), this.g_ = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
                // about being offline going forward.
                (this.y_ = !1), this.S_(e);
            }
        },
        {
            key: "S_",
            value: function S_(e) {
                e !== this.state && (this.state = e, this.onlineStateHandler(e));
            }
        },
        {
            key: "b_",
            value: function b_(e) {
                var t = "Could not reach Cloud Firestore backend. ".concat(e, "\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.");
                this.y_ ? (__PRIVATE_logError(t), this.y_ = !1) : __PRIVATE_logDebug("OnlineStateTracker", t);
            }
        },
        {
            key: "C_",
            value: function C_() {
                null !== this.p_ && (this.p_.cancel(), this.p_ = null);
            }
        }
    ]);
    return __PRIVATE_OnlineStateTracker;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_RemoteStoreImpl = function __PRIVATE_RemoteStoreImpl(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i) {
    "use strict";
    var _this = this;
    (0, $19mwo._)(this, __PRIVATE_RemoteStoreImpl);
    this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.v_ = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.F_ = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.M_ = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.x_ = [], this.O_ = i, this.O_.io(function(e) {
        var _this1 = _this;
        n.enqueueAndForget(/*#__PURE__*/ (0, $9OZ9j._)(function() {
            var _tmp;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                        // network becomes unreachable as we don't have any other way to tear
                        // down our streams.
                        _tmp = __PRIVATE_canUseNetwork(_this1);
                        if (!_tmp) return [
                            3,
                            2
                        ];
                        __PRIVATE_logDebug("RemoteStore", "Restarting streams for network reachability change.");
                        return [
                            4,
                            (function() {
                                var ___PRIVATE_restartNetwork = (0, $9OZ9j._)(function(e) {
                                    var _$t;
                                    return (0, $lF1I7.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _$t = __PRIVATE_debugCast(e);
                                                _$t.M_.add(4 /* OfflineCause.ConnectivityChange */ );
                                                return [
                                                    4,
                                                    __PRIVATE_disableNetworkInternal(_$t)
                                                ];
                                            case 1:
                                                _state.sent(), _$t.N_.set("Unknown" /* OnlineState.Unknown */ ), _$t.M_.delete(4 /* OfflineCause.ConnectivityChange */ );
                                                return [
                                                    4,
                                                    __PRIVATE_enableNetworkInternal(_$t)
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                function __PRIVATE_restartNetwork(e) {
                                    return ___PRIVATE_restartNetwork.apply(this, arguments);
                                }
                                return __PRIVATE_restartNetwork;
                            })()(_this1)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        }));
    }), this.N_ = new __PRIVATE_OnlineStateTracker(n, r);
};
function __PRIVATE_enableNetworkInternal(e) {
    return ___PRIVATE_enableNetworkInternal.apply(this, arguments);
}
function ___PRIVATE_enableNetworkInternal() {
    ___PRIVATE_enableNetworkInternal = (0, $9OZ9j._)(function(e) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t, err;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (!__PRIVATE_canUseNetwork(e)) return [
                        3,
                        8
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = e.x_[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    t = _step.value;
                    return [
                        4,
                        t(/* enabled= */ !0)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_enableNetworkInternal.apply(this, arguments);
}
function __PRIVATE_disableNetworkInternal(e) {
    return ___PRIVATE_disableNetworkInternal.apply(this, arguments);
}
function ___PRIVATE_disableNetworkInternal() {
    ___PRIVATE_disableNetworkInternal = /**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ (0, $9OZ9j._)(function(e) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t, err;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = e.x_[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    t = _step.value;
                    return [
                        4,
                        t(/* enabled= */ !1)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_disableNetworkInternal.apply(this, arguments);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function __PRIVATE_remoteStoreListen(e, t) {
    var n = __PRIVATE_debugCast(e);
    n.F_.has(t.targetId) || // Mark this as something the client is currently listening for.
    (n.F_.set(t.targetId, t), __PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    __PRIVATE_startWatchStream(n) : __PRIVATE_ensureWatchStream(n).Xo() && __PRIVATE_sendWatchRequest(n, t));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function __PRIVATE_remoteStoreUnlisten(e, t) {
    var n = __PRIVATE_debugCast(e), r = __PRIVATE_ensureWatchStream(n);
    n.F_.delete(t), r.Xo() && __PRIVATE_sendUnwatchRequest(n, t), 0 === n.F_.size && (r.Xo() ? r.n_() : __PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.N_.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function __PRIVATE_sendWatchRequest(e, t) {
    if (e.L_.xe(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo(SnapshotVersion.min()) > 0) {
        var n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
        t = t.withExpectedCount(n);
    }
    __PRIVATE_ensureWatchStream(e).P_(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function __PRIVATE_sendUnwatchRequest(e, t) {
    e.L_.xe(t), __PRIVATE_ensureWatchStream(e).I_(t);
}
function __PRIVATE_startWatchStream(e) {
    e.L_ = new __PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: function(t) {
            return e.remoteSyncer.getRemoteKeysForTarget(t);
        },
        ot: function(t) {
            return e.F_.get(t) || null;
        },
        tt: function() {
            return e.datastore.serializer.databaseId;
        }
    }), __PRIVATE_ensureWatchStream(e).start(), e.N_.w_();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function __PRIVATE_shouldStartWatchStream(e) {
    return __PRIVATE_canUseNetwork(e) && !__PRIVATE_ensureWatchStream(e).Zo() && e.F_.size > 0;
}
function __PRIVATE_canUseNetwork(e) {
    return 0 === __PRIVATE_debugCast(e).M_.size;
}
function __PRIVATE_cleanUpWatchStreamState(e) {
    e.L_ = void 0;
}
function __PRIVATE_onWatchStreamConnected(e) {
    return ___PRIVATE_onWatchStreamConnected.apply(this, arguments);
}
function ___PRIVATE_onWatchStreamConnected() {
    ___PRIVATE_onWatchStreamConnected = (0, $9OZ9j._)(function(e) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            // Mark the client as online since we got a "connected" notification.
            e.N_.set("Online" /* OnlineState.Online */ );
            return [
                2
            ];
        });
    });
    return ___PRIVATE_onWatchStreamConnected.apply(this, arguments);
}
function __PRIVATE_onWatchStreamOpen(e) {
    return ___PRIVATE_onWatchStreamOpen.apply(this, arguments);
}
function ___PRIVATE_onWatchStreamOpen() {
    ___PRIVATE_onWatchStreamOpen = (0, $9OZ9j._)(function(e) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            e.F_.forEach(function(t, n) {
                __PRIVATE_sendWatchRequest(e, t);
            });
            return [
                2
            ];
        });
    });
    return ___PRIVATE_onWatchStreamOpen.apply(this, arguments);
}
function __PRIVATE_onWatchStreamClose(e, t) {
    return ___PRIVATE_onWatchStreamClose.apply(this, arguments);
}
function ___PRIVATE_onWatchStreamClose() {
    ___PRIVATE_onWatchStreamClose = (0, $9OZ9j._)(function(e, t) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            __PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
            __PRIVATE_shouldStartWatchStream(e) ? (e.N_.D_(t), __PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
            // The online state is set to unknown because there is no active attempt
            // at establishing a connection
            e.N_.set("Unknown" /* OnlineState.Unknown */ );
            return [
                2
            ];
        });
    });
    return ___PRIVATE_onWatchStreamClose.apply(this, arguments);
}
function __PRIVATE_onWatchStreamChange(e, t, n) {
    return ___PRIVATE_onWatchStreamChange.apply(this, arguments);
}
function ___PRIVATE_onWatchStreamChange() {
    ___PRIVATE_onWatchStreamChange = (0, $9OZ9j._)(function(e, t, n) {
        var n1, _$t, _tmp, t1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!// Mark the client as online since we got a message from the server
                    (e.N_.set("Online" /* OnlineState.Online */ ), t instanceof __PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause)) return [
                        3,
                        6
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    return [
                        4,
                        /** Handles an error on a target */ (function() {
                            var ___PRIVATE_handleTargetError = (0, $9OZ9j._)(function(e, t) {
                                var _$n, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, r, _tmp, err;
                                return (0, $lF1I7.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _$n = t.cause;
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                7,
                                                8,
                                                9
                                            ]);
                                            _iterator = t.targetIds[Symbol.iterator]();
                                            _state.label = 2;
                                        case 2:
                                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                                3,
                                                6
                                            ];
                                            r = _step.value;
                                            // A watched target might have been removed already.
                                            _tmp = e.F_.has(r);
                                            if (!_tmp) return [
                                                3,
                                                4
                                            ];
                                            return [
                                                4,
                                                e.remoteSyncer.rejectListen(r, _$n)
                                            ];
                                        case 3:
                                            _tmp = (_state.sent(), e.F_.delete(r), e.L_.removeTarget(r));
                                            _state.label = 4;
                                        case 4:
                                            _tmp;
                                            _state.label = 5;
                                        case 5:
                                            _iteratorNormalCompletion = true;
                                            return [
                                                3,
                                                2
                                            ];
                                        case 6:
                                            return [
                                                3,
                                                9
                                            ];
                                        case 7:
                                            err = _state.sent();
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                            return [
                                                3,
                                                9
                                            ];
                                        case 8:
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                            return [
                                                7
                                            ];
                                        case 9:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            function __PRIVATE_handleTargetError(e, t) {
                                return ___PRIVATE_handleTargetError.apply(this, arguments);
                            }
                            return __PRIVATE_handleTargetError;
                        })()(e, t)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    n1 = _state.sent();
                    __PRIVATE_logDebug("RemoteStore", "Failed to remove targets %s: %s ", t.targetIds.join(","), n1);
                    return [
                        4,
                        __PRIVATE_disableNetworkUntilRecovery(e, n1)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        3,
                        13
                    ];
                case 6:
                    if (!(t instanceof __PRIVATE_DocumentWatchChange ? e.L_.Ke(t) : t instanceof __PRIVATE_ExistenceFilterChange ? e.L_.He(t) : e.L_.We(t), !n.isEqual(SnapshotVersion.min()))) return [
                        3,
                        13
                    ];
                    _state.label = 7;
                case 7:
                    _state.trys.push([
                        7,
                        11,
                        ,
                        13
                    ]);
                    return [
                        4,
                        __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)
                    ];
                case 8:
                    _$t = _state.sent();
                    _tmp = n.compareTo(_$t) >= 0;
                    if (!_tmp) return [
                        3,
                        10
                    ];
                    // We have received a target change with a global snapshot if the snapshot
                    // version is not equal to SnapshotVersion.min().
                    return [
                        4,
                        /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ function __PRIVATE_raiseWatchSnapshot(e, t) {
                            var _$n = e.L_.rt(t);
                            // Update in-memory resume tokens. LocalStore will update the
                            // persistent view of these when applying the completed RemoteEvent.
                            return _$n.targetChanges.forEach(function(n, r) {
                                if (n.resumeToken.approximateByteSize() > 0) {
                                    var i = e.F_.get(r);
                                    // A watched target might have been removed already.
                                    i && e.F_.set(r, i.withResumeToken(n.resumeToken, t));
                                }
                            }), // Re-establish listens for the targets that have been invalidated by
                            // existence filter mismatches.
                            _$n.targetMismatches.forEach(function(t, n) {
                                var r = e.F_.get(t);
                                if (!r) // A watched target might have been removed already.
                                return;
                                // Clear the resume token for the target, since we're in a known mismatch
                                // state.
                                e.F_.set(t, r.withResumeToken(ByteString.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                                // deliberately don't send a resume token so that we get a full update.
                                __PRIVATE_sendUnwatchRequest(e, t);
                                // Mark the target we send as being on behalf of an existence filter
                                // mismatch, but don't actually retain that in listenTargets. This ensures
                                // that we flag the first re-listen this way without impacting future
                                // listens of this target (that might happen e.g. on reconnect).
                                var i = new TargetData(r.target, t, n, r.sequenceNumber);
                                __PRIVATE_sendWatchRequest(e, i);
                            }), e.remoteSyncer.applyRemoteEvent(_$n);
                        }(e, n)
                    ];
                case 9:
                    _tmp = _state.sent();
                    _state.label = 10;
                case 10:
                    _tmp;
                    return [
                        3,
                        13
                    ];
                case 11:
                    t1 = _state.sent();
                    __PRIVATE_logDebug("RemoteStore", "Failed to raise snapshot:", t1);
                    return [
                        4,
                        __PRIVATE_disableNetworkUntilRecovery(e, t1)
                    ];
                case 12:
                    _state.sent();
                    return [
                        3,
                        13
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_onWatchStreamChange.apply(this, arguments);
}
function __PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    return ___PRIVATE_disableNetworkUntilRecovery.apply(this, arguments);
}
function ___PRIVATE_disableNetworkUntilRecovery() {
    ___PRIVATE_disableNetworkUntilRecovery = /**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ (0, $9OZ9j._)(function(e, t, n) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!__PRIVATE_isIndexedDbTransactionError(t)) throw t;
                    e.M_.add(1 /* OfflineCause.IndexedDbFailed */ );
                    // Disable network and raise offline snapshots
                    return [
                        4,
                        __PRIVATE_disableNetworkInternal(e)
                    ];
                case 1:
                    _state.sent(), e.N_.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
                    // Ideally, we would expose a health check directly on SimpleDb, but
                    // RemoteStore only has access to persistence through LocalStore.
                    (n = function() {
                        return __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
                    }), // Probe IndexedDB periodically and re-enable network
                    e.asyncQueue.enqueueRetryable(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    __PRIVATE_logDebug("RemoteStore", "Retrying IndexedDB access");
                                    return [
                                        4,
                                        n()
                                    ];
                                case 1:
                                    _state.sent(), e.M_.delete(1 /* OfflineCause.IndexedDbFailed */ );
                                    return [
                                        4,
                                        __PRIVATE_enableNetworkInternal(e)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_disableNetworkUntilRecovery.apply(this, arguments);
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function __PRIVATE_executeWithRecovery(e, t) {
    return t().catch(function(n) {
        return __PRIVATE_disableNetworkUntilRecovery(e, n, t);
    });
}
function __PRIVATE_fillWritePipeline(e) {
    return ___PRIVATE_fillWritePipeline.apply(this, arguments);
}
function ___PRIVATE_fillWritePipeline() {
    ___PRIVATE_fillWritePipeline = (0, $9OZ9j._)(function(e) {
        var t, n, r, _$e, e1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    t = __PRIVATE_debugCast(e), n = __PRIVATE_ensureWriteStream(t);
                    r = t.v_.length > 0 ? t.v_[t.v_.length - 1].batchId : -1;
                    _state.label = 1;
                case 1:
                    if (!__PRIVATE_canAddToWritePipeline(t)) return [
                        3,
                        7
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        6
                    ]);
                    return [
                        4,
                        __PRIVATE_localStoreGetNextMutationBatch(t.localStore, r)
                    ];
                case 3:
                    _$e = _state.sent();
                    if (null === _$e) {
                        0 === t.v_.length && n.n_();
                        return [
                            3,
                            7
                        ];
                    }
                    r = _$e.batchId, __PRIVATE_addToWritePipeline(t, _$e);
                    return [
                        3,
                        6
                    ];
                case 4:
                    e1 = _state.sent();
                    return [
                        4,
                        __PRIVATE_disableNetworkUntilRecovery(t, e1)
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        3,
                        1
                    ];
                case 7:
                    __PRIVATE_shouldStartWriteStream(t) && __PRIVATE_startWriteStream(t);
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_fillWritePipeline.apply(this, arguments);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function __PRIVATE_canAddToWritePipeline(e) {
    return __PRIVATE_canUseNetwork(e) && e.v_.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function __PRIVATE_addToWritePipeline(e, t) {
    e.v_.push(t);
    var n = __PRIVATE_ensureWriteStream(e);
    n.Xo() && n.E_ && n.d_(t.mutations);
}
function __PRIVATE_shouldStartWriteStream(e) {
    return __PRIVATE_canUseNetwork(e) && !__PRIVATE_ensureWriteStream(e).Zo() && e.v_.length > 0;
}
function __PRIVATE_startWriteStream(e) {
    __PRIVATE_ensureWriteStream(e).start();
}
function __PRIVATE_onWriteStreamOpen(e) {
    return ___PRIVATE_onWriteStreamOpen.apply(this, arguments);
}
function ___PRIVATE_onWriteStreamOpen() {
    ___PRIVATE_onWriteStreamOpen = (0, $9OZ9j._)(function(e) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            __PRIVATE_ensureWriteStream(e).V_();
            return [
                2
            ];
        });
    });
    return ___PRIVATE_onWriteStreamOpen.apply(this, arguments);
}
function __PRIVATE_onWriteHandshakeComplete(e) {
    return ___PRIVATE_onWriteHandshakeComplete.apply(this, arguments);
}
function ___PRIVATE_onWriteHandshakeComplete() {
    ___PRIVATE_onWriteHandshakeComplete = (0, $9OZ9j._)(function(e) {
        var t, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, n;
        return (0, $lF1I7.__generator)(this, function(_state) {
            t = __PRIVATE_ensureWriteStream(e);
            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // Send the write pipeline now that the stream is established.
                for(_iterator = e.v_[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    n = _step.value;
                    t.d_(n.mutations);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                2
            ];
        });
    });
    return ___PRIVATE_onWriteHandshakeComplete.apply(this, arguments);
}
function __PRIVATE_onMutationResult(e, t, n) {
    return ___PRIVATE_onMutationResult.apply(this, arguments);
}
function ___PRIVATE_onMutationResult() {
    ___PRIVATE_onMutationResult = (0, $9OZ9j._)(function(e, t, n) {
        var r, i;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = e.v_.shift(), i = MutationBatchResult.from(r, t, n);
                    return [
                        4,
                        __PRIVATE_executeWithRecovery(e, function() {
                            return e.remoteSyncer.applySuccessfulWrite(i);
                        })
                    ];
                case 1:
                    _state.sent();
                    // It's possible that with the completion of this mutation another
                    // slot has freed up.
                    return [
                        4,
                        __PRIVATE_fillWritePipeline(e)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_onMutationResult.apply(this, arguments);
}
function __PRIVATE_onWriteStreamClose(e, t) {
    return ___PRIVATE_onWriteStreamClose.apply(this, arguments);
}
function ___PRIVATE_onWriteStreamClose() {
    ___PRIVATE_onWriteStreamClose = (0, $9OZ9j._)(function(e, t) {
        var _tmp;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // If the write stream closed after the write handshake completes, a write
                    // operation failed and we fail the pending operation.
                    _tmp = t && __PRIVATE_ensureWriteStream(e).E_;
                    if (!_tmp) return [
                        3,
                        2
                    ];
                    // This error affects the actual write.
                    return [
                        4,
                        (function() {
                            var ___PRIVATE_handleWriteError = (0, $9OZ9j._)(function(e, t) {
                                var n;
                                return (0, $lF1I7.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!function __PRIVATE_isPermanentWriteError(e) {
                                                return __PRIVATE_isPermanentError(e) && e !== C.ABORTED;
                                            }(t.code)) return [
                                                3,
                                                3
                                            ];
                                            // This was a permanent error, the request itself was the problem
                                            // so it's not going to succeed if we resend it.
                                            n = e.v_.shift();
                                            // In this case it's also unlikely that the server itself is melting
                                            // down -- this was just a bad request so inhibit backoff on the next
                                            // restart.
                                            __PRIVATE_ensureWriteStream(e).t_();
                                            return [
                                                4,
                                                __PRIVATE_executeWithRecovery(e, function() {
                                                    return e.remoteSyncer.rejectFailedWrite(n.batchId, t);
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            // It's possible that with the completion of this mutation
                                            // another slot has freed up.
                                            return [
                                                4,
                                                __PRIVATE_fillWritePipeline(e)
                                            ];
                                        case 2:
                                            _state.sent();
                                            _state.label = 3;
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            function __PRIVATE_handleWriteError(e, t) {
                                return ___PRIVATE_handleWriteError.apply(this, arguments);
                            }
                            return __PRIVATE_handleWriteError;
                        })()(e, t)
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    _tmp, // The write stream might have been started by refilling the write
                    // pipeline for failed writes
                    __PRIVATE_shouldStartWriteStream(e) && __PRIVATE_startWriteStream(e);
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_onWriteStreamClose.apply(this, arguments);
}
function __PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    return ___PRIVATE_remoteStoreHandleCredentialChange.apply(this, arguments);
}
function ___PRIVATE_remoteStoreHandleCredentialChange() {
    ___PRIVATE_remoteStoreHandleCredentialChange = (0, $9OZ9j._)(function(e, t) {
        var n, r;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    n.asyncQueue.verifyOperationInProgress(), __PRIVATE_logDebug("RemoteStore", "RemoteStore received new credentials");
                    r = __PRIVATE_canUseNetwork(n);
                    // Tear down and re-create our network streams. This will ensure we get a
                    // fresh auth token for the new user and re-fill the write pipeline with
                    // new mutations from the LocalStore (since mutations are per-user).
                    n.M_.add(3 /* OfflineCause.CredentialChange */ );
                    return [
                        4,
                        __PRIVATE_disableNetworkInternal(n)
                    ];
                case 1:
                    _state.sent(), r && // Don't set the network status to Unknown if we are offline.
                    n.N_.set("Unknown" /* OnlineState.Unknown */ );
                    return [
                        4,
                        n.remoteSyncer.handleCredentialChange(t)
                    ];
                case 2:
                    _state.sent(), n.M_.delete(3 /* OfflineCause.CredentialChange */ );
                    return [
                        4,
                        __PRIVATE_enableNetworkInternal(n)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_remoteStoreHandleCredentialChange.apply(this, arguments);
}
function __PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    return ___PRIVATE_remoteStoreApplyPrimaryState.apply(this, arguments);
}
function ___PRIVATE_remoteStoreApplyPrimaryState() {
    ___PRIVATE_remoteStoreApplyPrimaryState = /**
 * Toggles the network state when the client gains or loses its primary lease.
 */ (0, $9OZ9j._)(function(e, t) {
        var n, _tmp, _tmp1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    if (!t) return [
                        3,
                        2
                    ];
                    n.M_.delete(2 /* OfflineCause.IsSecondary */ );
                    return [
                        4,
                        __PRIVATE_enableNetworkInternal(n)
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 2:
                    _tmp1 = t;
                    if (_tmp1) return [
                        3,
                        4
                    ];
                    n.M_.add(2 /* OfflineCause.IsSecondary */ );
                    return [
                        4,
                        __PRIVATE_disableNetworkInternal(n)
                    ];
                case 3:
                    _tmp1 = (_state.sent(), n.N_.set("Unknown" /* OnlineState.Unknown */ ));
                    _state.label = 4;
                case 4:
                    _tmp = _tmp1;
                    _state.label = 5;
                case 5:
                    _tmp;
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_remoteStoreApplyPrimaryState.apply(this, arguments);
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function __PRIVATE_ensureWatchStream(e) {
    return e.B_ || // Create stream (but note that it is not started yet).
    (e.B_ = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        var r = __PRIVATE_debugCast(e);
        return r.f_(), new __PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Po: __PRIVATE_onWatchStreamConnected.bind(null, e),
        To: __PRIVATE_onWatchStreamOpen.bind(null, e),
        Ao: __PRIVATE_onWatchStreamClose.bind(null, e),
        h_: __PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.x_.push(function() {
        var _ref = (0, $9OZ9j._)(function(t) {
            var _tmp;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!t) return [
                            3,
                            1
                        ];
                        _tmp = (e.B_.t_(), __PRIVATE_shouldStartWatchStream(e) ? __PRIVATE_startWatchStream(e) : e.N_.set("Unknown" /* OnlineState.Unknown */ ));
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            e.B_.stop()
                        ];
                    case 2:
                        _tmp = (_state.sent(), __PRIVATE_cleanUpWatchStreamState(e));
                        _state.label = 3;
                    case 3:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        });
        return function(t) {
            return _ref.apply(this, arguments);
        };
    }())), e.B_;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function __PRIVATE_ensureWriteStream(e) {
    return e.k_ || // Create stream (but note that it is not started yet).
    (e.k_ = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        var r = __PRIVATE_debugCast(e);
        return r.f_(), new __PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Po: function() {
            return Promise.resolve();
        },
        To: __PRIVATE_onWriteStreamOpen.bind(null, e),
        Ao: __PRIVATE_onWriteStreamClose.bind(null, e),
        R_: __PRIVATE_onWriteHandshakeComplete.bind(null, e),
        A_: __PRIVATE_onMutationResult.bind(null, e)
    }), e.x_.push(function() {
        var _ref = (0, $9OZ9j._)(function(t) {
            var _tmp;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!t) return [
                            3,
                            2
                        ];
                        e.k_.t_();
                        // This will start the write stream if necessary.
                        return [
                            4,
                            __PRIVATE_fillWritePipeline(e)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            e.k_.stop()
                        ];
                    case 3:
                        _tmp = (_state.sent(), e.v_.length > 0 && (__PRIVATE_logDebug("RemoteStore", "Stopping write stream with ".concat(e.v_.length, " pending writes")), e.v_ = []));
                        _state.label = 4;
                    case 4:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        });
        return function(t) {
            return _ref.apply(this, arguments);
        };
    }())), e.k_;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ var DelayedOperation = /*#__PURE__*/ function() {
    "use strict";
    function DelayedOperation(e, t, n, r, i) {
        (0, $19mwo._)(this, DelayedOperation);
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new __PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch(function(e) {});
    }
    (0, $6rpfc._)(DelayedOperation, [
        {
            key: "promise",
            get: function get() {
                return this.deferred.promise;
            }
        },
        {
            /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ key: "start",
            value: function start(e) {
                var _this = this;
                this.timerHandle = setTimeout(function() {
                    return _this.handleDelayElapsed();
                }, e);
            }
        },
        {
            /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ key: "skipDelay",
            value: function skipDelay() {
                return this.handleDelayElapsed();
            }
        },
        {
            /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ key: "cancel",
            value: function cancel(e) {
                null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new FirestoreError(C.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
            }
        },
        {
            key: "handleDelayElapsed",
            value: function handleDelayElapsed() {
                var _this = this;
                this.asyncQueue.enqueueAndForget(function() {
                    return null !== _this.timerHandle ? (_this.clearTimeout(), _this.op().then(function(e) {
                        return _this.deferred.resolve(e);
                    })) : Promise.resolve();
                });
            }
        },
        {
            key: "clearTimeout",
            value: function clearTimeout1() {
                null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
            }
        }
    ], [
        {
            key: "createAndSchedule",
            value: /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ function createAndSchedule(e, t, n, r, i) {
                var s = Date.now() + n, o = new DelayedOperation(e, t, s, r, i);
                return o.start(n), o;
            }
        }
    ]);
    return DelayedOperation;
}();
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function __PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if (__PRIVATE_logError("AsyncQueue", "".concat(t, ": ").concat(e)), __PRIVATE_isIndexedDbTransactionError(e)) return new FirestoreError(C.UNAVAILABLE, "".concat(t, ": ").concat(e));
    throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ var DocumentSet = /*#__PURE__*/ function() {
    "use strict";
    function DocumentSet(e) {
        (0, $19mwo._)(this, DocumentSet);
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? function(t, n) {
            return e(t, n) || DocumentKey.comparator(t.key, n.key);
        } : function(e, t) {
            return DocumentKey.comparator(e.key, t.key);
        }, this.keyedMap = documentMap(), this.sortedSet = new SortedMap(this.comparator);
    }
    (0, $6rpfc._)(DocumentSet, [
        {
            key: "has",
            value: function has(e) {
                return null != this.keyedMap.get(e);
            }
        },
        {
            key: "get",
            value: function get(e) {
                return this.keyedMap.get(e);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.sortedSet.minKey();
            }
        },
        {
            key: "last",
            value: function last() {
                return this.sortedSet.maxKey();
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.sortedSet.isEmpty();
            }
        },
        {
            /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ key: "indexOf",
            value: function indexOf(e) {
                var t = this.keyedMap.get(e);
                return t ? this.sortedSet.indexOf(t) : -1;
            }
        },
        {
            key: "size",
            get: function get() {
                return this.sortedSet.size;
            }
        },
        {
            /** Iterates documents in order defined by "comparator" */ key: "forEach",
            value: function forEach(e) {
                this.sortedSet.inorderTraversal(function(t, n) {
                    return e(t), !1;
                });
            }
        },
        {
            /** Inserts or updates a document with the same key */ key: "add",
            value: function add(e) {
                // First remove the element if we have it.
                var t = this.delete(e.key);
                return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
            }
        },
        {
            /** Deletes a document with a given key */ key: "delete",
            value: function _delete(e) {
                var t = this.get(e);
                return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                if (!(e instanceof DocumentSet)) return !1;
                if (this.size !== e.size) return !1;
                var t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
                for(; t.hasNext();){
                    var _$e = t.getNext().key, r = n.getNext().key;
                    if (!_$e.isEqual(r)) return !1;
                }
                return !0;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var e = [];
                return this.forEach(function(t) {
                    e.push(t.toString());
                }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
            }
        },
        {
            key: "copy",
            value: function copy(e, t) {
                var n = new DocumentSet;
                return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
            }
        }
    ], [
        {
            key: "emptySet",
            value: /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ function emptySet(e) {
                return new DocumentSet(e.comparator);
            }
        }
    ]);
    return DocumentSet;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ var __PRIVATE_DocumentChangeSet = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_DocumentChangeSet() {
        (0, $19mwo._)(this, __PRIVATE_DocumentChangeSet);
        this.q_ = new SortedMap(DocumentKey.comparator);
    }
    (0, $6rpfc._)(__PRIVATE_DocumentChangeSet, [
        {
            key: "track",
            value: function track(e) {
                var t = e.doc.key, n = this.q_.get(t);
                n ? // Merge the new change with the existing change.
                0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.q_ = this.q_.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.q_ = this.q_.insert(t, {
                    type: n.type,
                    doc: e.doc
                }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.q_ = this.q_.insert(t, {
                    type: 2 /* ChangeType.Modified */ ,
                    doc: e.doc
                }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.q_ = this.q_.insert(t, {
                    type: 0 /* ChangeType.Added */ ,
                    doc: e.doc
                }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.q_ = this.q_.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.q_ = this.q_.insert(t, {
                    type: 1 /* ChangeType.Removed */ ,
                    doc: n.doc
                }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.q_ = this.q_.insert(t, {
                    type: 2 /* ChangeType.Modified */ ,
                    doc: e.doc
                }) : // This includes these cases, which don't make sense:
                // Added->Added
                // Removed->Removed
                // Modified->Added
                // Removed->Modified
                // Metadata->Added
                // Removed->Metadata
                fail() : this.q_ = this.q_.insert(t, e);
            }
        },
        {
            key: "Q_",
            value: function Q_() {
                var e = [];
                return this.q_.inorderTraversal(function(t, n) {
                    e.push(n);
                }), e;
            }
        }
    ]);
    return __PRIVATE_DocumentChangeSet;
}();
var ViewSnapshot = /*#__PURE__*/ function() {
    "use strict";
    function ViewSnapshot(e, t, n, r, i, s, o, _, a) {
        (0, $19mwo._)(this, ViewSnapshot);
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = o, this.excludesMetadataChanges = _, this.hasCachedResults = a;
    }
    (0, $6rpfc._)(ViewSnapshot, [
        {
            key: "hasPendingWrites",
            get: function get() {
                return !this.mutatedKeys.isEmpty();
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && __PRIVATE_queryEquals(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
                var t = this.docChanges, n = e.docChanges;
                if (t.length !== n.length) return !1;
                for(var _$e = 0; _$e < t.length; _$e++)if (t[_$e].type !== n[_$e].type || !t[_$e].doc.isEqual(n[_$e].doc)) return !1;
                return !0;
            }
        }
    ], [
        {
            key: "fromInitialDocuments",
            value: /** Returns a view snapshot as if all documents in the snapshot were added. */ function fromInitialDocuments(e, t, n, r, i) {
                var s = [];
                return t.forEach(function(e) {
                    s.push({
                        type: 0 /* ChangeType.Added */ ,
                        doc: e
                    });
                }), new ViewSnapshot(e, t, DocumentSet.emptySet(t), s, n, r, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
            }
        }
    ]);
    return ViewSnapshot;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ var __PRIVATE_QueryListenersInfo = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_QueryListenersInfo() {
        (0, $19mwo._)(this, __PRIVATE_QueryListenersInfo);
        this.K_ = void 0, this.U_ = [];
    }
    (0, $6rpfc._)(__PRIVATE_QueryListenersInfo, [
        {
            // Helper methods that checks if the query has listeners that listening to remote store
            key: "W_",
            value: function W_() {
                return this.U_.some(function(e) {
                    return e.G_();
                });
            }
        }
    ]);
    return __PRIVATE_QueryListenersInfo;
}();
var __PRIVATE_EventManagerImpl = function __PRIVATE_EventManagerImpl() {
    "use strict";
    (0, $19mwo._)(this, __PRIVATE_EventManagerImpl);
    this.queries = new ObjectMap(function(e) {
        return __PRIVATE_canonifyQuery(e);
    }, __PRIVATE_queryEquals), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.z_ = new Set;
};
function __PRIVATE_eventManagerListen(e, t) {
    return ___PRIVATE_eventManagerListen.apply(this, arguments);
}
function ___PRIVATE_eventManagerListen() {
    ___PRIVATE_eventManagerListen = (0, $9OZ9j._)(function(e, t) {
        var n, r, i, s, e1, n1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    r = 3 /* ListenerSetupAction.NoActionRequired */ ;
                    i = t.query;
                    s = n.queries.get(i);
                    s ? !s.W_() && t.G_() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
                    (r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ ) : (s = new __PRIVATE_QueryListenersInfo, r = t.G_() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */  : 1 /* ListenerSetupAction.InitializeLocalListenOnly */ );
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        9,
                        ,
                        10
                    ]);
                    switch(r){
                        case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
                            return [
                                3,
                                2
                            ];
                        case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
                            return [
                                3,
                                4
                            ];
                        case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    return [
                        4,
                        n.onListen(i, /** enableRemoteListen= */ !0)
                    ];
                case 3:
                    s.K_ = _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    return [
                        4,
                        n.onListen(i, /** enableRemoteListen= */ !1)
                    ];
                case 5:
                    s.K_ = _state.sent();
                    return [
                        3,
                        8
                    ];
                case 6:
                    return [
                        4,
                        n.onFirstRemoteStoreListen(i)
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    e1 = _state.sent();
                    n1 = __PRIVATE_wrapInUserErrorIfRecoverable(e1, "Initialization of query '".concat(__PRIVATE_stringifyQuery(t.query), "' failed"));
                    return [
                        2,
                        void t.onError(n1)
                    ];
                case 10:
                    if (n.queries.set(i, s), s.U_.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
                    t.j_(n.onlineState), s.K_) t.H_(s.K_) && __PRIVATE_raiseSnapshotsInSyncEvent(n);
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_eventManagerListen.apply(this, arguments);
}
function __PRIVATE_eventManagerUnlisten(e, t) {
    return ___PRIVATE_eventManagerUnlisten.apply(this, arguments);
}
function ___PRIVATE_eventManagerUnlisten() {
    ___PRIVATE_eventManagerUnlisten = (0, $9OZ9j._)(function(e, t) {
        var n, r, i, s, _$e;
        return (0, $lF1I7.__generator)(this, function(_state) {
            n = __PRIVATE_debugCast(e), r = t.query;
            i = 3 /* ListenerRemovalAction.NoActionRequired */ ;
            s = n.queries.get(r);
            if (s) {
                _$e = s.U_.indexOf(t);
                _$e >= 0 && (s.U_.splice(_$e, 1), 0 === s.U_.length ? i = t.G_() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */  : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */  : !s.W_() && t.G_() && // The removed listener is the last one that sourced from watch.
                (i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ ));
            }
            switch(i){
                case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
                    return [
                        2,
                        (n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !0))
                    ];
                case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
                    return [
                        2,
                        (n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !1))
                    ];
                case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
                    return [
                        2,
                        n.onLastRemoteStoreUnlisten(r)
                    ];
                default:
                    return [
                        2
                    ];
            }
            return [
                2
            ];
        });
    });
    return ___PRIVATE_eventManagerUnlisten.apply(this, arguments);
}
function __PRIVATE_eventManagerOnWatchChange(e, t) {
    var n = __PRIVATE_debugCast(e);
    var r = !1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$e = _step.value;
            var _$t = _$e.query, i = n.queries.get(_$t);
            if (i) {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = i.U_[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _$t1 = _step1.value;
                        _$t1.H_(_$e) && (r = !0);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                i.K_ = _$e;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    r && __PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function __PRIVATE_eventManagerOnWatchError(e, t, n) {
    var r = __PRIVATE_debugCast(e), i = r.queries.get(t);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (i) try {
        for(var _iterator = i.U_[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$e = _step.value;
            _$e.onError(n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
// Call all global snapshot listeners that have been set.
function __PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.z_.forEach(function(e) {
        e.next();
    });
}
var ge, pe;
/** Listen to both cache and server changes */ (pe = ge || (ge = {})).J_ = "default", /** Listen to changes in cache only */ pe.Cache = "cache";
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ var __PRIVATE_QueryListener = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_QueryListener(e, t, n) {
        (0, $19mwo._)(this, __PRIVATE_QueryListener);
        this.query = e, this.Y_ = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.Z_ = !1, this.X_ = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    (0, $6rpfc._)(__PRIVATE_QueryListener, [
        {
            /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ key: "H_",
            value: function H_(e) {
                if (!this.options.includeMetadataChanges) {
                    // Remove the metadata only changes.
                    var t = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e.docChanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var n = _step.value;
                            3 /* ChangeType.Metadata */  !== n.type && t.push(n);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    e = new ViewSnapshot(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ !0, e.hasCachedResults);
                }
                var t1 = !1;
                return this.Z_ ? this.ea(e) && (this.Y_.next(e), t1 = !0) : this.ta(e, this.onlineState) && (this.na(e), t1 = !0), this.X_ = e, t1;
            }
        },
        {
            key: "onError",
            value: function onError(e) {
                this.Y_.error(e);
            }
        },
        {
            /** Returns whether a snapshot was raised. */ key: "j_",
            value: function j_(e) {
                this.onlineState = e;
                var t = !1;
                return this.X_ && !this.Z_ && this.ta(this.X_, e) && (this.na(this.X_), t = !0), t;
            }
        },
        {
            key: "ta",
            value: function ta(e, t) {
                // Always raise the first event when we're synced
                if (!e.fromCache) return !0;
                // Always raise event if listening to cache
                if (!this.G_()) return !0;
                // NOTE: We consider OnlineState.Unknown as online (it should become Offline
                // or Online if we wait long enough).
                var n = "Offline" /* OnlineState.Offline */  !== t;
                // Don't raise the event if we're online, aren't synced yet (checked
                // above) and are waiting for a sync.
                return (!this.options.ra || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
            // Raise data from cache if we have any documents, have cached results before,
            // or we are offline.
            }
        },
        {
            key: "ea",
            value: function ea(e) {
                // We don't need to handle includeDocumentMetadataChanges here because
                // the Metadata only changes have already been stripped out if needed.
                // At this point the only changes we will see are the ones we should
                // propagate.
                if (e.docChanges.length > 0) return !0;
                var t = this.X_ && this.X_.hasPendingWrites !== e.hasPendingWrites;
                return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
            // Generally we should have hit one of the cases above, but it's possible
            // to get here if there were only metadata docChanges and they got
            // stripped out.
            }
        },
        {
            key: "na",
            value: function na(e) {
                e = ViewSnapshot.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.Z_ = !0, this.Y_.next(e);
            }
        },
        {
            key: "G_",
            value: function G_() {
                return this.options.source !== ge.Cache;
            }
        }
    ]);
    return __PRIVATE_QueryListener;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ var __PRIVATE_SizedBundleElement = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SizedBundleElement(e, // How many bytes this element takes to store in the bundle.
    t) {
        (0, $19mwo._)(this, __PRIVATE_SizedBundleElement);
        this.ia = e, this.byteLength = t;
    }
    (0, $6rpfc._)(__PRIVATE_SizedBundleElement, [
        {
            key: "sa",
            value: function sa() {
                return "metadata" in this.ia;
            }
        }
    ]);
    return __PRIVATE_SizedBundleElement;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ var __PRIVATE_BundleConverterImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_BundleConverterImpl(e) {
        (0, $19mwo._)(this, __PRIVATE_BundleConverterImpl);
        this.serializer = e;
    }
    (0, $6rpfc._)(__PRIVATE_BundleConverterImpl, [
        {
            key: "Ps",
            value: function Ps(e) {
                return fromName(this.serializer, e);
            }
        },
        {
            /**
     * Converts a BundleDocument to a MutableDocument.
     */ key: "Is",
            value: function Is(e) {
                return e.metadata.exists ? __PRIVATE_fromDocument(this.serializer, e.document, !1) : MutableDocument.newNoDocument(this.Ps(e.metadata.name), this.Ts(e.metadata.readTime));
            }
        },
        {
            key: "Ts",
            value: function Ts(e) {
                return __PRIVATE_fromVersion(e);
            }
        }
    ]);
    return __PRIVATE_BundleConverterImpl;
}();
/**
 * A class to process the elements from a bundle, load them into local
 * storage and provide progress update while loading.
 */ var __PRIVATE_BundleLoader = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_BundleLoader(e, t, n) {
        (0, $19mwo._)(this, __PRIVATE_BundleLoader);
        this.oa = e, this.localStore = t, this.serializer = n, /** Batched queries to be saved into storage */ this.queries = [], /** Batched documents to be saved into storage */ this.documents = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = __PRIVATE_bundleInitialProgress(e);
    }
    (0, $6rpfc._)(__PRIVATE_BundleLoader, [
        {
            /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ key: "_a",
            value: function _a(e) {
                this.progress.bytesLoaded += e.byteLength;
                var t = this.progress.documentsLoaded;
                if (e.ia.namedQuery) this.queries.push(e.ia.namedQuery);
                else if (e.ia.documentMetadata) {
                    this.documents.push({
                        metadata: e.ia.documentMetadata
                    }), e.ia.documentMetadata.exists || ++t;
                    var n = ResourcePath.fromString(e.ia.documentMetadata.name);
                    this.collectionGroups.add(n.get(n.length - 2));
                } else e.ia.document && (this.documents[this.documents.length - 1].document = e.ia.document, ++t);
                return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, Object.assign({}, this.progress)) : null;
            }
        },
        {
            key: "aa",
            value: function aa(e) {
                var t = new Map, n = new __PRIVATE_BundleConverterImpl(this.serializer);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var r = _step.value;
                        if (r.metadata.queries) {
                            var _$e = n.Ps(r.metadata.name);
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = r.metadata.queries[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var n1 = _step1.value;
                                    var r1 = (t.get(n1) || __PRIVATE_documentKeySet()).add(_$e);
                                    t.set(n1, r1);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return t;
            }
        },
        {
            key: "complete",
            value: /**
     * Update the progress to 'Success' and return the updated progress.
     */ function complete() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var e, t, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, e1, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    __PRIVATE_localStoreApplyBundledDocuments(_this.localStore, new __PRIVATE_BundleConverterImpl(_this.serializer), _this.documents, _this.oa.id)
                                ];
                            case 1:
                                e = _state.sent(), t = _this.aa(_this.documents);
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = _this.queries[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                e1 = _step.value;
                                return [
                                    4,
                                    __PRIVATE_localStoreSaveNamedQuery(_this.localStore, e1, t.get(e1.name))
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    (_this.progress.taskState = "Success", {
                                        progress: _this.progress,
                                        ua: _this.collectionGroups,
                                        ca: e
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return __PRIVATE_BundleLoader;
}();
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function __PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_AddedLimboDocument = function __PRIVATE_AddedLimboDocument(e) {
    "use strict";
    (0, $19mwo._)(this, __PRIVATE_AddedLimboDocument);
    this.key = e;
};
var __PRIVATE_RemovedLimboDocument = function __PRIVATE_RemovedLimboDocument(e) {
    "use strict";
    (0, $19mwo._)(this, __PRIVATE_RemovedLimboDocument);
    this.key = e;
};
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ var __PRIVATE_View = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_View(e, /** Documents included in the remote target */ t) {
        (0, $19mwo._)(this, __PRIVATE_View);
        this.query = e, this.la = t, this.ha = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.Pa = __PRIVATE_documentKeySet(), /** Document Keys that have local changes */ this.mutatedKeys = __PRIVATE_documentKeySet(), this.Ia = __PRIVATE_newQueryComparator(e), this.Ta = new DocumentSet(this.Ia);
    }
    (0, $6rpfc._)(__PRIVATE_View, [
        {
            key: "Ea",
            get: /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ function get() {
                return this.la;
            }
        },
        {
            /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ key: "da",
            value: function da(e, t) {
                var _this = this;
                var n = t ? t.Aa : new __PRIVATE_DocumentChangeSet, r = t ? t.Ta : this.Ta;
                var i = t ? t.mutatedKeys : this.mutatedKeys, s = r, o = !1;
                // Track the last doc in a (full) limit. This is necessary, because some
                // update (a delete, or an update moving a doc past the old limit) might
                // mean there is some other document in the local cache that either should
                // come (1) between the old last limit doc and the new last document, in the
                // case of updates, or (2) after the new last document, in the case of
                // deletes. So we keep this doc at the old limit to compare the updates to.
                // Note that this should never get used in a refill (when previousChanges is
                // set), because there will only be adds -- no deletes or updates.
                var _ = "F" /* LimitType.First */  === this.query.limitType && r.size === this.query.limit ? r.last() : null, a = "L" /* LimitType.Last */  === this.query.limitType && r.size === this.query.limit ? r.first() : null;
                // Drop documents out to meet limit/limitToLast requirement.
                if (e.inorderTraversal(function(e, t) {
                    var u = r.get(e), c = __PRIVATE_queryMatches(_this.query, t) ? t : null, l = !!u && _this.mutatedKeys.has(u.key), h = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
                    // mutated during the lifetime of the view.
                    _this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
                    var P = !1;
                    // Calculate change
                    if (u && c) u.data.isEqual(c.data) ? l !== h && (n.track({
                        type: 3 /* ChangeType.Metadata */ ,
                        doc: c
                    }), P = !0) : _this.Ra(u, c) || (n.track({
                        type: 2 /* ChangeType.Modified */ ,
                        doc: c
                    }), P = !0, (_ && _this.Ia(c, _) > 0 || a && _this.Ia(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
                    // That means there may be some other doc in the local cache
                    // that should be included instead.
                    (o = !0));
                    else !u && c ? (n.track({
                        type: 0 /* ChangeType.Added */ ,
                        doc: c
                    }), P = !0) : u && !c && (n.track({
                        type: 1 /* ChangeType.Removed */ ,
                        doc: u
                    }), P = !0, (_ || a) && // A doc was removed from a full limit query. We'll need to
                    // requery from the local cache to see if we know about some other
                    // doc that should be in the results.
                    (o = !0));
                    P && (c ? (s = s.add(c), i = h ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
                }), null !== this.query.limit) for(; s.size > this.query.limit;){
                    var _$e = "F" /* LimitType.First */  === this.query.limitType ? s.last() : s.first();
                    s = s.delete(_$e.key), i = i.delete(_$e.key), n.track({
                        type: 1 /* ChangeType.Removed */ ,
                        doc: _$e
                    });
                }
                return {
                    Ta: s,
                    Aa: n,
                    Xi: o,
                    mutatedKeys: i
                };
            }
        },
        {
            key: "Ra",
            value: function Ra(e, t) {
                // We suppress the initial change event for documents that were modified as
                // part of a write acknowledgment (e.g. when the value of a server transform
                // is applied) as Watch will send us the same document again.
                // By suppressing the event, we only raise two user visible events (one with
                // `hasPendingWrites` and the final state of the document) instead of three
                // (one with `hasPendingWrites`, the modified document with
                // `hasPendingWrites` and the final state of the document).
                return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
            }
        },
        {
            /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
            key: "applyChanges",
            value: function applyChanges(e, t, n, r) {
                var _this = this;
                var i = this.Ta;
                this.Ta = e.Ta, this.mutatedKeys = e.mutatedKeys;
                // Sort changes based on type and query comparator
                var s = e.Aa.Q_();
                s.sort(function(e, t) {
                    return function __PRIVATE_compareChangeType(e, t) {
                        var order = function(e) {
                            switch(e){
                                case 0 /* ChangeType.Added */ :
                                    return 1;
                                case 2 /* ChangeType.Modified */ :
                                case 3 /* ChangeType.Metadata */ :
                                    // A metadata change is converted to a modified change at the public
                                    // api layer.  Since we sort by document key and then change type,
                                    // metadata and modified changes must be sorted equivalently.
                                    return 2;
                                case 1 /* ChangeType.Removed */ :
                                    return 0;
                                default:
                                    return fail();
                            }
                        };
                        return order(e) - order(t);
                    }(e.type, t.type) || _this.Ia(e.doc, t.doc);
                }), this.Va(n), r = null != r && r;
                var o = t && !r ? this.ma() : [], _ = 0 === this.Pa.size && this.current && !r ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , a = _ !== this.ha;
                // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
                // with the backend, and the query is not pending to reset due to existence filter mismatch.
                if (this.ha = _, 0 !== s.length || a) return {
                    snapshot: new ViewSnapshot(this.query, e.Ta, i, s, e.mutatedKeys, 0 /* SyncState.Local */  === _, a, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
                    fa: o
                };
                // no changes
                return {
                    fa: o
                };
            }
        },
        {
            /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ key: "j_",
            value: function j_(e) {
                return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
                // to refresh our syncState and generate a ViewChange as appropriate. We
                // are guaranteed to get a new TargetChange that sets `current` back to
                // true once the client is back online.
                (this.current = !1, this.applyChanges({
                    Ta: this.Ta,
                    Aa: new __PRIVATE_DocumentChangeSet,
                    mutatedKeys: this.mutatedKeys,
                    Xi: !1
                }, /* limboResolutionEnabled= */ !1)) : {
                    fa: []
                };
            }
        },
        {
            /**
     * Returns whether the doc for the given key should be in limbo.
     */ key: "ga",
            value: function ga(e) {
                // If the remote end says it's part of this query, it's not in limbo.
                return !this.la.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
                !!this.Ta.has(e) && !this.Ta.get(e).hasLocalMutations;
            }
        },
        {
            /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ key: "Va",
            value: function Va(e) {
                var _this = this;
                e && (e.addedDocuments.forEach(function(e) {
                    return _this.la = _this.la.add(e);
                }), e.modifiedDocuments.forEach(function(e) {}), e.removedDocuments.forEach(function(e) {
                    return _this.la = _this.la.delete(e);
                }), this.current = e.current);
            }
        },
        {
            key: "ma",
            value: function ma() {
                var _this = this;
                // We can only determine limbo documents when we're in-sync with the server.
                if (!this.current) return [];
                // TODO(klimt): Do this incrementally so that it's not quadratic when
                // updating many documents.
                var e = this.Pa;
                this.Pa = __PRIVATE_documentKeySet(), this.Ta.forEach(function(e) {
                    _this.ga(e.key) && (_this.Pa = _this.Pa.add(e.key));
                });
                // Diff the new limbo docs with the old limbo docs.
                var t = [];
                return e.forEach(function(e) {
                    _this.Pa.has(e) || t.push(new __PRIVATE_RemovedLimboDocument(e));
                }), this.Pa.forEach(function(n) {
                    e.has(n) || t.push(new __PRIVATE_AddedLimboDocument(n));
                }), t;
            }
        },
        {
            /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
            key: "pa",
            value: function pa(e) {
                this.la = e.hs, this.Pa = __PRIVATE_documentKeySet();
                var t = this.da(e.documents);
                return this.applyChanges(t, /* limboResolutionEnabled= */ !0);
            }
        },
        {
            /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
            key: "ya",
            value: function ya() {
                return ViewSnapshot.fromInitialDocuments(this.query, this.Ta, this.mutatedKeys, 0 /* SyncState.Local */  === this.ha, this.hasCachedResults);
            }
        }
    ]);
    return __PRIVATE_View;
}();
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ var __PRIVATE_QueryView = function __PRIVATE_QueryView(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n) {
    "use strict";
    (0, $19mwo._)(this, __PRIVATE_QueryView);
    this.query = e, this.targetId = t, this.view = n;
};
/** Tracks a limbo resolution. */ var LimboResolution = function LimboResolution(e) {
    "use strict";
    (0, $19mwo._)(this, LimboResolution);
    this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.wa = !1;
};
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ var __PRIVATE_SyncEngineImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SyncEngineImpl(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s) {
        (0, $19mwo._)(this, __PRIVATE_SyncEngineImpl);
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.Sa = {}, this.ba = new ObjectMap(function(e) {
            return __PRIVATE_canonifyQuery(e);
        }, __PRIVATE_queryEquals), this.Da = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.Ca = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.va = new SortedMap(DocumentKey.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.Fa = new Map, this.Ma = new __PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.xa = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.Oa = new Map, this.Na = __PRIVATE_TargetIdGenerator.Ln(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.La = void 0;
    }
    (0, $6rpfc._)(__PRIVATE_SyncEngineImpl, [
        {
            key: "isPrimaryClient",
            get: function get() {
                return !0 === this.La;
            }
        }
    ]);
    return __PRIVATE_SyncEngineImpl;
}();
function __PRIVATE_syncEngineListen(e, t) {
    return ___PRIVATE_syncEngineListen.apply(this, arguments);
}
function ___PRIVATE_syncEngineListen() {
    ___PRIVATE_syncEngineListen = /**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ (0, $9OZ9j._)(function(e, t) {
        var n, r, i, s, _tmp;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : !0;
                    r = __PRIVATE_ensureWatchCallbacks(e);
                    s = r.ba.get(t);
                    if (!s) return [
                        3,
                        1
                    ];
                    // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
                    // already exists when EventManager calls us for the first time. This
                    // happens when the primary tab is already listening to this query on
                    // behalf of another tab and the user of the primary also starts listening
                    // to the query. EventManager will not have an assigned target ID in this
                    // case and calls `listen` to obtain this ID.
                    _tmp = (r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.ya());
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        __PRIVATE_allocateTargetAndMaybeListen(r, t, n, /** shouldInitializeView= */ !0)
                    ];
                case 2:
                    _tmp = i = _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        (_tmp, i)
                    ];
            }
        });
    });
    return ___PRIVATE_syncEngineListen.apply(this, arguments);
}
function __PRIVATE_triggerRemoteStoreListen(e, t) {
    return ___PRIVATE_triggerRemoteStoreListen.apply(this, arguments);
}
function ___PRIVATE_triggerRemoteStoreListen() {
    ___PRIVATE_triggerRemoteStoreListen = /** Query has been listening to the cache, and tries to initiate the remote store listen */ (0, $9OZ9j._)(function(e, t) {
        var n;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_ensureWatchCallbacks(e);
                    return [
                        4,
                        __PRIVATE_allocateTargetAndMaybeListen(n, t, /** shouldListenToRemote= */ !0, /** shouldInitializeView= */ !1)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_triggerRemoteStoreListen.apply(this, arguments);
}
function __PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    return ___PRIVATE_allocateTargetAndMaybeListen.apply(this, arguments);
}
function ___PRIVATE_allocateTargetAndMaybeListen() {
    ___PRIVATE_allocateTargetAndMaybeListen = (0, $9OZ9j._)(function(e, t, n, r) {
        var i, s, o, _, _tmp;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __PRIVATE_localStoreAllocateTarget(e.localStore, __PRIVATE_queryToTarget(t))
                    ];
                case 1:
                    i = _state.sent(), s = i.targetId, o = n ? e.sharedClientState.addLocalQueryTarget(s) : "not-current";
                    _tmp = r;
                    if (!_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        __PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === o, i.resumeToken)
                    ];
                case 2:
                    _tmp = _ = _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        (_tmp, e.isPrimaryClient && n && __PRIVATE_remoteStoreListen(e.remoteStore, i), _)
                    ];
            }
        });
    });
    return ___PRIVATE_allocateTargetAndMaybeListen.apply(this, arguments);
}
function __PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    return ___PRIVATE_initializeViewAndComputeSnapshot.apply(this, arguments);
}
function ___PRIVATE_initializeViewAndComputeSnapshot() {
    ___PRIVATE_initializeViewAndComputeSnapshot = /**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ (0, $9OZ9j._)(function(e, t, n, r, i) {
        var s, o, _, a, u, c;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
                    // targets based on view changes. This allows us to only depend on Limbo
                    // changes when user code includes queries.
                    e.Ba = function(t, n, r) {
                        return (function() {
                            var ___PRIVATE_applyDocChanges = (0, $9OZ9j._)(function(e, t, n, r) {
                                var _$i, _tmp, s, o, _;
                                return (0, $lF1I7.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _$i = t.view.da(n);
                                            _tmp = _$i.Xi;
                                            if (!_tmp) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                __PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ !1).then(function(param) {
                                                    var _$e = param.documents;
                                                    return t.view.da(_$e, _$i);
                                                })
                                            ];
                                        case 1:
                                            // The query has a limit and some docs were removed, so we need
                                            // to re-run the query against the local store to make sure we
                                            // didn't lose any good docs that had been past the limit.
                                            _tmp = _$i = _state.sent();
                                            _state.label = 2;
                                        case 2:
                                            _tmp;
                                            s = r && r.targetChanges.get(t.targetId), o = r && null != r.targetMismatches.get(t.targetId), _ = t.view.applyChanges(_$i, /* limboResolutionEnabled= */ e.isPrimaryClient, s, o);
                                            return [
                                                2,
                                                (__PRIVATE_updateTrackedLimbos(e, t.targetId, _.fa), _.snapshot)
                                            ];
                                    }
                                });
                            });
                            function __PRIVATE_applyDocChanges(e, t, n, r) {
                                return ___PRIVATE_applyDocChanges.apply(this, arguments);
                            }
                            return __PRIVATE_applyDocChanges;
                        })()(e, t, n, r);
                    };
                    return [
                        4,
                        __PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ !0)
                    ];
                case 1:
                    s = _state.sent(), o = new __PRIVATE_View(t, s.hs), _ = o.da(s.documents), a = TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = o.applyChanges(_, /* limboResolutionEnabled= */ e.isPrimaryClient, a);
                    __PRIVATE_updateTrackedLimbos(e, n, u.fa);
                    c = new __PRIVATE_QueryView(t, n, o);
                    return [
                        2,
                        (e.ba.set(t, c), e.Da.has(n) ? e.Da.get(n).push(t) : e.Da.set(n, [
                            t
                        ]), u.snapshot)
                    ];
            }
        });
    });
    return ___PRIVATE_initializeViewAndComputeSnapshot.apply(this, arguments);
}
function __PRIVATE_syncEngineUnlisten(e, t, n) {
    return ___PRIVATE_syncEngineUnlisten.apply(this, arguments);
}
function ___PRIVATE_syncEngineUnlisten() {
    ___PRIVATE_syncEngineUnlisten = /** Stops listening to the query. */ (0, $9OZ9j._)(function(e, t, n) {
        var r, i, s, _tmp;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_debugCast(e), i = r.ba.get(t), s = r.Da.get(i.targetId);
                    if (s.length > 1) return [
                        2,
                        (r.Da.set(i.targetId, s.filter(function(e) {
                            return !__PRIVATE_queryEquals(e, t);
                        })), void r.ba.delete(t))
                    ];
                    if (!r.isPrimaryClient) return [
                        3,
                        3
                    ];
                    // We need to remove the local query target first to allow us to verify
                    // whether any other client is still interested in this target.
                    r.sharedClientState.removeLocalQueryTarget(i.targetId);
                    _tmp = r.sharedClientState.isActiveQueryTarget(i.targetId);
                    if (_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        __PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !1).then(function() {
                            r.sharedClientState.clearQueryState(i.targetId), n && __PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), __PRIVATE_removeAndCleanupTarget(r, i.targetId);
                        }).catch(__PRIVATE_ignoreIfPrimaryLeaseLoss)
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    _tmp;
                    return [
                        3,
                        5
                    ];
                case 3:
                    __PRIVATE_removeAndCleanupTarget(r, i.targetId);
                    return [
                        4,
                        __PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !0)
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_syncEngineUnlisten.apply(this, arguments);
}
function __PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    return ___PRIVATE_triggerRemoteStoreUnlisten.apply(this, arguments);
}
function ___PRIVATE_triggerRemoteStoreUnlisten() {
    ___PRIVATE_triggerRemoteStoreUnlisten = /** Unlistens to the remote store while still listening to the cache. */ (0, $9OZ9j._)(function(e, t) {
        var n, r, i;
        return (0, $lF1I7.__generator)(this, function(_state) {
            n = __PRIVATE_debugCast(e), r = n.ba.get(t), i = n.Da.get(r.targetId);
            n.isPrimaryClient && 1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
            // watch target.
            (n.sharedClientState.removeLocalQueryTarget(r.targetId), __PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
            return [
                2
            ];
        });
    });
    return ___PRIVATE_triggerRemoteStoreUnlisten.apply(this, arguments);
}
function __PRIVATE_syncEngineWrite(e, t, n) {
    return ___PRIVATE_syncEngineWrite.apply(this, arguments);
}
function ___PRIVATE_syncEngineWrite() {
    ___PRIVATE_syncEngineWrite = /**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ (0, $9OZ9j._)(function(e, t, n) {
        var r, _$e, e1, _$t;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_syncEngineEnsureWriteCallbacks(e);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        function __PRIVATE_localStoreWriteLocally(e, t) {
                            var _$n = __PRIVATE_debugCast(e), r = Timestamp.now(), i = t.reduce(function(e, t) {
                                return e.add(t.key);
                            }, __PRIVATE_documentKeySet());
                            var s, o;
                            return _$n.persistence.runTransaction("Locally write mutations", "readwrite", function(e) {
                                // Figure out which keys do not have a remote version in the cache, this
                                // is needed to create the right overlay mutation: if no remote version
                                // presents, we do not need to create overlays as patch mutations.
                                // TODO(Overlay): Is there a better way to determine this? Using the
                                //  document version does not work because local mutations set them back
                                //  to 0.
                                var _ = __PRIVATE_mutableDocumentMap(), a = __PRIVATE_documentKeySet();
                                return _$n.os.getEntries(e, i).next(function(e) {
                                    _ = e, _.forEach(function(e, t) {
                                        t.isValidDocument() || (a = a.add(e));
                                    });
                                }).next(function() {
                                    return _$n.localDocuments.getOverlayedDocuments(e, _);
                                }).next(function(i) {
                                    s = i;
                                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                                    // we record the base state in a separate patch mutation. This is
                                    // later used to guarantee consistent values and prevents flicker
                                    // even if the backend sends us an update that already includes our
                                    // transform.
                                    var o = [];
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var _$e = _step.value;
                                            var _$t = __PRIVATE_mutationExtractBaseValue(_$e, s.get(_$e.key).overlayedDocument);
                                            null != _$t && // NOTE: The base state should only be applied if there's some
                                            // existing document to override, so use a Precondition of
                                            // exists=true
                                            o.push(new __PRIVATE_PatchMutation(_$e.key, _$t, __PRIVATE_extractFieldMask(_$t.value.mapValue), Precondition.exists(!0)));
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    return _$n.mutationQueue.addMutationBatch(e, r, o, t);
                                }).next(function(t) {
                                    o = t;
                                    var r = t.applyToLocalDocumentSet(s, a);
                                    return _$n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                                });
                            }).then(function() {
                                return {
                                    batchId: o.batchId,
                                    changes: __PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                                };
                            });
                        }(r.localStore, t)
                    ];
                case 2:
                    _$e = _state.sent();
                    r.sharedClientState.addPendingMutation(_$e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
                        var r = e.xa[e.currentUser.toKey()];
                        r || (r = new SortedMap(__PRIVATE_primitiveComparator));
                        r = r.insert(t, n), e.xa[e.currentUser.toKey()] = r;
                    }(r, _$e.batchId, n);
                    return [
                        4,
                        __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, _$e.changes)
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        __PRIVATE_fillWritePipeline(r.remoteStore)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 5:
                    e1 = _state.sent();
                    // If we can't persist the mutation, we reject the user callback and
                    // don't send the mutation. The user can then retry the write.
                    _$t = __PRIVATE_wrapInUserErrorIfRecoverable(e1, "Failed to persist write");
                    n.reject(_$t);
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_syncEngineWrite.apply(this, arguments);
}
function __PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    return ___PRIVATE_syncEngineApplyRemoteEvent.apply(this, arguments);
}
function ___PRIVATE_syncEngineApplyRemoteEvent() {
    ___PRIVATE_syncEngineApplyRemoteEvent = /**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ (0, $9OZ9j._)(function(e, t) {
        var n, _$e, e1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        6
                    ]);
                    return [
                        4,
                        __PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t)
                    ];
                case 2:
                    _$e = _state.sent();
                    // Update `receivedDocument` as appropriate for any limbo targets.
                    t.targetChanges.forEach(function(e, t) {
                        var r = n.Fa.get(t);
                        r && // Since this is a limbo resolution lookup, it's for a single document
                        // and it could be added, modified, or removed, but not a combination.
                        (__PRIVATE_hardAssert(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1), e.addedDocuments.size > 0 ? r.wa = !0 : e.modifiedDocuments.size > 0 ? __PRIVATE_hardAssert(r.wa) : e.removedDocuments.size > 0 && (__PRIVATE_hardAssert(r.wa), r.wa = !1));
                    });
                    return [
                        4,
                        __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, _$e, t)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    e1 = _state.sent();
                    return [
                        4,
                        __PRIVATE_ignoreIfPrimaryLeaseLoss(e1)
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_syncEngineApplyRemoteEvent.apply(this, arguments);
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function __PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    var r = __PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        var _$e = [];
        r.ba.forEach(function(n, r) {
            var i = r.view.j_(t);
            i.snapshot && _$e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            var _$n = __PRIVATE_debugCast(e);
            _$n.onlineState = t;
            var r = !1;
            _$n.queries.forEach(function(e, n) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = n.U_[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        // Run global snapshot listeners if a consistent snapshot has been emitted.
                        _$e.j_(t) && (r = !0);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }), r && __PRIVATE_raiseSnapshotsInSyncEvent(_$n);
        }(r.eventManager, t), _$e.length && r.Sa.h_(_$e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
function __PRIVATE_syncEngineRejectListen(e, t, n) {
    return ___PRIVATE_syncEngineRejectListen.apply(this, arguments);
}
function ___PRIVATE_syncEngineRejectListen() {
    ___PRIVATE_syncEngineRejectListen = /**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ (0, $9OZ9j._)(function(e, t, n) {
        var r, i, s, _$e, _$n, i1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_debugCast(e);
                    // PORTING NOTE: Multi-tab only.
                    r.sharedClientState.updateQueryState(t, "rejected", n);
                    i = r.Fa.get(t), s = i && i.key;
                    if (!s) return [
                        3,
                        2
                    ];
                    // TODO(klimt): We really only should do the following on permission
                    // denied errors, but we don't have the cause code here.
                    // It's a limbo doc. Create a synthetic event saying it was deleted.
                    // This is kind of a hack. Ideally, we would have a method in the local
                    // store to purge a document. However, it would be tricky to keep all of
                    // the local store's invariants with another method.
                    _$e = new SortedMap(DocumentKey.comparator);
                    // TODO(b/217189216): This limbo document should ideally have a read time,
                    // so that it is picked up by any read-time based scans. The backend,
                    // however, does not send a read time for target removals.
                    _$e = _$e.insert(s, MutableDocument.newNoDocument(s, SnapshotVersion.min()));
                    _$n = __PRIVATE_documentKeySet().add(s), i1 = new RemoteEvent(SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new SortedMap(__PRIVATE_primitiveComparator), _$e, _$n);
                    return [
                        4,
                        __PRIVATE_syncEngineApplyRemoteEvent(r, i1)
                    ];
                case 1:
                    _state.sent(), // Since this query failed, we won't want to manually unlisten to it.
                    // We only remove it from bookkeeping after we successfully applied the
                    // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
                    // this query when the RemoteStore restarts the Watch stream, which should
                    // re-trigger the target failure.
                    r.va = r.va.remove(s), r.Fa.delete(t), __PRIVATE_pumpEnqueuedLimboResolutions(r);
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        __PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ !1).then(function() {
                            return __PRIVATE_removeAndCleanupTarget(r, t, n);
                        }).catch(__PRIVATE_ignoreIfPrimaryLeaseLoss)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_syncEngineRejectListen.apply(this, arguments);
}
function __PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    return ___PRIVATE_syncEngineApplySuccessfulWrite.apply(this, arguments);
}
function ___PRIVATE_syncEngineApplySuccessfulWrite() {
    ___PRIVATE_syncEngineApplySuccessfulWrite = (0, $9OZ9j._)(function(e, t) {
        var n, r, _$e, e1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e), r = t.batch.batchId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        6
                    ]);
                    return [
                        4,
                        __PRIVATE_localStoreAcknowledgeBatch(n.localStore, t)
                    ];
                case 2:
                    _$e = _state.sent();
                    // The local store may or may not be able to apply the write result and
                    // raise events immediately (depending on whether the watcher is caught
                    // up), so we raise user callbacks first so that they consistently happen
                    // before listen events.
                    __PRIVATE_processUserCallback(n, r, /*error=*/ null), __PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged");
                    return [
                        4,
                        __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, _$e)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    e1 = _state.sent();
                    return [
                        4,
                        __PRIVATE_ignoreIfPrimaryLeaseLoss(e1)
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_syncEngineApplySuccessfulWrite.apply(this, arguments);
}
function __PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    return ___PRIVATE_syncEngineRejectFailedWrite.apply(this, arguments);
}
function ___PRIVATE_syncEngineRejectFailedWrite() {
    ___PRIVATE_syncEngineRejectFailedWrite = (0, $9OZ9j._)(function(e, t, n) {
        var r, _$e, n1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_debugCast(e);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        6
                    ]);
                    return [
                        4,
                        function __PRIVATE_localStoreRejectBatch(e, t) {
                            var _$n = __PRIVATE_debugCast(e);
                            return _$n.persistence.runTransaction("Reject batch", "readwrite-primary", function(e) {
                                var r;
                                return _$n.mutationQueue.lookupMutationBatch(e, t).next(function(t) {
                                    return __PRIVATE_hardAssert(null !== t), r = t.keys(), _$n.mutationQueue.removeMutationBatch(e, t);
                                }).next(function() {
                                    return _$n.mutationQueue.performConsistencyCheck(e);
                                }).next(function() {
                                    return _$n.documentOverlayCache.removeOverlaysForBatchId(e, r, t);
                                }).next(function() {
                                    return _$n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r);
                                }).next(function() {
                                    return _$n.localDocuments.getDocuments(e, r);
                                });
                            });
                        }(r.localStore, t)
                    ];
                case 2:
                    _$e = _state.sent();
                    // The local store may or may not be able to apply the write result and
                    // raise events immediately (depending on whether the watcher is caught up),
                    // so we raise user callbacks first so that they consistently happen before
                    // listen events.
                    __PRIVATE_processUserCallback(r, t, n), __PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n);
                    return [
                        4,
                        __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, _$e)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    n1 = _state.sent();
                    return [
                        4,
                        __PRIVATE_ignoreIfPrimaryLeaseLoss(n1)
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_syncEngineRejectFailedWrite.apply(this, arguments);
}
function __PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    return ___PRIVATE_syncEngineRegisterPendingWritesCallback.apply(this, arguments);
}
function ___PRIVATE_syncEngineRegisterPendingWritesCallback() {
    ___PRIVATE_syncEngineRegisterPendingWritesCallback = /**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ (0, $9OZ9j._)(function(e, t) {
        var n, _$e, r, e1, n1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    __PRIVATE_canUseNetwork(n.remoteStore) || __PRIVATE_logDebug("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
                            var _$t = __PRIVATE_debugCast(e);
                            return _$t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", function(e) {
                                return _$t.mutationQueue.getHighestUnacknowledgedBatchId(e);
                            });
                        }(n.localStore)
                    ];
                case 2:
                    _$e = _state.sent();
                    if (-1 === _$e) // Trigger the callback right away if there is no pending writes at the moment.
                    return [
                        2,
                        void t.resolve()
                    ];
                    r = n.Oa.get(_$e) || [];
                    r.push(t), n.Oa.set(_$e, r);
                    return [
                        3,
                        4
                    ];
                case 3:
                    e1 = _state.sent();
                    n1 = __PRIVATE_wrapInUserErrorIfRecoverable(e1, "Initialization of waitForPendingWrites() operation failed");
                    t.reject(n1);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_syncEngineRegisterPendingWritesCallback.apply(this, arguments);
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function __PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.Oa.get(t) || []).forEach(function(e) {
        e.resolve();
    }), e.Oa.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function __PRIVATE_processUserCallback(e, t, n) {
    var r = __PRIVATE_debugCast(e);
    var i = r.xa[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        var _$e = i.get(t);
        _$e && (n ? _$e.reject(n) : _$e.resolve(), i = i.remove(t)), r.xa[r.currentUser.toKey()] = i;
    }
}
function __PRIVATE_removeAndCleanupTarget(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    e.sharedClientState.removeLocalQueryTarget(t);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e.Da.get(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            e.ba.delete(r), n && e.Sa.ka(r, n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (e.Da.delete(t), e.isPrimaryClient) e.Ma.Vr(t).forEach(function(t) {
        e.Ma.containsKey(t) || // We removed the last reference for this key
        __PRIVATE_removeLimboTarget(e, t);
    });
}
function __PRIVATE_removeLimboTarget(e, t) {
    e.Ca.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    var n = e.va.get(t);
    null !== n && (__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.va = e.va.remove(t), e.Fa.delete(n), __PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function __PRIVATE_updateTrackedLimbos(e, t, n) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            if (r instanceof __PRIVATE_AddedLimboDocument) e.Ma.addReference(r.key, t), __PRIVATE_trackLimboChange(e, r);
            else if (r instanceof __PRIVATE_RemovedLimboDocument) {
                __PRIVATE_logDebug("SyncEngine", "Document no longer in limbo: " + r.key), e.Ma.removeReference(r.key, t);
                e.Ma.containsKey(r.key) || // We removed the last reference for this key
                __PRIVATE_removeLimboTarget(e, r.key);
            } else fail();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function __PRIVATE_trackLimboChange(e, t) {
    var n = t.key, r = n.path.canonicalString();
    e.va.get(n) || e.Ca.has(r) || (__PRIVATE_logDebug("SyncEngine", "New document in limbo: " + n), e.Ca.add(r), __PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function __PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.Ca.size > 0 && e.va.size < e.maxConcurrentLimboResolutions;){
        var t = e.Ca.values().next().value;
        e.Ca.delete(t);
        var n = new DocumentKey(ResourcePath.fromString(t)), r = e.Na.next();
        e.Fa.set(r, new LimboResolution(n)), e.va = e.va.insert(n, r), __PRIVATE_remoteStoreListen(e.remoteStore, new TargetData(__PRIVATE_queryToTarget(__PRIVATE_newQueryForPath(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , __PRIVATE_ListenSequence.oe));
    }
}
function __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    return ___PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore.apply(this, arguments);
}
function ___PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore() {
    ___PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore = (0, $9OZ9j._)(function(e, t, n) {
        var r, i, s, o, _tmp;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_debugCast(e), i = [], s = [], o = [];
                    _tmp = r.ba.isEmpty();
                    if (_tmp) return [
                        3,
                        3
                    ];
                    r.ba.forEach(function(e, _) {
                        o.push(r.Ba(_, t, n).then(function(e) {
                            var _$t;
                            // If there are changes, or we are handling a global snapshot, notify
                            // secondary clients to update query state.
                            if ((e || n) && r.isPrimaryClient) {
                                // Query state is set to `current` if:
                                // - There is a view change and it is up-to-date, or,
                                // - There is a global snapshot, the Target is current, and no changes to be resolved
                                var i1 = e ? !e.fromCache : null === (_$t = null == n ? void 0 : n.targetChanges.get(_.targetId)) || void 0 === _$t ? void 0 : _$t.current;
                                r.sharedClientState.updateQueryState(_.targetId, i1 ? "current" : "not-current");
                            }
                            // Update views if there are actual changes.
                            if (e) {
                                i.push(e);
                                var _$t1 = __PRIVATE_LocalViewChanges.Ki(_.targetId, e);
                                s.push(_$t1);
                            }
                        }));
                    });
                    return [
                        4,
                        Promise.all(o)
                    ];
                case 1:
                    _state.sent(), r.Sa.h_(i);
                    return [
                        4,
                        (function() {
                            var ___PRIVATE_localStoreNotifyLocalViewChanges = (0, $9OZ9j._)(function(e, t) {
                                var n, e1, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e, _$t, _$e1, r, i;
                                return (0, $lF1I7.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            n = __PRIVATE_debugCast(e);
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4,
                                                n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", function(e) {
                                                    return PersistencePromise.forEach(t, function(t) {
                                                        return PersistencePromise.forEach(t.qi, function(r) {
                                                            return n.persistence.referenceDelegate.addReference(e, t.targetId, r);
                                                        }).next(function() {
                                                            return PersistencePromise.forEach(t.Qi, function(r) {
                                                                return n.persistence.referenceDelegate.removeReference(e, t.targetId, r);
                                                            });
                                                        });
                                                    });
                                                })
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                3,
                                                4
                                            ];
                                        case 3:
                                            e1 = _state.sent();
                                            if (!__PRIVATE_isIndexedDbTransactionError(e1)) throw e1;
                                            // If `notifyLocalViewChanges` fails, we did not advance the sequence
                                            // number for the documents that were included in this transaction.
                                            // This might trigger them to be deleted earlier than they otherwise
                                            // would have, but it should not invalidate the integrity of the data.
                                            __PRIVATE_logDebug("LocalStore", "Failed to update sequence numbers: " + e1);
                                            return [
                                                3,
                                                4
                                            ];
                                        case 4:
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(_iterator = t[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    _$e = _step.value;
                                                    _$t = _$e.targetId;
                                                    if (!_$e.fromCache) {
                                                        _$e1 = n.ns.get(_$t), r = _$e1.snapshotVersion, i = _$e1.withLastLimboFreeSnapshotVersion(r);
                                                        // Advance the last limbo free snapshot version
                                                        n.ns = n.ns.insert(_$t, i);
                                                    }
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
                                return ___PRIVATE_localStoreNotifyLocalViewChanges.apply(this, arguments);
                            }
                            return __PRIVATE_localStoreNotifyLocalViewChanges;
                        })()(r.localStore, s)
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    _tmp;
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore.apply(this, arguments);
}
function __PRIVATE_syncEngineHandleCredentialChange(e, t) {
    return ___PRIVATE_syncEngineHandleCredentialChange.apply(this, arguments);
}
function ___PRIVATE_syncEngineHandleCredentialChange() {
    ___PRIVATE_syncEngineHandleCredentialChange = (0, $9OZ9j._)(function(e, t) {
        var n, _$e;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    if (!!n.currentUser.isEqual(t)) return [
                        3,
                        3
                    ];
                    __PRIVATE_logDebug("SyncEngine", "User change. New user:", t.toKey());
                    return [
                        4,
                        __PRIVATE_localStoreHandleUserChange(n.localStore, t)
                    ];
                case 1:
                    _$e = _state.sent();
                    n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
                    function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
                        e.Oa.forEach(function(e) {
                            e.forEach(function(e) {
                                e.reject(new FirestoreError(C.CANCELLED, t));
                            });
                        }), e.Oa.clear();
                    }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
                    n.sharedClientState.handleUserChange(t, _$e.removedBatchIds, _$e.addedBatchIds);
                    return [
                        4,
                        __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, _$e.us)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_syncEngineHandleCredentialChange.apply(this, arguments);
}
function __PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    var n = __PRIVATE_debugCast(e), r = n.Fa.get(t);
    if (r && r.wa) return __PRIVATE_documentKeySet().add(r.key);
    {
        var _$e = __PRIVATE_documentKeySet();
        var r1 = n.Da.get(t);
        if (!r1) return _$e;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = r1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$t = _step.value;
                var r2 = n.ba.get(_$t);
                _$e = _$e.unionWith(r2.view.Ea);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _$e;
    }
}
function __PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    return ___PRIVATE_synchronizeViewAndComputeSnapshot.apply(this, arguments);
}
function ___PRIVATE_synchronizeViewAndComputeSnapshot() {
    ___PRIVATE_synchronizeViewAndComputeSnapshot = /**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ (0, $9OZ9j._)(function(e, t) {
        var n, r, i;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    return [
                        4,
                        __PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ !0)
                    ];
                case 1:
                    r = _state.sent(), i = t.view.pa(r);
                    return [
                        2,
                        (n.isPrimaryClient && __PRIVATE_updateTrackedLimbos(n, t.targetId, i.fa), i)
                    ];
            }
        });
    });
    return ___PRIVATE_synchronizeViewAndComputeSnapshot.apply(this, arguments);
}
function __PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    return ___PRIVATE_syncEngineSynchronizeWithChangedDocuments.apply(this, arguments);
}
function ___PRIVATE_syncEngineSynchronizeWithChangedDocuments() {
    ___PRIVATE_syncEngineSynchronizeWithChangedDocuments = /**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
    (0, $9OZ9j._)(function(e, t) {
        var n;
        return (0, $lF1I7.__generator)(this, function(_state) {
            n = __PRIVATE_debugCast(e);
            return [
                2,
                __PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then(function(e) {
                    return __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
                })
            ];
        });
    });
    return ___PRIVATE_syncEngineSynchronizeWithChangedDocuments.apply(this, arguments);
}
function __PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    return ___PRIVATE_syncEngineApplyBatchState.apply(this, arguments);
}
function ___PRIVATE_syncEngineApplyBatchState() {
    ___PRIVATE_syncEngineApplyBatchState = /** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
    (0, $9OZ9j._)(function(e, t, n, r) {
        var i, s, _tmp, _tmp1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = __PRIVATE_debugCast(e);
                    return [
                        4,
                        function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
                            var _$n = __PRIVATE_debugCast(e), _$r = __PRIVATE_debugCast(_$n.mutationQueue);
                            return _$n.persistence.runTransaction("Lookup mutation documents", "readonly", function(e) {
                                return _$r.vn(e, t).next(function(t) {
                                    return t ? _$n.localDocuments.getDocuments(e, t) : PersistencePromise.resolve(null);
                                });
                            });
                        }(i.localStore, t)
                    ];
                case 1:
                    s = _state.sent();
                    if (!(null !== s)) return [
                        3,
                        6
                    ];
                    if (!("pending" === n)) return [
                        3,
                        3
                    ];
                    // If we are the primary client, we need to send this write to the
                    // backend. Secondary clients will ignore these writes since their remote
                    // connection is disabled.
                    return [
                        4,
                        __PRIVATE_fillWritePipeline(i.remoteStore)
                    ];
                case 2:
                    _tmp1 = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    _tmp1 = "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
                    // other clients.
                    (__PRIVATE_processUserCallback(i, t, r || null), __PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
                        __PRIVATE_debugCast(__PRIVATE_debugCast(e).mutationQueue).Mn(t);
                    }(i.localStore, t)) : fail();
                    _state.label = 4;
                case 4:
                    _tmp1;
                    return [
                        4,
                        __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)
                    ];
                case 5:
                    _tmp = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    _tmp = // A throttled tab may not have seen the mutation before it was completed
                    // and removed from the mutation queue, in which case we won't have cached
                    // the affected documents. In this case we can safely ignore the update
                    // since that means we didn't apply the mutation locally at all (if we
                    // had, we would have cached the affected documents), and so we will just
                    // see any resulting document changes via normal remote document updates
                    // as applicable.
                    __PRIVATE_logDebug("SyncEngine", "Cannot apply mutation batch with id: " + t);
                    _state.label = 7;
                case 7:
                    _tmp;
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_syncEngineApplyBatchState.apply(this, arguments);
}
function __PRIVATE_syncEngineApplyPrimaryState(e, t) {
    return ___PRIVATE_syncEngineApplyPrimaryState.apply(this, arguments);
}
function ___PRIVATE_syncEngineApplyPrimaryState() {
    ___PRIVATE_syncEngineApplyPrimaryState = /** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
    (0, $9OZ9j._)(function(e, t) {
        var n, _$e, _$t, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e1, _$e2, _$t1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = __PRIVATE_debugCast(e);
                    if (!(__PRIVATE_ensureWatchCallbacks(n), __PRIVATE_syncEngineEnsureWriteCallbacks(n), !0 === t && !0 !== n.La)) return [
                        3,
                        3
                    ];
                    _$e = n.sharedClientState.getAllActiveQueryTargets();
                    return [
                        4,
                        __PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, _$e.toArray())
                    ];
                case 1:
                    _$t = _state.sent();
                    n.La = !0;
                    return [
                        4,
                        __PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0)
                    ];
                case 2:
                    _state.sent();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = _$t[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _$e1 = _step.value;
                            __PRIVATE_remoteStoreListen(n.remoteStore, _$e1);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        3,
                        7
                    ];
                case 3:
                    if (!(!1 === t && !1 !== n.La)) return [
                        3,
                        7
                    ];
                    _$e2 = [];
                    _$t1 = Promise.resolve();
                    n.Da.forEach(function(r, i) {
                        n.sharedClientState.isLocalQueryTarget(i) ? _$e2.push(i) : _$t1 = _$t1.then(function() {
                            return __PRIVATE_removeAndCleanupTarget(n, i), __PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ !0);
                        }), __PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
                    });
                    return [
                        4,
                        _$t1
                    ];
                case 4:
                    _state.sent();
                    return [
                        4,
                        __PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, _$e2)
                    ];
                case 5:
                    _state.sent(), // PORTING NOTE: Multi-Tab only.
                    function __PRIVATE_resetLimboDocuments(e) {
                        var _$t = __PRIVATE_debugCast(e);
                        _$t.Fa.forEach(function(e, n) {
                            __PRIVATE_remoteStoreUnlisten(_$t.remoteStore, n);
                        }), _$t.Ma.mr(), _$t.Fa = new Map, _$t.va = new SortedMap(DocumentKey.comparator);
                    }(n), n.La = !1;
                    return [
                        4,
                        __PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1)
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_syncEngineApplyPrimaryState.apply(this, arguments);
}
function __PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    return ___PRIVATE_synchronizeQueryViewsAndRaiseSnapshots.apply(this, arguments);
}
function ___PRIVATE_synchronizeQueryViewsAndRaiseSnapshots() {
    ___PRIVATE_synchronizeQueryViewsAndRaiseSnapshots = (0, $9OZ9j._)(function(e, t, n) {
        var r, i, s, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e, _$t, n1, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _$e1, _$t1, n2, err, n3, err;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_debugCast(e), i = [], s = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    _iterator = t[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        18
                    ];
                    _$e = _step.value;
                    _$t = void 0;
                    n1 = r.Da.get(_$e);
                    if (!(n1 && 0 !== n1.length)) return [
                        3,
                        12
                    ];
                    return [
                        4,
                        __PRIVATE_localStoreAllocateTarget(r.localStore, __PRIVATE_queryToTarget(n1[0]))
                    ];
                case 3:
                    // For queries that have a local View, we fetch their current state
                    // from LocalStore (as the resume token and the snapshot version
                    // might have changed) and reconcile their views with the persisted
                    // state (the list of syncedDocuments may have gotten out of sync).
                    _$t = _state.sent();
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        9,
                        10,
                        11
                    ]);
                    _iterator1 = n1[Symbol.iterator]();
                    _state.label = 5;
                case 5:
                    if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                        3,
                        8
                    ];
                    _$e1 = _step1.value;
                    _$t1 = r.ba.get(_$e1);
                    return [
                        4,
                        __PRIVATE_synchronizeViewAndComputeSnapshot(r, _$t1)
                    ];
                case 6:
                    n2 = _state.sent();
                    n2.snapshot && s.push(n2.snapshot);
                    _state.label = 7;
                case 7:
                    _iteratorNormalCompletion1 = true;
                    return [
                        3,
                        5
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    err = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                    return [
                        3,
                        11
                    ];
                case 10:
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        3,
                        16
                    ];
                case 12:
                    return [
                        4,
                        __PRIVATE_localStoreGetCachedTarget(r.localStore, _$e)
                    ];
                case 13:
                    n3 = _state.sent();
                    return [
                        4,
                        __PRIVATE_localStoreAllocateTarget(r.localStore, n3)
                    ];
                case 14:
                    _$t = _state.sent();
                    return [
                        4,
                        __PRIVATE_initializeViewAndComputeSnapshot(r, __PRIVATE_synthesizeTargetToQuery(n3), _$e, /*current=*/ !1, _$t.resumeToken)
                    ];
                case 15:
                    _state.sent();
                    _state.label = 16;
                case 16:
                    i.push(_$t);
                    _state.label = 17;
                case 17:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 18:
                    return [
                        3,
                        21
                    ];
                case 19:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        21
                    ];
                case 20:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 21:
                    return [
                        2,
                        (r.Sa.h_(s), i)
                    ];
            }
        });
    });
    return ___PRIVATE_synchronizeQueryViewsAndRaiseSnapshots.apply(this, arguments);
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_synthesizeTargetToQuery(e) {
    return __PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return __PRIVATE_debugCast(__PRIVATE_debugCast(e).persistence).Bi();
    }(__PRIVATE_debugCast(e).localStore);
}
function __PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    return ___PRIVATE_syncEngineApplyTargetState.apply(this, arguments);
}
function ___PRIVATE_syncEngineApplyTargetState() {
    ___PRIVATE_syncEngineApplyTargetState = /** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
    (0, $9OZ9j._)(function(e, t, n, r) {
        var i, s, _$e, _$r;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = __PRIVATE_debugCast(e);
                    if (i.La) // If we receive a target state notification via WebStorage, we are
                    // either already secondary or another tab has taken the primary lease.
                    return [
                        2,
                        void __PRIVATE_logDebug("SyncEngine", "Ignoring unexpected query state notification.")
                    ];
                    s = i.Da.get(t);
                    if (!(s && s.length > 0)) return [
                        3,
                        7
                    ];
                    switch(n){
                        case "current":
                            return [
                                3,
                                1
                            ];
                        case "not-current":
                            return [
                                3,
                                1
                            ];
                        case "rejected":
                            return [
                                3,
                                4
                            ];
                    }
                    return [
                        3,
                        6
                    ];
                case 1:
                    return [
                        4,
                        __PRIVATE_localStoreGetNewDocumentChanges(i.localStore, __PRIVATE_queryCollectionGroup(s[0]))
                    ];
                case 2:
                    _$e = _state.sent(), _$r = RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, ByteString.EMPTY_BYTE_STRING);
                    return [
                        4,
                        __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, _$e, _$r)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 4:
                    return [
                        4,
                        __PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ !0)
                    ];
                case 5:
                    _state.sent(), __PRIVATE_removeAndCleanupTarget(i, t, r);
                    return [
                        3,
                        7
                    ];
                case 6:
                    fail();
                    _state.label = 7;
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_syncEngineApplyTargetState.apply(this, arguments);
}
function __PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    return ___PRIVATE_syncEngineApplyActiveTargetsChange.apply(this, arguments);
}
function ___PRIVATE_syncEngineApplyActiveTargetsChange() {
    ___PRIVATE_syncEngineApplyActiveTargetsChange = /** Adds or removes Watch targets for queries from different tabs. */ (0, $9OZ9j._)(function(e, t, n) {
        var r, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e, _$t, _$n, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _loop, _iterator1, _step1, err;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = __PRIVATE_ensureWatchCallbacks(e);
                    if (!r.La) return [
                        3,
                        18
                    ];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        9,
                        10
                    ]);
                    _iterator = t[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        7
                    ];
                    _$e = _step.value;
                    if (r.Da.has(_$e) && r.sharedClientState.isActiveQueryTarget(_$e)) {
                        __PRIVATE_logDebug("SyncEngine", "Adding an already active target " + _$e);
                        return [
                            3,
                            6
                        ];
                    }
                    return [
                        4,
                        __PRIVATE_localStoreGetCachedTarget(r.localStore, _$e)
                    ];
                case 3:
                    _$t = _state.sent();
                    return [
                        4,
                        __PRIVATE_localStoreAllocateTarget(r.localStore, _$t)
                    ];
                case 4:
                    _$n = _state.sent();
                    return [
                        4,
                        __PRIVATE_initializeViewAndComputeSnapshot(r, __PRIVATE_synthesizeTargetToQuery(_$t), _$n.targetId, /*current=*/ !1, _$n.resumeToken)
                    ];
                case 5:
                    _state.sent(), __PRIVATE_remoteStoreListen(r.remoteStore, _$n);
                    _state.label = 6;
                case 6:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 7:
                    return [
                        3,
                        10
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        10
                    ];
                case 9:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 10:
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    _state.label = 11;
                case 11:
                    _state.trys.push([
                        11,
                        16,
                        17,
                        18
                    ]);
                    _loop = function() {
                        var _$e, _tmp;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _$e = _step1.value;
                                    // Check that the target is still active since the target might have been
                                    // removed if it has been rejected by the backend.
                                    _tmp = r.Da.has(_$e);
                                    if (!_tmp) return [
                                        3,
                                        2
                                    ];
                                    // Release queries that are still active.
                                    return [
                                        4,
                                        __PRIVATE_localStoreReleaseTarget(r.localStore, _$e, /* keepPersistedTargetData */ !1).then(function() {
                                            __PRIVATE_remoteStoreUnlisten(r.remoteStore, _$e), __PRIVATE_removeAndCleanupTarget(r, _$e);
                                        }).catch(__PRIVATE_ignoreIfPrimaryLeaseLoss)
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    _tmp;
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _iterator1 = n[Symbol.iterator]();
                    _state.label = 12;
                case 12:
                    if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                        3,
                        15
                    ];
                    return [
                        5,
                        (0, $lF1I7.__values)(_loop())
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    _iteratorNormalCompletion1 = true;
                    return [
                        3,
                        12
                    ];
                case 15:
                    return [
                        3,
                        18
                    ];
                case 16:
                    err = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                    return [
                        3,
                        18
                    ];
                case 17:
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                    return [
                        7
                    ];
                case 18:
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_syncEngineApplyActiveTargetsChange.apply(this, arguments);
}
function __PRIVATE_ensureWatchCallbacks(e) {
    var t = __PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = __PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = __PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = __PRIVATE_syncEngineRejectListen.bind(null, t), t.Sa.h_ = __PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.Sa.ka = __PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function __PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    var t = __PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = __PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = __PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function __PRIVATE_syncEngineLoadBundle(e, t, n) {
    var r = __PRIVATE_debugCast(e);
    (function() {
        var ___PRIVATE_loadBundleImpl = // eslint-disable-next-line @typescript-eslint/no-floating-promises
        /** Loads a bundle and returns the list of affected collection groups. */ (0, $9OZ9j._)(function(e, t, n) {
            var r, i, s, _$e, o, e1;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            14,
                            ,
                            15
                        ]);
                        return [
                            4,
                            t.getMetadata()
                        ];
                    case 1:
                        r = _state.sent();
                        return [
                            4,
                            function __PRIVATE_localStoreHasNewerBundle(e, t) {
                                var _$n = __PRIVATE_debugCast(e), r = __PRIVATE_fromVersion(t.createTime);
                                return _$n.persistence.runTransaction("hasNewerBundle", "readonly", function(e) {
                                    return _$n.$r.getBundleMetadata(e, t.id);
                                }).then(function(e) {
                                    return !!e && e.createTime.compareTo(r) >= 0;
                                });
                            }(e.localStore, r)
                        ];
                    case 2:
                        if (!_state.sent()) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            t.close()
                        ];
                    case 3:
                        return [
                            2,
                            (_state.sent(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                                return {
                                    taskState: "Success",
                                    documentsLoaded: e.totalDocuments,
                                    bytesLoaded: e.totalBytes,
                                    totalDocuments: e.totalDocuments,
                                    totalBytes: e.totalBytes
                                };
                            }(r)), Promise.resolve(new Set))
                        ];
                    case 4:
                        n._updateProgress(__PRIVATE_bundleInitialProgress(r));
                        i = new __PRIVATE_BundleLoader(r, e.localStore, t.serializer);
                        return [
                            4,
                            t.qa()
                        ];
                    case 5:
                        s = _state.sent();
                        _state.label = 6;
                    case 6:
                        if (!s) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            i._a(s)
                        ];
                    case 7:
                        _$e = _state.sent();
                        _$e && n._updateProgress(_$e);
                        return [
                            4,
                            t.qa()
                        ];
                    case 8:
                        s = _state.sent();
                        _state.label = 9;
                    case 9:
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            4,
                            i.complete()
                        ];
                    case 11:
                        o = _state.sent();
                        return [
                            4,
                            __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, o.ca, /* remoteEvent */ void 0)
                        ];
                    case 12:
                        _state.sent();
                        // Save metadata, so loading the same bundle will skip.
                        return [
                            4,
                            function __PRIVATE_localStoreSaveBundle(e, t) {
                                var _$n = __PRIVATE_debugCast(e);
                                return _$n.persistence.runTransaction("Save bundle", "readwrite", function(e) {
                                    return _$n.$r.saveBundleMetadata(e, t);
                                });
                            }(e.localStore, r)
                        ];
                    case 13:
                        return [
                            2,
                            (_state.sent(), n._completeWith(o.progress), Promise.resolve(o.ua))
                        ];
                    case 14:
                        e1 = _state.sent();
                        return [
                            2,
                            (__PRIVATE_logWarn("SyncEngine", "Loading bundle failed with ".concat(e1)), n._failWith(e1), Promise.resolve(new Set))
                        ];
                    case 15:
                        return [
                            2
                        ];
                }
            });
        });
        function __PRIVATE_loadBundleImpl(e, t, n) {
            return ___PRIVATE_loadBundleImpl.apply(this, arguments);
        }
        return __PRIVATE_loadBundleImpl;
    })()(r, t, n).then(function(e) {
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
var MemoryOfflineComponentProvider = /*#__PURE__*/ function() {
    "use strict";
    function MemoryOfflineComponentProvider() {
        (0, $19mwo._)(this, MemoryOfflineComponentProvider);
        this.synchronizeTabs = !1;
    }
    (0, $6rpfc._)(MemoryOfflineComponentProvider, [
        {
            key: "initialize",
            value: function initialize(e) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.serializer = __PRIVATE_newSerializer(e.databaseInfo.databaseId), _this.sharedClientState = _this.createSharedClientState(e), _this.persistence = _this.createPersistence(e);
                                return [
                                    4,
                                    _this.persistence.start()
                                ];
                            case 1:
                                _state.sent(), _this.localStore = _this.createLocalStore(e), _this.gcScheduler = _this.createGarbageCollectionScheduler(e, _this.localStore), _this.indexBackfillerScheduler = _this.createIndexBackfillerScheduler(e, _this.localStore);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createGarbageCollectionScheduler",
            value: function createGarbageCollectionScheduler(e, t) {
                return null;
            }
        },
        {
            key: "createIndexBackfillerScheduler",
            value: function createIndexBackfillerScheduler(e, t) {
                return null;
            }
        },
        {
            key: "createLocalStore",
            value: function createLocalStore(e) {
                return __PRIVATE_newLocalStore(this.persistence, new __PRIVATE_QueryEngine, e.initialUser, this.serializer);
            }
        },
        {
            key: "createPersistence",
            value: function createPersistence(e) {
                return new __PRIVATE_MemoryPersistence(__PRIVATE_MemoryEagerDelegate.Hr, this.serializer);
            }
        },
        {
            key: "createSharedClientState",
            value: function createSharedClientState(e) {
                return new __PRIVATE_MemorySharedClientState;
            }
        },
        {
            key: "terminate",
            value: function terminate() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var e, t;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                null === (e = _this.gcScheduler) || void 0 === e || e.stop(), null === (t = _this.indexBackfillerScheduler) || void 0 === t || t.stop(), _this.sharedClientState.shutdown();
                                return [
                                    4,
                                    _this.persistence.shutdown()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return MemoryOfflineComponentProvider;
}();
var __PRIVATE_LruGcMemoryOfflineComponentProvider = /*#__PURE__*/ function(MemoryOfflineComponentProvider) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_LruGcMemoryOfflineComponentProvider, MemoryOfflineComponentProvider);
    var _super = (0, $k1NN5._)(__PRIVATE_LruGcMemoryOfflineComponentProvider);
    function __PRIVATE_LruGcMemoryOfflineComponentProvider(e) {
        (0, $19mwo._)(this, __PRIVATE_LruGcMemoryOfflineComponentProvider);
        var _this;
        _this = _super.call(this), _this.cacheSizeBytes = e;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_LruGcMemoryOfflineComponentProvider, [
        {
            key: "createGarbageCollectionScheduler",
            value: function createGarbageCollectionScheduler(e, t) {
                __PRIVATE_hardAssert(this.persistence.referenceDelegate instanceof __PRIVATE_MemoryLruDelegate);
                var n = this.persistence.referenceDelegate.garbageCollector;
                return new __PRIVATE_LruScheduler(n, e.asyncQueue, t);
            }
        },
        {
            key: "createPersistence",
            value: function createPersistence(e) {
                var t = void 0 !== this.cacheSizeBytes ? LruParams.withCacheSize(this.cacheSizeBytes) : LruParams.DEFAULT;
                return new __PRIVATE_MemoryPersistence(function(e) {
                    return __PRIVATE_MemoryLruDelegate.Hr(e, t);
                }, this.serializer);
            }
        }
    ]);
    return __PRIVATE_LruGcMemoryOfflineComponentProvider;
}(MemoryOfflineComponentProvider);
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ var __PRIVATE_IndexedDbOfflineComponentProvider = /*#__PURE__*/ function(MemoryOfflineComponentProvider) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_IndexedDbOfflineComponentProvider, MemoryOfflineComponentProvider);
    var _super = (0, $k1NN5._)(__PRIVATE_IndexedDbOfflineComponentProvider);
    function __PRIVATE_IndexedDbOfflineComponentProvider(e, t, n) {
        (0, $19mwo._)(this, __PRIVATE_IndexedDbOfflineComponentProvider);
        var _this;
        _this = _super.call(this), _this.Qa = e, _this.cacheSizeBytes = t, _this.forceOwnership = n, _this.synchronizeTabs = !1;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_IndexedDbOfflineComponentProvider, [
        {
            key: "initialize",
            value: function initialize(e) {
                var _this = this;
                var _this1 = this, _superprop_get_initialize = function() {
                    return (0, $jLCbM._)((0, $laF8D._)(__PRIVATE_IndexedDbOfflineComponentProvider.prototype), "initialize", _this);
                };
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get_initialize().call(_this1, e)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this1.Qa.initialize(_this1, e)
                                ];
                            case 2:
                                _state.sent();
                                // Enqueue writes from a previous session
                                return [
                                    4,
                                    __PRIVATE_syncEngineEnsureWriteCallbacks(_this1.Qa.syncEngine)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    __PRIVATE_fillWritePipeline(_this1.Qa.remoteStore)
                                ];
                            case 4:
                                _state.sent();
                                // NOTE: This will immediately call the listener, so we make sure to
                                // set it after localStore / remoteStore are started.
                                return [
                                    4,
                                    _this1.persistence.fi(function() {
                                        return _this1.gcScheduler && !_this1.gcScheduler.started && _this1.gcScheduler.start(), _this1.indexBackfillerScheduler && !_this1.indexBackfillerScheduler.started && _this1.indexBackfillerScheduler.start(), Promise.resolve();
                                    })
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createLocalStore",
            value: function createLocalStore(e) {
                return __PRIVATE_newLocalStore(this.persistence, new __PRIVATE_QueryEngine, e.initialUser, this.serializer);
            }
        },
        {
            key: "createGarbageCollectionScheduler",
            value: function createGarbageCollectionScheduler(e, t) {
                var n = this.persistence.referenceDelegate.garbageCollector;
                return new __PRIVATE_LruScheduler(n, e.asyncQueue, t);
            }
        },
        {
            key: "createIndexBackfillerScheduler",
            value: function createIndexBackfillerScheduler(e, t) {
                var n = new __PRIVATE_IndexBackfiller(t, this.persistence);
                return new __PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
            }
        },
        {
            key: "createPersistence",
            value: function createPersistence(e) {
                var t = __PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? LruParams.withCacheSize(this.cacheSizeBytes) : LruParams.DEFAULT;
                return new __PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, __PRIVATE_getWindow(), getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
            }
        },
        {
            key: "createSharedClientState",
            value: function createSharedClientState(e) {
                return new __PRIVATE_MemorySharedClientState;
            }
        }
    ]);
    return __PRIVATE_IndexedDbOfflineComponentProvider;
}(MemoryOfflineComponentProvider);
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ var __PRIVATE_MultiTabOfflineComponentProvider = /*#__PURE__*/ function(__PRIVATE_IndexedDbOfflineComponentProvider) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_MultiTabOfflineComponentProvider, __PRIVATE_IndexedDbOfflineComponentProvider);
    var _super = (0, $k1NN5._)(__PRIVATE_MultiTabOfflineComponentProvider);
    function __PRIVATE_MultiTabOfflineComponentProvider(e, t) {
        (0, $19mwo._)(this, __PRIVATE_MultiTabOfflineComponentProvider);
        var _this;
        _this = _super.call(this, e, t, /* forceOwnership= */ !1), _this.Qa = e, _this.cacheSizeBytes = t, _this.synchronizeTabs = !0;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_MultiTabOfflineComponentProvider, [
        {
            key: "initialize",
            value: function initialize(e) {
                var _this = this;
                var _this1 = this, _superprop_get_initialize = function() {
                    return (0, $jLCbM._)((0, $laF8D._)(__PRIVATE_MultiTabOfflineComponentProvider.prototype), "initialize", _this);
                };
                return (0, $9OZ9j._)(function() {
                    var t, _tmp;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get_initialize().call(_this1, e)
                                ];
                            case 1:
                                _state.sent();
                                t = _this1.Qa.syncEngine;
                                _tmp = _this1.sharedClientState instanceof __PRIVATE_WebStorageSharedClientState;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                _this1.sharedClientState.syncEngine = {
                                    Zs: __PRIVATE_syncEngineApplyBatchState.bind(null, t),
                                    Xs: __PRIVATE_syncEngineApplyTargetState.bind(null, t),
                                    eo: __PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
                                    Bi: __PRIVATE_syncEngineGetActiveClients.bind(null, t),
                                    Ys: __PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
                                };
                                return [
                                    4,
                                    _this1.sharedClientState.start()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                // NOTE: This will immediately call the listener, so we make sure to
                                // set it after localStore / remoteStore are started.
                                return [
                                    4,
                                    _this1.persistence.fi(function() {
                                        var _ref = (0, $9OZ9j._)(function(e) {
                                            return (0, $lF1I7.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            __PRIVATE_syncEngineApplyPrimaryState(_this1.Qa.syncEngine, e)
                                                        ];
                                                    case 1:
                                                        _state.sent(), _this1.gcScheduler && (e && !_this1.gcScheduler.started ? _this1.gcScheduler.start() : e || _this1.gcScheduler.stop()), _this1.indexBackfillerScheduler && (e && !_this1.indexBackfillerScheduler.started ? _this1.indexBackfillerScheduler.start() : e || _this1.indexBackfillerScheduler.stop());
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(e) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createSharedClientState",
            value: function createSharedClientState(e) {
                var t = __PRIVATE_getWindow();
                if (!__PRIVATE_WebStorageSharedClientState.D(t)) throw new FirestoreError(C.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
                var n = __PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
                return new __PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
            }
        }
    ]);
    return __PRIVATE_MultiTabOfflineComponentProvider;
}(__PRIVATE_IndexedDbOfflineComponentProvider);
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ var OnlineComponentProvider = /*#__PURE__*/ function() {
    "use strict";
    function OnlineComponentProvider() {
        (0, $19mwo._)(this, OnlineComponentProvider);
    }
    (0, $6rpfc._)(OnlineComponentProvider, [
        {
            key: "initialize",
            value: function initialize(e, t) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _tmp;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.localStore;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                _this.localStore = e.localStore, _this.sharedClientState = e.sharedClientState, _this.datastore = _this.createDatastore(t), _this.remoteStore = _this.createRemoteStore(t), _this.eventManager = _this.createEventManager(t), _this.syncEngine = _this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), _this.sharedClientState.onlineStateHandler = function(e) {
                                    return __PRIVATE_syncEngineApplyOnlineStateChange(_this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ );
                                }, _this.remoteStore.remoteSyncer.handleCredentialChange = __PRIVATE_syncEngineHandleCredentialChange.bind(null, _this.syncEngine);
                                return [
                                    4,
                                    __PRIVATE_remoteStoreApplyPrimaryState(_this.remoteStore, _this.syncEngine.isPrimaryClient)
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createEventManager",
            value: function createEventManager(e) {
                return function __PRIVATE_newEventManager() {
                    return new __PRIVATE_EventManagerImpl;
                }();
            }
        },
        {
            key: "createDatastore",
            value: function createDatastore(e) {
                var t = __PRIVATE_newSerializer(e.databaseInfo.databaseId), n = function __PRIVATE_newConnection(e) {
                    return new __PRIVATE_WebChannelConnection(e);
                }(e.databaseInfo);
                return function __PRIVATE_newDatastore(e, t, n, r) {
                    return new __PRIVATE_DatastoreImpl(e, t, n, r);
                }(e.authCredentials, e.appCheckCredentials, n, t);
            }
        },
        {
            key: "createRemoteStore",
            value: function createRemoteStore(e) {
                var _this = this;
                return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
                    return new __PRIVATE_RemoteStoreImpl(e, t, n, r, i);
                }(this.localStore, this.datastore, e.asyncQueue, function(e) {
                    return __PRIVATE_syncEngineApplyOnlineStateChange(_this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ );
                }, function __PRIVATE_newConnectivityMonitor() {
                    return __PRIVATE_BrowserConnectivityMonitor.D() ? new __PRIVATE_BrowserConnectivityMonitor : new __PRIVATE_NoopConnectivityMonitor;
                }());
            }
        },
        {
            key: "createSyncEngine",
            value: function createSyncEngine(e, t) {
                return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
                r, i, s, o) {
                    var _ = new __PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
                    return o && (_.La = !0), _;
                }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
            }
        },
        {
            key: "terminate",
            value: function terminate() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var e;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (function() {
                                        var ___PRIVATE_remoteStoreShutdown = (0, $9OZ9j._)(function(e) {
                                            var t;
                                            return (0, $lF1I7.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        t = __PRIVATE_debugCast(e);
                                                        __PRIVATE_logDebug("RemoteStore", "RemoteStore shutting down."), t.M_.add(5 /* OfflineCause.Shutdown */ );
                                                        return [
                                                            4,
                                                            __PRIVATE_disableNetworkInternal(t)
                                                        ];
                                                    case 1:
                                                        _state.sent(), t.O_.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
                                                        // triggering spurious listener events with cached data, etc.
                                                        t.N_.set("Unknown" /* OnlineState.Unknown */ );
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        function __PRIVATE_remoteStoreShutdown(e) {
                                            return ___PRIVATE_remoteStoreShutdown.apply(this, arguments);
                                        }
                                        return __PRIVATE_remoteStoreShutdown;
                                    })()(_this.remoteStore)
                                ];
                            case 1:
                                _state.sent(), null === (e = _this.datastore) || void 0 === e || e.terminate();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return OnlineComponentProvider;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * How many bytes to read each time when `ReadableStreamReader.read()` is
 * called. Only applicable for byte streams that we control (e.g. those backed
 * by an UInt8Array).
 */ /**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function __PRIVATE_toByteStreamReaderHelper(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10240;
    var n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        read: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function() {
            return (0, $9OZ9j._)(function() {
                var r;
                return (0, $lF1I7.__generator)(this, function(_state) {
                    if (n < e.byteLength) {
                        r = {
                            value: e.slice(n, n + t),
                            done: !1
                        };
                        return [
                            2,
                            (n += t, r)
                        ];
                    }
                    return [
                        2,
                        {
                            done: !0
                        }
                    ];
                });
            })();
        },
        cancel: function() {
            return (0, $9OZ9j._)(function() {
                return (0, $lF1I7.__generator)(this, function(_state) {
                    return [
                        2
                    ];
                });
            })();
        },
        releaseLock: function() {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ var __PRIVATE_AsyncObserver = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_AsyncObserver(e) {
        (0, $19mwo._)(this, __PRIVATE_AsyncObserver);
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    (0, $6rpfc._)(__PRIVATE_AsyncObserver, [
        {
            key: "next",
            value: function next(e) {
                this.observer.next && this.Ka(this.observer.next, e);
            }
        },
        {
            key: "error",
            value: function error(e) {
                this.observer.error ? this.Ka(this.observer.error, e) : __PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString());
            }
        },
        {
            key: "$a",
            value: function $a() {
                this.muted = !0;
            }
        },
        {
            key: "Ka",
            value: function Ka(e, t) {
                var _this = this;
                this.muted || setTimeout(function() {
                    _this.muted || e(t);
                }, 0);
            }
        }
    ]);
    return __PRIVATE_AsyncObserver;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ var __PRIVATE_BundleReaderImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_BundleReaderImpl(/** The reader to read from underlying binary bundle data source. */ e, t) {
        var _this = this;
        (0, $19mwo._)(this, __PRIVATE_BundleReaderImpl);
        this.Ua = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new __PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.Wa = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.Ga().then(function(e) {
            e && e.sa() ? _this.metadata.resolve(e.ia.metadata) : _this.metadata.reject(new Error("The first element of the bundle is not a metadata, it is\n             ".concat(JSON.stringify(null == e ? void 0 : e.ia))));
        }, function(e) {
            return _this.metadata.reject(e);
        });
    }
    (0, $6rpfc._)(__PRIVATE_BundleReaderImpl, [
        {
            key: "close",
            value: function close() {
                return this.Ua.cancel();
            }
        },
        {
            key: "getMetadata",
            value: function getMetadata() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.metadata.promise
                        ];
                    });
                })();
            }
        },
        {
            key: "qa",
            value: function qa() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getMetadata()
                                ];
                            case 1:
                                // Makes sure metadata is read before proceeding.
                                return [
                                    2,
                                    (_state.sent(), _this.Ga())
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "Ga",
            value: /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ function Ga() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var e, t, n, r;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.za()
                                ];
                            case 1:
                                e = _state.sent();
                                if (null === e) return [
                                    2,
                                    null
                                ];
                                t = _this.Wa.decode(e), n = Number(t);
                                isNaN(n) && _this.ja("length string (".concat(t, ") is not valid number"));
                                return [
                                    4,
                                    _this.Ha(n)
                                ];
                            case 2:
                                r = _state.sent();
                                return [
                                    2,
                                    new __PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n)
                                ];
                        }
                    });
                })();
            }
        },
        {
            /** First index of '{' from the underlying buffer. */ key: "Ja",
            value: function Ja() {
                return this.buffer.findIndex(function(e) {
                    return e === "{".charCodeAt(0);
                });
            }
        },
        {
            key: "za",
            value: /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ function za() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var e, t;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.Ja() < 0)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.Ya()
                                ];
                            case 1:
                                if (_state.sent()) return [
                                    3,
                                    3
                                ];
                                _state.label = 2;
                            case 2:
                                return [
                                    3,
                                    0
                                ];
                            case 3:
                                // Broke out of the loop because underlying stream is closed, and there
                                // happens to be no more data to process.
                                if (0 === _this.buffer.length) return [
                                    2,
                                    null
                                ];
                                e = _this.Ja();
                                // Broke out of the loop because underlying stream is closed, but still
                                // cannot find an open bracket.
                                e < 0 && _this.ja("Reached the end of bundle when a length string is expected.");
                                t = _this.buffer.slice(0, e);
                                // Update the internal buffer to drop the read length.
                                return [
                                    2,
                                    (_this.buffer = _this.buffer.slice(e), t)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "Ha",
            value: /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ function Ha(e) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var t;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.buffer.length < e)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.Ya()
                                ];
                            case 1:
                                _state.sent() && _this.ja("Reached the end of bundle when more is expected.");
                                _state.label = 2;
                            case 2:
                                return [
                                    3,
                                    0
                                ];
                            case 3:
                                t = _this.Wa.decode(_this.buffer.slice(0, e));
                                // Update the internal buffer to drop the read json string.
                                return [
                                    2,
                                    (_this.buffer = _this.buffer.slice(e), t)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "ja",
            value: function ja(e) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                throw this.Ua.cancel(), new Error("Invalid bundle format: ".concat(e));
            }
        },
        {
            key: "Ya",
            value: /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ function Ya() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var e, t;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.Ua.read()
                                ];
                            case 1:
                                e = _state.sent();
                                if (!e.done) {
                                    t = new Uint8Array(_this.buffer.length + e.value.length);
                                    t.set(_this.buffer), t.set(e.value, _this.buffer.length), _this.buffer = t;
                                }
                                return [
                                    2,
                                    e.done
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return __PRIVATE_BundleReaderImpl;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ var Transaction$2 = /*#__PURE__*/ function() {
    "use strict";
    function Transaction$2(e) {
        (0, $19mwo._)(this, Transaction$2);
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    (0, $6rpfc._)(Transaction$2, [
        {
            key: "lookup",
            value: function lookup(e) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var t;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.ensureCommitNotCalled(), _this.mutations.length > 0) throw _this.lastTransactionError = new FirestoreError(C.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), _this.lastTransactionError;
                                return [
                                    4,
                                    (function() {
                                        var ___PRIVATE_invokeBatchGetDocumentsRpc = (0, $9OZ9j._)(function(e, t) {
                                            var n, r, i, s, o;
                                            return (0, $lF1I7.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        n = __PRIVATE_debugCast(e), r = {
                                                            documents: t.map(function(e) {
                                                                return __PRIVATE_toName(n.serializer, e);
                                                            })
                                                        };
                                                        return [
                                                            4,
                                                            n.xo("BatchGetDocuments", n.serializer.databaseId, ResourcePath.emptyPath(), r, t.length)
                                                        ];
                                                    case 1:
                                                        i = _state.sent(), s = new Map;
                                                        i.forEach(function(e) {
                                                            var _$t = __PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                                                            s.set(_$t.key.toString(), _$t);
                                                        });
                                                        o = [];
                                                        return [
                                                            2,
                                                            (t.forEach(function(e) {
                                                                var _$t = s.get(e.toString());
                                                                __PRIVATE_hardAssert(!!_$t), o.push(_$t);
                                                            }), o)
                                                        ];
                                                }
                                            });
                                        });
                                        function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
                                            return ___PRIVATE_invokeBatchGetDocumentsRpc.apply(this, arguments);
                                        }
                                        return __PRIVATE_invokeBatchGetDocumentsRpc;
                                    })()(_this.datastore, e)
                                ];
                            case 1:
                                t = _state.sent();
                                return [
                                    2,
                                    (t.forEach(function(e) {
                                        return _this.recordVersion(e);
                                    }), t)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "set",
            value: function set(e, t) {
                this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
            }
        },
        {
            key: "update",
            value: function update(e, t) {
                try {
                    this.write(t.toMutation(e, this.preconditionForUpdate(e)));
                } catch (e) {
                    this.lastTransactionError = e;
                }
                this.writtenDocs.add(e.toString());
            }
        },
        {
            key: "delete",
            value: function _delete(e) {
                this.write(new __PRIVATE_DeleteMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
            }
        },
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var e;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.ensureCommitNotCalled(), _this.lastTransactionError) throw _this.lastTransactionError;
                                e = _this.readVersions;
                                // For each mutation, note that the doc was written.
                                _this.mutations.forEach(function(t) {
                                    e.delete(t.key.toString());
                                }), // For each document that was read but not written to, we want to perform
                                // a `verify` operation.
                                e.forEach(function(e, t) {
                                    var n = DocumentKey.fromPath(t);
                                    _this.mutations.push(new __PRIVATE_VerifyMutation(n, _this.precondition(n)));
                                });
                                return [
                                    4,
                                    (function() {
                                        var ___PRIVATE_invokeCommitRpc = (0, $9OZ9j._)(function(e, t) {
                                            var n, r;
                                            return (0, $lF1I7.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        n = __PRIVATE_debugCast(e), r = {
                                                            writes: t.map(function(e) {
                                                                return toMutation(n.serializer, e);
                                                            })
                                                        };
                                                        return [
                                                            4,
                                                            n.Co("Commit", n.serializer.databaseId, ResourcePath.emptyPath(), r)
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        function __PRIVATE_invokeCommitRpc(e, t) {
                                            return ___PRIVATE_invokeCommitRpc.apply(this, arguments);
                                        }
                                        return __PRIVATE_invokeCommitRpc;
                                    })()(_this.datastore, _this.mutations)
                                ];
                            case 1:
                                _state.sent(), _this.committed = !0;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "recordVersion",
            value: function recordVersion(e) {
                var t;
                if (e.isFoundDocument()) t = e.version;
                else {
                    if (!e.isNoDocument()) throw fail();
                    // Represent a deleted doc using SnapshotVersion.min().
                    t = SnapshotVersion.min();
                }
                var n = this.readVersions.get(e.key.toString());
                if (n) {
                    if (!t.isEqual(n)) // This transaction will fail no matter what.
                    throw new FirestoreError(C.ABORTED, "Document version changed between two reads.");
                } else this.readVersions.set(e.key.toString(), t);
            }
        },
        {
            /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ key: "precondition",
            value: function precondition(e) {
                var t = this.readVersions.get(e.toString());
                return !this.writtenDocs.has(e.toString()) && t ? t.isEqual(SnapshotVersion.min()) ? Precondition.exists(!1) : Precondition.updateTime(t) : Precondition.none();
            }
        },
        {
            /**
     * Returns the precondition for a document if the operation is an update.
     */ key: "preconditionForUpdate",
            value: function preconditionForUpdate(e) {
                var t = this.readVersions.get(e.toString());
                // The first time a document is written, we want to take into account the
                // read time and existence
                if (!this.writtenDocs.has(e.toString()) && t) {
                    if (t.isEqual(SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
                    // This has to be validated locally because you can't send a
                    // precondition that a document does not exist without changing the
                    // semantics of the backend write to be an insert. This is the reverse
                    // of what we want, since we want to assert that the document doesn't
                    // exist but then send the update and have it fail. Since we can't
                    // express that to the backend, we have to validate locally.
                    // Note: this can change once we can send separate verify writes in the
                    // transaction.
                    throw new FirestoreError(C.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
                    // Document exists, base precondition on document update time.
                    return Precondition.updateTime(t);
                }
                // Document was not read, so we just use the preconditions for a blind
                // update.
                return Precondition.exists(!0);
            }
        },
        {
            key: "write",
            value: function write(e) {
                this.ensureCommitNotCalled(), this.mutations.push(e);
            }
        },
        {
            key: "ensureCommitNotCalled",
            value: function ensureCommitNotCalled() {}
        }
    ]);
    return Transaction$2;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ var __PRIVATE_TransactionRunner = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TransactionRunner(e, t, n, r, i) {
        (0, $19mwo._)(this, __PRIVATE_TransactionRunner);
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.Za = n.maxAttempts, this.Yo = new __PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    (0, $6rpfc._)(__PRIVATE_TransactionRunner, [
        {
            /** Runs the transaction and sets the result on deferred. */ key: "Xa",
            value: function Xa() {
                this.Za -= 1, this.eu();
            }
        },
        {
            key: "eu",
            value: function eu() {
                var _this = this;
                this.Yo.$o(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                    var e, t;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        e = new Transaction$2(_this.datastore), t = _this.tu(e);
                        t && t.then(function(t) {
                            _this.asyncQueue.enqueueAndForget(function() {
                                return e.commit().then(function() {
                                    _this.deferred.resolve(t);
                                }).catch(function(e) {
                                    _this.nu(e);
                                });
                            });
                        }).catch(function(e) {
                            _this.nu(e);
                        });
                        return [
                            2
                        ];
                    });
                }));
            }
        },
        {
            key: "tu",
            value: function tu(e) {
                try {
                    var t = this.updateFunction(e);
                    return !__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
                } catch (e) {
                    // Do not retry errors thrown by user provided updateFunction.
                    return this.deferred.reject(e), null;
                }
            }
        },
        {
            key: "nu",
            value: function nu(e) {
                var _this = this;
                this.Za > 0 && this.ru(e) ? (this.Za -= 1, this.asyncQueue.enqueueAndForget(function() {
                    return _this.eu(), Promise.resolve();
                })) : this.deferred.reject(e);
            }
        },
        {
            key: "ru",
            value: function ru(e) {
                if ("FirebaseError" === e.name) {
                    // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
                    // non-matching document versions with ABORTED. These errors should be retried.
                    var t = e.code;
                    return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !__PRIVATE_isPermanentError(t);
                }
                return !1;
            }
        }
    ]);
    return __PRIVATE_TransactionRunner;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ var FirestoreClient = /*#__PURE__*/ function() {
    "use strict";
    function FirestoreClient(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, r) {
        var _this = this;
        (0, $19mwo._)(this, FirestoreClient);
        var _this1 = this;
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this.databaseInfo = r, this.user = User.UNAUTHENTICATED, this.clientId = __PRIVATE_AutoId.newId(), this.authCredentialListener = function() {
            return Promise.resolve();
        }, this.appCheckCredentialListener = function() {
            return Promise.resolve();
        }, this.authCredentials.start(n, function() {
            var _ref = (0, $9OZ9j._)(function(e) {
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            __PRIVATE_logDebug("FirestoreClient", "Received user=", e.uid);
                            return [
                                4,
                                _this1.authCredentialListener(e)
                            ];
                        case 1:
                            _state.sent(), _this1.user = e;
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }()), this.appCheckCredentials.start(n, function(e) {
            return __PRIVATE_logDebug("FirestoreClient", "Received new app check token=", e), _this.appCheckCredentialListener(e, _this.user);
        });
    }
    (0, $6rpfc._)(FirestoreClient, [
        {
            key: "configuration",
            get: function get() {
                return {
                    asyncQueue: this.asyncQueue,
                    databaseInfo: this.databaseInfo,
                    clientId: this.clientId,
                    authCredentials: this.authCredentials,
                    appCheckCredentials: this.appCheckCredentials,
                    initialUser: this.user,
                    maxConcurrentLimboResolutions: 100
                };
            }
        },
        {
            key: "setCredentialChangeListener",
            value: function setCredentialChangeListener(e) {
                this.authCredentialListener = e;
            }
        },
        {
            key: "setAppCheckTokenChangeListener",
            value: function setAppCheckTokenChangeListener(e) {
                this.appCheckCredentialListener = e;
            }
        },
        {
            /**
     * Checks that the client has not been terminated. Ensures that other methods on //
     * this class cannot be called after the client is terminated. //
     */ key: "verifyNotTerminated",
            value: function verifyNotTerminated() {
                if (this.asyncQueue.isShuttingDown) throw new FirestoreError(C.FAILED_PRECONDITION, "The client has already been terminated.");
            }
        },
        {
            key: "terminate",
            value: function terminate() {
                this.asyncQueue.enterRestrictedMode();
                var e = new __PRIVATE_Deferred;
                var _this = this;
                return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                    var _tmp, _tmp1, t, n;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                _tmp = _this._onlineComponents;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._onlineComponents.terminate()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                _tmp1 = _this._offlineComponents;
                                if (!_tmp1) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this._offlineComponents.terminate()
                                ];
                            case 3:
                                _tmp1 = _state.sent();
                                _state.label = 4;
                            case 4:
                                _tmp1, // The credentials provider must be terminated after shutting down the
                                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                                // tokens.
                                _this.authCredentials.shutdown(), _this.appCheckCredentials.shutdown(), e.resolve();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                t = _state.sent();
                                n = __PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                                e.reject(n);
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })), e.promise;
            }
        }
    ]);
    return FirestoreClient;
}();
function __PRIVATE_setOfflineComponentProvider(e, t) {
    return ___PRIVATE_setOfflineComponentProvider.apply(this, arguments);
}
function ___PRIVATE_setOfflineComponentProvider() {
    ___PRIVATE_setOfflineComponentProvider = (0, $9OZ9j._)(function(e, t) {
        var n, r;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.asyncQueue.verifyOperationInProgress(), __PRIVATE_logDebug("FirestoreClient", "Initializing OfflineComponentProvider");
                    n = e.configuration;
                    return [
                        4,
                        t.initialize(n)
                    ];
                case 1:
                    _state.sent();
                    r = n.initialUser;
                    e.setCredentialChangeListener(function() {
                        var _ref = (0, $9OZ9j._)(function(e) {
                            var _tmp;
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = r.isEqual(e);
                                        if (_tmp) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            __PRIVATE_localStoreHandleUserChange(t.localStore, e)
                                        ];
                                    case 1:
                                        _tmp = (_state.sent(), r = e);
                                        _state.label = 2;
                                    case 2:
                                        _tmp;
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(e) {
                            return _ref.apply(this, arguments);
                        };
                    }()), // When a user calls clearPersistence() in one client, all other clients
                    // need to be terminated to allow the delete to succeed.
                    t.persistence.setDatabaseDeletedListener(function() {
                        return e.terminate();
                    }), e._offlineComponents = t;
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_setOfflineComponentProvider.apply(this, arguments);
}
function __PRIVATE_setOnlineComponentProvider(e, t) {
    return ___PRIVATE_setOnlineComponentProvider.apply(this, arguments);
}
function ___PRIVATE_setOnlineComponentProvider() {
    ___PRIVATE_setOnlineComponentProvider = (0, $9OZ9j._)(function(e, t) {
        var n;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.asyncQueue.verifyOperationInProgress();
                    return [
                        4,
                        __PRIVATE_ensureOfflineComponents(e)
                    ];
                case 1:
                    n = _state.sent();
                    __PRIVATE_logDebug("FirestoreClient", "Initializing OnlineComponentProvider");
                    return [
                        4,
                        t.initialize(n, e.configuration)
                    ];
                case 2:
                    _state.sent(), // The CredentialChangeListener of the online component provider takes
                    // precedence over the offline component provider.
                    e.setCredentialChangeListener(function(e) {
                        return __PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e);
                    }), e.setAppCheckTokenChangeListener(function(e, n) {
                        return __PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n);
                    }), e._onlineComponents = t;
                    return [
                        2
                    ];
            }
        });
    });
    return ___PRIVATE_setOnlineComponentProvider.apply(this, arguments);
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ function __PRIVATE_canFallbackFromIndexedDbError(e) {
    return "FirebaseError" === e.name ? e.code === C.FAILED_PRECONDITION || e.code === C.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
    // or an aborted error depending on whether the error happened during
    // schema migration.
    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
    // INVALID_STATE for any usage.
    11 === e.code;
}
function __PRIVATE_ensureOfflineComponents(e) {
    return ___PRIVATE_ensureOfflineComponents.apply(this, arguments);
}
function ___PRIVATE_ensureOfflineComponents() {
    ___PRIVATE_ensureOfflineComponents = (0, $9OZ9j._)(function(e) {
        var t, n;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!e._offlineComponents) return [
                        3,
                        8
                    ];
                    if (!e._uninitializedComponentsProvider) return [
                        3,
                        6
                    ];
                    __PRIVATE_logDebug("FirestoreClient", "Using user provided OfflineComponentProvider");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    return [
                        4,
                        __PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    t = _state.sent();
                    n = t;
                    if (!__PRIVATE_canFallbackFromIndexedDbError(n)) throw n;
                    __PRIVATE_logWarn("Error using user provided cache. Falling back to memory cache: " + n);
                    return [
                        4,
                        __PRIVATE_setOfflineComponentProvider(e, new MemoryOfflineComponentProvider)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    __PRIVATE_logDebug("FirestoreClient", "Using default OfflineComponentProvider");
                    return [
                        4,
                        __PRIVATE_setOfflineComponentProvider(e, new MemoryOfflineComponentProvider)
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2,
                        e._offlineComponents
                    ];
            }
        });
    });
    return ___PRIVATE_ensureOfflineComponents.apply(this, arguments);
}
function __PRIVATE_ensureOnlineComponents(e) {
    return ___PRIVATE_ensureOnlineComponents.apply(this, arguments);
}
function ___PRIVATE_ensureOnlineComponents() {
    ___PRIVATE_ensureOnlineComponents = (0, $9OZ9j._)(function(e) {
        var _tmp, _tmp1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = e._onlineComponents;
                    if (_tmp) return [
                        3,
                        5
                    ];
                    if (!e._uninitializedComponentsProvider) return [
                        3,
                        2
                    ];
                    __PRIVATE_logDebug("FirestoreClient", "Using user provided OnlineComponentProvider");
                    return [
                        4,
                        __PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)
                    ];
                case 1:
                    _tmp1 = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    __PRIVATE_logDebug("FirestoreClient", "Using default OnlineComponentProvider");
                    return [
                        4,
                        __PRIVATE_setOnlineComponentProvider(e, new OnlineComponentProvider)
                    ];
                case 3:
                    _tmp1 = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp = _tmp1;
                    _state.label = 5;
                case 5:
                    return [
                        2,
                        (_tmp, e._onlineComponents)
                    ];
            }
        });
    });
    return ___PRIVATE_ensureOnlineComponents.apply(this, arguments);
}
function __PRIVATE_getPersistence(e) {
    return __PRIVATE_ensureOfflineComponents(e).then(function(e) {
        return e.persistence;
    });
}
function __PRIVATE_getLocalStore(e) {
    return __PRIVATE_ensureOfflineComponents(e).then(function(e) {
        return e.localStore;
    });
}
function __PRIVATE_getRemoteStore(e) {
    return __PRIVATE_ensureOnlineComponents(e).then(function(e) {
        return e.remoteStore;
    });
}
function __PRIVATE_getSyncEngine(e) {
    return __PRIVATE_ensureOnlineComponents(e).then(function(e) {
        return e.syncEngine;
    });
}
function __PRIVATE_getDatastore(e) {
    return __PRIVATE_ensureOnlineComponents(e).then(function(e) {
        return e.datastore;
    });
}
function __PRIVATE_getEventManager(e) {
    return ___PRIVATE_getEventManager.apply(this, arguments);
}
function ___PRIVATE_getEventManager() {
    ___PRIVATE_getEventManager = (0, $9OZ9j._)(function(e) {
        var t, n;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __PRIVATE_ensureOnlineComponents(e)
                    ];
                case 1:
                    t = _state.sent(), n = t.eventManager;
                    return [
                        2,
                        (n.onListen = __PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = __PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = __PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = __PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), n)
                    ];
            }
        });
    });
    return ___PRIVATE_getEventManager.apply(this, arguments);
}
/** Enables the network connection and re-enqueues all pending operations. */ function __PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(/*#__PURE__*/ (0, $9OZ9j._)(function() {
        var t, n;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __PRIVATE_getPersistence(e)
                    ];
                case 1:
                    t = _state.sent();
                    return [
                        4,
                        __PRIVATE_getRemoteStore(e)
                    ];
                case 2:
                    n = _state.sent();
                    return [
                        2,
                        (t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
                            var t = __PRIVATE_debugCast(e);
                            return t.M_.delete(0 /* OfflineCause.UserDisabled */ ), __PRIVATE_enableNetworkInternal(t);
                        }(n))
                    ];
            }
        });
    }));
}
/** Disables the network connection. Pending operations will not complete. */ function __PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(/*#__PURE__*/ (0, $9OZ9j._)(function() {
        var t, n;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __PRIVATE_getPersistence(e)
                    ];
                case 1:
                    t = _state.sent();
                    return [
                        4,
                        __PRIVATE_getRemoteStore(e)
                    ];
                case 2:
                    n = _state.sent();
                    return [
                        2,
                        (t.setNetworkEnabled(!1), (function() {
                            var ___PRIVATE_remoteStoreDisableNetwork = (0, $9OZ9j._)(function(e) {
                                var t;
                                return (0, $lF1I7.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            t = __PRIVATE_debugCast(e);
                                            t.M_.add(0 /* OfflineCause.UserDisabled */ );
                                            return [
                                                4,
                                                __PRIVATE_disableNetworkInternal(t)
                                            ];
                                        case 1:
                                            _state.sent(), // Set the OnlineState to Offline so get()s return from cache, etc.
                                            t.N_.set("Offline" /* OnlineState.Offline */ );
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            function __PRIVATE_remoteStoreDisableNetwork(e) {
                                return ___PRIVATE_remoteStoreDisableNetwork.apply(this, arguments);
                            }
                            return __PRIVATE_remoteStoreDisableNetwork;
                        })()(n))
                    ];
            }
        });
    }));
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function __PRIVATE_firestoreClientGetDocumentFromLocalCache(e, t) {
    var n = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $9OZ9j._)(function() {
        var _;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function() {
                        var ___PRIVATE_readDocumentFromCache = (0, $9OZ9j._)(function(e, t, n) {
                            var r, e1, r1;
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            function __PRIVATE_localStoreReadDocument(e, t) {
                                                var _$n = __PRIVATE_debugCast(e);
                                                return _$n.persistence.runTransaction("read document", "readonly", function(e) {
                                                    return _$n.localDocuments.getDocument(e, t);
                                                });
                                            }(e, t)
                                        ];
                                    case 1:
                                        r = _state.sent();
                                        r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new FirestoreError(C.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        e1 = _state.sent();
                                        r1 = __PRIVATE_wrapInUserErrorIfRecoverable(e1, "Failed to get document '".concat(t, " from cache"));
                                        n.reject(r1);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        function __PRIVATE_readDocumentFromCache(e, t, n) {
                            return ___PRIVATE_readDocumentFromCache.apply(this, arguments);
                        }
                        return __PRIVATE_readDocumentFromCache;
                    }();
                    return [
                        4,
                        __PRIVATE_getLocalStore(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            t,
                            n
                        ])
                    ];
            }
        });
    })), n.promise;
}
function __PRIVATE_firestoreClientGetDocumentViaSnapshotListener(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var r = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $9OZ9j._)(function() {
        var _;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
                        var s = new __PRIVATE_AsyncObserver({
                            next: function(s) {
                                // Remove query first before passing event to user to avoid
                                // user actions affecting the now stale query.
                                t.enqueueAndForget(function() {
                                    return __PRIVATE_eventManagerUnlisten(e, o);
                                });
                                var _ = s.docs.has(n);
                                !_ && s.fromCache ? // TODO(dimond): If we're online and the document doesn't
                                // exist then we resolve with a doc.exists set to false. If
                                // we're offline however, we reject the Promise in this
                                // case. Two options: 1) Cache the negative response from
                                // the server so we can deliver that even when you're
                                // offline 2) Actually reject the Promise in the online case
                                // if the document doesn't exist.
                                i.reject(new FirestoreError(C.UNAVAILABLE, "Failed to get document because the client is offline.")) : _ && s.fromCache && r && "server" === r.source ? i.reject(new FirestoreError(C.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(s);
                            },
                            error: function(e) {
                                return i.reject(e);
                            }
                        }), o = new __PRIVATE_QueryListener(__PRIVATE_newQueryForPath(n.path), s, {
                            includeMetadataChanges: !0,
                            ra: !0
                        });
                        return __PRIVATE_eventManagerListen(e, o);
                    };
                    return [
                        4,
                        __PRIVATE_getEventManager(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            e.asyncQueue,
                            t,
                            n,
                            r
                        ])
                    ];
            }
        });
    })), r.promise;
}
function __PRIVATE_firestoreClientGetDocumentsFromLocalCache(e, t) {
    var n = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $9OZ9j._)(function() {
        var _;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function() {
                        var ___PRIVATE_executeQueryFromCache = (0, $9OZ9j._)(function(e, t, n) {
                            var r, i, s, o, e1, r1;
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            __PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0)
                                        ];
                                    case 1:
                                        r = _state.sent(), i = new __PRIVATE_View(t, r.hs), s = i.da(r.documents), o = i.applyChanges(s, /* limboResolutionEnabled= */ !1);
                                        n.resolve(o.snapshot);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        e1 = _state.sent();
                                        r1 = __PRIVATE_wrapInUserErrorIfRecoverable(e1, "Failed to execute query '".concat(t, " against cache"));
                                        n.reject(r1);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        function __PRIVATE_executeQueryFromCache(e, t, n) {
                            return ___PRIVATE_executeQueryFromCache.apply(this, arguments);
                        }
                        return __PRIVATE_executeQueryFromCache;
                    }();
                    return [
                        4,
                        __PRIVATE_getLocalStore(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            t,
                            n
                        ])
                    ];
            }
        });
    })), n.promise;
}
function __PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var r = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $9OZ9j._)(function() {
        var _;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
                        var s = new __PRIVATE_AsyncObserver({
                            next: function(n) {
                                // Remove query first before passing event to user to avoid
                                // user actions affecting the now stale query.
                                t.enqueueAndForget(function() {
                                    return __PRIVATE_eventManagerUnlisten(e, o);
                                }), n.fromCache && "server" === r.source ? i.reject(new FirestoreError(C.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                            },
                            error: function(e) {
                                return i.reject(e);
                            }
                        }), o = new __PRIVATE_QueryListener(n, s, {
                            includeMetadataChanges: !0,
                            ra: !0
                        });
                        return __PRIVATE_eventManagerListen(e, o);
                    };
                    return [
                        4,
                        __PRIVATE_getEventManager(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            e.asyncQueue,
                            t,
                            n,
                            r
                        ])
                    ];
            }
        });
    })), r.promise;
}
function __PRIVATE_firestoreClientRunAggregateQuery(e, t, n) {
    var r = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $9OZ9j._)(function() {
        var i, e1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        __PRIVATE_getDatastore(e)
                    ];
                case 1:
                    i = _state.sent();
                    r.resolve((function() {
                        var ___PRIVATE_invokeRunAggregationQueryRpc = (0, $9OZ9j._)(function(e, t, n) {
                            var r, i, _$__PRIVATE_toRunAggregationQueryRequest, s, o, _, a, u;
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        i = __PRIVATE_debugCast(e), _$__PRIVATE_toRunAggregationQueryRequest = __PRIVATE_toRunAggregationQueryRequest(i.serializer, __PRIVATE_queryToAggregateTarget(t), n), s = _$__PRIVATE_toRunAggregationQueryRequest.request, o = _$__PRIVATE_toRunAggregationQueryRequest.ut, _ = _$__PRIVATE_toRunAggregationQueryRequest.parent;
                                        i.connection.Do || delete s.parent;
                                        return [
                                            4,
                                            i.xo("RunAggregationQuery", i.serializer.databaseId, _, s, /*expectedResponseCount=*/ 1)
                                        ];
                                    case 1:
                                        a = _state.sent().filter(function(e) {
                                            return !!e.result;
                                        });
                                        // Omit RunAggregationQueryResponse that only contain readTimes.
                                        __PRIVATE_hardAssert(1 === a.length);
                                        // Remap the short-form aliases that were sent to the server
                                        // to the client-side aliases. Users will access the results
                                        // using the client-side alias.
                                        u = null === (r = a[0].result) || void 0 === r ? void 0 : r.aggregateFields;
                                        return [
                                            2,
                                            Object.keys(u).reduce(function(e, t) {
                                                return e[o[t]] = u[t], e;
                                            }, {})
                                        ];
                                }
                            });
                        });
                        function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                            return ___PRIVATE_invokeRunAggregationQueryRpc.apply(this, arguments);
                        }
                        return __PRIVATE_invokeRunAggregationQueryRpc;
                    })()(i, t, n));
                    return [
                        3,
                        3
                    ];
                case 2:
                    e1 = _state.sent();
                    r.reject(e1);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })), r.promise;
}
function __PRIVATE_firestoreClientAddSnapshotsInSyncListener(e, t) {
    var n = new __PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $9OZ9j._)(function() {
        var _;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function __PRIVATE_addSnapshotsInSyncListener(e, t) {
                        __PRIVATE_debugCast(e).z_.add(t), // Immediately fire an initial event, indicating all existing listeners
                        // are in-sync.
                        t.next();
                    };
                    return [
                        4,
                        __PRIVATE_getEventManager(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            n
                        ])
                    ];
            }
        });
    })), function() {
        n.$a(), e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $9OZ9j._)(function() {
            var _;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                            __PRIVATE_debugCast(e).z_.delete(t);
                        };
                        return [
                            4,
                            __PRIVATE_getEventManager(e)
                        ];
                    case 1:
                        return [
                            2,
                            _.apply(void 0, [
                                _state.sent(),
                                n
                            ])
                        ];
                }
            });
        }));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function __PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    var i = function __PRIVATE_createBundleReader(e, t) {
        var _$n;
        _$n = "string" == typeof e ? __PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new __PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return __PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return __PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(_$n), t);
    }(n, __PRIVATE_newSerializer(t));
    e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $9OZ9j._)(function() {
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __PRIVATE_getSyncEngine(e)
                    ];
                case 1:
                    __PRIVATE_syncEngineLoadBundle.apply(void 0, [
                        _state.sent(),
                        i,
                        r
                    ]);
                    return [
                        2
                    ];
            }
        });
    }));
}
function __PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(/*#__PURE__*/ (0, $9OZ9j._)(function() {
        var _;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function __PRIVATE_localStoreGetNamedQuery(e, t) {
                        var n = __PRIVATE_debugCast(e);
                        return n.persistence.runTransaction("Get named query", "readonly", function(e) {
                            return n.$r.getNamedQuery(e, t);
                        });
                    };
                    return [
                        4,
                        __PRIVATE_getLocalStore(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            t
                        ])
                    ];
            }
        });
    }));
}
function __PRIVATE_firestoreClientSetIndexConfiguration(e, t) {
    return e.asyncQueue.enqueue(/*#__PURE__*/ (0, $9OZ9j._)(function() {
        var _;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function() {
                        var ___PRIVATE_localStoreConfigureFieldIndexes = (0, $9OZ9j._)(function(e, t) {
                            var n, r, i;
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                n = __PRIVATE_debugCast(e), r = n.indexManager, i = [];
                                return [
                                    2,
                                    n.persistence.runTransaction("Configure indexes", "readwrite", function(e) {
                                        return r.getFieldIndexes(e).next(function(n) {
                                            return(/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ function __PRIVATE_diffArrays(e, t, n, r, i) {
                                                e = (0, $3jzhD._)(e), t = (0, $3jzhD._)(t), e.sort(n), t.sort(n);
                                                var s = e.length, o = t.length;
                                                var _ = 0, a = 0;
                                                for(; _ < o && a < s;){
                                                    var s1 = n(e[a], t[_]);
                                                    s1 < 0 ? // The element was removed if the next element in our ordered
                                                    // walkthrough is only in `before`.
                                                    i(e[a++]) : s1 > 0 ? // The element was added if the next element in our ordered walkthrough
                                                    // is only in `after`.
                                                    r(t[_++]) : (_++, a++);
                                                }
                                                for(; _ < o;)r(t[_++]);
                                                for(; a < s;)i(e[a++]);
                                            }(n, t, __PRIVATE_fieldIndexSemanticComparator, function(t) {
                                                i.push(r.addFieldIndex(e, t));
                                            }, function(t) {
                                                i.push(r.deleteFieldIndex(e, t));
                                            }));
                                        }).next(function() {
                                            return PersistencePromise.waitFor(i);
                                        });
                                    })
                                ];
                            });
                        });
                        function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
                            return ___PRIVATE_localStoreConfigureFieldIndexes.apply(this, arguments);
                        }
                        return __PRIVATE_localStoreConfigureFieldIndexes;
                    }();
                    return [
                        4,
                        __PRIVATE_getLocalStore(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            t
                        ])
                    ];
            }
        });
    }));
}
function __PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(e, t) {
    return e.asyncQueue.enqueue(/*#__PURE__*/ (0, $9OZ9j._)(function() {
        var _;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
                        __PRIVATE_debugCast(e).ts.Ui = t;
                    };
                    return [
                        4,
                        __PRIVATE_getLocalStore(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            t
                        ])
                    ];
            }
        });
    }));
}
function __PRIVATE_firestoreClientDeleteAllFieldIndexes(e) {
    return e.asyncQueue.enqueue(/*#__PURE__*/ (0, $9OZ9j._)(function() {
        var _;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
                        var t = __PRIVATE_debugCast(e), n = t.indexManager;
                        return t.persistence.runTransaction("Delete All Indexes", "readwrite", function(e) {
                            return n.deleteAllFieldIndexes(e);
                        });
                    };
                    return [
                        4,
                        __PRIVATE_getLocalStore(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    }));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function __PRIVATE_cloneLongPollingOptions(e) {
    var t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var ye = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new FirestoreError(C.INVALID_ARGUMENT, "Function ".concat(e, "() cannot be called with an empty ").concat(t, "."));
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function __PRIVATE_validateIsNotUsedTogether(e, t, n, r) {
    if (!0 === t && !0 === r) throw new FirestoreError(C.INVALID_ARGUMENT, "".concat(e, " and ").concat(n, " cannot be used together."));
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function __PRIVATE_validateDocumentPath(e) {
    if (!DocumentKey.isDocumentKey(e)) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid document reference. Document references must have an even number of segments, but ".concat(e, " has ").concat(e.length, "."));
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function __PRIVATE_validateCollectionPath(e) {
    if (DocumentKey.isDocumentKey(e)) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid collection reference. Collection references must have an odd number of segments, but ".concat(e, " has ").concat(e.length, "."));
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ /** Returns a string describing the type / value of the provided input. */ function __PRIVATE_valueDescription(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = "".concat(e.substring(0, 20), "...")), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            var t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? "a custom ".concat(t, " object") : "an object";
        }
    }
    return "function" == typeof e ? "a function" : fail();
}
function __PRIVATE_cast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new FirestoreError(C.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            var n = __PRIVATE_valueDescription(e);
            throw new FirestoreError(C.INVALID_ARGUMENT, "Expected type '".concat(t.name, "', but it was: ").concat(n));
        }
    }
    return e;
}
function __PRIVATE_validatePositiveNumber(e, t) {
    if (t <= 0) throw new FirestoreError(C.INVALID_ARGUMENT, "Function ".concat(e, "() requires a positive number, but it was: ").concat(t, "."));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ var FirestoreSettingsImpl = /*#__PURE__*/ function() {
    "use strict";
    function FirestoreSettingsImpl(e) {
        (0, $19mwo._)(this, FirestoreSettingsImpl);
        var t, n;
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new FirestoreError(C.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = "firestore.googleapis.com", this.ssl = true;
        } else this.host = e.host, this.ssl = null === (t = e.ssl) || void 0 === t || t;
        if (this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = 41943040;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < 1048576) throw new FirestoreError(C.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        __PRIVATE_validateIsNotUsedTogether("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = __PRIVATE_cloneLongPollingOptions(null !== (n = e.experimentalLongPollingOptions) && void 0 !== n ? n : {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new FirestoreError(C.INVALID_ARGUMENT, "invalid long polling timeout: ".concat(e.timeoutSeconds, " (must not be NaN)"));
                if (e.timeoutSeconds < 5) throw new FirestoreError(C.INVALID_ARGUMENT, "invalid long polling timeout: ".concat(e.timeoutSeconds, " (minimum allowed value is 5)"));
                if (e.timeoutSeconds > 30) throw new FirestoreError(C.INVALID_ARGUMENT, "invalid long polling timeout: ".concat(e.timeoutSeconds, " (maximum allowed value is 30)"));
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    (0, $6rpfc._)(FirestoreSettingsImpl, [
        {
            key: "isEqual",
            value: function isEqual(e) {
                return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function __PRIVATE_longPollingOptionsEqual(e, t) {
                    return e.timeoutSeconds === t.timeoutSeconds;
                }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
            }
        }
    ]);
    return FirestoreSettingsImpl;
}();
var Firestore$1 = /*#__PURE__*/ function() {
    "use strict";
    function Firestore$1(e, t, n, r) {
        (0, $19mwo._)(this, Firestore$1);
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new FirestoreSettingsImpl({}), this._settingsFrozen = !1;
    }
    (0, $6rpfc._)(Firestore$1, [
        {
            key: "app",
            get: /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ function get() {
                if (!this._app) throw new FirestoreError(C.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
                return this._app;
            }
        },
        {
            key: "_initialized",
            get: function get() {
                return this._settingsFrozen;
            }
        },
        {
            key: "_terminated",
            get: function get() {
                return void 0 !== this._terminateTask;
            }
        },
        {
            key: "_setSettings",
            value: function _setSettings(e) {
                if (this._settingsFrozen) throw new FirestoreError(C.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
                this._settings = new FirestoreSettingsImpl(e), void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
                    if (!e) return new __PRIVATE_EmptyAuthCredentialsProvider;
                    switch(e.type){
                        case "firstParty":
                            return new __PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                        case "provider":
                            return e.client;
                        default:
                            throw new FirestoreError(C.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
                    }
                }(e.credentials));
            }
        },
        {
            key: "_getSettings",
            value: function _getSettings() {
                return this._settings;
            }
        },
        {
            key: "_freezeSettings",
            value: function _freezeSettings() {
                return this._settingsFrozen = !0, this._settings;
            }
        },
        {
            key: "_delete",
            value: function _delete() {
                return this._terminateTask || (this._terminateTask = this._terminate()), this._terminateTask;
            }
        },
        {
            /** Returns a JSON-serializable representation of this `Firestore` instance. */ key: "toJSON",
            value: function toJSON() {
                return {
                    app: this._app,
                    databaseId: this._databaseId,
                    settings: this._settings
                };
            }
        },
        {
            /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ key: "_terminate",
            value: function _terminate() {
                /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
                    var t = ye.get(e);
                    t && (__PRIVATE_logDebug("ComponentProvider", "Removing Datastore"), ye.delete(e), t.terminate());
                }(this), Promise.resolve();
            }
        }
    ]);
    return Firestore$1;
}();
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function connectFirestoreEmulator(e, t, n) {
    var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var i;
    var s = (e = __PRIVATE_cast(e, Firestore$1))._getSettings(), o = "".concat(t, ":").concat(n);
    if ("firestore.googleapis.com" !== s.host && s.host !== o && __PRIVATE_logWarn("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used."), e._setSettings(Object.assign(Object.assign({}, s), {
        host: o,
        ssl: !1
    })), r.mockUserToken) {
        var _$t, _$n;
        if ("string" == typeof r.mockUserToken) _$t = r.mockUserToken, _$n = User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            _$t = (0, $gQ5gw.createMockUserToken)(r.mockUserToken, null === (i = e._app) || void 0 === i ? void 0 : i.options.projectId);
            var s1 = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!s1) throw new FirestoreError(C.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            _$n = new User(s1);
        }
        e._authCredentials = new __PRIVATE_EmulatorAuthCredentialsProvider(new __PRIVATE_OAuthToken(_$t, _$n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ var Query = /*#__PURE__*/ function() {
    "use strict";
    function Query(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n) {
        (0, $19mwo._)(this, Query);
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    (0, $6rpfc._)(Query, [
        {
            key: "withConverter",
            value: function withConverter(e) {
                return new Query(this.firestore, e, this._query);
            }
        }
    ]);
    return Query;
}();
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ var DocumentReference = /*#__PURE__*/ function() {
    "use strict";
    function DocumentReference(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n) {
        (0, $19mwo._)(this, DocumentReference);
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    (0, $6rpfc._)(DocumentReference, [
        {
            key: "_path",
            get: function get() {
                return this._key.path;
            }
        },
        {
            key: "id",
            get: /**
     * The document's identifier within its collection.
     */ function get() {
                return this._key.path.lastSegment();
            }
        },
        {
            key: "path",
            get: /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ function get() {
                return this._key.path.canonicalString();
            }
        },
        {
            key: "parent",
            get: /**
     * The collection this `DocumentReference` belongs to.
     */ function get() {
                return new CollectionReference(this.firestore, this.converter, this._key.path.popLast());
            }
        },
        {
            key: "withConverter",
            value: function withConverter(e) {
                return new DocumentReference(this.firestore, e, this._key);
            }
        }
    ]);
    return DocumentReference;
}();
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ var CollectionReference = /*#__PURE__*/ function(Query) {
    "use strict";
    (0, $iNfU4._)(CollectionReference, Query);
    var _super = (0, $k1NN5._)(CollectionReference);
    function CollectionReference(e, t, n) {
        (0, $19mwo._)(this, CollectionReference);
        var _this;
        _this = _super.call(this, e, t, __PRIVATE_newQueryForPath(n)), _this._path = n, /** The type of this Firestore reference. */ _this.type = "collection";
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(CollectionReference, [
        {
            key: "id",
            get: /** The collection's identifier. */ function get() {
                return this._query.path.lastSegment();
            }
        },
        {
            key: "path",
            get: /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ function get() {
                return this._query.path.canonicalString();
            }
        },
        {
            key: "parent",
            get: /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ function get() {
                var e = this._path.popLast();
                return e.isEmpty() ? null : new DocumentReference(this.firestore, /* converter= */ null, new DocumentKey(e));
            }
        },
        {
            key: "withConverter",
            value: function withConverter(e) {
                return new CollectionReference(this.firestore, e, this._path);
            }
        }
    ]);
    return CollectionReference;
}(Query);
function collection(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    if (e = (0, $gQ5gw.getModularInstance)(e), __PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof Firestore$1) {
        var _ResourcePath;
        var r = (_ResourcePath = ResourcePath).fromString.apply(_ResourcePath, [
            t
        ].concat((0, $3jzhD._)(n)));
        return __PRIVATE_validateCollectionPath(r), new CollectionReference(e, /* converter= */ null, r);
    }
    {
        var _ResourcePath1;
        if (!(e instanceof DocumentReference || e instanceof CollectionReference)) throw new FirestoreError(C.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        var r1 = e._path.child((_ResourcePath1 = ResourcePath).fromString.apply(_ResourcePath1, [
            t
        ].concat((0, $3jzhD._)(n))));
        return __PRIVATE_validateCollectionPath(r1), new CollectionReference(e.firestore, /* converter= */ null, r1);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function collectionGroup(e, t) {
    if (e = __PRIVATE_cast(e, Firestore$1), __PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid collection ID '".concat(t, "' passed to function collectionGroup(). Collection IDs must not contain '/'."));
    return new Query(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new __PRIVATE_QueryImpl(ResourcePath.emptyPath(), e);
    }(t));
}
function doc(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    if (e = (0, $gQ5gw.getModularInstance)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = __PRIVATE_AutoId.newId()), __PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof Firestore$1) {
        var _ResourcePath;
        var r = (_ResourcePath = ResourcePath).fromString.apply(_ResourcePath, [
            t
        ].concat((0, $3jzhD._)(n)));
        return __PRIVATE_validateDocumentPath(r), new DocumentReference(e, /* converter= */ null, new DocumentKey(r));
    }
    {
        var _ResourcePath1;
        if (!(e instanceof DocumentReference || e instanceof CollectionReference)) throw new FirestoreError(C.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        var r1 = e._path.child((_ResourcePath1 = ResourcePath).fromString.apply(_ResourcePath1, [
            t
        ].concat((0, $3jzhD._)(n))));
        return __PRIVATE_validateDocumentPath(r1), new DocumentReference(e.firestore, e instanceof CollectionReference ? e.converter : null, new DocumentKey(r1));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function refEqual(e, t) {
    return e = (0, $gQ5gw.getModularInstance)(e), t = (0, $gQ5gw.getModularInstance)(t), (e instanceof DocumentReference || e instanceof CollectionReference) && (t instanceof DocumentReference || t instanceof CollectionReference) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function queryEqual(e, t) {
    return e = (0, $gQ5gw.getModularInstance)(e), t = (0, $gQ5gw.getModularInstance)(t), e instanceof Query && t instanceof Query && e.firestore === t.firestore && __PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var __PRIVATE_AsyncQueueImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_AsyncQueueImpl() {
        var _this = this;
        (0, $19mwo._)(this, __PRIVATE_AsyncQueueImpl);
        // The last promise in the queue.
        this.iu = Promise.resolve(), // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.su = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.ou = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this._u = [], // visible for testing
        this.au = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.uu = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.cu = !1, // List of TimerIds to fast-forward delays for.
        this.lu = [], // Backoff timer used to schedule retries for retryable operations
        this.Yo = new __PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.hu = function() {
            var e = getDocument();
            e && __PRIVATE_logDebug("AsyncQueue", "Visibility state changed to " + e.visibilityState), _this.Yo.Wo();
        };
        var e = getDocument();
        e && "function" == typeof e.addEventListener && e.addEventListener("visibilitychange", this.hu);
    }
    (0, $6rpfc._)(__PRIVATE_AsyncQueueImpl, [
        {
            key: "isShuttingDown",
            get: function get() {
                return this.ou;
            }
        },
        {
            /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ key: "enqueueAndForget",
            value: function enqueueAndForget(e) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.enqueue(e);
            }
        },
        {
            key: "enqueueAndForgetEvenWhileRestricted",
            value: function enqueueAndForgetEvenWhileRestricted(e) {
                this.Pu(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.Iu(e);
            }
        },
        {
            key: "enterRestrictedMode",
            value: function enterRestrictedMode(e) {
                if (!this.ou) {
                    this.ou = !0, this.cu = e || !1;
                    var t = getDocument();
                    t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.hu);
                }
            }
        },
        {
            key: "enqueue",
            value: function enqueue(e) {
                var _this = this;
                if (this.Pu(), this.ou) // Return a Promise which never resolves.
                return new Promise(function() {});
                // Create a deferred Promise that we can return to the callee. This
                // allows us to return a "hanging Promise" only to the callee and still
                // advance the queue even when the operation is not run.
                var t = new __PRIVATE_Deferred;
                return this.Iu(function() {
                    return _this.ou && _this.cu ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise);
                }).then(function() {
                    return t.promise;
                });
            }
        },
        {
            key: "enqueueRetryable",
            value: function enqueueRetryable(e) {
                var _this = this;
                this.enqueueAndForget(function() {
                    return _this.su.push(e), _this.Tu();
                });
            }
        },
        {
            key: "Tu",
            value: /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ function Tu() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var e;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(0 !== _this.su.length)) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.su[0]()
                                ];
                            case 2:
                                _state.sent(), _this.su.shift(), _this.Yo.reset();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                if (!__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                                // Failure will be handled by AsyncQueue
                                __PRIVATE_logDebug("AsyncQueue", "Operation failed with retryable error: " + e);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                _this.su.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
                                // This is necessary to run retryable operations that failed during
                                // their initial attempt since we don't know whether they are already
                                // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
                                // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
                                // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
                                // call scheduled here.
                                // Since `backoffAndRun()` cancels an existing backoff and schedules a
                                // new backoff on every call, there is only ever a single additional
                                // operation in the queue.
                                _this.Yo.$o(function() {
                                    return _this.Tu();
                                });
                                _state.label = 5;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "Iu",
            value: function Iu(e) {
                var _this = this;
                var t = this.iu.then(function() {
                    return _this.uu = !0, e().catch(function(e) {
                        _this.au = e, _this.uu = !1;
                        var t = /**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function __PRIVATE_getMessageOrStack(e) {
                            var t = e.message || "";
                            e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack);
                            return t;
                        }(e);
                        // Re-throw the error so that this.tail becomes a rejected Promise and
                        // all further attempts to chain (via .then) will just short-circuit
                        // and return the rejected Promise.
                        throw __PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", t), e;
                    }).then(function(e) {
                        return _this.uu = !1, e;
                    });
                });
                return this.iu = t, t;
            }
        },
        {
            key: "enqueueAfterDelay",
            value: function enqueueAfterDelay(e, t, n) {
                var _this = this;
                this.Pu(), // Fast-forward delays for timerIds that have been overriden.
                this.lu.indexOf(e) > -1 && (t = 0);
                var r = DelayedOperation.createAndSchedule(this, e, t, n, function(e) {
                    return _this.Eu(e);
                });
                return this._u.push(r), r;
            }
        },
        {
            key: "Pu",
            value: function Pu() {
                this.au && fail();
            }
        },
        {
            key: "verifyOperationInProgress",
            value: function verifyOperationInProgress() {}
        },
        {
            key: "du",
            value: /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ function du() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var e;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = _this.iu;
                                return [
                                    4,
                                    e
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                if (e !== _this.iu) return [
                                    3,
                                    0
                                ];
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ key: "Au",
            value: function Au(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._u[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        if (t.timerId === e) return !0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return !1;
            }
        },
        {
            /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ key: "Ru",
            value: function Ru(e) {
                var _this = this;
                // Note that draining may generate more delayed ops, so we do that first.
                return this.du().then(function() {
                    // Run ops in the same order they'd run if they ran naturally.
                    _this._u.sort(function(e, t) {
                        return e.targetTimeMs - t.targetTimeMs;
                    });
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = _this._u[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var t = _step.value;
                            if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return _this.du();
                });
            }
        },
        {
            /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ key: "Vu",
            value: function Vu(e) {
                this.lu.push(e);
            }
        },
        {
            /** Called once a DelayedOperation is run or canceled. */ key: "Eu",
            value: function Eu(e) {
                // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
                var t = this._u.indexOf(e);
                this._u.splice(t, 1);
            }
        }
    ]);
    return __PRIVATE_AsyncQueueImpl;
}();
function __PRIVATE_isPartialObserver(e) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(e, t) {
        if ("object" != typeof e || null === e) return !1;
        var n = e;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$e = _step.value;
                if (_$e in n && "function" == typeof n[_$e]) return !0;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return !1;
    }(e, [
        "next",
        "error",
        "complete"
    ]);
}
var LoadBundleTask = /*#__PURE__*/ function() {
    "use strict";
    function LoadBundleTask() {
        (0, $19mwo._)(this, LoadBundleTask);
        this._progressObserver = {}, this._taskCompletionResolver = new __PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    (0, $6rpfc._)(LoadBundleTask, [
        {
            /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ key: "onProgress",
            value: function onProgress(e, t, n) {
                this._progressObserver = {
                    next: e,
                    error: t,
                    complete: n
                };
            }
        },
        {
            /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ key: "catch",
            value: function _catch(e) {
                return this._taskCompletionResolver.promise.catch(e);
            }
        },
        {
            /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ key: "then",
            value: function then(e, t) {
                return this._taskCompletionResolver.promise.then(e, t);
            }
        },
        {
            /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ key: "_completeWith",
            value: function _completeWith(e) {
                this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
            }
        },
        {
            /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ key: "_failWith",
            value: function _failWith(e) {
                this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
            }
        },
        {
            /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ key: "_updateProgress",
            value: function _updateProgress(e) {
                this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
            }
        }
    ]);
    return LoadBundleTask;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ var we = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ var Firestore = /*#__PURE__*/ function(Firestore$1) {
    "use strict";
    (0, $iNfU4._)(Firestore, Firestore$1);
    var _super = (0, $k1NN5._)(Firestore);
    function Firestore(e, t, n, r) {
        (0, $19mwo._)(this, Firestore);
        var _this;
        _this = _super.call(this, e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ _this.type = "firestore", _this._queue = function __PRIVATE_newAsyncQueue() {
            return new __PRIVATE_AsyncQueueImpl;
        }(), _this._persistenceKey = (null == r ? void 0 : r.name) || "[DEFAULT]";
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(Firestore, [
        {
            key: "_terminate",
            value: function _terminate() {
                return this._firestoreClient || // The client must be initialized to ensure that all subsequent API
                // usage throws an exception.
                __PRIVATE_configureFirestore(this), this._firestoreClient.terminate();
            }
        }
    ]);
    return Firestore;
}(Firestore$1);
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function initializeFirestore(e, t, n) {
    n || (n = "(default)");
    var r = (0, $ilNGG._getProvider)(e, "firestore");
    if (r.isInitialized(n)) {
        var _$e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, $gQ5gw.deepEqual)(i, t)) return _$e;
        throw new FirestoreError(C.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new FirestoreError(C.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < 1048576) throw new FirestoreError(C.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    return r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function getFirestore(t, n) {
    var r = "object" == typeof t ? t : (0, $ilNGG.getApp)(), i = "string" == typeof t ? t : n || "(default)", s = (0, $ilNGG._getProvider)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        var e = (0, $gQ5gw.getDefaultEmulatorHostnameAndPort)("firestore");
        e && connectFirestoreEmulator.apply(void 0, [
            s
        ].concat((0, $3jzhD._)(e)));
    }
    return s;
}
/**
 * @internal
 */ function ensureFirestoreConfigured(e) {
    return e._firestoreClient || __PRIVATE_configureFirestore(e), e._firestoreClient.verifyNotTerminated(), e._firestoreClient;
}
function __PRIVATE_configureFirestore(e) {
    var t, n, r;
    var i = e._freezeSettings(), s = function __PRIVATE_makeDatabaseInfo(e, t, n, r) {
        return new DatabaseInfo(e, t, n, r.host, r.ssl, r.experimentalForceLongPolling, r.experimentalAutoDetectLongPolling, __PRIVATE_cloneLongPollingOptions(r.experimentalLongPollingOptions), r.useFetchStreams);
    }(e._databaseId, (null === (t = e._app) || void 0 === t ? void 0 : t.options.appId) || "", e._persistenceKey, i);
    e._firestoreClient = new FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, s), (null === (n = i.localCache) || void 0 === n ? void 0 : n._offlineComponentProvider) && (null === (r = i.localCache) || void 0 === r ? void 0 : r._onlineComponentProvider) && (e._firestoreClient._uninitializedComponentsProvider = {
        _offlineKind: i.localCache.kind,
        _offline: i.localCache._offlineComponentProvider,
        _online: i.localCache._onlineComponentProvider
    });
}
/**
 * Attempts to enable persistent storage, if possible.
 *
 * On failure, `enableIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * Note: `enableIndexedDbPersistence()` must be called before any other functions
 * (other than {@link initializeFirestore}, {@link (getFirestore:1)} or
 * {@link clearIndexedDbPersistence}.
 *
 * Persistence cannot be used in a Node.js environment.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @param persistenceSettings - Optional settings object to configure
 * persistence.
 * @returns A `Promise` that represents successfully enabling persistent storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on IndexedDb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ function enableIndexedDbPersistence(e, t) {
    __PRIVATE_verifyNotInitialized(e = __PRIVATE_cast(e, Firestore));
    var n = ensureFirestoreConfigured(e);
    if (n._uninitializedComponentsProvider) throw new FirestoreError(C.FAILED_PRECONDITION, "SDK cache is already specified.");
    __PRIVATE_logWarn("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    var r = e._freezeSettings(), i = new OnlineComponentProvider;
    return __PRIVATE_setPersistenceProviders(n, i, new __PRIVATE_IndexedDbOfflineComponentProvider(i, r.cacheSizeBytes, null == t ? void 0 : t.forceOwnership));
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ function enableMultiTabIndexedDbPersistence(e) {
    __PRIVATE_verifyNotInitialized(e = __PRIVATE_cast(e, Firestore));
    var t = ensureFirestoreConfigured(e);
    if (t._uninitializedComponentsProvider) throw new FirestoreError(C.FAILED_PRECONDITION, "SDK cache is already specified.");
    __PRIVATE_logWarn("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    var n = e._freezeSettings(), r = new OnlineComponentProvider;
    return __PRIVATE_setPersistenceProviders(t, r, new __PRIVATE_MultiTabOfflineComponentProvider(r, n.cacheSizeBytes));
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function __PRIVATE_setPersistenceProviders(e, t, n) {
    var r = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueue(/*#__PURE__*/ (0, $9OZ9j._)(function() {
        var e1, _$t;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        __PRIVATE_setOfflineComponentProvider(e, n)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        __PRIVATE_setOnlineComponentProvider(e, t)
                    ];
                case 2:
                    _state.sent(), r.resolve();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e1 = _state.sent();
                    _$t = e1;
                    if (!__PRIVATE_canFallbackFromIndexedDbError(_$t)) throw _$t;
                    __PRIVATE_logWarn("Error enabling indexeddb cache. Falling back to memory cache: " + _$t), r.reject(_$t);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })).then(function() {
        return r.promise;
    });
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function clearIndexedDbPersistence(e) {
    if (e._initialized && !e._terminated) throw new FirestoreError(C.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    var t = new __PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(/*#__PURE__*/ (0, $9OZ9j._)(function() {
        var e1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (function() {
                            var ___PRIVATE_indexedDbClearPersistence = (0, $9OZ9j._)(function(e) {
                                var t;
                                return (0, $lF1I7.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!__PRIVATE_SimpleDb.D()) return [
                                                2,
                                                Promise.resolve()
                                            ];
                                            t = e + "main";
                                            return [
                                                4,
                                                __PRIVATE_SimpleDb.delete(t)
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            function __PRIVATE_indexedDbClearPersistence(e) {
                                return ___PRIVATE_indexedDbClearPersistence.apply(this, arguments);
                            }
                            return __PRIVATE_indexedDbClearPersistence;
                        })()(__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey))
                    ];
                case 1:
                    _state.sent(), t.resolve();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e1 = _state.sent();
                    t.reject(e1);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function waitForPendingWrites(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        var t = new __PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $9OZ9j._)(function() {
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            __PRIVATE_getSyncEngine(e)
                        ];
                    case 1:
                        return [
                            2,
                            __PRIVATE_syncEngineRegisterPendingWritesCallback.apply(void 0, [
                                _state.sent(),
                                t
                            ])
                        ];
                }
            });
        })), t.promise;
    }(ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function enableNetwork(e) {
    return __PRIVATE_firestoreClientEnableNetwork(ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function disableNetwork(e) {
    return __PRIVATE_firestoreClientDisableNetwork(ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function terminate(e) {
    return (0, $ilNGG._removeServiceInstance)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function loadBundle(e, t) {
    var n = ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)), r = new LoadBundleTask;
    return __PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function namedQuery(e, t) {
    return __PRIVATE_firestoreClientGetNamedQuery(ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)), t).then(function(t) {
        return t ? new Query(e, null, t.query) : null;
    });
}
function __PRIVATE_verifyNotInitialized(e) {
    if (e._initialized || e._terminated) throw new FirestoreError(C.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var AggregateField = function AggregateField() {
    "use strict";
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "count", t = arguments.length > 1 ? arguments[1] : void 0;
    (0, $19mwo._)(this, AggregateField);
    this._internalFieldPath = t, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = e;
};
/**
 * The results of executing an aggregation query.
 */ var AggregateQuerySnapshot = /*#__PURE__*/ function() {
    "use strict";
    function AggregateQuerySnapshot(e, t, n) {
        (0, $19mwo._)(this, AggregateQuerySnapshot);
        this._userDataWriter = t, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = e;
    }
    (0, $6rpfc._)(AggregateQuerySnapshot, [
        {
            /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ key: "data",
            value: function data() {
                return this._userDataWriter.convertObjectMap(this._data);
            }
        }
    ]);
    return AggregateQuerySnapshot;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ var Bytes = /*#__PURE__*/ function() {
    "use strict";
    function Bytes(e) {
        (0, $19mwo._)(this, Bytes);
        this._byteString = e;
    }
    (0, $6rpfc._)(Bytes, [
        {
            /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ key: "toBase64",
            value: function toBase64() {
                return this._byteString.toBase64();
            }
        },
        {
            /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ key: "toUint8Array",
            value: function toUint8Array() {
                return this._byteString.toUint8Array();
            }
        },
        {
            /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ key: "toString",
            value: function toString() {
                return "Bytes(base64: " + this.toBase64() + ")";
            }
        },
        {
            /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ key: "isEqual",
            value: function isEqual(e) {
                return this._byteString.isEqual(e._byteString);
            }
        }
    ], [
        {
            key: "fromBase64String",
            value: /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ function fromBase64String(e) {
                try {
                    return new Bytes(ByteString.fromBase64String(e));
                } catch (e) {
                    throw new FirestoreError(C.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
                }
            }
        },
        {
            key: "fromUint8Array",
            value: /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ function fromUint8Array(e) {
                return new Bytes(ByteString.fromUint8Array(e));
            }
        }
    ]);
    return Bytes;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ var FieldPath = /*#__PURE__*/ function() {
    "use strict";
    function FieldPath() {
        for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
            e[_key] = arguments[_key];
        }
        (0, $19mwo._)(this, FieldPath);
        for(var t = 0; t < e.length; ++t)if (0 === e[t].length) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new FieldPath$1(e);
    }
    (0, $6rpfc._)(FieldPath, [
        {
            /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ key: "isEqual",
            value: function isEqual(e) {
                return this._internalPath.isEqual(e._internalPath);
            }
        }
    ]);
    return FieldPath;
}();
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function documentId() {
    return new FieldPath("__name__");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ var FieldValue = function FieldValue(e) {
    "use strict";
    (0, $19mwo._)(this, FieldValue);
    this._methodName = e;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ var GeoPoint = /*#__PURE__*/ function() {
    "use strict";
    function GeoPoint(e, t) {
        (0, $19mwo._)(this, GeoPoint);
        if (!isFinite(e) || e < -90 || e > 90) throw new FirestoreError(C.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new FirestoreError(C.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    (0, $6rpfc._)(GeoPoint, [
        {
            key: "latitude",
            get: /**
     * The latitude of this `GeoPoint` instance.
     */ function get() {
                return this._lat;
            }
        },
        {
            key: "longitude",
            get: /**
     * The longitude of this `GeoPoint` instance.
     */ function get() {
                return this._long;
            }
        },
        {
            /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ key: "isEqual",
            value: function isEqual(e) {
                return this._lat === e._lat && this._long === e._long;
            }
        },
        {
            /** Returns a JSON-serializable representation of this GeoPoint. */ key: "toJSON",
            value: function toJSON() {
                return {
                    latitude: this._lat,
                    longitude: this._long
                };
            }
        },
        {
            /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ key: "_compareTo",
            value: function _compareTo(e) {
                return __PRIVATE_primitiveComparator(this._lat, e._lat) || __PRIVATE_primitiveComparator(this._long, e._long);
            }
        }
    ]);
    return GeoPoint;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Se = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ var ParsedSetData = /*#__PURE__*/ function() {
    "use strict";
    function ParsedSetData(e, t, n) {
        (0, $19mwo._)(this, ParsedSetData);
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    (0, $6rpfc._)(ParsedSetData, [
        {
            key: "toMutation",
            value: function toMutation(e, t) {
                return null !== this.fieldMask ? new __PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new __PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
            }
        }
    ]);
    return ParsedSetData;
}();
/** The result of parsing "update" data (i.e. for an updateData call). */ var ParsedUpdateData = /*#__PURE__*/ function() {
    "use strict";
    function ParsedUpdateData(e, // The fieldMask does not include document transforms.
    t, n) {
        (0, $19mwo._)(this, ParsedUpdateData);
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    (0, $6rpfc._)(ParsedUpdateData, [
        {
            key: "toMutation",
            value: function toMutation(e, t) {
                return new __PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
            }
        }
    ]);
    return ParsedUpdateData;
}();
function __PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw fail();
    }
}
/** A "context" object passed around while parsing user data. */ var __PRIVATE_ParseContextImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_ParseContextImpl(e, t, n, r, i, s) {
        (0, $19mwo._)(this, __PRIVATE_ParseContextImpl);
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.mu(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    (0, $6rpfc._)(__PRIVATE_ParseContextImpl, [
        {
            key: "path",
            get: function get() {
                return this.settings.path;
            }
        },
        {
            key: "fu",
            get: function get() {
                return this.settings.fu;
            }
        },
        {
            /** Returns a new context with the specified settings overwritten. */ key: "gu",
            value: function gu(e) {
                return new __PRIVATE_ParseContextImpl(Object.assign(Object.assign({}, this.settings), e), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
            }
        },
        {
            key: "pu",
            value: function pu(e) {
                var t;
                var n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.gu({
                    path: n,
                    yu: !1
                });
                return r.wu(e), r;
            }
        },
        {
            key: "Su",
            value: function Su(e) {
                var t;
                var n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.gu({
                    path: n,
                    yu: !1
                });
                return r.mu(), r;
            }
        },
        {
            key: "bu",
            value: function bu(e) {
                // TODO(b/34871131): We don't support array paths right now; so make path
                // undefined.
                return this.gu({
                    path: void 0,
                    yu: !0
                });
            }
        },
        {
            key: "Du",
            value: function Du(e) {
                return __PRIVATE_createError(e, this.settings.methodName, this.settings.Cu || !1, this.path, this.settings.vu);
            }
        },
        {
            /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ key: "contains",
            value: function contains(e) {
                return void 0 !== this.fieldMask.find(function(t) {
                    return e.isPrefixOf(t);
                }) || void 0 !== this.fieldTransforms.find(function(t) {
                    return e.isPrefixOf(t.field);
                });
            }
        },
        {
            key: "mu",
            value: function mu() {
                // TODO(b/34871131): Remove null check once we have proper paths for fields
                // within arrays.
                if (this.path) for(var e = 0; e < this.path.length; e++)this.wu(this.path.get(e));
            }
        },
        {
            key: "wu",
            value: function wu(e) {
                if (0 === e.length) throw this.Du("Document fields must not be empty");
                if (__PRIVATE_isWrite(this.fu) && Se.test(e)) throw this.Du('Document fields cannot begin and end with "__"');
            }
        }
    ]);
    return __PRIVATE_ParseContextImpl;
}();
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ var __PRIVATE_UserDataReader = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_UserDataReader(e, t, n) {
        (0, $19mwo._)(this, __PRIVATE_UserDataReader);
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || __PRIVATE_newSerializer(e);
    }
    (0, $6rpfc._)(__PRIVATE_UserDataReader, [
        {
            /** Creates a new top-level parse context. */ key: "Fu",
            value: function Fu(e, t, n) {
                var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
                return new __PRIVATE_ParseContextImpl({
                    fu: e,
                    methodName: t,
                    vu: n,
                    path: FieldPath$1.emptyPath(),
                    yu: !1,
                    Cu: r
                }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
            }
        }
    ]);
    return __PRIVATE_UserDataReader;
}();
function __PRIVATE_newUserDataReader(e) {
    var t = e._freezeSettings(), n = __PRIVATE_newSerializer(e._databaseId);
    return new __PRIVATE_UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function __PRIVATE_parseSetData(e, t, n, r, i) {
    var s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
    var o = e.Fu(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    __PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r);
    var _ = __PRIVATE_parseObject(r, o);
    var a, u;
    if (s.merge) a = new FieldMask(o.fieldMask), u = o.fieldTransforms;
    else if (s.mergeFields) {
        var _$e = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = s.mergeFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$r = _step.value;
                var _$i = __PRIVATE_fieldPathFromArgument$1(t, _$r, n);
                if (!o.contains(_$i)) throw new FirestoreError(C.INVALID_ARGUMENT, "Field '".concat(_$i, "' is specified in your field mask but missing from your input data."));
                __PRIVATE_fieldMaskContains(_$e, _$i) || _$e.push(_$i);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        a = new FieldMask(_$e), u = o.fieldTransforms.filter(function(e) {
            return a.covers(e.field);
        });
    } else a = null, u = o.fieldTransforms;
    return new ParsedSetData(new ObjectValue(_), a, u);
}
var __PRIVATE_DeleteFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_DeleteFieldValueImpl, FieldValue);
    var _super = (0, $k1NN5._)(__PRIVATE_DeleteFieldValueImpl);
    function __PRIVATE_DeleteFieldValueImpl() {
        (0, $19mwo._)(this, __PRIVATE_DeleteFieldValueImpl);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(__PRIVATE_DeleteFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                if (2 /* UserDataSource.MergeSet */  !== e.fu) throw 1 /* UserDataSource.Update */  === e.fu ? e.Du("".concat(this._methodName, "() can only appear at the top level of your update data")) : e.Du("".concat(this._methodName, "() cannot be used with set() unless you pass {merge:true}"));
                // No transform to add for a delete, but we need to add it to our
                // fieldMask so it gets deleted.
                return e.fieldMask.push(e.path), null;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof __PRIVATE_DeleteFieldValueImpl;
            }
        }
    ]);
    return __PRIVATE_DeleteFieldValueImpl;
}(FieldValue);
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function __PRIVATE_createSentinelChildContext(e, t, n) {
    return new __PRIVATE_ParseContextImpl({
        fu: 3 /* UserDataSource.Argument */ ,
        vu: t.settings.vu,
        methodName: e._methodName,
        yu: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
var __PRIVATE_ServerTimestampFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_ServerTimestampFieldValueImpl, FieldValue);
    var _super = (0, $k1NN5._)(__PRIVATE_ServerTimestampFieldValueImpl);
    function __PRIVATE_ServerTimestampFieldValueImpl() {
        (0, $19mwo._)(this, __PRIVATE_ServerTimestampFieldValueImpl);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(__PRIVATE_ServerTimestampFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                return new FieldTransform(e.path, new __PRIVATE_ServerTimestampTransform);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof __PRIVATE_ServerTimestampFieldValueImpl;
            }
        }
    ]);
    return __PRIVATE_ServerTimestampFieldValueImpl;
}(FieldValue);
var __PRIVATE_ArrayUnionFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_ArrayUnionFieldValueImpl, FieldValue);
    var _super = (0, $k1NN5._)(__PRIVATE_ArrayUnionFieldValueImpl);
    function __PRIVATE_ArrayUnionFieldValueImpl(e, t) {
        (0, $19mwo._)(this, __PRIVATE_ArrayUnionFieldValueImpl);
        var _this;
        _this = _super.call(this, e), _this.Mu = t;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_ArrayUnionFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                var t = __PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Mu.map(function(e) {
                    return __PRIVATE_parseData(e, t);
                }), r = new __PRIVATE_ArrayUnionTransformOperation(n);
                return new FieldTransform(e.path, r);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof __PRIVATE_ArrayUnionFieldValueImpl && (0, $gQ5gw.deepEqual)(this.Mu, e.Mu);
            }
        }
    ]);
    return __PRIVATE_ArrayUnionFieldValueImpl;
}(FieldValue);
var __PRIVATE_ArrayRemoveFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_ArrayRemoveFieldValueImpl, FieldValue);
    var _super = (0, $k1NN5._)(__PRIVATE_ArrayRemoveFieldValueImpl);
    function __PRIVATE_ArrayRemoveFieldValueImpl(e, t) {
        (0, $19mwo._)(this, __PRIVATE_ArrayRemoveFieldValueImpl);
        var _this;
        _this = _super.call(this, e), _this.Mu = t;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_ArrayRemoveFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                var t = __PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Mu.map(function(e) {
                    return __PRIVATE_parseData(e, t);
                }), r = new __PRIVATE_ArrayRemoveTransformOperation(n);
                return new FieldTransform(e.path, r);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof __PRIVATE_ArrayRemoveFieldValueImpl && (0, $gQ5gw.deepEqual)(this.Mu, e.Mu);
            }
        }
    ]);
    return __PRIVATE_ArrayRemoveFieldValueImpl;
}(FieldValue);
var __PRIVATE_NumericIncrementFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_NumericIncrementFieldValueImpl, FieldValue);
    var _super = (0, $k1NN5._)(__PRIVATE_NumericIncrementFieldValueImpl);
    function __PRIVATE_NumericIncrementFieldValueImpl(e, t) {
        (0, $19mwo._)(this, __PRIVATE_NumericIncrementFieldValueImpl);
        var _this;
        _this = _super.call(this, e), _this.xu = t;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_NumericIncrementFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                var t = new __PRIVATE_NumericIncrementTransformOperation(e.serializer, toNumber(e.serializer, this.xu));
                return new FieldTransform(e.path, t);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof __PRIVATE_NumericIncrementFieldValueImpl && this.xu === e.xu;
            }
        }
    ]);
    return __PRIVATE_NumericIncrementFieldValueImpl;
}(FieldValue);
/** Parse update data from an update() call. */ function __PRIVATE_parseUpdateData(e, t, n, r) {
    var i = e.Fu(1 /* UserDataSource.Update */ , t, n);
    __PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    var s = [], o = ObjectValue.empty();
    forEach(r, function(e, r) {
        var _ = __PRIVATE_fieldPathFromDotSeparatedString(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $gQ5gw.getModularInstance)(r);
        var a = i.Su(_);
        if (r instanceof __PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(_);
        else {
            var _$e = __PRIVATE_parseData(r, a);
            null != _$e && (s.push(_), o.set(_, _$e));
        }
    });
    var _ = new FieldMask(s);
    return new ParsedUpdateData(o, _, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function __PRIVATE_parseUpdateVarargs(e, t, n, r, i, s) {
    var o = e.Fu(1 /* UserDataSource.Update */ , t, n), _ = [
        __PRIVATE_fieldPathFromArgument$1(t, r, n)
    ], a = [
        i
    ];
    if (s.length % 2 != 0) throw new FirestoreError(C.INVALID_ARGUMENT, "Function ".concat(t, "() needs to be called with an even number of arguments that alternate between field names and values."));
    for(var _$e = 0; _$e < s.length; _$e += 2)_.push(__PRIVATE_fieldPathFromArgument$1(t, s[_$e])), a.push(s[_$e + 1]);
    var u = [], c = ObjectValue.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(var _$e1 = _.length - 1; _$e1 >= 0; --_$e1)if (!__PRIVATE_fieldMaskContains(u, _[_$e1])) {
        var _$t = _[_$e1];
        var _$n = a[_$e1];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        _$n = (0, $gQ5gw.getModularInstance)(_$n);
        var _$r = o.Su(_$t);
        if (_$n instanceof __PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        u.push(_$t);
        else {
            var _$e2 = __PRIVATE_parseData(_$n, _$r);
            null != _$e2 && (u.push(_$t), c.set(_$t, _$e2));
        }
    }
    var l = new FieldMask(u);
    return new ParsedUpdateData(c, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function __PRIVATE_parseQueryValue(e, t, n) {
    var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
    return __PRIVATE_parseData(n, e.Fu(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function __PRIVATE_parseData(e, t) {
    if (__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $gQ5gw.getModularInstance)(e))) return __PRIVATE_validatePlainObject("Unsupported field value:", t, e), __PRIVATE_parseObject(e, t);
    if (e instanceof FieldValue) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!__PRIVATE_isWrite(t.fu)) throw t.Du("".concat(e._methodName, "() can only be used with update() and set()"));
        if (!t.path) throw t.Du("".concat(e._methodName, "() is not currently supported inside arrays"));
        var n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.yu && 4 /* UserDataSource.ArrayArgument */  !== t.fu) throw t.Du("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            var n = [];
            var r = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    var _$e = __PRIVATE_parseData(i, t.bu(r));
                    null == _$e && // Just include nulls in the array for fields being replaced with a
                    // sentinel.
                    (_$e = {
                        nullValue: "NULL_VALUE"
                    }), n.push(_$e), r++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t) {
        if (null === (e = (0, $gQ5gw.getModularInstance)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return toNumber(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            var n = Timestamp.fromDate(e);
            return {
                timestampValue: toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof Timestamp) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            var n1 = new Timestamp(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: toTimestamp(t.serializer, n1)
            };
        }
        if (e instanceof GeoPoint) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof Bytes) return {
            bytesValue: __PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof DocumentReference) {
            var n2 = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n2)) throw t.Du("Document reference is for database ".concat(r.projectId, "/").concat(r.database, " but should be for database ").concat(n2.projectId, "/").concat(n2.database));
            return {
                referenceValue: __PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        throw t.Du("Unsupported field value: ".concat(__PRIVATE_valueDescription(e)));
    }(e, t);
}
function __PRIVATE_parseObject(e, t) {
    var n = {};
    return isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : forEach(e, function(e, r) {
        var i = __PRIVATE_parseData(r, t.pu(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function __PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof Timestamp || e instanceof GeoPoint || e instanceof Bytes || e instanceof DocumentReference || e instanceof FieldValue);
}
function __PRIVATE_validatePlainObject(e, t, n) {
    if (!__PRIVATE_looksLikeJsonObject(n) || !function __PRIVATE_isPlainObject(e) {
        return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
    }(n)) {
        var r = __PRIVATE_valueDescription(n);
        throw "an object" === r ? t.Du(e + " a custom object") : t.Du(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function __PRIVATE_fieldPathFromArgument$1(e, t, n) {
    if (// If required, replace the FieldPath Compat class with with the firestore-exp
    // FieldPath.
    (t = (0, $gQ5gw.getModularInstance)(t)) instanceof FieldPath) return t._internalPath;
    if ("string" == typeof t) return __PRIVATE_fieldPathFromDotSeparatedString(e, t);
    throw __PRIVATE_createError("Field path arguments must be of type string or ", e, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ var be = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function __PRIVATE_fieldPathFromDotSeparatedString(e, t, n) {
    if (t.search(be) >= 0) throw __PRIVATE_createError("Invalid field path (".concat(t, "). Paths must not contain '~', '*', '/', '[', or ']'"), e, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return (0, $2xfp5._)(FieldPath, (0, $3jzhD._)(t.split(".")))._internalPath;
    } catch (r) {
        throw __PRIVATE_createError("Invalid field path (".concat(t, "). Paths must not be empty, begin with '.', end with '.', or contain '..'"), e, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function __PRIVATE_createError(e, t, n, r, i) {
    var s = r && !r.isEmpty(), o = void 0 !== i;
    var _ = "Function ".concat(t, "() called with invalid data");
    n && (_ += " (via `toFirestore()`)"), _ += ". ";
    var a = "";
    return (s || o) && (a += " (found", s && (a += " in field ".concat(r)), o && (a += " in document ".concat(i)), a += ")"), new FirestoreError(C.INVALID_ARGUMENT, _ + e + a);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function __PRIVATE_fieldMaskContains(e, t) {
    return e.some(function(e) {
        return e.isEqual(t);
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ var DocumentSnapshot$1 = /*#__PURE__*/ function() {
    "use strict";
    function DocumentSnapshot$1(e, t, n, r, i) {
        (0, $19mwo._)(this, DocumentSnapshot$1);
        this._firestore = e, this._userDataWriter = t, this._key = n, this._document = r, this._converter = i;
    }
    (0, $6rpfc._)(DocumentSnapshot$1, [
        {
            key: "id",
            get: /** Property of the `DocumentSnapshot` that provides the document's ID. */ function get() {
                return this._key.path.lastSegment();
            }
        },
        {
            key: "ref",
            get: /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ function get() {
                return new DocumentReference(this._firestore, this._converter, this._key);
            }
        },
        {
            /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ key: "exists",
            value: function exists() {
                return null !== this._document;
            }
        },
        {
            /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ key: "data",
            value: function data() {
                if (this._document) {
                    if (this._converter) {
                        // We only want to use the converter and create a new DocumentSnapshot
                        // if a converter has been provided.
                        var e = new QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                        return this._converter.fromFirestore(e);
                    }
                    return this._userDataWriter.convertValue(this._document.data.value);
                }
            }
        },
        {
            /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "get",
            value: function get(e) {
                if (this._document) {
                    var t = this._document.data.field(__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
                    if (null !== t) return this._userDataWriter.convertValue(t);
                }
            }
        }
    ]);
    return DocumentSnapshot$1;
}();
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ var QueryDocumentSnapshot$1 = /*#__PURE__*/ function(DocumentSnapshot$1) {
    "use strict";
    (0, $iNfU4._)(QueryDocumentSnapshot$1, DocumentSnapshot$1);
    var _super = (0, $k1NN5._)(QueryDocumentSnapshot$1);
    function QueryDocumentSnapshot$1() {
        (0, $19mwo._)(this, QueryDocumentSnapshot$1);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(QueryDocumentSnapshot$1, [
        {
            /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ key: "data",
            value: function data() {
                return (0, $jLCbM._)((0, $laF8D._)(QueryDocumentSnapshot$1.prototype), "data", this).call(this);
            }
        }
    ]);
    return QueryDocumentSnapshot$1;
}(DocumentSnapshot$1);
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function __PRIVATE_fieldPathFromArgument(e, t) {
    return "string" == typeof t ? __PRIVATE_fieldPathFromDotSeparatedString(e, t) : t instanceof FieldPath ? t._internalPath : t._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_validateHasExplicitOrderByForLimitToLast(e) {
    if ("L" /* LimitType.Last */  === e.limitType && 0 === e.explicitOrderBy.length) throw new FirestoreError(C.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ var AppliableConstraint = function AppliableConstraint() {
    "use strict";
    (0, $19mwo._)(this, AppliableConstraint);
};
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ var QueryConstraint = /*#__PURE__*/ function(AppliableConstraint) {
    "use strict";
    (0, $iNfU4._)(QueryConstraint, AppliableConstraint);
    var _super = (0, $k1NN5._)(QueryConstraint);
    function QueryConstraint() {
        (0, $19mwo._)(this, QueryConstraint);
        return _super.apply(this, arguments);
    }
    return QueryConstraint;
}(AppliableConstraint);
function query(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    var r = [];
    t instanceof AppliableConstraint && r.push(t), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(e) {
        var _$t = e.filter(function(e) {
            return e instanceof QueryCompositeFilterConstraint;
        }).length, n = e.filter(function(e) {
            return e instanceof QueryFieldFilterConstraint;
        }).length;
        if (_$t > 1 || _$t > 0 && n > 0) throw new FirestoreError(C.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$t = _step.value;
            e = _$t._apply(e);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ var QueryFieldFilterConstraint = /*#__PURE__*/ function(QueryConstraint) {
    "use strict";
    (0, $iNfU4._)(QueryFieldFilterConstraint, QueryConstraint);
    var _super = (0, $k1NN5._)(QueryFieldFilterConstraint);
    function QueryFieldFilterConstraint(e, t, n) {
        (0, $19mwo._)(this, QueryFieldFilterConstraint);
        var _this;
        _this = _super.call(this), _this._field = e, _this._op = t, _this._value = n, /** The type of this query constraint */ _this.type = "where";
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(QueryFieldFilterConstraint, [
        {
            key: "_apply",
            value: function _apply(e) {
                var t = this._parse(e);
                return __PRIVATE_validateNewFieldFilter(e._query, t), new Query(e.firestore, e.converter, __PRIVATE_queryWithAddedFilter(e._query, t));
            }
        },
        {
            key: "_parse",
            value: function _parse(e) {
                var t = __PRIVATE_newUserDataReader(e.firestore), n = function __PRIVATE_newQueryFilter(e, t, n, r, i, s, o) {
                    var _;
                    if (i.isKeyField()) {
                        if ("array-contains" /* Operator.ARRAY_CONTAINS */  === s || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === s) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid Query. You can't perform '".concat(s, "' queries on documentId()."));
                        if ("in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s) {
                            __PRIVATE_validateDisjunctiveFilterElements(o, s);
                            var _$t = [];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$n = _step.value;
                                    _$t.push(__PRIVATE_parseDocumentIdValue(r, e, _$n));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            _ = {
                                arrayValue: {
                                    values: _$t
                                }
                            };
                        } else _ = __PRIVATE_parseDocumentIdValue(r, e, o);
                    } else "in" /* Operator.IN */  !== s && "not-in" /* Operator.NOT_IN */  !== s && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== s || __PRIVATE_validateDisjunctiveFilterElements(o, s), _ = __PRIVATE_parseQueryValue(n, t, o, /* allowArrays= */ "in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s);
                    return FieldFilter.create(i, s, _);
                }(e._query, "where", t, e.firestore._databaseId, this._field, this._op, this._value);
                return n;
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t, n) {
                return new QueryFieldFilterConstraint(e, t, n);
            }
        }
    ]);
    return QueryFieldFilterConstraint;
}(QueryConstraint);
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function where(e, t, n) {
    var r = t, i = __PRIVATE_fieldPathFromArgument("where", e);
    return QueryFieldFilterConstraint._create(i, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ var QueryCompositeFilterConstraint = /*#__PURE__*/ function(AppliableConstraint) {
    "use strict";
    (0, $iNfU4._)(QueryCompositeFilterConstraint, AppliableConstraint);
    var _super = (0, $k1NN5._)(QueryCompositeFilterConstraint);
    function QueryCompositeFilterConstraint(/** The type of this query constraint */ e, t) {
        (0, $19mwo._)(this, QueryCompositeFilterConstraint);
        var _this;
        _this = _super.call(this), _this.type = e, _this._queryConstraints = t;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(QueryCompositeFilterConstraint, [
        {
            key: "_parse",
            value: function _parse(e) {
                var t = this._queryConstraints.map(function(t) {
                    return t._parse(e);
                }).filter(function(e) {
                    return e.getFilters().length > 0;
                });
                return 1 === t.length ? t[0] : CompositeFilter.create(t, this._getOperator());
            }
        },
        {
            key: "_apply",
            value: function _apply(e) {
                var t = this._parse(e);
                return 0 === t.getFilters().length ? e : (function __PRIVATE_validateNewFilter(e, t) {
                    var n = e;
                    var r = t.getFlattenedFilters();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$e = _step.value;
                            __PRIVATE_validateNewFieldFilter(n, _$e), n = __PRIVATE_queryWithAddedFilter(n, _$e);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }(e._query, t), new Query(e.firestore, e.converter, __PRIVATE_queryWithAddedFilter(e._query, t)));
            }
        },
        {
            key: "_getQueryConstraints",
            value: function _getQueryConstraints() {
                return this._queryConstraints;
            }
        },
        {
            key: "_getOperator",
            value: function _getOperator() {
                return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t) {
                return new QueryCompositeFilterConstraint(e, t);
            }
        }
    ]);
    return QueryCompositeFilterConstraint;
}(AppliableConstraint);
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function or() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    // Only support QueryFilterConstraints
    return e.forEach(function(e) {
        return __PRIVATE_validateQueryFilterConstraint("or", e);
    }), QueryCompositeFilterConstraint._create("or" /* CompositeOperator.OR */ , e);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function and() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    // Only support QueryFilterConstraints
    return e.forEach(function(e) {
        return __PRIVATE_validateQueryFilterConstraint("and", e);
    }), QueryCompositeFilterConstraint._create("and" /* CompositeOperator.AND */ , e);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ var QueryOrderByConstraint = /*#__PURE__*/ function(QueryConstraint) {
    "use strict";
    (0, $iNfU4._)(QueryOrderByConstraint, QueryConstraint);
    var _super = (0, $k1NN5._)(QueryOrderByConstraint);
    function QueryOrderByConstraint(e, t) {
        (0, $19mwo._)(this, QueryOrderByConstraint);
        var _this;
        _this = _super.call(this), _this._field = e, _this._direction = t, /** The type of this query constraint */ _this.type = "orderBy";
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(QueryOrderByConstraint, [
        {
            key: "_apply",
            value: function _apply(e) {
                var t = function __PRIVATE_newQueryOrderBy(e, t, n) {
                    if (null !== e.startAt) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
                    if (null !== e.endAt) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
                    return new OrderBy(t, n);
                }(e._query, this._field, this._direction);
                return new Query(e.firestore, e.converter, function __PRIVATE_queryWithAddedOrderBy(e, t) {
                    // TODO(dimond): validate that orderBy does not list the same key twice.
                    var n = e.explicitOrderBy.concat([
                        t
                    ]);
                    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(e._query, t));
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t) {
                return new QueryOrderByConstraint(e, t);
            }
        }
    ]);
    return QueryOrderByConstraint;
}(QueryConstraint);
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function orderBy(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "asc";
    var n = t, r = __PRIVATE_fieldPathFromArgument("orderBy", e);
    return QueryOrderByConstraint._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ var QueryLimitConstraint = /*#__PURE__*/ function(QueryConstraint) {
    "use strict";
    (0, $iNfU4._)(QueryLimitConstraint, QueryConstraint);
    var _super = (0, $k1NN5._)(QueryLimitConstraint);
    function QueryLimitConstraint(/** The type of this query constraint */ e, t, n) {
        (0, $19mwo._)(this, QueryLimitConstraint);
        var _this;
        _this = _super.call(this), _this.type = e, _this._limit = t, _this._limitType = n;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(QueryLimitConstraint, [
        {
            key: "_apply",
            value: function _apply(e) {
                return new Query(e.firestore, e.converter, __PRIVATE_queryWithLimit(e._query, this._limit, this._limitType));
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t, n) {
                return new QueryLimitConstraint(e, t, n);
            }
        }
    ]);
    return QueryLimitConstraint;
}(QueryConstraint);
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function limit(e) {
    return __PRIVATE_validatePositiveNumber("limit", e), QueryLimitConstraint._create("limit", e, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function limitToLast(e) {
    return __PRIVATE_validatePositiveNumber("limitToLast", e), QueryLimitConstraint._create("limitToLast", e, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ var QueryStartAtConstraint = /*#__PURE__*/ function(QueryConstraint) {
    "use strict";
    (0, $iNfU4._)(QueryStartAtConstraint, QueryConstraint);
    var _super = (0, $k1NN5._)(QueryStartAtConstraint);
    function QueryStartAtConstraint(/** The type of this query constraint */ e, t, n) {
        (0, $19mwo._)(this, QueryStartAtConstraint);
        var _this;
        _this = _super.call(this), _this.type = e, _this._docOrFields = t, _this._inclusive = n;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(QueryStartAtConstraint, [
        {
            key: "_apply",
            value: function _apply(e) {
                var t = __PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
                return new Query(e.firestore, e.converter, function __PRIVATE_queryWithStartAt(e, t) {
                    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
                }(e._query, t));
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t, n) {
                return new QueryStartAtConstraint(e, t, n);
            }
        }
    ]);
    return QueryStartAtConstraint;
}(QueryConstraint);
function startAt() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return QueryStartAtConstraint._create("startAt", e, /*inclusive=*/ !0);
}
function startAfter() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return QueryStartAtConstraint._create("startAfter", e, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ var QueryEndAtConstraint = /*#__PURE__*/ function(QueryConstraint) {
    "use strict";
    (0, $iNfU4._)(QueryEndAtConstraint, QueryConstraint);
    var _super = (0, $k1NN5._)(QueryEndAtConstraint);
    function QueryEndAtConstraint(/** The type of this query constraint */ e, t, n) {
        (0, $19mwo._)(this, QueryEndAtConstraint);
        var _this;
        _this = _super.call(this), _this.type = e, _this._docOrFields = t, _this._inclusive = n;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(QueryEndAtConstraint, [
        {
            key: "_apply",
            value: function _apply(e) {
                var t = __PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
                return new Query(e.firestore, e.converter, function __PRIVATE_queryWithEndAt(e, t) {
                    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
                }(e._query, t));
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t, n) {
                return new QueryEndAtConstraint(e, t, n);
            }
        }
    ]);
    return QueryEndAtConstraint;
}(QueryConstraint);
function endBefore() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return QueryEndAtConstraint._create("endBefore", e, /*inclusive=*/ !1);
}
function endAt() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return QueryEndAtConstraint._create("endAt", e, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function __PRIVATE_newQueryBoundFromDocOrFields(e, t, n, r) {
    if (n[0] = (0, $gQ5gw.getModularInstance)(n[0]), n[0] instanceof DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(e, t, n, r, i) {
        if (!r) throw new FirestoreError(C.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for ".concat(n, "()."));
        var s = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Because people expect to continue/end a query at the exact document
            // provided, we need to use the implicit sort order rather than the explicit
            // sort order, because it's guaranteed to contain the document key. That way
            // the position becomes unambiguous and the query continues/ends exactly at
            // the provided document. Without the key (by using the explicit sort
            // orders), multiple documents could match the position, yielding duplicate
            // results.
            for(var _iterator = __PRIVATE_queryNormalizedOrderBy(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$n = _step.value;
                if (_$n.field.isKeyField()) s.push(__PRIVATE_refValue(t, r.key));
                else {
                    var _$e = r.data.field(_$n.field);
                    if (__PRIVATE_isServerTimestamp(_$e)) throw new FirestoreError(C.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + _$n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
                    if (null === _$e) {
                        var _$e1 = _$n.field.canonicalString();
                        throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a document for which the field '".concat(_$e1, "' (used as the orderBy) does not exist."));
                    }
                    s.push(_$e);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return new Bound(s, i);
    }(e._query, e.firestore._databaseId, t, n[0]._document, r);
    {
        var i = __PRIVATE_newUserDataReader(e.firestore);
        return function __PRIVATE_newQueryBoundFromFields(e, t, n, r, i, s) {
            // Use explicit order by's because it has to match the query the user made
            var o = e.explicitOrderBy;
            if (i.length > o.length) throw new FirestoreError(C.INVALID_ARGUMENT, "Too many arguments provided to ".concat(r, "(). The number of arguments must be less than or equal to the number of orderBy() clauses"));
            var _ = [];
            for(var _$s = 0; _$s < i.length; _$s++){
                var a = i[_$s];
                if (o[_$s].field.isKeyField()) {
                    if ("string" != typeof a) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in ".concat(r, "(), but got a ").concat(typeof a === "undefined" ? "undefined" : (0, $gnDeW._)(a)));
                    if (!__PRIVATE_isCollectionGroupQuery(e) && -1 !== a.indexOf("/")) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid query. When querying a collection and ordering by documentId(), the value passed to ".concat(r, "() must be a plain document ID, but '").concat(a, "' contains a slash."));
                    var _$n = e.path.child(ResourcePath.fromString(a));
                    if (!DocumentKey.isDocumentKey(_$n)) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid query. When querying a collection group and ordering by documentId(), the value passed to ".concat(r, "() must result in a valid document path, but '").concat(_$n, "' is not because it contains an odd number of segments."));
                    var _$i = new DocumentKey(_$n);
                    _.push(__PRIVATE_refValue(t, _$i));
                } else {
                    var _$e = __PRIVATE_parseQueryValue(n, r, a);
                    _.push(_$e);
                }
            }
            return new Bound(_, s);
        }(e._query, e.firestore._databaseId, i, t, n, r);
    }
}
function __PRIVATE_parseDocumentIdValue(e, t, n) {
    if ("string" == typeof (n = (0, $gQ5gw.getModularInstance)(n))) {
        if ("" === n) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!__PRIVATE_isCollectionGroupQuery(t) && -1 !== n.indexOf("/")) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '".concat(n, "' contains a '/' character."));
        var r = t.path.child(ResourcePath.fromString(n));
        if (!DocumentKey.isDocumentKey(r)) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '".concat(r, "' is not because it has an odd number of segments (").concat(r.length, ")."));
        return __PRIVATE_refValue(e, new DocumentKey(r));
    }
    if (n instanceof DocumentReference) return __PRIVATE_refValue(e, n._key);
    throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ".concat(__PRIVATE_valueDescription(n), "."));
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function __PRIVATE_validateDisjunctiveFilterElements(e, t) {
    if (!Array.isArray(e) || 0 === e.length) throw new FirestoreError(C.INVALID_ARGUMENT, "Invalid Query. A non-empty array is required for '".concat(t.toString(), "' filters."));
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function __PRIVATE_validateNewFieldFilter(e, t) {
    var n = function __PRIVATE_findOpInsideFilters(e, t) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                var n = _step.value;
                try {
                    for(var _iterator1 = n.getFlattenedFilters()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step1.value;
                        if (t.indexOf(_$e.op) >= 0) return _$e.op;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return null;
    }(e.filters, function __PRIVATE_conflictingOps(e) {
        switch(e){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(t.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === t.op ? new FirestoreError(C.INVALID_ARGUMENT, "Invalid query. You cannot use more than one '".concat(t.op.toString(), "' filter.")) : new FirestoreError(C.INVALID_ARGUMENT, "Invalid query. You cannot use '".concat(t.op.toString(), "' filters with '").concat(n.toString(), "' filters."));
}
function __PRIVATE_validateQueryFilterConstraint(e, t) {
    if (!(t instanceof QueryFieldFilterConstraint || t instanceof QueryCompositeFilterConstraint)) throw new FirestoreError(C.INVALID_ARGUMENT, "Function ".concat(e, "() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'."));
}
var AbstractUserDataWriter = /*#__PURE__*/ function() {
    "use strict";
    function AbstractUserDataWriter() {
        (0, $19mwo._)(this, AbstractUserDataWriter);
    }
    (0, $6rpfc._)(AbstractUserDataWriter, [
        {
            key: "convertValue",
            value: function convertValue(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
                switch(__PRIVATE_typeOrder(e)){
                    case 0 /* TypeOrder.NullValue */ :
                        return null;
                    case 1 /* TypeOrder.BooleanValue */ :
                        return e.booleanValue;
                    case 2 /* TypeOrder.NumberValue */ :
                        return __PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
                    case 3 /* TypeOrder.TimestampValue */ :
                        return this.convertTimestamp(e.timestampValue);
                    case 4 /* TypeOrder.ServerTimestampValue */ :
                        return this.convertServerTimestamp(e, t);
                    case 5 /* TypeOrder.StringValue */ :
                        return e.stringValue;
                    case 6 /* TypeOrder.BlobValue */ :
                        return this.convertBytes(__PRIVATE_normalizeByteString(e.bytesValue));
                    case 7 /* TypeOrder.RefValue */ :
                        return this.convertReference(e.referenceValue);
                    case 8 /* TypeOrder.GeoPointValue */ :
                        return this.convertGeoPoint(e.geoPointValue);
                    case 9 /* TypeOrder.ArrayValue */ :
                        return this.convertArray(e.arrayValue, t);
                    case 10 /* TypeOrder.ObjectValue */ :
                        return this.convertObject(e.mapValue, t);
                    default:
                        throw fail();
                }
            }
        },
        {
            key: "convertObject",
            value: function convertObject(e, t) {
                return this.convertObjectMap(e.fields, t);
            }
        },
        {
            /**
     * @internal
     */ key: "convertObjectMap",
            value: function convertObjectMap(e) {
                var _this = this;
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
                var n = {};
                return forEach(e, function(e, r) {
                    n[e] = _this.convertValue(r, t);
                }), n;
            }
        },
        {
            key: "convertGeoPoint",
            value: function convertGeoPoint(e) {
                return new GeoPoint(__PRIVATE_normalizeNumber(e.latitude), __PRIVATE_normalizeNumber(e.longitude));
            }
        },
        {
            key: "convertArray",
            value: function convertArray(e, t) {
                var _this = this;
                return (e.values || []).map(function(e) {
                    return _this.convertValue(e, t);
                });
            }
        },
        {
            key: "convertServerTimestamp",
            value: function convertServerTimestamp(e, t) {
                switch(t){
                    case "previous":
                        var n = __PRIVATE_getPreviousValue(e);
                        return null == n ? null : this.convertValue(n, t);
                    case "estimate":
                        return this.convertTimestamp(__PRIVATE_getLocalWriteTime(e));
                    default:
                        return null;
                }
            }
        },
        {
            key: "convertTimestamp",
            value: function convertTimestamp(e) {
                var t = __PRIVATE_normalizeTimestamp(e);
                return new Timestamp(t.seconds, t.nanos);
            }
        },
        {
            key: "convertDocumentKey",
            value: function convertDocumentKey(e, t) {
                var n = ResourcePath.fromString(e);
                __PRIVATE_hardAssert(__PRIVATE_isValidResourceName(n));
                var r = new DatabaseId(n.get(1), n.get(3)), i = new DocumentKey(n.popFirst(5));
                return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
                __PRIVATE_logError("Document ".concat(i, " contains a document reference within a different database (").concat(r.projectId, "/").concat(r.database, ") which is not supported. It will be treated as a reference in the current database (").concat(t.projectId, "/").concat(t.database, ") instead.")), i;
            }
        }
    ]);
    return AbstractUserDataWriter;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function __PRIVATE_applyFirestoreDataConverter(e, t, n) {
    var r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, r;
}
var __PRIVATE_LiteUserDataWriter = /*#__PURE__*/ function(AbstractUserDataWriter) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_LiteUserDataWriter, AbstractUserDataWriter);
    var _super = (0, $k1NN5._)(__PRIVATE_LiteUserDataWriter);
    function __PRIVATE_LiteUserDataWriter(e) {
        (0, $19mwo._)(this, __PRIVATE_LiteUserDataWriter);
        var _this;
        _this = _super.call(this), _this.firestore = e;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_LiteUserDataWriter, [
        {
            key: "convertBytes",
            value: function convertBytes(e) {
                return new Bytes(e);
            }
        },
        {
            key: "convertReference",
            value: function convertReference(e) {
                var t = this.convertDocumentKey(e, this.firestore._databaseId);
                return new DocumentReference(this.firestore, /* converter= */ null, t);
            }
        }
    ]);
    return __PRIVATE_LiteUserDataWriter;
}(AbstractUserDataWriter);
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to sum across the result set.
 */ function sum(e) {
    return new AggregateField("sum", __PRIVATE_fieldPathFromArgument$1("sum", e));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to average across the result set.
 */ function average(e) {
    return new AggregateField("avg", __PRIVATE_fieldPathFromArgument$1("average", e));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function count() {
    return new AggregateField("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left Compare this AggregateField to the `right`.
 * @param right Compare this AggregateField to the `left`.
 */ function aggregateFieldEqual(e, t) {
    var n, r;
    return e instanceof AggregateField && t instanceof AggregateField && e.aggregateType === t.aggregateType && (null === (n = e._internalFieldPath) || void 0 === n ? void 0 : n.canonicalString()) === (null === (r = t._internalFieldPath) || void 0 === r ? void 0 : r.canonicalString());
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function aggregateQuerySnapshotEqual(e, t) {
    return queryEqual(e.query, t.query) && (0, $gQ5gw.deepEqual)(e.data(), t.data());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ var SnapshotMetadata = /*#__PURE__*/ function() {
    "use strict";
    function SnapshotMetadata(e, t) {
        (0, $19mwo._)(this, SnapshotMetadata);
        this.hasPendingWrites = e, this.fromCache = t;
    }
    (0, $6rpfc._)(SnapshotMetadata, [
        {
            /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ key: "isEqual",
            value: function isEqual(e) {
                return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
            }
        }
    ]);
    return SnapshotMetadata;
}();
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ var DocumentSnapshot = /*#__PURE__*/ function(DocumentSnapshot$1) {
    "use strict";
    (0, $iNfU4._)(DocumentSnapshot, DocumentSnapshot$1);
    var _super = (0, $k1NN5._)(DocumentSnapshot);
    function DocumentSnapshot(e, t, n, r, i, s) {
        (0, $19mwo._)(this, DocumentSnapshot);
        var _this;
        _this = _super.call(this, e, t, n, r, s), _this._firestore = e, _this._firestoreImpl = e, _this.metadata = i;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(DocumentSnapshot, [
        {
            /**
     * Returns whether or not the data exists. True if the document exists.
     */ key: "exists",
            value: function exists() {
                return (0, $jLCbM._)((0, $laF8D._)(DocumentSnapshot.prototype), "exists", this).call(this);
            }
        },
        {
            /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ key: "data",
            value: function data() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                if (this._document) {
                    if (this._converter) {
                        // We only want to use the converter and create a new DocumentSnapshot
                        // if a converter has been provided.
                        var t = new QueryDocumentSnapshot(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                        return this._converter.fromFirestore(t, e);
                    }
                    return this._userDataWriter.convertValue(this._document.data.value, e.serverTimestamps);
                }
            }
        },
        {
            /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "get",
            value: function get(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this._document) {
                    var n = this._document.data.field(__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
                    if (null !== n) return this._userDataWriter.convertValue(n, t.serverTimestamps);
                }
            }
        }
    ]);
    return DocumentSnapshot;
}(DocumentSnapshot$1);
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ var QueryDocumentSnapshot = /*#__PURE__*/ function(DocumentSnapshot) {
    "use strict";
    (0, $iNfU4._)(QueryDocumentSnapshot, DocumentSnapshot);
    var _super = (0, $k1NN5._)(QueryDocumentSnapshot);
    function QueryDocumentSnapshot() {
        (0, $19mwo._)(this, QueryDocumentSnapshot);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(QueryDocumentSnapshot, [
        {
            /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ key: "data",
            value: function data() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return (0, $jLCbM._)((0, $laF8D._)(QueryDocumentSnapshot.prototype), "data", this).call(this, e);
            }
        }
    ]);
    return QueryDocumentSnapshot;
}(DocumentSnapshot);
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ var QuerySnapshot = /*#__PURE__*/ function() {
    "use strict";
    function QuerySnapshot(e, t, n, r) {
        (0, $19mwo._)(this, QuerySnapshot);
        this._firestore = e, this._userDataWriter = t, this._snapshot = r, this.metadata = new SnapshotMetadata(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    (0, $6rpfc._)(QuerySnapshot, [
        {
            key: "docs",
            get: /** An array of all the documents in the `QuerySnapshot`. */ function get() {
                var e = [];
                return this.forEach(function(t) {
                    return e.push(t);
                }), e;
            }
        },
        {
            key: "size",
            get: /** The number of documents in the `QuerySnapshot`. */ function get() {
                return this._snapshot.docs.size;
            }
        },
        {
            key: "empty",
            get: /** True if there are no documents in the `QuerySnapshot`. */ function get() {
                return 0 === this.size;
            }
        },
        {
            /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ key: "forEach",
            value: function forEach(e, t) {
                var _this = this;
                this._snapshot.docs.forEach(function(n) {
                    e.call(t, new QueryDocumentSnapshot(_this._firestore, _this._userDataWriter, n.key, n, new SnapshotMetadata(_this._snapshot.mutatedKeys.has(n.key), _this._snapshot.fromCache), _this.query.converter));
                });
            }
        },
        {
            /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ key: "docChanges",
            value: function docChanges() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var t = !!e.includeMetadataChanges;
                if (t && this._snapshot.excludesMetadataChanges) throw new FirestoreError(C.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
                return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === t || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(e, t) {
                    if (e._snapshot.oldDocs.isEmpty()) {
                        var t1 = 0;
                        return e._snapshot.docChanges.map(function(n) {
                            var r = new QueryDocumentSnapshot(e._firestore, e._userDataWriter, n.doc.key, n.doc, new SnapshotMetadata(e._snapshot.mutatedKeys.has(n.doc.key), e._snapshot.fromCache), e.query.converter);
                            return n.doc, {
                                type: "added",
                                doc: r,
                                oldIndex: -1,
                                newIndex: t1++
                            };
                        });
                    }
                    {
                        // A `DocumentSet` that is updated incrementally as changes are applied to use
                        // to lookup the index of a document.
                        var n = e._snapshot.oldDocs;
                        return e._snapshot.docChanges.filter(function(e) {
                            return t || 3 /* ChangeType.Metadata */  !== e.type;
                        }).map(function(t) {
                            var r = new QueryDocumentSnapshot(e._firestore, e._userDataWriter, t.doc.key, t.doc, new SnapshotMetadata(e._snapshot.mutatedKeys.has(t.doc.key), e._snapshot.fromCache), e.query.converter);
                            var i = -1, s = -1;
                            return 0 /* ChangeType.Added */  !== t.type && (i = n.indexOf(t.doc.key), n = n.delete(t.doc.key)), 1 /* ChangeType.Removed */  !== t.type && (n = n.add(t.doc), s = n.indexOf(t.doc.key)), {
                                type: __PRIVATE_resultChangeType(t.type),
                                doc: r,
                                oldIndex: i,
                                newIndex: s
                            };
                        });
                    }
                }(this, t), this._cachedChangesIncludeMetadataChanges = t), this._cachedChanges;
            }
        }
    ]);
    return QuerySnapshot;
}();
function __PRIVATE_resultChangeType(e) {
    switch(e){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return fail();
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function snapshotEqual(e, t) {
    return e instanceof DocumentSnapshot && t instanceof DocumentSnapshot ? e._firestore === t._firestore && e._key.isEqual(t._key) && (null === e._document ? null === t._document : e._document.isEqual(t._document)) && e._converter === t._converter : e instanceof QuerySnapshot && t instanceof QuerySnapshot && e._firestore === t._firestore && queryEqual(e.query, t.query) && e.metadata.isEqual(t.metadata) && e._snapshot.isEqual(t._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function getDoc(e) {
    e = __PRIVATE_cast(e, DocumentReference);
    var t = __PRIVATE_cast(e.firestore, Firestore);
    return __PRIVATE_firestoreClientGetDocumentViaSnapshotListener(ensureFirestoreConfigured(t), e._key).then(function(n) {
        return __PRIVATE_convertToDocSnapshot(t, e, n);
    });
}
var __PRIVATE_ExpUserDataWriter = /*#__PURE__*/ function(AbstractUserDataWriter) {
    "use strict";
    (0, $iNfU4._)(__PRIVATE_ExpUserDataWriter, AbstractUserDataWriter);
    var _super = (0, $k1NN5._)(__PRIVATE_ExpUserDataWriter);
    function __PRIVATE_ExpUserDataWriter(e) {
        (0, $19mwo._)(this, __PRIVATE_ExpUserDataWriter);
        var _this;
        _this = _super.call(this), _this.firestore = e;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(__PRIVATE_ExpUserDataWriter, [
        {
            key: "convertBytes",
            value: function convertBytes(e) {
                return new Bytes(e);
            }
        },
        {
            key: "convertReference",
            value: function convertReference(e) {
                var t = this.convertDocumentKey(e, this.firestore._databaseId);
                return new DocumentReference(this.firestore, /* converter= */ null, t);
            }
        }
    ]);
    return __PRIVATE_ExpUserDataWriter;
}(AbstractUserDataWriter);
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function getDocFromCache(e) {
    e = __PRIVATE_cast(e, DocumentReference);
    var t = __PRIVATE_cast(e.firestore, Firestore), n = ensureFirestoreConfigured(t), r = new __PRIVATE_ExpUserDataWriter(t);
    return __PRIVATE_firestoreClientGetDocumentFromLocalCache(n, e._key).then(function(n) {
        return new DocumentSnapshot(t, r, e._key, n, new SnapshotMetadata(null !== n && n.hasLocalMutations, /* fromCache= */ !0), e.converter);
    });
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function getDocFromServer(e) {
    e = __PRIVATE_cast(e, DocumentReference);
    var t = __PRIVATE_cast(e.firestore, Firestore);
    return __PRIVATE_firestoreClientGetDocumentViaSnapshotListener(ensureFirestoreConfigured(t), e._key, {
        source: "server"
    }).then(function(n) {
        return __PRIVATE_convertToDocSnapshot(t, e, n);
    });
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function getDocs(e) {
    e = __PRIVATE_cast(e, Query);
    var t = __PRIVATE_cast(e.firestore, Firestore), n = ensureFirestoreConfigured(t), r = new __PRIVATE_ExpUserDataWriter(t);
    return __PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query), __PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query).then(function(n) {
        return new QuerySnapshot(t, r, e, n);
    });
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function getDocsFromCache(e) {
    e = __PRIVATE_cast(e, Query);
    var t = __PRIVATE_cast(e.firestore, Firestore), n = ensureFirestoreConfigured(t), r = new __PRIVATE_ExpUserDataWriter(t);
    return __PRIVATE_firestoreClientGetDocumentsFromLocalCache(n, e._query).then(function(n) {
        return new QuerySnapshot(t, r, e, n);
    });
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function getDocsFromServer(e) {
    e = __PRIVATE_cast(e, Query);
    var t = __PRIVATE_cast(e.firestore, Firestore), n = ensureFirestoreConfigured(t), r = new __PRIVATE_ExpUserDataWriter(t);
    return __PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query, {
        source: "server"
    }).then(function(n) {
        return new QuerySnapshot(t, r, e, n);
    });
}
function setDoc(e, t, n) {
    e = __PRIVATE_cast(e, DocumentReference);
    var r = __PRIVATE_cast(e.firestore, Firestore), i = __PRIVATE_applyFirestoreDataConverter(e.converter, t, n);
    return executeWrite(r, [
        __PRIVATE_parseSetData(__PRIVATE_newUserDataReader(r), "setDoc", e._key, i, null !== e.converter, n).toMutation(e._key, Precondition.none())
    ]);
}
function updateDoc(e, t, n) {
    for(var _len = arguments.length, r = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        r[_key - 3] = arguments[_key];
    }
    e = __PRIVATE_cast(e, DocumentReference);
    var i = __PRIVATE_cast(e.firestore, Firestore), s = __PRIVATE_newUserDataReader(i);
    var o;
    o = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (t = (0, $gQ5gw.getModularInstance)(t)) || t instanceof FieldPath ? __PRIVATE_parseUpdateVarargs(s, "updateDoc", e._key, t, n, r) : __PRIVATE_parseUpdateData(s, "updateDoc", e._key, t);
    return executeWrite(i, [
        o.toMutation(e._key, Precondition.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function deleteDoc(e) {
    return executeWrite(__PRIVATE_cast(e.firestore, Firestore), [
        new __PRIVATE_DeleteMutation(e._key, Precondition.none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function addDoc(e, t) {
    var n = __PRIVATE_cast(e.firestore, Firestore), r = doc(e), i = __PRIVATE_applyFirestoreDataConverter(e.converter, t);
    return executeWrite(n, [
        __PRIVATE_parseSetData(__PRIVATE_newUserDataReader(e.firestore), "addDoc", r._key, i, null !== e.converter, {}).toMutation(r._key, Precondition.exists(!1))
    ]).then(function() {
        return r;
    });
}
function onSnapshot(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    var n, r, i;
    e = (0, $gQ5gw.getModularInstance)(e);
    var s = {
        includeMetadataChanges: !1,
        source: "default"
    }, o = 0;
    "object" != typeof t[o] || __PRIVATE_isPartialObserver(t[o]) || (s = t[o], o++);
    var _ = {
        includeMetadataChanges: s.includeMetadataChanges,
        source: s.source
    };
    if (__PRIVATE_isPartialObserver(t[o])) {
        var _$e = t[o];
        t[o] = null === (n = _$e.next) || void 0 === n ? void 0 : n.bind(_$e), t[o + 1] = null === (r = _$e.error) || void 0 === r ? void 0 : r.bind(_$e), t[o + 2] = null === (i = _$e.complete) || void 0 === i ? void 0 : i.bind(_$e);
    }
    var a, u, c;
    if (e instanceof DocumentReference) u = __PRIVATE_cast(e.firestore, Firestore), c = __PRIVATE_newQueryForPath(e._key.path), a = {
        next: function(n) {
            t[o] && t[o](__PRIVATE_convertToDocSnapshot(u, e, n));
        },
        error: t[o + 1],
        complete: t[o + 2]
    };
    else {
        var n1 = __PRIVATE_cast(e, Query);
        u = __PRIVATE_cast(n1.firestore, Firestore), c = n1._query;
        var r1 = new __PRIVATE_ExpUserDataWriter(u);
        a = {
            next: function(e) {
                t[o] && t[o](new QuerySnapshot(u, r1, n1, e));
            },
            error: t[o + 1],
            complete: t[o + 2]
        }, __PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query);
    }
    return function __PRIVATE_firestoreClientListen(e, t, n, r) {
        var i = new __PRIVATE_AsyncObserver(r), s = new __PRIVATE_QueryListener(t, i, n);
        return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $9OZ9j._)(function() {
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            __PRIVATE_getEventManager(e)
                        ];
                    case 1:
                        return [
                            2,
                            __PRIVATE_eventManagerListen.apply(void 0, [
                                _state.sent(),
                                s
                            ])
                        ];
                }
            });
        })), function() {
            i.$a(), e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                __PRIVATE_getEventManager(e)
                            ];
                        case 1:
                            return [
                                2,
                                __PRIVATE_eventManagerUnlisten.apply(void 0, [
                                    _state.sent(),
                                    s
                                ])
                            ];
                    }
                });
            }));
        };
    }(ensureFirestoreConfigured(u), c, _, a);
}
function onSnapshotsInSync(e, t) {
    return __PRIVATE_firestoreClientAddSnapshotsInSyncListener(ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)), __PRIVATE_isPartialObserver(t) ? t : {
        next: t
    });
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function executeWrite(e, t) {
    return function __PRIVATE_firestoreClientWrite(e, t) {
        var n = new __PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $9OZ9j._)(function() {
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            __PRIVATE_getSyncEngine(e)
                        ];
                    case 1:
                        return [
                            2,
                            __PRIVATE_syncEngineWrite.apply(void 0, [
                                _state.sent(),
                                t,
                                n
                            ])
                        ];
                }
            });
        })), n.promise;
    }(ensureFirestoreConfigured(e), t);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function __PRIVATE_convertToDocSnapshot(e, t, n) {
    var r = n.docs.get(t._key), i = new __PRIVATE_ExpUserDataWriter(e);
    return new DocumentSnapshot(e, i, t._key, r, new SnapshotMetadata(n.hasPendingWrites, n.fromCache), t.converter);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can
 * count the documents in cases where the result set is prohibitively large to
 * download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set size is calculated.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function getCountFromServer(e) {
    return getAggregateFromServer(e, {
        count: count()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set is aggregated over.
 * @param aggregateSpec An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function getAggregateFromServer(e, t) {
    var n = __PRIVATE_cast(e.firestore, Firestore), r = ensureFirestoreConfigured(n), i = __PRIVATE_mapToArray(t, function(e, t) {
        return new __PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath);
    });
    // Run the aggregation and convert the results
    return __PRIVATE_firestoreClientRunAggregateQuery(r, e._query, i).then(function(t) {
        return(/**
 * Converts the core aggregration result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult Core aggregation result
 * @internal
 */ function __PRIVATE_convertToAggregateQuerySnapshot(e, t, n) {
            var r = new __PRIVATE_ExpUserDataWriter(e);
            return new AggregateQuerySnapshot(t, r, n);
        }(n, e, t));
    });
}
var __PRIVATE_MemoryLocalCacheImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryLocalCacheImpl(e) {
        (0, $19mwo._)(this, __PRIVATE_MemoryLocalCacheImpl);
        this.kind = "memory", this._onlineComponentProvider = new OnlineComponentProvider, (null == e ? void 0 : e.garbageCollector) ? this._offlineComponentProvider = e.garbageCollector._offlineComponentProvider : this._offlineComponentProvider = new MemoryOfflineComponentProvider;
    }
    (0, $6rpfc._)(__PRIVATE_MemoryLocalCacheImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        }
    ]);
    return __PRIVATE_MemoryLocalCacheImpl;
}();
var __PRIVATE_PersistentLocalCacheImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_PersistentLocalCacheImpl(e) {
        (0, $19mwo._)(this, __PRIVATE_PersistentLocalCacheImpl);
        var t;
        this.kind = "persistent", (null == e ? void 0 : e.tabManager) ? (e.tabManager._initialize(e), t = e.tabManager) : (t = persistentSingleTabManager(void 0), t._initialize(e)), this._onlineComponentProvider = t._onlineComponentProvider, this._offlineComponentProvider = t._offlineComponentProvider;
    }
    (0, $6rpfc._)(__PRIVATE_PersistentLocalCacheImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        }
    ]);
    return __PRIVATE_PersistentLocalCacheImpl;
}();
var __PRIVATE_MemoryEagerGabageCollectorImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryEagerGabageCollectorImpl() {
        (0, $19mwo._)(this, __PRIVATE_MemoryEagerGabageCollectorImpl);
        this.kind = "memoryEager", this._offlineComponentProvider = new MemoryOfflineComponentProvider;
    }
    (0, $6rpfc._)(__PRIVATE_MemoryEagerGabageCollectorImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        }
    ]);
    return __PRIVATE_MemoryEagerGabageCollectorImpl;
}();
var __PRIVATE_MemoryLruGabageCollectorImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryLruGabageCollectorImpl(e) {
        (0, $19mwo._)(this, __PRIVATE_MemoryLruGabageCollectorImpl);
        this.kind = "memoryLru", this._offlineComponentProvider = new __PRIVATE_LruGcMemoryOfflineComponentProvider(e);
    }
    (0, $6rpfc._)(__PRIVATE_MemoryLruGabageCollectorImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        }
    ]);
    return __PRIVATE_MemoryLruGabageCollectorImpl;
}();
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function memoryEagerGarbageCollector() {
    return new __PRIVATE_MemoryEagerGabageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function memoryLruGarbageCollector(e) {
    return new __PRIVATE_MemoryLruGabageCollectorImpl(null == e ? void 0 : e.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function memoryLocalCache(e) {
    return new __PRIVATE_MemoryLocalCacheImpl(e);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function persistentLocalCache(e) {
    return new __PRIVATE_PersistentLocalCacheImpl(e);
}
var __PRIVATE_SingleTabManagerImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SingleTabManagerImpl(e) {
        (0, $19mwo._)(this, __PRIVATE_SingleTabManagerImpl);
        this.forceOwnership = e, this.kind = "persistentSingleTab";
    }
    (0, $6rpfc._)(__PRIVATE_SingleTabManagerImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        },
        {
            /**
     * @internal
     */ key: "_initialize",
            value: function _initialize(e) {
                this._onlineComponentProvider = new OnlineComponentProvider, this._offlineComponentProvider = new __PRIVATE_IndexedDbOfflineComponentProvider(this._onlineComponentProvider, null == e ? void 0 : e.cacheSizeBytes, this.forceOwnership);
            }
        }
    ]);
    return __PRIVATE_SingleTabManagerImpl;
}();
var __PRIVATE_MultiTabManagerImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MultiTabManagerImpl() {
        (0, $19mwo._)(this, __PRIVATE_MultiTabManagerImpl);
        this.kind = "PersistentMultipleTab";
    }
    (0, $6rpfc._)(__PRIVATE_MultiTabManagerImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        },
        {
            /**
     * @internal
     */ key: "_initialize",
            value: function _initialize(e) {
                this._onlineComponentProvider = new OnlineComponentProvider, this._offlineComponentProvider = new __PRIVATE_MultiTabOfflineComponentProvider(this._onlineComponentProvider, null == e ? void 0 : e.cacheSizeBytes);
            }
        }
    ]);
    return __PRIVATE_MultiTabManagerImpl;
}();
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings Configures the created tab manager.
 */ function persistentSingleTabManager(e) {
    return new __PRIVATE_SingleTabManagerImpl(null == e ? void 0 : e.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function persistentMultipleTabManager() {
    return new __PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var De = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ var WriteBatch = /*#__PURE__*/ function() {
    "use strict";
    function WriteBatch(e, t) {
        (0, $19mwo._)(this, WriteBatch);
        this._firestore = e, this._commitHandler = t, this._mutations = [], this._committed = !1, this._dataReader = __PRIVATE_newUserDataReader(e);
    }
    (0, $6rpfc._)(WriteBatch, [
        {
            key: "set",
            value: function set(e, t, n) {
                this._verifyNotCommitted();
                var r = __PRIVATE_validateReference(e, this._firestore), i = __PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = __PRIVATE_parseSetData(this._dataReader, "WriteBatch.set", r._key, i, null !== r.converter, n);
                return this._mutations.push(s.toMutation(r._key, Precondition.none())), this;
            }
        },
        {
            key: "update",
            value: function update(e, t, n) {
                for(var _len = arguments.length, r = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
                    r[_key - 3] = arguments[_key];
                }
                this._verifyNotCommitted();
                var i = __PRIVATE_validateReference(e, this._firestore);
                // For Compat types, we have to "extract" the underlying types before
                // performing validation.
                var s;
                return s = "string" == typeof (t = (0, $gQ5gw.getModularInstance)(t)) || t instanceof FieldPath ? __PRIVATE_parseUpdateVarargs(this._dataReader, "WriteBatch.update", i._key, t, n, r) : __PRIVATE_parseUpdateData(this._dataReader, "WriteBatch.update", i._key, t), this._mutations.push(s.toMutation(i._key, Precondition.exists(!0))), this;
            }
        },
        {
            /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ key: "delete",
            value: function _delete(e) {
                this._verifyNotCommitted();
                var t = __PRIVATE_validateReference(e, this._firestore);
                return this._mutations = this._mutations.concat(new __PRIVATE_DeleteMutation(t._key, Precondition.none())), this;
            }
        },
        {
            /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ key: "commit",
            value: function commit() {
                return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
            }
        },
        {
            key: "_verifyNotCommitted",
            value: function _verifyNotCommitted() {
                if (this._committed) throw new FirestoreError(C.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
            }
        }
    ]);
    return WriteBatch;
}();
function __PRIVATE_validateReference(e, t) {
    if ((e = (0, $gQ5gw.getModularInstance)(e)).firestore !== t) throw new FirestoreError(C.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ var Transaction = /*#__PURE__*/ function(_Transaction$1) {
    "use strict";
    (0, $iNfU4._)(Transaction, _Transaction$1);
    var _super = (0, $k1NN5._)(Transaction);
    function Transaction(e, t) {
        (0, $19mwo._)(this, Transaction);
        var _this;
        _this = _super.call(this, e, t), _this._firestore = e;
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(Transaction, [
        {
            /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ key: "get",
            value: function get(e) {
                var _this = this;
                var t = __PRIVATE_validateReference(e, this._firestore), n = new __PRIVATE_ExpUserDataWriter(this._firestore);
                return (0, $jLCbM._)((0, $laF8D._)(Transaction.prototype), "get", this).call(this, e).then(function(e) {
                    return new DocumentSnapshot(_this._firestore, n, t._key, e._document, new SnapshotMetadata(/* hasPendingWrites= */ !1, /* fromCache= */ !1), t.converter);
                });
            }
        }
    ]);
    return Transaction;
}(/*#__PURE__*/ function() {
    "use strict";
    function Transaction$1(e, t) {
        (0, $19mwo._)(this, Transaction$1);
        this._firestore = e, this._transaction = t, this._dataReader = __PRIVATE_newUserDataReader(e);
    }
    (0, $6rpfc._)(Transaction$1, [
        {
            /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ key: "get",
            value: function get(e) {
                var _this = this;
                var t = __PRIVATE_validateReference(e, this._firestore), n = new __PRIVATE_LiteUserDataWriter(this._firestore);
                return this._transaction.lookup([
                    t._key
                ]).then(function(e) {
                    if (!e || 1 !== e.length) return fail();
                    var r = e[0];
                    if (r.isFoundDocument()) return new DocumentSnapshot$1(_this._firestore, n, r.key, r, t.converter);
                    if (r.isNoDocument()) return new DocumentSnapshot$1(_this._firestore, n, t._key, null, t.converter);
                    throw fail();
                });
            }
        },
        {
            key: "set",
            value: function set(e, t, n) {
                var r = __PRIVATE_validateReference(e, this._firestore), i = __PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = __PRIVATE_parseSetData(this._dataReader, "Transaction.set", r._key, i, null !== r.converter, n);
                return this._transaction.set(r._key, s), this;
            }
        },
        {
            key: "update",
            value: function update(e, t, n) {
                for(var _len = arguments.length, r = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
                    r[_key - 3] = arguments[_key];
                }
                var i = __PRIVATE_validateReference(e, this._firestore);
                // For Compat types, we have to "extract" the underlying types before
                // performing validation.
                var s;
                return s = "string" == typeof (t = (0, $gQ5gw.getModularInstance)(t)) || t instanceof FieldPath ? __PRIVATE_parseUpdateVarargs(this._dataReader, "Transaction.update", i._key, t, n, r) : __PRIVATE_parseUpdateData(this._dataReader, "Transaction.update", i._key, t), this._transaction.update(i._key, s), this;
            }
        },
        {
            /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ key: "delete",
            value: function _delete(e) {
                var t = __PRIVATE_validateReference(e, this._firestore);
                return this._transaction.delete(t._key), this;
            }
        }
    ]);
    return Transaction$1;
}());
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function runTransaction(e, t, n) {
    e = __PRIVATE_cast(e, Firestore);
    var r = Object.assign(Object.assign({}, De), n);
    !function __PRIVATE_validateTransactionOptions(e) {
        if (e.maxAttempts < 1) throw new FirestoreError(C.INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    return function __PRIVATE_firestoreClientTransaction(e, t, n) {
        var r = new __PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $9OZ9j._)(function() {
            var i;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            __PRIVATE_getDatastore(e)
                        ];
                    case 1:
                        i = _state.sent();
                        new __PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).Xa();
                        return [
                            2
                        ];
                }
            });
        })), r.promise;
    }(ensureFirestoreConfigured(e), function(n) {
        return t(new Transaction(e, n));
    }, r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function deleteField() {
    return new __PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function serverTimestamp() {
    return new __PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function arrayUnion() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new __PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function arrayRemove() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new __PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function increment(e) {
    return new __PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */ function writeBatch(e) {
    return ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)), new WriteBatch(e, function(t) {
        return executeWrite(e, t);
    });
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function setIndexConfiguration(e, t) {
    var n;
    var r = ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore));
    if (!r._uninitializedComponentsProvider || "memory" === (null === (n = r._uninitializedComponentsProvider) || void 0 === n ? void 0 : n._offlineKind)) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return __PRIVATE_logWarn("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    var i = function __PRIVATE_parseIndexes(e) {
        var _$t = "string" == typeof e ? function __PRIVATE_tryParseJson(e) {
            try {
                return JSON.parse(e);
            } catch (e) {
                throw new FirestoreError(C.INVALID_ARGUMENT, "Failed to parse JSON: " + (null == e ? void 0 : e.message));
            }
        }(e) : e, n = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (Array.isArray(_$t.indexes)) try {
            for(var _iterator = _$t.indexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$e = _step.value;
                var _$t1 = __PRIVATE_tryGetString(_$e, "collectionGroup"), r = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (Array.isArray(_$e.fields)) try {
                    for(var _iterator1 = _$e.fields[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _$t2 = _step1.value;
                        var _$e1 = __PRIVATE_fieldPathFromDotSeparatedString("setIndexConfiguration", __PRIVATE_tryGetString(_$t2, "fieldPath"));
                        "CONTAINS" === _$t2.arrayConfig ? r.push(new IndexSegment(_$e1, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === _$t2.order ? r.push(new IndexSegment(_$e1, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === _$t2.order && r.push(new IndexSegment(_$e1, 1 /* IndexKind.DESCENDING */ ));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                n.push(new FieldIndex(FieldIndex.UNKNOWN_ID, _$t1, r, IndexState.empty()));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return n;
    }(t);
    return __PRIVATE_firestoreClientSetIndexConfiguration(r, i);
}
function __PRIVATE_tryGetString(e, t) {
    if ("string" != typeof e[t]) throw new FirestoreError(C.INVALID_ARGUMENT, "Missing string value for: " + t);
    return e[t];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ var PersistentCacheIndexManager = function PersistentCacheIndexManager(e) {
    "use strict";
    (0, $19mwo._)(this, PersistentCacheIndexManager);
    this._client = e, /** A type string to uniquely identify instances of this class. */ this.type = "PersistentCacheIndexManager";
};
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @return The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function getPersistentCacheIndexManager(e) {
    var t;
    e = __PRIVATE_cast(e, Firestore);
    var n = Ce.get(e);
    if (n) return n;
    var r = ensureFirestoreConfigured(e);
    if ("persistent" !== (null === (t = r._uninitializedComponentsProvider) || void 0 === t ? void 0 : t._offlineKind)) return null;
    var i = new PersistentCacheIndexManager(r);
    return Ce.set(e, i), i;
}
/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function enablePersistentCacheIndexAutoCreation(e) {
    __PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !0);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function disablePersistentCacheIndexAutoCreation(e) {
    __PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !1);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function deleteAllPersistentCacheIndexes(e) {
    e._client.verifyNotTerminated();
    __PRIVATE_firestoreClientDeleteAllFieldIndexes(e._client).then(function(e) {
        return __PRIVATE_logDebug("deleting all persistent cache indexes succeeded");
    }).catch(function(e) {
        return __PRIVATE_logWarn("deleting all persistent cache indexes failed", e);
    });
}
function __PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, t) {
    e._client.verifyNotTerminated();
    __PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(e._client, t).then(function(e) {
        return __PRIVATE_logDebug("setting persistent cache index auto creation isEnabled=".concat(t, " succeeded"));
    }).catch(function(e) {
        return __PRIVATE_logWarn("setting persistent cache index auto creation isEnabled=".concat(t, " failed"), e);
    });
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ var Ce = new WeakMap;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _internalQueryToProtoQueryTarget(e) {
    var t;
    var n = null === (t = ensureFirestoreConfigured(__PRIVATE_cast(e.firestore, Firestore))._onlineComponents) || void 0 === t ? void 0 : t.datastore.serializer;
    return void 0 === n ? null : __PRIVATE_toQueryTarget(n, __PRIVATE_queryToTarget(e._query))._t;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function _internalAggregationQueryToProtoRunAggregationQueryRequest(e, t) {
    var n;
    var r = __PRIVATE_mapToArray(t, function(e, t) {
        return new __PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath);
    }), i = null === (n = ensureFirestoreConfigured(__PRIVATE_cast(e.firestore, Firestore))._onlineComponents) || void 0 === n ? void 0 : n.datastore.serializer;
    return void 0 === i ? null : __PRIVATE_toRunAggregationQueryRequest(i, __PRIVATE_queryToAggregateTarget(e._query), r, /* skipAliasing= */ !0).request;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ var TestingHooks = /*#__PURE__*/ function() {
    "use strict";
    function TestingHooks() {
        (0, $19mwo._)(this, TestingHooks);
        throw new Error("instances of this class should not be created");
    }
    (0, $6rpfc._)(TestingHooks, null, [
        {
            key: "onExistenceFilterMismatch",
            value: /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback the callback to invoke upon existence filter mismatch.
     *
     * @return a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ function onExistenceFilterMismatch(e) {
                return __PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(e);
            }
        }
    ]);
    return TestingHooks;
}();
/**
 * The implementation of `TestingHooksSpi`.
 */ var __PRIVATE_TestingHooksSpiImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TestingHooksSpiImpl() {
        (0, $19mwo._)(this, __PRIVATE_TestingHooksSpiImpl);
        this.Ou = new Map;
    }
    (0, $6rpfc._)(__PRIVATE_TestingHooksSpiImpl, [
        {
            key: "et",
            value: function et(e) {
                this.Ou.forEach(function(t) {
                    return t(e);
                });
            }
        },
        {
            key: "onExistenceFilterMismatch",
            value: function onExistenceFilterMismatch(e) {
                var t = Symbol(), n = this.Ou;
                return n.set(t, e), function() {
                    return n.delete(t);
                };
            }
        }
    ], [
        {
            key: "instance",
            get: function get() {
                return ve || (ve = new __PRIVATE_TestingHooksSpiImpl, function __PRIVATE_setTestingHooksSpi(e) {
                    if (he) throw new Error("a TestingHooksSpi instance is already set");
                    he = e;
                }(ve)), ve;
            }
        }
    ]);
    return __PRIVATE_TestingHooksSpiImpl;
}();
var ve = null;
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    !function __PRIVATE_setSDKVersion(e) {
        b = e;
    }((0, $ilNGG.SDK_VERSION)), (0, $ilNGG._registerComponent)(new (0, $e5K63.Component)("firestore", function(e, param) {
        var n = param.instanceIdentifier, r = param.options;
        var i = e.getProvider("app").getImmediate(), s = new Firestore(new __PRIVATE_FirebaseAuthCredentialsProvider(e.getProvider("auth-internal")), new __PRIVATE_FirebaseAppCheckTokenProvider(e.getProvider("app-check-internal")), function __PRIVATE_databaseIdFromApp(e, t) {
            if (!Object.prototype.hasOwnProperty.apply(e.options, [
                "projectId"
            ])) throw new FirestoreError(C.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new DatabaseId(e.options.projectId, t);
        }(i, n), i);
        return r = Object.assign({
            useFetchStreams: t
        }, r), s._setSettings(r), s;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $ilNGG.registerVersion)(S, "4.6.4", e), // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $ilNGG.registerVersion)(S, "4.6.4", "esm2017");
}();

});
parcelRegister("9OZ9j", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $726837850a4fe2e7$export$7c398597f8905a1; });
function $726837850a4fe2e7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $726837850a4fe2e7$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $726837850a4fe2e7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $726837850a4fe2e7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("19mwo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0d6819fee3f78aec$export$2996f80ef42b8419; });
function $0d6819fee3f78aec$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("2xfp5", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $1d8a9cadc5491183$export$2d841144c5f8c4ab; });
$parcel$export(module.exports, "_", function () { return $1d8a9cadc5491183$export$2d841144c5f8c4ab; });

var $3cNIF = parcelRequire("3cNIF");

var $P3KuD = parcelRequire("P3KuD");
function $1d8a9cadc5491183$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $3cNIF._is_native_reflect_construct)()) $1d8a9cadc5491183$export$2d841144c5f8c4ab = Reflect.construct;
    else $1d8a9cadc5491183$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $P3KuD._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $1d8a9cadc5491183$export$2d841144c5f8c4ab.apply(null, arguments);
}

});
parcelRegister("3cNIF", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $25590f4f6624105d$export$685354647fba1516; });
function $25590f4f6624105d$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("P3KuD", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $0997abfc83ebc956$export$c2c98ac76e997b63; });
function $0997abfc83ebc956$export$c2c98ac76e997b63(o, p) {
    $0997abfc83ebc956$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0997abfc83ebc956$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("6rpfc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4b08d8a4f0594707$export$d60067ff2358eee8; });
function $4b08d8a4f0594707$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4b08d8a4f0594707$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $4b08d8a4f0594707$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4b08d8a4f0594707$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("jLCbM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e64007ab1c836ebf$export$afb3516d9d608401; });

var $d6Plo = parcelRequire("d6Plo");
function $e64007ab1c836ebf$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $e64007ab1c836ebf$export$afb3516d9d608401 = Reflect.get;
    else $e64007ab1c836ebf$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $d6Plo._super_prop_base)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $e64007ab1c836ebf$export$afb3516d9d608401(target, property, receiver || target);
}

});
parcelRegister("d6Plo", function(module, exports) {

$parcel$export(module.exports, "_super_prop_base", function () { return $98b3a9c5fd02464e$export$e4187255aefbc259; });

var $laF8D = parcelRequire("laF8D");
function $98b3a9c5fd02464e$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $laF8D._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}

});
parcelRegister("laF8D", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $f69a7158f4c6acee$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $f69a7158f4c6acee$export$f09211a7d3c496a1; });
function $f69a7158f4c6acee$export$f09211a7d3c496a1(o) {
    $f69a7158f4c6acee$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f69a7158f4c6acee$export$f09211a7d3c496a1(o);
}

});



parcelRegister("iNfU4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $dae923b2b1e47bc2$export$7e4530ad35d3bb8; });

var $P3KuD = parcelRequire("P3KuD");
function $dae923b2b1e47bc2$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $P3KuD._set_prototype_of)(subClass, superClass);
}

});

parcelRegister("hSCyS", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $d045645373b2ff14$export$ef97c660ca164e52; });
$parcel$export(module.exports, "_", function () { return $d045645373b2ff14$export$ef97c660ca164e52; });

var $15Pju = parcelRequire("15Pju");

var $gnDeW = parcelRequire("gnDeW");
function $d045645373b2ff14$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $gnDeW._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $15Pju._assert_this_initialized)(self);
}

});
parcelRegister("15Pju", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $0cbe0fd391348a8b$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $0cbe0fd391348a8b$export$f3b8ed2e4a5d10b8; });
function $0cbe0fd391348a8b$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});


parcelRegister("2MTYX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $207b7d5cf01ea820$export$fdf2a89c76341bbf; });

var $4rXYA = parcelRequire("4rXYA");

var $l6kcj = parcelRequire("l6kcj");

var $72HXH = parcelRequire("72HXH");

var $e9mxI = parcelRequire("e9mxI");
function $207b7d5cf01ea820$export$fdf2a89c76341bbf(arr, i) {
    return (0, $4rXYA._array_with_holes)(arr) || (0, $l6kcj._iterable_to_array_limit)(arr, i) || (0, $e9mxI._unsupported_iterable_to_array)(arr, i) || (0, $72HXH._non_iterable_rest)();
}

});
parcelRegister("4rXYA", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $33d8350eff40e0c1$export$e6256bf45c68d561; });
function $33d8350eff40e0c1$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("l6kcj", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $f5c9d3528aebe6fe$export$2fd15edff6687200; });
function $f5c9d3528aebe6fe$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("72HXH", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $520ad237069f9f54$export$60dbc22abd7da546; });
function $520ad237069f9f54$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("e9mxI", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $a4d3648114e31d20$export$a5be06335b3a083c; });

var $01v2J = parcelRequire("01v2J");
function $a4d3648114e31d20$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $01v2J._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $01v2J._array_like_to_array)(o, minLen);
}

});
parcelRegister("01v2J", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $00482c986aae5fbb$export$79e617b1955a2616; });
function $00482c986aae5fbb$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("3jzhD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $269e83fe683e1138$export$1b5e630bc3aea29f; });

var $bFcUn = parcelRequire("bFcUn");

var $bXCSl = parcelRequire("bXCSl");

var $bmsnS = parcelRequire("bmsnS");

var $e9mxI = parcelRequire("e9mxI");
function $269e83fe683e1138$export$1b5e630bc3aea29f(arr) {
    return (0, $bFcUn._array_without_holes)(arr) || (0, $bXCSl._iterable_to_array)(arr) || (0, $e9mxI._unsupported_iterable_to_array)(arr) || (0, $bmsnS._non_iterable_spread)();
}

});
parcelRegister("bFcUn", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $87dd895d3c503d5c$export$7e0947b5ad3404e2; });

var $01v2J = parcelRequire("01v2J");
function $87dd895d3c503d5c$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $01v2J._array_like_to_array)(arr);
}

});

parcelRegister("bXCSl", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $8b535c46f548a7d1$export$1eb58a6e75231000; });
function $8b535c46f548a7d1$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("bmsnS", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $8457c442b048f6ce$export$e6f3c4780d19eb2b; });
function $8457c442b048f6ce$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("etlBe", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a894875776326f1a$export$2466d533fda16e33; });

var $2xfp5 = parcelRequire("2xfp5");

var $laF8D = parcelRequire("laF8D");

var $64gqa = parcelRequire("64gqa");

var $P3KuD = parcelRequire("P3KuD");
function $a894875776326f1a$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $a894875776326f1a$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $64gqa._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $2xfp5._construct)(Class, arguments, (0, $laF8D._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $P3KuD._set_prototype_of)(Wrapper, Class);
    };
    return $a894875776326f1a$export$2466d533fda16e33(Class);
}

});
parcelRegister("64gqa", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $46afdaab5902c6c6$export$514eda94019f4334; });
function $46afdaab5902c6c6$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("k1NN5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e94a860c9aacac07$export$8dd05c13f5255580; });

var $laF8D = parcelRequire("laF8D");

var $3cNIF = parcelRequire("3cNIF");

var $hSCyS = parcelRequire("hSCyS");
function $e94a860c9aacac07$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $3cNIF._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $laF8D._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $laF8D._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $hSCyS._possible_constructor_return)(this, result);
    };
}

});

parcelRegister("lF1I7", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $fc4ec0fbc5686322$export$3c9a16f847548506; });
$parcel$export(module.exports, "__generator", function () { return $fc4ec0fbc5686322$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $fc4ec0fbc5686322$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $gnDeW = parcelRequire("gnDeW");
var $fc4ec0fbc5686322$var$extendStatics = function extendStatics1(d, b) {
    $fc4ec0fbc5686322$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $fc4ec0fbc5686322$var$extendStatics(d, b);
};
function $fc4ec0fbc5686322$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $fc4ec0fbc5686322$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fc4ec0fbc5686322$export$18ce0697a983be9b = function __assign1() {
    $fc4ec0fbc5686322$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc4ec0fbc5686322$export$18ce0697a983be9b.apply(this, arguments);
};
function $fc4ec0fbc5686322$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fc4ec0fbc5686322$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $fc4ec0fbc5686322$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $fc4ec0fbc5686322$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $fc4ec0fbc5686322$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $fc4ec0fbc5686322$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $gnDeW._)(x)) === "symbol" ? x : "".concat(x);
}
function $fc4ec0fbc5686322$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $gnDeW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $fc4ec0fbc5686322$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $fc4ec0fbc5686322$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fc4ec0fbc5686322$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $fc4ec0fbc5686322$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $fc4ec0fbc5686322$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $fc4ec0fbc5686322$export$45d3717a4c69092e(o, m, p);
}
function $fc4ec0fbc5686322$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $fc4ec0fbc5686322$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $fc4ec0fbc5686322$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fc4ec0fbc5686322$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $fc4ec0fbc5686322$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $fc4ec0fbc5686322$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $fc4ec0fbc5686322$export$10c90e4f7922046c(v) {
    return this instanceof $fc4ec0fbc5686322$export$10c90e4f7922046c ? (this.v = v, this) : new $fc4ec0fbc5686322$export$10c90e4f7922046c(v);
}
function $fc4ec0fbc5686322$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fc4ec0fbc5686322$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $fc4ec0fbc5686322$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fc4ec0fbc5686322$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $fc4ec0fbc5686322$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $fc4ec0fbc5686322$export$19a8beecd37a4c45 === "function" ? $fc4ec0fbc5686322$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $fc4ec0fbc5686322$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $fc4ec0fbc5686322$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $fc4ec0fbc5686322$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $fc4ec0fbc5686322$export$45d3717a4c69092e(result, mod, k);
    }
    $fc4ec0fbc5686322$var$__setModuleDefault(result, mod);
    return result;
}
function $fc4ec0fbc5686322$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $fc4ec0fbc5686322$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $fc4ec0fbc5686322$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $fc4ec0fbc5686322$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $fc4ec0fbc5686322$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $fc4ec0fbc5686322$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $fc4ec0fbc5686322$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $fc4ec0fbc5686322$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $fc4ec0fbc5686322$export$2e2bcd8739ae039 = {
    __extends: $fc4ec0fbc5686322$export$a8ba968b8961cb8a,
    __assign: $fc4ec0fbc5686322$export$18ce0697a983be9b,
    __rest: $fc4ec0fbc5686322$export$3c9a16f847548506,
    __decorate: $fc4ec0fbc5686322$export$29e00dfd3077644b,
    __param: $fc4ec0fbc5686322$export$d5ad3fd78186038f,
    __metadata: $fc4ec0fbc5686322$export$f1db080c865becb9,
    __awaiter: $fc4ec0fbc5686322$export$1050f835b63b671e,
    __generator: $fc4ec0fbc5686322$export$67ebef60e6f28a6,
    __createBinding: $fc4ec0fbc5686322$export$45d3717a4c69092e,
    __exportStar: $fc4ec0fbc5686322$export$f33643c0debef087,
    __values: $fc4ec0fbc5686322$export$19a8beecd37a4c45,
    __read: $fc4ec0fbc5686322$export$8d051b38c9118094,
    __spread: $fc4ec0fbc5686322$export$afc72e2116322959,
    __spreadArrays: $fc4ec0fbc5686322$export$6388937ca91ccae8,
    __spreadArray: $fc4ec0fbc5686322$export$1216008129fb82ed,
    __await: $fc4ec0fbc5686322$export$10c90e4f7922046c,
    __asyncGenerator: $fc4ec0fbc5686322$export$e427f37a30a4de9b,
    __asyncDelegator: $fc4ec0fbc5686322$export$bbd80228419bb833,
    __asyncValues: $fc4ec0fbc5686322$export$e3b29a3d6162315f,
    __makeTemplateObject: $fc4ec0fbc5686322$export$4fb47efe1390b86f,
    __importStar: $fc4ec0fbc5686322$export$c21735bcef00d192,
    __importDefault: $fc4ec0fbc5686322$export$da59b14a69baef04,
    __classPrivateFieldGet: $fc4ec0fbc5686322$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $fc4ec0fbc5686322$export$d40a35129aaff81f,
    __classPrivateFieldIn: $fc4ec0fbc5686322$export$81fdc39f203e4e04,
    __addDisposableResource: $fc4ec0fbc5686322$export$88ac25d8e944e405,
    __disposeResources: $fc4ec0fbc5686322$export$8f076105dc360e92
};

});

parcelRegister("ilNGG", function(module, exports) {

$parcel$export(module.exports, "_registerComponent", function () { return $d5c0bb0cb4aa3aa2$export$c930050e7bb63965; });
$parcel$export(module.exports, "_getProvider", function () { return $d5c0bb0cb4aa3aa2$export$fa0d6da0f5838f50; });
$parcel$export(module.exports, "_removeServiceInstance", function () { return $d5c0bb0cb4aa3aa2$export$48d18de2ff1c45a5; });
$parcel$export(module.exports, "_isFirebaseServerApp", function () { return $d5c0bb0cb4aa3aa2$export$643c8bc6c389f34e; });
$parcel$export(module.exports, "registerVersion", function () { return $d5c0bb0cb4aa3aa2$export$d29d5299a7137abc; });
$parcel$export(module.exports, "SDK_VERSION", function () { return $d5c0bb0cb4aa3aa2$export$31499a9cd224b78c; });
$parcel$export(module.exports, "initializeApp", function () { return $d5c0bb0cb4aa3aa2$export$c55cfd413944906d; });
$parcel$export(module.exports, "getApp", function () { return $d5c0bb0cb4aa3aa2$export$f9962582c9e66d99; });

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $c5rwh = parcelRequire("c5rwh");

var $iNfU4 = parcelRequire("iNfU4");

var $hSCyS = parcelRequire("hSCyS");

var $3jzhD = parcelRequire("3jzhD");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");

var $e5K63 = parcelRequire("e5K63");

var $3DJ6n = parcelRequire("3DJ6n");

var $gQ5gw = parcelRequire("gQ5gw");

var $7iY56 = parcelRequire("7iY56");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d5c0bb0cb4aa3aa2$var$PlatformLoggerServiceImpl = /*#__PURE__*/ function() {
    "use strict";
    function PlatformLoggerServiceImpl(container) {
        (0, $19mwo._)(this, PlatformLoggerServiceImpl);
        this.container = container;
    }
    (0, $6rpfc._)(PlatformLoggerServiceImpl, [
        {
            // In initial implementation, this will be called by installations on
            // auth token refresh, and installations will send this string.
            key: "getPlatformInfoString",
            value: function getPlatformInfoString() {
                var providers = this.container.getProviders();
                // Loop through providers and get library/version pairs from any that are
                // version components.
                return providers.map(function(provider) {
                    if ($d5c0bb0cb4aa3aa2$var$isVersionServiceProvider(provider)) {
                        var service = provider.getImmediate();
                        return "".concat(service.library, "/").concat(service.version);
                    } else return null;
                }).filter(function(logString) {
                    return logString;
                }).join(" ");
            }
        }
    ]);
    return PlatformLoggerServiceImpl;
}();
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $d5c0bb0cb4aa3aa2$var$isVersionServiceProvider(provider) {
    var component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
var $d5c0bb0cb4aa3aa2$var$name$p = "@firebase/app";
var $d5c0bb0cb4aa3aa2$var$version$1 = "0.10.6";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d5c0bb0cb4aa3aa2$var$logger = new (0, $3DJ6n.Logger)("@firebase/app");
var $d5c0bb0cb4aa3aa2$var$name$o = "@firebase/app-compat";
var $d5c0bb0cb4aa3aa2$var$name$n = "@firebase/analytics-compat";
var $d5c0bb0cb4aa3aa2$var$name$m = "@firebase/analytics";
var $d5c0bb0cb4aa3aa2$var$name$l = "@firebase/app-check-compat";
var $d5c0bb0cb4aa3aa2$var$name$k = "@firebase/app-check";
var $d5c0bb0cb4aa3aa2$var$name$j = "@firebase/auth";
var $d5c0bb0cb4aa3aa2$var$name$i = "@firebase/auth-compat";
var $d5c0bb0cb4aa3aa2$var$name$h = "@firebase/database";
var $d5c0bb0cb4aa3aa2$var$name$g = "@firebase/database-compat";
var $d5c0bb0cb4aa3aa2$var$name$f = "@firebase/functions";
var $d5c0bb0cb4aa3aa2$var$name$e = "@firebase/functions-compat";
var $d5c0bb0cb4aa3aa2$var$name$d = "@firebase/installations";
var $d5c0bb0cb4aa3aa2$var$name$c = "@firebase/installations-compat";
var $d5c0bb0cb4aa3aa2$var$name$b = "@firebase/messaging";
var $d5c0bb0cb4aa3aa2$var$name$a = "@firebase/messaging-compat";
var $d5c0bb0cb4aa3aa2$var$name$9 = "@firebase/performance";
var $d5c0bb0cb4aa3aa2$var$name$8 = "@firebase/performance-compat";
var $d5c0bb0cb4aa3aa2$var$name$7 = "@firebase/remote-config";
var $d5c0bb0cb4aa3aa2$var$name$6 = "@firebase/remote-config-compat";
var $d5c0bb0cb4aa3aa2$var$name$5 = "@firebase/storage";
var $d5c0bb0cb4aa3aa2$var$name$4 = "@firebase/storage-compat";
var $d5c0bb0cb4aa3aa2$var$name$3 = "@firebase/firestore";
var $d5c0bb0cb4aa3aa2$var$name$2 = "@firebase/vertexai-preview";
var $d5c0bb0cb4aa3aa2$var$name$1 = "@firebase/firestore-compat";
var $d5c0bb0cb4aa3aa2$var$name = "firebase";
var $d5c0bb0cb4aa3aa2$var$version = "10.12.3";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ var $d5c0bb0cb4aa3aa2$export$9f30fa0c10967f7f = "[DEFAULT]";
var $d5c0bb0cb4aa3aa2$var$_obj;
var $d5c0bb0cb4aa3aa2$var$PLATFORM_LOG_STRING = ($d5c0bb0cb4aa3aa2$var$_obj = {}, (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$p, "fire-core"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$o, "fire-core-compat"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$m, "fire-analytics"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$n, "fire-analytics-compat"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$k, "fire-app-check"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$l, "fire-app-check-compat"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$j, "fire-auth"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$i, "fire-auth-compat"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$h, "fire-rtdb"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$g, "fire-rtdb-compat"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$f, "fire-fn"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$e, "fire-fn-compat"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$d, "fire-iid"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$c, "fire-iid-compat"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$b, "fire-fcm"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$a, "fire-fcm-compat"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$9, "fire-perf"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$8, "fire-perf-compat"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$7, "fire-rc"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$6, "fire-rc-compat"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$5, "fire-gcs"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$4, "fire-gcs-compat"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$3, "fire-fst"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$1, "fire-fst-compat"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name$2, "fire-vertex"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, "fire-js", "fire-js"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj, $d5c0bb0cb4aa3aa2$var$name, "fire-js-all"), $d5c0bb0cb4aa3aa2$var$_obj);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ var $d5c0bb0cb4aa3aa2$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ var $d5c0bb0cb4aa3aa2$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $d5c0bb0cb4aa3aa2$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $d5c0bb0cb4aa3aa2$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $d5c0bb0cb4aa3aa2$var$logger.debug("Component ".concat(component.name, " failed to register with FirebaseApp ").concat(app.name), e);
    }
}
/**
 *
 * @internal
 */ function $d5c0bb0cb4aa3aa2$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $d5c0bb0cb4aa3aa2$export$c930050e7bb63965(component) {
    var componentName = component.name;
    if ($d5c0bb0cb4aa3aa2$export$9566bce3835c0f28.has(componentName)) {
        $d5c0bb0cb4aa3aa2$var$logger.debug("There were multiple attempts to register component ".concat(componentName, "."));
        return false;
    }
    $d5c0bb0cb4aa3aa2$export$9566bce3835c0f28.set(componentName, component);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // add the component to existing app instances
        for(var _iterator = $d5c0bb0cb4aa3aa2$export$b4e3c36c855b14b5.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var app = _step.value;
            $d5c0bb0cb4aa3aa2$export$fa5244b94c62d36a(app, component);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = $d5c0bb0cb4aa3aa2$export$fb03ad8d3d5c5f76.values()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var serverApp = _step1.value;
            $d5c0bb0cb4aa3aa2$export$fa5244b94c62d36a(serverApp, component);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $d5c0bb0cb4aa3aa2$export$fa0d6da0f5838f50(app, name) {
    var heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $d5c0bb0cb4aa3aa2$export$48d18de2ff1c45a5(app, name) {
    var instanceIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $d5c0bb0cb4aa3aa2$export$9f30fa0c10967f7f;
    $d5c0bb0cb4aa3aa2$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $d5c0bb0cb4aa3aa2$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $d5c0bb0cb4aa3aa2$export$643c8bc6c389f34e(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $d5c0bb0cb4aa3aa2$export$3685d89b9c3cdfaf() {
    $d5c0bb0cb4aa3aa2$export$9566bce3835c0f28.clear();
}
var $d5c0bb0cb4aa3aa2$var$_obj1;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d5c0bb0cb4aa3aa2$var$ERRORS = ($d5c0bb0cb4aa3aa2$var$_obj1 = {}, (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj1, "no-app" /* AppError.NO_APP */ , "No Firebase App '{$appName}' has been created - call initializeApp() first"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj1, "bad-app-name" /* AppError.BAD_APP_NAME */ , "Illegal App name: '{$appName}'"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj1, "duplicate-app" /* AppError.DUPLICATE_APP */ , "Firebase App named '{$appName}' already exists with different options or config"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj1, "app-deleted" /* AppError.APP_DELETED */ , "Firebase App named '{$appName}' already deleted"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj1, "server-app-deleted" /* AppError.SERVER_APP_DELETED */ , "Firebase Server App has been deleted"), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj1, "no-options" /* AppError.NO_OPTIONS */ , "Need to provide options, when not being deployed to hosting via source."), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj1, "invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ , "firebase.{$appName}() takes either no argument or a Firebase App instance."), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj1, "invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ , "First argument to `onLog` must be null or a function."), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj1, "idb-open" /* AppError.IDB_OPEN */ , "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}."), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj1, "idb-get" /* AppError.IDB_GET */ , "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}."), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj1, "idb-set" /* AppError.IDB_WRITE */ , "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}."), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj1, "idb-delete" /* AppError.IDB_DELETE */ , "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj1, "finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry."), (0, $c5rwh._)($d5c0bb0cb4aa3aa2$var$_obj1, "invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ , "FirebaseServerApp is not for use in browser environments."), $d5c0bb0cb4aa3aa2$var$_obj1);
var $d5c0bb0cb4aa3aa2$var$ERROR_FACTORY = new (0, $gQ5gw.ErrorFactory)("app", "Firebase", $d5c0bb0cb4aa3aa2$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d5c0bb0cb4aa3aa2$var$FirebaseAppImpl = /*#__PURE__*/ function() {
    "use strict";
    function FirebaseAppImpl(options, config, container) {
        var _this = this;
        (0, $19mwo._)(this, FirebaseAppImpl);
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $e5K63.Component)("app", function() {
            return _this;
        }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    (0, $6rpfc._)(FirebaseAppImpl, [
        {
            key: "automaticDataCollectionEnabled",
            get: function get() {
                this.checkDestroyed();
                return this._automaticDataCollectionEnabled;
            },
            set: function set(val) {
                this.checkDestroyed();
                this._automaticDataCollectionEnabled = val;
            }
        },
        {
            key: "name",
            get: function get() {
                this.checkDestroyed();
                return this._name;
            }
        },
        {
            key: "options",
            get: function get() {
                this.checkDestroyed();
                return this._options;
            }
        },
        {
            key: "config",
            get: function get() {
                this.checkDestroyed();
                return this._config;
            }
        },
        {
            key: "container",
            get: function get() {
                return this._container;
            }
        },
        {
            key: "isDeleted",
            get: function get() {
                return this._isDeleted;
            },
            set: function set(val) {
                this._isDeleted = val;
            }
        },
        {
            /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ key: "checkDestroyed",
            value: function checkDestroyed() {
                if (this.isDeleted) throw $d5c0bb0cb4aa3aa2$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
                    appName: this._name
                });
            }
        }
    ]);
    return FirebaseAppImpl;
}();
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d5c0bb0cb4aa3aa2$var$FirebaseServerAppImpl = /*#__PURE__*/ function(FirebaseAppImpl) {
    "use strict";
    (0, $iNfU4._)(FirebaseServerAppImpl, FirebaseAppImpl);
    var _super = (0, $k1NN5._)(FirebaseServerAppImpl);
    function FirebaseServerAppImpl(options, serverConfig, name, container) {
        (0, $19mwo._)(this, FirebaseServerAppImpl);
        var _this;
        // Build configuration parameters for the FirebaseAppImpl base class.
        var automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        var config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        _this = _super.call(this, options, config, container);
        else {
            var appImpl = options;
            _this = _super.call(this, appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        _this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        _this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== "undefined") _this._finalizationRegistry = new FinalizationRegistry(function() {
            _this.automaticCleanup();
        });
        _this._refCount = 0;
        _this.incRefCount(_this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegisry
        // will never trigger.
        _this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $d5c0bb0cb4aa3aa2$export$d29d5299a7137abc($d5c0bb0cb4aa3aa2$var$name$p, $d5c0bb0cb4aa3aa2$var$version$1, "serverapp");
        return (0, $hSCyS._)(_this);
    }
    (0, $6rpfc._)(FirebaseServerAppImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return undefined;
            }
        },
        {
            key: "refCount",
            get: function get() {
                return this._refCount;
            }
        },
        {
            // Increment the reference count of this server app. If an object is provided, register it
            // with the finalization registry.
            key: "incRefCount",
            value: function incRefCount(obj) {
                if (this.isDeleted) return;
                this._refCount++;
                if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
            }
        },
        {
            // Decrement the reference count.
            key: "decRefCount",
            value: function decRefCount() {
                if (this.isDeleted) return 0;
                return --this._refCount;
            }
        },
        {
            // Invoked by the FinalizationRegistry callback to note that this app should go through its
            // reference counts and delete itself if no reference count remain. The coordinating logic that
            // handles this is in deleteApp(...).
            key: "automaticCleanup",
            value: function automaticCleanup() {
                $d5c0bb0cb4aa3aa2$export$6eec44aa53d5ea34(this);
            }
        },
        {
            key: "settings",
            get: function get() {
                this.checkDestroyed();
                return this._serverConfig;
            }
        },
        {
            /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ key: "checkDestroyed",
            value: function checkDestroyed() {
                if (this.isDeleted) throw $d5c0bb0cb4aa3aa2$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
            }
        }
    ]);
    return FirebaseServerAppImpl;
}($d5c0bb0cb4aa3aa2$var$FirebaseAppImpl);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ var $d5c0bb0cb4aa3aa2$export$31499a9cd224b78c = $d5c0bb0cb4aa3aa2$var$version;
function $d5c0bb0cb4aa3aa2$export$c55cfd413944906d(_options) {
    var rawConfig = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var options = _options;
    if (typeof rawConfig !== "object") {
        var name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    var config = Object.assign({
        name: $d5c0bb0cb4aa3aa2$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    var name1 = config.name;
    if (typeof name1 !== "string" || !name1) throw $d5c0bb0cb4aa3aa2$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name1)
    });
    options || (options = (0, $gQ5gw.getDefaultAppConfig)());
    if (!options) throw $d5c0bb0cb4aa3aa2$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    var existingApp = $d5c0bb0cb4aa3aa2$export$b4e3c36c855b14b5.get(name1);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $gQ5gw.deepEqual)(options, existingApp.options) && (0, $gQ5gw.deepEqual)(config, existingApp.config)) return existingApp;
        else throw $d5c0bb0cb4aa3aa2$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name1
        });
    }
    var container = new (0, $e5K63.ComponentContainer)(name1);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $d5c0bb0cb4aa3aa2$export$9566bce3835c0f28.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var component = _step.value;
            container.addComponent(component);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var newApp = new $d5c0bb0cb4aa3aa2$var$FirebaseAppImpl(options, config, container);
    $d5c0bb0cb4aa3aa2$export$b4e3c36c855b14b5.set(name1, newApp);
    return newApp;
}
function $d5c0bb0cb4aa3aa2$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $gQ5gw.isBrowser)() && !(0, $gQ5gw.isWebWorker)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $d5c0bb0cb4aa3aa2$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = false;
    var appOptions;
    if ($d5c0bb0cb4aa3aa2$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    var nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    var hashCode = function(s) {
        return (0, $3jzhD._)(s).reduce(function(hash, c) {
            return Math.imul(31, hash) + c.charCodeAt(0) | 0;
        }, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === "undefined") throw $d5c0bb0cb4aa3aa2$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    var nameString = "" + hashCode(JSON.stringify(nameObj));
    var existingApp = $d5c0bb0cb4aa3aa2$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    var container = new (0, $e5K63.ComponentContainer)(nameString);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $d5c0bb0cb4aa3aa2$export$9566bce3835c0f28.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var component = _step.value;
            container.addComponent(component);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var newApp = new $d5c0bb0cb4aa3aa2$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $d5c0bb0cb4aa3aa2$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $d5c0bb0cb4aa3aa2$export$f9962582c9e66d99() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d5c0bb0cb4aa3aa2$export$9f30fa0c10967f7f;
    var app = $d5c0bb0cb4aa3aa2$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $d5c0bb0cb4aa3aa2$export$9f30fa0c10967f7f && (0, $gQ5gw.getDefaultAppConfig)()) return $d5c0bb0cb4aa3aa2$export$c55cfd413944906d();
    if (!app) throw $d5c0bb0cb4aa3aa2$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $d5c0bb0cb4aa3aa2$export$68ddedf7d44b3bdf() {
    return Array.from($d5c0bb0cb4aa3aa2$export$b4e3c36c855b14b5.values());
}
function $d5c0bb0cb4aa3aa2$export$6eec44aa53d5ea34(app) {
    return $d5c0bb0cb4aa3aa2$var$_deleteApp.apply(this, arguments);
}
function $d5c0bb0cb4aa3aa2$var$_deleteApp() {
    $d5c0bb0cb4aa3aa2$var$_deleteApp = /**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ (0, $9OZ9j._)(function(app) {
        var cleanupProviders, name, firebaseServerApp;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    cleanupProviders = false;
                    name = app.name;
                    if ($d5c0bb0cb4aa3aa2$export$b4e3c36c855b14b5.has(name)) {
                        cleanupProviders = true;
                        $d5c0bb0cb4aa3aa2$export$b4e3c36c855b14b5.delete(name);
                    } else if ($d5c0bb0cb4aa3aa2$export$fb03ad8d3d5c5f76.has(name)) {
                        firebaseServerApp = app;
                        if (firebaseServerApp.decRefCount() <= 0) {
                            $d5c0bb0cb4aa3aa2$export$fb03ad8d3d5c5f76.delete(name);
                            cleanupProviders = true;
                        }
                    }
                    if (!cleanupProviders) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Promise.all(app.container.getProviders().map(function(provider) {
                            return provider.delete();
                        }))
                    ];
                case 1:
                    _state.sent();
                    app.isDeleted = true;
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return $d5c0bb0cb4aa3aa2$var$_deleteApp.apply(this, arguments);
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $d5c0bb0cb4aa3aa2$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    var library = (_a = $d5c0bb0cb4aa3aa2$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += "-".concat(variant);
    var libraryMismatch = library.match(/\s|\//);
    var versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        var warning = [
            'Unable to register library "'.concat(library, '" with version "').concat(version, '":')
        ];
        if (libraryMismatch) warning.push('library name "'.concat(library, '" contains illegal characters (whitespace or "/")'));
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push('version name "'.concat(version, '" contains illegal characters (whitespace or "/")'));
        $d5c0bb0cb4aa3aa2$var$logger.warn(warning.join(" "));
        return;
    }
    $d5c0bb0cb4aa3aa2$export$c930050e7bb63965(new (0, $e5K63.Component)("".concat(library, "-version"), function() {
        return {
            library: library,
            version: version
        };
    }, "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $d5c0bb0cb4aa3aa2$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $d5c0bb0cb4aa3aa2$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $3DJ6n.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $d5c0bb0cb4aa3aa2$export$c622e99c0ce7b1c9(logLevel) {
    (0, $3DJ6n.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d5c0bb0cb4aa3aa2$var$DB_NAME = "firebase-heartbeat-database";
var $d5c0bb0cb4aa3aa2$var$DB_VERSION = 1;
var $d5c0bb0cb4aa3aa2$var$STORE_NAME = "firebase-heartbeat-store";
var $d5c0bb0cb4aa3aa2$var$dbPromise = null;
function $d5c0bb0cb4aa3aa2$var$getDbPromise() {
    if (!$d5c0bb0cb4aa3aa2$var$dbPromise) $d5c0bb0cb4aa3aa2$var$dbPromise = (0, $7iY56.openDB)($d5c0bb0cb4aa3aa2$var$DB_NAME, $d5c0bb0cb4aa3aa2$var$DB_VERSION, {
        upgrade: function(db, oldVersion) {
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($d5c0bb0cb4aa3aa2$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch(function(e) {
        throw $d5c0bb0cb4aa3aa2$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $d5c0bb0cb4aa3aa2$var$dbPromise;
}
function $d5c0bb0cb4aa3aa2$var$readHeartbeatsFromIndexedDB(app) {
    return $d5c0bb0cb4aa3aa2$var$_readHeartbeatsFromIndexedDB.apply(this, arguments);
}
function $d5c0bb0cb4aa3aa2$var$_readHeartbeatsFromIndexedDB() {
    $d5c0bb0cb4aa3aa2$var$_readHeartbeatsFromIndexedDB = (0, $9OZ9j._)(function(app) {
        var db, tx, result, e, idbGetError;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $d5c0bb0cb4aa3aa2$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    tx = db.transaction($d5c0bb0cb4aa3aa2$var$STORE_NAME);
                    return [
                        4,
                        tx.objectStore($d5c0bb0cb4aa3aa2$var$STORE_NAME).get($d5c0bb0cb4aa3aa2$var$computeKey(app))
                    ];
                case 2:
                    result = _state.sent();
                    // We already have the value but tx.done can throw,
                    // so we need to await it here to catch errors
                    return [
                        4,
                        tx.done
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        result
                    ];
                case 4:
                    e = _state.sent();
                    if (e instanceof (0, $gQ5gw.FirebaseError)) $d5c0bb0cb4aa3aa2$var$logger.warn(e.message);
                    else {
                        idbGetError = $d5c0bb0cb4aa3aa2$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                            originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                        });
                        $d5c0bb0cb4aa3aa2$var$logger.warn(idbGetError.message);
                    }
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $d5c0bb0cb4aa3aa2$var$_readHeartbeatsFromIndexedDB.apply(this, arguments);
}
function $d5c0bb0cb4aa3aa2$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    return $d5c0bb0cb4aa3aa2$var$_writeHeartbeatsToIndexedDB.apply(this, arguments);
}
function $d5c0bb0cb4aa3aa2$var$_writeHeartbeatsToIndexedDB() {
    $d5c0bb0cb4aa3aa2$var$_writeHeartbeatsToIndexedDB = (0, $9OZ9j._)(function(app, heartbeatObject) {
        var db, tx, objectStore, e, idbGetError;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $d5c0bb0cb4aa3aa2$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    tx = db.transaction($d5c0bb0cb4aa3aa2$var$STORE_NAME, "readwrite");
                    objectStore = tx.objectStore($d5c0bb0cb4aa3aa2$var$STORE_NAME);
                    return [
                        4,
                        objectStore.put(heartbeatObject, $d5c0bb0cb4aa3aa2$var$computeKey(app))
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        tx.done
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    if (e instanceof (0, $gQ5gw.FirebaseError)) $d5c0bb0cb4aa3aa2$var$logger.warn(e.message);
                    else {
                        idbGetError = $d5c0bb0cb4aa3aa2$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                            originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                        });
                        $d5c0bb0cb4aa3aa2$var$logger.warn(idbGetError.message);
                    }
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $d5c0bb0cb4aa3aa2$var$_writeHeartbeatsToIndexedDB.apply(this, arguments);
}
function $d5c0bb0cb4aa3aa2$var$computeKey(app) {
    return "".concat(app.name, "!").concat(app.options.appId);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d5c0bb0cb4aa3aa2$var$MAX_HEADER_BYTES = 1024;
// 30 days
var $d5c0bb0cb4aa3aa2$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
var $d5c0bb0cb4aa3aa2$var$HeartbeatServiceImpl = /*#__PURE__*/ function() {
    "use strict";
    function HeartbeatServiceImpl(container) {
        var _this = this;
        (0, $19mwo._)(this, HeartbeatServiceImpl);
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        var app = this.container.getProvider("app").getImmediate();
        this._storage = new $d5c0bb0cb4aa3aa2$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then(function(result) {
            _this._heartbeatsCache = result;
            return result;
        });
    }
    (0, $6rpfc._)(HeartbeatServiceImpl, [
        {
            key: "triggerHeartbeat",
            value: /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ function triggerHeartbeat() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _a, _b, platformLogger, agent, date;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                platformLogger = _this.container.getProvider("platform-logger").getImmediate();
                                // This is the "Firebase user agent" string from the platform logger
                                // service, not the browser user agent.
                                agent = platformLogger.getPlatformInfoString();
                                date = $d5c0bb0cb4aa3aa2$var$getUTCDateString();
                                if (!(((_a = _this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._heartbeatsCachePromise
                                ];
                            case 1:
                                _this._heartbeatsCache = _state.sent();
                                // If we failed to construct a heartbeats cache, then return immediately.
                                if (((_b = _this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return [
                                    2
                                ];
                                _state.label = 2;
                            case 2:
                                // Do not store a heartbeat if one is already stored for this day
                                // or if a header has already been sent today.
                                if (_this._heartbeatsCache.lastSentHeartbeatDate === date || _this._heartbeatsCache.heartbeats.some(function(singleDateHeartbeat) {
                                    return singleDateHeartbeat.date === date;
                                })) return [
                                    2
                                ];
                                else // There is no entry for this date. Create one.
                                _this._heartbeatsCache.heartbeats.push({
                                    date: date,
                                    agent: agent
                                });
                                // Remove entries older than 30 days.
                                _this._heartbeatsCache.heartbeats = _this._heartbeatsCache.heartbeats.filter(function(singleDateHeartbeat) {
                                    var hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                                    var now = Date.now();
                                    return now - hbTimestamp <= $d5c0bb0cb4aa3aa2$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
                                });
                                return [
                                    2,
                                    _this._storage.overwrite(_this._heartbeatsCache)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getHeartbeatsHeader",
            value: /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ function getHeartbeatsHeader() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _a, date, _extractHeartbeatsForHeader, heartbeatsToSend, unsentEntries, headerString;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this._heartbeatsCache === null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._heartbeatsCachePromise
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                // If it's still null or the array is empty, there is no data to send.
                                if (((_a = _this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || _this._heartbeatsCache.heartbeats.length === 0) return [
                                    2,
                                    ""
                                ];
                                date = $d5c0bb0cb4aa3aa2$var$getUTCDateString();
                                // Extract as many heartbeats from the cache as will fit under the size limit.
                                _extractHeartbeatsForHeader = $d5c0bb0cb4aa3aa2$var$extractHeartbeatsForHeader(_this._heartbeatsCache.heartbeats), heartbeatsToSend = _extractHeartbeatsForHeader.heartbeatsToSend, unsentEntries = _extractHeartbeatsForHeader.unsentEntries;
                                headerString = (0, $gQ5gw.base64urlEncodeWithoutPadding)(JSON.stringify({
                                    version: 2,
                                    heartbeats: heartbeatsToSend
                                }));
                                // Store last sent date to prevent another being logged/sent for the same day.
                                _this._heartbeatsCache.lastSentHeartbeatDate = date;
                                if (!(unsentEntries.length > 0)) return [
                                    3,
                                    4
                                ];
                                // Store any unsent entries if they exist.
                                _this._heartbeatsCache.heartbeats = unsentEntries;
                                // This seems more likely than emptying the array (below) to lead to some odd state
                                // since the cache isn't empty and this will be called again on the next request,
                                // and is probably safest if we await it.
                                return [
                                    4,
                                    _this._storage.overwrite(_this._heartbeatsCache)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _this._heartbeatsCache.heartbeats = [];
                                // Do not wait for this, to reduce latency.
                                _this._storage.overwrite(_this._heartbeatsCache);
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    headerString
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return HeartbeatServiceImpl;
}();
function $d5c0bb0cb4aa3aa2$var$getUTCDateString() {
    var today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $d5c0bb0cb4aa3aa2$var$extractHeartbeatsForHeader(heartbeatsCache) {
    var maxSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $d5c0bb0cb4aa3aa2$var$MAX_HEADER_BYTES;
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    var heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    var unsentEntries = heartbeatsCache.slice();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var singleDateHeartbeat = _step.value;
            // Look for an existing entry with the same user agent.
            var heartbeatEntry = heartbeatsToSend.find(function(hb) {
                return hb.agent === singleDateHeartbeat.agent;
            });
            if (!heartbeatEntry) {
                // If no entry for this user agent exists, create one.
                heartbeatsToSend.push({
                    agent: singleDateHeartbeat.agent,
                    dates: [
                        singleDateHeartbeat.date
                    ]
                });
                if ($d5c0bb0cb4aa3aa2$var$countBytes(heartbeatsToSend) > maxSize) {
                    // If the header would exceed max size, remove the added heartbeat
                    // entry and stop adding to the header.
                    heartbeatsToSend.pop();
                    return "break";
                }
            } else {
                heartbeatEntry.dates.push(singleDateHeartbeat.date);
                // If the header would exceed max size, remove the added date
                // and stop adding to the header.
                if ($d5c0bb0cb4aa3aa2$var$countBytes(heartbeatsToSend) > maxSize) {
                    heartbeatEntry.dates.pop();
                    return "break";
                }
            }
            // Pop unsent entry from queue. (Skipped if adding the entry exceeded
            // quota and the loop breaks early.)
            unsentEntries = unsentEntries.slice(1);
        };
        for(var _iterator = heartbeatsCache[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if (_ret === "break") break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
var $d5c0bb0cb4aa3aa2$var$HeartbeatStorageImpl = /*#__PURE__*/ function() {
    "use strict";
    function HeartbeatStorageImpl(app) {
        (0, $19mwo._)(this, HeartbeatStorageImpl);
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    (0, $6rpfc._)(HeartbeatStorageImpl, [
        {
            key: "runIndexedDBEnvironmentCheck",
            value: function runIndexedDBEnvironmentCheck() {
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        if (!(0, $gQ5gw.isIndexedDBAvailable)()) return [
                            2,
                            false
                        ];
                        else return [
                            2,
                            (0, $gQ5gw.validateIndexedDBOpenable)().then(function() {
                                return true;
                            }).catch(function() {
                                return false;
                            })
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "read",
            value: /**
     * Read all heartbeats.
     */ function read() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var canUseIndexedDB, idbHeartbeatObject;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._canUseIndexedDBPromise
                                ];
                            case 1:
                                canUseIndexedDB = _state.sent();
                                if (!!canUseIndexedDB) return [
                                    3,
                                    2
                                ];
                                return [
                                    2,
                                    {
                                        heartbeats: []
                                    }
                                ];
                            case 2:
                                return [
                                    4,
                                    $d5c0bb0cb4aa3aa2$var$readHeartbeatsFromIndexedDB(_this.app)
                                ];
                            case 3:
                                idbHeartbeatObject = _state.sent();
                                if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return [
                                    2,
                                    idbHeartbeatObject
                                ];
                                else return [
                                    2,
                                    {
                                        heartbeats: []
                                    }
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "overwrite",
            value: // overwrite the storage with the provided heartbeats
            function overwrite(heartbeatsObject) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _a, canUseIndexedDB, existingHeartbeatsObject;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._canUseIndexedDBPromise
                                ];
                            case 1:
                                canUseIndexedDB = _state.sent();
                                if (!!canUseIndexedDB) return [
                                    3,
                                    2
                                ];
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.read()
                                ];
                            case 3:
                                existingHeartbeatsObject = _state.sent();
                                return [
                                    2,
                                    $d5c0bb0cb4aa3aa2$var$writeHeartbeatsToIndexedDB(_this.app, {
                                        lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                                        heartbeats: heartbeatsObject.heartbeats
                                    })
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "add",
            value: // add heartbeats
            function add(heartbeatsObject) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _a, canUseIndexedDB, existingHeartbeatsObject;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._canUseIndexedDBPromise
                                ];
                            case 1:
                                canUseIndexedDB = _state.sent();
                                if (!!canUseIndexedDB) return [
                                    3,
                                    2
                                ];
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.read()
                                ];
                            case 3:
                                existingHeartbeatsObject = _state.sent();
                                return [
                                    2,
                                    $d5c0bb0cb4aa3aa2$var$writeHeartbeatsToIndexedDB(_this.app, {
                                        lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                                        heartbeats: (0, $3jzhD._)(existingHeartbeatsObject.heartbeats).concat((0, $3jzhD._)(heartbeatsObject.heartbeats))
                                    })
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return HeartbeatStorageImpl;
}();
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $d5c0bb0cb4aa3aa2$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $gQ5gw.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $d5c0bb0cb4aa3aa2$var$registerCoreComponents(variant) {
    $d5c0bb0cb4aa3aa2$export$c930050e7bb63965(new (0, $e5K63.Component)("platform-logger", function(container) {
        return new $d5c0bb0cb4aa3aa2$var$PlatformLoggerServiceImpl(container);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ));
    $d5c0bb0cb4aa3aa2$export$c930050e7bb63965(new (0, $e5K63.Component)("heartbeat", function(container) {
        return new $d5c0bb0cb4aa3aa2$var$HeartbeatServiceImpl(container);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $d5c0bb0cb4aa3aa2$export$d29d5299a7137abc($d5c0bb0cb4aa3aa2$var$name$p, $d5c0bb0cb4aa3aa2$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $d5c0bb0cb4aa3aa2$export$d29d5299a7137abc($d5c0bb0cb4aa3aa2$var$name$p, $d5c0bb0cb4aa3aa2$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $d5c0bb0cb4aa3aa2$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $d5c0bb0cb4aa3aa2$var$registerCoreComponents("");

});
parcelRegister("c5rwh", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $8ccb4c841f980228$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $8ccb4c841f980228$export$1e71eb4bef00f6b0; });
function $8ccb4c841f980228$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("e5K63", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $a4254a2776caa895$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "ComponentContainer", function () { return $a4254a2776caa895$export$436a80eea5d5c0c5; });

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $lF1I7 = parcelRequire("lF1I7");

var $gQ5gw = parcelRequire("gQ5gw");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ var $a4254a2776caa895$export$16fa2f45be04daa8 = /*#__PURE__*/ function() {
    "use strict";
    function Component(name, instanceFactory, type) {
        (0, $19mwo._)(this, Component);
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    (0, $6rpfc._)(Component, [
        {
            key: "setInstantiationMode",
            value: function setInstantiationMode(mode) {
                this.instantiationMode = mode;
                return this;
            }
        },
        {
            key: "setMultipleInstances",
            value: function setMultipleInstances(multipleInstances) {
                this.multipleInstances = multipleInstances;
                return this;
            }
        },
        {
            key: "setServiceProps",
            value: function setServiceProps(props) {
                this.serviceProps = props;
                return this;
            }
        },
        {
            key: "setInstanceCreatedCallback",
            value: function setInstanceCreatedCallback(callback) {
                this.onInstanceCreated = callback;
                return this;
            }
        }
    ]);
    return Component;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $a4254a2776caa895$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ var $a4254a2776caa895$export$2881499e37b75b9a = /*#__PURE__*/ function() {
    "use strict";
    function Provider(name, container) {
        (0, $19mwo._)(this, Provider);
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    (0, $6rpfc._)(Provider, [
        {
            /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ key: "get",
            value: function get(identifier) {
                // if multipleInstances is not supported, use the default name
                var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
                if (!this.instancesDeferred.has(normalizedIdentifier)) {
                    var deferred = new (0, $gQ5gw.Deferred)();
                    this.instancesDeferred.set(normalizedIdentifier, deferred);
                    if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
                    try {
                        var instance = this.getOrInitializeService({
                            instanceIdentifier: normalizedIdentifier
                        });
                        if (instance) deferred.resolve(instance);
                    } catch (e) {
                    // when the instance factory throws an exception during get(), it should not cause
                    // a fatal error. We just return the unresolved promise in this case.
                    }
                }
                return this.instancesDeferred.get(normalizedIdentifier).promise;
            }
        },
        {
            key: "getImmediate",
            value: function getImmediate(options) {
                var _a;
                // if multipleInstances is not supported, use the default name
                var normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
                var optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
                if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
                    return this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                } catch (e) {
                    if (optional) return null;
                    else throw e;
                }
                else {
                    // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
                    if (optional) return null;
                    else throw Error("Service ".concat(this.name, " is not available"));
                }
            }
        },
        {
            key: "getComponent",
            value: function getComponent() {
                return this.component;
            }
        },
        {
            key: "setComponent",
            value: function setComponent(component) {
                if (component.name !== this.name) throw Error("Mismatching Component ".concat(component.name, " for Provider ").concat(this.name, "."));
                if (this.component) throw Error("Component for ".concat(this.name, " has already been provided"));
                this.component = component;
                // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
                if (!this.shouldAutoInitialize()) return;
                // if the service is eager, initialize the default instance
                if ($a4254a2776caa895$var$isComponentEager(component)) try {
                    this.getOrInitializeService({
                        instanceIdentifier: $a4254a2776caa895$var$DEFAULT_ENTRY_NAME
                    });
                } catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Create service instances for the pending promises and resolve them
                    // NOTE: if this.multipleInstances is false, only the default instance will be created
                    // and all promises with resolve with it regardless of the identifier.
                    for(var _iterator = this.instancesDeferred.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $2MTYX._)(_step.value, 2), instanceIdentifier = _step_value[0], instanceDeferred = _step_value[1];
                        var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                        try {
                            // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                            var instance = this.getOrInitializeService({
                                instanceIdentifier: normalizedIdentifier
                            });
                            instanceDeferred.resolve(instance);
                        } catch (e) {
                        // when the instance factory throws an exception, it should not cause
                        // a fatal error. We just leave the promise unresolved.
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "clearInstance",
            value: function clearInstance() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $a4254a2776caa895$var$DEFAULT_ENTRY_NAME;
                this.instancesDeferred.delete(identifier);
                this.instancesOptions.delete(identifier);
                this.instances.delete(identifier);
            }
        },
        {
            key: "delete",
            value: // app.delete() will call this method on every provider to delete the services
            // TODO: should we mark the provider as deleted?
            function _delete() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var services;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                services = Array.from(_this.instances.values());
                                return [
                                    4,
                                    Promise.all((0, $3jzhD._)(services.filter(function(service) {
                                        return "INTERNAL" in service;
                                    }) // legacy services
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    .map(function(service) {
                                        return service.INTERNAL.delete();
                                    })).concat((0, $3jzhD._)(services.filter(function(service) {
                                        return "_delete" in service;
                                    }) // modularized services
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    .map(function(service) {
                                        return service._delete();
                                    }))))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isComponentSet",
            value: function isComponentSet() {
                return this.component != null;
            }
        },
        {
            key: "isInitialized",
            value: function isInitialized() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $a4254a2776caa895$var$DEFAULT_ENTRY_NAME;
                return this.instances.has(identifier);
            }
        },
        {
            key: "getOptions",
            value: function getOptions() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $a4254a2776caa895$var$DEFAULT_ENTRY_NAME;
                return this.instancesOptions.get(identifier) || {};
            }
        },
        {
            key: "initialize",
            value: function initialize() {
                var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _opts_options = opts.options, options = _opts_options === void 0 ? {} : _opts_options;
                var normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
                if (this.isInitialized(normalizedIdentifier)) throw Error("".concat(this.name, "(").concat(normalizedIdentifier, ") has already been initialized"));
                if (!this.isComponentSet()) throw Error("Component ".concat(this.name, " has not been registered yet"));
                var instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier,
                    options: options
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // resolve any pending promise waiting for the service instance
                    for(var _iterator = this.instancesDeferred.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $2MTYX._)(_step.value, 2), instanceIdentifier = _step_value[0], instanceDeferred = _step_value[1];
                        var normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                        if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return instance;
            }
        },
        {
            /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ key: "onInit",
            value: function onInit(callback, identifier) {
                var _a;
                var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
                var existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
                existingCallbacks.add(callback);
                this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
                var existingInstance = this.instances.get(normalizedIdentifier);
                if (existingInstance) callback(existingInstance, normalizedIdentifier);
                return function() {
                    existingCallbacks.delete(callback);
                };
            }
        },
        {
            /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ key: "invokeOnInitCallbacks",
            value: function invokeOnInitCallbacks(instance, identifier) {
                var callbacks = this.onInitCallbacks.get(identifier);
                if (!callbacks) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var callback = _step.value;
                        try {
                            callback(instance, identifier);
                        } catch (_a) {
                        // ignore errors in the onInit callback
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "getOrInitializeService",
            value: function getOrInitializeService(param) {
                var instanceIdentifier = param.instanceIdentifier, _param_options = param.options, options = _param_options === void 0 ? {} : _param_options;
                var instance = this.instances.get(instanceIdentifier);
                if (!instance && this.component) {
                    instance = this.component.instanceFactory(this.container, {
                        instanceIdentifier: $a4254a2776caa895$var$normalizeIdentifierForFactory(instanceIdentifier),
                        options: options
                    });
                    this.instances.set(instanceIdentifier, instance);
                    this.instancesOptions.set(instanceIdentifier, options);
                    /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
                    /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                        this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
                    } catch (_a) {
                    // ignore errors in the onInstanceCreatedCallback
                    }
                }
                return instance || null;
            }
        },
        {
            key: "normalizeInstanceIdentifier",
            value: function normalizeInstanceIdentifier() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $a4254a2776caa895$var$DEFAULT_ENTRY_NAME;
                if (this.component) return this.component.multipleInstances ? identifier : $a4254a2776caa895$var$DEFAULT_ENTRY_NAME;
                else return identifier; // assume multiple instances are supported before the component is provided.
            }
        },
        {
            key: "shouldAutoInitialize",
            value: function shouldAutoInitialize() {
                return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
            }
        }
    ]);
    return Provider;
}();
// undefined should be passed to the service factory for the default instance
function $a4254a2776caa895$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $a4254a2776caa895$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $a4254a2776caa895$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ var $a4254a2776caa895$export$436a80eea5d5c0c5 = /*#__PURE__*/ function() {
    "use strict";
    function ComponentContainer(name) {
        (0, $19mwo._)(this, ComponentContainer);
        this.name = name;
        this.providers = new Map();
    }
    (0, $6rpfc._)(ComponentContainer, [
        {
            /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ key: "addComponent",
            value: function addComponent(component) {
                var provider = this.getProvider(component.name);
                if (provider.isComponentSet()) throw new Error("Component ".concat(component.name, " has already been registered with ").concat(this.name));
                provider.setComponent(component);
            }
        },
        {
            key: "addOrOverwriteComponent",
            value: function addOrOverwriteComponent(component) {
                var provider = this.getProvider(component.name);
                if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
                this.providers.delete(component.name);
                this.addComponent(component);
            }
        },
        {
            /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ key: "getProvider",
            value: function getProvider(name) {
                if (this.providers.has(name)) return this.providers.get(name);
                // create a Provider for a service that hasn't registered with Firebase
                var provider = new $a4254a2776caa895$export$2881499e37b75b9a(name, this);
                this.providers.set(name, provider);
                return provider;
            }
        },
        {
            key: "getProviders",
            value: function getProviders() {
                return Array.from(this.providers.values());
            }
        }
    ]);
    return ComponentContainer;
}();

});
parcelRegister("gQ5gw", function(module, exports) {

$parcel$export(module.exports, "base64urlEncodeWithoutPadding", function () { return $c425964833c2e1d2$export$4b5284a3025a455; });
$parcel$export(module.exports, "base64Decode", function () { return $c425964833c2e1d2$export$c62426fdd000a97e; });
$parcel$export(module.exports, "getDefaultEmulatorHost", function () { return $c425964833c2e1d2$export$9c11895284c8adad; });
$parcel$export(module.exports, "getDefaultEmulatorHostnameAndPort", function () { return $c425964833c2e1d2$export$a3febcf1f14a3a0c; });
$parcel$export(module.exports, "getDefaultAppConfig", function () { return $c425964833c2e1d2$export$3dfb6827a9f89756; });
$parcel$export(module.exports, "getExperimentalSetting", function () { return $c425964833c2e1d2$export$5539a1a3afe87d6; });
$parcel$export(module.exports, "Deferred", function () { return $c425964833c2e1d2$export$85f6557964517f1a; });
$parcel$export(module.exports, "createMockUserToken", function () { return $c425964833c2e1d2$export$367bf224123348f1; });
$parcel$export(module.exports, "getUA", function () { return $c425964833c2e1d2$export$c36915b22ce77c19; });
$parcel$export(module.exports, "isMobileCordova", function () { return $c425964833c2e1d2$export$872f8323f01d7ae0; });
$parcel$export(module.exports, "isBrowser", function () { return $c425964833c2e1d2$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "isWebWorker", function () { return $c425964833c2e1d2$export$97b87b8868ff7a3c; });
$parcel$export(module.exports, "isBrowserExtension", function () { return $c425964833c2e1d2$export$caa8774a9107a58e; });
$parcel$export(module.exports, "isReactNative", function () { return $c425964833c2e1d2$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isIE", function () { return $c425964833c2e1d2$export$7e7b1a9668aaed8; });
$parcel$export(module.exports, "isSafari", function () { return $c425964833c2e1d2$export$95df08bae54cb4df; });
$parcel$export(module.exports, "isIndexedDBAvailable", function () { return $c425964833c2e1d2$export$3865db50535c2055; });
$parcel$export(module.exports, "validateIndexedDBOpenable", function () { return $c425964833c2e1d2$export$a8a3018f3d187a4d; });
$parcel$export(module.exports, "FirebaseError", function () { return $c425964833c2e1d2$export$dd24e9cd51226c56; });
$parcel$export(module.exports, "ErrorFactory", function () { return $c425964833c2e1d2$export$3fa6e1b18a3b2d40; });
$parcel$export(module.exports, "isEmpty", function () { return $c425964833c2e1d2$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "deepEqual", function () { return $c425964833c2e1d2$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "querystring", function () { return $c425964833c2e1d2$export$ac4103b836844853; });
$parcel$export(module.exports, "querystringDecode", function () { return $c425964833c2e1d2$export$c1271ca4c8a70741; });
$parcel$export(module.exports, "extractQuerystring", function () { return $c425964833c2e1d2$export$1a8408415472d8ed; });
$parcel$export(module.exports, "createSubscribe", function () { return $c425964833c2e1d2$export$364097d812234b3f; });
$parcel$export(module.exports, "getModularInstance", function () { return $c425964833c2e1d2$export$4befe9b5fa509a1b; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $15Pju = parcelRequire("15Pju");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $etlBe = parcelRequire("etlBe");

var $k1NN5 = parcelRequire("k1NN5");

var $hZFWO = parcelRequire("hZFWO");
var $c425964833c2e1d2$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ var $c425964833c2e1d2$export$a7a9523472993e97 = function assert(assertion, message) {
    if (!assertion) throw $c425964833c2e1d2$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ var $c425964833c2e1d2$export$a39cad550e7ab28a = function assertionError(message) {
    return new Error("Firebase Database (" + $c425964833c2e1d2$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $c425964833c2e1d2$var$stringToByteArray$1 = function stringToByteArray$1(str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ var $c425964833c2e1d2$var$byteArrayToString = function byteArrayToString(bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while(pos < bytes.length){
        var c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c21 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = ((c1 & 7) << 18 | (c21 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            var c22 = bytes[pos++];
            var c31 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c22 & 63) << 6 | c31 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
var $c425964833c2e1d2$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray: function(input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        var byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        var output = [];
        for(var i = 0; i < input.length; i += 3){
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            var outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($c425964833c2e1d2$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $c425964833c2e1d2$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray: function(input, webSafe) {
        this.init_();
        var charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        var output = [];
        for(var i = 0; i < input.length;){
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $c425964833c2e1d2$export$55ca9d4bee46aeb3();
            var outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_: function() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(var i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ var $c425964833c2e1d2$export$55ca9d4bee46aeb3 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $iNfU4._)(DecodeBase64StringError, Error1);
    var _super = (0, $k1NN5._)(DecodeBase64StringError);
    function DecodeBase64StringError() {
        (0, $19mwo._)(this, DecodeBase64StringError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "DecodeBase64StringError";
        return _this;
    }
    return DecodeBase64StringError;
}((0, $etlBe._)(Error));
/**
 * URL-safe base64 encoding
 */ var $c425964833c2e1d2$export$e510a73ee562749 = function base64Encode(str) {
    var utf8Bytes = $c425964833c2e1d2$var$stringToByteArray$1(str);
    return $c425964833c2e1d2$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ var $c425964833c2e1d2$export$4b5284a3025a455 = function base64urlEncodeWithoutPadding(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $c425964833c2e1d2$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ var $c425964833c2e1d2$export$c62426fdd000a97e = function base64Decode(str) {
    try {
        return $c425964833c2e1d2$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $c425964833c2e1d2$export$6c40052bed430212(value) {
    return $c425964833c2e1d2$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $c425964833c2e1d2$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(var prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$c425964833c2e1d2$var$isValidKey(prop)) continue;
        target[prop] = $c425964833c2e1d2$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $c425964833c2e1d2$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $c425964833c2e1d2$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $c425964833c2e1d2$var$getDefaultsFromGlobal = function() {
    return $c425964833c2e1d2$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
};
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ var $c425964833c2e1d2$var$getDefaultsFromEnvVariable = function() {
    if (typeof $hZFWO === "undefined" || typeof $hZFWO.env === "undefined") return;
    var defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
var $c425964833c2e1d2$var$getDefaultsFromCookie = function() {
    if (typeof document === "undefined") return;
    var match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    var decoded = match && $c425964833c2e1d2$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ var $c425964833c2e1d2$export$212bb2fc580a90a8 = function() {
    try {
        return $c425964833c2e1d2$var$getDefaultsFromGlobal() || $c425964833c2e1d2$var$getDefaultsFromEnvVariable() || $c425964833c2e1d2$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info("Unable to get __FIREBASE_DEFAULTS__ due to: ".concat(e));
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ var $c425964833c2e1d2$export$9c11895284c8adad = function(productName) {
    var _a, _b;
    return (_b = (_a = $c425964833c2e1d2$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ var $c425964833c2e1d2$export$a3febcf1f14a3a0c = function(productName) {
    var host = $c425964833c2e1d2$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    var separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error("Invalid host ".concat(host, " with no separate hostname and port!"));
    // eslint-disable-next-line no-restricted-globals
    var port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ var $c425964833c2e1d2$export$3dfb6827a9f89756 = function() {
    var _a;
    return (_a = $c425964833c2e1d2$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ var $c425964833c2e1d2$export$5539a1a3afe87d6 = function(name) {
    var _a;
    return (_a = $c425964833c2e1d2$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a["_".concat(name)];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $c425964833c2e1d2$export$85f6557964517f1a = /*#__PURE__*/ function() {
    "use strict";
    function Deferred() {
        var _this = this;
        (0, $19mwo._)(this, Deferred);
        this.reject = function() {};
        this.resolve = function() {};
        this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    (0, $6rpfc._)(Deferred, [
        {
            /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ key: "wrapCallback",
            value: function wrapCallback(callback) {
                var _this = this;
                return function(error, value) {
                    if (error) _this.reject(error);
                    else _this.resolve(value);
                    if (typeof callback === "function") {
                        // Attaching noop handler just in case developer wasn't expecting
                        // promises
                        _this.promise.catch(function() {});
                        // Some of our callbacks don't expect a value and our own tests
                        // assert that the parameter length is 1
                        if (callback.length === 1) callback(error);
                        else callback(error, value);
                    }
                };
            }
        }
    ]);
    return Deferred;
}();
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c425964833c2e1d2$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    var header = {
        alg: "none",
        type: "JWT"
    };
    var project = projectId || "demo-project";
    var iat = token.iat || 0;
    var sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    var payload = Object.assign({
        // Set all required fields to decent defaults
        iss: "https://securetoken.google.com/".concat(project),
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    var signature = "";
    return [
        $c425964833c2e1d2$export$4b5284a3025a455(JSON.stringify(header)),
        $c425964833c2e1d2$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $c425964833c2e1d2$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $c425964833c2e1d2$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($c425964833c2e1d2$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $c425964833c2e1d2$export$8ee0fc9ee280b4ee() {
    var _a;
    var forceEnvironment = (_a = $c425964833c2e1d2$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $c425964833c2e1d2$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" || $c425964833c2e1d2$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context
 */ function $c425964833c2e1d2$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== "undefined" && typeof self !== "undefined" && self instanceof WorkerGlobalScope;
}
function $c425964833c2e1d2$export$caa8774a9107a58e() {
    var runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $c425964833c2e1d2$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $c425964833c2e1d2$export$f2f6a8999f8ebd30() {
    return $c425964833c2e1d2$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $c425964833c2e1d2$export$7e7b1a9668aaed8() {
    var ua = $c425964833c2e1d2$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $c425964833c2e1d2$export$202944b2d2824246() {
    return $c425964833c2e1d2$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $c425964833c2e1d2$export$5d1d834fbbf8bab7() {
    return $c425964833c2e1d2$export$588c7fdda06fbb0a.NODE_CLIENT === true || $c425964833c2e1d2$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $c425964833c2e1d2$export$95df08bae54cb4df() {
    return !$c425964833c2e1d2$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $c425964833c2e1d2$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $c425964833c2e1d2$export$a8a3018f3d187a4d() {
    return new Promise(function(resolve, reject) {
        try {
            var preExist = true;
            var DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            var request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = function() {
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = function() {
                preExist = false;
            };
            request.onerror = function() {
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $c425964833c2e1d2$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ var $c425964833c2e1d2$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var $c425964833c2e1d2$export$dd24e9cd51226c56 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $iNfU4._)(FirebaseError, Error1);
    var _super = (0, $k1NN5._)(FirebaseError);
    function FirebaseError(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData) {
        (0, $19mwo._)(this, FirebaseError);
        var _this;
        _this = _super.call(this, message);
        _this.code = code;
        _this.customData = customData;
        /** The custom name for all FirebaseErrors. */ _this.name = $c425964833c2e1d2$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf((0, $15Pju._)(_this), FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace((0, $15Pju._)(_this), $c425964833c2e1d2$export$3fa6e1b18a3b2d40.prototype.create);
        return _this;
    }
    return FirebaseError;
}((0, $etlBe._)(Error));
var $c425964833c2e1d2$export$3fa6e1b18a3b2d40 = /*#__PURE__*/ function() {
    "use strict";
    function ErrorFactory(service, serviceName, errors) {
        (0, $19mwo._)(this, ErrorFactory);
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    (0, $6rpfc._)(ErrorFactory, [
        {
            key: "create",
            value: function create(code) {
                for(var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    data[_key - 1] = arguments[_key];
                }
                var customData = data[0] || {};
                var fullCode = "".concat(this.service, "/").concat(code);
                var template = this.errors[code];
                var message = template ? $c425964833c2e1d2$var$replaceTemplate(template, customData) : "Error";
                // Service Name: Error message (service/code).
                var fullMessage = "".concat(this.serviceName, ": ").concat(message, " (").concat(fullCode, ").");
                var error = new $c425964833c2e1d2$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
                return error;
            }
        }
    ]);
    return ErrorFactory;
}();
function $c425964833c2e1d2$var$replaceTemplate(template, data) {
    return template.replace($c425964833c2e1d2$var$PATTERN, function(_, key) {
        var value = data[key];
        return value != null ? String(value) : "<".concat(key, "?>");
    });
}
var $c425964833c2e1d2$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $c425964833c2e1d2$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $c425964833c2e1d2$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $c425964833c2e1d2$export$2f872c0f2117be69 = function decode(token) {
    var header = {}, claims = {}, data = {}, signature = "";
    try {
        var parts = token.split(".");
        header = $c425964833c2e1d2$export$c5a53ce6a17cf18d($c425964833c2e1d2$export$c62426fdd000a97e(parts[0]) || "");
        claims = $c425964833c2e1d2$export$c5a53ce6a17cf18d($c425964833c2e1d2$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $c425964833c2e1d2$export$5f870fcca7ae6a88 = function isValidTimestamp(token) {
    var claims = $c425964833c2e1d2$export$2f872c0f2117be69(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $c425964833c2e1d2$export$701c661ec91095f2 = function issuedAtTime(token) {
    var claims = $c425964833c2e1d2$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $c425964833c2e1d2$export$9565ca3d387f8aa0 = function isValidFormat(token) {
    var decoded = $c425964833c2e1d2$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $c425964833c2e1d2$export$fc970ed23da99565 = function isAdmin(token) {
    var claims = $c425964833c2e1d2$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c425964833c2e1d2$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $c425964833c2e1d2$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $c425964833c2e1d2$export$dd1bc94b04021eeb(obj) {
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $c425964833c2e1d2$export$871de8747c9eaa88(obj, fn, contextObj) {
    var res = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $c425964833c2e1d2$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = aKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var k = _step.value;
            if (!bKeys.includes(k)) return false;
            var aProp = a[k];
            var bProp = b[k];
            if ($c425964833c2e1d2$var$isObject(aProp) && $c425964833c2e1d2$var$isObject(bProp)) {
                if (!$c425964833c2e1d2$export$9cb4719e2e525b7a(aProp, bProp)) return false;
            } else if (aProp !== bProp) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = bKeys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var k1 = _step1.value;
            if (!aKeys.includes(k1)) return false;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return true;
}
function $c425964833c2e1d2$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $c425964833c2e1d2$export$a9cd205a244d9f54(promise) {
    var timeInMS = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2000;
    var deferredPromise = new $c425964833c2e1d2$export$85f6557964517f1a();
    setTimeout(function() {
        return deferredPromise.reject("timeout!");
    }, timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $c425964833c2e1d2$export$ac4103b836844853(querystringParams) {
    var params = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $2MTYX._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (Array.isArray(value)) value.forEach(function(arrayVal) {
                params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
            });
            else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
        };
        for(var _iterator = Object.entries(querystringParams)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $c425964833c2e1d2$export$c1271ca4c8a70741(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach(function(token) {
        if (token) {
            var _token_split = (0, $2MTYX._)(token.split("="), 2), key = _token_split[0], value = _token_split[1];
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $c425964833c2e1d2$export$1a8408415472d8ed(url) {
    var queryStart = url.indexOf("?");
    if (!queryStart) return "";
    var fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ var $c425964833c2e1d2$export$c85d589bf4e25fef = /*#__PURE__*/ function() {
    "use strict";
    function Sha1() {
        (0, $19mwo._)(this, Sha1);
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(var i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    (0, $6rpfc._)(Sha1, [
        {
            key: "reset",
            value: function reset() {
                this.chain_[0] = 0x67452301;
                this.chain_[1] = 0xefcdab89;
                this.chain_[2] = 0x98badcfe;
                this.chain_[3] = 0x10325476;
                this.chain_[4] = 0xc3d2e1f0;
                this.inbuf_ = 0;
                this.total_ = 0;
            }
        },
        {
            /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ key: "compress_",
            value: function compress_(buf, offset) {
                if (!offset) offset = 0;
                var W = this.W_;
                // get 16 big endian words
                if (typeof buf === "string") for(var i = 0; i < 16; i++){
                    // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                    // have a bug that turns the post-increment ++ operator into pre-increment
                    // during JIT compilation.  We have code that depends heavily on SHA-1 for
                    // correctness and which is affected by this bug, so I've removed all uses
                    // of post-increment ++ in which the result value is used.  We can revert
                    // this change once the Safari bug
                    // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                    // most clients have been updated.
                    W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
                    offset += 4;
                }
                else for(var i1 = 0; i1 < 16; i1++){
                    W[i1] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
                    offset += 4;
                }
                // expand to 80 words
                for(var i2 = 16; i2 < 80; i2++){
                    var t = W[i2 - 3] ^ W[i2 - 8] ^ W[i2 - 14] ^ W[i2 - 16];
                    W[i2] = (t << 1 | t >>> 31) & 0xffffffff;
                }
                var a = this.chain_[0];
                var b = this.chain_[1];
                var c = this.chain_[2];
                var d = this.chain_[3];
                var e = this.chain_[4];
                var f, k;
                // TODO(user): Try to unroll this loop to speed up the computation.
                for(var i3 = 0; i3 < 80; i3++){
                    if (i3 < 40) {
                        if (i3 < 20) {
                            f = d ^ b & (c ^ d);
                            k = 0x5a827999;
                        } else {
                            f = b ^ c ^ d;
                            k = 0x6ed9eba1;
                        }
                    } else if (i3 < 60) {
                        f = b & c | d & (b | c);
                        k = 0x8f1bbcdc;
                    } else {
                        f = b ^ c ^ d;
                        k = 0xca62c1d6;
                    }
                    var t1 = (a << 5 | a >>> 27) + f + e + k + W[i3] & 0xffffffff;
                    e = d;
                    d = c;
                    c = (b << 30 | b >>> 2) & 0xffffffff;
                    b = a;
                    a = t1;
                }
                this.chain_[0] = this.chain_[0] + a & 0xffffffff;
                this.chain_[1] = this.chain_[1] + b & 0xffffffff;
                this.chain_[2] = this.chain_[2] + c & 0xffffffff;
                this.chain_[3] = this.chain_[3] + d & 0xffffffff;
                this.chain_[4] = this.chain_[4] + e & 0xffffffff;
            }
        },
        {
            key: "update",
            value: function update(bytes, length) {
                // TODO(johnlenz): tighten the function signature and remove this check
                if (bytes == null) return;
                if (length === undefined) length = bytes.length;
                var lengthMinusBlock = length - this.blockSize;
                var n = 0;
                // Using local instead of member variables gives ~5% speedup on Firefox 16.
                var buf = this.buf_;
                var inbuf = this.inbuf_;
                // The outer while loop should execute at most twice.
                while(n < length){
                    // When we have no data in the block to top up, we can directly process the
                    // input buffer (assuming it contains sufficient data). This gives ~25%
                    // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
                    // the data is provided in large chunks (or in multiples of 64 bytes).
                    if (inbuf === 0) while(n <= lengthMinusBlock){
                        this.compress_(bytes, n);
                        n += this.blockSize;
                    }
                    if (typeof bytes === "string") while(n < length){
                        buf[inbuf] = bytes.charCodeAt(n);
                        ++inbuf;
                        ++n;
                        if (inbuf === this.blockSize) {
                            this.compress_(buf);
                            inbuf = 0;
                            break;
                        }
                    }
                    else while(n < length){
                        buf[inbuf] = bytes[n];
                        ++inbuf;
                        ++n;
                        if (inbuf === this.blockSize) {
                            this.compress_(buf);
                            inbuf = 0;
                            break;
                        }
                    }
                }
                this.inbuf_ = inbuf;
                this.total_ += length;
            }
        },
        {
            /** @override */ key: "digest",
            value: function digest() {
                var digest = [];
                var totalBits = this.total_ * 8;
                // Add pad 0x80 0x00*.
                if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
                else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
                // Add # bits.
                for(var i = this.blockSize - 1; i >= 56; i--){
                    this.buf_[i] = totalBits & 255;
                    totalBits /= 256; // Don't use bit-shifting here!
                }
                this.compress_(this.buf_);
                var n = 0;
                for(var i1 = 0; i1 < 5; i1++)for(var j = 24; j >= 0; j -= 8){
                    digest[n] = this.chain_[i1] >> j & 255;
                    ++n;
                }
                return digest;
            }
        }
    ]);
    return Sha1;
}();
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $c425964833c2e1d2$export$364097d812234b3f(executor, onNoObservers) {
    var proxy = new $c425964833c2e1d2$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ var $c425964833c2e1d2$var$ObserverProxy = /*#__PURE__*/ function() {
    "use strict";
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        (0, $19mwo._)(this, ObserverProxy);
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(function() {
            executor(_this);
        }).catch(function(e) {
            _this.error(e);
        });
    }
    (0, $6rpfc._)(ObserverProxy, [
        {
            key: "next",
            value: function next(value) {
                this.forEachObserver(function(observer) {
                    observer.next(value);
                });
            }
        },
        {
            key: "error",
            value: function error(error) {
                this.forEachObserver(function(observer) {
                    observer.error(error);
                });
                this.close(error);
            }
        },
        {
            key: "complete",
            value: function complete() {
                this.forEachObserver(function(observer) {
                    observer.complete();
                });
                this.close();
            }
        },
        {
            /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ key: "subscribe",
            value: function subscribe(nextOrObserver, error, complete) {
                var _this = this;
                var observer;
                if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
                // Assemble an Observer object when passed as callback functions.
                if ($c425964833c2e1d2$var$implementsAnyMethods(nextOrObserver, [
                    "next",
                    "error",
                    "complete"
                ])) observer = nextOrObserver;
                else observer = {
                    next: nextOrObserver,
                    error: error,
                    complete: complete
                };
                if (observer.next === undefined) observer.next = $c425964833c2e1d2$var$noop;
                if (observer.error === undefined) observer.error = $c425964833c2e1d2$var$noop;
                if (observer.complete === undefined) observer.complete = $c425964833c2e1d2$var$noop;
                var unsub = this.unsubscribeOne.bind(this, this.observers.length);
                // Attempt to subscribe to a terminated Observable - we
                // just respond to the Observer with the final error or complete
                // event.
                if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function() {
                    try {
                        if (_this.finalError) observer.error(_this.finalError);
                        else observer.complete();
                    } catch (e) {
                    // nothing
                    }
                    return;
                });
                this.observers.push(observer);
                return unsub;
            }
        },
        {
            // Unsubscribe is synchronous - we guarantee that no events are sent to
            // any unsubscribed Observer.
            key: "unsubscribeOne",
            value: function unsubscribeOne(i) {
                if (this.observers === undefined || this.observers[i] === undefined) return;
                delete this.observers[i];
                this.observerCount -= 1;
                if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
            }
        },
        {
            key: "forEachObserver",
            value: function forEachObserver(fn) {
                if (this.finalized) // Already closed by previous event....just eat the additional values.
                return;
                // Since sendOne calls asynchronously - there is no chance that
                // this.observers will become undefined.
                for(var i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
            }
        },
        {
            // Call the Observer via one of it's callback function. We are careful to
            // confirm that the observe has not been unsubscribed since this asynchronous
            // function had been queued.
            key: "sendOne",
            value: function sendOne(i, fn) {
                var _this = this;
                // Execute the callback asynchronously
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function() {
                    if (_this.observers !== undefined && _this.observers[i] !== undefined) try {
                        fn(_this.observers[i]);
                    } catch (e) {
                        // Ignore exceptions raised in Observers or missing methods of an
                        // Observer.
                        // Log error to console. b/31404806
                        if (typeof console !== "undefined" && console.error) console.error(e);
                    }
                });
            }
        },
        {
            key: "close",
            value: function close(err) {
                var _this = this;
                if (this.finalized) return;
                this.finalized = true;
                if (err !== undefined) this.finalError = err;
                // Proxy is no longer needed - garbage collect references
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function() {
                    _this.observers = undefined;
                    _this.onNoObservers = undefined;
                });
            }
        }
    ]);
    return ObserverProxy;
}();
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $c425964833c2e1d2$export$12af436354f1a4f7(fn, onError) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        Promise.resolve(true).then(function() {
            fn.apply(void 0, (0, $3jzhD._)(args));
        }).catch(function(error) {
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $c425964833c2e1d2$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = methods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var method = _step.value;
            if (method in obj && typeof obj[method] === "function") return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $c425964833c2e1d2$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ var $c425964833c2e1d2$export$20164226a0ed35c3 = function validateArgCount(fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        var error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $c425964833c2e1d2$export$adea4917e02d93dc(fnName, argName) {
    return "".concat(fnName, " failed: ").concat(argName, " argument ");
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $c425964833c2e1d2$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($c425964833c2e1d2$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $c425964833c2e1d2$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($c425964833c2e1d2$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $c425964833c2e1d2$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($c425964833c2e1d2$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ var $c425964833c2e1d2$export$655666783217a925 = function stringToByteArray(str) {
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            $c425964833c2e1d2$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ var $c425964833c2e1d2$export$9536dc0a75b20bf9 = function stringLength(str) {
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ var $c425964833c2e1d2$export$abe4376e1bf796d6 = function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ var $c425964833c2e1d2$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ var $c425964833c2e1d2$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ var $c425964833c2e1d2$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ var $c425964833c2e1d2$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $c425964833c2e1d2$export$4d810c0ca64ed8e9(backoffCount) {
    var intervalMillis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c425964833c2e1d2$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $c425964833c2e1d2$var$DEFAULT_BACKOFF_FACTOR;
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    var currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    var randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $c425964833c2e1d2$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($c425964833c2e1d2$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $c425964833c2e1d2$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return "".concat(i);
    return i + $c425964833c2e1d2$var$indicator(i);
}
function $c425964833c2e1d2$var$indicator(i) {
    i = Math.abs(i);
    var cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    var dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c425964833c2e1d2$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

});
parcelRegister("hZFWO", function(module, exports) {
// shim for using process in browser
var $d198ac116a0e36eb$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d198ac116a0e36eb$var$cachedSetTimeout;
var $d198ac116a0e36eb$var$cachedClearTimeout;
function $d198ac116a0e36eb$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $d198ac116a0e36eb$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $d198ac116a0e36eb$var$cachedSetTimeout = setTimeout;
        else $d198ac116a0e36eb$var$cachedSetTimeout = $d198ac116a0e36eb$var$defaultSetTimout;
    } catch (e) {
        $d198ac116a0e36eb$var$cachedSetTimeout = $d198ac116a0e36eb$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $d198ac116a0e36eb$var$cachedClearTimeout = clearTimeout;
        else $d198ac116a0e36eb$var$cachedClearTimeout = $d198ac116a0e36eb$var$defaultClearTimeout;
    } catch (e) {
        $d198ac116a0e36eb$var$cachedClearTimeout = $d198ac116a0e36eb$var$defaultClearTimeout;
    }
})();
function $d198ac116a0e36eb$var$runTimeout(fun) {
    if ($d198ac116a0e36eb$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d198ac116a0e36eb$var$cachedSetTimeout === $d198ac116a0e36eb$var$defaultSetTimout || !$d198ac116a0e36eb$var$cachedSetTimeout) && setTimeout) {
        $d198ac116a0e36eb$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d198ac116a0e36eb$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d198ac116a0e36eb$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d198ac116a0e36eb$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d198ac116a0e36eb$var$runClearTimeout(marker) {
    if ($d198ac116a0e36eb$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d198ac116a0e36eb$var$cachedClearTimeout === $d198ac116a0e36eb$var$defaultClearTimeout || !$d198ac116a0e36eb$var$cachedClearTimeout) && clearTimeout) {
        $d198ac116a0e36eb$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d198ac116a0e36eb$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d198ac116a0e36eb$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d198ac116a0e36eb$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d198ac116a0e36eb$var$queue = [];
var $d198ac116a0e36eb$var$draining = false;
var $d198ac116a0e36eb$var$currentQueue;
var $d198ac116a0e36eb$var$queueIndex = -1;
function $d198ac116a0e36eb$var$cleanUpNextTick() {
    if (!$d198ac116a0e36eb$var$draining || !$d198ac116a0e36eb$var$currentQueue) return;
    $d198ac116a0e36eb$var$draining = false;
    if ($d198ac116a0e36eb$var$currentQueue.length) $d198ac116a0e36eb$var$queue = $d198ac116a0e36eb$var$currentQueue.concat($d198ac116a0e36eb$var$queue);
    else $d198ac116a0e36eb$var$queueIndex = -1;
    if ($d198ac116a0e36eb$var$queue.length) $d198ac116a0e36eb$var$drainQueue();
}
function $d198ac116a0e36eb$var$drainQueue() {
    if ($d198ac116a0e36eb$var$draining) return;
    var timeout = $d198ac116a0e36eb$var$runTimeout($d198ac116a0e36eb$var$cleanUpNextTick);
    $d198ac116a0e36eb$var$draining = true;
    var len = $d198ac116a0e36eb$var$queue.length;
    while(len){
        $d198ac116a0e36eb$var$currentQueue = $d198ac116a0e36eb$var$queue;
        $d198ac116a0e36eb$var$queue = [];
        while(++$d198ac116a0e36eb$var$queueIndex < len)if ($d198ac116a0e36eb$var$currentQueue) $d198ac116a0e36eb$var$currentQueue[$d198ac116a0e36eb$var$queueIndex].run();
        $d198ac116a0e36eb$var$queueIndex = -1;
        len = $d198ac116a0e36eb$var$queue.length;
    }
    $d198ac116a0e36eb$var$currentQueue = null;
    $d198ac116a0e36eb$var$draining = false;
    $d198ac116a0e36eb$var$runClearTimeout(timeout);
}
$d198ac116a0e36eb$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d198ac116a0e36eb$var$queue.push(new $d198ac116a0e36eb$var$Item(fun, args));
    if ($d198ac116a0e36eb$var$queue.length === 1 && !$d198ac116a0e36eb$var$draining) $d198ac116a0e36eb$var$runTimeout($d198ac116a0e36eb$var$drainQueue);
};
// v8 likes predictible objects
function $d198ac116a0e36eb$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d198ac116a0e36eb$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d198ac116a0e36eb$var$process.title = "browser";
$d198ac116a0e36eb$var$process.browser = true;
$d198ac116a0e36eb$var$process.env = {};
$d198ac116a0e36eb$var$process.argv = [];
$d198ac116a0e36eb$var$process.version = ""; // empty string to avoid regexp issues
$d198ac116a0e36eb$var$process.versions = {};
function $d198ac116a0e36eb$var$noop() {}
$d198ac116a0e36eb$var$process.on = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.addListener = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.once = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.off = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.removeListener = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.removeAllListeners = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.emit = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.prependListener = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.prependOnceListener = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.listeners = function(name) {
    return [];
};
$d198ac116a0e36eb$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$d198ac116a0e36eb$var$process.cwd = function() {
    return "/";
};
$d198ac116a0e36eb$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$d198ac116a0e36eb$var$process.umask = function() {
    return 0;
};

});



parcelRegister("3DJ6n", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $2a67ffe376308ccd$export$243e62d78d3b544d; });
$parcel$export(module.exports, "Logger", function () { return $2a67ffe376308ccd$export$efa9a398d6368992; });
$parcel$export(module.exports, "setLogLevel", function () { return $2a67ffe376308ccd$export$c622e99c0ce7b1c9; });
$parcel$export(module.exports, "setUserLogHandler", function () { return $2a67ffe376308ccd$export$29577d29c84db5f6; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ 
var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $c5rwh = parcelRequire("c5rwh");

var $3jzhD = parcelRequire("3jzhD");
var $2a67ffe376308ccd$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $2a67ffe376308ccd$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($2a67ffe376308ccd$export$243e62d78d3b544d || ($2a67ffe376308ccd$export$243e62d78d3b544d = {}));
var $2a67ffe376308ccd$var$levelStringToEnum = {
    "debug": $2a67ffe376308ccd$export$243e62d78d3b544d.DEBUG,
    "verbose": $2a67ffe376308ccd$export$243e62d78d3b544d.VERBOSE,
    "info": $2a67ffe376308ccd$export$243e62d78d3b544d.INFO,
    "warn": $2a67ffe376308ccd$export$243e62d78d3b544d.WARN,
    "error": $2a67ffe376308ccd$export$243e62d78d3b544d.ERROR,
    "silent": $2a67ffe376308ccd$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ var $2a67ffe376308ccd$var$defaultLogLevel = $2a67ffe376308ccd$export$243e62d78d3b544d.INFO;
var $2a67ffe376308ccd$var$_obj;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ var $2a67ffe376308ccd$var$ConsoleMethod = ($2a67ffe376308ccd$var$_obj = {}, (0, $c5rwh._)($2a67ffe376308ccd$var$_obj, $2a67ffe376308ccd$export$243e62d78d3b544d.DEBUG, "log"), (0, $c5rwh._)($2a67ffe376308ccd$var$_obj, $2a67ffe376308ccd$export$243e62d78d3b544d.VERBOSE, "log"), (0, $c5rwh._)($2a67ffe376308ccd$var$_obj, $2a67ffe376308ccd$export$243e62d78d3b544d.INFO, "info"), (0, $c5rwh._)($2a67ffe376308ccd$var$_obj, $2a67ffe376308ccd$export$243e62d78d3b544d.WARN, "warn"), (0, $c5rwh._)($2a67ffe376308ccd$var$_obj, $2a67ffe376308ccd$export$243e62d78d3b544d.ERROR, "error"), $2a67ffe376308ccd$var$_obj);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ var $2a67ffe376308ccd$var$defaultLogHandler = function(instance, logType) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        args[_key - 2] = arguments[_key];
    }
    var _console;
    if (logType < instance.logLevel) return;
    var now = new Date().toISOString();
    var method = $2a67ffe376308ccd$var$ConsoleMethod[logType];
    if (method) (_console = console)[method].apply(_console, [
        "[".concat(now, "]  ").concat(instance.name, ":")
    ].concat((0, $3jzhD._)(args)));
    else throw new Error("Attempted to log a message with an invalid logType (value: ".concat(logType, ")"));
};
var $2a67ffe376308ccd$export$efa9a398d6368992 = /*#__PURE__*/ function() {
    "use strict";
    function Logger(name) {
        (0, $19mwo._)(this, Logger);
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $2a67ffe376308ccd$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $2a67ffe376308ccd$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $2a67ffe376308ccd$var$instances.push(this);
    }
    (0, $6rpfc._)(Logger, [
        {
            key: "logLevel",
            get: function get() {
                return this._logLevel;
            },
            set: function set(val) {
                if (!(val in $2a67ffe376308ccd$export$243e62d78d3b544d)) throw new TypeError('Invalid value "'.concat(val, '" assigned to `logLevel`'));
                this._logLevel = val;
            }
        },
        {
            // Workaround for setter/getter having to be the same type.
            key: "setLogLevel",
            value: function setLogLevel(val) {
                this._logLevel = typeof val === "string" ? $2a67ffe376308ccd$var$levelStringToEnum[val] : val;
            }
        },
        {
            key: "logHandler",
            get: function get() {
                return this._logHandler;
            },
            set: function set(val) {
                if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
                this._logHandler = val;
            }
        },
        {
            key: "userLogHandler",
            get: function get() {
                return this._userLogHandler;
            },
            set: function set(val) {
                this._userLogHandler = val;
            }
        },
        {
            /**
     * The functions below are all based on the `console` interface
     */ key: "debug",
            value: function debug() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $2a67ffe376308ccd$export$243e62d78d3b544d.DEBUG
                ].concat((0, $3jzhD._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $2a67ffe376308ccd$export$243e62d78d3b544d.DEBUG
                ].concat((0, $3jzhD._)(args)));
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $2a67ffe376308ccd$export$243e62d78d3b544d.VERBOSE
                ].concat((0, $3jzhD._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $2a67ffe376308ccd$export$243e62d78d3b544d.VERBOSE
                ].concat((0, $3jzhD._)(args)));
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $2a67ffe376308ccd$export$243e62d78d3b544d.INFO
                ].concat((0, $3jzhD._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $2a67ffe376308ccd$export$243e62d78d3b544d.INFO
                ].concat((0, $3jzhD._)(args)));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $2a67ffe376308ccd$export$243e62d78d3b544d.WARN
                ].concat((0, $3jzhD._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $2a67ffe376308ccd$export$243e62d78d3b544d.WARN
                ].concat((0, $3jzhD._)(args)));
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $2a67ffe376308ccd$export$243e62d78d3b544d.ERROR
                ].concat((0, $3jzhD._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $2a67ffe376308ccd$export$243e62d78d3b544d.ERROR
                ].concat((0, $3jzhD._)(args)));
            }
        }
    ]);
    return Logger;
}();
function $2a67ffe376308ccd$export$c622e99c0ce7b1c9(level) {
    $2a67ffe376308ccd$var$instances.forEach(function(inst) {
        inst.setLogLevel(level);
    });
}
function $2a67ffe376308ccd$export$29577d29c84db5f6(logCallback, options) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var instance = _step.value;
            var customLogLevel = null;
            if (options && options.level) customLogLevel = $2a67ffe376308ccd$var$levelStringToEnum[options.level];
            if (logCallback === null) instance.userLogHandler = null;
            else instance.userLogHandler = function(instance, level) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    args[_key - 2] = arguments[_key];
                }
                var message = args.map(function(arg) {
                    if (arg == null) return null;
                    else if (typeof arg === "string") return arg;
                    else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                    else if (arg instanceof Error) return arg.message;
                    else try {
                        return JSON.stringify(arg);
                    } catch (ignored) {
                        return null;
                    }
                }).filter(function(arg) {
                    return arg;
                }).join(" ");
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                    level: $2a67ffe376308ccd$export$243e62d78d3b544d[level].toLowerCase(),
                    message: message,
                    args: args,
                    type: instance.name
                });
            };
        };
        for(var _iterator = $2a67ffe376308ccd$var$instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

});

parcelRegister("7iY56", function(module, exports) {

$parcel$export(module.exports, "openDB", function () { return $5518d1c2b155308c$export$ca0ed41b1a2af7e; });

var $9OZ9j = parcelRequire("9OZ9j");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $3jzhD = parcelRequire("3jzhD");

var $lF1I7 = parcelRequire("lF1I7");

var $fM1Jp = parcelRequire("fM1Jp");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $5518d1c2b155308c$export$ca0ed41b1a2af7e(name, version) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, blocked = _ref.blocked, upgrade = _ref.upgrade, blocking = _ref.blocking, terminated = _ref.terminated;
    var request = indexedDB.open(name, version);
    var openPromise = (0, $fM1Jp.w)(request);
    if (upgrade) request.addEventListener("upgradeneeded", function(event) {
        upgrade((0, $fM1Jp.w)(request.result), event.oldVersion, event.newVersion, (0, $fM1Jp.w)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", function(event) {
        return blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event);
    });
    openPromise.then(function(db) {
        if (terminated) db.addEventListener("close", function() {
            return terminated();
        });
        if (blocking) db.addEventListener("versionchange", function(event) {
            return blocking(event.oldVersion, event.newVersion, event);
        });
    }).catch(function() {});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $5518d1c2b155308c$export$9d6df0ac66a98bb2(name) {
    var blocked = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).blocked;
    var request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", function(event) {
        return blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event);
    });
    return (0, $fM1Jp.w)(request).then(function() {
        return undefined;
    });
}
var $5518d1c2b155308c$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
var $5518d1c2b155308c$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
var $5518d1c2b155308c$var$cachedMethods = new Map();
function $5518d1c2b155308c$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($5518d1c2b155308c$var$cachedMethods.get(prop)) return $5518d1c2b155308c$var$cachedMethods.get(prop);
    var targetFuncName = prop.replace(/FromIndex$/, "");
    var useIndex = prop !== targetFuncName;
    var isWrite = $5518d1c2b155308c$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $5518d1c2b155308c$var$readMethods.includes(targetFuncName))) return;
    var method = function() {
        var _ref = (0, $9OZ9j._)(function(storeName) {
            var _len, args, _key, _target, tx, _$target;
            var _arguments = arguments;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            args[_key - 1] = _arguments[_key];
                        }
                        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
                        tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
                        _$target = tx.store;
                        if (useIndex) _$target = _$target.index(args.shift());
                        return [
                            4,
                            Promise.all([
                                (_target = _$target)[targetFuncName].apply(_target, (0, $3jzhD._)(args)),
                                isWrite && tx.done
                            ])
                        ];
                    case 1:
                        // Must reject if op rejects.
                        // If it's a write operation, must reject if tx.done rejects.
                        // Must reject with op rejection first.
                        // Must resolve with op value.
                        // Must handle both promises (no unhandled rejections)
                        return [
                            2,
                            _state.sent()[0]
                        ];
                }
            });
        });
        return function method(storeName) {
            return _ref.apply(this, arguments);
        };
    }();
    $5518d1c2b155308c$var$cachedMethods.set(prop, method);
    return method;
}
(0, $fM1Jp.r)(function(oldTraps) {
    return (0, $ddevm._)((0, $78DQ7._)({}, oldTraps), {
        get: function(target, prop, receiver) {
            return $5518d1c2b155308c$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver);
        },
        has: function(target, prop) {
            return !!$5518d1c2b155308c$var$getMethod(target, prop) || oldTraps.has(target, prop);
        }
    });
});

});
parcelRegister("78DQ7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $53282f0f5813967e$export$581ff339ea0ba762; });

var $c5rwh = parcelRequire("c5rwh");
function $53282f0f5813967e$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $c5rwh._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("ddevm", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $99e7bda04c888523$export$4fa2f4023c9cbda5; });
function $99e7bda04c888523$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $99e7bda04c888523$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $99e7bda04c888523$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("fM1Jp", function(module, exports) {

$parcel$export(module.exports, "w", function () { return $b7bcae8d71315f6b$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "r", function () { return $b7bcae8d71315f6b$export$43caf9889c228507; });

var $3jzhD = parcelRequire("3jzhD");
var $b7bcae8d71315f6b$export$23f2a1d2818174ef = function(object, constructors) {
    return constructors.some(function(c) {
        return object instanceof c;
    });
};
var $b7bcae8d71315f6b$var$idbProxyableTypes;
var $b7bcae8d71315f6b$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $b7bcae8d71315f6b$var$getIdbProxyableTypes() {
    return $b7bcae8d71315f6b$var$idbProxyableTypes || ($b7bcae8d71315f6b$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $b7bcae8d71315f6b$var$getCursorAdvanceMethods() {
    return $b7bcae8d71315f6b$var$cursorAdvanceMethods || ($b7bcae8d71315f6b$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
var $b7bcae8d71315f6b$var$cursorRequestMap = new WeakMap();
var $b7bcae8d71315f6b$var$transactionDoneMap = new WeakMap();
var $b7bcae8d71315f6b$var$transactionStoreNamesMap = new WeakMap();
var $b7bcae8d71315f6b$var$transformCache = new WeakMap();
var $b7bcae8d71315f6b$export$407448d2b89b1813 = new WeakMap();
function $b7bcae8d71315f6b$var$promisifyRequest(request) {
    var promise = new Promise(function(resolve, reject) {
        var unlisten = function() {
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        var success = function() {
            resolve($b7bcae8d71315f6b$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        var error = function() {
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then(function(value) {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $b7bcae8d71315f6b$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(function() {});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $b7bcae8d71315f6b$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $b7bcae8d71315f6b$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($b7bcae8d71315f6b$var$transactionDoneMap.has(tx)) return;
    var done = new Promise(function(resolve, reject) {
        var unlisten = function() {
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        var complete = function() {
            resolve();
            unlisten();
        };
        var error = function() {
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $b7bcae8d71315f6b$var$transactionDoneMap.set(tx, done);
}
var $b7bcae8d71315f6b$var$idbProxyTraps = {
    get: function(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $b7bcae8d71315f6b$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $b7bcae8d71315f6b$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $b7bcae8d71315f6b$export$efccba1c4a2ef57b(target[prop]);
    },
    set: function(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has: function(target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $b7bcae8d71315f6b$export$43caf9889c228507(callback) {
    $b7bcae8d71315f6b$var$idbProxyTraps = callback($b7bcae8d71315f6b$var$idbProxyTraps);
}
function $b7bcae8d71315f6b$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var _func;
        var tx = (_func = func).call.apply(_func, [
            $b7bcae8d71315f6b$export$3b14a55fb2447963(this),
            storeNames
        ].concat((0, $3jzhD._)(args)));
        $b7bcae8d71315f6b$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $b7bcae8d71315f6b$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($b7bcae8d71315f6b$var$getCursorAdvanceMethods().includes(func)) return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($b7bcae8d71315f6b$export$3b14a55fb2447963(this), args);
        return $b7bcae8d71315f6b$export$efccba1c4a2ef57b($b7bcae8d71315f6b$var$cursorRequestMap.get(this));
    };
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $b7bcae8d71315f6b$export$efccba1c4a2ef57b(func.apply($b7bcae8d71315f6b$export$3b14a55fb2447963(this), args));
    };
}
function $b7bcae8d71315f6b$var$transformCachableValue(value) {
    if (typeof value === "function") return $b7bcae8d71315f6b$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $b7bcae8d71315f6b$var$cacheDonePromiseForTransaction(value);
    if ($b7bcae8d71315f6b$export$23f2a1d2818174ef(value, $b7bcae8d71315f6b$var$getIdbProxyableTypes())) return new Proxy(value, $b7bcae8d71315f6b$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $b7bcae8d71315f6b$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $b7bcae8d71315f6b$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($b7bcae8d71315f6b$var$transformCache.has(value)) return $b7bcae8d71315f6b$var$transformCache.get(value);
    var newValue = $b7bcae8d71315f6b$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $b7bcae8d71315f6b$var$transformCache.set(value, newValue);
        $b7bcae8d71315f6b$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
var $b7bcae8d71315f6b$export$3b14a55fb2447963 = function(value) {
    return $b7bcae8d71315f6b$export$407448d2b89b1813.get(value);
};

});



parcelRegister("iFOaV", function(module, exports) {

$parcel$export(module.exports, "Integer", function () { return $d982fa0ff8c5f739$export$70ffa26850098d01; });
$parcel$export(module.exports, "Md5", function () { return $d982fa0ff8c5f739$export$9f5a3dfc7a9f5dd; });
var $d982fa0ff8c5f739$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $d982fa0ff8c5f739$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $d982fa0ff8c5f739$export$70ffa26850098d01;
var $d982fa0ff8c5f739$export$9f5a3dfc7a9f5dd;
(function() {
    var h; /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    function k(f, a) {
        function c() {}
        c.prototype = a.prototype;
        f.D = a.prototype;
        f.prototype = new c;
        f.prototype.constructor = f;
        f.C = function(d, e, g) {
            for(var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++)b[r - 2] = arguments[r];
            return a.prototype[e].apply(d, b);
        };
    }
    function l() {
        this.blockSize = -1;
    }
    function m() {
        this.blockSize = -1;
        this.blockSize = 64;
        this.g = Array(4);
        this.B = Array(this.blockSize);
        this.o = this.h = 0;
        this.s();
    }
    k(m, l);
    m.prototype.s = function() {
        this.g[0] = 1732584193;
        this.g[1] = 4023233417;
        this.g[2] = 2562383102;
        this.g[3] = 271733878;
        this.o = this.h = 0;
    };
    function n(f, a, c) {
        c || (c = 0);
        var d = Array(16);
        if ("string" === typeof a) for(var e = 0; 16 > e; ++e)d[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
        else for(e = 0; 16 > e; ++e)d[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
        a = f.g[0];
        c = f.g[1];
        e = f.g[2];
        var g = f.g[3];
        var b = a + (g ^ c & (e ^ g)) + d[0] + 3614090360 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[1] + 3905402710 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[2] + 606105819 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[3] + 3250441966 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[4] + 4118548399 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[5] + 1200080426 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[6] + 2821735955 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[7] + 4249261313 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[8] + 1770035416 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[9] + 2336552879 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[10] + 4294925233 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[11] + 2304563134 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[12] + 1804603682 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[13] + 4254626195 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[14] + 2792965006 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[15] + 1236535329 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (e ^ g & (c ^ e)) + d[1] + 4129170786 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[6] + 3225465664 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[11] + 643717713 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[0] + 3921069994 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[5] + 3593408605 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[10] + 38016083 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[15] + 3634488961 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[4] + 3889429448 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[9] + 568446438 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[14] + 3275163606 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[3] + 4107603335 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[8] + 1163531501 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[13] + 2850285829 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[2] + 4243563512 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[7] + 1735328473 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[12] + 2368359562 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (c ^ e ^ g) + d[5] + 4294588738 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[8] + 2272392833 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[11] + 1839030562 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[14] + 4259657740 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[1] + 2763975236 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[4] + 1272893353 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[7] + 4139469664 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[10] + 3200236656 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[13] + 681279174 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[0] + 3936430074 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[3] + 3572445317 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[6] + 76029189 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[9] + 3654602809 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[12] + 3873151461 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[15] + 530742520 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[2] + 3299628645 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (e ^ (c | ~g)) + d[0] + 4096336452 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[7] + 1126891415 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[14] + 2878612391 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[5] + 4237533241 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[12] + 1700485571 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[3] + 2399980690 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[10] + 4293915773 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[1] + 2240044497 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[8] + 1873313359 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[15] + 4264355552 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[6] + 2734768916 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[13] + 1309151649 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[4] + 4149444226 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[11] + 3174756917 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[2] + 718787259 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[9] + 3951481745 & 4294967295;
        f.g[0] = f.g[0] + a & 4294967295;
        f.g[1] = f.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
        f.g[2] = f.g[2] + e & 4294967295;
        f.g[3] = f.g[3] + g & 4294967295;
    }
    m.prototype.u = function(f, a) {
        void 0 === a && (a = f.length);
        for(var c = a - this.blockSize, d = this.B, e = this.h, g = 0; g < a;){
            if (0 == e) for(; g <= c;)n(this, f, g), g += this.blockSize;
            if ("string" === typeof f) {
                for(; g < a;)if (d[e++] = f.charCodeAt(g++), e == this.blockSize) {
                    n(this, d);
                    e = 0;
                    break;
                }
            } else for(; g < a;)if (d[e++] = f[g++], e == this.blockSize) {
                n(this, d);
                e = 0;
                break;
            }
        }
        this.h = e;
        this.o += a;
    };
    m.prototype.v = function() {
        var f = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
        f[0] = 128;
        for(var a = 1; a < f.length - 8; ++a)f[a] = 0;
        var c = 8 * this.o;
        for(a = f.length - 8; a < f.length; ++a)f[a] = c & 255, c /= 256;
        this.u(f);
        f = Array(16);
        for(a = c = 0; 4 > a; ++a)for(var d = 0; 32 > d; d += 8)f[c++] = this.g[a] >>> d & 255;
        return f;
    };
    function p(f, a) {
        var c = q;
        return Object.prototype.hasOwnProperty.call(c, f) ? c[f] : c[f] = a(f);
    }
    function t(f, a) {
        this.h = a;
        for(var c = [], d = !0, e = f.length - 1; 0 <= e; e--){
            var g = f[e] | 0;
            d && g == a || (c[e] = g, d = !1);
        }
        this.g = c;
    }
    var q = {};
    function u(f) {
        return -128 <= f && 128 > f ? p(f, function(a) {
            return new t([
                a | 0
            ], 0 > a ? -1 : 0);
        }) : new t([
            f | 0
        ], 0 > f ? -1 : 0);
    }
    function v(f) {
        if (isNaN(f) || !isFinite(f)) return w;
        if (0 > f) return x(v(-f));
        for(var a = [], c = 1, d = 0; f >= c; d++)a[d] = f / c | 0, c *= 4294967296;
        return new t(a, 0);
    }
    function y(f, a) {
        if (0 == f.length) throw Error("number format error: empty string");
        a = a || 10;
        if (2 > a || 36 < a) throw Error("radix out of range: " + a);
        if ("-" == f.charAt(0)) return x(y(f.substring(1), a));
        if (0 <= f.indexOf("-")) throw Error('number format error: interior "-" character');
        for(var c = v(Math.pow(a, 8)), d = w, e = 0; e < f.length; e += 8){
            var g = Math.min(8, f.length - e), b = parseInt(f.substring(e, e + g), a);
            8 > g ? (g = v(Math.pow(a, g)), d = d.j(g).add(v(b))) : (d = d.j(c), d = d.add(v(b)));
        }
        return d;
    }
    var w = u(0), z = u(1), A = u(16777216);
    h = t.prototype;
    h.m = function() {
        if (B(this)) return -x(this).m();
        for(var f = 0, a = 1, c = 0; c < this.g.length; c++){
            var d = this.i(c);
            f += (0 <= d ? d : 4294967296 + d) * a;
            a *= 4294967296;
        }
        return f;
    };
    h.toString = function(f) {
        f = f || 10;
        if (2 > f || 36 < f) throw Error("radix out of range: " + f);
        if (C(this)) return "0";
        if (B(this)) return "-" + x(this).toString(f);
        for(var a = v(Math.pow(f, 6)), c = this, d = "";;){
            var e = D(c, a).g;
            c = F(c, e.j(a));
            var g = ((0 < c.g.length ? c.g[0] : c.h) >>> 0).toString(f);
            c = e;
            if (C(c)) return g + d;
            for(; 6 > g.length;)g = "0" + g;
            d = g + d;
        }
    };
    h.i = function(f) {
        return 0 > f ? 0 : f < this.g.length ? this.g[f] : this.h;
    };
    function C(f) {
        if (0 != f.h) return !1;
        for(var a = 0; a < f.g.length; a++)if (0 != f.g[a]) return !1;
        return !0;
    }
    function B(f) {
        return -1 == f.h;
    }
    h.l = function(f) {
        f = F(this, f);
        return B(f) ? -1 : C(f) ? 0 : 1;
    };
    function x(f) {
        for(var a = f.g.length, c = [], d = 0; d < a; d++)c[d] = ~f.g[d];
        return new t(c, ~f.h).add(z);
    }
    h.abs = function() {
        return B(this) ? x(this) : this;
    };
    h.add = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0, e = 0; e <= a; e++){
            var g = d + (this.i(e) & 65535) + (f.i(e) & 65535), b = (g >>> 16) + (this.i(e) >>> 16) + (f.i(e) >>> 16);
            d = b >>> 16;
            g &= 65535;
            b &= 65535;
            c[e] = b << 16 | g;
        }
        return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };
    function F(f, a) {
        return f.add(x(a));
    }
    h.j = function(f) {
        if (C(this) || C(f)) return w;
        if (B(this)) return B(f) ? x(this).j(x(f)) : x(x(this).j(f));
        if (B(f)) return x(this.j(x(f)));
        if (0 > this.l(A) && 0 > f.l(A)) return v(this.m() * f.m());
        for(var a = this.g.length + f.g.length, c = [], d = 0; d < 2 * a; d++)c[d] = 0;
        for(d = 0; d < this.g.length; d++)for(var e = 0; e < f.g.length; e++){
            var g = this.i(d) >>> 16, b = this.i(d) & 65535, r = f.i(e) >>> 16, E = f.i(e) & 65535;
            c[2 * d + 2 * e] += b * E;
            G(c, 2 * d + 2 * e);
            c[2 * d + 2 * e + 1] += g * E;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 1] += b * r;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 2] += g * r;
            G(c, 2 * d + 2 * e + 2);
        }
        for(d = 0; d < a; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
        for(d = a; d < 2 * a; d++)c[d] = 0;
        return new t(c, 0);
    };
    function G(f, a) {
        for(; (f[a] & 65535) != f[a];)f[a + 1] += f[a] >>> 16, f[a] &= 65535, a++;
    }
    function H(f, a) {
        this.g = f;
        this.h = a;
    }
    function D(f, a) {
        if (C(a)) throw Error("division by zero");
        if (C(f)) return new H(w, w);
        if (B(f)) return a = D(x(f), a), new H(x(a.g), x(a.h));
        if (B(a)) return a = D(f, x(a)), new H(x(a.g), a.h);
        if (30 < f.g.length) {
            if (B(f) || B(a)) throw Error("slowDivide_ only works with positive integers.");
            for(var c = z, d = a; 0 >= d.l(f);)c = I(c), d = I(d);
            var e = J(c, 1), g = J(d, 1);
            d = J(d, 2);
            for(c = J(c, 2); !C(d);){
                var b = g.add(d);
                0 >= b.l(f) && (e = e.add(c), g = b);
                d = J(d, 1);
                c = J(c, 1);
            }
            a = F(f, e.j(a));
            return new H(e, a);
        }
        for(e = w; 0 <= f.l(a);){
            c = Math.max(1, Math.floor(f.m() / a.m()));
            d = Math.ceil(Math.log(c) / Math.LN2);
            d = 48 >= d ? 1 : Math.pow(2, d - 48);
            g = v(c);
            for(b = g.j(a); B(b) || 0 < b.l(f);)c -= d, g = v(c), b = g.j(a);
            C(g) && (g = z);
            e = e.add(g);
            f = F(f, b);
        }
        return new H(e, f);
    }
    h.A = function(f) {
        return D(this, f).h;
    };
    h.and = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) & f.i(d);
        return new t(c, this.h & f.h);
    };
    h.or = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) | f.i(d);
        return new t(c, this.h | f.h);
    };
    h.xor = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) ^ f.i(d);
        return new t(c, this.h ^ f.h);
    };
    function I(f) {
        for(var a = f.g.length + 1, c = [], d = 0; d < a; d++)c[d] = f.i(d) << 1 | f.i(d - 1) >>> 31;
        return new t(c, f.h);
    }
    function J(f, a) {
        var c = a >> 5;
        a %= 32;
        for(var d = f.g.length - c, e = [], g = 0; g < d; g++)e[g] = 0 < a ? f.i(g + c) >>> a | f.i(g + c + 1) << 32 - a : f.i(g + c);
        return new t(e, f.h);
    }
    m.prototype.digest = m.prototype.v;
    m.prototype.reset = m.prototype.s;
    m.prototype.update = m.prototype.u;
    $d982fa0ff8c5f739$export$9f5a3dfc7a9f5dd = $d982fa0ff8c5f739$export$2e2bcd8739ae039.Md5 = m;
    t.prototype.add = t.prototype.add;
    t.prototype.multiply = t.prototype.j;
    t.prototype.modulo = t.prototype.A;
    t.prototype.compare = t.prototype.l;
    t.prototype.toNumber = t.prototype.m;
    t.prototype.toString = t.prototype.toString;
    t.prototype.getBits = t.prototype.i;
    t.fromNumber = v;
    t.fromString = y;
    $d982fa0ff8c5f739$export$70ffa26850098d01 = $d982fa0ff8c5f739$export$2e2bcd8739ae039.Integer = t;
}).apply(typeof $d982fa0ff8c5f739$var$commonjsGlobal !== "undefined" ? $d982fa0ff8c5f739$var$commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});

});

parcelRegister("2B9VL", function(module, exports) {

$parcel$export(module.exports, "XhrIo", function () { return $1e46bd7fb4109e0c$export$26404658cda3ee02; });
$parcel$export(module.exports, "FetchXmlHttpFactory", function () { return $1e46bd7fb4109e0c$export$ddb1030448106742; });
$parcel$export(module.exports, "WebChannel", function () { return $1e46bd7fb4109e0c$export$aa726fb96ad3e039; });
$parcel$export(module.exports, "EventType", function () { return $1e46bd7fb4109e0c$export$3d7865934588d77e; });
$parcel$export(module.exports, "ErrorCode", function () { return $1e46bd7fb4109e0c$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "Stat", function () { return $1e46bd7fb4109e0c$export$cbbc350c1dfc80cb; });
$parcel$export(module.exports, "Event", function () { return $1e46bd7fb4109e0c$export$d61e24a684f9e51; });
$parcel$export(module.exports, "getStatEventTarget", function () { return $1e46bd7fb4109e0c$export$888d0d9ab79d08fc; });
$parcel$export(module.exports, "createWebChannelTransport", function () { return $1e46bd7fb4109e0c$export$66869136fc133c3a; });

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $jLCbM = parcelRequire("jLCbM");

var $laF8D = parcelRequire("laF8D");

var $iNfU4 = parcelRequire("iNfU4");

var $2MTYX = parcelRequire("2MTYX");

var $gnDeW = parcelRequire("gnDeW");

var $k1NN5 = parcelRequire("k1NN5");
var $1e46bd7fb4109e0c$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $1e46bd7fb4109e0c$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $1e46bd7fb4109e0c$export$26404658cda3ee02;
var $1e46bd7fb4109e0c$export$ddb1030448106742;
var $1e46bd7fb4109e0c$export$aa726fb96ad3e039;
var $1e46bd7fb4109e0c$export$3d7865934588d77e;
var $1e46bd7fb4109e0c$export$d4e71bc0b80dc0fb;
var $1e46bd7fb4109e0c$export$cbbc350c1dfc80cb;
var $1e46bd7fb4109e0c$export$d61e24a684f9e51;
var $1e46bd7fb4109e0c$export$888d0d9ab79d08fc;
var $1e46bd7fb4109e0c$export$66869136fc133c3a;
(function() {
    var h, aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function aa(a, b, c) {
        if (a == Array.prototype || a == Object.prototype) return a;
        a[b] = c.value;
        return a;
    };
    function ba(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $1e46bd7fb4109e0c$var$commonjsGlobal && $1e46bd7fb4109e0c$var$commonjsGlobal
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    function ea(a, b) {
        a instanceof String && (a += "");
        var c = 0, d = !1, e = {
            next: function next() {
                if (!d && c < a.length) {
                    var f = c++;
                    return {
                        value: b(f, a[f]),
                        done: !1
                    };
                }
                d = !0;
                return {
                    done: !0,
                    value: void 0
                };
            }
        };
        e[Symbol.iterator] = function() {
            return e;
        };
        return e;
    }
    da("Array.prototype.values", function(a) {
        return a ? a : function() {
            return ea(this, function(b, c) {
                return c;
            });
        };
    }); /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var fa = fa || {}, k = this || self;
    function ha(a) {
        var b = typeof a === "undefined" ? "undefined" : (0, $gnDeW._)(a);
        b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
        return "array" == b || "object" == b && "number" == typeof a.length;
    }
    function n(a) {
        var b = typeof a === "undefined" ? "undefined" : (0, $gnDeW._)(a);
        return "object" == b && null != a || "function" == b;
    }
    function ia(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ja(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var e = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(e, d);
                return a.apply(b, e);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function p(a, b, c) {
        p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ia : ja;
        return p.apply(null, arguments);
    }
    function ka(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    function r(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.aa = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Qb = function(d, e, f) {
            for(var g = Array(arguments.length - 2), m = 2; m < arguments.length; m++)g[m - 2] = arguments[m];
            return b.prototype[e].apply(d, g);
        };
    }
    function la(a) {
        var b = a.length;
        if (0 < b) {
            var c = Array(b);
            for(var d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    function ma(a, b) {
        for(var c = 1; c < arguments.length; c++){
            var d = arguments[c];
            if (ha(d)) {
                var e = a.length || 0, f = d.length || 0;
                a.length = e + f;
                for(var g = 0; g < f; g++)a[e + g] = d[g];
            } else a.push(d);
        }
    }
    var na = /*#__PURE__*/ function() {
        "use strict";
        function na(a, b) {
            (0, $19mwo._)(this, na);
            this.i = a;
            this.j = b;
            this.h = 0;
            this.g = null;
        }
        (0, $6rpfc._)(na, [
            {
                key: "get",
                value: function get() {
                    var a;
                    0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
                    return a;
                }
            }
        ]);
        return na;
    }();
    function t(a) {
        return /^[\s\xa0]*$/.test(a);
    }
    function u() {
        var a = k.navigator;
        return a && (a = a.userAgent) ? a : "";
    }
    function oa(a) {
        oa[" "](a);
        return a;
    }
    oa[" "] = function() {};
    var pa = -1 != u().indexOf("Gecko") && !(-1 != u().toLowerCase().indexOf("webkit") && -1 == u().indexOf("Edge")) && !(-1 != u().indexOf("Trident") || -1 != u().indexOf("MSIE")) && -1 == u().indexOf("Edge");
    function qa(a, b, c) {
        for(var d in a)b.call(c, a[d], d, a);
    }
    function ra(a, b) {
        for(var c in a)b.call(void 0, a[c], c, a);
    }
    function sa(a) {
        var b = {};
        for(var c in a)b[c] = a[c];
        return b;
    }
    var ta = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function ua(a, b) {
        var c, d;
        for(var e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(var f = 0; f < ta.length; f++)c = ta[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function va(a) {
        var b = 1;
        a = a.split(":");
        var c = [];
        for(; 0 < b && a.length;)c.push(a.shift()), b--;
        a.length && c.push(a.join(":"));
        return c;
    }
    function wa(a) {
        k.setTimeout(function() {
            throw a;
        }, 0);
    }
    function xa() {
        var a = za;
        var b = null;
        a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
        return b;
    }
    var Aa = /*#__PURE__*/ function() {
        "use strict";
        function Aa() {
            (0, $19mwo._)(this, Aa);
            this.h = this.g = null;
        }
        (0, $6rpfc._)(Aa, [
            {
                key: "add",
                value: function add(a, b) {
                    var c = Ba.get();
                    c.set(a, b);
                    this.h ? this.h.next = c : this.g = c;
                    this.h = c;
                }
            }
        ]);
        return Aa;
    }();
    var Ba = new na(function() {
        return new Ca;
    }, function(a) {
        return a.reset();
    });
    var Ca = /*#__PURE__*/ function() {
        "use strict";
        function Ca() {
            (0, $19mwo._)(this, Ca);
            this.next = this.g = this.h = null;
        }
        (0, $6rpfc._)(Ca, [
            {
                key: "set",
                value: function set(a, b) {
                    this.h = a;
                    this.g = b;
                    this.next = null;
                }
            },
            {
                key: "reset",
                value: function reset() {
                    this.next = this.g = this.h = null;
                }
            }
        ]);
        return Ca;
    }();
    var x, y = !1, za = new Aa, Ea = function() {
        var a = k.Promise.resolve(void 0);
        x = function() {
            a.then(Da);
        };
    };
    var Da = function() {
        for(var a; a = xa();){
            try {
                a.h.call(a.g);
            } catch (c) {
                wa(c);
            }
            var b = Ba;
            b.j(a);
            100 > b.h && (b.h++, a.next = b.g, b.g = a);
        }
        y = !1;
    };
    function z() {
        this.s = this.s;
        this.C = this.C;
    }
    z.prototype.s = !1;
    z.prototype.ma = function() {
        this.s || (this.s = !0, this.N());
    };
    z.prototype.N = function() {
        if (this.C) for(; this.C.length;)this.C.shift()();
    };
    function A(a, b) {
        this.type = a;
        this.g = this.target = b;
        this.defaultPrevented = !1;
    }
    A.prototype.h = function() {
        this.defaultPrevented = !0;
    };
    var Fa = function() {
        if (!k.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function get() {
                a = !0;
            }
        });
        try {
            var c = function() {};
            k.addEventListener("test", c, b);
            k.removeEventListener("test", c, b);
        } catch (c) {}
        return a;
    }();
    function C(a, b) {
        A.call(this, a ? a.type : "");
        this.relatedTarget = this.g = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.i = null;
        if (a) {
            var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
            this.target = a.target || a.srcElement;
            this.g = b;
            if (b = a.relatedTarget) {
                if (pa) {
                    a: {
                        try {
                            oa(b.nodeName);
                            var e = !0;
                            break a;
                        } catch (f) {}
                        e = !1;
                    }
                    e || (b = null);
                }
            } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
            this.relatedTarget = b;
            d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
            this.button = a.button;
            this.key = a.key || "";
            this.ctrlKey = a.ctrlKey;
            this.altKey = a.altKey;
            this.shiftKey = a.shiftKey;
            this.metaKey = a.metaKey;
            this.pointerId = a.pointerId || 0;
            this.pointerType = "string" === typeof a.pointerType ? a.pointerType : Ga[a.pointerType] || "";
            this.state = a.state;
            this.i = a;
            a.defaultPrevented && C.aa.h.call(this);
        }
    }
    r(C, A);
    var Ga = {
        2: "touch",
        3: "pen",
        4: "mouse"
    };
    C.prototype.h = function() {
        C.aa.h.call(this);
        var a = this.i;
        a.preventDefault ? a.preventDefault() : a.returnValue = !1;
    };
    var D = "closure_listenable_" + (1E6 * Math.random() | 0);
    var Ha = 0;
    function Ia(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ha = e;
        this.key = ++Ha;
        this.da = this.fa = !1;
    }
    function Ja(a) {
        a.da = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.ha = null;
    }
    function Ka(a) {
        this.src = a;
        this.g = {};
        this.h = 0;
    }
    Ka.prototype.add = function(a, b, c, d, e) {
        var f = a.toString();
        a = this.g[f];
        a || (a = this.g[f] = [], this.h++);
        var g = La(a, b, d, e);
        -1 < g ? (b = a[g], c || (b.fa = !1)) : (b = new Ia(b, this.src, f, !!d, e), b.fa = c, a.push(b));
        return b;
    };
    function Ma(a, b) {
        var c = b.type;
        if (c in a.g) {
            var d = a.g[c], e = Array.prototype.indexOf.call(d, b, void 0), f;
            (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
            f && (Ja(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
        }
    }
    function La(a, b, c, d) {
        for(var e = 0; e < a.length; ++e){
            var f = a[e];
            if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
        }
        return -1;
    }
    var Na = "closure_lm_" + (1E6 * Math.random() | 0), Oa = {};
    function Qa(a, b, c, d, e) {
        if (d && d.once) return Ra(a, b, c, d, e);
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Qa(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.K(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !1, d, e);
    }
    function Ta(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        var g = n(e) ? !!e.capture : !!e, m = Ua(a);
        m || (a[Na] = m = new Ka(a));
        c = m.add(b, c, d, g, f);
        if (c.proxy) return c;
        d = Va();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) Fa || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
        else if (a.attachEvent) a.attachEvent(Wa(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        return c;
    }
    function Va() {
        function a(c) {
            return b.call(a.src, a.listener, c);
        }
        var b = Xa;
        return a;
    }
    function Ra(a, b, c, d, e) {
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Ra(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.L(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !0, d, e);
    }
    function Ya(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)Ya(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = Sa(c), a && a[D]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = La(f, c, d, e), -1 < c && (Ja(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = Ua(a)) && (b = a.g[b.toString()], a = -1, b && (a = La(b, c, d, e)), (c = -1 < a ? b[a] : null) && Za(c));
    }
    function Za(a) {
        if ("number" !== typeof a && a && !a.da) {
            var b = a.src;
            if (b && b[D]) Ma(b.i, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Wa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                (c = Ua(b)) ? (Ma(c, a), 0 == c.h && (c.src = null, b[Na] = null)) : Ja(a);
            }
        }
    }
    function Wa(a) {
        return a in Oa ? Oa[a] : Oa[a] = "on" + a;
    }
    function Xa(a, b) {
        if (a.da) a = !0;
        else {
            b = new C(b, this);
            var c = a.listener, d = a.ha || a.src;
            a.fa && Za(a);
            a = c.call(d, b);
        }
        return a;
    }
    function Ua(a) {
        a = a[Na];
        return a instanceof Ka ? a : null;
    }
    var $a = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
    function Sa(a) {
        if ("function" === typeof a) return a;
        a[$a] || (a[$a] = function(b) {
            return a.handleEvent(b);
        });
        return a[$a];
    }
    function E() {
        z.call(this);
        this.i = new Ka(this);
        this.M = this;
        this.F = null;
    }
    r(E, z);
    E.prototype[D] = !0;
    E.prototype.removeEventListener = function(a, b, c, d) {
        Ya(this, a, b, c, d);
    };
    function F(a, b) {
        var c, d = a.F;
        if (d) for(c = []; d; d = d.F)c.push(d);
        a = a.M;
        d = b.type || b;
        if ("string" === typeof b) b = new A(b, a);
        else if (b instanceof A) b.target = b.target || a;
        else {
            var e = b;
            b = new A(d, a);
            ua(b, e);
        }
        e = !0;
        if (c) for(var f = c.length - 1; 0 <= f; f--){
            var g = b.g = c[f];
            e = ab(g, d, !0, b) && e;
        }
        g = b.g = a;
        e = ab(g, d, !0, b) && e;
        e = ab(g, d, !1, b) && e;
        if (c) for(f = 0; f < c.length; f++)g = b.g = c[f], e = ab(g, d, !1, b) && e;
    }
    E.prototype.N = function() {
        E.aa.N.call(this);
        if (this.i) {
            var a = this.i, c;
            for(c in a.g){
                for(var d = a.g[c], e = 0; e < d.length; e++)Ja(d[e]);
                delete a.g[c];
                a.h--;
            }
        }
        this.F = null;
    };
    E.prototype.K = function(a, b, c, d) {
        return this.i.add(String(a), b, !1, c, d);
    };
    E.prototype.L = function(a, b, c, d) {
        return this.i.add(String(a), b, !0, c, d);
    };
    function ab(a, b, c, d) {
        b = a.i.g[String(b)];
        if (!b) return !0;
        b = b.concat();
        for(var e = !0, f = 0; f < b.length; ++f){
            var g = b[f];
            if (g && !g.da && g.capture == c) {
                var m = g.listener, q = g.ha || g.src;
                g.fa && Ma(a.i, g);
                e = !1 !== m.call(q, d) && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function bb(a, b, c) {
        if ("function" === typeof a) c && (a = p(a, c));
        else if (a && "function" == typeof a.handleEvent) a = p(a.handleEvent, a);
        else throw Error("Invalid listener argument");
        return 2147483647 < Number(b) ? -1 : k.setTimeout(a, b || 0);
    }
    function cb(a) {
        a.g = bb(function() {
            a.g = null;
            a.i && (a.i = !1, cb(a));
        }, a.l);
        var b = a.h;
        a.h = null;
        a.m.apply(null, b);
    }
    var eb = /*#__PURE__*/ function(z) {
        "use strict";
        (0, $iNfU4._)(eb, z);
        var _super = (0, $k1NN5._)(eb);
        function eb(a, b) {
            (0, $19mwo._)(this, eb);
            var _this;
            _this = _super.call(this);
            _this.m = a;
            _this.l = b;
            _this.h = null;
            _this.i = !1;
            _this.g = null;
            return _this;
        }
        (0, $6rpfc._)(eb, [
            {
                key: "j",
                value: function j(a) {
                    this.h = arguments;
                    this.g ? this.i = !0 : cb(this);
                }
            },
            {
                key: "N",
                value: function N() {
                    (0, $jLCbM._)((0, $laF8D._)(eb.prototype), "N", this).call(this);
                    this.g && (k.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
                }
            }
        ]);
        return eb;
    }(z);
    function G(a) {
        z.call(this);
        this.h = a;
        this.g = {};
    }
    r(G, z);
    var fb = [];
    function gb(a) {
        qa(a.g, function(b, c) {
            this.g.hasOwnProperty(c) && Za(b);
        }, a);
        a.g = {};
    }
    G.prototype.N = function() {
        G.aa.N.call(this);
        gb(this);
    };
    G.prototype.handleEvent = function() {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var hb = k.JSON.stringify;
    var ib = k.JSON.parse;
    var jb = /*#__PURE__*/ function() {
        "use strict";
        function jb() {
            (0, $19mwo._)(this, jb);
        }
        (0, $6rpfc._)(jb, [
            {
                key: "stringify",
                value: function stringify(a) {
                    return k.JSON.stringify(a, void 0);
                }
            },
            {
                key: "parse",
                value: function parse(a) {
                    return k.JSON.parse(a, void 0);
                }
            }
        ]);
        return jb;
    }();
    function kb() {}
    kb.prototype.h = null;
    function lb(a) {
        return a.h || (a.h = a.i());
    }
    function mb() {}
    var H = {
        OPEN: "a",
        kb: "b",
        Ja: "c",
        wb: "d"
    };
    function nb() {
        A.call(this, "d");
    }
    r(nb, A);
    function ob() {
        A.call(this, "c");
    }
    r(ob, A);
    var I = {}, pb = null;
    function qb() {
        return pb = pb || new E;
    }
    I.La = "serverreachability";
    function rb(a) {
        A.call(this, I.La, a);
    }
    r(rb, A);
    function J(a) {
        var b = qb();
        F(b, new rb(b));
    }
    I.STAT_EVENT = "statevent";
    function sb(a, b) {
        A.call(this, I.STAT_EVENT, a);
        this.stat = b;
    }
    r(sb, A);
    function K(a) {
        var b = qb();
        F(b, new sb(b, a));
    }
    I.Ma = "timingevent";
    function tb(a, b) {
        A.call(this, I.Ma, a);
        this.size = b;
    }
    r(tb, A);
    function ub(a, b) {
        if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
        return k.setTimeout(function() {
            a();
        }, b);
    }
    function vb() {
        this.g = !0;
    }
    vb.prototype.xa = function() {
        this.g = !1;
    };
    function wb(a, b, c, d, e, f) {
        a.info(function() {
            if (a.g) {
                if (f) {
                    var g = "";
                    for(var m = f.split("&"), q = 0; q < m.length; q++){
                        var l = m[q].split("=");
                        if (1 < l.length) {
                            var v = l[0];
                            l = l[1];
                            var w = v.split("_");
                            g = 2 <= w.length && "type" == w[1] ? g + (v + "=" + l + "&") : g + (v + "=redacted&");
                        }
                    }
                } else g = null;
            } else g = f;
            return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
        });
    }
    function xb(a, b, c, d, e, f, g) {
        a.info(function() {
            return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
        });
    }
    function L(a, b, c, d) {
        a.info(function() {
            return "XMLHTTP TEXT (" + b + "): " + yb(a, c) + (d ? " " + d : "");
        });
    }
    function zb(a, b) {
        a.info(function() {
            return "TIMEOUT: " + b;
        });
    }
    vb.prototype.info = function() {};
    function yb(a, b) {
        if (!a.g) return b;
        if (!b) return null;
        try {
            var c = JSON.parse(b);
            if (c) {
                for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                    var d = c[a];
                    if (!(2 > d.length)) {
                        var e = d[1];
                        if (Array.isArray(e) && !(1 > e.length)) {
                            var f = e[0];
                            if ("noop" != f && "stop" != f && "close" != f) for(var g = 1; g < e.length; g++)e[g] = "";
                        }
                    }
                }
            }
            return hb(c);
        } catch (m) {
            return b;
        }
    }
    var Ab = {
        NO_ERROR: 0,
        gb: 1,
        tb: 2,
        sb: 3,
        nb: 4,
        rb: 5,
        ub: 6,
        Ia: 7,
        TIMEOUT: 8,
        xb: 9
    };
    var Bb = {
        lb: "complete",
        Hb: "success",
        Ja: "error",
        Ia: "abort",
        zb: "ready",
        Ab: "readystatechange",
        TIMEOUT: "timeout",
        vb: "incrementaldata",
        yb: "progress",
        ob: "downloadprogress",
        Pb: "uploadprogress"
    };
    var Cb;
    function Db() {}
    r(Db, kb);
    Db.prototype.g = function() {
        return new XMLHttpRequest;
    };
    Db.prototype.i = function() {
        return {};
    };
    Cb = new Db;
    function M(a, b, c, d) {
        this.j = a;
        this.i = b;
        this.l = c;
        this.R = d || 1;
        this.U = new G(this);
        this.I = 45E3;
        this.H = null;
        this.o = !1;
        this.m = this.A = this.v = this.L = this.F = this.S = this.B = null;
        this.D = [];
        this.g = null;
        this.C = 0;
        this.s = this.u = null;
        this.X = -1;
        this.J = !1;
        this.O = 0;
        this.M = null;
        this.W = this.K = this.T = this.P = !1;
        this.h = new Eb;
    }
    function Eb() {
        this.i = null;
        this.g = "";
        this.h = !1;
    }
    var Fb = {}, Gb = {};
    function Hb(a, b, c) {
        a.L = 1;
        a.v = Ib(N(b));
        a.m = c;
        a.P = !0;
        Jb(a, null);
    }
    function Jb(a, b) {
        a.F = Date.now();
        Kb(a);
        a.A = N(a.v);
        var c = a.A, d = a.R;
        Array.isArray(d) || (d = [
            String(d)
        ]);
        Lb(c.i, "t", d);
        a.C = 0;
        c = a.j.J;
        a.h = new Eb;
        a.g = Mb(a.j, c ? b : null, !a.m);
        0 < a.O && (a.M = new eb(p(a.Y, a, a.g), a.O));
        b = a.U;
        c = a.g;
        d = a.ca;
        var e = "readystatechange";
        Array.isArray(e) || (e && (fb[0] = e.toString()), e = fb);
        for(var f = 0; f < e.length; f++){
            var g = Qa(c, e[f], d || b.handleEvent, !1, b.h || b);
            if (!g) break;
            b.g[g.key] = g;
        }
        b = a.H ? sa(a.H) : {};
        a.m ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.A, a.u, a.m, b)) : (a.u = "GET", a.g.ea(a.A, a.u, null, b));
        J();
        wb(a.i, a.u, a.A, a.l, a.R, a.m);
    }
    M.prototype.ca = function(a) {
        a = a.target;
        var b = this.M;
        b && 3 == P(a) ? b.j() : this.Y(a);
    };
    M.prototype.Y = function(a) {
        try {
            if (a == this.g) a: {
                var w = P(this.g);
                var b = this.g.Ba();
                var O = this.g.Z();
                if (!(3 > w) && (3 != w || this.g && (this.h.h || this.g.oa() || Nb(this.g)))) {
                    this.J || 4 != w || 7 == b || (8 == b || 0 >= O ? J(3) : J(2));
                    Ob(this);
                    var c = this.g.Z();
                    this.X = c;
                    b: if (Pb(this)) {
                        var d = Nb(this.g);
                        a = "";
                        var e = d.length, f = 4 == P(this.g);
                        if (!this.h.i) {
                            if ("undefined" === typeof TextDecoder) {
                                Q(this);
                                Qb(this);
                                var g = "";
                                break b;
                            }
                            this.h.i = new k.TextDecoder;
                        }
                        for(b = 0; b < e; b++)this.h.h = !0, a += this.h.i.decode(d[b], {
                            stream: !(f && b == e - 1)
                        });
                        d.length = 0;
                        this.h.g += a;
                        this.C = 0;
                        g = this.h.g;
                    } else g = this.g.oa();
                    this.o = 200 == c;
                    xb(this.i, this.u, this.A, this.l, this.R, w, c);
                    if (this.o) {
                        if (this.T && !this.K) {
                            b: {
                                if (this.g) {
                                    var m, q = this.g;
                                    if ((m = q.g ? q.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !t(m)) {
                                        var l = m;
                                        break b;
                                    }
                                }
                                l = null;
                            }
                            if (c = l) L(this.i, this.l, c, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, Rb(this, c);
                            else {
                                this.o = !1;
                                this.s = 3;
                                K(12);
                                Q(this);
                                Qb(this);
                                break a;
                            }
                        }
                        if (this.P) {
                            c = !0;
                            var B;
                            for(; !this.J && this.C < g.length;)if (B = Sb(this, g), B == Gb) {
                                4 == w && (this.s = 4, K(14), c = !1);
                                L(this.i, this.l, null, "[Incomplete Response]");
                                break;
                            } else if (B == Fb) {
                                this.s = 4;
                                K(15);
                                L(this.i, this.l, g, "[Invalid Chunk]");
                                c = !1;
                                break;
                            } else L(this.i, this.l, B, null), Rb(this, B);
                            Pb(this) && 0 != this.C && (this.h.g = this.h.g.slice(this.C), this.C = 0);
                            4 != w || 0 != g.length || this.h.h || (this.s = 1, K(16), c = !1);
                            this.o = this.o && c;
                            if (!c) L(this.i, this.l, g, "[Invalid Chunked Response]"), Q(this), Qb(this);
                            else if (0 < g.length && !this.W) {
                                this.W = !0;
                                var v = this.j;
                                v.g == this && v.ba && !v.M && (v.j.info("Great, no buffering proxy detected. Bytes received: " + g.length), Tb(v), v.M = !0, K(11));
                            }
                        } else L(this.i, this.l, g, null), Rb(this, g);
                        4 == w && Q(this);
                        this.o && !this.J && (4 == w ? Ub(this.j, this) : (this.o = !1, Kb(this)));
                    } else Vb(this.g), 400 == c && 0 < g.indexOf("Unknown SID") ? (this.s = 3, K(12)) : (this.s = 0, K(13)), Q(this), Qb(this);
                }
            }
        } catch (w) {} finally{}
    };
    function Pb(a) {
        return a.g ? "GET" == a.u && 2 != a.L && a.j.Ca : !1;
    }
    function Sb(a, b) {
        var c = a.C, d = b.indexOf("\n", c);
        if (-1 == d) return Gb;
        c = Number(b.substring(c, d));
        if (isNaN(c)) return Fb;
        d += 1;
        if (d + c > b.length) return Gb;
        b = b.slice(d, d + c);
        a.C = d + c;
        return b;
    }
    M.prototype.cancel = function() {
        this.J = !0;
        Q(this);
    };
    function Kb(a) {
        a.S = Date.now() + a.I;
        Wb(a, a.I);
    }
    function Wb(a, b) {
        if (null != a.B) throw Error("WatchDog timer not null");
        a.B = ub(p(a.ba, a), b);
    }
    function Ob(a) {
        a.B && (k.clearTimeout(a.B), a.B = null);
    }
    M.prototype.ba = function() {
        this.B = null;
        var a = Date.now();
        0 <= a - this.S ? (zb(this.i, this.A), 2 != this.L && (J(), K(17)), Q(this), this.s = 2, Qb(this)) : Wb(this, this.S - a);
    };
    function Qb(a) {
        0 == a.j.G || a.J || Ub(a.j, a);
    }
    function Q(a) {
        Ob(a);
        var b = a.M;
        b && "function" == typeof b.ma && b.ma();
        a.M = null;
        gb(a.U);
        a.g && (b = a.g, a.g = null, b.abort(), b.ma());
    }
    function Rb(a, b) {
        try {
            var c = a.j;
            if (0 != c.G && (c.g == a || Xb(c.h, a))) {
                if (!a.K && Xb(c.h, a) && 3 == c.G) {
                    try {
                        var d = c.Da.g.parse(b);
                    } catch (l) {
                        d = null;
                    }
                    if (Array.isArray(d) && 3 == d.length) {
                        var e = d;
                        if (0 == e[0]) {
                            a: if (!c.u) {
                                if (c.g) {
                                    if (c.g.F + 3E3 < a.F) Yb(c), Zb(c);
                                    else break a;
                                }
                                $b(c);
                                K(18);
                            }
                        } else c.za = e[1], 0 < c.za - c.T && 37500 > e[2] && c.F && 0 == c.v && !c.C && (c.C = ub(p(c.Za, c), 6E3));
                        if (1 >= ac(c.h) && c.ca) {
                            try {
                                c.ca();
                            } catch (l) {}
                            c.ca = void 0;
                        }
                    } else R(c, 11);
                } else if ((a.K || c.g == a) && Yb(c), !t(b)) for(e = c.Da.g.parse(b), b = 0; b < e.length; b++){
                    var l = e[b];
                    c.T = l[0];
                    l = l[1];
                    if (2 == c.G) {
                        if ("c" == l[0]) {
                            c.K = l[1];
                            c.ia = l[2];
                            var v = l[3];
                            null != v && (c.la = v, c.j.info("VER=" + c.la));
                            var w = l[4];
                            null != w && (c.Aa = w, c.j.info("SVER=" + c.Aa));
                            var O = l[5];
                            null != O && "number" === typeof O && 0 < O && (d = 1.5 * O, c.L = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
                            d = c;
                            var B = a.g;
                            if (B) {
                                var ya = B.g ? B.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                if (ya) {
                                    var f = d.h;
                                    f.g || -1 == ya.indexOf("spdy") && -1 == ya.indexOf("quic") && -1 == ya.indexOf("h2") || (f.j = f.l, f.g = new Set, f.h && (bc(f, f.h), f.h = null));
                                }
                                if (d.D) {
                                    var db = B.g ? B.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                    db && (d.ya = db, S(d.I, d.D, db));
                                }
                            }
                            c.G = 3;
                            c.l && c.l.ua();
                            c.ba && (c.R = Date.now() - a.F, c.j.info("Handshake RTT: " + c.R + "ms"));
                            d = c;
                            var g = a;
                            d.qa = cc(d, d.J ? d.ia : null, d.W);
                            if (g.K) {
                                dc(d.h, g);
                                var m = g, q = d.L;
                                q && (m.I = q);
                                m.B && (Ob(m), Kb(m));
                                d.g = g;
                            } else ec(d);
                            0 < c.i.length && fc(c);
                        } else "stop" != l[0] && "close" != l[0] || R(c, 7);
                    } else 3 == c.G && ("stop" == l[0] || "close" == l[0] ? "stop" == l[0] ? R(c, 7) : gc(c) : "noop" != l[0] && c.l && c.l.ta(l), c.v = 0);
                }
            }
            J(4);
        } catch (l) {}
    }
    var hc = function hc(a, b) {
        "use strict";
        (0, $19mwo._)(this, hc);
        this.g = a;
        this.map = b;
    };
    function ic(a) {
        this.l = a || 10;
        k.PerformanceNavigationTiming ? (a = k.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!(k.chrome && k.chrome.loadTimes && k.chrome.loadTimes() && k.chrome.loadTimes().wasFetchedViaSpdy);
        this.j = a ? this.l : 1;
        this.g = null;
        1 < this.j && (this.g = new Set);
        this.h = null;
        this.i = [];
    }
    function jc(a) {
        return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
    }
    function ac(a) {
        return a.h ? 1 : a.g ? a.g.size : 0;
    }
    function Xb(a, b) {
        return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
    }
    function bc(a, b) {
        a.g ? a.g.add(b) : a.h = b;
    }
    function dc(a, b) {
        a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
    }
    ic.prototype.cancel = function() {
        this.i = kc(this);
        if (this.h) this.h.cancel(), this.h = null;
        else if (this.g && 0 !== this.g.size) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this.g.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var a = _step.value;
                    a.cancel();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            this.g.clear();
        }
    };
    function kc(a) {
        if (null != a.h) return a.i.concat(a.h.D);
        if (null != a.g && 0 !== a.g.size) {
            var b = a.i;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = a.g.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var c = _step.value;
                    b = b.concat(c.D);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return b;
        }
        return la(a.i);
    }
    function lc(a) {
        if (a.V && "function" == typeof a.V) return a.V();
        if ("undefined" !== typeof Map && a instanceof Map || "undefined" !== typeof Set && a instanceof Set) return Array.from(a.values());
        if ("string" === typeof a) return a.split("");
        if (ha(a)) {
            for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
            return b;
        }
        b = [];
        c = 0;
        for(d in a)b[c++] = a[d];
        return b;
    }
    function mc(a) {
        if (a.na && "function" == typeof a.na) return a.na();
        if (!a.V || "function" != typeof a.V) {
            if ("undefined" !== typeof Map && a instanceof Map) return Array.from(a.keys());
            if (!("undefined" !== typeof Set && a instanceof Set)) {
                if (ha(a) || "string" === typeof a) {
                    var b = [];
                    a = a.length;
                    for(var c = 0; c < a; c++)b.push(c);
                    return b;
                }
                b = [];
                c = 0;
                for(var d in a)b[c++] = d;
                return b;
            }
        }
    }
    function nc(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
        else if (ha(a) || "string" === typeof a) Array.prototype.forEach.call(a, b, void 0);
        else for(var c = mc(a), d = lc(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
    var oc = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
    function pc(a, b) {
        if (a) {
            a = a.split("&");
            for(var c = 0; c < a.length; c++){
                var d = a[c].indexOf("="), e = null;
                if (0 <= d) {
                    var f = a[c].substring(0, d);
                    e = a[c].substring(d + 1);
                } else f = a[c];
                b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
            }
        }
    }
    function T(a) {
        this.g = this.o = this.j = "";
        this.s = null;
        this.m = this.l = "";
        this.h = !1;
        if (a instanceof T) {
            this.h = a.h;
            qc(this, a.j);
            this.o = a.o;
            this.g = a.g;
            rc(this, a.s);
            this.l = a.l;
            var b = a.i;
            var c = new sc;
            c.i = b.i;
            b.g && (c.g = new Map(b.g), c.h = b.h);
            tc(this, c);
            this.m = a.m;
        } else a && (b = String(a).match(oc)) ? (this.h = !1, qc(this, b[1] || "", !0), this.o = uc(b[2] || ""), this.g = uc(b[3] || "", !0), rc(this, b[4]), this.l = uc(b[5] || "", !0), tc(this, b[6] || "", !0), this.m = uc(b[7] || "")) : (this.h = !1, this.i = new sc(null, this.h));
    }
    T.prototype.toString = function() {
        var a = [], b = this.j;
        b && a.push(vc(b, wc, !0), ":");
        var c = this.g;
        if (c || "file" == b) a.push("//"), (b = this.o) && a.push(vc(b, wc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.s, null != c && a.push(":", String(c));
        if (c = this.l) this.g && "/" != c.charAt(0) && a.push("/"), a.push(vc(c, "/" == c.charAt(0) ? xc : yc, !0));
        (c = this.i.toString()) && a.push("?", c);
        (c = this.m) && a.push("#", vc(c, zc));
        return a.join("");
    };
    function N(a) {
        return new T(a);
    }
    function qc(a, b, c) {
        a.j = c ? uc(b, !0) : b;
        a.j && (a.j = a.j.replace(/:$/, ""));
    }
    function rc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
            a.s = b;
        } else a.s = null;
    }
    function tc(a, b, c) {
        b instanceof sc ? (a.i = b, Ac(a.i, a.h)) : (c || (b = vc(b, Bc)), a.i = new sc(b, a.h));
    }
    function S(a, b, c) {
        a.i.set(b, c);
    }
    function Ib(a) {
        S(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
        return a;
    }
    function uc(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function vc(a, b, c) {
        return "string" === typeof a ? (a = encodeURI(a).replace(b, Cc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function Cc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var wc = /[#\/\?@]/g, yc = /[#\?:]/g, xc = /[#\?]/g, Bc = /[#\?@]/g, zc = /#/g;
    function sc(a, b) {
        this.h = this.g = null;
        this.i = a || null;
        this.j = !!b;
    }
    function U(a) {
        a.g || (a.g = new Map, a.h = 0, a.i && pc(a.i, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    h = sc.prototype;
    h.add = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        var c = this.g.get(a);
        c || this.g.set(a, c = []);
        c.push(b);
        this.h += 1;
        return this;
    };
    function Dc(a, b) {
        U(a);
        b = V(a, b);
        a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
    }
    function Ec(a, b) {
        U(a);
        b = V(a, b);
        return a.g.has(b);
    }
    h.forEach = function(a, b) {
        U(this);
        this.g.forEach(function(c, d) {
            c.forEach(function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    h.na = function() {
        U(this);
        var a = Array.from(this.g.values()), b = Array.from(this.g.keys()), c = [];
        for(var d = 0; d < b.length; d++){
            var e = a[d];
            for(var f = 0; f < e.length; f++)c.push(b[d]);
        }
        return c;
    };
    h.V = function(a) {
        U(this);
        var b = [];
        if ("string" === typeof a) Ec(this, a) && (b = b.concat(this.g.get(V(this, a))));
        else {
            a = Array.from(this.g.values());
            for(var c = 0; c < a.length; c++)b = b.concat(a[c]);
        }
        return b;
    };
    h.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        Ec(this, a) && (this.h -= this.g.get(a).length);
        this.g.set(a, [
            b
        ]);
        this.h += 1;
        return this;
    };
    h.get = function(a, b) {
        if (!a) return b;
        a = this.V(a);
        return 0 < a.length ? String(a[0]) : b;
    };
    function Lb(a, b, c) {
        Dc(a, b);
        0 < c.length && (a.i = null, a.g.set(V(a, b), la(c)), a.h += c.length);
    }
    h.toString = function() {
        if (this.i) return this.i;
        if (!this.g) return "";
        var a = [], b = Array.from(this.g.keys());
        for(var c = 0; c < b.length; c++){
            var d = b[c];
            var f = encodeURIComponent(String(d)), g = this.V(d);
            for(d = 0; d < g.length; d++){
                var e = f;
                "" !== g[d] && (e += "=" + encodeURIComponent(String(g[d])));
                a.push(e);
            }
        }
        return this.i = a.join("&");
    };
    function V(a, b) {
        b = String(b);
        a.j && (b = b.toLowerCase());
        return b;
    }
    function Ac(a, b) {
        b && !a.j && (U(a), a.i = null, a.g.forEach(function(c, d) {
            var e = d.toLowerCase();
            d != e && (Dc(this, d), Lb(this, e, c));
        }, a));
        a.j = b;
    }
    function Fc(a, b) {
        var c = new vb;
        if (k.Image) {
            var d = new Image;
            d.onload = ka(W, c, "TestLoadImage: loaded", !0, b, d);
            d.onerror = ka(W, c, "TestLoadImage: error", !1, b, d);
            d.onabort = ka(W, c, "TestLoadImage: abort", !1, b, d);
            d.ontimeout = ka(W, c, "TestLoadImage: timeout", !1, b, d);
            k.setTimeout(function() {
                if (d.ontimeout) d.ontimeout();
            }, 1E4);
            d.src = a;
        } else b(!1);
    }
    function Gc(a, b) {
        var c = new vb, d = new AbortController, e = setTimeout(function() {
            d.abort();
            W(c, "TestPingServer: timeout", !1, b);
        }, 1E4);
        fetch(a, {
            signal: d.signal
        }).then(function(f) {
            clearTimeout(e);
            f.ok ? W(c, "TestPingServer: ok", !0, b) : W(c, "TestPingServer: server error", !1, b);
        }).catch(function() {
            clearTimeout(e);
            W(c, "TestPingServer: error", !1, b);
        });
    }
    function W(a, b, c, d, e) {
        try {
            e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
        } catch (f) {}
    }
    function Hc() {
        this.g = new jb;
    }
    function Ic(a, b, c) {
        var d = c || "";
        try {
            nc(a, function(e, f) {
                var g = e;
                n(e) && (g = hb(e));
                b.push(d + f + "=" + encodeURIComponent(g));
            });
        } catch (e) {
            throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
        }
    }
    function Jc(a) {
        this.l = a.Ub || null;
        this.j = a.eb || !1;
    }
    r(Jc, kb);
    Jc.prototype.g = function() {
        return new Kc(this.l, this.j);
    };
    Jc.prototype.i = function(a) {
        return function() {
            return a;
        };
    }({});
    function Kc(a, b) {
        E.call(this);
        this.D = a;
        this.o = b;
        this.m = void 0;
        this.status = this.readyState = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.u = new Headers;
        this.h = null;
        this.B = "GET";
        this.A = "";
        this.g = !1;
        this.v = this.j = this.l = null;
    }
    r(Kc, E);
    h = Kc.prototype;
    h.open = function(a, b) {
        if (0 != this.readyState) throw this.abort(), Error("Error reopening a connection");
        this.B = a;
        this.A = b;
        this.readyState = 1;
        Lc(this);
    };
    h.send = function(a) {
        if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
        this.g = !0;
        var b = {
            headers: this.u,
            method: this.B,
            credentials: this.m,
            cache: void 0
        };
        a && (b.body = a);
        (this.D || k).fetch(new Request(this.A, b)).then(this.Sa.bind(this), this.ga.bind(this));
    };
    h.abort = function() {
        this.response = this.responseText = "";
        this.u = new Headers;
        this.status = 0;
        this.j && this.j.cancel("Request was aborted.").catch(function() {});
        1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, Mc(this));
        this.readyState = 0;
    };
    h.Sa = function(a) {
        if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Lc(this)), this.g && (this.readyState = 3, Lc(this), this.g))) {
            if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Qa.bind(this), this.ga.bind(this));
            else if ("undefined" !== typeof k.ReadableStream && "body" in a) {
                this.j = a.body.getReader();
                if (this.o) {
                    if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                    this.response = [];
                } else this.response = this.responseText = "", this.v = new TextDecoder;
                Nc(this);
            } else a.text().then(this.Ra.bind(this), this.ga.bind(this));
        }
    };
    function Nc(a) {
        a.j.read().then(a.Pa.bind(a)).catch(a.ga.bind(a));
    }
    h.Pa = function(a) {
        if (this.g) {
            if (this.o && a.value) this.response.push(a.value);
            else if (!this.o) {
                var b = a.value ? a.value : new Uint8Array(0);
                if (b = this.v.decode(b, {
                    stream: !a.done
                })) this.response = this.responseText += b;
            }
            a.done ? Mc(this) : Lc(this);
            3 == this.readyState && Nc(this);
        }
    };
    h.Ra = function(a) {
        this.g && (this.response = this.responseText = a, Mc(this));
    };
    h.Qa = function(a) {
        this.g && (this.response = a, Mc(this));
    };
    h.ga = function() {
        this.g && Mc(this);
    };
    function Mc(a) {
        a.readyState = 4;
        a.l = null;
        a.j = null;
        a.v = null;
        Lc(a);
    }
    h.setRequestHeader = function(a, b) {
        this.u.append(a, b);
    };
    h.getResponseHeader = function(a) {
        return this.h ? this.h.get(a.toLowerCase()) || "" : "";
    };
    h.getAllResponseHeaders = function() {
        if (!this.h) return "";
        var a = [], b = this.h.entries();
        for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Lc(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Kc.prototype, "withCredentials", {
        get: function get() {
            return "include" === this.m;
        },
        set: function set(a) {
            this.m = a ? "include" : "same-origin";
        }
    });
    function Oc(a) {
        var b = "";
        qa(a, function(c, d) {
            b += d;
            b += ":";
            b += c;
            b += "\r\n";
        });
        return b;
    }
    function Pc(a, b, c) {
        a: {
            for(d in c){
                var d = !1;
                break a;
            }
            d = !0;
        }
        d || (c = Oc(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : S(a, b, c));
    }
    function X(a) {
        E.call(this);
        this.headers = new Map;
        this.o = a || null;
        this.h = !1;
        this.v = this.g = null;
        this.D = "";
        this.m = 0;
        this.l = "";
        this.j = this.B = this.u = this.A = !1;
        this.I = null;
        this.H = "";
        this.J = !1;
    }
    r(X, E);
    var Qc = /^https?$/i, Rc = [
        "POST",
        "PUT"
    ];
    h = X.prototype;
    h.Ha = function(a) {
        this.J = a;
    };
    h.ea = function(a, b, c, d) {
        if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
        b = b ? b.toUpperCase() : "GET";
        this.D = a;
        this.l = "";
        this.m = 0;
        this.A = !1;
        this.h = !0;
        this.g = this.o ? this.o.g() : Cb.g();
        this.v = this.o ? lb(this.o) : lb(Cb);
        this.g.onreadystatechange = p(this.Ea, this);
        try {
            this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
        } catch (f) {
            Sc(this, f);
            return;
        }
        a = c || "";
        c = new Map(this.headers);
        if (d) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
            else if ("function" === typeof d.keys && "function" === typeof d.get) try {
                for(var _iterator = d.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$f = _step.value;
                    c.set(_$f, d.get(_$f));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else throw Error("Unknown input type for opt_headers: " + String(d));
        }
        d = Array.from(c.keys()).find(function(f) {
            return "content-type" == f.toLowerCase();
        });
        e = k.FormData && a instanceof k.FormData;
        !(0 <= Array.prototype.indexOf.call(Rc, b, void 0)) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = c[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value = (0, $2MTYX._)(_step1.value, 2), _$f1 = _step_value[0], g = _step_value[1];
                this.g.setRequestHeader(_$f1, g);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        this.H && (this.g.responseType = this.H);
        "withCredentials" in this.g && this.g.withCredentials !== this.J && (this.g.withCredentials = this.J);
        try {
            Tc(this), this.u = !0, this.g.send(a), this.u = !1;
        } catch (f) {
            Sc(this, f);
        }
    };
    function Sc(a, b) {
        a.h = !1;
        a.g && (a.j = !0, a.g.abort(), a.j = !1);
        a.l = b;
        a.m = 5;
        Uc(a);
        Vc(a);
    }
    function Uc(a) {
        a.A || (a.A = !0, F(a, "complete"), F(a, "error"));
    }
    h.abort = function(a) {
        this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.m = a || 7, F(this, "complete"), F(this, "abort"), Vc(this));
    };
    h.N = function() {
        this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Vc(this, !0));
        X.aa.N.call(this);
    };
    h.Ea = function() {
        this.s || (this.B || this.u || this.j ? Wc(this) : this.bb());
    };
    h.bb = function() {
        Wc(this);
    };
    function Wc(a) {
        if (a.h && "undefined" != typeof fa && (!a.v[1] || 4 != P(a) || 2 != a.Z())) {
            if (a.u && 4 == P(a)) bb(a.Ea, 0, a);
            else if (F(a, "readystatechange"), 4 == P(a)) {
                a.h = !1;
                try {
                    var g = a.Z();
                    a: switch(g){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var b = !0;
                            break a;
                        default:
                            b = !1;
                    }
                    var c;
                    if (!(c = b)) {
                        var d;
                        if (d = 0 === g) {
                            var e = String(a.D).match(oc)[1] || null;
                            !e && k.self && k.self.location && (e = k.self.location.protocol.slice(0, -1));
                            d = !Qc.test(e ? e.toLowerCase() : "");
                        }
                        c = d;
                    }
                    if (c) F(a, "complete"), F(a, "success");
                    else {
                        a.m = 6;
                        try {
                            var f = 2 < P(a) ? a.g.statusText : "";
                        } catch (m) {
                            f = "";
                        }
                        a.l = f + " [" + a.Z() + "]";
                        Uc(a);
                    }
                } finally{
                    Vc(a);
                }
            }
        }
    }
    function Vc(a, b) {
        if (a.g) {
            Tc(a);
            var c = a.g, d = a.v[0] ? function() {} : null;
            a.g = null;
            a.v = null;
            b || F(a, "ready");
            try {
                c.onreadystatechange = d;
            } catch (e) {}
        }
    }
    function Tc(a) {
        a.I && (k.clearTimeout(a.I), a.I = null);
    }
    h.isActive = function() {
        return !!this.g;
    };
    function P(a) {
        return a.g ? a.g.readyState : 0;
    }
    h.Z = function() {
        try {
            return 2 < P(this) ? this.g.status : -1;
        } catch (a) {
            return -1;
        }
    };
    h.oa = function() {
        try {
            return this.g ? this.g.responseText : "";
        } catch (a) {
            return "";
        }
    };
    h.Oa = function(a) {
        if (this.g) {
            var b = this.g.responseText;
            a && 0 == b.indexOf(a) && (b = b.substring(a.length));
            return ib(b);
        }
    };
    function Nb(a) {
        try {
            if (!a.g) return null;
            if ("response" in a.g) return a.g.response;
            switch(a.H){
                case "":
                case "text":
                    return a.g.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function Vb(a) {
        var b = {};
        a = (a.g && 2 <= P(a) ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
        for(var d = 0; d < a.length; d++){
            if (t(a[d])) continue;
            var c = va(a[d]);
            var e = c[0];
            c = c[1];
            if ("string" !== typeof c) continue;
            c = c.trim();
            var f = b[e] || [];
            b[e] = f;
            f.push(c);
        }
        ra(b, function(d) {
            return d.join(", ");
        });
    }
    h.Ba = function() {
        return this.m;
    };
    h.Ka = function() {
        return "string" === typeof this.l ? this.l : String(this.l);
    };
    function Xc(a, b, c) {
        return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
    }
    function Yc(a) {
        this.Aa = 0;
        this.i = [];
        this.j = new vb;
        this.ia = this.qa = this.I = this.W = this.g = this.ya = this.D = this.H = this.m = this.S = this.o = null;
        this.Ya = this.U = 0;
        this.Va = Xc("failFast", !1, a);
        this.F = this.C = this.u = this.s = this.l = null;
        this.X = !0;
        this.za = this.T = -1;
        this.Y = this.v = this.B = 0;
        this.Ta = Xc("baseRetryDelayMs", 5E3, a);
        this.cb = Xc("retryDelaySeedMs", 1E4, a);
        this.Wa = Xc("forwardChannelMaxRetries", 2, a);
        this.wa = Xc("forwardChannelRequestTimeoutMs", 2E4, a);
        this.pa = a && a.xmlHttpFactory || void 0;
        this.Xa = a && a.Tb || void 0;
        this.Ca = a && a.useFetchStreams || !1;
        this.L = void 0;
        this.J = a && a.supportsCrossDomainXhr || !1;
        this.K = "";
        this.h = new ic(a && a.concurrentRequestLimit);
        this.Da = new Hc;
        this.P = a && a.fastHandshake || !1;
        this.O = a && a.encodeInitMessageHeaders || !1;
        this.P && this.O && (this.O = !1);
        this.Ua = a && a.Rb || !1;
        a && a.xa && this.j.xa();
        a && a.forceLongPolling && (this.X = !1);
        this.ba = !this.P && this.X && a && a.detectBufferingProxy || !1;
        this.ja = void 0;
        a && a.longPollingTimeout && 0 < a.longPollingTimeout && (this.ja = a.longPollingTimeout);
        this.ca = void 0;
        this.R = 0;
        this.M = !1;
        this.ka = this.A = null;
    }
    h = Yc.prototype;
    h.la = 8;
    h.G = 1;
    h.connect = function(a, b, c, d) {
        K(0);
        this.W = a;
        this.H = b || {};
        c && void 0 !== d && (this.H.OSID = c, this.H.OAID = d);
        this.F = this.X;
        this.I = cc(this, null, this.W);
        fc(this);
    };
    function gc(a) {
        Zc(a);
        if (3 == a.G) {
            var b = a.U++, c = N(a.I);
            S(c, "SID", a.K);
            S(c, "RID", b);
            S(c, "TYPE", "terminate");
            $c(a, c);
            b = new M(a, a.j, b);
            b.L = 2;
            b.v = Ib(N(c));
            c = !1;
            if (k.navigator && k.navigator.sendBeacon) try {
                c = k.navigator.sendBeacon(b.v.toString(), "");
            } catch (d) {}
            !c && k.Image && ((new Image).src = b.v, c = !0);
            c || (b.g = Mb(b.j, null), b.g.ea(b.v));
            b.F = Date.now();
            Kb(b);
        }
        ad(a);
    }
    function Zb(a) {
        a.g && (Tb(a), a.g.cancel(), a.g = null);
    }
    function Zc(a) {
        Zb(a);
        a.u && (k.clearTimeout(a.u), a.u = null);
        Yb(a);
        a.h.cancel();
        a.s && ("number" === typeof a.s && k.clearTimeout(a.s), a.s = null);
    }
    function fc(a) {
        if (!jc(a.h) && !a.s) {
            a.s = !0;
            var b = a.Ga;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.B = 0;
        }
    }
    function bd(a, b) {
        if (ac(a.h) >= a.h.j - (a.s ? 1 : 0)) return !1;
        if (a.s) return a.i = b.D.concat(a.i), !0;
        if (1 == a.G || 2 == a.G || a.B >= (a.Va ? 0 : a.Wa)) return !1;
        a.s = ub(p(a.Ga, a, b), cd(a, a.B));
        a.B++;
        return !0;
    }
    h.Ga = function(a) {
        if (this.s) {
            if (this.s = null, 1 == this.G) {
                if (!a) {
                    this.U = Math.floor(1E5 * Math.random());
                    a = this.U++;
                    var e = new M(this, this.j, a);
                    var f = this.o;
                    this.S && (f ? (f = sa(f), ua(f, this.S)) : f = this.S);
                    null !== this.m || this.O || (e.H = f, f = null);
                    if (this.P) a: {
                        var b = 0;
                        for(var c = 0; c < this.i.length; c++){
                            b: {
                                var d = this.i[c];
                                if ("__data__" in d.map && (d = d.map.__data__, "string" === typeof d)) {
                                    d = d.length;
                                    break b;
                                }
                                d = void 0;
                            }
                            if (void 0 === d) break;
                            b += d;
                            if (4096 < b) {
                                b = c;
                                break a;
                            }
                            if (4096 === b || c === this.i.length - 1) {
                                b = c + 1;
                                break a;
                            }
                        }
                        b = 1E3;
                    }
                    else b = 1E3;
                    b = dd(this, e, b);
                    c = N(this.I);
                    S(c, "RID", a);
                    S(c, "CVER", 22);
                    this.D && S(c, "X-HTTP-Session-Id", this.D);
                    $c(this, c);
                    f && (this.O ? b = "headers=" + encodeURIComponent(String(Oc(f))) + "&" + b : this.m && Pc(c, this.m, f));
                    bc(this.h, e);
                    this.Ua && S(c, "TYPE", "init");
                    this.P ? (S(c, "$req", b), S(c, "SID", "null"), e.T = !0, Hb(e, c, null)) : Hb(e, c, b);
                    this.G = 2;
                }
            } else 3 == this.G && (a ? ed(this, a) : 0 == this.i.length || jc(this.h) || ed(this));
        }
    };
    function ed(a, b) {
        var c;
        b ? c = b.l : c = a.U++;
        var d = N(a.I);
        S(d, "SID", a.K);
        S(d, "RID", c);
        S(d, "AID", a.T);
        $c(a, d);
        a.m && a.o && Pc(d, a.m, a.o);
        c = new M(a, a.j, c, a.B + 1);
        null === a.m && (c.H = a.o);
        b && (a.i = b.D.concat(a.i));
        b = dd(a, c, 1E3);
        c.I = Math.round(.5 * a.wa) + Math.round(.5 * a.wa * Math.random());
        bc(a.h, c);
        Hb(c, d, b);
    }
    function $c(a, b) {
        a.H && qa(a.H, function(c, d) {
            S(b, d, c);
        });
        a.l && nc({}, function(c, d) {
            S(b, d, c);
        });
    }
    function dd(a, b, c) {
        c = Math.min(a.i.length, c);
        var d = a.l ? p(a.l.Na, a.l, a) : null;
        a: {
            var e = a.i;
            var f = -1;
            for(;;){
                var g = [
                    "count=" + c
                ];
                -1 == f ? 0 < c ? (f = e[0].g, g.push("ofs=" + f)) : f = 0 : g.push("ofs=" + f);
                var m = !0;
                for(var q = 0; q < c; q++){
                    var l = e[q].g;
                    var v = e[q].map;
                    l -= f;
                    if (0 > l) f = Math.max(0, e[q].g - 100), m = !1;
                    else try {
                        Ic(v, g, "req" + l + "_");
                    } catch (w) {
                        d && d(v);
                    }
                }
                if (m) {
                    d = g.join("&");
                    break a;
                }
            }
        }
        a = a.i.splice(0, c);
        b.D = a;
        return d;
    }
    function ec(a) {
        if (!a.g && !a.u) {
            a.Y = 1;
            var b = a.Fa;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.v = 0;
        }
    }
    function $b(a) {
        if (a.g || a.u || 3 <= a.v) return !1;
        a.Y++;
        a.u = ub(p(a.Fa, a), cd(a, a.v));
        a.v++;
        return !0;
    }
    h.Fa = function() {
        this.u = null;
        fd(this);
        if (this.ba && !(this.M || null == this.g || 0 >= this.R)) {
            var a = 2 * this.R;
            this.j.info("BP detection timer enabled: " + a);
            this.A = ub(p(this.ab, this), a);
        }
    };
    h.ab = function() {
        this.A && (this.A = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.M = !0, K(10), Zb(this), fd(this));
    };
    function Tb(a) {
        null != a.A && (k.clearTimeout(a.A), a.A = null);
    }
    function fd(a) {
        a.g = new M(a, a.j, "rpc", a.Y);
        null === a.m && (a.g.H = a.o);
        a.g.O = 0;
        var b = N(a.qa);
        S(b, "RID", "rpc");
        S(b, "SID", a.K);
        S(b, "AID", a.T);
        S(b, "CI", a.F ? "0" : "1");
        !a.F && a.ja && S(b, "TO", a.ja);
        S(b, "TYPE", "xmlhttp");
        $c(a, b);
        a.m && a.o && Pc(b, a.m, a.o);
        a.L && (a.g.I = a.L);
        var c = a.g;
        a = a.ia;
        c.L = 1;
        c.v = Ib(N(b));
        c.m = null;
        c.P = !0;
        Jb(c, a);
    }
    h.Za = function() {
        null != this.C && (this.C = null, Zb(this), $b(this), K(19));
    };
    function Yb(a) {
        null != a.C && (k.clearTimeout(a.C), a.C = null);
    }
    function Ub(a, b) {
        var c = null;
        if (a.g == b) {
            Yb(a);
            Tb(a);
            a.g = null;
            var d = 2;
        } else if (Xb(a.h, b)) c = b.D, dc(a.h, b), d = 1;
        else return;
        if (0 != a.G) {
            if (b.o) {
                if (1 == d) {
                    c = b.m ? b.m.length : 0;
                    b = Date.now() - b.F;
                    var e = a.B;
                    d = qb();
                    F(d, new tb(d, c));
                    fc(a);
                } else ec(a);
            } else if (e = b.s, 3 == e || 0 == e && 0 < b.X || !(1 == d && bd(a, b) || 2 == d && $b(a))) switch(c && 0 < c.length && (b = a.h, b.i = b.i.concat(c)), e){
                case 1:
                    R(a, 5);
                    break;
                case 4:
                    R(a, 10);
                    break;
                case 3:
                    R(a, 6);
                    break;
                default:
                    R(a, 2);
            }
        }
    }
    function cd(a, b) {
        var c = a.Ta + Math.floor(Math.random() * a.cb);
        a.isActive() || (c *= 2);
        return c * b;
    }
    function R(a, b) {
        a.j.info("Error code " + b);
        if (2 == b) {
            var c = p(a.fb, a), d = a.Xa;
            var e = !d;
            d = new T(d || "//www.google.com/images/cleardot.gif");
            k.location && "http" == k.location.protocol || qc(d, "https");
            Ib(d);
            e ? Fc(d.toString(), c) : Gc(d.toString(), c);
        } else K(2);
        a.G = 0;
        a.l && a.l.sa(b);
        ad(a);
        Zc(a);
    }
    h.fb = function(a) {
        a ? (this.j.info("Successfully pinged google.com"), K(2)) : (this.j.info("Failed to ping google.com"), K(1));
    };
    function ad(a) {
        a.G = 0;
        a.ka = [];
        if (a.l) {
            var b = kc(a.h);
            if (0 != b.length || 0 != a.i.length) ma(a.ka, b), ma(a.ka, a.i), a.h.i.length = 0, la(a.i), a.i.length = 0;
            a.l.ra();
        }
    }
    function cc(a, b, c) {
        var d = c instanceof T ? N(c) : new T(c);
        if ("" != d.g) b && (d.g = b + "." + d.g), rc(d, d.s);
        else {
            var e = k.location;
            d = e.protocol;
            b = b ? b + "." + e.hostname : e.hostname;
            e = +e.port;
            var f = new T(null);
            d && qc(f, d);
            b && (f.g = b);
            e && rc(f, e);
            c && (f.l = c);
            d = f;
        }
        c = a.D;
        b = a.ya;
        c && b && S(d, c, b);
        S(d, "VER", a.la);
        $c(a, d);
        return d;
    }
    function Mb(a, b, c) {
        if (b && !a.J) throw Error("Can't create secondary domain capable XhrIo object.");
        b = a.Ca && !a.pa ? new X(new Jc({
            eb: c
        })) : new X(a.pa);
        b.Ha(a.J);
        return b;
    }
    h.isActive = function() {
        return !!this.l && this.l.isActive(this);
    };
    function gd() {}
    h = gd.prototype;
    h.ua = function() {};
    h.ta = function() {};
    h.sa = function() {};
    h.ra = function() {};
    h.isActive = function() {
        return !0;
    };
    h.Na = function() {};
    function hd() {}
    hd.prototype.g = function(a, b) {
        return new Y(a, b);
    };
    function Y(a, b) {
        E.call(this);
        this.g = new Yc(b);
        this.l = a;
        this.h = b && b.messageUrlParams || null;
        a = b && b.messageHeaders || null;
        b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
            "X-Client-Protocol": "webchannel"
        });
        this.g.o = a;
        a = b && b.initMessageHeaders || null;
        b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
            "X-WebChannel-Content-Type": b.messageContentType
        });
        b && b.va && (a ? a["X-WebChannel-Client-Profile"] = b.va : a = {
            "X-WebChannel-Client-Profile": b.va
        });
        this.g.S = a;
        (a = b && b.Sb) && !t(a) && (this.g.m = a);
        this.v = b && b.supportsCrossDomainXhr || !1;
        this.u = b && b.sendRawJson || !1;
        (b = b && b.httpSessionIdParam) && !t(b) && (this.g.D = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
        this.j = new Z(this);
    }
    r(Y, E);
    Y.prototype.m = function() {
        this.g.l = this.j;
        this.v && (this.g.J = !0);
        this.g.connect(this.l, this.h || void 0);
    };
    Y.prototype.close = function() {
        gc(this.g);
    };
    Y.prototype.o = function(a) {
        var b = this.g;
        if ("string" === typeof a) {
            var c = {};
            c.__data__ = a;
            a = c;
        } else this.u && (c = {}, c.__data__ = hb(a), a = c);
        b.i.push(new hc(b.Ya++, a));
        3 == b.G && fc(b);
    };
    Y.prototype.N = function() {
        this.g.l = null;
        delete this.j;
        gc(this.g);
        delete this.g;
        Y.aa.N.call(this);
    };
    function id(a) {
        nb.call(this);
        a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
        var b = a.__sm__;
        if (b) {
            a: {
                for(var c in b){
                    a = c;
                    break a;
                }
                a = void 0;
            }
            if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
            this.data = b;
        } else this.data = a;
    }
    r(id, nb);
    function jd() {
        ob.call(this);
        this.status = 1;
    }
    r(jd, ob);
    function Z(a) {
        this.g = a;
    }
    r(Z, gd);
    Z.prototype.ua = function() {
        F(this.g, "a");
    };
    Z.prototype.ta = function(a) {
        F(this.g, new id(a));
    };
    Z.prototype.sa = function(a) {
        F(this.g, new jd());
    };
    Z.prototype.ra = function() {
        F(this.g, "b");
    };
    hd.prototype.createWebChannel = hd.prototype.g;
    Y.prototype.send = Y.prototype.o;
    Y.prototype.open = Y.prototype.m;
    Y.prototype.close = Y.prototype.close;
    $1e46bd7fb4109e0c$export$66869136fc133c3a = $1e46bd7fb4109e0c$export$2e2bcd8739ae039.createWebChannelTransport = function createWebChannelTransport() {
        return new hd;
    };
    $1e46bd7fb4109e0c$export$888d0d9ab79d08fc = $1e46bd7fb4109e0c$export$2e2bcd8739ae039.getStatEventTarget = function getStatEventTarget() {
        return qb();
    };
    $1e46bd7fb4109e0c$export$d61e24a684f9e51 = $1e46bd7fb4109e0c$export$2e2bcd8739ae039.Event = I;
    $1e46bd7fb4109e0c$export$cbbc350c1dfc80cb = $1e46bd7fb4109e0c$export$2e2bcd8739ae039.Stat = {
        mb: 0,
        pb: 1,
        qb: 2,
        Jb: 3,
        Ob: 4,
        Lb: 5,
        Mb: 6,
        Kb: 7,
        Ib: 8,
        Nb: 9,
        PROXY: 10,
        NOPROXY: 11,
        Gb: 12,
        Cb: 13,
        Db: 14,
        Bb: 15,
        Eb: 16,
        Fb: 17,
        ib: 18,
        hb: 19,
        jb: 20
    };
    Ab.NO_ERROR = 0;
    Ab.TIMEOUT = 8;
    Ab.HTTP_ERROR = 6;
    $1e46bd7fb4109e0c$export$d4e71bc0b80dc0fb = $1e46bd7fb4109e0c$export$2e2bcd8739ae039.ErrorCode = Ab;
    Bb.COMPLETE = "complete";
    $1e46bd7fb4109e0c$export$3d7865934588d77e = $1e46bd7fb4109e0c$export$2e2bcd8739ae039.EventType = Bb;
    mb.EventType = H;
    H.OPEN = "a";
    H.CLOSE = "b";
    H.ERROR = "c";
    H.MESSAGE = "d";
    E.prototype.listen = E.prototype.K;
    $1e46bd7fb4109e0c$export$aa726fb96ad3e039 = $1e46bd7fb4109e0c$export$2e2bcd8739ae039.WebChannel = mb;
    $1e46bd7fb4109e0c$export$ddb1030448106742 = $1e46bd7fb4109e0c$export$2e2bcd8739ae039.FetchXmlHttpFactory = Jc;
    X.prototype.listenOnce = X.prototype.L;
    X.prototype.getLastError = X.prototype.Ka;
    X.prototype.getLastErrorCode = X.prototype.Ba;
    X.prototype.getStatus = X.prototype.Z;
    X.prototype.getResponseJson = X.prototype.Oa;
    X.prototype.getResponseText = X.prototype.oa;
    X.prototype.send = X.prototype.ea;
    X.prototype.setWithCredentials = X.prototype.Ha;
    $1e46bd7fb4109e0c$export$26404658cda3ee02 = $1e46bd7fb4109e0c$export$2e2bcd8739ae039.XhrIo = X;
}).apply(typeof $1e46bd7fb4109e0c$var$commonjsGlobal !== "undefined" ? $1e46bd7fb4109e0c$var$commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});

});

parcelRegister("9iKK3", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $6c5a0d6caccac2f9$export$a143d493d941bafc; }, function (v) { return $6c5a0d6caccac2f9$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $6c5a0d6caccac2f9$export$f99ded8fe4b79145; }, function (v) { return $6c5a0d6caccac2f9$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $15Pju = parcelRequire("15Pju");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $gnDeW = parcelRequire("gnDeW");

var $k1NN5 = parcelRequire("k1NN5");
var $6c5a0d6caccac2f9$export$a143d493d941bafc;
var $6c5a0d6caccac2f9$export$e4cf37d7f6fb9e0a;
var $6c5a0d6caccac2f9$export$f99ded8fe4b79145;
var $6c5a0d6caccac2f9$export$599f31c3813fae4d;
"use strict";

var $cOFqU = parcelRequire("cOFqU");

var $lqFFf = parcelRequire("lqFFf");
var $6c5a0d6caccac2f9$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$6c5a0d6caccac2f9$export$a143d493d941bafc = $6c5a0d6caccac2f9$var$Buffer;
$6c5a0d6caccac2f9$export$e4cf37d7f6fb9e0a = $6c5a0d6caccac2f9$var$SlowBuffer;
$6c5a0d6caccac2f9$export$f99ded8fe4b79145 = 50;
var $6c5a0d6caccac2f9$var$K_MAX_LENGTH = 0x7fffffff;
$6c5a0d6caccac2f9$export$599f31c3813fae4d = $6c5a0d6caccac2f9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $6c5a0d6caccac2f9$var$Buffer.TYPED_ARRAY_SUPPORT = $6c5a0d6caccac2f9$var$typedArraySupport();
if (!$6c5a0d6caccac2f9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $6c5a0d6caccac2f9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($6c5a0d6caccac2f9$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function get() {
        if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($6c5a0d6caccac2f9$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function get() {
        if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $6c5a0d6caccac2f9$var$createBuffer(length) {
    if (length > $6c5a0d6caccac2f9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $6c5a0d6caccac2f9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $6c5a0d6caccac2f9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $6c5a0d6caccac2f9$var$allocUnsafe(arg);
    }
    return $6c5a0d6caccac2f9$var$from(arg, encodingOrOffset, length);
}
$6c5a0d6caccac2f9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $6c5a0d6caccac2f9$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $6c5a0d6caccac2f9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $6c5a0d6caccac2f9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value)));
    if ($6c5a0d6caccac2f9$var$isInstance(value, ArrayBuffer) || value && $6c5a0d6caccac2f9$var$isInstance(value.buffer, ArrayBuffer)) return $6c5a0d6caccac2f9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($6c5a0d6caccac2f9$var$isInstance(value, SharedArrayBuffer) || value && $6c5a0d6caccac2f9$var$isInstance(value.buffer, SharedArrayBuffer))) return $6c5a0d6caccac2f9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $6c5a0d6caccac2f9$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $6c5a0d6caccac2f9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $6c5a0d6caccac2f9$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $6c5a0d6caccac2f9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $6c5a0d6caccac2f9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($6c5a0d6caccac2f9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($6c5a0d6caccac2f9$var$Buffer, Uint8Array);
function $6c5a0d6caccac2f9$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $6c5a0d6caccac2f9$var$alloc(size, fill, encoding) {
    $6c5a0d6caccac2f9$var$assertSize(size);
    if (size <= 0) return $6c5a0d6caccac2f9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $6c5a0d6caccac2f9$var$createBuffer(size).fill(fill, encoding) : $6c5a0d6caccac2f9$var$createBuffer(size).fill(fill);
    return $6c5a0d6caccac2f9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $6c5a0d6caccac2f9$var$Buffer.alloc = function(size, fill, encoding) {
    return $6c5a0d6caccac2f9$var$alloc(size, fill, encoding);
};
function $6c5a0d6caccac2f9$var$allocUnsafe(size) {
    $6c5a0d6caccac2f9$var$assertSize(size);
    return $6c5a0d6caccac2f9$var$createBuffer(size < 0 ? 0 : $6c5a0d6caccac2f9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $6c5a0d6caccac2f9$var$Buffer.allocUnsafe = function(size) {
    return $6c5a0d6caccac2f9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $6c5a0d6caccac2f9$var$Buffer.allocUnsafeSlow = function(size) {
    return $6c5a0d6caccac2f9$var$allocUnsafe(size);
};
function $6c5a0d6caccac2f9$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$6c5a0d6caccac2f9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $6c5a0d6caccac2f9$var$byteLength(string, encoding) | 0;
    var buf = $6c5a0d6caccac2f9$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $6c5a0d6caccac2f9$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $6c5a0d6caccac2f9$var$checked(array.length) | 0;
    var buf = $6c5a0d6caccac2f9$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $6c5a0d6caccac2f9$var$fromArrayView(arrayView) {
    if ($6c5a0d6caccac2f9$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $6c5a0d6caccac2f9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $6c5a0d6caccac2f9$var$fromArrayLike(arrayView);
}
function $6c5a0d6caccac2f9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $6c5a0d6caccac2f9$var$Buffer.prototype);
    return buf;
}
function $6c5a0d6caccac2f9$var$fromObject(obj) {
    if ($6c5a0d6caccac2f9$var$Buffer.isBuffer(obj)) {
        var len = $6c5a0d6caccac2f9$var$checked(obj.length) | 0;
        var buf = $6c5a0d6caccac2f9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $6c5a0d6caccac2f9$var$numberIsNaN(obj.length)) return $6c5a0d6caccac2f9$var$createBuffer(0);
        return $6c5a0d6caccac2f9$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $6c5a0d6caccac2f9$var$fromArrayLike(obj.data);
}
function $6c5a0d6caccac2f9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $6c5a0d6caccac2f9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $6c5a0d6caccac2f9$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $6c5a0d6caccac2f9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $6c5a0d6caccac2f9$var$Buffer.alloc(+length);
}
$6c5a0d6caccac2f9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $6c5a0d6caccac2f9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$6c5a0d6caccac2f9$var$Buffer.compare = function compare(a, b) {
    if ($6c5a0d6caccac2f9$var$isInstance(a, Uint8Array)) a = $6c5a0d6caccac2f9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($6c5a0d6caccac2f9$var$isInstance(b, Uint8Array)) b = $6c5a0d6caccac2f9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(a) || !$6c5a0d6caccac2f9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$6c5a0d6caccac2f9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$6c5a0d6caccac2f9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $6c5a0d6caccac2f9$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $6c5a0d6caccac2f9$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($6c5a0d6caccac2f9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(buf)) buf = $6c5a0d6caccac2f9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $6c5a0d6caccac2f9$var$byteLength(string, encoding) {
    if ($6c5a0d6caccac2f9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $6c5a0d6caccac2f9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $gnDeW._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $6c5a0d6caccac2f9$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $6c5a0d6caccac2f9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $6c5a0d6caccac2f9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$6c5a0d6caccac2f9$var$Buffer.byteLength = $6c5a0d6caccac2f9$var$byteLength;
function $6c5a0d6caccac2f9$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $6c5a0d6caccac2f9$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $6c5a0d6caccac2f9$var$utf8Slice(this, start, end);
        case "ascii":
            return $6c5a0d6caccac2f9$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $6c5a0d6caccac2f9$var$latin1Slice(this, start, end);
        case "base64":
            return $6c5a0d6caccac2f9$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $6c5a0d6caccac2f9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$6c5a0d6caccac2f9$var$Buffer.prototype._isBuffer = true;
function $6c5a0d6caccac2f9$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$6c5a0d6caccac2f9$var$swap(this, i, i + 1);
    return this;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $6c5a0d6caccac2f9$var$swap(this, i, i + 3);
        $6c5a0d6caccac2f9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $6c5a0d6caccac2f9$var$swap(this, i, i + 7);
        $6c5a0d6caccac2f9$var$swap(this, i + 1, i + 6);
        $6c5a0d6caccac2f9$var$swap(this, i + 2, i + 5);
        $6c5a0d6caccac2f9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $6c5a0d6caccac2f9$var$utf8Slice(this, 0, length);
    return $6c5a0d6caccac2f9$var$slowToString.apply(this, arguments);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.toLocaleString = $6c5a0d6caccac2f9$var$Buffer.prototype.toString;
$6c5a0d6caccac2f9$var$Buffer.prototype.equals = function equals(b) {
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $6c5a0d6caccac2f9$var$Buffer.compare(this, b) === 0;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $6c5a0d6caccac2f9$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($6c5a0d6caccac2f9$var$customInspectSymbol) $6c5a0d6caccac2f9$var$Buffer.prototype[$6c5a0d6caccac2f9$var$customInspectSymbol] = $6c5a0d6caccac2f9$var$Buffer.prototype.inspect;
$6c5a0d6caccac2f9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($6c5a0d6caccac2f9$var$isInstance(target, Uint8Array)) target = $6c5a0d6caccac2f9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $gnDeW._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $6c5a0d6caccac2f9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($6c5a0d6caccac2f9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $6c5a0d6caccac2f9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($6c5a0d6caccac2f9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $6c5a0d6caccac2f9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $6c5a0d6caccac2f9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $6c5a0d6caccac2f9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $6c5a0d6caccac2f9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $6c5a0d6caccac2f9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $6c5a0d6caccac2f9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($6c5a0d6caccac2f9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $6c5a0d6caccac2f9$var$utf8Write(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $6c5a0d6caccac2f9$var$asciiWrite(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$asciiToBytes(string), buf, offset, length);
}
function $6c5a0d6caccac2f9$var$base64Write(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$base64ToBytes(string), buf, offset, length);
}
function $6c5a0d6caccac2f9$var$ucs2Write(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$6c5a0d6caccac2f9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $6c5a0d6caccac2f9$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $6c5a0d6caccac2f9$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $6c5a0d6caccac2f9$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $6c5a0d6caccac2f9$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $6c5a0d6caccac2f9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$6c5a0d6caccac2f9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $6c5a0d6caccac2f9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $cOFqU.fromByteArray(buf);
    else return $cOFqU.fromByteArray(buf.slice(start, end));
}
function $6c5a0d6caccac2f9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $6c5a0d6caccac2f9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $6c5a0d6caccac2f9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $6c5a0d6caccac2f9$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $6c5a0d6caccac2f9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $6c5a0d6caccac2f9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $6c5a0d6caccac2f9$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $6c5a0d6caccac2f9$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $6c5a0d6caccac2f9$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $6c5a0d6caccac2f9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $6c5a0d6caccac2f9$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $6c5a0d6caccac2f9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $6c5a0d6caccac2f9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$6c5a0d6caccac2f9$var$Buffer.prototype.readUintLE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUintBE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint8 = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint16LE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint16BE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint32LE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint32BE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigUInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigUInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return $lqFFf.read(this, offset, true, 23, 4);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return $lqFFf.read(this, offset, false, 23, 4);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 8, this.length);
    return $lqFFf.read(this, offset, true, 52, 8);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 8, this.length);
    return $lqFFf.read(this, offset, false, 52, 8);
};
function $6c5a0d6caccac2f9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUintLE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUintBE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint8 = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint16LE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint16BE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint32LE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint32BE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $6c5a0d6caccac2f9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $6c5a0d6caccac2f9$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $6c5a0d6caccac2f9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $6c5a0d6caccac2f9$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigUInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigUInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $6c5a0d6caccac2f9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $6c5a0d6caccac2f9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $lqFFf.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeFloat(this, value, offset, true, noAssert);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeFloat(this, value, offset, false, noAssert);
};
function $6c5a0d6caccac2f9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $lqFFf.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeDouble(this, value, offset, true, noAssert);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$6c5a0d6caccac2f9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$6c5a0d6caccac2f9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$6c5a0d6caccac2f9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $6c5a0d6caccac2f9$var$Buffer.isBuffer(val) ? val : $6c5a0d6caccac2f9$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $6c5a0d6caccac2f9$var$errors = {};
function $6c5a0d6caccac2f9$var$E(sym, getMessage, Base) {
    $6c5a0d6caccac2f9$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $iNfU4._)(NodeError, Base);
        var _super = (0, $k1NN5._)(NodeError);
        function NodeError() {
            (0, $19mwo._)(this, NodeError);
            var _this;
            _this = _super.call(this);
            Object.defineProperty((0, $15Pju._)(_this), "message", {
                value: getMessage.apply((0, $15Pju._)(_this), arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $6rpfc._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, "code", {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$6c5a0d6caccac2f9$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$6c5a0d6caccac2f9$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $gnDeW._)(actual));
}, TypeError);
$6c5a0d6caccac2f9$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $6c5a0d6caccac2f9$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $gnDeW._)(input)) === "bigint") {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $6c5a0d6caccac2f9$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $6c5a0d6caccac2f9$var$addNumericalSeparator(val) {
    var res = "";
    var i = val.length;
    var start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $6c5a0d6caccac2f9$var$checkBounds(buf, offset, byteLength) {
    $6c5a0d6caccac2f9$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $6c5a0d6caccac2f9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $gnDeW._)(min)) === "bigint" ? "n" : "";
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $6c5a0d6caccac2f9$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $6c5a0d6caccac2f9$var$checkBounds(buf, offset, byteLength);
}
function $6c5a0d6caccac2f9$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $6c5a0d6caccac2f9$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $6c5a0d6caccac2f9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $6c5a0d6caccac2f9$var$validateNumber(value, type);
        throw new $6c5a0d6caccac2f9$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $6c5a0d6caccac2f9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $6c5a0d6caccac2f9$var$errors.ERR_OUT_OF_RANGE(type || "offset", ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $6c5a0d6caccac2f9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $6c5a0d6caccac2f9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($6c5a0d6caccac2f9$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $6c5a0d6caccac2f9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $6c5a0d6caccac2f9$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $6c5a0d6caccac2f9$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $6c5a0d6caccac2f9$var$base64ToBytes(str) {
    return $cOFqU.toByteArray($6c5a0d6caccac2f9$var$base64clean(str));
}
function $6c5a0d6caccac2f9$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $6c5a0d6caccac2f9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $6c5a0d6caccac2f9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $6c5a0d6caccac2f9$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $6c5a0d6caccac2f9$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $6c5a0d6caccac2f9$var$BufferBigIntNotDefined : fn;
}
function $6c5a0d6caccac2f9$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("cOFqU", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $954a4b447490bcaa$export$d622b2ad8d90c771; }, function (v) { return $954a4b447490bcaa$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $954a4b447490bcaa$export$6100ba28696e12de; }, function (v) { return $954a4b447490bcaa$export$6100ba28696e12de = v; });
var $954a4b447490bcaa$export$a48f0734ac7c2329;
var $954a4b447490bcaa$export$d622b2ad8d90c771;
var $954a4b447490bcaa$export$6100ba28696e12de;
"use strict";
$954a4b447490bcaa$export$a48f0734ac7c2329 = $954a4b447490bcaa$var$byteLength;
$954a4b447490bcaa$export$d622b2ad8d90c771 = $954a4b447490bcaa$var$toByteArray;
$954a4b447490bcaa$export$6100ba28696e12de = $954a4b447490bcaa$var$fromByteArray;
var $954a4b447490bcaa$var$lookup = [];
var $954a4b447490bcaa$var$revLookup = [];
var $954a4b447490bcaa$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $954a4b447490bcaa$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $954a4b447490bcaa$var$i = 0, $954a4b447490bcaa$var$len = $954a4b447490bcaa$var$code.length; $954a4b447490bcaa$var$i < $954a4b447490bcaa$var$len; ++$954a4b447490bcaa$var$i){
    $954a4b447490bcaa$var$lookup[$954a4b447490bcaa$var$i] = $954a4b447490bcaa$var$code[$954a4b447490bcaa$var$i];
    $954a4b447490bcaa$var$revLookup[$954a4b447490bcaa$var$code.charCodeAt($954a4b447490bcaa$var$i)] = $954a4b447490bcaa$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$954a4b447490bcaa$var$revLookup["-".charCodeAt(0)] = 62;
$954a4b447490bcaa$var$revLookup["_".charCodeAt(0)] = 63;
function $954a4b447490bcaa$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $954a4b447490bcaa$var$byteLength(b64) {
    var lens = $954a4b447490bcaa$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $954a4b447490bcaa$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $954a4b447490bcaa$var$toByteArray(b64) {
    var tmp;
    var lens = $954a4b447490bcaa$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $954a4b447490bcaa$var$Arr($954a4b447490bcaa$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i)] << 18 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i)] << 2 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i)] << 10 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $954a4b447490bcaa$var$tripletToBase64(num) {
    return $954a4b447490bcaa$var$lookup[num >> 18 & 0x3F] + $954a4b447490bcaa$var$lookup[num >> 12 & 0x3F] + $954a4b447490bcaa$var$lookup[num >> 6 & 0x3F] + $954a4b447490bcaa$var$lookup[num & 0x3F];
}
function $954a4b447490bcaa$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($954a4b447490bcaa$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $954a4b447490bcaa$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($954a4b447490bcaa$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($954a4b447490bcaa$var$lookup[tmp >> 2] + $954a4b447490bcaa$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($954a4b447490bcaa$var$lookup[tmp >> 10] + $954a4b447490bcaa$var$lookup[tmp >> 4 & 0x3F] + $954a4b447490bcaa$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("lqFFf", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $f99c5859a5f73a56$export$aafa59e2e03f2942; }, function (v) { return $f99c5859a5f73a56$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $f99c5859a5f73a56$export$68d8715fc104d294; }, function (v) { return $f99c5859a5f73a56$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $f99c5859a5f73a56$export$aafa59e2e03f2942;
var $f99c5859a5f73a56$export$68d8715fc104d294;
$f99c5859a5f73a56$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$f99c5859a5f73a56$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("dKdZ4", function(module, exports) {

var $gnDeW = parcelRequire("gnDeW");
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined1;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined1) result = result === undefined1 ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined1 : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, _$Function = context.Function, Math = context.Math, _$Object = context.Object, _$RegExp = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = _$Function.prototype, objectProto = _$Object.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(_$Object);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = _$RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined1, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined1, getPrototype = overArg(_$Object.getPrototypeOf, _$Object), objectCreate = _$Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined1, symIterator = Symbol ? Symbol.iterator : undefined1, symToStringTag = Symbol ? Symbol.toStringTag : undefined1;
        var defineProperty = function() {
            try {
                var func = getNative(_$Object, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = _$Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(_$Object.keys, _$Object), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(_$Object, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined1, symbolToString = symbolProto ? symbolProto.toString : undefined1;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var _$result = new object;
                object.prototype = undefined1;
                return _$result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined1;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var _$result = new LazyWrapper(this.__wrapped__);
            _$result.__actions__ = copyArray(this.__actions__);
            _$result.__dir__ = this.__dir__;
            _$result.__filtered__ = this.__filtered__;
            _$result.__iteratees__ = copyArray(this.__iteratees__);
            _$result.__takeCount__ = this.__takeCount__;
            _$result.__views__ = copyArray(this.__views__);
            return _$result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var _$result = new LazyWrapper(this);
                _$result.__dir__ = -1;
                _$result.__filtered__ = true;
            } else {
                _$result = this.clone();
                _$result.__dir__ *= -1;
            }
            return _$result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var _$result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], _$iteratee = data.iteratee, type = data.type, computed = _$iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                _$result[resIndex++] = value;
            }
            return _$result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var _$result = this.has(key) && delete this.__data__[key];
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var _$result = data[key];
                return _$result === HASH_UNDEFINED ? undefined1 : _$result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined1;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined1 : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined1 ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined1 : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var _$result = getMapData(this, key)["delete"](key);
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), _$size = data.size;
            data.set(key, value);
            this.size += data.size == _$size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, _$result = data["delete"](key);
            this.size = data.size;
            return _$result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, _$result = skipIndexes ? baseTimes(value.length, String) : [], length = _$result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) _$result.push(key);
            return _$result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined1;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined1 && !eq(object[key], value) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, _$result = Array1(length), skip = object == null;
            while(++index < length)_$result[index] = skip ? undefined1 : get(object, paths[index]);
            return _$result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined1) number = number <= upper ? number : upper;
                if (lower !== undefined1) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var _$result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) _$result = object ? customizer(value, key, object, stack) : customizer(value);
            if (_$result !== undefined1) return _$result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                _$result = initCloneArray(value);
                if (!isDeep) return copyArray(value, _$result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    _$result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(_$result, value)) : copySymbols(value, baseAssign(_$result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    _$result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, _$result);
            if (isSet(value)) value.forEach(function(subValue) {
                _$result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                _$result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined1 : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(_$result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return _$result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = _$Object(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined1 && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined1, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, isCommon = true, length = array.length, _$result = [], valuesLength = values.length;
            if (!length) return _$result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                _$includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                _$includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    _$result.push(value);
                } else if (!_$includes(values, computed, comparator)) _$result.push(value);
            }
            return _$result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var _$result = true;
            baseEach(collection, function(value, index, collection) {
                _$result = !!predicate(value, index, collection);
                return _$result;
            });
            return _$result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined1 ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, _$result = value;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined1 || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var _$result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) _$result.push(value);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined1;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var _$result = keysFunc(object);
            return isArray(object) ? _$result : arrayPush(_$result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined1 ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in _$Object(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in _$Object(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var _$includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, _$result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined1;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && _$result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : _$includes(_$result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : _$includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined1 : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = _$Object(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined1 && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var _$result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(_$result === undefined1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : _$result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var _$result = [];
            for(var key in _$Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), _$result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                _$result[++index] = iteratee(value, key, collection);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined1;
                    if (newValue === undefined1) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined1;
            var isCommon = newValue === undefined1;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined1;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var _$result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(_$result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, _$result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(_$result, castPath(path, object), value);
            }
            return _$result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var _$indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = _$indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), _$result = Array1(length);
            while(length--){
                _$result[fromRight ? length : ++index] = start;
                start += step;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var _$result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return _$result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) _$result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return _$result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined1;
                    if (newValue === undefined1) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function baseSetData(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function baseSetToString(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var _$result = Array1(length);
            while(++index < length)_$result[index] = array[index + start];
            return _$result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var _$result;
            baseEach(collection, function(value, index, collection) {
                _$result = predicate(value, index, collection);
                return !_$result;
            });
            return !!_$result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined1;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    _$result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var _$result = value + "";
            return _$result == "0" && 1 / value == -INFINITY ? "-0" : _$result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, length = array.length, isCommon = true, _$result = [], seen = _$result;
            if (comparator) {
                isCommon = false;
                _$includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var _$set = iteratee ? null : createSet(array);
                if (_$set) return setToArray(_$set);
                isCommon = false;
                _$includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : _$result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    _$result.push(value);
                } else if (!_$includes(seen, computed, comparator)) {
                    if (seen !== _$result) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var _$result = value;
            if (_$result instanceof LazyWrapper) _$result = _$result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, _$result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, _$result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) _$result[index] = baseDifference(_$result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(_$result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, _$result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined1;
                assignFunc(_$result, props[index], value);
            }
            return _$result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined1 ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, _$result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(_$result);
            return _$result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var _$result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(_$result).set(new Uint8Array(arrayBuffer));
            return _$result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var _$result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            _$result.lastIndex = regexp.lastIndex;
            return _$result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? _$Object(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var _$result = compareAscending(objCriteria[index], othCriteria[index]);
                if (_$result) {
                    if (index >= ordersLength) return _$result;
                    var order = orders[index];
                    return _$result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)_$result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)_$result[leftIndex++] = args[argsIndex++];
            return _$result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)_$result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)_$result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[offset + holders[holdersIndex]] = args[argsIndex++];
            return _$result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined1;
                if (newValue === undefined1) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined1, guard = length > 2 ? sources[2] : undefined1;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined1;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined1 : customizer;
                    length = 1;
                }
                object = _$Object(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = _$Object(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = _$Object(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined1;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), _$result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(_$result) ? _$result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined1, args, holders, undefined1, undefined1, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = _$Object(collection);
                if (!isArrayLike(collection)) {
                    var _$iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function predicate(key) {
                        return _$iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[_$iteratee ? collection[index] : index] : undefined1;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined1;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, _$result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)_$result = funcs[index].call(this, _$result);
                    return _$result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined1 : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var _$result;
                if (value === undefined1 && other === undefined1) return defaultValue;
                if (value !== undefined1) _$result = value;
                if (other !== undefined1) {
                    if (_$result === undefined1) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    _$result = operator(value, other);
                }
                return _$result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined1 ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var _$result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(_$result), 0, length).join("") : _$result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined1;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined1) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined1 ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined1, newHoldersRight = isCurry ? undefined1 : holders, newPartials = isCurry ? partials : undefined1, newPartialsRight = isCurry ? undefined1 : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var _$result = wrapFunc.apply(undefined1, newData);
            if (isLaziable(func)) setData(_$result, newData);
            _$result.placeholder = placeholder;
            return setWrapToString(_$result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function createSet(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined1;
            }
            ary = ary === undefined1 ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined1 ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined1;
            }
            var data = isBindKey ? undefined1 : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var _$result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) _$result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) _$result = createPartial(func, bitmask, thisArg, partials);
            else _$result = createHybrid.apply(undefined1, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(_$result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined1, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined1 : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, _$result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined1;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined1) {
                    if (compared) continue;
                    _$result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        _$result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    _$result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return _$result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var _$result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return _$result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var _$result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    _$result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (_$result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) _$result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return _$result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined1, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function getData(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var _$result = func.name + "", array = realNames[_$result], length = hasOwnProperty.call(realNames, _$result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return _$result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var _$result = lodash.iteratee || iteratee;
            _$result = _$result === iteratee ? baseIteratee : _$result;
            return arguments.length ? _$result(arguments[0], arguments[1]) : _$result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var _$result = keys(object), length = _$result.length;
            while(length--){
                var key = _$result[length], value = object[key];
                _$result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return _$result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined1;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined1;
                var unmasked = true;
            } catch (e) {}
            var _$result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return _$result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function getSymbols(object) {
            if (object == null) return [];
            object = _$Object(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function getSymbolsIn(object) {
            var _$result = [];
            while(object){
                arrayPush(_$result, getSymbols(object));
                object = getPrototype(object);
            }
            return _$result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
            var _$result = baseGetTag(value), Ctor = _$result == objectTag ? value.constructor : undefined1, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return _$result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], _$size = data.size;
                switch(data.type){
                    case "drop":
                        start += _$size;
                        break;
                    case "dropRight":
                        end -= _$size;
                        break;
                    case "take":
                        end = nativeMin(end, start + _$size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - _$size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, _$result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(_$result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (_$result || ++index != length) return _$result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, _$result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                _$result.index = array.index;
                _$result.input = array.input;
            }
            return _$result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value);
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index === "undefined" ? "undefined" : (0, $gnDeW._)(index);
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value);
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in _$Object(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value);
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined1 || key in _$Object(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var _$result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = _$result.cache;
            return _$result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var _$result = [];
            if (object != null) for(var key in _$Object(object))_$result.push(key);
            return _$result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined1 ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined1;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined1, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined1 ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var _$result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) _$result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                _$result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return _$result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var _$result = value + "";
            return _$result == "0" && 1 / value == -INFINITY ? "-0" : _$result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var _$result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            _$result.__actions__ = copyArray(wrapper.__actions__);
            _$result.__index__ = wrapper.__index__;
            _$result.__values__ = wrapper.__values__;
            return _$result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined1) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, _$result = Array1(nativeCeil(length / size));
            while(index < length)_$result[resIndex++] = baseSlice(array, index, index += size);
            return _$result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index];
                if (value) _$result[resIndex++] = value;
            }
            return _$result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var _$iteratee = last(values);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined1, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, _$result = {};
            while(++index < length){
                var pair = pairs[index];
                _$result[pair[0]] = pair[1];
            }
            return _$result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined1;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (_$iteratee === last(mapped)) _$iteratee = undefined1;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined1, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined1;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined1;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined1, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, _$result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return _$result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var _$result = [];
            if (!(array && array.length)) return _$result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    _$result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return _$result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined1 ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined1, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return array && array.length ? baseUniq(array, undefined1, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var _$result = unzip(array);
            if (iteratee == null) return _$result;
            return arrayMap(_$result, function(group) {
                return apply(iteratee, undefined1, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined1, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, _$iteratee = length > 1 ? arrays[length - 1] : undefined1;
            _$iteratee = typeof _$iteratee == "function" ? (arrays.pop(), _$iteratee) : undefined1;
            return unzipWith(arrays, _$iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var _$result = lodash(value);
            _$result.__chain__ = true;
            return _$result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function interceptor(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined1
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined1);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined1) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined1 : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var _$result, parent = this;
            while(parent instanceof baseLodash){
                var _$clone = wrapperClone(parent);
                _$clone.__index__ = 0;
                _$clone.__values__ = undefined1;
                if (_$result) previous.__wrapped__ = _$clone;
                else _$result = _$clone;
                var previous = _$clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return _$result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined1
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                _$result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return _$result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined1 : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined1 : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined1, undefined1, undefined1, undefined1, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var _$result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) _$result = func.apply(this, arguments);
                if (n <= 1) func = undefined1;
                return _$result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curry.placeholder;
            return _$result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curryRight.placeholder;
            return _$result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, _$result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined1;
                lastInvokeTime = time;
                _$result = func.apply(thisArg, args);
                return _$result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : _$result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined1;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined1;
                return _$result;
            }
            function cancel() {
                if (timerId !== undefined1) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined1;
            }
            function flush() {
                return timerId === undefined1 ? _$result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined1) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined1) timerId = setTimeout(timerExpired, wait);
                return _$result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function memoized1() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var _$result = func.apply(this, args);
                memoized.cache = cache.set(key, _$result) || cache;
                return _$result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined1, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined1, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined1, undefined1, undefined1, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined1 ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function isArguments(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            var _$result = customizer ? customizer(value, other) : undefined1;
            return _$result === undefined1 ? baseIsEqual(value, other, undefined1, customizer) : !!_$result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value);
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return (typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value)) == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined1;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var _$result = toFinite(value), remainder = _$result % 1;
            return _$result === _$result ? remainder ? _$result - remainder : _$result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var _$result = baseCreate(prototype);
            return properties == null ? _$result : baseAssign(_$result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = _$Object(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined1;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined1, customDefaultsMerge);
            return apply(mergeWith, undefined1, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var _$result = object == null ? undefined1 : baseGet(object, path);
            return _$result === undefined1 ? defaultValue : _$result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, iteratee(value, key, object), value);
            });
            return _$result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, key, iteratee(value, key, object));
            });
            return _$result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var _$result = {};
            if (object == null) return _$result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), _$result);
            if (isDeep) _$result = baseClone(_$result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(_$result, paths[length]);
            return _$result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined1;
            }
            while(++index < length){
                var value = object == null ? undefined1 : object[toKey(path[index])];
                if (value === undefined1) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined1) {
                upper = lower;
                lower = undefined1;
            }
            if (upper !== undefined1) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined1) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined1) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined1;
            if (floating === undefined1) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined1;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined1;
                }
            }
            if (lower === undefined1 && upper === undefined1) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined1) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined1 ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined1;
            limit = limit === undefined1 ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined1;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = _$RegExp((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var _$result = attempt(function() {
                return _$Function(importsKeys, sourceURL + "return " + source).apply(undefined1, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            _$result.source = source;
            if (isError(_$result)) throw _$result;
            return _$result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var _$result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined1) return _$result + omission;
            if (strSymbols) end += _$result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = _$result;
                    if (!separator.global) separator = _$RegExp(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    _$result = _$result.slice(0, newEnd === undefined1 ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = _$result.lastIndexOf(separator);
                if (index > -1) _$result = _$result.slice(0, index);
            }
            return _$result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined1 : pattern;
            if (pattern === undefined1) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined1, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var _$chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (_$chain || chainAll) {
                        var _$result = object(this.__wrapped__), actions = _$result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        _$result.__chain__ = chainAll;
                        return _$result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined1 : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var _$result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return _$result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined1;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined1;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined1;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined1;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined1 ? 1 : nativeMax(toInteger(n), 0);
                var _$result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (_$result.__filtered__) _$result.__takeCount__ = nativeMin(n, _$result.__takeCount__);
                else _$result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (_$result.__dir__ < 0 ? "Right" : "")
                });
                return _$result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var _$result = this.clone();
                _$result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                _$result.__filtered__ = _$result.__filtered__ || isFilter;
                return _$result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var _$result = this;
            if (_$result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(_$result);
            if (start < 0) _$result = _$result.takeRight(-start);
            else if (start) _$result = _$result.drop(start);
            if (end !== undefined1) {
                end = toInteger(end);
                _$result = end < 0 ? _$result.dropRight(-end) : _$result.take(end - start);
            }
            return _$result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, _$iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function interceptor(value) {
                    var _$result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? _$result[0] : _$result;
                };
                if (useLazy && checkIteratee && typeof _$iteratee == "function" && _$iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var _$result = func.apply(value, args);
                    _$result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined1
                    });
                    return new LodashWrapper(_$result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                _$result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? _$result.value()[0] : _$result.value() : _$result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined1, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined1
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(undefined);

});

parcelRegister("7PvJn", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

var $gnDeW = parcelRequire("gnDeW");
(function(global, factory) {
    module.exports = factory();
})(undefined, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function some(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function keys(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function func() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var _$format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (_$format || !formatUpper) return _$format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var _$format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(_$format) ? _$format(output) : _$format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function func(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function indexOf(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, _$locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                _$locale = loadLocale(split.slice(0, j).join("-"));
                if (_$locale) return _$locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var _$locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    _$locale = loadLocale(config.parentLocale);
                    if (_$locale != null) parentConfig = _$locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var _$locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                _$locale = new Locale(config);
                _$locale.parentLocale = locales[name];
                locales[name] = _$locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var _$locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            _$locale = loadLocale(key);
            if (_$locale) return _$locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, _$format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || _$format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(_$format)) configFromStringAndArray(config);
        else if (_$format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function now() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, _$weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + _$weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var _$offset = this.utcOffset(), sign = "+";
            if (_$offset < 0) {
                _$offset = -_$offset;
                sign = "-";
            }
            return sign + zeroFill(~~(_$offset / 60), 2) + separator + zeroFill(~~_$offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, _$diff;
        if (model._isUTC) {
            res = model.clone();
            _$diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + _$diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var _$offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (_$offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - _$offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? _$offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var _$diff = myMoment.diff(now, "days", true);
        return _$diff < -6 ? "sameElse" : _$diff < -1 ? "lastWeek" : _$diff < 0 ? "lastDay" : _$diff < 1 ? "sameDay" : _$diff < 2 ? "nextDay" : _$diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), _$format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[_$format]) ? formats[_$format].call(this, now) : formats[_$format]);
        return this.format(output || this.localeData().calendar(_$format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch((0, $gnDeW._)(eras[i].since)){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch((0, $gnDeW._)(eras[i].until)){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var _$locale = getLocale(), utc = createUTC().set(setter, index);
        return _$locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var _$locale = getLocale(), shift = localeSorted ? _$locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), _$weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || _$weeks <= 1 && [
            "w"
        ] || _$weeks < thresholds.w && [
            "ww",
            _$weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, _$locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        _$locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, _$locale);
        if (withSuffix) output = _$locale.pastFuture(+this, output);
        return _$locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("hpryi", function(module, exports) {

$parcel$export(module.exports, "HTTPClient", function () { return $cbd22d3323bef9ca$export$45cf759b359d3d24; });

var $15Pju = parcelRequire("15Pju");

var $9OZ9j = parcelRequire("9OZ9j");

var $27QSE = parcelRequire("27QSE");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $jLCbM = parcelRequire("jLCbM");

var $laF8D = parcelRequire("laF8D");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $e2m1c = parcelRequire("e2m1c");

var $etlBe = parcelRequire("etlBe");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");

var $aU3XG = parcelRequire("aU3XG");

var $e5wYp = parcelRequire("e5wYp");
var /**
 * @see {@link https://github.com/mo/abortcontroller-polyfill/issues/70}
 */ _AbortSignal_prototype, /**
 * @see {@link https://github.com/mo/abortcontroller-polyfill/issues/73#issuecomment-2085543258}
 */ _AbortSignal;
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $eef213ff4197108b$exports = {};
$parcel$export($eef213ff4197108b$exports, "Stack", function() {
    return $eef213ff4197108b$export$694e0d28c7ffc90c;
});
var _Array_prototype = Array.prototype, $eef213ff4197108b$var$push = _Array_prototype.push;
var $eef213ff4197108b$export$694e0d28c7ffc90c = /*#__PURE__*/ function() {
    "use strict";
    function $eef213ff4197108b$export$694e0d28c7ffc90c() {
        (0, $19mwo._)(this, $eef213ff4197108b$export$694e0d28c7ffc90c);
        this.length = 0;
    }
    (0, $6rpfc._)($eef213ff4197108b$export$694e0d28c7ffc90c, [
        {
            key: "use",
            value: function use() {
                for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
                    middlewares[_key] = arguments[_key];
                }
                $eef213ff4197108b$var$push.apply(this, middlewares);
                return this;
            }
        },
        {
            key: "execute",
            value: function execute(context) {
                var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var middleware = this[depth];
                if (middleware instanceof Function) return middleware(context, this.execute.bind(this, context, ++depth));
            }
        },
        {
            key: "mount",
            value: function mount(condition, stack) {
                return this.use(function(context, next) {
                    return condition(context) ? stack.execute(context) : next();
                });
            }
        }
    ]);
    return $eef213ff4197108b$export$694e0d28c7ffc90c;
}();
var $0fe1f1400993ba8a$exports = {};
$parcel$export($0fe1f1400993ba8a$exports, "BodyRequestMethods", function() {
    return $0fe1f1400993ba8a$export$4125cfe7e08e2040;
});
$parcel$export($0fe1f1400993ba8a$exports, "HTTPError", function() {
    return $0fe1f1400993ba8a$export$aa9d629c530f62a7;
});
$parcel$export($0fe1f1400993ba8a$exports, "headerParser", function() {
    return $0fe1f1400993ba8a$export$b725a69477e4d33f;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseHeaders", function() {
    return $0fe1f1400993ba8a$export$eea2c1c5e1a37e50;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseBody", function() {
    return $0fe1f1400993ba8a$export$3b629cd0ff482602;
});
$parcel$export($0fe1f1400993ba8a$exports, "requestXHR", function() {
    return $0fe1f1400993ba8a$export$4f2a8c8c11a6373a;
});
$parcel$export($0fe1f1400993ba8a$exports, "requestFetch", function() {
    return $0fe1f1400993ba8a$export$bda27a3e49197b9;
});
$parcel$export($0fe1f1400993ba8a$exports, "request", function() {
    return $0fe1f1400993ba8a$export$b5fe3f66a567bec0;
});
var $22de11b45b0eeb97$exports = {};
$parcel$export($22de11b45b0eeb97$exports, "parseDocument", function() {
    return $22de11b45b0eeb97$export$b6a9369736b19f4d;
});
$parcel$export($22de11b45b0eeb97$exports, "makeFormData", function() {
    return $22de11b45b0eeb97$export$2c28ab2e118e73f1;
});
$parcel$export($22de11b45b0eeb97$exports, "serializeNode", function() {
    return $22de11b45b0eeb97$export$a0beee2e55fb5dd1;
});
$parcel$export($22de11b45b0eeb97$exports, "serialize", function() {
    return $22de11b45b0eeb97$export$dfdc1655ccc5b9cb;
});
$parcel$export($22de11b45b0eeb97$exports, "readAs", function() {
    return $22de11b45b0eeb97$export$e209cbb66c5b18c;
});
$parcel$export($22de11b45b0eeb97$exports, "encodeBase64", function() {
    return $22de11b45b0eeb97$export$8fb536984ec8b4d7;
});
(_AbortSignal_prototype = AbortSignal.prototype).throwIfAborted || (_AbortSignal_prototype.throwIfAborted = function() {
    var _this = this, aborted = _this.aborted, tmp = _this.reason, reason = tmp === void 0 ? "Aborted" : tmp;
    if (!aborted) return;
    throw reason instanceof DOMException ? reason : new DOMException(reason instanceof Error ? reason.message : reason + "", "AbortError");
});
(_AbortSignal = AbortSignal).any || (_AbortSignal.any = function(iterable) {
    var controller = new AbortController();
    function abort() {
        controller.abort(this.reason);
        clean();
    }
    function clean() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var signal = _step.value;
                signal.removeEventListener("abort", abort);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var signal = _step.value;
            if (signal.aborted) {
                controller.abort(signal.reason);
                break;
            } else signal.addEventListener("abort", abort);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return controller.signal;
});
function $22de11b45b0eeb97$export$b6a9369736b19f4d(text) {
    return _$22de11b45b0eeb97$export$b6a9369736b19f4d.apply(this, arguments);
}
function _$22de11b45b0eeb97$export$b6a9369736b19f4d() {
    _$22de11b45b0eeb97$export$b6a9369736b19f4d = (0, $9OZ9j._)(function(text) {
        var contentType, _ref, type;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            contentType = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "";
            _ref = (0, $2MTYX._)((contentType === null || contentType === void 0 ? void 0 : contentType.split(";")) || [], 1), type = _ref[0];
            return [
                2,
                new DOMParser().parseFromString(text, type || "text/html")
            ];
        });
    });
    return _$22de11b45b0eeb97$export$b6a9369736b19f4d.apply(this, arguments);
}
function $22de11b45b0eeb97$export$2c28ab2e118e73f1(data) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2MTYX._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            var list = typeof value !== "string" && (0, $e5wYp.likeArray)(value) ? value : [
                value
            ];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Array.from(list)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var item = _step1.value;
                    if (item != null) {
                        if (typeof item === "object") formData.append(key, item, item.name);
                        else formData.append(key, item);
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $22de11b45b0eeb97$export$a0beee2e55fb5dd1(root) {
    var contentType;
    if (!(root instanceof HTMLFormElement)) return {
        contentType: root instanceof SVGElement ? "image/svg" : root instanceof HTMLDocument || root instanceof HTMLElement ? "text/html" : "application/xml",
        data: (0, $e5wYp.stringifyDOM)(root)
    };
    if (root.querySelector('input[type="file"][name]')) return {
        contentType: "multipart/form-data",
        data: new FormData(root)
    };
    var data = (0, $e5wYp.formToJSON)(root);
    switch(contentType = root.enctype){
        case "text/plain":
            return {
                contentType: contentType,
                data: Object.entries(data).map(function(param) {
                    var _param = (0, $2MTYX._)(param, 2), name = _param[0], value = _param[1];
                    return "".concat(name, "=").concat(value);
                }).join("\n")
            };
        case "application/x-www-form-urlencoded":
            return {
                contentType: contentType,
                data: new URLSearchParams(data) + ""
            };
        default:
            return {
                contentType: "application/json",
                data: JSON.stringify(data)
            };
    }
}
function $22de11b45b0eeb97$export$dfdc1655ccc5b9cb(data, contentType) {
    var _ref = (0, $2MTYX._)((contentType === null || contentType === void 0 ? void 0 : contentType.split(";")) || [], 1), type = _ref[0];
    switch(type){
        case "application/x-www-form-urlencoded":
            return {
                contentType: contentType,
                data: new URLSearchParams(data)
            };
        case "multipart/form-data":
            return {
                data: $22de11b45b0eeb97$export$2c28ab2e118e73f1(data)
            };
        case "application/json":
            return {
                contentType: contentType,
                data: JSON.stringify(data)
            };
        case "text/html":
        case "application/xml":
        case "image/svg":
            return {
                contentType: contentType,
                data: (0, $e5wYp.stringifyDOM)(data)
            };
    }
    if (type) return {
        data: data,
        contentType: contentType
    };
    try {
        if (data instanceof URLSearchParams) return {
            contentType: "application/x-www-form-urlencoded",
            data: data
        };
    } catch (e) {}
    try {
        if (data instanceof FormData) return {
            data: data
        };
    } catch (e) {}
    try {
        if (data instanceof Node) return $22de11b45b0eeb97$export$a0beee2e55fb5dd1(data);
    } catch (e) {}
    try {
        if ((0, $e5wYp.isTypedArray)(data) || data instanceof ArrayBuffer || data instanceof DataView || data instanceof Blob || data instanceof ReadableStream) return {
            contentType: "application/octet-stream",
            data: data
        };
    } catch (e) {}
    try {
        return {
            contentType: "application/json",
            data: JSON.stringify(data)
        };
    } catch (e) {}
    throw new Error("Unserialized Object needs a specific Content-Type");
}
var $22de11b45b0eeb97$var$FileMethod;
(function(FileMethod) {
    FileMethod["text"] = "readAsText";
    FileMethod["dataURL"] = "readAsDataURL";
    FileMethod["binaryString"] = "readAsBinaryString";
    FileMethod["arrayBuffer"] = "readAsArrayBuffer";
})($22de11b45b0eeb97$var$FileMethod || ($22de11b45b0eeb97$var$FileMethod = {}));
function $22de11b45b0eeb97$export$e209cbb66c5b18c(file, method, encoding) {
    var reader = new FileReader();
    return {
        progress: (0, $aU3XG.Observable).fromEvent(reader, "progress"),
        result: new Promise(function(resolve, reject) {
            reader.onerror = reject;
            reader.onload = function() {
                return resolve(reader.result);
            };
            reader[$22de11b45b0eeb97$var$FileMethod[method]](file, encoding);
        })
    };
}
var $22de11b45b0eeb97$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
var $22de11b45b0eeb97$export$8fb536984ec8b4d7 = function() {
    var _ref = (0, $9OZ9j._)(function(raw) {
        var _tmp, _;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(raw instanceof Blob)) return [
                        3,
                        2
                    ];
                    _ = $22de11b45b0eeb97$var$DataURI.exec;
                    return [
                        4,
                        $22de11b45b0eeb97$export$e209cbb66c5b18c(raw, "text").result
                    ];
                case 1:
                    _tmp = (_.apply($22de11b45b0eeb97$var$DataURI, [
                        _state.sent()
                    ]) || "")[4];
                    return [
                        3,
                        3
                    ];
                case 2:
                    _tmp = btoa(encodeURIComponent(raw).replace(/%([0-9A-F]{2})/g, function(_, p1) {
                        return String.fromCharCode(+("0x" + p1));
                    }));
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        _tmp
                    ];
            }
        });
    });
    return function $22de11b45b0eeb97$export$8fb536984ec8b4d7(raw) {
        return _ref.apply(this, arguments);
    };
}();
var $0fe1f1400993ba8a$export$4125cfe7e08e2040;
(function(BodyRequestMethods) {
    BodyRequestMethods["POST"] = "POST";
    BodyRequestMethods["PUT"] = "PUT";
    BodyRequestMethods["PATCH"] = "PATCH";
    BodyRequestMethods["DELETE"] = "DELETE";
})($0fe1f1400993ba8a$export$4125cfe7e08e2040 || ($0fe1f1400993ba8a$export$4125cfe7e08e2040 = {}));
var $0fe1f1400993ba8a$export$aa9d629c530f62a7 = /*#__PURE__*/ function(URIError1) {
    "use strict";
    (0, $iNfU4._)($0fe1f1400993ba8a$export$aa9d629c530f62a7, URIError1);
    var _super = (0, $k1NN5._)($0fe1f1400993ba8a$export$aa9d629c530f62a7);
    function $0fe1f1400993ba8a$export$aa9d629c530f62a7(message, response) {
        (0, $19mwo._)(this, $0fe1f1400993ba8a$export$aa9d629c530f62a7);
        var _this;
        _this = _super.call(this, message);
        Object.assign((0, $15Pju._)(_this), response);
        return _this;
    }
    return $0fe1f1400993ba8a$export$aa9d629c530f62a7;
}((0, $etlBe._)(URIError));
var $0fe1f1400993ba8a$export$b725a69477e4d33f = {
    Link: function(value) {
        return Object.fromEntries(Array.from(value.matchAll(/<(\S+?)>; rel="(\w+)"(?:; title="(.*?)")?/g), function(param) {
            var _param = (0, $2MTYX._)(param, 4), _ = _param[0], URI = _param[1], rel = _param[2], title = _param[3];
            return [
                rel,
                {
                    rel: rel,
                    URI: URI,
                    title: title
                }
            ];
        }));
    }
};
var $0fe1f1400993ba8a$export$eea2c1c5e1a37e50 = function(raw) {
    return Object.fromEntries(Array.from(raw.trim().matchAll(/^([\w-]+):\s*(.*)/gm), function(param) {
        var _param = (0, $2MTYX._)(param, 3), _ = _param[0], key = _param[1], value = _param[2];
        var _$0fe1f1400993ba8a$export$b725a69477e4d33f_key;
        key = key.replace(/(^[a-z]|-[a-z])/g, function(char) {
            return char.toUpperCase();
        });
        var _$0fe1f1400993ba8a$export$b725a69477e4d33f_key1;
        return [
            key,
            (_$0fe1f1400993ba8a$export$b725a69477e4d33f_key1 = (_$0fe1f1400993ba8a$export$b725a69477e4d33f_key = $0fe1f1400993ba8a$export$b725a69477e4d33f[key]) === null || _$0fe1f1400993ba8a$export$b725a69477e4d33f_key === void 0 ? void 0 : _$0fe1f1400993ba8a$export$b725a69477e4d33f_key.call($0fe1f1400993ba8a$export$b725a69477e4d33f, value)) !== null && _$0fe1f1400993ba8a$export$b725a69477e4d33f_key1 !== void 0 ? _$0fe1f1400993ba8a$export$b725a69477e4d33f_key1 : value
        ];
    }));
};
function $0fe1f1400993ba8a$export$3b629cd0ff482602(raw, contentType) {
    if (contentType.includes("text")) return raw;
    if (contentType.includes("json")) return (0, $e5wYp.parseJSON)(raw);
    if (contentType.match(/html|xml/)) try {
        return $22de11b45b0eeb97$export$b6a9369736b19f4d(raw, contentType);
    } catch (e) {}
    return new TextEncoder().encode(raw).buffer;
}
function $0fe1f1400993ba8a$export$4f2a8c8c11a6373a(_param) {
    var tmp = _param.method, method = tmp === void 0 ? "GET" : tmp, path = _param.path, tmp1 = _param.headers, headers = tmp1 === void 0 ? {} : tmp1, body = _param.body, signal = _param.signal, rest = (0, $6JqHh._)(_param, [
        "method",
        "path",
        "headers",
        "body",
        "signal"
    ]);
    var request = new XMLHttpRequest(), header_list = headers instanceof Array ? headers : (headers === null || headers === void 0 ? void 0 : headers[Symbol.iterator]) instanceof Function ? (0, $3jzhD._)(headers) : Object.entries(headers);
    var abort = function() {
        return request.abort();
    };
    signal === null || signal === void 0 ? void 0 : signal.addEventListener("abort", abort);
    var response = new Promise(function(resolve, reject) {
        request.onreadystatechange = function() {
            if (request.readyState !== 4) return;
            if (!request.status && !(signal === null || signal === void 0 ? void 0 : signal.aborted)) return;
            resolve({
                status: request.status,
                statusText: request.statusText,
                headers: $0fe1f1400993ba8a$export$eea2c1c5e1a37e50(request.getAllResponseHeaders()),
                body: request.response || request.responseText
            });
        };
        request.onerror = request.ontimeout = reject;
        request.open(method, path + "");
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = header_list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $2MTYX._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                request.setRequestHeader(key, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        Object.assign(request, rest);
        request.send(body);
    }).then(function(_param) {
        var body = _param.body, meta = (0, $6JqHh._)(_param, [
            "body"
        ]);
        signal === null || signal === void 0 ? void 0 : signal.throwIfAborted();
        var contentType = request.getResponseHeader("Content-Type") || "";
        if (typeof body === "string" && !contentType.includes("text")) body = $0fe1f1400993ba8a$export$3b629cd0ff482602(body, contentType);
        return (0, $ddevm._)((0, $78DQ7._)({}, meta), {
            body: body
        });
    });
    response.finally(function() {
        return signal === null || signal === void 0 ? void 0 : signal.removeEventListener("abort", abort);
    });
    return {
        response: response,
        upload: (0, $aU3XG.Observable).fromEvent(request.upload, "progress"),
        download: (0, $aU3XG.Observable).fromEvent(request, "progress")
    };
}
function $0fe1f1400993ba8a$export$bda27a3e49197b9(_) {
    return _$0fe1f1400993ba8a$export$bda27a3e49197b9.apply(this, arguments);
}
function _$0fe1f1400993ba8a$export$bda27a3e49197b9() {
    _$0fe1f1400993ba8a$export$bda27a3e49197b9 = (0, $9OZ9j._)(function(param) {
        var path, method, headers, withCredentials, body, signal, timeout, responseType, signals, response, header, contentType, backup, data, _tmp, _tmp1, e, text, data;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    path = param.path, method = param.method, headers = param.headers, withCredentials = param.withCredentials, body = param.body, signal = param.signal, timeout = param.timeout, responseType = param.responseType;
                    signals = [
                        signal,
                        timeout && AbortSignal.timeout(timeout)
                    ].filter(Boolean);
                    headers = headers instanceof Headers ? Object.fromEntries(headers.entries()) : headers instanceof Array ? Object.fromEntries(headers) : headers;
                    headers = responseType === "text" ? (0, $ddevm._)((0, $78DQ7._)({}, headers), {
                        Accept: "text/plain"
                    }) : responseType === "json" ? (0, $ddevm._)((0, $78DQ7._)({}, headers), {
                        Accept: "application/json"
                    }) : responseType === "document" ? (0, $ddevm._)((0, $78DQ7._)({}, headers), {
                        Accept: "text/html, application/xhtml+xml, application/xml"
                    }) : responseType === "arraybuffer" || responseType === "blob" ? (0, $ddevm._)((0, $78DQ7._)({}, headers), {
                        Accept: "application/octet-stream"
                    }) : headers;
                    return [
                        4,
                        fetch(path + "", {
                            method: method,
                            headers: headers,
                            credentials: withCredentials ? "include" : "omit",
                            body: body,
                            signal: signals[0] && AbortSignal.any(signals)
                        })
                    ];
                case 1:
                    response = _state.sent();
                    header = $0fe1f1400993ba8a$export$eea2c1c5e1a37e50((0, $3jzhD._)(response.headers).map(function(param) {
                        var _param = (0, $2MTYX._)(param, 2), key = _param[0], value = _param[1];
                        return "".concat(key, ": ").concat(value);
                    }).join("\n"));
                    if (!(response.status !== 204)) return [
                        3,
                        11
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        9,
                        ,
                        11
                    ]);
                    contentType = response.headers.get("Content-Type") || "", backup = response.clone();
                    if (!(responseType === "text")) return [
                        3,
                        3
                    ];
                    _tmp = response.text();
                    return [
                        3,
                        7
                    ];
                case 3:
                    if (!(responseType === "document")) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        response.text()
                    ];
                case 4:
                    _tmp1 = $22de11b45b0eeb97$export$b6a9369736b19f4d.apply(void 0, [
                        _state.sent(),
                        contentType
                    ]);
                    return [
                        3,
                        6
                    ];
                case 5:
                    _tmp1 = responseType === "json" ? response.json() : responseType === "arraybuffer" ? response.arrayBuffer() : response.blob();
                    _state.label = 6;
                case 6:
                    _tmp = _tmp1;
                    _state.label = 7;
                case 7:
                    return [
                        4,
                        _tmp
                    ];
                case 8:
                    data = _state.sent();
                    return [
                        3,
                        11
                    ];
                case 9:
                    e = _state.sent();
                    return [
                        4,
                        backup.text()
                    ];
                case 10:
                    text = _state.sent();
                    data = $0fe1f1400993ba8a$export$3b629cd0ff482602(text, contentType);
                    return [
                        3,
                        11
                    ];
                case 11:
                    return [
                        2,
                        {
                            status: response.status,
                            statusText: response.statusText,
                            headers: header,
                            body: data
                        }
                    ];
            }
        });
    });
    return _$0fe1f1400993ba8a$export$bda27a3e49197b9.apply(this, arguments);
}
function $0fe1f1400993ba8a$export$b5fe3f66a567bec0(options) {
    return typeof globalThis.XMLHttpRequest === "function" ? $0fe1f1400993ba8a$export$4f2a8c8c11a6373a(options) : {
        response: $0fe1f1400993ba8a$export$bda27a3e49197b9(options)
    };
}
var $cbd22d3323bef9ca$exports = {};
$parcel$export($cbd22d3323bef9ca$exports, "HTTPClient", function() {
    return $cbd22d3323bef9ca$export$45cf759b359d3d24;
});
var _Array_prototype1 = Array.prototype, $cbd22d3323bef9ca$var$splice = _Array_prototype1.splice;
var $cbd22d3323bef9ca$export$45cf759b359d3d24 = /*#__PURE__*/ function($eef213ff4197108b$export$694e0d28c7ffc90c) {
    "use strict";
    (0, $iNfU4._)($cbd22d3323bef9ca$export$45cf759b359d3d24, $eef213ff4197108b$export$694e0d28c7ffc90c);
    var _super = (0, $k1NN5._)($cbd22d3323bef9ca$export$45cf759b359d3d24);
    function $cbd22d3323bef9ca$export$45cf759b359d3d24() {
        var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $19mwo._)(this, $cbd22d3323bef9ca$export$45cf759b359d3d24);
        var _this;
        var tmp = _param.baseURI, baseURI = tmp === void 0 ? function() {
            var _globalThis_document;
            return (_globalThis_document = globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.baseURI;
        }() : tmp, options = (0, $6JqHh._)(_param, [
            "baseURI"
        ]);
        _this = _super.call(this);
        _this.defaultWare = function() {
            var _ref = (0, $9OZ9j._)(function(param, next) {
                var request, response, tmp, method, tmp1, headers, body, _$22de11b45b0eeb97$export$dfdc1655ccc5b9cb, contentType, data;
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            request = param.request, response = param.response;
                            tmp = request.method, method = tmp === void 0 ? "GET" : tmp, tmp1 = request.headers, headers = tmp1 === void 0 ? {} : tmp1, body = request.body;
                            if (method in $0fe1f1400993ba8a$export$4125cfe7e08e2040 && body && typeof body === "object") {
                                _$22de11b45b0eeb97$export$dfdc1655ccc5b9cb = $22de11b45b0eeb97$export$dfdc1655ccc5b9cb(body, headers["Content-Type"]), contentType = _$22de11b45b0eeb97$export$dfdc1655ccc5b9cb.contentType, data = _$22de11b45b0eeb97$export$dfdc1655ccc5b9cb.data;
                                if (contentType) headers["Content-Type"] = contentType;
                                request.body = data;
                            }
                            return [
                                4,
                                next()
                            ];
                        case 1:
                            _state.sent();
                            if (response.status > 299) throw new $0fe1f1400993ba8a$export$aa9d629c530f62a7(response.statusText, response);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_, next) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.baseURI = baseURI, _this.options = options;
        (0, $jLCbM._)(((0, $15Pju._)(_this), (0, $laF8D._)($cbd22d3323bef9ca$export$45cf759b359d3d24.prototype)), "use", _this).call(_this, _this.defaultWare);
        var _this1 = (0, $15Pju._)(_this);
        (0, $jLCbM._)(((0, $15Pju._)(_this), (0, $laF8D._)($cbd22d3323bef9ca$export$45cf759b359d3d24.prototype)), "use", _this).call(_this, function() {
            var _ref = (0, $9OZ9j._)(function(param) {
                var data, response, _, _tmp;
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            data = param.request, response = param.response;
                            data.path = new URL(data.path + "", _this1.baseURI) + "";
                            _ = Object.assign;
                            _tmp = [
                                response
                            ];
                            return [
                                4,
                                $0fe1f1400993ba8a$export$b5fe3f66a567bec0((0, $78DQ7._)({}, options, data)).response
                            ];
                        case 1:
                            _.apply(Object, _tmp.concat([
                                _state.sent()
                            ]));
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }());
        return _this;
    }
    (0, $6rpfc._)($cbd22d3323bef9ca$export$45cf759b359d3d24, [
        {
            key: "use",
            value: function use() {
                for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
                    middlewares[_key] = arguments[_key];
                }
                var _$cbd22d3323bef9ca$var$splice;
                (_$cbd22d3323bef9ca$var$splice = $cbd22d3323bef9ca$var$splice).call.apply(_$cbd22d3323bef9ca$var$splice, [
                    this,
                    -2,
                    0
                ].concat((0, $3jzhD._)(middlewares)));
                return this;
            }
        },
        {
            key: "request",
            value: function request(data) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var context;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = {
                                    request: (0, $ddevm._)((0, $78DQ7._)({}, data), {
                                        headers: (0, $78DQ7._)({}, data.headers)
                                    }),
                                    response: {}
                                };
                                return [
                                    4,
                                    _this.execute(context)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    context.response
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "head",
            value: function head(path, headers, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _ref, data;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.request((0, $78DQ7._)({
                                        method: "HEAD",
                                        path: path,
                                        headers: headers
                                    }, options))
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.headers;
                                return [
                                    2,
                                    data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "get",
            value: function get(path, headers, options) {
                return this.request((0, $78DQ7._)({
                    method: "GET",
                    path: path,
                    headers: headers
                }, options));
            }
        },
        {
            key: "post",
            value: function post(path, body, headers, options) {
                return this.request((0, $78DQ7._)({
                    method: "POST",
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "put",
            value: function put(path, body, headers, options) {
                return this.request((0, $78DQ7._)({
                    method: "PUT",
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "patch",
            value: function patch(path, body, headers, options) {
                return this.request((0, $78DQ7._)({
                    method: "PATCH",
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "delete",
            value: function _delete(path, body, headers, options) {
                return this.request((0, $78DQ7._)({
                    method: "DELETE",
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "download",
            value: function download(path) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                return (0, $e2m1c._)(function() {
                    var headers, tmp, chunkSize, tmp1, _ref, tmp2, start, tmp3, end, options, total, _ref1, length, error, i, j, _ref2, status, _ref_headers, range, body, totalBytes, loaded;
                    function setEndAsHeader(length) {
                        total = length;
                        if (end === Infinity) end = total;
                    }
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = _param.headers, tmp = _param.chunkSize, chunkSize = tmp === void 0 ? Math.pow(1024, 2) : tmp, tmp1 = _param.range, _ref = (0, $2MTYX._)(tmp1 === void 0 ? [] : tmp1, 2), tmp2 = _ref[0], start = tmp2 === void 0 ? 0 : tmp2, tmp3 = _ref[1], end = tmp3 === void 0 ? Infinity : tmp3, options = (0, $6JqHh._)(_param, [
                                    "headers",
                                    "chunkSize",
                                    "range"
                                ]);
                                total = 0;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (0, $27QSE._)(_this.head(path, headers, options))
                                ];
                            case 2:
                                _ref1 = _state.sent(), length = _ref1["Content-Length"];
                                setEndAsHeader(+length);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                console.error(error);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                i = start, j = i - 1 + chunkSize;
                                _state.label = 5;
                            case 5:
                                if (!(i < end)) return [
                                    3,
                                    11
                                ];
                                return [
                                    4,
                                    (0, $27QSE._)(_this.get(path, (0, $ddevm._)((0, $78DQ7._)({}, headers), {
                                        Range: "bytes=".concat(i, "-").concat(j)
                                    }), options))
                                ];
                            case 6:
                                _ref2 = _state.sent(), status = _ref2.status, _ref_headers = _ref2.headers, range = _ref_headers["Content-Range"], body = _ref2.body;
                                totalBytes = +(range === null || range === void 0 ? void 0 : range.split("/").pop());
                                if (totalBytes) setEndAsHeader(totalBytes);
                                if (!(status !== 206)) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    {
                                        total: total,
                                        loaded: total,
                                        percent: 100,
                                        buffer: body
                                    }
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    3,
                                    11
                                ];
                            case 8:
                                loaded = i + body.byteLength;
                                return [
                                    4,
                                    {
                                        total: total,
                                        loaded: loaded,
                                        percent: +(loaded / total * 100).toFixed(2),
                                        buffer: body
                                    }
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                i = j + 1, j += chunkSize;
                                return [
                                    3,
                                    5
                                ];
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return $cbd22d3323bef9ca$export$45cf759b359d3d24;
}($eef213ff4197108b$export$694e0d28c7ffc90c);

});
parcelRegister("27QSE", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $18c5412ea4e23ae6$export$491e832825b6666e; });

var $3RWgJ = parcelRequire("3RWgJ");
function $18c5412ea4e23ae6$export$491e832825b6666e(value) {
    return new (0, $3RWgJ._await_value)(value);
}

});
parcelRegister("3RWgJ", function(module, exports) {

$parcel$export(module.exports, "_await_value", function () { return $2d13855458b0991d$export$14d68ad33f8c0242; });
function $2d13855458b0991d$export$14d68ad33f8c0242(value) {
    this.wrapped = value;
}

});


parcelRegister("6JqHh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4e6ba78638fa161b$export$69fdd232f62cde60; });

var $2SyoA = parcelRequire("2SyoA");
function $4e6ba78638fa161b$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $2SyoA._object_without_properties_loose)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("2SyoA", function(module, exports) {

$parcel$export(module.exports, "_object_without_properties_loose", function () { return $218b4e28393a679d$export$7a4a7e38737aceb4; });
function $218b4e28393a679d$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("e2m1c", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a38254fde6cf71c0$export$a1b373fcf543ed3a; });

var $8Oe11 = parcelRequire("8Oe11");
function $a38254fde6cf71c0$export$a1b373fcf543ed3a(fn) {
    return function() {
        return new (0, $8Oe11._async_generator)(fn.apply(this, arguments));
    };
}

});
parcelRegister("8Oe11", function(module, exports) {

$parcel$export(module.exports, "_async_generator", function () { return $669ddd6faedd1abd$export$f6ee6a12e55075bb; });

var $3RWgJ = parcelRequire("3RWgJ");
function $669ddd6faedd1abd$export$f6ee6a12e55075bb(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var wrappedAwait = value instanceof (0, $3RWgJ._await_value);
            Promise.resolve(wrappedAwait ? value.wrapped : value).then(function(arg) {
                if (wrappedAwait) {
                    resume("next", arg);
                    return;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
if (typeof Symbol === "function" && Symbol.asyncIterator) $669ddd6faedd1abd$export$f6ee6a12e55075bb.prototype[Symbol.asyncIterator] = function() {
    return this;
};
$669ddd6faedd1abd$export$f6ee6a12e55075bb.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$669ddd6faedd1abd$export$f6ee6a12e55075bb.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$669ddd6faedd1abd$export$f6ee6a12e55075bb.prototype.return = function(arg) {
    return this._invoke("return", arg);
};

});


parcelRegister("aU3XG", function(module, exports) {

$parcel$export(module.exports, "Observable", function () { return $7f023510481d8142$export$77cea355fa80b5f4; });

var $gIbDP = parcelRequire("gIbDP");

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $e2m1c = parcelRequire("e2m1c");

var $lF1I7 = parcelRequire("lF1I7");
function $7f023510481d8142$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $7f023510481d8142$var$$22de11b45b0eeb97$exports = {};
$7f023510481d8142$var$$parcel$export($7f023510481d8142$var$$22de11b45b0eeb97$exports, "Defer", function() {
    return $7f023510481d8142$export$c7e91f8aec23ae14;
});
$7f023510481d8142$var$$parcel$export($7f023510481d8142$var$$22de11b45b0eeb97$exports, "makeDefer", function() {
    return $7f023510481d8142$export$51ca94569b882c51;
});
var $7f023510481d8142$export$c7e91f8aec23ae14 = function $22de11b45b0eeb97$export$c7e91f8aec23ae14() {
    "use strict";
    var _this = this;
    (0, $19mwo._)(this, $22de11b45b0eeb97$export$c7e91f8aec23ae14);
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
    });
};
var $7f023510481d8142$export$51ca94569b882c51 = function() {
    return new $7f023510481d8142$export$c7e91f8aec23ae14();
};
var $7f023510481d8142$var$$e3640f413e0c36e7$exports = {};
$7f023510481d8142$var$$parcel$export($7f023510481d8142$var$$e3640f413e0c36e7$exports, "Observable", function() {
    return $7f023510481d8142$export$77cea355fa80b5f4;
});
if (!Symbol.observable) Reflect.set(Symbol, "observable", Symbol("observable"));
var $7f023510481d8142$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    "use strict";
    function $e3640f413e0c36e7$export$77cea355fa80b5f4(subscriber) {
        (0, $19mwo._)(this, $e3640f413e0c36e7$export$77cea355fa80b5f4);
        this.subscriber = subscriber;
    }
    (0, $6rpfc._)($e3640f413e0c36e7$export$77cea355fa80b5f4, [
        {
            key: Symbol.observable,
            value: function value() {
                return this;
            }
        },
        {
            key: Symbol.asyncIterator,
            value: function value() {
                var _this = this;
                return (0, $e2m1c._)(function() {
                    var queue, canceler, done, observer;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                queue = [
                                    new $7f023510481d8142$export$c7e91f8aec23ae14()
                                ], done = false;
                                observer = {
                                    next: function(value) {
                                        if (done) return;
                                        queue[queue.length - 1].resolve(value);
                                        queue.push(new $7f023510481d8142$export$c7e91f8aec23ae14());
                                    },
                                    error: function(reason) {
                                        if (!done) queue[queue.length - 1].reject(reason), done = true;
                                        if (canceler) canceler();
                                    },
                                    complete: function() {
                                        if (!done) queue[queue.length - 1].resolve(), done = true;
                                        if (canceler) canceler();
                                    }
                                };
                                canceler = _this.subscriber(observer);
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    queue[0].promise
                                ];
                            case 2:
                                _state.sent();
                                queue.shift();
                                _state.label = 3;
                            case 3:
                                if (queue[0]) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toPromise",
            value: function toPromise() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var stack, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                stack = [];
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    12
                                ]);
                                _iterator = (0, $gIbDP._)(_this);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    5
                                ];
                                _value = _step.value;
                                item = _value;
                                stack.push(item);
                                if (stack.length > 2) stack.shift();
                                _state.label = 4;
                            case 4:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    12
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    12
                                ];
                            case 7:
                                _state.trys.push([
                                    7,
                                    ,
                                    10,
                                    11
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 8:
                                _state.sent();
                                _state.label = 9;
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    2,
                                    stack[0]
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "subscribe",
            value: function subscribe(onNext, onError, onComplete) {
                var stop = false;
                var _this = this;
                (0, $9OZ9j._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, err, error;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    13,
                                    ,
                                    14
                                ]);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    12
                                ]);
                                _iterator = (0, $gIbDP._)(_this);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    5
                                ];
                                _value = _step.value;
                                item = _value;
                                if (!stop) onNext(item);
                                else return [
                                    3,
                                    5
                                ];
                                _state.label = 4;
                            case 4:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    12
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    12
                                ];
                            case 7:
                                _state.trys.push([
                                    7,
                                    ,
                                    10,
                                    11
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 8:
                                _state.sent();
                                _state.label = 9;
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    7
                                ];
                            case 12:
                                if (onComplete instanceof Function) onComplete();
                                return [
                                    3,
                                    14
                                ];
                            case 13:
                                error = _state.sent();
                                if (onError instanceof Function) onError(error);
                                return [
                                    3,
                                    14
                                ];
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                })();
                return {
                    unsubscribe: function() {
                        stop = true;
                    },
                    get closed () {
                        return stop;
                    }
                };
            }
        }
    ], [
        {
            key: "of",
            value: function of() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                return new this(function(param) {
                    var next = param.next, complete = param.complete;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var item = _step.value;
                            next(item);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    complete();
                });
            }
        },
        {
            key: "from",
            value: function from(observable) {
                return new this(function(param) {
                    var next = param.next, error = param.error, complete = param.complete;
                    return observable.subscribe(next, error, complete).unsubscribe;
                });
            }
        },
        {
            key: "fromEvent",
            value: function fromEvent(target, name) {
                return new this(function(param) {
                    var next = param.next, error = param.error;
                    if (typeof target.on === "function") target.on(name, next).on("error", error);
                    else {
                        target.addEventListener(name, next);
                        target.addEventListener("error", error);
                    }
                    return function() {
                        if (typeof target.off === "function") target.off(name, next).off("error", error);
                        else {
                            target.removeEventListener(name, next);
                            target.removeEventListener("error", error);
                        }
                    };
                });
            }
        }
    ]);
    return $e3640f413e0c36e7$export$77cea355fa80b5f4;
}();
var $7f023510481d8142$var$$603f33a01a36ab56$exports = {};
$7f023510481d8142$var$$parcel$export($7f023510481d8142$var$$603f33a01a36ab56$exports, "createQueue", function() {
    return $7f023510481d8142$export$d16acf4b6e75743d;
});
function $7f023510481d8142$export$d16acf4b6e75743d() {
    var feedNext, stop;
    var observable = new $7f023510481d8142$export$77cea355fa80b5f4(function(param) {
        var next = param.next, complete = param.complete;
        feedNext = next, stop = complete;
    });
    return {
        process: function(data) {
            var defer = new $7f023510481d8142$export$c7e91f8aec23ae14();
            if (!feedNext) throw Error("Can't process data before Queue consuming");
            feedNext({
                defer: defer,
                data: data
            });
            return defer.promise;
        },
        destroy: function() {
            if (!stop) throw Error("Can't stop a Queue before Queue consuming");
            stop();
        },
        observable: observable
    };
}

});
parcelRegister("gIbDP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c2a9c929d08f3a2b$export$adaf682ac3edfe45; });
function $c2a9c929d08f3a2b$export$adaf682ac3edfe45(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $c2a9c929d08f3a2b$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $c2a9c929d08f3a2b$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $c2a9c929d08f3a2b$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $c2a9c929d08f3a2b$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $c2a9c929d08f3a2b$var$AsyncFromSyncIterator(s);
}

});


parcelRegister("e5wYp", function(module, exports) {

$parcel$export(module.exports, "likeArray", function () { return $a41b1c278196f7ae$export$b5a4d6f439a5044d; });
$parcel$export(module.exports, "isTypedArray", function () { return $a41b1c278196f7ae$export$b119cc7e1840e59c; });
$parcel$export(module.exports, "parseJSON", function () { return $a41b1c278196f7ae$export$27924e57e9afff7f; });
$parcel$export(module.exports, "parseURLData", function () { return $a41b1c278196f7ae$export$eb9b2aadbe449a20; });
$parcel$export(module.exports, "stringifyDOM", function () { return $a41b1c278196f7ae$export$b0709844452f8b6b; });
$parcel$export(module.exports, "formToJSON", function () { return $a41b1c278196f7ae$export$86d7c59254d6a2c9; });
$parcel$export(module.exports, "serviceWorkerUpdate", function () { return $a41b1c278196f7ae$export$d635d04af3887bbe; });

var $9OZ9j = parcelRequire("9OZ9j");

var $27QSE = parcelRequire("27QSE");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $jLCbM = parcelRequire("jLCbM");

var $laF8D = parcelRequire("laF8D");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $e2m1c = parcelRequire("e2m1c");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");

var $lF1I7 = parcelRequire("lF1I7");
function $a41b1c278196f7ae$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $a41b1c278196f7ae$var$$9b05bcda60cc529c$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $a41b1c278196f7ae$export$61cc6ed0f143570b;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $a41b1c278196f7ae$export$dd1bc94b04021eeb;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $a41b1c278196f7ae$export$a09f818797e212c4;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $a41b1c278196f7ae$export$170f4e08cad8229d;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $a41b1c278196f7ae$export$2a489b3f92f4996a;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $a41b1c278196f7ae$export$67a6ce548ae77071;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $a41b1c278196f7ae$export$a48f0734ac7c2329;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $a41b1c278196f7ae$export$3f34ca2fef821bbd;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $a41b1c278196f7ae$export$86f54f62aa7a7514;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $a41b1c278196f7ae$export$89912e019eef22aa;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $a41b1c278196f7ae$export$1c8ba402144543e5;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $a41b1c278196f7ae$export$2ddabb89308e1a22;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $a41b1c278196f7ae$export$14527669107aa301;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $a41b1c278196f7ae$export$3f063810d7bf01bd;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $a41b1c278196f7ae$export$b5a4d6f439a5044d;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $a41b1c278196f7ae$export$b119cc7e1840e59c;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $a41b1c278196f7ae$export$7b85fd78dd236198;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $a41b1c278196f7ae$export$697c3df919c0e61a;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $a41b1c278196f7ae$export$e6b5ff3168b5942b;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $a41b1c278196f7ae$export$1d012a0dff3dab06;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $a41b1c278196f7ae$export$69a3209f1a06c04d;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $a41b1c278196f7ae$export$86c18c6347f4a8c4;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $a41b1c278196f7ae$export$dce9414bed0662c;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $a41b1c278196f7ae$export$271f7c16f175f804;
});
var $a41b1c278196f7ae$var$$6a9944941b4c1893$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "sum", function() {
    return $a41b1c278196f7ae$export$8a63f25cc62965f1;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $a41b1c278196f7ae$export$e1f36757ecda301d;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $a41b1c278196f7ae$export$8e694e1eafd55acb;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $a41b1c278196f7ae$export$57d7c52a66287430;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $a41b1c278196f7ae$export$2b4693832ca3ce16;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $a41b1c278196f7ae$export$5b784e078da1ce6;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $a41b1c278196f7ae$export$17ec9c9f4f23588c;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $a41b1c278196f7ae$export$595dbf49c602a1f;
});
function $a41b1c278196f7ae$export$8a63f25cc62965f1() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return data.reduce(function(sum, item) {
        return sum + item;
    }, 0);
}
function $a41b1c278196f7ae$export$e1f36757ecda301d() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return $a41b1c278196f7ae$export$8a63f25cc62965f1.apply(void 0, (0, $3jzhD._)(data)) / data.length;
}
function $a41b1c278196f7ae$export$8e694e1eafd55acb(data) {
    var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var average = $a41b1c278196f7ae$export$e1f36757ecda301d.apply(void 0, (0, $3jzhD._)(data));
    var summary = $a41b1c278196f7ae$export$8a63f25cc62965f1.apply(void 0, (0, $3jzhD._)(data.map(function(item) {
        return Math.pow(item - average, 2);
    })));
    return summary / (data.length - (sample ? 1 : 0));
}
function $a41b1c278196f7ae$export$57d7c52a66287430(data) {
    var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return Math.sqrt($a41b1c278196f7ae$export$8e694e1eafd55acb(data, sample));
}
function $a41b1c278196f7ae$export$2b4693832ca3ce16() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return Math.sqrt($a41b1c278196f7ae$export$8a63f25cc62965f1.apply(void 0, (0, $3jzhD._)(data.map(function(item) {
        return Math.pow(item, 2);
    }))));
}
function $a41b1c278196f7ae$export$5b784e078da1ce6(raw, length) {
    var text = raw.toFixed(length + 2);
    var offset = text.indexOf(".") + length + 1;
    var cut = function(text) {
        return text.slice(0, offset - (length ? 0 : 1));
    };
    if (!+text.slice(offset)) return cut(text);
    var result = cut((+cut(text) + Math.pow(10, -length)).toFixed(length));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
function $a41b1c278196f7ae$export$17ec9c9f4f23588c(raw) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var text = raw.toFixed(length + 2);
    var floatOffset = text.indexOf(".");
    if (floatOffset < 0) return length ? "".concat(text, ".").concat("0".repeat(length)) : text;
    var offset = floatOffset + length + 1;
    var before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    var carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $a41b1c278196f7ae$export$5b784e078da1ce6(raw, length);
    var result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
var $a41b1c278196f7ae$export$595dbf49c602a1f = /*#__PURE__*/ function() {
    "use strict";
    function $6a9944941b4c1893$export$595dbf49c602a1f(value) {
        (0, $19mwo._)(this, $6a9944941b4c1893$export$595dbf49c602a1f);
        this.value = value;
    }
    (0, $6rpfc._)($6a9944941b4c1893$export$595dbf49c602a1f, [
        {
            key: "valueOf",
            value: function valueOf() {
                return this.value;
            }
        },
        {
            key: "toShortString",
            value: function toShortString() {
                var fractionDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2;
                var _this = this, units = _this.units, value = _this.value;
                var _ref = (0, $3jzhD._)(units).reverse().find(function(param) {
                    var base = param.base;
                    return Math.abs(value) >= base;
                }) || units[0], base = _ref.base, name = _ref.name;
                return "".concat((value / base).toFixed(fractionDigits), " ").concat(name);
            }
        }
    ], [
        {
            key: "distanceOf",
            value: function distanceOf(a, b) {
                return Reflect.construct(this, [
                    a - b
                ]);
            }
        }
    ]);
    return $6a9944941b4c1893$export$595dbf49c602a1f;
}();
function $a41b1c278196f7ae$export$61cc6ed0f143570b(value) {
    return !(value != null) || Number.isNaN(value);
}
function $a41b1c278196f7ae$export$dd1bc94b04021eeb(value) {
    return $a41b1c278196f7ae$export$61cc6ed0f143570b(value) || (typeof value === "object" ? !Object.keys(value).length : value === "");
}
var $a41b1c278196f7ae$export$a09f818797e212c4 = function(data) {
    return Object.prototype.toString.call(data).slice(8, -1);
};
function $a41b1c278196f7ae$export$170f4e08cad8229d(Sub, Super) {
    return Sub.prototype instanceof Super;
}
function $a41b1c278196f7ae$export$2a489b3f92f4996a(target, dataStore, setter) {
    var prototype = Object.getPrototypeOf(target);
    var prototypeProxy = new Proxy(prototype, {
        set: function(_, key, value, receiver) {
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter === null || setter === void 0 ? void 0 : setter(key, value);
            return true;
        },
        get: function(prototype, key, receiver) {
            return key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver);
        }
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
function $a41b1c278196f7ae$export$67a6ce548ae77071(raw) {
    return /^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + "", undefined, {
        numeric: true
    }) > 0;
}
function $a41b1c278196f7ae$export$a48f0734ac7c2329(raw) {
    return raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, "xx").length;
}
function $a41b1c278196f7ae$export$3f34ca2fef821bbd(raw) {
    return raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, function(match, offset) {
        return "".concat(offset ? "-" : "").concat((match[1] || match[0]).toLowerCase());
    });
}
function $a41b1c278196f7ae$export$86f54f62aa7a7514(raw) {
    var large = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, function(match, offset) {
        return offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase();
    });
}
function $a41b1c278196f7ae$export$89912e019eef22aa() {
    return (Date.now() + parseInt((Math.random() + "").slice(2))).toString(36);
}
function $a41b1c278196f7ae$export$1c8ba402144543e5(values, keys) {
    return Object.fromEntries(values.map(function(value, index) {
        return [
            keys[index],
            value
        ];
    }));
}
var $a41b1c278196f7ae$export$2ddabb89308e1a22;
(function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
})($a41b1c278196f7ae$export$2ddabb89308e1a22 || ($a41b1c278196f7ae$export$2ddabb89308e1a22 = {}));
function $a41b1c278196f7ae$export$14527669107aa301(oldList, newList) {
    var map = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = oldList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            map[item] = -1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = newList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var item1 = _step1.value;
            var _map, _item;
            (_map = map)[_item = item1] || (_map[_item] = 0);
            map[item1] += 1;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return {
        map: map,
        group: $a41b1c278196f7ae$export$3f063810d7bf01bd(Object.entries(map), function(param) {
            var _param = (0, $2MTYX._)(param, 2), key = _param[0], status = _param[1];
            return status;
        })
    };
}
function $a41b1c278196f7ae$export$b5a4d6f439a5044d(data) {
    if ($a41b1c278196f7ae$export$61cc6ed0f143570b(data)) return false;
    var length = data.length;
    return typeof length === "number" && length >= 0 && ~~length === length;
}
var $a41b1c278196f7ae$export$b119cc7e1840e59c = function(data) {
    return data instanceof Object.getPrototypeOf(Int8Array);
};
function $a41b1c278196f7ae$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($a41b1c278196f7ae$export$61cc6ed0f143570b(data)) return [];
    if ($a41b1c278196f7ae$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
var $a41b1c278196f7ae$export$697c3df919c0e61a = function(array, unitLength) {
    return array.reduce(function(grid, item, index) {
        var _grid, _ref;
        ((_grid = grid)[_ref = ~~(index / unitLength)] || (_grid[_ref] = []))[index % unitLength] = item;
        return grid;
    }, []);
};
function $a41b1c278196f7ae$export$e6b5ff3168b5942b(list, subKey, handler) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (handler(item)) return [
                item
            ];
            if (item[subKey] instanceof Array) {
                var result = $a41b1c278196f7ae$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
                if (result.length) return [
                    item
                ].concat((0, $3jzhD._)(result));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [];
}
function $a41b1c278196f7ae$export$3f063810d7bf01bd(list, iteratee) {
    var data = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
            if (!(keys instanceof Array)) keys = [
                keys
            ];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = new Set(keys.filter(function(key) {
                    return key != null;
                }))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var key = _step1.value;
                    (data[key] = data[key] || []).push(item);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
}
function $a41b1c278196f7ae$export$1d012a0dff3dab06(list, iteratee) {
    var group = $a41b1c278196f7ae$export$3f063810d7bf01bd(list, iteratee);
    var sortedList = Object.entries(group).map(function(param) {
        var _param = (0, $2MTYX._)(param, 2), key = _param[0], _param_ = _param[1], length = _param_.length;
        return [
            key,
            length
        ];
    });
    return Object.fromEntries(sortedList);
}
function $a41b1c278196f7ae$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function() {
        for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
            data[_key] = arguments[_key];
        }
        var _executor;
        if (cacheData != null) return cacheData;
        console.trace("[Cache] execute: ".concat(title));
        cacheData = (_executor = executor).call.apply(_executor, [
            this,
            function() {
                return cacheData = undefined;
            }
        ].concat((0, $3jzhD._)(data)));
        Promise.resolve(cacheData).then(function(data) {
            return console.log("[Cache] refreshed: ".concat(title, " => ").concat(data));
        }, function(error) {
            return console.error("[Cache] failed: ".concat((error === null || error === void 0 ? void 0 : error.message) || error));
        });
        return cacheData;
    };
}
function $a41b1c278196f7ae$export$86c18c6347f4a8c4(executor) {
    return $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$86c18c6347f4a8c4.apply(this, arguments);
}
function $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$86c18c6347f4a8c4() {
    $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$86c18c6347f4a8c4 = (0, $e2m1c._)(function(executor) {
        var _Promise_withResolvers, promise, resolve, reject, doneSymbol, done, disposer, value, ref;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _Promise_withResolvers = Promise.withResolvers(), promise = _Promise_withResolvers.promise, resolve = _Promise_withResolvers.resolve, reject = _Promise_withResolvers.reject;
                    doneSymbol = Symbol("done"), done = Promise.withResolvers();
                    disposer = executor({
                        next: function(value) {
                            return resolve(value);
                        },
                        error: function(error) {
                            reject(error);
                            // @ts-ignore
                            disposer === null || disposer === void 0 ? void 0 : disposer();
                        },
                        complete: function() {
                            done.resolve(doneSymbol);
                            // @ts-ignore
                            disposer === null || disposer === void 0 ? void 0 : disposer();
                        }
                    });
                    _state.label = 1;
                case 1:
                    if (!true) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        (0, $27QSE._)(Promise.race([
                            promise,
                            done.promise
                        ]))
                    ];
                case 2:
                    value = _state.sent();
                    if (value === doneSymbol) return [
                        2
                    ];
                    return [
                        4,
                        value
                    ];
                case 3:
                    _state.sent();
                    ref = Promise.withResolvers(), promise = ref.promise, resolve = ref.resolve, reject = ref.reject, ref;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$86c18c6347f4a8c4.apply(this, arguments);
}
function $a41b1c278196f7ae$export$dce9414bed0662c() {
    return $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$dce9414bed0662c.apply(this, arguments);
}
function $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$dce9414bed0662c() {
    $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$dce9414bed0662c = (0, $e2m1c._)(function() {
        var _loop, _len, sources, _key, iterators;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function() {
                        var dones, i, iterator, _ref, done, value;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    dones = [];
                                    i = 0, iterator = void 0;
                                    _state.label = 1;
                                case 1:
                                    if (!(iterator = iterators[i])) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        (0, $27QSE._)(iterator.next())
                                    ];
                                case 2:
                                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                                    if (!!done) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        value
                                    ];
                                case 3:
                                    _state.sent();
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    dones.push(i);
                                    _state.label = 5;
                                case 5:
                                    i++;
                                    return [
                                        3,
                                        1
                                    ];
                                case 6:
                                    iterators = iterators.filter(function(_, i) {
                                        return !dones.includes(i);
                                    });
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    for(_len = _arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++){
                        sources[_key] = _arguments[_key];
                    }
                    iterators = sources.map(function(item) {
                        return item();
                    });
                    _state.label = 1;
                case 1:
                    if (!iterators[0]) return [
                        3,
                        3
                    ];
                    return [
                        5,
                        (0, $lF1I7.__values)(_loop())
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $a41b1c278196f7ae$var$_$9b05bcda60cc529c$export$dce9414bed0662c.apply(this, arguments);
}
var $a41b1c278196f7ae$export$271f7c16f175f804 = /*#__PURE__*/ function($6a9944941b4c1893$export$595dbf49c602a1f) {
    "use strict";
    (0, $iNfU4._)($9b05bcda60cc529c$export$271f7c16f175f804, $6a9944941b4c1893$export$595dbf49c602a1f);
    var _super = (0, $k1NN5._)($9b05bcda60cc529c$export$271f7c16f175f804);
    function $9b05bcda60cc529c$export$271f7c16f175f804() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $19mwo._)(this, $9b05bcda60cc529c$export$271f7c16f175f804);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, $3jzhD._)(args)));
        _this.units = [
            "",
            "K",
            "M",
            "G",
            "T",
            "P",
            "E",
            "Z",
            "Y"
        ].map(function(name, i) {
            return {
                base: Math.pow(1024, i),
                name: name + "B"
            };
        });
        return _this;
    }
    return $9b05bcda60cc529c$export$271f7c16f175f804;
}($a41b1c278196f7ae$export$595dbf49c602a1f);
var $a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $a41b1c278196f7ae$export$c489aa6f7fd82b1a;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $a41b1c278196f7ae$export$cbd942915f33be50;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $a41b1c278196f7ae$export$9b886f8493244014;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $a41b1c278196f7ae$export$e99cbb807a5bb10d;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $a41b1c278196f7ae$export$7a9a31a911eb9a20;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $a41b1c278196f7ae$export$fca4f8121099df57;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $a41b1c278196f7ae$export$6ce2f08d515512;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $a41b1c278196f7ae$export$951c8378cdfec6e6;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $a41b1c278196f7ae$export$1a4097b876a13bf7;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $a41b1c278196f7ae$export$d9bcbd5e1ff81430;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $a41b1c278196f7ae$export$506c8e8f8c8edda;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $a41b1c278196f7ae$export$3ae94a2503e890a1;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $a41b1c278196f7ae$export$62ad822b3a5fd9a0;
});
var $a41b1c278196f7ae$export$c489aa6f7fd82b1a = 1000;
var $a41b1c278196f7ae$export$cbd942915f33be50 = $a41b1c278196f7ae$export$c489aa6f7fd82b1a * 60;
var $a41b1c278196f7ae$export$9b886f8493244014 = $a41b1c278196f7ae$export$cbd942915f33be50 * 15;
var $a41b1c278196f7ae$export$e99cbb807a5bb10d = $a41b1c278196f7ae$export$9b886f8493244014 * 4;
var $a41b1c278196f7ae$export$7a9a31a911eb9a20 = $a41b1c278196f7ae$export$e99cbb807a5bb10d * 24;
var $a41b1c278196f7ae$export$fca4f8121099df57 = $a41b1c278196f7ae$export$7a9a31a911eb9a20 * 7;
var $a41b1c278196f7ae$export$6ce2f08d515512 = $a41b1c278196f7ae$export$7a9a31a911eb9a20 * 365;
var $a41b1c278196f7ae$export$951c8378cdfec6e6 = $a41b1c278196f7ae$export$6ce2f08d515512 / 12;
var $a41b1c278196f7ae$export$1a4097b876a13bf7 = $a41b1c278196f7ae$export$951c8378cdfec6e6 * 3;
var $a41b1c278196f7ae$export$d9bcbd5e1ff81430 = /*#__PURE__*/ function($6a9944941b4c1893$export$595dbf49c602a1f) {
    "use strict";
    (0, $iNfU4._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430, $6a9944941b4c1893$export$595dbf49c602a1f);
    var _super = (0, $k1NN5._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430);
    function $f872d8bba1c0f79f$export$d9bcbd5e1ff81430() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $19mwo._)(this, $f872d8bba1c0f79f$export$d9bcbd5e1ff81430);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, $3jzhD._)(args)));
        _this.units = [
            {
                base: $a41b1c278196f7ae$export$c489aa6f7fd82b1a,
                name: "s"
            },
            {
                base: $a41b1c278196f7ae$export$cbd942915f33be50,
                name: "m"
            },
            {
                base: $a41b1c278196f7ae$export$e99cbb807a5bb10d,
                name: "H"
            },
            {
                base: $a41b1c278196f7ae$export$7a9a31a911eb9a20,
                name: "D"
            },
            {
                base: $a41b1c278196f7ae$export$fca4f8121099df57,
                name: "W"
            },
            {
                base: $a41b1c278196f7ae$export$951c8378cdfec6e6,
                name: "M"
            },
            {
                base: $a41b1c278196f7ae$export$6ce2f08d515512,
                name: "Y"
            }
        ];
        return _this;
    }
    (0, $6rpfc._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430, [
        {
            key: "toShortString",
            value: function toShortString() {
                var fractionDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return (0, $jLCbM._)((0, $laF8D._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430.prototype), "toShortString", this).call(this, fractionDigits);
            }
        }
    ]);
    return $f872d8bba1c0f79f$export$d9bcbd5e1ff81430;
}($a41b1c278196f7ae$export$595dbf49c602a1f);
function $a41b1c278196f7ae$export$506c8e8f8c8edda(end) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var timeDistance = $a41b1c278196f7ae$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    var _timeDistance_toShortString_split = (0, $2MTYX._)(timeDistance.toShortString().split(/\s+/), 2), value = _timeDistance_toShortString_split[0], unit = _timeDistance_toShortString_split[1];
    return {
        distance: +value,
        unit: unit
    };
}
function $a41b1c278196f7ae$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + "";
    return function(template) {
        return (value.length < template.length ? value.padStart(template.length, "0") : value).slice(-Math.max(template.length, 2));
    };
}
function $a41b1c278196f7ae$export$3ae94a2503e890a1() {
    var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date(), template = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "YYYY-MM-DD HH:mm:ss";
    time = time instanceof Date ? time : new Date(time);
    time = new Date(+time - time.getTimezoneOffset() * $a41b1c278196f7ae$export$cbd942915f33be50);
    var _time_toJSON_split = (0, $2MTYX._)(time.toJSON().split(/\D/), 7), year = _time_toJSON_split[0], month = _time_toJSON_split[1], day = _time_toJSON_split[2], hour = _time_toJSON_split[3], minute = _time_toJSON_split[4], second = _time_toJSON_split[5], millisecond = _time_toJSON_split[6];
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $a41b1c278196f7ae$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $a41b1c278196f7ae$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $a41b1c278196f7ae$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $a41b1c278196f7ae$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $a41b1c278196f7ae$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $a41b1c278196f7ae$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $a41b1c278196f7ae$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    var month = date.getMonth() + delta;
    date.setFullYear(date.getFullYear() + Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
var $a41b1c278196f7ae$var$$ba0e5dc395660a7c$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $a41b1c278196f7ae$export$27924e57e9afff7f;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $a41b1c278196f7ae$export$7ea17d45ecdcf634;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $a41b1c278196f7ae$export$bb8626e4916f587b;
});
function $a41b1c278196f7ae$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === "string" && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            var date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    var value = parseItem(raw);
    if (typeof value !== "string" || $a41b1c278196f7ae$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, function(key, value) {
            return parseItem(value);
        });
    } catch (e) {
        return raw;
    }
}
function $a41b1c278196f7ae$export$7ea17d45ecdcf634(raw) {
    var parsed = $a41b1c278196f7ae$export$27924e57e9afff7f(raw);
    if (typeof parsed !== "string") return parsed;
    var number = +parsed;
    return Number.isNaN(number) || number + "" !== parsed ? parsed : number;
}
function $a41b1c278196f7ae$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    var quote = raw[0];
    var index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError("A ".concat(quote, " is missing"));
    return raw.slice(1, index);
}
function $a41b1c278196f7ae$export$bb8626e4916f587b(raw, header) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    var data = raw.trim().split(/[\r\n]+/).map(function(row) {
        var list = [];
        do {
            var value = void 0;
            if (row[0] === '"' || row[0] === "'") {
                value = $a41b1c278196f7ae$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
                row = row.slice(value.length + 3);
            } else {
                var index = row.indexOf(separator);
                if (index > -1) {
                    value = row.slice(0, index);
                    row = row.slice(index + 1);
                } else {
                    value = row;
                    row = "";
                }
            }
            list.push($a41b1c278196f7ae$export$7ea17d45ecdcf634(value.trim()));
        }while (row);
        return list;
    });
    return !header ? data : data.slice(1).map(function(row) {
        return row.reduce(function(object, item, index) {
            object[data[0][index]] = item;
            return object;
        }, {});
    });
}
var $a41b1c278196f7ae$var$$083124ac4b1a50a0$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $a41b1c278196f7ae$export$71e6483fc2b024eb;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $a41b1c278196f7ae$export$eb9b2aadbe449a20;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $a41b1c278196f7ae$export$13397a83aa5915d6;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $a41b1c278196f7ae$export$fd89523fba250fa4;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $a41b1c278196f7ae$export$504fbde693c1771c;
});
function $a41b1c278196f7ae$export$71e6483fc2b024eb(URI) {
    return new URL(URI, document.baseURI).origin !== location.origin;
}
function $a41b1c278196f7ae$export$eb9b2aadbe449a20() {
    var raw = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.location.search, toBuiltIn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var list = raw.split(/\?|#/);
    var data = new URLSearchParams(list[1] || list[0]);
    return Object.fromEntries((0, $3jzhD._)(data.keys()).map(function(key) {
        var list = toBuiltIn ? data.getAll(key).map($a41b1c278196f7ae$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
var $a41b1c278196f7ae$var$$083124ac4b1a50a0$var$stringify = function(value) {
    return typeof value === "string" ? value : $a41b1c278196f7ae$export$b5a4d6f439a5044d(value) ? $a41b1c278196f7ae$export$7b85fd78dd236198(value) + "" : JSON.stringify(value);
};
function $a41b1c278196f7ae$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    var list = map.map(function(param) {
        var _param = (0, $2MTYX._)(param, 2), key = _param[0], value = _param[1];
        return !$a41b1c278196f7ae$export$dd1bc94b04021eeb(value) && [
            key,
            $a41b1c278196f7ae$var$$083124ac4b1a50a0$var$stringify(value)
        ];
    }).filter(Boolean);
    return new URLSearchParams(list);
}
function $a41b1c278196f7ae$export$fd89523fba250fa4(URI) {
    return $a41b1c278196f7ae$var$_$083124ac4b1a50a0$export$fd89523fba250fa4.apply(this, arguments);
}
function $a41b1c278196f7ae$var$_$083124ac4b1a50a0$export$fd89523fba250fa4() {
    $a41b1c278196f7ae$var$_$083124ac4b1a50a0$export$fd89523fba250fa4 = (0, $9OZ9j._)(function(URI) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(URI + "")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().blob()
                    ];
            }
        });
    });
    return $a41b1c278196f7ae$var$_$083124ac4b1a50a0$export$fd89523fba250fa4.apply(this, arguments);
}
var $a41b1c278196f7ae$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $a41b1c278196f7ae$export$504fbde693c1771c(URI) {
    var _ref = (0, $2MTYX._)($a41b1c278196f7ae$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [], 5), _ = _ref[0], type = _ref[1], __ = _ref[2], base64 = _ref[3], data = _ref[4];
    data = base64 ? atob(data) : data;
    var aBuffer = new ArrayBuffer(data.length);
    var uBuffer = new Uint8Array(aBuffer);
    for(var i = 0; data[i]; i++)uBuffer[i] = data.charCodeAt(i);
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $a41b1c278196f7ae$var$$50872bf213056663$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $a41b1c278196f7ae$export$1b9ac4d3de3ffd2e;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$50872bf213056663$exports, "makeSHA", function() {
    return $a41b1c278196f7ae$export$d51f3b55e8d1aa73;
});
var $a41b1c278196f7ae$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), function(_, cell) {
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $a41b1c278196f7ae$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = raw[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            value = value >> 8 & 0x00ffffff ^ $a41b1c278196f7ae$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return "0x" + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === "object") {
    if ("msCrypto" in globalThis) {
        var $a41b1c278196f7ae$var$_loop = function(key) {
            var origin = $a41b1c278196f7ae$var$subtle[key];
            if (origin instanceof Function) $a41b1c278196f7ae$var$subtle[key] = function() {
                var observer = origin.apply(this, arguments);
                return new Promise(function(resolve, reject) {
                    observer.oncomplete = function(param) {
                        var target = param.target;
                        return resolve(target.result);
                    };
                    observer.onabort = observer.onerror = reject;
                });
            };
        };
        // @ts-ignore
        var $a41b1c278196f7ae$var$_ref = globalThis.crypto = globalThis.msCrypto, $a41b1c278196f7ae$var$subtle = $a41b1c278196f7ae$var$_ref.subtle;
        for(var $a41b1c278196f7ae$var$key in $a41b1c278196f7ae$var$subtle)$a41b1c278196f7ae$var$_loop($a41b1c278196f7ae$var$key);
    }
    var $a41b1c278196f7ae$var$crypto1 = globalThis.crypto;
    if (!($a41b1c278196f7ae$var$crypto1 === null || $a41b1c278196f7ae$var$crypto1 === void 0 ? void 0 : $a41b1c278196f7ae$var$crypto1.subtle) && ($a41b1c278196f7ae$var$crypto1 === null || $a41b1c278196f7ae$var$crypto1 === void 0 ? void 0 : $a41b1c278196f7ae$var$crypto1["webkitSubtle"])) $a41b1c278196f7ae$var$crypto1.subtle = $a41b1c278196f7ae$var$crypto1["webkitSubtle"];
}
function $a41b1c278196f7ae$export$d51f3b55e8d1aa73(raw) {
    return $a41b1c278196f7ae$var$_$50872bf213056663$export$d51f3b55e8d1aa73.apply(this, arguments);
}
function $a41b1c278196f7ae$var$_$50872bf213056663$export$d51f3b55e8d1aa73() {
    $a41b1c278196f7ae$var$_$50872bf213056663$export$d51f3b55e8d1aa73 = (0, $9OZ9j._)(function(raw) {
        var algorithm, buffer;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    algorithm = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "SHA-1";
                    return [
                        4,
                        crypto.subtle.digest(algorithm, new TextEncoder().encode(raw))
                    ];
                case 1:
                    buffer = _state.sent();
                    return [
                        2,
                        Array.from(new Uint8Array(buffer), function(byte) {
                            return byte.toString(16).padStart(2, "0");
                        }).join("")
                    ];
            }
        });
    });
    return $a41b1c278196f7ae$var$_$50872bf213056663$export$d51f3b55e8d1aa73.apply(this, arguments);
}
var $a41b1c278196f7ae$var$$93a3089d2937b23f$exports = {};
var $a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $a41b1c278196f7ae$export$2ee022bbbc550b25;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $a41b1c278196f7ae$export$a549dd5cef7f8327;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $a41b1c278196f7ae$export$8eece510bcb9c62c;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $a41b1c278196f7ae$export$b8a1af58c024fefd;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $a41b1c278196f7ae$export$a2cf0d4bb6e06de4;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $a41b1c278196f7ae$export$d66b332881d9723f;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $a41b1c278196f7ae$export$b0709844452f8b6b;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $a41b1c278196f7ae$export$5118471ee5d5453b;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $a41b1c278196f7ae$export$be4650432daa84fd;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $a41b1c278196f7ae$export$578e38b4a3e0b255;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $a41b1c278196f7ae$export$7cd14c57bbb84350;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $a41b1c278196f7ae$export$5100419dfae0456d;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $a41b1c278196f7ae$export$28d9d24a8cd0ffc2;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $a41b1c278196f7ae$export$3f99968195accfaf;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $a41b1c278196f7ae$export$eafdbaa868ea9975;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $a41b1c278196f7ae$export$36a0c1ca2ae264fa;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $a41b1c278196f7ae$export$86d7c59254d6a2c9;
});
var $a41b1c278196f7ae$var$$3e0a089cc13f69ad$var$templateMap = {};
function $a41b1c278196f7ae$export$2ee022bbbc550b25(tagName) {
    if ($a41b1c278196f7ae$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $a41b1c278196f7ae$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    var spawn = document.createElement("template");
    spawn.innerHTML = "<".concat(tagName, " />");
    return $a41b1c278196f7ae$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $a41b1c278196f7ae$export$a549dd5cef7f8327(tagName) {
    var node = $a41b1c278196f7ae$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? "html" : "xml";
}
function $a41b1c278196f7ae$export$8eece510bcb9c62c(Class) {
    return $a41b1c278196f7ae$export$170f4e08cad8229d(Class, HTMLElement);
}
var $a41b1c278196f7ae$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $a41b1c278196f7ae$export$b8a1af58c024fefd(Class) {
    var name = $a41b1c278196f7ae$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var _ref = new Class(), tagName = _ref.tagName;
    $a41b1c278196f7ae$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $a41b1c278196f7ae$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ var ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                "sizes"
            ]
        ],
        [
            HTMLIFrameElement,
            [
                "sandbox"
            ]
        ],
        [
            HTMLObjectElement,
            [
                "form"
            ]
        ],
        [
            HTMLInputElement,
            [
                "form",
                "list"
            ]
        ],
        [
            HTMLButtonElement,
            [
                "form"
            ]
        ],
        [
            HTMLSelectElement,
            [
                "form"
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                "form"
            ]
        ],
        [
            HTMLOutputElement,
            [
                "form"
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                "form"
            ]
        ]
    ];
    var template = $a41b1c278196f7ae$export$2ee022bbbc550b25(tagName);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ReadOnly_Properties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2MTYX._)(_step.value, 2), Class = _step_value[0], keys = _step_value[1];
            if (template instanceof Class && keys.includes(propertyName)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $a41b1c278196f7ae$export$d66b332881d9723f(HTML) {
    var spawn = document.createElement("template");
    spawn.innerHTML = HTML;
    return (0, $3jzhD._)(spawn.content.childNodes).map(function(node) {
        node.remove();
        return node;
    });
}
function $a41b1c278196f7ae$export$b0709844452f8b6b(node) {
    return new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, "");
}
function $a41b1c278196f7ae$export$5118471ee5d5453b(root, type) {
    var children, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, node, err;
    return (0, $lF1I7.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                children = (0, $3jzhD._)(root.childNodes);
                if (!($a41b1c278196f7ae$export$dd1bc94b04021eeb(type) || type === root.nodeType)) return [
                    3,
                    2
                ];
                return [
                    4,
                    root
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    8,
                    9,
                    10
                ]);
                _iterator = children[Symbol.iterator]();
                _state.label = 4;
            case 4:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    7
                ];
                node = _step.value;
                return [
                    5,
                    (0, $lF1I7.__values)($a41b1c278196f7ae$export$5118471ee5d5453b(node, type))
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    4
                ];
            case 7:
                return [
                    3,
                    10
                ];
            case 8:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    10
                ];
            case 9:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function $a41b1c278196f7ae$export$be4650432daa84fd(root) {
    var text = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a41b1c278196f7ae$export$5118471ee5d5453b(root)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, nodeType = _step_value.nodeType, parentElement = _step_value.parentElement, nodeValue = _step_value.nodeValue;
            if (nodeType === Node.TEXT_NODE && parentElement.getAttribute("aria-hidden") !== "true") {
                var _parentElement_getBoundingClientRect = parentElement.getBoundingClientRect(), width = _parentElement_getBoundingClientRect.width, height = _parentElement_getBoundingClientRect.height;
                if (width && height) text += nodeValue.trim().replace(/\s+/g, " ");
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return text;
}
function $a41b1c278196f7ae$export$578e38b4a3e0b255(param) {
    var offsetWidth = param.offsetWidth, children = param.children, pageHeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 841.89, pageWidth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 595.28;
    var scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return (0, $3jzhD._)(children).reduce(function(pages, node) {
        var _pages, _bottomIndex;
        var top = node.offsetTop, height = node.offsetHeight;
        top += offset;
        var bottom = top + height;
        var bottomOffset = bottom / scrollHeight;
        var topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        ((_pages = pages)[_bottomIndex = bottomIndex] || (_pages[_bottomIndex] = [])).push(node);
        return pages;
    }, []);
}
function $a41b1c278196f7ae$export$7cd14c57bbb84350(URI) {
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var alternate = _param.alternate, options = (0, $6JqHh._)(_param, [
        "alternate"
    ]);
    var style = (0, $3jzhD._)(document.styleSheets).find(function(param) {
        var href = param.href;
        return href === URI;
    });
    if (style) return Promise.resolve(style);
    var link = document.createElement("link");
    return new Promise(function(resolve, reject) {
        link.onload = function() {
            return resolve(link.sheet);
        };
        link.onerror = function(_1, _2, _3, _4, error) {
            return reject(error);
        };
        Object.assign(link, options);
        link.rel = (alternate ? "alternate " : "") + "stylesheet";
        link.href = URI;
        document.head.append(link);
    });
}
function $a41b1c278196f7ae$export$5100419dfae0456d(data) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, indent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "    ";
    var padding = indent.repeat(depth);
    return Object.entries(data).map(function(param) {
        var _param = (0, $2MTYX._)(param, 2), key = _param[0], value = _param[1];
        return typeof value !== "object" ? "".concat(padding).concat($a41b1c278196f7ae$export$3f34ca2fef821bbd(key), ": ").concat(value, ";") : "".concat(padding).concat(key, " {\n").concat($a41b1c278196f7ae$export$5100419dfae0456d(value, depth + 1, indent), "\n").concat(padding, "}");
    }).join("\n");
}
function $a41b1c278196f7ae$export$28d9d24a8cd0ffc2() {
    for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++){
        nodes[_key] = arguments[_key];
    }
    var _fragment, _node;
    var fragment = document.createDocumentFragment();
    (_fragment = fragment).append.apply(_fragment, (0, $3jzhD._)(nodes));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a41b1c278196f7ae$export$5118471ee5d5453b(fragment)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            if (![
                1,
                3,
                11
            ].includes(node.nodeType) || [
                "meta",
                "title",
                "link",
                "script"
            ].includes(node.nodeName.toLowerCase())) (_node = node).replaceWith.apply(_node, (0, $3jzhD._)(node.childNodes));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var selection = globalThis.getSelection();
    if (!selection) return;
    var range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $a41b1c278196f7ae$export$3f99968195accfaf(selector, root, align, justify) {
    var _querySelector;
    var _ref = (0, $2MTYX._)(/^#(.+)/.exec(selector) || [], 2), _ = _ref[0], ID = _ref[1];
    if (ID === "top") window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
    });
    else (_querySelector = (root || document).querySelector(ID ? '[id="'.concat(ID, '"]') : selector)) === null || _querySelector === void 0 ? void 0 : _querySelector.scrollIntoView({
        behavior: "smooth",
        block: align,
        inline: justify
    });
}
function $a41b1c278196f7ae$export$eafdbaa868ea9975(box, handler) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 6;
    return Array.from(box.querySelectorAll(Array.from(new Array(depth), function(_, index) {
        return "h".concat(++index);
    }) + ""), function(header) {
        new IntersectionObserver(function(param) {
            var _param = (0, $2MTYX._)(param, 1), item = _param[0];
            if (!item.isIntersecting) return;
            var target = item.target;
            handler({
                target: target,
                links: (0, $3jzhD._)(target.ownerDocument.querySelectorAll('[href="#'.concat(target.id, '"]')))
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, "-");
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
}
function $a41b1c278196f7ae$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === "visible" ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(function(param) {
        var _param = (0, $2MTYX._)(param, 1), _param_ = _param[0], isIntersecting = _param_.isIntersecting;
        return change(isIntersecting ? last | 2 : last & 1);
    }).observe(root);
    document.addEventListener("visibilitychange", function() {
        return change(document.visibilityState === "visible" ? last | 1 : last & 2);
    });
}
function $a41b1c278196f7ae$export$86d7c59254d6a2c9(form) {
    var data = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = form.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var field = _step.value;
            var type = field.type, name = field.name, value = field.value, checked = field.checked, defaultValue = field.defaultValue, selectedOptions = field.selectedOptions, files = field.files;
            if (!name || value === "") continue;
            var box = type !== "fieldset" && field.closest("fieldset");
            if (box && box !== form) continue;
            var parsedValue = value;
            switch(type){
                case "radio":
                case "checkbox":
                    if (checked) parsedValue = defaultValue ? $a41b1c278196f7ae$export$7ea17d45ecdcf634(defaultValue) : true;
                    else continue;
                    break;
                case "select-multiple":
                    parsedValue = Array.from(selectedOptions, function(param) {
                        var value = param.value;
                        return $a41b1c278196f7ae$export$7ea17d45ecdcf634(value);
                    });
                    break;
                case "fieldset":
                    parsedValue = $a41b1c278196f7ae$export$86d7c59254d6a2c9(field);
                    break;
                case "file":
                    parsedValue = files && Array.from(files);
                    break;
                case "date":
                case "datetime-local":
                case "month":
                case "hidden":
                case "number":
                case "range":
                case "select-one":
                    parsedValue = $a41b1c278196f7ae$export$7ea17d45ecdcf634(value);
            }
            if (name in data) data[name] = [].concat(data[name], parsedValue);
            else data[name] = !(parsedValue instanceof Array) || !$a41b1c278196f7ae$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
}
var $a41b1c278196f7ae$var$$bb23e0c794fefbef$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $a41b1c278196f7ae$export$e772c8ff12451969;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $a41b1c278196f7ae$export$57207d71b8c929c8;
});
function $a41b1c278196f7ae$export$e772c8ff12451969() {
    var seconds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return new Promise(function(resolve) {
        return setTimeout(resolve, seconds * 1000);
    });
}
function $a41b1c278196f7ae$export$57207d71b8c929c8(executor) {
    var seconds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var stop = false;
    (0, $9OZ9j._)(function() {
        var result;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!stop) return [
                        3,
                        4
                    ];
                    result = executor();
                    if (!(result instanceof Promise)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        result
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        $a41b1c278196f7ae$export$e772c8ff12451969(seconds)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        0
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
    return function() {
        return stop = true;
    };
}
var $a41b1c278196f7ae$var$$19ed8aeb7905a045$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $a41b1c278196f7ae$export$10b1921597150314;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $a41b1c278196f7ae$export$3e2b244719956741;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $a41b1c278196f7ae$export$1d1d2ed6b55cf67f;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $a41b1c278196f7ae$export$2155c0b5a4b77fb8;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $a41b1c278196f7ae$export$9d97473344489dfc;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $a41b1c278196f7ae$export$d635d04af3887bbe;
});
function $a41b1c278196f7ae$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
var $a41b1c278196f7ae$export$3e2b244719956741 = typeof window !== "undefined" ? new Promise(function(resolve) {
    var _document;
    function done() {
        var _document;
        (_document = document) === null || _document === void 0 ? void 0 : _document.removeEventListener("DOMContentLoaded", done);
        window.removeEventListener("load", done);
        resolve();
    }
    (_document = document) === null || _document === void 0 ? void 0 : _document.addEventListener("DOMContentLoaded", done);
    window.addEventListener("load", done);
    setTimeout(function check() {
        var _document;
        ((_document = document) === null || _document === void 0 ? void 0 : _document.readyState) === "complete" ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $a41b1c278196f7ae$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise(function(resolve, reject) {
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + "end", end);
            element.removeEventListener(scope + "cancel", cancel);
        }
        element.addEventListener(scope + "end", end);
        element.addEventListener(scope + "cancel", cancel);
    });
}
function $a41b1c278196f7ae$export$2155c0b5a4b77fb8(handlers) {
    function server(_param) {
        return _server.apply(this, arguments);
    }
    function _server() {
        _server = (0, $9OZ9j._)(function(_param) {
            var _param_data, type, id, source, origin, data, _handlers_type, result;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _param_data = _param.data, type = _param_data.type, id = _param_data.id, source = _param.source, origin = _param.origin, data = (0, $6JqHh._)(_param.data, [
                            "type",
                            "id"
                        ]);
                        result = (_handlers_type = handlers[type]) === null || _handlers_type === void 0 ? void 0 : _handlers_type.call(handlers, data);
                        if (!(result instanceof Promise)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            result
                        ];
                    case 1:
                        result = _state.sent();
                        _state.label = 2;
                    case 2:
                        // @ts-ignore
                        source.postMessage((0, $ddevm._)((0, $78DQ7._)({}, result), {
                            id: id
                        }), origin);
                        return [
                            2
                        ];
                }
            });
        });
        return _server.apply(this, arguments);
    }
    globalThis.addEventListener("message", server);
    return function() {
        return globalThis.removeEventListener("message", server);
    };
}
function $a41b1c278196f7ae$export$9d97473344489dfc(target) {
    var origin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "*";
    return function(type, data) {
        return new Promise(function(resolve) {
            var UID = $a41b1c278196f7ae$export$89912e019eef22aa();
            function handler(_param) {
                var _param_data = _param.data, id = _param_data.id, _$data = (0, $6JqHh._)(_param.data, [
                    "id"
                ]);
                if (id !== UID) return;
                resolve(_$data);
                globalThis.removeEventListener("message", handler);
            }
            globalThis.addEventListener("message", handler);
            // @ts-ignore
            target.postMessage((0, $78DQ7._)({
                id: UID,
                type: type
            }, data), origin);
        });
    };
}
function $a41b1c278196f7ae$export$d635d04af3887bbe(registration) {
    return new Promise(function(resolve) {
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = function() {
            var _registration_installing;
            return (_registration_installing = registration.installing) === null || _registration_installing === void 0 ? void 0 : _registration_installing.addEventListener("statechange", function() {
                if (this.state === "installed" && navigator.serviceWorker.controller) resolve(this);
            });
        };
    });
}
var $a41b1c278196f7ae$var$$7a08303ce13c49c5$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $a41b1c278196f7ae$export$1b88f6b6d432a52a;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $a41b1c278196f7ae$export$b70f6380221b1350;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $a41b1c278196f7ae$export$75d6cbe4503e149;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $a41b1c278196f7ae$export$b2618d51188815c2;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $a41b1c278196f7ae$export$490814474ddbb428;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $a41b1c278196f7ae$export$3ea201dffb50dfef;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $a41b1c278196f7ae$export$d1012c7198c6b460;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $a41b1c278196f7ae$export$a35a418b7b17958e;
});
var $a41b1c278196f7ae$export$1b88f6b6d432a52a = /*#__PURE__*/ function() {
    "use strict";
    function $7a08303ce13c49c5$export$1b88f6b6d432a52a(from, to) {
        (0, $19mwo._)(this, $7a08303ce13c49c5$export$1b88f6b6d432a52a);
        this.from = from;
        this.to = to;
    }
    (0, $6rpfc._)($7a08303ce13c49c5$export$1b88f6b6d432a52a, [
        {
            key: "length",
            get: function get() {
                var _this = this, from = _this.from, to = _this.to;
                return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
            }
        },
        {
            key: "direction",
            get: function get() {
                var _this = this, from = _this.from, to = _this.to;
                var XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
                var XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
                switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
                    case XL:
                        return XD > 0 ? "right" : "left";
                    case YL:
                        return YD > 0 ? "forward" : "backward";
                    case ZL:
                        return ZD > 0 ? "up" : "down";
                }
            }
        }
    ]);
    return $7a08303ce13c49c5$export$1b88f6b6d432a52a;
}();
function $a41b1c278196f7ae$export$b70f6380221b1350(from, to) {
    var threshold = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : parseInt(getComputedStyle(document.body).fontSize) * 6;
    var _getSelection;
    var vector = new $a41b1c278196f7ae$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !((_getSelection = getSelection()) === null || _getSelection === void 0 ? void 0 : _getSelection.toString().trim())) return vector;
}
function $a41b1c278196f7ae$export$75d6cbe4503e149(type, element) {
    var _getComputedStyle = getComputedStyle(element), transitionDuration = _getComputedStyle.transitionDuration, animationDuration = _getComputedStyle.animationDuration;
    var duration = type === "animation" ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === "ms" ? 1 : 1000);
}
function $a41b1c278196f7ae$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $a41b1c278196f7ae$export$1d1d2ed6b55cf67f(type, element).catch(function(event) {
            return Promise.resolve(event);
        }),
        new Promise(function(resolve) {
            return setTimeout(resolve, $a41b1c278196f7ae$export$75d6cbe4503e149(type, element));
        })
    ]);
}
function $a41b1c278196f7ae$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    var end = $a41b1c278196f7ae$export$b2618d51188815c2(type, element);
    return new Promise(function(resolve) {
        return requestAnimationFrame(function() {
            element.classList.add(className);
            end.then(resolve);
        });
    });
}
function $a41b1c278196f7ae$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    return $a41b1c278196f7ae$var$_$7a08303ce13c49c5$var$fadeOut.apply(this, arguments);
}
function $a41b1c278196f7ae$var$_$7a08303ce13c49c5$var$fadeOut() {
    $a41b1c278196f7ae$var$_$7a08303ce13c49c5$var$fadeOut = (0, $9OZ9j._)(function(type, element, className, remove) {
        var end;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = $a41b1c278196f7ae$export$b2618d51188815c2(type, element);
                    element.classList.remove(className);
                    return [
                        4,
                        end
                    ];
                case 1:
                    _state.sent();
                    if (remove) element.remove();
                    else element.style.display = "none";
                    return [
                        2
                    ];
            }
        });
    });
    return $a41b1c278196f7ae$var$_$7a08303ce13c49c5$var$fadeOut.apply(this, arguments);
}
function $a41b1c278196f7ae$export$490814474ddbb428(element, className) {
    var display = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "block";
    return $a41b1c278196f7ae$var$$7a08303ce13c49c5$var$fadeIn("transition", element, className, display);
}
function $a41b1c278196f7ae$export$3ea201dffb50dfef(element, className) {
    var display = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "block";
    return $a41b1c278196f7ae$var$$7a08303ce13c49c5$var$fadeIn("animation", element, className, display);
}
function $a41b1c278196f7ae$export$d1012c7198c6b460(element, className, remove) {
    return $a41b1c278196f7ae$var$$7a08303ce13c49c5$var$fadeOut("transition", element, className, remove);
}
function $a41b1c278196f7ae$export$a35a418b7b17958e(element, className, remove) {
    return $a41b1c278196f7ae$var$$7a08303ce13c49c5$var$fadeOut("animation", element, className, remove);
}
var $a41b1c278196f7ae$var$$69bd9f0117925302$exports = {};
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$69bd9f0117925302$exports, "describe", function() {
    return $a41b1c278196f7ae$export$cd5450f3a47e3789;
});
$a41b1c278196f7ae$var$$parcel$export($a41b1c278196f7ae$var$$69bd9f0117925302$exports, "it", function() {
    return $a41b1c278196f7ae$export$3486a10f30cf1ee4;
});
function $a41b1c278196f7ae$export$cd5450f3a47e3789(title, cases) {
    return $a41b1c278196f7ae$var$_$69bd9f0117925302$export$cd5450f3a47e3789.apply(this, arguments);
}
function $a41b1c278196f7ae$var$_$69bd9f0117925302$export$cd5450f3a47e3789() {
    $a41b1c278196f7ae$var$_$69bd9f0117925302$export$cd5450f3a47e3789 = (0, $9OZ9j._)(function(title, cases) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log(title);
                    console.time(title);
                    return [
                        4,
                        cases()
                    ];
                case 1:
                    _state.sent();
                    console.timeEnd(title);
                    return [
                        2
                    ];
            }
        });
    });
    return $a41b1c278196f7ae$var$_$69bd9f0117925302$export$cd5450f3a47e3789.apply(this, arguments);
}
function $a41b1c278196f7ae$export$3486a10f30cf1ee4(title, userCase) {
    return $a41b1c278196f7ae$var$_$69bd9f0117925302$export$3486a10f30cf1ee4.apply(this, arguments);
}
function $a41b1c278196f7ae$var$_$69bd9f0117925302$export$3486a10f30cf1ee4() {
    $a41b1c278196f7ae$var$_$69bd9f0117925302$export$3486a10f30cf1ee4 = (0, $9OZ9j._)(function(title, userCase) {
        var secondsOut;
        var _arguments = arguments;
        function timeOut() {
            return _timeOut.apply(this, arguments);
        }
        function _timeOut() {
            _timeOut = (0, $9OZ9j._)(function() {
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                $a41b1c278196f7ae$export$e772c8ff12451969(secondsOut)
                            ];
                        case 1:
                            _state.sent();
                            throw new RangeError("Timed out");
                    }
                });
            });
            return _timeOut.apply(this, arguments);
        }
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    secondsOut = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 3;
                    title = "    " + title;
                    console.time(title);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4,
                        Promise.race([
                            userCase(function(status) {
                                return console.assert(status, title);
                            }),
                            timeOut()
                        ])
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    console.timeEnd(title);
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $a41b1c278196f7ae$var$_$69bd9f0117925302$export$3486a10f30cf1ee4.apply(this, arguments);
}

});


parcelRegister("fdPHT", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b1502ddb39c03b09$export$ae55be85d98224ed; }, function (v) { return $b1502ddb39c03b09$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b1502ddb39c03b09$export$d39a5bbd09211389; }, function (v) { return $b1502ddb39c03b09$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b1502ddb39c03b09$export$882461b6382ed46c; }, function (v) { return $b1502ddb39c03b09$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b1502ddb39c03b09$export$466bfc07425424d5; }, function (v) { return $b1502ddb39c03b09$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b1502ddb39c03b09$export$cd75ccfd720a3cd4; }, function (v) { return $b1502ddb39c03b09$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b1502ddb39c03b09$export$fa8d919ba61d84db; }, function (v) { return $b1502ddb39c03b09$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b1502ddb39c03b09$export$757ceba2d55c277e; }, function (v) { return $b1502ddb39c03b09$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b1502ddb39c03b09$export$b3890eb0ae9dca99; }, function (v) { return $b1502ddb39c03b09$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b1502ddb39c03b09$export$502457920280e6be; }, function (v) { return $b1502ddb39c03b09$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b1502ddb39c03b09$export$c78a37762a8d58e1; }, function (v) { return $b1502ddb39c03b09$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b1502ddb39c03b09$export$dc54d992c10e8a18; }, function (v) { return $b1502ddb39c03b09$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b1502ddb39c03b09$export$83d89fbfd8236492; }, function (v) { return $b1502ddb39c03b09$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $gnDeW = parcelRequire("gnDeW");
var $b1502ddb39c03b09$export$ae55be85d98224ed;
var $b1502ddb39c03b09$export$d39a5bbd09211389;
var $b1502ddb39c03b09$export$882461b6382ed46c;
var $b1502ddb39c03b09$export$466bfc07425424d5;
var $b1502ddb39c03b09$export$cd75ccfd720a3cd4;
var $b1502ddb39c03b09$export$fa8d919ba61d84db;
var $b1502ddb39c03b09$export$757ceba2d55c277e;
var $b1502ddb39c03b09$export$b3890eb0ae9dca99;
var $b1502ddb39c03b09$export$502457920280e6be;
var $b1502ddb39c03b09$export$c78a37762a8d58e1;
var $b1502ddb39c03b09$export$dc54d992c10e8a18;
var $b1502ddb39c03b09$export$83d89fbfd8236492;
"use strict";

var $33gHU = parcelRequire("33gHU");

var $bE6KD = parcelRequire("bE6KD");
function $b1502ddb39c03b09$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b1502ddb39c03b09$var$da = new Set, $b1502ddb39c03b09$var$ea = {};
function $b1502ddb39c03b09$var$fa(a, b) {
    $b1502ddb39c03b09$var$ha(a, b);
    $b1502ddb39c03b09$var$ha(a + "Capture", b);
}
function $b1502ddb39c03b09$var$ha(a, b) {
    $b1502ddb39c03b09$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b1502ddb39c03b09$var$da.add(b[a]);
}
var $b1502ddb39c03b09$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b1502ddb39c03b09$var$ja = Object.prototype.hasOwnProperty, $b1502ddb39c03b09$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b1502ddb39c03b09$var$la = {}, $b1502ddb39c03b09$var$ma = {};
function $b1502ddb39c03b09$var$oa(a) {
    if ($b1502ddb39c03b09$var$ja.call($b1502ddb39c03b09$var$ma, a)) return !0;
    if ($b1502ddb39c03b09$var$ja.call($b1502ddb39c03b09$var$la, a)) return !1;
    if ($b1502ddb39c03b09$var$ka.test(a)) return $b1502ddb39c03b09$var$ma[a] = !0;
    $b1502ddb39c03b09$var$la[a] = !0;
    return !1;
}
function $b1502ddb39c03b09$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $gnDeW._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b1502ddb39c03b09$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b1502ddb39c03b09$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b1502ddb39c03b09$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b1502ddb39c03b09$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b1502ddb39c03b09$var$z[b] = new $b1502ddb39c03b09$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b1502ddb39c03b09$var$ra = /[\-:]([a-z])/g;
function $b1502ddb39c03b09$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b1502ddb39c03b09$var$ra, $b1502ddb39c03b09$var$sa);
    $b1502ddb39c03b09$var$z[b] = new $b1502ddb39c03b09$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b1502ddb39c03b09$var$ra, $b1502ddb39c03b09$var$sa);
    $b1502ddb39c03b09$var$z[b] = new $b1502ddb39c03b09$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b1502ddb39c03b09$var$ra, $b1502ddb39c03b09$var$sa);
    $b1502ddb39c03b09$var$z[b] = new $b1502ddb39c03b09$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b1502ddb39c03b09$var$z.xlinkHref = new $b1502ddb39c03b09$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b1502ddb39c03b09$var$ta(a, b, c, d) {
    var e = $b1502ddb39c03b09$var$z.hasOwnProperty(b) ? $b1502ddb39c03b09$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b1502ddb39c03b09$var$qa(b, c, e, d) && (c = null), d || null === e ? $b1502ddb39c03b09$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b1502ddb39c03b09$var$ua = $33gHU.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b1502ddb39c03b09$var$va = Symbol.for("react.element"), $b1502ddb39c03b09$var$wa = Symbol.for("react.portal"), $b1502ddb39c03b09$var$ya = Symbol.for("react.fragment"), $b1502ddb39c03b09$var$za = Symbol.for("react.strict_mode"), $b1502ddb39c03b09$var$Aa = Symbol.for("react.profiler"), $b1502ddb39c03b09$var$Ba = Symbol.for("react.provider"), $b1502ddb39c03b09$var$Ca = Symbol.for("react.context"), $b1502ddb39c03b09$var$Da = Symbol.for("react.forward_ref"), $b1502ddb39c03b09$var$Ea = Symbol.for("react.suspense"), $b1502ddb39c03b09$var$Fa = Symbol.for("react.suspense_list"), $b1502ddb39c03b09$var$Ga = Symbol.for("react.memo"), $b1502ddb39c03b09$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b1502ddb39c03b09$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b1502ddb39c03b09$var$Ja = Symbol.iterator;
function $b1502ddb39c03b09$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b1502ddb39c03b09$var$Ja && a[$b1502ddb39c03b09$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b1502ddb39c03b09$var$A = Object.assign, $b1502ddb39c03b09$var$La;
function $b1502ddb39c03b09$var$Ma(a) {
    if (void 0 === $b1502ddb39c03b09$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b1502ddb39c03b09$var$La = b && b[1] || "";
    }
    return "\n" + $b1502ddb39c03b09$var$La + a;
}
var $b1502ddb39c03b09$var$Na = !1;
function $b1502ddb39c03b09$var$Oa(a, b) {
    if (!a || $b1502ddb39c03b09$var$Na) return "";
    $b1502ddb39c03b09$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b1502ddb39c03b09$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b1502ddb39c03b09$var$Ma(a) : "";
}
function $b1502ddb39c03b09$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b1502ddb39c03b09$var$Ma(a.type);
        case 16:
            return $b1502ddb39c03b09$var$Ma("Lazy");
        case 13:
            return $b1502ddb39c03b09$var$Ma("Suspense");
        case 19:
            return $b1502ddb39c03b09$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b1502ddb39c03b09$var$Oa(a.type, !1), a;
        case 11:
            return a = $b1502ddb39c03b09$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b1502ddb39c03b09$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b1502ddb39c03b09$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b1502ddb39c03b09$var$ya:
            return "Fragment";
        case $b1502ddb39c03b09$var$wa:
            return "Portal";
        case $b1502ddb39c03b09$var$Aa:
            return "Profiler";
        case $b1502ddb39c03b09$var$za:
            return "StrictMode";
        case $b1502ddb39c03b09$var$Ea:
            return "Suspense";
        case $b1502ddb39c03b09$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b1502ddb39c03b09$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b1502ddb39c03b09$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b1502ddb39c03b09$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b1502ddb39c03b09$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b1502ddb39c03b09$var$Qa(a.type) || "Memo";
        case $b1502ddb39c03b09$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b1502ddb39c03b09$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b1502ddb39c03b09$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b1502ddb39c03b09$var$Qa(b);
        case 8:
            return b === $b1502ddb39c03b09$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b1502ddb39c03b09$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $gnDeW._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b1502ddb39c03b09$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b1502ddb39c03b09$var$Ua(a) {
    var b = $b1502ddb39c03b09$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b1502ddb39c03b09$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b1502ddb39c03b09$var$Ua(a));
}
function $b1502ddb39c03b09$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b1502ddb39c03b09$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b1502ddb39c03b09$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b1502ddb39c03b09$var$Ya(a, b) {
    var c = b.checked;
    return $b1502ddb39c03b09$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b1502ddb39c03b09$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b1502ddb39c03b09$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b1502ddb39c03b09$var$ab(a, b) {
    b = b.checked;
    null != b && $b1502ddb39c03b09$var$ta(a, "checked", b, !1);
}
function $b1502ddb39c03b09$var$bb(a, b) {
    $b1502ddb39c03b09$var$ab(a, b);
    var c = $b1502ddb39c03b09$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b1502ddb39c03b09$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b1502ddb39c03b09$var$cb(a, b.type, $b1502ddb39c03b09$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b1502ddb39c03b09$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b1502ddb39c03b09$var$cb(a, b, c) {
    if ("number" !== b || $b1502ddb39c03b09$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b1502ddb39c03b09$var$eb = Array.isArray;
function $b1502ddb39c03b09$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b1502ddb39c03b09$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b1502ddb39c03b09$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b1502ddb39c03b09$var$p(91));
    return $b1502ddb39c03b09$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b1502ddb39c03b09$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b1502ddb39c03b09$var$p(92));
            if ($b1502ddb39c03b09$var$eb(c)) {
                if (1 < c.length) throw Error($b1502ddb39c03b09$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b1502ddb39c03b09$var$Sa(c)
    };
}
function $b1502ddb39c03b09$var$ib(a, b) {
    var c = $b1502ddb39c03b09$var$Sa(b.value), d = $b1502ddb39c03b09$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b1502ddb39c03b09$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b1502ddb39c03b09$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b1502ddb39c03b09$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b1502ddb39c03b09$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b1502ddb39c03b09$var$mb, $b1502ddb39c03b09$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b1502ddb39c03b09$var$mb = $b1502ddb39c03b09$var$mb || document.createElement("div");
        $b1502ddb39c03b09$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b1502ddb39c03b09$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b1502ddb39c03b09$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b1502ddb39c03b09$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b1502ddb39c03b09$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b1502ddb39c03b09$var$pb).forEach(function(a) {
    $b1502ddb39c03b09$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b1502ddb39c03b09$var$pb[b] = $b1502ddb39c03b09$var$pb[a];
    });
});
function $b1502ddb39c03b09$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b1502ddb39c03b09$var$pb.hasOwnProperty(a) && $b1502ddb39c03b09$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b1502ddb39c03b09$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b1502ddb39c03b09$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b1502ddb39c03b09$var$tb = $b1502ddb39c03b09$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b1502ddb39c03b09$var$ub(a, b) {
    if (b) {
        if ($b1502ddb39c03b09$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b1502ddb39c03b09$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b1502ddb39c03b09$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b1502ddb39c03b09$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b1502ddb39c03b09$var$p(62));
    }
}
function $b1502ddb39c03b09$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b1502ddb39c03b09$var$wb = null;
function $b1502ddb39c03b09$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b1502ddb39c03b09$var$yb = null, $b1502ddb39c03b09$var$zb = null, $b1502ddb39c03b09$var$Ab = null;
function $b1502ddb39c03b09$var$Bb(a) {
    if (a = $b1502ddb39c03b09$var$Cb(a)) {
        if ("function" !== typeof $b1502ddb39c03b09$var$yb) throw Error($b1502ddb39c03b09$var$p(280));
        var b = a.stateNode;
        b && (b = $b1502ddb39c03b09$var$Db(b), $b1502ddb39c03b09$var$yb(a.stateNode, a.type, b));
    }
}
function $b1502ddb39c03b09$var$Eb(a) {
    $b1502ddb39c03b09$var$zb ? $b1502ddb39c03b09$var$Ab ? $b1502ddb39c03b09$var$Ab.push(a) : $b1502ddb39c03b09$var$Ab = [
        a
    ] : $b1502ddb39c03b09$var$zb = a;
}
function $b1502ddb39c03b09$var$Fb() {
    if ($b1502ddb39c03b09$var$zb) {
        var a = $b1502ddb39c03b09$var$zb, b = $b1502ddb39c03b09$var$Ab;
        $b1502ddb39c03b09$var$Ab = $b1502ddb39c03b09$var$zb = null;
        $b1502ddb39c03b09$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b1502ddb39c03b09$var$Bb(b[a]);
    }
}
function $b1502ddb39c03b09$var$Gb(a, b) {
    return a(b);
}
function $b1502ddb39c03b09$var$Hb() {}
var $b1502ddb39c03b09$var$Ib = !1;
function $b1502ddb39c03b09$var$Jb(a, b, c) {
    if ($b1502ddb39c03b09$var$Ib) return a(b, c);
    $b1502ddb39c03b09$var$Ib = !0;
    try {
        return $b1502ddb39c03b09$var$Gb(a, b, c);
    } finally{
        if ($b1502ddb39c03b09$var$Ib = !1, null !== $b1502ddb39c03b09$var$zb || null !== $b1502ddb39c03b09$var$Ab) $b1502ddb39c03b09$var$Hb(), $b1502ddb39c03b09$var$Fb();
    }
}
function $b1502ddb39c03b09$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b1502ddb39c03b09$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b1502ddb39c03b09$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $gnDeW._)(c)));
    return c;
}
var $b1502ddb39c03b09$var$Lb = !1;
if ($b1502ddb39c03b09$var$ia) try {
    var $b1502ddb39c03b09$var$Mb = {};
    Object.defineProperty($b1502ddb39c03b09$var$Mb, "passive", {
        get: function get() {
            $b1502ddb39c03b09$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b1502ddb39c03b09$var$Mb, $b1502ddb39c03b09$var$Mb);
    window.removeEventListener("test", $b1502ddb39c03b09$var$Mb, $b1502ddb39c03b09$var$Mb);
} catch (a) {
    $b1502ddb39c03b09$var$Lb = !1;
}
function $b1502ddb39c03b09$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b1502ddb39c03b09$var$Ob = !1, $b1502ddb39c03b09$var$Pb = null, $b1502ddb39c03b09$var$Qb = !1, $b1502ddb39c03b09$var$Rb = null, $b1502ddb39c03b09$var$Sb = {
    onError: function onError(a) {
        $b1502ddb39c03b09$var$Ob = !0;
        $b1502ddb39c03b09$var$Pb = a;
    }
};
function $b1502ddb39c03b09$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b1502ddb39c03b09$var$Ob = !1;
    $b1502ddb39c03b09$var$Pb = null;
    $b1502ddb39c03b09$var$Nb.apply($b1502ddb39c03b09$var$Sb, arguments);
}
function $b1502ddb39c03b09$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b1502ddb39c03b09$var$Tb.apply(this, arguments);
    if ($b1502ddb39c03b09$var$Ob) {
        if ($b1502ddb39c03b09$var$Ob) {
            var l = $b1502ddb39c03b09$var$Pb;
            $b1502ddb39c03b09$var$Ob = !1;
            $b1502ddb39c03b09$var$Pb = null;
        } else throw Error($b1502ddb39c03b09$var$p(198));
        $b1502ddb39c03b09$var$Qb || ($b1502ddb39c03b09$var$Qb = !0, $b1502ddb39c03b09$var$Rb = l);
    }
}
function $b1502ddb39c03b09$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b1502ddb39c03b09$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b1502ddb39c03b09$var$Xb(a) {
    if ($b1502ddb39c03b09$var$Vb(a) !== a) throw Error($b1502ddb39c03b09$var$p(188));
}
function $b1502ddb39c03b09$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b1502ddb39c03b09$var$Vb(a);
        if (null === b) throw Error($b1502ddb39c03b09$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b1502ddb39c03b09$var$Xb(e), a;
                if (f === d) return $b1502ddb39c03b09$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b1502ddb39c03b09$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b1502ddb39c03b09$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b1502ddb39c03b09$var$p(190));
    }
    if (3 !== c.tag) throw Error($b1502ddb39c03b09$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b1502ddb39c03b09$var$Zb(a) {
    a = $b1502ddb39c03b09$var$Yb(a);
    return null !== a ? $b1502ddb39c03b09$var$$b(a) : null;
}
function $b1502ddb39c03b09$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b1502ddb39c03b09$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b1502ddb39c03b09$var$ac = $bE6KD.unstable_scheduleCallback, $b1502ddb39c03b09$var$bc = $bE6KD.unstable_cancelCallback, $b1502ddb39c03b09$var$cc = $bE6KD.unstable_shouldYield, $b1502ddb39c03b09$var$dc = $bE6KD.unstable_requestPaint, $b1502ddb39c03b09$var$B = $bE6KD.unstable_now, $b1502ddb39c03b09$var$ec = $bE6KD.unstable_getCurrentPriorityLevel, $b1502ddb39c03b09$var$fc = $bE6KD.unstable_ImmediatePriority, $b1502ddb39c03b09$var$gc = $bE6KD.unstable_UserBlockingPriority, $b1502ddb39c03b09$var$hc = $bE6KD.unstable_NormalPriority, $b1502ddb39c03b09$var$ic = $bE6KD.unstable_LowPriority, $b1502ddb39c03b09$var$jc = $bE6KD.unstable_IdlePriority, $b1502ddb39c03b09$var$kc = null, $b1502ddb39c03b09$var$lc = null;
function $b1502ddb39c03b09$var$mc(a) {
    if ($b1502ddb39c03b09$var$lc && "function" === typeof $b1502ddb39c03b09$var$lc.onCommitFiberRoot) try {
        $b1502ddb39c03b09$var$lc.onCommitFiberRoot($b1502ddb39c03b09$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b1502ddb39c03b09$var$oc = Math.clz32 ? Math.clz32 : $b1502ddb39c03b09$var$nc, $b1502ddb39c03b09$var$pc = Math.log, $b1502ddb39c03b09$var$qc = Math.LN2;
function $b1502ddb39c03b09$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b1502ddb39c03b09$var$pc(a) / $b1502ddb39c03b09$var$qc | 0) | 0;
}
var $b1502ddb39c03b09$var$rc = 64, $b1502ddb39c03b09$var$sc = 4194304;
function $b1502ddb39c03b09$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b1502ddb39c03b09$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b1502ddb39c03b09$var$tc(h) : (f &= g, 0 !== f && (d = $b1502ddb39c03b09$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b1502ddb39c03b09$var$tc(g) : 0 !== f && (d = $b1502ddb39c03b09$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b1502ddb39c03b09$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b1502ddb39c03b09$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b1502ddb39c03b09$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b1502ddb39c03b09$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b1502ddb39c03b09$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b1502ddb39c03b09$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b1502ddb39c03b09$var$yc() {
    var a = $b1502ddb39c03b09$var$rc;
    $b1502ddb39c03b09$var$rc <<= 1;
    0 === ($b1502ddb39c03b09$var$rc & 4194240) && ($b1502ddb39c03b09$var$rc = 64);
    return a;
}
function $b1502ddb39c03b09$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b1502ddb39c03b09$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b1502ddb39c03b09$var$oc(b);
    a[b] = c;
}
function $b1502ddb39c03b09$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b1502ddb39c03b09$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b1502ddb39c03b09$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b1502ddb39c03b09$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b1502ddb39c03b09$var$C = 0;
function $b1502ddb39c03b09$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b1502ddb39c03b09$var$Ec, $b1502ddb39c03b09$var$Fc, $b1502ddb39c03b09$var$Gc, $b1502ddb39c03b09$var$Hc, $b1502ddb39c03b09$var$Ic, $b1502ddb39c03b09$var$Jc = !1, $b1502ddb39c03b09$var$Kc = [], $b1502ddb39c03b09$var$Lc = null, $b1502ddb39c03b09$var$Mc = null, $b1502ddb39c03b09$var$Nc = null, $b1502ddb39c03b09$var$Oc = new Map, $b1502ddb39c03b09$var$Pc = new Map, $b1502ddb39c03b09$var$Qc = [], $b1502ddb39c03b09$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b1502ddb39c03b09$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b1502ddb39c03b09$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b1502ddb39c03b09$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b1502ddb39c03b09$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b1502ddb39c03b09$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b1502ddb39c03b09$var$Pc.delete(b.pointerId);
    }
}
function $b1502ddb39c03b09$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b1502ddb39c03b09$var$Cb(b), null !== b && $b1502ddb39c03b09$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b1502ddb39c03b09$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b1502ddb39c03b09$var$Lc = $b1502ddb39c03b09$var$Tc($b1502ddb39c03b09$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b1502ddb39c03b09$var$Mc = $b1502ddb39c03b09$var$Tc($b1502ddb39c03b09$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b1502ddb39c03b09$var$Nc = $b1502ddb39c03b09$var$Tc($b1502ddb39c03b09$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b1502ddb39c03b09$var$Oc.set(f, $b1502ddb39c03b09$var$Tc($b1502ddb39c03b09$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b1502ddb39c03b09$var$Pc.set(f, $b1502ddb39c03b09$var$Tc($b1502ddb39c03b09$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b1502ddb39c03b09$var$Vc(a) {
    var b = $b1502ddb39c03b09$var$Wc(a.target);
    if (null !== b) {
        var c = $b1502ddb39c03b09$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b1502ddb39c03b09$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b1502ddb39c03b09$var$Ic(a.priority, function() {
                        $b1502ddb39c03b09$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b1502ddb39c03b09$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b1502ddb39c03b09$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b1502ddb39c03b09$var$wb = d;
            c.target.dispatchEvent(d);
            $b1502ddb39c03b09$var$wb = null;
        } else return b = $b1502ddb39c03b09$var$Cb(c), null !== b && $b1502ddb39c03b09$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b1502ddb39c03b09$var$Zc(a, b, c) {
    $b1502ddb39c03b09$var$Xc(a) && c.delete(b);
}
function $b1502ddb39c03b09$var$$c() {
    $b1502ddb39c03b09$var$Jc = !1;
    null !== $b1502ddb39c03b09$var$Lc && $b1502ddb39c03b09$var$Xc($b1502ddb39c03b09$var$Lc) && ($b1502ddb39c03b09$var$Lc = null);
    null !== $b1502ddb39c03b09$var$Mc && $b1502ddb39c03b09$var$Xc($b1502ddb39c03b09$var$Mc) && ($b1502ddb39c03b09$var$Mc = null);
    null !== $b1502ddb39c03b09$var$Nc && $b1502ddb39c03b09$var$Xc($b1502ddb39c03b09$var$Nc) && ($b1502ddb39c03b09$var$Nc = null);
    $b1502ddb39c03b09$var$Oc.forEach($b1502ddb39c03b09$var$Zc);
    $b1502ddb39c03b09$var$Pc.forEach($b1502ddb39c03b09$var$Zc);
}
function $b1502ddb39c03b09$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b1502ddb39c03b09$var$Jc || ($b1502ddb39c03b09$var$Jc = !0, $bE6KD.unstable_scheduleCallback($bE6KD.unstable_NormalPriority, $b1502ddb39c03b09$var$$c)));
}
function $b1502ddb39c03b09$var$bd(a) {
    function b(b) {
        return $b1502ddb39c03b09$var$ad(b, a);
    }
    if (0 < $b1502ddb39c03b09$var$Kc.length) {
        $b1502ddb39c03b09$var$ad($b1502ddb39c03b09$var$Kc[0], a);
        for(var c = 1; c < $b1502ddb39c03b09$var$Kc.length; c++){
            var d = $b1502ddb39c03b09$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b1502ddb39c03b09$var$Lc && $b1502ddb39c03b09$var$ad($b1502ddb39c03b09$var$Lc, a);
    null !== $b1502ddb39c03b09$var$Mc && $b1502ddb39c03b09$var$ad($b1502ddb39c03b09$var$Mc, a);
    null !== $b1502ddb39c03b09$var$Nc && $b1502ddb39c03b09$var$ad($b1502ddb39c03b09$var$Nc, a);
    $b1502ddb39c03b09$var$Oc.forEach(b);
    $b1502ddb39c03b09$var$Pc.forEach(b);
    for(c = 0; c < $b1502ddb39c03b09$var$Qc.length; c++)d = $b1502ddb39c03b09$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b1502ddb39c03b09$var$Qc.length && (c = $b1502ddb39c03b09$var$Qc[0], null === c.blockedOn);)$b1502ddb39c03b09$var$Vc(c), null === c.blockedOn && $b1502ddb39c03b09$var$Qc.shift();
}
var $b1502ddb39c03b09$var$cd = $b1502ddb39c03b09$var$ua.ReactCurrentBatchConfig, $b1502ddb39c03b09$var$dd = !0;
function $b1502ddb39c03b09$var$ed(a, b, c, d) {
    var e = $b1502ddb39c03b09$var$C, f = $b1502ddb39c03b09$var$cd.transition;
    $b1502ddb39c03b09$var$cd.transition = null;
    try {
        $b1502ddb39c03b09$var$C = 1, $b1502ddb39c03b09$var$fd(a, b, c, d);
    } finally{
        $b1502ddb39c03b09$var$C = e, $b1502ddb39c03b09$var$cd.transition = f;
    }
}
function $b1502ddb39c03b09$var$gd(a, b, c, d) {
    var e = $b1502ddb39c03b09$var$C, f = $b1502ddb39c03b09$var$cd.transition;
    $b1502ddb39c03b09$var$cd.transition = null;
    try {
        $b1502ddb39c03b09$var$C = 4, $b1502ddb39c03b09$var$fd(a, b, c, d);
    } finally{
        $b1502ddb39c03b09$var$C = e, $b1502ddb39c03b09$var$cd.transition = f;
    }
}
function $b1502ddb39c03b09$var$fd(a, b, c, d) {
    if ($b1502ddb39c03b09$var$dd) {
        var e = $b1502ddb39c03b09$var$Yc(a, b, c, d);
        if (null === e) $b1502ddb39c03b09$var$hd(a, b, d, $b1502ddb39c03b09$var$id, c), $b1502ddb39c03b09$var$Sc(a, d);
        else if ($b1502ddb39c03b09$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b1502ddb39c03b09$var$Sc(a, d), b & 4 && -1 < $b1502ddb39c03b09$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b1502ddb39c03b09$var$Cb(e);
                null !== f && $b1502ddb39c03b09$var$Ec(f);
                f = $b1502ddb39c03b09$var$Yc(a, b, c, d);
                null === f && $b1502ddb39c03b09$var$hd(a, b, d, $b1502ddb39c03b09$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b1502ddb39c03b09$var$hd(a, b, d, null, c);
    }
}
var $b1502ddb39c03b09$var$id = null;
function $b1502ddb39c03b09$var$Yc(a, b, c, d) {
    $b1502ddb39c03b09$var$id = null;
    a = $b1502ddb39c03b09$var$xb(d);
    a = $b1502ddb39c03b09$var$Wc(a);
    if (null !== a) {
        if (b = $b1502ddb39c03b09$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b1502ddb39c03b09$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b1502ddb39c03b09$var$id = a;
    return null;
}
function $b1502ddb39c03b09$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b1502ddb39c03b09$var$ec()){
                case $b1502ddb39c03b09$var$fc:
                    return 1;
                case $b1502ddb39c03b09$var$gc:
                    return 4;
                case $b1502ddb39c03b09$var$hc:
                case $b1502ddb39c03b09$var$ic:
                    return 16;
                case $b1502ddb39c03b09$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b1502ddb39c03b09$var$kd = null, $b1502ddb39c03b09$var$ld = null, $b1502ddb39c03b09$var$md = null;
function $b1502ddb39c03b09$var$nd() {
    if ($b1502ddb39c03b09$var$md) return $b1502ddb39c03b09$var$md;
    var a, b = $b1502ddb39c03b09$var$ld, c = b.length, d, e = "value" in $b1502ddb39c03b09$var$kd ? $b1502ddb39c03b09$var$kd.value : $b1502ddb39c03b09$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b1502ddb39c03b09$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b1502ddb39c03b09$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b1502ddb39c03b09$var$pd() {
    return !0;
}
function $b1502ddb39c03b09$var$qd() {
    return !1;
}
function $b1502ddb39c03b09$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b1502ddb39c03b09$var$pd : $b1502ddb39c03b09$var$qd;
        this.isPropagationStopped = $b1502ddb39c03b09$var$qd;
        return this;
    }
    $b1502ddb39c03b09$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $gnDeW._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $b1502ddb39c03b09$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $gnDeW._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $b1502ddb39c03b09$var$pd);
        },
        persist: function persist() {},
        isPersistent: $b1502ddb39c03b09$var$pd
    });
    return b;
}
var $b1502ddb39c03b09$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b1502ddb39c03b09$var$td = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$sd), $b1502ddb39c03b09$var$ud = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$sd, {
    view: 0,
    detail: 0
}), $b1502ddb39c03b09$var$vd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$ud), $b1502ddb39c03b09$var$wd, $b1502ddb39c03b09$var$xd, $b1502ddb39c03b09$var$yd, $b1502ddb39c03b09$var$Ad = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b1502ddb39c03b09$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b1502ddb39c03b09$var$yd && ($b1502ddb39c03b09$var$yd && "mousemove" === a.type ? ($b1502ddb39c03b09$var$wd = a.screenX - $b1502ddb39c03b09$var$yd.screenX, $b1502ddb39c03b09$var$xd = a.screenY - $b1502ddb39c03b09$var$yd.screenY) : $b1502ddb39c03b09$var$xd = $b1502ddb39c03b09$var$wd = 0, $b1502ddb39c03b09$var$yd = a);
        return $b1502ddb39c03b09$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $b1502ddb39c03b09$var$xd;
    }
}), $b1502ddb39c03b09$var$Bd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Ad), $b1502ddb39c03b09$var$Cd = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$Ad, {
    dataTransfer: 0
}), $b1502ddb39c03b09$var$Dd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Cd), $b1502ddb39c03b09$var$Ed = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$ud, {
    relatedTarget: 0
}), $b1502ddb39c03b09$var$Fd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Ed), $b1502ddb39c03b09$var$Gd = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b1502ddb39c03b09$var$Hd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Gd), $b1502ddb39c03b09$var$Id = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b1502ddb39c03b09$var$Jd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Id), $b1502ddb39c03b09$var$Kd = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$sd, {
    data: 0
}), $b1502ddb39c03b09$var$Ld = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Kd), $b1502ddb39c03b09$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b1502ddb39c03b09$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b1502ddb39c03b09$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b1502ddb39c03b09$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b1502ddb39c03b09$var$Od[a]) ? !!b[a] : !1;
}
function $b1502ddb39c03b09$var$zd() {
    return $b1502ddb39c03b09$var$Pd;
}
var $b1502ddb39c03b09$var$Qd = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $b1502ddb39c03b09$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b1502ddb39c03b09$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b1502ddb39c03b09$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b1502ddb39c03b09$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $b1502ddb39c03b09$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $b1502ddb39c03b09$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b1502ddb39c03b09$var$Rd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Qd), $b1502ddb39c03b09$var$Sd = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b1502ddb39c03b09$var$Td = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Sd), $b1502ddb39c03b09$var$Ud = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b1502ddb39c03b09$var$zd
}), $b1502ddb39c03b09$var$Vd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Ud), $b1502ddb39c03b09$var$Wd = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b1502ddb39c03b09$var$Xd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Wd), $b1502ddb39c03b09$var$Yd = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b1502ddb39c03b09$var$Zd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Yd), $b1502ddb39c03b09$var$$d = [
    9,
    13,
    27,
    32
], $b1502ddb39c03b09$var$ae = $b1502ddb39c03b09$var$ia && "CompositionEvent" in window, $b1502ddb39c03b09$var$be = null;
$b1502ddb39c03b09$var$ia && "documentMode" in document && ($b1502ddb39c03b09$var$be = document.documentMode);
var $b1502ddb39c03b09$var$ce = $b1502ddb39c03b09$var$ia && "TextEvent" in window && !$b1502ddb39c03b09$var$be, $b1502ddb39c03b09$var$de = $b1502ddb39c03b09$var$ia && (!$b1502ddb39c03b09$var$ae || $b1502ddb39c03b09$var$be && 8 < $b1502ddb39c03b09$var$be && 11 >= $b1502ddb39c03b09$var$be), $b1502ddb39c03b09$var$ee = String.fromCharCode(32), $b1502ddb39c03b09$var$fe = !1;
function $b1502ddb39c03b09$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b1502ddb39c03b09$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b1502ddb39c03b09$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b1502ddb39c03b09$var$ie = !1;
function $b1502ddb39c03b09$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b1502ddb39c03b09$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b1502ddb39c03b09$var$fe = !0;
            return $b1502ddb39c03b09$var$ee;
        case "textInput":
            return a = b.data, a === $b1502ddb39c03b09$var$ee && $b1502ddb39c03b09$var$fe ? null : a;
        default:
            return null;
    }
}
function $b1502ddb39c03b09$var$ke(a, b) {
    if ($b1502ddb39c03b09$var$ie) return "compositionend" === a || !$b1502ddb39c03b09$var$ae && $b1502ddb39c03b09$var$ge(a, b) ? (a = $b1502ddb39c03b09$var$nd(), $b1502ddb39c03b09$var$md = $b1502ddb39c03b09$var$ld = $b1502ddb39c03b09$var$kd = null, $b1502ddb39c03b09$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b1502ddb39c03b09$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b1502ddb39c03b09$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b1502ddb39c03b09$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b1502ddb39c03b09$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b1502ddb39c03b09$var$ne(a, b, c, d) {
    $b1502ddb39c03b09$var$Eb(d);
    b = $b1502ddb39c03b09$var$oe(b, "onChange");
    0 < b.length && (c = new $b1502ddb39c03b09$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b1502ddb39c03b09$var$pe = null, $b1502ddb39c03b09$var$qe = null;
function $b1502ddb39c03b09$var$re(a) {
    $b1502ddb39c03b09$var$se(a, 0);
}
function $b1502ddb39c03b09$var$te(a) {
    var b = $b1502ddb39c03b09$var$ue(a);
    if ($b1502ddb39c03b09$var$Wa(b)) return a;
}
function $b1502ddb39c03b09$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b1502ddb39c03b09$var$we = !1;
if ($b1502ddb39c03b09$var$ia) {
    var $b1502ddb39c03b09$var$xe;
    if ($b1502ddb39c03b09$var$ia) {
        var $b1502ddb39c03b09$var$ye = "oninput" in document;
        if (!$b1502ddb39c03b09$var$ye) {
            var $b1502ddb39c03b09$var$ze = document.createElement("div");
            $b1502ddb39c03b09$var$ze.setAttribute("oninput", "return;");
            $b1502ddb39c03b09$var$ye = "function" === typeof $b1502ddb39c03b09$var$ze.oninput;
        }
        $b1502ddb39c03b09$var$xe = $b1502ddb39c03b09$var$ye;
    } else $b1502ddb39c03b09$var$xe = !1;
    $b1502ddb39c03b09$var$we = $b1502ddb39c03b09$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b1502ddb39c03b09$var$Ae() {
    $b1502ddb39c03b09$var$pe && ($b1502ddb39c03b09$var$pe.detachEvent("onpropertychange", $b1502ddb39c03b09$var$Be), $b1502ddb39c03b09$var$qe = $b1502ddb39c03b09$var$pe = null);
}
function $b1502ddb39c03b09$var$Be(a) {
    if ("value" === a.propertyName && $b1502ddb39c03b09$var$te($b1502ddb39c03b09$var$qe)) {
        var b = [];
        $b1502ddb39c03b09$var$ne(b, $b1502ddb39c03b09$var$qe, a, $b1502ddb39c03b09$var$xb(a));
        $b1502ddb39c03b09$var$Jb($b1502ddb39c03b09$var$re, b);
    }
}
function $b1502ddb39c03b09$var$Ce(a, b, c) {
    "focusin" === a ? ($b1502ddb39c03b09$var$Ae(), $b1502ddb39c03b09$var$pe = b, $b1502ddb39c03b09$var$qe = c, $b1502ddb39c03b09$var$pe.attachEvent("onpropertychange", $b1502ddb39c03b09$var$Be)) : "focusout" === a && $b1502ddb39c03b09$var$Ae();
}
function $b1502ddb39c03b09$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b1502ddb39c03b09$var$te($b1502ddb39c03b09$var$qe);
}
function $b1502ddb39c03b09$var$Ee(a, b) {
    if ("click" === a) return $b1502ddb39c03b09$var$te(b);
}
function $b1502ddb39c03b09$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b1502ddb39c03b09$var$te(b);
}
function $b1502ddb39c03b09$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b1502ddb39c03b09$var$He = "function" === typeof Object.is ? Object.is : $b1502ddb39c03b09$var$Ge;
function $b1502ddb39c03b09$var$Ie(a, b) {
    if ($b1502ddb39c03b09$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b1502ddb39c03b09$var$ja.call(b, e) || !$b1502ddb39c03b09$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b1502ddb39c03b09$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b1502ddb39c03b09$var$Ke(a, b) {
    var c = $b1502ddb39c03b09$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b1502ddb39c03b09$var$Je(c);
    }
}
function $b1502ddb39c03b09$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b1502ddb39c03b09$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b1502ddb39c03b09$var$Me() {
    for(var a = window, b = $b1502ddb39c03b09$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b1502ddb39c03b09$var$Xa(a.document);
    }
    return b;
}
function $b1502ddb39c03b09$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b1502ddb39c03b09$var$Oe(a) {
    var b = $b1502ddb39c03b09$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b1502ddb39c03b09$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b1502ddb39c03b09$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b1502ddb39c03b09$var$Ke(c, f);
                var g = $b1502ddb39c03b09$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b1502ddb39c03b09$var$Pe = $b1502ddb39c03b09$var$ia && "documentMode" in document && 11 >= document.documentMode, $b1502ddb39c03b09$var$Qe = null, $b1502ddb39c03b09$var$Re = null, $b1502ddb39c03b09$var$Se = null, $b1502ddb39c03b09$var$Te = !1;
function $b1502ddb39c03b09$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b1502ddb39c03b09$var$Te || null == $b1502ddb39c03b09$var$Qe || $b1502ddb39c03b09$var$Qe !== $b1502ddb39c03b09$var$Xa(d) || (d = $b1502ddb39c03b09$var$Qe, "selectionStart" in d && $b1502ddb39c03b09$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b1502ddb39c03b09$var$Se && $b1502ddb39c03b09$var$Ie($b1502ddb39c03b09$var$Se, d) || ($b1502ddb39c03b09$var$Se = d, d = $b1502ddb39c03b09$var$oe($b1502ddb39c03b09$var$Re, "onSelect"), 0 < d.length && (b = new $b1502ddb39c03b09$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b1502ddb39c03b09$var$Qe)));
}
function $b1502ddb39c03b09$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b1502ddb39c03b09$var$We = {
    animationend: $b1502ddb39c03b09$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b1502ddb39c03b09$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b1502ddb39c03b09$var$Ve("Animation", "AnimationStart"),
    transitionend: $b1502ddb39c03b09$var$Ve("Transition", "TransitionEnd")
}, $b1502ddb39c03b09$var$Xe = {}, $b1502ddb39c03b09$var$Ye = {};
$b1502ddb39c03b09$var$ia && ($b1502ddb39c03b09$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b1502ddb39c03b09$var$We.animationend.animation, delete $b1502ddb39c03b09$var$We.animationiteration.animation, delete $b1502ddb39c03b09$var$We.animationstart.animation), "TransitionEvent" in window || delete $b1502ddb39c03b09$var$We.transitionend.transition);
function $b1502ddb39c03b09$var$Ze(a) {
    if ($b1502ddb39c03b09$var$Xe[a]) return $b1502ddb39c03b09$var$Xe[a];
    if (!$b1502ddb39c03b09$var$We[a]) return a;
    var b = $b1502ddb39c03b09$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b1502ddb39c03b09$var$Ye) return $b1502ddb39c03b09$var$Xe[a] = b[c];
    return a;
}
var $b1502ddb39c03b09$var$$e = $b1502ddb39c03b09$var$Ze("animationend"), $b1502ddb39c03b09$var$af = $b1502ddb39c03b09$var$Ze("animationiteration"), $b1502ddb39c03b09$var$bf = $b1502ddb39c03b09$var$Ze("animationstart"), $b1502ddb39c03b09$var$cf = $b1502ddb39c03b09$var$Ze("transitionend"), $b1502ddb39c03b09$var$df = new Map, $b1502ddb39c03b09$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b1502ddb39c03b09$var$ff(a, b) {
    $b1502ddb39c03b09$var$df.set(a, b);
    $b1502ddb39c03b09$var$fa(b, [
        a
    ]);
}
for(var $b1502ddb39c03b09$var$gf = 0; $b1502ddb39c03b09$var$gf < $b1502ddb39c03b09$var$ef.length; $b1502ddb39c03b09$var$gf++){
    var $b1502ddb39c03b09$var$hf = $b1502ddb39c03b09$var$ef[$b1502ddb39c03b09$var$gf], $b1502ddb39c03b09$var$jf = $b1502ddb39c03b09$var$hf.toLowerCase(), $b1502ddb39c03b09$var$kf = $b1502ddb39c03b09$var$hf[0].toUpperCase() + $b1502ddb39c03b09$var$hf.slice(1);
    $b1502ddb39c03b09$var$ff($b1502ddb39c03b09$var$jf, "on" + $b1502ddb39c03b09$var$kf);
}
$b1502ddb39c03b09$var$ff($b1502ddb39c03b09$var$$e, "onAnimationEnd");
$b1502ddb39c03b09$var$ff($b1502ddb39c03b09$var$af, "onAnimationIteration");
$b1502ddb39c03b09$var$ff($b1502ddb39c03b09$var$bf, "onAnimationStart");
$b1502ddb39c03b09$var$ff("dblclick", "onDoubleClick");
$b1502ddb39c03b09$var$ff("focusin", "onFocus");
$b1502ddb39c03b09$var$ff("focusout", "onBlur");
$b1502ddb39c03b09$var$ff($b1502ddb39c03b09$var$cf, "onTransitionEnd");
$b1502ddb39c03b09$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b1502ddb39c03b09$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b1502ddb39c03b09$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b1502ddb39c03b09$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b1502ddb39c03b09$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b1502ddb39c03b09$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b1502ddb39c03b09$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b1502ddb39c03b09$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b1502ddb39c03b09$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b1502ddb39c03b09$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b1502ddb39c03b09$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b1502ddb39c03b09$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b1502ddb39c03b09$var$lf));
function $b1502ddb39c03b09$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b1502ddb39c03b09$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b1502ddb39c03b09$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b1502ddb39c03b09$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b1502ddb39c03b09$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b1502ddb39c03b09$var$Qb) throw a = $b1502ddb39c03b09$var$Rb, $b1502ddb39c03b09$var$Qb = !1, $b1502ddb39c03b09$var$Rb = null, a;
}
function $b1502ddb39c03b09$var$D(a, b) {
    var c = b[$b1502ddb39c03b09$var$of];
    void 0 === c && (c = b[$b1502ddb39c03b09$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b1502ddb39c03b09$var$pf(b, a, 2, !1), c.add(d));
}
function $b1502ddb39c03b09$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b1502ddb39c03b09$var$pf(c, a, d, b);
}
var $b1502ddb39c03b09$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b1502ddb39c03b09$var$sf(a) {
    if (!a[$b1502ddb39c03b09$var$rf]) {
        a[$b1502ddb39c03b09$var$rf] = !0;
        $b1502ddb39c03b09$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b1502ddb39c03b09$var$mf.has(b) || $b1502ddb39c03b09$var$qf(b, !1, a), $b1502ddb39c03b09$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b1502ddb39c03b09$var$rf] || (b[$b1502ddb39c03b09$var$rf] = !0, $b1502ddb39c03b09$var$qf("selectionchange", !1, b));
    }
}
function $b1502ddb39c03b09$var$pf(a, b, c, d) {
    switch($b1502ddb39c03b09$var$jd(b)){
        case 1:
            var e = $b1502ddb39c03b09$var$ed;
            break;
        case 4:
            e = $b1502ddb39c03b09$var$gd;
            break;
        default:
            e = $b1502ddb39c03b09$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b1502ddb39c03b09$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b1502ddb39c03b09$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b1502ddb39c03b09$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b1502ddb39c03b09$var$Jb(function() {
        var _$d = f, _$e = $b1502ddb39c03b09$var$xb(c), g = [];
        a: {
            var h = $b1502ddb39c03b09$var$df.get(a);
            if (void 0 !== h) {
                var k = $b1502ddb39c03b09$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b1502ddb39c03b09$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b1502ddb39c03b09$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b1502ddb39c03b09$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b1502ddb39c03b09$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b1502ddb39c03b09$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b1502ddb39c03b09$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b1502ddb39c03b09$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b1502ddb39c03b09$var$Vd;
                        break;
                    case $b1502ddb39c03b09$var$$e:
                    case $b1502ddb39c03b09$var$af:
                    case $b1502ddb39c03b09$var$bf:
                        k = $b1502ddb39c03b09$var$Hd;
                        break;
                    case $b1502ddb39c03b09$var$cf:
                        k = $b1502ddb39c03b09$var$Xd;
                        break;
                    case "scroll":
                        k = $b1502ddb39c03b09$var$vd;
                        break;
                    case "wheel":
                        k = $b1502ddb39c03b09$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b1502ddb39c03b09$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b1502ddb39c03b09$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b1502ddb39c03b09$var$Kb(w, x), null != F && t.push($b1502ddb39c03b09$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b1502ddb39c03b09$var$wb && (n = c.relatedTarget || c.fromElement) && ($b1502ddb39c03b09$var$Wc(n) || n[$b1502ddb39c03b09$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $b1502ddb39c03b09$var$Wc(n) : null, null !== n && (J = $b1502ddb39c03b09$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $b1502ddb39c03b09$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b1502ddb39c03b09$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b1502ddb39c03b09$var$ue(k);
                        u = null == n ? h : $b1502ddb39c03b09$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b1502ddb39c03b09$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b1502ddb39c03b09$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b1502ddb39c03b09$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b1502ddb39c03b09$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b1502ddb39c03b09$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b1502ddb39c03b09$var$vf(t);
                                x = $b1502ddb39c03b09$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b1502ddb39c03b09$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b1502ddb39c03b09$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $b1502ddb39c03b09$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b1502ddb39c03b09$var$ve;
                else if ($b1502ddb39c03b09$var$me(h)) {
                    if ($b1502ddb39c03b09$var$we) na = $b1502ddb39c03b09$var$Fe;
                    else {
                        na = $b1502ddb39c03b09$var$De;
                        var xa = $b1502ddb39c03b09$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b1502ddb39c03b09$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $b1502ddb39c03b09$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b1502ddb39c03b09$var$cb(h, "number", h.value);
            }
            xa = _$d ? $b1502ddb39c03b09$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($b1502ddb39c03b09$var$me(xa) || "true" === xa.contentEditable) $b1502ddb39c03b09$var$Qe = xa, $b1502ddb39c03b09$var$Re = _$d, $b1502ddb39c03b09$var$Se = null;
                    break;
                case "focusout":
                    $b1502ddb39c03b09$var$Se = $b1502ddb39c03b09$var$Re = $b1502ddb39c03b09$var$Qe = null;
                    break;
                case "mousedown":
                    $b1502ddb39c03b09$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b1502ddb39c03b09$var$Te = !1;
                    $b1502ddb39c03b09$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($b1502ddb39c03b09$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b1502ddb39c03b09$var$Ue(g, c, _$e);
            }
            var $a;
            if ($b1502ddb39c03b09$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b1502ddb39c03b09$var$ie ? $b1502ddb39c03b09$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b1502ddb39c03b09$var$de && "ko" !== c.locale && ($b1502ddb39c03b09$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b1502ddb39c03b09$var$ie && ($a = $b1502ddb39c03b09$var$nd()) : ($b1502ddb39c03b09$var$kd = _$e, $b1502ddb39c03b09$var$ld = "value" in $b1502ddb39c03b09$var$kd ? $b1502ddb39c03b09$var$kd.value : $b1502ddb39c03b09$var$kd.textContent, $b1502ddb39c03b09$var$ie = !0)), xa = $b1502ddb39c03b09$var$oe(_$d, ba), 0 < xa.length && (ba = new $b1502ddb39c03b09$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b1502ddb39c03b09$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b1502ddb39c03b09$var$ce ? $b1502ddb39c03b09$var$je(a, c) : $b1502ddb39c03b09$var$ke(a, c)) _$d = $b1502ddb39c03b09$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $b1502ddb39c03b09$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $b1502ddb39c03b09$var$se(g, b);
    });
}
function $b1502ddb39c03b09$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b1502ddb39c03b09$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b1502ddb39c03b09$var$Kb(a, c), null != f && d.unshift($b1502ddb39c03b09$var$tf(a, f, e)), f = $b1502ddb39c03b09$var$Kb(a, b), null != f && d.push($b1502ddb39c03b09$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b1502ddb39c03b09$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b1502ddb39c03b09$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b1502ddb39c03b09$var$Kb(c, f), null != k && g.unshift($b1502ddb39c03b09$var$tf(c, k, h))) : e || (k = $b1502ddb39c03b09$var$Kb(c, f), null != k && g.push($b1502ddb39c03b09$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b1502ddb39c03b09$var$xf = /\r\n?/g, $b1502ddb39c03b09$var$yf = /\u0000|\uFFFD/g;
function $b1502ddb39c03b09$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b1502ddb39c03b09$var$xf, "\n").replace($b1502ddb39c03b09$var$yf, "");
}
function $b1502ddb39c03b09$var$Af(a, b, c) {
    b = $b1502ddb39c03b09$var$zf(b);
    if ($b1502ddb39c03b09$var$zf(a) !== b && c) throw Error($b1502ddb39c03b09$var$p(425));
}
function $b1502ddb39c03b09$var$Bf() {}
var $b1502ddb39c03b09$var$Cf = null, $b1502ddb39c03b09$var$Df = null;
function $b1502ddb39c03b09$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b1502ddb39c03b09$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b1502ddb39c03b09$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b1502ddb39c03b09$var$Hf = "function" === typeof Promise ? Promise : void 0, $b1502ddb39c03b09$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b1502ddb39c03b09$var$Hf ? function Jf(a) {
    return $b1502ddb39c03b09$var$Hf.resolve(null).then(a).catch($b1502ddb39c03b09$var$If);
} : $b1502ddb39c03b09$var$Ff;
function $b1502ddb39c03b09$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b1502ddb39c03b09$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b1502ddb39c03b09$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b1502ddb39c03b09$var$bd(b);
}
function $b1502ddb39c03b09$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b1502ddb39c03b09$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b1502ddb39c03b09$var$Nf = Math.random().toString(36).slice(2), $b1502ddb39c03b09$var$Of = "__reactFiber$" + $b1502ddb39c03b09$var$Nf, $b1502ddb39c03b09$var$Pf = "__reactProps$" + $b1502ddb39c03b09$var$Nf, $b1502ddb39c03b09$var$uf = "__reactContainer$" + $b1502ddb39c03b09$var$Nf, $b1502ddb39c03b09$var$of = "__reactEvents$" + $b1502ddb39c03b09$var$Nf, $b1502ddb39c03b09$var$Qf = "__reactListeners$" + $b1502ddb39c03b09$var$Nf, $b1502ddb39c03b09$var$Rf = "__reactHandles$" + $b1502ddb39c03b09$var$Nf;
function $b1502ddb39c03b09$var$Wc(a) {
    var b = a[$b1502ddb39c03b09$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b1502ddb39c03b09$var$uf] || c[$b1502ddb39c03b09$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b1502ddb39c03b09$var$Mf(a); null !== a;){
                if (c = a[$b1502ddb39c03b09$var$Of]) return c;
                a = $b1502ddb39c03b09$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b1502ddb39c03b09$var$Cb(a) {
    a = a[$b1502ddb39c03b09$var$Of] || a[$b1502ddb39c03b09$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b1502ddb39c03b09$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b1502ddb39c03b09$var$p(33));
}
function $b1502ddb39c03b09$var$Db(a) {
    return a[$b1502ddb39c03b09$var$Pf] || null;
}
var $b1502ddb39c03b09$var$Sf = [], $b1502ddb39c03b09$var$Tf = -1;
function $b1502ddb39c03b09$var$Uf(a) {
    return {
        current: a
    };
}
function $b1502ddb39c03b09$var$E(a) {
    0 > $b1502ddb39c03b09$var$Tf || (a.current = $b1502ddb39c03b09$var$Sf[$b1502ddb39c03b09$var$Tf], $b1502ddb39c03b09$var$Sf[$b1502ddb39c03b09$var$Tf] = null, $b1502ddb39c03b09$var$Tf--);
}
function $b1502ddb39c03b09$var$G(a, b) {
    $b1502ddb39c03b09$var$Tf++;
    $b1502ddb39c03b09$var$Sf[$b1502ddb39c03b09$var$Tf] = a.current;
    a.current = b;
}
var $b1502ddb39c03b09$var$Vf = {}, $b1502ddb39c03b09$var$H = $b1502ddb39c03b09$var$Uf($b1502ddb39c03b09$var$Vf), $b1502ddb39c03b09$var$Wf = $b1502ddb39c03b09$var$Uf(!1), $b1502ddb39c03b09$var$Xf = $b1502ddb39c03b09$var$Vf;
function $b1502ddb39c03b09$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b1502ddb39c03b09$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b1502ddb39c03b09$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b1502ddb39c03b09$var$$f() {
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$Wf);
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$H);
}
function $b1502ddb39c03b09$var$ag(a, b, c) {
    if ($b1502ddb39c03b09$var$H.current !== $b1502ddb39c03b09$var$Vf) throw Error($b1502ddb39c03b09$var$p(168));
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$H, b);
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$Wf, c);
}
function $b1502ddb39c03b09$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b1502ddb39c03b09$var$p(108, $b1502ddb39c03b09$var$Ra(a) || "Unknown", e));
    return $b1502ddb39c03b09$var$A({}, c, d);
}
function $b1502ddb39c03b09$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b1502ddb39c03b09$var$Vf;
    $b1502ddb39c03b09$var$Xf = $b1502ddb39c03b09$var$H.current;
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$H, a);
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$Wf, $b1502ddb39c03b09$var$Wf.current);
    return !0;
}
function $b1502ddb39c03b09$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b1502ddb39c03b09$var$p(169));
    c ? (a = $b1502ddb39c03b09$var$bg(a, b, $b1502ddb39c03b09$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$Wf), $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$H), $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$H, a)) : $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$Wf);
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$Wf, c);
}
var $b1502ddb39c03b09$var$eg = null, $b1502ddb39c03b09$var$fg = !1, $b1502ddb39c03b09$var$gg = !1;
function $b1502ddb39c03b09$var$hg(a) {
    null === $b1502ddb39c03b09$var$eg ? $b1502ddb39c03b09$var$eg = [
        a
    ] : $b1502ddb39c03b09$var$eg.push(a);
}
function $b1502ddb39c03b09$var$ig(a) {
    $b1502ddb39c03b09$var$fg = !0;
    $b1502ddb39c03b09$var$hg(a);
}
function $b1502ddb39c03b09$var$jg() {
    if (!$b1502ddb39c03b09$var$gg && null !== $b1502ddb39c03b09$var$eg) {
        $b1502ddb39c03b09$var$gg = !0;
        var a = 0, b = $b1502ddb39c03b09$var$C;
        try {
            var c = $b1502ddb39c03b09$var$eg;
            for($b1502ddb39c03b09$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b1502ddb39c03b09$var$eg = null;
            $b1502ddb39c03b09$var$fg = !1;
        } catch (e) {
            throw null !== $b1502ddb39c03b09$var$eg && ($b1502ddb39c03b09$var$eg = $b1502ddb39c03b09$var$eg.slice(a + 1)), $b1502ddb39c03b09$var$ac($b1502ddb39c03b09$var$fc, $b1502ddb39c03b09$var$jg), e;
        } finally{
            $b1502ddb39c03b09$var$C = b, $b1502ddb39c03b09$var$gg = !1;
        }
    }
    return null;
}
var $b1502ddb39c03b09$var$kg = [], $b1502ddb39c03b09$var$lg = 0, $b1502ddb39c03b09$var$mg = null, $b1502ddb39c03b09$var$ng = 0, $b1502ddb39c03b09$var$og = [], $b1502ddb39c03b09$var$pg = 0, $b1502ddb39c03b09$var$qg = null, $b1502ddb39c03b09$var$rg = 1, $b1502ddb39c03b09$var$sg = "";
function $b1502ddb39c03b09$var$tg(a, b) {
    $b1502ddb39c03b09$var$kg[$b1502ddb39c03b09$var$lg++] = $b1502ddb39c03b09$var$ng;
    $b1502ddb39c03b09$var$kg[$b1502ddb39c03b09$var$lg++] = $b1502ddb39c03b09$var$mg;
    $b1502ddb39c03b09$var$mg = a;
    $b1502ddb39c03b09$var$ng = b;
}
function $b1502ddb39c03b09$var$ug(a, b, c) {
    $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg++] = $b1502ddb39c03b09$var$rg;
    $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg++] = $b1502ddb39c03b09$var$sg;
    $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg++] = $b1502ddb39c03b09$var$qg;
    $b1502ddb39c03b09$var$qg = a;
    var d = $b1502ddb39c03b09$var$rg;
    a = $b1502ddb39c03b09$var$sg;
    var e = 32 - $b1502ddb39c03b09$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b1502ddb39c03b09$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b1502ddb39c03b09$var$rg = 1 << 32 - $b1502ddb39c03b09$var$oc(b) + e | c << e | d;
        $b1502ddb39c03b09$var$sg = f + a;
    } else $b1502ddb39c03b09$var$rg = 1 << f | c << e | d, $b1502ddb39c03b09$var$sg = a;
}
function $b1502ddb39c03b09$var$vg(a) {
    null !== a.return && ($b1502ddb39c03b09$var$tg(a, 1), $b1502ddb39c03b09$var$ug(a, 1, 0));
}
function $b1502ddb39c03b09$var$wg(a) {
    for(; a === $b1502ddb39c03b09$var$mg;)$b1502ddb39c03b09$var$mg = $b1502ddb39c03b09$var$kg[--$b1502ddb39c03b09$var$lg], $b1502ddb39c03b09$var$kg[$b1502ddb39c03b09$var$lg] = null, $b1502ddb39c03b09$var$ng = $b1502ddb39c03b09$var$kg[--$b1502ddb39c03b09$var$lg], $b1502ddb39c03b09$var$kg[$b1502ddb39c03b09$var$lg] = null;
    for(; a === $b1502ddb39c03b09$var$qg;)$b1502ddb39c03b09$var$qg = $b1502ddb39c03b09$var$og[--$b1502ddb39c03b09$var$pg], $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg] = null, $b1502ddb39c03b09$var$sg = $b1502ddb39c03b09$var$og[--$b1502ddb39c03b09$var$pg], $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg] = null, $b1502ddb39c03b09$var$rg = $b1502ddb39c03b09$var$og[--$b1502ddb39c03b09$var$pg], $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg] = null;
}
var $b1502ddb39c03b09$var$xg = null, $b1502ddb39c03b09$var$yg = null, $b1502ddb39c03b09$var$I = !1, $b1502ddb39c03b09$var$zg = null;
function $b1502ddb39c03b09$var$Ag(a, b) {
    var c = $b1502ddb39c03b09$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b1502ddb39c03b09$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b1502ddb39c03b09$var$xg = a, $b1502ddb39c03b09$var$yg = $b1502ddb39c03b09$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b1502ddb39c03b09$var$xg = a, $b1502ddb39c03b09$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b1502ddb39c03b09$var$qg ? {
                id: $b1502ddb39c03b09$var$rg,
                overflow: $b1502ddb39c03b09$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b1502ddb39c03b09$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b1502ddb39c03b09$var$xg = a, $b1502ddb39c03b09$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b1502ddb39c03b09$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b1502ddb39c03b09$var$Eg(a) {
    if ($b1502ddb39c03b09$var$I) {
        var b = $b1502ddb39c03b09$var$yg;
        if (b) {
            var c = b;
            if (!$b1502ddb39c03b09$var$Cg(a, b)) {
                if ($b1502ddb39c03b09$var$Dg(a)) throw Error($b1502ddb39c03b09$var$p(418));
                b = $b1502ddb39c03b09$var$Lf(c.nextSibling);
                var d = $b1502ddb39c03b09$var$xg;
                b && $b1502ddb39c03b09$var$Cg(a, b) ? $b1502ddb39c03b09$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b1502ddb39c03b09$var$I = !1, $b1502ddb39c03b09$var$xg = a);
            }
        } else {
            if ($b1502ddb39c03b09$var$Dg(a)) throw Error($b1502ddb39c03b09$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b1502ddb39c03b09$var$I = !1;
            $b1502ddb39c03b09$var$xg = a;
        }
    }
}
function $b1502ddb39c03b09$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b1502ddb39c03b09$var$xg = a;
}
function $b1502ddb39c03b09$var$Gg(a) {
    if (a !== $b1502ddb39c03b09$var$xg) return !1;
    if (!$b1502ddb39c03b09$var$I) return $b1502ddb39c03b09$var$Fg(a), $b1502ddb39c03b09$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b1502ddb39c03b09$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b1502ddb39c03b09$var$yg)) {
        if ($b1502ddb39c03b09$var$Dg(a)) throw $b1502ddb39c03b09$var$Hg(), Error($b1502ddb39c03b09$var$p(418));
        for(; b;)$b1502ddb39c03b09$var$Ag(a, b), b = $b1502ddb39c03b09$var$Lf(b.nextSibling);
    }
    $b1502ddb39c03b09$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b1502ddb39c03b09$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b1502ddb39c03b09$var$yg = $b1502ddb39c03b09$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b1502ddb39c03b09$var$yg = null;
        }
    } else $b1502ddb39c03b09$var$yg = $b1502ddb39c03b09$var$xg ? $b1502ddb39c03b09$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b1502ddb39c03b09$var$Hg() {
    for(var a = $b1502ddb39c03b09$var$yg; a;)a = $b1502ddb39c03b09$var$Lf(a.nextSibling);
}
function $b1502ddb39c03b09$var$Ig() {
    $b1502ddb39c03b09$var$yg = $b1502ddb39c03b09$var$xg = null;
    $b1502ddb39c03b09$var$I = !1;
}
function $b1502ddb39c03b09$var$Jg(a) {
    null === $b1502ddb39c03b09$var$zg ? $b1502ddb39c03b09$var$zg = [
        a
    ] : $b1502ddb39c03b09$var$zg.push(a);
}
var $b1502ddb39c03b09$var$Kg = $b1502ddb39c03b09$var$ua.ReactCurrentBatchConfig;
function $b1502ddb39c03b09$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b1502ddb39c03b09$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b1502ddb39c03b09$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b1502ddb39c03b09$var$p(284));
        if (!c._owner) throw Error($b1502ddb39c03b09$var$p(290, a));
    }
    return a;
}
function $b1502ddb39c03b09$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b1502ddb39c03b09$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b1502ddb39c03b09$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $b1502ddb39c03b09$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b1502ddb39c03b09$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b1502ddb39c03b09$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b1502ddb39c03b09$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b1502ddb39c03b09$var$Ha && $b1502ddb39c03b09$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $b1502ddb39c03b09$var$Lg(a, b, c), d.return = a, d;
        d = $b1502ddb39c03b09$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b1502ddb39c03b09$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b1502ddb39c03b09$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b1502ddb39c03b09$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b1502ddb39c03b09$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b1502ddb39c03b09$var$va:
                    return c = $b1502ddb39c03b09$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b1502ddb39c03b09$var$Lg(a, null, b), c.return = a, c;
                case $b1502ddb39c03b09$var$wa:
                    return b = $b1502ddb39c03b09$var$Sg(b, a.mode, c), b.return = a, b;
                case $b1502ddb39c03b09$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b1502ddb39c03b09$var$eb(b) || $b1502ddb39c03b09$var$Ka(b)) return b = $b1502ddb39c03b09$var$Tg(b, a.mode, c, null), b.return = a, b;
            $b1502ddb39c03b09$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b1502ddb39c03b09$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b1502ddb39c03b09$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b1502ddb39c03b09$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b1502ddb39c03b09$var$eb(c) || $b1502ddb39c03b09$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b1502ddb39c03b09$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b1502ddb39c03b09$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b1502ddb39c03b09$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b1502ddb39c03b09$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b1502ddb39c03b09$var$eb(d) || $b1502ddb39c03b09$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b1502ddb39c03b09$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b1502ddb39c03b09$var$I && $b1502ddb39c03b09$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b1502ddb39c03b09$var$I && $b1502ddb39c03b09$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b1502ddb39c03b09$var$I && $b1502ddb39c03b09$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b1502ddb39c03b09$var$Ka(h);
        if ("function" !== typeof l) throw Error($b1502ddb39c03b09$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b1502ddb39c03b09$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b1502ddb39c03b09$var$I && $b1502ddb39c03b09$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b1502ddb39c03b09$var$I && $b1502ddb39c03b09$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b1502ddb39c03b09$var$I && $b1502ddb39c03b09$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b1502ddb39c03b09$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b1502ddb39c03b09$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b1502ddb39c03b09$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b1502ddb39c03b09$var$Ha && $b1502ddb39c03b09$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b1502ddb39c03b09$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b1502ddb39c03b09$var$ya ? (d = $b1502ddb39c03b09$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b1502ddb39c03b09$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b1502ddb39c03b09$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b1502ddb39c03b09$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b1502ddb39c03b09$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b1502ddb39c03b09$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b1502ddb39c03b09$var$eb(f)) return n(a, d, f, h);
            if ($b1502ddb39c03b09$var$Ka(f)) return t(a, d, f, h);
            $b1502ddb39c03b09$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b1502ddb39c03b09$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b1502ddb39c03b09$var$Ug = $b1502ddb39c03b09$var$Og(!0), $b1502ddb39c03b09$var$Vg = $b1502ddb39c03b09$var$Og(!1), $b1502ddb39c03b09$var$Wg = $b1502ddb39c03b09$var$Uf(null), $b1502ddb39c03b09$var$Xg = null, $b1502ddb39c03b09$var$Yg = null, $b1502ddb39c03b09$var$Zg = null;
function $b1502ddb39c03b09$var$$g() {
    $b1502ddb39c03b09$var$Zg = $b1502ddb39c03b09$var$Yg = $b1502ddb39c03b09$var$Xg = null;
}
function $b1502ddb39c03b09$var$ah(a) {
    var b = $b1502ddb39c03b09$var$Wg.current;
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$Wg);
    a._currentValue = b;
}
function $b1502ddb39c03b09$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b1502ddb39c03b09$var$ch(a, b) {
    $b1502ddb39c03b09$var$Xg = a;
    $b1502ddb39c03b09$var$Zg = $b1502ddb39c03b09$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b1502ddb39c03b09$var$dh = !0), a.firstContext = null);
}
function $b1502ddb39c03b09$var$eh(a) {
    var b = a._currentValue;
    if ($b1502ddb39c03b09$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b1502ddb39c03b09$var$Yg) {
            if (null === $b1502ddb39c03b09$var$Xg) throw Error($b1502ddb39c03b09$var$p(308));
            $b1502ddb39c03b09$var$Yg = a;
            $b1502ddb39c03b09$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b1502ddb39c03b09$var$Yg = $b1502ddb39c03b09$var$Yg.next = a;
    }
    return b;
}
var $b1502ddb39c03b09$var$fh = null;
function $b1502ddb39c03b09$var$gh(a) {
    null === $b1502ddb39c03b09$var$fh ? $b1502ddb39c03b09$var$fh = [
        a
    ] : $b1502ddb39c03b09$var$fh.push(a);
}
function $b1502ddb39c03b09$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b1502ddb39c03b09$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b1502ddb39c03b09$var$ih(a, d);
}
function $b1502ddb39c03b09$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b1502ddb39c03b09$var$jh = !1;
function $b1502ddb39c03b09$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b1502ddb39c03b09$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b1502ddb39c03b09$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b1502ddb39c03b09$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b1502ddb39c03b09$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b1502ddb39c03b09$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b1502ddb39c03b09$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b1502ddb39c03b09$var$ih(a, c);
}
function $b1502ddb39c03b09$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b1502ddb39c03b09$var$Cc(a, c);
    }
}
function $b1502ddb39c03b09$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b1502ddb39c03b09$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $b1502ddb39c03b09$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b1502ddb39c03b09$var$A({}, q, r);
                            break a;
                        case 2:
                            $b1502ddb39c03b09$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b1502ddb39c03b09$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b1502ddb39c03b09$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b1502ddb39c03b09$var$p(191, e));
            e.call(d);
        }
    }
}
var $b1502ddb39c03b09$var$th = {}, $b1502ddb39c03b09$var$uh = $b1502ddb39c03b09$var$Uf($b1502ddb39c03b09$var$th), $b1502ddb39c03b09$var$vh = $b1502ddb39c03b09$var$Uf($b1502ddb39c03b09$var$th), $b1502ddb39c03b09$var$wh = $b1502ddb39c03b09$var$Uf($b1502ddb39c03b09$var$th);
function $b1502ddb39c03b09$var$xh(a) {
    if (a === $b1502ddb39c03b09$var$th) throw Error($b1502ddb39c03b09$var$p(174));
    return a;
}
function $b1502ddb39c03b09$var$yh(a, b) {
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$wh, b);
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$vh, a);
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$uh, $b1502ddb39c03b09$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b1502ddb39c03b09$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b1502ddb39c03b09$var$lb(b, a);
    }
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$uh);
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$uh, b);
}
function $b1502ddb39c03b09$var$zh() {
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$uh);
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$vh);
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$wh);
}
function $b1502ddb39c03b09$var$Ah(a) {
    $b1502ddb39c03b09$var$xh($b1502ddb39c03b09$var$wh.current);
    var b = $b1502ddb39c03b09$var$xh($b1502ddb39c03b09$var$uh.current);
    var c = $b1502ddb39c03b09$var$lb(b, a.type);
    b !== c && ($b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$vh, a), $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$uh, c));
}
function $b1502ddb39c03b09$var$Bh(a) {
    $b1502ddb39c03b09$var$vh.current === a && ($b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$uh), $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$vh));
}
var $b1502ddb39c03b09$var$L = $b1502ddb39c03b09$var$Uf(0);
function $b1502ddb39c03b09$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b1502ddb39c03b09$var$Dh = [];
function $b1502ddb39c03b09$var$Eh() {
    for(var a = 0; a < $b1502ddb39c03b09$var$Dh.length; a++)$b1502ddb39c03b09$var$Dh[a]._workInProgressVersionPrimary = null;
    $b1502ddb39c03b09$var$Dh.length = 0;
}
var $b1502ddb39c03b09$var$Fh = $b1502ddb39c03b09$var$ua.ReactCurrentDispatcher, $b1502ddb39c03b09$var$Gh = $b1502ddb39c03b09$var$ua.ReactCurrentBatchConfig, $b1502ddb39c03b09$var$Hh = 0, $b1502ddb39c03b09$var$M = null, $b1502ddb39c03b09$var$N = null, $b1502ddb39c03b09$var$O = null, $b1502ddb39c03b09$var$Ih = !1, $b1502ddb39c03b09$var$Jh = !1, $b1502ddb39c03b09$var$Kh = 0, $b1502ddb39c03b09$var$Lh = 0;
function $b1502ddb39c03b09$var$P() {
    throw Error($b1502ddb39c03b09$var$p(321));
}
function $b1502ddb39c03b09$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b1502ddb39c03b09$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b1502ddb39c03b09$var$Nh(a, b, c, d, e, f) {
    $b1502ddb39c03b09$var$Hh = f;
    $b1502ddb39c03b09$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b1502ddb39c03b09$var$Fh.current = null === a || null === a.memoizedState ? $b1502ddb39c03b09$var$Oh : $b1502ddb39c03b09$var$Ph;
    a = c(d, e);
    if ($b1502ddb39c03b09$var$Jh) {
        f = 0;
        do {
            $b1502ddb39c03b09$var$Jh = !1;
            $b1502ddb39c03b09$var$Kh = 0;
            if (25 <= f) throw Error($b1502ddb39c03b09$var$p(301));
            f += 1;
            $b1502ddb39c03b09$var$O = $b1502ddb39c03b09$var$N = null;
            b.updateQueue = null;
            $b1502ddb39c03b09$var$Fh.current = $b1502ddb39c03b09$var$Qh;
            a = c(d, e);
        }while ($b1502ddb39c03b09$var$Jh);
    }
    $b1502ddb39c03b09$var$Fh.current = $b1502ddb39c03b09$var$Rh;
    b = null !== $b1502ddb39c03b09$var$N && null !== $b1502ddb39c03b09$var$N.next;
    $b1502ddb39c03b09$var$Hh = 0;
    $b1502ddb39c03b09$var$O = $b1502ddb39c03b09$var$N = $b1502ddb39c03b09$var$M = null;
    $b1502ddb39c03b09$var$Ih = !1;
    if (b) throw Error($b1502ddb39c03b09$var$p(300));
    return a;
}
function $b1502ddb39c03b09$var$Sh() {
    var a = 0 !== $b1502ddb39c03b09$var$Kh;
    $b1502ddb39c03b09$var$Kh = 0;
    return a;
}
function $b1502ddb39c03b09$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b1502ddb39c03b09$var$O ? $b1502ddb39c03b09$var$M.memoizedState = $b1502ddb39c03b09$var$O = a : $b1502ddb39c03b09$var$O = $b1502ddb39c03b09$var$O.next = a;
    return $b1502ddb39c03b09$var$O;
}
function $b1502ddb39c03b09$var$Uh() {
    if (null === $b1502ddb39c03b09$var$N) {
        var a = $b1502ddb39c03b09$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b1502ddb39c03b09$var$N.next;
    var b = null === $b1502ddb39c03b09$var$O ? $b1502ddb39c03b09$var$M.memoizedState : $b1502ddb39c03b09$var$O.next;
    if (null !== b) $b1502ddb39c03b09$var$O = b, $b1502ddb39c03b09$var$N = a;
    else {
        if (null === a) throw Error($b1502ddb39c03b09$var$p(310));
        $b1502ddb39c03b09$var$N = a;
        a = {
            memoizedState: $b1502ddb39c03b09$var$N.memoizedState,
            baseState: $b1502ddb39c03b09$var$N.baseState,
            baseQueue: $b1502ddb39c03b09$var$N.baseQueue,
            queue: $b1502ddb39c03b09$var$N.queue,
            next: null
        };
        null === $b1502ddb39c03b09$var$O ? $b1502ddb39c03b09$var$M.memoizedState = $b1502ddb39c03b09$var$O = a : $b1502ddb39c03b09$var$O = $b1502ddb39c03b09$var$O.next = a;
    }
    return $b1502ddb39c03b09$var$O;
}
function $b1502ddb39c03b09$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b1502ddb39c03b09$var$Wh(a) {
    var b = $b1502ddb39c03b09$var$Uh(), c = b.queue;
    if (null === c) throw Error($b1502ddb39c03b09$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b1502ddb39c03b09$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b1502ddb39c03b09$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b1502ddb39c03b09$var$M.lanes |= m;
                $b1502ddb39c03b09$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b1502ddb39c03b09$var$He(d, b.memoizedState) || ($b1502ddb39c03b09$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b1502ddb39c03b09$var$M.lanes |= f, $b1502ddb39c03b09$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b1502ddb39c03b09$var$Xh(a) {
    var b = $b1502ddb39c03b09$var$Uh(), c = b.queue;
    if (null === c) throw Error($b1502ddb39c03b09$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b1502ddb39c03b09$var$He(f, b.memoizedState) || ($b1502ddb39c03b09$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b1502ddb39c03b09$var$Yh() {}
function $b1502ddb39c03b09$var$Zh(a, b) {
    var c = $b1502ddb39c03b09$var$M, d = $b1502ddb39c03b09$var$Uh(), e = b(), f = !$b1502ddb39c03b09$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b1502ddb39c03b09$var$dh = !0);
    d = d.queue;
    $b1502ddb39c03b09$var$$h($b1502ddb39c03b09$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b1502ddb39c03b09$var$O && $b1502ddb39c03b09$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b1502ddb39c03b09$var$bi(9, $b1502ddb39c03b09$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $b1502ddb39c03b09$var$Q) throw Error($b1502ddb39c03b09$var$p(349));
        0 !== ($b1502ddb39c03b09$var$Hh & 30) || $b1502ddb39c03b09$var$di(c, b, e);
    }
    return e;
}
function $b1502ddb39c03b09$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b1502ddb39c03b09$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b1502ddb39c03b09$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b1502ddb39c03b09$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b1502ddb39c03b09$var$ei(b) && $b1502ddb39c03b09$var$fi(a);
}
function $b1502ddb39c03b09$var$ai(a, b, c) {
    return c(function() {
        $b1502ddb39c03b09$var$ei(b) && $b1502ddb39c03b09$var$fi(a);
    });
}
function $b1502ddb39c03b09$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b1502ddb39c03b09$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b1502ddb39c03b09$var$fi(a) {
    var b = $b1502ddb39c03b09$var$ih(a, 1);
    null !== b && $b1502ddb39c03b09$var$gi(b, a, 1, -1);
}
function $b1502ddb39c03b09$var$hi(a) {
    var b = $b1502ddb39c03b09$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b1502ddb39c03b09$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b1502ddb39c03b09$var$ii.bind(null, $b1502ddb39c03b09$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b1502ddb39c03b09$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b1502ddb39c03b09$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b1502ddb39c03b09$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b1502ddb39c03b09$var$ji() {
    return $b1502ddb39c03b09$var$Uh().memoizedState;
}
function $b1502ddb39c03b09$var$ki(a, b, c, d) {
    var e = $b1502ddb39c03b09$var$Th();
    $b1502ddb39c03b09$var$M.flags |= a;
    e.memoizedState = $b1502ddb39c03b09$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b1502ddb39c03b09$var$li(a, b, c, d) {
    var e = $b1502ddb39c03b09$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b1502ddb39c03b09$var$N) {
        var g = $b1502ddb39c03b09$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b1502ddb39c03b09$var$Mh(d, g.deps)) {
            e.memoizedState = $b1502ddb39c03b09$var$bi(b, c, f, d);
            return;
        }
    }
    $b1502ddb39c03b09$var$M.flags |= a;
    e.memoizedState = $b1502ddb39c03b09$var$bi(1 | b, c, f, d);
}
function $b1502ddb39c03b09$var$mi(a, b) {
    return $b1502ddb39c03b09$var$ki(8390656, 8, a, b);
}
function $b1502ddb39c03b09$var$$h(a, b) {
    return $b1502ddb39c03b09$var$li(2048, 8, a, b);
}
function $b1502ddb39c03b09$var$ni(a, b) {
    return $b1502ddb39c03b09$var$li(4, 2, a, b);
}
function $b1502ddb39c03b09$var$oi(a, b) {
    return $b1502ddb39c03b09$var$li(4, 4, a, b);
}
function $b1502ddb39c03b09$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b1502ddb39c03b09$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b1502ddb39c03b09$var$li(4, 4, $b1502ddb39c03b09$var$pi.bind(null, b, a), c);
}
function $b1502ddb39c03b09$var$ri() {}
function $b1502ddb39c03b09$var$si(a, b) {
    var c = $b1502ddb39c03b09$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b1502ddb39c03b09$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b1502ddb39c03b09$var$ti(a, b) {
    var c = $b1502ddb39c03b09$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b1502ddb39c03b09$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b1502ddb39c03b09$var$ui(a, b, c) {
    if (0 === ($b1502ddb39c03b09$var$Hh & 21)) return a.baseState && (a.baseState = !1, $b1502ddb39c03b09$var$dh = !0), a.memoizedState = c;
    $b1502ddb39c03b09$var$He(c, b) || (c = $b1502ddb39c03b09$var$yc(), $b1502ddb39c03b09$var$M.lanes |= c, $b1502ddb39c03b09$var$rh |= c, a.baseState = !0);
    return b;
}
function $b1502ddb39c03b09$var$vi(a, b) {
    var c = $b1502ddb39c03b09$var$C;
    $b1502ddb39c03b09$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b1502ddb39c03b09$var$Gh.transition;
    $b1502ddb39c03b09$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b1502ddb39c03b09$var$C = c, $b1502ddb39c03b09$var$Gh.transition = d;
    }
}
function $b1502ddb39c03b09$var$wi() {
    return $b1502ddb39c03b09$var$Uh().memoizedState;
}
function $b1502ddb39c03b09$var$xi(a, b, c) {
    var d = $b1502ddb39c03b09$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b1502ddb39c03b09$var$zi(a)) $b1502ddb39c03b09$var$Ai(b, c);
    else if (c = $b1502ddb39c03b09$var$hh(a, b, c, d), null !== c) {
        var e = $b1502ddb39c03b09$var$R();
        $b1502ddb39c03b09$var$gi(c, a, d, e);
        $b1502ddb39c03b09$var$Bi(c, b, d);
    }
}
function $b1502ddb39c03b09$var$ii(a, b, c) {
    var d = $b1502ddb39c03b09$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b1502ddb39c03b09$var$zi(a)) $b1502ddb39c03b09$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b1502ddb39c03b09$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b1502ddb39c03b09$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b1502ddb39c03b09$var$hh(a, b, e, d);
        null !== c && (e = $b1502ddb39c03b09$var$R(), $b1502ddb39c03b09$var$gi(c, a, d, e), $b1502ddb39c03b09$var$Bi(c, b, d));
    }
}
function $b1502ddb39c03b09$var$zi(a) {
    var b = a.alternate;
    return a === $b1502ddb39c03b09$var$M || null !== b && b === $b1502ddb39c03b09$var$M;
}
function $b1502ddb39c03b09$var$Ai(a, b) {
    $b1502ddb39c03b09$var$Jh = $b1502ddb39c03b09$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b1502ddb39c03b09$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b1502ddb39c03b09$var$Cc(a, c);
    }
}
var $b1502ddb39c03b09$var$Rh = {
    readContext: $b1502ddb39c03b09$var$eh,
    useCallback: $b1502ddb39c03b09$var$P,
    useContext: $b1502ddb39c03b09$var$P,
    useEffect: $b1502ddb39c03b09$var$P,
    useImperativeHandle: $b1502ddb39c03b09$var$P,
    useInsertionEffect: $b1502ddb39c03b09$var$P,
    useLayoutEffect: $b1502ddb39c03b09$var$P,
    useMemo: $b1502ddb39c03b09$var$P,
    useReducer: $b1502ddb39c03b09$var$P,
    useRef: $b1502ddb39c03b09$var$P,
    useState: $b1502ddb39c03b09$var$P,
    useDebugValue: $b1502ddb39c03b09$var$P,
    useDeferredValue: $b1502ddb39c03b09$var$P,
    useTransition: $b1502ddb39c03b09$var$P,
    useMutableSource: $b1502ddb39c03b09$var$P,
    useSyncExternalStore: $b1502ddb39c03b09$var$P,
    useId: $b1502ddb39c03b09$var$P,
    unstable_isNewReconciler: !1
}, $b1502ddb39c03b09$var$Oh = {
    readContext: $b1502ddb39c03b09$var$eh,
    useCallback: function useCallback(a, b) {
        $b1502ddb39c03b09$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b1502ddb39c03b09$var$eh,
    useEffect: $b1502ddb39c03b09$var$mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b1502ddb39c03b09$var$ki(4194308, 4, $b1502ddb39c03b09$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $b1502ddb39c03b09$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $b1502ddb39c03b09$var$ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $b1502ddb39c03b09$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $b1502ddb39c03b09$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b1502ddb39c03b09$var$xi.bind(null, $b1502ddb39c03b09$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $b1502ddb39c03b09$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b1502ddb39c03b09$var$hi,
    useDebugValue: $b1502ddb39c03b09$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        return $b1502ddb39c03b09$var$Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $b1502ddb39c03b09$var$hi(!1), b = a[0];
        a = $b1502ddb39c03b09$var$vi.bind(null, a[1]);
        $b1502ddb39c03b09$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $b1502ddb39c03b09$var$M, e = $b1502ddb39c03b09$var$Th();
        if ($b1502ddb39c03b09$var$I) {
            if (void 0 === c) throw Error($b1502ddb39c03b09$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b1502ddb39c03b09$var$Q) throw Error($b1502ddb39c03b09$var$p(349));
            0 !== ($b1502ddb39c03b09$var$Hh & 30) || $b1502ddb39c03b09$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b1502ddb39c03b09$var$mi($b1502ddb39c03b09$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b1502ddb39c03b09$var$bi(9, $b1502ddb39c03b09$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $b1502ddb39c03b09$var$Th(), b = $b1502ddb39c03b09$var$Q.identifierPrefix;
        if ($b1502ddb39c03b09$var$I) {
            var c = $b1502ddb39c03b09$var$sg;
            var d = $b1502ddb39c03b09$var$rg;
            c = (d & ~(1 << 32 - $b1502ddb39c03b09$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b1502ddb39c03b09$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b1502ddb39c03b09$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b1502ddb39c03b09$var$Ph = {
    readContext: $b1502ddb39c03b09$var$eh,
    useCallback: $b1502ddb39c03b09$var$si,
    useContext: $b1502ddb39c03b09$var$eh,
    useEffect: $b1502ddb39c03b09$var$$h,
    useImperativeHandle: $b1502ddb39c03b09$var$qi,
    useInsertionEffect: $b1502ddb39c03b09$var$ni,
    useLayoutEffect: $b1502ddb39c03b09$var$oi,
    useMemo: $b1502ddb39c03b09$var$ti,
    useReducer: $b1502ddb39c03b09$var$Wh,
    useRef: $b1502ddb39c03b09$var$ji,
    useState: function useState() {
        return $b1502ddb39c03b09$var$Wh($b1502ddb39c03b09$var$Vh);
    },
    useDebugValue: $b1502ddb39c03b09$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $b1502ddb39c03b09$var$Uh();
        return $b1502ddb39c03b09$var$ui(b, $b1502ddb39c03b09$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $b1502ddb39c03b09$var$Wh($b1502ddb39c03b09$var$Vh)[0], b = $b1502ddb39c03b09$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b1502ddb39c03b09$var$Yh,
    useSyncExternalStore: $b1502ddb39c03b09$var$Zh,
    useId: $b1502ddb39c03b09$var$wi,
    unstable_isNewReconciler: !1
}, $b1502ddb39c03b09$var$Qh = {
    readContext: $b1502ddb39c03b09$var$eh,
    useCallback: $b1502ddb39c03b09$var$si,
    useContext: $b1502ddb39c03b09$var$eh,
    useEffect: $b1502ddb39c03b09$var$$h,
    useImperativeHandle: $b1502ddb39c03b09$var$qi,
    useInsertionEffect: $b1502ddb39c03b09$var$ni,
    useLayoutEffect: $b1502ddb39c03b09$var$oi,
    useMemo: $b1502ddb39c03b09$var$ti,
    useReducer: $b1502ddb39c03b09$var$Xh,
    useRef: $b1502ddb39c03b09$var$ji,
    useState: function useState() {
        return $b1502ddb39c03b09$var$Xh($b1502ddb39c03b09$var$Vh);
    },
    useDebugValue: $b1502ddb39c03b09$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $b1502ddb39c03b09$var$Uh();
        return null === $b1502ddb39c03b09$var$N ? b.memoizedState = a : $b1502ddb39c03b09$var$ui(b, $b1502ddb39c03b09$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $b1502ddb39c03b09$var$Xh($b1502ddb39c03b09$var$Vh)[0], b = $b1502ddb39c03b09$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b1502ddb39c03b09$var$Yh,
    useSyncExternalStore: $b1502ddb39c03b09$var$Zh,
    useId: $b1502ddb39c03b09$var$wi,
    unstable_isNewReconciler: !1
};
function $b1502ddb39c03b09$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $b1502ddb39c03b09$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b1502ddb39c03b09$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b1502ddb39c03b09$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b1502ddb39c03b09$var$Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $b1502ddb39c03b09$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $b1502ddb39c03b09$var$R(), e = $b1502ddb39c03b09$var$yi(a), f = $b1502ddb39c03b09$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b1502ddb39c03b09$var$nh(a, f, e);
        null !== b && ($b1502ddb39c03b09$var$gi(b, a, e, d), $b1502ddb39c03b09$var$oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $b1502ddb39c03b09$var$R(), e = $b1502ddb39c03b09$var$yi(a), f = $b1502ddb39c03b09$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b1502ddb39c03b09$var$nh(a, f, e);
        null !== b && ($b1502ddb39c03b09$var$gi(b, a, e, d), $b1502ddb39c03b09$var$oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $b1502ddb39c03b09$var$R(), d = $b1502ddb39c03b09$var$yi(a), e = $b1502ddb39c03b09$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b1502ddb39c03b09$var$nh(a, e, d);
        null !== b && ($b1502ddb39c03b09$var$gi(b, a, d, c), $b1502ddb39c03b09$var$oh(b, a, d));
    }
};
function $b1502ddb39c03b09$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b1502ddb39c03b09$var$Ie(c, d) || !$b1502ddb39c03b09$var$Ie(e, f) : !0;
}
function $b1502ddb39c03b09$var$Gi(a, b, c) {
    var d = !1, e = $b1502ddb39c03b09$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b1502ddb39c03b09$var$eh(f) : (e = $b1502ddb39c03b09$var$Zf(b) ? $b1502ddb39c03b09$var$Xf : $b1502ddb39c03b09$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b1502ddb39c03b09$var$Yf(a, e) : $b1502ddb39c03b09$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b1502ddb39c03b09$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b1502ddb39c03b09$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b1502ddb39c03b09$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $b1502ddb39c03b09$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b1502ddb39c03b09$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b1502ddb39c03b09$var$eh(f) : (f = $b1502ddb39c03b09$var$Zf(b) ? $b1502ddb39c03b09$var$Xf : $b1502ddb39c03b09$var$H.current, e.context = $b1502ddb39c03b09$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b1502ddb39c03b09$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b1502ddb39c03b09$var$Ei.enqueueReplaceState(e, e.state, null), $b1502ddb39c03b09$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b1502ddb39c03b09$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $b1502ddb39c03b09$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b1502ddb39c03b09$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b1502ddb39c03b09$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b1502ddb39c03b09$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $b1502ddb39c03b09$var$Ni(a, b, c) {
    c = $b1502ddb39c03b09$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b1502ddb39c03b09$var$Oi || ($b1502ddb39c03b09$var$Oi = !0, $b1502ddb39c03b09$var$Pi = d);
        $b1502ddb39c03b09$var$Li(a, b);
    };
    return c;
}
function $b1502ddb39c03b09$var$Qi(a, b, c) {
    c = $b1502ddb39c03b09$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b1502ddb39c03b09$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b1502ddb39c03b09$var$Li(a, b);
        "function" !== typeof d && (null === $b1502ddb39c03b09$var$Ri ? $b1502ddb39c03b09$var$Ri = new Set([
            this
        ]) : $b1502ddb39c03b09$var$Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $b1502ddb39c03b09$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b1502ddb39c03b09$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b1502ddb39c03b09$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $b1502ddb39c03b09$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b1502ddb39c03b09$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b1502ddb39c03b09$var$mh(-1, 1), b.tag = 2, $b1502ddb39c03b09$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b1502ddb39c03b09$var$Wi = $b1502ddb39c03b09$var$ua.ReactCurrentOwner, $b1502ddb39c03b09$var$dh = !1;
function $b1502ddb39c03b09$var$Xi(a, b, c, d) {
    b.child = null === a ? $b1502ddb39c03b09$var$Vg(b, null, c, d) : $b1502ddb39c03b09$var$Ug(b, a.child, c, d);
}
function $b1502ddb39c03b09$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b1502ddb39c03b09$var$ch(b, e);
    d = $b1502ddb39c03b09$var$Nh(a, b, c, d, f, e);
    c = $b1502ddb39c03b09$var$Sh();
    if (null !== a && !$b1502ddb39c03b09$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b1502ddb39c03b09$var$Zi(a, b, e);
    $b1502ddb39c03b09$var$I && c && $b1502ddb39c03b09$var$vg(b);
    b.flags |= 1;
    $b1502ddb39c03b09$var$Xi(a, b, d, e);
    return b.child;
}
function $b1502ddb39c03b09$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b1502ddb39c03b09$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b1502ddb39c03b09$var$bj(a, b, f, d, e);
        a = $b1502ddb39c03b09$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b1502ddb39c03b09$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b1502ddb39c03b09$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $b1502ddb39c03b09$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b1502ddb39c03b09$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b1502ddb39c03b09$var$Ie(f, d) && a.ref === b.ref) {
            if ($b1502ddb39c03b09$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b1502ddb39c03b09$var$dh = !0);
            else return b.lanes = a.lanes, $b1502ddb39c03b09$var$Zi(a, b, e);
        }
    }
    return $b1502ddb39c03b09$var$cj(a, b, c, d, e);
}
function $b1502ddb39c03b09$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$ej, $b1502ddb39c03b09$var$fj), $b1502ddb39c03b09$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$ej, $b1502ddb39c03b09$var$fj), $b1502ddb39c03b09$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$ej, $b1502ddb39c03b09$var$fj);
            $b1502ddb39c03b09$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$ej, $b1502ddb39c03b09$var$fj), $b1502ddb39c03b09$var$fj |= d;
    $b1502ddb39c03b09$var$Xi(a, b, e, c);
    return b.child;
}
function $b1502ddb39c03b09$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b1502ddb39c03b09$var$cj(a, b, c, d, e) {
    var f = $b1502ddb39c03b09$var$Zf(c) ? $b1502ddb39c03b09$var$Xf : $b1502ddb39c03b09$var$H.current;
    f = $b1502ddb39c03b09$var$Yf(b, f);
    $b1502ddb39c03b09$var$ch(b, e);
    c = $b1502ddb39c03b09$var$Nh(a, b, c, d, f, e);
    d = $b1502ddb39c03b09$var$Sh();
    if (null !== a && !$b1502ddb39c03b09$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b1502ddb39c03b09$var$Zi(a, b, e);
    $b1502ddb39c03b09$var$I && d && $b1502ddb39c03b09$var$vg(b);
    b.flags |= 1;
    $b1502ddb39c03b09$var$Xi(a, b, c, e);
    return b.child;
}
function $b1502ddb39c03b09$var$hj(a, b, c, d, e) {
    if ($b1502ddb39c03b09$var$Zf(c)) {
        var f = !0;
        $b1502ddb39c03b09$var$cg(b);
    } else f = !1;
    $b1502ddb39c03b09$var$ch(b, e);
    if (null === b.stateNode) $b1502ddb39c03b09$var$ij(a, b), $b1502ddb39c03b09$var$Gi(b, c, d), $b1502ddb39c03b09$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b1502ddb39c03b09$var$eh(l) : (l = $b1502ddb39c03b09$var$Zf(c) ? $b1502ddb39c03b09$var$Xf : $b1502ddb39c03b09$var$H.current, l = $b1502ddb39c03b09$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b1502ddb39c03b09$var$Hi(b, g, d, l);
        $b1502ddb39c03b09$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b1502ddb39c03b09$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b1502ddb39c03b09$var$Wf.current || $b1502ddb39c03b09$var$jh ? ("function" === typeof m && ($b1502ddb39c03b09$var$Di(b, c, m, d), k = b.memoizedState), (h = $b1502ddb39c03b09$var$jh || $b1502ddb39c03b09$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b1502ddb39c03b09$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b1502ddb39c03b09$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b1502ddb39c03b09$var$eh(k) : (k = $b1502ddb39c03b09$var$Zf(c) ? $b1502ddb39c03b09$var$Xf : $b1502ddb39c03b09$var$H.current, k = $b1502ddb39c03b09$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b1502ddb39c03b09$var$Hi(b, g, d, k);
        $b1502ddb39c03b09$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $b1502ddb39c03b09$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b1502ddb39c03b09$var$Wf.current || $b1502ddb39c03b09$var$jh ? ("function" === typeof y && ($b1502ddb39c03b09$var$Di(b, c, y, d), n = b.memoizedState), (l = $b1502ddb39c03b09$var$jh || $b1502ddb39c03b09$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b1502ddb39c03b09$var$jj(a, b, c, d, f, e);
}
function $b1502ddb39c03b09$var$jj(a, b, c, d, e, f) {
    $b1502ddb39c03b09$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b1502ddb39c03b09$var$dg(b, c, !1), $b1502ddb39c03b09$var$Zi(a, b, f);
    d = b.stateNode;
    $b1502ddb39c03b09$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b1502ddb39c03b09$var$Ug(b, a.child, null, f), b.child = $b1502ddb39c03b09$var$Ug(b, null, h, f)) : $b1502ddb39c03b09$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b1502ddb39c03b09$var$dg(b, c, !0);
    return b.child;
}
function $b1502ddb39c03b09$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b1502ddb39c03b09$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b1502ddb39c03b09$var$ag(a, b.context, !1);
    $b1502ddb39c03b09$var$yh(a, b.containerInfo);
}
function $b1502ddb39c03b09$var$lj(a, b, c, d, e) {
    $b1502ddb39c03b09$var$Ig();
    $b1502ddb39c03b09$var$Jg(e);
    b.flags |= 256;
    $b1502ddb39c03b09$var$Xi(a, b, c, d);
    return b.child;
}
var $b1502ddb39c03b09$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b1502ddb39c03b09$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b1502ddb39c03b09$var$oj(a, b, c) {
    var d = b.pendingProps, e = $b1502ddb39c03b09$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, e & 1);
    if (null === a) {
        $b1502ddb39c03b09$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b1502ddb39c03b09$var$pj(g, d, 0, null), a = $b1502ddb39c03b09$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b1502ddb39c03b09$var$nj(c), b.memoizedState = $b1502ddb39c03b09$var$mj, a) : $b1502ddb39c03b09$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b1502ddb39c03b09$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b1502ddb39c03b09$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b1502ddb39c03b09$var$Pg(h, f) : (f = $b1502ddb39c03b09$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b1502ddb39c03b09$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b1502ddb39c03b09$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b1502ddb39c03b09$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b1502ddb39c03b09$var$qj(a, b) {
    b = $b1502ddb39c03b09$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b1502ddb39c03b09$var$sj(a, b, c, d) {
    null !== d && $b1502ddb39c03b09$var$Jg(d);
    $b1502ddb39c03b09$var$Ug(b, a.child, null, c);
    a = $b1502ddb39c03b09$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b1502ddb39c03b09$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b1502ddb39c03b09$var$Ki(Error($b1502ddb39c03b09$var$p(422))), $b1502ddb39c03b09$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b1502ddb39c03b09$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b1502ddb39c03b09$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b1502ddb39c03b09$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $b1502ddb39c03b09$var$nj(g);
        b.memoizedState = $b1502ddb39c03b09$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b1502ddb39c03b09$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b1502ddb39c03b09$var$p(419));
        d = $b1502ddb39c03b09$var$Ki(f, d, void 0);
        return $b1502ddb39c03b09$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b1502ddb39c03b09$var$dh || h) {
        d = $b1502ddb39c03b09$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b1502ddb39c03b09$var$ih(a, e), $b1502ddb39c03b09$var$gi(d, a, e, -1));
        }
        $b1502ddb39c03b09$var$tj();
        d = $b1502ddb39c03b09$var$Ki(Error($b1502ddb39c03b09$var$p(421)));
        return $b1502ddb39c03b09$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b1502ddb39c03b09$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b1502ddb39c03b09$var$yg = $b1502ddb39c03b09$var$Lf(e.nextSibling);
    $b1502ddb39c03b09$var$xg = b;
    $b1502ddb39c03b09$var$I = !0;
    $b1502ddb39c03b09$var$zg = null;
    null !== a && ($b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg++] = $b1502ddb39c03b09$var$rg, $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg++] = $b1502ddb39c03b09$var$sg, $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg++] = $b1502ddb39c03b09$var$qg, $b1502ddb39c03b09$var$rg = a.id, $b1502ddb39c03b09$var$sg = a.overflow, $b1502ddb39c03b09$var$qg = b);
    b = $b1502ddb39c03b09$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b1502ddb39c03b09$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b1502ddb39c03b09$var$bh(a.return, b, c);
}
function $b1502ddb39c03b09$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b1502ddb39c03b09$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b1502ddb39c03b09$var$Xi(a, b, d.children, c);
    d = $b1502ddb39c03b09$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b1502ddb39c03b09$var$vj(a, c, b);
            else if (19 === a.tag) $b1502ddb39c03b09$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b1502ddb39c03b09$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b1502ddb39c03b09$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b1502ddb39c03b09$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b1502ddb39c03b09$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $b1502ddb39c03b09$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b1502ddb39c03b09$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b1502ddb39c03b09$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b1502ddb39c03b09$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b1502ddb39c03b09$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b1502ddb39c03b09$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b1502ddb39c03b09$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b1502ddb39c03b09$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $b1502ddb39c03b09$var$kj(b);
            $b1502ddb39c03b09$var$Ig();
            break;
        case 5:
            $b1502ddb39c03b09$var$Ah(b);
            break;
        case 1:
            $b1502ddb39c03b09$var$Zf(b.type) && $b1502ddb39c03b09$var$cg(b);
            break;
        case 4:
            $b1502ddb39c03b09$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, $b1502ddb39c03b09$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b1502ddb39c03b09$var$oj(a, b, c);
                $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, $b1502ddb39c03b09$var$L.current & 1);
                a = $b1502ddb39c03b09$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, $b1502ddb39c03b09$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b1502ddb39c03b09$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, $b1502ddb39c03b09$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b1502ddb39c03b09$var$dj(a, b, c);
    }
    return $b1502ddb39c03b09$var$Zi(a, b, c);
}
var $b1502ddb39c03b09$var$zj, $b1502ddb39c03b09$var$Aj, $b1502ddb39c03b09$var$Bj, $b1502ddb39c03b09$var$Cj;
$b1502ddb39c03b09$var$zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b1502ddb39c03b09$var$Aj = function Aj() {};
$b1502ddb39c03b09$var$Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b1502ddb39c03b09$var$xh($b1502ddb39c03b09$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b1502ddb39c03b09$var$Ya(a, e);
                d = $b1502ddb39c03b09$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b1502ddb39c03b09$var$A({}, e, {
                    value: void 0
                });
                d = $b1502ddb39c03b09$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b1502ddb39c03b09$var$gb(a, e);
                d = $b1502ddb39c03b09$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b1502ddb39c03b09$var$Bf);
        }
        $b1502ddb39c03b09$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b1502ddb39c03b09$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b1502ddb39c03b09$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b1502ddb39c03b09$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b1502ddb39c03b09$var$Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b1502ddb39c03b09$var$Dj(a, b) {
    if (!$b1502ddb39c03b09$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b1502ddb39c03b09$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b1502ddb39c03b09$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $b1502ddb39c03b09$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b1502ddb39c03b09$var$S(b), null;
        case 1:
            return $b1502ddb39c03b09$var$Zf(b.type) && $b1502ddb39c03b09$var$$f(), $b1502ddb39c03b09$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b1502ddb39c03b09$var$zh();
            $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$Wf);
            $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$H);
            $b1502ddb39c03b09$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b1502ddb39c03b09$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b1502ddb39c03b09$var$zg && ($b1502ddb39c03b09$var$Fj($b1502ddb39c03b09$var$zg), $b1502ddb39c03b09$var$zg = null));
            $b1502ddb39c03b09$var$Aj(a, b);
            $b1502ddb39c03b09$var$S(b);
            return null;
        case 5:
            $b1502ddb39c03b09$var$Bh(b);
            var e = $b1502ddb39c03b09$var$xh($b1502ddb39c03b09$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b1502ddb39c03b09$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b1502ddb39c03b09$var$p(166));
                    $b1502ddb39c03b09$var$S(b);
                    return null;
                }
                a = $b1502ddb39c03b09$var$xh($b1502ddb39c03b09$var$uh.current);
                if ($b1502ddb39c03b09$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b1502ddb39c03b09$var$Of] = b;
                    d[$b1502ddb39c03b09$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b1502ddb39c03b09$var$D("cancel", d);
                            $b1502ddb39c03b09$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b1502ddb39c03b09$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b1502ddb39c03b09$var$lf.length; e++)$b1502ddb39c03b09$var$D($b1502ddb39c03b09$var$lf[e], d);
                            break;
                        case "source":
                            $b1502ddb39c03b09$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b1502ddb39c03b09$var$D("error", d);
                            $b1502ddb39c03b09$var$D("load", d);
                            break;
                        case "details":
                            $b1502ddb39c03b09$var$D("toggle", d);
                            break;
                        case "input":
                            $b1502ddb39c03b09$var$Za(d, f);
                            $b1502ddb39c03b09$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b1502ddb39c03b09$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b1502ddb39c03b09$var$hb(d, f), $b1502ddb39c03b09$var$D("invalid", d);
                    }
                    $b1502ddb39c03b09$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b1502ddb39c03b09$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b1502ddb39c03b09$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b1502ddb39c03b09$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b1502ddb39c03b09$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b1502ddb39c03b09$var$Va(d);
                            $b1502ddb39c03b09$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b1502ddb39c03b09$var$Va(d);
                            $b1502ddb39c03b09$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b1502ddb39c03b09$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b1502ddb39c03b09$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b1502ddb39c03b09$var$Of] = b;
                    a[$b1502ddb39c03b09$var$Pf] = d;
                    $b1502ddb39c03b09$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b1502ddb39c03b09$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b1502ddb39c03b09$var$D("cancel", a);
                                $b1502ddb39c03b09$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b1502ddb39c03b09$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b1502ddb39c03b09$var$lf.length; e++)$b1502ddb39c03b09$var$D($b1502ddb39c03b09$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b1502ddb39c03b09$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b1502ddb39c03b09$var$D("error", a);
                                $b1502ddb39c03b09$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b1502ddb39c03b09$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b1502ddb39c03b09$var$Za(a, d);
                                e = $b1502ddb39c03b09$var$Ya(a, d);
                                $b1502ddb39c03b09$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b1502ddb39c03b09$var$A({}, d, {
                                    value: void 0
                                });
                                $b1502ddb39c03b09$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b1502ddb39c03b09$var$hb(a, d);
                                e = $b1502ddb39c03b09$var$gb(a, d);
                                $b1502ddb39c03b09$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b1502ddb39c03b09$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b1502ddb39c03b09$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b1502ddb39c03b09$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b1502ddb39c03b09$var$ob(a, k) : "number" === typeof k && $b1502ddb39c03b09$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b1502ddb39c03b09$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b1502ddb39c03b09$var$D("scroll", a) : null != k && $b1502ddb39c03b09$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b1502ddb39c03b09$var$Va(a);
                                $b1502ddb39c03b09$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b1502ddb39c03b09$var$Va(a);
                                $b1502ddb39c03b09$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b1502ddb39c03b09$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b1502ddb39c03b09$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b1502ddb39c03b09$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b1502ddb39c03b09$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b1502ddb39c03b09$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b1502ddb39c03b09$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b1502ddb39c03b09$var$p(166));
                c = $b1502ddb39c03b09$var$xh($b1502ddb39c03b09$var$wh.current);
                $b1502ddb39c03b09$var$xh($b1502ddb39c03b09$var$uh.current);
                if ($b1502ddb39c03b09$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b1502ddb39c03b09$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b1502ddb39c03b09$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b1502ddb39c03b09$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b1502ddb39c03b09$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b1502ddb39c03b09$var$Of] = b, b.stateNode = d;
            }
            $b1502ddb39c03b09$var$S(b);
            return null;
        case 13:
            $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b1502ddb39c03b09$var$I && null !== $b1502ddb39c03b09$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b1502ddb39c03b09$var$Hg(), $b1502ddb39c03b09$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b1502ddb39c03b09$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b1502ddb39c03b09$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b1502ddb39c03b09$var$p(317));
                        f[$b1502ddb39c03b09$var$Of] = b;
                    } else $b1502ddb39c03b09$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b1502ddb39c03b09$var$S(b);
                    f = !1;
                } else null !== $b1502ddb39c03b09$var$zg && ($b1502ddb39c03b09$var$Fj($b1502ddb39c03b09$var$zg), $b1502ddb39c03b09$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b1502ddb39c03b09$var$L.current & 1) ? 0 === $b1502ddb39c03b09$var$T && ($b1502ddb39c03b09$var$T = 3) : $b1502ddb39c03b09$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b1502ddb39c03b09$var$S(b);
            return null;
        case 4:
            return $b1502ddb39c03b09$var$zh(), $b1502ddb39c03b09$var$Aj(a, b), null === a && $b1502ddb39c03b09$var$sf(b.stateNode.containerInfo), $b1502ddb39c03b09$var$S(b), null;
        case 10:
            return $b1502ddb39c03b09$var$ah(b.type._context), $b1502ddb39c03b09$var$S(b), null;
        case 17:
            return $b1502ddb39c03b09$var$Zf(b.type) && $b1502ddb39c03b09$var$$f(), $b1502ddb39c03b09$var$S(b), null;
        case 19:
            $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$L);
            f = b.memoizedState;
            if (null === f) return $b1502ddb39c03b09$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b1502ddb39c03b09$var$Dj(f, !1);
                else {
                    if (0 !== $b1502ddb39c03b09$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b1502ddb39c03b09$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b1502ddb39c03b09$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, $b1502ddb39c03b09$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b1502ddb39c03b09$var$B() > $b1502ddb39c03b09$var$Gj && (b.flags |= 128, d = !0, $b1502ddb39c03b09$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b1502ddb39c03b09$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b1502ddb39c03b09$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b1502ddb39c03b09$var$I) return $b1502ddb39c03b09$var$S(b), null;
                    } else 2 * $b1502ddb39c03b09$var$B() - f.renderingStartTime > $b1502ddb39c03b09$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $b1502ddb39c03b09$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b1502ddb39c03b09$var$B(), b.sibling = null, c = $b1502ddb39c03b09$var$L.current, $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, d ? c & 1 | 2 : c & 1), b;
            $b1502ddb39c03b09$var$S(b);
            return null;
        case 22:
        case 23:
            return $b1502ddb39c03b09$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b1502ddb39c03b09$var$fj & 1073741824) && ($b1502ddb39c03b09$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b1502ddb39c03b09$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b1502ddb39c03b09$var$p(156, b.tag));
}
function $b1502ddb39c03b09$var$Ij(a, b) {
    $b1502ddb39c03b09$var$wg(b);
    switch(b.tag){
        case 1:
            return $b1502ddb39c03b09$var$Zf(b.type) && $b1502ddb39c03b09$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b1502ddb39c03b09$var$zh(), $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$Wf), $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$H), $b1502ddb39c03b09$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b1502ddb39c03b09$var$Bh(b), null;
        case 13:
            $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b1502ddb39c03b09$var$p(340));
                $b1502ddb39c03b09$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$L), null;
        case 4:
            return $b1502ddb39c03b09$var$zh(), null;
        case 10:
            return $b1502ddb39c03b09$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $b1502ddb39c03b09$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b1502ddb39c03b09$var$Jj = !1, $b1502ddb39c03b09$var$U = !1, $b1502ddb39c03b09$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $b1502ddb39c03b09$var$V = null;
function $b1502ddb39c03b09$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b1502ddb39c03b09$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b1502ddb39c03b09$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b1502ddb39c03b09$var$W(a, b, d);
    }
}
var $b1502ddb39c03b09$var$Nj = !1;
function $b1502ddb39c03b09$var$Oj(a, b) {
    $b1502ddb39c03b09$var$Cf = $b1502ddb39c03b09$var$dd;
    a = $b1502ddb39c03b09$var$Me();
    if ($b1502ddb39c03b09$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b1502ddb39c03b09$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b1502ddb39c03b09$var$dd = !1;
    for($b1502ddb39c03b09$var$V = b; null !== $b1502ddb39c03b09$var$V;)if (b = $b1502ddb39c03b09$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b1502ddb39c03b09$var$V = a;
    else for(; null !== $b1502ddb39c03b09$var$V;){
        b = $b1502ddb39c03b09$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b1502ddb39c03b09$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b1502ddb39c03b09$var$p(163));
            }
        } catch (F) {
            $b1502ddb39c03b09$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b1502ddb39c03b09$var$V = a;
            break;
        }
        $b1502ddb39c03b09$var$V = b.return;
    }
    n = $b1502ddb39c03b09$var$Nj;
    $b1502ddb39c03b09$var$Nj = !1;
    return n;
}
function $b1502ddb39c03b09$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b1502ddb39c03b09$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b1502ddb39c03b09$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b1502ddb39c03b09$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b1502ddb39c03b09$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b1502ddb39c03b09$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b1502ddb39c03b09$var$Of], delete b[$b1502ddb39c03b09$var$Pf], delete b[$b1502ddb39c03b09$var$of], delete b[$b1502ddb39c03b09$var$Qf], delete b[$b1502ddb39c03b09$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b1502ddb39c03b09$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b1502ddb39c03b09$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b1502ddb39c03b09$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b1502ddb39c03b09$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b1502ddb39c03b09$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b1502ddb39c03b09$var$Vj(a, b, c), a = a.sibling; null !== a;)$b1502ddb39c03b09$var$Vj(a, b, c), a = a.sibling;
}
function $b1502ddb39c03b09$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b1502ddb39c03b09$var$Wj(a, b, c), a = a.sibling; null !== a;)$b1502ddb39c03b09$var$Wj(a, b, c), a = a.sibling;
}
var $b1502ddb39c03b09$var$X = null, $b1502ddb39c03b09$var$Xj = !1;
function $b1502ddb39c03b09$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$b1502ddb39c03b09$var$Zj(a, b, c), c = c.sibling;
}
function $b1502ddb39c03b09$var$Zj(a, b, c) {
    if ($b1502ddb39c03b09$var$lc && "function" === typeof $b1502ddb39c03b09$var$lc.onCommitFiberUnmount) try {
        $b1502ddb39c03b09$var$lc.onCommitFiberUnmount($b1502ddb39c03b09$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b1502ddb39c03b09$var$U || $b1502ddb39c03b09$var$Lj(c, b);
        case 6:
            var d = $b1502ddb39c03b09$var$X, e = $b1502ddb39c03b09$var$Xj;
            $b1502ddb39c03b09$var$X = null;
            $b1502ddb39c03b09$var$Yj(a, b, c);
            $b1502ddb39c03b09$var$X = d;
            $b1502ddb39c03b09$var$Xj = e;
            null !== $b1502ddb39c03b09$var$X && ($b1502ddb39c03b09$var$Xj ? (a = $b1502ddb39c03b09$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b1502ddb39c03b09$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b1502ddb39c03b09$var$X && ($b1502ddb39c03b09$var$Xj ? (a = $b1502ddb39c03b09$var$X, c = c.stateNode, 8 === a.nodeType ? $b1502ddb39c03b09$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b1502ddb39c03b09$var$Kf(a, c), $b1502ddb39c03b09$var$bd(a)) : $b1502ddb39c03b09$var$Kf($b1502ddb39c03b09$var$X, c.stateNode));
            break;
        case 4:
            d = $b1502ddb39c03b09$var$X;
            e = $b1502ddb39c03b09$var$Xj;
            $b1502ddb39c03b09$var$X = c.stateNode.containerInfo;
            $b1502ddb39c03b09$var$Xj = !0;
            $b1502ddb39c03b09$var$Yj(a, b, c);
            $b1502ddb39c03b09$var$X = d;
            $b1502ddb39c03b09$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b1502ddb39c03b09$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b1502ddb39c03b09$var$Mj(c, b, g) : 0 !== (f & 4) && $b1502ddb39c03b09$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b1502ddb39c03b09$var$Yj(a, b, c);
            break;
        case 1:
            if (!$b1502ddb39c03b09$var$U && ($b1502ddb39c03b09$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b1502ddb39c03b09$var$W(c, b, h);
            }
            $b1502ddb39c03b09$var$Yj(a, b, c);
            break;
        case 21:
            $b1502ddb39c03b09$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b1502ddb39c03b09$var$U = (d = $b1502ddb39c03b09$var$U) || null !== c.memoizedState, $b1502ddb39c03b09$var$Yj(a, b, c), $b1502ddb39c03b09$var$U = d) : $b1502ddb39c03b09$var$Yj(a, b, c);
            break;
        default:
            $b1502ddb39c03b09$var$Yj(a, b, c);
    }
}
function $b1502ddb39c03b09$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b1502ddb39c03b09$var$Kj);
        b.forEach(function(b) {
            var d = $b1502ddb39c03b09$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b1502ddb39c03b09$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b1502ddb39c03b09$var$X = h.stateNode;
                        $b1502ddb39c03b09$var$Xj = !1;
                        break a;
                    case 3:
                        $b1502ddb39c03b09$var$X = h.stateNode.containerInfo;
                        $b1502ddb39c03b09$var$Xj = !0;
                        break a;
                    case 4:
                        $b1502ddb39c03b09$var$X = h.stateNode.containerInfo;
                        $b1502ddb39c03b09$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b1502ddb39c03b09$var$X) throw Error($b1502ddb39c03b09$var$p(160));
            $b1502ddb39c03b09$var$Zj(f, g, e);
            $b1502ddb39c03b09$var$X = null;
            $b1502ddb39c03b09$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b1502ddb39c03b09$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b1502ddb39c03b09$var$dk(b, a), b = b.sibling;
}
function $b1502ddb39c03b09$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            if (d & 4) {
                try {
                    $b1502ddb39c03b09$var$Pj(3, a, a.return), $b1502ddb39c03b09$var$Qj(3, a);
                } catch (t) {
                    $b1502ddb39c03b09$var$W(a, a.return, t);
                }
                try {
                    $b1502ddb39c03b09$var$Pj(5, a, a.return);
                } catch (t) {
                    $b1502ddb39c03b09$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            d & 512 && null !== c && $b1502ddb39c03b09$var$Lj(c, c.return);
            break;
        case 5:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            d & 512 && null !== c && $b1502ddb39c03b09$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b1502ddb39c03b09$var$ob(e, "");
                } catch (t) {
                    $b1502ddb39c03b09$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b1502ddb39c03b09$var$ab(e, f);
                    $b1502ddb39c03b09$var$vb(h, g);
                    var l = $b1502ddb39c03b09$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b1502ddb39c03b09$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b1502ddb39c03b09$var$nb(e, q) : "children" === m ? $b1502ddb39c03b09$var$ob(e, q) : $b1502ddb39c03b09$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b1502ddb39c03b09$var$bb(e, f);
                            break;
                        case "textarea":
                            $b1502ddb39c03b09$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b1502ddb39c03b09$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b1502ddb39c03b09$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b1502ddb39c03b09$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b1502ddb39c03b09$var$Pf] = f;
                } catch (t) {
                    $b1502ddb39c03b09$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b1502ddb39c03b09$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b1502ddb39c03b09$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b1502ddb39c03b09$var$bd(b.containerInfo);
            } catch (t) {
                $b1502ddb39c03b09$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            break;
        case 13:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b1502ddb39c03b09$var$fk = $b1502ddb39c03b09$var$B()));
            d & 4 && $b1502ddb39c03b09$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b1502ddb39c03b09$var$U = (l = $b1502ddb39c03b09$var$U) || m, $b1502ddb39c03b09$var$ck(b, a), $b1502ddb39c03b09$var$U = l) : $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b1502ddb39c03b09$var$V = a, m = a.child; null !== m;){
                    for(q = $b1502ddb39c03b09$var$V = m; null !== $b1502ddb39c03b09$var$V;){
                        r = $b1502ddb39c03b09$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b1502ddb39c03b09$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $b1502ddb39c03b09$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b1502ddb39c03b09$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b1502ddb39c03b09$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b1502ddb39c03b09$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b1502ddb39c03b09$var$V = y) : $b1502ddb39c03b09$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b1502ddb39c03b09$var$rb("display", g));
                            } catch (t) {
                                $b1502ddb39c03b09$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b1502ddb39c03b09$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            d & 4 && $b1502ddb39c03b09$var$ak(a);
            break;
        case 21:
            break;
        default:
            $b1502ddb39c03b09$var$ck(b, a), $b1502ddb39c03b09$var$ek(a);
    }
}
function $b1502ddb39c03b09$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b1502ddb39c03b09$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b1502ddb39c03b09$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b1502ddb39c03b09$var$ob(e, ""), d.flags &= -33);
                    var f = $b1502ddb39c03b09$var$Uj(a);
                    $b1502ddb39c03b09$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b1502ddb39c03b09$var$Uj(a);
                    $b1502ddb39c03b09$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($b1502ddb39c03b09$var$p(161));
            }
        } catch (k) {
            $b1502ddb39c03b09$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b1502ddb39c03b09$var$hk(a, b, c) {
    $b1502ddb39c03b09$var$V = a;
    $b1502ddb39c03b09$var$ik(a, b, c);
}
function $b1502ddb39c03b09$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b1502ddb39c03b09$var$V;){
        var e = $b1502ddb39c03b09$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b1502ddb39c03b09$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b1502ddb39c03b09$var$U;
                h = $b1502ddb39c03b09$var$Jj;
                var l = $b1502ddb39c03b09$var$U;
                $b1502ddb39c03b09$var$Jj = g;
                if (($b1502ddb39c03b09$var$U = k) && !l) for($b1502ddb39c03b09$var$V = e; null !== $b1502ddb39c03b09$var$V;)g = $b1502ddb39c03b09$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b1502ddb39c03b09$var$jk(e) : null !== k ? (k.return = g, $b1502ddb39c03b09$var$V = k) : $b1502ddb39c03b09$var$jk(e);
                for(; null !== f;)$b1502ddb39c03b09$var$V = f, $b1502ddb39c03b09$var$ik(f, b, c), f = f.sibling;
                $b1502ddb39c03b09$var$V = e;
                $b1502ddb39c03b09$var$Jj = h;
                $b1502ddb39c03b09$var$U = l;
            }
            $b1502ddb39c03b09$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b1502ddb39c03b09$var$V = f) : $b1502ddb39c03b09$var$kk(a, b, c);
    }
}
function $b1502ddb39c03b09$var$kk(a) {
    for(; null !== $b1502ddb39c03b09$var$V;){
        var b = $b1502ddb39c03b09$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b1502ddb39c03b09$var$U || $b1502ddb39c03b09$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b1502ddb39c03b09$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b1502ddb39c03b09$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b1502ddb39c03b09$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b1502ddb39c03b09$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b1502ddb39c03b09$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b1502ddb39c03b09$var$p(163));
                }
                $b1502ddb39c03b09$var$U || b.flags & 512 && $b1502ddb39c03b09$var$Rj(b);
            } catch (r) {
                $b1502ddb39c03b09$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b1502ddb39c03b09$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b1502ddb39c03b09$var$V = c;
            break;
        }
        $b1502ddb39c03b09$var$V = b.return;
    }
}
function $b1502ddb39c03b09$var$gk(a) {
    for(; null !== $b1502ddb39c03b09$var$V;){
        var b = $b1502ddb39c03b09$var$V;
        if (b === a) {
            $b1502ddb39c03b09$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b1502ddb39c03b09$var$V = c;
            break;
        }
        $b1502ddb39c03b09$var$V = b.return;
    }
}
function $b1502ddb39c03b09$var$jk(a) {
    for(; null !== $b1502ddb39c03b09$var$V;){
        var b = $b1502ddb39c03b09$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b1502ddb39c03b09$var$Qj(4, b);
                    } catch (k) {
                        $b1502ddb39c03b09$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b1502ddb39c03b09$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b1502ddb39c03b09$var$Rj(b);
                    } catch (k) {
                        $b1502ddb39c03b09$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b1502ddb39c03b09$var$Rj(b);
                    } catch (k) {
                        $b1502ddb39c03b09$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b1502ddb39c03b09$var$W(b, b.return, k);
        }
        if (b === a) {
            $b1502ddb39c03b09$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b1502ddb39c03b09$var$V = h;
            break;
        }
        $b1502ddb39c03b09$var$V = b.return;
    }
}
var $b1502ddb39c03b09$var$lk = Math.ceil, $b1502ddb39c03b09$var$mk = $b1502ddb39c03b09$var$ua.ReactCurrentDispatcher, $b1502ddb39c03b09$var$nk = $b1502ddb39c03b09$var$ua.ReactCurrentOwner, $b1502ddb39c03b09$var$ok = $b1502ddb39c03b09$var$ua.ReactCurrentBatchConfig, $b1502ddb39c03b09$var$K = 0, $b1502ddb39c03b09$var$Q = null, $b1502ddb39c03b09$var$Y = null, $b1502ddb39c03b09$var$Z = 0, $b1502ddb39c03b09$var$fj = 0, $b1502ddb39c03b09$var$ej = $b1502ddb39c03b09$var$Uf(0), $b1502ddb39c03b09$var$T = 0, $b1502ddb39c03b09$var$pk = null, $b1502ddb39c03b09$var$rh = 0, $b1502ddb39c03b09$var$qk = 0, $b1502ddb39c03b09$var$rk = 0, $b1502ddb39c03b09$var$sk = null, $b1502ddb39c03b09$var$tk = null, $b1502ddb39c03b09$var$fk = 0, $b1502ddb39c03b09$var$Gj = Infinity, $b1502ddb39c03b09$var$uk = null, $b1502ddb39c03b09$var$Oi = !1, $b1502ddb39c03b09$var$Pi = null, $b1502ddb39c03b09$var$Ri = null, $b1502ddb39c03b09$var$vk = !1, $b1502ddb39c03b09$var$wk = null, $b1502ddb39c03b09$var$xk = 0, $b1502ddb39c03b09$var$yk = 0, $b1502ddb39c03b09$var$zk = null, $b1502ddb39c03b09$var$Ak = -1, $b1502ddb39c03b09$var$Bk = 0;
function $b1502ddb39c03b09$var$R() {
    return 0 !== ($b1502ddb39c03b09$var$K & 6) ? $b1502ddb39c03b09$var$B() : -1 !== $b1502ddb39c03b09$var$Ak ? $b1502ddb39c03b09$var$Ak : $b1502ddb39c03b09$var$Ak = $b1502ddb39c03b09$var$B();
}
function $b1502ddb39c03b09$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b1502ddb39c03b09$var$K & 2) && 0 !== $b1502ddb39c03b09$var$Z) return $b1502ddb39c03b09$var$Z & -$b1502ddb39c03b09$var$Z;
    if (null !== $b1502ddb39c03b09$var$Kg.transition) return 0 === $b1502ddb39c03b09$var$Bk && ($b1502ddb39c03b09$var$Bk = $b1502ddb39c03b09$var$yc()), $b1502ddb39c03b09$var$Bk;
    a = $b1502ddb39c03b09$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b1502ddb39c03b09$var$jd(a.type);
    return a;
}
function $b1502ddb39c03b09$var$gi(a, b, c, d) {
    if (50 < $b1502ddb39c03b09$var$yk) throw $b1502ddb39c03b09$var$yk = 0, $b1502ddb39c03b09$var$zk = null, Error($b1502ddb39c03b09$var$p(185));
    $b1502ddb39c03b09$var$Ac(a, c, d);
    if (0 === ($b1502ddb39c03b09$var$K & 2) || a !== $b1502ddb39c03b09$var$Q) a === $b1502ddb39c03b09$var$Q && (0 === ($b1502ddb39c03b09$var$K & 2) && ($b1502ddb39c03b09$var$qk |= c), 4 === $b1502ddb39c03b09$var$T && $b1502ddb39c03b09$var$Ck(a, $b1502ddb39c03b09$var$Z)), $b1502ddb39c03b09$var$Dk(a, d), 1 === c && 0 === $b1502ddb39c03b09$var$K && 0 === (b.mode & 1) && ($b1502ddb39c03b09$var$Gj = $b1502ddb39c03b09$var$B() + 500, $b1502ddb39c03b09$var$fg && $b1502ddb39c03b09$var$jg());
}
function $b1502ddb39c03b09$var$Dk(a, b) {
    var c = a.callbackNode;
    $b1502ddb39c03b09$var$wc(a, b);
    var d = $b1502ddb39c03b09$var$uc(a, a === $b1502ddb39c03b09$var$Q ? $b1502ddb39c03b09$var$Z : 0);
    if (0 === d) null !== c && $b1502ddb39c03b09$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b1502ddb39c03b09$var$bc(c);
        if (1 === b) 0 === a.tag ? $b1502ddb39c03b09$var$ig($b1502ddb39c03b09$var$Ek.bind(null, a)) : $b1502ddb39c03b09$var$hg($b1502ddb39c03b09$var$Ek.bind(null, a)), $b1502ddb39c03b09$var$Jf(function() {
            0 === ($b1502ddb39c03b09$var$K & 6) && $b1502ddb39c03b09$var$jg();
        }), c = null;
        else {
            switch($b1502ddb39c03b09$var$Dc(d)){
                case 1:
                    c = $b1502ddb39c03b09$var$fc;
                    break;
                case 4:
                    c = $b1502ddb39c03b09$var$gc;
                    break;
                case 16:
                    c = $b1502ddb39c03b09$var$hc;
                    break;
                case 536870912:
                    c = $b1502ddb39c03b09$var$jc;
                    break;
                default:
                    c = $b1502ddb39c03b09$var$hc;
            }
            c = $b1502ddb39c03b09$var$Fk(c, $b1502ddb39c03b09$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b1502ddb39c03b09$var$Gk(a, b) {
    $b1502ddb39c03b09$var$Ak = -1;
    $b1502ddb39c03b09$var$Bk = 0;
    if (0 !== ($b1502ddb39c03b09$var$K & 6)) throw Error($b1502ddb39c03b09$var$p(327));
    var c = a.callbackNode;
    if ($b1502ddb39c03b09$var$Hk() && a.callbackNode !== c) return null;
    var d = $b1502ddb39c03b09$var$uc(a, a === $b1502ddb39c03b09$var$Q ? $b1502ddb39c03b09$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b1502ddb39c03b09$var$Ik(a, d);
    else {
        b = d;
        var e = $b1502ddb39c03b09$var$K;
        $b1502ddb39c03b09$var$K |= 2;
        var f = $b1502ddb39c03b09$var$Jk();
        if ($b1502ddb39c03b09$var$Q !== a || $b1502ddb39c03b09$var$Z !== b) $b1502ddb39c03b09$var$uk = null, $b1502ddb39c03b09$var$Gj = $b1502ddb39c03b09$var$B() + 500, $b1502ddb39c03b09$var$Kk(a, b);
        for(;;)try {
            $b1502ddb39c03b09$var$Lk();
            break;
        } catch (h) {
            $b1502ddb39c03b09$var$Mk(a, h);
        }
        $b1502ddb39c03b09$var$$g();
        $b1502ddb39c03b09$var$mk.current = f;
        $b1502ddb39c03b09$var$K = e;
        null !== $b1502ddb39c03b09$var$Y ? b = 0 : ($b1502ddb39c03b09$var$Q = null, $b1502ddb39c03b09$var$Z = 0, b = $b1502ddb39c03b09$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b1502ddb39c03b09$var$xc(a), 0 !== e && (d = e, b = $b1502ddb39c03b09$var$Nk(a, e)));
        if (1 === b) throw c = $b1502ddb39c03b09$var$pk, $b1502ddb39c03b09$var$Kk(a, 0), $b1502ddb39c03b09$var$Ck(a, d), $b1502ddb39c03b09$var$Dk(a, $b1502ddb39c03b09$var$B()), c;
        if (6 === b) $b1502ddb39c03b09$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b1502ddb39c03b09$var$Ok(e) && (b = $b1502ddb39c03b09$var$Ik(a, d), 2 === b && (f = $b1502ddb39c03b09$var$xc(a), 0 !== f && (d = f, b = $b1502ddb39c03b09$var$Nk(a, f))), 1 === b)) throw c = $b1502ddb39c03b09$var$pk, $b1502ddb39c03b09$var$Kk(a, 0), $b1502ddb39c03b09$var$Ck(a, d), $b1502ddb39c03b09$var$Dk(a, $b1502ddb39c03b09$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b1502ddb39c03b09$var$p(345));
                case 2:
                    $b1502ddb39c03b09$var$Pk(a, $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$uk);
                    break;
                case 3:
                    $b1502ddb39c03b09$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $b1502ddb39c03b09$var$fk + 500 - $b1502ddb39c03b09$var$B(), 10 < b)) {
                        if (0 !== $b1502ddb39c03b09$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b1502ddb39c03b09$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b1502ddb39c03b09$var$Ff($b1502ddb39c03b09$var$Pk.bind(null, a, $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$uk), b);
                        break;
                    }
                    $b1502ddb39c03b09$var$Pk(a, $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$uk);
                    break;
                case 4:
                    $b1502ddb39c03b09$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b1502ddb39c03b09$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b1502ddb39c03b09$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b1502ddb39c03b09$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b1502ddb39c03b09$var$Ff($b1502ddb39c03b09$var$Pk.bind(null, a, $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$uk), d);
                        break;
                    }
                    $b1502ddb39c03b09$var$Pk(a, $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$uk);
                    break;
                case 5:
                    $b1502ddb39c03b09$var$Pk(a, $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$uk);
                    break;
                default:
                    throw Error($b1502ddb39c03b09$var$p(329));
            }
        }
    }
    $b1502ddb39c03b09$var$Dk(a, $b1502ddb39c03b09$var$B());
    return a.callbackNode === c ? $b1502ddb39c03b09$var$Gk.bind(null, a) : null;
}
function $b1502ddb39c03b09$var$Nk(a, b) {
    var c = $b1502ddb39c03b09$var$sk;
    a.current.memoizedState.isDehydrated && ($b1502ddb39c03b09$var$Kk(a, b).flags |= 256);
    a = $b1502ddb39c03b09$var$Ik(a, b);
    2 !== a && (b = $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$tk = c, null !== b && $b1502ddb39c03b09$var$Fj(b));
    return a;
}
function $b1502ddb39c03b09$var$Fj(a) {
    null === $b1502ddb39c03b09$var$tk ? $b1502ddb39c03b09$var$tk = a : $b1502ddb39c03b09$var$tk.push.apply($b1502ddb39c03b09$var$tk, a);
}
function $b1502ddb39c03b09$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b1502ddb39c03b09$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b1502ddb39c03b09$var$Ck(a, b) {
    b &= ~$b1502ddb39c03b09$var$rk;
    b &= ~$b1502ddb39c03b09$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b1502ddb39c03b09$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b1502ddb39c03b09$var$Ek(a) {
    if (0 !== ($b1502ddb39c03b09$var$K & 6)) throw Error($b1502ddb39c03b09$var$p(327));
    $b1502ddb39c03b09$var$Hk();
    var b = $b1502ddb39c03b09$var$uc(a, 0);
    if (0 === (b & 1)) return $b1502ddb39c03b09$var$Dk(a, $b1502ddb39c03b09$var$B()), null;
    var c = $b1502ddb39c03b09$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b1502ddb39c03b09$var$xc(a);
        0 !== d && (b = d, c = $b1502ddb39c03b09$var$Nk(a, d));
    }
    if (1 === c) throw c = $b1502ddb39c03b09$var$pk, $b1502ddb39c03b09$var$Kk(a, 0), $b1502ddb39c03b09$var$Ck(a, b), $b1502ddb39c03b09$var$Dk(a, $b1502ddb39c03b09$var$B()), c;
    if (6 === c) throw Error($b1502ddb39c03b09$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b1502ddb39c03b09$var$Pk(a, $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$uk);
    $b1502ddb39c03b09$var$Dk(a, $b1502ddb39c03b09$var$B());
    return null;
}
function $b1502ddb39c03b09$var$Qk(a, b) {
    var c = $b1502ddb39c03b09$var$K;
    $b1502ddb39c03b09$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b1502ddb39c03b09$var$K = c, 0 === $b1502ddb39c03b09$var$K && ($b1502ddb39c03b09$var$Gj = $b1502ddb39c03b09$var$B() + 500, $b1502ddb39c03b09$var$fg && $b1502ddb39c03b09$var$jg());
    }
}
function $b1502ddb39c03b09$var$Rk(a) {
    null !== $b1502ddb39c03b09$var$wk && 0 === $b1502ddb39c03b09$var$wk.tag && 0 === ($b1502ddb39c03b09$var$K & 6) && $b1502ddb39c03b09$var$Hk();
    var b = $b1502ddb39c03b09$var$K;
    $b1502ddb39c03b09$var$K |= 1;
    var c = $b1502ddb39c03b09$var$ok.transition, d = $b1502ddb39c03b09$var$C;
    try {
        if ($b1502ddb39c03b09$var$ok.transition = null, $b1502ddb39c03b09$var$C = 1, a) return a();
    } finally{
        $b1502ddb39c03b09$var$C = d, $b1502ddb39c03b09$var$ok.transition = c, $b1502ddb39c03b09$var$K = b, 0 === ($b1502ddb39c03b09$var$K & 6) && $b1502ddb39c03b09$var$jg();
    }
}
function $b1502ddb39c03b09$var$Hj() {
    $b1502ddb39c03b09$var$fj = $b1502ddb39c03b09$var$ej.current;
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$ej);
}
function $b1502ddb39c03b09$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b1502ddb39c03b09$var$Gf(c));
    if (null !== $b1502ddb39c03b09$var$Y) for(c = $b1502ddb39c03b09$var$Y.return; null !== c;){
        var d = c;
        $b1502ddb39c03b09$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b1502ddb39c03b09$var$$f();
                break;
            case 3:
                $b1502ddb39c03b09$var$zh();
                $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$Wf);
                $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$H);
                $b1502ddb39c03b09$var$Eh();
                break;
            case 5:
                $b1502ddb39c03b09$var$Bh(d);
                break;
            case 4:
                $b1502ddb39c03b09$var$zh();
                break;
            case 13:
                $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$L);
                break;
            case 19:
                $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$L);
                break;
            case 10:
                $b1502ddb39c03b09$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $b1502ddb39c03b09$var$Hj();
        }
        c = c.return;
    }
    $b1502ddb39c03b09$var$Q = a;
    $b1502ddb39c03b09$var$Y = a = $b1502ddb39c03b09$var$Pg(a.current, null);
    $b1502ddb39c03b09$var$Z = $b1502ddb39c03b09$var$fj = b;
    $b1502ddb39c03b09$var$T = 0;
    $b1502ddb39c03b09$var$pk = null;
    $b1502ddb39c03b09$var$rk = $b1502ddb39c03b09$var$qk = $b1502ddb39c03b09$var$rh = 0;
    $b1502ddb39c03b09$var$tk = $b1502ddb39c03b09$var$sk = null;
    if (null !== $b1502ddb39c03b09$var$fh) {
        for(b = 0; b < $b1502ddb39c03b09$var$fh.length; b++)if (c = $b1502ddb39c03b09$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b1502ddb39c03b09$var$fh = null;
    }
    return a;
}
function $b1502ddb39c03b09$var$Mk(a, b) {
    do {
        var c = $b1502ddb39c03b09$var$Y;
        try {
            $b1502ddb39c03b09$var$$g();
            $b1502ddb39c03b09$var$Fh.current = $b1502ddb39c03b09$var$Rh;
            if ($b1502ddb39c03b09$var$Ih) {
                for(var d = $b1502ddb39c03b09$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b1502ddb39c03b09$var$Ih = !1;
            }
            $b1502ddb39c03b09$var$Hh = 0;
            $b1502ddb39c03b09$var$O = $b1502ddb39c03b09$var$N = $b1502ddb39c03b09$var$M = null;
            $b1502ddb39c03b09$var$Jh = !1;
            $b1502ddb39c03b09$var$Kh = 0;
            $b1502ddb39c03b09$var$nk.current = null;
            if (null === c || null === c.return) {
                $b1502ddb39c03b09$var$T = 1;
                $b1502ddb39c03b09$var$pk = b;
                $b1502ddb39c03b09$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b1502ddb39c03b09$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b1502ddb39c03b09$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b1502ddb39c03b09$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $b1502ddb39c03b09$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b1502ddb39c03b09$var$Si(f, l, b);
                            $b1502ddb39c03b09$var$tj();
                            break a;
                        }
                        k = Error($b1502ddb39c03b09$var$p(426));
                    }
                } else if ($b1502ddb39c03b09$var$I && h.mode & 1) {
                    var J = $b1502ddb39c03b09$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b1502ddb39c03b09$var$Vi(J, g, h, f, b);
                        $b1502ddb39c03b09$var$Jg($b1502ddb39c03b09$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $b1502ddb39c03b09$var$Ji(k, h);
                4 !== $b1502ddb39c03b09$var$T && ($b1502ddb39c03b09$var$T = 2);
                null === $b1502ddb39c03b09$var$sk ? $b1502ddb39c03b09$var$sk = [
                    f
                ] : $b1502ddb39c03b09$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b1502ddb39c03b09$var$Ni(f, k, b);
                            $b1502ddb39c03b09$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b1502ddb39c03b09$var$Ri || !$b1502ddb39c03b09$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b1502ddb39c03b09$var$Qi(f, h, b);
                                $b1502ddb39c03b09$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b1502ddb39c03b09$var$Sk(c);
        } catch (na) {
            b = na;
            $b1502ddb39c03b09$var$Y === c && null !== c && ($b1502ddb39c03b09$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b1502ddb39c03b09$var$Jk() {
    var a = $b1502ddb39c03b09$var$mk.current;
    $b1502ddb39c03b09$var$mk.current = $b1502ddb39c03b09$var$Rh;
    return null === a ? $b1502ddb39c03b09$var$Rh : a;
}
function $b1502ddb39c03b09$var$tj() {
    if (0 === $b1502ddb39c03b09$var$T || 3 === $b1502ddb39c03b09$var$T || 2 === $b1502ddb39c03b09$var$T) $b1502ddb39c03b09$var$T = 4;
    null === $b1502ddb39c03b09$var$Q || 0 === ($b1502ddb39c03b09$var$rh & 268435455) && 0 === ($b1502ddb39c03b09$var$qk & 268435455) || $b1502ddb39c03b09$var$Ck($b1502ddb39c03b09$var$Q, $b1502ddb39c03b09$var$Z);
}
function $b1502ddb39c03b09$var$Ik(a, b) {
    var c = $b1502ddb39c03b09$var$K;
    $b1502ddb39c03b09$var$K |= 2;
    var d = $b1502ddb39c03b09$var$Jk();
    if ($b1502ddb39c03b09$var$Q !== a || $b1502ddb39c03b09$var$Z !== b) $b1502ddb39c03b09$var$uk = null, $b1502ddb39c03b09$var$Kk(a, b);
    for(;;)try {
        $b1502ddb39c03b09$var$Tk();
        break;
    } catch (e) {
        $b1502ddb39c03b09$var$Mk(a, e);
    }
    $b1502ddb39c03b09$var$$g();
    $b1502ddb39c03b09$var$K = c;
    $b1502ddb39c03b09$var$mk.current = d;
    if (null !== $b1502ddb39c03b09$var$Y) throw Error($b1502ddb39c03b09$var$p(261));
    $b1502ddb39c03b09$var$Q = null;
    $b1502ddb39c03b09$var$Z = 0;
    return $b1502ddb39c03b09$var$T;
}
function $b1502ddb39c03b09$var$Tk() {
    for(; null !== $b1502ddb39c03b09$var$Y;)$b1502ddb39c03b09$var$Uk($b1502ddb39c03b09$var$Y);
}
function $b1502ddb39c03b09$var$Lk() {
    for(; null !== $b1502ddb39c03b09$var$Y && !$b1502ddb39c03b09$var$cc();)$b1502ddb39c03b09$var$Uk($b1502ddb39c03b09$var$Y);
}
function $b1502ddb39c03b09$var$Uk(a) {
    var b = $b1502ddb39c03b09$var$Vk(a.alternate, a, $b1502ddb39c03b09$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b1502ddb39c03b09$var$Sk(a) : $b1502ddb39c03b09$var$Y = b;
    $b1502ddb39c03b09$var$nk.current = null;
}
function $b1502ddb39c03b09$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b1502ddb39c03b09$var$Ej(c, b, $b1502ddb39c03b09$var$fj), null !== c) {
                $b1502ddb39c03b09$var$Y = c;
                return;
            }
        } else {
            c = $b1502ddb39c03b09$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b1502ddb39c03b09$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b1502ddb39c03b09$var$T = 6;
                $b1502ddb39c03b09$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b1502ddb39c03b09$var$Y = b;
            return;
        }
        $b1502ddb39c03b09$var$Y = b = a;
    }while (null !== b);
    0 === $b1502ddb39c03b09$var$T && ($b1502ddb39c03b09$var$T = 5);
}
function $b1502ddb39c03b09$var$Pk(a, b, c) {
    var d = $b1502ddb39c03b09$var$C, e = $b1502ddb39c03b09$var$ok.transition;
    try {
        $b1502ddb39c03b09$var$ok.transition = null, $b1502ddb39c03b09$var$C = 1, $b1502ddb39c03b09$var$Wk(a, b, c, d);
    } finally{
        $b1502ddb39c03b09$var$ok.transition = e, $b1502ddb39c03b09$var$C = d;
    }
    return null;
}
function $b1502ddb39c03b09$var$Wk(a, b, c, d) {
    do $b1502ddb39c03b09$var$Hk();
    while (null !== $b1502ddb39c03b09$var$wk);
    if (0 !== ($b1502ddb39c03b09$var$K & 6)) throw Error($b1502ddb39c03b09$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b1502ddb39c03b09$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b1502ddb39c03b09$var$Bc(a, f);
    a === $b1502ddb39c03b09$var$Q && ($b1502ddb39c03b09$var$Y = $b1502ddb39c03b09$var$Q = null, $b1502ddb39c03b09$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b1502ddb39c03b09$var$vk || ($b1502ddb39c03b09$var$vk = !0, $b1502ddb39c03b09$var$Fk($b1502ddb39c03b09$var$hc, function() {
        $b1502ddb39c03b09$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b1502ddb39c03b09$var$ok.transition;
        $b1502ddb39c03b09$var$ok.transition = null;
        var g = $b1502ddb39c03b09$var$C;
        $b1502ddb39c03b09$var$C = 1;
        var h = $b1502ddb39c03b09$var$K;
        $b1502ddb39c03b09$var$K |= 4;
        $b1502ddb39c03b09$var$nk.current = null;
        $b1502ddb39c03b09$var$Oj(a, c);
        $b1502ddb39c03b09$var$dk(c, a);
        $b1502ddb39c03b09$var$Oe($b1502ddb39c03b09$var$Df);
        $b1502ddb39c03b09$var$dd = !!$b1502ddb39c03b09$var$Cf;
        $b1502ddb39c03b09$var$Df = $b1502ddb39c03b09$var$Cf = null;
        a.current = c;
        $b1502ddb39c03b09$var$hk(c, a, e);
        $b1502ddb39c03b09$var$dc();
        $b1502ddb39c03b09$var$K = h;
        $b1502ddb39c03b09$var$C = g;
        $b1502ddb39c03b09$var$ok.transition = f;
    } else a.current = c;
    $b1502ddb39c03b09$var$vk && ($b1502ddb39c03b09$var$vk = !1, $b1502ddb39c03b09$var$wk = a, $b1502ddb39c03b09$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($b1502ddb39c03b09$var$Ri = null);
    $b1502ddb39c03b09$var$mc(c.stateNode, d);
    $b1502ddb39c03b09$var$Dk(a, $b1502ddb39c03b09$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b1502ddb39c03b09$var$Oi) throw $b1502ddb39c03b09$var$Oi = !1, a = $b1502ddb39c03b09$var$Pi, $b1502ddb39c03b09$var$Pi = null, a;
    0 !== ($b1502ddb39c03b09$var$xk & 1) && 0 !== a.tag && $b1502ddb39c03b09$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b1502ddb39c03b09$var$zk ? $b1502ddb39c03b09$var$yk++ : ($b1502ddb39c03b09$var$yk = 0, $b1502ddb39c03b09$var$zk = a) : $b1502ddb39c03b09$var$yk = 0;
    $b1502ddb39c03b09$var$jg();
    return null;
}
function $b1502ddb39c03b09$var$Hk() {
    if (null !== $b1502ddb39c03b09$var$wk) {
        var a = $b1502ddb39c03b09$var$Dc($b1502ddb39c03b09$var$xk), b = $b1502ddb39c03b09$var$ok.transition, c = $b1502ddb39c03b09$var$C;
        try {
            $b1502ddb39c03b09$var$ok.transition = null;
            $b1502ddb39c03b09$var$C = 16 > a ? 16 : a;
            if (null === $b1502ddb39c03b09$var$wk) var d = !1;
            else {
                a = $b1502ddb39c03b09$var$wk;
                $b1502ddb39c03b09$var$wk = null;
                $b1502ddb39c03b09$var$xk = 0;
                if (0 !== ($b1502ddb39c03b09$var$K & 6)) throw Error($b1502ddb39c03b09$var$p(331));
                var e = $b1502ddb39c03b09$var$K;
                $b1502ddb39c03b09$var$K |= 4;
                for($b1502ddb39c03b09$var$V = a.current; null !== $b1502ddb39c03b09$var$V;){
                    var f = $b1502ddb39c03b09$var$V, g = f.child;
                    if (0 !== ($b1502ddb39c03b09$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b1502ddb39c03b09$var$V = l; null !== $b1502ddb39c03b09$var$V;){
                                    var m = $b1502ddb39c03b09$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b1502ddb39c03b09$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b1502ddb39c03b09$var$V = q;
                                    else for(; null !== $b1502ddb39c03b09$var$V;){
                                        m = $b1502ddb39c03b09$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b1502ddb39c03b09$var$Sj(m);
                                        if (m === l) {
                                            $b1502ddb39c03b09$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b1502ddb39c03b09$var$V = r;
                                            break;
                                        }
                                        $b1502ddb39c03b09$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b1502ddb39c03b09$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b1502ddb39c03b09$var$V = g;
                    else b: for(; null !== $b1502ddb39c03b09$var$V;){
                        f = $b1502ddb39c03b09$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b1502ddb39c03b09$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b1502ddb39c03b09$var$V = x;
                            break b;
                        }
                        $b1502ddb39c03b09$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b1502ddb39c03b09$var$V = w; null !== $b1502ddb39c03b09$var$V;){
                    g = $b1502ddb39c03b09$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b1502ddb39c03b09$var$V = u;
                    else b: for(g = w; null !== $b1502ddb39c03b09$var$V;){
                        h = $b1502ddb39c03b09$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b1502ddb39c03b09$var$Qj(9, h);
                            }
                        } catch (na) {
                            $b1502ddb39c03b09$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b1502ddb39c03b09$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b1502ddb39c03b09$var$V = F;
                            break b;
                        }
                        $b1502ddb39c03b09$var$V = h.return;
                    }
                }
                $b1502ddb39c03b09$var$K = e;
                $b1502ddb39c03b09$var$jg();
                if ($b1502ddb39c03b09$var$lc && "function" === typeof $b1502ddb39c03b09$var$lc.onPostCommitFiberRoot) try {
                    $b1502ddb39c03b09$var$lc.onPostCommitFiberRoot($b1502ddb39c03b09$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b1502ddb39c03b09$var$C = c, $b1502ddb39c03b09$var$ok.transition = b;
        }
    }
    return !1;
}
function $b1502ddb39c03b09$var$Xk(a, b, c) {
    b = $b1502ddb39c03b09$var$Ji(c, b);
    b = $b1502ddb39c03b09$var$Ni(a, b, 1);
    a = $b1502ddb39c03b09$var$nh(a, b, 1);
    b = $b1502ddb39c03b09$var$R();
    null !== a && ($b1502ddb39c03b09$var$Ac(a, 1, b), $b1502ddb39c03b09$var$Dk(a, b));
}
function $b1502ddb39c03b09$var$W(a, b, c) {
    if (3 === a.tag) $b1502ddb39c03b09$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b1502ddb39c03b09$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b1502ddb39c03b09$var$Ri || !$b1502ddb39c03b09$var$Ri.has(d))) {
                a = $b1502ddb39c03b09$var$Ji(c, a);
                a = $b1502ddb39c03b09$var$Qi(b, a, 1);
                b = $b1502ddb39c03b09$var$nh(b, a, 1);
                a = $b1502ddb39c03b09$var$R();
                null !== b && ($b1502ddb39c03b09$var$Ac(b, 1, a), $b1502ddb39c03b09$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b1502ddb39c03b09$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b1502ddb39c03b09$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $b1502ddb39c03b09$var$Q === a && ($b1502ddb39c03b09$var$Z & c) === c && (4 === $b1502ddb39c03b09$var$T || 3 === $b1502ddb39c03b09$var$T && ($b1502ddb39c03b09$var$Z & 130023424) === $b1502ddb39c03b09$var$Z && 500 > $b1502ddb39c03b09$var$B() - $b1502ddb39c03b09$var$fk ? $b1502ddb39c03b09$var$Kk(a, 0) : $b1502ddb39c03b09$var$rk |= c);
    $b1502ddb39c03b09$var$Dk(a, b);
}
function $b1502ddb39c03b09$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b1502ddb39c03b09$var$sc, $b1502ddb39c03b09$var$sc <<= 1, 0 === ($b1502ddb39c03b09$var$sc & 130023424) && ($b1502ddb39c03b09$var$sc = 4194304)));
    var c = $b1502ddb39c03b09$var$R();
    a = $b1502ddb39c03b09$var$ih(a, b);
    null !== a && ($b1502ddb39c03b09$var$Ac(a, b, c), $b1502ddb39c03b09$var$Dk(a, c));
}
function $b1502ddb39c03b09$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b1502ddb39c03b09$var$Yk(a, c);
}
function $b1502ddb39c03b09$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b1502ddb39c03b09$var$p(314));
    }
    null !== d && d.delete(b);
    $b1502ddb39c03b09$var$Yk(a, c);
}
var $b1502ddb39c03b09$var$Vk;
$b1502ddb39c03b09$var$Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b1502ddb39c03b09$var$Wf.current) $b1502ddb39c03b09$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b1502ddb39c03b09$var$dh = !1, $b1502ddb39c03b09$var$yj(a, b, c);
            $b1502ddb39c03b09$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b1502ddb39c03b09$var$dh = !1, $b1502ddb39c03b09$var$I && 0 !== (b.flags & 1048576) && $b1502ddb39c03b09$var$ug(b, $b1502ddb39c03b09$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b1502ddb39c03b09$var$ij(a, b);
            a = b.pendingProps;
            var e = $b1502ddb39c03b09$var$Yf(b, $b1502ddb39c03b09$var$H.current);
            $b1502ddb39c03b09$var$ch(b, c);
            e = $b1502ddb39c03b09$var$Nh(null, b, d, a, e, c);
            var f = $b1502ddb39c03b09$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b1502ddb39c03b09$var$Zf(d) ? (f = !0, $b1502ddb39c03b09$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b1502ddb39c03b09$var$kh(b), e.updater = $b1502ddb39c03b09$var$Ei, b.stateNode = e, e._reactInternals = b, $b1502ddb39c03b09$var$Ii(b, d, a, c), b = $b1502ddb39c03b09$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $b1502ddb39c03b09$var$I && f && $b1502ddb39c03b09$var$vg(b), $b1502ddb39c03b09$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b1502ddb39c03b09$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b1502ddb39c03b09$var$Zk(d);
                a = $b1502ddb39c03b09$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $b1502ddb39c03b09$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b1502ddb39c03b09$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b1502ddb39c03b09$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b1502ddb39c03b09$var$$i(null, b, d, $b1502ddb39c03b09$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($b1502ddb39c03b09$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b1502ddb39c03b09$var$Ci(d, e), $b1502ddb39c03b09$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b1502ddb39c03b09$var$Ci(d, e), $b1502ddb39c03b09$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $b1502ddb39c03b09$var$kj(b);
                if (null === a) throw Error($b1502ddb39c03b09$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b1502ddb39c03b09$var$lh(a, b);
                $b1502ddb39c03b09$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b1502ddb39c03b09$var$Ji(Error($b1502ddb39c03b09$var$p(423)), b);
                        b = $b1502ddb39c03b09$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b1502ddb39c03b09$var$Ji(Error($b1502ddb39c03b09$var$p(424)), b);
                        b = $b1502ddb39c03b09$var$lj(a, b, d, c, e);
                        break a;
                    } else for($b1502ddb39c03b09$var$yg = $b1502ddb39c03b09$var$Lf(b.stateNode.containerInfo.firstChild), $b1502ddb39c03b09$var$xg = b, $b1502ddb39c03b09$var$I = !0, $b1502ddb39c03b09$var$zg = null, c = $b1502ddb39c03b09$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b1502ddb39c03b09$var$Ig();
                    if (d === e) {
                        b = $b1502ddb39c03b09$var$Zi(a, b, c);
                        break a;
                    }
                    $b1502ddb39c03b09$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b1502ddb39c03b09$var$Ah(b), null === a && $b1502ddb39c03b09$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b1502ddb39c03b09$var$Ef(d, e) ? g = null : null !== f && $b1502ddb39c03b09$var$Ef(d, f) && (b.flags |= 32), $b1502ddb39c03b09$var$gj(a, b), $b1502ddb39c03b09$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $b1502ddb39c03b09$var$Eg(b), null;
        case 13:
            return $b1502ddb39c03b09$var$oj(a, b, c);
        case 4:
            return $b1502ddb39c03b09$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b1502ddb39c03b09$var$Ug(b, null, d, c) : $b1502ddb39c03b09$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b1502ddb39c03b09$var$Ci(d, e), $b1502ddb39c03b09$var$Yi(a, b, d, e, c);
        case 7:
            return $b1502ddb39c03b09$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b1502ddb39c03b09$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b1502ddb39c03b09$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b1502ddb39c03b09$var$He(f.value, g)) {
                        if (f.children === e.children && !$b1502ddb39c03b09$var$Wf.current) {
                            b = $b1502ddb39c03b09$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b1502ddb39c03b09$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b1502ddb39c03b09$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b1502ddb39c03b09$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b1502ddb39c03b09$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b1502ddb39c03b09$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b1502ddb39c03b09$var$ch(b, c), e = $b1502ddb39c03b09$var$eh(e), d = d(e), b.flags |= 1, $b1502ddb39c03b09$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b1502ddb39c03b09$var$Ci(d, b.pendingProps), e = $b1502ddb39c03b09$var$Ci(d.type, e), $b1502ddb39c03b09$var$$i(a, b, d, e, c);
        case 15:
            return $b1502ddb39c03b09$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b1502ddb39c03b09$var$Ci(d, e), $b1502ddb39c03b09$var$ij(a, b), b.tag = 1, $b1502ddb39c03b09$var$Zf(d) ? (a = !0, $b1502ddb39c03b09$var$cg(b)) : a = !1, $b1502ddb39c03b09$var$ch(b, c), $b1502ddb39c03b09$var$Gi(b, d, e), $b1502ddb39c03b09$var$Ii(b, d, e, c), $b1502ddb39c03b09$var$jj(null, b, d, !0, a, c);
        case 19:
            return $b1502ddb39c03b09$var$xj(a, b, c);
        case 22:
            return $b1502ddb39c03b09$var$dj(a, b, c);
    }
    throw Error($b1502ddb39c03b09$var$p(156, b.tag));
};
function $b1502ddb39c03b09$var$Fk(a, b) {
    return $b1502ddb39c03b09$var$ac(a, b);
}
function $b1502ddb39c03b09$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b1502ddb39c03b09$var$Bg(a, b, c, d) {
    return new $b1502ddb39c03b09$var$$k(a, b, c, d);
}
function $b1502ddb39c03b09$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b1502ddb39c03b09$var$Zk(a) {
    if ("function" === typeof a) return $b1502ddb39c03b09$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b1502ddb39c03b09$var$Da) return 11;
        if (a === $b1502ddb39c03b09$var$Ga) return 14;
    }
    return 2;
}
function $b1502ddb39c03b09$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b1502ddb39c03b09$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b1502ddb39c03b09$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b1502ddb39c03b09$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b1502ddb39c03b09$var$ya:
            return $b1502ddb39c03b09$var$Tg(c.children, e, f, b);
        case $b1502ddb39c03b09$var$za:
            g = 8;
            e |= 8;
            break;
        case $b1502ddb39c03b09$var$Aa:
            return a = $b1502ddb39c03b09$var$Bg(12, c, b, e | 2), a.elementType = $b1502ddb39c03b09$var$Aa, a.lanes = f, a;
        case $b1502ddb39c03b09$var$Ea:
            return a = $b1502ddb39c03b09$var$Bg(13, c, b, e), a.elementType = $b1502ddb39c03b09$var$Ea, a.lanes = f, a;
        case $b1502ddb39c03b09$var$Fa:
            return a = $b1502ddb39c03b09$var$Bg(19, c, b, e), a.elementType = $b1502ddb39c03b09$var$Fa, a.lanes = f, a;
        case $b1502ddb39c03b09$var$Ia:
            return $b1502ddb39c03b09$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b1502ddb39c03b09$var$Ba:
                    g = 10;
                    break a;
                case $b1502ddb39c03b09$var$Ca:
                    g = 9;
                    break a;
                case $b1502ddb39c03b09$var$Da:
                    g = 11;
                    break a;
                case $b1502ddb39c03b09$var$Ga:
                    g = 14;
                    break a;
                case $b1502ddb39c03b09$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b1502ddb39c03b09$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $gnDeW._)(a), ""));
    }
    b = $b1502ddb39c03b09$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b1502ddb39c03b09$var$Tg(a, b, c, d) {
    a = $b1502ddb39c03b09$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b1502ddb39c03b09$var$pj(a, b, c, d) {
    a = $b1502ddb39c03b09$var$Bg(22, a, d, b);
    a.elementType = $b1502ddb39c03b09$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b1502ddb39c03b09$var$Qg(a, b, c) {
    a = $b1502ddb39c03b09$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b1502ddb39c03b09$var$Sg(a, b, c) {
    b = $b1502ddb39c03b09$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b1502ddb39c03b09$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b1502ddb39c03b09$var$zc(0);
    this.expirationTimes = $b1502ddb39c03b09$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b1502ddb39c03b09$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b1502ddb39c03b09$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $b1502ddb39c03b09$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b1502ddb39c03b09$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b1502ddb39c03b09$var$kh(f);
    return a;
}
function $b1502ddb39c03b09$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b1502ddb39c03b09$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b1502ddb39c03b09$var$dl(a) {
    if (!a) return $b1502ddb39c03b09$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b1502ddb39c03b09$var$Vb(a) !== a || 1 !== a.tag) throw Error($b1502ddb39c03b09$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b1502ddb39c03b09$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b1502ddb39c03b09$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b1502ddb39c03b09$var$Zf(c)) return $b1502ddb39c03b09$var$bg(a, c, b);
    }
    return b;
}
function $b1502ddb39c03b09$var$el(a, b, c, d, e, f, g, h, k) {
    a = $b1502ddb39c03b09$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $b1502ddb39c03b09$var$dl(null);
    c = a.current;
    d = $b1502ddb39c03b09$var$R();
    e = $b1502ddb39c03b09$var$yi(c);
    f = $b1502ddb39c03b09$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b1502ddb39c03b09$var$nh(c, f, e);
    a.current.lanes = e;
    $b1502ddb39c03b09$var$Ac(a, e, d);
    $b1502ddb39c03b09$var$Dk(a, d);
    return a;
}
function $b1502ddb39c03b09$var$fl(a, b, c, d) {
    var e = b.current, f = $b1502ddb39c03b09$var$R(), g = $b1502ddb39c03b09$var$yi(e);
    c = $b1502ddb39c03b09$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b1502ddb39c03b09$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b1502ddb39c03b09$var$nh(e, b, g);
    null !== a && ($b1502ddb39c03b09$var$gi(a, e, g, f), $b1502ddb39c03b09$var$oh(a, e, g));
    return g;
}
function $b1502ddb39c03b09$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b1502ddb39c03b09$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b1502ddb39c03b09$var$il(a, b) {
    $b1502ddb39c03b09$var$hl(a, b);
    (a = a.alternate) && $b1502ddb39c03b09$var$hl(a, b);
}
function $b1502ddb39c03b09$var$jl() {
    return null;
}
var $b1502ddb39c03b09$var$kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function $b1502ddb39c03b09$var$ll(a) {
    this._internalRoot = a;
}
$b1502ddb39c03b09$var$ml.prototype.render = $b1502ddb39c03b09$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b1502ddb39c03b09$var$p(409));
    $b1502ddb39c03b09$var$fl(a, b, null, null);
};
$b1502ddb39c03b09$var$ml.prototype.unmount = $b1502ddb39c03b09$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b1502ddb39c03b09$var$Rk(function() {
            $b1502ddb39c03b09$var$fl(null, a, null, null);
        });
        b[$b1502ddb39c03b09$var$uf] = null;
    }
};
function $b1502ddb39c03b09$var$ml(a) {
    this._internalRoot = a;
}
$b1502ddb39c03b09$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b1502ddb39c03b09$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b1502ddb39c03b09$var$Qc.length && 0 !== b && b < $b1502ddb39c03b09$var$Qc[c].priority; c++);
        $b1502ddb39c03b09$var$Qc.splice(c, 0, a);
        0 === c && $b1502ddb39c03b09$var$Vc(a);
    }
};
function $b1502ddb39c03b09$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b1502ddb39c03b09$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b1502ddb39c03b09$var$pl() {}
function $b1502ddb39c03b09$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $b1502ddb39c03b09$var$gl(g);
                f.call(_$a);
            };
        }
        var g = $b1502ddb39c03b09$var$el(b, d, a, 0, null, !1, !1, "", $b1502ddb39c03b09$var$pl);
        a._reactRootContainer = g;
        a[$b1502ddb39c03b09$var$uf] = g.current;
        $b1502ddb39c03b09$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b1502ddb39c03b09$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $b1502ddb39c03b09$var$gl(k);
            h.call(_$a);
        };
    }
    var k = $b1502ddb39c03b09$var$bl(a, 0, !1, null, null, !1, !1, "", $b1502ddb39c03b09$var$pl);
    a._reactRootContainer = k;
    a[$b1502ddb39c03b09$var$uf] = k.current;
    $b1502ddb39c03b09$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b1502ddb39c03b09$var$Rk(function() {
        $b1502ddb39c03b09$var$fl(b, k, c, d);
    });
    return k;
}
function $b1502ddb39c03b09$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $b1502ddb39c03b09$var$gl(g);
                h.call(_$a);
            };
        }
        $b1502ddb39c03b09$var$fl(b, g, a, e);
    } else g = $b1502ddb39c03b09$var$ql(c, b, a, e, d);
    return $b1502ddb39c03b09$var$gl(g);
}
$b1502ddb39c03b09$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b1502ddb39c03b09$var$tc(b.pendingLanes);
                0 !== c && ($b1502ddb39c03b09$var$Cc(b, c | 1), $b1502ddb39c03b09$var$Dk(b, $b1502ddb39c03b09$var$B()), 0 === ($b1502ddb39c03b09$var$K & 6) && ($b1502ddb39c03b09$var$Gj = $b1502ddb39c03b09$var$B() + 500, $b1502ddb39c03b09$var$jg()));
            }
            break;
        case 13:
            $b1502ddb39c03b09$var$Rk(function() {
                var b = $b1502ddb39c03b09$var$ih(a, 1);
                if (null !== b) {
                    var c = $b1502ddb39c03b09$var$R();
                    $b1502ddb39c03b09$var$gi(b, a, 1, c);
                }
            }), $b1502ddb39c03b09$var$il(a, 1);
    }
};
$b1502ddb39c03b09$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $b1502ddb39c03b09$var$ih(a, 134217728);
        if (null !== b) {
            var c = $b1502ddb39c03b09$var$R();
            $b1502ddb39c03b09$var$gi(b, a, 134217728, c);
        }
        $b1502ddb39c03b09$var$il(a, 134217728);
    }
};
$b1502ddb39c03b09$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $b1502ddb39c03b09$var$yi(a), c = $b1502ddb39c03b09$var$ih(a, b);
        if (null !== c) {
            var d = $b1502ddb39c03b09$var$R();
            $b1502ddb39c03b09$var$gi(c, a, b, d);
        }
        $b1502ddb39c03b09$var$il(a, b);
    }
};
$b1502ddb39c03b09$var$Hc = function Hc() {
    return $b1502ddb39c03b09$var$C;
};
$b1502ddb39c03b09$var$Ic = function Ic(a, b) {
    var c = $b1502ddb39c03b09$var$C;
    try {
        return $b1502ddb39c03b09$var$C = a, b();
    } finally{
        $b1502ddb39c03b09$var$C = c;
    }
};
$b1502ddb39c03b09$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $b1502ddb39c03b09$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b1502ddb39c03b09$var$Db(d);
                        if (!e) throw Error($b1502ddb39c03b09$var$p(90));
                        $b1502ddb39c03b09$var$Wa(d);
                        $b1502ddb39c03b09$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b1502ddb39c03b09$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b1502ddb39c03b09$var$fb(a, !!c.multiple, b, !1);
    }
};
$b1502ddb39c03b09$var$Gb = $b1502ddb39c03b09$var$Qk;
$b1502ddb39c03b09$var$Hb = $b1502ddb39c03b09$var$Rk;
var $b1502ddb39c03b09$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $b1502ddb39c03b09$var$Cb,
        $b1502ddb39c03b09$var$ue,
        $b1502ddb39c03b09$var$Db,
        $b1502ddb39c03b09$var$Eb,
        $b1502ddb39c03b09$var$Fb,
        $b1502ddb39c03b09$var$Qk
    ]
}, $b1502ddb39c03b09$var$tl = {
    findFiberByHostInstance: $b1502ddb39c03b09$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $b1502ddb39c03b09$var$ul = {
    bundleType: $b1502ddb39c03b09$var$tl.bundleType,
    version: $b1502ddb39c03b09$var$tl.version,
    rendererPackageName: $b1502ddb39c03b09$var$tl.rendererPackageName,
    rendererConfig: $b1502ddb39c03b09$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b1502ddb39c03b09$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $b1502ddb39c03b09$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b1502ddb39c03b09$var$tl.findFiberByHostInstance || $b1502ddb39c03b09$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b1502ddb39c03b09$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b1502ddb39c03b09$var$vl.isDisabled && $b1502ddb39c03b09$var$vl.supportsFiber) try {
        $b1502ddb39c03b09$var$kc = $b1502ddb39c03b09$var$vl.inject($b1502ddb39c03b09$var$ul), $b1502ddb39c03b09$var$lc = $b1502ddb39c03b09$var$vl;
    } catch (a) {}
}
$b1502ddb39c03b09$export$ae55be85d98224ed = $b1502ddb39c03b09$var$sl;
$b1502ddb39c03b09$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b1502ddb39c03b09$var$nl(b)) throw Error($b1502ddb39c03b09$var$p(200));
    return $b1502ddb39c03b09$var$cl(a, b, null, c);
};
$b1502ddb39c03b09$export$882461b6382ed46c = function(a, b) {
    if (!$b1502ddb39c03b09$var$nl(a)) throw Error($b1502ddb39c03b09$var$p(299));
    var c = !1, d = "", e = $b1502ddb39c03b09$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b1502ddb39c03b09$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$b1502ddb39c03b09$var$uf] = b.current;
    $b1502ddb39c03b09$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b1502ddb39c03b09$var$ll(b);
};
$b1502ddb39c03b09$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b1502ddb39c03b09$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b1502ddb39c03b09$var$p(268, a));
    }
    a = $b1502ddb39c03b09$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b1502ddb39c03b09$export$cd75ccfd720a3cd4 = function(a) {
    return $b1502ddb39c03b09$var$Rk(a);
};
$b1502ddb39c03b09$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b1502ddb39c03b09$var$ol(b)) throw Error($b1502ddb39c03b09$var$p(200));
    return $b1502ddb39c03b09$var$rl(null, a, b, !0, c);
};
$b1502ddb39c03b09$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b1502ddb39c03b09$var$nl(a)) throw Error($b1502ddb39c03b09$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b1502ddb39c03b09$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b1502ddb39c03b09$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b1502ddb39c03b09$var$uf] = b.current;
    $b1502ddb39c03b09$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b1502ddb39c03b09$var$ml(b);
};
$b1502ddb39c03b09$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b1502ddb39c03b09$var$ol(b)) throw Error($b1502ddb39c03b09$var$p(200));
    return $b1502ddb39c03b09$var$rl(null, a, b, !1, c);
};
$b1502ddb39c03b09$export$502457920280e6be = function(a) {
    if (!$b1502ddb39c03b09$var$ol(a)) throw Error($b1502ddb39c03b09$var$p(40));
    return a._reactRootContainer ? ($b1502ddb39c03b09$var$Rk(function() {
        $b1502ddb39c03b09$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b1502ddb39c03b09$var$uf] = null;
        });
    }), !0) : !1;
};
$b1502ddb39c03b09$export$c78a37762a8d58e1 = $b1502ddb39c03b09$var$Qk;
$b1502ddb39c03b09$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b1502ddb39c03b09$var$ol(c)) throw Error($b1502ddb39c03b09$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b1502ddb39c03b09$var$p(38));
    return $b1502ddb39c03b09$var$rl(a, b, c, !1, d);
};
$b1502ddb39c03b09$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("bE6KD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("15wph"));

});
parcelRegister("15wph", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $0caf65653c79c297$export$c4744153514ff05d; }, function (v) { return $0caf65653c79c297$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $0caf65653c79c297$export$3e506c1ccc9cc1a7; }, function (v) { return $0caf65653c79c297$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $0caf65653c79c297$export$e26fe2ed2fa76875; }, function (v) { return $0caf65653c79c297$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $0caf65653c79c297$export$502329bbf4b505b1; }, function (v) { return $0caf65653c79c297$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $0caf65653c79c297$export$6e3807111c4874c4; }, function (v) { return $0caf65653c79c297$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $0caf65653c79c297$export$c27134553091fb3a; }, function (v) { return $0caf65653c79c297$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $0caf65653c79c297$export$33ee1acdc04fd2a2; }, function (v) { return $0caf65653c79c297$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $0caf65653c79c297$export$b00a404bbd5edef2; }, function (v) { return $0caf65653c79c297$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $0caf65653c79c297$export$8352ce38b91d0c62; }, function (v) { return $0caf65653c79c297$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $0caf65653c79c297$export$d66a1c1c77bd778b; }, function (v) { return $0caf65653c79c297$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $0caf65653c79c297$export$d3dfb8e4810cb555; }, function (v) { return $0caf65653c79c297$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $0caf65653c79c297$export$839f9183b0465a69; }, function (v) { return $0caf65653c79c297$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $0caf65653c79c297$export$72fdf0e06517287b; }, function (v) { return $0caf65653c79c297$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $0caf65653c79c297$export$4b844e58a3e414b4; }, function (v) { return $0caf65653c79c297$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $0caf65653c79c297$export$816d2913ae6b83b1; }, function (v) { return $0caf65653c79c297$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $0caf65653c79c297$export$61bcfe829111a1d0; }, function (v) { return $0caf65653c79c297$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $0caf65653c79c297$export$7ee8c9beb337bc3f; }, function (v) { return $0caf65653c79c297$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $0caf65653c79c297$export$b5836b71941fa3ed; }, function (v) { return $0caf65653c79c297$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $0caf65653c79c297$export$cf845f2c119da08a; }, function (v) { return $0caf65653c79c297$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0caf65653c79c297$export$c4744153514ff05d;
var $0caf65653c79c297$export$3e506c1ccc9cc1a7;
var $0caf65653c79c297$export$e26fe2ed2fa76875;
var $0caf65653c79c297$export$502329bbf4b505b1;
var $0caf65653c79c297$export$6e3807111c4874c4;
var $0caf65653c79c297$export$c27134553091fb3a;
var $0caf65653c79c297$export$33ee1acdc04fd2a2;
var $0caf65653c79c297$export$b00a404bbd5edef2;
var $0caf65653c79c297$export$8352ce38b91d0c62;
var $0caf65653c79c297$export$d66a1c1c77bd778b;
var $0caf65653c79c297$export$d3dfb8e4810cb555;
var $0caf65653c79c297$export$839f9183b0465a69;
var $0caf65653c79c297$export$72fdf0e06517287b;
var $0caf65653c79c297$export$4b844e58a3e414b4;
var $0caf65653c79c297$export$816d2913ae6b83b1;
var $0caf65653c79c297$export$61bcfe829111a1d0;
var $0caf65653c79c297$export$7ee8c9beb337bc3f;
var $0caf65653c79c297$export$b5836b71941fa3ed;
var $0caf65653c79c297$export$cf845f2c119da08a;
"use strict";
function $0caf65653c79c297$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $0caf65653c79c297$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $0caf65653c79c297$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $0caf65653c79c297$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $0caf65653c79c297$var$g(C, c)) n < e && 0 > $0caf65653c79c297$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $0caf65653c79c297$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $0caf65653c79c297$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $0caf65653c79c297$var$l = performance;
    $0caf65653c79c297$export$c4744153514ff05d = function() {
        return $0caf65653c79c297$var$l.now();
    };
} else {
    var $0caf65653c79c297$var$p = Date, $0caf65653c79c297$var$q = $0caf65653c79c297$var$p.now();
    $0caf65653c79c297$export$c4744153514ff05d = function() {
        return $0caf65653c79c297$var$p.now() - $0caf65653c79c297$var$q;
    };
}
var $0caf65653c79c297$var$r = [], $0caf65653c79c297$var$t = [], $0caf65653c79c297$var$u = 1, $0caf65653c79c297$var$v = null, $0caf65653c79c297$var$y = 3, $0caf65653c79c297$var$z = !1, $0caf65653c79c297$var$A = !1, $0caf65653c79c297$var$B = !1, $0caf65653c79c297$var$D = "function" === typeof setTimeout ? setTimeout : null, $0caf65653c79c297$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $0caf65653c79c297$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $0caf65653c79c297$var$G(a) {
    for(var b = $0caf65653c79c297$var$h($0caf65653c79c297$var$t); null !== b;){
        if (null === b.callback) $0caf65653c79c297$var$k($0caf65653c79c297$var$t);
        else if (b.startTime <= a) $0caf65653c79c297$var$k($0caf65653c79c297$var$t), b.sortIndex = b.expirationTime, $0caf65653c79c297$var$f($0caf65653c79c297$var$r, b);
        else break;
        b = $0caf65653c79c297$var$h($0caf65653c79c297$var$t);
    }
}
function $0caf65653c79c297$var$H(a) {
    $0caf65653c79c297$var$B = !1;
    $0caf65653c79c297$var$G(a);
    if (!$0caf65653c79c297$var$A) {
        if (null !== $0caf65653c79c297$var$h($0caf65653c79c297$var$r)) $0caf65653c79c297$var$A = !0, $0caf65653c79c297$var$I($0caf65653c79c297$var$J);
        else {
            var b = $0caf65653c79c297$var$h($0caf65653c79c297$var$t);
            null !== b && $0caf65653c79c297$var$K($0caf65653c79c297$var$H, b.startTime - a);
        }
    }
}
function $0caf65653c79c297$var$J(a, b) {
    $0caf65653c79c297$var$A = !1;
    $0caf65653c79c297$var$B && ($0caf65653c79c297$var$B = !1, $0caf65653c79c297$var$E($0caf65653c79c297$var$L), $0caf65653c79c297$var$L = -1);
    $0caf65653c79c297$var$z = !0;
    var c = $0caf65653c79c297$var$y;
    try {
        $0caf65653c79c297$var$G(b);
        for($0caf65653c79c297$var$v = $0caf65653c79c297$var$h($0caf65653c79c297$var$r); null !== $0caf65653c79c297$var$v && (!($0caf65653c79c297$var$v.expirationTime > b) || a && !$0caf65653c79c297$var$M());){
            var d = $0caf65653c79c297$var$v.callback;
            if ("function" === typeof d) {
                $0caf65653c79c297$var$v.callback = null;
                $0caf65653c79c297$var$y = $0caf65653c79c297$var$v.priorityLevel;
                var e = d($0caf65653c79c297$var$v.expirationTime <= b);
                b = $0caf65653c79c297$export$c4744153514ff05d();
                "function" === typeof e ? $0caf65653c79c297$var$v.callback = e : $0caf65653c79c297$var$v === $0caf65653c79c297$var$h($0caf65653c79c297$var$r) && $0caf65653c79c297$var$k($0caf65653c79c297$var$r);
                $0caf65653c79c297$var$G(b);
            } else $0caf65653c79c297$var$k($0caf65653c79c297$var$r);
            $0caf65653c79c297$var$v = $0caf65653c79c297$var$h($0caf65653c79c297$var$r);
        }
        if (null !== $0caf65653c79c297$var$v) var w = !0;
        else {
            var m = $0caf65653c79c297$var$h($0caf65653c79c297$var$t);
            null !== m && $0caf65653c79c297$var$K($0caf65653c79c297$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $0caf65653c79c297$var$v = null, $0caf65653c79c297$var$y = c, $0caf65653c79c297$var$z = !1;
    }
}
var $0caf65653c79c297$var$N = !1, $0caf65653c79c297$var$O = null, $0caf65653c79c297$var$L = -1, $0caf65653c79c297$var$P = 5, $0caf65653c79c297$var$Q = -1;
function $0caf65653c79c297$var$M() {
    return $0caf65653c79c297$export$c4744153514ff05d() - $0caf65653c79c297$var$Q < $0caf65653c79c297$var$P ? !1 : !0;
}
function $0caf65653c79c297$var$R() {
    if (null !== $0caf65653c79c297$var$O) {
        var a = $0caf65653c79c297$export$c4744153514ff05d();
        $0caf65653c79c297$var$Q = a;
        var b = !0;
        try {
            b = $0caf65653c79c297$var$O(!0, a);
        } finally{
            b ? $0caf65653c79c297$var$S() : ($0caf65653c79c297$var$N = !1, $0caf65653c79c297$var$O = null);
        }
    } else $0caf65653c79c297$var$N = !1;
}
var $0caf65653c79c297$var$S;
if ("function" === typeof $0caf65653c79c297$var$F) $0caf65653c79c297$var$S = function S() {
    $0caf65653c79c297$var$F($0caf65653c79c297$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $0caf65653c79c297$var$T = new MessageChannel, $0caf65653c79c297$var$U = $0caf65653c79c297$var$T.port2;
    $0caf65653c79c297$var$T.port1.onmessage = $0caf65653c79c297$var$R;
    $0caf65653c79c297$var$S = function S() {
        $0caf65653c79c297$var$U.postMessage(null);
    };
} else $0caf65653c79c297$var$S = function S() {
    $0caf65653c79c297$var$D($0caf65653c79c297$var$R, 0);
};
function $0caf65653c79c297$var$I(a) {
    $0caf65653c79c297$var$O = a;
    $0caf65653c79c297$var$N || ($0caf65653c79c297$var$N = !0, $0caf65653c79c297$var$S());
}
function $0caf65653c79c297$var$K(a, b) {
    $0caf65653c79c297$var$L = $0caf65653c79c297$var$D(function() {
        a($0caf65653c79c297$export$c4744153514ff05d());
    }, b);
}
$0caf65653c79c297$export$3e506c1ccc9cc1a7 = 5;
$0caf65653c79c297$export$e26fe2ed2fa76875 = 1;
$0caf65653c79c297$export$502329bbf4b505b1 = 4;
$0caf65653c79c297$export$6e3807111c4874c4 = 3;
$0caf65653c79c297$export$c27134553091fb3a = null;
$0caf65653c79c297$export$33ee1acdc04fd2a2 = 2;
$0caf65653c79c297$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$0caf65653c79c297$export$8352ce38b91d0c62 = function() {
    $0caf65653c79c297$var$A || $0caf65653c79c297$var$z || ($0caf65653c79c297$var$A = !0, $0caf65653c79c297$var$I($0caf65653c79c297$var$J));
};
$0caf65653c79c297$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $0caf65653c79c297$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$0caf65653c79c297$export$d3dfb8e4810cb555 = function() {
    return $0caf65653c79c297$var$y;
};
$0caf65653c79c297$export$839f9183b0465a69 = function() {
    return $0caf65653c79c297$var$h($0caf65653c79c297$var$r);
};
$0caf65653c79c297$export$72fdf0e06517287b = function(a) {
    switch($0caf65653c79c297$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $0caf65653c79c297$var$y;
    }
    var c = $0caf65653c79c297$var$y;
    $0caf65653c79c297$var$y = b;
    try {
        return a();
    } finally{
        $0caf65653c79c297$var$y = c;
    }
};
$0caf65653c79c297$export$4b844e58a3e414b4 = function() {};
$0caf65653c79c297$export$816d2913ae6b83b1 = function() {};
$0caf65653c79c297$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $0caf65653c79c297$var$y;
    $0caf65653c79c297$var$y = a;
    try {
        return b();
    } finally{
        $0caf65653c79c297$var$y = c;
    }
};
$0caf65653c79c297$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $0caf65653c79c297$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $0caf65653c79c297$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $0caf65653c79c297$var$f($0caf65653c79c297$var$t, a), null === $0caf65653c79c297$var$h($0caf65653c79c297$var$r) && a === $0caf65653c79c297$var$h($0caf65653c79c297$var$t) && ($0caf65653c79c297$var$B ? ($0caf65653c79c297$var$E($0caf65653c79c297$var$L), $0caf65653c79c297$var$L = -1) : $0caf65653c79c297$var$B = !0, $0caf65653c79c297$var$K($0caf65653c79c297$var$H, c - d))) : (a.sortIndex = e, $0caf65653c79c297$var$f($0caf65653c79c297$var$r, a), $0caf65653c79c297$var$A || $0caf65653c79c297$var$z || ($0caf65653c79c297$var$A = !0, $0caf65653c79c297$var$I($0caf65653c79c297$var$J)));
    return a;
};
$0caf65653c79c297$export$b5836b71941fa3ed = $0caf65653c79c297$var$M;
$0caf65653c79c297$export$cf845f2c119da08a = function(a) {
    var b = $0caf65653c79c297$var$y;
    return function() {
        var c = $0caf65653c79c297$var$y;
        $0caf65653c79c297$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $0caf65653c79c297$var$y = c;
        }
    };
};

});



parcelRegister("7uGlr", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $574c2e85dce00dae$export$306c0aa65ff9ec16; }, function (v) { return $574c2e85dce00dae$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $574c2e85dce00dae$export$306c0aa65ff9ec16;
"use strict";

var $33gHU = parcelRequire("33gHU");
function $574c2e85dce00dae$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $574c2e85dce00dae$var$k = "function" === typeof Object.is ? Object.is : $574c2e85dce00dae$var$h, $574c2e85dce00dae$var$l = $33gHU.useState, $574c2e85dce00dae$var$m = $33gHU.useEffect, $574c2e85dce00dae$var$n = $33gHU.useLayoutEffect, $574c2e85dce00dae$var$p = $33gHU.useDebugValue;
function $574c2e85dce00dae$var$q(a, b) {
    var d = b(), f = $574c2e85dce00dae$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $574c2e85dce00dae$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $574c2e85dce00dae$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $574c2e85dce00dae$var$m(function() {
        $574c2e85dce00dae$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $574c2e85dce00dae$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $574c2e85dce00dae$var$p(d);
    return d;
}
function $574c2e85dce00dae$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$574c2e85dce00dae$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $574c2e85dce00dae$var$t(a, b) {
    return b();
}
var $574c2e85dce00dae$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $574c2e85dce00dae$var$t : $574c2e85dce00dae$var$q;
$574c2e85dce00dae$export$306c0aa65ff9ec16 = void 0 !== $33gHU.useSyncExternalStore ? $33gHU.useSyncExternalStore : $574c2e85dce00dae$var$u;

});

parcelRegister("dNvVv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $hgwVv = parcelRequire("hgwVv");
function $a0b89debaf1d2861$var$emptyFunction() {}
function $a0b89debaf1d2861$var$emptyFunctionWithReset() {}
$a0b89debaf1d2861$var$emptyFunctionWithReset.resetWarningCache = $a0b89debaf1d2861$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $hgwVv) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $a0b89debaf1d2861$var$emptyFunctionWithReset,
        resetWarningCache: $a0b89debaf1d2861$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("hgwVv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $c91d78cefd8560cc$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $c91d78cefd8560cc$var$ReactPropTypesSecret;

});


parcelRegister("dSxWp", function(module, exports) {

var $15Pju = parcelRequire("15Pju");

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $jLCbM = parcelRequire("jLCbM");

var $laF8D = parcelRequire("laF8D");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AzureOpenAI = exports.fileFromPath = exports.toFile = exports.UnprocessableEntityError = exports.PermissionDeniedError = exports.InternalServerError = exports.AuthenticationError = exports.BadRequestError = exports.RateLimitError = exports.ConflictError = exports.NotFoundError = exports.APIUserAbortError = exports.APIConnectionTimeoutError = exports.APIConnectionError = exports.APIError = exports.OpenAIError = exports.OpenAI = void 0;

var Errors = __importStar((parcelRequire("kQ0uC")));

var Uploads = __importStar((parcelRequire("bPEOW")));

var Core = __importStar((parcelRequire("c8Tp0")));

var Pagination = __importStar((parcelRequire("4ux0n")));

var API = __importStar((parcelRequire("fQQlH")));
var _Core_readEnv, _Core_readEnv1;
/**
 * API Client for interfacing with the OpenAI API.
 */ var OpenAI = /*#__PURE__*/ function(_Core_APIClient) {
    (0, $iNfU4._)(OpenAI, _Core_APIClient);
    var _super = (0, $k1NN5._)(OpenAI);
    function OpenAI() {
        var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $19mwo._)(this, OpenAI);
        var _this;
        var _param_baseURL = _param.baseURL, baseURL = _param_baseURL === void 0 ? Core.readEnv("OPENAI_BASE_URL") : _param_baseURL, _param_apiKey = _param.apiKey, apiKey = _param_apiKey === void 0 ? Core.readEnv("OPENAI_API_KEY") : _param_apiKey, _param_organization = _param.organization, organization = _param_organization === void 0 ? (_Core_readEnv = Core.readEnv("OPENAI_ORG_ID")) !== null && _Core_readEnv !== void 0 ? _Core_readEnv : null : _param_organization, _param_project = _param.project, project = _param_project === void 0 ? (_Core_readEnv1 = Core.readEnv("OPENAI_PROJECT_ID")) !== null && _Core_readEnv1 !== void 0 ? _Core_readEnv1 : null : _param_project, opts = (0, $6JqHh._)(_param, [
            "baseURL",
            "apiKey",
            "organization",
            "project"
        ]);
        if (apiKey === undefined) throw new Errors.OpenAIError("The OPENAI_API_KEY environment variable is missing or empty; either provide it, or instantiate the OpenAI client with an apiKey option, like new OpenAI({ apiKey: 'My API Key' }).");
        var options = (0, $ddevm._)((0, $78DQ7._)({
            apiKey: apiKey,
            organization: organization,
            project: project
        }, opts), {
            baseURL: baseURL || "https://api.openai.com/v1"
        });
        if (!options.dangerouslyAllowBrowser && Core.isRunningInBrowser()) throw new Errors.OpenAIError("It looks like you're running in a browser-like environment.\n\nThis is disabled by default, as it risks exposing your secret API credentials to attackers.\nIf you understand the risks and have appropriate mitigations in place,\nyou can set the `dangerouslyAllowBrowser` option to `true`, e.g.,\n\nnew OpenAI({ apiKey, dangerouslyAllowBrowser: true });\n\nhttps://help.openai.com/en/articles/5112595-best-practices-for-api-key-safety\n");
        var _options_timeout;
        _this = _super.call(this, {
            baseURL: options.baseURL,
            timeout: (_options_timeout = options.timeout) !== null && _options_timeout !== void 0 ? _options_timeout : 600000 /* 10 minutes */ ,
            httpAgent: options.httpAgent,
            maxRetries: options.maxRetries,
            fetch: options.fetch
        });
        _this.completions = new API.Completions((0, $15Pju._)(_this));
        _this.chat = new API.Chat((0, $15Pju._)(_this));
        _this.embeddings = new API.Embeddings((0, $15Pju._)(_this));
        _this.files = new API.Files((0, $15Pju._)(_this));
        _this.images = new API.Images((0, $15Pju._)(_this));
        _this.audio = new API.Audio((0, $15Pju._)(_this));
        _this.moderations = new API.Moderations((0, $15Pju._)(_this));
        _this.models = new API.Models((0, $15Pju._)(_this));
        _this.fineTuning = new API.FineTuning((0, $15Pju._)(_this));
        _this.beta = new API.Beta((0, $15Pju._)(_this));
        _this.batches = new API.Batches((0, $15Pju._)(_this));
        _this.uploads = new API.Uploads((0, $15Pju._)(_this));
        _this._options = options;
        _this.apiKey = apiKey;
        _this.organization = organization;
        _this.project = project;
        return _this;
    }
    (0, $6rpfc._)(OpenAI, [
        {
            key: "defaultQuery",
            value: function defaultQuery() {
                return this._options.defaultQuery;
            }
        },
        {
            key: "defaultHeaders",
            value: function defaultHeaders(opts) {
                return (0, $78DQ7._)((0, $ddevm._)((0, $78DQ7._)({}, (0, $jLCbM._)((0, $laF8D._)(OpenAI.prototype), "defaultHeaders", this).call(this, opts)), {
                    "OpenAI-Organization": this.organization,
                    "OpenAI-Project": this.project
                }), this._options.defaultHeaders);
            }
        },
        {
            key: "authHeaders",
            value: function authHeaders(opts) {
                return {
                    Authorization: "Bearer ".concat(this.apiKey)
                };
            }
        }
    ]);
    return OpenAI;
}(Core.APIClient);
exports.OpenAI = OpenAI;
_a = OpenAI;
OpenAI.OpenAI = _a;
OpenAI.DEFAULT_TIMEOUT = 600000; // 10 minutes
OpenAI.OpenAIError = Errors.OpenAIError;
OpenAI.APIError = Errors.APIError;
OpenAI.APIConnectionError = Errors.APIConnectionError;
OpenAI.APIConnectionTimeoutError = Errors.APIConnectionTimeoutError;
OpenAI.APIUserAbortError = Errors.APIUserAbortError;
OpenAI.NotFoundError = Errors.NotFoundError;
OpenAI.ConflictError = Errors.ConflictError;
OpenAI.RateLimitError = Errors.RateLimitError;
OpenAI.BadRequestError = Errors.BadRequestError;
OpenAI.AuthenticationError = Errors.AuthenticationError;
OpenAI.InternalServerError = Errors.InternalServerError;
OpenAI.PermissionDeniedError = Errors.PermissionDeniedError;
OpenAI.UnprocessableEntityError = Errors.UnprocessableEntityError;
OpenAI.toFile = Uploads.toFile;
OpenAI.fileFromPath = Uploads.fileFromPath;
exports.OpenAIError = Errors.OpenAIError, exports.APIError = Errors.APIError, exports.APIConnectionError = Errors.APIConnectionError, exports.APIConnectionTimeoutError = Errors.APIConnectionTimeoutError, exports.APIUserAbortError = Errors.APIUserAbortError, exports.NotFoundError = Errors.NotFoundError, exports.ConflictError = Errors.ConflictError, exports.RateLimitError = Errors.RateLimitError, exports.BadRequestError = Errors.BadRequestError, exports.AuthenticationError = Errors.AuthenticationError, exports.InternalServerError = Errors.InternalServerError, exports.PermissionDeniedError = Errors.PermissionDeniedError, exports.UnprocessableEntityError = Errors.UnprocessableEntityError;
exports.toFile = Uploads.toFile;
exports.fileFromPath = Uploads.fileFromPath;
(function(OpenAI) {
    OpenAI.Page = Pagination.Page;
    OpenAI.CursorPage = Pagination.CursorPage;
    OpenAI.Completions = API.Completions;
    OpenAI.Chat = API.Chat;
    OpenAI.Embeddings = API.Embeddings;
    OpenAI.Files = API.Files;
    OpenAI.FileObjectsPage = API.FileObjectsPage;
    OpenAI.Images = API.Images;
    OpenAI.Audio = API.Audio;
    OpenAI.Moderations = API.Moderations;
    OpenAI.Models = API.Models;
    OpenAI.ModelsPage = API.ModelsPage;
    OpenAI.FineTuning = API.FineTuning;
    OpenAI.Beta = API.Beta;
    OpenAI.Batches = API.Batches;
    OpenAI.BatchesPage = API.BatchesPage;
    OpenAI.Uploads = API.Uploads;
})(OpenAI = exports.OpenAI || (exports.OpenAI = {}));
/** API Client for interfacing with the Azure OpenAI API. */ var AzureOpenAI = /*#__PURE__*/ function(OpenAI) {
    (0, $iNfU4._)(AzureOpenAI, OpenAI);
    var _super = (0, $k1NN5._)(AzureOpenAI);
    function AzureOpenAI() {
        var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $19mwo._)(this, AzureOpenAI);
        var _this;
        var _param_baseURL = _param.baseURL, baseURL = _param_baseURL === void 0 ? Core.readEnv("OPENAI_BASE_URL") : _param_baseURL, _param_apiKey = _param.apiKey, apiKey = _param_apiKey === void 0 ? Core.readEnv("AZURE_OPENAI_API_KEY") : _param_apiKey, _param_apiVersion = _param.apiVersion, apiVersion = _param_apiVersion === void 0 ? Core.readEnv("OPENAI_API_VERSION") : _param_apiVersion, endpoint = _param.endpoint, deployment = _param.deployment, azureADTokenProvider = _param.azureADTokenProvider, dangerouslyAllowBrowser = _param.dangerouslyAllowBrowser, opts = (0, $6JqHh._)(_param, [
            "baseURL",
            "apiKey",
            "apiVersion",
            "endpoint",
            "deployment",
            "azureADTokenProvider",
            "dangerouslyAllowBrowser"
        ]);
        if (!apiVersion) throw new Errors.OpenAIError("The OPENAI_API_VERSION environment variable is missing or empty; either provide it, or instantiate the AzureOpenAI client with an apiVersion option, like new AzureOpenAI({ apiVersion: 'My API Version' }).");
        if (typeof azureADTokenProvider === "function") dangerouslyAllowBrowser = true;
        if (!azureADTokenProvider && !apiKey) throw new Errors.OpenAIError("Missing credentials. Please pass one of `apiKey` and `azureADTokenProvider`, or set the `AZURE_OPENAI_API_KEY` environment variable.");
        if (azureADTokenProvider && apiKey) throw new Errors.OpenAIError("The `apiKey` and `azureADTokenProvider` arguments are mutually exclusive; only one can be passed at a time.");
        // define a sentinel value to avoid any typing issues
        apiKey !== null && apiKey !== void 0 ? apiKey : apiKey = API_KEY_SENTINEL;
        opts.defaultQuery = (0, $ddevm._)((0, $78DQ7._)({}, opts.defaultQuery), {
            "api-version": apiVersion
        });
        if (!baseURL) {
            if (!endpoint) endpoint = undefined;
            if (!endpoint) throw new Errors.OpenAIError("Must provide one of the `baseURL` or `endpoint` arguments, or the `AZURE_OPENAI_ENDPOINT` environment variable");
            baseURL = "".concat(endpoint, "/openai");
        } else {
            if (endpoint) throw new Errors.OpenAIError("baseURL and endpoint are mutually exclusive");
        }
        _this = _super.call(this, (0, $78DQ7._)({
            apiKey: apiKey,
            baseURL: baseURL
        }, opts, dangerouslyAllowBrowser !== undefined ? {
            dangerouslyAllowBrowser: dangerouslyAllowBrowser
        } : {}));
        _this.apiVersion = "";
        _this._azureADTokenProvider = azureADTokenProvider;
        _this.apiVersion = apiVersion;
        _this._deployment = deployment;
        return _this;
    }
    (0, $6rpfc._)(AzureOpenAI, [
        {
            key: "buildRequest",
            value: function buildRequest(options) {
                if (_deployments_endpoints.has(options.path) && options.method === "post" && options.body !== undefined) {
                    if (!Core.isObj(options.body)) throw new Error("Expected request body to be an object");
                    var model = this._deployment || options.body["model"];
                    if (model !== undefined && !this.baseURL.includes("/deployments")) options.path = "/deployments/".concat(model).concat(options.path);
                }
                return (0, $jLCbM._)((0, $laF8D._)(AzureOpenAI.prototype), "buildRequest", this).call(this, options);
            }
        },
        {
            key: "_getAzureADToken",
            value: function _getAzureADToken() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var token;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(typeof _this._azureADTokenProvider === "function")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._azureADTokenProvider()
                                ];
                            case 1:
                                token = _state.sent();
                                if (!token || typeof token !== "string") throw new Errors.OpenAIError("Expected 'azureADTokenProvider' argument to return a string but it returned ".concat(token));
                                return [
                                    2,
                                    token
                                ];
                            case 2:
                                return [
                                    2,
                                    undefined
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "authHeaders",
            value: function authHeaders(opts) {
                return {};
            }
        },
        {
            key: "prepareOptions",
            value: function prepareOptions(opts) {
                var _this = this;
                var _this1 = this, _superprop_get_prepareOptions = function() {
                    return (0, $jLCbM._)((0, $laF8D._)(AzureOpenAI.prototype), "prepareOptions", _this);
                };
                return (0, $9OZ9j._)(function() {
                    var _opts_headers, _opts_headers1, token, _opts_headers2;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (((_opts_headers = opts.headers) === null || _opts_headers === void 0 ? void 0 : _opts_headers["Authorization"]) || ((_opts_headers1 = opts.headers) === null || _opts_headers1 === void 0 ? void 0 : _opts_headers1["api-key"])) return [
                                    2,
                                    _superprop_get_prepareOptions().call(_this1, opts)
                                ];
                                return [
                                    4,
                                    _this1._getAzureADToken()
                                ];
                            case 1:
                                token = _state.sent();
                                (_opts_headers2 = opts.headers) !== null && _opts_headers2 !== void 0 ? _opts_headers2 : opts.headers = {};
                                if (token) opts.headers["Authorization"] = "Bearer ".concat(token);
                                else if (_this1.apiKey !== API_KEY_SENTINEL) opts.headers["api-key"] = _this1.apiKey;
                                else throw new Errors.OpenAIError("Unable to handle auth");
                                return [
                                    2,
                                    _superprop_get_prepareOptions().call(_this1, opts)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AzureOpenAI;
}(OpenAI);
exports.AzureOpenAI = AzureOpenAI;
var _deployments_endpoints = new Set([
    "/completions",
    "/chat/completions",
    "/embeddings",
    "/audio/transcriptions",
    "/audio/translations",
    "/audio/speech",
    "/images/generations"
]);
var API_KEY_SENTINEL = "<Missing Key>";
// ---------------------- End Azure ----------------------
exports = module.exports = OpenAI;
module.exports.AzureOpenAI = AzureOpenAI;
exports.default = OpenAI;

});
parcelRegister("kQ0uC", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $etlBe = parcelRequire("etlBe");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContentFilterFinishReasonError = module.exports.LengthFinishReasonError = module.exports.InternalServerError = module.exports.RateLimitError = module.exports.UnprocessableEntityError = module.exports.ConflictError = module.exports.NotFoundError = module.exports.PermissionDeniedError = module.exports.AuthenticationError = module.exports.BadRequestError = module.exports.APIConnectionTimeoutError = module.exports.APIConnectionError = module.exports.APIUserAbortError = module.exports.APIError = module.exports.OpenAIError = void 0;

var $c8Tp0 = parcelRequire("c8Tp0");
var $03ea35de42cd2b84$var$OpenAIError = /*#__PURE__*/ function(Error1) {
    (0, $iNfU4._)(OpenAIError, Error1);
    var _super = (0, $k1NN5._)(OpenAIError);
    function OpenAIError() {
        (0, $19mwo._)(this, OpenAIError);
        return _super.apply(this, arguments);
    }
    return OpenAIError;
}((0, $etlBe._)(Error));
module.exports.OpenAIError = $03ea35de42cd2b84$var$OpenAIError;
var $03ea35de42cd2b84$var$APIError = /*#__PURE__*/ function(OpenAIError) {
    (0, $iNfU4._)(APIError, OpenAIError);
    var _super = (0, $k1NN5._)(APIError);
    function APIError(status, error, message, headers) {
        (0, $19mwo._)(this, APIError);
        var _this;
        _this = _super.call(this, "".concat(APIError.makeMessage(status, error, message)));
        _this.status = status;
        _this.headers = headers;
        _this.request_id = headers === null || headers === void 0 ? void 0 : headers["x-request-id"];
        var data = error;
        _this.error = data;
        _this.code = data === null || data === void 0 ? void 0 : data["code"];
        _this.param = data === null || data === void 0 ? void 0 : data["param"];
        _this.type = data === null || data === void 0 ? void 0 : data["type"];
        return _this;
    }
    (0, $6rpfc._)(APIError, null, [
        {
            key: "makeMessage",
            value: function makeMessage(status, error, message) {
                var msg = (error === null || error === void 0 ? void 0 : error.message) ? typeof error.message === "string" ? error.message : JSON.stringify(error.message) : error ? JSON.stringify(error) : message;
                if (status && msg) return "".concat(status, " ").concat(msg);
                if (status) return "".concat(status, " status code (no body)");
                if (msg) return msg;
                return "(no status code or body)";
            }
        },
        {
            key: "generate",
            value: function generate(status, errorResponse, message, headers) {
                if (!status) return new $03ea35de42cd2b84$var$APIConnectionError({
                    cause: (0, $c8Tp0.castToError)(errorResponse)
                });
                var error = errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse["error"];
                if (status === 400) return new $03ea35de42cd2b84$var$BadRequestError(status, error, message, headers);
                if (status === 401) return new $03ea35de42cd2b84$var$AuthenticationError(status, error, message, headers);
                if (status === 403) return new $03ea35de42cd2b84$var$PermissionDeniedError(status, error, message, headers);
                if (status === 404) return new $03ea35de42cd2b84$var$NotFoundError(status, error, message, headers);
                if (status === 409) return new $03ea35de42cd2b84$var$ConflictError(status, error, message, headers);
                if (status === 422) return new $03ea35de42cd2b84$var$UnprocessableEntityError(status, error, message, headers);
                if (status === 429) return new $03ea35de42cd2b84$var$RateLimitError(status, error, message, headers);
                if (status >= 500) return new $03ea35de42cd2b84$var$InternalServerError(status, error, message, headers);
                return new APIError(status, error, message, headers);
            }
        }
    ]);
    return APIError;
}($03ea35de42cd2b84$var$OpenAIError);
module.exports.APIError = $03ea35de42cd2b84$var$APIError;
var $03ea35de42cd2b84$var$APIUserAbortError = /*#__PURE__*/ function(APIError) {
    (0, $iNfU4._)(APIUserAbortError, APIError);
    var _super = (0, $k1NN5._)(APIUserAbortError);
    function APIUserAbortError() {
        var message = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).message;
        (0, $19mwo._)(this, APIUserAbortError);
        var _this;
        _this = _super.call(this, undefined, undefined, message || "Request was aborted.", undefined);
        _this.status = undefined;
        return _this;
    }
    return APIUserAbortError;
}($03ea35de42cd2b84$var$APIError);
module.exports.APIUserAbortError = $03ea35de42cd2b84$var$APIUserAbortError;
var $03ea35de42cd2b84$var$APIConnectionError = /*#__PURE__*/ function(APIError) {
    (0, $iNfU4._)(APIConnectionError, APIError);
    var _super = (0, $k1NN5._)(APIConnectionError);
    function APIConnectionError(param) {
        var message = param.message, cause = param.cause;
        (0, $19mwo._)(this, APIConnectionError);
        var _this;
        _this = _super.call(this, undefined, undefined, message || "Connection error.", undefined);
        _this.status = undefined;
        // in some environments the 'cause' property is already declared
        // @ts-ignore
        if (cause) _this.cause = cause;
        return _this;
    }
    return APIConnectionError;
}($03ea35de42cd2b84$var$APIError);
module.exports.APIConnectionError = $03ea35de42cd2b84$var$APIConnectionError;
var $03ea35de42cd2b84$var$APIConnectionTimeoutError = /*#__PURE__*/ function(APIConnectionError) {
    (0, $iNfU4._)(APIConnectionTimeoutError, APIConnectionError);
    var _super = (0, $k1NN5._)(APIConnectionTimeoutError);
    function APIConnectionTimeoutError() {
        var message = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).message;
        (0, $19mwo._)(this, APIConnectionTimeoutError);
        return _super.call(this, {
            message: message !== null && message !== void 0 ? message : "Request timed out."
        });
    }
    return APIConnectionTimeoutError;
}($03ea35de42cd2b84$var$APIConnectionError);
module.exports.APIConnectionTimeoutError = $03ea35de42cd2b84$var$APIConnectionTimeoutError;
var $03ea35de42cd2b84$var$BadRequestError = /*#__PURE__*/ function(APIError) {
    (0, $iNfU4._)(BadRequestError, APIError);
    var _super = (0, $k1NN5._)(BadRequestError);
    function BadRequestError() {
        (0, $19mwo._)(this, BadRequestError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.status = 400;
        return _this;
    }
    return BadRequestError;
}($03ea35de42cd2b84$var$APIError);
module.exports.BadRequestError = $03ea35de42cd2b84$var$BadRequestError;
var $03ea35de42cd2b84$var$AuthenticationError = /*#__PURE__*/ function(APIError) {
    (0, $iNfU4._)(AuthenticationError, APIError);
    var _super = (0, $k1NN5._)(AuthenticationError);
    function AuthenticationError() {
        (0, $19mwo._)(this, AuthenticationError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.status = 401;
        return _this;
    }
    return AuthenticationError;
}($03ea35de42cd2b84$var$APIError);
module.exports.AuthenticationError = $03ea35de42cd2b84$var$AuthenticationError;
var $03ea35de42cd2b84$var$PermissionDeniedError = /*#__PURE__*/ function(APIError) {
    (0, $iNfU4._)(PermissionDeniedError, APIError);
    var _super = (0, $k1NN5._)(PermissionDeniedError);
    function PermissionDeniedError() {
        (0, $19mwo._)(this, PermissionDeniedError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.status = 403;
        return _this;
    }
    return PermissionDeniedError;
}($03ea35de42cd2b84$var$APIError);
module.exports.PermissionDeniedError = $03ea35de42cd2b84$var$PermissionDeniedError;
var $03ea35de42cd2b84$var$NotFoundError = /*#__PURE__*/ function(APIError) {
    (0, $iNfU4._)(NotFoundError, APIError);
    var _super = (0, $k1NN5._)(NotFoundError);
    function NotFoundError() {
        (0, $19mwo._)(this, NotFoundError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.status = 404;
        return _this;
    }
    return NotFoundError;
}($03ea35de42cd2b84$var$APIError);
module.exports.NotFoundError = $03ea35de42cd2b84$var$NotFoundError;
var $03ea35de42cd2b84$var$ConflictError = /*#__PURE__*/ function(APIError) {
    (0, $iNfU4._)(ConflictError, APIError);
    var _super = (0, $k1NN5._)(ConflictError);
    function ConflictError() {
        (0, $19mwo._)(this, ConflictError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.status = 409;
        return _this;
    }
    return ConflictError;
}($03ea35de42cd2b84$var$APIError);
module.exports.ConflictError = $03ea35de42cd2b84$var$ConflictError;
var $03ea35de42cd2b84$var$UnprocessableEntityError = /*#__PURE__*/ function(APIError) {
    (0, $iNfU4._)(UnprocessableEntityError, APIError);
    var _super = (0, $k1NN5._)(UnprocessableEntityError);
    function UnprocessableEntityError() {
        (0, $19mwo._)(this, UnprocessableEntityError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.status = 422;
        return _this;
    }
    return UnprocessableEntityError;
}($03ea35de42cd2b84$var$APIError);
module.exports.UnprocessableEntityError = $03ea35de42cd2b84$var$UnprocessableEntityError;
var $03ea35de42cd2b84$var$RateLimitError = /*#__PURE__*/ function(APIError) {
    (0, $iNfU4._)(RateLimitError, APIError);
    var _super = (0, $k1NN5._)(RateLimitError);
    function RateLimitError() {
        (0, $19mwo._)(this, RateLimitError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.status = 429;
        return _this;
    }
    return RateLimitError;
}($03ea35de42cd2b84$var$APIError);
module.exports.RateLimitError = $03ea35de42cd2b84$var$RateLimitError;
var $03ea35de42cd2b84$var$InternalServerError = /*#__PURE__*/ function(APIError) {
    (0, $iNfU4._)(InternalServerError, APIError);
    var _super = (0, $k1NN5._)(InternalServerError);
    function InternalServerError() {
        (0, $19mwo._)(this, InternalServerError);
        return _super.apply(this, arguments);
    }
    return InternalServerError;
}($03ea35de42cd2b84$var$APIError);
module.exports.InternalServerError = $03ea35de42cd2b84$var$InternalServerError;
var $03ea35de42cd2b84$var$LengthFinishReasonError = /*#__PURE__*/ function(OpenAIError) {
    (0, $iNfU4._)(LengthFinishReasonError, OpenAIError);
    var _super = (0, $k1NN5._)(LengthFinishReasonError);
    function LengthFinishReasonError() {
        (0, $19mwo._)(this, LengthFinishReasonError);
        return _super.call(this, "Could not parse response content as the length limit was reached");
    }
    return LengthFinishReasonError;
}($03ea35de42cd2b84$var$OpenAIError);
module.exports.LengthFinishReasonError = $03ea35de42cd2b84$var$LengthFinishReasonError;
var $03ea35de42cd2b84$var$ContentFilterFinishReasonError = /*#__PURE__*/ function(OpenAIError) {
    (0, $iNfU4._)(ContentFilterFinishReasonError, OpenAIError);
    var _super = (0, $k1NN5._)(ContentFilterFinishReasonError);
    function ContentFilterFinishReasonError() {
        (0, $19mwo._)(this, ContentFilterFinishReasonError);
        return _super.call(this, "Could not parse response content as the request was rejected by the content filter");
    }
    return ContentFilterFinishReasonError;
}($03ea35de42cd2b84$var$OpenAIError);
module.exports.ContentFilterFinishReasonError = $03ea35de42cd2b84$var$ContentFilterFinishReasonError;

});
parcelRegister("c8Tp0", function(module, exports) {

var $gIbDP = parcelRequire("gIbDP");

var $9OZ9j = parcelRequire("9OZ9j");

var $27QSE = parcelRequire("27QSE");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $gnDeW = parcelRequire("gnDeW");

var $e2m1c = parcelRequire("e2m1c");

var $etlBe = parcelRequire("etlBe");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");

var $9iKK3 = parcelRequire("9iKK3");
var $8d713523431e0532$require$Buffer = $9iKK3.Buffer;

var $hZFWO = parcelRequire("hZFWO");
"use strict";
var $8d713523431e0532$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $8d713523431e0532$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $8d713523431e0532$var$_AbstractPage_client;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isObj = module.exports.toBase64 = module.exports.getRequiredHeader = module.exports.isHeadersProtocol = module.exports.isRunningInBrowser = module.exports.debug = module.exports.hasOwn = module.exports.isEmptyObj = module.exports.maybeCoerceBoolean = module.exports.maybeCoerceFloat = module.exports.maybeCoerceInteger = module.exports.coerceBoolean = module.exports.coerceFloat = module.exports.coerceInteger = module.exports.readEnv = module.exports.ensurePresent = module.exports.castToError = module.exports.sleep = module.exports.safeJSON = module.exports.isRequestOptions = module.exports.createResponseHeaders = module.exports.PagePromise = module.exports.AbstractPage = module.exports.APIClient = module.exports.APIPromise = module.exports.createForm = module.exports.multipartFormRequestOptions = module.exports.maybeMultipartFormRequestOptions = void 0;

var $8Zn2o = parcelRequire("8Zn2o");

var $8BEDZ = parcelRequire("8BEDZ");

var $kQ0uC = parcelRequire("kQ0uC");

var $fEKje = parcelRequire("fEKje");

var $bPEOW = parcelRequire("bPEOW");

var $bPEOW = parcelRequire("bPEOW");
Object.defineProperty(module.exports, "maybeMultipartFormRequestOptions", {
    enumerable: true,
    get: function get() {
        return $bPEOW.maybeMultipartFormRequestOptions;
    }
});
Object.defineProperty(module.exports, "multipartFormRequestOptions", {
    enumerable: true,
    get: function get() {
        return $bPEOW.multipartFormRequestOptions;
    }
});
Object.defineProperty(module.exports, "createForm", {
    enumerable: true,
    get: function get() {
        return $bPEOW.createForm;
    }
});
function $8d713523431e0532$var$defaultParseResponse(props) {
    return $8d713523431e0532$var$_defaultParseResponse.apply(this, arguments);
}
function $8d713523431e0532$var$_defaultParseResponse() {
    $8d713523431e0532$var$_defaultParseResponse = (0, $9OZ9j._)(function(props) {
        var response, contentType, isJSON, json, text;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    response = props.response;
                    if (props.options.stream) {
                        $8d713523431e0532$var$debug("response", response.status, response.url, response.headers, response.body);
                        // Note: there is an invariant here that isn't represented in the type system
                        // that if you set `stream: true` the response type must also be `Stream<T>`
                        if (props.options.__streamClass) return [
                            2,
                            props.options.__streamClass.fromSSEResponse(response, props.controller)
                        ];
                        return [
                            2,
                            $8BEDZ.Stream.fromSSEResponse(response, props.controller)
                        ];
                    }
                    // fetch refuses to read the body when the status code is 204.
                    if (response.status === 204) return [
                        2,
                        null
                    ];
                    if (props.options.__binaryResponse) return [
                        2,
                        response
                    ];
                    contentType = response.headers.get("content-type");
                    isJSON = (contentType === null || contentType === void 0 ? void 0 : contentType.includes("application/json")) || (contentType === null || contentType === void 0 ? void 0 : contentType.includes("application/vnd.api+json"));
                    if (!isJSON) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 1:
                    json = _state.sent();
                    $8d713523431e0532$var$debug("response", response.status, response.url, response.headers, json);
                    return [
                        2,
                        json
                    ];
                case 2:
                    return [
                        4,
                        response.text()
                    ];
                case 3:
                    text = _state.sent();
                    $8d713523431e0532$var$debug("response", response.status, response.url, response.headers, text);
                    // TODO handle blob, arraybuffer, other content types, etc.
                    return [
                        2,
                        text
                    ];
            }
        });
    });
    return $8d713523431e0532$var$_defaultParseResponse.apply(this, arguments);
}
/**
 * A subclass of `Promise` providing additional helper methods
 * for interacting with the SDK.
 */ var $8d713523431e0532$var$APIPromise = /*#__PURE__*/ function(Promise1) {
    "use strict";
    (0, $iNfU4._)(APIPromise, Promise1);
    var _super = (0, $k1NN5._)(APIPromise);
    function APIPromise(responsePromise) {
        var parseResponse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8d713523431e0532$var$defaultParseResponse;
        (0, $19mwo._)(this, APIPromise);
        var _this;
        _this = _super.call(this, function(resolve) {
            // this is maybe a bit weird but this has to be a no-op to not implicitly
            // parse the response body; instead .then, .catch, .finally are overridden
            // to parse the response
            resolve(null);
        });
        _this.responsePromise = responsePromise;
        _this.parseResponse = parseResponse;
        return _this;
    }
    (0, $6rpfc._)(APIPromise, [
        {
            key: "_thenUnwrap",
            value: function _thenUnwrap(transform) {
                var _this = this;
                return new APIPromise(this.responsePromise, function() {
                    var _ref = (0, $9OZ9j._)(function(props) {
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _this.parseResponse(props)
                                    ];
                                case 1:
                                    return [
                                        2,
                                        transform.apply(void 0, [
                                            _state.sent()
                                        ])
                                    ];
                            }
                        });
                    });
                    return function(props) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            /**
     * Gets the raw `Response` instance instead of parsing the response
     * data.
     *
     * If you want to parse the response body but still get the `Response`
     * instance, you can use {@link withResponse()}.
     *
     * 👋 Getting the wrong TypeScript type for `Response`?
     * Try setting `"moduleResolution": "NodeNext"` if you can,
     * or add one of these imports before your first `import … from 'openai'`:
     * - `import 'openai/shims/node'` (if you're running on Node)
     * - `import 'openai/shims/web'` (otherwise)
     */ key: "asResponse",
            value: function asResponse() {
                return this.responsePromise.then(function(p) {
                    return p.response;
                });
            }
        },
        {
            key: "withResponse",
            value: /**
     * Gets the parsed response data and the raw `Response` instance.
     *
     * If you just want to get the raw `Response` instance without parsing it,
     * you can use {@link asResponse()}.
     *
     *
     * 👋 Getting the wrong TypeScript type for `Response`?
     * Try setting `"moduleResolution": "NodeNext"` if you can,
     * or add one of these imports before your first `import … from 'openai'`:
     * - `import 'openai/shims/node'` (if you're running on Node)
     * - `import 'openai/shims/web'` (otherwise)
     */ function withResponse() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _ref, data, response;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all([
                                        _this.parse(),
                                        _this.asResponse()
                                    ])
                                ];
                            case 1:
                                _ref = (0, $2MTYX._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), data = _ref[0], response = _ref[1];
                                return [
                                    2,
                                    {
                                        data: data,
                                        response: response
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "parse",
            value: function parse() {
                if (!this.parsedPromise) this.parsedPromise = this.responsePromise.then(this.parseResponse);
                return this.parsedPromise;
            }
        },
        {
            key: "then",
            value: function then(onfulfilled, onrejected) {
                return this.parse().then(onfulfilled, onrejected);
            }
        },
        {
            key: "catch",
            value: function _catch(onrejected) {
                return this.parse().catch(onrejected);
            }
        },
        {
            key: "finally",
            value: function _finally(onfinally) {
                return this.parse().finally(onfinally);
            }
        }
    ]);
    return APIPromise;
}((0, $etlBe._)(Promise));
module.exports.APIPromise = $8d713523431e0532$var$APIPromise;
var $8d713523431e0532$var$APIClient = /*#__PURE__*/ function() {
    "use strict";
    function APIClient(param) {
        var baseURL = param.baseURL, _param_maxRetries = param.maxRetries, maxRetries = _param_maxRetries === void 0 ? 2 : _param_maxRetries, _param_timeout = param.timeout, timeout = _param_timeout === void 0 ? 600000 : _param_timeout, httpAgent = param.httpAgent, overridenFetch = param.fetch;
        (0, $19mwo._)(this, APIClient);
        this.baseURL = baseURL;
        this.maxRetries = $8d713523431e0532$var$validatePositiveInteger("maxRetries", maxRetries);
        this.timeout = $8d713523431e0532$var$validatePositiveInteger("timeout", timeout);
        this.httpAgent = httpAgent;
        this.fetch = overridenFetch !== null && overridenFetch !== void 0 ? overridenFetch : $fEKje.fetch;
    }
    (0, $6rpfc._)(APIClient, [
        {
            key: "authHeaders",
            value: function authHeaders(opts) {
                return {};
            }
        },
        {
            /**
     * Override this to add your own default headers, for example:
     *
     *  {
     *    ...super.defaultHeaders(),
     *    Authorization: 'Bearer 123',
     *  }
     */ key: "defaultHeaders",
            value: function defaultHeaders(opts) {
                return (0, $78DQ7._)({
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "User-Agent": this.getUserAgent()
                }, $8d713523431e0532$var$getPlatformHeaders(), this.authHeaders(opts));
            }
        },
        {
            /**
     * Override this to add your own headers validation:
     */ key: "validateHeaders",
            value: function validateHeaders(headers, customHeaders) {}
        },
        {
            key: "defaultIdempotencyKey",
            value: function defaultIdempotencyKey() {
                return "stainless-node-retry-".concat($8d713523431e0532$var$uuid4());
            }
        },
        {
            key: "get",
            value: function get(path, opts) {
                return this.methodRequest("get", path, opts);
            }
        },
        {
            key: "post",
            value: function post(path, opts) {
                return this.methodRequest("post", path, opts);
            }
        },
        {
            key: "patch",
            value: function patch(path, opts) {
                return this.methodRequest("patch", path, opts);
            }
        },
        {
            key: "put",
            value: function put(path, opts) {
                return this.methodRequest("put", path, opts);
            }
        },
        {
            key: "delete",
            value: function _delete(path, opts) {
                return this.methodRequest("delete", path, opts);
            }
        },
        {
            key: "methodRequest",
            value: function methodRequest(method, path, opts) {
                return this.request(Promise.resolve(opts).then(function() {
                    var _ref = (0, $9OZ9j._)(function(opts) {
                        var body, _tmp, _;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!(opts && (0, $bPEOW.isBlobLike)(opts === null || opts === void 0 ? void 0 : opts.body))) return [
                                        3,
                                        2
                                    ];
                                    _ = DataView.bind;
                                    return [
                                        4,
                                        opts.body.arrayBuffer()
                                    ];
                                case 1:
                                    _tmp = new (_.apply(DataView, [
                                        void 0,
                                        _state.sent()
                                    ]));
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    _tmp = (opts === null || opts === void 0 ? void 0 : opts.body) instanceof DataView ? opts.body : (opts === null || opts === void 0 ? void 0 : opts.body) instanceof ArrayBuffer ? new DataView(opts.body) : opts && ArrayBuffer.isView(opts === null || opts === void 0 ? void 0 : opts.body) ? new DataView(opts.body.buffer) : opts === null || opts === void 0 ? void 0 : opts.body;
                                    _state.label = 3;
                                case 3:
                                    body = _tmp;
                                    return [
                                        2,
                                        (0, $ddevm._)((0, $78DQ7._)({
                                            method: method,
                                            path: path
                                        }, opts), {
                                            body: body
                                        })
                                    ];
                            }
                        });
                    });
                    return function(opts) {
                        return _ref.apply(this, arguments);
                    };
                }()));
            }
        },
        {
            key: "getAPIList",
            value: function getAPIList(path, Page, opts) {
                return this.requestAPIList(Page, (0, $78DQ7._)({
                    method: "get",
                    path: path
                }, opts));
            }
        },
        {
            key: "calculateContentLength",
            value: function calculateContentLength(body) {
                if (typeof body === "string") {
                    if (typeof $8d713523431e0532$require$Buffer !== "undefined") return $8d713523431e0532$require$Buffer.byteLength(body, "utf8").toString();
                    if (typeof TextEncoder !== "undefined") {
                        var encoder = new TextEncoder();
                        var encoded = encoder.encode(body);
                        return encoded.length.toString();
                    }
                } else if (ArrayBuffer.isView(body)) return body.byteLength.toString();
                return null;
            }
        },
        {
            key: "buildRequest",
            value: function buildRequest(options) {
                var _httpAgent_options;
                var method = options.method, path = options.path, query = options.query, tmp = options.headers, headers = tmp === void 0 ? {} : tmp;
                var body = ArrayBuffer.isView(options.body) || options.__binaryRequest && typeof options.body === "string" ? options.body : (0, $bPEOW.isMultipartBody)(options.body) ? options.body.body : options.body ? JSON.stringify(options.body, null, 2) : null;
                var contentLength = this.calculateContentLength(body);
                var url = this.buildURL(path, query);
                if ("timeout" in options) $8d713523431e0532$var$validatePositiveInteger("timeout", options.timeout);
                var _options_timeout;
                var timeout = (_options_timeout = options.timeout) !== null && _options_timeout !== void 0 ? _options_timeout : this.timeout;
                var _options_httpAgent, _ref;
                var httpAgent = (_ref = (_options_httpAgent = options.httpAgent) !== null && _options_httpAgent !== void 0 ? _options_httpAgent : this.httpAgent) !== null && _ref !== void 0 ? _ref : (0, $fEKje.getDefaultAgent)(url);
                var minAgentTimeout = timeout + 1000;
                var _httpAgent_options_timeout;
                if (typeof (httpAgent === null || httpAgent === void 0 ? void 0 : (_httpAgent_options = httpAgent.options) === null || _httpAgent_options === void 0 ? void 0 : _httpAgent_options.timeout) === "number" && minAgentTimeout > ((_httpAgent_options_timeout = httpAgent.options.timeout) !== null && _httpAgent_options_timeout !== void 0 ? _httpAgent_options_timeout : 0)) // Allow any given request to bump our agent active socket timeout.
                // This may seem strange, but leaking active sockets should be rare and not particularly problematic,
                // and without mutating agent we would need to create more of them.
                // This tradeoff optimizes for performance.
                httpAgent.options.timeout = minAgentTimeout;
                if (this.idempotencyHeader && method !== "get") {
                    if (!options.idempotencyKey) options.idempotencyKey = this.defaultIdempotencyKey();
                    headers[this.idempotencyHeader] = options.idempotencyKey;
                }
                var reqHeaders = this.buildHeaders({
                    options: options,
                    headers: headers,
                    contentLength: contentLength
                });
                var _options_signal;
                var req = (0, $ddevm._)((0, $78DQ7._)((0, $ddevm._)((0, $78DQ7._)({
                    method: method
                }, body && {
                    body: body
                }), {
                    headers: reqHeaders
                }), httpAgent && {
                    agent: httpAgent
                }), {
                    // @ts-ignore node-fetch uses a custom AbortSignal type that is
                    // not compatible with standard web types
                    signal: (_options_signal = options.signal) !== null && _options_signal !== void 0 ? _options_signal : null
                });
                return {
                    req: req,
                    url: url,
                    timeout: timeout
                };
            }
        },
        {
            key: "buildHeaders",
            value: function buildHeaders(param) {
                var options = param.options, headers = param.headers, contentLength = param.contentLength;
                var reqHeaders = {};
                if (contentLength) reqHeaders["content-length"] = contentLength;
                var defaultHeaders = this.defaultHeaders(options);
                $8d713523431e0532$var$applyHeadersMut(reqHeaders, defaultHeaders);
                $8d713523431e0532$var$applyHeadersMut(reqHeaders, headers);
                // let builtin fetch set the Content-Type for multipart bodies
                if ((0, $bPEOW.isMultipartBody)(options.body) && $fEKje.kind !== "node") delete reqHeaders["content-type"];
                this.validateHeaders(reqHeaders, headers);
                return reqHeaders;
            }
        },
        {
            key: "prepareOptions",
            value: /**
     * Used as a callback for mutating the given `FinalRequestOptions` object.
     */ function prepareOptions(options) {
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "prepareRequest",
            value: /**
     * Used as a callback for mutating the given `RequestInit` object.
     *
     * This is useful for cases where you want to add certain headers based off of
     * the request properties, e.g. `method` or `url`.
     */ function prepareRequest(request, param) {
                var url = param.url, options = param.options;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "parseHeaders",
            value: function parseHeaders(headers) {
                return !headers ? {} : Symbol.iterator in headers ? Object.fromEntries(Array.from(headers).map(function(header) {
                    return (0, $3jzhD._)(header);
                })) : (0, $78DQ7._)({}, headers);
            }
        },
        {
            key: "makeStatusError",
            value: function makeStatusError(status, error, message, headers) {
                return $kQ0uC.APIError.generate(status, error, message, headers);
            }
        },
        {
            key: "request",
            value: function request(options) {
                var remainingRetries = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return new $8d713523431e0532$var$APIPromise(this.makeRequest(options, remainingRetries));
            }
        },
        {
            key: "makeRequest",
            value: function makeRequest(optionsInput, retriesRemaining) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _options_signal, options, _options_maxRetries, _this_buildRequest, req, url, timeout, controller, response, _options_signal1, responseHeaders, retryMessage, errText, errJSON, errMessage, retryMessage1, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    optionsInput
                                ];
                            case 1:
                                options = _state.sent();
                                if (retriesRemaining == null) retriesRemaining = (_options_maxRetries = options.maxRetries) !== null && _options_maxRetries !== void 0 ? _options_maxRetries : _this.maxRetries;
                                return [
                                    4,
                                    _this.prepareOptions(options)
                                ];
                            case 2:
                                _state.sent();
                                _this_buildRequest = _this.buildRequest(options), req = _this_buildRequest.req, url = _this_buildRequest.url, timeout = _this_buildRequest.timeout;
                                return [
                                    4,
                                    _this.prepareRequest(req, {
                                        url: url,
                                        options: options
                                    })
                                ];
                            case 3:
                                _state.sent();
                                $8d713523431e0532$var$debug("request", url, options, req.headers);
                                if ((_options_signal = options.signal) === null || _options_signal === void 0 ? void 0 : _options_signal.aborted) throw new $kQ0uC.APIUserAbortError();
                                controller = new AbortController();
                                return [
                                    4,
                                    _this.fetchWithTimeout(url, req, timeout, controller).catch(module.exports.castToError)
                                ];
                            case 4:
                                response = _state.sent();
                                if (response instanceof Error) {
                                    ;
                                    if ((_options_signal1 = options.signal) === null || _options_signal1 === void 0 ? void 0 : _options_signal1.aborted) throw new $kQ0uC.APIUserAbortError();
                                    if (retriesRemaining) return [
                                        2,
                                        _this.retryRequest(options, retriesRemaining)
                                    ];
                                    if (response.name === "AbortError") throw new $kQ0uC.APIConnectionTimeoutError();
                                    throw new $kQ0uC.APIConnectionError({
                                        cause: response
                                    });
                                }
                                responseHeaders = (0, module.exports.createResponseHeaders)(response.headers);
                                if (!!response.ok) return [
                                    3,
                                    6
                                ];
                                if (retriesRemaining && _this.shouldRetry(response)) {
                                    retryMessage = "retrying, ".concat(retriesRemaining, " attempts remaining");
                                    $8d713523431e0532$var$debug("response (error; ".concat(retryMessage, ")"), response.status, url, responseHeaders);
                                    return [
                                        2,
                                        _this.retryRequest(options, retriesRemaining, responseHeaders)
                                    ];
                                }
                                return [
                                    4,
                                    response.text().catch(function(e) {
                                        return (0, module.exports.castToError)(e).message;
                                    })
                                ];
                            case 5:
                                errText = _state.sent();
                                errJSON = (0, module.exports.safeJSON)(errText);
                                errMessage = errJSON ? undefined : errText;
                                retryMessage1 = retriesRemaining ? "(error; no more retries left)" : "(error; not retryable)";
                                $8d713523431e0532$var$debug("response (error; ".concat(retryMessage1, ")"), response.status, url, responseHeaders, errMessage);
                                err = _this.makeStatusError(response.status, errJSON, errMessage, responseHeaders);
                                throw err;
                            case 6:
                                return [
                                    2,
                                    {
                                        response: response,
                                        options: options,
                                        controller: controller
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestAPIList",
            value: function requestAPIList(Page, options) {
                var request = this.makeRequest(options, null);
                return new $8d713523431e0532$var$PagePromise(this, request, Page);
            }
        },
        {
            key: "buildURL",
            value: function buildURL(path, query) {
                var url = $8d713523431e0532$var$isAbsoluteURL(path) ? new URL(path) : new URL(this.baseURL + (this.baseURL.endsWith("/") && path.startsWith("/") ? path.slice(1) : path));
                var defaultQuery = this.defaultQuery();
                if (!$8d713523431e0532$var$isEmptyObj(defaultQuery)) query = (0, $78DQ7._)({}, defaultQuery, query);
                if (typeof query === "object" && query && !Array.isArray(query)) url.search = this.stringifyQuery(query);
                return url.toString();
            }
        },
        {
            key: "stringifyQuery",
            value: function stringifyQuery(query) {
                return Object.entries(query).filter(function(param) {
                    var _param = (0, $2MTYX._)(param, 2), _ = _param[0], value = _param[1];
                    return typeof value !== "undefined";
                }).map(function(param) {
                    var _param = (0, $2MTYX._)(param, 2), key = _param[0], value = _param[1];
                    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
                    if (value === null) return "".concat(encodeURIComponent(key), "=");
                    throw new $kQ0uC.OpenAIError("Cannot stringify type ".concat(typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value), "; Expected string, number, boolean, or null. If you need to pass nested query parameters, you can manually encode them, e.g. { query: { 'foo[key1]': value1, 'foo[key2]': value2 } }, and please open a GitHub issue requesting better support for your use case."));
                }).join("&");
            }
        },
        {
            key: "fetchWithTimeout",
            value: function fetchWithTimeout(url, init, ms, controller) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _ref, signal, options, timeout;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        _ref = init || {}, signal = _ref.signal, options = (0, $6JqHh._)(_ref, [
                            "signal"
                        ]);
                        if (signal) signal.addEventListener("abort", function() {
                            return controller.abort();
                        });
                        timeout = setTimeout(function() {
                            return controller.abort();
                        }, ms);
                        return [
                            2,
                            _this.getRequestClient()// use undefined this binding; fetch errors if bound to something else in browser/cloudflare
                            .fetch.call(undefined, url, (0, $78DQ7._)({
                                signal: controller.signal
                            }, options)).finally(function() {
                                clearTimeout(timeout);
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getRequestClient",
            value: function getRequestClient() {
                return {
                    fetch: this.fetch
                };
            }
        },
        {
            key: "shouldRetry",
            value: function shouldRetry(response) {
                // Note this is not a standard header.
                var shouldRetryHeader = response.headers.get("x-should-retry");
                // If the server explicitly says whether or not to retry, obey.
                if (shouldRetryHeader === "true") return true;
                if (shouldRetryHeader === "false") return false;
                // Retry on request timeouts.
                if (response.status === 408) return true;
                // Retry on lock timeouts.
                if (response.status === 409) return true;
                // Retry on rate limits.
                if (response.status === 429) return true;
                // Retry internal errors.
                if (response.status >= 500) return true;
                return false;
            }
        },
        {
            key: "retryRequest",
            value: function retryRequest(options, retriesRemaining, responseHeaders) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var timeoutMillis, retryAfterMillisHeader, timeoutMs, retryAfterHeader, timeoutSeconds, _options_maxRetries, maxRetries;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Note the `retry-after-ms` header may not be standard, but is a good idea and we'd like proactive support for it.
                                retryAfterMillisHeader = responseHeaders === null || responseHeaders === void 0 ? void 0 : responseHeaders["retry-after-ms"];
                                if (retryAfterMillisHeader) {
                                    timeoutMs = parseFloat(retryAfterMillisHeader);
                                    if (!Number.isNaN(timeoutMs)) timeoutMillis = timeoutMs;
                                }
                                // About the Retry-After header: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After
                                retryAfterHeader = responseHeaders === null || responseHeaders === void 0 ? void 0 : responseHeaders["retry-after"];
                                if (retryAfterHeader && !timeoutMillis) {
                                    timeoutSeconds = parseFloat(retryAfterHeader);
                                    if (!Number.isNaN(timeoutSeconds)) timeoutMillis = timeoutSeconds * 1000;
                                    else timeoutMillis = Date.parse(retryAfterHeader) - Date.now();
                                }
                                // If the API asks us to wait a certain amount of time (and it's a reasonable amount),
                                // just do what it says, but otherwise calculate a default
                                if (!(timeoutMillis && 0 <= timeoutMillis && timeoutMillis < 60000)) {
                                    ;
                                    maxRetries = (_options_maxRetries = options.maxRetries) !== null && _options_maxRetries !== void 0 ? _options_maxRetries : _this.maxRetries;
                                    timeoutMillis = _this.calculateDefaultRetryTimeoutMillis(retriesRemaining, maxRetries);
                                }
                                return [
                                    4,
                                    (0, module.exports.sleep)(timeoutMillis)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.makeRequest(options, retriesRemaining - 1)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "calculateDefaultRetryTimeoutMillis",
            value: function calculateDefaultRetryTimeoutMillis(retriesRemaining, maxRetries) {
                var initialRetryDelay = 0.5;
                var maxRetryDelay = 8.0;
                var numRetries = maxRetries - retriesRemaining;
                // Apply exponential backoff, but not more than the max.
                var sleepSeconds = Math.min(initialRetryDelay * Math.pow(2, numRetries), maxRetryDelay);
                // Apply some jitter, take up to at most 25 percent of the retry time.
                var jitter = 1 - Math.random() * 0.25;
                return sleepSeconds * jitter * 1000;
            }
        },
        {
            key: "getUserAgent",
            value: function getUserAgent() {
                return "".concat(this.constructor.name, "/JS ").concat($8Zn2o.VERSION);
            }
        }
    ]);
    return APIClient;
}();
module.exports.APIClient = $8d713523431e0532$var$APIClient;
var $8d713523431e0532$var$AbstractPage = /*#__PURE__*/ function() {
    "use strict";
    function AbstractPage(client, response, body, options) {
        (0, $19mwo._)(this, AbstractPage);
        $8d713523431e0532$var$_AbstractPage_client.set(this, void 0);
        $8d713523431e0532$var$__classPrivateFieldSet(this, $8d713523431e0532$var$_AbstractPage_client, client, "f");
        this.options = options;
        this.response = response;
        this.body = body;
    }
    (0, $6rpfc._)(AbstractPage, [
        {
            key: "hasNextPage",
            value: function hasNextPage() {
                var items = this.getPaginatedItems();
                if (!items.length) return false;
                return this.nextPageInfo() != null;
            }
        },
        {
            key: "getNextPage",
            value: function getNextPage() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var nextInfo, nextOptions, params, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, value;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                nextInfo = _this.nextPageInfo();
                                if (!nextInfo) throw new $kQ0uC.OpenAIError("No next page expected; please check `.hasNextPage()` before calling `.getNextPage()`.");
                                nextOptions = (0, $78DQ7._)({}, _this.options);
                                if ("params" in nextInfo && typeof nextOptions.query === "object") nextOptions.query = (0, $78DQ7._)({}, nextOptions.query, nextInfo.params);
                                else if ("url" in nextInfo) {
                                    params = (0, $3jzhD._)(Object.entries(nextOptions.query || {})).concat((0, $3jzhD._)(nextInfo.url.searchParams.entries()));
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = params[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            _step_value = (0, $2MTYX._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                                            nextInfo.url.searchParams.set(key, value);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    nextOptions.query = undefined;
                                    nextOptions.path = nextInfo.url.toString();
                                }
                                return [
                                    4,
                                    $8d713523431e0532$var$__classPrivateFieldGet(_this, $8d713523431e0532$var$_AbstractPage_client, "f").requestAPIList(_this.constructor, nextOptions)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "iterPages",
            value: function iterPages() {
                var _this = this;
                return (0, $e2m1c._)(function() {
                    var page;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // eslint-disable-next-line @typescript-eslint/no-this-alias
                                page = _this;
                                return [
                                    4,
                                    page
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                if (!page.hasNextPage()) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    (0, $27QSE._)(page.getNextPage())
                                ];
                            case 3:
                                page = _state.sent();
                                return [
                                    4,
                                    page
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: ($8d713523431e0532$var$_AbstractPage_client = new WeakMap(), Symbol.asyncIterator),
            value: function value() {
                var _this = this;
                return (0, $e2m1c._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, page, _iteratorNormalCompletion, _didIteratorError1, _iteratorError1, _iterator1, _step1, item, err, err1;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    13,
                                    14,
                                    19
                                ]);
                                _iterator = (0, $gIbDP._)(_this.iterPages());
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    (0, $27QSE._)(_iterator.next())
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    12
                                ];
                                _value = _step.value;
                                page = _value;
                                _iteratorNormalCompletion = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    9,
                                    10,
                                    11
                                ]);
                                _iterator1 = page.getPaginatedItems()[Symbol.iterator]();
                                _state.label = 5;
                            case 5:
                                if (!!(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    8
                                ];
                                item = _step1.value;
                                return [
                                    4,
                                    item
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    5
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 11:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 12:
                                return [
                                    3,
                                    19
                                ];
                            case 13:
                                err1 = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err1;
                                return [
                                    3,
                                    19
                                ];
                            case 14:
                                _state.trys.push([
                                    14,
                                    ,
                                    17,
                                    18
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    16
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 15:
                                _state.sent();
                                _state.label = 16;
                            case 16:
                                return [
                                    3,
                                    18
                                ];
                            case 17:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 18:
                                return [
                                    7
                                ];
                            case 19:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AbstractPage;
}();
module.exports.AbstractPage = $8d713523431e0532$var$AbstractPage;
/**
 * This subclass of Promise will resolve to an instantiated Page once the request completes.
 *
 * It also implements AsyncIterable to allow auto-paginating iteration on an unawaited list call, eg:
 *
 *    for await (const item of client.items.list()) {
 *      console.log(item)
 *    }
 */ var $8d713523431e0532$var$PagePromise = /*#__PURE__*/ function(APIPromise) {
    "use strict";
    (0, $iNfU4._)(PagePromise, APIPromise);
    var _super = (0, $k1NN5._)(PagePromise);
    function PagePromise(client, request, Page) {
        (0, $19mwo._)(this, PagePromise);
        return _super.call(this, request, function() {
            var _ref = (0, $9OZ9j._)(function(props) {
                var _, _tmp;
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _ = Page.bind;
                            _tmp = [
                                void 0,
                                client,
                                props.response
                            ];
                            return [
                                4,
                                $8d713523431e0532$var$defaultParseResponse(props)
                            ];
                        case 1:
                            return [
                                2,
                                new (_.apply(Page, _tmp.concat([
                                    _state.sent(),
                                    props.options
                                ])))
                            ];
                    }
                });
            });
            return function(props) {
                return _ref.apply(this, arguments);
            };
        }());
    }
    (0, $6rpfc._)(PagePromise, [
        {
            key: Symbol.asyncIterator,
            value: /**
     * Allow auto-paginating iteration on an unawaited list call, eg:
     *
     *    for await (const item of client.items.list()) {
     *      console.log(item)
     *    }
     */ function value() {
                var _this = this;
                return (0, $e2m1c._)(function() {
                    var page, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $27QSE._)(_this)
                                ];
                            case 1:
                                page = _state.sent();
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    8,
                                    9,
                                    14
                                ]);
                                _iterator = (0, $gIbDP._)(page);
                                _state.label = 3;
                            case 3:
                                return [
                                    4,
                                    (0, $27QSE._)(_iterator.next())
                                ];
                            case 4:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    7
                                ];
                                _value = _step.value;
                                item = _value;
                                return [
                                    4,
                                    item
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    3
                                ];
                            case 7:
                                return [
                                    3,
                                    14
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    14
                                ];
                            case 9:
                                _state.trys.push([
                                    9,
                                    ,
                                    12,
                                    13
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    11
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 10:
                                _state.sent();
                                _state.label = 11;
                            case 11:
                                return [
                                    3,
                                    13
                                ];
                            case 12:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 13:
                                return [
                                    7
                                ];
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PagePromise;
}($8d713523431e0532$var$APIPromise);
module.exports.PagePromise = $8d713523431e0532$var$PagePromise;
var $8d713523431e0532$var$createResponseHeaders = function(headers) {
    return new Proxy(Object.fromEntries(// @ts-ignore
    headers.entries()), {
        get: function(target, name) {
            var key = name.toString();
            return target[key.toLowerCase()] || target[key];
        }
    });
};
module.exports.createResponseHeaders = $8d713523431e0532$var$createResponseHeaders;
// This is required so that we can determine if a given object matches the RequestOptions
// type at runtime. While this requires duplication, it is enforced by the TypeScript
// compiler such that any missing / extraneous keys will cause an error.
var $8d713523431e0532$var$requestOptionsKeys = {
    method: true,
    path: true,
    query: true,
    body: true,
    headers: true,
    maxRetries: true,
    stream: true,
    timeout: true,
    httpAgent: true,
    signal: true,
    idempotencyKey: true,
    __binaryRequest: true,
    __binaryResponse: true,
    __streamClass: true
};
var $8d713523431e0532$var$isRequestOptions = function(obj) {
    return typeof obj === "object" && obj !== null && !$8d713523431e0532$var$isEmptyObj(obj) && Object.keys(obj).every(function(k) {
        return $8d713523431e0532$var$hasOwn($8d713523431e0532$var$requestOptionsKeys, k);
    });
};
module.exports.isRequestOptions = $8d713523431e0532$var$isRequestOptions;
var $8d713523431e0532$var$getPlatformProperties = function() {
    var _Deno_version;
    var _Deno_version_deno;
    if (typeof Deno !== "undefined" && Deno.build != null) return {
        "X-Stainless-Lang": "js",
        "X-Stainless-Package-Version": $8Zn2o.VERSION,
        "X-Stainless-OS": $8d713523431e0532$var$normalizePlatform(Deno.build.os),
        "X-Stainless-Arch": $8d713523431e0532$var$normalizeArch(Deno.build.arch),
        "X-Stainless-Runtime": "deno",
        "X-Stainless-Runtime-Version": typeof Deno.version === "string" ? Deno.version : (_Deno_version_deno = (_Deno_version = Deno.version) === null || _Deno_version === void 0 ? void 0 : _Deno_version.deno) !== null && _Deno_version_deno !== void 0 ? _Deno_version_deno : "unknown"
    };
    if (typeof EdgeRuntime !== "undefined") return {
        "X-Stainless-Lang": "js",
        "X-Stainless-Package-Version": $8Zn2o.VERSION,
        "X-Stainless-OS": "Unknown",
        "X-Stainless-Arch": "other:".concat(EdgeRuntime),
        "X-Stainless-Runtime": "edge",
        "X-Stainless-Runtime-Version": $hZFWO.version
    };
    // Check if Node.js
    if (Object.prototype.toString.call(typeof $hZFWO !== "undefined" ? $hZFWO : 0) === "[object process]") return {
        "X-Stainless-Lang": "js",
        "X-Stainless-Package-Version": $8Zn2o.VERSION,
        "X-Stainless-OS": $8d713523431e0532$var$normalizePlatform($hZFWO.platform),
        "X-Stainless-Arch": $8d713523431e0532$var$normalizeArch($hZFWO.arch),
        "X-Stainless-Runtime": "node",
        "X-Stainless-Runtime-Version": $hZFWO.version
    };
    var browserInfo = $8d713523431e0532$var$getBrowserInfo();
    if (browserInfo) return {
        "X-Stainless-Lang": "js",
        "X-Stainless-Package-Version": $8Zn2o.VERSION,
        "X-Stainless-OS": "Unknown",
        "X-Stainless-Arch": "unknown",
        "X-Stainless-Runtime": "browser:".concat(browserInfo.browser),
        "X-Stainless-Runtime-Version": browserInfo.version
    };
    // TODO add support for Cloudflare workers, etc.
    return {
        "X-Stainless-Lang": "js",
        "X-Stainless-Package-Version": $8Zn2o.VERSION,
        "X-Stainless-OS": "Unknown",
        "X-Stainless-Arch": "unknown",
        "X-Stainless-Runtime": "unknown",
        "X-Stainless-Runtime-Version": "unknown"
    };
};
// Note: modified from https://github.com/JS-DevTools/host-environment/blob/b1ab79ecde37db5d6e163c050e54fe7d287d7c92/src/isomorphic.browser.ts
function $8d713523431e0532$var$getBrowserInfo() {
    if (typeof navigator === "undefined" || !navigator) return null;
    // NOTE: The order matters here!
    var browserPatterns = [
        {
            key: "edge",
            pattern: /Edge(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: "ie",
            pattern: /MSIE(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: "ie",
            pattern: /Trident(?:.*rv\:(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: "chrome",
            pattern: /Chrome(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: "firefox",
            pattern: /Firefox(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: "safari",
            pattern: /(?:Version\W+(\d+)\.(\d+)(?:\.(\d+))?)?(?:\W+Mobile\S*)?\W+Safari/
        }
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Find the FIRST matching browser
        for(var _iterator = browserPatterns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, key = _step_value.key, pattern = _step_value.pattern;
            var match = pattern.exec(navigator.userAgent);
            if (match) {
                var major = match[1] || 0;
                var minor = match[2] || 0;
                var patch = match[3] || 0;
                return {
                    browser: key,
                    version: "".concat(major, ".").concat(minor, ".").concat(patch)
                };
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
var $8d713523431e0532$var$normalizeArch = function(arch) {
    // Node docs:
    // - https://nodejs.org/api/process.html#processarch
    // Deno docs:
    // - https://doc.deno.land/deno/stable/~/Deno.build
    if (arch === "x32") return "x32";
    if (arch === "x86_64" || arch === "x64") return "x64";
    if (arch === "arm") return "arm";
    if (arch === "aarch64" || arch === "arm64") return "arm64";
    if (arch) return "other:".concat(arch);
    return "unknown";
};
var $8d713523431e0532$var$normalizePlatform = function(platform) {
    // Node platforms:
    // - https://nodejs.org/api/process.html#processplatform
    // Deno platforms:
    // - https://doc.deno.land/deno/stable/~/Deno.build
    // - https://github.com/denoland/deno/issues/14799
    platform = platform.toLowerCase();
    // NOTE: this iOS check is untested and may not work
    // Node does not work natively on IOS, there is a fork at
    // https://github.com/nodejs-mobile/nodejs-mobile
    // however it is unknown at the time of writing how to detect if it is running
    if (platform.includes("ios")) return "iOS";
    if (platform === "android") return "Android";
    if (platform === "darwin") return "MacOS";
    if (platform === "win32") return "Windows";
    if (platform === "freebsd") return "FreeBSD";
    if (platform === "openbsd") return "OpenBSD";
    if (platform === "linux") return "Linux";
    if (platform) return "Other:".concat(platform);
    return "Unknown";
};
var $8d713523431e0532$var$_platformHeaders;
var $8d713523431e0532$var$getPlatformHeaders = function() {
    return $8d713523431e0532$var$_platformHeaders !== null && $8d713523431e0532$var$_platformHeaders !== void 0 ? $8d713523431e0532$var$_platformHeaders : $8d713523431e0532$var$_platformHeaders = $8d713523431e0532$var$getPlatformProperties();
};
var $8d713523431e0532$var$safeJSON = function(text) {
    try {
        return JSON.parse(text);
    } catch (err) {
        return undefined;
    }
};
module.exports.safeJSON = $8d713523431e0532$var$safeJSON;
// https://stackoverflow.com/a/19709846
var $8d713523431e0532$var$startsWithSchemeRegexp = new RegExp("^(?:[a-z]+:)?//", "i");
var $8d713523431e0532$var$isAbsoluteURL = function(url) {
    return $8d713523431e0532$var$startsWithSchemeRegexp.test(url);
};
var $8d713523431e0532$var$sleep = function(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
};
module.exports.sleep = $8d713523431e0532$var$sleep;
var $8d713523431e0532$var$validatePositiveInteger = function(name, n) {
    if (typeof n !== "number" || !Number.isInteger(n)) throw new $kQ0uC.OpenAIError("".concat(name, " must be an integer"));
    if (n < 0) throw new $kQ0uC.OpenAIError("".concat(name, " must be a positive integer"));
    return n;
};
var $8d713523431e0532$var$castToError = function(err) {
    if (err instanceof Error) return err;
    return new Error(err);
};
module.exports.castToError = $8d713523431e0532$var$castToError;
var $8d713523431e0532$var$ensurePresent = function(value) {
    if (value == null) throw new $kQ0uC.OpenAIError("Expected a value to be given but received ".concat(value, " instead."));
    return value;
};
module.exports.ensurePresent = $8d713523431e0532$var$ensurePresent;
/**
 * Read an environment variable.
 *
 * Trims beginning and trailing whitespace.
 *
 * Will return undefined if the environment variable doesn't exist or cannot be accessed.
 */ var $8d713523431e0532$var$readEnv = function(env) {
    var _process_env_env, _process_env, _Deno_env_get, _Deno_env_get1, _Deno_env;
    var _process_env_env_trim;
    if (typeof $hZFWO !== "undefined") return (_process_env_env_trim = (_process_env = $hZFWO.env) === null || _process_env === void 0 ? void 0 : (_process_env_env = _process_env[env]) === null || _process_env_env === void 0 ? void 0 : _process_env_env.trim()) !== null && _process_env_env_trim !== void 0 ? _process_env_env_trim : undefined;
    if (typeof Deno !== "undefined") return (_Deno_env = Deno.env) === null || _Deno_env === void 0 ? void 0 : (_Deno_env_get1 = _Deno_env.get) === null || _Deno_env_get1 === void 0 ? void 0 : (_Deno_env_get = _Deno_env_get1.call(_Deno_env, env)) === null || _Deno_env_get === void 0 ? void 0 : _Deno_env_get.trim();
    return undefined;
};
module.exports.readEnv = $8d713523431e0532$var$readEnv;
var $8d713523431e0532$var$coerceInteger = function(value) {
    if (typeof value === "number") return Math.round(value);
    if (typeof value === "string") return parseInt(value, 10);
    throw new $kQ0uC.OpenAIError("Could not coerce ".concat(value, " (type: ").concat(typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value), ") into a number"));
};
module.exports.coerceInteger = $8d713523431e0532$var$coerceInteger;
var $8d713523431e0532$var$coerceFloat = function(value) {
    if (typeof value === "number") return value;
    if (typeof value === "string") return parseFloat(value);
    throw new $kQ0uC.OpenAIError("Could not coerce ".concat(value, " (type: ").concat(typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value), ") into a number"));
};
module.exports.coerceFloat = $8d713523431e0532$var$coerceFloat;
var $8d713523431e0532$var$coerceBoolean = function(value) {
    if (typeof value === "boolean") return value;
    if (typeof value === "string") return value === "true";
    return Boolean(value);
};
module.exports.coerceBoolean = $8d713523431e0532$var$coerceBoolean;
var $8d713523431e0532$var$maybeCoerceInteger = function(value) {
    if (value === undefined) return undefined;
    return (0, module.exports.coerceInteger)(value);
};
module.exports.maybeCoerceInteger = $8d713523431e0532$var$maybeCoerceInteger;
var $8d713523431e0532$var$maybeCoerceFloat = function(value) {
    if (value === undefined) return undefined;
    return (0, module.exports.coerceFloat)(value);
};
module.exports.maybeCoerceFloat = $8d713523431e0532$var$maybeCoerceFloat;
var $8d713523431e0532$var$maybeCoerceBoolean = function(value) {
    if (value === undefined) return undefined;
    return (0, module.exports.coerceBoolean)(value);
};
module.exports.maybeCoerceBoolean = $8d713523431e0532$var$maybeCoerceBoolean;
// https://stackoverflow.com/a/34491287
function $8d713523431e0532$var$isEmptyObj(obj) {
    if (!obj) return true;
    for(var _k in obj)return false;
    return true;
}
module.exports.isEmptyObj = $8d713523431e0532$var$isEmptyObj;
// https://eslint.org/docs/latest/rules/no-prototype-builtins
function $8d713523431e0532$var$hasOwn(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
module.exports.hasOwn = $8d713523431e0532$var$hasOwn;
/**
 * Copies headers from "newHeaders" onto "targetHeaders",
 * using lower-case for all properties,
 * ignoring any keys with undefined values,
 * and deleting any keys with null values.
 */ function $8d713523431e0532$var$applyHeadersMut(targetHeaders, newHeaders) {
    for(var k in newHeaders){
        if (!$8d713523431e0532$var$hasOwn(newHeaders, k)) continue;
        var lowerKey = k.toLowerCase();
        if (!lowerKey) continue;
        var val = newHeaders[k];
        if (val === null) delete targetHeaders[lowerKey];
        else if (val !== undefined) targetHeaders[lowerKey] = val;
    }
}
function $8d713523431e0532$var$debug(action) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _console;
    var _process_env;
    if (typeof $hZFWO !== "undefined" && ($hZFWO === null || $hZFWO === void 0 ? void 0 : (_process_env = $hZFWO.env) === null || _process_env === void 0 ? void 0 : _process_env["DEBUG"]) === "true") (_console = console).log.apply(_console, [
        "OpenAI:DEBUG:".concat(action)
    ].concat((0, $3jzhD._)(args)));
}
module.exports.debug = $8d713523431e0532$var$debug;
/**
 * https://stackoverflow.com/a/2117523
 */ var $8d713523431e0532$var$uuid4 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        var v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
var $8d713523431e0532$var$isRunningInBrowser = function() {
    return(// @ts-ignore
    typeof window !== "undefined" && // @ts-ignore
    typeof window.document !== "undefined" && // @ts-ignore
    typeof navigator !== "undefined");
};
module.exports.isRunningInBrowser = $8d713523431e0532$var$isRunningInBrowser;
var $8d713523431e0532$var$isHeadersProtocol = function(headers) {
    return typeof (headers === null || headers === void 0 ? void 0 : headers.get) === "function";
};
module.exports.isHeadersProtocol = $8d713523431e0532$var$isHeadersProtocol;
var $8d713523431e0532$var$getRequiredHeader = function(headers, header) {
    var lowerCasedHeader = header.toLowerCase();
    if ((0, module.exports.isHeadersProtocol)(headers)) {
        var _header_;
        // to deal with the case where the header looks like Stainless-Event-Id
        var intercapsHeader = ((_header_ = header[0]) === null || _header_ === void 0 ? void 0 : _header_.toUpperCase()) + header.substring(1).replace(/([^\w])(\w)/g, function(_m, g1, g2) {
            return g1 + g2.toUpperCase();
        });
        for(var _i = 0, _iter = [
            header,
            lowerCasedHeader,
            header.toUpperCase(),
            intercapsHeader
        ]; _i < _iter.length; _i++){
            var key = _iter[_i];
            var value = headers.get(key);
            if (value) return value;
        }
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(headers)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2MTYX._)(_step.value, 2), key1 = _step_value[0], value1 = _step_value[1];
            if (key1.toLowerCase() === lowerCasedHeader) {
                if (Array.isArray(value1)) {
                    if (value1.length <= 1) return value1[0];
                    console.warn("Received ".concat(value1.length, " entries for the ").concat(header, " header, using the first entry."));
                    return value1[0];
                }
                return value1;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    throw new Error("Could not find ".concat(header, " header"));
};
module.exports.getRequiredHeader = $8d713523431e0532$var$getRequiredHeader;
/**
 * Encodes a string to Base64 format.
 */ var $8d713523431e0532$var$toBase64 = function(str) {
    if (!str) return "";
    if (typeof $8d713523431e0532$require$Buffer !== "undefined") return $8d713523431e0532$require$Buffer.from(str).toString("base64");
    if (typeof btoa !== "undefined") return btoa(str);
    throw new $kQ0uC.OpenAIError("Cannot generate b64 string; Expected `Buffer` or `btoa` to be defined");
};
module.exports.toBase64 = $8d713523431e0532$var$toBase64;
function $8d713523431e0532$var$isObj(obj) {
    return obj != null && typeof obj === "object" && !Array.isArray(obj);
}
module.exports.isObj = $8d713523431e0532$var$isObj;

});
parcelRegister("8Zn2o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VERSION = void 0;
module.exports.VERSION = "4.56.0"; // x-release-please-version

});

parcelRegister("8BEDZ", function(module, exports) {

var $gIbDP = parcelRequire("gIbDP");

var $9OZ9j = parcelRequire("9OZ9j");

var $27QSE = parcelRequire("27QSE");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $c5rwh = parcelRequire("c5rwh");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $e2m1c = parcelRequire("e2m1c");

var $lF1I7 = parcelRequire("lF1I7");

var $9iKK3 = parcelRequire("9iKK3");
var $64414e8174b5cb0f$require$Buffer = $9iKK3.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.readableStreamAsyncIterable = module.exports._decodeChunks = module.exports._iterSSEMessages = module.exports.Stream = void 0;

var $fEKje = parcelRequire("fEKje");

var $kQ0uC = parcelRequire("kQ0uC");

var $kQ0uC = parcelRequire("kQ0uC");
var $64414e8174b5cb0f$var$Stream = /*#__PURE__*/ function() {
    "use strict";
    function Stream(iterator, controller) {
        (0, $19mwo._)(this, Stream);
        this.iterator = iterator;
        this.controller = controller;
    }
    (0, $6rpfc._)(Stream, [
        {
            key: Symbol.asyncIterator,
            value: function value() {
                return this.iterator();
            }
        },
        {
            /**
     * Splits the stream into two streams which can be
     * independently read from at different speeds.
     */ key: "tee",
            value: function tee() {
                var left = [];
                var right = [];
                var iterator = this.iterator();
                var teeIterator = function(queue) {
                    return {
                        next: function() {
                            if (queue.length === 0) {
                                var result = iterator.next();
                                left.push(result);
                                right.push(result);
                            }
                            return queue.shift();
                        }
                    };
                };
                return [
                    new Stream(function() {
                        return teeIterator(left);
                    }, this.controller),
                    new Stream(function() {
                        return teeIterator(right);
                    }, this.controller)
                ];
            }
        },
        {
            /**
     * Converts this stream to a newline-separated ReadableStream of
     * JSON stringified values in the stream
     * which can be turned back into a Stream with `Stream.fromReadableStream()`.
     */ key: "toReadableStream",
            value: function toReadableStream() {
                var self = this;
                var iter;
                var encoder = new TextEncoder();
                return new $fEKje.ReadableStream({
                    start: function() {
                        return (0, $9OZ9j._)(function() {
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                iter = self[Symbol.asyncIterator]();
                                return [
                                    2
                                ];
                            });
                        })();
                    },
                    pull: function(ctrl) {
                        return (0, $9OZ9j._)(function() {
                            var _ref, value, done, bytes, err;
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            iter.next()
                                        ];
                                    case 1:
                                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                        if (done) return [
                                            2,
                                            ctrl.close()
                                        ];
                                        bytes = encoder.encode(JSON.stringify(value) + "\n");
                                        ctrl.enqueue(bytes);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        ctrl.error(err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    },
                    cancel: function() {
                        return (0, $9OZ9j._)(function() {
                            var _iter_return;
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            (_iter_return = iter.return) === null || _iter_return === void 0 ? void 0 : _iter_return.call(iter)
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    }
                });
            }
        }
    ], [
        {
            key: "fromSSEResponse",
            value: function fromSSEResponse(response, controller) {
                var consumed = false;
                function iterator() {
                    return _iterator.apply(this, arguments);
                }
                function _iterator() {
                    _iterator = (0, $e2m1c._)(function() {
                        var done, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _$_iterator, _step, _value, sse, data, data1, err, e;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (consumed) throw new Error("Cannot iterate over a consumed stream, use `.tee()` to split the stream.");
                                    consumed = true;
                                    done = false;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        17,
                                        18,
                                        19
                                    ]);
                                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                                    _state.label = 2;
                                case 2:
                                    _state.trys.push([
                                        2,
                                        10,
                                        11,
                                        16
                                    ]);
                                    _$_iterator = (0, $gIbDP._)($64414e8174b5cb0f$var$_iterSSEMessages(response, controller));
                                    _state.label = 3;
                                case 3:
                                    return [
                                        4,
                                        (0, $27QSE._)(_$_iterator.next())
                                    ];
                                case 4:
                                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                        3,
                                        9
                                    ];
                                    _value = _step.value;
                                    sse = _value;
                                    if (done) return [
                                        3,
                                        8
                                    ];
                                    if (sse.data.startsWith("[DONE]")) {
                                        done = true;
                                        return [
                                            3,
                                            8
                                        ];
                                    }
                                    if (!(sse.event === null)) return [
                                        3,
                                        6
                                    ];
                                    data = void 0;
                                    try {
                                        data = JSON.parse(sse.data);
                                    } catch (e) {
                                        console.error("Could not parse message into JSON:", sse.data);
                                        console.error("From chunk:", sse.raw);
                                        throw e;
                                    }
                                    if (data && data.error) throw new $kQ0uC.APIError(undefined, data.error, undefined, undefined);
                                    return [
                                        4,
                                        data
                                    ];
                                case 5:
                                    _state.sent();
                                    return [
                                        3,
                                        8
                                    ];
                                case 6:
                                    data1 = void 0;
                                    try {
                                        data1 = JSON.parse(sse.data);
                                    } catch (e) {
                                        console.error("Could not parse message into JSON:", sse.data);
                                        console.error("From chunk:", sse.raw);
                                        throw e;
                                    }
                                    // TODO: Is this where the error should be thrown?
                                    if (sse.event == "error") throw new $kQ0uC.APIError(undefined, data1.error, data1.message, undefined);
                                    return [
                                        4,
                                        {
                                            event: sse.event,
                                            data: data1
                                        }
                                    ];
                                case 7:
                                    _state.sent();
                                    _state.label = 8;
                                case 8:
                                    _iteratorAbruptCompletion = false;
                                    return [
                                        3,
                                        3
                                    ];
                                case 9:
                                    return [
                                        3,
                                        16
                                    ];
                                case 10:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        16
                                    ];
                                case 11:
                                    _state.trys.push([
                                        11,
                                        ,
                                        14,
                                        15
                                    ]);
                                    if (!(_iteratorAbruptCompletion && _$_iterator.return != null)) return [
                                        3,
                                        13
                                    ];
                                    return [
                                        4,
                                        _$_iterator.return()
                                    ];
                                case 12:
                                    _state.sent();
                                    _state.label = 13;
                                case 13:
                                    return [
                                        3,
                                        15
                                    ];
                                case 14:
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                    return [
                                        7
                                    ];
                                case 15:
                                    return [
                                        7
                                    ];
                                case 16:
                                    done = true;
                                    return [
                                        3,
                                        19
                                    ];
                                case 17:
                                    e = _state.sent();
                                    // If the user calls `stream.controller.abort()`, we should exit without throwing.
                                    if (e instanceof Error && e.name === "AbortError") return [
                                        2
                                    ];
                                    throw e;
                                case 18:
                                    // If the user `break`s, abort the ongoing request.
                                    if (!done) controller.abort();
                                    return [
                                        7
                                    ];
                                case 19:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return _iterator.apply(this, arguments);
                }
                return new Stream(iterator, controller);
            }
        },
        {
            key: "fromReadableStream",
            value: /**
     * Generates a Stream from a newline-separated ReadableStream
     * where each item is a JSON value.
     */ function fromReadableStream(readableStream, controller) {
                var consumed = false;
                function iterLines() {
                    return _iterLines.apply(this, arguments);
                }
                function _iterLines() {
                    _iterLines = (0, $e2m1c._)(function() {
                        var lineDecoder, iter, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, _iteratorNormalCompletion, _didIteratorError1, _iteratorError1, _iterator1, _step1, line, err, err1, _iteratorNormalCompletion1, _didIteratorError2, _iteratorError2, _iterator2, _step2, line1, err;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    lineDecoder = new $64414e8174b5cb0f$var$LineDecoder();
                                    iter = $64414e8174b5cb0f$var$readableStreamAsyncIterable(readableStream);
                                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        13,
                                        14,
                                        19
                                    ]);
                                    _iterator = (0, $gIbDP._)(iter);
                                    _state.label = 2;
                                case 2:
                                    return [
                                        4,
                                        (0, $27QSE._)(_iterator.next())
                                    ];
                                case 3:
                                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                        3,
                                        12
                                    ];
                                    _value = _step.value;
                                    chunk = _value;
                                    _iteratorNormalCompletion = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    _state.label = 4;
                                case 4:
                                    _state.trys.push([
                                        4,
                                        9,
                                        10,
                                        11
                                    ]);
                                    _iterator1 = lineDecoder.decode(chunk)[Symbol.iterator]();
                                    _state.label = 5;
                                case 5:
                                    if (!!(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done)) return [
                                        3,
                                        8
                                    ];
                                    line = _step1.value;
                                    return [
                                        4,
                                        line
                                    ];
                                case 6:
                                    _state.sent();
                                    _state.label = 7;
                                case 7:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        5
                                    ];
                                case 8:
                                    return [
                                        3,
                                        11
                                    ];
                                case 9:
                                    err = _state.sent();
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                    return [
                                        3,
                                        11
                                    ];
                                case 10:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 11:
                                    _iteratorAbruptCompletion = false;
                                    return [
                                        3,
                                        2
                                    ];
                                case 12:
                                    return [
                                        3,
                                        19
                                    ];
                                case 13:
                                    err1 = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err1;
                                    return [
                                        3,
                                        19
                                    ];
                                case 14:
                                    _state.trys.push([
                                        14,
                                        ,
                                        17,
                                        18
                                    ]);
                                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                        3,
                                        16
                                    ];
                                    return [
                                        4,
                                        _iterator.return()
                                    ];
                                case 15:
                                    _state.sent();
                                    _state.label = 16;
                                case 16:
                                    return [
                                        3,
                                        18
                                    ];
                                case 17:
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                    return [
                                        7
                                    ];
                                case 18:
                                    return [
                                        7
                                    ];
                                case 19:
                                    _iteratorNormalCompletion1 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                    _state.label = 20;
                                case 20:
                                    _state.trys.push([
                                        20,
                                        25,
                                        26,
                                        27
                                    ]);
                                    _iterator2 = lineDecoder.flush()[Symbol.iterator]();
                                    _state.label = 21;
                                case 21:
                                    if (!!(_iteratorNormalCompletion1 = (_step2 = _iterator2.next()).done)) return [
                                        3,
                                        24
                                    ];
                                    line1 = _step2.value;
                                    return [
                                        4,
                                        line1
                                    ];
                                case 22:
                                    _state.sent();
                                    _state.label = 23;
                                case 23:
                                    _iteratorNormalCompletion1 = true;
                                    return [
                                        3,
                                        21
                                    ];
                                case 24:
                                    return [
                                        3,
                                        27
                                    ];
                                case 25:
                                    err = _state.sent();
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                    return [
                                        3,
                                        27
                                    ];
                                case 26:
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator2.return != null) {
                                            _iterator2.return();
                                        }
                                    } finally{
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 27:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return _iterLines.apply(this, arguments);
                }
                function iterator() {
                    return _iterator.apply(this, arguments);
                }
                function _iterator() {
                    _iterator = (0, $e2m1c._)(function() {
                        var done, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _$_iterator, _step, _value, line, err, e;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (consumed) throw new Error("Cannot iterate over a consumed stream, use `.tee()` to split the stream.");
                                    consumed = true;
                                    done = false;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        15,
                                        16,
                                        17
                                    ]);
                                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                                    _state.label = 2;
                                case 2:
                                    _state.trys.push([
                                        2,
                                        8,
                                        9,
                                        14
                                    ]);
                                    _$_iterator = (0, $gIbDP._)(iterLines());
                                    _state.label = 3;
                                case 3:
                                    return [
                                        4,
                                        (0, $27QSE._)(_$_iterator.next())
                                    ];
                                case 4:
                                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                        3,
                                        7
                                    ];
                                    _value = _step.value;
                                    line = _value;
                                    if (done) return [
                                        3,
                                        6
                                    ];
                                    if (!line) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        JSON.parse(line)
                                    ];
                                case 5:
                                    _state.sent();
                                    _state.label = 6;
                                case 6:
                                    _iteratorAbruptCompletion = false;
                                    return [
                                        3,
                                        3
                                    ];
                                case 7:
                                    return [
                                        3,
                                        14
                                    ];
                                case 8:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        14
                                    ];
                                case 9:
                                    _state.trys.push([
                                        9,
                                        ,
                                        12,
                                        13
                                    ]);
                                    if (!(_iteratorAbruptCompletion && _$_iterator.return != null)) return [
                                        3,
                                        11
                                    ];
                                    return [
                                        4,
                                        _$_iterator.return()
                                    ];
                                case 10:
                                    _state.sent();
                                    _state.label = 11;
                                case 11:
                                    return [
                                        3,
                                        13
                                    ];
                                case 12:
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                    return [
                                        7
                                    ];
                                case 13:
                                    return [
                                        7
                                    ];
                                case 14:
                                    done = true;
                                    return [
                                        3,
                                        17
                                    ];
                                case 15:
                                    e = _state.sent();
                                    // If the user calls `stream.controller.abort()`, we should exit without throwing.
                                    if (e instanceof Error && e.name === "AbortError") return [
                                        2
                                    ];
                                    throw e;
                                case 16:
                                    // If the user `break`s, abort the ongoing request.
                                    if (!done) controller.abort();
                                    return [
                                        7
                                    ];
                                case 17:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return _iterator.apply(this, arguments);
                }
                return new Stream(iterator, controller);
            }
        }
    ]);
    return Stream;
}();
module.exports.Stream = $64414e8174b5cb0f$var$Stream;
function $64414e8174b5cb0f$var$_iterSSEMessages(response, controller) {
    return $64414e8174b5cb0f$var$__iterSSEMessages.apply(this, arguments);
}
function $64414e8174b5cb0f$var$__iterSSEMessages() {
    $64414e8174b5cb0f$var$__iterSSEMessages = (0, $e2m1c._)(function(response, controller) {
        var sseDecoder, lineDecoder, iter, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, sseChunk, _iteratorNormalCompletion, _didIteratorError1, _iteratorError1, _iterator1, _step1, line, sse, err, err1, _iteratorNormalCompletion1, _didIteratorError2, _iteratorError2, _iterator2, _step2, line1, sse1, err;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!response.body) {
                        controller.abort();
                        throw new $kQ0uC.OpenAIError("Attempted to iterate over a response with no body");
                    }
                    sseDecoder = new $64414e8174b5cb0f$var$SSEDecoder();
                    lineDecoder = new $64414e8174b5cb0f$var$LineDecoder();
                    iter = $64414e8174b5cb0f$var$readableStreamAsyncIterable(response.body);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        13,
                        14,
                        19
                    ]);
                    _iterator = (0, $gIbDP._)($64414e8174b5cb0f$var$iterSSEChunks(iter));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $27QSE._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        12
                    ];
                    _value = _step.value;
                    sseChunk = _value;
                    _iteratorNormalCompletion = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        9,
                        10,
                        11
                    ]);
                    _iterator1 = lineDecoder.decode(sseChunk)[Symbol.iterator]();
                    _state.label = 5;
                case 5:
                    if (!!(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done)) return [
                        3,
                        8
                    ];
                    line = _step1.value;
                    sse = sseDecoder.decode(line);
                    if (!sse) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        sse
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        5
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    err = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                    return [
                        3,
                        11
                    ];
                case 10:
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                    return [
                        7
                    ];
                case 11:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 12:
                    return [
                        3,
                        19
                    ];
                case 13:
                    err1 = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err1;
                    return [
                        3,
                        19
                    ];
                case 14:
                    _state.trys.push([
                        14,
                        ,
                        17,
                        18
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        16
                    ];
                    return [
                        4,
                        _iterator.return()
                    ];
                case 15:
                    _state.sent();
                    _state.label = 16;
                case 16:
                    return [
                        3,
                        18
                    ];
                case 17:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 18:
                    return [
                        7
                    ];
                case 19:
                    _iteratorNormalCompletion1 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    _state.label = 20;
                case 20:
                    _state.trys.push([
                        20,
                        25,
                        26,
                        27
                    ]);
                    _iterator2 = lineDecoder.flush()[Symbol.iterator]();
                    _state.label = 21;
                case 21:
                    if (!!(_iteratorNormalCompletion1 = (_step2 = _iterator2.next()).done)) return [
                        3,
                        24
                    ];
                    line1 = _step2.value;
                    sse1 = sseDecoder.decode(line1);
                    if (!sse1) return [
                        3,
                        23
                    ];
                    return [
                        4,
                        sse1
                    ];
                case 22:
                    _state.sent();
                    _state.label = 23;
                case 23:
                    _iteratorNormalCompletion1 = true;
                    return [
                        3,
                        21
                    ];
                case 24:
                    return [
                        3,
                        27
                    ];
                case 25:
                    err = _state.sent();
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                    return [
                        3,
                        27
                    ];
                case 26:
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                    return [
                        7
                    ];
                case 27:
                    return [
                        2
                    ];
            }
        });
    });
    return $64414e8174b5cb0f$var$__iterSSEMessages.apply(this, arguments);
}
module.exports._iterSSEMessages = $64414e8174b5cb0f$var$_iterSSEMessages;
function $64414e8174b5cb0f$var$iterSSEChunks(iterator) {
    return $64414e8174b5cb0f$var$_iterSSEChunks.apply(this, arguments);
}
function $64414e8174b5cb0f$var$_iterSSEChunks() {
    $64414e8174b5cb0f$var$_iterSSEChunks = /**
 * Given an async iterable iterator, iterates over it and yields full
 * SSE chunks, i.e. yields when a double new-line is encountered.
 */ (0, $e2m1c._)(function(iterator) {
        var data, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, binaryChunk, newData, patternIndex, err;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = new Uint8Array();
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $gIbDP._)(iterator);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $27QSE._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (chunk == null) return [
                        3,
                        6
                    ];
                    binaryChunk = chunk instanceof ArrayBuffer ? new Uint8Array(chunk) : typeof chunk === "string" ? new TextEncoder().encode(chunk) : chunk;
                    newData = new Uint8Array(data.length + binaryChunk.length);
                    newData.set(data);
                    newData.set(binaryChunk, data.length);
                    data = newData;
                    patternIndex = void 0;
                    _state.label = 4;
                case 4:
                    if (!((patternIndex = $64414e8174b5cb0f$var$findDoubleNewlineIndex(data)) !== -1)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        data.slice(0, patternIndex)
                    ];
                case 5:
                    _state.sent();
                    data = data.slice(patternIndex);
                    return [
                        3,
                        4
                    ];
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator.return()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    if (!(data.length > 0)) return [
                        3,
                        16
                    ];
                    return [
                        4,
                        data
                    ];
                case 15:
                    _state.sent();
                    _state.label = 16;
                case 16:
                    return [
                        2
                    ];
            }
        });
    });
    return $64414e8174b5cb0f$var$_iterSSEChunks.apply(this, arguments);
}
function $64414e8174b5cb0f$var$findDoubleNewlineIndex(buffer) {
    // This function searches the buffer for the end patterns (\r\r, \n\n, \r\n\r\n)
    // and returns the index right after the first occurrence of any pattern,
    // or -1 if none of the patterns are found.
    var newline = 0x0a; // \n
    var carriage = 0x0d; // \r
    for(var i = 0; i < buffer.length - 2; i++){
        if (buffer[i] === newline && buffer[i + 1] === newline) // \n\n
        return i + 2;
        if (buffer[i] === carriage && buffer[i + 1] === carriage) // \r\r
        return i + 2;
        if (buffer[i] === carriage && buffer[i + 1] === newline && i + 3 < buffer.length && buffer[i + 2] === carriage && buffer[i + 3] === newline) // \r\n\r\n
        return i + 4;
    }
    return -1;
}
var $64414e8174b5cb0f$var$SSEDecoder = /*#__PURE__*/ function() {
    "use strict";
    function SSEDecoder() {
        (0, $19mwo._)(this, SSEDecoder);
        this.event = null;
        this.data = [];
        this.chunks = [];
    }
    (0, $6rpfc._)(SSEDecoder, [
        {
            key: "decode",
            value: function decode(line) {
                if (line.endsWith("\r")) line = line.substring(0, line.length - 1);
                if (!line) {
                    // empty line and we didn't previously encounter any messages
                    if (!this.event && !this.data.length) return null;
                    var sse = {
                        event: this.event,
                        data: this.data.join("\n"),
                        raw: this.chunks
                    };
                    this.event = null;
                    this.data = [];
                    this.chunks = [];
                    return sse;
                }
                this.chunks.push(line);
                if (line.startsWith(":")) return null;
                var _partition = (0, $2MTYX._)($64414e8174b5cb0f$var$partition(line, ":"), 3), fieldname = _partition[0], _ = _partition[1], value = _partition[2];
                if (value.startsWith(" ")) value = value.substring(1);
                if (fieldname === "event") this.event = value;
                else if (fieldname === "data") this.data.push(value);
                return null;
            }
        }
    ]);
    return SSEDecoder;
}();
/**
 * A re-implementation of httpx's `LineDecoder` in Python that handles incrementally
 * reading lines from text.
 *
 * https://github.com/encode/httpx/blob/920333ea98118e9cf617f246905d7b202510941c/httpx/_decoders.py#L258
 */ var $64414e8174b5cb0f$var$LineDecoder = /*#__PURE__*/ function() {
    "use strict";
    function LineDecoder() {
        (0, $19mwo._)(this, LineDecoder);
        this.buffer = [];
        this.trailingCR = false;
    }
    (0, $6rpfc._)(LineDecoder, [
        {
            key: "decode",
            value: function decode(chunk) {
                var text = this.decodeText(chunk);
                if (this.trailingCR) {
                    text = "\r" + text;
                    this.trailingCR = false;
                }
                if (text.endsWith("\r")) {
                    this.trailingCR = true;
                    text = text.slice(0, -1);
                }
                if (!text) return [];
                var trailingNewline = LineDecoder.NEWLINE_CHARS.has(text[text.length - 1] || "");
                var lines = text.split(LineDecoder.NEWLINE_REGEXP);
                // if there is a trailing new line then the last entry will be an empty
                // string which we don't care about
                if (trailingNewline) lines.pop();
                if (lines.length === 1 && !trailingNewline) {
                    this.buffer.push(lines[0]);
                    return [];
                }
                if (this.buffer.length > 0) {
                    lines = [
                        this.buffer.join("") + lines[0]
                    ].concat((0, $3jzhD._)(lines.slice(1)));
                    this.buffer = [];
                }
                if (!trailingNewline) this.buffer = [
                    lines.pop() || ""
                ];
                return lines;
            }
        },
        {
            key: "decodeText",
            value: function decodeText(bytes) {
                if (bytes == null) return "";
                if (typeof bytes === "string") return bytes;
                // Node:
                if (typeof $64414e8174b5cb0f$require$Buffer !== "undefined") {
                    if (bytes instanceof $64414e8174b5cb0f$require$Buffer) return bytes.toString();
                    if (bytes instanceof Uint8Array) return $64414e8174b5cb0f$require$Buffer.from(bytes).toString();
                    throw new $kQ0uC.OpenAIError("Unexpected: received non-Uint8Array (".concat(bytes.constructor.name, ') stream chunk in an environment with a global "Buffer" defined, which this library assumes to be Node. Please report this error.'));
                }
                // Browser
                if (typeof TextDecoder !== "undefined") {
                    if (bytes instanceof Uint8Array || bytes instanceof ArrayBuffer) {
                        var _this_textDecoder;
                        (_this_textDecoder = this.textDecoder) !== null && _this_textDecoder !== void 0 ? _this_textDecoder : this.textDecoder = new TextDecoder("utf8");
                        return this.textDecoder.decode(bytes);
                    }
                    throw new $kQ0uC.OpenAIError("Unexpected: received non-Uint8Array/ArrayBuffer (".concat(bytes.constructor.name, ") in a web platform. Please report this error."));
                }
                throw new $kQ0uC.OpenAIError("Unexpected: neither Buffer nor TextDecoder are available as globals. Please report this error.");
            }
        },
        {
            key: "flush",
            value: function flush() {
                if (!this.buffer.length && !this.trailingCR) return [];
                var lines = [
                    this.buffer.join("")
                ];
                this.buffer = [];
                this.trailingCR = false;
                return lines;
            }
        }
    ]);
    return LineDecoder;
}();
// prettier-ignore
$64414e8174b5cb0f$var$LineDecoder.NEWLINE_CHARS = new Set([
    "\n",
    "\r"
]);
$64414e8174b5cb0f$var$LineDecoder.NEWLINE_REGEXP = /\r\n|[\n\r]/g;
/** This is an internal helper function that's just used for testing */ function $64414e8174b5cb0f$var$_decodeChunks(chunks) {
    var _lines;
    var decoder = new $64414e8174b5cb0f$var$LineDecoder();
    var lines = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = chunks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var chunk = _step.value;
            (_lines = lines).push.apply(_lines, (0, $3jzhD._)(decoder.decode(chunk)));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return lines;
}
module.exports._decodeChunks = $64414e8174b5cb0f$var$_decodeChunks;
function $64414e8174b5cb0f$var$partition(str, delimiter) {
    var index = str.indexOf(delimiter);
    if (index !== -1) return [
        str.substring(0, index),
        delimiter,
        str.substring(index + delimiter.length)
    ];
    return [
        str,
        "",
        ""
    ];
}
/**
 * Most browsers don't yet have async iterable support for ReadableStream,
 * and Node has a very different way of reading bytes from its "ReadableStream".
 *
 * This polyfill was pulled from https://github.com/MattiasBuelens/web-streams-polyfill/pull/122#issuecomment-1627354490
 */ function $64414e8174b5cb0f$var$readableStreamAsyncIterable(stream) {
    if (stream[Symbol.asyncIterator]) return stream;
    var reader = stream.getReader();
    return (0, $c5rwh._)({
        next: function() {
            return (0, $9OZ9j._)(function() {
                var result, e;
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                reader.read()
                            ];
                        case 1:
                            result = _state.sent();
                            if (result === null || result === void 0 ? void 0 : result.done) reader.releaseLock(); // release lock when stream becomes closed
                            return [
                                2,
                                result
                            ];
                        case 2:
                            e = _state.sent();
                            reader.releaseLock(); // release lock when stream becomes errored
                            throw e;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        return: function() {
            return (0, $9OZ9j._)(function() {
                var cancelPromise;
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cancelPromise = reader.cancel();
                            reader.releaseLock();
                            return [
                                4,
                                cancelPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                {
                                    done: true,
                                    value: undefined
                                }
                            ];
                    }
                });
            })();
        }
    }, Symbol.asyncIterator, function() {
        return this;
    });
}
module.exports.readableStreamAsyncIterable = $64414e8174b5cb0f$var$readableStreamAsyncIterable;

});
parcelRegister("fEKje", function(module, exports) {
/**
 * Disclaimer: modules in _shims aren't intended to be imported by SDK users.
 */ 
var $cOmXb = parcelRequire("cOmXb");

var $38cl2 = parcelRequire("38cl2");
if (!$cOmXb.kind) $cOmXb.setShims($38cl2.getRuntime(), {
    auto: true
});
var $b65e8379bc2ae0b9$var$_iteratorNormalCompletion = true, $b65e8379bc2ae0b9$var$_didIteratorError = false, $b65e8379bc2ae0b9$var$_iteratorError = undefined;
try {
    var $b65e8379bc2ae0b9$var$_loop = function() {
        var property = $b65e8379bc2ae0b9$var$_step.value;
        Object.defineProperty(module.exports, property, {
            get: function() {
                return $cOmXb[property];
            }
        });
    };
    for(var $b65e8379bc2ae0b9$var$_iterator = Object.keys($cOmXb)[Symbol.iterator](), $b65e8379bc2ae0b9$var$_step; !($b65e8379bc2ae0b9$var$_iteratorNormalCompletion = ($b65e8379bc2ae0b9$var$_step = $b65e8379bc2ae0b9$var$_iterator.next()).done); $b65e8379bc2ae0b9$var$_iteratorNormalCompletion = true)$b65e8379bc2ae0b9$var$_loop();
} catch (err) {
    $b65e8379bc2ae0b9$var$_didIteratorError = true;
    $b65e8379bc2ae0b9$var$_iteratorError = err;
} finally{
    try {
        if (!$b65e8379bc2ae0b9$var$_iteratorNormalCompletion && $b65e8379bc2ae0b9$var$_iterator.return != null) {
            $b65e8379bc2ae0b9$var$_iterator.return();
        }
    } finally{
        if ($b65e8379bc2ae0b9$var$_didIteratorError) {
            throw $b65e8379bc2ae0b9$var$_iteratorError;
        }
    }
}

});
parcelRegister("cOmXb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setShims = module.exports.isFsReadStream = module.exports.fileFromPath = module.exports.getDefaultAgent = module.exports.getMultipartRequestOptions = module.exports.ReadableStream = module.exports.File = module.exports.Blob = module.exports.FormData = module.exports.Headers = module.exports.Response = module.exports.Request = module.exports.fetch = module.exports.kind = module.exports.auto = void 0;
module.exports.auto = false;
module.exports.kind = undefined;
module.exports.fetch = undefined;
module.exports.Request = undefined;
module.exports.Response = undefined;
module.exports.Headers = undefined;
module.exports.FormData = undefined;
module.exports.Blob = undefined;
module.exports.File = undefined;
module.exports.ReadableStream = undefined;
module.exports.getMultipartRequestOptions = undefined;
module.exports.getDefaultAgent = undefined;
module.exports.fileFromPath = undefined;
module.exports.isFsReadStream = undefined;
function $953bf5a714c816cb$var$setShims(shims) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        auto: false
    };
    if (module.exports.auto) throw new Error("you must `import 'openai/shims/".concat(shims.kind, "'` before importing anything else from openai"));
    if (module.exports.kind) throw new Error("can't `import 'openai/shims/".concat(shims.kind, "'` after `import 'openai/shims/").concat(module.exports.kind, "'`"));
    module.exports.auto = options.auto;
    module.exports.kind = shims.kind;
    module.exports.fetch = shims.fetch;
    module.exports.Request = shims.Request;
    module.exports.Response = shims.Response;
    module.exports.Headers = shims.Headers;
    module.exports.FormData = shims.FormData;
    module.exports.Blob = shims.Blob;
    module.exports.File = shims.File;
    module.exports.ReadableStream = shims.ReadableStream;
    module.exports.getMultipartRequestOptions = shims.getMultipartRequestOptions;
    module.exports.getDefaultAgent = shims.getDefaultAgent;
    module.exports.fileFromPath = shims.fileFromPath;
    module.exports.isFsReadStream = shims.isFsReadStream;
}
module.exports.setShims = $953bf5a714c816cb$var$setShims;

});

parcelRegister("38cl2", function(module, exports) {
"use strict";
var $247bb09369d08df1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $247bb09369d08df1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $247bb09369d08df1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/**
 * Disclaimer: modules in _shims aren't intended to be imported by SDK users.
 */ $247bb09369d08df1$var$__exportStar((parcelRequire("6nG6J")), module.exports);

});
parcelRegister("6nG6J", function(module, exports) {

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $lF1I7 = parcelRequire("lF1I7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRuntime = void 0;

var $eyWNG = parcelRequire("eyWNG");
function $4a558dbe506494dc$var$getRuntime() {
    var manuallyImported = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).manuallyImported;
    var recommendation = manuallyImported ? "You may need to use polyfills" : "Add one of these imports before your first `import \u2026 from 'openai'`:\n- `import 'openai/shims/node'` (if you're running on Node)\n- `import 'openai/shims/web'` (otherwise)\n";
    var _fetch, _Request, _Response, _Headers;
    try {
        // @ts-ignore
        _fetch = fetch;
        // @ts-ignore
        _Request = Request;
        // @ts-ignore
        _Response = Response;
        // @ts-ignore
        _Headers = Headers;
    } catch (error) {
        throw new Error("this environment is missing the following Web Fetch API type: ".concat(error.message, ". ").concat(recommendation));
    }
    return {
        kind: "web",
        fetch: _fetch,
        Request: _Request,
        Response: _Response,
        Headers: _Headers,
        FormData: // @ts-ignore
        typeof FormData !== "undefined" ? FormData : function FormData1() {
            (0, $19mwo._)(this, FormData1);
            throw new Error("file uploads aren't supported in this environment yet as 'FormData' is undefined. ".concat(recommendation));
        },
        Blob: typeof Blob !== "undefined" ? Blob : function Blob1() {
            (0, $19mwo._)(this, Blob1);
            throw new Error("file uploads aren't supported in this environment yet as 'Blob' is undefined. ".concat(recommendation));
        },
        File: // @ts-ignore
        typeof File !== "undefined" ? File : function File1() {
            (0, $19mwo._)(this, File1);
            throw new Error("file uploads aren't supported in this environment yet as 'File' is undefined. ".concat(recommendation));
        },
        ReadableStream: // @ts-ignore
        typeof ReadableStream !== "undefined" ? ReadableStream : function ReadableStream1() {
            (0, $19mwo._)(this, ReadableStream1);
            throw new Error("streaming isn't supported in this environment yet as 'ReadableStream' is undefined. ".concat(recommendation));
        },
        getMultipartRequestOptions: function() {
            var _ref = (0, $9OZ9j._)(function(// @ts-ignore
            form, opts) {
                return (0, $lF1I7.__generator)(this, function(_state) {
                    return [
                        2,
                        (0, $ddevm._)((0, $78DQ7._)({}, opts), {
                            body: new $eyWNG.MultipartBody(form)
                        })
                    ];
                });
            });
            return function(form, opts) {
                return _ref.apply(this, arguments);
            };
        }(),
        getDefaultAgent: function(url) {
            return undefined;
        },
        fileFromPath: function() {
            throw new Error("The `fileFromPath` function is only supported in Node. See the README for more details: https://www.github.com/openai/openai-node#file-uploads");
        },
        isFsReadStream: function(value) {
            return false;
        }
    };
}
module.exports.getRuntime = $4a558dbe506494dc$var$getRuntime;

});
parcelRegister("eyWNG", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultipartBody = void 0;
/**
 * Disclaimer: modules in _shims aren't intended to be imported by SDK users.
 */ var $a9a1da2db549da21$var$MultipartBody = /*#__PURE__*/ function() {
    function MultipartBody(body) {
        (0, $19mwo._)(this, MultipartBody);
        this.body = body;
    }
    (0, $6rpfc._)(MultipartBody, [
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "MultipartBody";
            }
        }
    ]);
    return MultipartBody;
}();
module.exports.MultipartBody = $a9a1da2db549da21$var$MultipartBody;

});





parcelRegister("bPEOW", function(module, exports) {

var $gIbDP = parcelRequire("gIbDP");

var $9OZ9j = parcelRequire("9OZ9j");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $2MTYX = parcelRequire("2MTYX");

var $gnDeW = parcelRequire("gnDeW");

var $lF1I7 = parcelRequire("lF1I7");

var $9iKK3 = parcelRequire("9iKK3");
var $89d41f3f923ec99c$require$Buffer = $9iKK3.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createForm = module.exports.multipartFormRequestOptions = module.exports.maybeMultipartFormRequestOptions = module.exports.isMultipartBody = module.exports.toFile = module.exports.isUploadable = module.exports.isBlobLike = module.exports.isFileLike = module.exports.isResponseLike = module.exports.fileFromPath = void 0;

var $fEKje = parcelRequire("fEKje");

var $fEKje = parcelRequire("fEKje");
Object.defineProperty(module.exports, "fileFromPath", {
    enumerable: true,
    get: function get() {
        return $fEKje.fileFromPath;
    }
});
var $89d41f3f923ec99c$var$isResponseLike = function(value) {
    return value != null && typeof value === "object" && typeof value.url === "string" && typeof value.blob === "function";
};
module.exports.isResponseLike = $89d41f3f923ec99c$var$isResponseLike;
var $89d41f3f923ec99c$var$isFileLike = function(value) {
    return value != null && typeof value === "object" && typeof value.name === "string" && typeof value.lastModified === "number" && (0, module.exports.isBlobLike)(value);
};
module.exports.isFileLike = $89d41f3f923ec99c$var$isFileLike;
/**
 * The BlobLike type omits arrayBuffer() because @types/node-fetch@^2.6.4 lacks it; but this check
 * adds the arrayBuffer() method type because it is available and used at runtime
 */ var $89d41f3f923ec99c$var$isBlobLike = function(value) {
    return value != null && typeof value === "object" && typeof value.size === "number" && typeof value.type === "string" && typeof value.text === "function" && typeof value.slice === "function" && typeof value.arrayBuffer === "function";
};
module.exports.isBlobLike = $89d41f3f923ec99c$var$isBlobLike;
var $89d41f3f923ec99c$var$isUploadable = function(value) {
    return (0, module.exports.isFileLike)(value) || (0, module.exports.isResponseLike)(value) || (0, $fEKje.isFsReadStream)(value);
};
module.exports.isUploadable = $89d41f3f923ec99c$var$isUploadable;
function $89d41f3f923ec99c$var$toFile(value, name, options) {
    return $89d41f3f923ec99c$var$_toFile.apply(this, arguments);
}
function $89d41f3f923ec99c$var$_toFile() {
    $89d41f3f923ec99c$var$_toFile = /**
 * Helper for creating a {@link File} to pass to an SDK upload method from a variety of different data formats
 * @param value the raw content of the file.  Can be an {@link Uploadable}, {@link BlobLikePart}, or {@link AsyncIterable} of {@link BlobLikePart}s
 * @param {string=} name the name of the file. If omitted, toFile will try to determine a file name from bits if possible
 * @param {Object=} options additional properties
 * @param {string=} options.type the MIME type of the content
 * @param {number=} options.lastModified the last modified timestamp
 * @returns a {@link File} with the given properties
 */ (0, $9OZ9j._)(function(value, name, options) {
        var blob, _pathname_split_pop, bits, _getName, _bits_, type;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        value
                    ];
                case 1:
                    // If it's a promise, resolve it.
                    value = _state.sent();
                    // Use the file's options if there isn't one provided
                    options !== null && options !== void 0 ? options : options = (0, module.exports.isFileLike)(value) ? {
                        lastModified: value.lastModified,
                        type: value.type
                    } : {};
                    if (!(0, module.exports.isResponseLike)(value)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        value.blob()
                    ];
                case 2:
                    blob = _state.sent();
                    name || (name = (_pathname_split_pop = new URL(value.url).pathname.split(/[\\/]/).pop()) !== null && _pathname_split_pop !== void 0 ? _pathname_split_pop : "unknown_file");
                    return [
                        2,
                        new $fEKje.File([
                            blob
                        ], name, options)
                    ];
                case 3:
                    return [
                        4,
                        $89d41f3f923ec99c$var$getBytes(value)
                    ];
                case 4:
                    bits = _state.sent();
                    name || (name = (_getName = $89d41f3f923ec99c$var$getName(value)) !== null && _getName !== void 0 ? _getName : "unknown_file");
                    if (!options.type) {
                        ;
                        type = (_bits_ = bits[0]) === null || _bits_ === void 0 ? void 0 : _bits_.type;
                        if (typeof type === "string") options = (0, $ddevm._)((0, $78DQ7._)({}, options), {
                            type: type
                        });
                    }
                    return [
                        2,
                        new $fEKje.File(bits, name, options)
                    ];
            }
        });
    });
    return $89d41f3f923ec99c$var$_toFile.apply(this, arguments);
}
module.exports.toFile = $89d41f3f923ec99c$var$toFile;
function $89d41f3f923ec99c$var$getBytes(value) {
    return $89d41f3f923ec99c$var$_getBytes.apply(this, arguments);
}
function $89d41f3f923ec99c$var$_getBytes() {
    $89d41f3f923ec99c$var$_getBytes = (0, $9OZ9j._)(function(value) {
        var _value_constructor, parts, _, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    parts = [];
                    if (!(typeof value === "string" || ArrayBuffer.isView(value) || // includes Uint8Array, Buffer, etc.
                    value instanceof ArrayBuffer)) return [
                        3,
                        1
                    ];
                    parts.push(value);
                    return [
                        3,
                        17
                    ];
                case 1:
                    if (!(0, module.exports.isBlobLike)(value)) return [
                        3,
                        3
                    ];
                    _ = parts.push;
                    return [
                        4,
                        value.arrayBuffer()
                    ];
                case 2:
                    _.apply(parts, [
                        _state.sent()
                    ]);
                    return [
                        3,
                        17
                    ];
                case 3:
                    if (!$89d41f3f923ec99c$var$isAsyncIterableIterator(value) // includes Readable, ReadableStream, etc.
                    ) return [
                        3,
                        16
                    ];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        9,
                        10,
                        15
                    ]);
                    _iterator = (0, $gIbDP._)(value);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        8
                    ];
                    _value = _step.value;
                    chunk = _value;
                    parts.push(chunk); // TODO, consider validating?
                    _state.label = 7;
                case 7:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 8:
                    return [
                        3,
                        15
                    ];
                case 9:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        15
                    ];
                case 10:
                    _state.trys.push([
                        10,
                        ,
                        13,
                        14
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        12
                    ];
                    return [
                        4,
                        _iterator.return()
                    ];
                case 11:
                    _state.sent();
                    _state.label = 12;
                case 12:
                    return [
                        3,
                        14
                    ];
                case 13:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 14:
                    return [
                        7
                    ];
                case 15:
                    return [
                        3,
                        17
                    ];
                case 16:
                    throw new Error("Unexpected data type: ".concat(typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value), "; constructor: ").concat(value === null || value === void 0 ? void 0 : (_value_constructor = value.constructor) === null || _value_constructor === void 0 ? void 0 : _value_constructor.name, "; props: ").concat($89d41f3f923ec99c$var$propsForError(value)));
                case 17:
                    return [
                        2,
                        parts
                    ];
            }
        });
    });
    return $89d41f3f923ec99c$var$_getBytes.apply(this, arguments);
}
function $89d41f3f923ec99c$var$propsForError(value) {
    var props = Object.getOwnPropertyNames(value);
    return "[".concat(props.map(function(p) {
        return '"'.concat(p, '"');
    }).join(", "), "]");
}
function $89d41f3f923ec99c$var$getName(value) {
    var // For fs.ReadStream
    _getStringFromMaybeBuffer;
    return $89d41f3f923ec99c$var$getStringFromMaybeBuffer(value.name) || $89d41f3f923ec99c$var$getStringFromMaybeBuffer(value.filename) || ((_getStringFromMaybeBuffer = $89d41f3f923ec99c$var$getStringFromMaybeBuffer(value.path)) === null || _getStringFromMaybeBuffer === void 0 ? void 0 : _getStringFromMaybeBuffer.split(/[\\/]/).pop());
}
var $89d41f3f923ec99c$var$getStringFromMaybeBuffer = function(x) {
    if (typeof x === "string") return x;
    if (typeof $89d41f3f923ec99c$require$Buffer !== "undefined" && x instanceof $89d41f3f923ec99c$require$Buffer) return String(x);
    return undefined;
};
var $89d41f3f923ec99c$var$isAsyncIterableIterator = function(value) {
    return value != null && typeof value === "object" && typeof value[Symbol.asyncIterator] === "function";
};
var $89d41f3f923ec99c$var$isMultipartBody = function(body) {
    return body && typeof body === "object" && body.body && body[Symbol.toStringTag] === "MultipartBody";
};
module.exports.isMultipartBody = $89d41f3f923ec99c$var$isMultipartBody;
/**
 * Returns a multipart/form-data request if any part of the given request body contains a File / Blob value.
 * Otherwise returns the request as is.
 */ var $89d41f3f923ec99c$var$maybeMultipartFormRequestOptions = function() {
    var _ref = (0, $9OZ9j._)(function(opts) {
        var form;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$89d41f3f923ec99c$var$hasUploadableValue(opts.body)) return [
                        2,
                        opts
                    ];
                    return [
                        4,
                        (0, module.exports.createForm)(opts.body)
                    ];
                case 1:
                    form = _state.sent();
                    return [
                        2,
                        (0, $fEKje.getMultipartRequestOptions)(form, opts)
                    ];
            }
        });
    });
    return function maybeMultipartFormRequestOptions(opts) {
        return _ref.apply(this, arguments);
    };
}();
module.exports.maybeMultipartFormRequestOptions = $89d41f3f923ec99c$var$maybeMultipartFormRequestOptions;
var $89d41f3f923ec99c$var$multipartFormRequestOptions = function() {
    var _ref = (0, $9OZ9j._)(function(opts) {
        var form;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, module.exports.createForm)(opts.body)
                    ];
                case 1:
                    form = _state.sent();
                    return [
                        2,
                        (0, $fEKje.getMultipartRequestOptions)(form, opts)
                    ];
            }
        });
    });
    return function multipartFormRequestOptions(opts) {
        return _ref.apply(this, arguments);
    };
}();
module.exports.multipartFormRequestOptions = $89d41f3f923ec99c$var$multipartFormRequestOptions;
var $89d41f3f923ec99c$var$createForm = function() {
    var _ref = (0, $9OZ9j._)(function(body) {
        var form;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    form = new $fEKje.FormData();
                    return [
                        4,
                        Promise.all(Object.entries(body || {}).map(function(param) {
                            var _param = (0, $2MTYX._)(param, 2), key = _param[0], value = _param[1];
                            return $89d41f3f923ec99c$var$addFormValue(form, key, value);
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        form
                    ];
            }
        });
    });
    return function createForm(body) {
        return _ref.apply(this, arguments);
    };
}();
module.exports.createForm = $89d41f3f923ec99c$var$createForm;
var $89d41f3f923ec99c$var$hasUploadableValue = function(value) {
    if ((0, module.exports.isUploadable)(value)) return true;
    if (Array.isArray(value)) return value.some($89d41f3f923ec99c$var$hasUploadableValue);
    if (value && typeof value === "object") for(var k in value){
        if ($89d41f3f923ec99c$var$hasUploadableValue(value[k])) return true;
    }
    return false;
};
var $89d41f3f923ec99c$var$addFormValue = function() {
    var _ref = (0, $9OZ9j._)(function(form, key, value) {
        var file;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (value === undefined) return [
                        2
                    ];
                    if (value == null) throw new TypeError('Received null for "'.concat(key, "\"; to pass null in FormData, you must use the string 'null'"));
                    if (!(typeof value === "string" || typeof value === "number" || typeof value === "boolean")) return [
                        3,
                        1
                    ];
                    form.append(key, String(value));
                    return [
                        3,
                        8
                    ];
                case 1:
                    if (!(0, module.exports.isUploadable)(value)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $89d41f3f923ec99c$var$toFile(value)
                    ];
                case 2:
                    file = _state.sent();
                    form.append(key, file);
                    return [
                        3,
                        8
                    ];
                case 3:
                    if (!Array.isArray(value)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        Promise.all(value.map(function(entry) {
                            return $89d41f3f923ec99c$var$addFormValue(form, key + "[]", entry);
                        }))
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 5:
                    if (!(typeof value === "object")) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        Promise.all(Object.entries(value).map(function(param) {
                            var _param = (0, $2MTYX._)(param, 2), name = _param[0], prop = _param[1];
                            return $89d41f3f923ec99c$var$addFormValue(form, "".concat(key, "[").concat(name, "]"), prop);
                        }))
                    ];
                case 6:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 7:
                    throw new TypeError("Invalid value given to form, expected a string, number, boolean, object, Array, File or Blob but got ".concat(value, " instead"));
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function addFormValue(form, key, value) {
        return _ref.apply(this, arguments);
    };
}();

});



parcelRegister("4ux0n", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CursorPage = module.exports.Page = void 0;

var $c8Tp0 = parcelRequire("c8Tp0");
/**
 * Note: no pagination actually occurs yet, this is for forwards-compatibility.
 */ var $345390e58d1d4d4f$var$Page = /*#__PURE__*/ function(_core_1_AbstractPage) {
    (0, $iNfU4._)(Page, _core_1_AbstractPage);
    var _super = (0, $k1NN5._)(Page);
    function Page(client, response, body, options) {
        (0, $19mwo._)(this, Page);
        var _this;
        _this = _super.call(this, client, response, body, options);
        _this.data = body.data || [];
        _this.object = body.object;
        return _this;
    }
    (0, $6rpfc._)(Page, [
        {
            key: "getPaginatedItems",
            value: function getPaginatedItems() {
                var _this_data;
                return (_this_data = this.data) !== null && _this_data !== void 0 ? _this_data : [];
            }
        },
        {
            // @deprecated Please use `nextPageInfo()` instead
            /**
     * This page represents a response that isn't actually paginated at the API level
     * so there will never be any next page params.
     */ key: "nextPageParams",
            value: function nextPageParams() {
                return null;
            }
        },
        {
            key: "nextPageInfo",
            value: function nextPageInfo() {
                return null;
            }
        }
    ]);
    return Page;
}($c8Tp0.AbstractPage);
module.exports.Page = $345390e58d1d4d4f$var$Page;
var $345390e58d1d4d4f$var$CursorPage = /*#__PURE__*/ function(_core_1_AbstractPage) {
    (0, $iNfU4._)(CursorPage, _core_1_AbstractPage);
    var _super = (0, $k1NN5._)(CursorPage);
    function CursorPage(client, response, body, options) {
        (0, $19mwo._)(this, CursorPage);
        var _this;
        _this = _super.call(this, client, response, body, options);
        _this.data = body.data || [];
        return _this;
    }
    (0, $6rpfc._)(CursorPage, [
        {
            key: "getPaginatedItems",
            value: function getPaginatedItems() {
                var _this_data;
                return (_this_data = this.data) !== null && _this_data !== void 0 ? _this_data : [];
            }
        },
        {
            // @deprecated Please use `nextPageInfo()` instead
            key: "nextPageParams",
            value: function nextPageParams() {
                var info = this.nextPageInfo();
                if (!info) return null;
                if ("params" in info) return info.params;
                var params = Object.fromEntries(info.url.searchParams);
                if (!Object.keys(params).length) return null;
                return params;
            }
        },
        {
            key: "nextPageInfo",
            value: function nextPageInfo() {
                var _data_;
                var data = this.getPaginatedItems();
                if (!data.length) return null;
                var id = (_data_ = data[data.length - 1]) === null || _data_ === void 0 ? void 0 : _data_.id;
                if (!id) return null;
                return {
                    params: {
                        after: id
                    }
                };
            }
        }
    ]);
    return CursorPage;
}($c8Tp0.AbstractPage);
module.exports.CursorPage = $345390e58d1d4d4f$var$CursorPage;

});

parcelRegister("fQQlH", function(module, exports) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $b8a451be91976e66$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b8a451be91976e66$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b8a451be91976e66$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uploads = module.exports.Moderations = module.exports.Models = module.exports.ModelsPage = module.exports.Images = module.exports.FineTuning = module.exports.Files = module.exports.FileObjectsPage = module.exports.Embeddings = module.exports.Completions = module.exports.Beta = module.exports.Batches = module.exports.BatchesPage = module.exports.Audio = void 0;

$b8a451be91976e66$var$__exportStar((parcelRequire("6poys")), module.exports);

$b8a451be91976e66$var$__exportStar((parcelRequire("aJ1tC")), module.exports);

var $2q3b0 = parcelRequire("2q3b0");
Object.defineProperty(module.exports, "Audio", {
    enumerable: true,
    get: function get() {
        return $2q3b0.Audio;
    }
});

var $kypD9 = parcelRequire("kypD9");
Object.defineProperty(module.exports, "BatchesPage", {
    enumerable: true,
    get: function get() {
        return $kypD9.BatchesPage;
    }
});
Object.defineProperty(module.exports, "Batches", {
    enumerable: true,
    get: function get() {
        return $kypD9.Batches;
    }
});

var $52Zu9 = parcelRequire("52Zu9");
Object.defineProperty(module.exports, "Beta", {
    enumerable: true,
    get: function get() {
        return $52Zu9.Beta;
    }
});

var $gLhOS = parcelRequire("gLhOS");
Object.defineProperty(module.exports, "Completions", {
    enumerable: true,
    get: function get() {
        return $gLhOS.Completions;
    }
});

var $kIEUV = parcelRequire("kIEUV");
Object.defineProperty(module.exports, "Embeddings", {
    enumerable: true,
    get: function get() {
        return $kIEUV.Embeddings;
    }
});

var $6Lmf1 = parcelRequire("6Lmf1");
Object.defineProperty(module.exports, "FileObjectsPage", {
    enumerable: true,
    get: function get() {
        return $6Lmf1.FileObjectsPage;
    }
});
Object.defineProperty(module.exports, "Files", {
    enumerable: true,
    get: function get() {
        return $6Lmf1.Files;
    }
});

var $kfoQV = parcelRequire("kfoQV");
Object.defineProperty(module.exports, "FineTuning", {
    enumerable: true,
    get: function get() {
        return $kfoQV.FineTuning;
    }
});

var $3Vf7B = parcelRequire("3Vf7B");
Object.defineProperty(module.exports, "Images", {
    enumerable: true,
    get: function get() {
        return $3Vf7B.Images;
    }
});

var $kgOrA = parcelRequire("kgOrA");
Object.defineProperty(module.exports, "ModelsPage", {
    enumerable: true,
    get: function get() {
        return $kgOrA.ModelsPage;
    }
});
Object.defineProperty(module.exports, "Models", {
    enumerable: true,
    get: function get() {
        return $kgOrA.Models;
    }
});

var $4r7ux = parcelRequire("4r7ux");
Object.defineProperty(module.exports, "Moderations", {
    enumerable: true,
    get: function get() {
        return $4r7ux.Moderations;
    }
});

var $1Gy6w = parcelRequire("1Gy6w");
Object.defineProperty(module.exports, "Uploads", {
    enumerable: true,
    get: function get() {
        return $1Gy6w.Uploads;
    }
});

});
parcelRegister("6poys", function(module, exports) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chat = module.exports.Completions = void 0;

var $aI21Q = parcelRequire("aI21Q");
Object.defineProperty(module.exports, "Completions", {
    enumerable: true,
    get: function get() {
        return $aI21Q.Completions;
    }
});

var $ealMP = parcelRequire("ealMP");
Object.defineProperty(module.exports, "Chat", {
    enumerable: true,
    get: function get() {
        return $ealMP.Chat;
    }
});

});
parcelRegister("aI21Q", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Completions = void 0;

var $26X5G = parcelRequire("26X5G");
var $7cbf965363a3b7f5$var$Completions = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Completions, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Completions);
    function Completions() {
        (0, $19mwo._)(this, Completions);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Completions, [
        {
            key: "create",
            value: function create(body, options) {
                var _body_stream;
                return this._client.post("/chat/completions", (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    stream: (_body_stream = body.stream) !== null && _body_stream !== void 0 ? _body_stream : false
                }));
            }
        }
    ]);
    return Completions;
}($26X5G.APIResource);
module.exports.Completions = $7cbf965363a3b7f5$var$Completions;
$7cbf965363a3b7f5$var$Completions = module.exports.Completions || (module.exports.Completions = {});

});
parcelRegister("26X5G", function(module, exports) {

var $19mwo = parcelRequire("19mwo");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.APIResource = void 0;
var $1899fa8294f46efb$var$APIResource = function APIResource(client) {
    (0, $19mwo._)(this, APIResource);
    this._client = client;
};
module.exports.APIResource = $1899fa8294f46efb$var$APIResource;

});


parcelRegister("ealMP", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $iNfU4 = parcelRequire("iNfU4");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $a502e635eb3333e7$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a502e635eb3333e7$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a502e635eb3333e7$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a502e635eb3333e7$var$__createBinding(result, mod, k);
    }
    $a502e635eb3333e7$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chat = void 0;

var $26X5G = parcelRequire("26X5G");

var $a502e635eb3333e7$var$CompletionsAPI = $a502e635eb3333e7$var$__importStar((parcelRequire("aI21Q")));
var $a502e635eb3333e7$var$Chat = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Chat, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Chat);
    function Chat() {
        (0, $19mwo._)(this, Chat);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.completions = new $a502e635eb3333e7$var$CompletionsAPI.Completions(_this._client);
        return _this;
    }
    return Chat;
}($26X5G.APIResource);
module.exports.Chat = $a502e635eb3333e7$var$Chat;
(function(Chat) {
    Chat.Completions = $a502e635eb3333e7$var$CompletionsAPI.Completions;
})($a502e635eb3333e7$var$Chat = module.exports.Chat || (module.exports.Chat = {}));

});


parcelRegister("aJ1tC", function(module, exports) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2q3b0", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $iNfU4 = parcelRequire("iNfU4");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $1c307946ae708cbd$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1c307946ae708cbd$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1c307946ae708cbd$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1c307946ae708cbd$var$__createBinding(result, mod, k);
    }
    $1c307946ae708cbd$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Audio = void 0;

var $26X5G = parcelRequire("26X5G");

var $1c307946ae708cbd$var$SpeechAPI = $1c307946ae708cbd$var$__importStar((parcelRequire("hoY1o")));

var $1c307946ae708cbd$var$TranscriptionsAPI = $1c307946ae708cbd$var$__importStar((parcelRequire("gyt1f")));

var $1c307946ae708cbd$var$TranslationsAPI = $1c307946ae708cbd$var$__importStar((parcelRequire("GaERH")));
var $1c307946ae708cbd$var$Audio = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Audio, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Audio);
    function Audio() {
        (0, $19mwo._)(this, Audio);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.transcriptions = new $1c307946ae708cbd$var$TranscriptionsAPI.Transcriptions(_this._client);
        _this.translations = new $1c307946ae708cbd$var$TranslationsAPI.Translations(_this._client);
        _this.speech = new $1c307946ae708cbd$var$SpeechAPI.Speech(_this._client);
        return _this;
    }
    return Audio;
}($26X5G.APIResource);
module.exports.Audio = $1c307946ae708cbd$var$Audio;
(function(Audio) {
    Audio.Transcriptions = $1c307946ae708cbd$var$TranscriptionsAPI.Transcriptions;
    Audio.Translations = $1c307946ae708cbd$var$TranslationsAPI.Translations;
    Audio.Speech = $1c307946ae708cbd$var$SpeechAPI.Speech;
})($1c307946ae708cbd$var$Audio = module.exports.Audio || (module.exports.Audio = {}));

});
parcelRegister("hoY1o", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Speech = void 0;

var $26X5G = parcelRequire("26X5G");
var $cab33c950b61a441$var$Speech = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Speech, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Speech);
    function Speech() {
        (0, $19mwo._)(this, Speech);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Speech, [
        {
            /**
     * Generates audio from the input text.
     */ key: "create",
            value: function create(body, options) {
                return this._client.post("/audio/speech", (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    __binaryResponse: true
                }));
            }
        }
    ]);
    return Speech;
}($26X5G.APIResource);
module.exports.Speech = $cab33c950b61a441$var$Speech;
$cab33c950b61a441$var$Speech = module.exports.Speech || (module.exports.Speech = {});

});

parcelRegister("gyt1f", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $c0d654e82e112034$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c0d654e82e112034$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c0d654e82e112034$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c0d654e82e112034$var$__createBinding(result, mod, k);
    }
    $c0d654e82e112034$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transcriptions = void 0;

var $26X5G = parcelRequire("26X5G");

var $c0d654e82e112034$var$Core = $c0d654e82e112034$var$__importStar((parcelRequire("c8Tp0")));
var $c0d654e82e112034$var$Transcriptions = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Transcriptions, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Transcriptions);
    function Transcriptions() {
        (0, $19mwo._)(this, Transcriptions);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Transcriptions, [
        {
            /**
     * Transcribes audio into the input language.
     */ key: "create",
            value: function create(body, options) {
                return this._client.post("/audio/transcriptions", $c0d654e82e112034$var$Core.multipartFormRequestOptions((0, $78DQ7._)({
                    body: body
                }, options)));
            }
        }
    ]);
    return Transcriptions;
}($26X5G.APIResource);
module.exports.Transcriptions = $c0d654e82e112034$var$Transcriptions;
$c0d654e82e112034$var$Transcriptions = module.exports.Transcriptions || (module.exports.Transcriptions = {});

});

parcelRegister("GaERH", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $07ec30d67b1f5be9$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $07ec30d67b1f5be9$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $07ec30d67b1f5be9$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $07ec30d67b1f5be9$var$__createBinding(result, mod, k);
    }
    $07ec30d67b1f5be9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Translations = void 0;

var $26X5G = parcelRequire("26X5G");

var $07ec30d67b1f5be9$var$Core = $07ec30d67b1f5be9$var$__importStar((parcelRequire("c8Tp0")));
var $07ec30d67b1f5be9$var$Translations = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Translations, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Translations);
    function Translations() {
        (0, $19mwo._)(this, Translations);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Translations, [
        {
            /**
     * Translates audio into English.
     */ key: "create",
            value: function create(body, options) {
                return this._client.post("/audio/translations", $07ec30d67b1f5be9$var$Core.multipartFormRequestOptions((0, $78DQ7._)({
                    body: body
                }, options)));
            }
        }
    ]);
    return Translations;
}($26X5G.APIResource);
module.exports.Translations = $07ec30d67b1f5be9$var$Translations;
$07ec30d67b1f5be9$var$Translations = module.exports.Translations || (module.exports.Translations = {});

});


parcelRegister("kypD9", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $ef6add4f7d4cdc66$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ef6add4f7d4cdc66$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ef6add4f7d4cdc66$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ef6add4f7d4cdc66$var$__createBinding(result, mod, k);
    }
    $ef6add4f7d4cdc66$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BatchesPage = module.exports.Batches = void 0;

var $26X5G = parcelRequire("26X5G");

var $c8Tp0 = parcelRequire("c8Tp0");

var $ef6add4f7d4cdc66$var$BatchesAPI = $ef6add4f7d4cdc66$var$__importStar(module.exports);

var $4ux0n = parcelRequire("4ux0n");
var $ef6add4f7d4cdc66$var$Batches = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Batches, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Batches);
    function Batches() {
        (0, $19mwo._)(this, Batches);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Batches, [
        {
            /**
     * Creates and executes a batch from an uploaded file of requests
     */ key: "create",
            value: function create(body, options) {
                return this._client.post("/batches", (0, $78DQ7._)({
                    body: body
                }, options));
            }
        },
        {
            /**
     * Retrieves a batch.
     */ key: "retrieve",
            value: function retrieve(batchId, options) {
                return this._client.get("/batches/".concat(batchId), options);
            }
        },
        {
            key: "list",
            value: function list() {
                var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, options = arguments.length > 1 ? arguments[1] : void 0;
                if ((0, $c8Tp0.isRequestOptions)(query)) return this.list({}, query);
                return this._client.getAPIList("/batches", $ef6add4f7d4cdc66$var$BatchesPage, (0, $78DQ7._)({
                    query: query
                }, options));
            }
        },
        {
            /**
     * Cancels an in-progress batch. The batch will be in status `cancelling` for up to
     * 10 minutes, before changing to `cancelled`, where it will have partial results
     * (if any) available in the output file.
     */ key: "cancel",
            value: function cancel(batchId, options) {
                return this._client.post("/batches/".concat(batchId, "/cancel"), options);
            }
        }
    ]);
    return Batches;
}($26X5G.APIResource);
module.exports.Batches = $ef6add4f7d4cdc66$var$Batches;
var $ef6add4f7d4cdc66$var$BatchesPage = /*#__PURE__*/ function(_pagination_1_CursorPage) {
    (0, $iNfU4._)(BatchesPage, _pagination_1_CursorPage);
    var _super = (0, $k1NN5._)(BatchesPage);
    function BatchesPage() {
        (0, $19mwo._)(this, BatchesPage);
        return _super.apply(this, arguments);
    }
    return BatchesPage;
}($4ux0n.CursorPage);
module.exports.BatchesPage = $ef6add4f7d4cdc66$var$BatchesPage;
(function(Batches) {
    Batches.BatchesPage = $ef6add4f7d4cdc66$var$BatchesAPI.BatchesPage;
})($ef6add4f7d4cdc66$var$Batches = module.exports.Batches || (module.exports.Batches = {}));

});

parcelRegister("52Zu9", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $iNfU4 = parcelRequire("iNfU4");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $3accd559170e344c$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3accd559170e344c$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3accd559170e344c$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3accd559170e344c$var$__createBinding(result, mod, k);
    }
    $3accd559170e344c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Beta = void 0;

var $26X5G = parcelRequire("26X5G");

var $3accd559170e344c$var$AssistantsAPI = $3accd559170e344c$var$__importStar((parcelRequire("bg1lW")));

var $3accd559170e344c$var$ChatAPI = $3accd559170e344c$var$__importStar((parcelRequire("hVmid")));

var $3accd559170e344c$var$ThreadsAPI = $3accd559170e344c$var$__importStar((parcelRequire("3OOAu")));

var $3accd559170e344c$var$VectorStoresAPI = $3accd559170e344c$var$__importStar((parcelRequire("j1skS")));
var $3accd559170e344c$var$Beta = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Beta, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Beta);
    function Beta() {
        (0, $19mwo._)(this, Beta);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.vectorStores = new $3accd559170e344c$var$VectorStoresAPI.VectorStores(_this._client);
        _this.chat = new $3accd559170e344c$var$ChatAPI.Chat(_this._client);
        _this.assistants = new $3accd559170e344c$var$AssistantsAPI.Assistants(_this._client);
        _this.threads = new $3accd559170e344c$var$ThreadsAPI.Threads(_this._client);
        return _this;
    }
    return Beta;
}($26X5G.APIResource);
module.exports.Beta = $3accd559170e344c$var$Beta;
(function(Beta) {
    Beta.VectorStores = $3accd559170e344c$var$VectorStoresAPI.VectorStores;
    Beta.VectorStoresPage = $3accd559170e344c$var$VectorStoresAPI.VectorStoresPage;
    Beta.Chat = $3accd559170e344c$var$ChatAPI.Chat;
    Beta.Assistants = $3accd559170e344c$var$AssistantsAPI.Assistants;
    Beta.AssistantsPage = $3accd559170e344c$var$AssistantsAPI.AssistantsPage;
    Beta.Threads = $3accd559170e344c$var$ThreadsAPI.Threads;
})($3accd559170e344c$var$Beta = module.exports.Beta || (module.exports.Beta = {}));

});
parcelRegister("bg1lW", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $83223cfb73f1d453$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $83223cfb73f1d453$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $83223cfb73f1d453$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $83223cfb73f1d453$var$__createBinding(result, mod, k);
    }
    $83223cfb73f1d453$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AssistantsPage = module.exports.Assistants = void 0;

var $26X5G = parcelRequire("26X5G");

var $c8Tp0 = parcelRequire("c8Tp0");

var $83223cfb73f1d453$var$AssistantsAPI = $83223cfb73f1d453$var$__importStar(module.exports);

var $4ux0n = parcelRequire("4ux0n");
var $83223cfb73f1d453$var$Assistants = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Assistants, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Assistants);
    function Assistants() {
        (0, $19mwo._)(this, Assistants);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Assistants, [
        {
            /**
     * Create an assistant with a model and instructions.
     */ key: "create",
            value: function create(body, options) {
                return this._client.post("/assistants", (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Retrieves an assistant.
     */ key: "retrieve",
            value: function retrieve(assistantId, options) {
                return this._client.get("/assistants/".concat(assistantId), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Modifies an assistant.
     */ key: "update",
            value: function update(assistantId, body, options) {
                return this._client.post("/assistants/".concat(assistantId), (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            key: "list",
            value: function list() {
                var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, options = arguments.length > 1 ? arguments[1] : void 0;
                if ((0, $c8Tp0.isRequestOptions)(query)) return this.list({}, query);
                return this._client.getAPIList("/assistants", $83223cfb73f1d453$var$AssistantsPage, (0, $ddevm._)((0, $78DQ7._)({
                    query: query
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Delete an assistant.
     */ key: "del",
            value: function del(assistantId, options) {
                return this._client.delete("/assistants/".concat(assistantId), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        }
    ]);
    return Assistants;
}($26X5G.APIResource);
module.exports.Assistants = $83223cfb73f1d453$var$Assistants;
var $83223cfb73f1d453$var$AssistantsPage = /*#__PURE__*/ function(_pagination_1_CursorPage) {
    (0, $iNfU4._)(AssistantsPage, _pagination_1_CursorPage);
    var _super = (0, $k1NN5._)(AssistantsPage);
    function AssistantsPage() {
        (0, $19mwo._)(this, AssistantsPage);
        return _super.apply(this, arguments);
    }
    return AssistantsPage;
}($4ux0n.CursorPage);
module.exports.AssistantsPage = $83223cfb73f1d453$var$AssistantsPage;
(function(Assistants) {
    Assistants.AssistantsPage = $83223cfb73f1d453$var$AssistantsAPI.AssistantsPage;
})($83223cfb73f1d453$var$Assistants = module.exports.Assistants || (module.exports.Assistants = {}));

});

parcelRegister("hVmid", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $iNfU4 = parcelRequire("iNfU4");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $d0c90d71d8aed9be$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d0c90d71d8aed9be$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d0c90d71d8aed9be$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d0c90d71d8aed9be$var$__createBinding(result, mod, k);
    }
    $d0c90d71d8aed9be$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chat = void 0;

var $26X5G = parcelRequire("26X5G");

var $d0c90d71d8aed9be$var$CompletionsAPI = $d0c90d71d8aed9be$var$__importStar((parcelRequire("hDYmQ")));
var $d0c90d71d8aed9be$var$Chat = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Chat, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Chat);
    function Chat() {
        (0, $19mwo._)(this, Chat);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.completions = new $d0c90d71d8aed9be$var$CompletionsAPI.Completions(_this._client);
        return _this;
    }
    return Chat;
}($26X5G.APIResource);
module.exports.Chat = $d0c90d71d8aed9be$var$Chat;
(function(Chat) {
    Chat.Completions = $d0c90d71d8aed9be$var$CompletionsAPI.Completions;
})($d0c90d71d8aed9be$var$Chat = module.exports.Chat || (module.exports.Chat = {}));

});
parcelRegister("hDYmQ", function(module, exports) {

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Completions = module.exports.ChatCompletionStream = module.exports.ParsingToolFunction = module.exports.ParsingFunction = module.exports.ChatCompletionStreamingRunner = module.exports.ChatCompletionRunner = void 0;

var $26X5G = parcelRequire("26X5G");

var $5xi0f = parcelRequire("5xi0f");

var $5xi0f = parcelRequire("5xi0f");
Object.defineProperty(module.exports, "ChatCompletionRunner", {
    enumerable: true,
    get: function get() {
        return $5xi0f.ChatCompletionRunner;
    }
});

var $8bbhJ = parcelRequire("8bbhJ");

var $8bbhJ = parcelRequire("8bbhJ");
Object.defineProperty(module.exports, "ChatCompletionStreamingRunner", {
    enumerable: true,
    get: function get() {
        return $8bbhJ.ChatCompletionStreamingRunner;
    }
});

var $2XNub = parcelRequire("2XNub");
Object.defineProperty(module.exports, "ParsingFunction", {
    enumerable: true,
    get: function get() {
        return $2XNub.ParsingFunction;
    }
});
Object.defineProperty(module.exports, "ParsingToolFunction", {
    enumerable: true,
    get: function get() {
        return $2XNub.ParsingToolFunction;
    }
});

var $9TkpA = parcelRequire("9TkpA");

var $29whI = parcelRequire("29whI");

var $9TkpA = parcelRequire("9TkpA");
Object.defineProperty(module.exports, "ChatCompletionStream", {
    enumerable: true,
    get: function get() {
        return $9TkpA.ChatCompletionStream;
    }
});
var $cd84e7ecefdcd091$var$Completions = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Completions, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Completions);
    function Completions() {
        (0, $19mwo._)(this, Completions);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Completions, [
        {
            key: "parse",
            value: function parse(body, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var completion;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $29whI.validateInputTools)(body.tools);
                                return [
                                    4,
                                    _this._client.chat.completions.create(body, (0, $ddevm._)((0, $78DQ7._)({}, options), {
                                        headers: (0, $ddevm._)((0, $78DQ7._)({}, options === null || options === void 0 ? void 0 : options.headers), {
                                            "X-Stainless-Helper-Method": "beta.chat.completions.parse"
                                        })
                                    }))
                                ];
                            case 1:
                                completion = _state.sent();
                                return [
                                    2,
                                    (0, $29whI.parseChatCompletion)(completion, body)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "runFunctions",
            value: function runFunctions(body, options) {
                if (body.stream) return $8bbhJ.ChatCompletionStreamingRunner.runFunctions(this._client, body, options);
                return $5xi0f.ChatCompletionRunner.runFunctions(this._client, body, options);
            }
        },
        {
            key: "runTools",
            value: function runTools(body, options) {
                if (body.stream) return $8bbhJ.ChatCompletionStreamingRunner.runTools(this._client, body, options);
                return $5xi0f.ChatCompletionRunner.runTools(this._client, body, options);
            }
        },
        {
            /**
     * Creates a chat completion stream
     */ key: "stream",
            value: function stream(body, options) {
                return $9TkpA.ChatCompletionStream.createChatCompletion(this._client, body, options);
            }
        }
    ]);
    return Completions;
}($26X5G.APIResource);
module.exports.Completions = $cd84e7ecefdcd091$var$Completions;

});
parcelRegister("5xi0f", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $jLCbM = parcelRequire("jLCbM");

var $laF8D = parcelRequire("laF8D");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChatCompletionRunner = void 0;

var $l7ElV = parcelRequire("l7ElV");

var $ZAb8y = parcelRequire("ZAb8y");
var $407dffd81721417c$var$ChatCompletionRunner = /*#__PURE__*/ function(_AbstractChatCompletionRunner_1_AbstractChatCompletionRunner) {
    (0, $iNfU4._)(ChatCompletionRunner, _AbstractChatCompletionRunner_1_AbstractChatCompletionRunner);
    var _super = (0, $k1NN5._)(ChatCompletionRunner);
    function ChatCompletionRunner() {
        (0, $19mwo._)(this, ChatCompletionRunner);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ChatCompletionRunner, [
        {
            key: "_addMessage",
            value: function _addMessage(message) {
                (0, $jLCbM._)((0, $laF8D._)(ChatCompletionRunner.prototype), "_addMessage", this).call(this, message);
                if ((0, $ZAb8y.isAssistantMessage)(message) && message.content) this._emit("content", message.content);
            }
        }
    ], [
        {
            key: "runFunctions",
            value: /** @deprecated - please use `runTools` instead. */ function runFunctions(client, params, options) {
                var runner = new ChatCompletionRunner();
                var opts = (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $ddevm._)((0, $78DQ7._)({}, options === null || options === void 0 ? void 0 : options.headers), {
                        "X-Stainless-Helper-Method": "runFunctions"
                    })
                });
                runner._run(function() {
                    return runner._runFunctions(client, params, opts);
                });
                return runner;
            }
        },
        {
            key: "runTools",
            value: function runTools(client, params, options) {
                var runner = new ChatCompletionRunner();
                var opts = (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $ddevm._)((0, $78DQ7._)({}, options === null || options === void 0 ? void 0 : options.headers), {
                        "X-Stainless-Helper-Method": "runTools"
                    })
                });
                runner._run(function() {
                    return runner._runTools(client, params, opts);
                });
                return runner;
            }
        }
    ]);
    return ChatCompletionRunner;
}($l7ElV.AbstractChatCompletionRunner);
module.exports.ChatCompletionRunner = $407dffd81721417c$var$ChatCompletionRunner;

});
parcelRegister("l7ElV", function(module, exports) {

var $15Pju = parcelRequire("15Pju");

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $3jzhD = parcelRequire("3jzhD");

var $gnDeW = parcelRequire("gnDeW");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");
"use strict";
var $f6098d988bc5aa67$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalContent, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalMessage, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalFunctionCall, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalFunctionCallResult, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_calculateTotalUsage, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_validateParams, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_stringifyFunctionCallResult;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractChatCompletionRunner = void 0;

var $kQ0uC = parcelRequire("kQ0uC");

var $2XNub = parcelRequire("2XNub");

var $ZAb8y = parcelRequire("ZAb8y");

var $3RnC6 = parcelRequire("3RnC6");

var $29whI = parcelRequire("29whI");
var $f6098d988bc5aa67$var$DEFAULT_MAX_CHAT_COMPLETIONS = 10;
var $f6098d988bc5aa67$var$AbstractChatCompletionRunner = /*#__PURE__*/ function(_EventStream_1_EventStream) {
    (0, $iNfU4._)(AbstractChatCompletionRunner, _EventStream_1_EventStream);
    var _super = (0, $k1NN5._)(AbstractChatCompletionRunner);
    function AbstractChatCompletionRunner() {
        (0, $19mwo._)(this, AbstractChatCompletionRunner);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances.add((0, $15Pju._)(_this));
        _this._chatCompletions = [];
        _this.messages = [];
        return _this;
    }
    (0, $6rpfc._)(AbstractChatCompletionRunner, [
        {
            key: "_addChatCompletion",
            value: function _addChatCompletion(chatCompletion) {
                var _chatCompletion_choices_;
                this._chatCompletions.push(chatCompletion);
                this._emit("chatCompletion", chatCompletion);
                var message = (_chatCompletion_choices_ = chatCompletion.choices[0]) === null || _chatCompletion_choices_ === void 0 ? void 0 : _chatCompletion_choices_.message;
                if (message) this._addMessage(message);
                return chatCompletion;
            }
        },
        {
            key: "_addMessage",
            value: function _addMessage(message) {
                var emit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                if (!("content" in message)) message.content = null;
                this.messages.push(message);
                if (emit) {
                    this._emit("message", message);
                    if (((0, $ZAb8y.isFunctionMessage)(message) || (0, $ZAb8y.isToolMessage)(message)) && message.content) // Note, this assumes that {role: 'tool', content: …} is always the result of a call of tool of type=function.
                    this._emit("functionCallResult", message.content);
                    else if ((0, $ZAb8y.isAssistantMessage)(message) && message.function_call) this._emit("functionCall", message.function_call);
                    else if ((0, $ZAb8y.isAssistantMessage)(message) && message.tool_calls) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = message.tool_calls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var tool_call = _step.value;
                                if (tool_call.type === "function") this._emit("functionCall", tool_call.function);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                }
            }
        },
        {
            key: "finalChatCompletion",
            value: /**
     * @returns a promise that resolves with the final ChatCompletion, or rejects
     * if an error occurred or the stream ended prematurely without producing a ChatCompletion.
     */ function finalChatCompletion() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var completion;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.done()
                                ];
                            case 1:
                                _state.sent();
                                completion = _this._chatCompletions[_this._chatCompletions.length - 1];
                                if (!completion) throw new $kQ0uC.OpenAIError("stream ended without producing a ChatCompletion");
                                return [
                                    2,
                                    completion
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "finalContent",
            value: /**
     * @returns a promise that resolves with the content of the final ChatCompletionMessage, or rejects
     * if an error occurred or the stream ended prematurely without producing a ChatCompletionMessage.
     */ function finalContent() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.done()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    $f6098d988bc5aa67$var$__classPrivateFieldGet(_this, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances, "m", $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalContent).call(_this)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "finalMessage",
            value: /**
     * @returns a promise that resolves with the the final assistant ChatCompletionMessage response,
     * or rejects if an error occurred or the stream ended prematurely without producing a ChatCompletionMessage.
     */ function finalMessage() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.done()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    $f6098d988bc5aa67$var$__classPrivateFieldGet(_this, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances, "m", $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalMessage).call(_this)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "finalFunctionCall",
            value: /**
     * @returns a promise that resolves with the content of the final FunctionCall, or rejects
     * if an error occurred or the stream ended prematurely without producing a ChatCompletionMessage.
     */ function finalFunctionCall() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.done()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    $f6098d988bc5aa67$var$__classPrivateFieldGet(_this, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances, "m", $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalFunctionCall).call(_this)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "finalFunctionCallResult",
            value: function finalFunctionCallResult() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.done()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    $f6098d988bc5aa67$var$__classPrivateFieldGet(_this, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances, "m", $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalFunctionCallResult).call(_this)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "totalUsage",
            value: function totalUsage() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.done()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    $f6098d988bc5aa67$var$__classPrivateFieldGet(_this, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances, "m", $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_calculateTotalUsage).call(_this)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "allChatCompletions",
            value: function allChatCompletions() {
                return (0, $3jzhD._)(this._chatCompletions);
            }
        },
        {
            key: "_emitFinal",
            value: function _emitFinal() {
                var completion = this._chatCompletions[this._chatCompletions.length - 1];
                if (completion) this._emit("finalChatCompletion", completion);
                var finalMessage = $f6098d988bc5aa67$var$__classPrivateFieldGet(this, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances, "m", $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalMessage).call(this);
                if (finalMessage) this._emit("finalMessage", finalMessage);
                var finalContent = $f6098d988bc5aa67$var$__classPrivateFieldGet(this, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances, "m", $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalContent).call(this);
                if (finalContent) this._emit("finalContent", finalContent);
                var finalFunctionCall = $f6098d988bc5aa67$var$__classPrivateFieldGet(this, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances, "m", $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalFunctionCall).call(this);
                if (finalFunctionCall) this._emit("finalFunctionCall", finalFunctionCall);
                var finalFunctionCallResult = $f6098d988bc5aa67$var$__classPrivateFieldGet(this, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances, "m", $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalFunctionCallResult).call(this);
                if (finalFunctionCallResult != null) this._emit("finalFunctionCallResult", finalFunctionCallResult);
                if (this._chatCompletions.some(function(c) {
                    return c.usage;
                })) this._emit("totalUsage", $f6098d988bc5aa67$var$__classPrivateFieldGet(this, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances, "m", $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_calculateTotalUsage).call(this));
            }
        },
        {
            key: "_createChatCompletion",
            value: function _createChatCompletion(client, params, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var signal, chatCompletion;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                signal = options === null || options === void 0 ? void 0 : options.signal;
                                if (signal) {
                                    if (signal.aborted) _this.controller.abort();
                                    signal.addEventListener("abort", function() {
                                        return _this.controller.abort();
                                    });
                                }
                                $f6098d988bc5aa67$var$__classPrivateFieldGet(_this, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances, "m", $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_validateParams).call(_this, params);
                                return [
                                    4,
                                    client.chat.completions.create((0, $ddevm._)((0, $78DQ7._)({}, params), {
                                        stream: false
                                    }), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                                        signal: _this.controller.signal
                                    }))
                                ];
                            case 1:
                                chatCompletion = _state.sent();
                                _this._connected();
                                return [
                                    2,
                                    _this._addChatCompletion((0, $29whI.parseChatCompletion)(chatCompletion, params))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_runChatCompletion",
            value: function _runChatCompletion(client, params, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, message;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = params.messages[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        message = _step.value;
                                        _this._addMessage(message, false);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return [
                                    4,
                                    _this._createChatCompletion(client, params, options)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_runFunctions",
            value: function _runFunctions(client, params, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var role, _params_function_call, function_call, stream, restParams, singleFunctionToCall, _ref, _ref_maxChatCompletions, maxChatCompletions, functionsByName, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, f, functions, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, message, i, _chatCompletion_choices_, chatCompletion, message1, _message_function_call, name, args, fn, content, content1, parsed, _tmp, error, rawContent, content2;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                role = "function";
                                _params_function_call = params.function_call, function_call = _params_function_call === void 0 ? "auto" : _params_function_call, stream = params.stream, restParams = (0, $6JqHh._)(params, [
                                    "function_call",
                                    "stream"
                                ]);
                                singleFunctionToCall = typeof function_call !== "string" && (function_call === null || function_call === void 0 ? void 0 : function_call.name);
                                _ref = options || {}, _ref_maxChatCompletions = _ref.maxChatCompletions, maxChatCompletions = _ref_maxChatCompletions === void 0 ? $f6098d988bc5aa67$var$DEFAULT_MAX_CHAT_COMPLETIONS : _ref_maxChatCompletions;
                                functionsByName = {};
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = params.functions[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        f = _step.value;
                                        functionsByName[f.name || f.function.name] = f;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                functions = params.functions.map(function(f) {
                                    return {
                                        name: f.name || f.function.name,
                                        parameters: f.parameters,
                                        description: f.description
                                    };
                                });
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = params.messages[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        message = _step1.value;
                                        _this._addMessage(message, false);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                i = 0;
                                _state.label = 1;
                            case 1:
                                if (!(i < maxChatCompletions)) return [
                                    3,
                                    11
                                ];
                                return [
                                    4,
                                    _this._createChatCompletion(client, (0, $ddevm._)((0, $78DQ7._)({}, restParams), {
                                        function_call: function_call,
                                        functions: functions,
                                        messages: (0, $3jzhD._)(_this.messages)
                                    }), options)
                                ];
                            case 2:
                                chatCompletion = _state.sent();
                                message1 = (_chatCompletion_choices_ = chatCompletion.choices[0]) === null || _chatCompletion_choices_ === void 0 ? void 0 : _chatCompletion_choices_.message;
                                if (!message1) throw new $kQ0uC.OpenAIError("missing message in ChatCompletion response");
                                if (!message1.function_call) return [
                                    2
                                ];
                                _message_function_call = message1.function_call, name = _message_function_call.name, args = _message_function_call.arguments;
                                fn = functionsByName[name];
                                if (!fn) {
                                    content = "Invalid function_call: ".concat(JSON.stringify(name), ". Available options are: ").concat(functions.map(function(f) {
                                        return JSON.stringify(f.name);
                                    }).join(", "), ". Please try again");
                                    _this._addMessage({
                                        role: role,
                                        name: name,
                                        content: content
                                    });
                                    return [
                                        3,
                                        10
                                    ];
                                } else if (singleFunctionToCall && singleFunctionToCall !== name) {
                                    content1 = "Invalid function_call: ".concat(JSON.stringify(name), ". ").concat(JSON.stringify(singleFunctionToCall), " requested. Please try again");
                                    _this._addMessage({
                                        role: role,
                                        name: name,
                                        content: content1
                                    });
                                    return [
                                        3,
                                        10
                                    ];
                                }
                                parsed = void 0;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    7,
                                    ,
                                    8
                                ]);
                                if (!(0, $2XNub.isRunnableFunctionWithParse)(fn)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    fn.parse(args)
                                ];
                            case 4:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _tmp = args;
                                _state.label = 6;
                            case 6:
                                parsed = _tmp;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                error = _state.sent();
                                _this._addMessage({
                                    role: role,
                                    name: name,
                                    content: error instanceof Error ? error.message : String(error)
                                });
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                return [
                                    4,
                                    fn.function(parsed, _this)
                                ];
                            case 9:
                                rawContent = _state.sent();
                                content2 = $f6098d988bc5aa67$var$__classPrivateFieldGet(_this, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances, "m", $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_stringifyFunctionCallResult).call(_this, rawContent);
                                _this._addMessage({
                                    role: role,
                                    name: name,
                                    content: content2
                                });
                                if (singleFunctionToCall) return [
                                    2
                                ];
                                _state.label = 10;
                            case 10:
                                ++i;
                                return [
                                    3,
                                    1
                                ];
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_runTools",
            value: function _runTools(client, params, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _tool_choice_function, role, _params_tool_choice, tool_choice, stream, restParams, singleFunctionToCall, _ref, _ref_maxChatCompletions, maxChatCompletions, inputTools, functionsByName, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, f, tools, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, message, i, _chatCompletion_choices_, _message_tool_calls, chatCompletion, message1, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, tool_call, tool_call_id, _tool_call_function, name, args, fn, content, content1, parsed, _tmp, error, content2, rawContent, content3, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                role = "tool";
                                _params_tool_choice = params.tool_choice, tool_choice = _params_tool_choice === void 0 ? "auto" : _params_tool_choice, stream = params.stream, restParams = (0, $6JqHh._)(params, [
                                    "tool_choice",
                                    "stream"
                                ]);
                                singleFunctionToCall = typeof tool_choice !== "string" && (tool_choice === null || tool_choice === void 0 ? void 0 : (_tool_choice_function = tool_choice.function) === null || _tool_choice_function === void 0 ? void 0 : _tool_choice_function.name);
                                _ref = options || {}, _ref_maxChatCompletions = _ref.maxChatCompletions, maxChatCompletions = _ref_maxChatCompletions === void 0 ? $f6098d988bc5aa67$var$DEFAULT_MAX_CHAT_COMPLETIONS : _ref_maxChatCompletions;
                                // TODO(someday): clean this logic up
                                inputTools = params.tools.map(function(tool) {
                                    if ((0, $29whI.isAutoParsableTool)(tool)) {
                                        if (!tool.$callback) throw new $kQ0uC.OpenAIError("Tool given to `.runTools()` that does not have an associated function");
                                        return {
                                            type: "function",
                                            function: {
                                                function: tool.$callback,
                                                name: tool.function.name,
                                                description: tool.function.description || "",
                                                parameters: tool.function.parameters,
                                                parse: tool.$parseRaw,
                                                strict: true
                                            }
                                        };
                                    }
                                    return tool;
                                });
                                functionsByName = {};
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = inputTools[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        f = _step.value;
                                        if (f.type === "function") functionsByName[f.function.name || f.function.function.name] = f.function;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                tools = "tools" in params ? inputTools.map(function(t) {
                                    return t.type === "function" ? {
                                        type: "function",
                                        function: {
                                            name: t.function.name || t.function.function.name,
                                            parameters: t.function.parameters,
                                            description: t.function.description,
                                            strict: t.function.strict
                                        }
                                    } : t;
                                }) : undefined;
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = params.messages[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        message = _step1.value;
                                        _this._addMessage(message, false);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                i = 0;
                                _state.label = 1;
                            case 1:
                                if (!(i < maxChatCompletions)) return [
                                    3,
                                    17
                                ];
                                return [
                                    4,
                                    _this._createChatCompletion(client, (0, $ddevm._)((0, $78DQ7._)({}, restParams), {
                                        tool_choice: tool_choice,
                                        tools: tools,
                                        messages: (0, $3jzhD._)(_this.messages)
                                    }), options)
                                ];
                            case 2:
                                chatCompletion = _state.sent();
                                message1 = (_chatCompletion_choices_ = chatCompletion.choices[0]) === null || _chatCompletion_choices_ === void 0 ? void 0 : _chatCompletion_choices_.message;
                                if (!message1) throw new $kQ0uC.OpenAIError("missing message in ChatCompletion response");
                                if (!((_message_tool_calls = message1.tool_calls) === null || _message_tool_calls === void 0 ? void 0 : _message_tool_calls.length)) return [
                                    2
                                ];
                                _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    14,
                                    15,
                                    16
                                ]);
                                _iterator2 = message1.tool_calls[Symbol.iterator]();
                                _state.label = 4;
                            case 4:
                                if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                                    3,
                                    13
                                ];
                                tool_call = _step2.value;
                                if (tool_call.type !== "function") return [
                                    3,
                                    12
                                ];
                                tool_call_id = tool_call.id;
                                _tool_call_function = tool_call.function, name = _tool_call_function.name, args = _tool_call_function.arguments;
                                fn = functionsByName[name];
                                if (!fn) {
                                    content = "Invalid tool_call: ".concat(JSON.stringify(name), ". Available options are: ").concat(Object.keys(functionsByName).map(function(name) {
                                        return JSON.stringify(name);
                                    }).join(", "), ". Please try again");
                                    _this._addMessage({
                                        role: role,
                                        tool_call_id: tool_call_id,
                                        content: content
                                    });
                                    return [
                                        3,
                                        12
                                    ];
                                } else if (singleFunctionToCall && singleFunctionToCall !== name) {
                                    content1 = "Invalid tool_call: ".concat(JSON.stringify(name), ". ").concat(JSON.stringify(singleFunctionToCall), " requested. Please try again");
                                    _this._addMessage({
                                        role: role,
                                        tool_call_id: tool_call_id,
                                        content: content1
                                    });
                                    return [
                                        3,
                                        12
                                    ];
                                }
                                parsed = void 0;
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    9,
                                    ,
                                    10
                                ]);
                                if (!(0, $2XNub.isRunnableFunctionWithParse)(fn)) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    fn.parse(args)
                                ];
                            case 6:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                _tmp = args;
                                _state.label = 8;
                            case 8:
                                parsed = _tmp;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                error = _state.sent();
                                content2 = error instanceof Error ? error.message : String(error);
                                _this._addMessage({
                                    role: role,
                                    tool_call_id: tool_call_id,
                                    content: content2
                                });
                                return [
                                    3,
                                    12
                                ];
                            case 10:
                                return [
                                    4,
                                    fn.function(parsed, _this)
                                ];
                            case 11:
                                rawContent = _state.sent();
                                content3 = $f6098d988bc5aa67$var$__classPrivateFieldGet(_this, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances, "m", $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_stringifyFunctionCallResult).call(_this, rawContent);
                                _this._addMessage({
                                    role: role,
                                    tool_call_id: tool_call_id,
                                    content: content3
                                });
                                if (singleFunctionToCall) return [
                                    2
                                ];
                                _state.label = 12;
                            case 12:
                                _iteratorNormalCompletion2 = true;
                                return [
                                    3,
                                    4
                                ];
                            case 13:
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err = _state.sent();
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 16:
                                ++i;
                                return [
                                    3,
                                    1
                                ];
                            case 17:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AbstractChatCompletionRunner;
}($3RnC6.EventStream);
module.exports.AbstractChatCompletionRunner = $f6098d988bc5aa67$var$AbstractChatCompletionRunner;
var $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalMessage1;
$f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances = new WeakSet(), $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalContent = function _AbstractChatCompletionRunner_getFinalContent() {
    var __classPrivateFieldGet_call_content;
    return (__classPrivateFieldGet_call_content = $f6098d988bc5aa67$var$__classPrivateFieldGet(this, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_instances, "m", $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalMessage).call(this).content) !== null && __classPrivateFieldGet_call_content !== void 0 ? __classPrivateFieldGet_call_content : null;
}, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalMessage1 = function _AbstractChatCompletionRunner_getFinalMessage() {
    var i = this.messages.length;
    while(i-- > 0){
        var message = this.messages[i];
        if ((0, $ZAb8y.isAssistantMessage)(message)) {
            var function_call = message.function_call, rest = (0, $6JqHh._)(message, [
                "function_call"
            ]);
            var _message_content, _message_refusal;
            var ret = (0, $ddevm._)((0, $78DQ7._)({}, rest), {
                content: (_message_content = message.content) !== null && _message_content !== void 0 ? _message_content : null,
                refusal: (_message_refusal = message.refusal) !== null && _message_refusal !== void 0 ? _message_refusal : null
            });
            if (function_call) ret.function_call = function_call;
            return ret;
        }
    }
    throw new $kQ0uC.OpenAIError("stream ended without producing a ChatCompletionMessage with role=assistant");
}, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalMessage = $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalMessage1, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalMessage1, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalFunctionCall = function _AbstractChatCompletionRunner_getFinalFunctionCall() {
    for(var i = this.messages.length - 1; i >= 0; i--){
        var _message_tool_calls, _message_tool_calls_at;
        var message = this.messages[i];
        if ((0, $ZAb8y.isAssistantMessage)(message) && (message === null || message === void 0 ? void 0 : message.function_call)) return message.function_call;
        if ((0, $ZAb8y.isAssistantMessage)(message) && (message === null || message === void 0 ? void 0 : (_message_tool_calls = message.tool_calls) === null || _message_tool_calls === void 0 ? void 0 : _message_tool_calls.length)) return (_message_tool_calls_at = message.tool_calls.at(-1)) === null || _message_tool_calls_at === void 0 ? void 0 : _message_tool_calls_at.function;
    }
    return;
}, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_getFinalFunctionCallResult = function _AbstractChatCompletionRunner_getFinalFunctionCallResult() {
    var _this = this, _loop = function(i) {
        var message = _this.messages[i];
        if ((0, $ZAb8y.isFunctionMessage)(message) && message.content != null) return {
            v: message.content
        };
        if ((0, $ZAb8y.isToolMessage)(message) && message.content != null && typeof message.content === "string" && _this.messages.some(function(x) {
            var _x_tool_calls;
            return x.role === "assistant" && ((_x_tool_calls = x.tool_calls) === null || _x_tool_calls === void 0 ? void 0 : _x_tool_calls.some(function(y) {
                return y.type === "function" && y.id === message.tool_call_id;
            }));
        })) return {
            v: message.content
        };
    };
    for(var i = this.messages.length - 1; i >= 0; i--){
        var _ret = _loop(i);
        if ((0, $gnDeW._)(_ret) === "object") return _ret.v;
    }
    return;
}, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_calculateTotalUsage = function _AbstractChatCompletionRunner_calculateTotalUsage() {
    var total = {
        completion_tokens: 0,
        prompt_tokens: 0,
        total_tokens: 0
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = this._chatCompletions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var usage = _step.value.usage;
            if (usage) {
                total.completion_tokens += usage.completion_tokens;
                total.prompt_tokens += usage.prompt_tokens;
                total.total_tokens += usage.total_tokens;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return total;
}, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_validateParams = function _AbstractChatCompletionRunner_validateParams(params) {
    if (params.n != null && params.n > 1) throw new $kQ0uC.OpenAIError("ChatCompletion convenience helpers only support n=1 at this time. To use n>1, please use chat.completions.create() directly.");
}, $f6098d988bc5aa67$var$_AbstractChatCompletionRunner_stringifyFunctionCallResult = function _AbstractChatCompletionRunner_stringifyFunctionCallResult(rawContent) {
    return typeof rawContent === "string" ? rawContent : rawContent === undefined ? "undefined" : JSON.stringify(rawContent);
};

});
parcelRegister("2XNub", function(module, exports) {

var $19mwo = parcelRequire("19mwo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParsingToolFunction = module.exports.ParsingFunction = module.exports.isRunnableFunctionWithParse = void 0;
function $22877a5414791622$var$isRunnableFunctionWithParse(fn) {
    return typeof fn.parse === "function";
}
module.exports.isRunnableFunctionWithParse = $22877a5414791622$var$isRunnableFunctionWithParse;
/**
 * This is helper class for passing a `function` and `parse` where the `function`
 * argument type matches the `parse` return type.
 *
 * @deprecated - please use ParsingToolFunction instead.
 */ var $22877a5414791622$var$ParsingFunction = function ParsingFunction(input) {
    (0, $19mwo._)(this, ParsingFunction);
    this.function = input.function;
    this.parse = input.parse;
    this.parameters = input.parameters;
    this.description = input.description;
    this.name = input.name;
};
module.exports.ParsingFunction = $22877a5414791622$var$ParsingFunction;
/**
 * This is helper class for passing a `function` and `parse` where the `function`
 * argument type matches the `parse` return type.
 */ var $22877a5414791622$var$ParsingToolFunction = function ParsingToolFunction(input) {
    (0, $19mwo._)(this, ParsingToolFunction);
    this.type = "function";
    this.function = input;
};
module.exports.ParsingToolFunction = $22877a5414791622$var$ParsingToolFunction;

});

parcelRegister("ZAb8y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isPresent = module.exports.isToolMessage = module.exports.isFunctionMessage = module.exports.isAssistantMessage = void 0;
var $0b91c2f130740cd6$var$isAssistantMessage = function(message) {
    return (message === null || message === void 0 ? void 0 : message.role) === "assistant";
};
module.exports.isAssistantMessage = $0b91c2f130740cd6$var$isAssistantMessage;
var $0b91c2f130740cd6$var$isFunctionMessage = function(message) {
    return (message === null || message === void 0 ? void 0 : message.role) === "function";
};
module.exports.isFunctionMessage = $0b91c2f130740cd6$var$isFunctionMessage;
var $0b91c2f130740cd6$var$isToolMessage = function(message) {
    return (message === null || message === void 0 ? void 0 : message.role) === "tool";
};
module.exports.isToolMessage = $0b91c2f130740cd6$var$isToolMessage;
function $0b91c2f130740cd6$var$isPresent(obj) {
    return obj != null;
}
module.exports.isPresent = $0b91c2f130740cd6$var$isPresent;

});

parcelRegister("3RnC6", function(module, exports) {

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $3jzhD = parcelRequire("3jzhD");

var $lF1I7 = parcelRequire("lF1I7");
"use strict";
var $2cf8a38570842f53$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $2cf8a38570842f53$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $2cf8a38570842f53$var$_EventStream_instances, $2cf8a38570842f53$var$_EventStream_connectedPromise, $2cf8a38570842f53$var$_EventStream_resolveConnectedPromise, $2cf8a38570842f53$var$_EventStream_rejectConnectedPromise, $2cf8a38570842f53$var$_EventStream_endPromise, $2cf8a38570842f53$var$_EventStream_resolveEndPromise, $2cf8a38570842f53$var$_EventStream_rejectEndPromise, $2cf8a38570842f53$var$_EventStream_listeners, $2cf8a38570842f53$var$_EventStream_ended, $2cf8a38570842f53$var$_EventStream_errored, $2cf8a38570842f53$var$_EventStream_aborted, $2cf8a38570842f53$var$_EventStream_catchingPromiseCreated, $2cf8a38570842f53$var$_EventStream_handleError;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventStream = void 0;

var $kQ0uC = parcelRequire("kQ0uC");
var $2cf8a38570842f53$var$EventStream = /*#__PURE__*/ function() {
    function EventStream() {
        var _this = this;
        (0, $19mwo._)(this, EventStream);
        $2cf8a38570842f53$var$_EventStream_instances.add(this);
        this.controller = new AbortController();
        $2cf8a38570842f53$var$_EventStream_connectedPromise.set(this, void 0);
        $2cf8a38570842f53$var$_EventStream_resolveConnectedPromise.set(this, function() {});
        $2cf8a38570842f53$var$_EventStream_rejectConnectedPromise.set(this, function() {});
        $2cf8a38570842f53$var$_EventStream_endPromise.set(this, void 0);
        $2cf8a38570842f53$var$_EventStream_resolveEndPromise.set(this, function() {});
        $2cf8a38570842f53$var$_EventStream_rejectEndPromise.set(this, function() {});
        $2cf8a38570842f53$var$_EventStream_listeners.set(this, {});
        $2cf8a38570842f53$var$_EventStream_ended.set(this, false);
        $2cf8a38570842f53$var$_EventStream_errored.set(this, false);
        $2cf8a38570842f53$var$_EventStream_aborted.set(this, false);
        $2cf8a38570842f53$var$_EventStream_catchingPromiseCreated.set(this, false);
        $2cf8a38570842f53$var$__classPrivateFieldSet(this, $2cf8a38570842f53$var$_EventStream_connectedPromise, new Promise(function(resolve, reject) {
            $2cf8a38570842f53$var$__classPrivateFieldSet(_this, $2cf8a38570842f53$var$_EventStream_resolveConnectedPromise, resolve, "f");
            $2cf8a38570842f53$var$__classPrivateFieldSet(_this, $2cf8a38570842f53$var$_EventStream_rejectConnectedPromise, reject, "f");
        }), "f");
        $2cf8a38570842f53$var$__classPrivateFieldSet(this, $2cf8a38570842f53$var$_EventStream_endPromise, new Promise(function(resolve, reject) {
            $2cf8a38570842f53$var$__classPrivateFieldSet(_this, $2cf8a38570842f53$var$_EventStream_resolveEndPromise, resolve, "f");
            $2cf8a38570842f53$var$__classPrivateFieldSet(_this, $2cf8a38570842f53$var$_EventStream_rejectEndPromise, reject, "f");
        }), "f");
        // Don't let these promises cause unhandled rejection errors.
        // we will manually cause an unhandled rejection error later
        // if the user hasn't registered any error listener or called
        // any promise-returning method.
        $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_connectedPromise, "f").catch(function() {});
        $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_endPromise, "f").catch(function() {});
    }
    (0, $6rpfc._)(EventStream, [
        {
            key: "_run",
            value: function _run(executor) {
                var _this = this;
                // Unfortunately if we call `executor()` immediately we get runtime errors about
                // references to `this` before the `super()` constructor call returns.
                setTimeout(function() {
                    executor().then(function() {
                        _this._emitFinal();
                        _this._emit("end");
                    }, $2cf8a38570842f53$var$__classPrivateFieldGet(_this, $2cf8a38570842f53$var$_EventStream_instances, "m", $2cf8a38570842f53$var$_EventStream_handleError).bind(_this));
                }, 0);
            }
        },
        {
            key: "_connected",
            value: function _connected() {
                if (this.ended) return;
                $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_resolveConnectedPromise, "f").call(this);
                this._emit("connect");
            }
        },
        {
            key: "ended",
            get: function get() {
                return $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_ended, "f");
            }
        },
        {
            key: "errored",
            get: function get() {
                return $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_errored, "f");
            }
        },
        {
            key: "aborted",
            get: function get() {
                return $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_aborted, "f");
            }
        },
        {
            key: "abort",
            value: function abort() {
                this.controller.abort();
            }
        },
        {
            /**
     * Adds the listener function to the end of the listeners array for the event.
     * No checks are made to see if the listener has already been added. Multiple calls passing
     * the same combination of event and listener will result in the listener being added, and
     * called, multiple times.
     * @returns this ChatCompletionStream, so that calls can be chained
     */ key: "on",
            value: function on(event, listener) {
                var listeners = $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_listeners, "f")[event] || ($2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_listeners, "f")[event] = []);
                listeners.push({
                    listener: listener
                });
                return this;
            }
        },
        {
            /**
     * Removes the specified listener from the listener array for the event.
     * off() will remove, at most, one instance of a listener from the listener array. If any single
     * listener has been added multiple times to the listener array for the specified event, then
     * off() must be called multiple times to remove each instance.
     * @returns this ChatCompletionStream, so that calls can be chained
     */ key: "off",
            value: function off(event, listener) {
                var listeners = $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_listeners, "f")[event];
                if (!listeners) return this;
                var index = listeners.findIndex(function(l) {
                    return l.listener === listener;
                });
                if (index >= 0) listeners.splice(index, 1);
                return this;
            }
        },
        {
            /**
     * Adds a one-time listener function for the event. The next time the event is triggered,
     * this listener is removed and then invoked.
     * @returns this ChatCompletionStream, so that calls can be chained
     */ key: "once",
            value: function once(event, listener) {
                var listeners = $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_listeners, "f")[event] || ($2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_listeners, "f")[event] = []);
                listeners.push({
                    listener: listener,
                    once: true
                });
                return this;
            }
        },
        {
            /**
     * This is similar to `.once()`, but returns a Promise that resolves the next time
     * the event is triggered, instead of calling a listener callback.
     * @returns a Promise that resolves the next time given event is triggered,
     * or rejects if an error is emitted.  (If you request the 'error' event,
     * returns a promise that resolves with the error).
     *
     * Example:
     *
     *   const message = await stream.emitted('message') // rejects if the stream errors
     */ key: "emitted",
            value: function emitted(event) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    $2cf8a38570842f53$var$__classPrivateFieldSet(_this, $2cf8a38570842f53$var$_EventStream_catchingPromiseCreated, true, "f");
                    if (event !== "error") _this.once("error", reject);
                    _this.once(event, resolve);
                });
            }
        },
        {
            key: "done",
            value: function done() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $2cf8a38570842f53$var$__classPrivateFieldSet(_this, $2cf8a38570842f53$var$_EventStream_catchingPromiseCreated, true, "f");
                                return [
                                    4,
                                    $2cf8a38570842f53$var$__classPrivateFieldGet(_this, $2cf8a38570842f53$var$_EventStream_endPromise, "f")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_emit",
            value: function _emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                // make sure we don't emit any events after end
                if ($2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_ended, "f")) return;
                if (event === "end") {
                    $2cf8a38570842f53$var$__classPrivateFieldSet(this, $2cf8a38570842f53$var$_EventStream_ended, true, "f");
                    $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_resolveEndPromise, "f").call(this);
                }
                var listeners = $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_listeners, "f")[event];
                if (listeners) {
                    $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_listeners, "f")[event] = listeners.filter(function(l) {
                        return !l.once;
                    });
                    listeners.forEach(function(param) {
                        var listener = param.listener;
                        return listener.apply(void 0, (0, $3jzhD._)(args));
                    });
                }
                if (event === "abort") {
                    var error = args[0];
                    if (!$2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_catchingPromiseCreated, "f") && !(listeners === null || listeners === void 0 ? void 0 : listeners.length)) Promise.reject(error);
                    $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_rejectConnectedPromise, "f").call(this, error);
                    $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_rejectEndPromise, "f").call(this, error);
                    this._emit("end");
                    return;
                }
                if (event === "error") {
                    // NOTE: _emit('error', error) should only be called from #handleError().
                    var error1 = args[0];
                    if (!$2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_catchingPromiseCreated, "f") && !(listeners === null || listeners === void 0 ? void 0 : listeners.length)) // Trigger an unhandled rejection if the user hasn't registered any error handlers.
                    // If you are seeing stack traces here, make sure to handle errors via either:
                    // - runner.on('error', () => ...)
                    // - await runner.done()
                    // - await runner.finalChatCompletion()
                    // - etc.
                    Promise.reject(error1);
                    $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_rejectConnectedPromise, "f").call(this, error1);
                    $2cf8a38570842f53$var$__classPrivateFieldGet(this, $2cf8a38570842f53$var$_EventStream_rejectEndPromise, "f").call(this, error1);
                    this._emit("end");
                }
            }
        },
        {
            key: "_emitFinal",
            value: function _emitFinal() {}
        }
    ]);
    return EventStream;
}();
module.exports.EventStream = $2cf8a38570842f53$var$EventStream;
$2cf8a38570842f53$var$_EventStream_connectedPromise = new WeakMap(), $2cf8a38570842f53$var$_EventStream_resolveConnectedPromise = new WeakMap(), $2cf8a38570842f53$var$_EventStream_rejectConnectedPromise = new WeakMap(), $2cf8a38570842f53$var$_EventStream_endPromise = new WeakMap(), $2cf8a38570842f53$var$_EventStream_resolveEndPromise = new WeakMap(), $2cf8a38570842f53$var$_EventStream_rejectEndPromise = new WeakMap(), $2cf8a38570842f53$var$_EventStream_listeners = new WeakMap(), $2cf8a38570842f53$var$_EventStream_ended = new WeakMap(), $2cf8a38570842f53$var$_EventStream_errored = new WeakMap(), $2cf8a38570842f53$var$_EventStream_aborted = new WeakMap(), $2cf8a38570842f53$var$_EventStream_catchingPromiseCreated = new WeakMap(), $2cf8a38570842f53$var$_EventStream_instances = new WeakSet(), $2cf8a38570842f53$var$_EventStream_handleError = function _EventStream_handleError(error) {
    $2cf8a38570842f53$var$__classPrivateFieldSet(this, $2cf8a38570842f53$var$_EventStream_errored, true, "f");
    if (error instanceof Error && error.name === "AbortError") error = new $kQ0uC.APIUserAbortError();
    if (error instanceof $kQ0uC.APIUserAbortError) {
        $2cf8a38570842f53$var$__classPrivateFieldSet(this, $2cf8a38570842f53$var$_EventStream_aborted, true, "f");
        return this._emit("abort", error);
    }
    if (error instanceof $kQ0uC.OpenAIError) return this._emit("error", error);
    if (error instanceof Error) {
        var openAIError = new $kQ0uC.OpenAIError(error.message);
        // @ts-ignore
        openAIError.cause = error;
        return this._emit("error", openAIError);
    }
    return this._emit("error", new $kQ0uC.OpenAIError(String(error)));
};

});

parcelRegister("29whI", function(module, exports) {

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateInputTools = module.exports.hasAutoParseableInput = module.exports.shouldParseToolCall = module.exports.parseChatCompletion = module.exports.maybeParseChatCompletion = module.exports.isAutoParsableTool = module.exports.makeParseableTool = module.exports.isAutoParsableResponseFormat = module.exports.makeParseableResponseFormat = void 0;

var $kQ0uC = parcelRequire("kQ0uC");
function $191577193b9b1b6d$var$makeParseableResponseFormat(response_format, parser) {
    var obj = (0, $78DQ7._)({}, response_format);
    Object.defineProperties(obj, {
        $brand: {
            value: "auto-parseable-response-format",
            enumerable: false
        },
        $parseRaw: {
            value: parser,
            enumerable: false
        }
    });
    return obj;
}
module.exports.makeParseableResponseFormat = $191577193b9b1b6d$var$makeParseableResponseFormat;
function $191577193b9b1b6d$var$isAutoParsableResponseFormat(response_format) {
    return (response_format === null || response_format === void 0 ? void 0 : response_format["$brand"]) === "auto-parseable-response-format";
}
module.exports.isAutoParsableResponseFormat = $191577193b9b1b6d$var$isAutoParsableResponseFormat;
function $191577193b9b1b6d$var$makeParseableTool(tool, param) {
    var parser = param.parser, callback = param.callback;
    var obj = (0, $78DQ7._)({}, tool);
    Object.defineProperties(obj, {
        $brand: {
            value: "auto-parseable-tool",
            enumerable: false
        },
        $parseRaw: {
            value: parser,
            enumerable: false
        },
        $callback: {
            value: callback,
            enumerable: false
        }
    });
    return obj;
}
module.exports.makeParseableTool = $191577193b9b1b6d$var$makeParseableTool;
function $191577193b9b1b6d$var$isAutoParsableTool(tool) {
    return (tool === null || tool === void 0 ? void 0 : tool["$brand"]) === "auto-parseable-tool";
}
module.exports.isAutoParsableTool = $191577193b9b1b6d$var$isAutoParsableTool;
function $191577193b9b1b6d$var$maybeParseChatCompletion(completion, params) {
    if (!params || !$191577193b9b1b6d$var$hasAutoParseableInput(params)) return (0, $ddevm._)((0, $78DQ7._)({}, completion), {
        choices: completion.choices.map(function(choice) {
            var _choice_message_tool_calls;
            return (0, $ddevm._)((0, $78DQ7._)({}, choice), {
                message: (0, $ddevm._)((0, $78DQ7._)({}, choice.message), {
                    parsed: null,
                    tool_calls: (_choice_message_tool_calls = choice.message.tool_calls) !== null && _choice_message_tool_calls !== void 0 ? _choice_message_tool_calls : []
                })
            });
        })
    });
    return $191577193b9b1b6d$var$parseChatCompletion(completion, params);
}
module.exports.maybeParseChatCompletion = $191577193b9b1b6d$var$maybeParseChatCompletion;
function $191577193b9b1b6d$var$parseChatCompletion(completion, params) {
    var choices = completion.choices.map(function(choice) {
        var _choice_message_tool_calls;
        if (choice.finish_reason === "length") throw new $kQ0uC.LengthFinishReasonError();
        if (choice.finish_reason === "content_filter") throw new $kQ0uC.ContentFilterFinishReasonError();
        var _choice_message_tool_calls_map;
        return (0, $ddevm._)((0, $78DQ7._)({}, choice), {
            message: (0, $ddevm._)((0, $78DQ7._)({}, choice.message), {
                tool_calls: (_choice_message_tool_calls_map = (_choice_message_tool_calls = choice.message.tool_calls) === null || _choice_message_tool_calls === void 0 ? void 0 : _choice_message_tool_calls.map(function(toolCall) {
                    return $191577193b9b1b6d$var$parseToolCall(params, toolCall);
                })) !== null && _choice_message_tool_calls_map !== void 0 ? _choice_message_tool_calls_map : [],
                parsed: choice.message.content && !choice.message.refusal ? $191577193b9b1b6d$var$parseResponseFormat(params, choice.message.content) : null
            })
        });
    });
    return (0, $ddevm._)((0, $78DQ7._)({}, completion), {
        choices: choices
    });
}
module.exports.parseChatCompletion = $191577193b9b1b6d$var$parseChatCompletion;
function $191577193b9b1b6d$var$parseResponseFormat(params, content) {
    var _params_response_format, _params_response_format1;
    if (((_params_response_format = params.response_format) === null || _params_response_format === void 0 ? void 0 : _params_response_format.type) !== "json_schema") return null;
    if (((_params_response_format1 = params.response_format) === null || _params_response_format1 === void 0 ? void 0 : _params_response_format1.type) === "json_schema") {
        if ("$parseRaw" in params.response_format) {
            var response_format = params.response_format;
            return response_format.$parseRaw(content);
        }
        return JSON.parse(content);
    }
    return null;
}
function $191577193b9b1b6d$var$parseToolCall(params, toolCall) {
    var _params_tools;
    var inputTool = (_params_tools = params.tools) === null || _params_tools === void 0 ? void 0 : _params_tools.find(function(inputTool) {
        var _inputTool_function;
        return ((_inputTool_function = inputTool.function) === null || _inputTool_function === void 0 ? void 0 : _inputTool_function.name) === toolCall.function.name;
    });
    return (0, $ddevm._)((0, $78DQ7._)({}, toolCall), {
        function: (0, $ddevm._)((0, $78DQ7._)({}, toolCall.function), {
            parsed_arguments: $191577193b9b1b6d$var$isAutoParsableTool(inputTool) ? inputTool.$parseRaw(toolCall.function.arguments) : (inputTool === null || inputTool === void 0 ? void 0 : inputTool.function.strict) ? JSON.parse(toolCall.function.arguments) : null
        })
    });
}
function $191577193b9b1b6d$var$shouldParseToolCall(params, toolCall) {
    var _params_tools;
    if (!params) return false;
    var inputTool = (_params_tools = params.tools) === null || _params_tools === void 0 ? void 0 : _params_tools.find(function(inputTool) {
        var _inputTool_function;
        return ((_inputTool_function = inputTool.function) === null || _inputTool_function === void 0 ? void 0 : _inputTool_function.name) === toolCall.function.name;
    });
    return $191577193b9b1b6d$var$isAutoParsableTool(inputTool) || (inputTool === null || inputTool === void 0 ? void 0 : inputTool.function.strict) || false;
}
module.exports.shouldParseToolCall = $191577193b9b1b6d$var$shouldParseToolCall;
function $191577193b9b1b6d$var$hasAutoParseableInput(params) {
    var _params_tools;
    if ($191577193b9b1b6d$var$isAutoParsableResponseFormat(params.response_format)) return true;
    var _params_tools_some;
    return (_params_tools_some = (_params_tools = params.tools) === null || _params_tools === void 0 ? void 0 : _params_tools.some(function(t) {
        return $191577193b9b1b6d$var$isAutoParsableTool(t) || t.type === "function" && t.function.strict === true;
    })) !== null && _params_tools_some !== void 0 ? _params_tools_some : false;
}
module.exports.hasAutoParseableInput = $191577193b9b1b6d$var$hasAutoParseableInput;
function $191577193b9b1b6d$var$validateInputTools(tools) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (tools !== null && tools !== void 0 ? tools : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var tool = _step.value;
            if (tool.type !== "function") throw new $kQ0uC.OpenAIError("Currently only `function` tool types support auto-parsing; Received `".concat(tool.type, "`"));
            if (tool.function.strict !== true) throw new $kQ0uC.OpenAIError("The `".concat(tool.function.name, "` tool is not marked with `strict: true`. Only strict function tools can be auto-parsed"));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
module.exports.validateInputTools = $191577193b9b1b6d$var$validateInputTools;

});



parcelRegister("8bbhJ", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChatCompletionStreamingRunner = void 0;

var $9TkpA = parcelRequire("9TkpA");
var $5f481ac5adeac73d$var$ChatCompletionStreamingRunner = /*#__PURE__*/ function(_ChatCompletionStream_1_ChatCompletionStream) {
    (0, $iNfU4._)(ChatCompletionStreamingRunner, _ChatCompletionStream_1_ChatCompletionStream);
    var _super = (0, $k1NN5._)(ChatCompletionStreamingRunner);
    function ChatCompletionStreamingRunner() {
        (0, $19mwo._)(this, ChatCompletionStreamingRunner);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ChatCompletionStreamingRunner, null, [
        {
            key: "fromReadableStream",
            value: function fromReadableStream(stream) {
                var runner = new ChatCompletionStreamingRunner(null);
                runner._run(function() {
                    return runner._fromReadableStream(stream);
                });
                return runner;
            }
        },
        {
            key: "runFunctions",
            value: /** @deprecated - please use `runTools` instead. */ function runFunctions(client, params, options) {
                var runner = new ChatCompletionStreamingRunner(null);
                var opts = (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $ddevm._)((0, $78DQ7._)({}, options === null || options === void 0 ? void 0 : options.headers), {
                        "X-Stainless-Helper-Method": "runFunctions"
                    })
                });
                runner._run(function() {
                    return runner._runFunctions(client, params, opts);
                });
                return runner;
            }
        },
        {
            key: "runTools",
            value: function runTools(client, params, options) {
                var runner = new ChatCompletionStreamingRunner(// @ts-expect-error TODO these types are incompatible
                params);
                var opts = (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $ddevm._)((0, $78DQ7._)({}, options === null || options === void 0 ? void 0 : options.headers), {
                        "X-Stainless-Helper-Method": "runTools"
                    })
                });
                runner._run(function() {
                    return runner._runTools(client, params, opts);
                });
                return runner;
            }
        }
    ]);
    return ChatCompletionStreamingRunner;
}($9TkpA.ChatCompletionStream);
module.exports.ChatCompletionStreamingRunner = $5f481ac5adeac73d$var$ChatCompletionStreamingRunner;

});
parcelRegister("9TkpA", function(module, exports) {

var $15Pju = parcelRequire("15Pju");

var $gIbDP = parcelRequire("gIbDP");

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $jLCbM = parcelRequire("jLCbM");

var $laF8D = parcelRequire("laF8D");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $3jzhD = parcelRequire("3jzhD");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");
"use strict";
var $733915786c3a31a5$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $733915786c3a31a5$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $733915786c3a31a5$var$_ChatCompletionStream_instances, $733915786c3a31a5$var$_ChatCompletionStream_params, $733915786c3a31a5$var$_ChatCompletionStream_choiceEventStates, $733915786c3a31a5$var$_ChatCompletionStream_currentChatCompletionSnapshot, $733915786c3a31a5$var$_ChatCompletionStream_beginRequest, $733915786c3a31a5$var$_ChatCompletionStream_getChoiceEventState, $733915786c3a31a5$var$_ChatCompletionStream_addChunk, $733915786c3a31a5$var$_ChatCompletionStream_emitToolCallDoneEvent, $733915786c3a31a5$var$_ChatCompletionStream_emitContentDoneEvents, $733915786c3a31a5$var$_ChatCompletionStream_endRequest, $733915786c3a31a5$var$_ChatCompletionStream_getAutoParseableResponseFormat, $733915786c3a31a5$var$_ChatCompletionStream_accumulateChatCompletion;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChatCompletionStream = void 0;

var $kQ0uC = parcelRequire("kQ0uC");

var $l7ElV = parcelRequire("l7ElV");

var $8BEDZ = parcelRequire("8BEDZ");

var $29whI = parcelRequire("29whI");

var $gVEFd = parcelRequire("gVEFd");
var $733915786c3a31a5$var$_ChatCompletionStream_accumulateChatCompletion1;
var $733915786c3a31a5$var$ChatCompletionStream = /*#__PURE__*/ function(_AbstractChatCompletionRunner_1_AbstractChatCompletionRunner) {
    (0, $iNfU4._)(ChatCompletionStream, _AbstractChatCompletionRunner_1_AbstractChatCompletionRunner);
    var _super = (0, $k1NN5._)(ChatCompletionStream);
    function ChatCompletionStream(params) {
        (0, $19mwo._)(this, ChatCompletionStream);
        var _this;
        _this = _super.call(this);
        $733915786c3a31a5$var$_ChatCompletionStream_instances.add((0, $15Pju._)(_this));
        $733915786c3a31a5$var$_ChatCompletionStream_params.set((0, $15Pju._)(_this), void 0);
        $733915786c3a31a5$var$_ChatCompletionStream_choiceEventStates.set((0, $15Pju._)(_this), void 0);
        $733915786c3a31a5$var$_ChatCompletionStream_currentChatCompletionSnapshot.set((0, $15Pju._)(_this), void 0);
        $733915786c3a31a5$var$__classPrivateFieldSet((0, $15Pju._)(_this), $733915786c3a31a5$var$_ChatCompletionStream_params, params, "f");
        $733915786c3a31a5$var$__classPrivateFieldSet((0, $15Pju._)(_this), $733915786c3a31a5$var$_ChatCompletionStream_choiceEventStates, [], "f");
        return _this;
    }
    (0, $6rpfc._)(ChatCompletionStream, [
        {
            key: "currentChatCompletionSnapshot",
            get: function get() {
                return $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_currentChatCompletionSnapshot, "f");
            }
        },
        {
            key: "_createChatCompletion",
            value: function _createChatCompletion(client, params, options) {
                var _this = this;
                var _this1 = this, _superprop_get__createChatCompletion = function() {
                    return (0, $jLCbM._)((0, $laF8D._)(ChatCompletionStream.prototype), "_createChatCompletion", _this);
                };
                return (0, $9OZ9j._)(function() {
                    var _stream_controller_signal, signal, stream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _superprop_get__createChatCompletion();
                                signal = options === null || options === void 0 ? void 0 : options.signal;
                                if (signal) {
                                    if (signal.aborted) _this1.controller.abort();
                                    signal.addEventListener("abort", function() {
                                        return _this1.controller.abort();
                                    });
                                }
                                $733915786c3a31a5$var$__classPrivateFieldGet(_this1, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_beginRequest).call(_this1);
                                return [
                                    4,
                                    client.chat.completions.create((0, $ddevm._)((0, $78DQ7._)({}, params), {
                                        stream: true
                                    }), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                                        signal: _this1.controller.signal
                                    }))
                                ];
                            case 1:
                                stream = _state.sent();
                                _this1._connected();
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $gIbDP._)(stream);
                                _state.label = 3;
                            case 3:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 4:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                chunk = _value;
                                $733915786c3a31a5$var$__classPrivateFieldGet(_this1, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_addChunk).call(_this1, chunk);
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                if ((_stream_controller_signal = stream.controller.signal) === null || _stream_controller_signal === void 0 ? void 0 : _stream_controller_signal.aborted) throw new $kQ0uC.APIUserAbortError();
                                return [
                                    2,
                                    _this1._addChatCompletion($733915786c3a31a5$var$__classPrivateFieldGet(_this1, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_endRequest).call(_this1))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_fromReadableStream",
            value: function _fromReadableStream(readableStream, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _stream_controller_signal, signal, stream, chatId, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                signal = options === null || options === void 0 ? void 0 : options.signal;
                                if (signal) {
                                    if (signal.aborted) _this.controller.abort();
                                    signal.addEventListener("abort", function() {
                                        return _this.controller.abort();
                                    });
                                }
                                $733915786c3a31a5$var$__classPrivateFieldGet(_this, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_beginRequest).call(_this);
                                _this._connected();
                                stream = $8BEDZ.Stream.fromReadableStream(readableStream, _this.controller);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    12
                                ]);
                                _iterator = (0, $gIbDP._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    5
                                ];
                                _value = _step.value;
                                chunk = _value;
                                if (chatId && chatId !== chunk.id) // A new request has been made.
                                _this._addChatCompletion($733915786c3a31a5$var$__classPrivateFieldGet(_this, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_endRequest).call(_this));
                                $733915786c3a31a5$var$__classPrivateFieldGet(_this, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_addChunk).call(_this, chunk);
                                chatId = chunk.id;
                                _state.label = 4;
                            case 4:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    12
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    12
                                ];
                            case 7:
                                _state.trys.push([
                                    7,
                                    ,
                                    10,
                                    11
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 8:
                                _state.sent();
                                _state.label = 9;
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    7
                                ];
                            case 12:
                                if ((_stream_controller_signal = stream.controller.signal) === null || _stream_controller_signal === void 0 ? void 0 : _stream_controller_signal.aborted) throw new $kQ0uC.APIUserAbortError();
                                return [
                                    2,
                                    _this._addChatCompletion($733915786c3a31a5$var$__classPrivateFieldGet(_this, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_endRequest).call(_this))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: ($733915786c3a31a5$var$_ChatCompletionStream_params = new WeakMap(), $733915786c3a31a5$var$_ChatCompletionStream_choiceEventStates = new WeakMap(), $733915786c3a31a5$var$_ChatCompletionStream_currentChatCompletionSnapshot = new WeakMap(), $733915786c3a31a5$var$_ChatCompletionStream_instances = new WeakSet(), $733915786c3a31a5$var$_ChatCompletionStream_beginRequest = function _ChatCompletionStream_beginRequest() {
                if (this.ended) return;
                $733915786c3a31a5$var$__classPrivateFieldSet(this, $733915786c3a31a5$var$_ChatCompletionStream_currentChatCompletionSnapshot, undefined, "f");
            }, $733915786c3a31a5$var$_ChatCompletionStream_getChoiceEventState = function _ChatCompletionStream_getChoiceEventState(choice) {
                var state = $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_choiceEventStates, "f")[choice.index];
                if (state) return state;
                state = {
                    content_done: false,
                    refusal_done: false,
                    logprobs_content_done: false,
                    logprobs_refusal_done: false,
                    done_tool_calls: new Set(),
                    current_tool_call_index: null
                };
                $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_choiceEventStates, "f")[choice.index] = state;
                return state;
            }, $733915786c3a31a5$var$_ChatCompletionStream_addChunk = function _ChatCompletionStream_addChunk(chunk) {
                if (this.ended) return;
                var completion = $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_accumulateChatCompletion).call(this, chunk);
                this._emit("chunk", chunk, completion);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = chunk.choices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var choice = _step.value;
                        var _choiceSnapshot_message, _choiceSnapshot_message1, _choiceSnapshot_message2, _choiceSnapshot_message3, _choice_logprobs, _choiceSnapshot_message4, _choice_logprobs1, _choiceSnapshot_logprobs, _choice_logprobs2, _choiceSnapshot_message5, _choice_logprobs3, _choiceSnapshot_logprobs1;
                        var choiceSnapshot = completion.choices[choice.index];
                        if (choice.delta.content != null && ((_choiceSnapshot_message = choiceSnapshot.message) === null || _choiceSnapshot_message === void 0 ? void 0 : _choiceSnapshot_message.role) === "assistant" && ((_choiceSnapshot_message1 = choiceSnapshot.message) === null || _choiceSnapshot_message1 === void 0 ? void 0 : _choiceSnapshot_message1.content)) {
                            this._emit("content", choice.delta.content, choiceSnapshot.message.content);
                            this._emit("content.delta", {
                                delta: choice.delta.content,
                                snapshot: choiceSnapshot.message.content,
                                parsed: choiceSnapshot.message.parsed
                            });
                        }
                        if (choice.delta.refusal != null && ((_choiceSnapshot_message2 = choiceSnapshot.message) === null || _choiceSnapshot_message2 === void 0 ? void 0 : _choiceSnapshot_message2.role) === "assistant" && ((_choiceSnapshot_message3 = choiceSnapshot.message) === null || _choiceSnapshot_message3 === void 0 ? void 0 : _choiceSnapshot_message3.refusal)) this._emit("refusal.delta", {
                            delta: choice.delta.refusal,
                            snapshot: choiceSnapshot.message.refusal
                        });
                        var _choiceSnapshot_logprobs_content;
                        if (((_choice_logprobs = choice.logprobs) === null || _choice_logprobs === void 0 ? void 0 : _choice_logprobs.content) != null && ((_choiceSnapshot_message4 = choiceSnapshot.message) === null || _choiceSnapshot_message4 === void 0 ? void 0 : _choiceSnapshot_message4.role) === "assistant") this._emit("logprobs.content.delta", {
                            content: (_choice_logprobs1 = choice.logprobs) === null || _choice_logprobs1 === void 0 ? void 0 : _choice_logprobs1.content,
                            snapshot: (_choiceSnapshot_logprobs_content = (_choiceSnapshot_logprobs = choiceSnapshot.logprobs) === null || _choiceSnapshot_logprobs === void 0 ? void 0 : _choiceSnapshot_logprobs.content) !== null && _choiceSnapshot_logprobs_content !== void 0 ? _choiceSnapshot_logprobs_content : []
                        });
                        var _choiceSnapshot_logprobs_refusal;
                        if (((_choice_logprobs2 = choice.logprobs) === null || _choice_logprobs2 === void 0 ? void 0 : _choice_logprobs2.refusal) != null && ((_choiceSnapshot_message5 = choiceSnapshot.message) === null || _choiceSnapshot_message5 === void 0 ? void 0 : _choiceSnapshot_message5.role) === "assistant") this._emit("logprobs.refusal.delta", {
                            refusal: (_choice_logprobs3 = choice.logprobs) === null || _choice_logprobs3 === void 0 ? void 0 : _choice_logprobs3.refusal,
                            snapshot: (_choiceSnapshot_logprobs_refusal = (_choiceSnapshot_logprobs1 = choiceSnapshot.logprobs) === null || _choiceSnapshot_logprobs1 === void 0 ? void 0 : _choiceSnapshot_logprobs1.refusal) !== null && _choiceSnapshot_logprobs_refusal !== void 0 ? _choiceSnapshot_logprobs_refusal : []
                        });
                        var state = $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_getChoiceEventState).call(this, choiceSnapshot);
                        if (choiceSnapshot.finish_reason) {
                            $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_emitContentDoneEvents).call(this, choiceSnapshot);
                            if (state.current_tool_call_index != null) $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_emitToolCallDoneEvent).call(this, choiceSnapshot, state.current_tool_call_index);
                        }
                        var _choice_delta_tool_calls;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = ((_choice_delta_tool_calls = choice.delta.tool_calls) !== null && _choice_delta_tool_calls !== void 0 ? _choice_delta_tool_calls : [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var toolCall = _step1.value;
                                if (state.current_tool_call_index !== toolCall.index) {
                                    $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_emitContentDoneEvents).call(this, choiceSnapshot);
                                    // new tool call started, the previous one is done
                                    if (state.current_tool_call_index != null) $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_emitToolCallDoneEvent).call(this, choiceSnapshot, state.current_tool_call_index);
                                }
                                state.current_tool_call_index = toolCall.index;
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        var _choice_delta_tool_calls1;
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator2 = ((_choice_delta_tool_calls1 = choice.delta.tool_calls) !== null && _choice_delta_tool_calls1 !== void 0 ? _choice_delta_tool_calls1 : [])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var toolCallDelta = _step2.value;
                                var _choiceSnapshot_message_tool_calls, _toolCallSnapshot_function, _toolCallDelta_function;
                                var toolCallSnapshot = (_choiceSnapshot_message_tool_calls = choiceSnapshot.message.tool_calls) === null || _choiceSnapshot_message_tool_calls === void 0 ? void 0 : _choiceSnapshot_message_tool_calls[toolCallDelta.index];
                                if (!(toolCallSnapshot === null || toolCallSnapshot === void 0 ? void 0 : toolCallSnapshot.type)) continue;
                                var _toolCallDelta_function_arguments;
                                if ((toolCallSnapshot === null || toolCallSnapshot === void 0 ? void 0 : toolCallSnapshot.type) === "function") this._emit("tool_calls.function.arguments.delta", {
                                    name: (_toolCallSnapshot_function = toolCallSnapshot.function) === null || _toolCallSnapshot_function === void 0 ? void 0 : _toolCallSnapshot_function.name,
                                    index: toolCallDelta.index,
                                    arguments: toolCallSnapshot.function.arguments,
                                    parsed_arguments: toolCallSnapshot.function.parsed_arguments,
                                    arguments_delta: (_toolCallDelta_function_arguments = (_toolCallDelta_function = toolCallDelta.function) === null || _toolCallDelta_function === void 0 ? void 0 : _toolCallDelta_function.arguments) !== null && _toolCallDelta_function_arguments !== void 0 ? _toolCallDelta_function_arguments : ""
                                });
                                else $733915786c3a31a5$var$assertNever(toolCallSnapshot === null || toolCallSnapshot === void 0 ? void 0 : toolCallSnapshot.type);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }, $733915786c3a31a5$var$_ChatCompletionStream_emitToolCallDoneEvent = function _ChatCompletionStream_emitToolCallDoneEvent(choiceSnapshot, toolCallIndex) {
                var _choiceSnapshot_message_tool_calls;
                var state = $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_getChoiceEventState).call(this, choiceSnapshot);
                if (state.done_tool_calls.has(toolCallIndex)) // we've already fired the done event
                return;
                var toolCallSnapshot = (_choiceSnapshot_message_tool_calls = choiceSnapshot.message.tool_calls) === null || _choiceSnapshot_message_tool_calls === void 0 ? void 0 : _choiceSnapshot_message_tool_calls[toolCallIndex];
                if (!toolCallSnapshot) throw new Error("no tool call snapshot");
                if (!toolCallSnapshot.type) throw new Error("tool call snapshot missing `type`");
                if (toolCallSnapshot.type === "function") {
                    var __classPrivateFieldGet_tools, __classPrivateFieldGet1;
                    var inputTool = (__classPrivateFieldGet1 = $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_params, "f")) === null || __classPrivateFieldGet1 === void 0 ? void 0 : (__classPrivateFieldGet_tools = __classPrivateFieldGet1.tools) === null || __classPrivateFieldGet_tools === void 0 ? void 0 : __classPrivateFieldGet_tools.find(function(tool) {
                        return tool.type === "function" && tool.function.name === toolCallSnapshot.function.name;
                    });
                    this._emit("tool_calls.function.arguments.done", {
                        name: toolCallSnapshot.function.name,
                        index: toolCallIndex,
                        arguments: toolCallSnapshot.function.arguments,
                        parsed_arguments: (0, $29whI.isAutoParsableTool)(inputTool) ? inputTool.$parseRaw(toolCallSnapshot.function.arguments) : (inputTool === null || inputTool === void 0 ? void 0 : inputTool.function.strict) ? JSON.parse(toolCallSnapshot.function.arguments) : null
                    });
                } else $733915786c3a31a5$var$assertNever(toolCallSnapshot.type);
            }, $733915786c3a31a5$var$_ChatCompletionStream_emitContentDoneEvents = function _ChatCompletionStream_emitContentDoneEvents(choiceSnapshot) {
                var _choiceSnapshot_logprobs, _choiceSnapshot_logprobs1;
                var state = $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_getChoiceEventState).call(this, choiceSnapshot);
                if (choiceSnapshot.message.content && !state.content_done) {
                    state.content_done = true;
                    var responseFormat = $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_getAutoParseableResponseFormat).call(this);
                    this._emit("content.done", {
                        content: choiceSnapshot.message.content,
                        parsed: responseFormat ? responseFormat.$parseRaw(choiceSnapshot.message.content) : null
                    });
                }
                if (choiceSnapshot.message.refusal && !state.refusal_done) {
                    state.refusal_done = true;
                    this._emit("refusal.done", {
                        refusal: choiceSnapshot.message.refusal
                    });
                }
                if (((_choiceSnapshot_logprobs = choiceSnapshot.logprobs) === null || _choiceSnapshot_logprobs === void 0 ? void 0 : _choiceSnapshot_logprobs.content) && !state.logprobs_content_done) {
                    state.logprobs_content_done = true;
                    this._emit("logprobs.content.done", {
                        content: choiceSnapshot.logprobs.content
                    });
                }
                if (((_choiceSnapshot_logprobs1 = choiceSnapshot.logprobs) === null || _choiceSnapshot_logprobs1 === void 0 ? void 0 : _choiceSnapshot_logprobs1.refusal) && !state.logprobs_refusal_done) {
                    state.logprobs_refusal_done = true;
                    this._emit("logprobs.refusal.done", {
                        refusal: choiceSnapshot.logprobs.refusal
                    });
                }
            }, $733915786c3a31a5$var$_ChatCompletionStream_endRequest = function _ChatCompletionStream_endRequest() {
                if (this.ended) throw new $kQ0uC.OpenAIError("stream has ended, this shouldn't happen");
                var snapshot = $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_currentChatCompletionSnapshot, "f");
                if (!snapshot) throw new $kQ0uC.OpenAIError("request ended without sending any chunks");
                $733915786c3a31a5$var$__classPrivateFieldSet(this, $733915786c3a31a5$var$_ChatCompletionStream_currentChatCompletionSnapshot, undefined, "f");
                $733915786c3a31a5$var$__classPrivateFieldSet(this, $733915786c3a31a5$var$_ChatCompletionStream_choiceEventStates, [], "f");
                return $733915786c3a31a5$var$finalizeChatCompletion(snapshot, $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_params, "f"));
            }, $733915786c3a31a5$var$_ChatCompletionStream_getAutoParseableResponseFormat = function _ChatCompletionStream_getAutoParseableResponseFormat() {
                var __classPrivateFieldGet1;
                var responseFormat = (__classPrivateFieldGet1 = $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_params, "f")) === null || __classPrivateFieldGet1 === void 0 ? void 0 : __classPrivateFieldGet1.response_format;
                if ((0, $29whI.isAutoParsableResponseFormat)(responseFormat)) return responseFormat;
                return null;
            }, $733915786c3a31a5$var$_ChatCompletionStream_accumulateChatCompletion1 = function _ChatCompletionStream_accumulateChatCompletion(chunk) {
                var _a, _b, _c, _d;
                var snapshot = $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_currentChatCompletionSnapshot, "f");
                var choices = chunk.choices, rest = (0, $6JqHh._)(chunk, [
                    "choices"
                ]);
                if (!snapshot) snapshot = $733915786c3a31a5$var$__classPrivateFieldSet(this, $733915786c3a31a5$var$_ChatCompletionStream_currentChatCompletionSnapshot, (0, $ddevm._)((0, $78DQ7._)({}, rest), {
                    choices: []
                }), "f");
                else Object.assign(snapshot, rest);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = chunk.choices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _ref = _step.value;
                        var delta = _ref.delta, finish_reason = _ref.finish_reason, index = _ref.index, _ref_logprobs = _ref.logprobs, logprobs = _ref_logprobs === void 0 ? null : _ref_logprobs, other = (0, $6JqHh._)(_ref, [
                            "delta",
                            "finish_reason",
                            "index",
                            "logprobs"
                        ]);
                        var choice = snapshot.choices[index];
                        if (!choice) choice = snapshot.choices[index] = (0, $78DQ7._)({
                            finish_reason: finish_reason,
                            index: index,
                            message: {},
                            logprobs: logprobs
                        }, other);
                        if (logprobs) {
                            if (!choice.logprobs) choice.logprobs = Object.assign({}, logprobs);
                            else {
                                var content = logprobs.content, refusal = logprobs.refusal, rest1 = (0, $6JqHh._)(logprobs, [
                                    "content",
                                    "refusal"
                                ]);
                                $733915786c3a31a5$var$assertIsEmpty(rest1);
                                Object.assign(choice.logprobs, rest1);
                                if (content) {
                                    var _choice_logprobs_content;
                                    var _content;
                                    (_content = (_a = choice.logprobs).content) !== null && _content !== void 0 ? _content : _a.content = [];
                                    (_choice_logprobs_content = choice.logprobs.content).push.apply(_choice_logprobs_content, (0, $3jzhD._)(content));
                                }
                                if (refusal) {
                                    var _choice_logprobs_refusal;
                                    var _refusal;
                                    (_refusal = (_b = choice.logprobs).refusal) !== null && _refusal !== void 0 ? _refusal : _b.refusal = [];
                                    (_choice_logprobs_refusal = choice.logprobs.refusal).push.apply(_choice_logprobs_refusal, (0, $3jzhD._)(refusal));
                                }
                            }
                        }
                        if (finish_reason) {
                            choice.finish_reason = finish_reason;
                            if ($733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_params, "f") && (0, $29whI.hasAutoParseableInput)($733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_params, "f"))) {
                                if (finish_reason === "length") throw new $kQ0uC.LengthFinishReasonError();
                                if (finish_reason === "content_filter") throw new $kQ0uC.ContentFilterFinishReasonError();
                            }
                        }
                        Object.assign(choice, other);
                        if (!delta) continue; // Shouldn't happen; just in case.
                        var content1 = delta.content, refusal1 = delta.refusal, function_call = delta.function_call, role = delta.role, tool_calls = delta.tool_calls, rest2 = (0, $6JqHh._)(delta, [
                            "content",
                            "refusal",
                            "function_call",
                            "role",
                            "tool_calls"
                        ]);
                        $733915786c3a31a5$var$assertIsEmpty(rest2);
                        Object.assign(choice.message, rest2);
                        if (refusal1) choice.message.refusal = (choice.message.refusal || "") + refusal1;
                        if (role) choice.message.role = role;
                        if (function_call) {
                            if (!choice.message.function_call) choice.message.function_call = function_call;
                            else {
                                if (function_call.name) choice.message.function_call.name = function_call.name;
                                if (function_call.arguments) {
                                    var _arguments;
                                    (_arguments = (_c = choice.message.function_call).arguments) !== null && _arguments !== void 0 ? _arguments : _c.arguments = "";
                                    choice.message.function_call.arguments += function_call.arguments;
                                }
                            }
                        }
                        if (content1) {
                            choice.message.content = (choice.message.content || "") + content1;
                            if (!choice.message.refusal && $733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_instances, "m", $733915786c3a31a5$var$_ChatCompletionStream_getAutoParseableResponseFormat).call(this)) choice.message.parsed = (0, $gVEFd.partialParse)(choice.message.content);
                        }
                        if (tool_calls) {
                            if (!choice.message.tool_calls) choice.message.tool_calls = [];
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = tool_calls[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var _ref1 = _step1.value;
                                    var index1 = _ref1.index, id = _ref1.id, type = _ref1.type, fn = _ref1.function, rest3 = (0, $6JqHh._)(_ref1, [
                                        "index",
                                        "id",
                                        "type",
                                        "function"
                                    ]);
                                    var _index;
                                    var tool_call = (_index = (_d = choice.message.tool_calls)[index1]) !== null && _index !== void 0 ? _index : _d[index1] = {};
                                    Object.assign(tool_call, rest3);
                                    if (id) tool_call.id = id;
                                    if (type) tool_call.type = type;
                                    var _fn_name, _tool_call_function;
                                    if (fn) (_tool_call_function = tool_call.function) !== null && _tool_call_function !== void 0 ? _tool_call_function : tool_call.function = {
                                        name: (_fn_name = fn.name) !== null && _fn_name !== void 0 ? _fn_name : "",
                                        arguments: ""
                                    };
                                    if (fn === null || fn === void 0 ? void 0 : fn.name) tool_call.function.name = fn.name;
                                    if (fn === null || fn === void 0 ? void 0 : fn.arguments) {
                                        tool_call.function.arguments += fn.arguments;
                                        if ((0, $29whI.shouldParseToolCall)($733915786c3a31a5$var$__classPrivateFieldGet(this, $733915786c3a31a5$var$_ChatCompletionStream_params, "f"), tool_call)) tool_call.function.parsed_arguments = (0, $gVEFd.partialParse)(tool_call.function.arguments);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return snapshot;
            }, $733915786c3a31a5$var$_ChatCompletionStream_accumulateChatCompletion = $733915786c3a31a5$var$_ChatCompletionStream_accumulateChatCompletion1, $733915786c3a31a5$var$_ChatCompletionStream_accumulateChatCompletion1, Symbol.asyncIterator),
            value: function value() {
                var pushQueue = [];
                var readQueue = [];
                var done = false;
                this.on("chunk", function(chunk) {
                    var reader = readQueue.shift();
                    if (reader) reader.resolve(chunk);
                    else pushQueue.push(chunk);
                });
                this.on("end", function() {
                    done = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = readQueue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var reader = _step.value;
                            reader.resolve(undefined);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    readQueue.length = 0;
                });
                this.on("abort", function(err1) {
                    done = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = readQueue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var reader = _step.value;
                            reader.reject(err1);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    readQueue.length = 0;
                });
                this.on("error", function(err1) {
                    done = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = readQueue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var reader = _step.value;
                            reader.reject(err1);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    readQueue.length = 0;
                });
                var _this = this;
                return {
                    next: /*#__PURE__*/ (0, $9OZ9j._)(function() {
                        var chunk;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            if (!pushQueue.length) {
                                if (done) return [
                                    2,
                                    {
                                        value: undefined,
                                        done: true
                                    }
                                ];
                                return [
                                    2,
                                    new Promise(function(resolve, reject) {
                                        return readQueue.push({
                                            resolve: resolve,
                                            reject: reject
                                        });
                                    }).then(function(chunk) {
                                        return chunk ? {
                                            value: chunk,
                                            done: false
                                        } : {
                                            value: undefined,
                                            done: true
                                        };
                                    })
                                ];
                            }
                            chunk = pushQueue.shift();
                            return [
                                2,
                                {
                                    value: chunk,
                                    done: false
                                }
                            ];
                        });
                    }),
                    return: /*#__PURE__*/ (0, $9OZ9j._)(function() {
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            _this.abort();
                            return [
                                2,
                                {
                                    value: undefined,
                                    done: true
                                }
                            ];
                        });
                    })
                };
            }
        },
        {
            key: "toReadableStream",
            value: function toReadableStream() {
                var stream = new $8BEDZ.Stream(this[Symbol.asyncIterator].bind(this), this.controller);
                return stream.toReadableStream();
            }
        }
    ], [
        {
            key: "fromReadableStream",
            value: /**
     * Intended for use on the frontend, consuming a stream produced with
     * `.toReadableStream()` on the backend.
     *
     * Note that messages sent to the model do not appear in `.on('message')`
     * in this context.
     */ function fromReadableStream(stream) {
                var runner = new ChatCompletionStream(null);
                runner._run(function() {
                    return runner._fromReadableStream(stream);
                });
                return runner;
            }
        },
        {
            key: "createChatCompletion",
            value: function createChatCompletion(client, params, options) {
                var runner = new ChatCompletionStream(params);
                runner._run(function() {
                    return runner._runChatCompletion(client, (0, $ddevm._)((0, $78DQ7._)({}, params), {
                        stream: true
                    }), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                        headers: (0, $ddevm._)((0, $78DQ7._)({}, options === null || options === void 0 ? void 0 : options.headers), {
                            "X-Stainless-Helper-Method": "stream"
                        })
                    }));
                });
                return runner;
            }
        }
    ]);
    return ChatCompletionStream;
}($l7ElV.AbstractChatCompletionRunner);
module.exports.ChatCompletionStream = $733915786c3a31a5$var$ChatCompletionStream;
function $733915786c3a31a5$var$finalizeChatCompletion(snapshot, params) {
    var id = snapshot.id, choices = snapshot.choices, created = snapshot.created, model = snapshot.model, system_fingerprint = snapshot.system_fingerprint, rest = (0, $6JqHh._)(snapshot, [
        "id",
        "choices",
        "created",
        "model",
        "system_fingerprint"
    ]);
    var completion = (0, $78DQ7._)((0, $ddevm._)((0, $78DQ7._)({}, rest), {
        id: id,
        choices: choices.map(function(_param) {
            var message = _param.message, finish_reason = _param.finish_reason, index = _param.index, logprobs = _param.logprobs, choiceRest = (0, $6JqHh._)(_param, [
                "message",
                "finish_reason",
                "index",
                "logprobs"
            ]);
            if (!finish_reason) throw new $kQ0uC.OpenAIError("missing finish_reason for choice ".concat(index));
            var _message_content = message.content, content = _message_content === void 0 ? null : _message_content, function_call = message.function_call, tool_calls = message.tool_calls, messageRest = (0, $6JqHh._)(message, [
                "content",
                "function_call",
                "tool_calls"
            ]);
            var role = message.role; // this is what we expect; in theory it could be different which would make our types a slight lie but would be fine.
            if (!role) throw new $kQ0uC.OpenAIError("missing role for choice ".concat(index));
            if (function_call) {
                var args = function_call.arguments, name = function_call.name;
                if (args == null) throw new $kQ0uC.OpenAIError("missing function_call.arguments for choice ".concat(index));
                if (!name) throw new $kQ0uC.OpenAIError("missing function_call.name for choice ".concat(index));
                var _message_refusal;
                return (0, $ddevm._)((0, $78DQ7._)({}, choiceRest), {
                    message: {
                        content: content,
                        function_call: {
                            arguments: args,
                            name: name
                        },
                        role: role,
                        refusal: (_message_refusal = message.refusal) !== null && _message_refusal !== void 0 ? _message_refusal : null
                    },
                    finish_reason: finish_reason,
                    index: index,
                    logprobs: logprobs
                });
            }
            var _message_refusal1;
            if (tool_calls) return (0, $ddevm._)((0, $78DQ7._)({}, choiceRest), {
                index: index,
                finish_reason: finish_reason,
                logprobs: logprobs,
                message: (0, $ddevm._)((0, $78DQ7._)({}, messageRest), {
                    role: role,
                    content: content,
                    refusal: (_message_refusal1 = message.refusal) !== null && _message_refusal1 !== void 0 ? _message_refusal1 : null,
                    tool_calls: tool_calls.map(function(tool_call, i) {
                        var fn = tool_call.function, type = tool_call.type, id = tool_call.id, toolRest = (0, $6JqHh._)(tool_call, [
                            "function",
                            "type",
                            "id"
                        ]);
                        var _ref = fn || {}, args = _ref.arguments, name = _ref.name, fnRest = (0, $6JqHh._)(_ref, [
                            "arguments",
                            "name"
                        ]);
                        if (id == null) throw new $kQ0uC.OpenAIError("missing choices[".concat(index, "].tool_calls[").concat(i, "].id\n").concat($733915786c3a31a5$var$str(snapshot)));
                        if (type == null) throw new $kQ0uC.OpenAIError("missing choices[".concat(index, "].tool_calls[").concat(i, "].type\n").concat($733915786c3a31a5$var$str(snapshot)));
                        if (name == null) throw new $kQ0uC.OpenAIError("missing choices[".concat(index, "].tool_calls[").concat(i, "].function.name\n").concat($733915786c3a31a5$var$str(snapshot)));
                        if (args == null) throw new $kQ0uC.OpenAIError("missing choices[".concat(index, "].tool_calls[").concat(i, "].function.arguments\n").concat($733915786c3a31a5$var$str(snapshot)));
                        return (0, $ddevm._)((0, $78DQ7._)({}, toolRest), {
                            id: id,
                            type: type,
                            function: (0, $ddevm._)((0, $78DQ7._)({}, fnRest), {
                                name: name,
                                arguments: args
                            })
                        });
                    })
                })
            });
            var _message_refusal2;
            return (0, $ddevm._)((0, $78DQ7._)({}, choiceRest), {
                message: (0, $ddevm._)((0, $78DQ7._)({}, messageRest), {
                    content: content,
                    role: role,
                    refusal: (_message_refusal2 = message.refusal) !== null && _message_refusal2 !== void 0 ? _message_refusal2 : null
                }),
                finish_reason: finish_reason,
                index: index,
                logprobs: logprobs
            });
        }),
        created: created,
        model: model,
        object: "chat.completion"
    }), system_fingerprint ? {
        system_fingerprint: system_fingerprint
    } : {});
    return (0, $29whI.maybeParseChatCompletion)(completion, params);
}
function $733915786c3a31a5$var$str(x) {
    return JSON.stringify(x);
}
/**
 * Ensures the given argument is an empty object, useful for
 * asserting that all known properties on an object have been
 * destructured.
 */ function $733915786c3a31a5$var$assertIsEmpty(obj) {
    return;
}
function $733915786c3a31a5$var$assertNever(_x) {}

});
parcelRegister("gVEFd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.partialParse = void 0;
var $c531833115f9a194$var$tokenize = function(input) {
    var current = 0;
    var tokens = [];
    while(current < input.length){
        var char = input[current];
        if (char === "\\") {
            current++;
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "brace",
                value: "{"
            });
            current++;
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "brace",
                value: "}"
            });
            current++;
            continue;
        }
        if (char === "[") {
            tokens.push({
                type: "paren",
                value: "["
            });
            current++;
            continue;
        }
        if (char === "]") {
            tokens.push({
                type: "paren",
                value: "]"
            });
            current++;
            continue;
        }
        if (char === ":") {
            tokens.push({
                type: "separator",
                value: ":"
            });
            current++;
            continue;
        }
        if (char === ",") {
            tokens.push({
                type: "delimiter",
                value: ","
            });
            current++;
            continue;
        }
        if (char === '"') {
            var value = "";
            var danglingQuote = false;
            char = input[++current];
            while(char !== '"'){
                if (current === input.length) {
                    danglingQuote = true;
                    break;
                }
                if (char === "\\") {
                    current++;
                    if (current === input.length) {
                        danglingQuote = true;
                        break;
                    }
                    value += char + input[current];
                    char = input[++current];
                } else {
                    value += char;
                    char = input[++current];
                }
            }
            char = input[++current];
            if (!danglingQuote) tokens.push({
                type: "string",
                value: value
            });
            continue;
        }
        var WHITESPACE = /\s/;
        if (char && WHITESPACE.test(char)) {
            current++;
            continue;
        }
        var NUMBERS = /[0-9]/;
        if (char && NUMBERS.test(char) || char === "-" || char === ".") {
            var value1 = "";
            if (char === "-") {
                value1 += char;
                char = input[++current];
            }
            while(char && NUMBERS.test(char) || char === "."){
                value1 += char;
                char = input[++current];
            }
            tokens.push({
                type: "number",
                value: value1
            });
            continue;
        }
        var LETTERS = /[a-z]/i;
        if (char && LETTERS.test(char)) {
            var value2 = "";
            while(char && LETTERS.test(char)){
                if (current === input.length) break;
                value2 += char;
                char = input[++current];
            }
            if (value2 == "true" || value2 == "false" || value2 === "null") tokens.push({
                type: "name",
                value: value2
            });
            else {
                // unknown token, e.g. `nul` which isn't quite `null`
                current++;
                continue;
            }
            continue;
        }
        current++;
    }
    return tokens;
}, $c531833115f9a194$var$strip = function(tokens) {
    if (tokens.length === 0) return tokens;
    var lastToken = tokens[tokens.length - 1];
    switch(lastToken.type){
        case "separator":
            tokens = tokens.slice(0, tokens.length - 1);
            return $c531833115f9a194$var$strip(tokens);
        case "number":
            var lastCharacterOfLastToken = lastToken.value[lastToken.value.length - 1];
            if (lastCharacterOfLastToken === "." || lastCharacterOfLastToken === "-") {
                tokens = tokens.slice(0, tokens.length - 1);
                return $c531833115f9a194$var$strip(tokens);
            }
        case "string":
            var tokenBeforeTheLastToken = tokens[tokens.length - 2];
            if ((tokenBeforeTheLastToken === null || tokenBeforeTheLastToken === void 0 ? void 0 : tokenBeforeTheLastToken.type) === "delimiter") {
                tokens = tokens.slice(0, tokens.length - 1);
                return $c531833115f9a194$var$strip(tokens);
            } else if ((tokenBeforeTheLastToken === null || tokenBeforeTheLastToken === void 0 ? void 0 : tokenBeforeTheLastToken.type) === "brace" && tokenBeforeTheLastToken.value === "{") {
                tokens = tokens.slice(0, tokens.length - 1);
                return $c531833115f9a194$var$strip(tokens);
            }
            break;
        case "delimiter":
            tokens = tokens.slice(0, tokens.length - 1);
            return $c531833115f9a194$var$strip(tokens);
    }
    return tokens;
}, $c531833115f9a194$var$unstrip = function(tokens) {
    var tail = [];
    tokens.map(function(token) {
        if (token.type === "brace") {
            if (token.value === "{") tail.push("}");
            else tail.splice(tail.lastIndexOf("}"), 1);
        }
        if (token.type === "paren") {
            if (token.value === "[") tail.push("]");
            else tail.splice(tail.lastIndexOf("]"), 1);
        }
    });
    if (tail.length > 0) tail.reverse().map(function(item) {
        if (item === "}") tokens.push({
            type: "brace",
            value: "}"
        });
        else if (item === "]") tokens.push({
            type: "paren",
            value: "]"
        });
    });
    return tokens;
}, $c531833115f9a194$var$generate = function(tokens) {
    var output = "";
    tokens.map(function(token) {
        switch(token.type){
            case "string":
                output += '"' + token.value + '"';
                break;
            default:
                output += token.value;
                break;
        }
    });
    return output;
}, $c531833115f9a194$var$partialParse = function(input) {
    return JSON.parse($c531833115f9a194$var$generate($c531833115f9a194$var$unstrip($c531833115f9a194$var$strip($c531833115f9a194$var$tokenize(input)))));
};
module.exports.partialParse = $c531833115f9a194$var$partialParse;

});





parcelRegister("3OOAu", function(module, exports) {

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $2c7d483a64d01e86$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2c7d483a64d01e86$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2c7d483a64d01e86$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2c7d483a64d01e86$var$__createBinding(result, mod, k);
    }
    $2c7d483a64d01e86$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Threads = void 0;

var $26X5G = parcelRequire("26X5G");

var $c8Tp0 = parcelRequire("c8Tp0");

var $bO9i3 = parcelRequire("bO9i3");

var $2c7d483a64d01e86$var$MessagesAPI = $2c7d483a64d01e86$var$__importStar((parcelRequire("5xx3z")));

var $2c7d483a64d01e86$var$RunsAPI = $2c7d483a64d01e86$var$__importStar((parcelRequire("jyUnt")));
var $2c7d483a64d01e86$var$Threads = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Threads, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Threads);
    function Threads() {
        (0, $19mwo._)(this, Threads);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.runs = new $2c7d483a64d01e86$var$RunsAPI.Runs(_this._client);
        _this.messages = new $2c7d483a64d01e86$var$MessagesAPI.Messages(_this._client);
        return _this;
    }
    (0, $6rpfc._)(Threads, [
        {
            key: "create",
            value: function create() {
                var body = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, options = arguments.length > 1 ? arguments[1] : void 0;
                if ((0, $c8Tp0.isRequestOptions)(body)) return this.create({}, body);
                return this._client.post("/threads", (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Retrieves a thread.
     */ key: "retrieve",
            value: function retrieve(threadId, options) {
                return this._client.get("/threads/".concat(threadId), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Modifies a thread.
     */ key: "update",
            value: function update(threadId, body, options) {
                return this._client.post("/threads/".concat(threadId), (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Delete a thread.
     */ key: "del",
            value: function del(threadId, options) {
                return this._client.delete("/threads/".concat(threadId), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            key: "createAndRun",
            value: function createAndRun(body, options) {
                var _body_stream;
                return this._client.post("/threads/runs", (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers),
                    stream: (_body_stream = body.stream) !== null && _body_stream !== void 0 ? _body_stream : false
                }));
            }
        },
        {
            key: "createAndRunPoll",
            value: /**
     * A helper to create a thread, start a run and then poll for a terminal state.
     * More information on Run lifecycles can be found here:
     * https://platform.openai.com/docs/assistants/how-it-works/runs-and-run-steps
     */ function createAndRunPoll(body, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var run;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.createAndRun(body, options)
                                ];
                            case 1:
                                run = _state.sent();
                                return [
                                    4,
                                    _this.runs.poll(run.thread_id, run.id, options)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Create a thread and stream the run back
     */ key: "createAndRunStream",
            value: function createAndRunStream(body, options) {
                return $bO9i3.AssistantStream.createThreadAssistantStream(body, this._client.beta.threads, options);
            }
        }
    ]);
    return Threads;
}($26X5G.APIResource);
module.exports.Threads = $2c7d483a64d01e86$var$Threads;
(function(Threads) {
    Threads.Runs = $2c7d483a64d01e86$var$RunsAPI.Runs;
    Threads.RunsPage = $2c7d483a64d01e86$var$RunsAPI.RunsPage;
    Threads.Messages = $2c7d483a64d01e86$var$MessagesAPI.Messages;
    Threads.MessagesPage = $2c7d483a64d01e86$var$MessagesAPI.MessagesPage;
})($2c7d483a64d01e86$var$Threads = module.exports.Threads || (module.exports.Threads = {}));

});
parcelRegister("bO9i3", function(module, exports) {

var $15Pju = parcelRequire("15Pju");

var $gIbDP = parcelRequire("gIbDP");

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");
"use strict";
var $898b920ec66a29cf$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $898b920ec66a29cf$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $898b920ec66a29cf$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $898b920ec66a29cf$var$__createBinding(result, mod, k);
    }
    $898b920ec66a29cf$var$__setModuleDefault(result, mod);
    return result;
};
var $898b920ec66a29cf$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $898b920ec66a29cf$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $898b920ec66a29cf$var$_AssistantStream_instances, $898b920ec66a29cf$var$_AssistantStream_events, $898b920ec66a29cf$var$_AssistantStream_runStepSnapshots, $898b920ec66a29cf$var$_AssistantStream_messageSnapshots, $898b920ec66a29cf$var$_AssistantStream_messageSnapshot, $898b920ec66a29cf$var$_AssistantStream_finalRun, $898b920ec66a29cf$var$_AssistantStream_currentContentIndex, $898b920ec66a29cf$var$_AssistantStream_currentContent, $898b920ec66a29cf$var$_AssistantStream_currentToolCallIndex, $898b920ec66a29cf$var$_AssistantStream_currentToolCall, $898b920ec66a29cf$var$_AssistantStream_currentEvent, $898b920ec66a29cf$var$_AssistantStream_currentRunSnapshot, $898b920ec66a29cf$var$_AssistantStream_currentRunStepSnapshot, $898b920ec66a29cf$var$_AssistantStream_addEvent, $898b920ec66a29cf$var$_AssistantStream_endRequest, $898b920ec66a29cf$var$_AssistantStream_handleMessage, $898b920ec66a29cf$var$_AssistantStream_handleRunStep, $898b920ec66a29cf$var$_AssistantStream_handleEvent, $898b920ec66a29cf$var$_AssistantStream_accumulateRunStep, $898b920ec66a29cf$var$_AssistantStream_accumulateMessage, $898b920ec66a29cf$var$_AssistantStream_accumulateContent, $898b920ec66a29cf$var$_AssistantStream_handleRun;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AssistantStream = void 0;

var $898b920ec66a29cf$var$Core = $898b920ec66a29cf$var$__importStar((parcelRequire("c8Tp0")));

var $8BEDZ = parcelRequire("8BEDZ");

var $kQ0uC = parcelRequire("kQ0uC");

var $3RnC6 = parcelRequire("3RnC6");
var $898b920ec66a29cf$var$AssistantStream = /*#__PURE__*/ function(_EventStream_1_EventStream) {
    (0, $iNfU4._)(AssistantStream, _EventStream_1_EventStream);
    var _super = (0, $k1NN5._)(AssistantStream);
    function AssistantStream() {
        (0, $19mwo._)(this, AssistantStream);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        $898b920ec66a29cf$var$_AssistantStream_instances.add((0, $15Pju._)(_this));
        //Track all events in a single list for reference
        $898b920ec66a29cf$var$_AssistantStream_events.set((0, $15Pju._)(_this), []);
        //Used to accumulate deltas
        //We are accumulating many types so the value here is not strict
        $898b920ec66a29cf$var$_AssistantStream_runStepSnapshots.set((0, $15Pju._)(_this), {});
        $898b920ec66a29cf$var$_AssistantStream_messageSnapshots.set((0, $15Pju._)(_this), {});
        $898b920ec66a29cf$var$_AssistantStream_messageSnapshot.set((0, $15Pju._)(_this), void 0);
        $898b920ec66a29cf$var$_AssistantStream_finalRun.set((0, $15Pju._)(_this), void 0);
        $898b920ec66a29cf$var$_AssistantStream_currentContentIndex.set((0, $15Pju._)(_this), void 0);
        $898b920ec66a29cf$var$_AssistantStream_currentContent.set((0, $15Pju._)(_this), void 0);
        $898b920ec66a29cf$var$_AssistantStream_currentToolCallIndex.set((0, $15Pju._)(_this), void 0);
        $898b920ec66a29cf$var$_AssistantStream_currentToolCall.set((0, $15Pju._)(_this), void 0);
        //For current snapshot methods
        $898b920ec66a29cf$var$_AssistantStream_currentEvent.set((0, $15Pju._)(_this), void 0);
        $898b920ec66a29cf$var$_AssistantStream_currentRunSnapshot.set((0, $15Pju._)(_this), void 0);
        $898b920ec66a29cf$var$_AssistantStream_currentRunStepSnapshot.set((0, $15Pju._)(_this), void 0);
        return _this;
    }
    (0, $6rpfc._)(AssistantStream, [
        {
            key: ($898b920ec66a29cf$var$_AssistantStream_events = new WeakMap(), $898b920ec66a29cf$var$_AssistantStream_runStepSnapshots = new WeakMap(), $898b920ec66a29cf$var$_AssistantStream_messageSnapshots = new WeakMap(), $898b920ec66a29cf$var$_AssistantStream_messageSnapshot = new WeakMap(), $898b920ec66a29cf$var$_AssistantStream_finalRun = new WeakMap(), $898b920ec66a29cf$var$_AssistantStream_currentContentIndex = new WeakMap(), $898b920ec66a29cf$var$_AssistantStream_currentContent = new WeakMap(), $898b920ec66a29cf$var$_AssistantStream_currentToolCallIndex = new WeakMap(), $898b920ec66a29cf$var$_AssistantStream_currentToolCall = new WeakMap(), $898b920ec66a29cf$var$_AssistantStream_currentEvent = new WeakMap(), $898b920ec66a29cf$var$_AssistantStream_currentRunSnapshot = new WeakMap(), $898b920ec66a29cf$var$_AssistantStream_currentRunStepSnapshot = new WeakMap(), $898b920ec66a29cf$var$_AssistantStream_instances = new WeakSet(), Symbol.asyncIterator),
            value: function value() {
                var pushQueue = [];
                var readQueue = [];
                var done = false;
                //Catch all for passing along all events
                this.on("event", function(event) {
                    var reader = readQueue.shift();
                    if (reader) reader.resolve(event);
                    else pushQueue.push(event);
                });
                this.on("end", function() {
                    done = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = readQueue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var reader = _step.value;
                            reader.resolve(undefined);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    readQueue.length = 0;
                });
                this.on("abort", function(err1) {
                    done = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = readQueue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var reader = _step.value;
                            reader.reject(err1);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    readQueue.length = 0;
                });
                this.on("error", function(err1) {
                    done = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = readQueue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var reader = _step.value;
                            reader.reject(err1);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    readQueue.length = 0;
                });
                var _this = this;
                return {
                    next: /*#__PURE__*/ (0, $9OZ9j._)(function() {
                        var chunk;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            if (!pushQueue.length) {
                                if (done) return [
                                    2,
                                    {
                                        value: undefined,
                                        done: true
                                    }
                                ];
                                return [
                                    2,
                                    new Promise(function(resolve, reject) {
                                        return readQueue.push({
                                            resolve: resolve,
                                            reject: reject
                                        });
                                    }).then(function(chunk) {
                                        return chunk ? {
                                            value: chunk,
                                            done: false
                                        } : {
                                            value: undefined,
                                            done: true
                                        };
                                    })
                                ];
                            }
                            chunk = pushQueue.shift();
                            return [
                                2,
                                {
                                    value: chunk,
                                    done: false
                                }
                            ];
                        });
                    }),
                    return: /*#__PURE__*/ (0, $9OZ9j._)(function() {
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            _this.abort();
                            return [
                                2,
                                {
                                    value: undefined,
                                    done: true
                                }
                            ];
                        });
                    })
                };
            }
        },
        {
            key: "_fromReadableStream",
            value: function _fromReadableStream(readableStream, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _stream_controller_signal, signal, stream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, event, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                signal = options === null || options === void 0 ? void 0 : options.signal;
                                if (signal) {
                                    if (signal.aborted) _this.controller.abort();
                                    signal.addEventListener("abort", function() {
                                        return _this.controller.abort();
                                    });
                                }
                                _this._connected();
                                stream = $8BEDZ.Stream.fromReadableStream(readableStream, _this.controller);
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    12
                                ]);
                                _iterator = (0, $gIbDP._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    5
                                ];
                                _value = _step.value;
                                event = _value;
                                $898b920ec66a29cf$var$__classPrivateFieldGet(_this, $898b920ec66a29cf$var$_AssistantStream_instances, "m", $898b920ec66a29cf$var$_AssistantStream_addEvent).call(_this, event);
                                _state.label = 4;
                            case 4:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    12
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    12
                                ];
                            case 7:
                                _state.trys.push([
                                    7,
                                    ,
                                    10,
                                    11
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 8:
                                _state.sent();
                                _state.label = 9;
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    7
                                ];
                            case 12:
                                if ((_stream_controller_signal = stream.controller.signal) === null || _stream_controller_signal === void 0 ? void 0 : _stream_controller_signal.aborted) throw new $kQ0uC.APIUserAbortError();
                                return [
                                    2,
                                    _this._addRun($898b920ec66a29cf$var$__classPrivateFieldGet(_this, $898b920ec66a29cf$var$_AssistantStream_instances, "m", $898b920ec66a29cf$var$_AssistantStream_endRequest).call(_this))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toReadableStream",
            value: function toReadableStream() {
                var stream = new $8BEDZ.Stream(this[Symbol.asyncIterator].bind(this), this.controller);
                return stream.toReadableStream();
            }
        },
        {
            key: "_createToolAssistantStream",
            value: function _createToolAssistantStream(run, threadId, runId, params, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _stream_controller_signal, signal, body, stream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, event, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                signal = options === null || options === void 0 ? void 0 : options.signal;
                                if (signal) {
                                    if (signal.aborted) _this.controller.abort();
                                    signal.addEventListener("abort", function() {
                                        return _this.controller.abort();
                                    });
                                }
                                body = (0, $ddevm._)((0, $78DQ7._)({}, params), {
                                    stream: true
                                });
                                return [
                                    4,
                                    run.submitToolOutputs(threadId, runId, body, (0, $ddevm._)((0, $78DQ7._)({}, options), {
                                        signal: _this.controller.signal
                                    }))
                                ];
                            case 1:
                                stream = _state.sent();
                                _this._connected();
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $gIbDP._)(stream);
                                _state.label = 3;
                            case 3:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 4:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                event = _value;
                                $898b920ec66a29cf$var$__classPrivateFieldGet(_this, $898b920ec66a29cf$var$_AssistantStream_instances, "m", $898b920ec66a29cf$var$_AssistantStream_addEvent).call(_this, event);
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                if ((_stream_controller_signal = stream.controller.signal) === null || _stream_controller_signal === void 0 ? void 0 : _stream_controller_signal.aborted) throw new $kQ0uC.APIUserAbortError();
                                return [
                                    2,
                                    _this._addRun($898b920ec66a29cf$var$__classPrivateFieldGet(_this, $898b920ec66a29cf$var$_AssistantStream_instances, "m", $898b920ec66a29cf$var$_AssistantStream_endRequest).call(_this))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "currentEvent",
            value: function currentEvent() {
                return $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentEvent, "f");
            }
        },
        {
            key: "currentRun",
            value: function currentRun() {
                return $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentRunSnapshot, "f");
            }
        },
        {
            key: "currentMessageSnapshot",
            value: function currentMessageSnapshot() {
                return $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_messageSnapshot, "f");
            }
        },
        {
            key: "currentRunStepSnapshot",
            value: function currentRunStepSnapshot() {
                return $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentRunStepSnapshot, "f");
            }
        },
        {
            key: "finalRunSteps",
            value: function finalRunSteps() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.done()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    Object.values($898b920ec66a29cf$var$__classPrivateFieldGet(_this, $898b920ec66a29cf$var$_AssistantStream_runStepSnapshots, "f"))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "finalMessages",
            value: function finalMessages() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.done()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    Object.values($898b920ec66a29cf$var$__classPrivateFieldGet(_this, $898b920ec66a29cf$var$_AssistantStream_messageSnapshots, "f"))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "finalRun",
            value: function finalRun() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.done()
                                ];
                            case 1:
                                _state.sent();
                                if (!$898b920ec66a29cf$var$__classPrivateFieldGet(_this, $898b920ec66a29cf$var$_AssistantStream_finalRun, "f")) throw Error("Final run was not received.");
                                return [
                                    2,
                                    $898b920ec66a29cf$var$__classPrivateFieldGet(_this, $898b920ec66a29cf$var$_AssistantStream_finalRun, "f")
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_createThreadAssistantStream",
            value: function _createThreadAssistantStream(thread, params, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _stream_controller_signal, signal, body, stream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, event, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                signal = options === null || options === void 0 ? void 0 : options.signal;
                                if (signal) {
                                    if (signal.aborted) _this.controller.abort();
                                    signal.addEventListener("abort", function() {
                                        return _this.controller.abort();
                                    });
                                }
                                body = (0, $ddevm._)((0, $78DQ7._)({}, params), {
                                    stream: true
                                });
                                return [
                                    4,
                                    thread.createAndRun(body, (0, $ddevm._)((0, $78DQ7._)({}, options), {
                                        signal: _this.controller.signal
                                    }))
                                ];
                            case 1:
                                stream = _state.sent();
                                _this._connected();
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $gIbDP._)(stream);
                                _state.label = 3;
                            case 3:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 4:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                event = _value;
                                $898b920ec66a29cf$var$__classPrivateFieldGet(_this, $898b920ec66a29cf$var$_AssistantStream_instances, "m", $898b920ec66a29cf$var$_AssistantStream_addEvent).call(_this, event);
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                if ((_stream_controller_signal = stream.controller.signal) === null || _stream_controller_signal === void 0 ? void 0 : _stream_controller_signal.aborted) throw new $kQ0uC.APIUserAbortError();
                                return [
                                    2,
                                    _this._addRun($898b920ec66a29cf$var$__classPrivateFieldGet(_this, $898b920ec66a29cf$var$_AssistantStream_instances, "m", $898b920ec66a29cf$var$_AssistantStream_endRequest).call(_this))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_createAssistantStream",
            value: function _createAssistantStream(run, threadId, params, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _stream_controller_signal, signal, body, stream, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, event, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                signal = options === null || options === void 0 ? void 0 : options.signal;
                                if (signal) {
                                    if (signal.aborted) _this.controller.abort();
                                    signal.addEventListener("abort", function() {
                                        return _this.controller.abort();
                                    });
                                }
                                body = (0, $ddevm._)((0, $78DQ7._)({}, params), {
                                    stream: true
                                });
                                return [
                                    4,
                                    run.create(threadId, body, (0, $ddevm._)((0, $78DQ7._)({}, options), {
                                        signal: _this.controller.signal
                                    }))
                                ];
                            case 1:
                                stream = _state.sent();
                                _this._connected();
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $gIbDP._)(stream);
                                _state.label = 3;
                            case 3:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 4:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                event = _value;
                                $898b920ec66a29cf$var$__classPrivateFieldGet(_this, $898b920ec66a29cf$var$_AssistantStream_instances, "m", $898b920ec66a29cf$var$_AssistantStream_addEvent).call(_this, event);
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                if ((_stream_controller_signal = stream.controller.signal) === null || _stream_controller_signal === void 0 ? void 0 : _stream_controller_signal.aborted) throw new $kQ0uC.APIUserAbortError();
                                return [
                                    2,
                                    _this._addRun($898b920ec66a29cf$var$__classPrivateFieldGet(_this, $898b920ec66a29cf$var$_AssistantStream_instances, "m", $898b920ec66a29cf$var$_AssistantStream_endRequest).call(_this))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_addRun",
            value: function _addRun(run) {
                return run;
            }
        },
        {
            key: "_threadAssistantStream",
            value: function _threadAssistantStream(params, thread, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._createThreadAssistantStream(thread, params, options)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_runAssistantStream",
            value: function _runAssistantStream(threadId, runs, params, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._createAssistantStream(runs, threadId, params, options)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_runToolAssistantStream",
            value: function _runToolAssistantStream(threadId, runId, runs, params, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._createToolAssistantStream(runs, threadId, runId, params, options)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "fromReadableStream",
            value: function fromReadableStream(stream) {
                var runner = new AssistantStream();
                runner._run(function() {
                    return runner._fromReadableStream(stream);
                });
                return runner;
            }
        },
        {
            key: "createToolAssistantStream",
            value: function createToolAssistantStream(threadId, runId, runs, params, options) {
                var runner = new AssistantStream();
                runner._run(function() {
                    return runner._runToolAssistantStream(threadId, runId, runs, params, (0, $ddevm._)((0, $78DQ7._)({}, options), {
                        headers: (0, $ddevm._)((0, $78DQ7._)({}, options === null || options === void 0 ? void 0 : options.headers), {
                            "X-Stainless-Helper-Method": "stream"
                        })
                    }));
                });
                return runner;
            }
        },
        {
            key: "createThreadAssistantStream",
            value: function createThreadAssistantStream(params, thread, options) {
                var runner = new AssistantStream();
                runner._run(function() {
                    return runner._threadAssistantStream(params, thread, (0, $ddevm._)((0, $78DQ7._)({}, options), {
                        headers: (0, $ddevm._)((0, $78DQ7._)({}, options === null || options === void 0 ? void 0 : options.headers), {
                            "X-Stainless-Helper-Method": "stream"
                        })
                    }));
                });
                return runner;
            }
        },
        {
            key: "createAssistantStream",
            value: function createAssistantStream(threadId, runs, params, options) {
                var runner = new AssistantStream();
                runner._run(function() {
                    return runner._runAssistantStream(threadId, runs, params, (0, $ddevm._)((0, $78DQ7._)({}, options), {
                        headers: (0, $ddevm._)((0, $78DQ7._)({}, options === null || options === void 0 ? void 0 : options.headers), {
                            "X-Stainless-Helper-Method": "stream"
                        })
                    }));
                });
                return runner;
            }
        },
        {
            key: "accumulateDelta",
            value: function accumulateDelta(acc, delta) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(delta)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $2MTYX._)(_step.value, 2), key = _step_value[0], deltaValue = _step_value[1];
                        if (!acc.hasOwnProperty(key)) {
                            acc[key] = deltaValue;
                            continue;
                        }
                        var accValue = acc[key];
                        if (accValue === null || accValue === undefined) {
                            acc[key] = deltaValue;
                            continue;
                        }
                        // We don't accumulate these special properties
                        if (key === "index" || key === "type") {
                            acc[key] = deltaValue;
                            continue;
                        }
                        // Type-specific accumulation logic
                        if (typeof accValue === "string" && typeof deltaValue === "string") accValue += deltaValue;
                        else if (typeof accValue === "number" && typeof deltaValue === "number") accValue += deltaValue;
                        else if ($898b920ec66a29cf$var$Core.isObj(accValue) && $898b920ec66a29cf$var$Core.isObj(deltaValue)) accValue = this.accumulateDelta(accValue, deltaValue);
                        else if (Array.isArray(accValue) && Array.isArray(deltaValue)) {
                            if (accValue.every(function(x) {
                                return typeof x === "string" || typeof x === "number";
                            })) {
                                var _accValue;
                                (_accValue = accValue).push.apply(_accValue, (0, $3jzhD._)(deltaValue)); // Use spread syntax for efficient addition
                                continue;
                            }
                        } else throw Error("Unhandled record type: ".concat(key, ", deltaValue: ").concat(deltaValue, ", accValue: ").concat(accValue));
                        acc[key] = accValue;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return acc;
            }
        }
    ]);
    return AssistantStream;
}($3RnC6.EventStream);
module.exports.AssistantStream = $898b920ec66a29cf$var$AssistantStream;
$898b920ec66a29cf$var$_AssistantStream_addEvent = function _AssistantStream_addEvent(event) {
    if (this.ended) return;
    $898b920ec66a29cf$var$__classPrivateFieldSet(this, $898b920ec66a29cf$var$_AssistantStream_currentEvent, event, "f");
    $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_instances, "m", $898b920ec66a29cf$var$_AssistantStream_handleEvent).call(this, event);
    switch(event.event){
        case "thread.created":
            break;
        case "thread.run.created":
        case "thread.run.queued":
        case "thread.run.in_progress":
        case "thread.run.requires_action":
        case "thread.run.completed":
        case "thread.run.failed":
        case "thread.run.cancelling":
        case "thread.run.cancelled":
        case "thread.run.expired":
            $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_instances, "m", $898b920ec66a29cf$var$_AssistantStream_handleRun).call(this, event);
            break;
        case "thread.run.step.created":
        case "thread.run.step.in_progress":
        case "thread.run.step.delta":
        case "thread.run.step.completed":
        case "thread.run.step.failed":
        case "thread.run.step.cancelled":
        case "thread.run.step.expired":
            $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_instances, "m", $898b920ec66a29cf$var$_AssistantStream_handleRunStep).call(this, event);
            break;
        case "thread.message.created":
        case "thread.message.in_progress":
        case "thread.message.delta":
        case "thread.message.completed":
        case "thread.message.incomplete":
            $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_instances, "m", $898b920ec66a29cf$var$_AssistantStream_handleMessage).call(this, event);
            break;
        case "error":
            //This is included for completeness, but errors are processed in the SSE event processing so this should not occur
            throw new Error("Encountered an error event in event processing - errors should be processed earlier");
    }
}, $898b920ec66a29cf$var$_AssistantStream_endRequest = function _AssistantStream_endRequest() {
    if (this.ended) throw new $kQ0uC.OpenAIError("stream has ended, this shouldn't happen");
    if (!$898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_finalRun, "f")) throw Error("Final run has not been received");
    return $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_finalRun, "f");
}, $898b920ec66a29cf$var$_AssistantStream_handleMessage = function _AssistantStream_handleMessage(event) {
    var __classPrivateFieldGet_call = (0, $2MTYX._)($898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_instances, "m", $898b920ec66a29cf$var$_AssistantStream_accumulateMessage).call(this, event, $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_messageSnapshot, "f")), 2), accumulatedMessage = __classPrivateFieldGet_call[0], newContent = __classPrivateFieldGet_call[1];
    $898b920ec66a29cf$var$__classPrivateFieldSet(this, $898b920ec66a29cf$var$_AssistantStream_messageSnapshot, accumulatedMessage, "f");
    $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_messageSnapshots, "f")[accumulatedMessage.id] = accumulatedMessage;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newContent[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var content = _step.value;
            var snapshotContent = accumulatedMessage.content[content.index];
            if ((snapshotContent === null || snapshotContent === void 0 ? void 0 : snapshotContent.type) == "text") this._emit("textCreated", snapshotContent.text);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    switch(event.event){
        case "thread.message.created":
            this._emit("messageCreated", event.data);
            break;
        case "thread.message.in_progress":
            break;
        case "thread.message.delta":
            this._emit("messageDelta", event.data.delta, accumulatedMessage);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (event.data.delta.content) try {
                for(var _iterator1 = event.data.delta.content[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var content1 = _step1.value;
                    //If it is text delta, emit a text delta event
                    if (content1.type == "text" && content1.text) {
                        var textDelta = content1.text;
                        var snapshot = accumulatedMessage.content[content1.index];
                        if (snapshot && snapshot.type == "text") this._emit("textDelta", textDelta, snapshot.text);
                        else throw Error("The snapshot associated with this text delta is not text or missing");
                    }
                    if (content1.index != $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentContentIndex, "f")) {
                        //See if we have in progress content
                        if ($898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentContent, "f")) switch($898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentContent, "f").type){
                            case "text":
                                this._emit("textDone", $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentContent, "f").text, $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_messageSnapshot, "f"));
                                break;
                            case "image_file":
                                this._emit("imageFileDone", $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentContent, "f").image_file, $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_messageSnapshot, "f"));
                                break;
                        }
                        $898b920ec66a29cf$var$__classPrivateFieldSet(this, $898b920ec66a29cf$var$_AssistantStream_currentContentIndex, content1.index, "f");
                    }
                    $898b920ec66a29cf$var$__classPrivateFieldSet(this, $898b920ec66a29cf$var$_AssistantStream_currentContent, accumulatedMessage.content[content1.index], "f");
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            break;
        case "thread.message.completed":
        case "thread.message.incomplete":
            //We emit the latest content we were working on on completion (including incomplete)
            if ($898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentContentIndex, "f") !== undefined) {
                var currentContent = event.data.content[$898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentContentIndex, "f")];
                if (currentContent) switch(currentContent.type){
                    case "image_file":
                        this._emit("imageFileDone", currentContent.image_file, $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_messageSnapshot, "f"));
                        break;
                    case "text":
                        this._emit("textDone", currentContent.text, $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_messageSnapshot, "f"));
                        break;
                }
            }
            if ($898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_messageSnapshot, "f")) this._emit("messageDone", event.data);
            $898b920ec66a29cf$var$__classPrivateFieldSet(this, $898b920ec66a29cf$var$_AssistantStream_messageSnapshot, undefined, "f");
    }
}, $898b920ec66a29cf$var$_AssistantStream_handleRunStep = function _AssistantStream_handleRunStep(event) {
    var accumulatedRunStep = $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_instances, "m", $898b920ec66a29cf$var$_AssistantStream_accumulateRunStep).call(this, event);
    $898b920ec66a29cf$var$__classPrivateFieldSet(this, $898b920ec66a29cf$var$_AssistantStream_currentRunStepSnapshot, accumulatedRunStep, "f");
    switch(event.event){
        case "thread.run.step.created":
            this._emit("runStepCreated", event.data);
            break;
        case "thread.run.step.delta":
            var delta = event.data.delta;
            if (delta.step_details && delta.step_details.type == "tool_calls" && delta.step_details.tool_calls && accumulatedRunStep.step_details.type == "tool_calls") {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = delta.step_details.tool_calls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var toolCall = _step.value;
                        if (toolCall.index == $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentToolCallIndex, "f")) this._emit("toolCallDelta", toolCall, accumulatedRunStep.step_details.tool_calls[toolCall.index]);
                        else {
                            if ($898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentToolCall, "f")) this._emit("toolCallDone", $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentToolCall, "f"));
                            $898b920ec66a29cf$var$__classPrivateFieldSet(this, $898b920ec66a29cf$var$_AssistantStream_currentToolCallIndex, toolCall.index, "f");
                            $898b920ec66a29cf$var$__classPrivateFieldSet(this, $898b920ec66a29cf$var$_AssistantStream_currentToolCall, accumulatedRunStep.step_details.tool_calls[toolCall.index], "f");
                            if ($898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentToolCall, "f")) this._emit("toolCallCreated", $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentToolCall, "f"));
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            this._emit("runStepDelta", event.data.delta, accumulatedRunStep);
            break;
        case "thread.run.step.completed":
        case "thread.run.step.failed":
        case "thread.run.step.cancelled":
        case "thread.run.step.expired":
            $898b920ec66a29cf$var$__classPrivateFieldSet(this, $898b920ec66a29cf$var$_AssistantStream_currentRunStepSnapshot, undefined, "f");
            var details = event.data.step_details;
            if (details.type == "tool_calls") {
                if ($898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentToolCall, "f")) {
                    this._emit("toolCallDone", $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentToolCall, "f"));
                    $898b920ec66a29cf$var$__classPrivateFieldSet(this, $898b920ec66a29cf$var$_AssistantStream_currentToolCall, undefined, "f");
                }
            }
            this._emit("runStepDone", event.data, accumulatedRunStep);
            break;
        case "thread.run.step.in_progress":
            break;
    }
}, $898b920ec66a29cf$var$_AssistantStream_handleEvent = function _AssistantStream_handleEvent(event) {
    $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_events, "f").push(event);
    this._emit("event", event);
}, $898b920ec66a29cf$var$_AssistantStream_accumulateRunStep = function _AssistantStream_accumulateRunStep(event) {
    switch(event.event){
        case "thread.run.step.created":
            $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_runStepSnapshots, "f")[event.data.id] = event.data;
            return event.data;
        case "thread.run.step.delta":
            var snapshot = $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_runStepSnapshots, "f")[event.data.id];
            if (!snapshot) throw Error("Received a RunStepDelta before creation of a snapshot");
            var data = event.data;
            if (data.delta) {
                var accumulated = $898b920ec66a29cf$var$AssistantStream.accumulateDelta(snapshot, data.delta);
                $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_runStepSnapshots, "f")[event.data.id] = accumulated;
            }
            return $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_runStepSnapshots, "f")[event.data.id];
        case "thread.run.step.completed":
        case "thread.run.step.failed":
        case "thread.run.step.cancelled":
        case "thread.run.step.expired":
        case "thread.run.step.in_progress":
            $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_runStepSnapshots, "f")[event.data.id] = event.data;
            break;
    }
    if ($898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_runStepSnapshots, "f")[event.data.id]) return $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_runStepSnapshots, "f")[event.data.id];
    throw new Error("No snapshot available");
}, $898b920ec66a29cf$var$_AssistantStream_accumulateMessage = function _AssistantStream_accumulateMessage(event, snapshot) {
    var newContent = [];
    switch(event.event){
        case "thread.message.created":
            //On creation the snapshot is just the initial message
            return [
                event.data,
                newContent
            ];
        case "thread.message.delta":
            if (!snapshot) throw Error("Received a delta with no existing snapshot (there should be one from message creation)");
            var data = event.data;
            //If this delta does not have content, nothing to process
            if (data.delta.content) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = data.delta.content[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var contentElement = _step.value;
                        if (contentElement.index in snapshot.content) {
                            var currentContent = snapshot.content[contentElement.index];
                            snapshot.content[contentElement.index] = $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_instances, "m", $898b920ec66a29cf$var$_AssistantStream_accumulateContent).call(this, contentElement, currentContent);
                        } else {
                            snapshot.content[contentElement.index] = contentElement;
                            // This is a new element
                            newContent.push(contentElement);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return [
                snapshot,
                newContent
            ];
        case "thread.message.in_progress":
        case "thread.message.completed":
        case "thread.message.incomplete":
            //No changes on other thread events
            if (snapshot) return [
                snapshot,
                newContent
            ];
            else throw Error("Received thread message event with no existing snapshot");
    }
    throw Error("Tried to accumulate a non-message event");
}, $898b920ec66a29cf$var$_AssistantStream_accumulateContent = function _AssistantStream_accumulateContent(contentElement, currentContent) {
    return $898b920ec66a29cf$var$AssistantStream.accumulateDelta(currentContent, contentElement);
}, $898b920ec66a29cf$var$_AssistantStream_handleRun = function _AssistantStream_handleRun(event) {
    $898b920ec66a29cf$var$__classPrivateFieldSet(this, $898b920ec66a29cf$var$_AssistantStream_currentRunSnapshot, event.data, "f");
    switch(event.event){
        case "thread.run.created":
            break;
        case "thread.run.queued":
            break;
        case "thread.run.in_progress":
            break;
        case "thread.run.requires_action":
        case "thread.run.cancelled":
        case "thread.run.failed":
        case "thread.run.completed":
        case "thread.run.expired":
            $898b920ec66a29cf$var$__classPrivateFieldSet(this, $898b920ec66a29cf$var$_AssistantStream_finalRun, event.data, "f");
            if ($898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentToolCall, "f")) {
                this._emit("toolCallDone", $898b920ec66a29cf$var$__classPrivateFieldGet(this, $898b920ec66a29cf$var$_AssistantStream_currentToolCall, "f"));
                $898b920ec66a29cf$var$__classPrivateFieldSet(this, $898b920ec66a29cf$var$_AssistantStream_currentToolCall, undefined, "f");
            }
            break;
        case "thread.run.cancelling":
            break;
    }
};

});

parcelRegister("5xx3z", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $4089ad26324659e7$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4089ad26324659e7$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4089ad26324659e7$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4089ad26324659e7$var$__createBinding(result, mod, k);
    }
    $4089ad26324659e7$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MessagesPage = module.exports.Messages = void 0;

var $26X5G = parcelRequire("26X5G");

var $c8Tp0 = parcelRequire("c8Tp0");

var $4089ad26324659e7$var$MessagesAPI = $4089ad26324659e7$var$__importStar(module.exports);

var $4ux0n = parcelRequire("4ux0n");
var $4089ad26324659e7$var$Messages = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Messages, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Messages);
    function Messages() {
        (0, $19mwo._)(this, Messages);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Messages, [
        {
            /**
     * Create a message.
     */ key: "create",
            value: function create(threadId, body, options) {
                return this._client.post("/threads/".concat(threadId, "/messages"), (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Retrieve a message.
     */ key: "retrieve",
            value: function retrieve(threadId, messageId, options) {
                return this._client.get("/threads/".concat(threadId, "/messages/").concat(messageId), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Modifies a message.
     */ key: "update",
            value: function update(threadId, messageId, body, options) {
                return this._client.post("/threads/".concat(threadId, "/messages/").concat(messageId), (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            key: "list",
            value: function list(threadId) {
                var query = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, options = arguments.length > 2 ? arguments[2] : void 0;
                if ((0, $c8Tp0.isRequestOptions)(query)) return this.list(threadId, {}, query);
                return this._client.getAPIList("/threads/".concat(threadId, "/messages"), $4089ad26324659e7$var$MessagesPage, (0, $ddevm._)((0, $78DQ7._)({
                    query: query
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Deletes a message.
     */ key: "del",
            value: function del(threadId, messageId, options) {
                return this._client.delete("/threads/".concat(threadId, "/messages/").concat(messageId), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        }
    ]);
    return Messages;
}($26X5G.APIResource);
module.exports.Messages = $4089ad26324659e7$var$Messages;
var $4089ad26324659e7$var$MessagesPage = /*#__PURE__*/ function(_pagination_1_CursorPage) {
    (0, $iNfU4._)(MessagesPage, _pagination_1_CursorPage);
    var _super = (0, $k1NN5._)(MessagesPage);
    function MessagesPage() {
        (0, $19mwo._)(this, MessagesPage);
        return _super.apply(this, arguments);
    }
    return MessagesPage;
}($4ux0n.CursorPage);
module.exports.MessagesPage = $4089ad26324659e7$var$MessagesPage;
(function(Messages) {
    Messages.MessagesPage = $4089ad26324659e7$var$MessagesAPI.MessagesPage;
})($4089ad26324659e7$var$Messages = module.exports.Messages || (module.exports.Messages = {}));

});

parcelRegister("jyUnt", function(module, exports) {

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $03acda8725e12f86$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $03acda8725e12f86$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $03acda8725e12f86$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $03acda8725e12f86$var$__createBinding(result, mod, k);
    }
    $03acda8725e12f86$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RunsPage = module.exports.Runs = void 0;

var $26X5G = parcelRequire("26X5G");

var $c8Tp0 = parcelRequire("c8Tp0");

var $bO9i3 = parcelRequire("bO9i3");

var $c8Tp0 = parcelRequire("c8Tp0");

var $03acda8725e12f86$var$RunsAPI = $03acda8725e12f86$var$__importStar(module.exports);

var $03acda8725e12f86$var$StepsAPI = $03acda8725e12f86$var$__importStar((parcelRequire("iAb8W")));

var $4ux0n = parcelRequire("4ux0n");
var $03acda8725e12f86$var$Runs = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Runs, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Runs);
    function Runs() {
        (0, $19mwo._)(this, Runs);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.steps = new $03acda8725e12f86$var$StepsAPI.Steps(_this._client);
        return _this;
    }
    (0, $6rpfc._)(Runs, [
        {
            key: "create",
            value: function create(threadId, body, options) {
                var _body_stream;
                return this._client.post("/threads/".concat(threadId, "/runs"), (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers),
                    stream: (_body_stream = body.stream) !== null && _body_stream !== void 0 ? _body_stream : false
                }));
            }
        },
        {
            /**
     * Retrieves a run.
     */ key: "retrieve",
            value: function retrieve(threadId, runId, options) {
                return this._client.get("/threads/".concat(threadId, "/runs/").concat(runId), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Modifies a run.
     */ key: "update",
            value: function update(threadId, runId, body, options) {
                return this._client.post("/threads/".concat(threadId, "/runs/").concat(runId), (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            key: "list",
            value: function list(threadId) {
                var query = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, options = arguments.length > 2 ? arguments[2] : void 0;
                if ((0, $c8Tp0.isRequestOptions)(query)) return this.list(threadId, {}, query);
                return this._client.getAPIList("/threads/".concat(threadId, "/runs"), $03acda8725e12f86$var$RunsPage, (0, $ddevm._)((0, $78DQ7._)({
                    query: query
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Cancels a run that is `in_progress`.
     */ key: "cancel",
            value: function cancel(threadId, runId, options) {
                return this._client.post("/threads/".concat(threadId, "/runs/").concat(runId, "/cancel"), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            key: "createAndPoll",
            value: /**
     * A helper to create a run an poll for a terminal state. More information on Run
     * lifecycles can be found here:
     * https://platform.openai.com/docs/assistants/how-it-works/runs-and-run-steps
     */ function createAndPoll(threadId, body, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var run;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.create(threadId, body, options)
                                ];
                            case 1:
                                run = _state.sent();
                                return [
                                    4,
                                    _this.poll(threadId, run.id, options)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Create a Run stream
     *
     * @deprecated use `stream` instead
     */ key: "createAndStream",
            value: function createAndStream(threadId, body, options) {
                return $bO9i3.AssistantStream.createAssistantStream(threadId, this._client.beta.threads.runs, body, options);
            }
        },
        {
            key: "poll",
            value: /**
     * A helper to poll a run status until it reaches a terminal state. More
     * information on Run lifecycles can be found here:
     * https://platform.openai.com/docs/assistants/how-it-works/runs-and-run-steps
     */ function poll(threadId, runId, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var headers, _ref, run, response, _, sleepInterval, headerInterval, headerIntervalMs;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = (0, $ddevm._)((0, $78DQ7._)({}, options === null || options === void 0 ? void 0 : options.headers), {
                                    "X-Stainless-Poll-Helper": "true"
                                });
                                if (options === null || options === void 0 ? void 0 : options.pollIntervalMs) headers["X-Stainless-Custom-Poll-Interval"] = options.pollIntervalMs.toString();
                                _state.label = 1;
                            case 1:
                                if (!true) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    _this.retrieve(threadId, runId, (0, $ddevm._)((0, $78DQ7._)({}, options), {
                                        headers: (0, $78DQ7._)({}, options === null || options === void 0 ? void 0 : options.headers, headers)
                                    })).withResponse()
                                ];
                            case 2:
                                _ref = _state.sent(), run = _ref.data, response = _ref.response;
                                _ = run.status;
                                switch(_){
                                    case "queued":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "in_progress":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "cancelling":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "requires_action":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "incomplete":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "cancelled":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "completed":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "failed":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "expired":
                                        return [
                                            3,
                                            5
                                        ];
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                sleepInterval = 5000;
                                if (options === null || options === void 0 ? void 0 : options.pollIntervalMs) sleepInterval = options.pollIntervalMs;
                                else {
                                    headerInterval = response.headers.get("openai-poll-after-ms");
                                    if (headerInterval) {
                                        headerIntervalMs = parseInt(headerInterval);
                                        if (!isNaN(headerIntervalMs)) sleepInterval = headerIntervalMs;
                                    }
                                }
                                return [
                                    4,
                                    (0, $c8Tp0.sleep)(sleepInterval)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                return [
                                    2,
                                    run
                                ];
                            case 6:
                                return [
                                    3,
                                    1
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Create a Run stream
     */ key: "stream",
            value: function stream(threadId, body, options) {
                return $bO9i3.AssistantStream.createAssistantStream(threadId, this._client.beta.threads.runs, body, options);
            }
        },
        {
            key: "submitToolOutputs",
            value: function submitToolOutputs(threadId, runId, body, options) {
                var _body_stream;
                return this._client.post("/threads/".concat(threadId, "/runs/").concat(runId, "/submit_tool_outputs"), (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers),
                    stream: (_body_stream = body.stream) !== null && _body_stream !== void 0 ? _body_stream : false
                }));
            }
        },
        {
            key: "submitToolOutputsAndPoll",
            value: /**
     * A helper to submit a tool output to a run and poll for a terminal run state.
     * More information on Run lifecycles can be found here:
     * https://platform.openai.com/docs/assistants/how-it-works/runs-and-run-steps
     */ function submitToolOutputsAndPoll(threadId, runId, body, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var run;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.submitToolOutputs(threadId, runId, body, options)
                                ];
                            case 1:
                                run = _state.sent();
                                return [
                                    4,
                                    _this.poll(threadId, run.id, options)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Submit the tool outputs from a previous run and stream the run to a terminal
     * state. More information on Run lifecycles can be found here:
     * https://platform.openai.com/docs/assistants/how-it-works/runs-and-run-steps
     */ key: "submitToolOutputsStream",
            value: function submitToolOutputsStream(threadId, runId, body, options) {
                return $bO9i3.AssistantStream.createToolAssistantStream(threadId, runId, this._client.beta.threads.runs, body, options);
            }
        }
    ]);
    return Runs;
}($26X5G.APIResource);
module.exports.Runs = $03acda8725e12f86$var$Runs;
var $03acda8725e12f86$var$RunsPage = /*#__PURE__*/ function(_pagination_1_CursorPage) {
    (0, $iNfU4._)(RunsPage, _pagination_1_CursorPage);
    var _super = (0, $k1NN5._)(RunsPage);
    function RunsPage() {
        (0, $19mwo._)(this, RunsPage);
        return _super.apply(this, arguments);
    }
    return RunsPage;
}($4ux0n.CursorPage);
module.exports.RunsPage = $03acda8725e12f86$var$RunsPage;
(function(Runs) {
    Runs.RunsPage = $03acda8725e12f86$var$RunsAPI.RunsPage;
    Runs.Steps = $03acda8725e12f86$var$StepsAPI.Steps;
    Runs.RunStepsPage = $03acda8725e12f86$var$StepsAPI.RunStepsPage;
})($03acda8725e12f86$var$Runs = module.exports.Runs || (module.exports.Runs = {}));

});
parcelRegister("iAb8W", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $d8743b9b621a874a$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d8743b9b621a874a$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d8743b9b621a874a$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d8743b9b621a874a$var$__createBinding(result, mod, k);
    }
    $d8743b9b621a874a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RunStepsPage = module.exports.Steps = void 0;

var $26X5G = parcelRequire("26X5G");

var $c8Tp0 = parcelRequire("c8Tp0");

var $d8743b9b621a874a$var$StepsAPI = $d8743b9b621a874a$var$__importStar(module.exports);

var $4ux0n = parcelRequire("4ux0n");
var $d8743b9b621a874a$var$Steps = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Steps, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Steps);
    function Steps() {
        (0, $19mwo._)(this, Steps);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Steps, [
        {
            /**
     * Retrieves a run step.
     */ key: "retrieve",
            value: function retrieve(threadId, runId, stepId, options) {
                return this._client.get("/threads/".concat(threadId, "/runs/").concat(runId, "/steps/").concat(stepId), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            key: "list",
            value: function list(threadId, runId) {
                var query = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, options = arguments.length > 3 ? arguments[3] : void 0;
                if ((0, $c8Tp0.isRequestOptions)(query)) return this.list(threadId, runId, {}, query);
                return this._client.getAPIList("/threads/".concat(threadId, "/runs/").concat(runId, "/steps"), $d8743b9b621a874a$var$RunStepsPage, (0, $ddevm._)((0, $78DQ7._)({
                    query: query
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        }
    ]);
    return Steps;
}($26X5G.APIResource);
module.exports.Steps = $d8743b9b621a874a$var$Steps;
var $d8743b9b621a874a$var$RunStepsPage = /*#__PURE__*/ function(_pagination_1_CursorPage) {
    (0, $iNfU4._)(RunStepsPage, _pagination_1_CursorPage);
    var _super = (0, $k1NN5._)(RunStepsPage);
    function RunStepsPage() {
        (0, $19mwo._)(this, RunStepsPage);
        return _super.apply(this, arguments);
    }
    return RunStepsPage;
}($4ux0n.CursorPage);
module.exports.RunStepsPage = $d8743b9b621a874a$var$RunStepsPage;
(function(Steps) {
    Steps.RunStepsPage = $d8743b9b621a874a$var$StepsAPI.RunStepsPage;
})($d8743b9b621a874a$var$Steps = module.exports.Steps || (module.exports.Steps = {}));

});



parcelRegister("j1skS", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $0392e79995d83e24$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0392e79995d83e24$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0392e79995d83e24$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0392e79995d83e24$var$__createBinding(result, mod, k);
    }
    $0392e79995d83e24$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VectorStoresPage = module.exports.VectorStores = void 0;

var $26X5G = parcelRequire("26X5G");

var $c8Tp0 = parcelRequire("c8Tp0");

var $0392e79995d83e24$var$VectorStoresAPI = $0392e79995d83e24$var$__importStar(module.exports);

var $0392e79995d83e24$var$FileBatchesAPI = $0392e79995d83e24$var$__importStar((parcelRequire("i1A7q")));

var $0392e79995d83e24$var$FilesAPI = $0392e79995d83e24$var$__importStar((parcelRequire("1jrwO")));

var $4ux0n = parcelRequire("4ux0n");
var $0392e79995d83e24$var$VectorStores = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(VectorStores, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(VectorStores);
    function VectorStores() {
        (0, $19mwo._)(this, VectorStores);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.files = new $0392e79995d83e24$var$FilesAPI.Files(_this._client);
        _this.fileBatches = new $0392e79995d83e24$var$FileBatchesAPI.FileBatches(_this._client);
        return _this;
    }
    (0, $6rpfc._)(VectorStores, [
        {
            /**
     * Create a vector store.
     */ key: "create",
            value: function create(body, options) {
                return this._client.post("/vector_stores", (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Retrieves a vector store.
     */ key: "retrieve",
            value: function retrieve(vectorStoreId, options) {
                return this._client.get("/vector_stores/".concat(vectorStoreId), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Modifies a vector store.
     */ key: "update",
            value: function update(vectorStoreId, body, options) {
                return this._client.post("/vector_stores/".concat(vectorStoreId), (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            key: "list",
            value: function list() {
                var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, options = arguments.length > 1 ? arguments[1] : void 0;
                if ((0, $c8Tp0.isRequestOptions)(query)) return this.list({}, query);
                return this._client.getAPIList("/vector_stores", $0392e79995d83e24$var$VectorStoresPage, (0, $ddevm._)((0, $78DQ7._)({
                    query: query
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Delete a vector store.
     */ key: "del",
            value: function del(vectorStoreId, options) {
                return this._client.delete("/vector_stores/".concat(vectorStoreId), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        }
    ]);
    return VectorStores;
}($26X5G.APIResource);
module.exports.VectorStores = $0392e79995d83e24$var$VectorStores;
var $0392e79995d83e24$var$VectorStoresPage = /*#__PURE__*/ function(_pagination_1_CursorPage) {
    (0, $iNfU4._)(VectorStoresPage, _pagination_1_CursorPage);
    var _super = (0, $k1NN5._)(VectorStoresPage);
    function VectorStoresPage() {
        (0, $19mwo._)(this, VectorStoresPage);
        return _super.apply(this, arguments);
    }
    return VectorStoresPage;
}($4ux0n.CursorPage);
module.exports.VectorStoresPage = $0392e79995d83e24$var$VectorStoresPage;
(function(VectorStores) {
    VectorStores.VectorStoresPage = $0392e79995d83e24$var$VectorStoresAPI.VectorStoresPage;
    VectorStores.Files = $0392e79995d83e24$var$FilesAPI.Files;
    VectorStores.VectorStoreFilesPage = $0392e79995d83e24$var$FilesAPI.VectorStoreFilesPage;
    VectorStores.FileBatches = $0392e79995d83e24$var$FileBatchesAPI.FileBatches;
})($0392e79995d83e24$var$VectorStores = module.exports.VectorStores || (module.exports.VectorStores = {}));

});
parcelRegister("i1A7q", function(module, exports) {

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $3jzhD = parcelRequire("3jzhD");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VectorStoreFilesPage = module.exports.FileBatches = void 0;

var $26X5G = parcelRequire("26X5G");

var $c8Tp0 = parcelRequire("c8Tp0");

var $c8Tp0 = parcelRequire("c8Tp0");

var $eMFu7 = parcelRequire("eMFu7");

var $1jrwO = parcelRequire("1jrwO");
Object.defineProperty(module.exports, "VectorStoreFilesPage", {
    enumerable: true,
    get: function get() {
        return $1jrwO.VectorStoreFilesPage;
    }
});
var $d1f4566cf24c236d$var$FileBatches = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(FileBatches, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(FileBatches);
    function FileBatches() {
        (0, $19mwo._)(this, FileBatches);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(FileBatches, [
        {
            /**
     * Create a vector store file batch.
     */ key: "create",
            value: function create(vectorStoreId, body, options) {
                return this._client.post("/vector_stores/".concat(vectorStoreId, "/file_batches"), (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Retrieves a vector store file batch.
     */ key: "retrieve",
            value: function retrieve(vectorStoreId, batchId, options) {
                return this._client.get("/vector_stores/".concat(vectorStoreId, "/file_batches/").concat(batchId), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Cancel a vector store file batch. This attempts to cancel the processing of
     * files in this batch as soon as possible.
     */ key: "cancel",
            value: function cancel(vectorStoreId, batchId, options) {
                return this._client.post("/vector_stores/".concat(vectorStoreId, "/file_batches/").concat(batchId, "/cancel"), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            key: "createAndPoll",
            value: /**
     * Create a vector store batch and poll until all files have been processed.
     */ function createAndPoll(vectorStoreId, body, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var batch;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.create(vectorStoreId, body)
                                ];
                            case 1:
                                batch = _state.sent();
                                return [
                                    4,
                                    _this.poll(vectorStoreId, batch.id, options)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "listFiles",
            value: function listFiles(vectorStoreId, batchId) {
                var query = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, options = arguments.length > 3 ? arguments[3] : void 0;
                if ((0, $c8Tp0.isRequestOptions)(query)) return this.listFiles(vectorStoreId, batchId, {}, query);
                return this._client.getAPIList("/vector_stores/".concat(vectorStoreId, "/file_batches/").concat(batchId, "/files"), $1jrwO.VectorStoreFilesPage, (0, $ddevm._)((0, $78DQ7._)({
                    query: query
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            key: "poll",
            value: /**
     * Wait for the given file batch to be processed.
     *
     * Note: this will return even if one of the files failed to process, you need to
     * check batch.file_counts.failed_count to handle this case.
     */ function poll(vectorStoreId, batchId, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var headers, _ref, batch, response, _, sleepInterval, headerInterval, headerIntervalMs;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = (0, $ddevm._)((0, $78DQ7._)({}, options === null || options === void 0 ? void 0 : options.headers), {
                                    "X-Stainless-Poll-Helper": "true"
                                });
                                if (options === null || options === void 0 ? void 0 : options.pollIntervalMs) headers["X-Stainless-Custom-Poll-Interval"] = options.pollIntervalMs.toString();
                                _state.label = 1;
                            case 1:
                                if (!true) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    _this.retrieve(vectorStoreId, batchId, (0, $ddevm._)((0, $78DQ7._)({}, options), {
                                        headers: headers
                                    })).withResponse()
                                ];
                            case 2:
                                _ref = _state.sent(), batch = _ref.data, response = _ref.response;
                                _ = batch.status;
                                switch(_){
                                    case "in_progress":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "failed":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "cancelled":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "completed":
                                        return [
                                            3,
                                            5
                                        ];
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                sleepInterval = 5000;
                                if (options === null || options === void 0 ? void 0 : options.pollIntervalMs) sleepInterval = options.pollIntervalMs;
                                else {
                                    headerInterval = response.headers.get("openai-poll-after-ms");
                                    if (headerInterval) {
                                        headerIntervalMs = parseInt(headerInterval);
                                        if (!isNaN(headerIntervalMs)) sleepInterval = headerIntervalMs;
                                    }
                                }
                                return [
                                    4,
                                    (0, $c8Tp0.sleep)(sleepInterval)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                return [
                                    2,
                                    batch
                                ];
                            case 6:
                                return [
                                    3,
                                    1
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "uploadAndPoll",
            value: /**
     * Uploads the given files concurrently and then creates a vector store file batch.
     *
     * The concurrency limit is configurable using the `maxConcurrency` parameter.
     */ function uploadAndPoll(vectorStoreId, param, options) {
                var files = param.files, _param_fileIds = param.fileIds, fileIds = _param_fileIds === void 0 ? [] : _param_fileIds;
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _options_maxConcurrency, configuredConcurrency, concurrencyLimit, client, fileIterator, allFileIds, workers;
                    function processFiles(iterator) {
                        return _processFiles.apply(this, arguments);
                    }
                    function _processFiles() {
                        _processFiles = // This code is based on this design. The libraries don't accommodate our environment limits.
                        // https://stackoverflow.com/questions/40639432/what-is-the-best-way-to-limit-concurrency-when-using-es6s-promise-all
                        (0, $9OZ9j._)(function(iterator) {
                            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, fileObj, err;
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            7,
                                            8
                                        ]);
                                        _iterator = iterator[Symbol.iterator]();
                                        _state.label = 2;
                                    case 2:
                                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                            3,
                                            5
                                        ];
                                        item = _step.value;
                                        return [
                                            4,
                                            client.files.create({
                                                file: item,
                                                purpose: "assistants"
                                            }, options)
                                        ];
                                    case 3:
                                        fileObj = _state.sent();
                                        allFileIds.push(fileObj.id);
                                        _state.label = 4;
                                    case 4:
                                        _iteratorNormalCompletion = true;
                                        return [
                                            3,
                                            2
                                        ];
                                    case 5:
                                        return [
                                            3,
                                            8
                                        ];
                                    case 6:
                                        err = _state.sent();
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                        return [
                                            3,
                                            8
                                        ];
                                    case 7:
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                        return [
                                            7
                                        ];
                                    case 8:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return _processFiles.apply(this, arguments);
                    }
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (files == null || files.length == 0) throw new Error("No `files` provided to process. If you've already uploaded files you should use `.createAndPoll()` instead");
                                configuredConcurrency = (_options_maxConcurrency = options === null || options === void 0 ? void 0 : options.maxConcurrency) !== null && _options_maxConcurrency !== void 0 ? _options_maxConcurrency : 5;
                                // We cap the number of workers at the number of files (so we don't start any unnecessary workers)
                                concurrencyLimit = Math.min(configuredConcurrency, files.length);
                                client = _this._client;
                                fileIterator = files.values();
                                allFileIds = (0, $3jzhD._)(fileIds);
                                // Start workers to process results
                                workers = Array(concurrencyLimit).fill(fileIterator).map(processFiles);
                                // Wait for all processing to complete.
                                return [
                                    4,
                                    (0, $eMFu7.allSettledWithThrow)(workers)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.createAndPoll(vectorStoreId, {
                                        file_ids: allFileIds
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return FileBatches;
}($26X5G.APIResource);
module.exports.FileBatches = $d1f4566cf24c236d$var$FileBatches;
$d1f4566cf24c236d$var$FileBatches = module.exports.FileBatches || (module.exports.FileBatches = {});

});
parcelRegister("eMFu7", function(module, exports) {

var $9OZ9j = parcelRequire("9OZ9j");

var $lF1I7 = parcelRequire("lF1I7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.allSettledWithThrow = void 0;
/**
 * Like `Promise.allSettled()` but throws an error if any promises are rejected.
 */ var $ac35ba66e18afa24$var$allSettledWithThrow = function() {
    var _ref = (0, $9OZ9j._)(function(promises) {
        var results, rejected, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, result, values, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, result1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.allSettled(promises)
                    ];
                case 1:
                    results = _state.sent();
                    rejected = results.filter(function(result) {
                        return result.status === "rejected";
                    });
                    if (rejected.length) {
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = rejected[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                result = _step.value;
                                console.error(result.reason);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        throw new Error("".concat(rejected.length, " promise(s) failed - see the above errors"));
                    }
                    // Note: TS was complaining about using `.filter().map()` here for some reason
                    values = [];
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = results[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            result1 = _step1.value;
                            if (result1.status === "fulfilled") values.push(result1.value);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return [
                        2,
                        values
                    ];
            }
        });
    });
    return function allSettledWithThrow(promises) {
        return _ref.apply(this, arguments);
    };
}();
module.exports.allSettledWithThrow = $ac35ba66e18afa24$var$allSettledWithThrow;

});

parcelRegister("1jrwO", function(module, exports) {

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $0f4ceb51129a6594$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0f4ceb51129a6594$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0f4ceb51129a6594$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0f4ceb51129a6594$var$__createBinding(result, mod, k);
    }
    $0f4ceb51129a6594$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VectorStoreFilesPage = module.exports.Files = void 0;

var $26X5G = parcelRequire("26X5G");

var $c8Tp0 = parcelRequire("c8Tp0");

var $0f4ceb51129a6594$var$FilesAPI = $0f4ceb51129a6594$var$__importStar(module.exports);

var $4ux0n = parcelRequire("4ux0n");
var $0f4ceb51129a6594$var$Files = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Files, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Files);
    function Files() {
        (0, $19mwo._)(this, Files);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Files, [
        {
            /**
     * Create a vector store file by attaching a
     * [File](https://platform.openai.com/docs/api-reference/files) to a
     * [vector store](https://platform.openai.com/docs/api-reference/vector-stores/object).
     */ key: "create",
            value: function create(vectorStoreId, body, options) {
                return this._client.post("/vector_stores/".concat(vectorStoreId, "/files"), (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Retrieves a vector store file.
     */ key: "retrieve",
            value: function retrieve(vectorStoreId, fileId, options) {
                return this._client.get("/vector_stores/".concat(vectorStoreId, "/files/").concat(fileId), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            key: "list",
            value: function list(vectorStoreId) {
                var query = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, options = arguments.length > 2 ? arguments[2] : void 0;
                if ((0, $c8Tp0.isRequestOptions)(query)) return this.list(vectorStoreId, {}, query);
                return this._client.getAPIList("/vector_stores/".concat(vectorStoreId, "/files"), $0f4ceb51129a6594$var$VectorStoreFilesPage, (0, $ddevm._)((0, $78DQ7._)({
                    query: query
                }, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            /**
     * Delete a vector store file. This will remove the file from the vector store but
     * the file itself will not be deleted. To delete the file, use the
     * [delete file](https://platform.openai.com/docs/api-reference/files/delete)
     * endpoint.
     */ key: "del",
            value: function del(vectorStoreId, fileId, options) {
                return this._client.delete("/vector_stores/".concat(vectorStoreId, "/files/").concat(fileId), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        "OpenAI-Beta": "assistants=v2"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            key: "createAndPoll",
            value: /**
     * Attach a file to the given vector store and wait for it to be processed.
     */ function createAndPoll(vectorStoreId, body, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var file;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.create(vectorStoreId, body, options)
                                ];
                            case 1:
                                file = _state.sent();
                                return [
                                    4,
                                    _this.poll(vectorStoreId, file.id, options)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "poll",
            value: /**
     * Wait for the vector store file to finish processing.
     *
     * Note: this will return even if the file failed to process, you need to check
     * file.last_error and file.status to handle these cases
     */ function poll(vectorStoreId, fileId, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var headers, fileResponse, file, _, sleepInterval, headerInterval, headerIntervalMs;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = (0, $ddevm._)((0, $78DQ7._)({}, options === null || options === void 0 ? void 0 : options.headers), {
                                    "X-Stainless-Poll-Helper": "true"
                                });
                                if (options === null || options === void 0 ? void 0 : options.pollIntervalMs) headers["X-Stainless-Custom-Poll-Interval"] = options.pollIntervalMs.toString();
                                _state.label = 1;
                            case 1:
                                if (!true) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    _this.retrieve(vectorStoreId, fileId, (0, $ddevm._)((0, $78DQ7._)({}, options), {
                                        headers: headers
                                    })).withResponse()
                                ];
                            case 2:
                                fileResponse = _state.sent();
                                file = fileResponse.data;
                                _ = file.status;
                                switch(_){
                                    case "in_progress":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "failed":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "completed":
                                        return [
                                            3,
                                            5
                                        ];
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                sleepInterval = 5000;
                                if (options === null || options === void 0 ? void 0 : options.pollIntervalMs) sleepInterval = options.pollIntervalMs;
                                else {
                                    headerInterval = fileResponse.response.headers.get("openai-poll-after-ms");
                                    if (headerInterval) {
                                        headerIntervalMs = parseInt(headerInterval);
                                        if (!isNaN(headerIntervalMs)) sleepInterval = headerIntervalMs;
                                    }
                                }
                                return [
                                    4,
                                    (0, $c8Tp0.sleep)(sleepInterval)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                return [
                                    2,
                                    file
                                ];
                            case 6:
                                return [
                                    3,
                                    1
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "upload",
            value: /**
     * Upload a file to the `files` API and then attach it to the given vector store.
     *
     * Note the file will be asynchronously processed (you can use the alternative
     * polling helper method to wait for processing to complete).
     */ function upload(vectorStoreId, file, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var fileInfo;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._client.files.create({
                                        file: file,
                                        purpose: "assistants"
                                    }, options)
                                ];
                            case 1:
                                fileInfo = _state.sent();
                                return [
                                    2,
                                    _this.create(vectorStoreId, {
                                        file_id: fileInfo.id
                                    }, options)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "uploadAndPoll",
            value: /**
     * Add a file to a vector store and poll until processing is complete.
     */ function uploadAndPoll(vectorStoreId, file, options) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var fileInfo;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.upload(vectorStoreId, file, options)
                                ];
                            case 1:
                                fileInfo = _state.sent();
                                return [
                                    4,
                                    _this.poll(vectorStoreId, fileInfo.id, options)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Files;
}($26X5G.APIResource);
module.exports.Files = $0f4ceb51129a6594$var$Files;
var $0f4ceb51129a6594$var$VectorStoreFilesPage = /*#__PURE__*/ function(_pagination_1_CursorPage) {
    (0, $iNfU4._)(VectorStoreFilesPage, _pagination_1_CursorPage);
    var _super = (0, $k1NN5._)(VectorStoreFilesPage);
    function VectorStoreFilesPage() {
        (0, $19mwo._)(this, VectorStoreFilesPage);
        return _super.apply(this, arguments);
    }
    return VectorStoreFilesPage;
}($4ux0n.CursorPage);
module.exports.VectorStoreFilesPage = $0f4ceb51129a6594$var$VectorStoreFilesPage;
(function(Files) {
    Files.VectorStoreFilesPage = $0f4ceb51129a6594$var$FilesAPI.VectorStoreFilesPage;
})($0f4ceb51129a6594$var$Files = module.exports.Files || (module.exports.Files = {}));

});




parcelRegister("gLhOS", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Completions = void 0;

var $26X5G = parcelRequire("26X5G");
var $c33edbbd0202786a$var$Completions = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Completions, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Completions);
    function Completions() {
        (0, $19mwo._)(this, Completions);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Completions, [
        {
            key: "create",
            value: function create(body, options) {
                var _body_stream;
                return this._client.post("/completions", (0, $ddevm._)((0, $78DQ7._)({
                    body: body
                }, options), {
                    stream: (_body_stream = body.stream) !== null && _body_stream !== void 0 ? _body_stream : false
                }));
            }
        }
    ]);
    return Completions;
}($26X5G.APIResource);
module.exports.Completions = $c33edbbd0202786a$var$Completions;
$c33edbbd0202786a$var$Completions = module.exports.Completions || (module.exports.Completions = {});

});

parcelRegister("kIEUV", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Embeddings = void 0;

var $26X5G = parcelRequire("26X5G");
var $f157a7ffad9c3c97$var$Embeddings = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Embeddings, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Embeddings);
    function Embeddings() {
        (0, $19mwo._)(this, Embeddings);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Embeddings, [
        {
            /**
     * Creates an embedding vector representing the input text.
     */ key: "create",
            value: function create(body, options) {
                return this._client.post("/embeddings", (0, $78DQ7._)({
                    body: body
                }, options));
            }
        }
    ]);
    return Embeddings;
}($26X5G.APIResource);
module.exports.Embeddings = $f157a7ffad9c3c97$var$Embeddings;
$f157a7ffad9c3c97$var$Embeddings = module.exports.Embeddings || (module.exports.Embeddings = {});

});

parcelRegister("6Lmf1", function(module, exports) {

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $4ec86288194d7f5b$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4ec86288194d7f5b$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4ec86288194d7f5b$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4ec86288194d7f5b$var$__createBinding(result, mod, k);
    }
    $4ec86288194d7f5b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FileObjectsPage = module.exports.Files = void 0;

var $26X5G = parcelRequire("26X5G");



var $kQ0uC = parcelRequire("kQ0uC");

var $4ec86288194d7f5b$var$Core = $4ec86288194d7f5b$var$__importStar((parcelRequire("c8Tp0")));

var $4ec86288194d7f5b$var$FilesAPI = $4ec86288194d7f5b$var$__importStar(module.exports);

var $4ux0n = parcelRequire("4ux0n");
var $4ec86288194d7f5b$var$Files = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Files, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Files);
    function Files() {
        (0, $19mwo._)(this, Files);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Files, [
        {
            /**
     * Upload a file that can be used across various endpoints. Individual files can be
     * up to 512 MB, and the size of all files uploaded by one organization can be up
     * to 100 GB.
     *
     * The Assistants API supports files up to 2 million tokens and of specific file
     * types. See the
     * [Assistants Tools guide](https://platform.openai.com/docs/assistants/tools) for
     * details.
     *
     * The Fine-tuning API only supports `.jsonl` files. The input also has certain
     * required formats for fine-tuning
     * [chat](https://platform.openai.com/docs/api-reference/fine-tuning/chat-input) or
     * [completions](https://platform.openai.com/docs/api-reference/fine-tuning/completions-input)
     * models.
     *
     * The Batch API only supports `.jsonl` files up to 100 MB in size. The input also
     * has a specific required
     * [format](https://platform.openai.com/docs/api-reference/batch/request-input).
     *
     * Please [contact us](https://help.openai.com/) if you need to increase these
     * storage limits.
     */ key: "create",
            value: function create(body, options) {
                return this._client.post("/files", $4ec86288194d7f5b$var$Core.multipartFormRequestOptions((0, $78DQ7._)({
                    body: body
                }, options)));
            }
        },
        {
            /**
     * Returns information about a specific file.
     */ key: "retrieve",
            value: function retrieve(fileId, options) {
                return this._client.get("/files/".concat(fileId), options);
            }
        },
        {
            key: "list",
            value: function list() {
                var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, options = arguments.length > 1 ? arguments[1] : void 0;
                if ((0, (parcelRequire("c8Tp0")).isRequestOptions)(query)) return this.list({}, query);
                return this._client.getAPIList("/files", $4ec86288194d7f5b$var$FileObjectsPage, (0, $78DQ7._)({
                    query: query
                }, options));
            }
        },
        {
            /**
     * Delete a file.
     */ key: "del",
            value: function del(fileId, options) {
                return this._client.delete("/files/".concat(fileId), options);
            }
        },
        {
            /**
     * Returns the contents of the specified file.
     */ key: "content",
            value: function content(fileId, options) {
                return this._client.get("/files/".concat(fileId, "/content"), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    __binaryResponse: true
                }));
            }
        },
        {
            /**
     * Returns the contents of the specified file.
     *
     * @deprecated The `.content()` method should be used instead
     */ key: "retrieveContent",
            value: function retrieveContent(fileId, options) {
                return this._client.get("/files/".concat(fileId, "/content"), (0, $ddevm._)((0, $78DQ7._)({}, options), {
                    headers: (0, $78DQ7._)({
                        Accept: "application/json"
                    }, options === null || options === void 0 ? void 0 : options.headers)
                }));
            }
        },
        {
            key: "waitForProcessing",
            value: /**
     * Waits for the given file to be processed, default timeout is 30 mins.
     */ function waitForProcessing(id) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_pollInterval = _ref.pollInterval, pollInterval = _ref_pollInterval === void 0 ? 5000 : _ref_pollInterval, _ref_maxWait = _ref.maxWait, maxWait = _ref_maxWait === void 0 ? 1800000 : _ref_maxWait;
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var TERMINAL_STATES, start, file;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                TERMINAL_STATES = new Set([
                                    "processed",
                                    "error",
                                    "deleted"
                                ]);
                                start = Date.now();
                                return [
                                    4,
                                    _this.retrieve(id)
                                ];
                            case 1:
                                file = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (!(!file.status || !TERMINAL_STATES.has(file.status))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    (0, (parcelRequire("c8Tp0")).sleep)(pollInterval)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    _this.retrieve(id)
                                ];
                            case 4:
                                file = _state.sent();
                                if (Date.now() - start > maxWait) throw new $kQ0uC.APIConnectionTimeoutError({
                                    message: "Giving up on waiting for file ".concat(id, " to finish processing after ").concat(maxWait, " milliseconds.")
                                });
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    2,
                                    file
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Files;
}($26X5G.APIResource);
module.exports.Files = $4ec86288194d7f5b$var$Files;
/**
 * Note: no pagination actually occurs yet, this is for forwards-compatibility.
 */ var $4ec86288194d7f5b$var$FileObjectsPage = /*#__PURE__*/ function(_pagination_1_Page) {
    (0, $iNfU4._)(FileObjectsPage, _pagination_1_Page);
    var _super = (0, $k1NN5._)(FileObjectsPage);
    function FileObjectsPage() {
        (0, $19mwo._)(this, FileObjectsPage);
        return _super.apply(this, arguments);
    }
    return FileObjectsPage;
}($4ux0n.Page);
module.exports.FileObjectsPage = $4ec86288194d7f5b$var$FileObjectsPage;
(function(Files) {
    Files.FileObjectsPage = $4ec86288194d7f5b$var$FilesAPI.FileObjectsPage;
})($4ec86288194d7f5b$var$Files = module.exports.Files || (module.exports.Files = {}));

});

parcelRegister("kfoQV", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $iNfU4 = parcelRequire("iNfU4");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $ebd87c91463aa4f9$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ebd87c91463aa4f9$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ebd87c91463aa4f9$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ebd87c91463aa4f9$var$__createBinding(result, mod, k);
    }
    $ebd87c91463aa4f9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FineTuning = void 0;

var $26X5G = parcelRequire("26X5G");

var $ebd87c91463aa4f9$var$JobsAPI = $ebd87c91463aa4f9$var$__importStar((parcelRequire("fUAsY")));
var $ebd87c91463aa4f9$var$FineTuning = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(FineTuning, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(FineTuning);
    function FineTuning() {
        (0, $19mwo._)(this, FineTuning);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.jobs = new $ebd87c91463aa4f9$var$JobsAPI.Jobs(_this._client);
        return _this;
    }
    return FineTuning;
}($26X5G.APIResource);
module.exports.FineTuning = $ebd87c91463aa4f9$var$FineTuning;
(function(FineTuning) {
    FineTuning.Jobs = $ebd87c91463aa4f9$var$JobsAPI.Jobs;
    FineTuning.FineTuningJobsPage = $ebd87c91463aa4f9$var$JobsAPI.FineTuningJobsPage;
    FineTuning.FineTuningJobEventsPage = $ebd87c91463aa4f9$var$JobsAPI.FineTuningJobEventsPage;
})($ebd87c91463aa4f9$var$FineTuning = module.exports.FineTuning || (module.exports.FineTuning = {}));

});
parcelRegister("fUAsY", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $b9585f72773669b5$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b9585f72773669b5$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b9585f72773669b5$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b9585f72773669b5$var$__createBinding(result, mod, k);
    }
    $b9585f72773669b5$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FineTuningJobEventsPage = module.exports.FineTuningJobsPage = module.exports.Jobs = void 0;

var $26X5G = parcelRequire("26X5G");

var $c8Tp0 = parcelRequire("c8Tp0");

var $b9585f72773669b5$var$JobsAPI = $b9585f72773669b5$var$__importStar(module.exports);

var $b9585f72773669b5$var$CheckpointsAPI = $b9585f72773669b5$var$__importStar((parcelRequire("3F6Fb")));

var $4ux0n = parcelRequire("4ux0n");
var $b9585f72773669b5$var$Jobs = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Jobs, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Jobs);
    function Jobs() {
        (0, $19mwo._)(this, Jobs);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.checkpoints = new $b9585f72773669b5$var$CheckpointsAPI.Checkpoints(_this._client);
        return _this;
    }
    (0, $6rpfc._)(Jobs, [
        {
            /**
     * Creates a fine-tuning job which begins the process of creating a new model from
     * a given dataset.
     *
     * Response includes details of the enqueued job including job status and the name
     * of the fine-tuned models once complete.
     *
     * [Learn more about fine-tuning](https://platform.openai.com/docs/guides/fine-tuning)
     */ key: "create",
            value: function create(body, options) {
                return this._client.post("/fine_tuning/jobs", (0, $78DQ7._)({
                    body: body
                }, options));
            }
        },
        {
            /**
     * Get info about a fine-tuning job.
     *
     * [Learn more about fine-tuning](https://platform.openai.com/docs/guides/fine-tuning)
     */ key: "retrieve",
            value: function retrieve(fineTuningJobId, options) {
                return this._client.get("/fine_tuning/jobs/".concat(fineTuningJobId), options);
            }
        },
        {
            key: "list",
            value: function list() {
                var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, options = arguments.length > 1 ? arguments[1] : void 0;
                if ((0, $c8Tp0.isRequestOptions)(query)) return this.list({}, query);
                return this._client.getAPIList("/fine_tuning/jobs", $b9585f72773669b5$var$FineTuningJobsPage, (0, $78DQ7._)({
                    query: query
                }, options));
            }
        },
        {
            /**
     * Immediately cancel a fine-tune job.
     */ key: "cancel",
            value: function cancel(fineTuningJobId, options) {
                return this._client.post("/fine_tuning/jobs/".concat(fineTuningJobId, "/cancel"), options);
            }
        },
        {
            key: "listEvents",
            value: function listEvents(fineTuningJobId) {
                var query = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, options = arguments.length > 2 ? arguments[2] : void 0;
                if ((0, $c8Tp0.isRequestOptions)(query)) return this.listEvents(fineTuningJobId, {}, query);
                return this._client.getAPIList("/fine_tuning/jobs/".concat(fineTuningJobId, "/events"), $b9585f72773669b5$var$FineTuningJobEventsPage, (0, $78DQ7._)({
                    query: query
                }, options));
            }
        }
    ]);
    return Jobs;
}($26X5G.APIResource);
module.exports.Jobs = $b9585f72773669b5$var$Jobs;
var $b9585f72773669b5$var$FineTuningJobsPage = /*#__PURE__*/ function(_pagination_1_CursorPage) {
    (0, $iNfU4._)(FineTuningJobsPage, _pagination_1_CursorPage);
    var _super = (0, $k1NN5._)(FineTuningJobsPage);
    function FineTuningJobsPage() {
        (0, $19mwo._)(this, FineTuningJobsPage);
        return _super.apply(this, arguments);
    }
    return FineTuningJobsPage;
}($4ux0n.CursorPage);
module.exports.FineTuningJobsPage = $b9585f72773669b5$var$FineTuningJobsPage;
var $b9585f72773669b5$var$FineTuningJobEventsPage = /*#__PURE__*/ function(_pagination_1_CursorPage) {
    (0, $iNfU4._)(FineTuningJobEventsPage, _pagination_1_CursorPage);
    var _super = (0, $k1NN5._)(FineTuningJobEventsPage);
    function FineTuningJobEventsPage() {
        (0, $19mwo._)(this, FineTuningJobEventsPage);
        return _super.apply(this, arguments);
    }
    return FineTuningJobEventsPage;
}($4ux0n.CursorPage);
module.exports.FineTuningJobEventsPage = $b9585f72773669b5$var$FineTuningJobEventsPage;
(function(Jobs) {
    Jobs.FineTuningJobsPage = $b9585f72773669b5$var$JobsAPI.FineTuningJobsPage;
    Jobs.FineTuningJobEventsPage = $b9585f72773669b5$var$JobsAPI.FineTuningJobEventsPage;
    Jobs.Checkpoints = $b9585f72773669b5$var$CheckpointsAPI.Checkpoints;
    Jobs.FineTuningJobCheckpointsPage = $b9585f72773669b5$var$CheckpointsAPI.FineTuningJobCheckpointsPage;
})($b9585f72773669b5$var$Jobs = module.exports.Jobs || (module.exports.Jobs = {}));

});
parcelRegister("3F6Fb", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $2aaa5e9fbcf46f4c$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2aaa5e9fbcf46f4c$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2aaa5e9fbcf46f4c$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2aaa5e9fbcf46f4c$var$__createBinding(result, mod, k);
    }
    $2aaa5e9fbcf46f4c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FineTuningJobCheckpointsPage = module.exports.Checkpoints = void 0;

var $26X5G = parcelRequire("26X5G");

var $c8Tp0 = parcelRequire("c8Tp0");

var $2aaa5e9fbcf46f4c$var$CheckpointsAPI = $2aaa5e9fbcf46f4c$var$__importStar(module.exports);

var $4ux0n = parcelRequire("4ux0n");
var $2aaa5e9fbcf46f4c$var$Checkpoints = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Checkpoints, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Checkpoints);
    function Checkpoints() {
        (0, $19mwo._)(this, Checkpoints);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Checkpoints, [
        {
            key: "list",
            value: function list(fineTuningJobId) {
                var query = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, options = arguments.length > 2 ? arguments[2] : void 0;
                if ((0, $c8Tp0.isRequestOptions)(query)) return this.list(fineTuningJobId, {}, query);
                return this._client.getAPIList("/fine_tuning/jobs/".concat(fineTuningJobId, "/checkpoints"), $2aaa5e9fbcf46f4c$var$FineTuningJobCheckpointsPage, (0, $78DQ7._)({
                    query: query
                }, options));
            }
        }
    ]);
    return Checkpoints;
}($26X5G.APIResource);
module.exports.Checkpoints = $2aaa5e9fbcf46f4c$var$Checkpoints;
var $2aaa5e9fbcf46f4c$var$FineTuningJobCheckpointsPage = /*#__PURE__*/ function(_pagination_1_CursorPage) {
    (0, $iNfU4._)(FineTuningJobCheckpointsPage, _pagination_1_CursorPage);
    var _super = (0, $k1NN5._)(FineTuningJobCheckpointsPage);
    function FineTuningJobCheckpointsPage() {
        (0, $19mwo._)(this, FineTuningJobCheckpointsPage);
        return _super.apply(this, arguments);
    }
    return FineTuningJobCheckpointsPage;
}($4ux0n.CursorPage);
module.exports.FineTuningJobCheckpointsPage = $2aaa5e9fbcf46f4c$var$FineTuningJobCheckpointsPage;
(function(Checkpoints) {
    Checkpoints.FineTuningJobCheckpointsPage = $2aaa5e9fbcf46f4c$var$CheckpointsAPI.FineTuningJobCheckpointsPage;
})($2aaa5e9fbcf46f4c$var$Checkpoints = module.exports.Checkpoints || (module.exports.Checkpoints = {}));

});



parcelRegister("3Vf7B", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $2db26ccd320383ef$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2db26ccd320383ef$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2db26ccd320383ef$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2db26ccd320383ef$var$__createBinding(result, mod, k);
    }
    $2db26ccd320383ef$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Images = void 0;

var $26X5G = parcelRequire("26X5G");

var $2db26ccd320383ef$var$Core = $2db26ccd320383ef$var$__importStar((parcelRequire("c8Tp0")));
var $2db26ccd320383ef$var$Images = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Images, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Images);
    function Images() {
        (0, $19mwo._)(this, Images);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Images, [
        {
            /**
     * Creates a variation of a given image.
     */ key: "createVariation",
            value: function createVariation(body, options) {
                return this._client.post("/images/variations", $2db26ccd320383ef$var$Core.multipartFormRequestOptions((0, $78DQ7._)({
                    body: body
                }, options)));
            }
        },
        {
            /**
     * Creates an edited or extended image given an original image and a prompt.
     */ key: "edit",
            value: function edit(body, options) {
                return this._client.post("/images/edits", $2db26ccd320383ef$var$Core.multipartFormRequestOptions((0, $78DQ7._)({
                    body: body
                }, options)));
            }
        },
        {
            /**
     * Creates an image given a prompt.
     */ key: "generate",
            value: function generate(body, options) {
                return this._client.post("/images/generations", (0, $78DQ7._)({
                    body: body
                }, options));
            }
        }
    ]);
    return Images;
}($26X5G.APIResource);
module.exports.Images = $2db26ccd320383ef$var$Images;
$2db26ccd320383ef$var$Images = module.exports.Images || (module.exports.Images = {});

});

parcelRegister("kgOrA", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $ec1c6e5e36d7bfb9$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ec1c6e5e36d7bfb9$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ec1c6e5e36d7bfb9$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ec1c6e5e36d7bfb9$var$__createBinding(result, mod, k);
    }
    $ec1c6e5e36d7bfb9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModelsPage = module.exports.Models = void 0;

var $26X5G = parcelRequire("26X5G");

var $ec1c6e5e36d7bfb9$var$ModelsAPI = $ec1c6e5e36d7bfb9$var$__importStar(module.exports);

var $4ux0n = parcelRequire("4ux0n");
var $ec1c6e5e36d7bfb9$var$Models = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Models, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Models);
    function Models() {
        (0, $19mwo._)(this, Models);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Models, [
        {
            /**
     * Retrieves a model instance, providing basic information about the model such as
     * the owner and permissioning.
     */ key: "retrieve",
            value: function retrieve(model, options) {
                return this._client.get("/models/".concat(model), options);
            }
        },
        {
            /**
     * Lists the currently available models, and provides basic information about each
     * one such as the owner and availability.
     */ key: "list",
            value: function list(options) {
                return this._client.getAPIList("/models", $ec1c6e5e36d7bfb9$var$ModelsPage, options);
            }
        },
        {
            /**
     * Delete a fine-tuned model. You must have the Owner role in your organization to
     * delete a model.
     */ key: "del",
            value: function del(model, options) {
                return this._client.delete("/models/".concat(model), options);
            }
        }
    ]);
    return Models;
}($26X5G.APIResource);
module.exports.Models = $ec1c6e5e36d7bfb9$var$Models;
/**
 * Note: no pagination actually occurs yet, this is for forwards-compatibility.
 */ var $ec1c6e5e36d7bfb9$var$ModelsPage = /*#__PURE__*/ function(_pagination_1_Page) {
    (0, $iNfU4._)(ModelsPage, _pagination_1_Page);
    var _super = (0, $k1NN5._)(ModelsPage);
    function ModelsPage() {
        (0, $19mwo._)(this, ModelsPage);
        return _super.apply(this, arguments);
    }
    return ModelsPage;
}($4ux0n.Page);
module.exports.ModelsPage = $ec1c6e5e36d7bfb9$var$ModelsPage;
(function(Models) {
    Models.ModelsPage = $ec1c6e5e36d7bfb9$var$ModelsAPI.ModelsPage;
})($ec1c6e5e36d7bfb9$var$Models = module.exports.Models || (module.exports.Models = {}));

});

parcelRegister("4r7ux", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Moderations = void 0;

var $26X5G = parcelRequire("26X5G");
var $33af7eae6a1de848$var$Moderations = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Moderations, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Moderations);
    function Moderations() {
        (0, $19mwo._)(this, Moderations);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Moderations, [
        {
            /**
     * Classifies if text is potentially harmful.
     */ key: "create",
            value: function create(body, options) {
                return this._client.post("/moderations", (0, $78DQ7._)({
                    body: body
                }, options));
            }
        }
    ]);
    return Moderations;
}($26X5G.APIResource);
module.exports.Moderations = $33af7eae6a1de848$var$Moderations;
$33af7eae6a1de848$var$Moderations = module.exports.Moderations || (module.exports.Moderations = {});

});

parcelRegister("1Gy6w", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $13a42b12f1e34c02$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $13a42b12f1e34c02$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $13a42b12f1e34c02$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $13a42b12f1e34c02$var$__createBinding(result, mod, k);
    }
    $13a42b12f1e34c02$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uploads = void 0;

var $26X5G = parcelRequire("26X5G");

var $13a42b12f1e34c02$var$PartsAPI = $13a42b12f1e34c02$var$__importStar((parcelRequire("avO81")));
var $13a42b12f1e34c02$var$Uploads = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Uploads, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Uploads);
    function Uploads() {
        (0, $19mwo._)(this, Uploads);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.parts = new $13a42b12f1e34c02$var$PartsAPI.Parts(_this._client);
        return _this;
    }
    (0, $6rpfc._)(Uploads, [
        {
            /**
     * Creates an intermediate
     * [Upload](https://platform.openai.com/docs/api-reference/uploads/object) object
     * that you can add
     * [Parts](https://platform.openai.com/docs/api-reference/uploads/part-object) to.
     * Currently, an Upload can accept at most 8 GB in total and expires after an hour
     * after you create it.
     *
     * Once you complete the Upload, we will create a
     * [File](https://platform.openai.com/docs/api-reference/files/object) object that
     * contains all the parts you uploaded. This File is usable in the rest of our
     * platform as a regular File object.
     *
     * For certain `purpose`s, the correct `mime_type` must be specified. Please refer
     * to documentation for the supported MIME types for your use case:
     *
     * - [Assistants](https://platform.openai.com/docs/assistants/tools/file-search/supported-files)
     *
     * For guidance on the proper filename extensions for each purpose, please follow
     * the documentation on
     * [creating a File](https://platform.openai.com/docs/api-reference/files/create).
     */ key: "create",
            value: function create(body, options) {
                return this._client.post("/uploads", (0, $78DQ7._)({
                    body: body
                }, options));
            }
        },
        {
            /**
     * Cancels the Upload. No Parts may be added after an Upload is cancelled.
     */ key: "cancel",
            value: function cancel(uploadId, options) {
                return this._client.post("/uploads/".concat(uploadId, "/cancel"), options);
            }
        },
        {
            /**
     * Completes the
     * [Upload](https://platform.openai.com/docs/api-reference/uploads/object).
     *
     * Within the returned Upload object, there is a nested
     * [File](https://platform.openai.com/docs/api-reference/files/object) object that
     * is ready to use in the rest of the platform.
     *
     * You can specify the order of the Parts by passing in an ordered list of the Part
     * IDs.
     *
     * The number of bytes uploaded upon completion must match the number of bytes
     * initially specified when creating the Upload object. No Parts may be added after
     * an Upload is completed.
     */ key: "complete",
            value: function complete(uploadId, body, options) {
                return this._client.post("/uploads/".concat(uploadId, "/complete"), (0, $78DQ7._)({
                    body: body
                }, options));
            }
        }
    ]);
    return Uploads;
}($26X5G.APIResource);
module.exports.Uploads = $13a42b12f1e34c02$var$Uploads;
(function(Uploads) {
    Uploads.Parts = $13a42b12f1e34c02$var$PartsAPI.Parts;
})($13a42b12f1e34c02$var$Uploads = module.exports.Uploads || (module.exports.Uploads = {}));

});
parcelRegister("avO81", function(module, exports) {

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $k1NN5 = parcelRequire("k1NN5");
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var $7a73af199f2f8af9$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7a73af199f2f8af9$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7a73af199f2f8af9$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7a73af199f2f8af9$var$__createBinding(result, mod, k);
    }
    $7a73af199f2f8af9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parts = void 0;

var $26X5G = parcelRequire("26X5G");

var $7a73af199f2f8af9$var$Core = $7a73af199f2f8af9$var$__importStar((parcelRequire("c8Tp0")));
var $7a73af199f2f8af9$var$Parts = /*#__PURE__*/ function(_resource_1_APIResource) {
    (0, $iNfU4._)(Parts, _resource_1_APIResource);
    var _super = (0, $k1NN5._)(Parts);
    function Parts() {
        (0, $19mwo._)(this, Parts);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(Parts, [
        {
            /**
     * Adds a
     * [Part](https://platform.openai.com/docs/api-reference/uploads/part-object) to an
     * [Upload](https://platform.openai.com/docs/api-reference/uploads/object) object.
     * A Part represents a chunk of bytes from the file you are trying to upload.
     *
     * Each Part can be at most 64 MB, and you can add Parts until you hit the Upload
     * maximum of 8 GB.
     *
     * It is possible to add multiple Parts in parallel. You can decide the intended
     * order of the Parts when you
     * [complete the Upload](https://platform.openai.com/docs/api-reference/uploads/complete).
     */ key: "create",
            value: function create(uploadId, body, options) {
                return this._client.post("/uploads/".concat(uploadId, "/parts"), $7a73af199f2f8af9$var$Core.multipartFormRequestOptions((0, $78DQ7._)({
                    body: body
                }, options)));
            }
        }
    ]);
    return Parts;
}($26X5G.APIResource);
module.exports.Parts = $7a73af199f2f8af9$var$Parts;
$7a73af199f2f8af9$var$Parts = module.exports.Parts || (module.exports.Parts = {});

});




parcelRegister("3Fd7H", function(module, exports) {

$parcel$export(module.exports, "ZodFirstPartyTypeKind", function () { return ZodFirstPartyTypeKind; });
$parcel$export(module.exports, "z", function () { return z; });

var $15Pju = parcelRequire("15Pju");

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $c5rwh = parcelRequire("c5rwh");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $gnDeW = parcelRequire("gnDeW");

var $etlBe = parcelRequire("etlBe");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");
var util;
(function(util) {
    util.assertEqual = function(val) {
        return val;
    };
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = function(items) {
        var obj = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                obj[item] = item;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return obj;
    };
    util.getValidEnumValues = function(obj) {
        var validKeys = util.objectKeys(obj).filter(function(k) {
            return typeof obj[obj[k]] !== "number";
        });
        var filtered = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = validKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var k = _step.value;
                filtered[k] = obj[k];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return util.objectValues(filtered);
    };
    util.objectValues = function(obj) {
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? function(obj) {
        return Object.keys(obj) // eslint-disable-line ban/ban
        ;
    } : function(object) {
        var keys = [];
        for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = function(arr, checker) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (checker(item)) return item;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? function(val) {
        return Number.isInteger(val) // eslint-disable-line ban/ban
        ;
    } : function(val) {
        return typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    };
    function joinValues(array) {
        var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " | ";
        return array.map(function(val) {
            return typeof val === "string" ? "'".concat(val, "'") : val;
        }).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = function(_, value) {
        if ((typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value)) === "bigint") return value.toString();
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function(objectUtil) {
    objectUtil.mergeShapes = function(first, second) {
        return (0, $78DQ7._)({}, first, second);
    };
})(objectUtil || (objectUtil = {}));
var ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
var getParsedType = function(data) {
    var t = typeof data === "undefined" ? "undefined" : (0, $gnDeW._)(data);
    switch(t){
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) return ZodParsedType.array;
            if (data === null) return ZodParsedType.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return ZodParsedType.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return ZodParsedType.map;
            if (typeof Set !== "undefined" && data instanceof Set) return ZodParsedType.set;
            if (typeof Date !== "undefined" && data instanceof Date) return ZodParsedType.date;
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};
var ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
var quotelessJson = function(obj) {
    var json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
var ZodError = /*#__PURE__*/ function _target(Error1) {
    "use strict";
    (0, $iNfU4._)(ZodError, Error1);
    var _super = (0, $k1NN5._)(ZodError);
    function ZodError(issues) {
        (0, $19mwo._)(this, ZodError);
        var _this;
        _this = _super.call(this);
        _this.issues = [];
        _this.addIssue = function(sub) {
            _this.issues = (0, $3jzhD._)(_this.issues).concat([
                sub
            ]);
        };
        _this.addIssues = function() {
            var subs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
            _this.issues = (0, $3jzhD._)(_this.issues).concat((0, $3jzhD._)(subs));
        };
        var actualProto = (this instanceof ZodError ? this.constructor : void 0).prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf((0, $15Pju._)(_this), actualProto);
        else _this.__proto__ = actualProto;
        _this.name = "ZodError";
        _this.issues = issues;
        return _this;
    }
    (0, $6rpfc._)(ZodError, [
        {
            key: "errors",
            get: function get() {
                return this.issues;
            }
        },
        {
            key: "format",
            value: function format(_mapper) {
                var mapper = _mapper || function(issue) {
                    return issue.message;
                };
                var fieldErrors = {
                    _errors: []
                };
                var processError = function(error) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = error.issues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var issue = _step.value;
                            if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                            else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                            else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                            else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                            else {
                                var curr = fieldErrors;
                                var i = 0;
                                while(i < issue.path.length){
                                    var el = issue.path[i];
                                    var terminal = i === issue.path.length - 1;
                                    if (!terminal) curr[el] = curr[el] || {
                                        _errors: []
                                    };
                                    else {
                                        curr[el] = curr[el] || {
                                            _errors: []
                                        };
                                        curr[el]._errors.push(mapper(issue));
                                    }
                                    curr = curr[el];
                                    i++;
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                };
                processError(this);
                return fieldErrors;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.message;
            }
        },
        {
            key: "message",
            get: function get() {
                return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
            }
        },
        {
            key: "isEmpty",
            get: function get() {
                return this.issues.length === 0;
            }
        },
        {
            key: "flatten",
            value: function flatten() {
                var mapper = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(issue) {
                    return issue.message;
                };
                var fieldErrors = {};
                var formErrors = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.issues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sub = _step.value;
                        if (sub.path.length > 0) {
                            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                            fieldErrors[sub.path[0]].push(mapper(sub));
                        } else formErrors.push(mapper(sub));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    formErrors: formErrors,
                    fieldErrors: fieldErrors
                };
            }
        },
        {
            key: "formErrors",
            get: function get() {
                return this.flatten();
            }
        }
    ], [
        {
            key: "assert",
            value: function assert(value) {
                if (!(value instanceof ZodError)) throw new Error("Not a ZodError: ".concat(value));
            }
        }
    ]);
    return ZodError;
}((0, $etlBe._)(Error));
ZodError.create = function(issues) {
    var error = new ZodError(issues);
    return error;
};
var errorMap = function(issue, _ctx) {
    var message;
    switch(issue.code){
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) message = "Required";
            else message = "Expected ".concat(issue.expected, ", received ").concat(issue.received);
            break;
        case ZodIssueCode.invalid_literal:
            message = "Invalid literal value, expected ".concat(JSON.stringify(issue.expected, util.jsonStringifyReplacer));
            break;
        case ZodIssueCode.unrecognized_keys:
            message = "Unrecognized key(s) in object: ".concat(util.joinValues(issue.keys, ", "));
            break;
        case ZodIssueCode.invalid_union:
            message = "Invalid input";
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = "Invalid discriminator value. Expected ".concat(util.joinValues(issue.options));
            break;
        case ZodIssueCode.invalid_enum_value:
            message = "Invalid enum value. Expected ".concat(util.joinValues(issue.options), ", received '").concat(issue.received, "'");
            break;
        case ZodIssueCode.invalid_arguments:
            message = "Invalid function arguments";
            break;
        case ZodIssueCode.invalid_return_type:
            message = "Invalid function return type";
            break;
        case ZodIssueCode.invalid_date:
            message = "Invalid date";
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = 'Invalid input: must include "'.concat(issue.validation.includes, '"');
                    if (typeof issue.validation.position === "number") message = "".concat(message, " at one or more positions greater than or equal to ").concat(issue.validation.position);
                } else if ("startsWith" in issue.validation) message = 'Invalid input: must start with "'.concat(issue.validation.startsWith, '"');
                else if ("endsWith" in issue.validation) message = 'Invalid input: must end with "'.concat(issue.validation.endsWith, '"');
                else util.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = "Invalid ".concat(issue.validation);
            else message = "Invalid";
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array") message = "Array must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at least" : "more than", " ").concat(issue.minimum, " element(s)");
            else if (issue.type === "string") message = "String must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at least" : "over", " ").concat(issue.minimum, " character(s)");
            else if (issue.type === "number") message = "Number must be ".concat(issue.exact ? "exactly equal to " : issue.inclusive ? "greater than or equal to " : "greater than ").concat(issue.minimum);
            else if (issue.type === "date") message = "Date must be ".concat(issue.exact ? "exactly equal to " : issue.inclusive ? "greater than or equal to " : "greater than ").concat(new Date(Number(issue.minimum)));
            else message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array") message = "Array must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at most" : "less than", " ").concat(issue.maximum, " element(s)");
            else if (issue.type === "string") message = "String must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at most" : "under", " ").concat(issue.maximum, " character(s)");
            else if (issue.type === "number") message = "Number must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "less than or equal to" : "less than", " ").concat(issue.maximum);
            else if (issue.type === "bigint") message = "BigInt must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "less than or equal to" : "less than", " ").concat(issue.maximum);
            else if (issue.type === "date") message = "Date must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "smaller than or equal to" : "smaller than", " ").concat(new Date(Number(issue.maximum)));
            else message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = "Invalid input";
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = "Intersection results could not be merged";
            break;
        case ZodIssueCode.not_multiple_of:
            message = "Number must be a multiple of ".concat(issue.multipleOf);
            break;
        case ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util.assertNever(issue);
    }
    return {
        message: message
    };
};
var overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}
var makeIssue = function(params) {
    var data = params.data, path = params.path, errorMaps = params.errorMaps, issueData = params.issueData;
    var fullPath = (0, $3jzhD._)(path).concat((0, $3jzhD._)(issueData.path || []));
    var fullIssue = (0, $ddevm._)((0, $78DQ7._)({}, issueData), {
        path: fullPath
    });
    if (issueData.message !== undefined) return (0, $ddevm._)((0, $78DQ7._)({}, issueData), {
        path: fullPath,
        message: issueData.message
    });
    var errorMessage = "";
    var maps = errorMaps.filter(function(m) {
        return !!m;
    }).slice().reverse();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = maps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var map = _step.value;
            errorMessage = map(fullIssue, {
                data: data,
                defaultError: errorMessage
            }).message;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, $ddevm._)((0, $78DQ7._)({}, issueData), {
        path: fullPath,
        message: errorMessage
    });
};
var EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    var overrideMap = getErrorMap();
    var issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === errorMap ? undefined : errorMap
        ].filter(function(x) {
            return !!x;
        })
    });
    ctx.common.issues.push(issue);
}
var ParseStatus = /*#__PURE__*/ function() {
    "use strict";
    function ParseStatus() {
        (0, $19mwo._)(this, ParseStatus);
        this.value = "valid";
    }
    (0, $6rpfc._)(ParseStatus, [
        {
            key: "dirty",
            value: function dirty() {
                if (this.value === "valid") this.value = "dirty";
            }
        },
        {
            key: "abort",
            value: function abort() {
                if (this.value !== "aborted") this.value = "aborted";
            }
        }
    ], [
        {
            key: "mergeArray",
            value: function mergeArray(status, results) {
                var arrayValue = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var s = _step.value;
                        if (s.status === "aborted") return INVALID;
                        if (s.status === "dirty") status.dirty();
                        arrayValue.push(s.value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: arrayValue
                };
            }
        },
        {
            key: "mergeObjectAsync",
            value: function mergeObjectAsync(status, pairs) {
                return (0, $9OZ9j._)(function() {
                    var syncPairs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, key, value, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                syncPairs = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = pairs[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                pair = _step.value;
                                return [
                                    4,
                                    pair.key
                                ];
                            case 3:
                                key = _state.sent();
                                return [
                                    4,
                                    pair.value
                                ];
                            case 4:
                                value = _state.sent();
                                syncPairs.push({
                                    key: key,
                                    value: value
                                });
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    ParseStatus.mergeObjectSync(status, syncPairs)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "mergeObjectSync",
            value: function mergeObjectSync(status, pairs) {
                var finalObject = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var pair = _step.value;
                        var key = pair.key, value = pair.value;
                        if (key.status === "aborted") return INVALID;
                        if (value.status === "aborted") return INVALID;
                        if (key.status === "dirty") status.dirty();
                        if (value.status === "dirty") status.dirty();
                        if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: finalObject
                };
            }
        }
    ]);
    return ParseStatus;
}();
var INVALID = Object.freeze({
    status: "aborted"
});
var DIRTY = function(value) {
    return {
        status: "dirty",
        value: value
    };
};
var OK = function(value) {
    return {
        status: "valid",
        value: value
    };
};
var isAborted = function(x) {
    return x.status === "aborted";
};
var isDirty = function(x) {
    return x.status === "dirty";
};
var isValid = function(x) {
    return x.status === "valid";
};
var isAsync = function(x) {
    return typeof Promise !== "undefined" && x instanceof Promise;
};
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = function(message) {
        return typeof message === "string" ? {
            message: message
        } : message || {};
    };
    errorUtil.toString = function(message) {
        return typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
    };
})(errorUtil || (errorUtil = {}));
var _ZodEnum_cache, _ZodNativeEnum_cache;
var ParseInputLazyPath = /*#__PURE__*/ function() {
    "use strict";
    function ParseInputLazyPath(parent, value, path, key) {
        (0, $19mwo._)(this, ParseInputLazyPath);
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    (0, $6rpfc._)(ParseInputLazyPath, [
        {
            key: "path",
            get: function get() {
                if (!this._cachedPath.length) {
                    var _this__cachedPath, _this__cachedPath1;
                    if (this._key instanceof Array) (_this__cachedPath = this._cachedPath).push.apply(_this__cachedPath, (0, $3jzhD._)(this._path).concat((0, $3jzhD._)(this._key)));
                    else (_this__cachedPath1 = this._cachedPath).push.apply(_this__cachedPath1, (0, $3jzhD._)(this._path).concat([
                        this._key
                    ]));
                }
                return this._cachedPath;
            }
        }
    ]);
    return ParseInputLazyPath;
}();
var handleResult = function(ctx, result) {
    if (isValid(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                var error = new ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function processCreateParams(params) {
    if (!params) return {};
    var errorMap = params.errorMap, invalid_type_error = params.invalid_type_error, required_error = params.required_error, description = params.description;
    if (errorMap && (invalid_type_error || required_error)) throw new Error('Can\'t use "invalid_type_error" or "required_error" in conjunction with custom error map.');
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    var customMap = function(iss, ctx) {
        var _a, _b;
        var message = params.message;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
var ZodType = /*#__PURE__*/ function() {
    "use strict";
    function ZodType(def) {
        (0, $19mwo._)(this, ZodType);
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    (0, $6rpfc._)(ZodType, [
        {
            key: "description",
            get: function get() {
                return this._def.description;
            }
        },
        {
            key: "_getType",
            value: function _getType(input) {
                return getParsedType(input.data);
            }
        },
        {
            key: "_getOrReturnCtx",
            value: function _getOrReturnCtx(input, ctx) {
                return ctx || {
                    common: input.parent.common,
                    data: input.data,
                    parsedType: getParsedType(input.data),
                    schemaErrorMap: this._def.errorMap,
                    path: input.path,
                    parent: input.parent
                };
            }
        },
        {
            key: "_processInputParams",
            value: function _processInputParams(input) {
                return {
                    status: new ParseStatus(),
                    ctx: {
                        common: input.parent.common,
                        data: input.data,
                        parsedType: getParsedType(input.data),
                        schemaErrorMap: this._def.errorMap,
                        path: input.path,
                        parent: input.parent
                    }
                };
            }
        },
        {
            key: "_parseSync",
            value: function _parseSync(input) {
                var result = this._parse(input);
                if (isAsync(result)) throw new Error("Synchronous parse encountered promise.");
                return result;
            }
        },
        {
            key: "_parseAsync",
            value: function _parseAsync(input) {
                var result = this._parse(input);
                return Promise.resolve(result);
            }
        },
        {
            key: "parse",
            value: function parse(data, params) {
                var result = this.safeParse(data, params);
                if (result.success) return result.data;
                throw result.error;
            }
        },
        {
            key: "safeParse",
            value: function safeParse(data, params) {
                var _a;
                var ctx = {
                    common: {
                        issues: [],
                        async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
                    },
                    path: (params === null || params === void 0 ? void 0 : params.path) || [],
                    schemaErrorMap: this._def.errorMap,
                    parent: null,
                    data: data,
                    parsedType: getParsedType(data)
                };
                var result = this._parseSync({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
                return handleResult(ctx, result);
            }
        },
        {
            key: "parseAsync",
            value: function parseAsync(data, params) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var result;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.safeParseAsync(data, params)
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.success) return [
                                    2,
                                    result.data
                                ];
                                throw result.error;
                        }
                    });
                })();
            }
        },
        {
            key: "safeParseAsync",
            value: function safeParseAsync(data, params) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var ctx, maybeAsyncResult, result;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ctx = {
                                    common: {
                                        issues: [],
                                        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                                        async: true
                                    },
                                    path: (params === null || params === void 0 ? void 0 : params.path) || [],
                                    schemaErrorMap: _this._def.errorMap,
                                    parent: null,
                                    data: data,
                                    parsedType: getParsedType(data)
                                };
                                maybeAsyncResult = _this._parse({
                                    data: data,
                                    path: ctx.path,
                                    parent: ctx
                                });
                                return [
                                    4,
                                    isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    handleResult(ctx, result)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "refine",
            value: function refine(check, message) {
                var getIssueProperties = function(val) {
                    if (typeof message === "string" || typeof message === "undefined") return {
                        message: message
                    };
                    else if (typeof message === "function") return message(val);
                    else return message;
                };
                return this._refinement(function(val, ctx) {
                    var result = check(val);
                    var setError = function() {
                        return ctx.addIssue((0, $78DQ7._)({
                            code: ZodIssueCode.custom
                        }, getIssueProperties(val)));
                    };
                    if (typeof Promise !== "undefined" && result instanceof Promise) return result.then(function(data) {
                        if (!data) {
                            setError();
                            return false;
                        } else return true;
                    });
                    if (!result) {
                        setError();
                        return false;
                    } else return true;
                });
            }
        },
        {
            key: "refinement",
            value: function refinement(check, refinementData) {
                return this._refinement(function(val, ctx) {
                    if (!check(val)) {
                        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                        return false;
                    } else return true;
                });
            }
        },
        {
            key: "_refinement",
            value: function _refinement(refinement) {
                return new ZodEffects({
                    schema: this,
                    typeName: ZodFirstPartyTypeKind.ZodEffects,
                    effect: {
                        type: "refinement",
                        refinement: refinement
                    }
                });
            }
        },
        {
            key: "superRefine",
            value: function superRefine(refinement) {
                return this._refinement(refinement);
            }
        },
        {
            key: "optional",
            value: function optional() {
                return ZodOptional.create(this, this._def);
            }
        },
        {
            key: "nullable",
            value: function nullable() {
                return ZodNullable.create(this, this._def);
            }
        },
        {
            key: "nullish",
            value: function nullish() {
                return this.nullable().optional();
            }
        },
        {
            key: "array",
            value: function array() {
                return ZodArray.create(this, this._def);
            }
        },
        {
            key: "promise",
            value: function promise() {
                return ZodPromise.create(this, this._def);
            }
        },
        {
            key: "or",
            value: function or(option) {
                return ZodUnion.create([
                    this,
                    option
                ], this._def);
            }
        },
        {
            key: "and",
            value: function and(incoming) {
                return ZodIntersection.create(this, incoming, this._def);
            }
        },
        {
            key: "transform",
            value: function transform(transform) {
                return new ZodEffects((0, $ddevm._)((0, $78DQ7._)({}, processCreateParams(this._def)), {
                    schema: this,
                    typeName: ZodFirstPartyTypeKind.ZodEffects,
                    effect: {
                        type: "transform",
                        transform: transform
                    }
                }));
            }
        },
        {
            key: "default",
            value: function _default(def) {
                var defaultValueFunc = typeof def === "function" ? def : function() {
                    return def;
                };
                return new ZodDefault((0, $ddevm._)((0, $78DQ7._)({}, processCreateParams(this._def)), {
                    innerType: this,
                    defaultValue: defaultValueFunc,
                    typeName: ZodFirstPartyTypeKind.ZodDefault
                }));
            }
        },
        {
            key: "brand",
            value: function brand() {
                return new ZodBranded((0, $78DQ7._)({
                    typeName: ZodFirstPartyTypeKind.ZodBranded,
                    type: this
                }, processCreateParams(this._def)));
            }
        },
        {
            key: "catch",
            value: function _catch(def) {
                var catchValueFunc = typeof def === "function" ? def : function() {
                    return def;
                };
                return new ZodCatch((0, $ddevm._)((0, $78DQ7._)({}, processCreateParams(this._def)), {
                    innerType: this,
                    catchValue: catchValueFunc,
                    typeName: ZodFirstPartyTypeKind.ZodCatch
                }));
            }
        },
        {
            key: "describe",
            value: function describe(description) {
                var This = this.constructor;
                return new This((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    description: description
                }));
            }
        },
        {
            key: "pipe",
            value: function pipe(target) {
                return ZodPipeline.create(this, target);
            }
        },
        {
            key: "readonly",
            value: function readonly() {
                return ZodReadonly.create(this);
            }
        },
        {
            key: "isOptional",
            value: function isOptional() {
                return this.safeParse(undefined).success;
            }
        },
        {
            key: "isNullable",
            value: function isNullable() {
                return this.safeParse(null).success;
            }
        }
    ]);
    return ZodType;
}();
var cuidRegex = /^c[^\s-]{8,}$/i;
var cuid2Regex = /^[0-9a-z]+$/;
var ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
var nanoidRegex = /^[a-z0-9_-]{21}$/i;
var durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
var emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
var _emojiRegex = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
var emojiRegex;
// faster, simpler, safer
var ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
var ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
var base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
var dateRegexSource = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))";
var dateRegex = new RegExp("^".concat(dateRegexSource, "$"));
function timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    var regex = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
    if (args.precision) regex = "".concat(regex, "\\.\\d{").concat(args.precision, "}");
    else if (args.precision == null) regex = "".concat(regex, "(\\.\\d+)?");
    return regex;
}
function timeRegex(args) {
    return new RegExp("^".concat(timeRegexSource(args), "$"));
}
// Adapted from https://stackoverflow.com/a/3143231
function datetimeRegex(args) {
    var regex = "".concat(dateRegexSource, "T").concat(timeRegexSource(args));
    var opts = [];
    opts.push(args.local ? "Z?" : "Z");
    if (args.offset) opts.push("([+-]\\d{2}:?\\d{2})");
    regex = "".concat(regex, "(").concat(opts.join("|"), ")");
    return new RegExp("^".concat(regex, "$"));
}
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) return true;
    return false;
}
var ZodString = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodString, ZodType);
    var _super = (0, $k1NN5._)(ZodString);
    function ZodString() {
        (0, $19mwo._)(this, ZodString);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodString, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = String(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.string) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.string,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var status = new ParseStatus();
                var ctx1 = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            if (input.data.length < check.value) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_small,
                                    minimum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            if (input.data.length > check.value) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_big,
                                    maximum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "length") {
                            var tooBig = input.data.length > check.value;
                            var tooSmall = input.data.length < check.value;
                            if (tooBig || tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                if (tooBig) addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_big,
                                    maximum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: true,
                                    message: check.message
                                });
                                else if (tooSmall) addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_small,
                                    minimum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: true,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "email") {
                            if (!emailRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "email",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "emoji") {
                            if (!emojiRegex) emojiRegex = new RegExp(_emojiRegex, "u");
                            if (!emojiRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "emoji",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "uuid") {
                            if (!uuidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "uuid",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "nanoid") {
                            if (!nanoidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "nanoid",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "cuid") {
                            if (!cuidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "cuid",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "cuid2") {
                            if (!cuid2Regex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "cuid2",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "ulid") {
                            if (!ulidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "ulid",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "url") try {
                            new URL(input.data);
                        } catch (_a) {
                            ctx1 = this._getOrReturnCtx(input, ctx1);
                            addIssueToContext(ctx1, {
                                validation: "url",
                                code: ZodIssueCode.invalid_string,
                                message: check.message
                            });
                            status.dirty();
                        }
                        else if (check.kind === "regex") {
                            check.regex.lastIndex = 0;
                            var testResult = check.regex.test(input.data);
                            if (!testResult) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "regex",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "trim") input.data = input.data.trim();
                        else if (check.kind === "includes") {
                            if (!input.data.includes(check.value, check.position)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_string,
                                    validation: {
                                        includes: check.value,
                                        position: check.position
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
                        else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
                        else if (check.kind === "startsWith") {
                            if (!input.data.startsWith(check.value)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_string,
                                    validation: {
                                        startsWith: check.value
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "endsWith") {
                            if (!input.data.endsWith(check.value)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_string,
                                    validation: {
                                        endsWith: check.value
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "datetime") {
                            var regex = datetimeRegex(check);
                            if (!regex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_string,
                                    validation: "datetime",
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "date") {
                            var regex1 = dateRegex;
                            if (!regex1.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_string,
                                    validation: "date",
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "time") {
                            var regex2 = timeRegex(check);
                            if (!regex2.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_string,
                                    validation: "time",
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "duration") {
                            if (!durationRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "duration",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "ip") {
                            if (!isValidIP(input.data, check.version)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "ip",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "base64") {
                            if (!base64Regex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "base64",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else util.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "_regex",
            value: function _regex(regex, validation, message) {
                return this.refinement(function(data) {
                    return regex.test(data);
                }, (0, $78DQ7._)({
                    validation: validation,
                    code: ZodIssueCode.invalid_string
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodString((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    checks: (0, $3jzhD._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "email",
            value: function email(message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "email"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "url",
            value: function url(message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "url"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "emoji",
            value: function emoji(message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "emoji"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "uuid",
            value: function uuid(message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "uuid"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "nanoid",
            value: function nanoid(message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "nanoid"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "cuid",
            value: function cuid(message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "cuid"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "cuid2",
            value: function cuid2(message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "cuid2"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "ulid",
            value: function ulid(message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "ulid"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "base64",
            value: function base64(message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "base64"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "ip",
            value: function ip(options) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "ip"
                }, errorUtil.errToObj(options)));
            }
        },
        {
            key: "datetime",
            value: function datetime(options) {
                var _a, _b;
                if (typeof options === "string") return this._addCheck({
                    kind: "datetime",
                    precision: null,
                    offset: false,
                    local: false,
                    message: options
                });
                return this._addCheck((0, $78DQ7._)({
                    kind: "datetime",
                    precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
                    offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
                    local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false
                }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
            }
        },
        {
            key: "date",
            value: function date(message) {
                return this._addCheck({
                    kind: "date",
                    message: message
                });
            }
        },
        {
            key: "time",
            value: function time(options) {
                if (typeof options === "string") return this._addCheck({
                    kind: "time",
                    precision: null,
                    message: options
                });
                return this._addCheck((0, $78DQ7._)({
                    kind: "time",
                    precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision
                }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
            }
        },
        {
            key: "duration",
            value: function duration(message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "duration"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "regex",
            value: function regex(regex, message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "regex",
                    regex: regex
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "includes",
            value: function includes(value, options) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "includes",
                    value: value,
                    position: options === null || options === void 0 ? void 0 : options.position
                }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
            }
        },
        {
            key: "startsWith",
            value: function startsWith(value, message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "startsWith",
                    value: value
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "endsWith",
            value: function endsWith(value, message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "endsWith",
                    value: value
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "min",
            value: function min(minLength, message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "min",
                    value: minLength
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "max",
            value: function max(maxLength, message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "max",
                    value: maxLength
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "length",
            value: function length(len, message) {
                return this._addCheck((0, $78DQ7._)({
                    kind: "length",
                    value: len
                }, errorUtil.errToObj(message)));
            }
        },
        {
            /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, errorUtil.errToObj(message));
            }
        },
        {
            key: "trim",
            value: function trim() {
                return new ZodString((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    checks: (0, $3jzhD._)(this._def.checks).concat([
                        {
                            kind: "trim"
                        }
                    ])
                }));
            }
        },
        {
            key: "toLowerCase",
            value: function toLowerCase() {
                return new ZodString((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    checks: (0, $3jzhD._)(this._def.checks).concat([
                        {
                            kind: "toLowerCase"
                        }
                    ])
                }));
            }
        },
        {
            key: "toUpperCase",
            value: function toUpperCase() {
                return new ZodString((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    checks: (0, $3jzhD._)(this._def.checks).concat([
                        {
                            kind: "toUpperCase"
                        }
                    ])
                }));
            }
        },
        {
            key: "isDatetime",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "datetime";
                });
            }
        },
        {
            key: "isDate",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "date";
                });
            }
        },
        {
            key: "isTime",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "time";
                });
            }
        },
        {
            key: "isDuration",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "duration";
                });
            }
        },
        {
            key: "isEmail",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "email";
                });
            }
        },
        {
            key: "isURL",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "url";
                });
            }
        },
        {
            key: "isEmoji",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "emoji";
                });
            }
        },
        {
            key: "isUUID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "uuid";
                });
            }
        },
        {
            key: "isNANOID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "nanoid";
                });
            }
        },
        {
            key: "isCUID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "cuid";
                });
            }
        },
        {
            key: "isCUID2",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "cuid2";
                });
            }
        },
        {
            key: "isULID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "ulid";
                });
            }
        },
        {
            key: "isIP",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "ip";
                });
            }
        },
        {
            key: "isBase64",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "base64";
                });
            }
        },
        {
            key: "minLength",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxLength",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        }
    ]);
    return ZodString;
}(ZodType);
ZodString.create = function(params) {
    var _a;
    return new ZodString((0, $78DQ7._)({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, processCreateParams(params)));
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    var valDecCount = (val.toString().split(".")[1] || "").length;
    var stepDecCount = (step.toString().split(".")[1] || "").length;
    var decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    var valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    var stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
var ZodNumber = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodNumber, ZodType);
    var _super = (0, $k1NN5._)(ZodNumber);
    function ZodNumber() {
        (0, $19mwo._)(this, ZodNumber);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.min = _this.gte;
        _this.max = _this.lte;
        _this.step = _this.multipleOf;
        return _this;
    }
    (0, $6rpfc._)(ZodNumber, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = Number(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.number) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.number,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var ctx1 = undefined;
                var status = new ParseStatus();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "int") {
                            if (!util.isInteger(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_type,
                                    expected: "integer",
                                    received: "float",
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "min") {
                            var tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                            if (tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_small,
                                    minimum: check.value,
                                    type: "number",
                                    inclusive: check.inclusive,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            var tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                            if (tooBig) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_big,
                                    maximum: check.value,
                                    type: "number",
                                    inclusive: check.inclusive,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "multipleOf") {
                            if (floatSafeRemainder(input.data, check.value) !== 0) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.not_multiple_of,
                                    multipleOf: check.value,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "finite") {
                            if (!Number.isFinite(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.not_finite,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else util.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "gte",
            value: function gte(value, message) {
                return this.setLimit("min", value, true, errorUtil.toString(message));
            }
        },
        {
            key: "gt",
            value: function gt(value, message) {
                return this.setLimit("min", value, false, errorUtil.toString(message));
            }
        },
        {
            key: "lte",
            value: function lte(value, message) {
                return this.setLimit("max", value, true, errorUtil.toString(message));
            }
        },
        {
            key: "lt",
            value: function lt(value, message) {
                return this.setLimit("max", value, false, errorUtil.toString(message));
            }
        },
        {
            key: "setLimit",
            value: function setLimit(kind, value, inclusive, message) {
                return new ZodNumber((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    checks: (0, $3jzhD._)(this._def.checks).concat([
                        {
                            kind: kind,
                            value: value,
                            inclusive: inclusive,
                            message: errorUtil.toString(message)
                        }
                    ])
                }));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodNumber((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    checks: (0, $3jzhD._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "int",
            value: function int(message) {
                return this._addCheck({
                    kind: "int",
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "positive",
            value: function positive(message) {
                return this._addCheck({
                    kind: "min",
                    value: 0,
                    inclusive: false,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "negative",
            value: function negative(message) {
                return this._addCheck({
                    kind: "max",
                    value: 0,
                    inclusive: false,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonpositive",
            value: function nonpositive(message) {
                return this._addCheck({
                    kind: "max",
                    value: 0,
                    inclusive: true,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonnegative",
            value: function nonnegative(message) {
                return this._addCheck({
                    kind: "min",
                    value: 0,
                    inclusive: true,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "multipleOf",
            value: function multipleOf(value, message) {
                return this._addCheck({
                    kind: "multipleOf",
                    value: value,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "finite",
            value: function finite(message) {
                return this._addCheck({
                    kind: "finite",
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "safe",
            value: function safe(message) {
                return this._addCheck({
                    kind: "min",
                    inclusive: true,
                    value: Number.MIN_SAFE_INTEGER,
                    message: errorUtil.toString(message)
                })._addCheck({
                    kind: "max",
                    inclusive: true,
                    value: Number.MAX_SAFE_INTEGER,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "minValue",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxValue",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        },
        {
            key: "isInt",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value);
                });
            }
        },
        {
            key: "isFinite",
            get: function get() {
                var max = null, min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
                        else if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        } else if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return Number.isFinite(min) && Number.isFinite(max);
            }
        }
    ]);
    return ZodNumber;
}(ZodType);
ZodNumber.create = function(params) {
    return new ZodNumber((0, $78DQ7._)({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, processCreateParams(params)));
};
var ZodBigInt = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodBigInt, ZodType);
    var _super = (0, $k1NN5._)(ZodBigInt);
    function ZodBigInt() {
        (0, $19mwo._)(this, ZodBigInt);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.min = _this.gte;
        _this.max = _this.lte;
        return _this;
    }
    (0, $6rpfc._)(ZodBigInt, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = BigInt(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.bigint) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.bigint,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var ctx1 = undefined;
                var status = new ParseStatus();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            var tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                            if (tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_small,
                                    type: "bigint",
                                    minimum: check.value,
                                    inclusive: check.inclusive,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            var tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                            if (tooBig) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_big,
                                    type: "bigint",
                                    maximum: check.value,
                                    inclusive: check.inclusive,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "multipleOf") {
                            if (input.data % check.value !== BigInt(0)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.not_multiple_of,
                                    multipleOf: check.value,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else util.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "gte",
            value: function gte(value, message) {
                return this.setLimit("min", value, true, errorUtil.toString(message));
            }
        },
        {
            key: "gt",
            value: function gt(value, message) {
                return this.setLimit("min", value, false, errorUtil.toString(message));
            }
        },
        {
            key: "lte",
            value: function lte(value, message) {
                return this.setLimit("max", value, true, errorUtil.toString(message));
            }
        },
        {
            key: "lt",
            value: function lt(value, message) {
                return this.setLimit("max", value, false, errorUtil.toString(message));
            }
        },
        {
            key: "setLimit",
            value: function setLimit(kind, value, inclusive, message) {
                return new ZodBigInt((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    checks: (0, $3jzhD._)(this._def.checks).concat([
                        {
                            kind: kind,
                            value: value,
                            inclusive: inclusive,
                            message: errorUtil.toString(message)
                        }
                    ])
                }));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodBigInt((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    checks: (0, $3jzhD._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "positive",
            value: function positive(message) {
                return this._addCheck({
                    kind: "min",
                    value: BigInt(0),
                    inclusive: false,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "negative",
            value: function negative(message) {
                return this._addCheck({
                    kind: "max",
                    value: BigInt(0),
                    inclusive: false,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonpositive",
            value: function nonpositive(message) {
                return this._addCheck({
                    kind: "max",
                    value: BigInt(0),
                    inclusive: true,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonnegative",
            value: function nonnegative(message) {
                return this._addCheck({
                    kind: "min",
                    value: BigInt(0),
                    inclusive: true,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "multipleOf",
            value: function multipleOf(value, message) {
                return this._addCheck({
                    kind: "multipleOf",
                    value: value,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "minValue",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxValue",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        }
    ]);
    return ZodBigInt;
}(ZodType);
ZodBigInt.create = function(params) {
    var _a;
    return new ZodBigInt((0, $78DQ7._)({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, processCreateParams(params)));
};
var ZodBoolean = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodBoolean, ZodType);
    var _super = (0, $k1NN5._)(ZodBoolean);
    function ZodBoolean() {
        (0, $19mwo._)(this, ZodBoolean);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodBoolean, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = Boolean(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.boolean) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.boolean,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        }
    ]);
    return ZodBoolean;
}(ZodType);
ZodBoolean.create = function(params) {
    return new ZodBoolean((0, $78DQ7._)({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, processCreateParams(params)));
};
var ZodDate = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodDate, ZodType);
    var _super = (0, $k1NN5._)(ZodDate);
    function ZodDate() {
        (0, $19mwo._)(this, ZodDate);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodDate, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = new Date(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.date) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.date,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                if (isNaN(input.data.getTime())) {
                    var ctx1 = this._getOrReturnCtx(input);
                    addIssueToContext(ctx1, {
                        code: ZodIssueCode.invalid_date
                    });
                    return INVALID;
                }
                var status = new ParseStatus();
                var ctx2 = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            if (input.data.getTime() < check.value) {
                                ctx2 = this._getOrReturnCtx(input, ctx2);
                                addIssueToContext(ctx2, {
                                    code: ZodIssueCode.too_small,
                                    message: check.message,
                                    inclusive: true,
                                    exact: false,
                                    minimum: check.value,
                                    type: "date"
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            if (input.data.getTime() > check.value) {
                                ctx2 = this._getOrReturnCtx(input, ctx2);
                                addIssueToContext(ctx2, {
                                    code: ZodIssueCode.too_big,
                                    message: check.message,
                                    inclusive: true,
                                    exact: false,
                                    maximum: check.value,
                                    type: "date"
                                });
                                status.dirty();
                            }
                        } else util.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: new Date(input.data.getTime())
                };
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodDate((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    checks: (0, $3jzhD._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "min",
            value: function min(minDate, message) {
                return this._addCheck({
                    kind: "min",
                    value: minDate.getTime(),
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "max",
            value: function max(maxDate, message) {
                return this._addCheck({
                    kind: "max",
                    value: maxDate.getTime(),
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "minDate",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min != null ? new Date(min) : null;
            }
        },
        {
            key: "maxDate",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max != null ? new Date(max) : null;
            }
        }
    ]);
    return ZodDate;
}(ZodType);
ZodDate.create = function(params) {
    return new ZodDate((0, $78DQ7._)({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate
    }, processCreateParams(params)));
};
var ZodSymbol = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodSymbol, ZodType);
    var _super = (0, $k1NN5._)(ZodSymbol);
    function ZodSymbol() {
        (0, $19mwo._)(this, ZodSymbol);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodSymbol, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.symbol) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.symbol,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        }
    ]);
    return ZodSymbol;
}(ZodType);
ZodSymbol.create = function(params) {
    return new ZodSymbol((0, $78DQ7._)({
        typeName: ZodFirstPartyTypeKind.ZodSymbol
    }, processCreateParams(params)));
};
var ZodUndefined = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodUndefined, ZodType);
    var _super = (0, $k1NN5._)(ZodUndefined);
    function ZodUndefined() {
        (0, $19mwo._)(this, ZodUndefined);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodUndefined, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.undefined) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.undefined,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        }
    ]);
    return ZodUndefined;
}(ZodType);
ZodUndefined.create = function(params) {
    return new ZodUndefined((0, $78DQ7._)({
        typeName: ZodFirstPartyTypeKind.ZodUndefined
    }, processCreateParams(params)));
};
var ZodNull = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodNull, ZodType);
    var _super = (0, $k1NN5._)(ZodNull);
    function ZodNull() {
        (0, $19mwo._)(this, ZodNull);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodNull, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.null) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.null,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        }
    ]);
    return ZodNull;
}(ZodType);
ZodNull.create = function(params) {
    return new ZodNull((0, $78DQ7._)({
        typeName: ZodFirstPartyTypeKind.ZodNull
    }, processCreateParams(params)));
};
var ZodAny = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodAny, ZodType);
    var _super = (0, $k1NN5._)(ZodAny);
    function ZodAny() {
        (0, $19mwo._)(this, ZodAny);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        _this._any = true;
        return _this;
    }
    (0, $6rpfc._)(ZodAny, [
        {
            key: "_parse",
            value: function _parse(input) {
                return OK(input.data);
            }
        }
    ]);
    return ZodAny;
}(ZodType);
ZodAny.create = function(params) {
    return new ZodAny((0, $78DQ7._)({
        typeName: ZodFirstPartyTypeKind.ZodAny
    }, processCreateParams(params)));
};
var ZodUnknown = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodUnknown, ZodType);
    var _super = (0, $k1NN5._)(ZodUnknown);
    function ZodUnknown() {
        (0, $19mwo._)(this, ZodUnknown);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        // required
        _this._unknown = true;
        return _this;
    }
    (0, $6rpfc._)(ZodUnknown, [
        {
            key: "_parse",
            value: function _parse(input) {
                return OK(input.data);
            }
        }
    ]);
    return ZodUnknown;
}(ZodType);
ZodUnknown.create = function(params) {
    return new ZodUnknown((0, $78DQ7._)({
        typeName: ZodFirstPartyTypeKind.ZodUnknown
    }, processCreateParams(params)));
};
var ZodNever = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodNever, ZodType);
    var _super = (0, $k1NN5._)(ZodNever);
    function ZodNever() {
        (0, $19mwo._)(this, ZodNever);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodNever, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._getOrReturnCtx(input);
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_type,
                    expected: ZodParsedType.never,
                    received: ctx.parsedType
                });
                return INVALID;
            }
        }
    ]);
    return ZodNever;
}(ZodType);
ZodNever.create = function(params) {
    return new ZodNever((0, $78DQ7._)({
        typeName: ZodFirstPartyTypeKind.ZodNever
    }, processCreateParams(params)));
};
var ZodVoid = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodVoid, ZodType);
    var _super = (0, $k1NN5._)(ZodVoid);
    function ZodVoid() {
        (0, $19mwo._)(this, ZodVoid);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodVoid, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.undefined) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.void,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        }
    ]);
    return ZodVoid;
}(ZodType);
ZodVoid.create = function(params) {
    return new ZodVoid((0, $78DQ7._)({
        typeName: ZodFirstPartyTypeKind.ZodVoid
    }, processCreateParams(params)));
};
var ZodArray = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodArray, ZodType);
    var _super = (0, $k1NN5._)(ZodArray);
    function ZodArray() {
        (0, $19mwo._)(this, ZodArray);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodArray, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), ctx = _this__processInputParams.ctx, status = _this__processInputParams.status;
                var def = this._def;
                if (ctx.parsedType !== ZodParsedType.array) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.array,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                if (def.exactLength !== null) {
                    var tooBig = ctx.data.length > def.exactLength.value;
                    var tooSmall = ctx.data.length < def.exactLength.value;
                    if (tooBig || tooSmall) {
                        addIssueToContext(ctx, {
                            code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
                            minimum: tooSmall ? def.exactLength.value : undefined,
                            maximum: tooBig ? def.exactLength.value : undefined,
                            type: "array",
                            inclusive: true,
                            exact: true,
                            message: def.exactLength.message
                        });
                        status.dirty();
                    }
                }
                if (def.minLength !== null) {
                    if (ctx.data.length < def.minLength.value) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: def.minLength.value,
                            type: "array",
                            inclusive: true,
                            exact: false,
                            message: def.minLength.message
                        });
                        status.dirty();
                    }
                }
                if (def.maxLength !== null) {
                    if (ctx.data.length > def.maxLength.value) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: def.maxLength.value,
                            type: "array",
                            inclusive: true,
                            exact: false,
                            message: def.maxLength.message
                        });
                        status.dirty();
                    }
                }
                if (ctx.common.async) return Promise.all((0, $3jzhD._)(ctx.data).map(function(item, i) {
                    return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
                })).then(function(result) {
                    return ParseStatus.mergeArray(status, result);
                });
                var result = (0, $3jzhD._)(ctx.data).map(function(item, i) {
                    return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
                });
                return ParseStatus.mergeArray(status, result);
            }
        },
        {
            key: "element",
            get: function get() {
                return this._def.type;
            }
        },
        {
            key: "min",
            value: function min(minLength, message) {
                return new ZodArray((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    minLength: {
                        value: minLength,
                        message: errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "max",
            value: function max(maxLength, message) {
                return new ZodArray((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    maxLength: {
                        value: maxLength,
                        message: errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "length",
            value: function length(len, message) {
                return new ZodArray((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    exactLength: {
                        value: len,
                        message: errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, message);
            }
        }
    ]);
    return ZodArray;
}(ZodType);
ZodArray.create = function(schema, params) {
    return new ZodArray((0, $78DQ7._)({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray
    }, processCreateParams(params)));
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        var newShape = {};
        for(var key in schema.shape){
            var fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject((0, $ddevm._)((0, $78DQ7._)({}, schema._def), {
            shape: function() {
                return newShape;
            }
        }));
    } else if (schema instanceof ZodArray) return new ZodArray((0, $ddevm._)((0, $78DQ7._)({}, schema._def), {
        type: deepPartialify(schema.element)
    }));
    else if (schema instanceof ZodOptional) return ZodOptional.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodNullable) return ZodNullable.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodTuple) return ZodTuple.create(schema.items.map(function(item) {
        return deepPartialify(item);
    }));
    else return schema;
}
var ZodObject = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodObject, ZodType);
    var _super = (0, $k1NN5._)(ZodObject);
    function ZodObject() {
        (0, $19mwo._)(this, ZodObject);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ _this.nonstrict = _this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ _this.augment = _this.extend;
        return _this;
    }
    (0, $6rpfc._)(ZodObject, [
        {
            key: "_getCached",
            value: function _getCached() {
                if (this._cached !== null) return this._cached;
                var shape = this._def.shape();
                var keys = util.objectKeys(shape);
                return this._cached = {
                    shape: shape,
                    keys: keys
                };
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.object) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.object,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx1 = _this__processInputParams.ctx;
                var _this__getCached = this._getCached(), shape = _this__getCached.shape, shapeKeys = _this__getCached.keys;
                var extraKeys = [];
                if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
                    for(var key in ctx1.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
                }
                var pairs = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = shapeKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key1 = _step.value;
                        var keyValidator = shape[key1];
                        var value = ctx1.data[key1];
                        pairs.push({
                            key: {
                                status: "valid",
                                value: key1
                            },
                            value: keyValidator._parse(new ParseInputLazyPath(ctx1, value, ctx1.path, key1)),
                            alwaysSet: key1 in ctx1.data
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this._def.catchall instanceof ZodNever) {
                    var unknownKeys = this._def.unknownKeys;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (unknownKeys === "passthrough") try {
                        for(var _iterator1 = extraKeys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var key2 = _step1.value;
                            pairs.push({
                                key: {
                                    status: "valid",
                                    value: key2
                                },
                                value: {
                                    status: "valid",
                                    value: ctx1.data[key2]
                                }
                            });
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    else if (unknownKeys === "strict") {
                        if (extraKeys.length > 0) {
                            addIssueToContext(ctx1, {
                                code: ZodIssueCode.unrecognized_keys,
                                keys: extraKeys
                            });
                            status.dirty();
                        }
                    } else if (unknownKeys === "strip") ;
                    else throw new Error("Internal ZodObject error: invalid unknownKeys value.");
                } else {
                    // run catchall validation
                    var catchall = this._def.catchall;
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = extraKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var key3 = _step2.value;
                            var value1 = ctx1.data[key3];
                            pairs.push({
                                key: {
                                    status: "valid",
                                    value: key3
                                },
                                value: catchall._parse(new ParseInputLazyPath(ctx1, value1, ctx1.path, key3) //, ctx.child(key), value, getParsedType(value)
                                ),
                                alwaysSet: key3 in ctx1.data
                            });
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
                if (ctx1.common.async) return Promise.resolve().then(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                    var syncPairs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, key, value, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                syncPairs = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = pairs[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                pair = _step.value;
                                return [
                                    4,
                                    pair.key
                                ];
                            case 3:
                                key = _state.sent();
                                return [
                                    4,
                                    pair.value
                                ];
                            case 4:
                                value = _state.sent();
                                syncPairs.push({
                                    key: key,
                                    value: value,
                                    alwaysSet: pair.alwaysSet
                                });
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    syncPairs
                                ];
                        }
                    });
                })).then(function(syncPairs) {
                    return ParseStatus.mergeObjectSync(status, syncPairs);
                });
                else return ParseStatus.mergeObjectSync(status, pairs);
            }
        },
        {
            key: "shape",
            get: function get() {
                return this._def.shape();
            }
        },
        {
            key: "strict",
            value: function strict(message) {
                var _this = this;
                errorUtil.errToObj;
                return new ZodObject((0, $78DQ7._)((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    unknownKeys: "strict"
                }), message !== undefined ? {
                    errorMap: function(issue, ctx) {
                        var _a, _b, _c, _d;
                        var defaultError = (_c = (_b = (_a = _this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys") return {
                            message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                        };
                        return {
                            message: defaultError
                        };
                    }
                } : {}));
            }
        },
        {
            key: "strip",
            value: function strip() {
                return new ZodObject((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    unknownKeys: "strip"
                }));
            }
        },
        {
            key: "passthrough",
            value: function passthrough() {
                return new ZodObject((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    unknownKeys: "passthrough"
                }));
            }
        },
        {
            // const AugmentFactory =
            //   <Def extends ZodObjectDef>(def: Def) =>
            //   <Augmentation extends ZodRawShape>(
            //     augmentation: Augmentation
            //   ): ZodObject<
            //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
            //     Def["unknownKeys"],
            //     Def["catchall"]
            //   > => {
            //     return new ZodObject({
            //       ...def,
            //       shape: () => ({
            //         ...def.shape(),
            //         ...augmentation,
            //       }),
            //     }) as any;
            //   };
            key: "extend",
            value: function extend(augmentation) {
                var _this = this;
                return new ZodObject((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    shape: function() {
                        return (0, $78DQ7._)({}, _this._def.shape(), augmentation);
                    }
                }));
            }
        },
        {
            /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ key: "merge",
            value: function merge(merging) {
                var _this = this;
                var merged = new ZodObject({
                    unknownKeys: merging._def.unknownKeys,
                    catchall: merging._def.catchall,
                    shape: function() {
                        return (0, $78DQ7._)({}, _this._def.shape(), merging._def.shape());
                    },
                    typeName: ZodFirstPartyTypeKind.ZodObject
                });
                return merged;
            }
        },
        {
            // merge<
            //   Incoming extends AnyZodObject,
            //   Augmentation extends Incoming["shape"],
            //   NewOutput extends {
            //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
            //       ? Augmentation[k]["_output"]
            //       : k extends keyof Output
            //       ? Output[k]
            //       : never;
            //   },
            //   NewInput extends {
            //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
            //       ? Augmentation[k]["_input"]
            //       : k extends keyof Input
            //       ? Input[k]
            //       : never;
            //   }
            // >(
            //   merging: Incoming
            // ): ZodObject<
            //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
            //   Incoming["_def"]["unknownKeys"],
            //   Incoming["_def"]["catchall"],
            //   NewOutput,
            //   NewInput
            // > {
            //   const merged: any = new ZodObject({
            //     unknownKeys: merging._def.unknownKeys,
            //     catchall: merging._def.catchall,
            //     shape: () =>
            //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
            //     typeName: ZodFirstPartyTypeKind.ZodObject,
            //   }) as any;
            //   return merged;
            // }
            key: "setKey",
            value: function setKey(key, schema) {
                return this.augment((0, $c5rwh._)({}, key, schema));
            }
        },
        {
            // merge<Incoming extends AnyZodObject>(
            //   merging: Incoming
            // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
            // ZodObject<
            //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
            //   Incoming["_def"]["unknownKeys"],
            //   Incoming["_def"]["catchall"]
            // > {
            //   // const mergedShape = objectUtil.mergeShapes(
            //   //   this._def.shape(),
            //   //   merging._def.shape()
            //   // );
            //   const merged: any = new ZodObject({
            //     unknownKeys: merging._def.unknownKeys,
            //     catchall: merging._def.catchall,
            //     shape: () =>
            //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
            //     typeName: ZodFirstPartyTypeKind.ZodObject,
            //   }) as any;
            //   return merged;
            // }
            key: "catchall",
            value: function catchall(index) {
                return new ZodObject((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    catchall: index
                }));
            }
        },
        {
            key: "pick",
            value: function pick(mask) {
                var _this = this;
                var shape = {};
                util.objectKeys(mask).forEach(function(key) {
                    if (mask[key] && _this.shape[key]) shape[key] = _this.shape[key];
                });
                return new ZodObject((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    shape: function() {
                        return shape;
                    }
                }));
            }
        },
        {
            key: "omit",
            value: function omit(mask) {
                var _this = this;
                var shape = {};
                util.objectKeys(this.shape).forEach(function(key) {
                    if (!mask[key]) shape[key] = _this.shape[key];
                });
                return new ZodObject((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    shape: function() {
                        return shape;
                    }
                }));
            }
        },
        {
            /**
     * @deprecated
     */ key: "deepPartial",
            value: function deepPartial() {
                return deepPartialify(this);
            }
        },
        {
            key: "partial",
            value: function partial(mask) {
                var _this = this;
                var newShape = {};
                util.objectKeys(this.shape).forEach(function(key) {
                    var fieldSchema = _this.shape[key];
                    if (mask && !mask[key]) newShape[key] = fieldSchema;
                    else newShape[key] = fieldSchema.optional();
                });
                return new ZodObject((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    shape: function() {
                        return newShape;
                    }
                }));
            }
        },
        {
            key: "required",
            value: function required(mask) {
                var _this = this;
                var newShape = {};
                util.objectKeys(this.shape).forEach(function(key) {
                    if (mask && !mask[key]) newShape[key] = _this.shape[key];
                    else {
                        var fieldSchema = _this.shape[key];
                        var newField = fieldSchema;
                        while(newField instanceof ZodOptional)newField = newField._def.innerType;
                        newShape[key] = newField;
                    }
                });
                return new ZodObject((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    shape: function() {
                        return newShape;
                    }
                }));
            }
        },
        {
            key: "keyof",
            value: function keyof() {
                return createZodEnum(util.objectKeys(this.shape));
            }
        }
    ]);
    return ZodObject;
}(ZodType);
ZodObject.create = function(shape, params) {
    return new ZodObject((0, $78DQ7._)({
        shape: function() {
            return shape;
        },
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject
    }, processCreateParams(params)));
};
ZodObject.strictCreate = function(shape, params) {
    return new ZodObject((0, $78DQ7._)({
        shape: function() {
            return shape;
        },
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject
    }, processCreateParams(params)));
};
ZodObject.lazycreate = function(shape, params) {
    return new ZodObject((0, $78DQ7._)({
        shape: shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject
    }, processCreateParams(params)));
};
var ZodUnion = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodUnion, ZodType);
    var _super = (0, $k1NN5._)(ZodUnion);
    function ZodUnion() {
        (0, $19mwo._)(this, ZodUnion);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodUnion, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var options = this._def.options;
                function handleResults(results) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // return first issue-free validation if it exists
                        for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var result = _step.value;
                            if (result.result.status === "valid") return result.result;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = results[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var result1 = _step1.value;
                            if (result1.result.status === "dirty") {
                                var // add issues from dirty option
                                _ctx_common_issues;
                                (_ctx_common_issues = ctx.common.issues).push.apply(_ctx_common_issues, (0, $3jzhD._)(result1.ctx.common.issues));
                                return result1.result;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    // return invalid
                    var unionErrors = results.map(function(result) {
                        return new ZodError(result.ctx.common.issues);
                    });
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_union,
                        unionErrors: unionErrors
                    });
                    return INVALID;
                }
                if (ctx.common.async) return Promise.all(options.map(function() {
                    var _ref = (0, $9OZ9j._)(function(option) {
                        var childCtx, _tmp;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    childCtx = (0, $ddevm._)((0, $78DQ7._)({}, ctx), {
                                        common: (0, $ddevm._)((0, $78DQ7._)({}, ctx.common), {
                                            issues: []
                                        }),
                                        parent: null
                                    });
                                    _tmp = {};
                                    return [
                                        4,
                                        option._parseAsync({
                                            data: ctx.data,
                                            path: ctx.path,
                                            parent: childCtx
                                        })
                                    ];
                                case 1:
                                    return [
                                        2,
                                        (_tmp.result = _state.sent(), _tmp.ctx = childCtx, _tmp)
                                    ];
                            }
                        });
                    });
                    return function(option) {
                        return _ref.apply(this, arguments);
                    };
                }())).then(handleResults);
                else {
                    var dirty = undefined;
                    var issues = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var option = _step.value;
                            var childCtx = (0, $ddevm._)((0, $78DQ7._)({}, ctx), {
                                common: (0, $ddevm._)((0, $78DQ7._)({}, ctx.common), {
                                    issues: []
                                }),
                                parent: null
                            });
                            var result = option._parseSync({
                                data: ctx.data,
                                path: ctx.path,
                                parent: childCtx
                            });
                            if (result.status === "valid") return result;
                            else if (result.status === "dirty" && !dirty) dirty = {
                                result: result,
                                ctx: childCtx
                            };
                            if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (dirty) {
                        var _ctx_common_issues;
                        (_ctx_common_issues = ctx.common.issues).push.apply(_ctx_common_issues, (0, $3jzhD._)(dirty.ctx.common.issues));
                        return dirty.result;
                    }
                    var unionErrors = issues.map(function(issues) {
                        return new ZodError(issues);
                    });
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_union,
                        unionErrors: unionErrors
                    });
                    return INVALID;
                }
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.options;
            }
        }
    ]);
    return ZodUnion;
}(ZodType);
ZodUnion.create = function(types, params) {
    return new ZodUnion((0, $78DQ7._)({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion
    }, processCreateParams(params)));
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
var getDiscriminator = function(type) {
    if (type instanceof ZodLazy) return getDiscriminator(type.schema);
    else if (type instanceof ZodEffects) return getDiscriminator(type.innerType());
    else if (type instanceof ZodLiteral) return [
        type.value
    ];
    else if (type instanceof ZodEnum) return type.options;
    else if (type instanceof ZodNativeEnum) // eslint-disable-next-line ban/ban
    return util.objectValues(type.enum);
    else if (type instanceof ZodDefault) return getDiscriminator(type._def.innerType);
    else if (type instanceof ZodUndefined) return [
        undefined
    ];
    else if (type instanceof ZodNull) return [
        null
    ];
    else if (type instanceof ZodOptional) return [
        undefined
    ].concat((0, $3jzhD._)(getDiscriminator(type.unwrap())));
    else if (type instanceof ZodNullable) return [
        null
    ].concat((0, $3jzhD._)(getDiscriminator(type.unwrap())));
    else if (type instanceof ZodBranded) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodReadonly) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodCatch) return getDiscriminator(type._def.innerType);
    else return [];
};
var ZodDiscriminatedUnion = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodDiscriminatedUnion, ZodType);
    var _super = (0, $k1NN5._)(ZodDiscriminatedUnion);
    function ZodDiscriminatedUnion() {
        (0, $19mwo._)(this, ZodDiscriminatedUnion);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodDiscriminatedUnion, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== ZodParsedType.object) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.object,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var discriminator = this.discriminator;
                var discriminatorValue = ctx.data[discriminator];
                var option = this.optionsMap.get(discriminatorValue);
                if (!option) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_union_discriminator,
                        options: Array.from(this.optionsMap.keys()),
                        path: [
                            discriminator
                        ]
                    });
                    return INVALID;
                }
                if (ctx.common.async) return option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                else return option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "discriminator",
            get: function get() {
                return this._def.discriminator;
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.options;
            }
        },
        {
            key: "optionsMap",
            get: function get() {
                return this._def.optionsMap;
            }
        }
    ], [
        {
            key: "create",
            value: /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ function create(discriminator, options, params) {
                // Get all the valid discriminator values
                var optionsMap = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // try {
                    for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var type = _step.value;
                        var discriminatorValues = getDiscriminator(type.shape[discriminator]);
                        if (!discriminatorValues.length) throw new Error("A discriminator value for key `".concat(discriminator, "` could not be extracted from all schema options"));
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = discriminatorValues[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var value = _step1.value;
                                if (optionsMap.has(value)) throw new Error("Discriminator property ".concat(String(discriminator), " has duplicate value ").concat(String(value)));
                                optionsMap.set(value, type);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new ZodDiscriminatedUnion((0, $78DQ7._)({
                    typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
                    discriminator: discriminator,
                    options: options,
                    optionsMap: optionsMap
                }, processCreateParams(params)));
            }
        }
    ]);
    return ZodDiscriminatedUnion;
}(ZodType);
function mergeValues(a, b) {
    var aType = getParsedType(a);
    var bType = getParsedType(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        var bKeys = util.objectKeys(b);
        var sharedKeys = util.objectKeys(a).filter(function(key) {
            return bKeys.indexOf(key) !== -1;
        });
        var newObj = (0, $78DQ7._)({}, a, b);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = sharedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var sharedValue = mergeValues(a[key], b[key]);
                if (!sharedValue.valid) return {
                    valid: false
                };
                newObj[key] = sharedValue.data;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        var newArray = [];
        for(var index = 0; index < a.length; index++){
            var itemA = a[index];
            var itemB = b[index];
            var sharedValue1 = mergeValues(itemA, itemB);
            if (!sharedValue1.valid) return {
                valid: false
            };
            newArray.push(sharedValue1.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
var ZodIntersection = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodIntersection, ZodType);
    var _super = (0, $k1NN5._)(ZodIntersection);
    function ZodIntersection() {
        (0, $19mwo._)(this, ZodIntersection);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodIntersection, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                var handleParsed = function(parsedLeft, parsedRight) {
                    if (isAborted(parsedLeft) || isAborted(parsedRight)) return INVALID;
                    var merged = mergeValues(parsedLeft.value, parsedRight.value);
                    if (!merged.valid) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.invalid_intersection_types
                        });
                        return INVALID;
                    }
                    if (isDirty(parsedLeft) || isDirty(parsedRight)) status.dirty();
                    return {
                        status: status.value,
                        value: merged.data
                    };
                };
                if (ctx.common.async) return Promise.all([
                    this._def.left._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }),
                    this._def.right._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    })
                ]).then(function(param) {
                    var _param = (0, $2MTYX._)(param, 2), left = _param[0], right = _param[1];
                    return handleParsed(left, right);
                });
                else return handleParsed(this._def.left._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                }), this._def.right._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                }));
            }
        }
    ]);
    return ZodIntersection;
}(ZodType);
ZodIntersection.create = function(left, right, params) {
    return new ZodIntersection((0, $78DQ7._)({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection
    }, processCreateParams(params)));
};
var ZodTuple = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodTuple, ZodType);
    var _super = (0, $k1NN5._)(ZodTuple);
    function ZodTuple() {
        (0, $19mwo._)(this, ZodTuple);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodTuple, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== ZodParsedType.array) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.array,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                if (ctx.data.length < this._def.items.length) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: this._def.items.length,
                        inclusive: true,
                        exact: false,
                        type: "array"
                    });
                    return INVALID;
                }
                var rest = this._def.rest;
                if (!rest && ctx.data.length > this._def.items.length) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: this._def.items.length,
                        inclusive: true,
                        exact: false,
                        type: "array"
                    });
                    status.dirty();
                }
                var items = (0, $3jzhD._)(ctx.data).map(function(item, itemIndex) {
                    var schema = _this._def.items[itemIndex] || _this._def.rest;
                    if (!schema) return null;
                    return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
                }).filter(function(x) {
                    return !!x;
                }); // filter nulls
                if (ctx.common.async) return Promise.all(items).then(function(results) {
                    return ParseStatus.mergeArray(status, results);
                });
                else return ParseStatus.mergeArray(status, items);
            }
        },
        {
            key: "items",
            get: function get() {
                return this._def.items;
            }
        },
        {
            key: "rest",
            value: function rest(rest) {
                return new ZodTuple((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    rest: rest
                }));
            }
        }
    ]);
    return ZodTuple;
}(ZodType);
ZodTuple.create = function(schemas, params) {
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new ZodTuple((0, $78DQ7._)({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null
    }, processCreateParams(params)));
};
var ZodRecord = /*#__PURE__*/ function(ZodType1) {
    "use strict";
    (0, $iNfU4._)(ZodRecord, ZodType1);
    var _super = (0, $k1NN5._)(ZodRecord);
    function ZodRecord() {
        (0, $19mwo._)(this, ZodRecord);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodRecord, [
        {
            key: "keySchema",
            get: function get() {
                return this._def.keyType;
            }
        },
        {
            key: "valueSchema",
            get: function get() {
                return this._def.valueType;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== ZodParsedType.object) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.object,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var pairs = [];
                var keyType = this._def.keyType;
                var valueType = this._def.valueType;
                for(var key in ctx.data)pairs.push({
                    key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
                    value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
                    alwaysSet: key in ctx.data
                });
                if (ctx.common.async) return ParseStatus.mergeObjectAsync(status, pairs);
                else return ParseStatus.mergeObjectSync(status, pairs);
            }
        },
        {
            key: "element",
            get: function get() {
                return this._def.valueType;
            }
        }
    ], [
        {
            key: "create",
            value: function create(first, second, third) {
                if (second instanceof ZodType) return new ZodRecord((0, $78DQ7._)({
                    keyType: first,
                    valueType: second,
                    typeName: ZodFirstPartyTypeKind.ZodRecord
                }, processCreateParams(third)));
                return new ZodRecord((0, $78DQ7._)({
                    keyType: ZodString.create(),
                    valueType: first,
                    typeName: ZodFirstPartyTypeKind.ZodRecord
                }, processCreateParams(second)));
            }
        }
    ]);
    return ZodRecord;
}(ZodType);
var ZodMap = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodMap, ZodType);
    var _super = (0, $k1NN5._)(ZodMap);
    function ZodMap() {
        (0, $19mwo._)(this, ZodMap);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodMap, [
        {
            key: "keySchema",
            get: function get() {
                return this._def.keyType;
            }
        },
        {
            key: "valueSchema",
            get: function get() {
                return this._def.valueType;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== ZodParsedType.map) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.map,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var keyType = this._def.keyType;
                var valueType = this._def.valueType;
                var pairs = (0, $3jzhD._)(ctx.data.entries()).map(function(param, index) {
                    var _param = (0, $2MTYX._)(param, 2), key = _param[0], value = _param[1];
                    return {
                        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [
                            index,
                            "key"
                        ])),
                        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [
                            index,
                            "value"
                        ]))
                    };
                });
                if (ctx.common.async) {
                    var finalMap = new Map();
                    return Promise.resolve().then(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, key, value, err;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        7,
                                        8,
                                        9
                                    ]);
                                    _iterator = pairs[Symbol.iterator]();
                                    _state.label = 2;
                                case 2:
                                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                        3,
                                        6
                                    ];
                                    pair = _step.value;
                                    return [
                                        4,
                                        pair.key
                                    ];
                                case 3:
                                    key = _state.sent();
                                    return [
                                        4,
                                        pair.value
                                    ];
                                case 4:
                                    value = _state.sent();
                                    if (key.status === "aborted" || value.status === "aborted") return [
                                        2,
                                        INVALID
                                    ];
                                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                                    finalMap.set(key.value, value.value);
                                    _state.label = 5;
                                case 5:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        2
                                    ];
                                case 6:
                                    return [
                                        3,
                                        9
                                    ];
                                case 7:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        9
                                    ];
                                case 8:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 9:
                                    return [
                                        2,
                                        {
                                            status: status.value,
                                            value: finalMap
                                        }
                                    ];
                            }
                        });
                    }));
                } else {
                    var finalMap1 = new Map();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var pair = _step.value;
                            var key = pair.key;
                            var value = pair.value;
                            if (key.status === "aborted" || value.status === "aborted") return INVALID;
                            if (key.status === "dirty" || value.status === "dirty") status.dirty();
                            finalMap1.set(key.value, value.value);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return {
                        status: status.value,
                        value: finalMap1
                    };
                }
            }
        }
    ]);
    return ZodMap;
}(ZodType);
ZodMap.create = function(keyType, valueType, params) {
    return new ZodMap((0, $78DQ7._)({
        valueType: valueType,
        keyType: keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap
    }, processCreateParams(params)));
};
var ZodSet = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodSet, ZodType);
    var _super = (0, $k1NN5._)(ZodSet);
    function ZodSet() {
        (0, $19mwo._)(this, ZodSet);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodSet, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== ZodParsedType.set) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.set,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var def = this._def;
                if (def.minSize !== null) {
                    if (ctx.data.size < def.minSize.value) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: def.minSize.value,
                            type: "set",
                            inclusive: true,
                            exact: false,
                            message: def.minSize.message
                        });
                        status.dirty();
                    }
                }
                if (def.maxSize !== null) {
                    if (ctx.data.size > def.maxSize.value) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: def.maxSize.value,
                            type: "set",
                            inclusive: true,
                            exact: false,
                            message: def.maxSize.message
                        });
                        status.dirty();
                    }
                }
                var valueType = this._def.valueType;
                function finalizeSet(elements) {
                    var parsedSet = new Set();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            if (element.status === "aborted") return INVALID;
                            if (element.status === "dirty") status.dirty();
                            parsedSet.add(element.value);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return {
                        status: status.value,
                        value: parsedSet
                    };
                }
                var elements = (0, $3jzhD._)(ctx.data.values()).map(function(item, i) {
                    return valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i));
                });
                if (ctx.common.async) return Promise.all(elements).then(function(elements) {
                    return finalizeSet(elements);
                });
                else return finalizeSet(elements);
            }
        },
        {
            key: "min",
            value: function min(minSize, message) {
                return new ZodSet((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    minSize: {
                        value: minSize,
                        message: errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "max",
            value: function max(maxSize, message) {
                return new ZodSet((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    maxSize: {
                        value: maxSize,
                        message: errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "size",
            value: function size(size, message) {
                return this.min(size, message).max(size, message);
            }
        },
        {
            key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, message);
            }
        }
    ]);
    return ZodSet;
}(ZodType);
ZodSet.create = function(valueType, params) {
    return new ZodSet((0, $78DQ7._)({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet
    }, processCreateParams(params)));
};
var ZodFunction = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodFunction, ZodType);
    var _super = (0, $k1NN5._)(ZodFunction);
    function ZodFunction() {
        (0, $19mwo._)(this, ZodFunction);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.validate = _this.implement;
        return _this;
    }
    (0, $6rpfc._)(ZodFunction, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== ZodParsedType.function) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.function,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                function makeArgsIssue(args, error) {
                    return makeIssue({
                        data: args,
                        path: ctx.path,
                        errorMaps: [
                            ctx.common.contextualErrorMap,
                            ctx.schemaErrorMap,
                            getErrorMap(),
                            errorMap
                        ].filter(function(x) {
                            return !!x;
                        }),
                        issueData: {
                            code: ZodIssueCode.invalid_arguments,
                            argumentsError: error
                        }
                    });
                }
                function makeReturnsIssue(returns, error) {
                    return makeIssue({
                        data: returns,
                        path: ctx.path,
                        errorMaps: [
                            ctx.common.contextualErrorMap,
                            ctx.schemaErrorMap,
                            getErrorMap(),
                            errorMap
                        ].filter(function(x) {
                            return !!x;
                        }),
                        issueData: {
                            code: ZodIssueCode.invalid_return_type,
                            returnTypeError: error
                        }
                    });
                }
                var params = {
                    errorMap: ctx.common.contextualErrorMap
                };
                var fn = ctx.data;
                if (this._def.returns instanceof ZodPromise) {
                    // Would love a way to avoid disabling this rule, but we need
                    // an alias (using an arrow function was what caused 2651).
                    // eslint-disable-next-line @typescript-eslint/no-this-alias
                    var me = this;
                    return OK(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                        var _len, args, _key, error, parsedArgs, result, parsedReturns;
                        var _arguments = arguments;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                        args[_key] = _arguments[_key];
                                    }
                                    error = new ZodError([]);
                                    return [
                                        4,
                                        me._def.args.parseAsync(args, params).catch(function(e) {
                                            error.addIssue(makeArgsIssue(args, e));
                                            throw error;
                                        })
                                    ];
                                case 1:
                                    parsedArgs = _state.sent();
                                    return [
                                        4,
                                        Reflect.apply(fn, this, parsedArgs)
                                    ];
                                case 2:
                                    result = _state.sent();
                                    return [
                                        4,
                                        me._def.returns._def.type.parseAsync(result, params).catch(function(e) {
                                            error.addIssue(makeReturnsIssue(result, e));
                                            throw error;
                                        })
                                    ];
                                case 3:
                                    parsedReturns = _state.sent();
                                    return [
                                        2,
                                        parsedReturns
                                    ];
                            }
                        });
                    }));
                } else {
                    // Would love a way to avoid disabling this rule, but we need
                    // an alias (using an arrow function was what caused 2651).
                    // eslint-disable-next-line @typescript-eslint/no-this-alias
                    var me1 = this;
                    return OK(function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var parsedArgs = me1._def.args.safeParse(args, params);
                        if (!parsedArgs.success) throw new ZodError([
                            makeArgsIssue(args, parsedArgs.error)
                        ]);
                        var result = Reflect.apply(fn, this, parsedArgs.data);
                        var parsedReturns = me1._def.returns.safeParse(result, params);
                        if (!parsedReturns.success) throw new ZodError([
                            makeReturnsIssue(result, parsedReturns.error)
                        ]);
                        return parsedReturns.data;
                    });
                }
            }
        },
        {
            key: "parameters",
            value: function parameters() {
                return this._def.args;
            }
        },
        {
            key: "returnType",
            value: function returnType() {
                return this._def.returns;
            }
        },
        {
            key: "args",
            value: function args() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                return new ZodFunction((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    args: ZodTuple.create(items).rest(ZodUnknown.create())
                }));
            }
        },
        {
            key: "returns",
            value: function returns(returnType) {
                return new ZodFunction((0, $ddevm._)((0, $78DQ7._)({}, this._def), {
                    returns: returnType
                }));
            }
        },
        {
            key: "implement",
            value: function implement(func) {
                var validatedFunc = this.parse(func);
                return validatedFunc;
            }
        },
        {
            key: "strictImplement",
            value: function strictImplement(func) {
                var validatedFunc = this.parse(func);
                return validatedFunc;
            }
        }
    ], [
        {
            key: "create",
            value: function create(args, returns, params) {
                return new ZodFunction((0, $78DQ7._)({
                    args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
                    returns: returns || ZodUnknown.create(),
                    typeName: ZodFirstPartyTypeKind.ZodFunction
                }, processCreateParams(params)));
            }
        }
    ]);
    return ZodFunction;
}(ZodType);
var ZodLazy = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodLazy, ZodType);
    var _super = (0, $k1NN5._)(ZodLazy);
    function ZodLazy() {
        (0, $19mwo._)(this, ZodLazy);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodLazy, [
        {
            key: "schema",
            get: function get() {
                return this._def.getter();
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var lazySchema = this._def.getter();
                return lazySchema._parse({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        }
    ]);
    return ZodLazy;
}(ZodType);
ZodLazy.create = function(getter, params) {
    return new ZodLazy((0, $78DQ7._)({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy
    }, processCreateParams(params)));
};
var ZodLiteral = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodLiteral, ZodType);
    var _super = (0, $k1NN5._)(ZodLiteral);
    function ZodLiteral() {
        (0, $19mwo._)(this, ZodLiteral);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodLiteral, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (input.data !== this._def.value) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        received: ctx.data,
                        code: ZodIssueCode.invalid_literal,
                        expected: this._def.value
                    });
                    return INVALID;
                }
                return {
                    status: "valid",
                    value: input.data
                };
            }
        },
        {
            key: "value",
            get: function get() {
                return this._def.value;
            }
        }
    ]);
    return ZodLiteral;
}(ZodType);
ZodLiteral.create = function(value, params) {
    return new ZodLiteral((0, $78DQ7._)({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral
    }, processCreateParams(params)));
};
function createZodEnum(values, params) {
    return new ZodEnum((0, $78DQ7._)({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodEnum
    }, processCreateParams(params)));
}
var ZodEnum = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodEnum, ZodType);
    var _super = (0, $k1NN5._)(ZodEnum);
    function ZodEnum() {
        (0, $19mwo._)(this, ZodEnum);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _ZodEnum_cache.set((0, $15Pju._)(_this), void 0);
        return _this;
    }
    (0, $6rpfc._)(ZodEnum, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (typeof input.data !== "string") {
                    var ctx = this._getOrReturnCtx(input);
                    var expectedValues = this._def.values;
                    addIssueToContext(ctx, {
                        expected: util.joinValues(expectedValues),
                        received: ctx.parsedType,
                        code: ZodIssueCode.invalid_type
                    });
                    return INVALID;
                }
                if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f")) __classPrivateFieldSet(this, _ZodEnum_cache, new Set(this._def.values), "f");
                if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f").has(input.data)) {
                    var ctx1 = this._getOrReturnCtx(input);
                    var expectedValues1 = this._def.values;
                    addIssueToContext(ctx1, {
                        received: ctx1.data,
                        code: ZodIssueCode.invalid_enum_value,
                        options: expectedValues1
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.values;
            }
        },
        {
            key: "enum",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "Values",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "Enum",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "extract",
            value: function extract(values) {
                var newDef = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._def;
                return ZodEnum.create(values, (0, $78DQ7._)({}, this._def, newDef));
            }
        },
        {
            key: "exclude",
            value: function exclude(values) {
                var newDef = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._def;
                return ZodEnum.create(this.options.filter(function(opt) {
                    return !values.includes(opt);
                }), (0, $78DQ7._)({}, this._def, newDef));
            }
        }
    ]);
    return ZodEnum;
}(ZodType);
_ZodEnum_cache = new WeakMap();
ZodEnum.create = createZodEnum;
var ZodNativeEnum = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodNativeEnum, ZodType);
    var _super = (0, $k1NN5._)(ZodNativeEnum);
    function ZodNativeEnum() {
        (0, $19mwo._)(this, ZodNativeEnum);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _ZodNativeEnum_cache.set((0, $15Pju._)(_this), void 0);
        return _this;
    }
    (0, $6rpfc._)(ZodNativeEnum, [
        {
            key: "_parse",
            value: function _parse(input) {
                var nativeEnumValues = util.getValidEnumValues(this._def.values);
                var ctx = this._getOrReturnCtx(input);
                if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
                    var expectedValues = util.objectValues(nativeEnumValues);
                    addIssueToContext(ctx, {
                        expected: util.joinValues(expectedValues),
                        received: ctx.parsedType,
                        code: ZodIssueCode.invalid_type
                    });
                    return INVALID;
                }
                if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f")) __classPrivateFieldSet(this, _ZodNativeEnum_cache, new Set(util.getValidEnumValues(this._def.values)), "f");
                if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f").has(input.data)) {
                    var expectedValues1 = util.objectValues(nativeEnumValues);
                    addIssueToContext(ctx, {
                        received: ctx.data,
                        code: ZodIssueCode.invalid_enum_value,
                        options: expectedValues1
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        },
        {
            key: "enum",
            get: function get() {
                return this._def.values;
            }
        }
    ]);
    return ZodNativeEnum;
}(ZodType);
_ZodNativeEnum_cache = new WeakMap();
ZodNativeEnum.create = function(values, params) {
    return new ZodNativeEnum((0, $78DQ7._)({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum
    }, processCreateParams(params)));
};
var ZodPromise = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodPromise, ZodType);
    var _super = (0, $k1NN5._)(ZodPromise);
    function ZodPromise() {
        (0, $19mwo._)(this, ZodPromise);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodPromise, [
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.type;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.promise,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
                return OK(promisified.then(function(data) {
                    return _this._def.type.parseAsync(data, {
                        path: ctx.path,
                        errorMap: ctx.common.contextualErrorMap
                    });
                }));
            }
        }
    ]);
    return ZodPromise;
}(ZodType);
ZodPromise.create = function(schema, params) {
    return new ZodPromise((0, $78DQ7._)({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise
    }, processCreateParams(params)));
};
var ZodEffects = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodEffects, ZodType);
    var _super = (0, $k1NN5._)(ZodEffects);
    function ZodEffects() {
        (0, $19mwo._)(this, ZodEffects);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodEffects, [
        {
            key: "innerType",
            value: function innerType() {
                return this._def.schema;
            }
        },
        {
            key: "sourceType",
            value: function sourceType() {
                return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                var effect = this._def.effect || null;
                var checkCtx = {
                    addIssue: function(arg) {
                        addIssueToContext(ctx, arg);
                        if (arg.fatal) status.abort();
                        else status.dirty();
                    },
                    get path () {
                        return ctx.path;
                    }
                };
                checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
                if (effect.type === "preprocess") {
                    var processed = effect.transform(ctx.data, checkCtx);
                    var _this = this;
                    if (ctx.common.async) return Promise.resolve(processed).then(function() {
                        var _ref = (0, $9OZ9j._)(function(processed) {
                            var result;
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (status.value === "aborted") return [
                                            2,
                                            INVALID
                                        ];
                                        return [
                                            4,
                                            _this._def.schema._parseAsync({
                                                data: processed,
                                                path: ctx.path,
                                                parent: ctx
                                            })
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        if (result.status === "aborted") return [
                                            2,
                                            INVALID
                                        ];
                                        if (result.status === "dirty") return [
                                            2,
                                            DIRTY(result.value)
                                        ];
                                        if (status.value === "dirty") return [
                                            2,
                                            DIRTY(result.value)
                                        ];
                                        return [
                                            2,
                                            result
                                        ];
                                }
                            });
                        });
                        return function(processed) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    else {
                        if (status.value === "aborted") return INVALID;
                        var result = this._def.schema._parseSync({
                            data: processed,
                            path: ctx.path,
                            parent: ctx
                        });
                        if (result.status === "aborted") return INVALID;
                        if (result.status === "dirty") return DIRTY(result.value);
                        if (status.value === "dirty") return DIRTY(result.value);
                        return result;
                    }
                }
                if (effect.type === "refinement") {
                    var executeRefinement = function(acc) {
                        var result = effect.refinement(acc, checkCtx);
                        if (ctx.common.async) return Promise.resolve(result);
                        if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                        return acc;
                    };
                    if (ctx.common.async === false) {
                        var inner = this._def.schema._parseSync({
                            data: ctx.data,
                            path: ctx.path,
                            parent: ctx
                        });
                        if (inner.status === "aborted") return INVALID;
                        if (inner.status === "dirty") status.dirty();
                        // return value is ignored
                        executeRefinement(inner.value);
                        return {
                            status: status.value,
                            value: inner.value
                        };
                    } else return this._def.schema._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }).then(function(inner) {
                        if (inner.status === "aborted") return INVALID;
                        if (inner.status === "dirty") status.dirty();
                        return executeRefinement(inner.value).then(function() {
                            return {
                                status: status.value,
                                value: inner.value
                            };
                        });
                    });
                }
                if (effect.type === "transform") {
                    if (ctx.common.async === false) {
                        var base = this._def.schema._parseSync({
                            data: ctx.data,
                            path: ctx.path,
                            parent: ctx
                        });
                        if (!isValid(base)) return base;
                        var result1 = effect.transform(base.value, checkCtx);
                        if (result1 instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
                        return {
                            status: status.value,
                            value: result1
                        };
                    } else return this._def.schema._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }).then(function(base) {
                        if (!isValid(base)) return base;
                        return Promise.resolve(effect.transform(base.value, checkCtx)).then(function(result) {
                            return {
                                status: status.value,
                                value: result
                            };
                        });
                    });
                }
                util.assertNever(effect);
            }
        }
    ]);
    return ZodEffects;
}(ZodType);
ZodEffects.create = function(schema, effect, params) {
    return new ZodEffects((0, $78DQ7._)({
        schema: schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect: effect
    }, processCreateParams(params)));
};
ZodEffects.createWithPreprocess = function(preprocess, schema, params) {
    return new ZodEffects((0, $78DQ7._)({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: ZodFirstPartyTypeKind.ZodEffects
    }, processCreateParams(params)));
};
var ZodOptional = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodOptional, ZodType);
    var _super = (0, $k1NN5._)(ZodOptional);
    function ZodOptional() {
        (0, $19mwo._)(this, ZodOptional);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodOptional, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType === ZodParsedType.undefined) return OK(undefined);
                return this._def.innerType._parse(input);
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodOptional;
}(ZodType);
ZodOptional.create = function(type, params) {
    return new ZodOptional((0, $78DQ7._)({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional
    }, processCreateParams(params)));
};
var ZodNullable = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodNullable, ZodType);
    var _super = (0, $k1NN5._)(ZodNullable);
    function ZodNullable() {
        (0, $19mwo._)(this, ZodNullable);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodNullable, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType === ZodParsedType.null) return OK(null);
                return this._def.innerType._parse(input);
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodNullable;
}(ZodType);
ZodNullable.create = function(type, params) {
    return new ZodNullable((0, $78DQ7._)({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable
    }, processCreateParams(params)));
};
var ZodDefault = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodDefault, ZodType);
    var _super = (0, $k1NN5._)(ZodDefault);
    function ZodDefault() {
        (0, $19mwo._)(this, ZodDefault);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodDefault, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var data = ctx.data;
                if (ctx.parsedType === ZodParsedType.undefined) data = this._def.defaultValue();
                return this._def.innerType._parse({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "removeDefault",
            value: function removeDefault() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodDefault;
}(ZodType);
ZodDefault.create = function(type, params) {
    return new ZodDefault((0, $78DQ7._)({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : function() {
            return params.default;
        }
    }, processCreateParams(params)));
};
var ZodCatch = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodCatch, ZodType);
    var _super = (0, $k1NN5._)(ZodCatch);
    function ZodCatch() {
        (0, $19mwo._)(this, ZodCatch);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodCatch, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var ctx = this._processInputParams(input).ctx;
                // newCtx is used to not collect issues from inner types in ctx
                var newCtx = (0, $ddevm._)((0, $78DQ7._)({}, ctx), {
                    common: (0, $ddevm._)((0, $78DQ7._)({}, ctx.common), {
                        issues: []
                    })
                });
                var result = this._def.innerType._parse({
                    data: newCtx.data,
                    path: newCtx.path,
                    parent: (0, $78DQ7._)({}, newCtx)
                });
                if (isAsync(result)) return result.then(function(result) {
                    return {
                        status: "valid",
                        value: result.status === "valid" ? result.value : _this._def.catchValue({
                            get error () {
                                return new ZodError(newCtx.common.issues);
                            },
                            input: newCtx.data
                        })
                    };
                });
                else return {
                    status: "valid",
                    value: result.status === "valid" ? result.value : this._def.catchValue({
                        get error () {
                            return new ZodError(newCtx.common.issues);
                        },
                        input: newCtx.data
                    })
                };
            }
        },
        {
            key: "removeCatch",
            value: function removeCatch() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodCatch;
}(ZodType);
ZodCatch.create = function(type, params) {
    return new ZodCatch((0, $78DQ7._)({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : function() {
            return params.catch;
        }
    }, processCreateParams(params)));
};
var ZodNaN = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodNaN, ZodType);
    var _super = (0, $k1NN5._)(ZodNaN);
    function ZodNaN() {
        (0, $19mwo._)(this, ZodNaN);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodNaN, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.nan) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.nan,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return {
                    status: "valid",
                    value: input.data
                };
            }
        }
    ]);
    return ZodNaN;
}(ZodType);
ZodNaN.create = function(params) {
    return new ZodNaN((0, $78DQ7._)({
        typeName: ZodFirstPartyTypeKind.ZodNaN
    }, processCreateParams(params)));
};
var BRAND = Symbol("zod_brand");
var ZodBranded = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodBranded, ZodType);
    var _super = (0, $k1NN5._)(ZodBranded);
    function ZodBranded() {
        (0, $19mwo._)(this, ZodBranded);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodBranded, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var data = ctx.data;
                return this._def.type._parse({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.type;
            }
        }
    ]);
    return ZodBranded;
}(ZodType);
var ZodPipeline = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodPipeline, ZodType);
    var _super = (0, $k1NN5._)(ZodPipeline);
    function ZodPipeline() {
        (0, $19mwo._)(this, ZodPipeline);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodPipeline, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.common.async) {
                    var _this = this;
                    var handleAsync = function() {
                        var _ref = (0, $9OZ9j._)(function() {
                            var inResult;
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this._def.in._parseAsync({
                                                data: ctx.data,
                                                path: ctx.path,
                                                parent: ctx
                                            })
                                        ];
                                    case 1:
                                        inResult = _state.sent();
                                        if (inResult.status === "aborted") return [
                                            2,
                                            INVALID
                                        ];
                                        if (inResult.status === "dirty") {
                                            status.dirty();
                                            return [
                                                2,
                                                DIRTY(inResult.value)
                                            ];
                                        } else return [
                                            2,
                                            _this._def.out._parseAsync({
                                                data: inResult.value,
                                                path: ctx.path,
                                                parent: ctx
                                            })
                                        ];
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function handleAsync() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return handleAsync();
                } else {
                    var inResult = this._def.in._parseSync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    });
                    if (inResult.status === "aborted") return INVALID;
                    if (inResult.status === "dirty") {
                        status.dirty();
                        return {
                            status: "dirty",
                            value: inResult.value
                        };
                    } else return this._def.out._parseSync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx
                    });
                }
            }
        }
    ], [
        {
            key: "create",
            value: function create(a, b) {
                return new ZodPipeline({
                    in: a,
                    out: b,
                    typeName: ZodFirstPartyTypeKind.ZodPipeline
                });
            }
        }
    ]);
    return ZodPipeline;
}(ZodType);
var ZodReadonly = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $iNfU4._)(ZodReadonly, ZodType);
    var _super = (0, $k1NN5._)(ZodReadonly);
    function ZodReadonly() {
        (0, $19mwo._)(this, ZodReadonly);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(ZodReadonly, [
        {
            key: "_parse",
            value: function _parse(input) {
                var result = this._def.innerType._parse(input);
                var freeze = function(data) {
                    if (isValid(data)) data.value = Object.freeze(data.value);
                    return data;
                };
                return isAsync(result) ? result.then(function(data) {
                    return freeze(data);
                }) : freeze(result);
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodReadonly;
}(ZodType);
ZodReadonly.create = function(type, params) {
    return new ZodReadonly((0, $78DQ7._)({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly
    }, processCreateParams(params)));
};
function custom(check) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal = arguments.length > 2 ? arguments[2] : void 0;
    if (check) return ZodAny.create().superRefine(function(data, ctx) {
        var _a, _b;
        if (!check(data)) {
            var p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            var _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            var p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue((0, $ddevm._)((0, $78DQ7._)({
                code: "custom"
            }, p2), {
                fatal: _fatal
            }));
        }
    });
    return ZodAny.create();
}
var late = {
    object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
var instanceOfType = function(// const instanceOfType = <T extends new (...args: any[]) => any>(
cls) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        message: "Input not instance of ".concat(cls.name)
    };
    return custom(function(data) {
        return data instanceof cls;
    }, params);
};
var stringType = ZodString.create;
var numberType = ZodNumber.create;
var nanType = ZodNaN.create;
var bigIntType = ZodBigInt.create;
var booleanType = ZodBoolean.create;
var dateType = ZodDate.create;
var symbolType = ZodSymbol.create;
var undefinedType = ZodUndefined.create;
var nullType = ZodNull.create;
var anyType = ZodAny.create;
var unknownType = ZodUnknown.create;
var neverType = ZodNever.create;
var voidType = ZodVoid.create;
var arrayType = ZodArray.create;
var objectType = ZodObject.create;
var strictObjectType = ZodObject.strictCreate;
var unionType = ZodUnion.create;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
var intersectionType = ZodIntersection.create;
var tupleType = ZodTuple.create;
var recordType = ZodRecord.create;
var mapType = ZodMap.create;
var setType = ZodSet.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy.create;
var literalType = ZodLiteral.create;
var enumType = ZodEnum.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional.create;
var nullableType = ZodNullable.create;
var preprocessType = ZodEffects.createWithPreprocess;
var pipelineType = ZodPipeline.create;
var ostring = function() {
    return stringType().optional();
};
var onumber = function() {
    return numberType().optional();
};
var oboolean = function() {
    return booleanType().optional();
};
var coerce = {
    string: function(arg) {
        return ZodString.create((0, $ddevm._)((0, $78DQ7._)({}, arg), {
            coerce: true
        }));
    },
    number: function(arg) {
        return ZodNumber.create((0, $ddevm._)((0, $78DQ7._)({}, arg), {
            coerce: true
        }));
    },
    boolean: function(arg) {
        return ZodBoolean.create((0, $ddevm._)((0, $78DQ7._)({}, arg), {
            coerce: true
        }));
    },
    bigint: function(arg) {
        return ZodBigInt.create((0, $ddevm._)((0, $78DQ7._)({}, arg), {
            coerce: true
        }));
    },
    date: function(arg) {
        return ZodDate.create((0, $ddevm._)((0, $78DQ7._)({}, arg), {
            coerce: true
        }));
    }
};
var NEVER = INVALID;
var z = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid,
    isAsync: isAsync,
    get util () {
        return util;
    },
    get objectUtil () {
        return objectUtil;
    },
    ZodParsedType: ZodParsedType,
    getParsedType: getParsedType,
    ZodType: ZodType,
    datetimeRegex: datetimeRegex,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodSymbol: ZodSymbol,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodCatch: ZodCatch,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    ZodPipeline: ZodPipeline,
    ZodReadonly: ZodReadonly,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () {
        return ZodFirstPartyTypeKind;
    },
    coerce: coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    "enum": enumType,
    "function": functionType,
    "instanceof": instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    "null": nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    "undefined": undefinedType,
    union: unionType,
    unknown: unknownType,
    "void": voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});

});


var $lF1I7 = parcelRequire("lF1I7");
var $978b871a0234f592$exports = {};
"use strict";

$978b871a0234f592$exports = (parcelRequire("3hyzP"));


var $3959ba5a3cb8c567$var$OriginalPromise = Promise;
/**
 * ES5 subclassing is used per:
 * https://github.com/rtsao/browser-unhandled-rejection/issues/1
 * https://kangax.github.io/compat-table/es6/#test-Promise_is_subclassable
 *
 * Adapted from: https://gist.github.com/domenic/8ed6048b187ee8f2ec75
 */ var $3959ba5a3cb8c567$var$InstrumentedPromise$1 = function Promise1(resolver) {
    if (!(this instanceof $3959ba5a3cb8c567$var$InstrumentedPromise$1)) throw new TypeError("Cannot call a class as a function");
    var promise = new $3959ba5a3cb8c567$var$OriginalPromise(function(resolve, reject) {
        return resolver(resolve, function(arg) {
            $3959ba5a3cb8c567$var$OriginalPromise.resolve().then(function() {
                if (promise._hasDownstreams === undefined) $3959ba5a3cb8c567$var$dispatchUnhandledRejectionEvent(promise, arg);
            });
            return reject(arg);
        });
    });
    promise.__proto__ = $3959ba5a3cb8c567$var$InstrumentedPromise$1.prototype;
    return promise;
};
$3959ba5a3cb8c567$var$InstrumentedPromise$1.__proto__ = $3959ba5a3cb8c567$var$OriginalPromise;
$3959ba5a3cb8c567$var$InstrumentedPromise$1.prototype.__proto__ = $3959ba5a3cb8c567$var$OriginalPromise.prototype;
$3959ba5a3cb8c567$var$InstrumentedPromise$1.prototype.then = function then(onFulfilled, onRejected) {
    var next = $3959ba5a3cb8c567$var$OriginalPromise.prototype.then.call(this, onFulfilled, onRejected);
    this._hasDownstreams = true;
    return next;
};
function $3959ba5a3cb8c567$var$dispatchUnhandledRejectionEvent(promise, reason) {
    var event = document.createEvent("Event");
    /**
   * Note: these properties should not be enumerable, which is the default setting
   */ Object.defineProperties(event, {
        promise: {
            value: promise,
            writable: false
        },
        reason: {
            value: reason,
            writable: false
        }
    });
    event.initEvent("unhandledrejection", false, true // PromiseRejectionEvent is cancelable
    );
    window.dispatchEvent(event);
}
function $3959ba5a3cb8c567$export$baf72085f5fb4df() {
    return typeof PromiseRejectionEvent === "undefined";
}
function $3959ba5a3cb8c567$export$cea1c58a6db52bca() {
    Promise = $3959ba5a3cb8c567$var$InstrumentedPromise$1;
}
function $3959ba5a3cb8c567$export$dfb5619354ba860() {
    if ($3959ba5a3cb8c567$export$baf72085f5fb4df()) $3959ba5a3cb8c567$export$cea1c58a6db52bca();
}
var $3959ba5a3cb8c567$export$2e2bcd8739ae039 = $3959ba5a3cb8c567$var$InstrumentedPromise$1;



var $b0lSM = parcelRequire("b0lSM");

var $e5wYp = parcelRequire("e5wYp");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $3jzhD = parcelRequire("3jzhD");

var $lF1I7 = parcelRequire("lF1I7");

var $ilNGG = parcelRequire("ilNGG");
var $ee9ac008b9e571de$var$name = "firebase";
var $ee9ac008b9e571de$var$version = "10.12.3";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $ilNGG.registerVersion)($ee9ac008b9e571de$var$name, $ee9ac008b9e571de$var$version, "app");


var $ilNGG = parcelRequire("ilNGG");
parcelRequire("b6033");


var $b6033 = parcelRequire("b6033");

var $15Pju = parcelRequire("15Pju");

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $c5rwh = parcelRequire("c5rwh");

var $jLCbM = parcelRequire("jLCbM");

var $laF8D = parcelRequire("laF8D");

var $iNfU4 = parcelRequire("iNfU4");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");

var $ilNGG = parcelRequire("ilNGG");

var $gQ5gw = parcelRequire("gQ5gw");

var $3DJ6n = parcelRequire("3DJ6n");

var $lF1I7 = parcelRequire("lF1I7");

var $e5K63 = parcelRequire("e5K63");
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ var $65b82078b3339b3f$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone",
    TOTP: "totp"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ var $65b82078b3339b3f$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ var $65b82078b3339b3f$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ var $65b82078b3339b3f$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ var $65b82078b3339b3f$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65b82078b3339b3f$var$_debugErrorMap() {
    var _obj;
    return _obj = {}, (0, $c5rwh._)(_obj, "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ , "This operation is restricted to administrators only."), (0, $c5rwh._)(_obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , ""), (0, $c5rwh._)(_obj, "app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ , "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console."), (0, $c5rwh._)(_obj, "app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ , "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device."), (0, $c5rwh._)(_obj, "captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ , "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains."), (0, $c5rwh._)(_obj, "code-expired" /* AuthErrorCode.CODE_EXPIRED */ , "The SMS code has expired. Please re-send the verification code to try again."), (0, $c5rwh._)(_obj, "cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ , "Cordova framework is not ready."), (0, $c5rwh._)(_obj, "cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ , "This browser is not supported."), (0, $c5rwh._)(_obj, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , "This credential is already associated with a different user account."), (0, $c5rwh._)(_obj, "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ , "The custom token corresponds to a different audience."), (0, $c5rwh._)(_obj, "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ , "This operation is sensitive and requires recent authentication. Log in again before retrying this request."), (0, $c5rwh._)(_obj, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ , "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."), (0, $c5rwh._)(_obj, "dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ , "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions."), (0, $c5rwh._)(_obj, "email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ , "Multi-factor users must always have a verified email."), (0, $c5rwh._)(_obj, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , "The email address is already in use by another account."), (0, $c5rwh._)(_obj, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ , 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.'), (0, $c5rwh._)(_obj, "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ , "The action code has expired."), (0, $c5rwh._)(_obj, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ , "This operation has been cancelled due to another conflicting popup being opened."), (0, $c5rwh._)(_obj, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , "An internal AuthError has occurred."), (0, $c5rwh._)(_obj, "invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ , "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired."), (0, $c5rwh._)(_obj, "invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ , "The mobile app identifier is not registed for the current project."), (0, $c5rwh._)(_obj, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ , "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key."), (0, $c5rwh._)(_obj, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ , "An internal AuthError has occurred."), (0, $c5rwh._)(_obj, "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ , "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user."), (0, $c5rwh._)(_obj, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ , "The continue URL provided in the request is invalid."), (0, $c5rwh._)(_obj, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ , "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme."), (0, $c5rwh._)(_obj, "invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ , "The custom token format is incorrect. Please check the documentation."), (0, $c5rwh._)(_obj, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ , "The provided dynamic link domain is not configured or authorized for the current project."), (0, $c5rwh._)(_obj, "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ , "The email address is badly formatted."), (0, $c5rwh._)(_obj, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ , "Emulator URL must start with a valid scheme (http:// or https://)."), (0, $c5rwh._)(_obj, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , "Your API key is invalid, please check you have copied it correctly."), (0, $c5rwh._)(_obj, "invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ , "The SHA-1 certificate hash provided is invalid."), (0, $c5rwh._)(_obj, "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ , "The supplied auth credential is incorrect, malformed or has expired."), (0, $c5rwh._)(_obj, "invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ , "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console."), (0, $c5rwh._)(_obj, "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ , "The request does not contain a valid proof of first factor successful sign-in."), (0, $c5rwh._)(_obj, "invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ , "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers."), (0, $c5rwh._)(_obj, "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ , "The OAuth client ID provided is either invalid or does not match the specified API key."), (0, $c5rwh._)(_obj, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ , "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console."), (0, $c5rwh._)(_obj, "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ , "The action code is invalid. This can happen if the code is malformed, expired, or has already been used."), (0, $c5rwh._)(_obj, "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ , "The password is invalid or the user does not have a password."), (0, $c5rwh._)(_obj, "invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ , "The specified persistence type is invalid. It can only be local, session or none."), (0, $c5rwh._)(_obj, "invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ , "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code]."), (0, $c5rwh._)(_obj, "invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ , "The specified provider ID is invalid."), (0, $c5rwh._)(_obj, "invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ , "The email corresponding to this action failed to send as the provided recipient email address is invalid."), (0, $c5rwh._)(_obj, "invalid-sender" /* AuthErrorCode.INVALID_SENDER */ , "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console."), (0, $c5rwh._)(_obj, "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ , "The verification ID used to create the phone auth credential is invalid."), (0, $c5rwh._)(_obj, "invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ , "The Auth instance's tenant ID is invalid."), (0, $c5rwh._)(_obj, "login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , "Login blocked by user-provided method: {$originalMessage}"), (0, $c5rwh._)(_obj, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ , "An Android Package Name must be provided if the Android App is required to be installed."), (0, $c5rwh._)(_obj, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ , "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console."), (0, $c5rwh._)(_obj, "missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ , "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided."), (0, $c5rwh._)(_obj, "missing-verification-code" /* AuthErrorCode.MISSING_CODE */ , "The phone auth credential was created with an empty SMS verification code."), (0, $c5rwh._)(_obj, "missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ , "A continue URL must be provided in the request."), (0, $c5rwh._)(_obj, "missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ , "An internal AuthError has occurred."), (0, $c5rwh._)(_obj, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ , "An iOS Bundle ID must be provided if an App Store ID is provided."), (0, $c5rwh._)(_obj, "missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ , "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload."), (0, $c5rwh._)(_obj, "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ , "A non-empty password must be provided"), (0, $c5rwh._)(_obj, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ , "No second factor identifier is provided."), (0, $c5rwh._)(_obj, "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ , "The request is missing proof of first factor successful sign-in."), (0, $c5rwh._)(_obj, "missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ , "To send verification codes, provide a phone number for the recipient."), (0, $c5rwh._)(_obj, "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ , "The phone auth credential was created with an empty verification ID."), (0, $c5rwh._)(_obj, "app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ , "This instance of FirebaseApp has been deleted."), (0, $c5rwh._)(_obj, "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ , "The user does not have a second factor matching the identifier provided."), (0, $c5rwh._)(_obj, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , "Proof of ownership of a second factor is required to complete sign-in."), (0, $c5rwh._)(_obj, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address."), (0, $c5rwh._)(_obj, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred."), (0, $c5rwh._)(_obj, "no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ , "An internal AuthError has occurred."), (0, $c5rwh._)(_obj, "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ , "User was not linked to an account with the given provider."), (0, $c5rwh._)(_obj, "null-user" /* AuthErrorCode.NULL_USER */ , "A null user object was provided as the argument for an operation which requires a non-null user object."), (0, $c5rwh._)(_obj, "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ , "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section."), (0, $c5rwh._)(_obj, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.'), (0, $c5rwh._)(_obj, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ , "Unable to establish a connection with the popup. It may have been blocked by the browser."), (0, $c5rwh._)(_obj, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ , "The popup has been closed by the user before finalizing the operation."), (0, $c5rwh._)(_obj, "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ , "User can only be linked to one identity for the given provider."), (0, $c5rwh._)(_obj, "quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ , "The project's quota for this operation has been exceeded."), (0, $c5rwh._)(_obj, "redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ , "The redirect operation has been cancelled by the user before finalizing."), (0, $c5rwh._)(_obj, "redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ , "A redirect sign-in operation is already pending."), (0, $c5rwh._)(_obj, "rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ , "The request contains malformed or mismatching credentials."), (0, $c5rwh._)(_obj, "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ , "The second factor is already enrolled on this account."), (0, $c5rwh._)(_obj, "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ , "The maximum allowed number of second factors on a user has been exceeded."), (0, $c5rwh._)(_obj, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ , "The provided tenant ID does not match the Auth instance's tenant ID"), (0, $c5rwh._)(_obj, "timeout" /* AuthErrorCode.TIMEOUT */ , "The operation has timed out."), (0, $c5rwh._)(_obj, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ , "The user's credential is no longer valid. The user must sign in again."), (0, $c5rwh._)(_obj, "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ , "We have blocked all requests from this device due to unusual activity. Try again later."), (0, $c5rwh._)(_obj, "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ , "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console."), (0, $c5rwh._)(_obj, "unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ , "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor."), (0, $c5rwh._)(_obj, "unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ , "The current environment does not support the specified persistence type."), (0, $c5rwh._)(_obj, "unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ , "This operation is not supported in a multi-tenant context."), (0, $c5rwh._)(_obj, "unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ , "The operation requires a verified email."), (0, $c5rwh._)(_obj, "user-cancelled" /* AuthErrorCode.USER_CANCELLED */ , "The user did not grant your application the permissions it requested."), (0, $c5rwh._)(_obj, "user-not-found" /* AuthErrorCode.USER_DELETED */ , "There is no user record corresponding to this identifier. The user may have been deleted."), (0, $c5rwh._)(_obj, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , "The user account has been disabled by an administrator."), (0, $c5rwh._)(_obj, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ , "The supplied credentials do not correspond to the previously signed in user."), (0, $c5rwh._)(_obj, "user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ , ""), (0, $c5rwh._)(_obj, "weak-password" /* AuthErrorCode.WEAK_PASSWORD */ , "The password must be 6 characters long or more."), (0, $c5rwh._)(_obj, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ , "This browser is not supported or 3rd party cookies and data may be disabled."), (0, $c5rwh._)(_obj, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ , "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance."), (0, $c5rwh._)(_obj, "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ , "The reCAPTCHA token is missing when sending request to the backend."), (0, $c5rwh._)(_obj, "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ , "The reCAPTCHA token is invalid when sending request to the backend."), (0, $c5rwh._)(_obj, "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ , "The reCAPTCHA action is invalid when sending request to the backend."), (0, $c5rwh._)(_obj, "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ , "reCAPTCHA Enterprise integration is not enabled for this project."), (0, $c5rwh._)(_obj, "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ , "The reCAPTCHA client type is missing when sending request to the backend."), (0, $c5rwh._)(_obj, "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ , "The reCAPTCHA version is missing when sending request to the backend."), (0, $c5rwh._)(_obj, "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ , "Invalid request parameters."), (0, $c5rwh._)(_obj, "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ , "The reCAPTCHA version is invalid when sending request to the backend."), (0, $c5rwh._)(_obj, "unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , "The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK."), (0, $c5rwh._)(_obj, "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ , "The password does not meet the requirements."), _obj;
}
function $65b82078b3339b3f$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return (0, $c5rwh._)({}, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ , "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.");
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ var $65b82078b3339b3f$export$2329c99376c9d0a4 = $65b82078b3339b3f$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ var $65b82078b3339b3f$export$7f8ddf7c7c20b3cd = $65b82078b3339b3f$var$_prodErrorMap;
var $65b82078b3339b3f$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $gQ5gw.ErrorFactory)("auth", "Firebase", $65b82078b3339b3f$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ var $65b82078b3339b3f$export$9bb611d729802a56 = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_LOGIN_CREDENTIALS: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized",
    RECAPTCHA_NOT_ENABLED: "auth/recaptcha-not-enabled",
    MISSING_RECAPTCHA_TOKEN: "auth/missing-recaptcha-token",
    INVALID_RECAPTCHA_TOKEN: "auth/invalid-recaptcha-token",
    INVALID_RECAPTCHA_ACTION: "auth/invalid-recaptcha-action",
    MISSING_CLIENT_TYPE: "auth/missing-client-type",
    MISSING_RECAPTCHA_VERSION: "auth/missing-recaptcha-version",
    INVALID_RECAPTCHA_VERSION: "auth/invalid-recaptcha-version",
    INVALID_REQ_TYPE: "auth/invalid-req-type"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$logClient = new (0, $3DJ6n.Logger)("@firebase/auth");
function $65b82078b3339b3f$var$_logWarn(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _logClient;
    if ($65b82078b3339b3f$var$logClient.logLevel <= (0, $3DJ6n.LogLevel).WARN) (_logClient = $65b82078b3339b3f$var$logClient).warn.apply(_logClient, [
        "Auth (".concat((0, $ilNGG.SDK_VERSION), "): ").concat(msg)
    ].concat((0, $3jzhD._)(args)));
}
function $65b82078b3339b3f$var$_logError(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _logClient;
    if ($65b82078b3339b3f$var$logClient.logLevel <= (0, $3DJ6n.LogLevel).ERROR) (_logClient = $65b82078b3339b3f$var$logClient).error.apply(_logClient, [
        "Auth (".concat((0, $ilNGG.SDK_VERSION), "): ").concat(msg)
    ].concat((0, $3jzhD._)(args)));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65b82078b3339b3f$export$9fa96a7d116ea3ce(authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        rest[_key - 1] = arguments[_key];
    }
    throw $65b82078b3339b3f$var$createErrorInternal.apply(void 0, [
        authOrCode
    ].concat((0, $3jzhD._)(rest)));
}
function $65b82078b3339b3f$export$9d398bebfec1c039(authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        rest[_key - 1] = arguments[_key];
    }
    return $65b82078b3339b3f$var$createErrorInternal.apply(void 0, [
        authOrCode
    ].concat((0, $3jzhD._)(rest)));
}
function $65b82078b3339b3f$var$_errorWithCustomMessage(auth, code, message) {
    var errorMap = Object.assign(Object.assign({}, $65b82078b3339b3f$export$7f8ddf7c7c20b3cd()), (0, $c5rwh._)({}, code, message));
    var factory = new (0, $gQ5gw.ErrorFactory)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $65b82078b3339b3f$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , "Operations that alter the current user are not supported in conjunction with FirebaseServerApp");
}
function $65b82078b3339b3f$var$_assertInstanceOf(auth, object, instance) {
    var constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $65b82078b3339b3f$export$9fa96a7d116ea3ce(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $65b82078b3339b3f$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , "Type of ".concat(object.constructor.name, " does not match expected instance.") + "Did you pass a reference from a different Auth SDK?");
    }
}
function $65b82078b3339b3f$var$createErrorInternal(authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        rest[_key - 1] = arguments[_key];
    }
    var _DEFAULT_AUTH_ERROR_FACTORY1;
    if (typeof authOrCode !== "string") {
        var _authOrCode__errorFactory;
        var code = rest[0];
        var fullParams = (0, $3jzhD._)(rest.slice(1));
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return (_authOrCode__errorFactory = authOrCode._errorFactory).create.apply(_authOrCode__errorFactory, [
            code
        ].concat((0, $3jzhD._)(fullParams)));
    }
    return (_DEFAULT_AUTH_ERROR_FACTORY1 = $65b82078b3339b3f$var$_DEFAULT_AUTH_ERROR_FACTORY).create.apply(_DEFAULT_AUTH_ERROR_FACTORY1, [
        authOrCode
    ].concat((0, $3jzhD._)(rest)));
}
function $65b82078b3339b3f$export$890c4ad488842ce7(assertion, authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        rest[_key - 2] = arguments[_key];
    }
    if (!assertion) throw $65b82078b3339b3f$var$createErrorInternal.apply(void 0, [
        authOrCode
    ].concat((0, $3jzhD._)(rest)));
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $65b82078b3339b3f$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    var message = "INTERNAL ASSERTION FAILED: " + failure;
    $65b82078b3339b3f$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $65b82078b3339b3f$export$1fbe638ecf81657e(assertion, message) {
    if (!assertion) $65b82078b3339b3f$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65b82078b3339b3f$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $65b82078b3339b3f$var$_isHttpOrHttps() {
    return $65b82078b3339b3f$var$_getCurrentScheme() === "http:" || $65b82078b3339b3f$var$_getCurrentScheme() === "https:";
}
function $65b82078b3339b3f$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $65b82078b3339b3f$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($65b82078b3339b3f$var$_isHttpOrHttps() || (0, $gQ5gw.isBrowserExtension)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $65b82078b3339b3f$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    var navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ var $65b82078b3339b3f$var$Delay = /*#__PURE__*/ function() {
    "use strict";
    function Delay(shortDelay, longDelay) {
        (0, $19mwo._)(this, Delay);
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $65b82078b3339b3f$export$1fbe638ecf81657e(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $gQ5gw.isMobileCordova)() || (0, $gQ5gw.isReactNative)();
    }
    (0, $6rpfc._)(Delay, [
        {
            key: "get",
            value: function get() {
                if (!$65b82078b3339b3f$var$_isOnline()) // Pick the shorter timeout.
                return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
                // If running in a mobile environment, return the long delay, otherwise
                // return the short delay.
                // This could be improved in the future to dynamically change based on other
                // variables instead of just reading the current environment.
                return this.isMobile ? this.longDelay : this.shortDelay;
            }
        }
    ]);
    return Delay;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65b82078b3339b3f$var$_emulatorUrl(config, path) {
    $65b82078b3339b3f$export$1fbe638ecf81657e(config.emulator, "Emulator should always be set here");
    var url = config.emulator.url;
    if (!path) return url;
    return "".concat(url).concat(path.startsWith("/") ? path.slice(1) : path);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$export$2ed0fc6709e59212 = /*#__PURE__*/ function() {
    "use strict";
    function FetchProvider() {
        (0, $19mwo._)(this, FetchProvider);
    }
    (0, $6rpfc._)(FetchProvider, null, [
        {
            key: "initialize",
            value: function initialize(fetchImpl, headersImpl, responseImpl) {
                this.fetchImpl = fetchImpl;
                if (headersImpl) this.headersImpl = headersImpl;
                if (responseImpl) this.responseImpl = responseImpl;
            }
        },
        {
            key: "fetch",
            value: function fetch1() {
                if (this.fetchImpl) return this.fetchImpl;
                if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
                if (typeof globalThis !== "undefined" && globalThis.fetch) return globalThis.fetch;
                if (typeof fetch !== "undefined") return fetch;
                $65b82078b3339b3f$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
            }
        },
        {
            key: "headers",
            value: function headers() {
                if (this.headersImpl) return this.headersImpl;
                if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
                if (typeof globalThis !== "undefined" && globalThis.Headers) return globalThis.Headers;
                if (typeof Headers !== "undefined") return Headers;
                $65b82078b3339b3f$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
            }
        },
        {
            key: "response",
            value: function response() {
                if (this.responseImpl) return this.responseImpl;
                if (typeof self !== "undefined" && "Response" in self) return self.Response;
                if (typeof globalThis !== "undefined" && globalThis.Response) return globalThis.Response;
                if (typeof Response !== "undefined") return Response;
                $65b82078b3339b3f$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
            }
        }
    ]);
    return FetchProvider;
}();
var $65b82078b3339b3f$var$_obj;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ var $65b82078b3339b3f$var$SERVER_ERROR_MAP = ($65b82078b3339b3f$var$_obj = {}, // Custom token errors.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ , "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ), // This can only happen if the SDK sends a bad request.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Create Auth URI errors.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ , "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ), // This can only happen if the SDK sends a bad request.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Sign in with email and password errors (some apply to sign up too).
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ , "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ), // This can only happen if the SDK sends a bad request.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ , "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ), // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
// invalid.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ , "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ), // Sign up with email and password errors.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ , "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ , "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ), // Verify assertion for sign in with credential errors:
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ , "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ , "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ , "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ), // This can only happen if the SDK sends a bad request.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Send Password reset email errors:
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ , "user-not-found" /* AuthErrorCode.USER_DELETED */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ , "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ , "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ , "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ), // This can only happen if the SDK sends a bad request.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Operations that require ID token in request:
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ , "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ , "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ , "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ , "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ), // Other errors.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ , "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ , "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ), // Phone Auth related errors.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_CODE" /* ServerError.INVALID_CODE */ , "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ , "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ , "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ , "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ , "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ), // Other action code errors when additional settings passed.
// MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
// This is OK as this error will be caught by client side validation.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ , "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ , "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ), // getProjectConfig errors when clientId is passed.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ , "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ), // User actions (sign-up or deletion) disabled errors.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ , "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ), // Multi factor related errors.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ , "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ , "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ , "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ , "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ , "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ , "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ), // Blocking functions related errors.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Recaptcha related errors.
(0, $c5rwh._)($65b82078b3339b3f$var$_obj, "RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ , "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ , "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ , "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ , "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ , "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ , "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ , "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ), (0, $c5rwh._)($65b82078b3339b3f$var$_obj, "INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ , "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ), $65b82078b3339b3f$var$_obj);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$DEFAULT_API_TIMEOUT_MS = new $65b82078b3339b3f$var$Delay(30000, 60000);
function $65b82078b3339b3f$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
function $65b82078b3339b3f$var$_performApiRequest(auth, method, path, request) {
    return $65b82078b3339b3f$var$__performApiRequest.apply(this, arguments);
}
function $65b82078b3339b3f$var$__performApiRequest() {
    $65b82078b3339b3f$var$__performApiRequest = (0, $9OZ9j._)(function(auth, method, path, request) {
        var customErrorMap;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            customErrorMap = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : {};
            return [
                2,
                $65b82078b3339b3f$var$_performFetchWithErrorHandling(auth, customErrorMap, /*#__PURE__*/ (0, $9OZ9j._)(function() {
                    var body, params, query, headers;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                body = {};
                                params = {};
                                if (request) {
                                    if (method === "GET" /* HttpMethod.GET */ ) params = request;
                                    else body = {
                                        body: JSON.stringify(request)
                                    };
                                }
                                query = (0, $gQ5gw.querystring)(Object.assign({
                                    key: auth.config.apiKey
                                }, params)).slice(1);
                                return [
                                    4,
                                    auth._getAdditionalHeaders()
                                ];
                            case 1:
                                headers = _state.sent();
                                headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/json";
                                if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
                                return [
                                    2,
                                    $65b82078b3339b3f$export$2ed0fc6709e59212.fetch()($65b82078b3339b3f$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
                                        method: method,
                                        headers: headers,
                                        referrerPolicy: "no-referrer"
                                    }, body))
                                ];
                        }
                    });
                }))
            ];
        });
    });
    return $65b82078b3339b3f$var$__performApiRequest.apply(this, arguments);
}
function $65b82078b3339b3f$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    return $65b82078b3339b3f$var$__performFetchWithErrorHandling.apply(this, arguments);
}
function $65b82078b3339b3f$var$__performFetchWithErrorHandling() {
    $65b82078b3339b3f$var$__performFetchWithErrorHandling = (0, $9OZ9j._)(function(auth, customErrorMap, fetchFn) {
        var errorMap, networkTimeout, response, json, errorMessage, _errorMessage_split, serverErrorCode, serverErrorMessage, authError, e;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    auth._canInitEmulator = false;
                    errorMap = Object.assign(Object.assign({}, $65b82078b3339b3f$var$SERVER_ERROR_MAP), customErrorMap);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    networkTimeout = new $65b82078b3339b3f$var$NetworkTimeout(auth);
                    return [
                        4,
                        Promise.race([
                            fetchFn(),
                            networkTimeout.promise
                        ])
                    ];
                case 2:
                    response = _state.sent();
                    // If we've reached this point, the fetch succeeded and the networkTimeout
                    // didn't throw; clear the network timeout delay so that Node won't hang
                    networkTimeout.clearNetworkTimeout();
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    json = _state.sent();
                    if ("needConfirmation" in json) throw $65b82078b3339b3f$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
                    if (response.ok && !("errorMessage" in json)) return [
                        2,
                        json
                    ];
                    else {
                        errorMessage = response.ok ? json.errorMessage : json.error.message;
                        _errorMessage_split = (0, $2MTYX._)(errorMessage.split(" : "), 2), serverErrorCode = _errorMessage_split[0], serverErrorMessage = _errorMessage_split[1];
                        if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $65b82078b3339b3f$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
                        else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $65b82078b3339b3f$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
                        else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $65b82078b3339b3f$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
                        authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
                        if (serverErrorMessage) throw $65b82078b3339b3f$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
                        else $65b82078b3339b3f$export$9fa96a7d116ea3ce(auth, authError);
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    if (e instanceof (0, $gQ5gw.FirebaseError)) throw e;
                    // Changing this to a different error code will log user out when there is a network error
                    // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
                    // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
                    $65b82078b3339b3f$export$9fa96a7d116ea3ce(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
                        "message": String(e)
                    });
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__performFetchWithErrorHandling.apply(this, arguments);
}
function $65b82078b3339b3f$var$_performSignInRequest(auth, method, path, request) {
    return $65b82078b3339b3f$var$__performSignInRequest.apply(this, arguments);
}
function $65b82078b3339b3f$var$__performSignInRequest() {
    $65b82078b3339b3f$var$__performSignInRequest = (0, $9OZ9j._)(function(auth, method, path, request) {
        var customErrorMap, serverResponse;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    customErrorMap = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : {};
                    return [
                        4,
                        $65b82078b3339b3f$var$_performApiRequest(auth, method, path, request, customErrorMap)
                    ];
                case 1:
                    serverResponse = _state.sent();
                    if ("mfaPendingCredential" in serverResponse) $65b82078b3339b3f$export$9fa96a7d116ea3ce(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
                        _serverResponse: serverResponse
                    });
                    return [
                        2,
                        serverResponse
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__performSignInRequest.apply(this, arguments);
}
function $65b82078b3339b3f$var$_getFinalTarget(auth, host, path, query) {
    var base = "".concat(host).concat(path, "?").concat(query);
    if (!auth.config.emulator) return "".concat(auth.config.apiScheme, "://").concat(base);
    return $65b82078b3339b3f$var$_emulatorUrl(auth.config, base);
}
function $65b82078b3339b3f$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case "ENFORCE":
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case "AUDIT":
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case "OFF":
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
var $65b82078b3339b3f$var$NetworkTimeout = /*#__PURE__*/ function() {
    "use strict";
    function NetworkTimeout(auth) {
        var _this = this;
        (0, $19mwo._)(this, NetworkTimeout);
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise(function(_, reject) {
            _this.timer = setTimeout(function() {
                return reject($65b82078b3339b3f$export$9d398bebfec1c039(_this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $65b82078b3339b3f$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    (0, $6rpfc._)(NetworkTimeout, [
        {
            key: "clearNetworkTimeout",
            value: function clearNetworkTimeout() {
                clearTimeout(this.timer);
            }
        }
    ]);
    return NetworkTimeout;
}();
function $65b82078b3339b3f$var$_makeTaggedError(auth, code, response) {
    var errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    var error = $65b82078b3339b3f$export$9d398bebfec1c039(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65b82078b3339b3f$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $65b82078b3339b3f$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
var $65b82078b3339b3f$var$RecaptchaConfig = /*#__PURE__*/ function() {
    "use strict";
    function RecaptchaConfig(response) {
        (0, $19mwo._)(this, RecaptchaConfig);
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = "";
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error("recaptchaKey undefined");
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split("/")[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    (0, $6rpfc._)(RecaptchaConfig, [
        {
            /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ key: "getProviderEnforcementState",
            value: function getProviderEnforcementState(providerStr) {
                if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.recaptchaEnforcementState[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var recaptchaEnforcementState = _step.value;
                        if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $65b82078b3339b3f$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return null;
            }
        },
        {
            /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ key: "isProviderEnabled",
            value: function isProviderEnabled(providerStr) {
                return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
            }
        }
    ]);
    return RecaptchaConfig;
}();
function $65b82078b3339b3f$var$getRecaptchaParams(auth) {
    return $65b82078b3339b3f$var$_getRecaptchaParams.apply(this, arguments);
}
function $65b82078b3339b3f$var$_getRecaptchaParams() {
    $65b82078b3339b3f$var$_getRecaptchaParams = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(auth) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65b82078b3339b3f$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().recaptchaSiteKey || ""
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_getRecaptchaParams.apply(this, arguments);
}
function $65b82078b3339b3f$var$getRecaptchaConfig(auth, request) {
    return $65b82078b3339b3f$var$_getRecaptchaConfig.apply(this, arguments);
}
function $65b82078b3339b3f$var$_getRecaptchaConfig() {
    $65b82078b3339b3f$var$_getRecaptchaConfig = (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $65b82078b3339b3f$var$_getRecaptchaConfig.apply(this, arguments);
}
function $65b82078b3339b3f$var$deleteAccount(auth, request) {
    return $65b82078b3339b3f$var$_deleteAccount.apply(this, arguments);
}
function $65b82078b3339b3f$var$_deleteAccount() {
    $65b82078b3339b3f$var$_deleteAccount = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request)
            ];
        });
    });
    return $65b82078b3339b3f$var$_deleteAccount.apply(this, arguments);
}
function $65b82078b3339b3f$var$deleteLinkedAccounts(auth, request) {
    return $65b82078b3339b3f$var$_deleteLinkedAccounts.apply(this, arguments);
}
function $65b82078b3339b3f$var$_deleteLinkedAccounts() {
    $65b82078b3339b3f$var$_deleteLinkedAccounts = (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $65b82078b3339b3f$var$_deleteLinkedAccounts.apply(this, arguments);
}
function $65b82078b3339b3f$var$getAccountInfo(auth, request) {
    return $65b82078b3339b3f$var$_getAccountInfo.apply(this, arguments);
}
function $65b82078b3339b3f$var$_getAccountInfo() {
    $65b82078b3339b3f$var$_getAccountInfo = (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $65b82078b3339b3f$var$_getAccountInfo.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65b82078b3339b3f$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        var date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $65b82078b3339b3f$export$306ddfe3a8403e2(user) {
    var forceRefresh = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (0, $gQ5gw.getModularInstance)(user).getIdToken(forceRefresh);
}
function $65b82078b3339b3f$export$7a38258bbe170828(user) {
    return $65b82078b3339b3f$var$_getIdTokenResult.apply(this, arguments);
}
function $65b82078b3339b3f$var$_getIdTokenResult() {
    $65b82078b3339b3f$var$_getIdTokenResult = /**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ (0, $9OZ9j._)(function(user) {
        var forceRefresh, userInternal, token, claims, firebase, signInProvider;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    forceRefresh = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    userInternal = (0, $gQ5gw.getModularInstance)(user);
                    return [
                        4,
                        userInternal.getIdToken(forceRefresh)
                    ];
                case 1:
                    token = _state.sent();
                    claims = $65b82078b3339b3f$var$_parseToken(token);
                    $65b82078b3339b3f$export$890c4ad488842ce7(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
                    signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
                    return [
                        2,
                        {
                            claims: claims,
                            token: token,
                            authTime: $65b82078b3339b3f$var$utcTimestampToDateString($65b82078b3339b3f$var$secondsStringToMilliseconds(claims.auth_time)),
                            issuedAtTime: $65b82078b3339b3f$var$utcTimestampToDateString($65b82078b3339b3f$var$secondsStringToMilliseconds(claims.iat)),
                            expirationTime: $65b82078b3339b3f$var$utcTimestampToDateString($65b82078b3339b3f$var$secondsStringToMilliseconds(claims.exp)),
                            signInProvider: signInProvider || null,
                            signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
                        }
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_getIdTokenResult.apply(this, arguments);
}
function $65b82078b3339b3f$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $65b82078b3339b3f$var$_parseToken(token) {
    var _token_split = (0, $2MTYX._)(token.split("."), 3), algorithm = _token_split[0], payload = _token_split[1], signature = _token_split[2];
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $65b82078b3339b3f$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        var decoded = (0, $gQ5gw.base64Decode)(payload);
        if (!decoded) {
            $65b82078b3339b3f$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $65b82078b3339b3f$var$_logError("Caught error parsing JWT payload as JSON", e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $65b82078b3339b3f$var$_tokenExpiresIn(token) {
    var parsedToken = $65b82078b3339b3f$var$_parseToken(token);
    $65b82078b3339b3f$export$890c4ad488842ce7(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $65b82078b3339b3f$export$890c4ad488842ce7(typeof parsedToken.exp !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $65b82078b3339b3f$export$890c4ad488842ce7(typeof parsedToken.iat !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
function $65b82078b3339b3f$var$_logoutIfInvalidated(user, promise) {
    return $65b82078b3339b3f$var$__logoutIfInvalidated.apply(this, arguments);
}
function $65b82078b3339b3f$var$__logoutIfInvalidated() {
    $65b82078b3339b3f$var$__logoutIfInvalidated = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(user, promise) {
        var bypassAuthState, e;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    if (bypassAuthState) return [
                        2,
                        promise
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        6
                    ]);
                    return [
                        4,
                        promise
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    e = _state.sent();
                    if (!(e instanceof (0, $gQ5gw.FirebaseError) && $65b82078b3339b3f$var$isUserInvalidated(e))) return [
                        3,
                        5
                    ];
                    if (!(user.auth.currentUser === user)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        user.auth.signOut()
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    throw e;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__logoutIfInvalidated.apply(this, arguments);
}
function $65b82078b3339b3f$var$isUserInvalidated(param) {
    var code = param.code;
    return code === "auth/user-disabled" /* AuthErrorCode.USER_DISABLED */  || code === "auth/user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$ProactiveRefresh = /*#__PURE__*/ function() {
    "use strict";
    function ProactiveRefresh(user) {
        (0, $19mwo._)(this, ProactiveRefresh);
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    (0, $6rpfc._)(ProactiveRefresh, [
        {
            key: "_start",
            value: function _start() {
                if (this.isRunning) return;
                this.isRunning = true;
                this.schedule();
            }
        },
        {
            key: "_stop",
            value: function _stop() {
                if (!this.isRunning) return;
                this.isRunning = false;
                if (this.timerId !== null) clearTimeout(this.timerId);
            }
        },
        {
            key: "getInterval",
            value: function getInterval(wasError) {
                var _a;
                if (wasError) {
                    var interval = this.errorBackoff;
                    this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
                    return interval;
                } else {
                    // Reset the error backoff
                    this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
                    var expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
                    var interval1 = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
                    return Math.max(0, interval1);
                }
            }
        },
        {
            key: "schedule",
            value: function schedule() {
                var wasError = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (!this.isRunning) // Just in case...
                return;
                var interval = this.getInterval(wasError);
                var _this = this;
                this.timerId = setTimeout(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.iteration()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }), interval);
            }
        },
        {
            key: "iteration",
            value: function iteration() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var e;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.user.getIdToken(true)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                // Only retry on network errors
                                if ((e === null || e === void 0 ? void 0 : e.code) === "auth/network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ) _this.schedule(/* wasError */ true);
                                return [
                                    2
                                ];
                            case 3:
                                _this.schedule();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ProactiveRefresh;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$UserMetadata = /*#__PURE__*/ function() {
    "use strict";
    function UserMetadata(createdAt, lastLoginAt) {
        (0, $19mwo._)(this, UserMetadata);
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    (0, $6rpfc._)(UserMetadata, [
        {
            key: "_initializeTime",
            value: function _initializeTime() {
                this.lastSignInTime = $65b82078b3339b3f$var$utcTimestampToDateString(this.lastLoginAt);
                this.creationTime = $65b82078b3339b3f$var$utcTimestampToDateString(this.createdAt);
            }
        },
        {
            key: "_copy",
            value: function _copy(metadata) {
                this.createdAt = metadata.createdAt;
                this.lastLoginAt = metadata.lastLoginAt;
                this._initializeTime();
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    createdAt: this.createdAt,
                    lastLoginAt: this.lastLoginAt
                };
            }
        }
    ]);
    return UserMetadata;
}();
function $65b82078b3339b3f$var$_reloadWithoutSaving(user) {
    return $65b82078b3339b3f$var$__reloadWithoutSaving.apply(this, arguments);
}
function $65b82078b3339b3f$var$__reloadWithoutSaving() {
    $65b82078b3339b3f$var$__reloadWithoutSaving = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(user) {
        var _a, auth, idToken, response, coreAccount, newProviderData, providerData, oldIsAnonymous, newIsAnonymous, isAnonymous, updates;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    auth = user.auth;
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    return [
                        4,
                        $65b82078b3339b3f$var$_logoutIfInvalidated(user, $65b82078b3339b3f$var$getAccountInfo(auth, {
                            idToken: idToken
                        }))
                    ];
                case 2:
                    response = _state.sent();
                    $65b82078b3339b3f$export$890c4ad488842ce7(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    coreAccount = response.users[0];
                    user._notifyReloadListener(coreAccount);
                    newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $65b82078b3339b3f$var$extractProviderData(coreAccount.providerUserInfo) : [];
                    providerData = $65b82078b3339b3f$var$mergeProviderData(user.providerData, newProviderData);
                    // Preserves the non-nonymous status of the stored user, even if no more
                    // credentials (federated or email/password) are linked to the user. If
                    // the user was previously anonymous, then use provider data to update.
                    // On the other hand, if it was not anonymous before, it should never be
                    // considered anonymous now.
                    oldIsAnonymous = user.isAnonymous;
                    newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
                    isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
                    updates = {
                        uid: coreAccount.localId,
                        displayName: coreAccount.displayName || null,
                        photoURL: coreAccount.photoUrl || null,
                        email: coreAccount.email || null,
                        emailVerified: coreAccount.emailVerified || false,
                        phoneNumber: coreAccount.phoneNumber || null,
                        tenantId: coreAccount.tenantId || null,
                        providerData: providerData,
                        metadata: new $65b82078b3339b3f$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
                        isAnonymous: isAnonymous
                    };
                    Object.assign(user, updates);
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__reloadWithoutSaving.apply(this, arguments);
}
function $65b82078b3339b3f$export$d24c54395ce0c509(user) {
    return $65b82078b3339b3f$var$_reload.apply(this, arguments);
}
function $65b82078b3339b3f$var$_reload() {
    $65b82078b3339b3f$var$_reload = /**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ (0, $9OZ9j._)(function(user) {
        var userInternal;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $gQ5gw.getModularInstance)(user);
                    return [
                        4,
                        $65b82078b3339b3f$var$_reloadWithoutSaving(userInternal)
                    ];
                case 1:
                    _state.sent();
                    // Even though the current user hasn't changed, update
                    // current user will trigger a persistence update w/ the
                    // new info.
                    return [
                        4,
                        userInternal.auth._persistUserIfCurrent(userInternal)
                    ];
                case 2:
                    _state.sent();
                    userInternal.auth._notifyListenersIfCurrent(userInternal);
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_reload.apply(this, arguments);
}
function $65b82078b3339b3f$var$mergeProviderData(original, newData) {
    var deduped = original.filter(function(o) {
        return !newData.some(function(n) {
            return n.providerId === o.providerId;
        });
    });
    return (0, $3jzhD._)(deduped).concat((0, $3jzhD._)(newData));
}
function $65b82078b3339b3f$var$extractProviderData(providers) {
    return providers.map(function(_a) {
        var providerId = _a.providerId, provider = (0, $lF1I7.__rest)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
function $65b82078b3339b3f$var$requestStsToken(auth, refreshToken) {
    return $65b82078b3339b3f$var$_requestStsToken.apply(this, arguments);
}
function $65b82078b3339b3f$var$_requestStsToken() {
    $65b82078b3339b3f$var$_requestStsToken = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(auth, refreshToken) {
        var response;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65b82078b3339b3f$var$_performFetchWithErrorHandling(auth, {}, /*#__PURE__*/ (0, $9OZ9j._)(function() {
                            var body, _auth_config, tokenApiHost, apiKey, url, headers;
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        body = (0, $gQ5gw.querystring)({
                                            "grant_type": "refresh_token",
                                            "refresh_token": refreshToken
                                        }).slice(1);
                                        _auth_config = auth.config, tokenApiHost = _auth_config.tokenApiHost, apiKey = _auth_config.apiKey;
                                        url = $65b82078b3339b3f$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , "key=".concat(apiKey));
                                        return [
                                            4,
                                            auth._getAdditionalHeaders()
                                        ];
                                    case 1:
                                        headers = _state.sent();
                                        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
                                        return [
                                            2,
                                            $65b82078b3339b3f$export$2ed0fc6709e59212.fetch()(url, {
                                                method: "POST" /* HttpMethod.POST */ ,
                                                headers: headers,
                                                body: body
                                            })
                                        ];
                                }
                            });
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    // The response comes back in snake_case. Convert to camel:
                    return [
                        2,
                        {
                            accessToken: response.access_token,
                            expiresIn: response.expires_in,
                            refreshToken: response.refresh_token
                        }
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_requestStsToken.apply(this, arguments);
}
function $65b82078b3339b3f$var$revokeToken(auth, request) {
    return $65b82078b3339b3f$var$_revokeToken.apply(this, arguments);
}
function $65b82078b3339b3f$var$_revokeToken() {
    $65b82078b3339b3f$var$_revokeToken = (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $65b82078b3339b3f$var$_revokeToken.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ var $65b82078b3339b3f$var$StsTokenManager = /*#__PURE__*/ function() {
    "use strict";
    function StsTokenManager() {
        (0, $19mwo._)(this, StsTokenManager);
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    (0, $6rpfc._)(StsTokenManager, [
        {
            key: "isExpired",
            get: function get() {
                return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
            }
        },
        {
            key: "updateFromServerResponse",
            value: function updateFromServerResponse(response) {
                $65b82078b3339b3f$export$890c4ad488842ce7(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $65b82078b3339b3f$export$890c4ad488842ce7(typeof response.idToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $65b82078b3339b3f$export$890c4ad488842ce7(typeof response.refreshToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                var expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $65b82078b3339b3f$var$_tokenExpiresIn(response.idToken);
                this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
            }
        },
        {
            key: "updateFromIdToken",
            value: function updateFromIdToken(idToken) {
                $65b82078b3339b3f$export$890c4ad488842ce7(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                var expiresIn = $65b82078b3339b3f$var$_tokenExpiresIn(idToken);
                this.updateTokensAndExpiration(idToken, null, expiresIn);
            }
        },
        {
            key: "getToken",
            value: function getToken(auth) {
                var forceRefresh = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!forceRefresh && _this.accessToken && !_this.isExpired) return [
                                    2,
                                    _this.accessToken
                                ];
                                $65b82078b3339b3f$export$890c4ad488842ce7(_this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
                                if (!_this.refreshToken) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.refresh(auth, _this.refreshToken)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.accessToken
                                ];
                            case 2:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "clearRefreshToken",
            value: function clearRefreshToken() {
                this.refreshToken = null;
            }
        },
        {
            key: "refresh",
            value: function refresh(auth, oldToken) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _ref, accessToken, refreshToken, expiresIn;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65b82078b3339b3f$var$requestStsToken(auth, oldToken)
                                ];
                            case 1:
                                _ref = _state.sent(), accessToken = _ref.accessToken, refreshToken = _ref.refreshToken, expiresIn = _ref.expiresIn;
                                _this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateTokensAndExpiration",
            value: function updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
                this.refreshToken = refreshToken || null;
                this.accessToken = accessToken || null;
                this.expirationTime = Date.now() + expiresInSec * 1000;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    refreshToken: this.refreshToken,
                    accessToken: this.accessToken,
                    expirationTime: this.expirationTime
                };
            }
        },
        {
            key: "_assign",
            value: function _assign(stsTokenManager) {
                this.accessToken = stsTokenManager.accessToken;
                this.refreshToken = stsTokenManager.refreshToken;
                this.expirationTime = stsTokenManager.expirationTime;
            }
        },
        {
            key: "_clone",
            value: function _clone() {
                return Object.assign(new StsTokenManager(), this.toJSON());
            }
        },
        {
            key: "_performRefresh",
            value: function _performRefresh() {
                return $65b82078b3339b3f$var$debugFail("not implemented");
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(appName, object) {
                var refreshToken = object.refreshToken, accessToken = object.accessToken, expirationTime = object.expirationTime;
                var manager = new StsTokenManager();
                if (refreshToken) {
                    $65b82078b3339b3f$export$890c4ad488842ce7(typeof refreshToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                        appName: appName
                    });
                    manager.refreshToken = refreshToken;
                }
                if (accessToken) {
                    $65b82078b3339b3f$export$890c4ad488842ce7(typeof accessToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                        appName: appName
                    });
                    manager.accessToken = accessToken;
                }
                if (expirationTime) {
                    $65b82078b3339b3f$export$890c4ad488842ce7(typeof expirationTime === "number", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                        appName: appName
                    });
                    manager.expirationTime = expirationTime;
                }
                return manager;
            }
        }
    ]);
    return StsTokenManager;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65b82078b3339b3f$var$assertStringOrUndefined(assertion, appName) {
    $65b82078b3339b3f$export$890c4ad488842ce7(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
var $65b82078b3339b3f$export$23ebac1979863676 = /*#__PURE__*/ function() {
    "use strict";
    function UserImpl(_a) {
        (0, $19mwo._)(this, UserImpl);
        var uid = _a.uid, auth = _a.auth, stsTokenManager = _a.stsTokenManager, opt = (0, $lF1I7.__rest)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $65b82078b3339b3f$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? (0, $3jzhD._)(opt.providerData) : [];
        this.metadata = new $65b82078b3339b3f$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    (0, $6rpfc._)(UserImpl, [
        {
            key: "getIdToken",
            value: function getIdToken(forceRefresh) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var accessToken;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_logoutIfInvalidated(_this, _this.stsTokenManager.getToken(_this.auth, forceRefresh))
                                ];
                            case 1:
                                accessToken = _state.sent();
                                $65b82078b3339b3f$export$890c4ad488842ce7(accessToken, _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                if (!(_this.accessToken !== accessToken)) return [
                                    3,
                                    3
                                ];
                                _this.accessToken = accessToken;
                                return [
                                    4,
                                    _this.auth._persistUserIfCurrent(_this)
                                ];
                            case 2:
                                _state.sent();
                                _this.auth._notifyListenersIfCurrent(_this);
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    accessToken
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getIdTokenResult",
            value: function getIdTokenResult1(forceRefresh) {
                return $65b82078b3339b3f$export$7a38258bbe170828(this, forceRefresh);
            }
        },
        {
            key: "reload",
            value: function reload1() {
                return $65b82078b3339b3f$export$d24c54395ce0c509(this);
            }
        },
        {
            key: "_assign",
            value: function _assign(user) {
                if (this === user) return;
                $65b82078b3339b3f$export$890c4ad488842ce7(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                this.displayName = user.displayName;
                this.photoURL = user.photoURL;
                this.email = user.email;
                this.emailVerified = user.emailVerified;
                this.phoneNumber = user.phoneNumber;
                this.isAnonymous = user.isAnonymous;
                this.tenantId = user.tenantId;
                this.providerData = user.providerData.map(function(userInfo) {
                    return Object.assign({}, userInfo);
                });
                this.metadata._copy(user.metadata);
                this.stsTokenManager._assign(user.stsTokenManager);
            }
        },
        {
            key: "_clone",
            value: function _clone(auth) {
                var newUser = new UserImpl(Object.assign(Object.assign({}, this), {
                    auth: auth,
                    stsTokenManager: this.stsTokenManager._clone()
                }));
                newUser.metadata._copy(this.metadata);
                return newUser;
            }
        },
        {
            key: "_onReload",
            value: function _onReload(callback) {
                // There should only ever be one listener, and that is a single instance of MultiFactorUser
                $65b82078b3339b3f$export$890c4ad488842ce7(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                this.reloadListener = callback;
                if (this.reloadUserInfo) {
                    this._notifyReloadListener(this.reloadUserInfo);
                    this.reloadUserInfo = null;
                }
            }
        },
        {
            key: "_notifyReloadListener",
            value: function _notifyReloadListener(userInfo) {
                if (this.reloadListener) this.reloadListener(userInfo);
                else // If no listener is subscribed yet, save the result so it's available when they do subscribe
                this.reloadUserInfo = userInfo;
            }
        },
        {
            key: "_startProactiveRefresh",
            value: function _startProactiveRefresh() {
                this.proactiveRefresh._start();
            }
        },
        {
            key: "_stopProactiveRefresh",
            value: function _stopProactiveRefresh() {
                this.proactiveRefresh._stop();
            }
        },
        {
            key: "_updateTokensIfNecessary",
            value: function _updateTokensIfNecessary(response) {
                var reload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var tokensRefreshed;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                tokensRefreshed = false;
                                if (response.idToken && response.idToken !== _this.stsTokenManager.accessToken) {
                                    _this.stsTokenManager.updateFromServerResponse(response);
                                    tokensRefreshed = true;
                                }
                                if (!reload) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_reloadWithoutSaving(_this)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _this.auth._persistUserIfCurrent(_this)
                                ];
                            case 3:
                                _state.sent();
                                if (tokensRefreshed) _this.auth._notifyListenersIfCurrent(_this);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var idToken;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if ((0, $ilNGG._isFirebaseServerApp)(_this.auth.app)) return [
                                    2,
                                    Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(_this.auth))
                                ];
                                return [
                                    4,
                                    _this.getIdToken()
                                ];
                            case 1:
                                idToken = _state.sent();
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_logoutIfInvalidated(_this, $65b82078b3339b3f$var$deleteAccount(_this.auth, {
                                        idToken: idToken
                                    }))
                                ];
                            case 2:
                                _state.sent();
                                _this.stsTokenManager.clearRefreshToken();
                                // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
                                //       cancels pending actions...
                                return [
                                    2,
                                    _this.auth.signOut()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return Object.assign(Object.assign({
                    uid: this.uid,
                    email: this.email || undefined,
                    emailVerified: this.emailVerified,
                    displayName: this.displayName || undefined,
                    isAnonymous: this.isAnonymous,
                    photoURL: this.photoURL || undefined,
                    phoneNumber: this.phoneNumber || undefined,
                    tenantId: this.tenantId || undefined,
                    providerData: this.providerData.map(function(userInfo) {
                        return Object.assign({}, userInfo);
                    }),
                    stsTokenManager: this.stsTokenManager.toJSON(),
                    // Redirect event ID must be maintained in case there is a pending
                    // redirect event.
                    _redirectEventId: this._redirectEventId
                }, this.metadata.toJSON()), {
                    // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
                    apiKey: this.auth.config.apiKey,
                    appName: this.auth.name
                });
            }
        },
        {
            key: "refreshToken",
            get: function get() {
                return this.stsTokenManager.refreshToken || "";
            }
        }
    ], [
        {
            key: "_fromJSON",
            value: function _fromJSON(auth, object) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
                var email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
                var phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
                var photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
                var tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
                var _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
                var createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
                var lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
                var uid = object.uid, emailVerified = object.emailVerified, isAnonymous = object.isAnonymous, providerData = object.providerData, plainObjectTokenManager = object.stsTokenManager;
                $65b82078b3339b3f$export$890c4ad488842ce7(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                var stsTokenManager = $65b82078b3339b3f$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
                $65b82078b3339b3f$export$890c4ad488842ce7(typeof uid === "string", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $65b82078b3339b3f$var$assertStringOrUndefined(displayName, auth.name);
                $65b82078b3339b3f$var$assertStringOrUndefined(email, auth.name);
                $65b82078b3339b3f$export$890c4ad488842ce7(typeof emailVerified === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $65b82078b3339b3f$export$890c4ad488842ce7(typeof isAnonymous === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $65b82078b3339b3f$var$assertStringOrUndefined(phoneNumber, auth.name);
                $65b82078b3339b3f$var$assertStringOrUndefined(photoURL, auth.name);
                $65b82078b3339b3f$var$assertStringOrUndefined(tenantId, auth.name);
                $65b82078b3339b3f$var$assertStringOrUndefined(_redirectEventId, auth.name);
                $65b82078b3339b3f$var$assertStringOrUndefined(createdAt, auth.name);
                $65b82078b3339b3f$var$assertStringOrUndefined(lastLoginAt, auth.name);
                var user = new UserImpl({
                    uid: uid,
                    auth: auth,
                    email: email,
                    emailVerified: emailVerified,
                    displayName: displayName,
                    isAnonymous: isAnonymous,
                    photoURL: photoURL,
                    phoneNumber: phoneNumber,
                    tenantId: tenantId,
                    stsTokenManager: stsTokenManager,
                    createdAt: createdAt,
                    lastLoginAt: lastLoginAt
                });
                if (providerData && Array.isArray(providerData)) user.providerData = providerData.map(function(userInfo) {
                    return Object.assign({}, userInfo);
                });
                if (_redirectEventId) user._redirectEventId = _redirectEventId;
                return user;
            }
        },
        {
            key: "_fromIdTokenResponse",
            value: /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ function _fromIdTokenResponse(auth, idTokenResponse) {
                var isAnonymous = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                return (0, $9OZ9j._)(function() {
                    var stsTokenManager, user;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                stsTokenManager = new $65b82078b3339b3f$var$StsTokenManager();
                                stsTokenManager.updateFromServerResponse(idTokenResponse);
                                // Initialize the Firebase Auth user.
                                user = new UserImpl({
                                    uid: idTokenResponse.localId,
                                    auth: auth,
                                    stsTokenManager: stsTokenManager,
                                    isAnonymous: isAnonymous
                                });
                                // Updates the user info and data and resolves with a user instance.
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_reloadWithoutSaving(user)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    user
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_fromGetAccountInfoResponse",
            value: /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ function _fromGetAccountInfoResponse(auth, response, idToken) {
                return (0, $9OZ9j._)(function() {
                    var coreAccount, providerData, isAnonymous, stsTokenManager, user, updates;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        coreAccount = response.users[0];
                        $65b82078b3339b3f$export$890c4ad488842ce7(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                        providerData = coreAccount.providerUserInfo !== undefined ? $65b82078b3339b3f$var$extractProviderData(coreAccount.providerUserInfo) : [];
                        isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
                        stsTokenManager = new $65b82078b3339b3f$var$StsTokenManager();
                        stsTokenManager.updateFromIdToken(idToken);
                        // Initialize the Firebase Auth user.
                        user = new UserImpl({
                            uid: coreAccount.localId,
                            auth: auth,
                            stsTokenManager: stsTokenManager,
                            isAnonymous: isAnonymous
                        });
                        // update the user with data from the GetAccountInfo response.
                        updates = {
                            uid: coreAccount.localId,
                            displayName: coreAccount.displayName || null,
                            photoURL: coreAccount.photoUrl || null,
                            email: coreAccount.email || null,
                            emailVerified: coreAccount.emailVerified || false,
                            phoneNumber: coreAccount.phoneNumber || null,
                            tenantId: coreAccount.tenantId || null,
                            providerData: providerData,
                            metadata: new $65b82078b3339b3f$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
                            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length)
                        };
                        Object.assign(user, updates);
                        return [
                            2,
                            user
                        ];
                    });
                })();
            }
        }
    ]);
    return UserImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$instanceCache = new Map();
function $65b82078b3339b3f$export$158acd800e1ef08b(cls) {
    $65b82078b3339b3f$export$1fbe638ecf81657e(cls instanceof Function, "Expected a class definition");
    var instance = $65b82078b3339b3f$var$instanceCache.get(cls);
    if (instance) {
        $65b82078b3339b3f$export$1fbe638ecf81657e(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $65b82078b3339b3f$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$InMemoryPersistence = /*#__PURE__*/ function() {
    "use strict";
    function InMemoryPersistence() {
        (0, $19mwo._)(this, InMemoryPersistence);
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    (0, $6rpfc._)(InMemoryPersistence, [
        {
            key: "_isAvailable",
            value: function _isAvailable() {
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        return [
                            2,
                            true
                        ];
                    });
                })();
            }
        },
        {
            key: "_set",
            value: function _set(key, value) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        _this.storage[key] = value;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_get",
            value: function _get(key) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var value;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        value = _this.storage[key];
                        return [
                            2,
                            value === undefined ? null : value
                        ];
                    });
                })();
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        delete _this.storage[key];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_addListener",
            value: function _addListener(_key, _listener) {
                // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
                return;
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(_key, _listener) {
                // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
                return;
            }
        }
    ]);
    return InMemoryPersistence;
}();
$65b82078b3339b3f$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ var $65b82078b3339b3f$export$3a6d5c9ae78a2c08 = $65b82078b3339b3f$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65b82078b3339b3f$export$cf2f7c5792f80b46(key, apiKey, appName) {
    return "firebase:".concat(key, ":").concat(apiKey, ":").concat(appName);
}
var $65b82078b3339b3f$var$PersistenceUserManager = /*#__PURE__*/ function() {
    "use strict";
    function PersistenceUserManager(persistence, auth, userKey) {
        (0, $19mwo._)(this, PersistenceUserManager);
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        var _this_auth = this.auth, config = _this_auth.config, name = _this_auth.name;
        this.fullUserKey = $65b82078b3339b3f$export$cf2f7c5792f80b46(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $65b82078b3339b3f$export$cf2f7c5792f80b46("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    (0, $6rpfc._)(PersistenceUserManager, [
        {
            key: "setCurrentUser",
            value: function setCurrentUser(user) {
                return this.persistence._set(this.fullUserKey, user.toJSON());
            }
        },
        {
            key: "getCurrentUser",
            value: function getCurrentUser() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var blob;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.persistence._get(_this.fullUserKey)
                                ];
                            case 1:
                                blob = _state.sent();
                                return [
                                    2,
                                    blob ? $65b82078b3339b3f$export$23ebac1979863676._fromJSON(_this.auth, blob) : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "removeCurrentUser",
            value: function removeCurrentUser() {
                return this.persistence._remove(this.fullUserKey);
            }
        },
        {
            key: "savePersistenceForRedirect",
            value: function savePersistenceForRedirect() {
                return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
            }
        },
        {
            key: "setPersistence",
            value: function setPersistence(newPersistence) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var currentUser;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.persistence === newPersistence) return [
                                    2
                                ];
                                return [
                                    4,
                                    _this.getCurrentUser()
                                ];
                            case 1:
                                currentUser = _state.sent();
                                return [
                                    4,
                                    _this.removeCurrentUser()
                                ];
                            case 2:
                                _state.sent();
                                _this.persistence = newPersistence;
                                if (currentUser) return [
                                    2,
                                    _this.setCurrentUser(currentUser)
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete() {
                this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
            }
        }
    ], [
        {
            key: "create",
            value: function create(auth, persistenceHierarchy) {
                var userKey = arguments.length > 2 && arguments[2] !== void 0 /* KeyName.AUTH_USER */  ? arguments[2] : "authUser";
                return (0, $9OZ9j._)(function() {
                    var availablePersistences, selectedPersistence, key, userToMigrate, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, persistence, blob, user, _a, err, migrationHierarchy;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!persistenceHierarchy.length) return [
                                    2,
                                    new PersistenceUserManager($65b82078b3339b3f$export$158acd800e1ef08b($65b82078b3339b3f$export$3a6d5c9ae78a2c08), auth, userKey)
                                ];
                                return [
                                    4,
                                    Promise.all(persistenceHierarchy.map(function() {
                                        var _ref = (0, $9OZ9j._)(function(persistence) {
                                            return (0, $lF1I7.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            persistence._isAvailable()
                                                        ];
                                                    case 1:
                                                        if (_state.sent()) return [
                                                            2,
                                                            persistence
                                                        ];
                                                        return [
                                                            2,
                                                            undefined
                                                        ];
                                                }
                                            });
                                        });
                                        return function(persistence) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 1:
                                availablePersistences = _state.sent().filter(function(persistence) {
                                    return persistence;
                                });
                                // Fall back to the first persistence listed, or in memory if none available
                                selectedPersistence = availablePersistences[0] || $65b82078b3339b3f$export$158acd800e1ef08b($65b82078b3339b3f$export$3a6d5c9ae78a2c08);
                                key = $65b82078b3339b3f$export$cf2f7c5792f80b46(userKey, auth.config.apiKey, auth.name);
                                // Pull out the existing user, setting the chosen persistence to that
                                // persistence if the user exists.
                                userToMigrate = null;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    9,
                                    10,
                                    11
                                ]);
                                _iterator = persistenceHierarchy[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    8
                                ];
                                persistence = _step.value;
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    persistence._get(key)
                                ];
                            case 5:
                                blob = _state.sent();
                                if (blob) {
                                    user = $65b82078b3339b3f$export$23ebac1979863676._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                                    if (persistence !== selectedPersistence) userToMigrate = user;
                                    selectedPersistence = persistence;
                                    return [
                                        3,
                                        8
                                    ];
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                _a = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 11:
                                // If we find the user in a persistence that does support migration, use
                                // that migration path (of only persistences that support migration)
                                migrationHierarchy = availablePersistences.filter(function(p) {
                                    return p._shouldAllowMigration;
                                });
                                // If the persistence does _not_ allow migration, just finish off here
                                if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return [
                                    2,
                                    new PersistenceUserManager(selectedPersistence, auth, userKey)
                                ];
                                selectedPersistence = migrationHierarchy[0];
                                if (!userToMigrate) return [
                                    3,
                                    13
                                ];
                                // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
                                // we'll just let it bubble to surface the error.
                                return [
                                    4,
                                    selectedPersistence._set(key, userToMigrate.toJSON())
                                ];
                            case 12:
                                _state.sent();
                                _state.label = 13;
                            case 13:
                                // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
                                // such as users getting stuck with a previous account after signing out and refreshing the tab.
                                return [
                                    4,
                                    Promise.all(persistenceHierarchy.map(function() {
                                        var _ref = (0, $9OZ9j._)(function(persistence) {
                                            var _a;
                                            return (0, $lF1I7.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (!(persistence !== selectedPersistence)) return [
                                                            3,
                                                            4
                                                        ];
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4,
                                                            persistence._remove(key)
                                                        ];
                                                    case 2:
                                                        _state.sent();
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 3:
                                                        _a = _state.sent();
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(persistence) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 14:
                                _state.sent();
                                return [
                                    2,
                                    new PersistenceUserManager(selectedPersistence, auth, userKey)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PersistenceUserManager;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $65b82078b3339b3f$var$_getBrowserName(userAgent) {
    var ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* BrowserName.OPERA */ ;
    else if ($65b82078b3339b3f$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* BrowserName.EDGE */ ;
    else if ($65b82078b3339b3f$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* BrowserName.SILK */ ;
    else if ($65b82078b3339b3f$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($65b82078b3339b3f$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($65b82078b3339b3f$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes("chrome/") || $65b82078b3339b3f$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($65b82078b3339b3f$export$92108d983e8ee699(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        var re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        var matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $65b82078b3339b3f$var$_isFirefox() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $gQ5gw.getUA)();
    return /firefox\//i.test(ua);
}
function $65b82078b3339b3f$var$_isSafari() {
    var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $gQ5gw.getUA)();
    var ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $65b82078b3339b3f$var$_isChromeIOS() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $gQ5gw.getUA)();
    return /crios\//i.test(ua);
}
function $65b82078b3339b3f$var$_isIEMobile() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $gQ5gw.getUA)();
    return /iemobile/i.test(ua);
}
function $65b82078b3339b3f$export$92108d983e8ee699() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $gQ5gw.getUA)();
    return /android/i.test(ua);
}
function $65b82078b3339b3f$var$_isBlackBerry() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $gQ5gw.getUA)();
    return /blackberry/i.test(ua);
}
function $65b82078b3339b3f$var$_isWebOS() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $gQ5gw.getUA)();
    return /webos/i.test(ua);
}
function $65b82078b3339b3f$export$d66dc83d8cfc8dd() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $gQ5gw.getUA)();
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $65b82078b3339b3f$export$91c6e00c14e7e6fd() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $gQ5gw.getUA)();
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $65b82078b3339b3f$var$_isIOSStandalone() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $gQ5gw.getUA)();
    var _a;
    return $65b82078b3339b3f$export$d66dc83d8cfc8dd(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $65b82078b3339b3f$var$_isIE10() {
    return (0, $gQ5gw.isIE)() && document.documentMode === 10;
}
function $65b82078b3339b3f$var$_isMobileBrowser() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $gQ5gw.getUA)();
    // TODO: implement getBrowserName equivalent for OS.
    return $65b82078b3339b3f$export$d66dc83d8cfc8dd(ua) || $65b82078b3339b3f$export$92108d983e8ee699(ua) || $65b82078b3339b3f$var$_isWebOS(ua) || $65b82078b3339b3f$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $65b82078b3339b3f$var$_isIEMobile(ua);
}
function $65b82078b3339b3f$var$_isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    } catch (e) {
        return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $65b82078b3339b3f$export$9f4f30ee63539e24(clientPlatform) {
    var frameworks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $65b82078b3339b3f$var$_getBrowserName((0, $gQ5gw.getUA)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = "".concat($65b82078b3339b3f$var$_getBrowserName((0, $gQ5gw.getUA)()), "-").concat(clientPlatform);
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    var reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return "".concat(reportedPlatform, "/", "JsCore" /* ClientImplementation.CORE */ , "/").concat((0, $ilNGG.SDK_VERSION), "/").concat(reportedFrameworks);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$AuthMiddlewareQueue = /*#__PURE__*/ function() {
    "use strict";
    function AuthMiddlewareQueue(auth) {
        (0, $19mwo._)(this, AuthMiddlewareQueue);
        this.auth = auth;
        this.queue = [];
    }
    (0, $6rpfc._)(AuthMiddlewareQueue, [
        {
            key: "pushCallback",
            value: function pushCallback(callback, onAbort) {
                var _this = this;
                // The callback could be sync or async. Wrap it into a
                // function that is always async.
                var wrappedCallback = function(user) {
                    return new Promise(function(resolve, reject) {
                        try {
                            var result = callback(user);
                            // Either resolve with existing promise or wrap a non-promise
                            // return value into a promise.
                            resolve(result);
                        } catch (e) {
                            // Sync callback throws.
                            reject(e);
                        }
                    });
                };
                // Attach the onAbort if present
                wrappedCallback.onAbort = onAbort;
                this.queue.push(wrappedCallback);
                var index = this.queue.length - 1;
                return function() {
                    // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
                    // indexing of other elements.
                    _this.queue[index] = function() {
                        return Promise.resolve();
                    };
                };
            }
        },
        {
            key: "runMiddleware",
            value: function runMiddleware(nextUser) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var onAbortStack, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, beforeStateCallback, err, e, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, onAbort;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.auth.currentUser === nextUser) return [
                                    2
                                ];
                                // While running the middleware, build a temporary stack of onAbort
                                // callbacks to call if one middleware callback rejects.
                                onAbortStack = [];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    10,
                                    ,
                                    11
                                ]);
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = _this.queue[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                beforeStateCallback = _step.value;
                                return [
                                    4,
                                    beforeStateCallback(nextUser)
                                ];
                            case 4:
                                _state.sent();
                                // Only push the onAbort if the callback succeeds
                                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                e = _state.sent();
                                // Run all onAbort, with separate try/catch to ignore any errors and
                                // continue
                                onAbortStack.reverse();
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = onAbortStack[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        onAbort = _step1.value;
                                        try {
                                            onAbort();
                                        } catch (_) {
                                        /* swallow error */ }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                throw _this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                                    originalMessage: e === null || e === void 0 ? void 0 : e.message
                                });
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AuthMiddlewareQueue;
}();
function $65b82078b3339b3f$var$_getPasswordPolicy(auth) {
    return $65b82078b3339b3f$var$__getPasswordPolicy.apply(this, arguments);
}
function $65b82078b3339b3f$var$__getPasswordPolicy() {
    $65b82078b3339b3f$var$__getPasswordPolicy = /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ (0, $9OZ9j._)(function(auth) {
        var request;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            request = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
            return [
                2,
                $65b82078b3339b3f$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $65b82078b3339b3f$var$__getPasswordPolicy.apply(this, arguments);
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
var $65b82078b3339b3f$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ var $65b82078b3339b3f$var$PasswordPolicyImpl = /*#__PURE__*/ function() {
    "use strict";
    function PasswordPolicyImpl(response) {
        (0, $19mwo._)(this, PasswordPolicyImpl);
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        var responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $65b82078b3339b3f$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED") this.enforcementState = "OFF";
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join("")) !== null && _c !== void 0 ? _c : "";
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    (0, $6rpfc._)(PasswordPolicyImpl, [
        {
            key: "validatePassword",
            value: function validatePassword(password) {
                var _a, _b, _c, _d, _e, _f;
                var status = {
                    isValid: true,
                    passwordPolicy: this
                };
                // Check the password length and character options.
                this.validatePasswordLengthOptions(password, status);
                this.validatePasswordCharacterOptions(password, status);
                // Combine the status into single isValid property.
                status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
                status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
                status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
                status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
                status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
                status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
                return status;
            }
        },
        {
            /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ key: "validatePasswordLengthOptions",
            value: function validatePasswordLengthOptions(password, status) {
                var minPasswordLength = this.customStrengthOptions.minPasswordLength;
                var maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
                if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
                if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
            }
        },
        {
            /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ key: "validatePasswordCharacterOptions",
            value: function validatePasswordCharacterOptions(password, status) {
                // Assign statuses for requirements even if the password is an empty string.
                this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
                var passwordChar;
                for(var i = 0; i < password.length; i++){
                    passwordChar = password.charAt(i);
                    this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= "a" && passwordChar <= "z", /* containsUppercaseCharacter= */ passwordChar >= "A" && passwordChar <= "Z", /* containsNumericCharacter= */ passwordChar >= "0" && passwordChar <= "9", /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
                }
            }
        },
        {
            /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ key: "updatePasswordCharacterOptionsStatuses",
            value: function updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
                if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
                if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
                if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
                if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
            }
        }
    ]);
    return PasswordPolicyImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$export$91477dc880baac21 = /*#__PURE__*/ function() {
    "use strict";
    function AuthImpl(app, heartbeatServiceProvider, appCheckServiceProvider, config) {
        (0, $19mwo._)(this, AuthImpl);
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $65b82078b3339b3f$var$Subscription(this);
        this.idTokenSubscription = new $65b82078b3339b3f$var$Subscription(this);
        this.beforeStateQueue = new $65b82078b3339b3f$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $65b82078b3339b3f$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    (0, $6rpfc._)(AuthImpl, [
        {
            key: "_initializeWithPersistence",
            value: function _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
                if (popupRedirectResolver) this._popupRedirectResolver = $65b82078b3339b3f$export$158acd800e1ef08b(popupRedirectResolver);
                var _this = this;
                // Have to check for app deletion throughout initialization (after each
                // promise resolution)
                this._initializationPromise = this.queue(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                    var _a, _b, e;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this._deleted) return [
                                    2
                                ];
                                return [
                                    4,
                                    $65b82078b3339b3f$var$PersistenceUserManager.create(_this, persistenceHierarchy)
                                ];
                            case 1:
                                _this.persistenceManager = _state.sent();
                                if (_this._deleted) return [
                                    2
                                ];
                                if (!((_a = _this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively)) return [
                                    3,
                                    5
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this._popupRedirectResolver._initialize(_this)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    4,
                                    _this.initializeCurrentUser(popupRedirectResolver)
                                ];
                            case 6:
                                _state.sent();
                                _this.lastNotifiedUid = ((_b = _this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
                                if (_this._deleted) return [
                                    2
                                ];
                                _this._isInitialized = true;
                                return [
                                    2
                                ];
                        }
                    });
                }));
                return this._initializationPromise;
            }
        },
        {
            key: "_onStorageEvent",
            value: /**
     * If the persistence is changed in another window, the user manager will let us know
     */ function _onStorageEvent() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var user;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this._deleted) return [
                                    2
                                ];
                                return [
                                    4,
                                    _this.assertedPersistence.getCurrentUser()
                                ];
                            case 1:
                                user = _state.sent();
                                if (!_this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
                                return [
                                    2
                                ];
                                if (!(_this.currentUser && user && _this.currentUser.uid === user.uid)) return [
                                    3,
                                    3
                                ];
                                // Data update, simply copy data changes.
                                _this._currentUser._assign(user);
                                // If tokens changed from previous user tokens, this will trigger
                                // notifyAuthListeners_.
                                return [
                                    4,
                                    _this.currentUser.getIdToken()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 3:
                                // Update current Auth state. Either a new login or logout.
                                // Skip blocking callbacks, they should not apply to a change in another tab.
                                return [
                                    4,
                                    _this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initializeCurrentUserFromIdToken",
            value: function initializeCurrentUserFromIdToken(idToken) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var response, user, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    $65b82078b3339b3f$var$getAccountInfo(_this, {
                                        idToken: idToken
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    4,
                                    $65b82078b3339b3f$export$23ebac1979863676._fromGetAccountInfoResponse(_this, response, idToken)
                                ];
                            case 2:
                                user = _state.sent();
                                return [
                                    4,
                                    _this.directlySetCurrentUser(user)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                err = _state.sent();
                                console.warn("FirebaseServerApp could not login user with provided authIdToken: ", err);
                                return [
                                    4,
                                    _this.directlySetCurrentUser(null)
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initializeCurrentUser",
            value: function initializeCurrentUser(popupRedirectResolver) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _a, idToken, previouslyStoredUser, futureCurrentUser, needsTocheckMiddleware, redirectUserEventId, storedUserEventId, result, e;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if ((0, $ilNGG._isFirebaseServerApp)(_this.app)) {
                                    idToken = _this.app.settings.authIdToken;
                                    if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
                                    // attach an emulator, if desired.
                                    return [
                                        2,
                                        new Promise(function(resolve) {
                                            setTimeout(function() {
                                                return _this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve);
                                            });
                                        })
                                    ];
                                    else return [
                                        2,
                                        _this.directlySetCurrentUser(null)
                                    ];
                                }
                                return [
                                    4,
                                    _this.assertedPersistence.getCurrentUser()
                                ];
                            case 1:
                                previouslyStoredUser = _state.sent();
                                futureCurrentUser = previouslyStoredUser;
                                needsTocheckMiddleware = false;
                                if (!(popupRedirectResolver && _this.config.authDomain)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.getOrInitRedirectPersistenceManager()
                                ];
                            case 2:
                                _state.sent();
                                redirectUserEventId = (_a = _this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
                                storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
                                return [
                                    4,
                                    _this.tryRedirectSignIn(popupRedirectResolver)
                                ];
                            case 3:
                                result = _state.sent();
                                // If the stored user (i.e. the old "currentUser") has a redirectId that
                                // matches the redirect user, then we want to initially sign in with the
                                // new user object from result.
                                // TODO(samgho): More thoroughly test all of this
                                if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                                    futureCurrentUser = result.user;
                                    needsTocheckMiddleware = true;
                                }
                                _state.label = 4;
                            case 4:
                                // If no user in persistence, there is no current user. Set to null.
                                if (!futureCurrentUser) return [
                                    2,
                                    _this.directlySetCurrentUser(null)
                                ];
                                if (!!futureCurrentUser._redirectEventId) return [
                                    3,
                                    9
                                ];
                                if (!needsTocheckMiddleware) return [
                                    3,
                                    8
                                ];
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    _this.beforeStateQueue.runMiddleware(futureCurrentUser)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                e = _state.sent();
                                futureCurrentUser = previouslyStoredUser;
                                // We know this is available since the bit is only set when the
                                // resolver is available
                                _this._popupRedirectResolver._overrideRedirectResult(_this, function() {
                                    return Promise.reject(e);
                                });
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                if (futureCurrentUser) return [
                                    2,
                                    _this.reloadAndSetCurrentUserOrClear(futureCurrentUser)
                                ];
                                else return [
                                    2,
                                    _this.directlySetCurrentUser(null)
                                ];
                                _state.label = 9;
                            case 9:
                                $65b82078b3339b3f$export$890c4ad488842ce7(_this._popupRedirectResolver, _this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                                return [
                                    4,
                                    _this.getOrInitRedirectPersistenceManager()
                                ];
                            case 10:
                                _state.sent();
                                // If the redirect user's event ID matches the current user's event ID,
                                // DO NOT reload the current user, otherwise they'll be cleared from storage.
                                // This is important for the reauthenticateWithRedirect() flow.
                                if (_this.redirectUser && _this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return [
                                    2,
                                    _this.directlySetCurrentUser(futureCurrentUser)
                                ];
                                return [
                                    2,
                                    _this.reloadAndSetCurrentUserOrClear(futureCurrentUser)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "tryRedirectSignIn",
            value: function tryRedirectSignIn(redirectResolver) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var result, e;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // The redirect user needs to be checked (and signed in if available)
                                // during auth initialization. All of the normal sign in and link/reauth
                                // flows call back into auth and push things onto the promise queue. We
                                // need to await the result of the redirect sign in *inside the promise
                                // queue*. This presents a problem: we run into deadlock. See:
                                //    ┌> [Initialization] ─────┐
                                //    ┌> [<other queue tasks>] │
                                //    └─ [getRedirectResult] <─┘
                                //    where [] are tasks on the queue and arrows denote awaits
                                // Initialization will never complete because it's waiting on something
                                // that's waiting for initialization to complete!
                                //
                                // Instead, this method calls getRedirectResult() (stored in
                                // _completeRedirectFn) with an optional parameter that instructs all of
                                // the underlying auth operations to skip anything that mutates auth state.
                                result = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this._popupRedirectResolver._completeRedirectFn(_this, redirectResolver, true)
                                ];
                            case 2:
                                // We know this._popupRedirectResolver is set since redirectResolver
                                // is passed in. The _completeRedirectFn expects the unwrapped extern.
                                result = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                e = _state.sent();
                                // Swallow any errors here; the code can retrieve them in
                                // getRedirectResult().
                                return [
                                    4,
                                    _this._setRedirectUser(null)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reloadAndSetCurrentUserOrClear",
            value: function reloadAndSetCurrentUserOrClear(user) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var e;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_reloadWithoutSaving(user)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                if ((e === null || e === void 0 ? void 0 : e.code) !== "auth/network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ) // Something's wrong with the user's token. Log them out and remove
                                // them from storage
                                return [
                                    2,
                                    _this.directlySetCurrentUser(null)
                                ];
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2,
                                    _this.directlySetCurrentUser(user)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "useDeviceLanguage",
            value: function useDeviceLanguage() {
                this.languageCode = $65b82078b3339b3f$var$_getUserLanguage();
            }
        },
        {
            key: "_delete",
            value: function _delete() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        _this._deleted = true;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "updateCurrentUser",
            value: function updateCurrentUser(userExtern) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var user;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        if ((0, $ilNGG._isFirebaseServerApp)(_this.app)) return [
                            2,
                            Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(_this))
                        ];
                        // The public updateCurrentUser method needs to make a copy of the user,
                        // and also check that the project matches
                        user = userExtern ? (0, $gQ5gw.getModularInstance)(userExtern) : null;
                        if (user) $65b82078b3339b3f$export$890c4ad488842ce7(user.auth.config.apiKey === _this.config.apiKey, _this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
                        return [
                            2,
                            _this._updateCurrentUser(user && user._clone(_this))
                        ];
                    });
                })();
            }
        },
        {
            key: "_updateCurrentUser",
            value: function _updateCurrentUser(user) {
                var skipBeforeStateCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this._deleted) return [
                                    2
                                ];
                                if (user) $65b82078b3339b3f$export$890c4ad488842ce7(_this.tenantId === user.tenantId, _this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
                                if (!!skipBeforeStateCallbacks) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.beforeStateQueue.runMiddleware(user)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    _this.queue(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                                        return (0, $lF1I7.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this.directlySetCurrentUser(user)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _this.notifyAuthListeners();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signOut",
            value: function signOut() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if ((0, $ilNGG._isFirebaseServerApp)(_this.app)) return [
                                    2,
                                    Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(_this))
                                ];
                                // Run first, to block _setRedirectUser() if any callbacks fail.
                                return [
                                    4,
                                    _this.beforeStateQueue.runMiddleware(null)
                                ];
                            case 1:
                                _state.sent();
                                if (!(_this.redirectPersistenceManager || _this._popupRedirectResolver)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this._setRedirectUser(null)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                // Prevent callbacks from being called again in _updateCurrentUser, as
                                // they were already called in the first line.
                                return [
                                    2,
                                    _this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setPersistence",
            value: function setPersistence(persistence) {
                if ((0, $ilNGG._isFirebaseServerApp)(this.app)) return Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(this));
                var _this = this;
                return this.queue(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.assertedPersistence.setPersistence($65b82078b3339b3f$export$158acd800e1ef08b(persistence))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }));
            }
        },
        {
            key: "_getRecaptchaConfig",
            value: function _getRecaptchaConfig() {
                if (this.tenantId == null) return this._agentRecaptchaConfig;
                else return this._tenantRecaptchaConfigs[this.tenantId];
            }
        },
        {
            key: "validatePassword",
            value: function validatePassword(password) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var passwordPolicy;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this._getPasswordPolicyInternal()) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._updatePasswordPolicy()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                // Password policy will be defined after fetching.
                                passwordPolicy = _this._getPasswordPolicyInternal();
                                // Check that the policy schema version is supported by the SDK.
                                // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
                                if (passwordPolicy.schemaVersion !== _this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return [
                                    2,
                                    Promise.reject(_this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}))
                                ];
                                return [
                                    2,
                                    passwordPolicy.validatePassword(password)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getPasswordPolicyInternal",
            value: function _getPasswordPolicyInternal() {
                if (this.tenantId === null) return this._projectPasswordPolicy;
                else return this._tenantPasswordPolicies[this.tenantId];
            }
        },
        {
            key: "_updatePasswordPolicy",
            value: function _updatePasswordPolicy() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var response, passwordPolicy;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_getPasswordPolicy(_this)
                                ];
                            case 1:
                                response = _state.sent();
                                passwordPolicy = new $65b82078b3339b3f$var$PasswordPolicyImpl(response);
                                if (_this.tenantId === null) _this._projectPasswordPolicy = passwordPolicy;
                                else _this._tenantPasswordPolicies[_this.tenantId] = passwordPolicy;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getPersistence",
            value: function _getPersistence() {
                return this.assertedPersistence.persistence.type;
            }
        },
        {
            key: "_updateErrorMap",
            value: function _updateErrorMap(errorMap) {
                this._errorFactory = new (0, $gQ5gw.ErrorFactory)("auth", "Firebase", errorMap());
            }
        },
        {
            key: "onAuthStateChanged",
            value: function onAuthStateChanged(nextOrObserver, error, completed) {
                return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
            }
        },
        {
            key: "beforeAuthStateChanged",
            value: function beforeAuthStateChanged(callback, onAbort) {
                return this.beforeStateQueue.pushCallback(callback, onAbort);
            }
        },
        {
            key: "onIdTokenChanged",
            value: function onIdTokenChanged(nextOrObserver, error, completed) {
                return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
            }
        },
        {
            key: "authStateReady",
            value: function authStateReady() {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (_this.currentUser) resolve();
                    else {
                        var unsubscribe = _this.onAuthStateChanged(function() {
                            unsubscribe();
                            resolve();
                        }, reject);
                    }
                });
            }
        },
        {
            key: "revokeAccessToken",
            value: /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ function revokeAccessToken(token) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var idToken, request;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.currentUser) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.currentUser.getIdToken()
                                ];
                            case 1:
                                idToken = _state.sent();
                                // Generalize this to accept other providers once supported.
                                request = {
                                    providerId: "apple.com",
                                    tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                                    token: token,
                                    idToken: idToken
                                };
                                if (_this.tenantId != null) request.tenantId = _this.tenantId;
                                return [
                                    4,
                                    $65b82078b3339b3f$var$revokeToken(_this, request)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var _a;
                return {
                    apiKey: this.config.apiKey,
                    authDomain: this.config.authDomain,
                    appName: this.name,
                    currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
                };
            }
        },
        {
            key: "_setRedirectUser",
            value: function _setRedirectUser(user, popupRedirectResolver) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var redirectManager;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getOrInitRedirectPersistenceManager(popupRedirectResolver)
                                ];
                            case 1:
                                redirectManager = _state.sent();
                                return [
                                    2,
                                    user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOrInitRedirectPersistenceManager",
            value: function getOrInitRedirectPersistenceManager(popupRedirectResolver) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var resolver;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.redirectPersistenceManager) return [
                                    3,
                                    3
                                ];
                                resolver = popupRedirectResolver && $65b82078b3339b3f$export$158acd800e1ef08b(popupRedirectResolver) || _this._popupRedirectResolver;
                                $65b82078b3339b3f$export$890c4ad488842ce7(resolver, _this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                                return [
                                    4,
                                    $65b82078b3339b3f$var$PersistenceUserManager.create(_this, [
                                        $65b82078b3339b3f$export$158acd800e1ef08b(resolver._redirectPersistence)
                                    ], "redirectUser" /* KeyName.REDIRECT_USER */ )
                                ];
                            case 1:
                                _this.redirectPersistenceManager = _state.sent();
                                return [
                                    4,
                                    _this.redirectPersistenceManager.getCurrentUser()
                                ];
                            case 2:
                                _this.redirectUser = _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    _this.redirectPersistenceManager
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_redirectUserForId",
            value: function _redirectUserForId(id) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _a, _b;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this._isInitialized) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.queue(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                                        return (0, $lF1I7.__generator)(this, function(_state) {
                                            return [
                                                2
                                            ];
                                        });
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                if (((_a = _this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return [
                                    2,
                                    _this._currentUser
                                ];
                                if (((_b = _this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return [
                                    2,
                                    _this.redirectUser
                                ];
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_persistUserIfCurrent",
            value: function _persistUserIfCurrent(user) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        if (user === _this.currentUser) return [
                            2,
                            _this.queue(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                                return (0, $lF1I7.__generator)(this, function(_state) {
                                    return [
                                        2,
                                        _this.directlySetCurrentUser(user)
                                    ];
                                });
                            }))
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            /** Notifies listeners only if the user is current */ key: "_notifyListenersIfCurrent",
            value: function _notifyListenersIfCurrent(user) {
                if (user === this.currentUser) this.notifyAuthListeners();
            }
        },
        {
            key: "_key",
            value: function _key() {
                return "".concat(this.config.authDomain, ":").concat(this.config.apiKey, ":").concat(this.name);
            }
        },
        {
            key: "_startProactiveRefresh",
            value: function _startProactiveRefresh() {
                this.isProactiveRefreshEnabled = true;
                if (this.currentUser) this._currentUser._startProactiveRefresh();
            }
        },
        {
            key: "_stopProactiveRefresh",
            value: function _stopProactiveRefresh() {
                this.isProactiveRefreshEnabled = false;
                if (this.currentUser) this._currentUser._stopProactiveRefresh();
            }
        },
        {
            key: "_currentUser",
            get: /** Returns the current user cast as the internal type */ function get() {
                return this.currentUser;
            }
        },
        {
            key: "notifyAuthListeners",
            value: function notifyAuthListeners() {
                var _a, _b;
                if (!this._isInitialized) return;
                this.idTokenSubscription.next(this.currentUser);
                var currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
                if (this.lastNotifiedUid !== currentUid) {
                    this.lastNotifiedUid = currentUid;
                    this.authStateSubscription.next(this.currentUser);
                }
            }
        },
        {
            key: "registerStateListener",
            value: function registerStateListener(subscription, nextOrObserver, error, completed) {
                var _this = this;
                if (this._deleted) return function() {};
                var cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
                var isUnsubscribed = false;
                var promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
                $65b82078b3339b3f$export$890c4ad488842ce7(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                // The callback needs to be called asynchronously per the spec.
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                promise.then(function() {
                    if (isUnsubscribed) return;
                    cb(_this.currentUser);
                });
                if (typeof nextOrObserver === "function") {
                    var unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
                    return function() {
                        isUnsubscribed = true;
                        unsubscribe();
                    };
                } else {
                    var unsubscribe1 = subscription.addObserver(nextOrObserver);
                    return function() {
                        isUnsubscribed = true;
                        unsubscribe1();
                    };
                }
            }
        },
        {
            key: "directlySetCurrentUser",
            value: /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ function directlySetCurrentUser(user) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.currentUser && _this.currentUser !== user) _this._currentUser._stopProactiveRefresh();
                                if (user && _this.isProactiveRefreshEnabled) user._startProactiveRefresh();
                                _this.currentUser = user;
                                if (!user) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.assertedPersistence.setCurrentUser(user)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.assertedPersistence.removeCurrentUser()
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "queue",
            value: function queue(action) {
                // In case something errors, the callback still should be called in order
                // to keep the promise chain alive
                this.operations = this.operations.then(action, action);
                return this.operations;
            }
        },
        {
            key: "assertedPersistence",
            get: function get() {
                $65b82078b3339b3f$export$890c4ad488842ce7(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                return this.persistenceManager;
            }
        },
        {
            key: "_logFramework",
            value: function _logFramework(framework) {
                if (!framework || this.frameworks.includes(framework)) return;
                this.frameworks.push(framework);
                // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
                // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
                this.frameworks.sort();
                this.clientVersion = $65b82078b3339b3f$export$9f4f30ee63539e24(this.config.clientPlatform, this._getFrameworks());
            }
        },
        {
            key: "_getFrameworks",
            value: function _getFrameworks() {
                return this.frameworks;
            }
        },
        {
            key: "_getAdditionalHeaders",
            value: function _getAdditionalHeaders() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _a, headers, heartbeatsHeader, appCheckToken;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Additional headers on every request
                                headers = (0, $c5rwh._)({}, "X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ , _this.clientVersion);
                                if (_this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = _this.app.options.appId;
                                return [
                                    4,
                                    (_a = _this.heartbeatServiceProvider.getImmediate({
                                        optional: true
                                    })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader()
                                ];
                            case 1:
                                heartbeatsHeader = _state.sent();
                                if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
                                return [
                                    4,
                                    _this._getAppCheckToken()
                                ];
                            case 2:
                                appCheckToken = _state.sent();
                                if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
                                return [
                                    2,
                                    headers
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getAppCheckToken",
            value: function _getAppCheckToken() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _a, appCheckTokenResult;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (_a = _this.appCheckServiceProvider.getImmediate({
                                        optional: true
                                    })) === null || _a === void 0 ? void 0 : _a.getToken()
                                ];
                            case 1:
                                appCheckTokenResult = _state.sent();
                                if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
                                // In the error case, a dummy token will be returned along with an error field describing
                                // the error. In general, we shouldn't care about the error condition and just use
                                // the token (actual or dummy) to send requests.
                                $65b82078b3339b3f$var$_logWarn("Error while retrieving App Check token: ".concat(appCheckTokenResult.error));
                                return [
                                    2,
                                    appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AuthImpl;
}();
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $65b82078b3339b3f$export$a05254e7c3aeba6e(auth) {
    return (0, $gQ5gw.getModularInstance)(auth);
}
/** Helper class to wrap subscriber logic */ var $65b82078b3339b3f$var$Subscription = /*#__PURE__*/ function() {
    "use strict";
    function Subscription(auth) {
        var _this = this;
        (0, $19mwo._)(this, Subscription);
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $gQ5gw.createSubscribe)(function(observer) {
            return _this.observer = observer;
        });
    }
    (0, $6rpfc._)(Subscription, [
        {
            key: "next",
            get: function get() {
                $65b82078b3339b3f$export$890c4ad488842ce7(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                return this.observer.next.bind(this.observer);
            }
        }
    ]);
    return Subscription;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$externalJSProvider = {
    loadJS: function() {
        return (0, $9OZ9j._)(function() {
            return (0, $lF1I7.__generator)(this, function(_state) {
                throw new Error("Unable to load external scripts");
            });
        })();
    },
    recaptchaV2Script: "",
    recaptchaEnterpriseScript: "",
    gapiScript: ""
};
function $65b82078b3339b3f$var$_setExternalJSProvider(p) {
    $65b82078b3339b3f$var$externalJSProvider = p;
}
function $65b82078b3339b3f$var$_loadJS(url) {
    return $65b82078b3339b3f$var$externalJSProvider.loadJS(url);
}
function $65b82078b3339b3f$var$_recaptchaV2ScriptUrl() {
    return $65b82078b3339b3f$var$externalJSProvider.recaptchaV2Script;
}
function $65b82078b3339b3f$var$_recaptchaEnterpriseScriptUrl() {
    return $65b82078b3339b3f$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $65b82078b3339b3f$var$_gapiScriptUrl() {
    return $65b82078b3339b3f$var$externalJSProvider.gapiScript;
}
function $65b82078b3339b3f$var$_generateCallbackName(prefix) {
    return "__".concat(prefix).concat(Math.floor(Math.random() * 1000000));
}
/* eslint-disable @typescript-eslint/no-require-imports */ var $65b82078b3339b3f$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
var $65b82078b3339b3f$var$FAKE_TOKEN = "NO_RECAPTCHA";
var $65b82078b3339b3f$var$RecaptchaEnterpriseVerifier = /*#__PURE__*/ function() {
    "use strict";
    function RecaptchaEnterpriseVerifier(authExtern) {
        (0, $19mwo._)(this, RecaptchaEnterpriseVerifier);
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $65b82078b3339b3f$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $65b82078b3339b3f$export$a05254e7c3aeba6e(authExtern);
    }
    (0, $6rpfc._)(RecaptchaEnterpriseVerifier, [
        {
            key: "verify",
            value: /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ function verify() {
                var action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "verify", forceRefresh = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    function retrieveSiteKey(auth) {
                        return _retrieveSiteKey.apply(this, arguments);
                    }
                    function _retrieveSiteKey() {
                        _retrieveSiteKey = (0, $9OZ9j._)(function(auth) {
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                if (!forceRefresh) {
                                    if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return [
                                        2,
                                        auth._agentRecaptchaConfig.siteKey
                                    ];
                                    if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return [
                                        2,
                                        auth._tenantRecaptchaConfigs[auth.tenantId].siteKey
                                    ];
                                }
                                return [
                                    2,
                                    new Promise(function() {
                                        var _ref = (0, $9OZ9j._)(function(resolve, reject) {
                                            return (0, $lF1I7.__generator)(this, function(_state) {
                                                $65b82078b3339b3f$var$getRecaptchaConfig(auth, {
                                                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                                                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                                                }).then(function(response) {
                                                    if (response.recaptchaKey === undefined) reject(new Error("recaptcha Enterprise site key undefined"));
                                                    else {
                                                        var config = new $65b82078b3339b3f$var$RecaptchaConfig(response);
                                                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                                                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                                                        return resolve(config.siteKey);
                                                    }
                                                }).catch(function(error) {
                                                    reject(error);
                                                });
                                                return [
                                                    2
                                                ];
                                            });
                                        });
                                        return function(resolve, reject) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            });
                        });
                        return _retrieveSiteKey.apply(this, arguments);
                    }
                    function retrieveRecaptchaToken(siteKey, resolve, reject) {
                        var grecaptcha = window.grecaptcha;
                        if ($65b82078b3339b3f$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(function() {
                            grecaptcha.enterprise.execute(siteKey, {
                                action: action
                            }).then(function(token) {
                                resolve(token);
                            }).catch(function() {
                                resolve($65b82078b3339b3f$var$FAKE_TOKEN);
                            });
                        });
                        else reject(Error("No reCAPTCHA enterprise script loaded."));
                    }
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                retrieveSiteKey(_this.auth).then(function(siteKey) {
                                    if (!forceRefresh && $65b82078b3339b3f$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                                    else {
                                        if (typeof window === "undefined") {
                                            reject(new Error("RecaptchaVerifier is only supported in browser"));
                                            return;
                                        }
                                        var url = $65b82078b3339b3f$var$_recaptchaEnterpriseScriptUrl();
                                        if (url.length !== 0) url += siteKey;
                                        $65b82078b3339b3f$var$_loadJS(url).then(function() {
                                            retrieveRecaptchaToken(siteKey, resolve, reject);
                                        }).catch(function(error) {
                                            reject(error);
                                        });
                                    }
                                }).catch(function(error) {
                                    reject(error);
                                });
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return RecaptchaEnterpriseVerifier;
}();
function $65b82078b3339b3f$var$injectRecaptchaFields(auth, request, action) {
    return $65b82078b3339b3f$var$_injectRecaptchaFields.apply(this, arguments);
}
function $65b82078b3339b3f$var$_injectRecaptchaFields() {
    $65b82078b3339b3f$var$_injectRecaptchaFields = (0, $9OZ9j._)(function(auth, request, action) {
        var captchaResp, verifier, captchaResponse, error, newRequest;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    captchaResp = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : false;
                    verifier = new $65b82078b3339b3f$var$RecaptchaEnterpriseVerifier(auth);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    return [
                        4,
                        verifier.verify(action)
                    ];
                case 2:
                    captchaResponse = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        4,
                        verifier.verify(action, true)
                    ];
                case 4:
                    captchaResponse = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    newRequest = Object.assign({}, request);
                    if (!captchaResp) Object.assign(newRequest, {
                        captchaResponse: captchaResponse
                    });
                    else Object.assign(newRequest, {
                        "captchaResp": captchaResponse
                    });
                    Object.assign(newRequest, {
                        "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    });
                    Object.assign(newRequest, {
                        "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                    });
                    return [
                        2,
                        newRequest
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_injectRecaptchaFields.apply(this, arguments);
}
function $65b82078b3339b3f$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod) {
    return $65b82078b3339b3f$var$_handleRecaptchaFlow.apply(this, arguments);
}
function $65b82078b3339b3f$var$_handleRecaptchaFlow() {
    $65b82078b3339b3f$var$_handleRecaptchaFlow = (0, $9OZ9j._)(function(authInstance, request, actionName, actionMethod) {
        var _a, requestWithRecaptcha;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ ))) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $65b82078b3339b3f$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ )
                    ];
                case 1:
                    requestWithRecaptcha = _state.sent();
                    return [
                        2,
                        actionMethod(authInstance, requestWithRecaptcha)
                    ];
                case 2:
                    return [
                        2,
                        actionMethod(authInstance, request).catch(function() {
                            var _ref = (0, $9OZ9j._)(function(error) {
                                var requestWithRecaptcha;
                                return (0, $lF1I7.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(error.code === "auth/missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ )) return [
                                                3,
                                                2
                                            ];
                                            console.log("".concat(actionName, " is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow."));
                                            return [
                                                4,
                                                $65b82078b3339b3f$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ )
                                            ];
                                        case 1:
                                            requestWithRecaptcha = _state.sent();
                                            return [
                                                2,
                                                actionMethod(authInstance, requestWithRecaptcha)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                Promise.reject(error)
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(error) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_handleRecaptchaFlow.apply(this, arguments);
}
function $65b82078b3339b3f$var$_initializeRecaptchaConfig(auth) {
    return $65b82078b3339b3f$var$__initializeRecaptchaConfig.apply(this, arguments);
}
function $65b82078b3339b3f$var$__initializeRecaptchaConfig() {
    $65b82078b3339b3f$var$__initializeRecaptchaConfig = (0, $9OZ9j._)(function(auth) {
        var authInternal, response, config, verifier;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $65b82078b3339b3f$export$a05254e7c3aeba6e(auth);
                    return [
                        4,
                        $65b82078b3339b3f$var$getRecaptchaConfig(authInternal, {
                            clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                            version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                        })
                    ];
                case 1:
                    response = _state.sent();
                    config = new $65b82078b3339b3f$var$RecaptchaConfig(response);
                    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
                    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
                    if (config.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
                        verifier = new $65b82078b3339b3f$var$RecaptchaEnterpriseVerifier(authInternal);
                        verifier.verify();
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__initializeRecaptchaConfig.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $65b82078b3339b3f$export$b4171a6734a65d42(app, deps) {
    var provider = (0, $ilNGG._getProvider)(app, "auth");
    if (provider.isInitialized()) {
        var auth = provider.getImmediate();
        var initialOptions = provider.getOptions();
        if ((0, $gQ5gw.deepEqual)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $65b82078b3339b3f$export$9fa96a7d116ea3ce(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    var auth1 = provider.initialize({
        options: deps
    });
    return auth1;
}
function $65b82078b3339b3f$var$_initializeAuthInstance(auth, deps) {
    var persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    var hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($65b82078b3339b3f$export$158acd800e1ef08b);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $65b82078b3339b3f$export$3466f893ebf79586(auth, url, options) {
    var authInternal = $65b82078b3339b3f$export$a05254e7c3aeba6e(auth);
    $65b82078b3339b3f$export$890c4ad488842ce7(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $65b82078b3339b3f$export$890c4ad488842ce7(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    var disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    var protocol = $65b82078b3339b3f$var$extractProtocol(url);
    var _extractHostAndPort = $65b82078b3339b3f$var$extractHostAndPort(url), host = _extractHostAndPort.host, port = _extractHostAndPort.port;
    var portStr = port === null ? "" : ":".concat(port);
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: "".concat(protocol, "//").concat(host).concat(portStr, "/")
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $65b82078b3339b3f$var$emitEmulatorWarning();
}
function $65b82078b3339b3f$var$extractProtocol(url) {
    var protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $65b82078b3339b3f$var$extractHostAndPort(url) {
    var protocol = $65b82078b3339b3f$var$extractProtocol(url);
    var authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    var hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    var bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        var host = bracketedIPv6[1];
        return {
            host: host,
            port: $65b82078b3339b3f$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        var _hostAndPort_split = (0, $2MTYX._)(hostAndPort.split(":"), 2), host1 = _hostAndPort_split[0], port = _hostAndPort_split[1];
        return {
            host: host1,
            port: $65b82078b3339b3f$var$parsePort(port)
        };
    }
}
function $65b82078b3339b3f$var$parsePort(portStr) {
    if (!portStr) return null;
    var port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $65b82078b3339b3f$var$emitEmulatorWarning() {
    function attachBanner() {
        var el = document.createElement("p");
        var sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ var $65b82078b3339b3f$export$61196ced6d74a310 = /*#__PURE__*/ function() {
    "use strict";
    function AuthCredential(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod) {
        (0, $19mwo._)(this, AuthCredential);
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    (0, $6rpfc._)(AuthCredential, [
        {
            /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ key: "toJSON",
            value: function toJSON() {
                return $65b82078b3339b3f$var$debugFail("not implemented");
            }
        },
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(_auth) {
                return $65b82078b3339b3f$var$debugFail("not implemented");
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(_auth, _idToken) {
                return $65b82078b3339b3f$var$debugFail("not implemented");
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(_auth) {
                return $65b82078b3339b3f$var$debugFail("not implemented");
            }
        }
    ]);
    return AuthCredential;
}();
function $65b82078b3339b3f$var$resetPassword(auth, request) {
    return $65b82078b3339b3f$var$_resetPassword.apply(this, arguments);
}
function $65b82078b3339b3f$var$_resetPassword() {
    $65b82078b3339b3f$var$_resetPassword = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $65b82078b3339b3f$var$_resetPassword.apply(this, arguments);
}
function $65b82078b3339b3f$var$updateEmailPassword(auth, request) {
    return $65b82078b3339b3f$var$_updateEmailPassword.apply(this, arguments);
}
function $65b82078b3339b3f$var$_updateEmailPassword() {
    $65b82078b3339b3f$var$_updateEmailPassword = (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $65b82078b3339b3f$var$_updateEmailPassword.apply(this, arguments);
}
function $65b82078b3339b3f$var$linkEmailPassword(auth, request) {
    return $65b82078b3339b3f$var$_linkEmailPassword.apply(this, arguments);
}
function $65b82078b3339b3f$var$_linkEmailPassword() {
    $65b82078b3339b3f$var$_linkEmailPassword = // Used for linking an email/password account to an existing idToken. Uses the same request/response
    // format as updateEmailPassword.
    (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request)
            ];
        });
    });
    return $65b82078b3339b3f$var$_linkEmailPassword.apply(this, arguments);
}
function $65b82078b3339b3f$var$applyActionCode$1(auth, request) {
    return $65b82078b3339b3f$var$_applyActionCode$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$_applyActionCode$1() {
    $65b82078b3339b3f$var$_applyActionCode$1 = (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $65b82078b3339b3f$var$_applyActionCode$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$signInWithPassword(auth, request) {
    return $65b82078b3339b3f$var$_signInWithPassword.apply(this, arguments);
}
function $65b82078b3339b3f$var$_signInWithPassword() {
    $65b82078b3339b3f$var$_signInWithPassword = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $65b82078b3339b3f$var$_signInWithPassword.apply(this, arguments);
}
function $65b82078b3339b3f$var$sendOobCode(auth, request) {
    return $65b82078b3339b3f$var$_sendOobCode.apply(this, arguments);
}
function $65b82078b3339b3f$var$_sendOobCode() {
    $65b82078b3339b3f$var$_sendOobCode = (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $65b82078b3339b3f$var$_sendOobCode.apply(this, arguments);
}
function $65b82078b3339b3f$var$sendEmailVerification$1(auth, request) {
    return $65b82078b3339b3f$var$_sendEmailVerification$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$_sendEmailVerification$1() {
    $65b82078b3339b3f$var$_sendEmailVerification$1 = (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$sendOobCode(auth, request)
            ];
        });
    });
    return $65b82078b3339b3f$var$_sendEmailVerification$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$sendPasswordResetEmail$1(auth, request) {
    return $65b82078b3339b3f$var$_sendPasswordResetEmail$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$_sendPasswordResetEmail$1() {
    $65b82078b3339b3f$var$_sendPasswordResetEmail$1 = (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$sendOobCode(auth, request)
            ];
        });
    });
    return $65b82078b3339b3f$var$_sendPasswordResetEmail$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$sendSignInLinkToEmail$1(auth, request) {
    return $65b82078b3339b3f$var$_sendSignInLinkToEmail$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$_sendSignInLinkToEmail$1() {
    $65b82078b3339b3f$var$_sendSignInLinkToEmail$1 = (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$sendOobCode(auth, request)
            ];
        });
    });
    return $65b82078b3339b3f$var$_sendSignInLinkToEmail$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$verifyAndChangeEmail(auth, request) {
    return $65b82078b3339b3f$var$_verifyAndChangeEmail.apply(this, arguments);
}
function $65b82078b3339b3f$var$_verifyAndChangeEmail() {
    $65b82078b3339b3f$var$_verifyAndChangeEmail = (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$sendOobCode(auth, request)
            ];
        });
    });
    return $65b82078b3339b3f$var$_verifyAndChangeEmail.apply(this, arguments);
}
function $65b82078b3339b3f$var$signInWithEmailLink$1(auth, request) {
    return $65b82078b3339b3f$var$_signInWithEmailLink$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$_signInWithEmailLink$1() {
    $65b82078b3339b3f$var$_signInWithEmailLink$1 = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $65b82078b3339b3f$var$_signInWithEmailLink$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$signInWithEmailLinkForLinking(auth, request) {
    return $65b82078b3339b3f$var$_signInWithEmailLinkForLinking.apply(this, arguments);
}
function $65b82078b3339b3f$var$_signInWithEmailLinkForLinking() {
    $65b82078b3339b3f$var$_signInWithEmailLinkForLinking = (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $65b82078b3339b3f$var$_signInWithEmailLinkForLinking.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ var $65b82078b3339b3f$export$3a1a48c8f6ef640e = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $iNfU4._)(EmailAuthCredential, AuthCredential);
    var _super = (0, $k1NN5._)(EmailAuthCredential);
    function EmailAuthCredential(/** @internal */ _email, /** @internal */ _password, signInMethod) {
        var /** @internal */ _tenantId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        (0, $19mwo._)(this, EmailAuthCredential);
        var _this;
        _this = _super.call(this, "password" /* ProviderId.PASSWORD */ , signInMethod);
        _this._email = _email;
        _this._password = _password;
        _this._tenantId = _tenantId;
        return _this;
    }
    (0, $6rpfc._)(EmailAuthCredential, [
        {
            /** {@inheritdoc AuthCredential.toJSON} */ key: "toJSON",
            value: function toJSON() {
                return {
                    email: this._email,
                    password: this._password,
                    signInMethod: this.signInMethod,
                    tenantId: this._tenantId
                };
            }
        },
        {
            key: "_getIdTokenResponse",
            value: /** @internal */ function _getIdTokenResponse(auth) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var request;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_this.signInMethod){
                            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                                request = {
                                    returnSecureToken: true,
                                    email: _this._email,
                                    password: _this._password,
                                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                                };
                                return [
                                    2,
                                    $65b82078b3339b3f$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $65b82078b3339b3f$var$signInWithPassword)
                                ];
                            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                                return [
                                    2,
                                    $65b82078b3339b3f$var$signInWithEmailLink$1(auth, {
                                        email: _this._email,
                                        oobCode: _this._password
                                    })
                                ];
                            default:
                                $65b82078b3339b3f$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_linkToIdToken",
            value: /** @internal */ function _linkToIdToken(auth, idToken) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var request;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_this.signInMethod){
                            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                                request = {
                                    idToken: idToken,
                                    returnSecureToken: true,
                                    email: _this._email,
                                    password: _this._password,
                                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                                };
                                return [
                                    2,
                                    $65b82078b3339b3f$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $65b82078b3339b3f$var$linkEmailPassword)
                                ];
                            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                                return [
                                    2,
                                    $65b82078b3339b3f$var$signInWithEmailLinkForLinking(auth, {
                                        idToken: idToken,
                                        email: _this._email,
                                        oobCode: _this._password
                                    })
                                ];
                            default:
                                $65b82078b3339b3f$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                return this._getIdTokenResponse(auth);
            }
        }
    ], [
        {
            key: "_fromEmailAndPassword",
            value: /** @internal */ function _fromEmailAndPassword(email, password) {
                return new EmailAuthCredential(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
            }
        },
        {
            key: "_fromEmailAndCode",
            value: /** @internal */ function _fromEmailAndCode(email, oobCode) {
                var tenantId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                return new EmailAuthCredential(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
            }
        },
        {
            key: "fromJSON",
            value: /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ function fromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
                    if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
                    else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
                }
                return null;
            }
        }
    ]);
    return EmailAuthCredential;
}($65b82078b3339b3f$export$61196ced6d74a310);
function $65b82078b3339b3f$var$signInWithIdp(auth, request) {
    return $65b82078b3339b3f$var$_signInWithIdp.apply(this, arguments);
}
function $65b82078b3339b3f$var$_signInWithIdp() {
    $65b82078b3339b3f$var$_signInWithIdp = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $65b82078b3339b3f$var$_signInWithIdp.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ var $65b82078b3339b3f$export$a07804094c3ecf2d = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $iNfU4._)(OAuthCredential, AuthCredential);
    var _super = (0, $k1NN5._)(OAuthCredential);
    function OAuthCredential() {
        (0, $19mwo._)(this, OAuthCredential);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.pendingToken = null;
        return _this;
    }
    (0, $6rpfc._)(OAuthCredential, [
        {
            /** {@inheritdoc AuthCredential.toJSON}  */ key: "toJSON",
            value: function toJSON() {
                return {
                    idToken: this.idToken,
                    accessToken: this.accessToken,
                    secret: this.secret,
                    nonce: this.nonce,
                    pendingToken: this.pendingToken,
                    providerId: this.providerId,
                    signInMethod: this.signInMethod
                };
            }
        },
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                var request = this.buildRequest();
                return $65b82078b3339b3f$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                var request = this.buildRequest();
                request.idToken = idToken;
                return $65b82078b3339b3f$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                var request = this.buildRequest();
                request.autoCreate = false;
                return $65b82078b3339b3f$var$signInWithIdp(auth, request);
            }
        },
        {
            key: "buildRequest",
            value: function buildRequest() {
                var request = {
                    requestUri: $65b82078b3339b3f$var$IDP_REQUEST_URI$1,
                    returnSecureToken: true
                };
                if (this.pendingToken) request.pendingToken = this.pendingToken;
                else {
                    var postBody = {};
                    if (this.idToken) postBody["id_token"] = this.idToken;
                    if (this.accessToken) postBody["access_token"] = this.accessToken;
                    if (this.secret) postBody["oauth_token_secret"] = this.secret;
                    postBody["providerId"] = this.providerId;
                    if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
                    request.postBody = (0, $gQ5gw.querystring)(postBody);
                }
                return request;
            }
        }
    ], [
        {
            key: "_fromParams",
            value: /** @internal */ function _fromParams(params) {
                var cred = new OAuthCredential(params.providerId, params.signInMethod);
                if (params.idToken || params.accessToken) {
                    // OAuth 2 and either ID token or access token.
                    if (params.idToken) cred.idToken = params.idToken;
                    if (params.accessToken) cred.accessToken = params.accessToken;
                    // Add nonce if available and no pendingToken is present.
                    if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
                    if (params.pendingToken) cred.pendingToken = params.pendingToken;
                } else if (params.oauthToken && params.oauthTokenSecret) {
                    // OAuth 1 and OAuth token with token secret
                    cred.accessToken = params.oauthToken;
                    cred.secret = params.oauthTokenSecret;
                } else $65b82078b3339b3f$export$9fa96a7d116ea3ce("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return cred;
            }
        },
        {
            key: "fromJSON",
            value: /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ function fromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                var providerId = obj.providerId, signInMethod = obj.signInMethod, rest = (0, $lF1I7.__rest)(obj, [
                    "providerId",
                    "signInMethod"
                ]);
                if (!providerId || !signInMethod) return null;
                var cred = new OAuthCredential(providerId, signInMethod);
                cred.idToken = rest.idToken || undefined;
                cred.accessToken = rest.accessToken || undefined;
                cred.secret = rest.secret;
                cred.nonce = rest.nonce;
                cred.pendingToken = rest.pendingToken || null;
                return cred;
            }
        }
    ]);
    return OAuthCredential;
}($65b82078b3339b3f$export$61196ced6d74a310);
function $65b82078b3339b3f$var$sendPhoneVerificationCode(auth, request) {
    return $65b82078b3339b3f$var$_sendPhoneVerificationCode.apply(this, arguments);
}
function $65b82078b3339b3f$var$_sendPhoneVerificationCode() {
    $65b82078b3339b3f$var$_sendPhoneVerificationCode = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $65b82078b3339b3f$var$_sendPhoneVerificationCode.apply(this, arguments);
}
function $65b82078b3339b3f$var$signInWithPhoneNumber$1(auth, request) {
    return $65b82078b3339b3f$var$_signInWithPhoneNumber$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$_signInWithPhoneNumber$1() {
    $65b82078b3339b3f$var$_signInWithPhoneNumber$1 = (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $65b82078b3339b3f$var$_signInWithPhoneNumber$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$linkWithPhoneNumber$1(auth, request) {
    return $65b82078b3339b3f$var$_linkWithPhoneNumber$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$_linkWithPhoneNumber$1() {
    $65b82078b3339b3f$var$_linkWithPhoneNumber$1 = (0, $9OZ9j._)(function(auth, request) {
        var response;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65b82078b3339b3f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
                    ];
                case 1:
                    response = _state.sent();
                    if (response.temporaryProof) throw $65b82078b3339b3f$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_linkWithPhoneNumber$1.apply(this, arguments);
}
var $65b82078b3339b3f$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = (0, $c5rwh._)({}, "USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ , "user-not-found" /* AuthErrorCode.USER_DELETED */ );
function $65b82078b3339b3f$var$verifyPhoneNumberForExisting(auth, request) {
    return $65b82078b3339b3f$var$_verifyPhoneNumberForExisting.apply(this, arguments);
}
function $65b82078b3339b3f$var$_verifyPhoneNumberForExisting() {
    $65b82078b3339b3f$var$_verifyPhoneNumberForExisting = (0, $9OZ9j._)(function(auth, request) {
        var apiRequest;
        return (0, $lF1I7.__generator)(this, function(_state) {
            apiRequest = Object.assign(Object.assign({}, request), {
                operation: "REAUTH"
            });
            return [
                2,
                $65b82078b3339b3f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, apiRequest), $65b82078b3339b3f$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_)
            ];
        });
    });
    return $65b82078b3339b3f$var$_verifyPhoneNumberForExisting.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ var $65b82078b3339b3f$export$3722cfe417b6ed86 = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $iNfU4._)(PhoneAuthCredential, AuthCredential);
    var _super = (0, $k1NN5._)(PhoneAuthCredential);
    function PhoneAuthCredential(params) {
        (0, $19mwo._)(this, PhoneAuthCredential);
        var _this;
        _this = _super.call(this, "phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        _this.params = params;
        return _this;
    }
    (0, $6rpfc._)(PhoneAuthCredential, [
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                return $65b82078b3339b3f$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                return $65b82078b3339b3f$var$linkWithPhoneNumber$1(auth, Object.assign({
                    idToken: idToken
                }, this._makeVerificationRequest()));
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                return $65b82078b3339b3f$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
            }
        },
        {
            /** @internal */ key: "_makeVerificationRequest",
            value: function _makeVerificationRequest() {
                var _this_params = this.params, temporaryProof = _this_params.temporaryProof, phoneNumber = _this_params.phoneNumber, verificationId = _this_params.verificationId, verificationCode = _this_params.verificationCode;
                if (temporaryProof && phoneNumber) return {
                    temporaryProof: temporaryProof,
                    phoneNumber: phoneNumber
                };
                return {
                    sessionInfo: verificationId,
                    code: verificationCode
                };
            }
        },
        {
            /** {@inheritdoc AuthCredential.toJSON} */ key: "toJSON",
            value: function toJSON() {
                var obj = {
                    providerId: this.providerId
                };
                if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
                if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
                if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
                if (this.params.verificationId) obj.verificationId = this.params.verificationId;
                return obj;
            }
        }
    ], [
        {
            key: "_fromVerification",
            value: /** @internal */ function _fromVerification(verificationId, verificationCode) {
                return new PhoneAuthCredential({
                    verificationId: verificationId,
                    verificationCode: verificationCode
                });
            }
        },
        {
            key: "_fromTokenResponse",
            value: /** @internal */ function _fromTokenResponse(phoneNumber, temporaryProof) {
                return new PhoneAuthCredential({
                    phoneNumber: phoneNumber,
                    temporaryProof: temporaryProof
                });
            }
        },
        {
            key: "fromJSON",
            value: /** Generates a phone credential based on a plain object or a JSON string. */ function fromJSON(json) {
                if (typeof json === "string") json = JSON.parse(json);
                var verificationId = json.verificationId, verificationCode = json.verificationCode, phoneNumber = json.phoneNumber, temporaryProof = json.temporaryProof;
                if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
                return new PhoneAuthCredential({
                    verificationId: verificationId,
                    verificationCode: verificationCode,
                    phoneNumber: phoneNumber,
                    temporaryProof: temporaryProof
                });
            }
        }
    ]);
    return PhoneAuthCredential;
}($65b82078b3339b3f$export$61196ced6d74a310);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $65b82078b3339b3f$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $65b82078b3339b3f$var$parseDeepLink(url) {
    var link = (0, $gQ5gw.querystringDecode)((0, $gQ5gw.extractQuerystring)(url))["link"];
    // Double link case (automatic redirect).
    var doubleDeepLink = link ? (0, $gQ5gw.querystringDecode)((0, $gQ5gw.extractQuerystring)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    var iOSDeepLink = (0, $gQ5gw.querystringDecode)((0, $gQ5gw.extractQuerystring)(url))["deep_link_id"];
    var iOSDoubleDeepLink = iOSDeepLink ? (0, $gQ5gw.querystringDecode)((0, $gQ5gw.extractQuerystring)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ var $65b82078b3339b3f$export$f38c853ae54ed474 = /*#__PURE__*/ function() {
    "use strict";
    function ActionCodeURL(actionLink) {
        (0, $19mwo._)(this, ActionCodeURL);
        var _a, _b, _c, _d, _e, _f;
        var searchParams = (0, $gQ5gw.querystringDecode)((0, $gQ5gw.extractQuerystring)(actionLink));
        var apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        var code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        var operation = $65b82078b3339b3f$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $65b82078b3339b3f$export$890c4ad488842ce7(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    (0, $6rpfc._)(ActionCodeURL, null, [
        {
            key: "parseLink",
            value: /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ function parseLink(link) {
                var actionLink = $65b82078b3339b3f$var$parseDeepLink(link);
                try {
                    return new ActionCodeURL(actionLink);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return ActionCodeURL;
}();
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $65b82078b3339b3f$export$3b513254972cfc9c(link) {
    return $65b82078b3339b3f$export$f38c853ae54ed474.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ var $65b82078b3339b3f$export$e7c866399fa523f5 = /*#__PURE__*/ function() {
    "use strict";
    function EmailAuthProvider() {
        (0, $19mwo._)(this, EmailAuthProvider);
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = EmailAuthProvider.PROVIDER_ID;
    }
    (0, $6rpfc._)(EmailAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ function credential(email, password) {
                return $65b82078b3339b3f$export$3a1a48c8f6ef640e._fromEmailAndPassword(email, password);
            }
        },
        {
            key: "credentialWithLink",
            value: /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ function credentialWithLink(email, emailLink) {
                var actionCodeUrl = $65b82078b3339b3f$export$f38c853ae54ed474.parseLink(emailLink);
                $65b82078b3339b3f$export$890c4ad488842ce7(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return $65b82078b3339b3f$export$3a1a48c8f6ef640e._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
            }
        }
    ]);
    return EmailAuthProvider;
}();
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $65b82078b3339b3f$export$e7c866399fa523f5.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $65b82078b3339b3f$export$e7c866399fa523f5.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $65b82078b3339b3f$export$e7c866399fa523f5.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ var $65b82078b3339b3f$var$FederatedAuthProvider = /*#__PURE__*/ function() {
    "use strict";
    function FederatedAuthProvider(providerId) {
        (0, $19mwo._)(this, FederatedAuthProvider);
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    (0, $6rpfc._)(FederatedAuthProvider, [
        {
            /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ key: "setDefaultLanguage",
            value: function setDefaultLanguage(languageCode) {
                this.defaultLanguageCode = languageCode;
            }
        },
        {
            /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ key: "setCustomParameters",
            value: function setCustomParameters(customOAuthParameters) {
                this.customParameters = customOAuthParameters;
                return this;
            }
        },
        {
            /**
     * Retrieve the current list of {@link CustomParameters}.
     */ key: "getCustomParameters",
            value: function getCustomParameters() {
                return this.customParameters;
            }
        }
    ]);
    return FederatedAuthProvider;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ var $65b82078b3339b3f$var$BaseOAuthProvider = /*#__PURE__*/ function(FederatedAuthProvider) {
    "use strict";
    (0, $iNfU4._)(BaseOAuthProvider, FederatedAuthProvider);
    var _super = (0, $k1NN5._)(BaseOAuthProvider);
    function BaseOAuthProvider() {
        (0, $19mwo._)(this, BaseOAuthProvider);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        /** @internal */ _this.scopes = [];
        return _this;
    }
    (0, $6rpfc._)(BaseOAuthProvider, [
        {
            /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ key: "addScope",
            value: function addScope(scope) {
                // If not already added, add scope to list.
                if (!this.scopes.includes(scope)) this.scopes.push(scope);
                return this;
            }
        },
        {
            /**
     * Retrieve the current list of OAuth scopes.
     */ key: "getScopes",
            value: function getScopes() {
                return (0, $3jzhD._)(this.scopes);
            }
        }
    ]);
    return BaseOAuthProvider;
}($65b82078b3339b3f$var$FederatedAuthProvider);
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ var $65b82078b3339b3f$export$dc98b0b04f4c7758 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $iNfU4._)(OAuthProvider, BaseOAuthProvider);
    var _super = (0, $k1NN5._)(OAuthProvider);
    function OAuthProvider() {
        (0, $19mwo._)(this, OAuthProvider);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(OAuthProvider, [
        {
            /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ key: "credential",
            value: function credential(params) {
                return this._credential(Object.assign(Object.assign({}, params), {
                    nonce: params.rawNonce
                }));
            }
        },
        {
            /** An internal credential method that accepts more permissive options */ key: "_credential",
            value: function _credential(params) {
                $65b82078b3339b3f$export$890c4ad488842ce7(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                // For OAuthCredential, sign in method is same as providerId.
                return $65b82078b3339b3f$export$a07804094c3ecf2d._fromParams(Object.assign(Object.assign({}, params), {
                    providerId: this.providerId,
                    signInMethod: this.providerId
                }));
            }
        }
    ], [
        {
            key: "credentialFromJSON",
            value: /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ function credentialFromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                $65b82078b3339b3f$export$890c4ad488842ce7("providerId" in obj && "signInMethod" in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return $65b82078b3339b3f$export$a07804094c3ecf2d._fromParams(obj);
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return OAuthProvider.oauthCredentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return OAuthProvider.oauthCredentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "oauthCredentialFromTaggedObject",
            value: function oauthCredentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var oauthIdToken = tokenResponse.oauthIdToken, oauthAccessToken = tokenResponse.oauthAccessToken, oauthTokenSecret = tokenResponse.oauthTokenSecret, pendingToken = tokenResponse.pendingToken, nonce = tokenResponse.nonce, providerId = tokenResponse.providerId;
                if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
                if (!providerId) return null;
                try {
                    return new OAuthProvider(providerId)._credential({
                        idToken: oauthIdToken,
                        accessToken: oauthAccessToken,
                        nonce: nonce,
                        pendingToken: pendingToken
                    });
                } catch (e) {
                    return null;
                }
            }
        }
    ]);
    return OAuthProvider;
}($65b82078b3339b3f$var$BaseOAuthProvider);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ var $65b82078b3339b3f$export$71cec2538cb2c617 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $iNfU4._)(FacebookAuthProvider, BaseOAuthProvider);
    var _super = (0, $k1NN5._)(FacebookAuthProvider);
    function FacebookAuthProvider() {
        (0, $19mwo._)(this, FacebookAuthProvider);
        return _super.call(this, "facebook.com" /* ProviderId.FACEBOOK */ );
    }
    (0, $6rpfc._)(FacebookAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ function credential(accessToken) {
                return $65b82078b3339b3f$export$a07804094c3ecf2d._fromParams({
                    providerId: FacebookAuthProvider.PROVIDER_ID,
                    signInMethod: FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD,
                    accessToken: accessToken
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return FacebookAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return FacebookAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
                if (!tokenResponse.oauthAccessToken) return null;
                try {
                    return FacebookAuthProvider.credential(tokenResponse.oauthAccessToken);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return FacebookAuthProvider;
}($65b82078b3339b3f$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.FACEBOOK. */ $65b82078b3339b3f$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $65b82078b3339b3f$export$71cec2538cb2c617.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ var $65b82078b3339b3f$export$78acf4525d8a74c4 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $iNfU4._)(GoogleAuthProvider, BaseOAuthProvider);
    var _super = (0, $k1NN5._)(GoogleAuthProvider);
    function GoogleAuthProvider() {
        (0, $19mwo._)(this, GoogleAuthProvider);
        var _this;
        _this = _super.call(this, "google.com" /* ProviderId.GOOGLE */ );
        _this.addScope("profile");
        return _this;
    }
    (0, $6rpfc._)(GoogleAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ function credential(idToken, accessToken) {
                return $65b82078b3339b3f$export$a07804094c3ecf2d._fromParams({
                    providerId: GoogleAuthProvider.PROVIDER_ID,
                    signInMethod: GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD,
                    idToken: idToken,
                    accessToken: accessToken
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return GoogleAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return GoogleAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var oauthIdToken = tokenResponse.oauthIdToken, oauthAccessToken = tokenResponse.oauthAccessToken;
                if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
                return null;
                try {
                    return GoogleAuthProvider.credential(oauthIdToken, oauthAccessToken);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return GoogleAuthProvider;
}($65b82078b3339b3f$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.GOOGLE. */ $65b82078b3339b3f$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $65b82078b3339b3f$export$78acf4525d8a74c4.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ var $65b82078b3339b3f$export$8743009a87fcb00f = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $iNfU4._)(GithubAuthProvider, BaseOAuthProvider);
    var _super = (0, $k1NN5._)(GithubAuthProvider);
    function GithubAuthProvider() {
        (0, $19mwo._)(this, GithubAuthProvider);
        return _super.call(this, "github.com" /* ProviderId.GITHUB */ );
    }
    (0, $6rpfc._)(GithubAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */ function credential(accessToken) {
                return $65b82078b3339b3f$export$a07804094c3ecf2d._fromParams({
                    providerId: GithubAuthProvider.PROVIDER_ID,
                    signInMethod: GithubAuthProvider.GITHUB_SIGN_IN_METHOD,
                    accessToken: accessToken
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return GithubAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return GithubAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
                if (!tokenResponse.oauthAccessToken) return null;
                try {
                    return GithubAuthProvider.credential(tokenResponse.oauthAccessToken);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return GithubAuthProvider;
}($65b82078b3339b3f$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.GITHUB. */ $65b82078b3339b3f$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $65b82078b3339b3f$export$8743009a87fcb00f.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ var $65b82078b3339b3f$export$f96d196f7728bb5 = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $iNfU4._)(SAMLAuthCredential, AuthCredential);
    var _super = (0, $k1NN5._)(SAMLAuthCredential);
    function SAMLAuthCredential(providerId, pendingToken) {
        (0, $19mwo._)(this, SAMLAuthCredential);
        var _this;
        _this = _super.call(this, providerId, providerId);
        _this.pendingToken = pendingToken;
        return _this;
    }
    (0, $6rpfc._)(SAMLAuthCredential, [
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                var request = this.buildRequest();
                return $65b82078b3339b3f$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                var request = this.buildRequest();
                request.idToken = idToken;
                return $65b82078b3339b3f$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                var request = this.buildRequest();
                request.autoCreate = false;
                return $65b82078b3339b3f$var$signInWithIdp(auth, request);
            }
        },
        {
            /** {@inheritdoc AuthCredential.toJSON}  */ key: "toJSON",
            value: function toJSON() {
                return {
                    signInMethod: this.signInMethod,
                    providerId: this.providerId,
                    pendingToken: this.pendingToken
                };
            }
        },
        {
            key: "buildRequest",
            value: function buildRequest() {
                return {
                    requestUri: $65b82078b3339b3f$var$IDP_REQUEST_URI,
                    returnSecureToken: true,
                    pendingToken: this.pendingToken
                };
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ function fromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                var providerId = obj.providerId, signInMethod = obj.signInMethod, pendingToken = obj.pendingToken;
                if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
                return new SAMLAuthCredential(providerId, pendingToken);
            }
        },
        {
            key: "_create",
            value: /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ function _create(providerId, pendingToken) {
                return new SAMLAuthCredential(providerId, pendingToken);
            }
        }
    ]);
    return SAMLAuthCredential;
}($65b82078b3339b3f$export$61196ced6d74a310);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ var $65b82078b3339b3f$export$71511d61b312f219 = /*#__PURE__*/ function(FederatedAuthProvider) {
    "use strict";
    (0, $iNfU4._)(SAMLAuthProvider, FederatedAuthProvider);
    var _super = (0, $k1NN5._)(SAMLAuthProvider);
    function SAMLAuthProvider(providerId) {
        (0, $19mwo._)(this, SAMLAuthProvider);
        $65b82078b3339b3f$export$890c4ad488842ce7(providerId.startsWith($65b82078b3339b3f$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return _super.call(this, providerId);
    }
    (0, $6rpfc._)(SAMLAuthProvider, null, [
        {
            key: "credentialFromResult",
            value: /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return SAMLAuthProvider.samlCredentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return SAMLAuthProvider.samlCredentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromJSON",
            value: /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ function credentialFromJSON(json) {
                var credential = $65b82078b3339b3f$export$f96d196f7728bb5.fromJSON(json);
                $65b82078b3339b3f$export$890c4ad488842ce7(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return credential;
            }
        },
        {
            key: "samlCredentialFromTaggedObject",
            value: function samlCredentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var pendingToken = tokenResponse.pendingToken, providerId = tokenResponse.providerId;
                if (!pendingToken || !providerId) return null;
                try {
                    return $65b82078b3339b3f$export$f96d196f7728bb5._create(providerId, pendingToken);
                } catch (e) {
                    return null;
                }
            }
        }
    ]);
    return SAMLAuthProvider;
}($65b82078b3339b3f$var$FederatedAuthProvider);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ var $65b82078b3339b3f$export$3d8c2f653ac9d0b9 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $iNfU4._)(TwitterAuthProvider, BaseOAuthProvider);
    var _super = (0, $k1NN5._)(TwitterAuthProvider);
    function TwitterAuthProvider() {
        (0, $19mwo._)(this, TwitterAuthProvider);
        return _super.call(this, "twitter.com" /* ProviderId.TWITTER */ );
    }
    (0, $6rpfc._)(TwitterAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ function credential(token, secret) {
                return $65b82078b3339b3f$export$a07804094c3ecf2d._fromParams({
                    providerId: TwitterAuthProvider.PROVIDER_ID,
                    signInMethod: TwitterAuthProvider.TWITTER_SIGN_IN_METHOD,
                    oauthToken: token,
                    oauthTokenSecret: secret
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return TwitterAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return TwitterAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var oauthAccessToken = tokenResponse.oauthAccessToken, oauthTokenSecret = tokenResponse.oauthTokenSecret;
                if (!oauthAccessToken || !oauthTokenSecret) return null;
                try {
                    return TwitterAuthProvider.credential(oauthAccessToken, oauthTokenSecret);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return TwitterAuthProvider;
}($65b82078b3339b3f$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.TWITTER. */ $65b82078b3339b3f$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $65b82078b3339b3f$export$3d8c2f653ac9d0b9.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
function $65b82078b3339b3f$var$signUp(auth, request) {
    return $65b82078b3339b3f$var$_signUp.apply(this, arguments);
}
function $65b82078b3339b3f$var$_signUp() {
    $65b82078b3339b3f$var$_signUp = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $65b82078b3339b3f$var$_signUp.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$UserCredentialImpl = /*#__PURE__*/ function() {
    "use strict";
    function UserCredentialImpl(params) {
        (0, $19mwo._)(this, UserCredentialImpl);
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    (0, $6rpfc._)(UserCredentialImpl, null, [
        {
            key: "_fromIdTokenResponse",
            value: function _fromIdTokenResponse(auth, operationType, idTokenResponse) {
                var isAnonymous = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                return (0, $9OZ9j._)(function() {
                    var user, providerId, userCred;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65b82078b3339b3f$export$23ebac1979863676._fromIdTokenResponse(auth, idTokenResponse, isAnonymous)
                                ];
                            case 1:
                                user = _state.sent();
                                providerId = $65b82078b3339b3f$var$providerIdForResponse(idTokenResponse);
                                userCred = new UserCredentialImpl({
                                    user: user,
                                    providerId: providerId,
                                    _tokenResponse: idTokenResponse,
                                    operationType: operationType
                                });
                                return [
                                    2,
                                    userCred
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_forOperation",
            value: function _forOperation(user, operationType, response) {
                return (0, $9OZ9j._)(function() {
                    var providerId;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    user._updateTokensIfNecessary(response, /* reload */ true)
                                ];
                            case 1:
                                _state.sent();
                                providerId = $65b82078b3339b3f$var$providerIdForResponse(response);
                                return [
                                    2,
                                    new UserCredentialImpl({
                                        user: user,
                                        providerId: providerId,
                                        _tokenResponse: response,
                                        operationType: operationType
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return UserCredentialImpl;
}();
function $65b82078b3339b3f$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
function $65b82078b3339b3f$export$34aec0b863436764(auth) {
    return $65b82078b3339b3f$var$_signInAnonymously.apply(this, arguments);
}
function $65b82078b3339b3f$var$_signInAnonymously() {
    $65b82078b3339b3f$var$_signInAnonymously = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ (0, $9OZ9j._)(function(auth) {
        var _a, authInternal, response, userCredential;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ((0, $ilNGG._isFirebaseServerApp)(auth.app)) return [
                        2,
                        Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(auth))
                    ];
                    authInternal = $65b82078b3339b3f$export$a05254e7c3aeba6e(auth);
                    return [
                        4,
                        authInternal._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
                    return [
                        2,
                        new $65b82078b3339b3f$var$UserCredentialImpl({
                            user: authInternal.currentUser,
                            providerId: null,
                            operationType: "signIn" /* OperationType.SIGN_IN */ 
                        })
                    ];
                    return [
                        4,
                        $65b82078b3339b3f$var$signUp(authInternal, {
                            returnSecureToken: true
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        $65b82078b3339b3f$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true)
                    ];
                case 3:
                    userCredential = _state.sent();
                    return [
                        4,
                        authInternal._updateCurrentUser(userCredential.user)
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        userCredential
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_signInAnonymously.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$MultiFactorError = /*#__PURE__*/ function(FirebaseError) {
    "use strict";
    (0, $iNfU4._)(MultiFactorError, FirebaseError);
    var _super = (0, $k1NN5._)(MultiFactorError);
    function MultiFactorError(auth, error, operationType, user) {
        (0, $19mwo._)(this, MultiFactorError);
        var _this;
        var _a;
        _this = _super.call(this, error.code, error.message);
        _this.operationType = operationType;
        _this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf((0, $15Pju._)(_this), MultiFactorError.prototype);
        _this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
        return _this;
    }
    (0, $6rpfc._)(MultiFactorError, null, [
        {
            key: "_fromErrorAndOperation",
            value: function _fromErrorAndOperation(auth, error, operationType, user) {
                return new MultiFactorError(auth, error, operationType, user);
            }
        }
    ]);
    return MultiFactorError;
}((0, $gQ5gw.FirebaseError));
function $65b82078b3339b3f$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    var idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch(function(error) {
        if (error.code === "auth/multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ) throw $65b82078b3339b3f$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $65b82078b3339b3f$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(function(param) {
        var providerId = param.providerId;
        return providerId;
    }).filter(function(pid) {
        return !!pid;
    }));
}
function $65b82078b3339b3f$export$2f6ca3d3b1f80bf5(user, providerId) {
    return $65b82078b3339b3f$var$_unlink.apply(this, arguments);
}
function $65b82078b3339b3f$var$_unlink() {
    $65b82078b3339b3f$var$_unlink = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ (0, $9OZ9j._)(function(user, providerId) {
        var userInternal, providerUserInfo, _tmp, _tmp1, providersLeft;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $gQ5gw.getModularInstance)(user);
                    return [
                        4,
                        $65b82078b3339b3f$var$_assertLinkedStatus(true, userInternal, providerId)
                    ];
                case 1:
                    _state.sent();
                    _tmp = [
                        userInternal.auth
                    ];
                    _tmp1 = {};
                    return [
                        4,
                        userInternal.getIdToken()
                    ];
                case 2:
                    return [
                        4,
                        $65b82078b3339b3f$var$deleteLinkedAccounts.apply(void 0, _tmp.concat([
                            (_tmp1.idToken = _state.sent(), _tmp1.deleteProvider = [
                                providerId
                            ], _tmp1)
                        ]))
                    ];
                case 3:
                    providerUserInfo = _state.sent().providerUserInfo;
                    providersLeft = $65b82078b3339b3f$var$providerDataAsNames(providerUserInfo || []);
                    userInternal.providerData = userInternal.providerData.filter(function(pd) {
                        return providersLeft.has(pd.providerId);
                    });
                    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
                    return [
                        4,
                        userInternal.auth._persistUserIfCurrent(userInternal)
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        userInternal
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_unlink.apply(this, arguments);
}
function $65b82078b3339b3f$var$_link$1(user, credential) {
    return $65b82078b3339b3f$var$__link$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$__link$1() {
    $65b82078b3339b3f$var$__link$1 = (0, $9OZ9j._)(function(user, credential) {
        var bypassAuthState, response, _tmp, _, _tmp1;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    _tmp = [
                        user
                    ];
                    _ = credential._linkToIdToken;
                    _tmp1 = [
                        user.auth
                    ];
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    return [
                        4,
                        $65b82078b3339b3f$var$_logoutIfInvalidated.apply(void 0, _tmp.concat([
                            _.apply(credential, _tmp1.concat([
                                _state.sent()
                            ])),
                            bypassAuthState
                        ]))
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        $65b82078b3339b3f$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response)
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__link$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$_assertLinkedStatus(expected, user, provider) {
    return $65b82078b3339b3f$var$__assertLinkedStatus.apply(this, arguments);
}
function $65b82078b3339b3f$var$__assertLinkedStatus() {
    $65b82078b3339b3f$var$__assertLinkedStatus = (0, $9OZ9j._)(function(expected, user, provider) {
        var providerIds, code;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65b82078b3339b3f$var$_reloadWithoutSaving(user)
                    ];
                case 1:
                    _state.sent();
                    providerIds = $65b82078b3339b3f$var$providerDataAsNames(user.providerData);
                    code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
                    $65b82078b3339b3f$export$890c4ad488842ce7(providerIds.has(provider) === expected, user.auth, code);
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__assertLinkedStatus.apply(this, arguments);
}
function $65b82078b3339b3f$var$_reauthenticate(user, credential) {
    return $65b82078b3339b3f$var$__reauthenticate.apply(this, arguments);
}
function $65b82078b3339b3f$var$__reauthenticate() {
    $65b82078b3339b3f$var$__reauthenticate = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(user, credential) {
        var bypassAuthState, auth, operationType, response, parsed, localId, e;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    auth = user.auth;
                    if ((0, $ilNGG._isFirebaseServerApp)(auth.app)) return [
                        2,
                        Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(auth))
                    ];
                    operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $65b82078b3339b3f$var$_logoutIfInvalidated(user, $65b82078b3339b3f$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState)
                    ];
                case 2:
                    response = _state.sent();
                    $65b82078b3339b3f$export$890c4ad488842ce7(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    parsed = $65b82078b3339b3f$var$_parseToken(response.idToken);
                    $65b82078b3339b3f$export$890c4ad488842ce7(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    localId = parsed.sub;
                    $65b82078b3339b3f$export$890c4ad488842ce7(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
                    return [
                        2,
                        $65b82078b3339b3f$var$UserCredentialImpl._forOperation(user, operationType, response)
                    ];
                case 3:
                    e = _state.sent();
                    // Convert user deleted error into user mismatch
                    if ((e === null || e === void 0 ? void 0 : e.code) === "auth/user-not-found" /* AuthErrorCode.USER_DELETED */ ) $65b82078b3339b3f$export$9fa96a7d116ea3ce(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
                    throw e;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__reauthenticate.apply(this, arguments);
}
function $65b82078b3339b3f$var$_signInWithCredential(auth, credential) {
    return $65b82078b3339b3f$var$__signInWithCredential.apply(this, arguments);
}
function $65b82078b3339b3f$var$__signInWithCredential() {
    $65b82078b3339b3f$var$__signInWithCredential = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(auth, credential) {
        var bypassAuthState, operationType, response, userCredential;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    if ((0, $ilNGG._isFirebaseServerApp)(auth.app)) return [
                        2,
                        Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(auth))
                    ];
                    operationType = "signIn" /* OperationType.SIGN_IN */ ;
                    return [
                        4,
                        $65b82078b3339b3f$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        $65b82078b3339b3f$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response)
                    ];
                case 2:
                    userCredential = _state.sent();
                    if (!!bypassAuthState) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        auth._updateCurrentUser(userCredential.user)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        userCredential
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__signInWithCredential.apply(this, arguments);
}
function $65b82078b3339b3f$export$3c2fa207a37baaea(auth, credential) {
    return $65b82078b3339b3f$var$_signInWithCredential1.apply(this, arguments);
}
function $65b82078b3339b3f$var$_signInWithCredential1() {
    $65b82078b3339b3f$var$_signInWithCredential1 = /**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ (0, $9OZ9j._)(function(auth, credential) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_signInWithCredential($65b82078b3339b3f$export$a05254e7c3aeba6e(auth), credential)
            ];
        });
    });
    return $65b82078b3339b3f$var$_signInWithCredential1.apply(this, arguments);
}
function $65b82078b3339b3f$export$ce26c07117d59d6a(user, credential) {
    return $65b82078b3339b3f$var$_linkWithCredential.apply(this, arguments);
}
function $65b82078b3339b3f$var$_linkWithCredential() {
    $65b82078b3339b3f$var$_linkWithCredential = /**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ (0, $9OZ9j._)(function(user, credential) {
        var userInternal;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $gQ5gw.getModularInstance)(user);
                    return [
                        4,
                        $65b82078b3339b3f$var$_assertLinkedStatus(false, userInternal, credential.providerId)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        $65b82078b3339b3f$var$_link$1(userInternal, credential)
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_linkWithCredential.apply(this, arguments);
}
function $65b82078b3339b3f$export$6559d589eb85fbb6(user, credential) {
    return $65b82078b3339b3f$var$_reauthenticateWithCredential.apply(this, arguments);
}
function $65b82078b3339b3f$var$_reauthenticateWithCredential() {
    $65b82078b3339b3f$var$_reauthenticateWithCredential = /**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ (0, $9OZ9j._)(function(user, credential) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_reauthenticate((0, $gQ5gw.getModularInstance)(user), credential)
            ];
        });
    });
    return $65b82078b3339b3f$var$_reauthenticateWithCredential.apply(this, arguments);
}
function $65b82078b3339b3f$var$signInWithCustomToken$1(auth, request) {
    return $65b82078b3339b3f$var$_signInWithCustomToken$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$_signInWithCustomToken$1() {
    $65b82078b3339b3f$var$_signInWithCustomToken$1 = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $65b82078b3339b3f$var$_signInWithCustomToken$1.apply(this, arguments);
}
function $65b82078b3339b3f$export$efca4cbe5dd06740(auth, customToken) {
    return $65b82078b3339b3f$var$_signInWithCustomToken.apply(this, arguments);
}
function $65b82078b3339b3f$var$_signInWithCustomToken() {
    $65b82078b3339b3f$var$_signInWithCustomToken = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ (0, $9OZ9j._)(function(auth, customToken) {
        var authInternal, response, cred;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ((0, $ilNGG._isFirebaseServerApp)(auth.app)) return [
                        2,
                        Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(auth))
                    ];
                    authInternal = $65b82078b3339b3f$export$a05254e7c3aeba6e(auth);
                    return [
                        4,
                        $65b82078b3339b3f$var$signInWithCustomToken$1(authInternal, {
                            token: customToken,
                            returnSecureToken: true
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        $65b82078b3339b3f$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response)
                    ];
                case 2:
                    cred = _state.sent();
                    return [
                        4,
                        authInternal._updateCurrentUser(cred.user)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        cred
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_signInWithCustomToken.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$MultiFactorInfoImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorInfoImpl(factorId, response) {
        (0, $19mwo._)(this, MultiFactorInfoImpl);
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    (0, $6rpfc._)(MultiFactorInfoImpl, null, [
        {
            key: "_fromServerResponse",
            value: function _fromServerResponse(auth, enrollment) {
                if ("phoneInfo" in enrollment) return $65b82078b3339b3f$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
                else if ("totpInfo" in enrollment) return $65b82078b3339b3f$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
                return $65b82078b3339b3f$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        }
    ]);
    return MultiFactorInfoImpl;
}();
var $65b82078b3339b3f$var$PhoneMultiFactorInfoImpl = /*#__PURE__*/ function(MultiFactorInfoImpl) {
    "use strict";
    (0, $iNfU4._)(PhoneMultiFactorInfoImpl, MultiFactorInfoImpl);
    var _super = (0, $k1NN5._)(PhoneMultiFactorInfoImpl);
    function PhoneMultiFactorInfoImpl(response) {
        (0, $19mwo._)(this, PhoneMultiFactorInfoImpl);
        var _this;
        _this = _super.call(this, "phone" /* FactorId.PHONE */ , response);
        _this.phoneNumber = response.phoneInfo;
        return _this;
    }
    (0, $6rpfc._)(PhoneMultiFactorInfoImpl, null, [
        {
            key: "_fromServerResponse",
            value: function _fromServerResponse(_auth, enrollment) {
                return new PhoneMultiFactorInfoImpl(enrollment);
            }
        }
    ]);
    return PhoneMultiFactorInfoImpl;
}($65b82078b3339b3f$var$MultiFactorInfoImpl);
var $65b82078b3339b3f$var$TotpMultiFactorInfoImpl = /*#__PURE__*/ function(MultiFactorInfoImpl) {
    "use strict";
    (0, $iNfU4._)(TotpMultiFactorInfoImpl, MultiFactorInfoImpl);
    var _super = (0, $k1NN5._)(TotpMultiFactorInfoImpl);
    function TotpMultiFactorInfoImpl(response) {
        (0, $19mwo._)(this, TotpMultiFactorInfoImpl);
        return _super.call(this, "totp" /* FactorId.TOTP */ , response);
    }
    (0, $6rpfc._)(TotpMultiFactorInfoImpl, null, [
        {
            key: "_fromServerResponse",
            value: function _fromServerResponse(_auth, enrollment) {
                return new TotpMultiFactorInfoImpl(enrollment);
            }
        }
    ]);
    return TotpMultiFactorInfoImpl;
}($65b82078b3339b3f$var$MultiFactorInfoImpl);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65b82078b3339b3f$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $65b82078b3339b3f$export$890c4ad488842ce7(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $65b82078b3339b3f$export$890c4ad488842ce7(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $65b82078b3339b3f$export$890c4ad488842ce7(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $65b82078b3339b3f$export$890c4ad488842ce7(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
function $65b82078b3339b3f$var$recachePasswordPolicy(auth) {
    return $65b82078b3339b3f$var$_recachePasswordPolicy.apply(this, arguments);
}
function $65b82078b3339b3f$var$_recachePasswordPolicy() {
    $65b82078b3339b3f$var$_recachePasswordPolicy = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ (0, $9OZ9j._)(function(auth) {
        var authInternal;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $65b82078b3339b3f$export$a05254e7c3aeba6e(auth);
                    if (!authInternal._getPasswordPolicyInternal()) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        authInternal._updatePasswordPolicy()
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_recachePasswordPolicy.apply(this, arguments);
}
function $65b82078b3339b3f$export$a8550f7dbe79f93a(auth, email, actionCodeSettings) {
    return $65b82078b3339b3f$var$_sendPasswordResetEmail.apply(this, arguments);
}
function $65b82078b3339b3f$var$_sendPasswordResetEmail() {
    $65b82078b3339b3f$var$_sendPasswordResetEmail = /**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $9OZ9j._)(function(auth, email, actionCodeSettings) {
        var authInternal, request;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $65b82078b3339b3f$export$a05254e7c3aeba6e(auth);
                    request = {
                        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
                        email: email,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    };
                    if (actionCodeSettings) $65b82078b3339b3f$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
                    return [
                        4,
                        $65b82078b3339b3f$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $65b82078b3339b3f$var$sendPasswordResetEmail$1)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_sendPasswordResetEmail.apply(this, arguments);
}
function $65b82078b3339b3f$export$2e2af4578d910ddf(auth, oobCode, newPassword) {
    return $65b82078b3339b3f$var$_confirmPasswordReset.apply(this, arguments);
}
function $65b82078b3339b3f$var$_confirmPasswordReset() {
    $65b82078b3339b3f$var$_confirmPasswordReset = /**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ (0, $9OZ9j._)(function(auth, oobCode, newPassword) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65b82078b3339b3f$var$resetPassword((0, $gQ5gw.getModularInstance)(auth), {
                            oobCode: oobCode,
                            newPassword: newPassword
                        }).catch(function() {
                            var _ref = (0, $9OZ9j._)(function(error) {
                                return (0, $lF1I7.__generator)(this, function(_state) {
                                    if (error.code === "auth/password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ) $65b82078b3339b3f$var$recachePasswordPolicy(auth);
                                    throw error;
                                });
                            });
                            return function(error) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    // Do not return the email.
    });
    return $65b82078b3339b3f$var$_confirmPasswordReset.apply(this, arguments);
}
function $65b82078b3339b3f$export$a93c5207d687da10(auth, oobCode) {
    return $65b82078b3339b3f$var$_applyActionCode.apply(this, arguments);
}
function $65b82078b3339b3f$var$_applyActionCode() {
    $65b82078b3339b3f$var$_applyActionCode = /**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ (0, $9OZ9j._)(function(auth, oobCode) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65b82078b3339b3f$var$applyActionCode$1((0, $gQ5gw.getModularInstance)(auth), {
                            oobCode: oobCode
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_applyActionCode.apply(this, arguments);
}
function $65b82078b3339b3f$export$c3950d9923825c02(auth, oobCode) {
    return $65b82078b3339b3f$var$_checkActionCode.apply(this, arguments);
}
function $65b82078b3339b3f$var$_checkActionCode() {
    $65b82078b3339b3f$var$_checkActionCode = /**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ (0, $9OZ9j._)(function(auth, oobCode) {
        var authModular, response, operation, multiFactorInfo;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authModular = (0, $gQ5gw.getModularInstance)(auth);
                    return [
                        4,
                        $65b82078b3339b3f$var$resetPassword(authModular, {
                            oobCode: oobCode
                        })
                    ];
                case 1:
                    response = _state.sent();
                    // Email could be empty only if the request type is EMAIL_SIGNIN or
                    // VERIFY_AND_CHANGE_EMAIL.
                    // New email should not be empty if the request type is
                    // VERIFY_AND_CHANGE_EMAIL.
                    // Multi-factor info could not be empty if the request type is
                    // REVERT_SECOND_FACTOR_ADDITION.
                    operation = response.requestType;
                    $65b82078b3339b3f$export$890c4ad488842ce7(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    switch(operation){
                        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
                            break;
                        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
                            $65b82078b3339b3f$export$890c4ad488842ce7(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                            break;
                        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
                            $65b82078b3339b3f$export$890c4ad488842ce7(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                        // fall through
                        default:
                            $65b82078b3339b3f$export$890c4ad488842ce7(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    }
                    // The multi-factor info for revert second factor addition
                    multiFactorInfo = null;
                    if (response.mfaInfo) multiFactorInfo = $65b82078b3339b3f$var$MultiFactorInfoImpl._fromServerResponse($65b82078b3339b3f$export$a05254e7c3aeba6e(authModular), response.mfaInfo);
                    return [
                        2,
                        {
                            data: {
                                email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
                                previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
                                multiFactorInfo: multiFactorInfo
                            },
                            operation: operation
                        }
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_checkActionCode.apply(this, arguments);
}
function $65b82078b3339b3f$export$a9c996f45e5784d0(auth, code) {
    return $65b82078b3339b3f$var$_verifyPasswordResetCode.apply(this, arguments);
}
function $65b82078b3339b3f$var$_verifyPasswordResetCode() {
    $65b82078b3339b3f$var$_verifyPasswordResetCode = /**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ (0, $9OZ9j._)(function(auth, code) {
        var data;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65b82078b3339b3f$export$c3950d9923825c02((0, $gQ5gw.getModularInstance)(auth), code)
                    ];
                case 1:
                    data = _state.sent().data;
                    // Email should always be present since a code was sent to it
                    return [
                        2,
                        data.email
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_verifyPasswordResetCode.apply(this, arguments);
}
function $65b82078b3339b3f$export$7910e0436ed8d1de(auth, email, password) {
    return $65b82078b3339b3f$var$_createUserWithEmailAndPassword.apply(this, arguments);
}
function $65b82078b3339b3f$var$_createUserWithEmailAndPassword() {
    $65b82078b3339b3f$var$_createUserWithEmailAndPassword = /**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ (0, $9OZ9j._)(function(auth, email, password) {
        var authInternal, request, signUpResponse, response, userCredential;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ((0, $ilNGG._isFirebaseServerApp)(auth.app)) return [
                        2,
                        Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(auth))
                    ];
                    authInternal = $65b82078b3339b3f$export$a05254e7c3aeba6e(auth);
                    request = {
                        returnSecureToken: true,
                        email: email,
                        password: password,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    };
                    signUpResponse = $65b82078b3339b3f$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $65b82078b3339b3f$var$signUp);
                    return [
                        4,
                        signUpResponse.catch(function(error) {
                            if (error.code === "auth/password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ) $65b82078b3339b3f$var$recachePasswordPolicy(auth);
                            throw error;
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        $65b82078b3339b3f$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response)
                    ];
                case 2:
                    userCredential = _state.sent();
                    return [
                        4,
                        authInternal._updateCurrentUser(userCredential.user)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        userCredential
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_createUserWithEmailAndPassword.apply(this, arguments);
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $65b82078b3339b3f$export$555508cbc6add439(auth, email, password) {
    if ((0, $ilNGG._isFirebaseServerApp)(auth.app)) return Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $65b82078b3339b3f$export$3c2fa207a37baaea((0, $gQ5gw.getModularInstance)(auth), $65b82078b3339b3f$export$e7c866399fa523f5.credential(email, password)).catch(function() {
        var _ref = (0, $9OZ9j._)(function(error) {
            return (0, $lF1I7.__generator)(this, function(_state) {
                if (error.code === "auth/password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ) $65b82078b3339b3f$var$recachePasswordPolicy(auth);
                throw error;
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
}
function $65b82078b3339b3f$export$2219238a014317b0(auth, email, actionCodeSettings) {
    return $65b82078b3339b3f$var$_sendSignInLinkToEmail.apply(this, arguments);
}
function $65b82078b3339b3f$var$_sendSignInLinkToEmail() {
    $65b82078b3339b3f$var$_sendSignInLinkToEmail = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $9OZ9j._)(function(auth, email, actionCodeSettings) {
        var authInternal, request;
        function setActionCodeSettings(request, actionCodeSettings) {
            $65b82078b3339b3f$export$890c4ad488842ce7(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            if (actionCodeSettings) $65b82078b3339b3f$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
        }
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $65b82078b3339b3f$export$a05254e7c3aeba6e(auth);
                    request = {
                        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
                        email: email,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    };
                    setActionCodeSettings(request, actionCodeSettings);
                    return [
                        4,
                        $65b82078b3339b3f$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $65b82078b3339b3f$var$sendSignInLinkToEmail$1)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_sendSignInLinkToEmail.apply(this, arguments);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $65b82078b3339b3f$export$4c3d22f3d993c33f(auth, emailLink) {
    var actionCodeUrl = $65b82078b3339b3f$export$f38c853ae54ed474.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
function $65b82078b3339b3f$export$f787f51d84a910ad(auth, email, emailLink) {
    return $65b82078b3339b3f$var$_signInWithEmailLink.apply(this, arguments);
}
function $65b82078b3339b3f$var$_signInWithEmailLink() {
    $65b82078b3339b3f$var$_signInWithEmailLink = /**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ (0, $9OZ9j._)(function(auth, email, emailLink) {
        var authModular, credential;
        return (0, $lF1I7.__generator)(this, function(_state) {
            if ((0, $ilNGG._isFirebaseServerApp)(auth.app)) return [
                2,
                Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(auth))
            ];
            authModular = (0, $gQ5gw.getModularInstance)(auth);
            credential = $65b82078b3339b3f$export$e7c866399fa523f5.credentialWithLink(email, emailLink || $65b82078b3339b3f$var$_getCurrentUrl());
            // Check if the tenant ID in the email link matches the tenant ID on Auth
            // instance.
            $65b82078b3339b3f$export$890c4ad488842ce7(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
            return [
                2,
                $65b82078b3339b3f$export$3c2fa207a37baaea(authModular, credential)
            ];
        });
    });
    return $65b82078b3339b3f$var$_signInWithEmailLink.apply(this, arguments);
}
function $65b82078b3339b3f$var$createAuthUri(auth, request) {
    return $65b82078b3339b3f$var$_createAuthUri.apply(this, arguments);
}
function $65b82078b3339b3f$var$_createAuthUri() {
    $65b82078b3339b3f$var$_createAuthUri = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $65b82078b3339b3f$var$_createAuthUri.apply(this, arguments);
}
function $65b82078b3339b3f$export$c9170ad7d4cd7e57(auth, email) {
    return $65b82078b3339b3f$var$_fetchSignInMethodsForEmail.apply(this, arguments);
}
function $65b82078b3339b3f$var$_fetchSignInMethodsForEmail() {
    $65b82078b3339b3f$var$_fetchSignInMethodsForEmail = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ (0, $9OZ9j._)(function(auth, email) {
        var continueUri, request, signinMethods;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // createAuthUri returns an error if continue URI is not http or https.
                    // For environments like Cordova, Chrome extensions, native frameworks, file
                    // systems, etc, use http://localhost as continue URL.
                    continueUri = $65b82078b3339b3f$var$_isHttpOrHttps() ? $65b82078b3339b3f$var$_getCurrentUrl() : "http://localhost";
                    request = {
                        identifier: email,
                        continueUri: continueUri
                    };
                    return [
                        4,
                        $65b82078b3339b3f$var$createAuthUri((0, $gQ5gw.getModularInstance)(auth), request)
                    ];
                case 1:
                    signinMethods = _state.sent().signinMethods;
                    return [
                        2,
                        signinMethods || []
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_fetchSignInMethodsForEmail.apply(this, arguments);
}
function $65b82078b3339b3f$export$ee7c8ad385a60b7b(user, actionCodeSettings) {
    return $65b82078b3339b3f$var$_sendEmailVerification.apply(this, arguments);
}
function $65b82078b3339b3f$var$_sendEmailVerification() {
    $65b82078b3339b3f$var$_sendEmailVerification = /**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $9OZ9j._)(function(user, actionCodeSettings) {
        var userInternal, idToken, request, email;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $gQ5gw.getModularInstance)(user);
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    request = {
                        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
                        idToken: idToken
                    };
                    if (actionCodeSettings) $65b82078b3339b3f$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
                    return [
                        4,
                        $65b82078b3339b3f$var$sendEmailVerification$1(userInternal.auth, request)
                    ];
                case 2:
                    email = _state.sent().email;
                    if (!(email !== user.email)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        user.reload()
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_sendEmailVerification.apply(this, arguments);
}
function $65b82078b3339b3f$export$995eb9fca571757(user, newEmail, actionCodeSettings) {
    return $65b82078b3339b3f$var$_verifyBeforeUpdateEmail.apply(this, arguments);
}
function $65b82078b3339b3f$var$_verifyBeforeUpdateEmail() {
    $65b82078b3339b3f$var$_verifyBeforeUpdateEmail = /**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $9OZ9j._)(function(user, newEmail, actionCodeSettings) {
        var userInternal, idToken, request, email;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $gQ5gw.getModularInstance)(user);
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    request = {
                        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
                        idToken: idToken,
                        newEmail: newEmail
                    };
                    if (actionCodeSettings) $65b82078b3339b3f$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
                    return [
                        4,
                        $65b82078b3339b3f$var$verifyAndChangeEmail(userInternal.auth, request)
                    ];
                case 2:
                    email = _state.sent().email;
                    if (!(email !== user.email)) return [
                        3,
                        4
                    ];
                    // If the local copy of the email on user is outdated, reload the
                    // user.
                    return [
                        4,
                        user.reload()
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_verifyBeforeUpdateEmail.apply(this, arguments);
}
function $65b82078b3339b3f$var$updateProfile$1(auth, request) {
    return $65b82078b3339b3f$var$_updateProfile$1.apply(this, arguments);
}
function $65b82078b3339b3f$var$_updateProfile$1() {
    $65b82078b3339b3f$var$_updateProfile$1 = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(auth, request) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $65b82078b3339b3f$var$_updateProfile$1.apply(this, arguments);
}
function $65b82078b3339b3f$export$21579262ef46735b(user, _) {
    return $65b82078b3339b3f$var$_updateProfile.apply(this, arguments);
}
function $65b82078b3339b3f$var$_updateProfile() {
    $65b82078b3339b3f$var$_updateProfile = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ (0, $9OZ9j._)(function(user, param) {
        var displayName, photoUrl, userInternal, idToken, profileRequest, response, passwordProvider;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    displayName = param.displayName, photoUrl = param.photoURL;
                    if (displayName === undefined && photoUrl === undefined) return [
                        2
                    ];
                    userInternal = (0, $gQ5gw.getModularInstance)(user);
                    return [
                        4,
                        userInternal.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    profileRequest = {
                        idToken: idToken,
                        displayName: displayName,
                        photoUrl: photoUrl,
                        returnSecureToken: true
                    };
                    return [
                        4,
                        $65b82078b3339b3f$var$_logoutIfInvalidated(userInternal, $65b82078b3339b3f$var$updateProfile$1(userInternal.auth, profileRequest))
                    ];
                case 2:
                    response = _state.sent();
                    userInternal.displayName = response.displayName || null;
                    userInternal.photoURL = response.photoUrl || null;
                    // Update the password provider as well
                    passwordProvider = userInternal.providerData.find(function(param) {
                        var providerId = param.providerId;
                        return providerId === "password" /* ProviderId.PASSWORD */ ;
                    });
                    if (passwordProvider) {
                        passwordProvider.displayName = userInternal.displayName;
                        passwordProvider.photoURL = userInternal.photoURL;
                    }
                    return [
                        4,
                        userInternal._updateTokensIfNecessary(response)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_updateProfile.apply(this, arguments);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $65b82078b3339b3f$export$ab83b03e4111b1d0(user, newEmail) {
    var userInternal = (0, $gQ5gw.getModularInstance)(user);
    if ((0, $ilNGG._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $65b82078b3339b3f$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $65b82078b3339b3f$export$1a82df3d29112e01(user, newPassword) {
    return $65b82078b3339b3f$var$updateEmailOrPassword((0, $gQ5gw.getModularInstance)(user), null, newPassword);
}
function $65b82078b3339b3f$var$updateEmailOrPassword(user, email, password) {
    return $65b82078b3339b3f$var$_updateEmailOrPassword.apply(this, arguments);
}
function $65b82078b3339b3f$var$_updateEmailOrPassword() {
    $65b82078b3339b3f$var$_updateEmailOrPassword = (0, $9OZ9j._)(function(user, email, password) {
        var auth, idToken, request, response;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    auth = user.auth;
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    request = {
                        idToken: idToken,
                        returnSecureToken: true
                    };
                    if (email) request.email = email;
                    if (password) request.password = password;
                    return [
                        4,
                        $65b82078b3339b3f$var$_logoutIfInvalidated(user, $65b82078b3339b3f$var$updateEmailPassword(auth, request))
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        user._updateTokensIfNecessary(response, /* reload */ true)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_updateEmailOrPassword.apply(this, arguments);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $65b82078b3339b3f$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    var providerId = idTokenResponse.providerId;
    var profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    var isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        var signInProvider = (_b = (_a = $65b82078b3339b3f$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            var filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $65b82078b3339b3f$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $65b82078b3339b3f$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $65b82078b3339b3f$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $65b82078b3339b3f$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $65b82078b3339b3f$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $65b82078b3339b3f$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $65b82078b3339b3f$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
var $65b82078b3339b3f$var$GenericAdditionalUserInfo = function GenericAdditionalUserInfo(isNewUser, providerId) {
    "use strict";
    var profile = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    (0, $19mwo._)(this, GenericAdditionalUserInfo);
    this.isNewUser = isNewUser;
    this.providerId = providerId;
    this.profile = profile;
};
var $65b82078b3339b3f$var$FederatedAdditionalUserInfoWithUsername = /*#__PURE__*/ function(GenericAdditionalUserInfo) {
    "use strict";
    (0, $iNfU4._)(FederatedAdditionalUserInfoWithUsername, GenericAdditionalUserInfo);
    var _super = (0, $k1NN5._)(FederatedAdditionalUserInfoWithUsername);
    function FederatedAdditionalUserInfoWithUsername(isNewUser, providerId, profile, username) {
        (0, $19mwo._)(this, FederatedAdditionalUserInfoWithUsername);
        var _this;
        _this = _super.call(this, isNewUser, providerId, profile);
        _this.username = username;
        return _this;
    }
    return FederatedAdditionalUserInfoWithUsername;
}($65b82078b3339b3f$var$GenericAdditionalUserInfo);
var $65b82078b3339b3f$var$FacebookAdditionalUserInfo = /*#__PURE__*/ function(GenericAdditionalUserInfo) {
    "use strict";
    (0, $iNfU4._)(FacebookAdditionalUserInfo, GenericAdditionalUserInfo);
    var _super = (0, $k1NN5._)(FacebookAdditionalUserInfo);
    function FacebookAdditionalUserInfo(isNewUser, profile) {
        (0, $19mwo._)(this, FacebookAdditionalUserInfo);
        return _super.call(this, isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
    return FacebookAdditionalUserInfo;
}($65b82078b3339b3f$var$GenericAdditionalUserInfo);
var $65b82078b3339b3f$var$GithubAdditionalUserInfo = /*#__PURE__*/ function(FederatedAdditionalUserInfoWithUsername) {
    "use strict";
    (0, $iNfU4._)(GithubAdditionalUserInfo, FederatedAdditionalUserInfoWithUsername);
    var _super = (0, $k1NN5._)(GithubAdditionalUserInfo);
    function GithubAdditionalUserInfo(isNewUser, profile) {
        (0, $19mwo._)(this, GithubAdditionalUserInfo);
        return _super.call(this, isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
    return GithubAdditionalUserInfo;
}($65b82078b3339b3f$var$FederatedAdditionalUserInfoWithUsername);
var $65b82078b3339b3f$var$GoogleAdditionalUserInfo = /*#__PURE__*/ function(GenericAdditionalUserInfo) {
    "use strict";
    (0, $iNfU4._)(GoogleAdditionalUserInfo, GenericAdditionalUserInfo);
    var _super = (0, $k1NN5._)(GoogleAdditionalUserInfo);
    function GoogleAdditionalUserInfo(isNewUser, profile) {
        (0, $19mwo._)(this, GoogleAdditionalUserInfo);
        return _super.call(this, isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
    return GoogleAdditionalUserInfo;
}($65b82078b3339b3f$var$GenericAdditionalUserInfo);
var $65b82078b3339b3f$var$TwitterAdditionalUserInfo = /*#__PURE__*/ function(FederatedAdditionalUserInfoWithUsername) {
    "use strict";
    (0, $iNfU4._)(TwitterAdditionalUserInfo, FederatedAdditionalUserInfoWithUsername);
    var _super = (0, $k1NN5._)(TwitterAdditionalUserInfo);
    function TwitterAdditionalUserInfo(isNewUser, profile, screenName) {
        (0, $19mwo._)(this, TwitterAdditionalUserInfo);
        return _super.call(this, isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
    return TwitterAdditionalUserInfo;
}($65b82078b3339b3f$var$FederatedAdditionalUserInfoWithUsername);
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $65b82078b3339b3f$export$8a5498727ef6be21(userCredential) {
    var user = userCredential.user, _tokenResponse = userCredential._tokenResponse;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $65b82078b3339b3f$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $65b82078b3339b3f$export$9e5f44173e64f162(auth, persistence) {
    return (0, $gQ5gw.getModularInstance)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $65b82078b3339b3f$export$625550452a3fa3ec(auth) {
    return $65b82078b3339b3f$var$_initializeRecaptchaConfig(auth);
}
function $65b82078b3339b3f$export$90a7f3efeed30595(auth, password) {
    return $65b82078b3339b3f$var$_validatePassword.apply(this, arguments);
}
function $65b82078b3339b3f$var$_validatePassword() {
    $65b82078b3339b3f$var$_validatePassword = /**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ (0, $9OZ9j._)(function(auth, password) {
        var authInternal;
        return (0, $lF1I7.__generator)(this, function(_state) {
            authInternal = $65b82078b3339b3f$export$a05254e7c3aeba6e(auth);
            return [
                2,
                authInternal.validatePassword(password)
            ];
        });
    });
    return $65b82078b3339b3f$var$_validatePassword.apply(this, arguments);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $65b82078b3339b3f$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $gQ5gw.getModularInstance)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $65b82078b3339b3f$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $gQ5gw.getModularInstance)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $65b82078b3339b3f$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $gQ5gw.getModularInstance)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $65b82078b3339b3f$export$df995fae86a55f06(auth) {
    (0, $gQ5gw.getModularInstance)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $65b82078b3339b3f$export$ef35774e6d314e91(auth, user) {
    return (0, $gQ5gw.getModularInstance)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $65b82078b3339b3f$export$e7094788287c5e9b(auth) {
    return (0, $gQ5gw.getModularInstance)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $65b82078b3339b3f$export$96f57966bedc81b4(auth, token) {
    var authInternal = $65b82078b3339b3f$export$a05254e7c3aeba6e(auth);
    return authInternal.revokeAccessToken(token);
}
function $65b82078b3339b3f$export$a9c23c6ac3fc3eca(user) {
    return $65b82078b3339b3f$var$_deleteUser.apply(this, arguments);
}
function $65b82078b3339b3f$var$_deleteUser() {
    $65b82078b3339b3f$var$_deleteUser = /**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ (0, $9OZ9j._)(function(user) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                (0, $gQ5gw.getModularInstance)(user).delete()
            ];
        });
    });
    return $65b82078b3339b3f$var$_deleteUser.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$MultiFactorSessionImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorSessionImpl(type, credential, user) {
        (0, $19mwo._)(this, MultiFactorSessionImpl);
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    (0, $6rpfc._)(MultiFactorSessionImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                var key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? "idToken" : "pendingCredential";
                return {
                    multiFactorSession: (0, $c5rwh._)({}, key, this.credential)
                };
            }
        }
    ], [
        {
            key: "_fromIdtoken",
            value: function _fromIdtoken(idToken, user) {
                return new MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
            }
        },
        {
            key: "_fromMfaPendingCredential",
            value: function _fromMfaPendingCredential(mfaPendingCredential) {
                return new MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(obj) {
                var _a, _b;
                if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
                    if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
                    else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
                }
                return null;
            }
        }
    ]);
    return MultiFactorSessionImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$MultiFactorResolverImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorResolverImpl(session, hints, signInResolver) {
        (0, $19mwo._)(this, MultiFactorResolverImpl);
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    (0, $6rpfc._)(MultiFactorResolverImpl, [
        {
            key: "resolveSignIn",
            value: function resolveSignIn(assertionExtern) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var assertion;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        assertion = assertionExtern;
                        return [
                            2,
                            _this.signInResolver(assertion)
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "_fromError",
            value: /** @internal */ function _fromError(authExtern, error) {
                var auth = $65b82078b3339b3f$export$a05254e7c3aeba6e(authExtern);
                var serverResponse = error.customData._serverResponse;
                var hints = (serverResponse.mfaInfo || []).map(function(enrollment) {
                    return $65b82078b3339b3f$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment);
                });
                $65b82078b3339b3f$export$890c4ad488842ce7(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                var session = $65b82078b3339b3f$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
                return new MultiFactorResolverImpl(session, hints, function() {
                    var _ref = (0, $9OZ9j._)(function(assertion) {
                        var mfaResponse, idTokenResponse, _, userCredential;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        assertion._process(auth, session)
                                    ];
                                case 1:
                                    mfaResponse = _state.sent();
                                    // Clear out the unneeded fields from the old login response
                                    delete serverResponse.mfaInfo;
                                    delete serverResponse.mfaPendingCredential;
                                    // Use in the new token & refresh token in the old response
                                    idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                                        idToken: mfaResponse.idToken,
                                        refreshToken: mfaResponse.refreshToken
                                    });
                                    _ = error.operationType;
                                    switch(_){
                                        case "signIn" /* OperationType.SIGN_IN */ :
                                            return [
                                                3,
                                                2
                                            ];
                                        case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                                            return [
                                                3,
                                                5
                                            ];
                                    }
                                    return [
                                        3,
                                        6
                                    ];
                                case 2:
                                    return [
                                        4,
                                        $65b82078b3339b3f$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse)
                                    ];
                                case 3:
                                    userCredential = _state.sent();
                                    return [
                                        4,
                                        auth._updateCurrentUser(userCredential.user)
                                    ];
                                case 4:
                                    _state.sent();
                                    return [
                                        2,
                                        userCredential
                                    ];
                                case 5:
                                    $65b82078b3339b3f$export$890c4ad488842ce7(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                    return [
                                        2,
                                        $65b82078b3339b3f$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse)
                                    ];
                                case 6:
                                    $65b82078b3339b3f$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                    _state.label = 7;
                                case 7:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(assertion) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        }
    ]);
    return MultiFactorResolverImpl;
}();
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $65b82078b3339b3f$export$6554612db691658e(auth, error) {
    var _a;
    var authModular = (0, $gQ5gw.getModularInstance)(auth);
    var errorInternal = error;
    $65b82078b3339b3f$export$890c4ad488842ce7(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $65b82078b3339b3f$export$890c4ad488842ce7((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $65b82078b3339b3f$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65b82078b3339b3f$var$startEnrollPhoneMfa(auth, request) {
    return $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request));
}
function $65b82078b3339b3f$var$finalizeEnrollPhoneMfa(auth, request) {
    return $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request));
}
function $65b82078b3339b3f$var$startEnrollTotpMfa(auth, request) {
    return $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request));
}
function $65b82078b3339b3f$var$finalizeEnrollTotpMfa(auth, request) {
    return $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request));
}
function $65b82078b3339b3f$var$withdrawMfa(auth, request) {
    return $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request));
}
var $65b82078b3339b3f$var$MultiFactorUserImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorUserImpl(user) {
        var _this = this;
        (0, $19mwo._)(this, MultiFactorUserImpl);
        this.user = user;
        this.enrolledFactors = [];
        user._onReload(function(userInfo) {
            if (userInfo.mfaInfo) _this.enrolledFactors = userInfo.mfaInfo.map(function(enrollment) {
                return $65b82078b3339b3f$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment);
            });
        });
    }
    (0, $6rpfc._)(MultiFactorUserImpl, [
        {
            key: "getSession",
            value: function getSession() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = $65b82078b3339b3f$var$MultiFactorSessionImpl._fromIdtoken;
                                return [
                                    4,
                                    _this.user.getIdToken()
                                ];
                            case 1:
                                return [
                                    2,
                                    _.apply($65b82078b3339b3f$var$MultiFactorSessionImpl, [
                                        _state.sent(),
                                        _this.user
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "enroll",
            value: function enroll(assertionExtern, displayName) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var assertion, session, finalizeMfaResponse;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                assertion = assertionExtern;
                                return [
                                    4,
                                    _this.getSession()
                                ];
                            case 1:
                                session = _state.sent();
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_logoutIfInvalidated(_this.user, assertion._process(_this.user.auth, session, displayName))
                                ];
                            case 2:
                                finalizeMfaResponse = _state.sent();
                                // New tokens will be issued after enrollment of the new second factors.
                                // They need to be updated on the user.
                                return [
                                    4,
                                    _this.user._updateTokensIfNecessary(finalizeMfaResponse)
                                ];
                            case 3:
                                _state.sent();
                                // The user needs to be reloaded to get the new multi-factor information
                                // from server. USER_RELOADED event will be triggered and `enrolledFactors`
                                // will be updated.
                                return [
                                    2,
                                    _this.user.reload()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "unenroll",
            value: function unenroll(infoOrUid) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var mfaEnrollmentId, idToken, idTokenResponse, e;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
                                return [
                                    4,
                                    _this.user.getIdToken()
                                ];
                            case 1:
                                idToken = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_logoutIfInvalidated(_this.user, $65b82078b3339b3f$var$withdrawMfa(_this.user.auth, {
                                        idToken: idToken,
                                        mfaEnrollmentId: mfaEnrollmentId
                                    }))
                                ];
                            case 3:
                                idTokenResponse = _state.sent();
                                // Remove the second factor from the user's list.
                                _this.enrolledFactors = _this.enrolledFactors.filter(function(param) {
                                    var uid = param.uid;
                                    return uid !== mfaEnrollmentId;
                                });
                                // Depending on whether the backend decided to revoke the user's session,
                                // the tokenResponse may be empty. If the tokens were not updated (and they
                                // are now invalid), reloading the user will discover this and invalidate
                                // the user's state accordingly.
                                return [
                                    4,
                                    _this.user._updateTokensIfNecessary(idTokenResponse)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    _this.user.reload()
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                throw e;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "_fromUser",
            value: function _fromUser(user) {
                return new MultiFactorUserImpl(user);
            }
        }
    ]);
    return MultiFactorUserImpl;
}();
var $65b82078b3339b3f$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $65b82078b3339b3f$export$493d36ec626b6698(user) {
    var userModular = (0, $gQ5gw.getModularInstance)(user);
    if (!$65b82078b3339b3f$var$multiFactorUserCache.has(userModular)) $65b82078b3339b3f$var$multiFactorUserCache.set(userModular, $65b82078b3339b3f$var$MultiFactorUserImpl._fromUser(userModular));
    return $65b82078b3339b3f$var$multiFactorUserCache.get(userModular);
}
var $65b82078b3339b3f$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
var $65b82078b3339b3f$var$BrowserPersistenceClass = /*#__PURE__*/ function() {
    "use strict";
    function BrowserPersistenceClass(storageRetriever, type) {
        (0, $19mwo._)(this, BrowserPersistenceClass);
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    (0, $6rpfc._)(BrowserPersistenceClass, [
        {
            key: "_isAvailable",
            value: function _isAvailable() {
                try {
                    if (!this.storage) return Promise.resolve(false);
                    this.storage.setItem($65b82078b3339b3f$var$STORAGE_AVAILABLE_KEY, "1");
                    this.storage.removeItem($65b82078b3339b3f$var$STORAGE_AVAILABLE_KEY);
                    return Promise.resolve(true);
                } catch (_a) {
                    return Promise.resolve(false);
                }
            }
        },
        {
            key: "_set",
            value: function _set(key, value) {
                this.storage.setItem(key, JSON.stringify(value));
                return Promise.resolve();
            }
        },
        {
            key: "_get",
            value: function _get(key) {
                var json = this.storage.getItem(key);
                return Promise.resolve(json ? JSON.parse(json) : null);
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                this.storage.removeItem(key);
                return Promise.resolve();
            }
        },
        {
            key: "storage",
            get: function get() {
                return this.storageRetriever();
            }
        }
    ]);
    return BrowserPersistenceClass;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65b82078b3339b3f$var$_iframeCannotSyncWebStorage() {
    var ua = (0, $gQ5gw.getUA)();
    return $65b82078b3339b3f$var$_isSafari(ua) || $65b82078b3339b3f$export$d66dc83d8cfc8dd(ua);
}
// The polling period in case events are not supported
var $65b82078b3339b3f$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
var $65b82078b3339b3f$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
var $65b82078b3339b3f$var$BrowserLocalPersistence = /*#__PURE__*/ function(BrowserPersistenceClass) {
    "use strict";
    (0, $iNfU4._)(BrowserLocalPersistence, BrowserPersistenceClass);
    var _super = (0, $k1NN5._)(BrowserLocalPersistence);
    function BrowserLocalPersistence() {
        (0, $19mwo._)(this, BrowserLocalPersistence);
        var _this;
        _this = _super.call(this, function() {
            return window.localStorage;
        }, "LOCAL" /* PersistenceType.LOCAL */ );
        _this.boundEventHandler = function(event, poll) {
            return _this.onStorageEvent(event, poll);
        };
        _this.listeners = {};
        _this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        _this.safariLocalStorageNotSynced = $65b82078b3339b3f$var$_iframeCannotSyncWebStorage() && $65b82078b3339b3f$var$_isIframe();
        // Whether to use polling instead of depending on window events
        _this.fallbackToPolling = $65b82078b3339b3f$var$_isMobileBrowser();
        _this._shouldAllowMigration = true;
        return _this;
    }
    (0, $6rpfc._)(BrowserLocalPersistence, [
        {
            key: "forAllChangedKeys",
            value: function forAllChangedKeys(cb) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Check all keys with listeners on them.
                    for(var _iterator = Object.keys(this.listeners)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        // Get value from localStorage.
                        var newValue = this.storage.getItem(key);
                        var oldValue = this.localCache[key];
                        // If local map value does not match, trigger listener with storage event.
                        // Differentiate this simulated event from the real storage event.
                        if (newValue !== oldValue) cb(key, oldValue, newValue);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "onStorageEvent",
            value: function onStorageEvent(event) {
                var _this = this;
                var poll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                // Key would be null in some situations, like when localStorage is cleared
                if (!event.key) {
                    this.forAllChangedKeys(function(key, _oldValue, newValue) {
                        _this.notifyListeners(key, newValue);
                    });
                    return;
                }
                var key = event.key;
                // Check the mechanism how this event was detected.
                // The first event will dictate the mechanism to be used.
                if (poll) // Environment detects storage changes via polling.
                // Remove storage event listener to prevent possible event duplication.
                this.detachListener();
                else // Environment detects storage changes via storage event listener.
                // Remove polling listener to prevent possible event duplication.
                this.stopPolling();
                // Safari embedded iframe. Storage event will trigger with the delta
                // changes but no changes will be applied to the iframe localStorage.
                if (this.safariLocalStorageNotSynced) {
                    // Get current iframe page value.
                    var storedValue = this.storage.getItem(key);
                    // Value not synchronized, synchronize manually.
                    if (event.newValue !== storedValue) {
                        if (event.newValue !== null) // Value changed from current value.
                        this.storage.setItem(key, event.newValue);
                        else // Current value deleted.
                        this.storage.removeItem(key);
                    } else if (this.localCache[key] === event.newValue && !poll) // Already detected and processed, do not trigger listeners again.
                    return;
                }
                var triggerListeners = function() {
                    // Keep local map up to date in case storage event is triggered before
                    // poll.
                    var storedValue = _this.storage.getItem(key);
                    if (!poll && _this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
                    // This seems to trigger in some IE browsers for some reason.
                    return;
                    _this.notifyListeners(key, storedValue);
                };
                var storedValue1 = this.storage.getItem(key);
                if ($65b82078b3339b3f$var$_isIE10() && storedValue1 !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
                // correct key, oldValue and newValue but localStorage.getItem(key) does
                // not yield the updated value until a few milliseconds. This ensures
                // this recovers from that situation.
                setTimeout(triggerListeners, $65b82078b3339b3f$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
                else triggerListeners();
            }
        },
        {
            key: "notifyListeners",
            value: function notifyListeners(key, value) {
                this.localCache[key] = value;
                var listeners = this.listeners[key];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (listeners) try {
                    for(var _iterator = Array.from(listeners)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener(value ? JSON.parse(value) : value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "startPolling",
            value: function startPolling() {
                var _this = this;
                this.stopPolling();
                this.pollTimer = setInterval(function() {
                    _this.forAllChangedKeys(function(key, oldValue, newValue) {
                        _this.onStorageEvent(new StorageEvent("storage", {
                            key: key,
                            oldValue: oldValue,
                            newValue: newValue
                        }), /* poll */ true);
                    });
                }, $65b82078b3339b3f$var$_POLLING_INTERVAL_MS$1);
            }
        },
        {
            key: "stopPolling",
            value: function stopPolling() {
                if (this.pollTimer) {
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                }
            }
        },
        {
            key: "attachListener",
            value: function attachListener() {
                window.addEventListener("storage", this.boundEventHandler);
            }
        },
        {
            key: "detachListener",
            value: function detachListener() {
                window.removeEventListener("storage", this.boundEventHandler);
            }
        },
        {
            key: "_addListener",
            value: function _addListener(key, listener) {
                if (Object.keys(this.listeners).length === 0) {
                    // Whether browser can detect storage event when it had already been pushed to the background.
                    // This may happen in some mobile browsers. A localStorage change in the foreground window
                    // will not be detected in the background window via the storage event.
                    // This was detected in iOS 7.x mobile browsers
                    if (this.fallbackToPolling) this.startPolling();
                    else this.attachListener();
                }
                if (!this.listeners[key]) {
                    this.listeners[key] = new Set();
                    // Populate the cache to avoid spuriously triggering on first poll.
                    this.localCache[key] = this.storage.getItem(key);
                }
                this.listeners[key].add(listener);
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(key, listener) {
                if (this.listeners[key]) {
                    this.listeners[key].delete(listener);
                    if (this.listeners[key].size === 0) delete this.listeners[key];
                }
                if (Object.keys(this.listeners).length === 0) {
                    this.detachListener();
                    this.stopPolling();
                }
            }
        },
        {
            key: "_set",
            value: // Update local cache on base operations:
            function _set(key, value) {
                var _this = this;
                var _this1 = this, _superprop_get__set = function() {
                    return (0, $jLCbM._)((0, $laF8D._)(BrowserLocalPersistence.prototype), "_set", _this);
                };
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get__set().call(_this1, key, value)
                                ];
                            case 1:
                                _state.sent();
                                _this1.localCache[key] = JSON.stringify(value);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_get",
            value: function _get1(key) {
                var _this = this;
                var _this1 = this, _superprop_get__get = function() {
                    return (0, $jLCbM._)((0, $laF8D._)(BrowserLocalPersistence.prototype), "_get", _this);
                };
                return (0, $9OZ9j._)(function() {
                    var value;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get__get().call(_this1, key)
                                ];
                            case 1:
                                value = _state.sent();
                                _this1.localCache[key] = JSON.stringify(value);
                                return [
                                    2,
                                    value
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                var _this = this;
                var _this1 = this, _superprop_get__remove = function() {
                    return (0, $jLCbM._)((0, $laF8D._)(BrowserLocalPersistence.prototype), "_remove", _this);
                };
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get__remove().call(_this1, key)
                                ];
                            case 1:
                                _state.sent();
                                delete _this1.localCache[key];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return BrowserLocalPersistence;
}($65b82078b3339b3f$var$BrowserPersistenceClass);
$65b82078b3339b3f$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ var $65b82078b3339b3f$export$8b22cf2602fb60ce = $65b82078b3339b3f$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$BrowserSessionPersistence = /*#__PURE__*/ function(BrowserPersistenceClass) {
    "use strict";
    (0, $iNfU4._)(BrowserSessionPersistence, BrowserPersistenceClass);
    var _super = (0, $k1NN5._)(BrowserSessionPersistence);
    function BrowserSessionPersistence() {
        (0, $19mwo._)(this, BrowserSessionPersistence);
        return _super.call(this, function() {
            return window.sessionStorage;
        }, "SESSION" /* PersistenceType.SESSION */ );
    }
    (0, $6rpfc._)(BrowserSessionPersistence, [
        {
            key: "_addListener",
            value: function _addListener(_key, _listener) {
                // Listeners are not supported for session storage since it cannot be shared across windows
                return;
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(_key, _listener) {
                // Listeners are not supported for session storage since it cannot be shared across windows
                return;
            }
        }
    ]);
    return BrowserSessionPersistence;
}($65b82078b3339b3f$var$BrowserPersistenceClass);
$65b82078b3339b3f$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ var $65b82078b3339b3f$export$407448d2b89b1813 = $65b82078b3339b3f$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $65b82078b3339b3f$var$_allSettled(promises) {
    return Promise.all(promises.map(function() {
        var _ref = (0, $9OZ9j._)(function(promise) {
            var value, reason;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            promise
                        ];
                    case 1:
                        value = _state.sent();
                        return [
                            2,
                            {
                                fulfilled: true,
                                value: value
                            }
                        ];
                    case 2:
                        reason = _state.sent();
                        return [
                            2,
                            {
                                fulfilled: false,
                                reason: reason
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(promise) {
            return _ref.apply(this, arguments);
        };
    }()));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ var $65b82078b3339b3f$var$Receiver = /*#__PURE__*/ function() {
    "use strict";
    function Receiver(eventTarget) {
        (0, $19mwo._)(this, Receiver);
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    (0, $6rpfc._)(Receiver, [
        {
            key: "isListeningto",
            value: function isListeningto(eventTarget) {
                return this.eventTarget === eventTarget;
            }
        },
        {
            key: "handleEvent",
            value: /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ function handleEvent(event) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var messageEvent, _messageEvent_data, eventId, eventType, data, handlers, promises, response;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                messageEvent = event;
                                _messageEvent_data = messageEvent.data, eventId = _messageEvent_data.eventId, eventType = _messageEvent_data.eventType, data = _messageEvent_data.data;
                                handlers = _this.handlersMap[eventType];
                                if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return [
                                    2
                                ];
                                messageEvent.ports[0].postMessage({
                                    status: "ack" /* _Status.ACK */ ,
                                    eventId: eventId,
                                    eventType: eventType
                                });
                                promises = Array.from(handlers).map(function() {
                                    var _ref = (0, $9OZ9j._)(function(handler) {
                                        return (0, $lF1I7.__generator)(this, function(_state) {
                                            return [
                                                2,
                                                handler(messageEvent.origin, data)
                                            ];
                                        });
                                    });
                                    return function(handler) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_allSettled(promises)
                                ];
                            case 1:
                                response = _state.sent();
                                messageEvent.ports[0].postMessage({
                                    status: "done" /* _Status.DONE */ ,
                                    eventId: eventId,
                                    eventType: eventType,
                                    response: response
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ key: "_subscribe",
            value: function _subscribe(eventType, eventHandler) {
                if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
                if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
                this.handlersMap[eventType].add(eventHandler);
            }
        },
        {
            /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ key: "_unsubscribe",
            value: function _unsubscribe(eventType, eventHandler) {
                if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
                if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
                if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
            }
        }
    ], [
        {
            key: "_getInstance",
            value: /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ function _getInstance(eventTarget) {
                // The results are stored in an array since objects can't be keys for other
                // objects. In addition, setting a unique property on an event target as a
                // hash map key may not be allowed due to CORS restrictions.
                var existingInstance = this.receivers.find(function(receiver) {
                    return receiver.isListeningto(eventTarget);
                });
                if (existingInstance) return existingInstance;
                var newInstance = new Receiver(eventTarget);
                this.receivers.push(newInstance);
                return newInstance;
            }
        }
    ]);
    return Receiver;
}();
$65b82078b3339b3f$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65b82078b3339b3f$export$faec65b429be379() {
    var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", digits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var random = "";
    for(var i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ var $65b82078b3339b3f$var$Sender = /*#__PURE__*/ function() {
    "use strict";
    function Sender(target) {
        (0, $19mwo._)(this, Sender);
        this.target = target;
        this.handlers = new Set();
    }
    (0, $6rpfc._)(Sender, [
        {
            /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ key: "removeMessageHandler",
            value: function removeMessageHandler(handler) {
                if (handler.messageChannel) {
                    handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
                    handler.messageChannel.port1.close();
                }
                this.handlers.delete(handler);
            }
        },
        {
            key: "_send",
            value: /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ function _send(eventType, data) {
                var timeout = arguments.length > 2 && arguments[2] !== void 0 /* _TimeoutDuration.ACK */  ? arguments[2] : 50;
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var messageChannel, completionTimer, handler;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
                        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var eventId = $65b82078b3339b3f$export$faec65b429be379("", 20);
                                messageChannel.port1.start();
                                var ackTimer = setTimeout(function() {
                                    reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
                                }, timeout);
                                handler = {
                                    messageChannel: messageChannel,
                                    onMessage: function(event) {
                                        var messageEvent = event;
                                        if (messageEvent.data.eventId !== eventId) return;
                                        switch(messageEvent.data.status){
                                            case "ack" /* _Status.ACK */ :
                                                // The receiver should ACK first.
                                                clearTimeout(ackTimer);
                                                completionTimer = setTimeout(function() {
                                                    reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                                                }, 3000 /* _TimeoutDuration.COMPLETION */ );
                                                break;
                                            case "done" /* _Status.DONE */ :
                                                // Once the receiver's handlers are finished we will get the results.
                                                clearTimeout(completionTimer);
                                                resolve(messageEvent.data.response);
                                                break;
                                            default:
                                                clearTimeout(ackTimer);
                                                clearTimeout(completionTimer);
                                                reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                                                break;
                                        }
                                    }
                                };
                                _this.handlers.add(handler);
                                messageChannel.port1.addEventListener("message", handler.onMessage);
                                _this.target.postMessage({
                                    eventType: eventType,
                                    eventId: eventId,
                                    data: data
                                }, [
                                    messageChannel.port2
                                ]);
                            }).finally(function() {
                                if (handler) _this.removeMessageHandler(handler);
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return Sender;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $65b82078b3339b3f$var$_window() {
    return window;
}
function $65b82078b3339b3f$var$_setWindowLocation(url) {
    $65b82078b3339b3f$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65b82078b3339b3f$var$_isWorker() {
    return typeof $65b82078b3339b3f$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $65b82078b3339b3f$var$_window()["importScripts"] === "function";
}
function $65b82078b3339b3f$var$_getActiveServiceWorker() {
    return $65b82078b3339b3f$var$__getActiveServiceWorker.apply(this, arguments);
}
function $65b82078b3339b3f$var$__getActiveServiceWorker() {
    $65b82078b3339b3f$var$__getActiveServiceWorker = (0, $9OZ9j._)(function() {
        var registration, _a;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return [
                        2,
                        null
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        navigator.serviceWorker.ready
                    ];
                case 2:
                    registration = _state.sent();
                    return [
                        2,
                        registration.active
                    ];
                case 3:
                    _a = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__getActiveServiceWorker.apply(this, arguments);
}
function $65b82078b3339b3f$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $65b82078b3339b3f$var$_getWorkerGlobalScope() {
    return $65b82078b3339b3f$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$DB_NAME = "firebaseLocalStorageDb";
var $65b82078b3339b3f$var$DB_VERSION = 1;
var $65b82078b3339b3f$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
var $65b82078b3339b3f$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ var $65b82078b3339b3f$var$DBPromise = /*#__PURE__*/ function() {
    "use strict";
    function DBPromise(request) {
        (0, $19mwo._)(this, DBPromise);
        this.request = request;
    }
    (0, $6rpfc._)(DBPromise, [
        {
            key: "toPromise",
            value: function toPromise() {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    _this.request.addEventListener("success", function() {
                        resolve(_this.request.result);
                    });
                    _this.request.addEventListener("error", function() {
                        reject(_this.request.error);
                    });
                });
            }
        }
    ]);
    return DBPromise;
}();
function $65b82078b3339b3f$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $65b82078b3339b3f$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($65b82078b3339b3f$var$DB_OBJECTSTORE_NAME);
}
function $65b82078b3339b3f$var$_deleteDatabase() {
    var request = indexedDB.deleteDatabase($65b82078b3339b3f$var$DB_NAME);
    return new $65b82078b3339b3f$var$DBPromise(request).toPromise();
}
function $65b82078b3339b3f$var$_openDatabase() {
    var request = indexedDB.open($65b82078b3339b3f$var$DB_NAME, $65b82078b3339b3f$var$DB_VERSION);
    return new Promise(function(resolve, reject) {
        request.addEventListener("error", function() {
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", function() {
            var db = request.result;
            try {
                db.createObjectStore($65b82078b3339b3f$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $65b82078b3339b3f$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", /*#__PURE__*/ (0, $9OZ9j._)(function() {
            var db;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        db = request.result;
                        if (!!db.objectStoreNames.contains($65b82078b3339b3f$var$DB_OBJECTSTORE_NAME)) return [
                            3,
                            3
                        ];
                        // Need to close the database or else you get a `blocked` event
                        db.close();
                        return [
                            4,
                            $65b82078b3339b3f$var$_deleteDatabase()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            $65b82078b3339b3f$var$_openDatabase()
                        ];
                    case 2:
                        resolve.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        resolve(db);
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }));
    });
}
function $65b82078b3339b3f$var$_putObject(db, key, value) {
    return $65b82078b3339b3f$var$__putObject.apply(this, arguments);
}
function $65b82078b3339b3f$var$__putObject() {
    $65b82078b3339b3f$var$__putObject = (0, $9OZ9j._)(function(db, key, value) {
        var _obj, request;
        return (0, $lF1I7.__generator)(this, function(_state) {
            request = $65b82078b3339b3f$var$getObjectStore(db, true).put((_obj = {}, (0, $c5rwh._)(_obj, $65b82078b3339b3f$var$DB_DATA_KEYPATH, key), (0, $c5rwh._)(_obj, "value", value), _obj));
            return [
                2,
                new $65b82078b3339b3f$var$DBPromise(request).toPromise()
            ];
        });
    });
    return $65b82078b3339b3f$var$__putObject.apply(this, arguments);
}
function $65b82078b3339b3f$var$getObject(db, key) {
    return $65b82078b3339b3f$var$_getObject.apply(this, arguments);
}
function $65b82078b3339b3f$var$_getObject() {
    $65b82078b3339b3f$var$_getObject = (0, $9OZ9j._)(function(db, key) {
        var request, data;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = $65b82078b3339b3f$var$getObjectStore(db, false).get(key);
                    return [
                        4,
                        new $65b82078b3339b3f$var$DBPromise(request).toPromise()
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data === undefined ? null : data.value
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_getObject.apply(this, arguments);
}
function $65b82078b3339b3f$var$_deleteObject(db, key) {
    var request = $65b82078b3339b3f$var$getObjectStore(db, true).delete(key);
    return new $65b82078b3339b3f$var$DBPromise(request).toPromise();
}
var $65b82078b3339b3f$var$_POLLING_INTERVAL_MS = 800;
var $65b82078b3339b3f$var$_TRANSACTION_RETRY_COUNT = 3;
var $65b82078b3339b3f$var$IndexedDBLocalPersistence = /*#__PURE__*/ function() {
    "use strict";
    function IndexedDBLocalPersistence() {
        (0, $19mwo._)(this, IndexedDBLocalPersistence);
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(function() {}, function() {});
    }
    (0, $6rpfc._)(IndexedDBLocalPersistence, [
        {
            key: "_openDb",
            value: function _openDb() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.db) return [
                                    2,
                                    _this.db
                                ];
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_openDatabase()
                                ];
                            case 1:
                                _this.db = _state.sent();
                                return [
                                    2,
                                    _this.db
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_withRetries",
            value: function _withRetries(op) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var numAttempts, db, e;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                numAttempts = 0;
                                _state.label = 1;
                            case 1:
                                if (!true) return [
                                    3,
                                    7
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    _this._openDb()
                                ];
                            case 3:
                                db = _state.sent();
                                return [
                                    4,
                                    op(db)
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                e = _state.sent();
                                if (numAttempts++ > $65b82078b3339b3f$var$_TRANSACTION_RETRY_COUNT) throw e;
                                if (_this.db) {
                                    _this.db.close();
                                    _this.db = undefined;
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    3,
                                    1
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initializeServiceWorkerMessaging",
            value: /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ function initializeServiceWorkerMessaging() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        return [
                            2,
                            $65b82078b3339b3f$var$_isWorker() ? _this.initializeReceiver() : _this.initializeSender()
                        ];
                    });
                })();
            }
        },
        {
            key: "initializeReceiver",
            value: /**
     * As the worker we should listen to events from the main window.
     */ function initializeReceiver() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        _this.receiver = $65b82078b3339b3f$var$Receiver._getInstance($65b82078b3339b3f$var$_getWorkerGlobalScope());
                        // Refresh from persistence if we receive a KeyChanged message.
                        _this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , function() {
                            var _ref = (0, $9OZ9j._)(function(_origin, data) {
                                var keys;
                                return (0, $lF1I7.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this._poll()
                                            ];
                                        case 1:
                                            keys = _state.sent();
                                            return [
                                                2,
                                                {
                                                    keyProcessed: keys.includes(data.key)
                                                }
                                            ];
                                    }
                                });
                            });
                            return function(_origin, data) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        // Let the sender know that we are listening so they give us more timeout.
                        _this.receiver._subscribe("ping" /* _EventType.PING */ , function() {
                            var _ref = (0, $9OZ9j._)(function(_origin, _data) {
                                return (0, $lF1I7.__generator)(this, function(_state) {
                                    return [
                                        2,
                                        [
                                            "keyChanged" /* _EventType.KEY_CHANGED */ 
                                        ]
                                    ];
                                });
                            });
                            return function(_origin, _data) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "initializeSender",
            value: /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ function initializeSender() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _a, _b, results;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_getActiveServiceWorker()
                                ];
                            case 1:
                                // Check to see if there's an active service worker.
                                _this.activeServiceWorker = _state.sent();
                                if (!_this.activeServiceWorker) return [
                                    2
                                ];
                                _this.sender = new $65b82078b3339b3f$var$Sender(_this.activeServiceWorker);
                                return [
                                    4,
                                    _this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ )
                                ];
                            case 2:
                                results = _state.sent();
                                if (!results) return [
                                    2
                                ];
                                if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) _this.serviceWorkerReceiverAvailable = true;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "notifyServiceWorker",
            value: /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ function notifyServiceWorker(key) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _a;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.sender || !_this.activeServiceWorker || $65b82078b3339b3f$var$_getServiceWorkerController() !== _this.activeServiceWorker) return [
                                    2
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                                        key: key
                                    }, // Use long timeout if receiver has previously responded to a ping from us.
                                    _this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ )
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _a = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_isAvailable",
            value: function _isAvailable() {
                return (0, $9OZ9j._)(function() {
                    var db, _a;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                if (!indexedDB) return [
                                    2,
                                    false
                                ];
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_openDatabase()
                                ];
                            case 1:
                                db = _state.sent();
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_putObject(db, $65b82078b3339b3f$var$STORAGE_AVAILABLE_KEY, "1")
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_deleteObject(db, $65b82078b3339b3f$var$STORAGE_AVAILABLE_KEY)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    true
                                ];
                            case 4:
                                _a = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_withPendingWrite",
            value: function _withPendingWrite(write) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.pendingWrites++;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                return [
                                    4,
                                    write()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _this.pendingWrites--;
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_set",
            value: function _set(key, value) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        return [
                            2,
                            _this._withPendingWrite(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                                return (0, $lF1I7.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this._withRetries(function(db) {
                                                    return $65b82078b3339b3f$var$_putObject(db, key, value);
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            _this.localCache[key] = value;
                                            return [
                                                2,
                                                _this.notifyServiceWorker(key)
                                            ];
                                    }
                                });
                            }))
                        ];
                    });
                })();
            }
        },
        {
            key: "_get",
            value: function _get(key) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var obj;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._withRetries(function(db) {
                                        return $65b82078b3339b3f$var$getObject(db, key);
                                    })
                                ];
                            case 1:
                                obj = _state.sent();
                                _this.localCache[key] = obj;
                                return [
                                    2,
                                    obj
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        return [
                            2,
                            _this._withPendingWrite(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                                return (0, $lF1I7.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this._withRetries(function(db) {
                                                    return $65b82078b3339b3f$var$_deleteObject(db, key);
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            delete _this.localCache[key];
                                            return [
                                                2,
                                                _this.notifyServiceWorker(key)
                                            ];
                                    }
                                });
                            }))
                        ];
                    });
                })();
            }
        },
        {
            key: "_poll",
            value: function _poll() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var result, keys, keysInResult, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, value, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, localKey;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._withRetries(function(db) {
                                        var getAllRequest = $65b82078b3339b3f$var$getObjectStore(db, false).getAll();
                                        return new $65b82078b3339b3f$var$DBPromise(getAllRequest).toPromise();
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                if (!result) return [
                                    2,
                                    []
                                ];
                                // If we have pending writes in progress abort, we'll get picked up on the next poll
                                if (_this.pendingWrites !== 0) return [
                                    2,
                                    []
                                ];
                                keys = [];
                                keysInResult = new Set();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (result.length !== 0) try {
                                    for(_iterator = result[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        _step_value = _step.value, key = _step_value.fbase_key, value = _step_value.value;
                                        keysInResult.add(key);
                                        if (JSON.stringify(_this.localCache[key]) !== JSON.stringify(value)) {
                                            _this.notifyListeners(key, value);
                                            keys.push(key);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = Object.keys(_this.localCache)[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        localKey = _step1.value;
                                        if (_this.localCache[localKey] && !keysInResult.has(localKey)) {
                                            // Deleted
                                            _this.notifyListeners(localKey, null);
                                            keys.push(localKey);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                return [
                                    2,
                                    keys
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "notifyListeners",
            value: function notifyListeners(key, newValue) {
                this.localCache[key] = newValue;
                var listeners = this.listeners[key];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (listeners) try {
                    for(var _iterator = Array.from(listeners)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener(newValue);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "startPolling",
            value: function startPolling() {
                this.stopPolling();
                var _this = this;
                this.pollTimer = setInterval(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        return [
                            2,
                            _this._poll()
                        ];
                    });
                }), $65b82078b3339b3f$var$_POLLING_INTERVAL_MS);
            }
        },
        {
            key: "stopPolling",
            value: function stopPolling() {
                if (this.pollTimer) {
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                }
            }
        },
        {
            key: "_addListener",
            value: function _addListener(key, listener) {
                if (Object.keys(this.listeners).length === 0) this.startPolling();
                if (!this.listeners[key]) {
                    this.listeners[key] = new Set();
                    // Populate the cache to avoid spuriously triggering on first poll.
                    this._get(key); // This can happen in the background async and we can return immediately.
                }
                this.listeners[key].add(listener);
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(key, listener) {
                if (this.listeners[key]) {
                    this.listeners[key].delete(listener);
                    if (this.listeners[key].size === 0) delete this.listeners[key];
                }
                if (Object.keys(this.listeners).length === 0) this.stopPolling();
            }
        }
    ]);
    return IndexedDBLocalPersistence;
}();
$65b82078b3339b3f$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ var $65b82078b3339b3f$export$23f2a1d2818174ef = $65b82078b3339b3f$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65b82078b3339b3f$var$startSignInPhoneMfa(auth, request) {
    return $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request));
}
function $65b82078b3339b3f$var$finalizeSignInPhoneMfa(auth, request) {
    return $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request));
}
function $65b82078b3339b3f$var$finalizeSignInTotpMfa(auth, request) {
    return $65b82078b3339b3f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $65b82078b3339b3f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$_SOLVE_TIME_MS = 500;
var $65b82078b3339b3f$var$_EXPIRATION_TIME_MS = 60000;
var $65b82078b3339b3f$var$_WIDGET_ID_START = 1000000000000;
var $65b82078b3339b3f$var$MockReCaptcha = /*#__PURE__*/ function() {
    "use strict";
    function MockReCaptcha(auth) {
        (0, $19mwo._)(this, MockReCaptcha);
        this.auth = auth;
        this.counter = $65b82078b3339b3f$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    (0, $6rpfc._)(MockReCaptcha, [
        {
            key: "render",
            value: function render(container, parameters) {
                var id = this.counter;
                this._widgets.set(id, new $65b82078b3339b3f$var$MockWidget(container, this.auth.name, parameters || {}));
                this.counter++;
                return id;
            }
        },
        {
            key: "reset",
            value: function reset(optWidgetId) {
                var _a;
                var id = optWidgetId || $65b82078b3339b3f$var$_WIDGET_ID_START;
                (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
                this._widgets.delete(id);
            }
        },
        {
            key: "getResponse",
            value: function getResponse(optWidgetId) {
                var _a;
                var id = optWidgetId || $65b82078b3339b3f$var$_WIDGET_ID_START;
                return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
            }
        },
        {
            key: "execute",
            value: function execute(optWidgetId) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _a, id;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        id = optWidgetId || $65b82078b3339b3f$var$_WIDGET_ID_START;
                        (_a = _this._widgets.get(id)) === null || _a === void 0 || _a.execute();
                        return [
                            2,
                            ""
                        ];
                    });
                })();
            }
        }
    ]);
    return MockReCaptcha;
}();
var $65b82078b3339b3f$var$MockWidget = /*#__PURE__*/ function() {
    "use strict";
    function MockWidget(containerOrId, appName, params) {
        var _this = this;
        (0, $19mwo._)(this, MockWidget);
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = function() {
            _this.execute();
        };
        var container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $65b82078b3339b3f$export$890c4ad488842ce7(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    (0, $6rpfc._)(MockWidget, [
        {
            key: "getResponse",
            value: function getResponse() {
                this.checkIfDeleted();
                return this.responseToken;
            }
        },
        {
            key: "delete",
            value: function _delete() {
                this.checkIfDeleted();
                this.deleted = true;
                if (this.timerId) {
                    clearTimeout(this.timerId);
                    this.timerId = null;
                }
                this.container.removeEventListener("click", this.clickHandler);
            }
        },
        {
            key: "execute",
            value: function execute() {
                var _this = this;
                this.checkIfDeleted();
                if (this.timerId) return;
                this.timerId = window.setTimeout(function() {
                    _this.responseToken = $65b82078b3339b3f$var$generateRandomAlphaNumericString(50);
                    var _this_params = _this.params, callback = _this_params.callback, expiredCallback = _this_params["expired-callback"];
                    if (callback) try {
                        callback(_this.responseToken);
                    } catch (e) {}
                    _this.timerId = window.setTimeout(function() {
                        _this.timerId = null;
                        _this.responseToken = null;
                        if (expiredCallback) try {
                            expiredCallback();
                        } catch (e) {}
                        if (_this.isVisible) _this.execute();
                    }, $65b82078b3339b3f$var$_EXPIRATION_TIME_MS);
                }, $65b82078b3339b3f$var$_SOLVE_TIME_MS);
            }
        },
        {
            key: "checkIfDeleted",
            value: function checkIfDeleted() {
                if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
            }
        }
    ]);
    return MockWidget;
}();
function $65b82078b3339b3f$var$generateRandomAlphaNumericString(len) {
    var chars = [];
    var allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(var i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
var $65b82078b3339b3f$var$_JSLOAD_CALLBACK = $65b82078b3339b3f$var$_generateCallbackName("rcb");
var $65b82078b3339b3f$var$NETWORK_TIMEOUT_DELAY = new $65b82078b3339b3f$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ var $65b82078b3339b3f$var$ReCaptchaLoaderImpl = /*#__PURE__*/ function() {
    "use strict";
    function ReCaptchaLoaderImpl() {
        (0, $19mwo._)(this, ReCaptchaLoaderImpl);
        var _a;
        this.hostLanguage = "";
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $65b82078b3339b3f$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    (0, $6rpfc._)(ReCaptchaLoaderImpl, [
        {
            key: "load",
            value: function load(auth) {
                var _this = this;
                var hl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                $65b82078b3339b3f$export$890c4ad488842ce7($65b82078b3339b3f$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                if (this.shouldResolveImmediately(hl) && $65b82078b3339b3f$var$isV2($65b82078b3339b3f$var$_window().grecaptcha)) return Promise.resolve($65b82078b3339b3f$var$_window().grecaptcha);
                return new Promise(function(resolve, reject) {
                    var networkTimeout = $65b82078b3339b3f$var$_window().setTimeout(function() {
                        reject($65b82078b3339b3f$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                    }, $65b82078b3339b3f$var$NETWORK_TIMEOUT_DELAY.get());
                    $65b82078b3339b3f$var$_window()[$65b82078b3339b3f$var$_JSLOAD_CALLBACK] = function() {
                        $65b82078b3339b3f$var$_window().clearTimeout(networkTimeout);
                        delete $65b82078b3339b3f$var$_window()[$65b82078b3339b3f$var$_JSLOAD_CALLBACK];
                        var recaptcha = $65b82078b3339b3f$var$_window().grecaptcha;
                        if (!recaptcha || !$65b82078b3339b3f$var$isV2(recaptcha)) {
                            reject($65b82078b3339b3f$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                            return;
                        }
                        // Wrap the greptcha render function so that we know if the developer has
                        // called it separately
                        var render = recaptcha.render;
                        recaptcha.render = function(container, params) {
                            var widgetId = render(container, params);
                            _this.counter++;
                            return widgetId;
                        };
                        _this.hostLanguage = hl;
                        resolve(recaptcha);
                    };
                    var url = "".concat($65b82078b3339b3f$var$_recaptchaV2ScriptUrl(), "?").concat((0, $gQ5gw.querystring)({
                        onload: $65b82078b3339b3f$var$_JSLOAD_CALLBACK,
                        render: "explicit",
                        hl: hl
                    }));
                    $65b82078b3339b3f$var$_loadJS(url).catch(function() {
                        clearTimeout(networkTimeout);
                        reject($65b82078b3339b3f$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    });
                });
            }
        },
        {
            key: "clearedOneInstance",
            value: function clearedOneInstance() {
                this.counter--;
            }
        },
        {
            key: "shouldResolveImmediately",
            value: function shouldResolveImmediately(hl) {
                var _a;
                // We can resolve immediately if:
                //   • grecaptcha is already defined AND (
                //     1. the requested language codes are the same OR
                //     2. there exists already a ReCaptcha on the page
                //     3. the library was already loaded by the app
                // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
                // that are already in the page
                return !!((_a = $65b82078b3339b3f$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
            }
        }
    ]);
    return ReCaptchaLoaderImpl;
}();
function $65b82078b3339b3f$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
var $65b82078b3339b3f$var$MockReCaptchaLoaderImpl = /*#__PURE__*/ function() {
    "use strict";
    function MockReCaptchaLoaderImpl() {
        (0, $19mwo._)(this, MockReCaptchaLoaderImpl);
    }
    (0, $6rpfc._)(MockReCaptchaLoaderImpl, [
        {
            key: "load",
            value: function load(auth) {
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        return [
                            2,
                            new $65b82078b3339b3f$var$MockReCaptcha(auth)
                        ];
                    });
                })();
            }
        },
        {
            key: "clearedOneInstance",
            value: function clearedOneInstance() {}
        }
    ]);
    return MockReCaptchaLoaderImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
var $65b82078b3339b3f$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ var $65b82078b3339b3f$export$db202ddc8be9136 = /*#__PURE__*/ function() {
    "use strict";
    function RecaptchaVerifier(authExtern, containerOrId) {
        var parameters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Object.assign({}, $65b82078b3339b3f$var$DEFAULT_PARAMS);
        (0, $19mwo._)(this, RecaptchaVerifier);
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $65b82078b3339b3f$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $65b82078b3339b3f$export$a05254e7c3aeba6e(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $65b82078b3339b3f$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        var container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $65b82078b3339b3f$export$890c4ad488842ce7(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $65b82078b3339b3f$var$MockReCaptchaLoaderImpl() : new $65b82078b3339b3f$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    }
    (0, $6rpfc._)(RecaptchaVerifier, [
        {
            key: "verify",
            value: /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ function verify() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var id, recaptcha, response;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.assertNotDestroyed();
                                return [
                                    4,
                                    _this.render()
                                ];
                            case 1:
                                id = _state.sent();
                                recaptcha = _this.getAssertedRecaptcha();
                                response = recaptcha.getResponse(id);
                                if (response) return [
                                    2,
                                    response
                                ];
                                return [
                                    2,
                                    new Promise(function(resolve) {
                                        var tokenChange = function(token) {
                                            if (!token) return; // Ignore token expirations.
                                            _this.tokenChangeListeners.delete(tokenChange);
                                            resolve(token);
                                        };
                                        _this.tokenChangeListeners.add(tokenChange);
                                        if (_this.isInvisible) recaptcha.execute(id);
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ key: "render",
            value: function render() {
                var _this = this;
                try {
                    this.assertNotDestroyed();
                } catch (e) {
                    // This method returns a promise. Since it's not async (we want to return the
                    // _same_ promise if rendering is still occurring), the API surface should
                    // reject with the error rather than just throw
                    return Promise.reject(e);
                }
                if (this.renderPromise) return this.renderPromise;
                this.renderPromise = this.makeRenderPromise().catch(function(e) {
                    _this.renderPromise = null;
                    throw e;
                });
                return this.renderPromise;
            }
        },
        {
            /** @internal */ key: "_reset",
            value: function _reset() {
                this.assertNotDestroyed();
                if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
            }
        },
        {
            /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ key: "clear",
            value: function clear() {
                var _this = this;
                this.assertNotDestroyed();
                this.destroyed = true;
                this._recaptchaLoader.clearedOneInstance();
                if (!this.isInvisible) this.container.childNodes.forEach(function(node) {
                    _this.container.removeChild(node);
                });
            }
        },
        {
            key: "validateStartingState",
            value: function validateStartingState() {
                $65b82078b3339b3f$export$890c4ad488842ce7(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                $65b82078b3339b3f$export$890c4ad488842ce7(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                $65b82078b3339b3f$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
            }
        },
        {
            key: "makeTokenCallback",
            value: function makeTokenCallback(existing) {
                var _this = this;
                return function(token) {
                    _this.tokenChangeListeners.forEach(function(listener) {
                        return listener(token);
                    });
                    if (typeof existing === "function") existing(token);
                    else if (typeof existing === "string") {
                        var globalFunc = $65b82078b3339b3f$var$_window()[existing];
                        if (typeof globalFunc === "function") globalFunc(token);
                    }
                };
            }
        },
        {
            key: "assertNotDestroyed",
            value: function assertNotDestroyed() {
                $65b82078b3339b3f$export$890c4ad488842ce7(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        },
        {
            key: "makeRenderPromise",
            value: function makeRenderPromise() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var container, guaranteedEmpty;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.init()
                                ];
                            case 1:
                                _state.sent();
                                if (!_this.widgetId) {
                                    container = _this.container;
                                    if (!_this.isInvisible) {
                                        guaranteedEmpty = document.createElement("div");
                                        container.appendChild(guaranteedEmpty);
                                        container = guaranteedEmpty;
                                    }
                                    _this.widgetId = _this.getAssertedRecaptcha().render(container, _this.parameters);
                                }
                                return [
                                    2,
                                    _this.widgetId
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var siteKey;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $65b82078b3339b3f$export$890c4ad488842ce7($65b82078b3339b3f$var$_isHttpOrHttps() && !$65b82078b3339b3f$var$_isWorker(), _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                return [
                                    4,
                                    $65b82078b3339b3f$var$domReady()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this._recaptchaLoader.load(_this.auth, _this.auth.languageCode || undefined)
                                ];
                            case 2:
                                _this.recaptcha = _state.sent();
                                return [
                                    4,
                                    $65b82078b3339b3f$var$getRecaptchaParams(_this.auth)
                                ];
                            case 3:
                                siteKey = _state.sent();
                                $65b82078b3339b3f$export$890c4ad488842ce7(siteKey, _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                _this.parameters.sitekey = siteKey;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAssertedRecaptcha",
            value: function getAssertedRecaptcha() {
                $65b82078b3339b3f$export$890c4ad488842ce7(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                return this.recaptcha;
            }
        }
    ]);
    return RecaptchaVerifier;
}();
function $65b82078b3339b3f$var$domReady() {
    var resolver = null;
    return new Promise(function(resolve) {
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = function() {
            return resolve();
        };
        window.addEventListener("load", resolver);
    }).catch(function(e) {
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$ConfirmationResultImpl = /*#__PURE__*/ function() {
    "use strict";
    function ConfirmationResultImpl(verificationId, onConfirmation) {
        (0, $19mwo._)(this, ConfirmationResultImpl);
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    (0, $6rpfc._)(ConfirmationResultImpl, [
        {
            key: "confirm",
            value: function confirm(verificationCode) {
                var authCredential = $65b82078b3339b3f$export$3722cfe417b6ed86._fromVerification(this.verificationId, verificationCode);
                return this.onConfirmation(authCredential);
            }
        }
    ]);
    return ConfirmationResultImpl;
}();
function $65b82078b3339b3f$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    return $65b82078b3339b3f$var$_signInWithPhoneNumber.apply(this, arguments);
}
function $65b82078b3339b3f$var$_signInWithPhoneNumber() {
    $65b82078b3339b3f$var$_signInWithPhoneNumber = /**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ (0, $9OZ9j._)(function(auth, phoneNumber, appVerifier) {
        var authInternal, verificationId;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ((0, $ilNGG._isFirebaseServerApp)(auth.app)) return [
                        2,
                        Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(auth))
                    ];
                    authInternal = $65b82078b3339b3f$export$a05254e7c3aeba6e(auth);
                    return [
                        4,
                        $65b82078b3339b3f$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $gQ5gw.getModularInstance)(appVerifier))
                    ];
                case 1:
                    verificationId = _state.sent();
                    return [
                        2,
                        new $65b82078b3339b3f$var$ConfirmationResultImpl(verificationId, function(cred) {
                            return $65b82078b3339b3f$export$3c2fa207a37baaea(authInternal, cred);
                        })
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_signInWithPhoneNumber.apply(this, arguments);
}
function $65b82078b3339b3f$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    return $65b82078b3339b3f$var$_linkWithPhoneNumber.apply(this, arguments);
}
function $65b82078b3339b3f$var$_linkWithPhoneNumber() {
    $65b82078b3339b3f$var$_linkWithPhoneNumber = /**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ (0, $9OZ9j._)(function(user, phoneNumber, appVerifier) {
        var userInternal, verificationId;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $gQ5gw.getModularInstance)(user);
                    return [
                        4,
                        $65b82078b3339b3f$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ )
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        $65b82078b3339b3f$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $gQ5gw.getModularInstance)(appVerifier))
                    ];
                case 2:
                    verificationId = _state.sent();
                    return [
                        2,
                        new $65b82078b3339b3f$var$ConfirmationResultImpl(verificationId, function(cred) {
                            return $65b82078b3339b3f$export$ce26c07117d59d6a(userInternal, cred);
                        })
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_linkWithPhoneNumber.apply(this, arguments);
}
function $65b82078b3339b3f$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    return $65b82078b3339b3f$var$_reauthenticateWithPhoneNumber.apply(this, arguments);
}
function $65b82078b3339b3f$var$_reauthenticateWithPhoneNumber() {
    $65b82078b3339b3f$var$_reauthenticateWithPhoneNumber = /**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ (0, $9OZ9j._)(function(user, phoneNumber, appVerifier) {
        var userInternal, verificationId;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $gQ5gw.getModularInstance)(user);
                    if ((0, $ilNGG._isFirebaseServerApp)(userInternal.auth.app)) return [
                        2,
                        Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth))
                    ];
                    return [
                        4,
                        $65b82078b3339b3f$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $gQ5gw.getModularInstance)(appVerifier))
                    ];
                case 1:
                    verificationId = _state.sent();
                    return [
                        2,
                        new $65b82078b3339b3f$var$ConfirmationResultImpl(verificationId, function(cred) {
                            return $65b82078b3339b3f$export$6559d589eb85fbb6(userInternal, cred);
                        })
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_reauthenticateWithPhoneNumber.apply(this, arguments);
}
function $65b82078b3339b3f$var$_verifyPhoneNumber(auth, options, verifier) {
    return $65b82078b3339b3f$var$__verifyPhoneNumber.apply(this, arguments);
}
function $65b82078b3339b3f$var$__verifyPhoneNumber() {
    $65b82078b3339b3f$var$__verifyPhoneNumber = /**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ (0, $9OZ9j._)(function(auth, options, verifier) {
        var _a, recaptchaToken, phoneInfoOptions, session, response, mfaEnrollmentId, response1, sessionInfo;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        verifier.verify()
                    ];
                case 1:
                    recaptchaToken = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        ,
                        10,
                        11
                    ]);
                    $65b82078b3339b3f$export$890c4ad488842ce7(typeof recaptchaToken === "string", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    $65b82078b3339b3f$export$890c4ad488842ce7(verifier.type === $65b82078b3339b3f$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    if (typeof options === "string") phoneInfoOptions = {
                        phoneNumber: options
                    };
                    else phoneInfoOptions = options;
                    if (!("session" in phoneInfoOptions)) return [
                        3,
                        7
                    ];
                    session = phoneInfoOptions.session;
                    if (!("phoneNumber" in phoneInfoOptions)) return [
                        3,
                        4
                    ];
                    $65b82078b3339b3f$export$890c4ad488842ce7(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return [
                        4,
                        $65b82078b3339b3f$var$startEnrollPhoneMfa(auth, {
                            idToken: session.credential,
                            phoneEnrollmentInfo: {
                                phoneNumber: phoneInfoOptions.phoneNumber,
                                recaptchaToken: recaptchaToken
                            }
                        })
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        2,
                        response.phoneSessionInfo.sessionInfo
                    ];
                case 4:
                    $65b82078b3339b3f$export$890c4ad488842ce7(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                    $65b82078b3339b3f$export$890c4ad488842ce7(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                    return [
                        4,
                        $65b82078b3339b3f$var$startSignInPhoneMfa(auth, {
                            mfaPendingCredential: session.credential,
                            mfaEnrollmentId: mfaEnrollmentId,
                            phoneSignInInfo: {
                                recaptchaToken: recaptchaToken
                            }
                        })
                    ];
                case 5:
                    response1 = _state.sent();
                    return [
                        2,
                        response1.phoneResponseInfo.sessionInfo
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        $65b82078b3339b3f$var$sendPhoneVerificationCode(auth, {
                            phoneNumber: phoneInfoOptions.phoneNumber,
                            recaptchaToken: recaptchaToken
                        })
                    ];
                case 8:
                    sessionInfo = _state.sent().sessionInfo;
                    return [
                        2,
                        sessionInfo
                    ];
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    verifier._reset();
                    return [
                        7
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__verifyPhoneNumber.apply(this, arguments);
}
function $65b82078b3339b3f$export$3b14a55fb2447963(user, credential) {
    return $65b82078b3339b3f$var$_updatePhoneNumber.apply(this, arguments);
}
function $65b82078b3339b3f$var$_updatePhoneNumber() {
    $65b82078b3339b3f$var$_updatePhoneNumber = /**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ (0, $9OZ9j._)(function(user, credential) {
        var userInternal;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $gQ5gw.getModularInstance)(user);
                    if ((0, $ilNGG._isFirebaseServerApp)(userInternal.auth.app)) return [
                        2,
                        Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth))
                    ];
                    return [
                        4,
                        $65b82078b3339b3f$var$_link$1(userInternal, credential)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_updatePhoneNumber.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ var $65b82078b3339b3f$export$56c0d5a1e737357d = /*#__PURE__*/ function() {
    "use strict";
    function PhoneAuthProvider(auth) {
        (0, $19mwo._)(this, PhoneAuthProvider);
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = PhoneAuthProvider.PROVIDER_ID;
        this.auth = $65b82078b3339b3f$export$a05254e7c3aeba6e(auth);
    }
    (0, $6rpfc._)(PhoneAuthProvider, [
        {
            /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ key: "verifyPhoneNumber",
            value: function verifyPhoneNumber(phoneOptions, applicationVerifier) {
                return $65b82078b3339b3f$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $gQ5gw.getModularInstance)(applicationVerifier));
            }
        }
    ], [
        {
            key: "credential",
            value: /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ function credential(verificationId, verificationCode) {
                return $65b82078b3339b3f$export$3722cfe417b6ed86._fromVerification(verificationId, verificationCode);
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                var credential = userCredential;
                return PhoneAuthProvider.credentialFromTaggedObject(credential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ function credentialFromError(error) {
                return PhoneAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var phoneNumber = tokenResponse.phoneNumber, temporaryProof = tokenResponse.temporaryProof;
                if (phoneNumber && temporaryProof) return $65b82078b3339b3f$export$3722cfe417b6ed86._fromTokenResponse(phoneNumber, temporaryProof);
                return null;
            }
        }
    ]);
    return PhoneAuthProvider;
}();
/** Always set to {@link ProviderId}.PHONE. */ $65b82078b3339b3f$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $65b82078b3339b3f$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $65b82078b3339b3f$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $65b82078b3339b3f$export$158acd800e1ef08b(resolverOverride);
    $65b82078b3339b3f$export$890c4ad488842ce7(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$IdpCredential = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $iNfU4._)(IdpCredential, AuthCredential);
    var _super = (0, $k1NN5._)(IdpCredential);
    function IdpCredential(params) {
        (0, $19mwo._)(this, IdpCredential);
        var _this;
        _this = _super.call(this, "custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        _this.params = params;
        return _this;
    }
    (0, $6rpfc._)(IdpCredential, [
        {
            key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                return $65b82078b3339b3f$var$signInWithIdp(auth, this._buildIdpRequest());
            }
        },
        {
            key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                return $65b82078b3339b3f$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
            }
        },
        {
            key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                return $65b82078b3339b3f$var$signInWithIdp(auth, this._buildIdpRequest());
            }
        },
        {
            key: "_buildIdpRequest",
            value: function _buildIdpRequest(idToken) {
                var request = {
                    requestUri: this.params.requestUri,
                    sessionId: this.params.sessionId,
                    postBody: this.params.postBody,
                    tenantId: this.params.tenantId,
                    pendingToken: this.params.pendingToken,
                    returnSecureToken: true,
                    returnIdpCredential: true
                };
                if (idToken) request.idToken = idToken;
                return request;
            }
        }
    ]);
    return IdpCredential;
}($65b82078b3339b3f$export$61196ced6d74a310);
function $65b82078b3339b3f$var$_signIn(params) {
    return $65b82078b3339b3f$var$_signInWithCredential(params.auth, new $65b82078b3339b3f$var$IdpCredential(params), params.bypassAuthState);
}
function $65b82078b3339b3f$var$_reauth(params) {
    var auth = params.auth, user = params.user;
    $65b82078b3339b3f$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $65b82078b3339b3f$var$_reauthenticate(user, new $65b82078b3339b3f$var$IdpCredential(params), params.bypassAuthState);
}
function $65b82078b3339b3f$var$_link(params) {
    return $65b82078b3339b3f$var$__link.apply(this, arguments);
}
function $65b82078b3339b3f$var$__link() {
    $65b82078b3339b3f$var$__link = (0, $9OZ9j._)(function(params) {
        var auth, user;
        return (0, $lF1I7.__generator)(this, function(_state) {
            auth = params.auth, user = params.user;
            $65b82078b3339b3f$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            return [
                2,
                $65b82078b3339b3f$var$_link$1(user, new $65b82078b3339b3f$var$IdpCredential(params), params.bypassAuthState)
            ];
        });
    });
    return $65b82078b3339b3f$var$__link.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ var $65b82078b3339b3f$var$AbstractPopupRedirectOperation = /*#__PURE__*/ function() {
    "use strict";
    function AbstractPopupRedirectOperation(auth, filter, resolver, user) {
        var bypassAuthState = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        (0, $19mwo._)(this, AbstractPopupRedirectOperation);
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    (0, $6rpfc._)(AbstractPopupRedirectOperation, [
        {
            key: "execute",
            value: function execute() {
                var _this = this;
                return new Promise(function() {
                    var _ref = (0, $9OZ9j._)(function(resolve, reject) {
                        var e;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this.pendingPromise = {
                                        resolve: resolve,
                                        reject: reject
                                    };
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        4,
                                        ,
                                        5
                                    ]);
                                    return [
                                        4,
                                        _this.resolver._initialize(_this.auth)
                                    ];
                                case 2:
                                    _this.eventManager = _state.sent();
                                    return [
                                        4,
                                        _this.onExecution()
                                    ];
                                case 3:
                                    _state.sent();
                                    _this.eventManager.registerConsumer(_this);
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    e = _state.sent();
                                    _this.reject(e);
                                    return [
                                        3,
                                        5
                                    ];
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(resolve, reject) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "onAuthEvent",
            value: function onAuthEvent(event) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var urlResponse, sessionId, postBody, tenantId, error, type, params, _, e;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                urlResponse = event.urlResponse, sessionId = event.sessionId, postBody = event.postBody, tenantId = event.tenantId, error = event.error, type = event.type;
                                if (error) {
                                    _this.reject(error);
                                    return [
                                        2
                                    ];
                                }
                                params = {
                                    auth: _this.auth,
                                    requestUri: urlResponse,
                                    sessionId: sessionId,
                                    tenantId: tenantId || undefined,
                                    postBody: postBody || undefined,
                                    user: _this.user,
                                    bypassAuthState: _this.bypassAuthState
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _ = _this.resolve;
                                return [
                                    4,
                                    _this.getIdpTask(type)(params)
                                ];
                            case 2:
                                _.apply(_this, [
                                    _state.sent()
                                ]);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                _this.reject(e);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onError",
            value: function onError(error) {
                this.reject(error);
            }
        },
        {
            key: "getIdpTask",
            value: function getIdpTask(type) {
                switch(type){
                    case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
                    case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                        return $65b82078b3339b3f$var$_signIn;
                    case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
                    case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                        return $65b82078b3339b3f$var$_link;
                    case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
                    case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                        return $65b82078b3339b3f$var$_reauth;
                    default:
                        $65b82078b3339b3f$export$9fa96a7d116ea3ce(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                }
            }
        },
        {
            key: "resolve",
            value: function resolve(cred) {
                $65b82078b3339b3f$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
                this.pendingPromise.resolve(cred);
                this.unregisterAndCleanUp();
            }
        },
        {
            key: "reject",
            value: function reject(error) {
                $65b82078b3339b3f$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
                this.pendingPromise.reject(error);
                this.unregisterAndCleanUp();
            }
        },
        {
            key: "unregisterAndCleanUp",
            value: function unregisterAndCleanUp() {
                if (this.eventManager) this.eventManager.unregisterConsumer(this);
                this.pendingPromise = null;
                this.cleanUp();
            }
        }
    ]);
    return AbstractPopupRedirectOperation;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $65b82078b3339b3f$var$Delay(2000, 10000);
function $65b82078b3339b3f$export$db3b6bfb95261072(auth, provider, resolver) {
    return $65b82078b3339b3f$var$_signInWithPopup.apply(this, arguments);
}
function $65b82078b3339b3f$var$_signInWithPopup() {
    $65b82078b3339b3f$var$_signInWithPopup = /**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $9OZ9j._)(function(auth, provider, resolver) {
        var authInternal, resolverInternal, action;
        return (0, $lF1I7.__generator)(this, function(_state) {
            if ((0, $ilNGG._isFirebaseServerApp)(auth.app)) return [
                2,
                Promise.reject($65b82078b3339b3f$export$9d398bebfec1c039(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ))
            ];
            authInternal = $65b82078b3339b3f$export$a05254e7c3aeba6e(auth);
            $65b82078b3339b3f$var$_assertInstanceOf(auth, provider, $65b82078b3339b3f$var$FederatedAuthProvider);
            resolverInternal = $65b82078b3339b3f$var$_withDefaultResolver(authInternal, resolver);
            action = new $65b82078b3339b3f$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
            return [
                2,
                action.executeNotNull()
            ];
        });
    });
    return $65b82078b3339b3f$var$_signInWithPopup.apply(this, arguments);
}
function $65b82078b3339b3f$export$f1e1789686576879(user, provider, resolver) {
    return $65b82078b3339b3f$var$_reauthenticateWithPopup.apply(this, arguments);
}
function $65b82078b3339b3f$var$_reauthenticateWithPopup() {
    $65b82078b3339b3f$var$_reauthenticateWithPopup = /**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $9OZ9j._)(function(user, provider, resolver) {
        var userInternal, resolverInternal, action;
        return (0, $lF1I7.__generator)(this, function(_state) {
            userInternal = (0, $gQ5gw.getModularInstance)(user);
            if ((0, $ilNGG._isFirebaseServerApp)(userInternal.auth.app)) return [
                2,
                Promise.reject($65b82078b3339b3f$export$9d398bebfec1c039(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ))
            ];
            $65b82078b3339b3f$var$_assertInstanceOf(userInternal.auth, provider, $65b82078b3339b3f$var$FederatedAuthProvider);
            resolverInternal = $65b82078b3339b3f$var$_withDefaultResolver(userInternal.auth, resolver);
            action = new $65b82078b3339b3f$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
            return [
                2,
                action.executeNotNull()
            ];
        });
    });
    return $65b82078b3339b3f$var$_reauthenticateWithPopup.apply(this, arguments);
}
function $65b82078b3339b3f$export$4368d992c4eafac0(user, provider, resolver) {
    return $65b82078b3339b3f$var$_linkWithPopup.apply(this, arguments);
}
function $65b82078b3339b3f$var$_linkWithPopup() {
    $65b82078b3339b3f$var$_linkWithPopup = /**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $9OZ9j._)(function(user, provider, resolver) {
        var userInternal, resolverInternal, action;
        return (0, $lF1I7.__generator)(this, function(_state) {
            userInternal = (0, $gQ5gw.getModularInstance)(user);
            $65b82078b3339b3f$var$_assertInstanceOf(userInternal.auth, provider, $65b82078b3339b3f$var$FederatedAuthProvider);
            resolverInternal = $65b82078b3339b3f$var$_withDefaultResolver(userInternal.auth, resolver);
            action = new $65b82078b3339b3f$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
            return [
                2,
                action.executeNotNull()
            ];
        });
    });
    return $65b82078b3339b3f$var$_linkWithPopup.apply(this, arguments);
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ var $65b82078b3339b3f$var$PopupOperation = /*#__PURE__*/ function(AbstractPopupRedirectOperation) {
    "use strict";
    (0, $iNfU4._)(PopupOperation, AbstractPopupRedirectOperation);
    var _super = (0, $k1NN5._)(PopupOperation);
    function PopupOperation(auth, filter, provider, resolver, user) {
        (0, $19mwo._)(this, PopupOperation);
        var _this;
        _this = _super.call(this, auth, filter, resolver, user);
        _this.provider = provider;
        _this.authWindow = null;
        _this.pollId = null;
        if (PopupOperation.currentPopupAction) PopupOperation.currentPopupAction.cancel();
        PopupOperation.currentPopupAction = (0, $15Pju._)(_this);
        return _this;
    }
    (0, $6rpfc._)(PopupOperation, [
        {
            key: "executeNotNull",
            value: function executeNotNull() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var result;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.execute()
                                ];
                            case 1:
                                result = _state.sent();
                                $65b82078b3339b3f$export$890c4ad488842ce7(result, _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onExecution",
            value: function onExecution() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var eventId;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $65b82078b3339b3f$export$1fbe638ecf81657e(_this.filter.length === 1, "Popup operations only handle one event");
                                eventId = $65b82078b3339b3f$export$faec65b429be379();
                                return [
                                    4,
                                    _this.resolver._openPopup(_this.auth, _this.provider, _this.filter[0], eventId)
                                ];
                            case 1:
                                _this.authWindow = _state.sent();
                                _this.authWindow.associatedEvent = eventId;
                                // Check for web storage support and origin validation _after_ the popup is
                                // loaded. These operations are slow (~1 second or so) Rather than
                                // waiting on them before opening the window, optimistically open the popup
                                // and check for storage support at the same time. If storage support is
                                // not available, this will cause the whole thing to reject properly. It
                                // will also close the popup, but since the promise has already rejected,
                                // the popup closed by user poll will reject into the void.
                                _this.resolver._originValidation(_this.auth).catch(function(e) {
                                    _this.reject(e);
                                });
                                _this.resolver._isIframeWebStorageSupported(_this.auth, function(isSupported) {
                                    if (!isSupported) _this.reject($65b82078b3339b3f$export$9d398bebfec1c039(_this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
                                });
                                // Handle user closure. Notice this does *not* use await
                                _this.pollUserCancellation();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "eventId",
            get: function get() {
                var _a;
                return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                this.reject($65b82078b3339b3f$export$9d398bebfec1c039(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
            }
        },
        {
            key: "cleanUp",
            value: function cleanUp() {
                if (this.authWindow) this.authWindow.close();
                if (this.pollId) window.clearTimeout(this.pollId);
                this.authWindow = null;
                this.pollId = null;
                PopupOperation.currentPopupAction = null;
            }
        },
        {
            key: "pollUserCancellation",
            value: function pollUserCancellation() {
                var _this = this;
                var poll = function() {
                    var _a, _b;
                    if ((_b = (_a = _this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                        // Make sure that there is sufficient time for whatever action to
                        // complete. The window could have closed but the sign in network
                        // call could still be in flight. This is specifically true for
                        // Firefox or if the opener is in an iframe, in which case the oauth
                        // helper closes the popup.
                        _this.pollId = window.setTimeout(function() {
                            _this.pollId = null;
                            _this.reject($65b82078b3339b3f$export$9d398bebfec1c039(_this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                        }, 8000 /* _Timeout.AUTH_EVENT */ );
                        return;
                    }
                    _this.pollId = window.setTimeout(poll, $65b82078b3339b3f$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
                };
                poll();
            }
        }
    ]);
    return PopupOperation;
}($65b82078b3339b3f$var$AbstractPopupRedirectOperation);
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$65b82078b3339b3f$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
var $65b82078b3339b3f$var$redirectOutcomeMap = new Map();
var $65b82078b3339b3f$var$RedirectAction = /*#__PURE__*/ function(AbstractPopupRedirectOperation) {
    "use strict";
    (0, $iNfU4._)(RedirectAction, AbstractPopupRedirectOperation);
    var _super = (0, $k1NN5._)(RedirectAction);
    function RedirectAction(auth, resolver) {
        var bypassAuthState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        (0, $19mwo._)(this, RedirectAction);
        var _this;
        _this = _super.call(this, auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        _this.eventId = null;
        return _this;
    }
    (0, $6rpfc._)(RedirectAction, [
        {
            key: "execute",
            value: /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ function execute() {
                var _this = this;
                var _this1 = this, _superprop_get_execute = function() {
                    return (0, $jLCbM._)((0, $laF8D._)(RedirectAction.prototype), "execute", _this);
                };
                return (0, $9OZ9j._)(function() {
                    var readyOutcome, hasPendingRedirect, result, _tmp, e;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                readyOutcome = $65b82078b3339b3f$var$redirectOutcomeMap.get(_this1.auth._key());
                                if (!!readyOutcome) return [
                                    3,
                                    8
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_getAndClearPendingRedirectStatus(_this1.resolver, _this1.auth)
                                ];
                            case 2:
                                hasPendingRedirect = _state.sent();
                                if (!hasPendingRedirect) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _superprop_get_execute().call(_this1)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _tmp = null;
                                _state.label = 5;
                            case 5:
                                result = _tmp;
                                readyOutcome = function() {
                                    return Promise.resolve(result);
                                };
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                readyOutcome = function() {
                                    return Promise.reject(e);
                                };
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                $65b82078b3339b3f$var$redirectOutcomeMap.set(_this1.auth._key(), readyOutcome);
                                _state.label = 8;
                            case 8:
                                // If we're not bypassing auth state, the ready outcome should be set to
                                // null.
                                if (!_this1.bypassAuthState) $65b82078b3339b3f$var$redirectOutcomeMap.set(_this1.auth._key(), function() {
                                    return Promise.resolve(null);
                                });
                                return [
                                    2,
                                    readyOutcome()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onAuthEvent",
            value: function onAuthEvent(event) {
                var _this = this;
                var _this1 = this, _superprop_get_onAuthEvent = function() {
                    return (0, $jLCbM._)((0, $laF8D._)(RedirectAction.prototype), "onAuthEvent", _this);
                };
                return (0, $9OZ9j._)(function() {
                    var user;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return [
                                    2,
                                    _superprop_get_onAuthEvent().call(_this1, event)
                                ];
                                else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
                                    // This is a sentinel value indicating there's no pending redirect
                                    _this1.resolve(null);
                                    return [
                                        2
                                    ];
                                }
                                if (!event.eventId) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this1.auth._redirectUserForId(event.eventId)
                                ];
                            case 1:
                                user = _state.sent();
                                if (user) {
                                    _this1.user = user;
                                    return [
                                        2,
                                        _superprop_get_onAuthEvent().call(_this1, event)
                                    ];
                                } else _this1.resolve(null);
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onExecution",
            value: function onExecution() {
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "cleanUp",
            value: function cleanUp() {}
        }
    ]);
    return RedirectAction;
}($65b82078b3339b3f$var$AbstractPopupRedirectOperation);
function $65b82078b3339b3f$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    return $65b82078b3339b3f$var$__getAndClearPendingRedirectStatus.apply(this, arguments);
}
function $65b82078b3339b3f$var$__getAndClearPendingRedirectStatus() {
    $65b82078b3339b3f$var$__getAndClearPendingRedirectStatus = (0, $9OZ9j._)(function(resolver, auth) {
        var key, persistence, hasPendingRedirect;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    key = $65b82078b3339b3f$var$pendingRedirectKey(auth);
                    persistence = $65b82078b3339b3f$var$resolverPersistence(resolver);
                    return [
                        4,
                        persistence._isAvailable()
                    ];
                case 1:
                    if (!_state.sent()) return [
                        2,
                        false
                    ];
                    return [
                        4,
                        persistence._get(key)
                    ];
                case 2:
                    hasPendingRedirect = _state.sent() === "true";
                    return [
                        4,
                        persistence._remove(key)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        hasPendingRedirect
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__getAndClearPendingRedirectStatus.apply(this, arguments);
}
function $65b82078b3339b3f$var$_setPendingRedirectStatus(resolver, auth) {
    return $65b82078b3339b3f$var$__setPendingRedirectStatus.apply(this, arguments);
}
function $65b82078b3339b3f$var$__setPendingRedirectStatus() {
    $65b82078b3339b3f$var$__setPendingRedirectStatus = (0, $9OZ9j._)(function(resolver, auth) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                $65b82078b3339b3f$var$resolverPersistence(resolver)._set($65b82078b3339b3f$var$pendingRedirectKey(auth), "true")
            ];
        });
    });
    return $65b82078b3339b3f$var$__setPendingRedirectStatus.apply(this, arguments);
}
function $65b82078b3339b3f$export$b9a6b53f9be3734() {
    $65b82078b3339b3f$var$redirectOutcomeMap.clear();
}
function $65b82078b3339b3f$export$a33b77bbdbb8366c(auth, result) {
    $65b82078b3339b3f$var$redirectOutcomeMap.set(auth._key(), result);
}
function $65b82078b3339b3f$var$resolverPersistence(resolver) {
    return $65b82078b3339b3f$export$158acd800e1ef08b(resolver._redirectPersistence);
}
function $65b82078b3339b3f$var$pendingRedirectKey(auth) {
    return $65b82078b3339b3f$export$cf2f7c5792f80b46($65b82078b3339b3f$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $65b82078b3339b3f$export$2d1720544b23b823(auth, provider, resolver) {
    return $65b82078b3339b3f$var$_signInWithRedirect(auth, provider, resolver);
}
function $65b82078b3339b3f$var$_signInWithRedirect(auth, provider, resolver) {
    return $65b82078b3339b3f$var$__signInWithRedirect.apply(this, arguments);
}
function $65b82078b3339b3f$var$__signInWithRedirect() {
    $65b82078b3339b3f$var$__signInWithRedirect = (0, $9OZ9j._)(function(auth, provider, resolver) {
        var authInternal, resolverInternal;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ((0, $ilNGG._isFirebaseServerApp)(auth.app)) return [
                        2,
                        Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(auth))
                    ];
                    authInternal = $65b82078b3339b3f$export$a05254e7c3aeba6e(auth);
                    $65b82078b3339b3f$var$_assertInstanceOf(auth, provider, $65b82078b3339b3f$var$FederatedAuthProvider);
                    // Wait for auth initialization to complete, this will process pending redirects and clear the
                    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
                    // redirect and creating a PENDING_REDIRECT_KEY entry.
                    return [
                        4,
                        authInternal._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    resolverInternal = $65b82078b3339b3f$var$_withDefaultResolver(authInternal, resolver);
                    return [
                        4,
                        $65b82078b3339b3f$var$_setPendingRedirectStatus(resolverInternal, authInternal)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ )
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__signInWithRedirect.apply(this, arguments);
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $65b82078b3339b3f$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $65b82078b3339b3f$var$_reauthenticateWithRedirect(user, provider, resolver);
}
function $65b82078b3339b3f$var$_reauthenticateWithRedirect(user, provider, resolver) {
    return $65b82078b3339b3f$var$__reauthenticateWithRedirect.apply(this, arguments);
}
function $65b82078b3339b3f$var$__reauthenticateWithRedirect() {
    $65b82078b3339b3f$var$__reauthenticateWithRedirect = (0, $9OZ9j._)(function(user, provider, resolver) {
        var userInternal, resolverInternal, eventId;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $gQ5gw.getModularInstance)(user);
                    $65b82078b3339b3f$var$_assertInstanceOf(userInternal.auth, provider, $65b82078b3339b3f$var$FederatedAuthProvider);
                    if ((0, $ilNGG._isFirebaseServerApp)(userInternal.auth.app)) return [
                        2,
                        Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth))
                    ];
                    // Wait for auth initialization to complete, this will process pending redirects and clear the
                    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
                    // redirect and creating a PENDING_REDIRECT_KEY entry.
                    return [
                        4,
                        userInternal.auth._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    // Allow the resolver to error before persisting the redirect user
                    resolverInternal = $65b82078b3339b3f$var$_withDefaultResolver(userInternal.auth, resolver);
                    return [
                        4,
                        $65b82078b3339b3f$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        $65b82078b3339b3f$var$prepareUserForRedirect(userInternal)
                    ];
                case 3:
                    eventId = _state.sent();
                    return [
                        2,
                        resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId)
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__reauthenticateWithRedirect.apply(this, arguments);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $65b82078b3339b3f$export$39b482c5e57630a8(user, provider, resolver) {
    return $65b82078b3339b3f$var$_linkWithRedirect(user, provider, resolver);
}
function $65b82078b3339b3f$var$_linkWithRedirect(user, provider, resolver) {
    return $65b82078b3339b3f$var$__linkWithRedirect.apply(this, arguments);
}
function $65b82078b3339b3f$var$__linkWithRedirect() {
    $65b82078b3339b3f$var$__linkWithRedirect = (0, $9OZ9j._)(function(user, provider, resolver) {
        var userInternal, resolverInternal, eventId;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $gQ5gw.getModularInstance)(user);
                    $65b82078b3339b3f$var$_assertInstanceOf(userInternal.auth, provider, $65b82078b3339b3f$var$FederatedAuthProvider);
                    // Wait for auth initialization to complete, this will process pending redirects and clear the
                    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
                    // redirect and creating a PENDING_REDIRECT_KEY entry.
                    return [
                        4,
                        userInternal.auth._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    // Allow the resolver to error before persisting the redirect user
                    resolverInternal = $65b82078b3339b3f$var$_withDefaultResolver(userInternal.auth, resolver);
                    return [
                        4,
                        $65b82078b3339b3f$var$_assertLinkedStatus(false, userInternal, provider.providerId)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        $65b82078b3339b3f$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth)
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        $65b82078b3339b3f$var$prepareUserForRedirect(userInternal)
                    ];
                case 4:
                    eventId = _state.sent();
                    return [
                        2,
                        resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId)
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__linkWithRedirect.apply(this, arguments);
}
function $65b82078b3339b3f$export$35e795649ee09318(auth, resolver) {
    return $65b82078b3339b3f$var$_getRedirectResult.apply(this, arguments);
}
function $65b82078b3339b3f$var$_getRedirectResult() {
    $65b82078b3339b3f$var$_getRedirectResult = /**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $9OZ9j._)(function(auth, resolver) {
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65b82078b3339b3f$export$a05254e7c3aeba6e(auth)._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        $65b82078b3339b3f$export$53a70dd1ebbae346(auth, resolver, false)
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_getRedirectResult.apply(this, arguments);
}
function $65b82078b3339b3f$export$53a70dd1ebbae346(auth, resolverExtern) {
    return $65b82078b3339b3f$var$__getRedirectResult.apply(this, arguments);
}
function $65b82078b3339b3f$var$__getRedirectResult() {
    $65b82078b3339b3f$var$__getRedirectResult = (0, $9OZ9j._)(function(auth, resolverExtern) {
        var bypassAuthState, authInternal, resolver, action, result;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    if ((0, $ilNGG._isFirebaseServerApp)(auth.app)) return [
                        2,
                        Promise.reject($65b82078b3339b3f$var$_serverAppCurrentUserOperationNotSupportedError(auth))
                    ];
                    authInternal = $65b82078b3339b3f$export$a05254e7c3aeba6e(auth);
                    resolver = $65b82078b3339b3f$var$_withDefaultResolver(authInternal, resolverExtern);
                    action = new $65b82078b3339b3f$var$RedirectAction(authInternal, resolver, bypassAuthState);
                    return [
                        4,
                        action.execute()
                    ];
                case 1:
                    result = _state.sent();
                    if (!(result && !bypassAuthState)) return [
                        3,
                        4
                    ];
                    delete result.user._redirectEventId;
                    return [
                        4,
                        authInternal._persistUserIfCurrent(result.user)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        authInternal._setRedirectUser(null, resolverExtern)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__getRedirectResult.apply(this, arguments);
}
function $65b82078b3339b3f$var$prepareUserForRedirect(user) {
    return $65b82078b3339b3f$var$_prepareUserForRedirect.apply(this, arguments);
}
function $65b82078b3339b3f$var$_prepareUserForRedirect() {
    $65b82078b3339b3f$var$_prepareUserForRedirect = (0, $9OZ9j._)(function(user) {
        var eventId;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    eventId = $65b82078b3339b3f$export$faec65b429be379("".concat(user.uid, ":::"));
                    user._redirectEventId = eventId;
                    return [
                        4,
                        user.auth._setRedirectUser(user)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        user.auth._persistUserIfCurrent(user)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        eventId
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$_prepareUserForRedirect.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
var $65b82078b3339b3f$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
var $65b82078b3339b3f$export$24baa2b76016ce0e = /*#__PURE__*/ function() {
    "use strict";
    function AuthEventManager(auth) {
        (0, $19mwo._)(this, AuthEventManager);
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    (0, $6rpfc._)(AuthEventManager, [
        {
            key: "registerConsumer",
            value: function registerConsumer(authEventConsumer) {
                this.consumers.add(authEventConsumer);
                if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
                    this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
                    this.saveEventToCache(this.queuedRedirectEvent);
                    this.queuedRedirectEvent = null;
                }
            }
        },
        {
            key: "unregisterConsumer",
            value: function unregisterConsumer(authEventConsumer) {
                this.consumers.delete(authEventConsumer);
            }
        },
        {
            key: "onEvent",
            value: function onEvent(event) {
                var _this = this;
                // Check if the event has already been handled
                if (this.hasEventBeenHandled(event)) return false;
                var handled = false;
                this.consumers.forEach(function(consumer) {
                    if (_this.isEventForConsumer(event, consumer)) {
                        handled = true;
                        _this.sendToConsumer(event, consumer);
                        _this.saveEventToCache(event);
                    }
                });
                if (this.hasHandledPotentialRedirect || !$65b82078b3339b3f$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
                // bail now
                return handled;
                this.hasHandledPotentialRedirect = true;
                // If the redirect wasn't handled, hang on to it
                if (!handled) {
                    this.queuedRedirectEvent = event;
                    handled = true;
                }
                return handled;
            }
        },
        {
            key: "sendToConsumer",
            value: function sendToConsumer(event, consumer) {
                var _a;
                if (event.error && !$65b82078b3339b3f$var$isNullRedirectEvent(event)) {
                    var code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
                    consumer.onError($65b82078b3339b3f$export$9d398bebfec1c039(this.auth, code));
                } else consumer.onAuthEvent(event);
            }
        },
        {
            key: "isEventForConsumer",
            value: function isEventForConsumer(event, consumer) {
                var eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
                return consumer.filter.includes(event.type) && eventIdMatches;
            }
        },
        {
            key: "hasEventBeenHandled",
            value: function hasEventBeenHandled(event) {
                if (Date.now() - this.lastProcessedEventTime >= $65b82078b3339b3f$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
                return this.cachedEventUids.has($65b82078b3339b3f$var$eventUid(event));
            }
        },
        {
            key: "saveEventToCache",
            value: function saveEventToCache(event) {
                this.cachedEventUids.add($65b82078b3339b3f$var$eventUid(event));
                this.lastProcessedEventTime = Date.now();
            }
        }
    ]);
    return AuthEventManager;
}();
function $65b82078b3339b3f$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter(function(v) {
        return v;
    }).join("-");
}
function $65b82078b3339b3f$var$isNullRedirectEvent(param) {
    var type = param.type, error = param.error;
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === "auth/no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ;
}
function $65b82078b3339b3f$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $65b82078b3339b3f$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
function $65b82078b3339b3f$export$3d12bd131bb975d1(auth) {
    return $65b82078b3339b3f$var$__getProjectConfig.apply(this, arguments);
}
function $65b82078b3339b3f$var$__getProjectConfig() {
    $65b82078b3339b3f$var$__getProjectConfig = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $9OZ9j._)(function(auth) {
        var request;
        var _arguments = arguments;
        return (0, $lF1I7.__generator)(this, function(_state) {
            request = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
            return [
                2,
                $65b82078b3339b3f$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request)
            ];
        });
    });
    return $65b82078b3339b3f$var$__getProjectConfig.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
var $65b82078b3339b3f$var$HTTP_REGEX = /^https?/;
function $65b82078b3339b3f$var$_validateOrigin(auth) {
    return $65b82078b3339b3f$var$__validateOrigin.apply(this, arguments);
}
function $65b82078b3339b3f$var$__validateOrigin() {
    $65b82078b3339b3f$var$__validateOrigin = (0, $9OZ9j._)(function(auth) {
        var authorizedDomains, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, domain;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Skip origin validation if we are in an emulated environment
                    if (auth.config.emulator) return [
                        2
                    ];
                    return [
                        4,
                        $65b82078b3339b3f$export$3d12bd131bb975d1(auth)
                    ];
                case 1:
                    authorizedDomains = _state.sent().authorizedDomains;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = authorizedDomains[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            domain = _step.value;
                            try {
                                if ($65b82078b3339b3f$var$matchDomain(domain)) return [
                                    2
                                ];
                            } catch (_a) {
                            // Do nothing if there's a URL error; just continue searching
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // In the old SDK, this error also provides helpful messages.
                    $65b82078b3339b3f$export$9fa96a7d116ea3ce(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
                    return [
                        2
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__validateOrigin.apply(this, arguments);
}
function $65b82078b3339b3f$var$matchDomain(expected) {
    var currentUrl = $65b82078b3339b3f$var$_getCurrentUrl();
    var _ref = new URL(currentUrl), protocol = _ref.protocol, hostname = _ref.hostname;
    if (expected.startsWith("chrome-extension://")) {
        var ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$65b82078b3339b3f$var$HTTP_REGEX.test(protocol)) return false;
    if ($65b82078b3339b3f$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    var escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    var re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$NETWORK_TIMEOUT = new $65b82078b3339b3f$var$Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $65b82078b3339b3f$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    var beacon = $65b82078b3339b3f$var$_window().___jsl;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) try {
        // Get gapi hint.
        for(var _iterator = Object.keys(beacon.H)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var hint = _step.value;
            // Requested modules.
            beacon.H[hint].r = beacon.H[hint].r || [];
            // Loaded modules.
            beacon.H[hint].L = beacon.H[hint].L || [];
            // Set requested modules to a copy of the loaded modules.
            beacon.H[hint].r = (0, $3jzhD._)(beacon.H[hint].L);
            // Clear pending callbacks.
            if (beacon.CP) for(var i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
            beacon.CP[i] = null;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $65b82078b3339b3f$var$loadGapi(auth) {
    return new Promise(function(resolve, reject) {
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $65b82078b3339b3f$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: function() {
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: function() {
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $65b82078b3339b3f$var$resetUnloadedGapiModules();
                    reject($65b82078b3339b3f$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $65b82078b3339b3f$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $65b82078b3339b3f$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $65b82078b3339b3f$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            var cbName = $65b82078b3339b3f$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $65b82078b3339b3f$var$_window()[cbName] = function() {
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($65b82078b3339b3f$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $65b82078b3339b3f$var$_loadJS("".concat($65b82078b3339b3f$var$_gapiScriptUrl(), "?onload=").concat(cbName)).catch(function(e) {
                return reject(e);
            });
        }
    }).catch(function(error) {
        // Reset cached promise to allow for retrial.
        $65b82078b3339b3f$var$cachedGApiLoader = null;
        throw error;
    });
}
var $65b82078b3339b3f$var$cachedGApiLoader = null;
function $65b82078b3339b3f$var$_loadGapi(auth) {
    $65b82078b3339b3f$var$cachedGApiLoader = $65b82078b3339b3f$var$cachedGApiLoader || $65b82078b3339b3f$var$loadGapi(auth);
    return $65b82078b3339b3f$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$PING_TIMEOUT = new $65b82078b3339b3f$var$Delay(5000, 15000);
var $65b82078b3339b3f$var$IFRAME_PATH = "__/auth/iframe";
var $65b82078b3339b3f$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
var $65b82078b3339b3f$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
var $65b82078b3339b3f$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $65b82078b3339b3f$var$getIframeUrl(auth) {
    var config = auth.config;
    $65b82078b3339b3f$export$890c4ad488842ce7(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    var url = config.emulator ? $65b82078b3339b3f$var$_emulatorUrl(config, $65b82078b3339b3f$var$EMULATED_IFRAME_PATH) : "https://".concat(auth.config.authDomain, "/").concat($65b82078b3339b3f$var$IFRAME_PATH);
    var params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $ilNGG.SDK_VERSION)
    };
    var eid = $65b82078b3339b3f$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    var frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return "".concat(url, "?").concat((0, $gQ5gw.querystring)(params).slice(1));
}
function $65b82078b3339b3f$var$_openIframe(auth) {
    return $65b82078b3339b3f$var$__openIframe.apply(this, arguments);
}
function $65b82078b3339b3f$var$__openIframe() {
    $65b82078b3339b3f$var$__openIframe = (0, $9OZ9j._)(function(auth) {
        var context, gapi1;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65b82078b3339b3f$var$_loadGapi(auth)
                    ];
                case 1:
                    context = _state.sent();
                    gapi1 = $65b82078b3339b3f$var$_window().gapi;
                    $65b82078b3339b3f$export$890c4ad488842ce7(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return [
                        2,
                        context.open({
                            where: document.body,
                            url: $65b82078b3339b3f$var$getIframeUrl(auth),
                            messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
                            attributes: $65b82078b3339b3f$var$IFRAME_ATTRIBUTES,
                            dontclear: true
                        }, function(iframe) {
                            return new Promise(function() {
                                var _ref = (0, $9OZ9j._)(function(resolve, reject) {
                                    var networkError, networkErrorTimer;
                                    // Clear timer and resolve pending iframe ready promise.
                                    function clearTimerAndResolve() {
                                        $65b82078b3339b3f$var$_window().clearTimeout(networkErrorTimer);
                                        resolve(iframe);
                                    }
                                    return (0, $lF1I7.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    iframe.restyle({
                                                        // Prevent iframe from closing on mouse out.
                                                        setHideOnLeave: false
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                networkError = $65b82078b3339b3f$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
                                                // Confirm iframe is correctly loaded.
                                                // To fallback on failure, set a timeout.
                                                networkErrorTimer = $65b82078b3339b3f$var$_window().setTimeout(function() {
                                                    reject(networkError);
                                                }, $65b82078b3339b3f$var$PING_TIMEOUT.get());
                                                // This returns an IThenable. However the reject part does not call
                                                // when the iframe is not loaded.
                                                iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, function() {
                                                    reject(networkError);
                                                });
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(resolve, reject) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        })
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__openIframe.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
var $65b82078b3339b3f$var$DEFAULT_WIDTH = 500;
var $65b82078b3339b3f$var$DEFAULT_HEIGHT = 600;
var $65b82078b3339b3f$var$TARGET_BLANK = "_blank";
var $65b82078b3339b3f$var$FIREFOX_EMPTY_URL = "http://localhost";
var $65b82078b3339b3f$export$c03999cb2f36933f = /*#__PURE__*/ function() {
    "use strict";
    function AuthPopup(window1) {
        (0, $19mwo._)(this, AuthPopup);
        this.window = window1;
        this.associatedEvent = null;
    }
    (0, $6rpfc._)(AuthPopup, [
        {
            key: "close",
            value: function close() {
                if (this.window) try {
                    this.window.close();
                } catch (e) {}
            }
        }
    ]);
    return AuthPopup;
}();
function $65b82078b3339b3f$var$_open(auth, url, name) {
    var width = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $65b82078b3339b3f$var$DEFAULT_WIDTH, height = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $65b82078b3339b3f$var$DEFAULT_HEIGHT;
    var top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    var left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    var target = "";
    var options = Object.assign(Object.assign({}, $65b82078b3339b3f$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    var ua = (0, $gQ5gw.getUA)().toLowerCase();
    if (name) target = $65b82078b3339b3f$var$_isChromeIOS(ua) ? $65b82078b3339b3f$var$TARGET_BLANK : name;
    if ($65b82078b3339b3f$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $65b82078b3339b3f$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    var optionsString = Object.entries(options).reduce(function(accum, param) {
        var _param = (0, $2MTYX._)(param, 2), key = _param[0], value = _param[1];
        return "".concat(accum).concat(key, "=").concat(value, ",");
    }, "");
    if ($65b82078b3339b3f$var$_isIOSStandalone(ua) && target !== "_self") {
        $65b82078b3339b3f$var$openAsNewWindowIOS(url || "", target);
        return new $65b82078b3339b3f$export$c03999cb2f36933f(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    var newWin = window.open(url || "", target, optionsString);
    $65b82078b3339b3f$export$890c4ad488842ce7(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $65b82078b3339b3f$export$c03999cb2f36933f(newWin);
}
function $65b82078b3339b3f$var$openAsNewWindowIOS(url, target) {
    var el = document.createElement("a");
    el.href = url;
    el.target = target;
    var click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ var $65b82078b3339b3f$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ var $65b82078b3339b3f$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ var $65b82078b3339b3f$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
function $65b82078b3339b3f$export$28f7fcd39efa255(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    return $65b82078b3339b3f$var$__getRedirectUrl.apply(this, arguments);
}
function $65b82078b3339b3f$var$__getRedirectUrl() {
    $65b82078b3339b3f$var$__getRedirectUrl = (0, $9OZ9j._)(function(auth, provider, authType, redirectUrl, eventId, additionalParams) {
        var params, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, value, scopes, paramsDict, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key1, appCheckToken, appCheckTokenFragment;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    $65b82078b3339b3f$export$890c4ad488842ce7(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
                    $65b82078b3339b3f$export$890c4ad488842ce7(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
                    params = {
                        apiKey: auth.config.apiKey,
                        appName: auth.name,
                        authType: authType,
                        redirectUrl: redirectUrl,
                        v: (0, $ilNGG.SDK_VERSION),
                        eventId: eventId
                    };
                    if (provider instanceof $65b82078b3339b3f$var$FederatedAuthProvider) {
                        provider.setDefaultLanguage(auth.languageCode);
                        params.providerId = provider.providerId || "";
                        if (!(0, $gQ5gw.isEmpty)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            // TODO set additionalParams from the provider as well?
                            for(_iterator = Object.entries(additionalParams || {})[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                _step_value = (0, $2MTYX._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                                params[key] = value;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    if (provider instanceof $65b82078b3339b3f$var$BaseOAuthProvider) {
                        scopes = provider.getScopes().filter(function(scope) {
                            return scope !== "";
                        });
                        if (scopes.length > 0) params.scopes = scopes.join(",");
                    }
                    if (auth.tenantId) params.tid = auth.tenantId;
                    // TODO: maybe set eid as endipointId
                    // TODO: maybe set fw as Frameworks.join(",")
                    paramsDict = params;
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = Object.keys(paramsDict)[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            key1 = _step1.value;
                            if (paramsDict[key1] === undefined) delete paramsDict[key1];
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return [
                        4,
                        auth._getAppCheckToken()
                    ];
                case 1:
                    appCheckToken = _state.sent();
                    appCheckTokenFragment = appCheckToken ? "#".concat($65b82078b3339b3f$var$FIREBASE_APP_CHECK_FRAGMENT_ID, "=").concat(encodeURIComponent(appCheckToken)) : "";
                    // Start at index 1 to skip the leading '&' in the query string
                    return [
                        2,
                        "".concat($65b82078b3339b3f$var$getHandlerBase(auth), "?").concat((0, $gQ5gw.querystring)(paramsDict).slice(1)).concat(appCheckTokenFragment)
                    ];
            }
        });
    });
    return $65b82078b3339b3f$var$__getRedirectUrl.apply(this, arguments);
}
function $65b82078b3339b3f$var$getHandlerBase(param) {
    var config = param.config;
    if (!config.emulator) return "https://".concat(config.authDomain, "/").concat($65b82078b3339b3f$var$WIDGET_PATH);
    return $65b82078b3339b3f$var$_emulatorUrl(config, $65b82078b3339b3f$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ var $65b82078b3339b3f$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
var $65b82078b3339b3f$var$BrowserPopupRedirectResolver = /*#__PURE__*/ function() {
    "use strict";
    function BrowserPopupRedirectResolver() {
        (0, $19mwo._)(this, BrowserPopupRedirectResolver);
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $65b82078b3339b3f$export$407448d2b89b1813;
        this._completeRedirectFn = $65b82078b3339b3f$export$53a70dd1ebbae346;
        this._overrideRedirectResult = $65b82078b3339b3f$export$a33b77bbdbb8366c;
    }
    (0, $6rpfc._)(BrowserPopupRedirectResolver, [
        {
            key: "_openPopup",
            value: // Wrapping in async even though we don't await anywhere in order
            // to make sure errors are raised as promise rejections
            function _openPopup(auth, provider, authType, eventId) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _a, url;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $65b82078b3339b3f$export$1fbe638ecf81657e((_a = _this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
                                return [
                                    4,
                                    $65b82078b3339b3f$export$28f7fcd39efa255(auth, provider, authType, $65b82078b3339b3f$var$_getCurrentUrl(), eventId)
                                ];
                            case 1:
                                url = _state.sent();
                                return [
                                    2,
                                    $65b82078b3339b3f$var$_open(auth, url, $65b82078b3339b3f$export$faec65b429be379())
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_openRedirect",
            value: function _openRedirect(auth, provider, authType, eventId) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var url;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._originValidation(auth)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    $65b82078b3339b3f$export$28f7fcd39efa255(auth, provider, authType, $65b82078b3339b3f$var$_getCurrentUrl(), eventId)
                                ];
                            case 2:
                                url = _state.sent();
                                $65b82078b3339b3f$var$_setWindowLocation(url);
                                return [
                                    2,
                                    new Promise(function() {})
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_initialize",
            value: function _initialize(auth) {
                var _this = this;
                var key = auth._key();
                if (this.eventManagers[key]) {
                    var _this_eventManagers_key = this.eventManagers[key], manager = _this_eventManagers_key.manager, promise = _this_eventManagers_key.promise;
                    if (manager) return Promise.resolve(manager);
                    else {
                        $65b82078b3339b3f$export$1fbe638ecf81657e(promise, "If manager is not set, promise should be");
                        return promise;
                    }
                }
                var promise1 = this.initAndGetManager(auth);
                this.eventManagers[key] = {
                    promise: promise1
                };
                // If the promise is rejected, the key should be removed so that the
                // operation can be retried later.
                promise1.catch(function() {
                    delete _this.eventManagers[key];
                });
                return promise1;
            }
        },
        {
            key: "initAndGetManager",
            value: function initAndGetManager(auth) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var iframe, manager;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65b82078b3339b3f$var$_openIframe(auth)
                                ];
                            case 1:
                                iframe = _state.sent();
                                manager = new $65b82078b3339b3f$export$24baa2b76016ce0e(auth);
                                iframe.register("authEvent", function(iframeEvent) {
                                    $65b82078b3339b3f$export$890c4ad488842ce7(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
                                    // TODO: Consider splitting redirect and popup events earlier on
                                    var handled = manager.onEvent(iframeEvent.authEvent);
                                    return {
                                        status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
                                    };
                                }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
                                _this.eventManagers[auth._key()] = {
                                    manager: manager
                                };
                                _this.iframes[auth._key()] = iframe;
                                return [
                                    2,
                                    manager
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_isIframeWebStorageSupported",
            value: function _isIframeWebStorageSupported(auth, cb) {
                var iframe = this.iframes[auth._key()];
                iframe.send($65b82078b3339b3f$var$WEB_STORAGE_SUPPORT_KEY, {
                    type: $65b82078b3339b3f$var$WEB_STORAGE_SUPPORT_KEY
                }, function(result) {
                    var _a;
                    var isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$65b82078b3339b3f$var$WEB_STORAGE_SUPPORT_KEY];
                    if (isSupported !== undefined) cb(!!isSupported);
                    $65b82078b3339b3f$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
            }
        },
        {
            key: "_originValidation",
            value: function _originValidation(auth) {
                var key = auth._key();
                if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $65b82078b3339b3f$var$_validateOrigin(auth);
                return this.originValidationPromises[key];
            }
        },
        {
            key: "_shouldInitProactively",
            get: function get() {
                // Mobile browsers and Safari need to optimistically initialize
                return $65b82078b3339b3f$var$_isMobileBrowser() || $65b82078b3339b3f$var$_isSafari() || $65b82078b3339b3f$export$d66dc83d8cfc8dd();
            }
        }
    ]);
    return BrowserPopupRedirectResolver;
}();
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ var $65b82078b3339b3f$export$342063e11d6c3cad = $65b82078b3339b3f$var$BrowserPopupRedirectResolver;
var $65b82078b3339b3f$var$MultiFactorAssertionImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorAssertionImpl(factorId) {
        (0, $19mwo._)(this, MultiFactorAssertionImpl);
        this.factorId = factorId;
    }
    (0, $6rpfc._)(MultiFactorAssertionImpl, [
        {
            key: "_process",
            value: function _process(auth, session, displayName) {
                switch(session.type){
                    case "enroll" /* MultiFactorSessionType.ENROLL */ :
                        return this._finalizeEnroll(auth, session.credential, displayName);
                    case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                        return this._finalizeSignIn(auth, session.credential);
                    default:
                        return $65b82078b3339b3f$var$debugFail("unexpected MultiFactorSessionType");
                }
            }
        }
    ]);
    return MultiFactorAssertionImpl;
}();
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ var $65b82078b3339b3f$var$PhoneMultiFactorAssertionImpl = /*#__PURE__*/ function(MultiFactorAssertionImpl) {
    "use strict";
    (0, $iNfU4._)(PhoneMultiFactorAssertionImpl, MultiFactorAssertionImpl);
    var _super = (0, $k1NN5._)(PhoneMultiFactorAssertionImpl);
    function PhoneMultiFactorAssertionImpl(credential) {
        (0, $19mwo._)(this, PhoneMultiFactorAssertionImpl);
        var _this;
        _this = _super.call(this, "phone" /* FactorId.PHONE */ );
        _this.credential = credential;
        return _this;
    }
    (0, $6rpfc._)(PhoneMultiFactorAssertionImpl, [
        {
            /** @internal */ key: "_finalizeEnroll",
            value: function _finalizeEnroll(auth, idToken, displayName) {
                return $65b82078b3339b3f$var$finalizeEnrollPhoneMfa(auth, {
                    idToken: idToken,
                    displayName: displayName,
                    phoneVerificationInfo: this.credential._makeVerificationRequest()
                });
            }
        },
        {
            /** @internal */ key: "_finalizeSignIn",
            value: function _finalizeSignIn(auth, mfaPendingCredential) {
                return $65b82078b3339b3f$var$finalizeSignInPhoneMfa(auth, {
                    mfaPendingCredential: mfaPendingCredential,
                    phoneVerificationInfo: this.credential._makeVerificationRequest()
                });
            }
        }
    ], [
        {
            key: "_fromCredential",
            value: /** @internal */ function _fromCredential(credential) {
                return new PhoneMultiFactorAssertionImpl(credential);
            }
        }
    ]);
    return PhoneMultiFactorAssertionImpl;
}($65b82078b3339b3f$var$MultiFactorAssertionImpl);
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ var $65b82078b3339b3f$export$953cecd6e717a553 = /*#__PURE__*/ function() {
    "use strict";
    function PhoneMultiFactorGenerator() {
        (0, $19mwo._)(this, PhoneMultiFactorGenerator);
    }
    (0, $6rpfc._)(PhoneMultiFactorGenerator, null, [
        {
            key: "assertion",
            value: /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ function assertion(credential) {
                return $65b82078b3339b3f$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
            }
        }
    ]);
    return PhoneMultiFactorGenerator;
}();
/**
 * The identifier of the phone second factor: `phone`.
 */ $65b82078b3339b3f$export$953cecd6e717a553.FACTOR_ID = "phone";
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ var $65b82078b3339b3f$export$971d5caa766a69d7 = /*#__PURE__*/ function() {
    "use strict";
    function TotpMultiFactorGenerator() {
        (0, $19mwo._)(this, TotpMultiFactorGenerator);
    }
    (0, $6rpfc._)(TotpMultiFactorGenerator, null, [
        {
            key: "assertionForEnrollment",
            value: /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ function assertionForEnrollment(secret, oneTimePassword) {
                return $65b82078b3339b3f$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
            }
        },
        {
            key: "assertionForSignIn",
            value: /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ function assertionForSignIn(enrollmentId, oneTimePassword) {
                return $65b82078b3339b3f$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
            }
        },
        {
            key: "generateSecret",
            value: /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ function generateSecret(session) {
                return (0, $9OZ9j._)(function() {
                    var _a, mfaSession, response;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                mfaSession = session;
                                $65b82078b3339b3f$export$890c4ad488842ce7(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                return [
                                    4,
                                    $65b82078b3339b3f$var$startEnrollTotpMfa(mfaSession.user.auth, {
                                        idToken: mfaSession.credential,
                                        totpEnrollmentInfo: {}
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    $65b82078b3339b3f$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return TotpMultiFactorGenerator;
}();
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $65b82078b3339b3f$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
var $65b82078b3339b3f$var$TotpMultiFactorAssertionImpl = /*#__PURE__*/ function(MultiFactorAssertionImpl) {
    "use strict";
    (0, $iNfU4._)(TotpMultiFactorAssertionImpl, MultiFactorAssertionImpl);
    var _super = (0, $k1NN5._)(TotpMultiFactorAssertionImpl);
    function TotpMultiFactorAssertionImpl(otp, enrollmentId, secret) {
        (0, $19mwo._)(this, TotpMultiFactorAssertionImpl);
        var _this;
        _this = _super.call(this, "totp" /* FactorId.TOTP */ );
        _this.otp = otp;
        _this.enrollmentId = enrollmentId;
        _this.secret = secret;
        return _this;
    }
    (0, $6rpfc._)(TotpMultiFactorAssertionImpl, [
        {
            key: "_finalizeEnroll",
            value: /** @internal */ function _finalizeEnroll(auth, idToken, displayName) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        $65b82078b3339b3f$export$890c4ad488842ce7(typeof _this.secret !== "undefined", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        return [
                            2,
                            $65b82078b3339b3f$var$finalizeEnrollTotpMfa(auth, {
                                idToken: idToken,
                                displayName: displayName,
                                totpVerificationInfo: _this.secret._makeTotpVerificationInfo(_this.otp)
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "_finalizeSignIn",
            value: /** @internal */ function _finalizeSignIn(auth, mfaPendingCredential) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var totpVerificationInfo;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        $65b82078b3339b3f$export$890c4ad488842ce7(_this.enrollmentId !== undefined && _this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        totpVerificationInfo = {
                            verificationCode: _this.otp
                        };
                        return [
                            2,
                            $65b82078b3339b3f$var$finalizeSignInTotpMfa(auth, {
                                mfaPendingCredential: mfaPendingCredential,
                                mfaEnrollmentId: _this.enrollmentId,
                                totpVerificationInfo: totpVerificationInfo
                            })
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "_fromSecret",
            value: /** @internal */ function _fromSecret(secret, otp) {
                return new TotpMultiFactorAssertionImpl(otp, undefined, secret);
            }
        },
        {
            key: "_fromEnrollmentId",
            value: /** @internal */ function _fromEnrollmentId(enrollmentId, otp) {
                return new TotpMultiFactorAssertionImpl(otp, enrollmentId);
            }
        }
    ]);
    return TotpMultiFactorAssertionImpl;
}($65b82078b3339b3f$var$MultiFactorAssertionImpl);
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ var $65b82078b3339b3f$export$7ccc53e8f1e7dfc5 = /*#__PURE__*/ function() {
    "use strict";
    function TotpSecret(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth) {
        (0, $19mwo._)(this, TotpSecret);
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    (0, $6rpfc._)(TotpSecret, [
        {
            /** @internal */ key: "_makeTotpVerificationInfo",
            value: function _makeTotpVerificationInfo(otp) {
                return {
                    sessionInfo: this.sessionInfo,
                    verificationCode: otp
                };
            }
        },
        {
            /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ key: "generateQrCodeUrl",
            value: function generateQrCodeUrl(accountName, issuer) {
                var _a;
                var useDefaults = false;
                if ($65b82078b3339b3f$var$_isEmptyString(accountName) || $65b82078b3339b3f$var$_isEmptyString(issuer)) useDefaults = true;
                if (useDefaults) {
                    if ($65b82078b3339b3f$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || "unknownuser";
                    if ($65b82078b3339b3f$var$_isEmptyString(issuer)) issuer = this.auth.name;
                }
                return "otpauth://totp/".concat(issuer, ":").concat(accountName, "?secret=").concat(this.secretKey, "&issuer=").concat(issuer, "&algorithm=").concat(this.hashingAlgorithm, "&digits=").concat(this.codeLength);
            }
        }
    ], [
        {
            key: "_fromStartTotpMfaEnrollmentResponse",
            value: /** @internal */ function _fromStartTotpMfaEnrollmentResponse(response, auth) {
                return new TotpSecret(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
            }
        }
    ]);
    return TotpSecret;
}();
/** @internal */ function $65b82078b3339b3f$var$_isEmptyString(input) {
    return typeof input === "undefined" || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $65b82078b3339b3f$var$name = "@firebase/auth";
var $65b82078b3339b3f$var$version = "1.7.5";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$AuthInterop = /*#__PURE__*/ function() {
    "use strict";
    function AuthInterop(auth) {
        (0, $19mwo._)(this, AuthInterop);
        this.auth = auth;
        this.internalListeners = new Map();
    }
    (0, $6rpfc._)(AuthInterop, [
        {
            key: "getUid",
            value: function getUid() {
                var _a;
                this.assertAuthConfigured();
                return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
            }
        },
        {
            key: "getToken",
            value: function getToken(forceRefresh) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var accessToken;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.assertAuthConfigured();
                                return [
                                    4,
                                    _this.auth._initializationPromise
                                ];
                            case 1:
                                _state.sent();
                                if (!_this.auth.currentUser) return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    _this.auth.currentUser.getIdToken(forceRefresh)
                                ];
                            case 2:
                                accessToken = _state.sent();
                                return [
                                    2,
                                    {
                                        accessToken: accessToken
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addAuthTokenListener",
            value: function addAuthTokenListener(listener) {
                this.assertAuthConfigured();
                if (this.internalListeners.has(listener)) return;
                var unsubscribe = this.auth.onIdTokenChanged(function(user) {
                    listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
                });
                this.internalListeners.set(listener, unsubscribe);
                this.updateProactiveRefresh();
            }
        },
        {
            key: "removeAuthTokenListener",
            value: function removeAuthTokenListener(listener) {
                this.assertAuthConfigured();
                var unsubscribe = this.internalListeners.get(listener);
                if (!unsubscribe) return;
                this.internalListeners.delete(listener);
                unsubscribe();
                this.updateProactiveRefresh();
            }
        },
        {
            key: "assertAuthConfigured",
            value: function assertAuthConfigured() {
                $65b82078b3339b3f$export$890c4ad488842ce7(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
            }
        },
        {
            key: "updateProactiveRefresh",
            value: function updateProactiveRefresh() {
                if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
                else this.auth._stopProactiveRefresh();
            }
        }
    ]);
    return AuthInterop;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65b82078b3339b3f$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return "node";
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return "rn";
        case "Worker" /* ClientPlatform.WORKER */ :
            return "webworker";
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return "cordova";
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return "web-extension";
        default:
            return undefined;
    }
}
/** @internal */ function $65b82078b3339b3f$var$registerAuth(clientPlatform) {
    (0, $ilNGG._registerComponent)(new (0, $e5K63.Component)("auth" /* _ComponentName.AUTH */ , function(container, param) {
        var deps = param.options;
        var app = container.getProvider("app").getImmediate();
        var heartbeatServiceProvider = container.getProvider("heartbeat");
        var appCheckServiceProvider = container.getProvider("app-check-internal");
        var _app_options = app.options, apiKey = _app_options.apiKey, authDomain = _app_options.authDomain;
        $65b82078b3339b3f$export$890c4ad488842ce7(apiKey && !apiKey.includes(":"), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        var config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $65b82078b3339b3f$export$9f4f30ee63539e24(clientPlatform)
        };
        var authInstance = new $65b82078b3339b3f$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $65b82078b3339b3f$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback(function(container, _instanceIdentifier, _instance) {
        var authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $ilNGG._registerComponent)(new (0, $e5K63.Component)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , function(container) {
        var auth = $65b82078b3339b3f$export$a05254e7c3aeba6e(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return function(auth) {
            return new $65b82078b3339b3f$var$AuthInterop(auth);
        }(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $ilNGG.registerVersion)($65b82078b3339b3f$var$name, $65b82078b3339b3f$var$version, $65b82078b3339b3f$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $ilNGG.registerVersion)($65b82078b3339b3f$var$name, $65b82078b3339b3f$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $65b82078b3339b3f$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
var $65b82078b3339b3f$var$authIdTokenMaxAge = (0, $gQ5gw.getExperimentalSetting)("authIdTokenMaxAge") || $65b82078b3339b3f$var$DEFAULT_ID_TOKEN_MAX_AGE;
var $65b82078b3339b3f$var$lastPostedIdToken = null;
var $65b82078b3339b3f$var$mintCookieFactory = function(url) {
    return function() {
        var _ref = (0, $9OZ9j._)(function(user) {
            var idTokenResult, _tmp, idTokenAge, idToken;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = user;
                        if (!_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            user.getIdTokenResult()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        idTokenResult = _tmp;
                        idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
                        if (idTokenAge && idTokenAge > $65b82078b3339b3f$var$authIdTokenMaxAge) return [
                            2
                        ];
                        // Specifically trip null => undefined when logged out, to delete any existing cookie
                        idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
                        if ($65b82078b3339b3f$var$lastPostedIdToken === idToken) return [
                            2
                        ];
                        $65b82078b3339b3f$var$lastPostedIdToken = idToken;
                        return [
                            4,
                            fetch(url, {
                                method: idToken ? "POST" : "DELETE",
                                headers: idToken ? {
                                    "Authorization": "Bearer ".concat(idToken)
                                } : {}
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(user) {
            return _ref.apply(this, arguments);
        };
    }();
};
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $65b82078b3339b3f$export$ae1af26003f05816() {
    var app = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $ilNGG.getApp)();
    var provider = (0, $ilNGG._getProvider)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    var auth = $65b82078b3339b3f$export$b4171a6734a65d42(app, {
        popupRedirectResolver: $65b82078b3339b3f$export$342063e11d6c3cad,
        persistence: [
            $65b82078b3339b3f$export$23f2a1d2818174ef,
            $65b82078b3339b3f$export$8b22cf2602fb60ce,
            $65b82078b3339b3f$export$407448d2b89b1813
        ]
    });
    var authTokenSyncPath = (0, $gQ5gw.getExperimentalSetting)("authTokenSyncURL");
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === "boolean" && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        var authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            var mintCookie = $65b82078b3339b3f$var$mintCookieFactory(authTokenSyncUrl.toString());
            $65b82078b3339b3f$export$d141bba7fdc215a3(auth, mintCookie, function() {
                return mintCookie(auth.currentUser);
            });
            $65b82078b3339b3f$export$efccba1c4a2ef57b(auth, function(user) {
                return mintCookie(user);
            });
        }
    }
    var authEmulatorHost = (0, $gQ5gw.getDefaultEmulatorHost)("auth");
    if (authEmulatorHost) $65b82078b3339b3f$export$3466f893ebf79586(auth, "http://".concat(authEmulatorHost));
    return auth;
}
function $65b82078b3339b3f$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
$65b82078b3339b3f$var$_setExternalJSProvider({
    loadJS: function(url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise(function(resolve, reject) {
            var el = document.createElement("script");
            el.setAttribute("src", url);
            el.onload = resolve;
            el.onerror = function(e) {
                var error = $65b82078b3339b3f$export$9d398bebfec1c039("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = "text/javascript";
            el.charset = "UTF-8";
            $65b82078b3339b3f$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: "https://apis.google.com/js/api.js",
    recaptchaV2Script: "https://www.google.com/recaptcha/api.js",
    recaptchaEnterpriseScript: "https://www.google.com/recaptcha/enterprise.js?render="
});
$65b82078b3339b3f$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );


parcelRequire("ilNGG");
parcelRequire("gQ5gw");
parcelRequire("3DJ6n");

parcelRequire("e5K63");





var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $b0lSM = parcelRequire("b0lSM");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $c5rwh = parcelRequire("c5rwh");

var $lF1I7 = parcelRequire("lF1I7");

var $b0lSM = parcelRequire("b0lSM");


var $dKdZ4 = parcelRequire("dKdZ4");

var $7PvJn = parcelRequire("7PvJn");


var $b6033 = parcelRequire("b6033");
var $f70925294223df11$export$6b862160d295c8e = function(date) {
    if (date instanceof Date) return date;
    else if (date instanceof (0, $b6033.Timestamp)) return date.toDate();
    else {
        if (date.hasOwnProperty("seconds")) return (0, $b6033.Timestamp).fromMillis(date.seconds * 1000).toDate();
    }
};


var $f858d6a97cc5c220$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $f858d6a97cc5c220$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $f858d6a97cc5c220$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f858d6a97cc5c220$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $f858d6a97cc5c220$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $f858d6a97cc5c220$export$1f8b1cab05cab788;
(function(TaskType) {
    TaskType["ONE_TIME"] = "ONE_TIME";
    TaskType["WEEKLY"] = "WEEKLY";
    TaskType["MONTHLY"] = "MONTHLY";
})($f858d6a97cc5c220$export$1f8b1cab05cab788 || ($f858d6a97cc5c220$export$1f8b1cab05cab788 = {}));
var $f858d6a97cc5c220$export$dcf4d221b45abc27;
(function(TaskState) {
    TaskState["OPEN"] = "OPEN";
    TaskState["COMPLETE"] = "COMPLETE";
})($f858d6a97cc5c220$export$dcf4d221b45abc27 || ($f858d6a97cc5c220$export$dcf4d221b45abc27 = {}));
var $f858d6a97cc5c220$export$1b7c5dd652928d14 = function() {
    var _a, _OneTimeTaskModel_date_accessor_storage;
    var _date_decorators;
    var _date_initializers = [];
    var _date_extraInitializers = [];
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function OneTimeTaskModel(owner) {
            (0, $19mwo._)(this, OneTimeTaskModel);
            Object.defineProperty(this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: owner
            });
            _OneTimeTaskModel_date_accessor_storage.set(this, $f858d6a97cc5c220$var$__runInitializers(this, _date_initializers, new Date()));
            $f858d6a97cc5c220$var$__runInitializers(this, _date_extraInitializers);
            this.owner = owner;
        }
        (0, $6rpfc._)(OneTimeTaskModel, [
            {
                key: "date",
                get: function get() {
                    return $f858d6a97cc5c220$var$__classPrivateFieldGet(this, _OneTimeTaskModel_date_accessor_storage, "f");
                },
                set: function set(value) {
                    $f858d6a97cc5c220$var$__classPrivateFieldSet(this, _OneTimeTaskModel_date_accessor_storage, value, "f");
                }
            },
            {
                key: "toJS",
                value: function toJS() {
                    return {
                        date: this.date
                    };
                }
            },
            {
                key: "fromJS",
                value: function fromJS(json) {
                    this.date = (0, $f70925294223df11$export$6b862160d295c8e)(json["date"]);
                    return this;
                }
            }
        ]);
        return OneTimeTaskModel;
    }(), _OneTimeTaskModel_date_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _date_decorators = [
            (0, $b0lSM.observable)
        ];
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _date_decorators, {
            kind: "accessor",
            name: "date",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "date" in obj;
                },
                get: function(obj) {
                    return obj.date;
                },
                set: function(obj, value) {
                    obj.date = value;
                }
            },
            metadata: _metadata
        }, _date_initializers, _date_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $f858d6a97cc5c220$export$b6a1f1831456405c = function() {
    var _a, _WeeklyTaskModel_repeatCount_accessor_storage;
    var _repeatCount_decorators;
    var _repeatCount_initializers = [];
    var _repeatCount_extraInitializers = [];
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function WeeklyTaskModel(owner) {
            (0, $19mwo._)(this, WeeklyTaskModel);
            Object.defineProperty(this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: owner
            });
            _WeeklyTaskModel_repeatCount_accessor_storage.set(this, $f858d6a97cc5c220$var$__runInitializers(this, _repeatCount_initializers, 1));
            $f858d6a97cc5c220$var$__runInitializers(this, _repeatCount_extraInitializers);
            this.owner = owner;
        }
        (0, $6rpfc._)(WeeklyTaskModel, [
            {
                key: "repeatCount",
                get: function get() {
                    return $f858d6a97cc5c220$var$__classPrivateFieldGet(this, _WeeklyTaskModel_repeatCount_accessor_storage, "f");
                },
                set: function set(value) {
                    $f858d6a97cc5c220$var$__classPrivateFieldSet(this, _WeeklyTaskModel_repeatCount_accessor_storage, value, "f");
                }
            },
            {
                key: "toJS",
                value: function toJS() {
                    return {
                        repeatCount: this.repeatCount
                    };
                }
            },
            {
                key: "fromJS",
                value: function fromJS(json) {
                    this.repeatCount = json["repeatCount"];
                    return this;
                }
            }
        ]);
        return WeeklyTaskModel;
    }(), _WeeklyTaskModel_repeatCount_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _repeatCount_decorators = [
            (0, $b0lSM.observable)
        ];
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _repeatCount_decorators, {
            kind: "accessor",
            name: "repeatCount",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "repeatCount" in obj;
                },
                get: function(obj) {
                    return obj.repeatCount;
                },
                set: function(obj, value) {
                    obj.repeatCount = value;
                }
            },
            metadata: _metadata
        }, _repeatCount_initializers, _repeatCount_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $f858d6a97cc5c220$export$f3f20d9136cff626 = function() {
    var _a, _MonthlyTaskModel_monthly_accessor_storage;
    var _instanceExtraInitializers = [];
    var _monthly_decorators;
    var _monthly_initializers = [];
    var _monthly_extraInitializers = [];
    var _get_isPendingTask_decorators;
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function MonthlyTaskModel(owner) {
            (0, $19mwo._)(this, MonthlyTaskModel);
            Object.defineProperty(this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($f858d6a97cc5c220$var$__runInitializers(this, _instanceExtraInitializers), owner)
            });
            _MonthlyTaskModel_monthly_accessor_storage.set(this, $f858d6a97cc5c220$var$__runInitializers(this, _monthly_initializers, "start"));
            $f858d6a97cc5c220$var$__runInitializers(this, _monthly_extraInitializers);
            this.owner = owner;
        }
        (0, $6rpfc._)(MonthlyTaskModel, [
            {
                key: "monthly",
                get: function get() {
                    return $f858d6a97cc5c220$var$__classPrivateFieldGet(this, _MonthlyTaskModel_monthly_accessor_storage, "f");
                },
                set: function set(value) {
                    $f858d6a97cc5c220$var$__classPrivateFieldSet(this, _MonthlyTaskModel_monthly_accessor_storage, value, "f");
                }
            },
            {
                key: "isPendingTask",
                get: function get() {
                    var entries = (0, $b0lSM.values)(this.owner.logs.entries);
                    var latest = null;
                    entries.forEach(function(entry) {
                        if (latest == null) latest = entry;
                        else if (entry.when > latest.when) latest = entry;
                    });
                    if (latest == null) return true;
                    var lastEntry = (0, (/*@__PURE__*/$parcel$interopDefault($7PvJn)))(latest.when);
                    var endOfThisMonth = (0, (/*@__PURE__*/$parcel$interopDefault($7PvJn)))().endOf("month");
                    var startOfThisMonth = (0, (/*@__PURE__*/$parcel$interopDefault($7PvJn)))().startOf("month");
                    var b = (0, (/*@__PURE__*/$parcel$interopDefault($7PvJn)))();
                    var daysLeftInMonth = endOfThisMonth.diff(b, "days");
                    if (daysLeftInMonth < 7) {
                        //check this month 
                        if (lastEntry.isAfter(startOfThisMonth)) return true;
                    }
                    var lastMonth = (0, (/*@__PURE__*/$parcel$interopDefault($7PvJn)))().subtract(1, "month").startOf("month");
                    if (lastEntry.isBefore(lastMonth)) return true;
                    return false;
                }
            },
            {
                key: "isThereEntryForMonth",
                value: function isThereEntryForMonth(date) {}
            },
            {
                key: "toJS",
                value: function toJS() {
                    return {
                        monthly: this.monthly
                    };
                }
            },
            {
                key: "fromJS",
                value: function fromJS(json) {
                    this.monthly = json["monthly"];
                    return this;
                }
            }
        ]);
        return MonthlyTaskModel;
    }(), _MonthlyTaskModel_monthly_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _monthly_decorators = [
            (0, $b0lSM.observable)
        ];
        _get_isPendingTask_decorators = [
            (0, $b0lSM.computed)
        ];
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _monthly_decorators, {
            kind: "accessor",
            name: "monthly",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "monthly" in obj;
                },
                get: function(obj) {
                    return obj.monthly;
                },
                set: function(obj, value) {
                    obj.monthly = value;
                }
            },
            metadata: _metadata
        }, _monthly_initializers, _monthly_extraInitializers);
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _get_isPendingTask_decorators, {
            kind: "getter",
            name: "isPendingTask",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "isPendingTask" in obj;
                },
                get: function(obj) {
                    return obj.isPendingTask;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $f858d6a97cc5c220$export$ade9b241dfa4a5e7;
(function(SaveState) {
    SaveState[SaveState["NOT_SAVED"] = 0] = "NOT_SAVED";
    SaveState[SaveState["SAVING"] = 1] = "SAVING";
    SaveState[SaveState["SAVED"] = 2] = "SAVED";
})($f858d6a97cc5c220$export$ade9b241dfa4a5e7 || ($f858d6a97cc5c220$export$ade9b241dfa4a5e7 = {}));
var $f858d6a97cc5c220$export$1c98d9bfeea5177c = function() {
    var _a, _TaskModel_ioState_accessor_storage, _TaskModel_state_accessor_storage, _TaskModel_created_accessor_storage, _TaskModel_name_accessor_storage, _TaskModel_desc_accessor_storage, _TaskModel_icon_accessor_storage, _TaskModel_files_accessor_storage, _TaskModel_type_accessor_storage, _TaskModel_id_accessor_storage, _TaskModel_typeData_accessor_storage;
    var _instanceExtraInitializers = [];
    var _get_isSaving_decorators;
    var _ioState_decorators;
    var _ioState_initializers = [];
    var _ioState_extraInitializers = [];
    var _state_decorators;
    var _state_initializers = [];
    var _state_extraInitializers = [];
    var _setTaskState_decorators;
    var _created_decorators;
    var _created_initializers = [];
    var _created_extraInitializers = [];
    var _name_decorators;
    var _name_initializers = [];
    var _name_extraInitializers = [];
    var _desc_decorators;
    var _desc_initializers = [];
    var _desc_extraInitializers = [];
    var _icon_decorators;
    var _icon_initializers = [];
    var _icon_extraInitializers = [];
    var _files_decorators;
    var _files_initializers = [];
    var _files_extraInitializers = [];
    var _get_iconUrl_decorators;
    var _type_decorators;
    var _type_initializers = [];
    var _type_extraInitializers = [];
    var _id_decorators;
    var _id_initializers = [];
    var _id_extraInitializers = [];
    var _typeData_decorators;
    var _typeData_initializers = [];
    var _typeData_extraInitializers = [];
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function TaskModel() {
            var _this = this;
            (0, $19mwo._)(this, TaskModel);
            Object.defineProperty(this, "isAutoSaveOn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($f858d6a97cc5c220$var$__runInitializers(this, _instanceExtraInitializers), false)
            });
            Object.defineProperty(this, "logs", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: null
            });
            _TaskModel_ioState_accessor_storage.set(this, $f858d6a97cc5c220$var$__runInitializers(this, _ioState_initializers, $f858d6a97cc5c220$export$ade9b241dfa4a5e7.NOT_SAVED));
            _TaskModel_state_accessor_storage.set(this, ($f858d6a97cc5c220$var$__runInitializers(this, _ioState_extraInitializers), $f858d6a97cc5c220$var$__runInitializers(this, _state_initializers, $f858d6a97cc5c220$export$dcf4d221b45abc27.OPEN)));
            _TaskModel_created_accessor_storage.set(this, ($f858d6a97cc5c220$var$__runInitializers(this, _state_extraInitializers), $f858d6a97cc5c220$var$__runInitializers(this, _created_initializers, new Date())));
            _TaskModel_name_accessor_storage.set(this, ($f858d6a97cc5c220$var$__runInitializers(this, _created_extraInitializers), $f858d6a97cc5c220$var$__runInitializers(this, _name_initializers, "")));
            _TaskModel_desc_accessor_storage.set(this, ($f858d6a97cc5c220$var$__runInitializers(this, _name_extraInitializers), $f858d6a97cc5c220$var$__runInitializers(this, _desc_initializers, "")));
            _TaskModel_icon_accessor_storage.set(this, ($f858d6a97cc5c220$var$__runInitializers(this, _desc_extraInitializers), $f858d6a97cc5c220$var$__runInitializers(this, _icon_initializers, "default")));
            _TaskModel_files_accessor_storage.set(this, ($f858d6a97cc5c220$var$__runInitializers(this, _icon_extraInitializers), $f858d6a97cc5c220$var$__runInitializers(this, _files_initializers, [])));
            _TaskModel_type_accessor_storage.set(this, ($f858d6a97cc5c220$var$__runInitializers(this, _files_extraInitializers), $f858d6a97cc5c220$var$__runInitializers(this, _type_initializers, $f858d6a97cc5c220$export$1f8b1cab05cab788.ONE_TIME)));
            _TaskModel_id_accessor_storage.set(this, ($f858d6a97cc5c220$var$__runInitializers(this, _type_extraInitializers), $f858d6a97cc5c220$var$__runInitializers(this, _id_initializers, "")));
            var _obj;
            _TaskModel_typeData_accessor_storage.set(this, ($f858d6a97cc5c220$var$__runInitializers(this, _id_extraInitializers), $f858d6a97cc5c220$var$__runInitializers(this, _typeData_initializers, (_obj = {}, (0, $c5rwh._)(_obj, $f858d6a97cc5c220$export$1f8b1cab05cab788.ONE_TIME, new $f858d6a97cc5c220$export$1b7c5dd652928d14(this)), (0, $c5rwh._)(_obj, $f858d6a97cc5c220$export$1f8b1cab05cab788.WEEKLY, new $f858d6a97cc5c220$export$b6a1f1831456405c(this)), (0, $c5rwh._)(_obj, $f858d6a97cc5c220$export$1f8b1cab05cab788.MONTHLY, new $f858d6a97cc5c220$export$f3f20d9136cff626(this)), _obj))));
            $f858d6a97cc5c220$var$__runInitializers(this, _typeData_extraInitializers);
            this.id = (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().generateId([
                _a.DbSection
            ]);
            this.updateLogsObject();
            var t = this;
            var update_document_online = (0, $dKdZ4.debounce)(function() {
                return $f858d6a97cc5c220$var$__awaiter(_this, void 0, void 0, function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.log("Saving document online");
                                this.ioState = $f858d6a97cc5c220$export$ade9b241dfa4a5e7.SAVING;
                                return [
                                    4,
                                    (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().saveDoc([
                                        _a.DbSection
                                    ], this)
                                ];
                            case 1:
                                _state.sent();
                                this.ioState = $f858d6a97cc5c220$export$ade9b241dfa4a5e7.SAVED;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }, 1000);
            (0, $b0lSM.autorun)(function() {
                var toJs = _this.toJS();
                var files = (0, $b0lSM.values)(_this.files);
                if (_this.isAutoSaveOn) update_document_online();
            });
        }
        (0, $6rpfc._)(TaskModel, [
            {
                key: "isSaving",
                get: function get() {
                    console.log("isSaving", this.ioState);
                    return this.ioState == $f858d6a97cc5c220$export$ade9b241dfa4a5e7.SAVING;
                }
            },
            {
                key: "updateLogsObject",
                value: function updateLogsObject() {
                    this.logs = (0, $3a3345637c0a5d6f$export$b5afef939be034e8)().getTaskLogs(this.id);
                }
            },
            {
                key: "enableAutoSave",
                value: function enableAutoSave() {
                    this.isAutoSaveOn = true;
                }
            },
            {
                key: "ioState",
                get: function get() {
                    return $f858d6a97cc5c220$var$__classPrivateFieldGet(this, _TaskModel_ioState_accessor_storage, "f");
                },
                set: function set(value) {
                    $f858d6a97cc5c220$var$__classPrivateFieldSet(this, _TaskModel_ioState_accessor_storage, value, "f");
                }
            },
            {
                key: "state",
                get: function get() {
                    return $f858d6a97cc5c220$var$__classPrivateFieldGet(this, _TaskModel_state_accessor_storage, "f");
                },
                set: function set(value) {
                    $f858d6a97cc5c220$var$__classPrivateFieldSet(this, _TaskModel_state_accessor_storage, value, "f");
                }
            },
            {
                key: "setTaskState",
                value: function setTaskState(state) {
                    this.state = state;
                    if (state == $f858d6a97cc5c220$export$dcf4d221b45abc27.COMPLETE) this.logs.addEntry(new Date(), "COMPLETE");
                    else this.logs.addEntry(new Date(), "REOPEN");
                }
            },
            {
                //TODO: When no ID exists -> pregen ID
                key: "getUserStoragePath",
                value: function getUserStoragePath(fileName) {
                    if (this.id == "") throw "Fix me";
                    var userId = (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().userId;
                    return "users/".concat(userId, "/").concat(this.id, "/").concat(fileName);
                }
            },
            {
                key: "created",
                get: function get() {
                    return $f858d6a97cc5c220$var$__classPrivateFieldGet(this, _TaskModel_created_accessor_storage, "f");
                },
                set: function set(value) {
                    $f858d6a97cc5c220$var$__classPrivateFieldSet(this, _TaskModel_created_accessor_storage, value, "f");
                }
            },
            {
                key: "name",
                get: function get() {
                    return $f858d6a97cc5c220$var$__classPrivateFieldGet(this, _TaskModel_name_accessor_storage, "f");
                },
                set: function set(value) {
                    $f858d6a97cc5c220$var$__classPrivateFieldSet(this, _TaskModel_name_accessor_storage, value, "f");
                }
            },
            {
                key: "desc",
                get: function get() {
                    return $f858d6a97cc5c220$var$__classPrivateFieldGet(this, _TaskModel_desc_accessor_storage, "f");
                },
                set: function set(value) {
                    $f858d6a97cc5c220$var$__classPrivateFieldSet(this, _TaskModel_desc_accessor_storage, value, "f");
                }
            },
            {
                key: "icon",
                get: function get() {
                    return $f858d6a97cc5c220$var$__classPrivateFieldGet(this, _TaskModel_icon_accessor_storage, "f");
                },
                set: function set(value) {
                    $f858d6a97cc5c220$var$__classPrivateFieldSet(this, _TaskModel_icon_accessor_storage, value, "f");
                }
            },
            {
                key: "files",
                get: function get() {
                    return $f858d6a97cc5c220$var$__classPrivateFieldGet(this, _TaskModel_files_accessor_storage, "f");
                },
                set: function set(value) {
                    $f858d6a97cc5c220$var$__classPrivateFieldSet(this, _TaskModel_files_accessor_storage, value, "f");
                }
            },
            {
                key: "iconUrl",
                get: function get() {
                    return (0, $3a3345637c0a5d6f$export$bd973f06e9aaec8c)().getTaskIconUrl(this.icon);
                }
            },
            {
                key: "type",
                get: function get() {
                    return $f858d6a97cc5c220$var$__classPrivateFieldGet(this, _TaskModel_type_accessor_storage, "f");
                },
                set: function set(value) {
                    $f858d6a97cc5c220$var$__classPrivateFieldSet(this, _TaskModel_type_accessor_storage, value, "f");
                }
            },
            {
                key: "id",
                get: function get() {
                    return $f858d6a97cc5c220$var$__classPrivateFieldGet(this, _TaskModel_id_accessor_storage, "f");
                },
                set: function set(value) {
                    $f858d6a97cc5c220$var$__classPrivateFieldSet(this, _TaskModel_id_accessor_storage, value, "f");
                }
            },
            {
                key: "typeData",
                get: function get() {
                    return $f858d6a97cc5c220$var$__classPrivateFieldGet(this, _TaskModel_typeData_accessor_storage, "f");
                },
                set: function set(value) {
                    $f858d6a97cc5c220$var$__classPrivateFieldSet(this, _TaskModel_typeData_accessor_storage, value, "f");
                }
            },
            {
                key: "getSpecific",
                value: function getSpecific() {
                    return this.typeData[this.type];
                }
            },
            {
                key: "toJS",
                value: function toJS() {
                    var subData = this.typeData[this.type].toJS();
                    return {
                        id: this.id,
                        created: this.created,
                        icon: this.icon,
                        name: this.name,
                        desc: this.desc,
                        type: this.type,
                        state: this.state,
                        files: this.files,
                        typeData: subData
                    };
                }
            },
            {
                key: "fromJS",
                value: function fromJS(json) {
                    var _b, _c, _d, _e;
                    this.ioState = $f858d6a97cc5c220$export$ade9b241dfa4a5e7.SAVED;
                    this.isAutoSaveOn = false;
                    this.name = json["name"];
                    this.icon = json["icon"];
                    this.type = json["type"];
                    this.desc = (_b = json["desc"]) !== null && _b !== void 0 ? _b : "";
                    this.state = (_c = json["state"]) !== null && _c !== void 0 ? _c : $f858d6a97cc5c220$export$dcf4d221b45abc27.OPEN;
                    this.files = (_d = json["files"]) !== null && _d !== void 0 ? _d : [];
                    this.id = json["id"];
                    this.updateLogsObject();
                    if (json["created"]) this.created = (0, $f70925294223df11$export$6b862160d295c8e)(json["created"]);
                    else this.created = new Date();
                    this.typeData[this.type].fromJS((_e = json["typeData"]) !== null && _e !== void 0 ? _e : {});
                    return this;
                }
            }
        ]);
        return TaskModel;
    }(), _TaskModel_ioState_accessor_storage = new WeakMap(), _TaskModel_state_accessor_storage = new WeakMap(), _TaskModel_created_accessor_storage = new WeakMap(), _TaskModel_name_accessor_storage = new WeakMap(), _TaskModel_desc_accessor_storage = new WeakMap(), _TaskModel_icon_accessor_storage = new WeakMap(), _TaskModel_files_accessor_storage = new WeakMap(), _TaskModel_type_accessor_storage = new WeakMap(), _TaskModel_id_accessor_storage = new WeakMap(), _TaskModel_typeData_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _get_isSaving_decorators = [
            (0, $b0lSM.computed)
        ];
        _ioState_decorators = [
            (0, $b0lSM.observable)
        ];
        _state_decorators = [
            (0, $b0lSM.observable)
        ];
        _setTaskState_decorators = [
            (0, $b0lSM.action)
        ];
        _created_decorators = [
            (0, $b0lSM.observable)
        ];
        _name_decorators = [
            (0, $b0lSM.observable)
        ];
        _desc_decorators = [
            (0, $b0lSM.observable)
        ];
        _icon_decorators = [
            (0, $b0lSM.observable)
        ];
        _files_decorators = [
            (0, $b0lSM.observable)
        ];
        _get_iconUrl_decorators = [
            (0, $b0lSM.computed)
        ];
        _type_decorators = [
            (0, $b0lSM.observable)
        ];
        _id_decorators = [
            (0, $b0lSM.observable)
        ];
        _typeData_decorators = [
            (0, $b0lSM.observable)
        ];
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _get_isSaving_decorators, {
            kind: "getter",
            name: "isSaving",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "isSaving" in obj;
                },
                get: function(obj) {
                    return obj.isSaving;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _ioState_decorators, {
            kind: "accessor",
            name: "ioState",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "ioState" in obj;
                },
                get: function(obj) {
                    return obj.ioState;
                },
                set: function(obj, value) {
                    obj.ioState = value;
                }
            },
            metadata: _metadata
        }, _ioState_initializers, _ioState_extraInitializers);
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _state_decorators, {
            kind: "accessor",
            name: "state",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "state" in obj;
                },
                get: function(obj) {
                    return obj.state;
                },
                set: function(obj, value) {
                    obj.state = value;
                }
            },
            metadata: _metadata
        }, _state_initializers, _state_extraInitializers);
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _setTaskState_decorators, {
            kind: "method",
            name: "setTaskState",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "setTaskState" in obj;
                },
                get: function(obj) {
                    return obj.setTaskState;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _created_decorators, {
            kind: "accessor",
            name: "created",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "created" in obj;
                },
                get: function(obj) {
                    return obj.created;
                },
                set: function(obj, value) {
                    obj.created = value;
                }
            },
            metadata: _metadata
        }, _created_initializers, _created_extraInitializers);
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _name_decorators, {
            kind: "accessor",
            name: "name",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "name" in obj;
                },
                get: function(obj) {
                    return obj.name;
                },
                set: function(obj, value) {
                    obj.name = value;
                }
            },
            metadata: _metadata
        }, _name_initializers, _name_extraInitializers);
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _desc_decorators, {
            kind: "accessor",
            name: "desc",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "desc" in obj;
                },
                get: function(obj) {
                    return obj.desc;
                },
                set: function(obj, value) {
                    obj.desc = value;
                }
            },
            metadata: _metadata
        }, _desc_initializers, _desc_extraInitializers);
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _icon_decorators, {
            kind: "accessor",
            name: "icon",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "icon" in obj;
                },
                get: function(obj) {
                    return obj.icon;
                },
                set: function(obj, value) {
                    obj.icon = value;
                }
            },
            metadata: _metadata
        }, _icon_initializers, _icon_extraInitializers);
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _files_decorators, {
            kind: "accessor",
            name: "files",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "files" in obj;
                },
                get: function(obj) {
                    return obj.files;
                },
                set: function(obj, value) {
                    obj.files = value;
                }
            },
            metadata: _metadata
        }, _files_initializers, _files_extraInitializers);
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _get_iconUrl_decorators, {
            kind: "getter",
            name: "iconUrl",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "iconUrl" in obj;
                },
                get: function(obj) {
                    return obj.iconUrl;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _type_decorators, {
            kind: "accessor",
            name: "type",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "type" in obj;
                },
                get: function(obj) {
                    return obj.type;
                },
                set: function(obj, value) {
                    obj.type = value;
                }
            },
            metadata: _metadata
        }, _type_initializers, _type_extraInitializers);
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _id_decorators, {
            kind: "accessor",
            name: "id",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "id" in obj;
                },
                get: function(obj) {
                    return obj.id;
                },
                set: function(obj, value) {
                    obj.id = value;
                }
            },
            metadata: _metadata
        }, _id_initializers, _id_extraInitializers);
        $f858d6a97cc5c220$var$__esDecorate(_a, null, _typeData_decorators, {
            kind: "accessor",
            name: "typeData",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "typeData" in obj;
                },
                get: function(obj) {
                    return obj.typeData;
                },
                set: function(obj, value) {
                    obj.typeData = value;
                }
            },
            metadata: _metadata
        }, _typeData_initializers, _typeData_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), Object.defineProperty(_a, "DbSection", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "tasks"
    }), _a;
}();
 //export const taskModel = new TaskModel();
 //export default new TaskModel();



var $cf2b1744999344e8$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $cf2b1744999344e8$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $cf2b1744999344e8$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $cf2b1744999344e8$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $cf2b1744999344e8$export$dc06ce91c446b5ef = function() {
    var _a, _TasksStore_entries_accessor_storage, _TasksStore_isLoaded_accessor_storage;
    var _instanceExtraInitializers = [];
    var _entries_decorators;
    var _entries_initializers = [];
    var _entries_extraInitializers = [];
    var _isLoaded_decorators;
    var _isLoaded_initializers = [];
    var _isLoaded_extraInitializers = [];
    var _get_oneTimeTasks_decorators;
    var _get_weeklyTasks_decorators;
    var _get_monthlyTasks_decorators;
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function TasksStore() {
            (0, $19mwo._)(this, TasksStore);
            _TasksStore_entries_accessor_storage.set(this, ($cf2b1744999344e8$var$__runInitializers(this, _instanceExtraInitializers), $cf2b1744999344e8$var$__runInitializers(this, _entries_initializers, [])));
            _TasksStore_isLoaded_accessor_storage.set(this, ($cf2b1744999344e8$var$__runInitializers(this, _entries_extraInitializers), $cf2b1744999344e8$var$__runInitializers(this, _isLoaded_initializers, false)));
            $cf2b1744999344e8$var$__runInitializers(this, _isLoaded_extraInitializers);
            this.entries = [];
        }
        (0, $6rpfc._)(TasksStore, [
            {
                key: "entries",
                get: function get() {
                    return $cf2b1744999344e8$var$__classPrivateFieldGet(this, _TasksStore_entries_accessor_storage, "f");
                },
                set: function set(value) {
                    $cf2b1744999344e8$var$__classPrivateFieldSet(this, _TasksStore_entries_accessor_storage, value, "f");
                }
            },
            {
                key: "isLoaded",
                get: function get() {
                    return $cf2b1744999344e8$var$__classPrivateFieldGet(this, _TasksStore_isLoaded_accessor_storage, "f");
                },
                set: function set(value) {
                    $cf2b1744999344e8$var$__classPrivateFieldSet(this, _TasksStore_isLoaded_accessor_storage, value, "f");
                }
            },
            {
                key: "oneTimeTasks",
                get: function get() {
                    var list = this.entries.filter(function(task) {
                        return task.type == (0, $f858d6a97cc5c220$export$1f8b1cab05cab788).ONE_TIME && task.state == (0, $f858d6a97cc5c220$export$dcf4d221b45abc27).OPEN;
                    });
                    list.sort(function(a, b) {
                        var a1 = a.getSpecific();
                        var b1 = b.getSpecific();
                        if (a.created.getTime() == b.created.getTime()) return a.name.localeCompare(b.name);
                        return a.created.getTime() - b.created.getTime();
                    });
                    return list;
                }
            },
            {
                key: "weeklyTasks",
                get: function get() {
                    return this.entries.filter(function(task) {
                        return task.type == (0, $f858d6a97cc5c220$export$1f8b1cab05cab788).WEEKLY;
                    });
                }
            },
            {
                key: "monthlyTasks",
                get: function get() {
                    return this.entries.filter(function(task) {
                        return task.type == (0, $f858d6a97cc5c220$export$1f8b1cab05cab788).MONTHLY;
                    });
                }
            },
            {
                key: "delete",
                value: function _delete(id) {
                    (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().deleteData([
                        "tasks"
                    ], id);
                }
            },
            {
                key: "getCopy",
                value: function getCopy(id) {
                    var task = this.entries.find(function(entry) {
                        return entry.id === id;
                    });
                    var js = task.toJS();
                    var t = new (0, $f858d6a97cc5c220$export$1c98d9bfeea5177c)().fromJS(js);
                    return t;
                }
            },
            {
                key: "get",
                value: function get(id) {
                    var task = this.entries.find(function(entry) {
                        return entry.id === id;
                    });
                    return task;
                }
            },
            {
                key: "init",
                value: function init() {
                    var _this = this;
                    (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().listenData([
                        "tasks"
                    ], function(data) {
                        _this.entries = data;
                        _this.isLoaded = true;
                    }, (0, $f858d6a97cc5c220$export$1c98d9bfeea5177c));
                }
            }
        ]);
        return TasksStore;
    }(), _TasksStore_entries_accessor_storage = new WeakMap(), _TasksStore_isLoaded_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _entries_decorators = [
            (0, $b0lSM.observable)
        ];
        _isLoaded_decorators = [
            (0, $b0lSM.observable)
        ];
        _get_oneTimeTasks_decorators = [
            (0, $b0lSM.computed)
        ];
        _get_weeklyTasks_decorators = [
            (0, $b0lSM.computed)
        ];
        _get_monthlyTasks_decorators = [
            (0, $b0lSM.computed)
        ];
        $cf2b1744999344e8$var$__esDecorate(_a, null, _entries_decorators, {
            kind: "accessor",
            name: "entries",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "entries" in obj;
                },
                get: function(obj) {
                    return obj.entries;
                },
                set: function(obj, value) {
                    obj.entries = value;
                }
            },
            metadata: _metadata
        }, _entries_initializers, _entries_extraInitializers);
        $cf2b1744999344e8$var$__esDecorate(_a, null, _isLoaded_decorators, {
            kind: "accessor",
            name: "isLoaded",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "isLoaded" in obj;
                },
                get: function(obj) {
                    return obj.isLoaded;
                },
                set: function(obj, value) {
                    obj.isLoaded = value;
                }
            },
            metadata: _metadata
        }, _isLoaded_initializers, _isLoaded_extraInitializers);
        $cf2b1744999344e8$var$__esDecorate(_a, null, _get_oneTimeTasks_decorators, {
            kind: "getter",
            name: "oneTimeTasks",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "oneTimeTasks" in obj;
                },
                get: function(obj) {
                    return obj.oneTimeTasks;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $cf2b1744999344e8$var$__esDecorate(_a, null, _get_weeklyTasks_decorators, {
            kind: "getter",
            name: "weeklyTasks",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "weeklyTasks" in obj;
                },
                get: function(obj) {
                    return obj.weeklyTasks;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $cf2b1744999344e8$var$__esDecorate(_a, null, _get_monthlyTasks_decorators, {
            kind: "getter",
            name: "monthlyTasks",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "monthlyTasks" in obj;
                },
                get: function(obj) {
                    return obj.monthlyTasks;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();




var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $b0lSM = parcelRequire("b0lSM");
var $f8716cecb8649d0d$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $f8716cecb8649d0d$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $f8716cecb8649d0d$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $f8716cecb8649d0d$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $f8716cecb8649d0d$export$f41f3c05d8a4b8bf = function() {
    var _a, _UIModalStore_activeModal_accessor_storage, _UIModalStore_modalTitle_accessor_storage, _UIModalStore_attachmentUrl_accessor_storage, _UIModalStore_shouldBlockUI_accessor_storage;
    var _activeModal_decorators;
    var _activeModal_initializers = [];
    var _activeModal_extraInitializers = [];
    var _modalTitle_decorators;
    var _modalTitle_initializers = [];
    var _modalTitle_extraInitializers = [];
    var _attachmentUrl_decorators;
    var _attachmentUrl_initializers = [];
    var _attachmentUrl_extraInitializers = [];
    var _shouldBlockUI_decorators;
    var _shouldBlockUI_initializers = [];
    var _shouldBlockUI_extraInitializers = [];
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function UIModalStore() {
            (0, $19mwo._)(this, UIModalStore);
            Object.defineProperty(this, "onSelectIcon", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _UIModalStore_activeModal_accessor_storage.set(this, $f8716cecb8649d0d$var$__runInitializers(this, _activeModal_initializers, "None"));
            _UIModalStore_modalTitle_accessor_storage.set(this, ($f8716cecb8649d0d$var$__runInitializers(this, _activeModal_extraInitializers), $f8716cecb8649d0d$var$__runInitializers(this, _modalTitle_initializers, void 0)));
            _UIModalStore_attachmentUrl_accessor_storage.set(this, ($f8716cecb8649d0d$var$__runInitializers(this, _modalTitle_extraInitializers), $f8716cecb8649d0d$var$__runInitializers(this, _attachmentUrl_initializers, void 0)));
            _UIModalStore_shouldBlockUI_accessor_storage.set(this, ($f8716cecb8649d0d$var$__runInitializers(this, _attachmentUrl_extraInitializers), $f8716cecb8649d0d$var$__runInitializers(this, _shouldBlockUI_initializers, false)));
            $f8716cecb8649d0d$var$__runInitializers(this, _shouldBlockUI_extraInitializers);
        }
        (0, $6rpfc._)(UIModalStore, [
            {
                key: "openSelectIcon",
                value: function openSelectIcon(onSelect) {
                    this.onSelectIcon = onSelect;
                    this.modalTitle = "Icon Selection";
                    this.activeModal = "IconSelect";
                }
            },
            {
                key: "openContentFilter",
                value: function openContentFilter() {
                    this.modalTitle = "Filter";
                    this.activeModal = "ModalFilter";
                }
            },
            {
                key: "closeModal",
                value: function closeModal() {
                    this.activeModal = "None";
                }
            },
            {
                key: "reportIconSelected",
                value: function reportIconSelected(icon) {
                    if (icon != "") this.onSelectIcon(icon);
                    this.closeModal();
                }
            },
            {
                key: "openViewAttachment",
                value: function openViewAttachment(url) {
                    this.activeModal = "ViewAttachment";
                    this.modalTitle = "Attachment";
                    this.attachmentUrl = url;
                }
            },
            {
                key: "activeModal",
                get: function get() {
                    return $f8716cecb8649d0d$var$__classPrivateFieldGet(this, _UIModalStore_activeModal_accessor_storage, "f");
                },
                set: function set(value) {
                    $f8716cecb8649d0d$var$__classPrivateFieldSet(this, _UIModalStore_activeModal_accessor_storage, value, "f");
                }
            },
            {
                key: "modalTitle",
                get: function get() {
                    return $f8716cecb8649d0d$var$__classPrivateFieldGet(this, _UIModalStore_modalTitle_accessor_storage, "f");
                },
                set: function set(value) {
                    $f8716cecb8649d0d$var$__classPrivateFieldSet(this, _UIModalStore_modalTitle_accessor_storage, value, "f");
                }
            },
            {
                key: "attachmentUrl",
                get: function get() {
                    return $f8716cecb8649d0d$var$__classPrivateFieldGet(this, _UIModalStore_attachmentUrl_accessor_storage, "f");
                },
                set: function set(value) {
                    $f8716cecb8649d0d$var$__classPrivateFieldSet(this, _UIModalStore_attachmentUrl_accessor_storage, value, "f");
                }
            },
            {
                key: "shouldBlockUI",
                get: function get() {
                    return $f8716cecb8649d0d$var$__classPrivateFieldGet(this, _UIModalStore_shouldBlockUI_accessor_storage, "f");
                },
                set: function set(value) {
                    $f8716cecb8649d0d$var$__classPrivateFieldSet(this, _UIModalStore_shouldBlockUI_accessor_storage, value, "f");
                }
            }
        ]);
        return UIModalStore;
    }(), _UIModalStore_activeModal_accessor_storage = new WeakMap(), _UIModalStore_modalTitle_accessor_storage = new WeakMap(), _UIModalStore_attachmentUrl_accessor_storage = new WeakMap(), _UIModalStore_shouldBlockUI_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _activeModal_decorators = [
            (0, $b0lSM.observable)
        ];
        _modalTitle_decorators = [
            (0, $b0lSM.observable)
        ];
        _attachmentUrl_decorators = [
            (0, $b0lSM.observable)
        ];
        _shouldBlockUI_decorators = [
            (0, $b0lSM.observable)
        ];
        $f8716cecb8649d0d$var$__esDecorate(_a, null, _activeModal_decorators, {
            kind: "accessor",
            name: "activeModal",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "activeModal" in obj;
                },
                get: function(obj) {
                    return obj.activeModal;
                },
                set: function(obj, value) {
                    obj.activeModal = value;
                }
            },
            metadata: _metadata
        }, _activeModal_initializers, _activeModal_extraInitializers);
        $f8716cecb8649d0d$var$__esDecorate(_a, null, _modalTitle_decorators, {
            kind: "accessor",
            name: "modalTitle",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "modalTitle" in obj;
                },
                get: function(obj) {
                    return obj.modalTitle;
                },
                set: function(obj, value) {
                    obj.modalTitle = value;
                }
            },
            metadata: _metadata
        }, _modalTitle_initializers, _modalTitle_extraInitializers);
        $f8716cecb8649d0d$var$__esDecorate(_a, null, _attachmentUrl_decorators, {
            kind: "accessor",
            name: "attachmentUrl",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "attachmentUrl" in obj;
                },
                get: function(obj) {
                    return obj.attachmentUrl;
                },
                set: function(obj, value) {
                    obj.attachmentUrl = value;
                }
            },
            metadata: _metadata
        }, _attachmentUrl_initializers, _attachmentUrl_extraInitializers);
        $f8716cecb8649d0d$var$__esDecorate(_a, null, _shouldBlockUI_decorators, {
            kind: "accessor",
            name: "shouldBlockUI",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "shouldBlockUI" in obj;
                },
                get: function(obj) {
                    return obj.shouldBlockUI;
                },
                set: function(obj, value) {
                    obj.shouldBlockUI = value;
                }
            },
            metadata: _metadata
        }, _shouldBlockUI_initializers, _shouldBlockUI_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();



var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");
var $93a797117bb83aac$exports = {};
var $3c4f239e5505cdc5$exports = {};

$3c4f239e5505cdc5$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "airplane.b07f9698.svg";


var $c1b545d41ef75b1e$exports = {};

$c1b545d41ef75b1e$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "blender.9732f765.svg";


var $050191f3af4ffe74$exports = {};

$050191f3af4ffe74$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "book.97ef2b20.svg";


var $bcc0a3e96fcb099f$exports = {};

$bcc0a3e96fcb099f$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "box.96d04c1c.svg";


var $df865356e40767ec$exports = {};

$df865356e40767ec$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "cash.5b9abc2a.svg";


var $34f42d35c4006917$exports = {};

$34f42d35c4006917$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "clean-dishes.91faefab.svg";


var $a6d48207adeb124a$exports = {};

$a6d48207adeb124a$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "cleaning.5bdbcc87.svg";


var $9b2973e55daf8331$exports = {};

$9b2973e55daf8331$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "contract-paper.50aa3d30.svg";


var $907a53536c40a1dd$exports = {};

$907a53536c40a1dd$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "cooking.8af0186e.svg";


var $1f01f31970597969$exports = {};

$1f01f31970597969$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "default.5057ea51.svg";


var $048088d530febd84$exports = {};

$048088d530febd84$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "diary.f9c2383c.svg";


var $729a04a8b9db60d0$exports = {};

$729a04a8b9db60d0$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "doc.41e01ac4.svg";


var $1ed7f4ad32e3ef32$exports = {};

$1ed7f4ad32e3ef32$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "document.0db22646.svg";


var $2314d1101c0b8c95$exports = {};

$2314d1101c0b8c95$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "dog.6aad3b80.svg";


var $8558419bea02e56f$exports = {};

$8558419bea02e56f$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "dumbbell.9f4c4234.svg";


var $e3ab8efa586b4c05$exports = {};

$e3ab8efa586b4c05$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "finger-drums.3ee1ac06.svg";


var $3399f47a9140797b$exports = {};

$3399f47a9140797b$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "give-money.eb5078ad.svg";


var $64964d41c9cd01d5$exports = {};

$64964d41c9cd01d5$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "guitar.898e295b.svg";


var $41e5bb8988453e42$exports = {};

$41e5bb8988453e42$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "keyboard.8db02547.svg";


var $4f62219786cdac52$exports = {};

$4f62219786cdac52$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "meditation.c467a518.svg";


var $253e1fd12d83e0dc$exports = {};

$253e1fd12d83e0dc$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "microphone.2df700ee.svg";


var $ad60082013394667$exports = {};

$ad60082013394667$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "musical-note.3d47c7c6.svg";


var $6f3b81cfedec8ae5$exports = {};

$6f3b81cfedec8ae5$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "no.c6bf9c7e.svg";


var $c8220fdad21bb03e$exports = {};

$c8220fdad21bb03e$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "phone.08f9f5de.svg";


var $ab404c1903ce78e4$exports = {};

$ab404c1903ce78e4$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "piano.5491006d.svg";


var $7ef6d511b4faed5a$exports = {};

$7ef6d511b4faed5a$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "poi.46d21fb7.svg";


var $7ed8d3bf7bf6920a$exports = {};

$7ed8d3bf7bf6920a$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "roller-skates.c5dabf96.svg";


var $de38af426a94ff8b$exports = {};

$de38af426a94ff8b$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "select.4c90b477.svg";


var $23fef6dc3d7dccf7$exports = {};

$23fef6dc3d7dccf7$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "supermarket.18885ddc.svg";


var $fa9443cfd380be08$exports = {};

$fa9443cfd380be08$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "tasklist.997d737f.svg";


var $f1d5d25e2118d10e$exports = {};

$f1d5d25e2118d10e$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "work.b096f730.svg";


$93a797117bb83aac$exports = {
    "airplane": $3c4f239e5505cdc5$exports,
    "blender": $c1b545d41ef75b1e$exports,
    "book": $050191f3af4ffe74$exports,
    "box": $bcc0a3e96fcb099f$exports,
    "cash": $df865356e40767ec$exports,
    "clean-dishes": $34f42d35c4006917$exports,
    "cleaning": $a6d48207adeb124a$exports,
    "contract-paper": $9b2973e55daf8331$exports,
    "cooking": $907a53536c40a1dd$exports,
    "default": $1f01f31970597969$exports,
    "diary": $048088d530febd84$exports,
    "doc": $729a04a8b9db60d0$exports,
    "document": $1ed7f4ad32e3ef32$exports,
    "dog": $2314d1101c0b8c95$exports,
    "dumbbell": $8558419bea02e56f$exports,
    "finger-drums": $e3ab8efa586b4c05$exports,
    "give-money": $3399f47a9140797b$exports,
    "guitar": $64964d41c9cd01d5$exports,
    "keyboard": $41e5bb8988453e42$exports,
    "meditation": $4f62219786cdac52$exports,
    "microphone": $253e1fd12d83e0dc$exports,
    "musical-note": $ad60082013394667$exports,
    "no": $6f3b81cfedec8ae5$exports,
    "phone": $c8220fdad21bb03e$exports,
    "piano": $ab404c1903ce78e4$exports,
    "poi": $7ef6d511b4faed5a$exports,
    "roller-skates": $7ed8d3bf7bf6920a$exports,
    "select": $de38af426a94ff8b$exports,
    "supermarket": $23fef6dc3d7dccf7$exports,
    "tasklist": $fa9443cfd380be08$exports,
    "work": $f1d5d25e2118d10e$exports
};


var $eed63f1788d06139$exports = {};
var $a740b2b77f3e89ba$exports = {};

$a740b2b77f3e89ba$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "doc.41e01ac4.svg";


var $2043889fdeea23c2$exports = {};

$2043889fdeea23c2$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "pdf.ace48495.svg";


var $2d43ba66cd806124$exports = {};

$2d43ba66cd806124$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "txt.2f5185ca.svg";


$eed63f1788d06139$exports = {
    "doc": $a740b2b77f3e89ba$exports,
    "pdf": $2043889fdeea23c2$exports,
    "txt": $2d43ba66cd806124$exports
};


var $ee8dfbf5a380cb36$exports = {};
var $34f69aeb8b9f42ee$exports = {};

$34f69aeb8b9f42ee$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "Books.cd06b013.svg";


var $6ac3ea247f4fd835$exports = {};

$6ac3ea247f4fd835$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "default.8460baaf.svg";


var $47fe0667bee357e3$exports = {};

$47fe0667bee357e3$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "Link.7d742b42.svg";


var $5675c48294490770$exports = {};

$5675c48294490770$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "Movies.bf667b13.svg";


var $e97f6d24bfdd2f08$exports = {};

$e97f6d24bfdd2f08$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "Music.5d7ba4be.svg";


var $72738e01b9894adf$exports = {};

$72738e01b9894adf$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "PCGames.eb550560.svg";


var $920969c48c7255b0$exports = {};

$920969c48c7255b0$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "TVShows.bf667b13.svg";


$ee8dfbf5a380cb36$exports = {
    "Books": $34f69aeb8b9f42ee$exports,
    "default": $6ac3ea247f4fd835$exports,
    "Link": $47fe0667bee357e3$exports,
    "Movies": $5675c48294490770$exports,
    "Music": $e97f6d24bfdd2f08$exports,
    "PCGames": $72738e01b9894adf$exports,
    "TVShows": $920969c48c7255b0$exports
};


var $70ad5f884a2646d0$exports = {};
var $0c0fb18e0f352b05$exports = {};

$0c0fb18e0f352b05$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "back.d511f6a2.svg";


var $5f8569b148414ef3$exports = {};

$5f8569b148414ef3$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "camera.6b14872f.svg";


var $611958251111d895$exports = {};

$611958251111d895$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "content.ea43c5c5.svg";


var $9231a965887d1a61$exports = {};

$9231a965887d1a61$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "flip-camera.fc35a8ac.svg";


var $67a72ee69d9e10d2$exports = {};

$67a72ee69d9e10d2$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "heart-yes-filled.a58a8d73.svg";


var $e67ed9f8e3171c9f$exports = {};

$e67ed9f8e3171c9f$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "heart-yes.06fae020.svg";


var $d7354c77e0b4ea49$exports = {};

$d7354c77e0b4ea49$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "letter-t.b733db99.svg";


var $c0d999805e59cffe$exports = {};

$c0d999805e59cffe$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "loading.dc73db8c.svg";


var $08f4942916864b77$exports = {};

$08f4942916864b77$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "menu.21eb498b.svg";


var $647a91722a257b24$exports = {};

$647a91722a257b24$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "no.c6bf9c7e.svg";


var $a81ecc8d40b9a04c$exports = {};

$a81ecc8d40b9a04c$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "plus.fc3d1d52.svg";


var $db07fb9bba181263$exports = {};

$db07fb9bba181263$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "record.f0cc8e73.svg";


var $fdb5db4de60d0ac8$exports = {};

$fdb5db4de60d0ac8$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "saved.aafb74b2.svg";


var $f705841f4b55e405$exports = {};

$f705841f4b55e405$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "star.2dda531a.svg";


var $025823b09fb591a4$exports = {};

$025823b09fb591a4$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "stop-record.6656f686.svg";


var $24abc75c76b35152$exports = {};

$24abc75c76b35152$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "upload.364bfc8d.svg";


var $9605ae329add80ac$exports = {};

$9605ae329add80ac$exports = (parcelRequire("gIaEe")).getBundleURL("01RMl") + "yes.7dff4988.svg";


$70ad5f884a2646d0$exports = {
    "back": $0c0fb18e0f352b05$exports,
    "camera": $5f8569b148414ef3$exports,
    "content": $611958251111d895$exports,
    "flip-camera": $9231a965887d1a61$exports,
    "heart-yes-filled": $67a72ee69d9e10d2$exports,
    "heart-yes": $e67ed9f8e3171c9f$exports,
    "letter-t": $d7354c77e0b4ea49$exports,
    "loading": $c0d999805e59cffe$exports,
    "menu": $08f4942916864b77$exports,
    "no": $647a91722a257b24$exports,
    "plus": $a81ecc8d40b9a04c$exports,
    "record": $db07fb9bba181263$exports,
    "saved": $fdb5db4de60d0ac8$exports,
    "star": $f705841f4b55e405$exports,
    "stop-record": $025823b09fb591a4$exports,
    "upload": $24abc75c76b35152$exports,
    "yes": $9605ae329add80ac$exports
};


var $f38bbf47b43f06de$export$6b0e6d2de4623d33 = /*#__PURE__*/ function() {
    "use strict";
    function AssetsStore() {
        (0, $19mwo._)(this, AssetsStore);
        Object.defineProperty(this, "taskIcons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "docIcons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "contentIcons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "sysIcons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        this.setIcons();
    }
    (0, $6rpfc._)(AssetsStore, [
        {
            key: "getIconsAsList",
            value: function getIconsAsList(entries) {
                var l = {};
                Object.keys(entries).forEach(function(name) {
                    l[name] = {
                        name: name,
                        url: entries[name]
                    };
                });
                return l;
            }
        },
        {
            key: "setIcons",
            value: function setIcons() {
                this.taskIcons = this.getIconsAsList($93a797117bb83aac$exports);
                this.docIcons = this.getIconsAsList($eed63f1788d06139$exports);
                this.contentIcons = this.getIconsAsList($ee8dfbf5a380cb36$exports);
                this.sysIcons = this.getIconsAsList($70ad5f884a2646d0$exports);
            }
        },
        {
            key: "getTaskIconUrl",
            value: function getTaskIconUrl(iconName) {
                var icon = iconName == "" ? "default" : iconName;
                try {
                    return this.taskIcons[icon].url;
                } catch (_a) {
                    return this.taskIcons["default"].url;
                }
            }
        },
        {
            key: "getContentIconUrl",
            value: function getContentIconUrl(contentType) {
                if (this.contentIcons[contentType] == undefined) return this.contentIcons["default"].url;
                return this.contentIcons[contentType].url;
            }
        }
    ]);
    return AssetsStore;
}();



var $b0lSM = parcelRequire("b0lSM");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $b0lSM = parcelRequire("b0lSM");
var $712f9363716e1741$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $712f9363716e1741$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $712f9363716e1741$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $712f9363716e1741$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $712f9363716e1741$export$37d64a585fa0ddec = function() {
    var _a, _UIToasterStore_messages_accessor_storage;
    var _messages_decorators;
    var _messages_initializers = [];
    var _messages_extraInitializers = [];
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function UIToasterStore() {
            (0, $19mwo._)(this, UIToasterStore);
            Object.defineProperty(this, "runningId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 0
            });
            _UIToasterStore_messages_accessor_storage.set(this, $712f9363716e1741$var$__runInitializers(this, _messages_initializers, []));
            $712f9363716e1741$var$__runInitializers(this, _messages_extraInitializers);
        }
        (0, $6rpfc._)(UIToasterStore, [
            {
                key: "removeMessage",
                value: function removeMessage() {
                    this.messages.shift();
                }
            },
            {
                key: "messages",
                get: function get() {
                    return $712f9363716e1741$var$__classPrivateFieldGet(this, _UIToasterStore_messages_accessor_storage, "f");
                },
                set: function set(value) {
                    $712f9363716e1741$var$__classPrivateFieldSet(this, _UIToasterStore_messages_accessor_storage, value, "f");
                }
            },
            {
                key: "addMessage",
                value: function addMessage(message) {
                    var _this = this;
                    this.messages.push({
                        message: message,
                        id: this.runningId
                    });
                    this.runningId += 1;
                    setInterval(function() {
                        _this.removeMessage();
                    }, 5000);
                }
            }
        ]);
        return UIToasterStore;
    }(), _UIToasterStore_messages_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _messages_decorators = [
            (0, $b0lSM.observable)
        ];
        $712f9363716e1741$var$__esDecorate(_a, null, _messages_decorators, {
            kind: "accessor",
            name: "messages",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "messages" in obj;
                },
                get: function(obj) {
                    return obj.messages;
                },
                set: function(obj, value) {
                    obj.messages = value;
                }
            },
            metadata: _metadata
        }, _messages_initializers, _messages_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();



var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $b0lSM = parcelRequire("b0lSM");



var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $b0lSM = parcelRequire("b0lSM");

var $4a4682a89962fb1a$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $4a4682a89962fb1a$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $4a4682a89962fb1a$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $4a4682a89962fb1a$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $4a4682a89962fb1a$export$e9f05137ad0510d6 = function() {
    var _a, _TaskLogModel_id_accessor_storage, _TaskLogModel_when_accessor_storage, _TaskLogModel_comment_accessor_storage, _TaskLogModel_taskId_accessor_storage;
    var _id_decorators;
    var _id_initializers = [];
    var _id_extraInitializers = [];
    var _when_decorators;
    var _when_initializers = [];
    var _when_extraInitializers = [];
    var _comment_decorators;
    var _comment_initializers = [];
    var _comment_extraInitializers = [];
    var _taskId_decorators;
    var _taskId_initializers = [];
    var _taskId_extraInitializers = [];
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function TaskLogModel(id) {
            (0, $19mwo._)(this, TaskLogModel);
            _TaskLogModel_id_accessor_storage.set(this, $4a4682a89962fb1a$var$__runInitializers(this, _id_initializers, void 0));
            _TaskLogModel_when_accessor_storage.set(this, ($4a4682a89962fb1a$var$__runInitializers(this, _id_extraInitializers), $4a4682a89962fb1a$var$__runInitializers(this, _when_initializers, void 0)));
            _TaskLogModel_comment_accessor_storage.set(this, ($4a4682a89962fb1a$var$__runInitializers(this, _when_extraInitializers), $4a4682a89962fb1a$var$__runInitializers(this, _comment_initializers, void 0)));
            _TaskLogModel_taskId_accessor_storage.set(this, ($4a4682a89962fb1a$var$__runInitializers(this, _comment_extraInitializers), $4a4682a89962fb1a$var$__runInitializers(this, _taskId_initializers, void 0)));
            $4a4682a89962fb1a$var$__runInitializers(this, _taskId_extraInitializers);
            if (id) this.id = id;
        }
        (0, $6rpfc._)(TaskLogModel, [
            {
                key: "id",
                get: function get() {
                    return $4a4682a89962fb1a$var$__classPrivateFieldGet(this, _TaskLogModel_id_accessor_storage, "f");
                },
                set: function set(value) {
                    $4a4682a89962fb1a$var$__classPrivateFieldSet(this, _TaskLogModel_id_accessor_storage, value, "f");
                }
            },
            {
                key: "when",
                get: function get() {
                    return $4a4682a89962fb1a$var$__classPrivateFieldGet(this, _TaskLogModel_when_accessor_storage, "f");
                },
                set: function set(value) {
                    $4a4682a89962fb1a$var$__classPrivateFieldSet(this, _TaskLogModel_when_accessor_storage, value, "f");
                }
            },
            {
                key: "comment",
                get: function get() {
                    return $4a4682a89962fb1a$var$__classPrivateFieldGet(this, _TaskLogModel_comment_accessor_storage, "f");
                },
                set: function set(value) {
                    $4a4682a89962fb1a$var$__classPrivateFieldSet(this, _TaskLogModel_comment_accessor_storage, value, "f");
                }
            },
            {
                key: "taskId",
                get: function get() {
                    return $4a4682a89962fb1a$var$__classPrivateFieldGet(this, _TaskLogModel_taskId_accessor_storage, "f");
                },
                set: function set(value) {
                    $4a4682a89962fb1a$var$__classPrivateFieldSet(this, _TaskLogModel_taskId_accessor_storage, value, "f");
                }
            },
            {
                key: "set",
                value: function set(when, comment, taskId) {
                    this.when = when;
                    this.comment = comment;
                    this.taskId = taskId;
                }
            },
            {
                key: "toJS",
                value: function toJS() {
                    return {
                        comment: this.comment,
                        when: this.when,
                        id: this.id,
                        taskId: this.taskId
                    };
                }
            },
            {
                key: "fromJS",
                value: function fromJS(json) {
                    this.comment = json["comment"];
                    this.when = (0, $f70925294223df11$export$6b862160d295c8e)(json["when"]);
                    this.id = json["id"];
                    this.taskId = json["taskId"];
                    return this;
                }
            }
        ]);
        return TaskLogModel;
    }(), _TaskLogModel_id_accessor_storage = new WeakMap(), _TaskLogModel_when_accessor_storage = new WeakMap(), _TaskLogModel_comment_accessor_storage = new WeakMap(), _TaskLogModel_taskId_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _id_decorators = [
            (0, $b0lSM.observable)
        ];
        _when_decorators = [
            (0, $b0lSM.observable)
        ];
        _comment_decorators = [
            (0, $b0lSM.observable)
        ];
        _taskId_decorators = [
            (0, $b0lSM.observable)
        ];
        $4a4682a89962fb1a$var$__esDecorate(_a, null, _id_decorators, {
            kind: "accessor",
            name: "id",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "id" in obj;
                },
                get: function(obj) {
                    return obj.id;
                },
                set: function(obj, value) {
                    obj.id = value;
                }
            },
            metadata: _metadata
        }, _id_initializers, _id_extraInitializers);
        $4a4682a89962fb1a$var$__esDecorate(_a, null, _when_decorators, {
            kind: "accessor",
            name: "when",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "when" in obj;
                },
                get: function(obj) {
                    return obj.when;
                },
                set: function(obj, value) {
                    obj.when = value;
                }
            },
            metadata: _metadata
        }, _when_initializers, _when_extraInitializers);
        $4a4682a89962fb1a$var$__esDecorate(_a, null, _comment_decorators, {
            kind: "accessor",
            name: "comment",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "comment" in obj;
                },
                get: function(obj) {
                    return obj.comment;
                },
                set: function(obj, value) {
                    obj.comment = value;
                }
            },
            metadata: _metadata
        }, _comment_initializers, _comment_extraInitializers);
        $4a4682a89962fb1a$var$__esDecorate(_a, null, _taskId_decorators, {
            kind: "accessor",
            name: "taskId",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "taskId" in obj;
                },
                get: function(obj) {
                    return obj.taskId;
                },
                set: function(obj, value) {
                    obj.taskId = value;
                }
            },
            metadata: _metadata
        }, _taskId_initializers, _taskId_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();



var $7PvJn = parcelRequire("7PvJn");

var $544a6bbf19fedb51$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $544a6bbf19fedb51$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $544a6bbf19fedb51$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $544a6bbf19fedb51$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $544a6bbf19fedb51$export$4a17f8ea9ece003 = function() {
    var _a, _TaskLogEntries_entries_accessor_storage;
    var _entries_decorators;
    var _entries_initializers = [];
    var _entries_extraInitializers = [];
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function TaskLogEntries(taskId) {
            (0, $19mwo._)(this, TaskLogEntries);
            Object.defineProperty(this, "taskId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: taskId
            });
            Object.defineProperty(this, "global_path", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: [
                    "logs"
                ]
            });
            _TaskLogEntries_entries_accessor_storage.set(this, $544a6bbf19fedb51$var$__runInitializers(this, _entries_initializers, []));
            $544a6bbf19fedb51$var$__runInitializers(this, _entries_extraInitializers);
            this.taskId = taskId;
        }
        (0, $6rpfc._)(TaskLogEntries, [
            {
                key: "entries",
                get: function get() {
                    return $544a6bbf19fedb51$var$__classPrivateFieldGet(this, _TaskLogEntries_entries_accessor_storage, "f");
                },
                set: function set(value) {
                    $544a6bbf19fedb51$var$__classPrivateFieldSet(this, _TaskLogEntries_entries_accessor_storage, value, "f");
                }
            },
            {
                key: "addEntry",
                value: function addEntry(when, comment) {
                    var newId = (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().generateId(this.global_path);
                    var e = new (0, $4a4682a89962fb1a$export$e9f05137ad0510d6)(newId);
                    e.set(when, comment, this.taskId);
                    (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().saveDoc(this.global_path, e);
                }
            },
            {
                key: "removeEntry",
                value: function removeEntry(id) {
                    (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().deleteData(this.global_path, id);
                }
            }
        ]);
        return TaskLogEntries;
    }(), _TaskLogEntries_entries_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _entries_decorators = [
            (0, $b0lSM.observable)
        ];
        $544a6bbf19fedb51$var$__esDecorate(_a, null, _entries_decorators, {
            kind: "accessor",
            name: "entries",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "entries" in obj;
                },
                get: function(obj) {
                    return obj.entries;
                },
                set: function(obj, value) {
                    obj.entries = value;
                }
            },
            metadata: _metadata
        }, _entries_initializers, _entries_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $544a6bbf19fedb51$export$6a933480d228a1bd = function() {
    var _a, _TasksLogStore_entries_accessor_storage;
    var _instanceExtraInitializers = [];
    var _entries_decorators;
    var _entries_initializers = [];
    var _entries_extraInitializers = [];
    var _get_weeklyStats_decorators;
    var _get_todoTasks_decorators;
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function TasksLogStore() {
            (0, $19mwo._)(this, TasksLogStore);
            _TasksLogStore_entries_accessor_storage.set(this, ($544a6bbf19fedb51$var$__runInitializers(this, _instanceExtraInitializers), $544a6bbf19fedb51$var$__runInitializers(this, _entries_initializers, [])));
            Object.defineProperty(this, "logInstances", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($544a6bbf19fedb51$var$__runInitializers(this, _entries_extraInitializers), {})
            });
        }
        (0, $6rpfc._)(TasksLogStore, [
            {
                key: "entries",
                get: function get() {
                    return $544a6bbf19fedb51$var$__classPrivateFieldGet(this, _TasksLogStore_entries_accessor_storage, "f");
                },
                set: function set(value) {
                    $544a6bbf19fedb51$var$__classPrivateFieldSet(this, _TasksLogStore_entries_accessor_storage, value, "f");
                }
            },
            {
                key: "getTaskLogs",
                value: function getTaskLogs(taskId) {
                    if (!this.logInstances[taskId]) this.logInstances[taskId] = new $544a6bbf19fedb51$export$4a17f8ea9ece003(taskId);
                    return this.logInstances[taskId];
                }
            },
            {
                key: "weeklyStats",
                get: function get() {
                    var _this = this, _loop = function() {
                        var oneTimeList = {};
                        var current = (0, (/*@__PURE__*/$parcel$interopDefault($7PvJn)))(new Date());
                        var d = current.subtract(i, "days");
                        var on_the_day = _this.entries.filter(function(entry) {
                            var task = tasks.get(entry.taskId);
                            var sameDay = d.isSame((0, (/*@__PURE__*/$parcel$interopDefault($7PvJn)))(entry.when), "day");
                            if (sameDay && task) {
                                if (task.type == (0, $f858d6a97cc5c220$export$1f8b1cab05cab788).ONE_TIME) {
                                    oneTimeList[entry.taskId] = entry;
                                    return false;
                                }
                            }
                            return sameDay;
                        });
                        for(var oneTimeEntry in oneTimeList)if (tasks.get(oneTimeEntry).state == (0, $f858d6a97cc5c220$export$dcf4d221b45abc27).COMPLETE) on_the_day.push(oneTimeList[oneTimeEntry]);
                        weekly.push({
                            date: d.toDate(),
                            list: on_the_day
                        });
                    };
                    var l = (0, $b0lSM.values)(this.entries);
                    var weekly = [];
                    var tasks = (0, $3a3345637c0a5d6f$export$ed5c3368304694)();
                    for(var i = 0; i < 3; i++)_loop();
                    return weekly.reverse();
                }
            },
            {
                key: "todoTasks",
                get: function get() {
                    return "";
                }
            },
            {
                key: "init",
                value: function init() {
                    var _this = this;
                    (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().listenData([
                        "logs"
                    ], function(data) {
                        if (_this.entries.length > data.length) {
                            _this.entries = [];
                            for(var key in _this.logInstances)_this.logInstances[key].entries = [];
                        }
                        var newEntries = data.filter(function(e) {
                            return _this.entries.findIndex(function(e2) {
                                return e2.id == e.id;
                            }) == -1;
                        });
                        _this.entries = data;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = newEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var entry = _step.value;
                                var instance = _this.getTaskLogs(entry.taskId);
                                instance.entries.push(entry);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }, (0, $4a4682a89962fb1a$export$e9f05137ad0510d6));
                }
            }
        ]);
        return TasksLogStore;
    }(), _TasksLogStore_entries_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _entries_decorators = [
            (0, $b0lSM.observable)
        ];
        _get_weeklyStats_decorators = [
            (0, $b0lSM.computed)
        ];
        _get_todoTasks_decorators = [
            (0, $b0lSM.computed)
        ];
        $544a6bbf19fedb51$var$__esDecorate(_a, null, _entries_decorators, {
            kind: "accessor",
            name: "entries",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "entries" in obj;
                },
                get: function(obj) {
                    return obj.entries;
                },
                set: function(obj, value) {
                    obj.entries = value;
                }
            },
            metadata: _metadata
        }, _entries_initializers, _entries_extraInitializers);
        $544a6bbf19fedb51$var$__esDecorate(_a, null, _get_weeklyStats_decorators, {
            kind: "getter",
            name: "weeklyStats",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "weeklyStats" in obj;
                },
                get: function(obj) {
                    return obj.weeklyStats;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $544a6bbf19fedb51$var$__esDecorate(_a, null, _get_todoTasks_decorators, {
            kind: "getter",
            name: "todoTasks",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "todoTasks" in obj;
                },
                get: function(obj) {
                    return obj.todoTasks;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();


//FUTURE PULL UPDATES IN SERVICE!

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");
var $3f6316cccd323689$export$da4c4d4307140b47 = /*#__PURE__*/ function() {
    "use strict";
    function CacheStore() {
        (0, $19mwo._)(this, CacheStore);
    }
    (0, $6rpfc._)(CacheStore, [
        {
            key: "store",
            value: function store(cacheKey, snapshot) {
                localStorage.setItem(cacheKey, JSON.stringify(snapshot));
            // const wb = useWorkbox();
            }
        },
        {
            key: "get",
            value: function get(cacheKey) {
                if (localStorage.getItem(cacheKey)) return JSON.parse(localStorage.getItem(cacheKey));
                return null;
            }
        },
        {
            key: "has",
            value: function has(cacheKey) {
                return localStorage.getItem(cacheKey) != null;
            }
        }
    ]);
    return CacheStore;
}();



var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $lF1I7 = parcelRequire("lF1I7");



var $b0lSM = parcelRequire("b0lSM");


var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $lF1I7 = parcelRequire("lF1I7");

var $hpryi = parcelRequire("hpryi");

var $7PvJn = parcelRequire("7PvJn");
var $4f2acfc9d63b8383$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4f2acfc9d63b8383$var$API_SERVER = "https://api.ifgoodyes.com";
var $4f2acfc9d63b8383$var$MOVIE_GENRES = {
    "genres": [
        {
            "id": 28,
            "name": "Action"
        },
        {
            "id": 12,
            "name": "Adventure"
        },
        {
            "id": 16,
            "name": "Animation"
        },
        {
            "id": 35,
            "name": "Comedy"
        },
        {
            "id": 80,
            "name": "Crime"
        },
        {
            "id": 99,
            "name": "Documentary"
        },
        {
            "id": 18,
            "name": "Drama"
        },
        {
            "id": 10751,
            "name": "Family"
        },
        {
            "id": 14,
            "name": "Fantasy"
        },
        {
            "id": 36,
            "name": "History"
        },
        {
            "id": 27,
            "name": "Horror"
        },
        {
            "id": 10402,
            "name": "Music"
        },
        {
            "id": 9648,
            "name": "Mystery"
        },
        {
            "id": 10749,
            "name": "Romance"
        },
        {
            "id": 878,
            "name": "Science Fiction"
        },
        {
            "id": 10770,
            "name": "TV Movie"
        },
        {
            "id": 53,
            "name": "Thriller"
        },
        {
            "id": 10752,
            "name": "War"
        },
        {
            "id": 37,
            "name": "Western"
        }
    ]
};
var $4f2acfc9d63b8383$var$TV_GENRES = {
    "genres": [
        {
            "id": 10759,
            "name": "Action & Adventure"
        },
        {
            "id": 16,
            "name": "Animation"
        },
        {
            "id": 35,
            "name": "Comedy"
        },
        {
            "id": 80,
            "name": "Crime"
        },
        {
            "id": 99,
            "name": "Documentary"
        },
        {
            "id": 18,
            "name": "Drama"
        },
        {
            "id": 10751,
            "name": "Family"
        },
        {
            "id": 10762,
            "name": "Kids"
        },
        {
            "id": 9648,
            "name": "Mystery"
        },
        {
            "id": 10763,
            "name": "News"
        },
        {
            "id": 10764,
            "name": "Reality"
        },
        {
            "id": 10765,
            "name": "Sci-Fi & Fantasy"
        },
        {
            "id": 10766,
            "name": "Soap"
        },
        {
            "id": 10767,
            "name": "Talk"
        },
        {
            "id": 10768,
            "name": "War & Politics"
        },
        {
            "id": 37,
            "name": "Western"
        }
    ]
};
var $4f2acfc9d63b8383$export$11ad87743f4e83a2 = /*#__PURE__*/ function() {
    "use strict";
    function PreviewFetcher() {
        (0, $19mwo._)(this, PreviewFetcher);
    }
    (0, $6rpfc._)(PreviewFetcher, [
        {
            //https://api.themoviedb.org/3/search/tv
            key: "enhanceMovie",
            value: function enhanceMovie(movie, content) {
                return $4f2acfc9d63b8383$var$__awaiter(this, void 0, void 0, function() {
                    var api, url;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                api = "https://api.themoviedb.org/3/search/movie?query={SEARCH}&include_adult=true&language=en-US&page=1&region=US";
                                url = api.replace("{SEARCH}", movie);
                                return [
                                    4,
                                    this.enhanceWithTMDB(url, $4f2acfc9d63b8383$var$MOVIE_GENRES, content)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "enhanceBookCover",
            value: function enhanceBookCover(book, content) {
                return $4f2acfc9d63b8383$var$__awaiter(this, void 0, void 0, function() {
                    var api, url, http, res;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                api = "https://www.googleapis.com/books/v1/volumes?q={BOOK}&maxResults=1";
                                url = api.replace("{BOOK}", book);
                                http = new (0, $hpryi.HTTPClient)();
                                return [
                                    4,
                                    http.get(url, {
                                        accept: "application/json"
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                try {
                                    content.thumbnailURL = res.body.items[0].volumeInfo.imageLinks.thumbnail;
                                    return [
                                        2,
                                        true
                                    ];
                                } catch (e) {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "enhanveTvShow",
            value: function enhanveTvShow(tvShow, content) {
                return $4f2acfc9d63b8383$var$__awaiter(this, void 0, void 0, function() {
                    var api, url;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                api = "https://api.themoviedb.org/3/search/tv?query={SEARCH}&include_adult=true&language=en-US&page=1&region=US";
                                url = api.replace("{SEARCH}", tvShow);
                                return [
                                    4,
                                    this.enhanceWithTMDB(url, $4f2acfc9d63b8383$var$TV_GENRES, content)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "enhanceMusicArtist",
            value: function enhanceMusicArtist(artist, content) {
                return $4f2acfc9d63b8383$var$__awaiter(this, void 0, void 0, function() {
                    var api, http, res, r, e;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                api = "".concat($4f2acfc9d63b8383$var$API_SERVER, "/rest/data/getArtist?artist=").concat(artist);
                                http = new (0, $hpryi.HTTPClient)();
                                return [
                                    4,
                                    http.get(api)
                                ];
                            case 1:
                                res = _state.sent();
                                r = res.body;
                                content.thumbnailURL = r;
                                return [
                                    2,
                                    true
                                ];
                            case 2:
                                e = _state.sent();
                                return [
                                    2,
                                    false
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "enhanceGame",
            value: function enhanceGame(game, content) {
                return $4f2acfc9d63b8383$var$__awaiter(this, void 0, void 0, function() {
                    var api, http, res, r, e;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                api = "".concat($4f2acfc9d63b8383$var$API_SERVER, "/rest/data/getGameCover?game=").concat(game);
                                http = new (0, $hpryi.HTTPClient)();
                                return [
                                    4,
                                    http.get(api)
                                ];
                            case 1:
                                res = _state.sent();
                                r = JSON.parse(res.body);
                                content.thumbnailURL = r.thumbnail;
                                content.overview = r.summary; // + '\r\n' + r.storyline;
                                return [
                                    2,
                                    true
                                ];
                            case 2:
                                e = _state.sent();
                                return [
                                    2,
                                    false
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "enhanceWithTMDB",
            value: function enhanceWithTMDB(url, genreTable, content) {
                return $4f2acfc9d63b8383$var$__awaiter(this, void 0, void 0, function() {
                    var _this, token, client, res, r, baseURL, date, fields;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                token = "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJkNjMyNGFhZjhkYWU3ZTk3N2MxYjU1ZmZjYzAxOGMyZiIsIm5iZiI6MTcyMzg4NTM4NS44NjQ2OSwic3ViIjoiNjZjMDY2YmY3NDEzOGUxMGQ3MDNiYjI5Iiwic2NvcGVzIjpbImFwaV9yZWFkIl0sInZlcnNpb24iOjF9.QuWDtdToxlNI-uBybJpUJA780EvZl1gVYUXVVJxy8-c";
                                client = new (0, $hpryi.HTTPClient)().use(function(_a, next_1) {
                                    return $4f2acfc9d63b8383$var$__awaiter(_this, [
                                        _a,
                                        next_1
                                    ], void 0, function(param, next) {
                                        var _param_request, method, path, headers, response;
                                        return (0, $lF1I7.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _param_request = param.request, method = _param_request.method, path = _param_request.path, headers = _param_request.headers, response = param.response;
                                                    if (token) headers["Authorization"] = "token " + token;
                                                    return [
                                                        4,
                                                        next()
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                });
                                return [
                                    4,
                                    client.get(url, {
                                        accept: "application/json"
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                try {
                                    r = res.body.results[0];
                                    baseURL = "https://image.tmdb.org/t/p/w500";
                                    date = r.release_date || r.first_air_date;
                                    fields = {
                                        poster: baseURL + r.poster_path,
                                        genres: r.genre_ids.map(function(g) {
                                            return genreTable.genres.find(function(x) {
                                                return x.id == g;
                                            }).name;
                                        }),
                                        overview: r.overview,
                                        vote_average: r.vote_average
                                    };
                                    content.releaseDate = date ? (0, (/*@__PURE__*/$parcel$interopDefault($7PvJn)))(date).toDate() : null;
                                    content.thumbnailURL = fields.poster;
                                    content.genres = fields.genres;
                                    content.overview = fields.overview;
                                    return [
                                        2,
                                        true
                                    ];
                                } catch (e) {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return PreviewFetcher;
}();


var $ddcb476d90fa761b$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ddcb476d90fa761b$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ddcb476d90fa761b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ddcb476d90fa761b$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ddcb476d90fa761b$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $ddcb476d90fa761b$export$8536aa4ab0b165e5 = function() {
    var _a, _ListContentEntry_id_accessor_storage, _ListContentEntry_name_accessor_storage, _ListContentEntry_categoryId_accessor_storage, _ListContentEntry_watchSoon_accessor_storage, _ListContentEntry_created_accessor_storage, _ListContentEntry_genres_accessor_storage, _ListContentEntry_url_accessor_storage, _ListContentEntry_creators_accessor_storage, _ListContentEntry_thumbnailURL_accessor_storage, _ListContentEntry_releaseDate_accessor_storage, _ListContentEntry_overview_accessor_storage, _ListContentEntry_user_rating_accessor_storage, _ListContentEntry_user_notes_accessor_storage, _ListContentEntry_user_dating_date_accessor_storage;
    var _instanceExtraInitializers = [];
    var _id_decorators;
    var _id_initializers = [];
    var _id_extraInitializers = [];
    var _name_decorators;
    var _name_initializers = [];
    var _name_extraInitializers = [];
    var _categoryId_decorators;
    var _categoryId_initializers = [];
    var _categoryId_extraInitializers = [];
    var _watchSoon_decorators;
    var _watchSoon_initializers = [];
    var _watchSoon_extraInitializers = [];
    var _get_category_decorators;
    var _created_decorators;
    var _created_initializers = [];
    var _created_extraInitializers = [];
    var _genres_decorators;
    var _genres_initializers = [];
    var _genres_extraInitializers = [];
    var _url_decorators;
    var _url_initializers = [];
    var _url_extraInitializers = [];
    var _creators_decorators;
    var _creators_initializers = [];
    var _creators_extraInitializers = [];
    var _thumbnailURL_decorators;
    var _thumbnailURL_initializers = [];
    var _thumbnailURL_extraInitializers = [];
    var _releaseDate_decorators;
    var _releaseDate_initializers = [];
    var _releaseDate_extraInitializers = [];
    var _overview_decorators;
    var _overview_initializers = [];
    var _overview_extraInitializers = [];
    var _user_rating_decorators;
    var _user_rating_initializers = [];
    var _user_rating_extraInitializers = [];
    var _user_notes_decorators;
    var _user_notes_initializers = [];
    var _user_notes_extraInitializers = [];
    var _user_dating_date_decorators;
    var _user_dating_date_initializers = [];
    var _user_dating_date_extraInitializers = [];
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function ListContentEntry() {
            (0, $19mwo._)(this, ListContentEntry);
            _ListContentEntry_id_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _instanceExtraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _id_initializers, void 0)));
            _ListContentEntry_name_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _id_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _name_initializers, void 0)));
            _ListContentEntry_categoryId_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _name_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _categoryId_initializers, void 0)));
            _ListContentEntry_watchSoon_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _categoryId_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _watchSoon_initializers, false)));
            _ListContentEntry_created_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _watchSoon_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _created_initializers, new Date())));
            _ListContentEntry_genres_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _created_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _genres_initializers, [])));
            _ListContentEntry_url_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _genres_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _url_initializers, "")));
            _ListContentEntry_creators_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _url_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _creators_initializers, [])));
            _ListContentEntry_thumbnailURL_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _creators_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _thumbnailURL_initializers, "")));
            _ListContentEntry_releaseDate_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _thumbnailURL_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _releaseDate_initializers, new Date())));
            _ListContentEntry_overview_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _releaseDate_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _overview_initializers, "")));
            _ListContentEntry_user_rating_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _overview_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _user_rating_initializers, -1)));
            _ListContentEntry_user_notes_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _user_rating_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _user_notes_initializers, "")));
            _ListContentEntry_user_dating_date_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _user_notes_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _user_dating_date_initializers, null)));
            $ddcb476d90fa761b$var$__runInitializers(this, _user_dating_date_extraInitializers);
            this.id = (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().generateId(_a.PATH);
        }
        (0, $6rpfc._)(ListContentEntry, [
            {
                key: "id",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListContentEntry_id_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListContentEntry_id_accessor_storage, value, "f");
                }
            },
            {
                key: "name",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListContentEntry_name_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListContentEntry_name_accessor_storage, value, "f");
                }
            },
            {
                key: "categoryId",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListContentEntry_categoryId_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListContentEntry_categoryId_accessor_storage, value, "f");
                }
            },
            {
                key: "watchSoon",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListContentEntry_watchSoon_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListContentEntry_watchSoon_accessor_storage, value, "f");
                }
            },
            {
                key: "category",
                get: function get() {
                    var _this = this;
                    var _b;
                    var lists = (0, $3a3345637c0a5d6f$export$3b5bae399c8431fb)();
                    var category = lists.categories.find(function(c) {
                        return c.id == _this.categoryId;
                    });
                    return (_b = category === null || category === void 0 ? void 0 : category.name) !== null && _b !== void 0 ? _b : "";
                }
            },
            {
                key: "created",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListContentEntry_created_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListContentEntry_created_accessor_storage, value, "f");
                }
            },
            {
                key: "genres",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListContentEntry_genres_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListContentEntry_genres_accessor_storage, value, "f");
                }
            },
            {
                key: "url",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListContentEntry_url_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListContentEntry_url_accessor_storage, value, "f");
                }
            },
            {
                key: "creators",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListContentEntry_creators_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListContentEntry_creators_accessor_storage, value, "f");
                }
            },
            {
                key: "thumbnailURL",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListContentEntry_thumbnailURL_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListContentEntry_thumbnailURL_accessor_storage, value, "f");
                }
            },
            {
                key: "releaseDate",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListContentEntry_releaseDate_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListContentEntry_releaseDate_accessor_storage, value, "f");
                }
            },
            {
                key: "overview",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListContentEntry_overview_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListContentEntry_overview_accessor_storage, value, "f");
                }
            },
            {
                key: "user_rating",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListContentEntry_user_rating_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListContentEntry_user_rating_accessor_storage, value, "f");
                }
            },
            {
                key: "user_notes",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListContentEntry_user_notes_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListContentEntry_user_notes_accessor_storage, value, "f");
                }
            },
            {
                key: "user_dating_date",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListContentEntry_user_dating_date_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListContentEntry_user_dating_date_accessor_storage, value, "f");
                }
            },
            {
                key: "save",
                value: function save() {
                    return $ddcb476d90fa761b$var$__awaiter(this, void 0, void 0, function() {
                        var d;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.tryToEnhance()
                                    ];
                                case 1:
                                    _state.sent();
                                    d = this;
                                    return [
                                        2,
                                        (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().saveDoc(_a.PATH, d)
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "delete",
                value: function _delete() {
                    return $ddcb476d90fa761b$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            return [
                                2,
                                (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().deleteData(_a.PATH, this.id)
                            ];
                        });
                    });
                }
            },
            {
                key: "tryToEnhance",
                value: function tryToEnhance() {
                    return $ddcb476d90fa761b$var$__awaiter(this, void 0, void 0, function() {
                        var prevFetch, url, didEnhance, _;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    prevFetch = new (0, $4f2acfc9d63b8383$export$11ad87743f4e83a2)();
                                    url = null;
                                    didEnhance = false;
                                    _ = this.category;
                                    switch(_){
                                        case "Movies":
                                            return [
                                                3,
                                                1
                                            ];
                                        case "TVShows":
                                            return [
                                                3,
                                                3
                                            ];
                                        case "Books":
                                            return [
                                                3,
                                                5
                                            ];
                                        case "Music":
                                            return [
                                                3,
                                                7
                                            ];
                                        case "PCGames":
                                            return [
                                                3,
                                                9
                                            ];
                                    }
                                    return [
                                        3,
                                        11
                                    ];
                                case 1:
                                    return [
                                        4,
                                        prevFetch.enhanceMovie(this.name, this)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        3,
                                        11
                                    ];
                                case 3:
                                    return [
                                        4,
                                        prevFetch.enhanveTvShow(this.name, this)
                                    ];
                                case 4:
                                    _state.sent();
                                    return [
                                        3,
                                        11
                                    ];
                                case 5:
                                    return [
                                        4,
                                        prevFetch.enhanceBookCover(this.name, this)
                                    ];
                                case 6:
                                    _state.sent();
                                    return [
                                        3,
                                        11
                                    ];
                                case 7:
                                    return [
                                        4,
                                        prevFetch.enhanceMusicArtist(this.name, this)
                                    ];
                                case 8:
                                    _state.sent();
                                    return [
                                        3,
                                        11
                                    ];
                                case 9:
                                    return [
                                        4,
                                        prevFetch.enhanceGame(this.name, this)
                                    ];
                                case 10:
                                    _state.sent();
                                    return [
                                        3,
                                        11
                                    ];
                                case 11:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "toJS",
                value: function toJS() {
                    return {
                        id: this.id,
                        name: this.name,
                        categoryId: this.categoryId,
                        genres: this.genres,
                        url: this.url,
                        creators: this.creators,
                        releaseDate: this.releaseDate,
                        thumbnailURL: this.thumbnailURL,
                        created: this.created,
                        overview: this.overview,
                        user_rating: this.user_rating,
                        user_notes: this.user_notes,
                        user_dating_date: this.user_dating_date,
                        watchSoon: this.watchSoon
                    };
                }
            },
            {
                key: "fromJS",
                value: function fromJS(json) {
                    var _b, _c, _d, _e, _f, _g, _h, _j;
                    this.id = json["id"];
                    this.name = json["name"];
                    this.categoryId = json["categoryId"];
                    this.genres = (_b = json["genres"]) !== null && _b !== void 0 ? _b : [];
                    this.url = (_c = json["url"]) !== null && _c !== void 0 ? _c : "";
                    this.creators = (_d = json["creators"]) !== null && _d !== void 0 ? _d : [];
                    this.overview = (_e = json["overview"]) !== null && _e !== void 0 ? _e : "";
                    this.user_notes = (_f = json["user_notes"]) !== null && _f !== void 0 ? _f : "";
                    this.user_rating = (_g = json["user_rating"]) !== null && _g !== void 0 ? _g : -1;
                    this.watchSoon = (_h = json["watchSoon"]) !== null && _h !== void 0 ? _h : false;
                    if (json["releaseDate"]) this.releaseDate = (0, $f70925294223df11$export$6b862160d295c8e)(json["releaseDate"]);
                    else this.releaseDate = null;
                    if (json["user_dating_date"]) this.user_dating_date = (0, $f70925294223df11$export$6b862160d295c8e)(json["user_dating_date"]);
                    else this.user_dating_date = null;
                    this.thumbnailURL = (_j = json["thumbnailURL"]) !== null && _j !== void 0 ? _j : null;
                    if (json["created"]) this.created = (0, $f70925294223df11$export$6b862160d295c8e)(json["created"]);
                    else this.created = new Date();
                    if (json["created"]) this.created = (0, $f70925294223df11$export$6b862160d295c8e)(json["created"]);
                    else this.created = new Date();
                    return this;
                }
            }
        ]);
        return ListContentEntry;
    }(), _ListContentEntry_id_accessor_storage = new WeakMap(), _ListContentEntry_name_accessor_storage = new WeakMap(), _ListContentEntry_categoryId_accessor_storage = new WeakMap(), _ListContentEntry_watchSoon_accessor_storage = new WeakMap(), _ListContentEntry_created_accessor_storage = new WeakMap(), _ListContentEntry_genres_accessor_storage = new WeakMap(), _ListContentEntry_url_accessor_storage = new WeakMap(), _ListContentEntry_creators_accessor_storage = new WeakMap(), _ListContentEntry_thumbnailURL_accessor_storage = new WeakMap(), _ListContentEntry_releaseDate_accessor_storage = new WeakMap(), _ListContentEntry_overview_accessor_storage = new WeakMap(), _ListContentEntry_user_rating_accessor_storage = new WeakMap(), _ListContentEntry_user_notes_accessor_storage = new WeakMap(), _ListContentEntry_user_dating_date_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _id_decorators = [
            (0, $b0lSM.observable)
        ];
        _name_decorators = [
            (0, $b0lSM.observable)
        ];
        _categoryId_decorators = [
            (0, $b0lSM.observable)
        ];
        _watchSoon_decorators = [
            (0, $b0lSM.observable)
        ];
        _get_category_decorators = [
            (0, $b0lSM.computed)
        ];
        _created_decorators = [
            (0, $b0lSM.observable)
        ];
        _genres_decorators = [
            (0, $b0lSM.observable)
        ];
        _url_decorators = [
            (0, $b0lSM.observable)
        ];
        _creators_decorators = [
            (0, $b0lSM.observable)
        ];
        _thumbnailURL_decorators = [
            (0, $b0lSM.observable)
        ];
        _releaseDate_decorators = [
            (0, $b0lSM.observable)
        ];
        _overview_decorators = [
            (0, $b0lSM.observable)
        ];
        _user_rating_decorators = [
            (0, $b0lSM.observable)
        ];
        _user_notes_decorators = [
            (0, $b0lSM.observable)
        ];
        _user_dating_date_decorators = [
            (0, $b0lSM.observable)
        ];
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _id_decorators, {
            kind: "accessor",
            name: "id",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "id" in obj;
                },
                get: function(obj) {
                    return obj.id;
                },
                set: function(obj, value) {
                    obj.id = value;
                }
            },
            metadata: _metadata
        }, _id_initializers, _id_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _name_decorators, {
            kind: "accessor",
            name: "name",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "name" in obj;
                },
                get: function(obj) {
                    return obj.name;
                },
                set: function(obj, value) {
                    obj.name = value;
                }
            },
            metadata: _metadata
        }, _name_initializers, _name_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _categoryId_decorators, {
            kind: "accessor",
            name: "categoryId",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "categoryId" in obj;
                },
                get: function(obj) {
                    return obj.categoryId;
                },
                set: function(obj, value) {
                    obj.categoryId = value;
                }
            },
            metadata: _metadata
        }, _categoryId_initializers, _categoryId_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _watchSoon_decorators, {
            kind: "accessor",
            name: "watchSoon",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "watchSoon" in obj;
                },
                get: function(obj) {
                    return obj.watchSoon;
                },
                set: function(obj, value) {
                    obj.watchSoon = value;
                }
            },
            metadata: _metadata
        }, _watchSoon_initializers, _watchSoon_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _get_category_decorators, {
            kind: "getter",
            name: "category",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "category" in obj;
                },
                get: function(obj) {
                    return obj.category;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _created_decorators, {
            kind: "accessor",
            name: "created",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "created" in obj;
                },
                get: function(obj) {
                    return obj.created;
                },
                set: function(obj, value) {
                    obj.created = value;
                }
            },
            metadata: _metadata
        }, _created_initializers, _created_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _genres_decorators, {
            kind: "accessor",
            name: "genres",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "genres" in obj;
                },
                get: function(obj) {
                    return obj.genres;
                },
                set: function(obj, value) {
                    obj.genres = value;
                }
            },
            metadata: _metadata
        }, _genres_initializers, _genres_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _url_decorators, {
            kind: "accessor",
            name: "url",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "url" in obj;
                },
                get: function(obj) {
                    return obj.url;
                },
                set: function(obj, value) {
                    obj.url = value;
                }
            },
            metadata: _metadata
        }, _url_initializers, _url_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _creators_decorators, {
            kind: "accessor",
            name: "creators",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "creators" in obj;
                },
                get: function(obj) {
                    return obj.creators;
                },
                set: function(obj, value) {
                    obj.creators = value;
                }
            },
            metadata: _metadata
        }, _creators_initializers, _creators_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _thumbnailURL_decorators, {
            kind: "accessor",
            name: "thumbnailURL",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "thumbnailURL" in obj;
                },
                get: function(obj) {
                    return obj.thumbnailURL;
                },
                set: function(obj, value) {
                    obj.thumbnailURL = value;
                }
            },
            metadata: _metadata
        }, _thumbnailURL_initializers, _thumbnailURL_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _releaseDate_decorators, {
            kind: "accessor",
            name: "releaseDate",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "releaseDate" in obj;
                },
                get: function(obj) {
                    return obj.releaseDate;
                },
                set: function(obj, value) {
                    obj.releaseDate = value;
                }
            },
            metadata: _metadata
        }, _releaseDate_initializers, _releaseDate_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _overview_decorators, {
            kind: "accessor",
            name: "overview",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "overview" in obj;
                },
                get: function(obj) {
                    return obj.overview;
                },
                set: function(obj, value) {
                    obj.overview = value;
                }
            },
            metadata: _metadata
        }, _overview_initializers, _overview_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _user_rating_decorators, {
            kind: "accessor",
            name: "user_rating",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "user_rating" in obj;
                },
                get: function(obj) {
                    return obj.user_rating;
                },
                set: function(obj, value) {
                    obj.user_rating = value;
                }
            },
            metadata: _metadata
        }, _user_rating_initializers, _user_rating_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _user_notes_decorators, {
            kind: "accessor",
            name: "user_notes",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "user_notes" in obj;
                },
                get: function(obj) {
                    return obj.user_notes;
                },
                set: function(obj, value) {
                    obj.user_notes = value;
                }
            },
            metadata: _metadata
        }, _user_notes_initializers, _user_notes_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _user_dating_date_decorators, {
            kind: "accessor",
            name: "user_dating_date",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "user_dating_date" in obj;
                },
                get: function(obj) {
                    return obj.user_dating_date;
                },
                set: function(obj, value) {
                    obj.user_dating_date = value;
                }
            },
            metadata: _metadata
        }, _user_dating_date_initializers, _user_dating_date_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), Object.defineProperty(_a, "PATH", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: [
            "list_content"
        ]
    }), _a;
}();
var $ddcb476d90fa761b$export$c46be51aa96896da = function() {
    var _a, _ListCategoryModel_id_accessor_storage, _ListCategoryModel_name_accessor_storage, _ListCategoryModel_categories_accessor_storage;
    var _id_decorators;
    var _id_initializers = [];
    var _id_extraInitializers = [];
    var _name_decorators;
    var _name_initializers = [];
    var _name_extraInitializers = [];
    var _categories_decorators;
    var _categories_initializers = [];
    var _categories_extraInitializers = [];
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function ListCategoryModel() {
            (0, $19mwo._)(this, ListCategoryModel);
            _ListCategoryModel_id_accessor_storage.set(this, $ddcb476d90fa761b$var$__runInitializers(this, _id_initializers, ""));
            _ListCategoryModel_name_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _id_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _name_initializers, "")));
            _ListCategoryModel_categories_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _name_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _categories_initializers, [])));
            $ddcb476d90fa761b$var$__runInitializers(this, _categories_extraInitializers);
            this.id = (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().generateId(_a.PATH);
        }
        (0, $6rpfc._)(ListCategoryModel, [
            {
                key: "id",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListCategoryModel_id_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListCategoryModel_id_accessor_storage, value, "f");
                }
            },
            {
                key: "name",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListCategoryModel_name_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListCategoryModel_name_accessor_storage, value, "f");
                }
            },
            {
                key: "categories",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListCategoryModel_categories_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListCategoryModel_categories_accessor_storage, value, "f");
                }
            },
            {
                key: "save",
                value: function save() {
                    var d = this;
                    (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().saveDoc(_a.PATH, d);
                }
            },
            {
                key: "toJS",
                value: function toJS() {
                    return {
                        id: this.id,
                        name: this.name,
                        categories: this.categories
                    };
                }
            },
            {
                key: "fromJS",
                value: function fromJS(json) {
                    this.id = json["id"];
                    this.name = json["name"];
                    this.categories = json["categories"];
                    return this;
                }
            }
        ]);
        return ListCategoryModel;
    }(), _ListCategoryModel_id_accessor_storage = new WeakMap(), _ListCategoryModel_name_accessor_storage = new WeakMap(), _ListCategoryModel_categories_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _id_decorators = [
            (0, $b0lSM.observable)
        ];
        _name_decorators = [
            (0, $b0lSM.observable)
        ];
        _categories_decorators = [
            (0, $b0lSM.observable)
        ];
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _id_decorators, {
            kind: "accessor",
            name: "id",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "id" in obj;
                },
                get: function(obj) {
                    return obj.id;
                },
                set: function(obj, value) {
                    obj.id = value;
                }
            },
            metadata: _metadata
        }, _id_initializers, _id_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _name_decorators, {
            kind: "accessor",
            name: "name",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "name" in obj;
                },
                get: function(obj) {
                    return obj.name;
                },
                set: function(obj, value) {
                    obj.name = value;
                }
            },
            metadata: _metadata
        }, _name_initializers, _name_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _categories_decorators, {
            kind: "accessor",
            name: "categories",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "categories" in obj;
                },
                get: function(obj) {
                    return obj.categories;
                },
                set: function(obj, value) {
                    obj.categories = value;
                }
            },
            metadata: _metadata
        }, _categories_initializers, _categories_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), Object.defineProperty(_a, "PATH", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: [
            "list_categories"
        ]
    }), _a;
}();
var $ddcb476d90fa761b$export$e11a08c6776f4efd = function() {
    var _a, _FilterContentUI_rating_accessor_storage, _FilterContentUI_show_only_not_rated_accessor_storage, _FilterContentUI_show_watch_soon_accessor_storage, _FilterContentUI_contentType_accessor_storage, _FilterContentUI_search_accessor_storage;
    var _rating_decorators;
    var _rating_initializers = [];
    var _rating_extraInitializers = [];
    var _show_only_not_rated_decorators;
    var _show_only_not_rated_initializers = [];
    var _show_only_not_rated_extraInitializers = [];
    var _show_watch_soon_decorators;
    var _show_watch_soon_initializers = [];
    var _show_watch_soon_extraInitializers = [];
    var _contentType_decorators;
    var _contentType_initializers = [];
    var _contentType_extraInitializers = [];
    var _search_decorators;
    var _search_initializers = [];
    var _search_extraInitializers = [];
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function FilterContentUI() {
            (0, $19mwo._)(this, FilterContentUI);
            _FilterContentUI_rating_accessor_storage.set(this, $ddcb476d90fa761b$var$__runInitializers(this, _rating_initializers, void 0));
            _FilterContentUI_show_only_not_rated_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _rating_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _show_only_not_rated_initializers, void 0)));
            _FilterContentUI_show_watch_soon_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _show_only_not_rated_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _show_watch_soon_initializers, void 0)));
            _FilterContentUI_contentType_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _show_watch_soon_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _contentType_initializers, void 0)));
            _FilterContentUI_search_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _contentType_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _search_initializers, void 0)));
            $ddcb476d90fa761b$var$__runInitializers(this, _search_extraInitializers);
            this.reset();
        }
        (0, $6rpfc._)(FilterContentUI, [
            {
                key: "rating",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _FilterContentUI_rating_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _FilterContentUI_rating_accessor_storage, value, "f");
                }
            },
            {
                key: "show_only_not_rated",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _FilterContentUI_show_only_not_rated_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _FilterContentUI_show_only_not_rated_accessor_storage, value, "f");
                }
            },
            {
                key: "show_watch_soon",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _FilterContentUI_show_watch_soon_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _FilterContentUI_show_watch_soon_accessor_storage, value, "f");
                }
            },
            {
                key: "contentType",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _FilterContentUI_contentType_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _FilterContentUI_contentType_accessor_storage, value, "f");
                }
            },
            {
                key: "search",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _FilterContentUI_search_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _FilterContentUI_search_accessor_storage, value, "f");
                }
            },
            {
                key: "reset",
                value: function reset() {
                    this.rating = -1;
                    this.contentType = null;
                    this.search = "";
                    this.show_only_not_rated = false;
                    this.show_watch_soon = false;
                }
            }
        ]);
        return FilterContentUI;
    }(), _FilterContentUI_rating_accessor_storage = new WeakMap(), _FilterContentUI_show_only_not_rated_accessor_storage = new WeakMap(), _FilterContentUI_show_watch_soon_accessor_storage = new WeakMap(), _FilterContentUI_contentType_accessor_storage = new WeakMap(), _FilterContentUI_search_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _rating_decorators = [
            (0, $b0lSM.observable)
        ];
        _show_only_not_rated_decorators = [
            (0, $b0lSM.observable)
        ];
        _show_watch_soon_decorators = [
            (0, $b0lSM.observable)
        ];
        _contentType_decorators = [
            (0, $b0lSM.observable)
        ];
        _search_decorators = [
            (0, $b0lSM.observable)
        ];
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _rating_decorators, {
            kind: "accessor",
            name: "rating",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "rating" in obj;
                },
                get: function(obj) {
                    return obj.rating;
                },
                set: function(obj, value) {
                    obj.rating = value;
                }
            },
            metadata: _metadata
        }, _rating_initializers, _rating_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _show_only_not_rated_decorators, {
            kind: "accessor",
            name: "show_only_not_rated",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "show_only_not_rated" in obj;
                },
                get: function(obj) {
                    return obj.show_only_not_rated;
                },
                set: function(obj, value) {
                    obj.show_only_not_rated = value;
                }
            },
            metadata: _metadata
        }, _show_only_not_rated_initializers, _show_only_not_rated_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _show_watch_soon_decorators, {
            kind: "accessor",
            name: "show_watch_soon",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "show_watch_soon" in obj;
                },
                get: function(obj) {
                    return obj.show_watch_soon;
                },
                set: function(obj, value) {
                    obj.show_watch_soon = value;
                }
            },
            metadata: _metadata
        }, _show_watch_soon_initializers, _show_watch_soon_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _contentType_decorators, {
            kind: "accessor",
            name: "contentType",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "contentType" in obj;
                },
                get: function(obj) {
                    return obj.contentType;
                },
                set: function(obj, value) {
                    obj.contentType = value;
                }
            },
            metadata: _metadata
        }, _contentType_initializers, _contentType_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _search_decorators, {
            kind: "accessor",
            name: "search",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "search" in obj;
                },
                get: function(obj) {
                    return obj.search;
                },
                set: function(obj, value) {
                    obj.search = value;
                }
            },
            metadata: _metadata
        }, _search_initializers, _search_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $ddcb476d90fa761b$export$ac79b1df5378f990 = function() {
    var _a, _ListsStore_categories_accessor_storage, _ListsStore_contentList_accessor_storage, _ListsStore_filterUI_accessor_storage;
    var _categories_decorators;
    var _categories_initializers = [];
    var _categories_extraInitializers = [];
    var _contentList_decorators;
    var _contentList_initializers = [];
    var _contentList_extraInitializers = [];
    var _filterUI_decorators;
    var _filterUI_initializers = [];
    var _filterUI_extraInitializers = [];
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function ListsStore() {
            (0, $19mwo._)(this, ListsStore);
            _ListsStore_categories_accessor_storage.set(this, $ddcb476d90fa761b$var$__runInitializers(this, _categories_initializers, []));
            _ListsStore_contentList_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _categories_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _contentList_initializers, [])));
            _ListsStore_filterUI_accessor_storage.set(this, ($ddcb476d90fa761b$var$__runInitializers(this, _contentList_extraInitializers), $ddcb476d90fa761b$var$__runInitializers(this, _filterUI_initializers, new $ddcb476d90fa761b$export$e11a08c6776f4efd())));
            $ddcb476d90fa761b$var$__runInitializers(this, _filterUI_extraInitializers);
            this.categories = [];
            this.contentList = [];
        }
        (0, $6rpfc._)(ListsStore, [
            {
                key: "categories",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListsStore_categories_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListsStore_categories_accessor_storage, value, "f");
                }
            },
            {
                key: "contentList",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListsStore_contentList_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListsStore_contentList_accessor_storage, value, "f");
                }
            },
            {
                key: "filterUI",
                get: function get() {
                    return $ddcb476d90fa761b$var$__classPrivateFieldGet(this, _ListsStore_filterUI_accessor_storage, "f");
                },
                set: function set(value) {
                    $ddcb476d90fa761b$var$__classPrivateFieldSet(this, _ListsStore_filterUI_accessor_storage, value, "f");
                }
            },
            {
                key: "deleteCategory",
                value: function deleteCategory(id) {
                    (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().deleteData($ddcb476d90fa761b$export$c46be51aa96896da.PATH, id);
                }
            },
            {
                key: "init",
                value: function init() {
                    var _this = this;
                    (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().listenData($ddcb476d90fa761b$export$c46be51aa96896da.PATH, function(data) {
                        _this.categories = data;
                    }, $ddcb476d90fa761b$export$c46be51aa96896da);
                    (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().listenData($ddcb476d90fa761b$export$8536aa4ab0b165e5.PATH, function(data) {
                        _this.contentList = data;
                    }, $ddcb476d90fa761b$export$8536aa4ab0b165e5);
                }
            }
        ]);
        return ListsStore;
    }(), _ListsStore_categories_accessor_storage = new WeakMap(), _ListsStore_contentList_accessor_storage = new WeakMap(), _ListsStore_filterUI_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _categories_decorators = [
            (0, $b0lSM.observable)
        ];
        _contentList_decorators = [
            (0, $b0lSM.observable)
        ];
        _filterUI_decorators = [
            (0, $b0lSM.observable)
        ];
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _categories_decorators, {
            kind: "accessor",
            name: "categories",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "categories" in obj;
                },
                get: function(obj) {
                    return obj.categories;
                },
                set: function(obj, value) {
                    obj.categories = value;
                }
            },
            metadata: _metadata
        }, _categories_initializers, _categories_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _contentList_decorators, {
            kind: "accessor",
            name: "contentList",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "contentList" in obj;
                },
                get: function(obj) {
                    return obj.contentList;
                },
                set: function(obj, value) {
                    obj.contentList = value;
                }
            },
            metadata: _metadata
        }, _contentList_initializers, _contentList_extraInitializers);
        $ddcb476d90fa761b$var$__esDecorate(_a, null, _filterUI_decorators, {
            kind: "accessor",
            name: "filterUI",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "filterUI" in obj;
                },
                get: function(obj) {
                    return obj.filterUI;
                },
                set: function(obj, value) {
                    obj.filterUI = value;
                }
            },
            metadata: _metadata
        }, _filterUI_initializers, _filterUI_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();



var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $b0lSM = parcelRequire("b0lSM");
var $2e83237754d47b7b$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $2e83237754d47b7b$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $2e83237754d47b7b$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $2e83237754d47b7b$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $2e83237754d47b7b$export$ceb71efa96f8d38 = function() {
    var _a, _AnimationStore_animation_accessor_storage;
    var _animation_decorators;
    var _animation_initializers = [];
    var _animation_extraInitializers = [];
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function AnimationStore() {
            (0, $19mwo._)(this, AnimationStore);
            _AnimationStore_animation_accessor_storage.set(this, $2e83237754d47b7b$var$__runInitializers(this, _animation_initializers, null));
            Object.defineProperty(this, "positions", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($2e83237754d47b7b$var$__runInitializers(this, _animation_extraInitializers), {})
            });
        }
        (0, $6rpfc._)(AnimationStore, [
            {
                key: "animation",
                get: function get() {
                    return $2e83237754d47b7b$var$__classPrivateFieldGet(this, _AnimationStore_animation_accessor_storage, "f");
                },
                set: function set(value) {
                    $2e83237754d47b7b$var$__classPrivateFieldSet(this, _AnimationStore_animation_accessor_storage, value, "f");
                }
            },
            {
                key: "reportPosition",
                value: function reportPosition(info, pos) {
                    if (!this.positions[info.type]) this.positions[info.type] = {};
                    this.positions[info.type][info.id] = pos;
                }
            },
            {
                key: "getPosition",
                value: function getPosition(type, id) {
                    if (!this.positions[type]) return null;
                    if (!this.positions[type][id]) return null;
                    return this.positions[type][id];
                }
            }
        ]);
        return AnimationStore;
    }(), _AnimationStore_animation_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _animation_decorators = [
            (0, $b0lSM.observable)
        ];
        $2e83237754d47b7b$var$__esDecorate(_a, null, _animation_decorators, {
            kind: "accessor",
            name: "animation",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "animation" in obj;
                },
                get: function(obj) {
                    return obj.animation;
                },
                set: function(obj, value) {
                    obj.animation = value;
                }
            },
            metadata: _metadata
        }, _animation_initializers, _animation_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();



var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $b0lSM = parcelRequire("b0lSM");
var $1ee1913d87760836$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $1ee1913d87760836$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $1ee1913d87760836$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $1ee1913d87760836$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $1ee1913d87760836$export$28c2fde9c958d23b = function() {
    var _a, _UIStore_selectedDay_accessor_storage, _UIStore_isMenuOpen_accessor_storage;
    var _selectedDay_decorators;
    var _selectedDay_initializers = [];
    var _selectedDay_extraInitializers = [];
    var _isMenuOpen_decorators;
    var _isMenuOpen_initializers = [];
    var _isMenuOpen_extraInitializers = [];
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function UIStore() {
            (0, $19mwo._)(this, UIStore);
            _UIStore_selectedDay_accessor_storage.set(this, $1ee1913d87760836$var$__runInitializers(this, _selectedDay_initializers, new Date()));
            _UIStore_isMenuOpen_accessor_storage.set(this, ($1ee1913d87760836$var$__runInitializers(this, _selectedDay_extraInitializers), $1ee1913d87760836$var$__runInitializers(this, _isMenuOpen_initializers, false)));
            $1ee1913d87760836$var$__runInitializers(this, _isMenuOpen_extraInitializers);
        }
        (0, $6rpfc._)(UIStore, [
            {
                key: "selectedDay",
                get: function get() {
                    return $1ee1913d87760836$var$__classPrivateFieldGet(this, _UIStore_selectedDay_accessor_storage, "f");
                },
                set: function set(value) {
                    $1ee1913d87760836$var$__classPrivateFieldSet(this, _UIStore_selectedDay_accessor_storage, value, "f");
                }
            },
            {
                key: "isMenuOpen",
                get: function get() {
                    return $1ee1913d87760836$var$__classPrivateFieldGet(this, _UIStore_isMenuOpen_accessor_storage, "f");
                },
                set: function set(value) {
                    $1ee1913d87760836$var$__classPrivateFieldSet(this, _UIStore_isMenuOpen_accessor_storage, value, "f");
                }
            }
        ]);
        return UIStore;
    }(), _UIStore_selectedDay_accessor_storage = new WeakMap(), _UIStore_isMenuOpen_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _selectedDay_decorators = [
            (0, $b0lSM.observable)
        ];
        _isMenuOpen_decorators = [
            (0, $b0lSM.observable)
        ];
        $1ee1913d87760836$var$__esDecorate(_a, null, _selectedDay_decorators, {
            kind: "accessor",
            name: "selectedDay",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "selectedDay" in obj;
                },
                get: function(obj) {
                    return obj.selectedDay;
                },
                set: function(obj, value) {
                    obj.selectedDay = value;
                }
            },
            metadata: _metadata
        }, _selectedDay_initializers, _selectedDay_extraInitializers);
        $1ee1913d87760836$var$__esDecorate(_a, null, _isMenuOpen_decorators, {
            kind: "accessor",
            name: "isMenuOpen",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "isMenuOpen" in obj;
                },
                get: function(obj) {
                    return obj.isMenuOpen;
                },
                set: function(obj, value) {
                    obj.isMenuOpen = value;
                }
            },
            metadata: _metadata
        }, _isMenuOpen_initializers, _isMenuOpen_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();


var $3a3345637c0a5d6f$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $3a3345637c0a5d6f$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $3a3345637c0a5d6f$export$26bba7cb707d8026;
(function(LoadState) {
    LoadState["NOT_LOADED"] = "NOT_LOADED";
    LoadState["LOADING"] = "LOADING";
    LoadState["LOADED"] = "LOADED";
})($3a3345637c0a5d6f$export$26bba7cb707d8026 || ($3a3345637c0a5d6f$export$26bba7cb707d8026 = {}));
var $3a3345637c0a5d6f$var$Store = function() {
    var _a;
    var _instanceExtraInitializers = [];
    var _get_isLoaded_decorators;
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function Store() {
            (0, $19mwo._)(this, Store);
            Object.defineProperty(this, "tasks", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($3a3345637c0a5d6f$var$__runInitializers(this, _instanceExtraInitializers), new (0, $cf2b1744999344e8$export$dc06ce91c446b5ef)())
            });
            Object.defineProperty(this, "lists", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new (0, $ddcb476d90fa761b$export$ac79b1df5378f990)()
            });
            Object.defineProperty(this, "modal", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new (0, $f8716cecb8649d0d$export$f41f3c05d8a4b8bf)()
            });
            Object.defineProperty(this, "animation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new (0, $2e83237754d47b7b$export$ceb71efa96f8d38)()
            });
            Object.defineProperty(this, "toaster", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new (0, $712f9363716e1741$export$37d64a585fa0ddec)()
            });
            Object.defineProperty(this, "assets", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new (0, $f38bbf47b43f06de$export$6b0e6d2de4623d33)()
            });
            Object.defineProperty(this, "tasksLog", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new (0, $544a6bbf19fedb51$export$6a933480d228a1bd)()
            });
            Object.defineProperty(this, "cache", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new (0, $3f6316cccd323689$export$da4c4d4307140b47)()
            });
            Object.defineProperty(this, "ui", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new (0, $1ee1913d87760836$export$28c2fde9c958d23b)()
            });
            Object.defineProperty(this, "db", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: null
            });
            Object.defineProperty(this, "workbox", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "didInit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
        }
        (0, $6rpfc._)(Store, [
            {
                key: "isLoaded",
                get: function get() {
                    return this.tasks.isLoaded;
                }
            },
            {
                key: "init",
                value: function init(userId) {
                    if (this.didInit) return;
                    this.didInit = true;
                    console.log("User Id: ", userId);
                    this.db = (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().db;
                    this.tasks.init();
                    this.tasksLog.init();
                    this.lists.init();
                }
            }
        ]);
        return Store;
    }(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _get_isLoaded_decorators = [
            (0, $b0lSM.computed)
        ];
        $3a3345637c0a5d6f$var$__esDecorate(_a, null, _get_isLoaded_decorators, {
            kind: "getter",
            name: "isLoaded",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "isLoaded" in obj;
                },
                get: function(obj) {
                    return obj.isLoaded;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $3a3345637c0a5d6f$var$store = new $3a3345637c0a5d6f$var$Store();
var $3a3345637c0a5d6f$export$6ccbb43953eebf8 = function() {
    return $3a3345637c0a5d6f$var$store;
};
var $3a3345637c0a5d6f$export$edcd1bf374609759 = function() {
    return $3a3345637c0a5d6f$var$store.ui;
};
var $3a3345637c0a5d6f$export$bd973f06e9aaec8c = function() {
    return $3a3345637c0a5d6f$var$store.assets;
};
var $3a3345637c0a5d6f$export$33ffd74ebf07f060 = function() {
    return $3a3345637c0a5d6f$var$store.modal;
};
var $3a3345637c0a5d6f$export$ed5c3368304694 = function() {
    return $3a3345637c0a5d6f$var$store.tasks;
};
var $3a3345637c0a5d6f$export$f46171b59bb094f9 = function() {
    return $3a3345637c0a5d6f$var$store.toaster;
};
var $3a3345637c0a5d6f$export$b5afef939be034e8 = function() {
    return $3a3345637c0a5d6f$var$store.tasksLog;
};
var $3a3345637c0a5d6f$export$bdceb54baf319cd4 = function() {
    return $3a3345637c0a5d6f$var$store.workbox;
};
var $3a3345637c0a5d6f$export$c6e89b6bb9436bc0 = function() {
    return $3a3345637c0a5d6f$var$store.cache;
};
var $3a3345637c0a5d6f$export$3b5bae399c8431fb = function() {
    return $3a3345637c0a5d6f$var$store.lists;
};
var $3a3345637c0a5d6f$export$491715d4fdcd0f6b = function() {
    return $3a3345637c0a5d6f$var$store.animation;
};
var $3a3345637c0a5d6f$export$2e2bcd8739ae039 = $3a3345637c0a5d6f$var$store;



var $dKdZ4 = parcelRequire("dKdZ4");

var $15Pju = parcelRequire("15Pju");

var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");

var $ilNGG = parcelRequire("ilNGG");

var $gQ5gw = parcelRequire("gQ5gw");

var $e5K63 = parcelRequire("e5K63");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ var $f11ac745706cbb9d$var$DEFAULT_HOST = "firebasestorage.googleapis.com";
/**
 * The key in Firebase config json for the storage bucket.
 */ var $f11ac745706cbb9d$var$CONFIG_STORAGE_BUCKET_KEY = "storageBucket";
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ var $f11ac745706cbb9d$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ var $f11ac745706cbb9d$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * 1 second
 */ var $f11ac745706cbb9d$var$DEFAULT_MIN_SLEEP_TIME_MILLIS = 1000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error returned by the Firebase Storage SDK.
 * @public
 */ var $f11ac745706cbb9d$export$697502632950e9d3 = /*#__PURE__*/ function(FirebaseError) {
    "use strict";
    (0, $iNfU4._)(StorageError, FirebaseError);
    var _super = (0, $k1NN5._)(StorageError);
    function StorageError(code, message) {
        var status_ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        (0, $19mwo._)(this, StorageError);
        var _this;
        _this = _super.call(this, $f11ac745706cbb9d$var$prependCode(code), "Firebase Storage: ".concat(message, " (").concat($f11ac745706cbb9d$var$prependCode(code), ")"));
        _this.status_ = status_;
        /**
         * Stores custom error data unique to the `StorageError`.
         */ _this.customData = {
            serverResponse: null
        };
        _this._baseMessage = _this.message;
        // Without this, `instanceof StorageError`, in tests for example,
        // returns false.
        Object.setPrototypeOf((0, $15Pju._)(_this), StorageError.prototype);
        return _this;
    }
    (0, $6rpfc._)(StorageError, [
        {
            key: "status",
            get: function get() {
                return this.status_;
            },
            set: function set(status) {
                this.status_ = status;
            }
        },
        {
            /**
     * Compares a `StorageErrorCode` against this error's code, filtering out the prefix.
     */ key: "_codeEquals",
            value: function _codeEquals(code) {
                return $f11ac745706cbb9d$var$prependCode(code) === this.code;
            }
        },
        {
            key: "serverResponse",
            get: /**
     * Optional response message that was added by the server.
     */ function get() {
                return this.customData.serverResponse;
            },
            set: function set(serverResponse) {
                this.customData.serverResponse = serverResponse;
                if (this.customData.serverResponse) this.message = "".concat(this._baseMessage, "\n").concat(this.customData.serverResponse);
                else this.message = this._baseMessage;
            }
        }
    ]);
    return StorageError;
}((0, $gQ5gw.FirebaseError));
/**
 * @public
 * Error codes that can be attached to `StorageError` objects.
 */ var $f11ac745706cbb9d$export$54592d666d6ce114;
(function(StorageErrorCode) {
    // Shared between all platforms
    StorageErrorCode["UNKNOWN"] = "unknown";
    StorageErrorCode["OBJECT_NOT_FOUND"] = "object-not-found";
    StorageErrorCode["BUCKET_NOT_FOUND"] = "bucket-not-found";
    StorageErrorCode["PROJECT_NOT_FOUND"] = "project-not-found";
    StorageErrorCode["QUOTA_EXCEEDED"] = "quota-exceeded";
    StorageErrorCode["UNAUTHENTICATED"] = "unauthenticated";
    StorageErrorCode["UNAUTHORIZED"] = "unauthorized";
    StorageErrorCode["UNAUTHORIZED_APP"] = "unauthorized-app";
    StorageErrorCode["RETRY_LIMIT_EXCEEDED"] = "retry-limit-exceeded";
    StorageErrorCode["INVALID_CHECKSUM"] = "invalid-checksum";
    StorageErrorCode["CANCELED"] = "canceled";
    // JS specific
    StorageErrorCode["INVALID_EVENT_NAME"] = "invalid-event-name";
    StorageErrorCode["INVALID_URL"] = "invalid-url";
    StorageErrorCode["INVALID_DEFAULT_BUCKET"] = "invalid-default-bucket";
    StorageErrorCode["NO_DEFAULT_BUCKET"] = "no-default-bucket";
    StorageErrorCode["CANNOT_SLICE_BLOB"] = "cannot-slice-blob";
    StorageErrorCode["SERVER_FILE_WRONG_SIZE"] = "server-file-wrong-size";
    StorageErrorCode["NO_DOWNLOAD_URL"] = "no-download-url";
    StorageErrorCode["INVALID_ARGUMENT"] = "invalid-argument";
    StorageErrorCode["INVALID_ARGUMENT_COUNT"] = "invalid-argument-count";
    StorageErrorCode["APP_DELETED"] = "app-deleted";
    StorageErrorCode["INVALID_ROOT_OPERATION"] = "invalid-root-operation";
    StorageErrorCode["INVALID_FORMAT"] = "invalid-format";
    StorageErrorCode["INTERNAL_ERROR"] = "internal-error";
    StorageErrorCode["UNSUPPORTED_ENVIRONMENT"] = "unsupported-environment";
})($f11ac745706cbb9d$export$54592d666d6ce114 || ($f11ac745706cbb9d$export$54592d666d6ce114 = {}));
function $f11ac745706cbb9d$var$prependCode(code) {
    return "storage/" + code;
}
function $f11ac745706cbb9d$var$unknown() {
    var message = "An unknown error occurred, please check the error payload for server response.";
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.UNKNOWN, message);
}
function $f11ac745706cbb9d$var$objectNotFound(path) {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function $f11ac745706cbb9d$var$quotaExceeded(bucket) {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + "https://firebase.google.com/pricing/.");
}
function $f11ac745706cbb9d$var$unauthenticated() {
    var message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.UNAUTHENTICATED, message);
}
function $f11ac745706cbb9d$var$unauthorizedApp() {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.UNAUTHORIZED_APP, "This app does not have permission to access Firebase Storage on this project.");
}
function $f11ac745706cbb9d$var$unauthorized(path) {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function $f11ac745706cbb9d$var$retryLimitExceeded() {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.RETRY_LIMIT_EXCEEDED, "Max retry time for operation exceeded, please try again.");
}
function $f11ac745706cbb9d$var$canceled() {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.CANCELED, "User canceled the upload/download.");
}
function $f11ac745706cbb9d$var$invalidUrl(url) {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.INVALID_URL, "Invalid URL '" + url + "'.");
}
function $f11ac745706cbb9d$var$invalidDefaultBucket(bucket) {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function $f11ac745706cbb9d$var$noDefaultBucket() {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.NO_DEFAULT_BUCKET, "No default bucket found. Did you set the '" + $f11ac745706cbb9d$var$CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function $f11ac745706cbb9d$var$cannotSliceBlob() {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.CANNOT_SLICE_BLOB, "Cannot slice blob for upload. Please retry the upload.");
}
function $f11ac745706cbb9d$var$serverFileWrongSize() {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.SERVER_FILE_WRONG_SIZE, "Server recorded incorrect upload file size, please retry the upload.");
}
function $f11ac745706cbb9d$var$noDownloadURL() {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.NO_DOWNLOAD_URL, "The given file does not have any download URLs.");
}
function $f11ac745706cbb9d$var$missingPolyFill(polyFill) {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, "".concat(polyFill, " is missing. Make sure to install the required polyfills. See https://firebase.google.com/docs/web/environments-js-sdk#polyfills for more information."));
}
/**
 * @internal
 */ function $f11ac745706cbb9d$export$8f74d9881d1936fd(message) {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.INVALID_ARGUMENT, message);
}
function $f11ac745706cbb9d$var$appDeleted() {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.APP_DELETED, "The Firebase app was deleted.");
}
/**
 * @param name - The name of the operation that was invalid.
 *
 * @internal
 */ function $f11ac745706cbb9d$export$61f54cdc36500ad(name) {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */ function $f11ac745706cbb9d$var$invalidFormat(format, message) {
    return new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */ function $f11ac745706cbb9d$var$internalError(message) {
    throw new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.INTERNAL_ERROR, "Internal error: " + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Firebase Storage location data.
 *
 * @internal
 */ var $f11ac745706cbb9d$export$adb98fff6714334 = /*#__PURE__*/ function() {
    "use strict";
    function Location(bucket, path) {
        (0, $19mwo._)(this, Location);
        this.bucket = bucket;
        this.path_ = path;
    }
    (0, $6rpfc._)(Location, [
        {
            key: "path",
            get: function get() {
                return this.path_;
            }
        },
        {
            key: "isRoot",
            get: function get() {
                return this.path.length === 0;
            }
        },
        {
            key: "fullServerUrl",
            value: function fullServerUrl() {
                var encode = encodeURIComponent;
                return "/b/" + encode(this.bucket) + "/o/" + encode(this.path);
            }
        },
        {
            key: "bucketOnlyServerUrl",
            value: function bucketOnlyServerUrl() {
                var encode = encodeURIComponent;
                return "/b/" + encode(this.bucket) + "/o";
            }
        }
    ], [
        {
            key: "makeFromBucketSpec",
            value: function makeFromBucketSpec(bucketString, host) {
                var bucketLocation;
                try {
                    bucketLocation = Location.makeFromUrl(bucketString, host);
                } catch (e) {
                    // Not valid URL, use as-is. This lets you put bare bucket names in
                    // config.
                    return new Location(bucketString, "");
                }
                if (bucketLocation.path === "") return bucketLocation;
                else throw $f11ac745706cbb9d$var$invalidDefaultBucket(bucketString);
            }
        },
        {
            key: "makeFromUrl",
            value: function makeFromUrl(url, host) {
                var location = null;
                var bucketDomain = "([A-Za-z0-9.\\-_]+)";
                function gsModify(loc) {
                    if (loc.path.charAt(loc.path.length - 1) === "/") loc.path_ = loc.path_.slice(0, -1);
                }
                var gsPath = "(/(.*))?$";
                var gsRegex = new RegExp("^gs://" + bucketDomain + gsPath, "i");
                var gsIndices = {
                    bucket: 1,
                    path: 3
                };
                function httpModify(loc) {
                    loc.path_ = decodeURIComponent(loc.path);
                }
                var version = "v[A-Za-z0-9_]+";
                var firebaseStorageHost = host.replace(/[.]/g, "\\.");
                var firebaseStoragePath = "(/([^?#]*).*)?$";
                var firebaseStorageRegExp = new RegExp("^https?://".concat(firebaseStorageHost, "/").concat(version, "/b/").concat(bucketDomain, "/o").concat(firebaseStoragePath), "i");
                var firebaseStorageIndices = {
                    bucket: 1,
                    path: 3
                };
                var cloudStorageHost = host === $f11ac745706cbb9d$var$DEFAULT_HOST ? "(?:storage.googleapis.com|storage.cloud.google.com)" : host;
                var cloudStoragePath = "([^?#]*)";
                var cloudStorageRegExp = new RegExp("^https?://".concat(cloudStorageHost, "/").concat(bucketDomain, "/").concat(cloudStoragePath), "i");
                var cloudStorageIndices = {
                    bucket: 1,
                    path: 2
                };
                var groups = [
                    {
                        regex: gsRegex,
                        indices: gsIndices,
                        postModify: gsModify
                    },
                    {
                        regex: firebaseStorageRegExp,
                        indices: firebaseStorageIndices,
                        postModify: httpModify
                    },
                    {
                        regex: cloudStorageRegExp,
                        indices: cloudStorageIndices,
                        postModify: httpModify
                    }
                ];
                for(var i = 0; i < groups.length; i++){
                    var group = groups[i];
                    var captures = group.regex.exec(url);
                    if (captures) {
                        var bucketValue = captures[group.indices.bucket];
                        var pathValue = captures[group.indices.path];
                        if (!pathValue) pathValue = "";
                        location = new Location(bucketValue, pathValue);
                        group.postModify(location);
                        break;
                    }
                }
                if (location == null) throw $f11ac745706cbb9d$var$invalidUrl(url);
                return location;
            }
        }
    ]);
    return Location;
}();
/**
 * A request whose promise always fails.
 */ var $f11ac745706cbb9d$var$FailRequest = /*#__PURE__*/ function() {
    "use strict";
    function FailRequest(error) {
        (0, $19mwo._)(this, FailRequest);
        this.promise_ = Promise.reject(error);
    }
    (0, $6rpfc._)(FailRequest, [
        {
            /** @inheritDoc */ key: "getPromise",
            value: function getPromise() {
                return this.promise_;
            }
        },
        {
            /** @inheritDoc */ key: "cancel",
            value: function cancel() {
                var _appDelete = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            }
        }
    ]);
    return FailRequest;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Accepts a callback for an action to perform (`doRequest`),
 * and then a callback for when the backoff has completed (`backoffCompleteCb`).
 * The callback sent to start requires an argument to call (`onRequestComplete`).
 * When `start` calls `doRequest`, it passes a callback for when the request has
 * completed, `onRequestComplete`. Based on this, the backoff continues, with
 * another call to `doRequest` and the above loop continues until the timeout
 * is hit, or a successful response occurs.
 * @description
 * @param doRequest Callback to perform request
 * @param backoffCompleteCb Callback to call when backoff has been completed
 */ function $f11ac745706cbb9d$var$start(doRequest, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backoffCompleteCb, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    var waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var retryTimeoutId = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var globalTimeoutId = null;
    var hitTimeout = false;
    var cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    var triggeredCallback = false;
    function triggerCallback() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!triggeredCallback) {
            triggeredCallback = true;
            backoffCompleteCb.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        retryTimeoutId = setTimeout(function() {
            retryTimeoutId = null;
            doRequest(responseHandler, canceled());
        }, millis);
    }
    function clearGlobalTimeout() {
        if (globalTimeoutId) clearTimeout(globalTimeoutId);
    }
    function responseHandler(success) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        if (triggeredCallback) {
            clearGlobalTimeout();
            return;
        }
        if (success) {
            var _triggerCallback;
            clearGlobalTimeout();
            (_triggerCallback = triggerCallback).call.apply(_triggerCallback, [
                null,
                success
            ].concat((0, $3jzhD._)(args)));
            return;
        }
        var mustStop = canceled() || hitTimeout;
        if (mustStop) {
            var _triggerCallback1;
            clearGlobalTimeout();
            (_triggerCallback1 = triggerCallback).call.apply(_triggerCallback1, [
                null,
                success
            ].concat((0, $3jzhD._)(args)));
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        var waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    var stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        clearGlobalTimeout();
        if (triggeredCallback) return;
        if (retryTimeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(retryTimeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    globalTimeoutId = setTimeout(function() {
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $f11ac745706cbb9d$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f11ac745706cbb9d$var$isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $f11ac745706cbb9d$var$isFunction(p) {
    return typeof p === "function";
}
function $f11ac745706cbb9d$var$isNonArrayObject(p) {
    return typeof p === "object" && !Array.isArray(p);
}
function $f11ac745706cbb9d$var$isString(p) {
    return typeof p === "string" || p instanceof String;
}
function $f11ac745706cbb9d$var$isNativeBlob(p) {
    return $f11ac745706cbb9d$var$isNativeBlobDefined() && p instanceof Blob;
}
function $f11ac745706cbb9d$var$isNativeBlobDefined() {
    return typeof Blob !== "undefined";
}
function $f11ac745706cbb9d$var$validateNumber(argument, minValue, maxValue, value) {
    if (value < minValue) throw $f11ac745706cbb9d$export$8f74d9881d1936fd("Invalid value for '".concat(argument, "'. Expected ").concat(minValue, " or greater."));
    if (value > maxValue) throw $f11ac745706cbb9d$export$8f74d9881d1936fd("Invalid value for '".concat(argument, "'. Expected ").concat(maxValue, " or less."));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f11ac745706cbb9d$var$makeUrl(urlPart, host, protocol) {
    var origin = host;
    if (protocol == null) origin = "https://".concat(host);
    return "".concat(protocol, "://").concat(origin, "/v0").concat(urlPart);
}
function $f11ac745706cbb9d$var$makeQueryString(params) {
    var encode = encodeURIComponent;
    var queryPart = "?";
    for(var key in params)if (params.hasOwnProperty(key)) {
        var nextPart = encode(key) + "=" + encode(params[key]);
        queryPart = queryPart + nextPart + "&";
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error codes for requests made by the the XhrIo wrapper.
 */ var $f11ac745706cbb9d$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($f11ac745706cbb9d$var$ErrorCode || ($f11ac745706cbb9d$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks the status code to see if the action should be retried.
 *
 * @param status Current HTTP status code returned by server.
 * @param additionalRetryCodes additional retry codes to check against
 */ function $f11ac745706cbb9d$var$isRetryStatusCode(status, additionalRetryCodes) {
    // The codes for which to retry came from this page:
    // https://cloud.google.com/storage/docs/exponential-backoff
    var isFiveHundredCode = status >= 500 && status < 600;
    var extraRetryCodes = [
        // Request Timeout: web server didn't receive full request in time.
        408,
        // Too Many Requests: you're getting rate-limited, basically.
        429
    ];
    var isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
    var isAdditionalRetryCode = additionalRetryCodes.indexOf(status) !== -1;
    return isFiveHundredCode || isExtraRetryCode || isAdditionalRetryCode;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Handles network logic for all Storage Requests, including error reporting and
 * retries with backoff.
 *
 * @param I - the type of the backend's network response.
 * @param - O the output type used by the rest of the SDK. The conversion
 * happens in the specified `callback_`.
 */ var $f11ac745706cbb9d$var$NetworkRequest = /*#__PURE__*/ function() {
    "use strict";
    function NetworkRequest(url_, method_, headers_, body_, successCodes_, additionalRetryCodes_, callback_, errorCallback_, timeout_, progressCallback_, connectionFactory_) {
        var _this = this;
        var retry = arguments.length > 11 && arguments[11] !== void 0 ? arguments[11] : true;
        (0, $19mwo._)(this, NetworkRequest);
        this.url_ = url_;
        this.method_ = method_;
        this.headers_ = headers_;
        this.body_ = body_;
        this.successCodes_ = successCodes_;
        this.additionalRetryCodes_ = additionalRetryCodes_;
        this.callback_ = callback_;
        this.errorCallback_ = errorCallback_;
        this.timeout_ = timeout_;
        this.progressCallback_ = progressCallback_;
        this.connectionFactory_ = connectionFactory_;
        this.retry = retry;
        this.pendingConnection_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.promise_ = new Promise(function(resolve, reject) {
            _this.resolve_ = resolve;
            _this.reject_ = reject;
            _this.start_();
        });
    }
    (0, $6rpfc._)(NetworkRequest, [
        {
            /**
     * Actually starts the retry loop.
     */ key: "start_",
            value: function start_() {
                var _this = this;
                var doTheRequest = function(backoffCallback, canceled) {
                    if (canceled) {
                        backoffCallback(false, new $f11ac745706cbb9d$var$RequestEndStatus(false, null, true));
                        return;
                    }
                    var connection = _this.connectionFactory_();
                    _this.pendingConnection_ = connection;
                    var progressListener = function(progressEvent) {
                        var loaded = progressEvent.loaded;
                        var total = progressEvent.lengthComputable ? progressEvent.total : -1;
                        if (_this.progressCallback_ !== null) _this.progressCallback_(loaded, total);
                    };
                    if (_this.progressCallback_ !== null) connection.addUploadProgressListener(progressListener);
                    // connection.send() never rejects, so we don't need to have a error handler or use catch on the returned promise.
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    connection.send(_this.url_, _this.method_, _this.body_, _this.headers_).then(function() {
                        if (_this.progressCallback_ !== null) connection.removeUploadProgressListener(progressListener);
                        _this.pendingConnection_ = null;
                        var hitServer = connection.getErrorCode() === $f11ac745706cbb9d$var$ErrorCode.NO_ERROR;
                        var status = connection.getStatus();
                        if (!hitServer || $f11ac745706cbb9d$var$isRetryStatusCode(status, _this.additionalRetryCodes_) && _this.retry) {
                            var wasCanceled = connection.getErrorCode() === $f11ac745706cbb9d$var$ErrorCode.ABORT;
                            backoffCallback(false, new $f11ac745706cbb9d$var$RequestEndStatus(false, null, wasCanceled));
                            return;
                        }
                        var successCode = _this.successCodes_.indexOf(status) !== -1;
                        backoffCallback(true, new $f11ac745706cbb9d$var$RequestEndStatus(successCode, connection));
                    });
                };
                /**
         * @param requestWentThrough - True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ var backoffDone = function(requestWentThrough, status) {
                    var resolve = _this.resolve_;
                    var reject = _this.reject_;
                    var connection = status.connection;
                    if (status.wasSuccessCode) try {
                        var result = _this.callback_(connection, connection.getResponse());
                        if ($f11ac745706cbb9d$var$isJustDef(result)) resolve(result);
                        else resolve();
                    } catch (e) {
                        reject(e);
                    }
                    else {
                        if (connection !== null) {
                            var err = $f11ac745706cbb9d$var$unknown();
                            err.serverResponse = connection.getErrorText();
                            if (_this.errorCallback_) reject(_this.errorCallback_(connection, err));
                            else reject(err);
                        } else if (status.canceled) {
                            var err1 = _this.appDelete_ ? $f11ac745706cbb9d$var$appDeleted() : $f11ac745706cbb9d$var$canceled();
                            reject(err1);
                        } else {
                            var err2 = $f11ac745706cbb9d$var$retryLimitExceeded();
                            reject(err2);
                        }
                    }
                };
                if (this.canceled_) backoffDone(false, new $f11ac745706cbb9d$var$RequestEndStatus(false, null, true));
                else this.backoffId_ = $f11ac745706cbb9d$var$start(doTheRequest, backoffDone, this.timeout_);
            }
        },
        {
            /** @inheritDoc */ key: "getPromise",
            value: function getPromise() {
                return this.promise_;
            }
        },
        {
            /** @inheritDoc */ key: "cancel",
            value: function cancel(appDelete) {
                this.canceled_ = true;
                this.appDelete_ = appDelete || false;
                if (this.backoffId_ !== null) $f11ac745706cbb9d$var$stop(this.backoffId_);
                if (this.pendingConnection_ !== null) this.pendingConnection_.abort();
            }
        }
    ]);
    return NetworkRequest;
}();
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */ var $f11ac745706cbb9d$var$RequestEndStatus = function RequestEndStatus(wasSuccessCode, connection, canceled) {
    "use strict";
    (0, $19mwo._)(this, RequestEndStatus);
    this.wasSuccessCode = wasSuccessCode;
    this.connection = connection;
    this.canceled = !!canceled;
};
function $f11ac745706cbb9d$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers["Authorization"] = "Firebase " + authToken;
}
function $f11ac745706cbb9d$var$addVersionHeader_(headers, firebaseVersion) {
    headers["X-Firebase-Storage-Version"] = "webjs/" + (firebaseVersion !== null && firebaseVersion !== void 0 ? firebaseVersion : "AppManager");
}
function $f11ac745706cbb9d$var$addGmpidHeader_(headers, appId) {
    if (appId) headers["X-Firebase-GMPID"] = appId;
}
function $f11ac745706cbb9d$var$addAppCheckHeader_(headers, appCheckToken) {
    if (appCheckToken !== null) headers["X-Firebase-AppCheck"] = appCheckToken;
}
function $f11ac745706cbb9d$var$makeRequest(requestInfo, appId, authToken, appCheckToken, requestFactory, firebaseVersion) {
    var retry = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : true;
    var queryPart = $f11ac745706cbb9d$var$makeQueryString(requestInfo.urlParams);
    var url = requestInfo.url + queryPart;
    var headers = Object.assign({}, requestInfo.headers);
    $f11ac745706cbb9d$var$addGmpidHeader_(headers, appId);
    $f11ac745706cbb9d$var$addAuthHeader_(headers, authToken);
    $f11ac745706cbb9d$var$addVersionHeader_(headers, firebaseVersion);
    $f11ac745706cbb9d$var$addAppCheckHeader_(headers, appCheckToken);
    return new $f11ac745706cbb9d$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, requestFactory, retry);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f11ac745706cbb9d$var$getBlobBuilder() {
    if (typeof BlobBuilder !== "undefined") return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== "undefined") return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $f11ac745706cbb9d$var$getBlob$1() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var BlobBuilder1 = $f11ac745706cbb9d$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        var bb = new BlobBuilder1();
        for(var i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($f11ac745706cbb9d$var$isNativeBlobDefined()) return new Blob(args);
        else throw new $f11ac745706cbb9d$export$697502632950e9d3($f11ac745706cbb9d$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, "This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $f11ac745706cbb9d$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ function $f11ac745706cbb9d$var$decodeBase64(encoded) {
    if (typeof atob === "undefined") throw $f11ac745706cbb9d$var$missingPolyFill("base-64");
    return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enumeration of the possible string formats for upload.
 * @public
 */ var $f11ac745706cbb9d$export$f22e7fe56db8ae03 = {
    /**
     * Indicates the string should be interpreted "raw", that is, as normal text.
     * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
     * sequence.
     * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
     * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
     */ RAW: "raw",
    /**
     * Indicates the string should be interpreted as base64-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64: "base64",
    /**
     * Indicates the string should be interpreted as base64url-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64URL: "base64url",
    /**
     * Indicates the string is a data URL, such as one obtained from
     * canvas.toDataURL().
     * Example: the string 'data:application/octet-stream;base64,aaaa'
     * becomes the byte sequence
     * 69 a6 9a
     * (the content-type "application/octet-stream" is also applied, but can
     * be overridden in the metadata object).
     */ DATA_URL: "data_url"
};
var $f11ac745706cbb9d$var$StringData = function StringData(data, contentType) {
    "use strict";
    (0, $19mwo._)(this, StringData);
    this.data = data;
    this.contentType = contentType || null;
};
/**
 * @internal
 */ function $f11ac745706cbb9d$export$d80b9b5a2ccdd3e0(format, stringData) {
    switch(format){
        case $f11ac745706cbb9d$export$f22e7fe56db8ae03.RAW:
            return new $f11ac745706cbb9d$var$StringData($f11ac745706cbb9d$var$utf8Bytes_(stringData));
        case $f11ac745706cbb9d$export$f22e7fe56db8ae03.BASE64:
        case $f11ac745706cbb9d$export$f22e7fe56db8ae03.BASE64URL:
            return new $f11ac745706cbb9d$var$StringData($f11ac745706cbb9d$var$base64Bytes_(format, stringData));
        case $f11ac745706cbb9d$export$f22e7fe56db8ae03.DATA_URL:
            return new $f11ac745706cbb9d$var$StringData($f11ac745706cbb9d$var$dataURLBytes_(stringData), $f11ac745706cbb9d$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $f11ac745706cbb9d$var$unknown();
}
function $f11ac745706cbb9d$var$utf8Bytes_(value) {
    var b = [];
    for(var i = 0; i < value.length; i++){
        var c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                var valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    var hi = c;
                    var lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $f11ac745706cbb9d$var$percentEncodedBytes_(value) {
    var decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $f11ac745706cbb9d$var$invalidFormat($f11ac745706cbb9d$export$f22e7fe56db8ae03.DATA_URL, "Malformed data URL.");
    }
    return $f11ac745706cbb9d$var$utf8Bytes_(decoded);
}
function $f11ac745706cbb9d$var$base64Bytes_(format, value) {
    switch(format){
        case $f11ac745706cbb9d$export$f22e7fe56db8ae03.BASE64:
            {
                var hasMinus = value.indexOf("-") !== -1;
                var hasUnder = value.indexOf("_") !== -1;
                if (hasMinus || hasUnder) {
                    var invalidChar = hasMinus ? "-" : "_";
                    throw $f11ac745706cbb9d$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case $f11ac745706cbb9d$export$f22e7fe56db8ae03.BASE64URL:
            {
                var hasPlus = value.indexOf("+") !== -1;
                var hasSlash = value.indexOf("/") !== -1;
                if (hasPlus || hasSlash) {
                    var invalidChar1 = hasPlus ? "+" : "/";
                    throw $f11ac745706cbb9d$var$invalidFormat(format, "Invalid character '" + invalidChar1 + "' found: is it base64 encoded?");
                }
                value = value.replace(/-/g, "+").replace(/_/g, "/");
                break;
            }
    }
    var bytes;
    try {
        bytes = $f11ac745706cbb9d$var$decodeBase64(value);
    } catch (e) {
        if (e.message.includes("polyfill")) throw e;
        throw $f11ac745706cbb9d$var$invalidFormat(format, "Invalid character found");
    }
    var array = new Uint8Array(bytes.length);
    for(var i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
var $f11ac745706cbb9d$var$DataURLParts = function DataURLParts(dataURL) {
    "use strict";
    (0, $19mwo._)(this, DataURLParts);
    this.base64 = false;
    this.contentType = null;
    var matches = dataURL.match(/^data:([^,]+)?,/);
    if (matches === null) throw $f11ac745706cbb9d$var$invalidFormat($f11ac745706cbb9d$export$f22e7fe56db8ae03.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
    var middle = matches[1] || null;
    if (middle != null) {
        this.base64 = $f11ac745706cbb9d$var$endsWith(middle, ";base64");
        this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
    }
    this.rest = dataURL.substring(dataURL.indexOf(",") + 1);
};
function $f11ac745706cbb9d$var$dataURLBytes_(dataUrl) {
    var parts = new $f11ac745706cbb9d$var$DataURLParts(dataUrl);
    if (parts.base64) return $f11ac745706cbb9d$var$base64Bytes_($f11ac745706cbb9d$export$f22e7fe56db8ae03.BASE64, parts.rest);
    else return $f11ac745706cbb9d$var$percentEncodedBytes_(parts.rest);
}
function $f11ac745706cbb9d$var$dataURLContentType_(dataUrl) {
    var parts = new $f11ac745706cbb9d$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $f11ac745706cbb9d$var$endsWith(s, end) {
    var longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */ var $f11ac745706cbb9d$export$8deea8629ff0b8a7 = /*#__PURE__*/ function() {
    "use strict";
    function FbsBlob(data, elideCopy) {
        (0, $19mwo._)(this, FbsBlob);
        var size = 0;
        var blobType = "";
        if ($f11ac745706cbb9d$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    (0, $6rpfc._)(FbsBlob, [
        {
            key: "size",
            value: function size() {
                return this.size_;
            }
        },
        {
            key: "type",
            value: function type() {
                return this.type_;
            }
        },
        {
            key: "slice",
            value: function slice(startByte, endByte) {
                if ($f11ac745706cbb9d$var$isNativeBlob(this.data_)) {
                    var realBlob = this.data_;
                    var sliced = $f11ac745706cbb9d$var$sliceBlob(realBlob, startByte, endByte);
                    if (sliced === null) return null;
                    return new FbsBlob(sliced);
                } else {
                    var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
                    return new FbsBlob(slice, true);
                }
            }
        },
        {
            key: "uploadData",
            value: function uploadData() {
                return this.data_;
            }
        }
    ], [
        {
            key: "getBlob",
            value: function getBlob() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                if ($f11ac745706cbb9d$var$isNativeBlobDefined()) {
                    var blobby = args.map(function(val) {
                        if (val instanceof FbsBlob) return val.data_;
                        else return val;
                    });
                    return new FbsBlob($f11ac745706cbb9d$var$getBlob$1.apply(null, blobby));
                } else {
                    var uint8Arrays = args.map(function(val) {
                        if ($f11ac745706cbb9d$var$isString(val)) return $f11ac745706cbb9d$export$d80b9b5a2ccdd3e0($f11ac745706cbb9d$export$f22e7fe56db8ae03.RAW, val).data;
                        else // Blobs don't exist, so this has to be a Uint8Array.
                        return val.data_;
                    });
                    var finalLength = 0;
                    uint8Arrays.forEach(function(array) {
                        finalLength += array.byteLength;
                    });
                    var merged = new Uint8Array(finalLength);
                    var index = 0;
                    uint8Arrays.forEach(function(array) {
                        for(var i = 0; i < array.length; i++)merged[index++] = array[i];
                    });
                    return new FbsBlob(merged, true);
                }
            }
        }
    ]);
    return FbsBlob;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $f11ac745706cbb9d$var$jsonObjectOrNull(s) {
    var obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($f11ac745706cbb9d$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $f11ac745706cbb9d$var$parent(path) {
    if (path.length === 0) return null;
    var index = path.lastIndexOf("/");
    if (index === -1) return "";
    var newPath = path.slice(0, index);
    return newPath;
}
function $f11ac745706cbb9d$var$child(path, childPath) {
    var canonicalChildPath = childPath.split("/").filter(function(component) {
        return component.length > 0;
    }).join("/");
    if (path.length === 0) return canonicalChildPath;
    else return path + "/" + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $f11ac745706cbb9d$var$lastComponent(path) {
    var index = path.lastIndexOf("/", path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f11ac745706cbb9d$var$noXform_(metadata, value) {
    return value;
}
var $f11ac745706cbb9d$var$Mapping = function Mapping(server, local, writable, xform) {
    "use strict";
    (0, $19mwo._)(this, Mapping);
    this.server = server;
    this.local = local || server;
    this.writable = !!writable;
    this.xform = xform || $f11ac745706cbb9d$var$noXform_;
};
var $f11ac745706cbb9d$var$mappings_ = null;
function $f11ac745706cbb9d$var$xformPath(fullPath) {
    if (!$f11ac745706cbb9d$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $f11ac745706cbb9d$var$lastComponent(fullPath);
}
function $f11ac745706cbb9d$var$getMappings() {
    if ($f11ac745706cbb9d$var$mappings_) return $f11ac745706cbb9d$var$mappings_;
    var mappings = [];
    mappings.push(new $f11ac745706cbb9d$var$Mapping("bucket"));
    mappings.push(new $f11ac745706cbb9d$var$Mapping("generation"));
    mappings.push(new $f11ac745706cbb9d$var$Mapping("metageneration"));
    mappings.push(new $f11ac745706cbb9d$var$Mapping("name", "fullPath", true));
    function mappingsXformPath(_metadata, fullPath) {
        return $f11ac745706cbb9d$var$xformPath(fullPath);
    }
    var nameMapping = new $f11ac745706cbb9d$var$Mapping("name");
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if (size !== undefined) return Number(size);
        else return size;
    }
    var sizeMapping = new $f11ac745706cbb9d$var$Mapping("size");
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $f11ac745706cbb9d$var$Mapping("timeCreated"));
    mappings.push(new $f11ac745706cbb9d$var$Mapping("updated"));
    mappings.push(new $f11ac745706cbb9d$var$Mapping("md5Hash", null, true));
    mappings.push(new $f11ac745706cbb9d$var$Mapping("cacheControl", null, true));
    mappings.push(new $f11ac745706cbb9d$var$Mapping("contentDisposition", null, true));
    mappings.push(new $f11ac745706cbb9d$var$Mapping("contentEncoding", null, true));
    mappings.push(new $f11ac745706cbb9d$var$Mapping("contentLanguage", null, true));
    mappings.push(new $f11ac745706cbb9d$var$Mapping("contentType", null, true));
    mappings.push(new $f11ac745706cbb9d$var$Mapping("metadata", "customMetadata", true));
    $f11ac745706cbb9d$var$mappings_ = mappings;
    return $f11ac745706cbb9d$var$mappings_;
}
function $f11ac745706cbb9d$var$addRef(metadata, service) {
    function generateRef() {
        var bucket = metadata["bucket"];
        var path = metadata["fullPath"];
        var loc = new $f11ac745706cbb9d$export$adb98fff6714334(bucket, path);
        return service._makeStorageReference(loc);
    }
    Object.defineProperty(metadata, "ref", {
        get: generateRef
    });
}
function $f11ac745706cbb9d$var$fromResource(service, resource, mappings) {
    var metadata = {};
    metadata["type"] = "file";
    var len = mappings.length;
    for(var i = 0; i < len; i++){
        var mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $f11ac745706cbb9d$var$addRef(metadata, service);
    return metadata;
}
function $f11ac745706cbb9d$var$fromResourceString(service, resourceString, mappings) {
    var obj = $f11ac745706cbb9d$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    var resource = obj;
    return $f11ac745706cbb9d$var$fromResource(service, resource, mappings);
}
function $f11ac745706cbb9d$var$downloadUrlFromResourceString(metadata, resourceString, host, protocol) {
    var obj = $f11ac745706cbb9d$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$f11ac745706cbb9d$var$isString(obj["downloadTokens"])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    var tokens = obj["downloadTokens"];
    if (tokens.length === 0) return null;
    var encode = encodeURIComponent;
    var tokensList = tokens.split(",");
    var urls = tokensList.map(function(token) {
        var bucket = metadata["bucket"];
        var path = metadata["fullPath"];
        var urlPart = "/b/" + encode(bucket) + "/o/" + encode(path);
        var base = $f11ac745706cbb9d$var$makeUrl(urlPart, host, protocol);
        var queryString = $f11ac745706cbb9d$var$makeQueryString({
            alt: "media",
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $f11ac745706cbb9d$var$toResourceString(metadata, mappings) {
    var resource = {};
    var len = mappings.length;
    for(var i = 0; i < len; i++){
        var mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $f11ac745706cbb9d$var$PREFIXES_KEY = "prefixes";
var $f11ac745706cbb9d$var$ITEMS_KEY = "items";
function $f11ac745706cbb9d$var$fromBackendResponse(service, bucket, resource) {
    var listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource["nextPageToken"]
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (resource[$f11ac745706cbb9d$var$PREFIXES_KEY]) try {
        for(var _iterator = resource[$f11ac745706cbb9d$var$PREFIXES_KEY][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var path = _step.value;
            var pathWithoutTrailingSlash = path.replace(/\/$/, "");
            var reference = service._makeStorageReference(new $f11ac745706cbb9d$export$adb98fff6714334(bucket, pathWithoutTrailingSlash));
            listResult.prefixes.push(reference);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    if (resource[$f11ac745706cbb9d$var$ITEMS_KEY]) try {
        for(var _iterator1 = resource[$f11ac745706cbb9d$var$ITEMS_KEY][Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var item = _step1.value;
            var reference1 = service._makeStorageReference(new $f11ac745706cbb9d$export$adb98fff6714334(bucket, item["name"]));
            listResult.items.push(reference1);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return listResult;
}
function $f11ac745706cbb9d$var$fromResponseString(service, bucket, resourceString) {
    var obj = $f11ac745706cbb9d$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    var resource = obj;
    return $f11ac745706cbb9d$var$fromBackendResponse(service, bucket, resource);
}
/**
 * Contains a fully specified request.
 *
 * @param I - the type of the backend's network response.
 * @param O - the output response type used by the rest of the SDK.
 */ var $f11ac745706cbb9d$var$RequestInfo = function RequestInfo(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout) {
    "use strict";
    (0, $19mwo._)(this, RequestInfo);
    this.url = url;
    this.method = method;
    this.handler = handler;
    this.timeout = timeout;
    this.urlParams = {};
    this.headers = {};
    this.body = null;
    this.errorHandler = null;
    /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
    this.successCodes = [
        200
    ];
    this.additionalRetryCodes = [];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN StorageError if cndn is false.
 */ function $f11ac745706cbb9d$var$handlerCheck(cndn) {
    if (!cndn) throw $f11ac745706cbb9d$var$unknown();
}
function $f11ac745706cbb9d$var$metadataHandler(service, mappings) {
    function handler(xhr, text) {
        var metadata = $f11ac745706cbb9d$var$fromResourceString(service, text, mappings);
        $f11ac745706cbb9d$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $f11ac745706cbb9d$var$listHandler(service, bucket) {
    function handler(xhr, text) {
        var listResult = $f11ac745706cbb9d$var$fromResponseString(service, bucket, text);
        $f11ac745706cbb9d$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $f11ac745706cbb9d$var$downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        var metadata = $f11ac745706cbb9d$var$fromResourceString(service, text, mappings);
        $f11ac745706cbb9d$var$handlerCheck(metadata !== null);
        return $f11ac745706cbb9d$var$downloadUrlFromResourceString(metadata, text, service.host, service._protocol);
    }
    return handler;
}
function $f11ac745706cbb9d$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        var newErr;
        if (xhr.getStatus() === 401) {
            if (// This exact message string is the only consistent part of the
            // server's error response that identifies it as an App Check error.
            xhr.getErrorText().includes("Firebase App Check token is invalid")) newErr = $f11ac745706cbb9d$var$unauthorizedApp();
            else newErr = $f11ac745706cbb9d$var$unauthenticated();
        } else {
            if (xhr.getStatus() === 402) newErr = $f11ac745706cbb9d$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $f11ac745706cbb9d$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.status = xhr.getStatus();
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $f11ac745706cbb9d$var$objectErrorHandler(location) {
    var shared = $f11ac745706cbb9d$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        var newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $f11ac745706cbb9d$var$objectNotFound(location.path);
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $f11ac745706cbb9d$var$getMetadata$2(service, location, mappings) {
    var urlPart = location.fullServerUrl();
    var url = $f11ac745706cbb9d$var$makeUrl(urlPart, service.host, service._protocol);
    var method = "GET";
    var timeout = service.maxOperationRetryTime;
    var requestInfo = new $f11ac745706cbb9d$var$RequestInfo(url, method, $f11ac745706cbb9d$var$metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = $f11ac745706cbb9d$var$objectErrorHandler(location);
    return requestInfo;
}
function $f11ac745706cbb9d$var$list$2(service, location, delimiter, pageToken, maxResults) {
    var urlParams = {};
    if (location.isRoot) urlParams["prefix"] = "";
    else urlParams["prefix"] = location.path + "/";
    if (delimiter && delimiter.length > 0) urlParams["delimiter"] = delimiter;
    if (pageToken) urlParams["pageToken"] = pageToken;
    if (maxResults) urlParams["maxResults"] = maxResults;
    var urlPart = location.bucketOnlyServerUrl();
    var url = $f11ac745706cbb9d$var$makeUrl(urlPart, service.host, service._protocol);
    var method = "GET";
    var timeout = service.maxOperationRetryTime;
    var requestInfo = new $f11ac745706cbb9d$var$RequestInfo(url, method, $f11ac745706cbb9d$var$listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $f11ac745706cbb9d$var$sharedErrorHandler(location);
    return requestInfo;
}
function $f11ac745706cbb9d$var$getBytes$1(service, location, maxDownloadSizeBytes) {
    var urlPart = location.fullServerUrl();
    var url = $f11ac745706cbb9d$var$makeUrl(urlPart, service.host, service._protocol) + "?alt=media";
    var method = "GET";
    var timeout = service.maxOperationRetryTime;
    var requestInfo = new $f11ac745706cbb9d$var$RequestInfo(url, method, function(_, data) {
        return data;
    }, timeout);
    requestInfo.errorHandler = $f11ac745706cbb9d$var$objectErrorHandler(location);
    if (maxDownloadSizeBytes !== undefined) {
        requestInfo.headers["Range"] = "bytes=0-".concat(maxDownloadSizeBytes);
        requestInfo.successCodes = [
            200 /* OK */ ,
            206 /* Partial Content */ 
        ];
    }
    return requestInfo;
}
function $f11ac745706cbb9d$var$getDownloadUrl(service, location, mappings) {
    var urlPart = location.fullServerUrl();
    var url = $f11ac745706cbb9d$var$makeUrl(urlPart, service.host, service._protocol);
    var method = "GET";
    var timeout = service.maxOperationRetryTime;
    var requestInfo = new $f11ac745706cbb9d$var$RequestInfo(url, method, $f11ac745706cbb9d$var$downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = $f11ac745706cbb9d$var$objectErrorHandler(location);
    return requestInfo;
}
function $f11ac745706cbb9d$var$updateMetadata$2(service, location, metadata, mappings) {
    var urlPart = location.fullServerUrl();
    var url = $f11ac745706cbb9d$var$makeUrl(urlPart, service.host, service._protocol);
    var method = "PATCH";
    var body = $f11ac745706cbb9d$var$toResourceString(metadata, mappings);
    var headers = {
        "Content-Type": "application/json; charset=utf-8"
    };
    var timeout = service.maxOperationRetryTime;
    var requestInfo = new $f11ac745706cbb9d$var$RequestInfo(url, method, $f11ac745706cbb9d$var$metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $f11ac745706cbb9d$var$objectErrorHandler(location);
    return requestInfo;
}
function $f11ac745706cbb9d$var$deleteObject$2(service, location) {
    var urlPart = location.fullServerUrl();
    var url = $f11ac745706cbb9d$var$makeUrl(urlPart, service.host, service._protocol);
    var method = "DELETE";
    var timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    var requestInfo = new $f11ac745706cbb9d$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $f11ac745706cbb9d$var$objectErrorHandler(location);
    return requestInfo;
}
function $f11ac745706cbb9d$var$determineContentType_(metadata, blob) {
    return metadata && metadata["contentType"] || blob && blob.type() || "application/octet-stream";
}
function $f11ac745706cbb9d$var$metadataForUpload_(location, blob, metadata) {
    var metadataClone = Object.assign({}, metadata);
    metadataClone["fullPath"] = location.path;
    metadataClone["size"] = blob.size();
    if (!metadataClone["contentType"]) metadataClone["contentType"] = $f11ac745706cbb9d$var$determineContentType_(null, blob);
    return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */ function $f11ac745706cbb9d$var$multipartUpload(service, location, mappings, blob, metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var headers = {
        "X-Goog-Upload-Protocol": "multipart"
    };
    function genBoundary() {
        var str = "";
        for(var i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    var boundary = genBoundary();
    headers["Content-Type"] = "multipart/related; boundary=" + boundary;
    var metadata_ = $f11ac745706cbb9d$var$metadataForUpload_(location, blob, metadata);
    var metadataString = $f11ac745706cbb9d$var$toResourceString(metadata_, mappings);
    var preBlobPart = "--" + boundary + "\r\n" + "Content-Type: application/json; charset=utf-8\r\n\r\n" + metadataString + "\r\n--" + boundary + "\r\n" + "Content-Type: " + metadata_["contentType"] + "\r\n\r\n";
    var postBlobPart = "\r\n--" + boundary + "--";
    var body = $f11ac745706cbb9d$export$8deea8629ff0b8a7.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $f11ac745706cbb9d$var$cannotSliceBlob();
    var urlParams = {
        name: metadata_["fullPath"]
    };
    var url = $f11ac745706cbb9d$var$makeUrl(urlPart, service.host, service._protocol);
    var method = "POST";
    var timeout = service.maxUploadRetryTime;
    var requestInfo = new $f11ac745706cbb9d$var$RequestInfo(url, method, $f11ac745706cbb9d$var$metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $f11ac745706cbb9d$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */ var $f11ac745706cbb9d$var$ResumableUploadStatus = function ResumableUploadStatus(current, total, finalized, metadata) {
    "use strict";
    (0, $19mwo._)(this, ResumableUploadStatus);
    this.current = current;
    this.total = total;
    this.finalized = !!finalized;
    this.metadata = metadata || null;
};
function $f11ac745706cbb9d$var$checkResumeHeader_(xhr, allowed) {
    var status = null;
    try {
        status = xhr.getResponseHeader("X-Goog-Upload-Status");
    } catch (e) {
        $f11ac745706cbb9d$var$handlerCheck(false);
    }
    var allowedStatus = allowed || [
        "active"
    ];
    $f11ac745706cbb9d$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $f11ac745706cbb9d$var$createResumableUpload(service, location, mappings, blob, metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var metadataForUpload = $f11ac745706cbb9d$var$metadataForUpload_(location, blob, metadata);
    var urlParams = {
        name: metadataForUpload["fullPath"]
    };
    var url = $f11ac745706cbb9d$var$makeUrl(urlPart, service.host, service._protocol);
    var method = "POST";
    var headers = {
        "X-Goog-Upload-Protocol": "resumable",
        "X-Goog-Upload-Command": "start",
        "X-Goog-Upload-Header-Content-Length": "".concat(blob.size()),
        "X-Goog-Upload-Header-Content-Type": metadataForUpload["contentType"],
        "Content-Type": "application/json; charset=utf-8"
    };
    var body = $f11ac745706cbb9d$var$toResourceString(metadataForUpload, mappings);
    var timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        $f11ac745706cbb9d$var$checkResumeHeader_(xhr);
        var url;
        try {
            url = xhr.getResponseHeader("X-Goog-Upload-URL");
        } catch (e) {
            $f11ac745706cbb9d$var$handlerCheck(false);
        }
        $f11ac745706cbb9d$var$handlerCheck($f11ac745706cbb9d$var$isString(url));
        return url;
    }
    var requestInfo = new $f11ac745706cbb9d$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $f11ac745706cbb9d$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $f11ac745706cbb9d$var$getResumableUploadStatus(service, location, url, blob) {
    var headers = {
        "X-Goog-Upload-Command": "query"
    };
    function handler(xhr) {
        var status = $f11ac745706cbb9d$var$checkResumeHeader_(xhr, [
            "active",
            "final"
        ]);
        var sizeString = null;
        try {
            sizeString = xhr.getResponseHeader("X-Goog-Upload-Size-Received");
        } catch (e) {
            $f11ac745706cbb9d$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $f11ac745706cbb9d$var$handlerCheck(false);
        var size = Number(sizeString);
        $f11ac745706cbb9d$var$handlerCheck(!isNaN(size));
        return new $f11ac745706cbb9d$var$ResumableUploadStatus(size, blob.size(), status === "final");
    }
    var method = "POST";
    var timeout = service.maxUploadRetryTime;
    var requestInfo = new $f11ac745706cbb9d$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $f11ac745706cbb9d$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ var $f11ac745706cbb9d$var$RESUMABLE_UPLOAD_CHUNK_SIZE = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $f11ac745706cbb9d$var$continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    var status_ = new $f11ac745706cbb9d$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $f11ac745706cbb9d$var$serverFileWrongSize();
    var bytesLeft = status_.total - status_.current;
    var bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    var startByte = status_.current;
    var endByte = startByte + bytesToUpload;
    var uploadCommand = "";
    if (bytesToUpload === 0) uploadCommand = "finalize";
    else if (bytesLeft === bytesToUpload) uploadCommand = "upload, finalize";
    else uploadCommand = "upload";
    var headers = {
        "X-Goog-Upload-Command": uploadCommand,
        "X-Goog-Upload-Offset": "".concat(status_.current)
    };
    var body = blob.slice(startByte, endByte);
    if (body === null) throw $f11ac745706cbb9d$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        var uploadStatus = $f11ac745706cbb9d$var$checkResumeHeader_(xhr, [
            "active",
            "final"
        ]);
        var newCurrent = status_.current + bytesToUpload;
        var size = blob.size();
        var metadata;
        if (uploadStatus === "final") metadata = $f11ac745706cbb9d$var$metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new $f11ac745706cbb9d$var$ResumableUploadStatus(newCurrent, size, uploadStatus === "final", metadata);
    }
    var method = "POST";
    var timeout = service.maxUploadRetryTime;
    var requestInfo = new $f11ac745706cbb9d$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $f11ac745706cbb9d$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event that is triggered on a task.
 * @internal
 */ var $f11ac745706cbb9d$export$2cf04e0422ce9b07 = {
    /**
     * For this event,
     * <ul>
     *   <li>The `next` function is triggered on progress updates and when the
     *       task is paused/resumed with an `UploadTaskSnapshot` as the first
     *       argument.</li>
     *   <li>The `error` function is triggered if the upload is canceled or fails
     *       for another reason.</li>
     *   <li>The `complete` function is triggered if the upload completes
     *       successfully.</li>
     * </ul>
     */ STATE_CHANGED: "state_changed"
};
// type keys = keyof TaskState
/**
 * Represents the current state of a running upload.
 * @internal
 */ var $f11ac745706cbb9d$export$9dc4203728a9a7c9 = {
    /** The task is currently transferring data. */ RUNNING: "running",
    /** The task was paused by the user. */ PAUSED: "paused",
    /** The task completed successfully. */ SUCCESS: "success",
    /** The task was canceled. */ CANCELED: "canceled",
    /** The task failed with an error. */ ERROR: "error"
};
function $f11ac745706cbb9d$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case "running" /* InternalTaskState.RUNNING */ :
        case "pausing" /* InternalTaskState.PAUSING */ :
        case "canceling" /* InternalTaskState.CANCELING */ :
            return $f11ac745706cbb9d$export$9dc4203728a9a7c9.RUNNING;
        case "paused" /* InternalTaskState.PAUSED */ :
            return $f11ac745706cbb9d$export$9dc4203728a9a7c9.PAUSED;
        case "success" /* InternalTaskState.SUCCESS */ :
            return $f11ac745706cbb9d$export$9dc4203728a9a7c9.SUCCESS;
        case "canceled" /* InternalTaskState.CANCELED */ :
            return $f11ac745706cbb9d$export$9dc4203728a9a7c9.CANCELED;
        case "error" /* InternalTaskState.ERROR */ :
            return $f11ac745706cbb9d$export$9dc4203728a9a7c9.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $f11ac745706cbb9d$export$9dc4203728a9a7c9.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $f11ac745706cbb9d$var$Observer = function Observer(nextOrObserver, error, complete) {
    "use strict";
    (0, $19mwo._)(this, Observer);
    var asFunctions = $f11ac745706cbb9d$var$isFunction(nextOrObserver) || error != null || complete != null;
    if (asFunctions) {
        this.next = nextOrObserver;
        this.error = error !== null && error !== void 0 ? error : undefined;
        this.complete = complete !== null && complete !== void 0 ? complete : undefined;
    } else {
        var observer = nextOrObserver;
        this.next = observer.next;
        this.error = observer.error;
        this.complete = observer.complete;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f11ac745706cbb9d$var$async(f) {
    return function() {
        for(var _len = arguments.length, argsToForward = new Array(_len), _key = 0; _key < _len; _key++){
            argsToForward[_key] = arguments[_key];
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(function() {
            return f.apply(void 0, (0, $3jzhD._)(argsToForward));
        });
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** An override for the text-based Connection. Used in tests. */ var $f11ac745706cbb9d$var$textFactoryOverride = null;
/**
 * Network layer for browsers. We use this instead of goog.net.XhrIo because
 * goog.net.XhrIo is hyuuuuge and doesn't work in React Native on Android.
 */ var $f11ac745706cbb9d$var$XhrConnection = /*#__PURE__*/ function() {
    "use strict";
    function XhrConnection() {
        var _this = this;
        (0, $19mwo._)(this, XhrConnection);
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.initXhr();
        this.errorCode_ = $f11ac745706cbb9d$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise(function(resolve) {
            _this.xhr_.addEventListener("abort", function() {
                _this.errorCode_ = $f11ac745706cbb9d$var$ErrorCode.ABORT;
                resolve();
            });
            _this.xhr_.addEventListener("error", function() {
                _this.errorCode_ = $f11ac745706cbb9d$var$ErrorCode.NETWORK_ERROR;
                resolve();
            });
            _this.xhr_.addEventListener("load", function() {
                resolve();
            });
        });
    }
    (0, $6rpfc._)(XhrConnection, [
        {
            key: "send",
            value: function send(url, method, body, headers) {
                if (this.sent_) throw $f11ac745706cbb9d$var$internalError("cannot .send() more than once");
                this.sent_ = true;
                this.xhr_.open(method, url, true);
                if (headers !== undefined) {
                    for(var key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
                }
                if (body !== undefined) this.xhr_.send(body);
                else this.xhr_.send();
                return this.sendPromise_;
            }
        },
        {
            key: "getErrorCode",
            value: function getErrorCode() {
                if (!this.sent_) throw $f11ac745706cbb9d$var$internalError("cannot .getErrorCode() before sending");
                return this.errorCode_;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                if (!this.sent_) throw $f11ac745706cbb9d$var$internalError("cannot .getStatus() before sending");
                try {
                    return this.xhr_.status;
                } catch (e) {
                    return -1;
                }
            }
        },
        {
            key: "getResponse",
            value: function getResponse() {
                if (!this.sent_) throw $f11ac745706cbb9d$var$internalError("cannot .getResponse() before sending");
                return this.xhr_.response;
            }
        },
        {
            key: "getErrorText",
            value: function getErrorText() {
                if (!this.sent_) throw $f11ac745706cbb9d$var$internalError("cannot .getErrorText() before sending");
                return this.xhr_.statusText;
            }
        },
        {
            /** Aborts the request. */ key: "abort",
            value: function abort() {
                this.xhr_.abort();
            }
        },
        {
            key: "getResponseHeader",
            value: function getResponseHeader(header) {
                return this.xhr_.getResponseHeader(header);
            }
        },
        {
            key: "addUploadProgressListener",
            value: function addUploadProgressListener(listener) {
                if (this.xhr_.upload != null) this.xhr_.upload.addEventListener("progress", listener);
            }
        },
        {
            key: "removeUploadProgressListener",
            value: function removeUploadProgressListener(listener) {
                if (this.xhr_.upload != null) this.xhr_.upload.removeEventListener("progress", listener);
            }
        }
    ]);
    return XhrConnection;
}();
var $f11ac745706cbb9d$var$XhrTextConnection = /*#__PURE__*/ function(XhrConnection) {
    "use strict";
    (0, $iNfU4._)(XhrTextConnection, XhrConnection);
    var _super = (0, $k1NN5._)(XhrTextConnection);
    function XhrTextConnection() {
        (0, $19mwo._)(this, XhrTextConnection);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(XhrTextConnection, [
        {
            key: "initXhr",
            value: function initXhr() {
                this.xhr_.responseType = "text";
            }
        }
    ]);
    return XhrTextConnection;
}($f11ac745706cbb9d$var$XhrConnection);
function $f11ac745706cbb9d$var$newTextConnection() {
    return $f11ac745706cbb9d$var$textFactoryOverride ? $f11ac745706cbb9d$var$textFactoryOverride() : new $f11ac745706cbb9d$var$XhrTextConnection();
}
var $f11ac745706cbb9d$var$XhrBytesConnection = /*#__PURE__*/ function(XhrConnection) {
    "use strict";
    (0, $iNfU4._)(XhrBytesConnection, XhrConnection);
    var _super = (0, $k1NN5._)(XhrBytesConnection);
    function XhrBytesConnection() {
        (0, $19mwo._)(this, XhrBytesConnection);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(XhrBytesConnection, [
        {
            key: "initXhr",
            value: function initXhr() {
                this.xhr_.responseType = "arraybuffer";
            }
        }
    ]);
    return XhrBytesConnection;
}($f11ac745706cbb9d$var$XhrConnection);
function $f11ac745706cbb9d$var$newBytesConnection() {
    return new $f11ac745706cbb9d$var$XhrBytesConnection();
}
var $f11ac745706cbb9d$var$XhrBlobConnection = /*#__PURE__*/ function(XhrConnection) {
    "use strict";
    (0, $iNfU4._)(XhrBlobConnection, XhrConnection);
    var _super = (0, $k1NN5._)(XhrBlobConnection);
    function XhrBlobConnection() {
        (0, $19mwo._)(this, XhrBlobConnection);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(XhrBlobConnection, [
        {
            key: "initXhr",
            value: function initXhr() {
                this.xhr_.responseType = "blob";
            }
        }
    ]);
    return XhrBlobConnection;
}($f11ac745706cbb9d$var$XhrConnection);
function $f11ac745706cbb9d$var$newBlobConnection() {
    return new $f11ac745706cbb9d$var$XhrBlobConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */ var $f11ac745706cbb9d$export$86a2a9b92406a048 = /*#__PURE__*/ function() {
    "use strict";
    function UploadTask(ref, blob) {
        var _this = this;
        var metadata = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        (0, $19mwo._)(this, UploadTask);
        /**
         * Number of bytes transferred so far.
         */ this._transferred = 0;
        this._needToFetchStatus = false;
        this._needToFetchMetadata = false;
        this._observers = [];
        this._error = undefined;
        this._uploadUrl = undefined;
        this._request = undefined;
        this._chunkMultiplier = 1;
        this._resolve = undefined;
        this._reject = undefined;
        this._ref = ref;
        this._blob = blob;
        this._metadata = metadata;
        this._mappings = $f11ac745706cbb9d$var$getMappings();
        this._resumable = this._shouldDoResumable(this._blob);
        this._state = "running" /* InternalTaskState.RUNNING */ ;
        this._errorHandler = function(error) {
            _this._request = undefined;
            _this._chunkMultiplier = 1;
            if (error._codeEquals($f11ac745706cbb9d$export$54592d666d6ce114.CANCELED)) {
                _this._needToFetchStatus = true;
                _this.completeTransitions_();
            } else {
                var backoffExpired = _this.isExponentialBackoffExpired();
                if ($f11ac745706cbb9d$var$isRetryStatusCode(error.status, [])) {
                    if (backoffExpired) error = $f11ac745706cbb9d$var$retryLimitExceeded();
                    else {
                        _this.sleepTime = Math.max(_this.sleepTime * 2, $f11ac745706cbb9d$var$DEFAULT_MIN_SLEEP_TIME_MILLIS);
                        _this._needToFetchStatus = true;
                        _this.completeTransitions_();
                        return;
                    }
                }
                _this._error = error;
                _this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this._metadataErrorHandler = function(error) {
            _this._request = undefined;
            if (error._codeEquals($f11ac745706cbb9d$export$54592d666d6ce114.CANCELED)) _this.completeTransitions_();
            else {
                _this._error = error;
                _this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this.sleepTime = 0;
        this.maxSleepTime = this._ref.storage.maxUploadRetryTime;
        this._promise = new Promise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
            _this._start();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this._promise.then(null, function() {});
    }
    (0, $6rpfc._)(UploadTask, [
        {
            key: "isExponentialBackoffExpired",
            value: function isExponentialBackoffExpired() {
                return this.sleepTime > this.maxSleepTime;
            }
        },
        {
            key: "_makeProgressCallback",
            value: function _makeProgressCallback() {
                var _this = this;
                var sizeBefore = this._transferred;
                return function(loaded) {
                    return _this._updateProgress(sizeBefore + loaded);
                };
            }
        },
        {
            key: "_shouldDoResumable",
            value: function _shouldDoResumable(blob) {
                return blob.size() > 262144;
            }
        },
        {
            key: "_start",
            value: function _start() {
                var _this = this;
                if (this._state !== "running" /* InternalTaskState.RUNNING */ ) // This can happen if someone pauses us in a resume callback, for example.
                return;
                if (this._request !== undefined) return;
                if (this._resumable) {
                    if (this._uploadUrl === undefined) this._createResumable();
                    else {
                        if (this._needToFetchStatus) this._fetchStatus();
                        else if (this._needToFetchMetadata) // Happens if we miss the metadata on upload completion.
                        this._fetchMetadata();
                        else this.pendingTimeout = setTimeout(function() {
                            _this.pendingTimeout = undefined;
                            _this._continueUpload();
                        }, this.sleepTime);
                    }
                } else this._oneShotUpload();
            }
        },
        {
            key: "_resolveToken",
            value: function _resolveToken(callback) {
                var _this = this;
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.all([
                    this._ref.storage._getAuthToken(),
                    this._ref.storage._getAppCheckToken()
                ]).then(function(param) {
                    var _param = (0, $2MTYX._)(param, 2), authToken = _param[0], appCheckToken = _param[1];
                    switch(_this._state){
                        case "running" /* InternalTaskState.RUNNING */ :
                            callback(authToken, appCheckToken);
                            break;
                        case "canceling" /* InternalTaskState.CANCELING */ :
                            _this._transition("canceled" /* InternalTaskState.CANCELED */ );
                            break;
                        case "pausing" /* InternalTaskState.PAUSING */ :
                            _this._transition("paused" /* InternalTaskState.PAUSED */ );
                            break;
                    }
                });
            }
        },
        {
            // TODO(andysoto): assert false
            key: "_createResumable",
            value: function _createResumable() {
                var _this = this;
                this._resolveToken(function(authToken, appCheckToken) {
                    var requestInfo = $f11ac745706cbb9d$var$createResumableUpload(_this._ref.storage, _this._ref._location, _this._mappings, _this._blob, _this._metadata);
                    var createRequest = _this._ref.storage._makeRequest(requestInfo, $f11ac745706cbb9d$var$newTextConnection, authToken, appCheckToken);
                    _this._request = createRequest;
                    createRequest.getPromise().then(function(url) {
                        _this._request = undefined;
                        _this._uploadUrl = url;
                        _this._needToFetchStatus = false;
                        _this.completeTransitions_();
                    }, _this._errorHandler);
                });
            }
        },
        {
            key: "_fetchStatus",
            value: function _fetchStatus() {
                var _this = this;
                // TODO(andysoto): assert(this.uploadUrl_ !== null);
                var url = this._uploadUrl;
                this._resolveToken(function(authToken, appCheckToken) {
                    var requestInfo = $f11ac745706cbb9d$var$getResumableUploadStatus(_this._ref.storage, _this._ref._location, url, _this._blob);
                    var statusRequest = _this._ref.storage._makeRequest(requestInfo, $f11ac745706cbb9d$var$newTextConnection, authToken, appCheckToken);
                    _this._request = statusRequest;
                    statusRequest.getPromise().then(function(status) {
                        status;
                        _this._request = undefined;
                        _this._updateProgress(status.current);
                        _this._needToFetchStatus = false;
                        if (status.finalized) _this._needToFetchMetadata = true;
                        _this.completeTransitions_();
                    }, _this._errorHandler);
                });
            }
        },
        {
            key: "_continueUpload",
            value: function _continueUpload() {
                var _this = this;
                var chunkSize = $f11ac745706cbb9d$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
                var status = new $f11ac745706cbb9d$var$ResumableUploadStatus(this._transferred, this._blob.size());
                // TODO(andysoto): assert(this.uploadUrl_ !== null);
                var url = this._uploadUrl;
                this._resolveToken(function(authToken, appCheckToken) {
                    var requestInfo;
                    try {
                        requestInfo = $f11ac745706cbb9d$var$continueResumableUpload(_this._ref._location, _this._ref.storage, url, _this._blob, chunkSize, _this._mappings, status, _this._makeProgressCallback());
                    } catch (e) {
                        _this._error = e;
                        _this._transition("error" /* InternalTaskState.ERROR */ );
                        return;
                    }
                    var uploadRequest = _this._ref.storage._makeRequest(requestInfo, $f11ac745706cbb9d$var$newTextConnection, authToken, appCheckToken, /*retry=*/ false // Upload requests should not be retried as each retry should be preceded by another query request. Which is handled in this file.
                    );
                    _this._request = uploadRequest;
                    uploadRequest.getPromise().then(function(newStatus) {
                        _this._increaseMultiplier();
                        _this._request = undefined;
                        _this._updateProgress(newStatus.current);
                        if (newStatus.finalized) {
                            _this._metadata = newStatus.metadata;
                            _this._transition("success" /* InternalTaskState.SUCCESS */ );
                        } else _this.completeTransitions_();
                    }, _this._errorHandler);
                });
            }
        },
        {
            key: "_increaseMultiplier",
            value: function _increaseMultiplier() {
                var currentSize = $f11ac745706cbb9d$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
                // Max chunk size is 32M.
                if (currentSize * 2 < 33554432) this._chunkMultiplier *= 2;
            }
        },
        {
            key: "_fetchMetadata",
            value: function _fetchMetadata() {
                var _this = this;
                this._resolveToken(function(authToken, appCheckToken) {
                    var requestInfo = $f11ac745706cbb9d$var$getMetadata$2(_this._ref.storage, _this._ref._location, _this._mappings);
                    var metadataRequest = _this._ref.storage._makeRequest(requestInfo, $f11ac745706cbb9d$var$newTextConnection, authToken, appCheckToken);
                    _this._request = metadataRequest;
                    metadataRequest.getPromise().then(function(metadata) {
                        _this._request = undefined;
                        _this._metadata = metadata;
                        _this._transition("success" /* InternalTaskState.SUCCESS */ );
                    }, _this._metadataErrorHandler);
                });
            }
        },
        {
            key: "_oneShotUpload",
            value: function _oneShotUpload() {
                var _this = this;
                this._resolveToken(function(authToken, appCheckToken) {
                    var requestInfo = $f11ac745706cbb9d$var$multipartUpload(_this._ref.storage, _this._ref._location, _this._mappings, _this._blob, _this._metadata);
                    var multipartRequest = _this._ref.storage._makeRequest(requestInfo, $f11ac745706cbb9d$var$newTextConnection, authToken, appCheckToken);
                    _this._request = multipartRequest;
                    multipartRequest.getPromise().then(function(metadata) {
                        _this._request = undefined;
                        _this._metadata = metadata;
                        _this._updateProgress(_this._blob.size());
                        _this._transition("success" /* InternalTaskState.SUCCESS */ );
                    }, _this._errorHandler);
                });
            }
        },
        {
            key: "_updateProgress",
            value: function _updateProgress(transferred) {
                var old = this._transferred;
                this._transferred = transferred;
                // A progress update can make the "transferred" value smaller (e.g. a
                // partial upload not completed by server, after which the "transferred"
                // value may reset to the value at the beginning of the request).
                if (this._transferred !== old) this._notifyObservers();
            }
        },
        {
            key: "_transition",
            value: function _transition(state) {
                if (this._state === state) return;
                switch(state){
                    case "canceling" /* InternalTaskState.CANCELING */ :
                    case "pausing" /* InternalTaskState.PAUSING */ :
                        // TODO(andysoto):
                        // assert(this.state_ === InternalTaskState.RUNNING ||
                        //        this.state_ === InternalTaskState.PAUSING);
                        this._state = state;
                        if (this._request !== undefined) this._request.cancel();
                        else if (this.pendingTimeout) {
                            clearTimeout(this.pendingTimeout);
                            this.pendingTimeout = undefined;
                            this.completeTransitions_();
                        }
                        break;
                    case "running" /* InternalTaskState.RUNNING */ :
                        // TODO(andysoto):
                        // assert(this.state_ === InternalTaskState.PAUSED ||
                        //        this.state_ === InternalTaskState.PAUSING);
                        var wasPaused = this._state === "paused" /* InternalTaskState.PAUSED */ ;
                        this._state = state;
                        if (wasPaused) {
                            this._notifyObservers();
                            this._start();
                        }
                        break;
                    case "paused" /* InternalTaskState.PAUSED */ :
                        // TODO(andysoto):
                        // assert(this.state_ === InternalTaskState.PAUSING);
                        this._state = state;
                        this._notifyObservers();
                        break;
                    case "canceled" /* InternalTaskState.CANCELED */ :
                        // TODO(andysoto):
                        // assert(this.state_ === InternalTaskState.PAUSED ||
                        //        this.state_ === InternalTaskState.CANCELING);
                        this._error = $f11ac745706cbb9d$var$canceled();
                        this._state = state;
                        this._notifyObservers();
                        break;
                    case "error" /* InternalTaskState.ERROR */ :
                        // TODO(andysoto):
                        // assert(this.state_ === InternalTaskState.RUNNING ||
                        //        this.state_ === InternalTaskState.PAUSING ||
                        //        this.state_ === InternalTaskState.CANCELING);
                        this._state = state;
                        this._notifyObservers();
                        break;
                    case "success" /* InternalTaskState.SUCCESS */ :
                        // TODO(andysoto):
                        // assert(this.state_ === InternalTaskState.RUNNING ||
                        //        this.state_ === InternalTaskState.PAUSING ||
                        //        this.state_ === InternalTaskState.CANCELING);
                        this._state = state;
                        this._notifyObservers();
                        break;
                }
            }
        },
        {
            key: "completeTransitions_",
            value: function completeTransitions_() {
                switch(this._state){
                    case "pausing" /* InternalTaskState.PAUSING */ :
                        this._transition("paused" /* InternalTaskState.PAUSED */ );
                        break;
                    case "canceling" /* InternalTaskState.CANCELING */ :
                        this._transition("canceled" /* InternalTaskState.CANCELED */ );
                        break;
                    case "running" /* InternalTaskState.RUNNING */ :
                        this._start();
                        break;
                }
            }
        },
        {
            key: "snapshot",
            get: /**
     * A snapshot of the current task state.
     */ function get() {
                var externalState = $f11ac745706cbb9d$var$taskStateFromInternalTaskState(this._state);
                return {
                    bytesTransferred: this._transferred,
                    totalBytes: this._blob.size(),
                    state: externalState,
                    metadata: this._metadata,
                    task: this,
                    ref: this._ref
                };
            }
        },
        {
            /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `StorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */ key: "on",
            value: function on(type, nextOrObserver, error, completed) {
                var _this = this;
                // Note: `type` isn't being used. Its type is also incorrect. TaskEvent should not be a string.
                var observer = new $f11ac745706cbb9d$var$Observer(nextOrObserver || undefined, error || undefined, completed || undefined);
                this._addObserver(observer);
                return function() {
                    _this._removeObserver(observer);
                };
            }
        },
        {
            /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */ key: "then",
            value: function then(onFulfilled, onRejected) {
                // These casts are needed so that TypeScript can infer the types of the
                // resulting Promise.
                return this._promise.then(onFulfilled, onRejected);
            }
        },
        {
            /**
     * Equivalent to calling `then(null, onRejected)`.
     */ key: "catch",
            value: function _catch(onRejected) {
                return this.then(null, onRejected);
            }
        },
        {
            /**
     * Adds the given observer.
     */ key: "_addObserver",
            value: function _addObserver(observer) {
                this._observers.push(observer);
                this._notifyObserver(observer);
            }
        },
        {
            /**
     * Removes the given observer.
     */ key: "_removeObserver",
            value: function _removeObserver(observer) {
                var i = this._observers.indexOf(observer);
                if (i !== -1) this._observers.splice(i, 1);
            }
        },
        {
            key: "_notifyObservers",
            value: function _notifyObservers() {
                var _this = this;
                this._finishPromise();
                var observers = this._observers.slice();
                observers.forEach(function(observer) {
                    _this._notifyObserver(observer);
                });
            }
        },
        {
            key: "_finishPromise",
            value: function _finishPromise() {
                if (this._resolve !== undefined) {
                    var triggered = true;
                    switch($f11ac745706cbb9d$var$taskStateFromInternalTaskState(this._state)){
                        case $f11ac745706cbb9d$export$9dc4203728a9a7c9.SUCCESS:
                            $f11ac745706cbb9d$var$async(this._resolve.bind(null, this.snapshot))();
                            break;
                        case $f11ac745706cbb9d$export$9dc4203728a9a7c9.CANCELED:
                        case $f11ac745706cbb9d$export$9dc4203728a9a7c9.ERROR:
                            var toCall = this._reject;
                            $f11ac745706cbb9d$var$async(toCall.bind(null, this._error))();
                            break;
                        default:
                            triggered = false;
                            break;
                    }
                    if (triggered) {
                        this._resolve = undefined;
                        this._reject = undefined;
                    }
                }
            }
        },
        {
            key: "_notifyObserver",
            value: function _notifyObserver(observer) {
                var externalState = $f11ac745706cbb9d$var$taskStateFromInternalTaskState(this._state);
                switch(externalState){
                    case $f11ac745706cbb9d$export$9dc4203728a9a7c9.RUNNING:
                    case $f11ac745706cbb9d$export$9dc4203728a9a7c9.PAUSED:
                        if (observer.next) $f11ac745706cbb9d$var$async(observer.next.bind(observer, this.snapshot))();
                        break;
                    case $f11ac745706cbb9d$export$9dc4203728a9a7c9.SUCCESS:
                        if (observer.complete) $f11ac745706cbb9d$var$async(observer.complete.bind(observer))();
                        break;
                    case $f11ac745706cbb9d$export$9dc4203728a9a7c9.CANCELED:
                    case $f11ac745706cbb9d$export$9dc4203728a9a7c9.ERROR:
                        if (observer.error) $f11ac745706cbb9d$var$async(observer.error.bind(observer, this._error))();
                        break;
                    default:
                        // TODO(andysoto): assert(false);
                        if (observer.error) $f11ac745706cbb9d$var$async(observer.error.bind(observer, this._error))();
                }
            }
        },
        {
            /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ key: "resume",
            value: function resume() {
                var valid = this._state === "paused" /* InternalTaskState.PAUSED */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
                if (valid) this._transition("running" /* InternalTaskState.RUNNING */ );
                return valid;
            }
        },
        {
            /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ key: "pause",
            value: function pause() {
                var valid = this._state === "running" /* InternalTaskState.RUNNING */ ;
                if (valid) this._transition("pausing" /* InternalTaskState.PAUSING */ );
                return valid;
            }
        },
        {
            /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */ key: "cancel",
            value: function cancel() {
                var valid = this._state === "running" /* InternalTaskState.RUNNING */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
                if (valid) this._transition("canceling" /* InternalTaskState.CANCELING */ );
                return valid;
            }
        }
    ]);
    return UploadTask;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ var $f11ac745706cbb9d$var$Reference = /*#__PURE__*/ function() {
    "use strict";
    function Reference(_service, location) {
        (0, $19mwo._)(this, Reference);
        this._service = _service;
        if (location instanceof $f11ac745706cbb9d$export$adb98fff6714334) this._location = location;
        else this._location = $f11ac745706cbb9d$export$adb98fff6714334.makeFromUrl(location, _service.host);
    }
    (0, $6rpfc._)(Reference, [
        {
            /**
     * Returns the URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ key: "toString",
            value: function toString() {
                return "gs://" + this._location.bucket + "/" + this._location.path;
            }
        },
        {
            key: "_newRef",
            value: function _newRef(service, location) {
                return new Reference(service, location);
            }
        },
        {
            key: "root",
            get: /**
     * A reference to the root of this object's bucket.
     */ function get() {
                var location = new $f11ac745706cbb9d$export$adb98fff6714334(this._location.bucket, "");
                return this._newRef(this._service, location);
            }
        },
        {
            key: "bucket",
            get: /**
     * The name of the bucket containing this reference's object.
     */ function get() {
                return this._location.bucket;
            }
        },
        {
            key: "fullPath",
            get: /**
     * The full path of this object.
     */ function get() {
                return this._location.path;
            }
        },
        {
            key: "name",
            get: /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */ function get() {
                return $f11ac745706cbb9d$var$lastComponent(this._location.path);
            }
        },
        {
            key: "storage",
            get: /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */ function get() {
                return this._service;
            }
        },
        {
            key: "parent",
            get: /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */ function get() {
                var newPath = $f11ac745706cbb9d$var$parent(this._location.path);
                if (newPath === null) return null;
                var location = new $f11ac745706cbb9d$export$adb98fff6714334(this._location.bucket, newPath);
                return new Reference(this._service, location);
            }
        },
        {
            /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */ key: "_throwIfRoot",
            value: function _throwIfRoot(name) {
                if (this._location.path === "") throw $f11ac745706cbb9d$export$61f54cdc36500ad(name);
            }
        }
    ]);
    return Reference;
}();
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded bytes.
 */ function $f11ac745706cbb9d$var$getBytesInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot("getBytes");
    var requestInfo = $f11ac745706cbb9d$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $f11ac745706cbb9d$var$newBytesConnection).then(function(bytes) {
        return maxDownloadSizeBytes !== undefined ? bytes.slice(0, maxDownloadSizeBytes) : bytes;
    });
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded blob.
 */ function $f11ac745706cbb9d$var$getBlobInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot("getBlob");
    var requestInfo = $f11ac745706cbb9d$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $f11ac745706cbb9d$var$newBlobConnection).then(function(blob) {
        return maxDownloadSizeBytes !== undefined ? blob.slice(0, maxDownloadSizeBytes) : blob;
    });
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */ function $f11ac745706cbb9d$var$uploadBytes$1(ref, data, metadata) {
    ref._throwIfRoot("uploadBytes");
    var requestInfo = $f11ac745706cbb9d$var$multipartUpload(ref.storage, ref._location, $f11ac745706cbb9d$var$getMappings(), new $f11ac745706cbb9d$export$8deea8629ff0b8a7(data, true), metadata);
    return ref.storage.makeRequestWithTokens(requestInfo, $f11ac745706cbb9d$var$newTextConnection).then(function(finalMetadata) {
        return {
            metadata: finalMetadata,
            ref: ref
        };
    });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */ function $f11ac745706cbb9d$var$uploadBytesResumable$1(ref, data, metadata) {
    ref._throwIfRoot("uploadBytesResumable");
    return new $f11ac745706cbb9d$export$86a2a9b92406a048(ref, new $f11ac745706cbb9d$export$8deea8629ff0b8a7(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */ function $f11ac745706cbb9d$var$uploadString$1(ref, value) {
    var format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $f11ac745706cbb9d$export$f22e7fe56db8ae03.RAW, metadata = arguments.length > 3 ? arguments[3] : void 0;
    ref._throwIfRoot("uploadString");
    var data = $f11ac745706cbb9d$export$d80b9b5a2ccdd3e0(format, value);
    var metadataClone = Object.assign({}, metadata);
    if (metadataClone["contentType"] == null && data.contentType != null) metadataClone["contentType"] = data.contentType;
    return $f11ac745706cbb9d$var$uploadBytes$1(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $f11ac745706cbb9d$var$listAll$1(ref) {
    var accumulator = {
        prefixes: [],
        items: []
    };
    return $f11ac745706cbb9d$var$listAllHelper(ref, accumulator).then(function() {
        return accumulator;
    });
}
function $f11ac745706cbb9d$var$listAllHelper(ref, accumulator, pageToken) {
    return $f11ac745706cbb9d$var$_listAllHelper.apply(this, arguments);
}
function $f11ac745706cbb9d$var$_listAllHelper() {
    $f11ac745706cbb9d$var$_listAllHelper = /**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */ (0, $9OZ9j._)(function(ref, accumulator, pageToken) {
        var _accumulator_prefixes, _accumulator_items, opt, nextPage;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    opt = {
                        // maxResults is 1000 by default.
                        pageToken: pageToken
                    };
                    return [
                        4,
                        $f11ac745706cbb9d$var$list$1(ref, opt)
                    ];
                case 1:
                    nextPage = _state.sent();
                    (_accumulator_prefixes = accumulator.prefixes).push.apply(_accumulator_prefixes, (0, $3jzhD._)(nextPage.prefixes));
                    (_accumulator_items = accumulator.items).push.apply(_accumulator_items, (0, $3jzhD._)(nextPage.items));
                    if (!(nextPage.nextPageToken != null)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $f11ac745706cbb9d$var$listAllHelper(ref, accumulator, nextPage.nextPageToken)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $f11ac745706cbb9d$var$_listAllHelper.apply(this, arguments);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $f11ac745706cbb9d$var$list$1(ref, options) {
    if (options != null) {
        if (typeof options.maxResults === "number") $f11ac745706cbb9d$var$validateNumber("options.maxResults", /* minValue= */ 1, /* maxValue= */ 1000, options.maxResults);
    }
    var op = options || {};
    var requestInfo = $f11ac745706cbb9d$var$list$2(ref.storage, ref._location, /*delimiter= */ "/", op.pageToken, op.maxResults);
    return ref.storage.makeRequestWithTokens(requestInfo, $f11ac745706cbb9d$var$newTextConnection);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retreived, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */ function $f11ac745706cbb9d$var$getMetadata$1(ref) {
    ref._throwIfRoot("getMetadata");
    var requestInfo = $f11ac745706cbb9d$var$getMetadata$2(ref.storage, ref._location, $f11ac745706cbb9d$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $f11ac745706cbb9d$var$newTextConnection);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */ function $f11ac745706cbb9d$var$updateMetadata$1(ref, metadata) {
    ref._throwIfRoot("updateMetadata");
    var requestInfo = $f11ac745706cbb9d$var$updateMetadata$2(ref.storage, ref._location, metadata, $f11ac745706cbb9d$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $f11ac745706cbb9d$var$newTextConnection);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $f11ac745706cbb9d$var$getDownloadURL$1(ref) {
    ref._throwIfRoot("getDownloadURL");
    var requestInfo = $f11ac745706cbb9d$var$getDownloadUrl(ref.storage, ref._location, $f11ac745706cbb9d$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $f11ac745706cbb9d$var$newTextConnection).then(function(url) {
        if (url === null) throw $f11ac745706cbb9d$var$noDownloadURL();
        return url;
    });
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $f11ac745706cbb9d$var$deleteObject$1(ref) {
    ref._throwIfRoot("deleteObject");
    var requestInfo = $f11ac745706cbb9d$var$deleteObject$2(ref.storage, ref._location);
    return ref.storage.makeRequestWithTokens(requestInfo, $f11ac745706cbb9d$var$newTextConnection);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */ function $f11ac745706cbb9d$var$_getChild$1(ref, childPath) {
    var newPath = $f11ac745706cbb9d$var$child(ref._location.path, childPath);
    var location = new $f11ac745706cbb9d$export$adb98fff6714334(ref._location.bucket, newPath);
    return new $f11ac745706cbb9d$var$Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f11ac745706cbb9d$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */ function $f11ac745706cbb9d$var$refFromURL(service, url) {
    return new $f11ac745706cbb9d$var$Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */ function $f11ac745706cbb9d$var$refFromPath(ref, path) {
    if (ref instanceof $f11ac745706cbb9d$var$FirebaseStorageImpl) {
        var service = ref;
        if (service._bucket == null) throw $f11ac745706cbb9d$var$noDefaultBucket();
        var reference = new $f11ac745706cbb9d$var$Reference(service, service._bucket);
        if (path != null) return $f11ac745706cbb9d$var$refFromPath(reference, path);
        else return reference;
    } else {
        // ref is a Reference
        if (path !== undefined) return $f11ac745706cbb9d$var$_getChild$1(ref, path);
        else return ref;
    }
}
function $f11ac745706cbb9d$var$ref$1(serviceOrRef, pathOrUrl) {
    if (pathOrUrl && $f11ac745706cbb9d$var$isUrl(pathOrUrl)) {
        if (serviceOrRef instanceof $f11ac745706cbb9d$var$FirebaseStorageImpl) return $f11ac745706cbb9d$var$refFromURL(serviceOrRef, pathOrUrl);
        else throw $f11ac745706cbb9d$export$8f74d9881d1936fd("To use ref(service, url), the first argument must be a Storage instance.");
    } else return $f11ac745706cbb9d$var$refFromPath(serviceOrRef, pathOrUrl);
}
function $f11ac745706cbb9d$var$extractBucket(host, config) {
    var bucketString = config === null || config === void 0 ? void 0 : config[$f11ac745706cbb9d$var$CONFIG_STORAGE_BUCKET_KEY];
    if (bucketString == null) return null;
    return $f11ac745706cbb9d$export$adb98fff6714334.makeFromBucketSpec(bucketString, host);
}
function $f11ac745706cbb9d$var$connectStorageEmulator$1(storage, host, port) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    storage.host = "".concat(host, ":").concat(port);
    storage._protocol = "http";
    var mockUserToken = options.mockUserToken;
    if (mockUserToken) storage._overrideAuthToken = typeof mockUserToken === "string" ? mockUserToken : (0, $gQ5gw.createMockUserToken)(mockUserToken, storage.app.options.projectId);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @param opt_url - gs:// url to a custom Storage Bucket
 *
 * @internal
 */ var $f11ac745706cbb9d$var$FirebaseStorageImpl = /*#__PURE__*/ function() {
    "use strict";
    function FirebaseStorageImpl(/**
     * FirebaseApp associated with this StorageService instance.
     */ app, _authProvider, /**
     * @internal
     */ _appCheckProvider, /**
     * @internal
     */ _url, _firebaseVersion) {
        (0, $19mwo._)(this, FirebaseStorageImpl);
        this.app = app;
        this._authProvider = _authProvider;
        this._appCheckProvider = _appCheckProvider;
        this._url = _url;
        this._firebaseVersion = _firebaseVersion;
        this._bucket = null;
        /**
         * This string can be in the formats:
         * - host
         * - host:port
         */ this._host = $f11ac745706cbb9d$var$DEFAULT_HOST;
        this._protocol = "https";
        this._appId = null;
        this._deleted = false;
        this._maxOperationRetryTime = $f11ac745706cbb9d$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this._maxUploadRetryTime = $f11ac745706cbb9d$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this._requests = new Set();
        if (_url != null) this._bucket = $f11ac745706cbb9d$export$adb98fff6714334.makeFromBucketSpec(_url, this._host);
        else this._bucket = $f11ac745706cbb9d$var$extractBucket(this._host, this.app.options);
    }
    (0, $6rpfc._)(FirebaseStorageImpl, [
        {
            key: "host",
            get: /**
     * The host string for this service, in the form of `host` or
     * `host:port`.
     */ function get() {
                return this._host;
            },
            set: function set(host) {
                this._host = host;
                if (this._url != null) this._bucket = $f11ac745706cbb9d$export$adb98fff6714334.makeFromBucketSpec(this._url, host);
                else this._bucket = $f11ac745706cbb9d$var$extractBucket(host, this.app.options);
            }
        },
        {
            key: "maxUploadRetryTime",
            get: /**
     * The maximum time to retry uploads in milliseconds.
     */ function get() {
                return this._maxUploadRetryTime;
            },
            set: function set(time) {
                $f11ac745706cbb9d$var$validateNumber("time", /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
                this._maxUploadRetryTime = time;
            }
        },
        {
            key: "maxOperationRetryTime",
            get: /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */ function get() {
                return this._maxOperationRetryTime;
            },
            set: function set(time) {
                $f11ac745706cbb9d$var$validateNumber("time", /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
                this._maxOperationRetryTime = time;
            }
        },
        {
            key: "_getAuthToken",
            value: function _getAuthToken() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var auth, tokenData;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this._overrideAuthToken) return [
                                    2,
                                    _this._overrideAuthToken
                                ];
                                auth = _this._authProvider.getImmediate({
                                    optional: true
                                });
                                if (!auth) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    auth.getToken()
                                ];
                            case 1:
                                tokenData = _state.sent();
                                if (tokenData !== null) return [
                                    2,
                                    tokenData.accessToken
                                ];
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getAppCheckToken",
            value: function _getAppCheckToken() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var appCheck, result;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                appCheck = _this._appCheckProvider.getImmediate({
                                    optional: true
                                });
                                if (!appCheck) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    appCheck.getToken()
                                ];
                            case 1:
                                result = _state.sent();
                                // TODO: What do we want to do if there is an error getting the token?
                                // Context: appCheck.getToken() will never throw even if an error happened. In the error case, a dummy token will be
                                // returned along with an error field describing the error. In general, we shouldn't care about the error condition and just use
                                // the token (actual or dummy) to send requests.
                                return [
                                    2,
                                    result.token
                                ];
                            case 2:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Stop running requests and prevent more from being created.
     */ key: "_delete",
            value: function _delete() {
                if (!this._deleted) {
                    this._deleted = true;
                    this._requests.forEach(function(request) {
                        return request.cancel();
                    });
                    this._requests.clear();
                }
                return Promise.resolve();
            }
        },
        {
            /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */ key: "_makeStorageReference",
            value: function _makeStorageReference(loc) {
                return new $f11ac745706cbb9d$var$Reference(this, loc);
            }
        },
        {
            /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */ key: "_makeRequest",
            value: function _makeRequest(requestInfo, requestFactory, authToken, appCheckToken) {
                var _this = this;
                var retry = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
                if (!this._deleted) {
                    var request = $f11ac745706cbb9d$var$makeRequest(requestInfo, this._appId, authToken, appCheckToken, requestFactory, this._firebaseVersion, retry);
                    this._requests.add(request);
                    // Request removes itself from set when complete.
                    request.getPromise().then(function() {
                        return _this._requests.delete(request);
                    }, function() {
                        return _this._requests.delete(request);
                    });
                    return request;
                } else return new $f11ac745706cbb9d$var$FailRequest($f11ac745706cbb9d$var$appDeleted());
            }
        },
        {
            key: "makeRequestWithTokens",
            value: function makeRequestWithTokens(requestInfo, requestFactory) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _ref, authToken, appCheckToken;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all([
                                        _this._getAuthToken(),
                                        _this._getAppCheckToken()
                                    ])
                                ];
                            case 1:
                                _ref = (0, $2MTYX._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), authToken = _ref[0], appCheckToken = _ref[1];
                                return [
                                    2,
                                    _this._makeRequest(requestInfo, requestFactory, authToken, appCheckToken).getPromise()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return FirebaseStorageImpl;
}();
var $f11ac745706cbb9d$var$name = "@firebase/storage";
var $f11ac745706cbb9d$var$version = "0.12.6";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ var $f11ac745706cbb9d$var$STORAGE_TYPE = "storage";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise containing the object's bytes
 */ function $f11ac745706cbb9d$export$a3521add2594f3c8(ref, maxDownloadSizeBytes) {
    ref = (0, $gQ5gw.getModularInstance)(ref);
    return $f11ac745706cbb9d$var$getBytesInternal(ref, maxDownloadSizeBytes);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */ function $f11ac745706cbb9d$export$ac40f56b52f99dd1(ref, data, metadata) {
    ref = (0, $gQ5gw.getModularInstance)(ref);
    return $f11ac745706cbb9d$var$uploadBytes$1(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */ function $f11ac745706cbb9d$export$d885b2eb178808b3(ref, value, format, metadata) {
    ref = (0, $gQ5gw.getModularInstance)(ref);
    return $f11ac745706cbb9d$var$uploadString$1(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */ function $f11ac745706cbb9d$export$3895d39eb7ac9b25(ref, data, metadata) {
    ref = (0, $gQ5gw.getModularInstance)(ref);
    return $f11ac745706cbb9d$var$uploadBytesResumable$1(ref, data, metadata);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retreived, the promise is
 * rejected.
 * @public
 * @param ref - {@link StorageReference} to get metadata from.
 */ function $f11ac745706cbb9d$export$8548546c0aa631e6(ref) {
    ref = (0, $gQ5gw.getModularInstance)(ref);
    return $f11ac745706cbb9d$var$getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - {@link StorageReference} to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves with the new metadata for this object.
 */ function $f11ac745706cbb9d$export$f64791b2d30456a0(ref, metadata) {
    ref = (0, $gQ5gw.getModularInstance)(ref);
    return $f11ac745706cbb9d$var$updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - {@link StorageReference} to get list from.
 * @param options - See {@link ListOptions} for details.
 * @returns A `Promise` that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $f11ac745706cbb9d$export$8837f4fc672e936d(ref, options) {
    ref = (0, $gQ5gw.getModularInstance)(ref);
    return $f11ac745706cbb9d$var$list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: `listAll` may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - {@link StorageReference} to get list from.
 *
 * @returns A `Promise` that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $f11ac745706cbb9d$export$6a265a7d315dec03(ref) {
    ref = (0, $gQ5gw.getModularInstance)(ref);
    return $f11ac745706cbb9d$var$listAll$1(ref);
}
/**
 * Returns the download URL for the given {@link StorageReference}.
 * @public
 * @param ref - {@link StorageReference} to get the download URL for.
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $f11ac745706cbb9d$export$c8bf645a0c2a7d9f(ref) {
    ref = (0, $gQ5gw.getModularInstance)(ref);
    return $f11ac745706cbb9d$var$getDownloadURL$1(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - {@link StorageReference} for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $f11ac745706cbb9d$export$39c5ed4ec960eade(ref) {
    ref = (0, $gQ5gw.getModularInstance)(ref);
    return $f11ac745706cbb9d$var$deleteObject$1(ref);
}
function $f11ac745706cbb9d$export$eff4d24c3ff7876e(serviceOrRef, pathOrUrl) {
    serviceOrRef = (0, $gQ5gw.getModularInstance)(serviceOrRef);
    return $f11ac745706cbb9d$var$ref$1(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */ function $f11ac745706cbb9d$export$9acd24c0fce96a85(ref, childPath) {
    return $f11ac745706cbb9d$var$_getChild$1(ref, childPath);
}
/**
 * Gets a {@link FirebaseStorage} instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get {@link FirebaseStorage} instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A {@link FirebaseStorage} instance.
 */ function $f11ac745706cbb9d$export$fbd9b57a66480737() {
    var app = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $ilNGG.getApp)(), bucketUrl = arguments.length > 1 ? arguments[1] : void 0;
    app = (0, $gQ5gw.getModularInstance)(app);
    var storageProvider = (0, $ilNGG._getProvider)(app, $f11ac745706cbb9d$var$STORAGE_TYPE);
    var storageInstance = storageProvider.getImmediate({
        identifier: bucketUrl
    });
    var emulator = (0, $gQ5gw.getDefaultEmulatorHostnameAndPort)("storage");
    if (emulator) $f11ac745706cbb9d$export$9850e656f954b889.apply(void 0, [
        storageInstance
    ].concat((0, $3jzhD._)(emulator)));
    return storageInstance;
}
/**
 * Modify this {@link FirebaseStorage} instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The {@link FirebaseStorage} instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @param options - Emulator options. `options.mockUserToken` is the mock auth
 * token to use for unit testing Security Rules.
 * @public
 */ function $f11ac745706cbb9d$export$9850e656f954b889(storage, host, port) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    $f11ac745706cbb9d$var$connectStorageEmulator$1(storage, host, port, options);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * This API is not available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise that resolves with a Blob containing the object's bytes
 */ function $f11ac745706cbb9d$export$37610328929d7521(ref, maxDownloadSizeBytes) {
    ref = (0, $gQ5gw.getModularInstance)(ref);
    return $f11ac745706cbb9d$var$getBlobInternal(ref, maxDownloadSizeBytes);
}
/**
 * Downloads the data at the object's location. Raises an error event if the
 * object is not found.
 *
 * This API is only available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A stream with the object's data as bytes
 */ function $f11ac745706cbb9d$export$747191980cdf43e8(ref, maxDownloadSizeBytes) {
    throw new Error("getStream() is only supported by NodeJS builds");
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */ function $f11ac745706cbb9d$var$factory(container, param) {
    var url = param.instanceIdentifier;
    var app = container.getProvider("app").getImmediate();
    var authProvider = container.getProvider("auth-internal");
    var appCheckProvider = container.getProvider("app-check-internal");
    return new $f11ac745706cbb9d$var$FirebaseStorageImpl(app, authProvider, appCheckProvider, url, (0, $ilNGG.SDK_VERSION));
}
function $f11ac745706cbb9d$var$registerStorage() {
    (0, $ilNGG._registerComponent)(new (0, $e5K63.Component)($f11ac745706cbb9d$var$STORAGE_TYPE, $f11ac745706cbb9d$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    //RUNTIME_ENV will be replaced during the compilation to "node" for nodejs and an empty string for browser
    (0, $ilNGG.registerVersion)($f11ac745706cbb9d$var$name, $f11ac745706cbb9d$var$version, "");
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $ilNGG.registerVersion)($f11ac745706cbb9d$var$name, $f11ac745706cbb9d$var$version, "esm2017");
}
$f11ac745706cbb9d$var$registerStorage();




var $fe3694ddba3770ae$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fe3694ddba3770ae$var$FirebaseAdapater = /*#__PURE__*/ function() {
    "use strict";
    function FirebaseAdapater() {
        (0, $19mwo._)(this, FirebaseAdapater);
        Object.defineProperty(this, "unsubList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "app", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "db", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    (0, $6rpfc._)(FirebaseAdapater, [
        {
            key: "buildPath",
            value: function buildPath(sectionName, id) {
                var sections = [
                    "users",
                    this.userId
                ].concat((0, $3jzhD._)(sectionName));
                if (id) sections.push(id);
                return sections.join("/");
            }
        },
        {
            key: "generateId",
            value: function generateId(sectionName) {
                return (0, $b6033.doc)((0, $b6033.collection)(this.db, this.buildPath(sectionName))).id;
            }
        },
        {
            key: "saveDoc",
            value: function saveDoc(sectionName, data) {
                return $fe3694ddba3770ae$var$__awaiter(this, void 0, void 0, function() {
                    var js;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                //check if it has ID or not - add or update
                                js = data.toJS();
                                if (!js.id) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $b6033.setDoc)((0, $b6033.doc)(this.db, this.buildPath(sectionName), js.id), js)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    js.id
                                ];
                            case 2:
                                throw "Expecting valid ID";
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "uploadFile",
            value: function uploadFile(storagePath_1, file_1, taskId_1) {
                return $fe3694ddba3770ae$var$__awaiter(this, arguments, void 0, function(storagePath, file, taskId) {
                    var onProgress, storage, storageRef, upload_task, metadata, snapshot, url;
                    var _arguments = arguments;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                onProgress = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : null;
                                storage = (0, $f11ac745706cbb9d$export$fbd9b57a66480737)(this.app);
                                storageRef = (0, $f11ac745706cbb9d$export$eff4d24c3ff7876e)(storage, storagePath);
                                upload_task = (0, $f11ac745706cbb9d$export$3895d39eb7ac9b25)(storageRef, file);
                                upload_task.on("state_changed", function(snapshot) {
                                    // Observe state change events such as progress, pause, and resume
                                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                                    var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                                    if (onProgress) onProgress(progress);
                                }, function(error) {}, function() {});
                                metadata = {
                                    customMetadata: {
                                        taskId: taskId
                                    }
                                };
                                return [
                                    4,
                                    upload_task
                                ];
                            case 1:
                                snapshot = _state.sent();
                                return [
                                    4,
                                    (0, $f11ac745706cbb9d$export$f64791b2d30456a0)(storageRef, metadata)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    (0, $f11ac745706cbb9d$export$c8bf645a0c2a7d9f)(snapshot.ref)
                                ];
                            case 3:
                                url = _state.sent();
                                return [
                                    2,
                                    url
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "deleteData",
            value: function deleteData(sectionName, id) {
                var path = this.buildPath(sectionName, id);
                return (0, $b6033.deleteDoc)((0, $b6033.doc)(this.db, path));
            }
        },
        {
            key: "unsub",
            value: function unsub(fn) {
                if (this.unsubList.indexOf(fn) >= 0) {
                    fn();
                    (0, $dKdZ4.remove)(this.unsubList, fn);
                } else console.error("Unsub not found");
            }
        },
        {
            key: "listenData",
            value: function listenData(subcol, callback, ctor) {
                //todo: FIND iD AND UPDATE DOC ETC
                var cache = (0, $3a3345637c0a5d6f$export$c6e89b6bb9436bc0)();
                var cacheKey = subcol.join(".");
                if (cache.has(cacheKey)) {
                    console.log("*** Used cache prior to fetching");
                    var json = cache.get(cacheKey);
                    var docs = JSON.parse(json).map(function(doc) {
                        var d = new ctor();
                        d.fromJS(Object.assign({}, doc));
                        return d;
                    });
                    callback(docs);
                }
                var path = this.buildPath(subcol);
                var unsub = (0, $b6033.onSnapshot)((0, $b6033.collection)(this.db, path), function(collection) {
                    var json = JSON.stringify(collection.docs.map(function(doc) {
                        return Object.assign(Object.assign({}, doc.data()), {
                            id: doc.id
                        });
                    }));
                    cache.store(cacheKey, json);
                    console.log("*** Firebase snapshot");
                    var docs = collection.docs.map(function(doc) {
                        var d = new ctor();
                        d.fromJS(Object.assign(Object.assign({}, doc.data()), {
                            id: doc.id
                        }));
                        return d;
                    });
                    callback(docs);
                });
                this.unsubList.push(unsub);
                return unsub;
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                var firebaseConfig = {
                    apiKey: "AIzaSyD8QDm6AKiD-O8TvWSi2I9Y-AsxmzhCuK8",
                    authDomain: "adhd-e3dad.firebaseapp.com",
                    projectId: "adhd-e3dad",
                    storageBucket: "adhd-e3dad.appspot.com",
                    messagingSenderId: "405904685378",
                    appId: "1:405904685378:web:9c8e26f78a9622902eb0db"
                };
                // Initialize Firebase
                console.log("Initializing Firebase");
                this.app = (0, $ilNGG.initializeApp)(firebaseConfig);
                this.db = (0, $b6033.getFirestore)(this.app);
                var auth = (0, $65b82078b3339b3f$export$ae1af26003f05816)(this.app);
                var cache = (0, $3a3345637c0a5d6f$export$c6e89b6bb9436bc0)();
                if (cache.has("userId")) {
                    this.userId = cache.get("userId");
                    (0, $3a3345637c0a5d6f$export$2e2bcd8739ae039).init(this.userId);
                }
                (0, $65b82078b3339b3f$export$4a5767248b18ef41)(auth, function(user) {
                    if (user) {
                        console.log("Logged in!");
                        _this.userId = user.uid;
                        //Init app refactor
                        cache.store("userId", user.uid);
                        (0, $3a3345637c0a5d6f$export$2e2bcd8739ae039).init(user.uid);
                    } else {
                        var pass = window.prompt("Password?");
                        (0, $65b82078b3339b3f$export$555508cbc6add439)(auth, "nixaboo@gmail.com", pass);
                    }
                });
            }
        }
    ]);
    return FirebaseAdapater;
}();
var $fe3694ddba3770ae$var$mFirebaseService = new $fe3694ddba3770ae$var$FirebaseAdapater();
function $fe3694ddba3770ae$export$7a667d08ed65fa47() {
    return $fe3694ddba3770ae$var$mFirebaseService;
}



/**
 * React Router DOM v6.24.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $2MTYX = parcelRequire("2MTYX");

var $lF1I7 = parcelRequire("lF1I7");

var $33gHU = parcelRequire("33gHU");
var $e1a300cc66774841$exports = {};
"use strict";
function $e1a300cc66774841$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e1a300cc66774841$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e1a300cc66774841$var$checkDCE();

$e1a300cc66774841$exports = (parcelRequire("fdPHT"));


/**
 * @remix-run/router v1.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $c5rwh = parcelRequire("c5rwh");

var $iNfU4 = parcelRequire("iNfU4");

var $2MTYX = parcelRequire("2MTYX");

var $4rXYA = parcelRequire("4rXYA");

var $bXCSl = parcelRequire("bXCSl");

var $72HXH = parcelRequire("72HXH");

var $e9mxI = parcelRequire("e9mxI");
function $126a3ad0eef7c214$export$e62c166da838fa3(arr) {
    return (0, $4rXYA._array_with_holes)(arr) || (0, $bXCSl._iterable_to_array)(arr) || (0, $e9mxI._unsupported_iterable_to_array)(arr) || (0, $72HXH._non_iterable_rest)();
}



var $3jzhD = parcelRequire("3jzhD");

var $etlBe = parcelRequire("etlBe");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");

var $lF1I7 = parcelRequire("lF1I7");
function $84ab79249a3ce5e1$var$_extends() {
    $84ab79249a3ce5e1$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $84ab79249a3ce5e1$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $84ab79249a3ce5e1$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($84ab79249a3ce5e1$export$e19cd5f9376f8cee || ($84ab79249a3ce5e1$export$e19cd5f9376f8cee = {}));
var $84ab79249a3ce5e1$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $84ab79249a3ce5e1$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $84ab79249a3ce5e1$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $84ab79249a3ce5e1$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $84ab79249a3ce5e1$export$fe53371bee54353d(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $84ab79249a3ce5e1$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $84ab79249a3ce5e1$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $84ab79249a3ce5e1$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $84ab79249a3ce5e1$export$fe53371bee54353d(to);
    }
    return $84ab79249a3ce5e1$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $84ab79249a3ce5e1$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = $84ab79249a3ce5e1$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $84ab79249a3ce5e1$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $84ab79249a3ce5e1$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $84ab79249a3ce5e1$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $84ab79249a3ce5e1$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $84ab79249a3ce5e1$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $84ab79249a3ce5e1$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $84ab79249a3ce5e1$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $84ab79249a3ce5e1$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $84ab79249a3ce5e1$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $84ab79249a3ce5e1$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $84ab79249a3ce5e1$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $84ab79249a3ce5e1$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $84ab79249a3ce5e1$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $84ab79249a3ce5e1$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $84ab79249a3ce5e1$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($84ab79249a3ce5e1$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Push;
        var location = $84ab79249a3ce5e1$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $84ab79249a3ce5e1$var$getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Replace;
        var location = $84ab79249a3ce5e1$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $84ab79249a3ce5e1$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : $84ab79249a3ce5e1$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $84ab79249a3ce5e1$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($84ab79249a3ce5e1$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener($84ab79249a3ce5e1$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $84ab79249a3ce5e1$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($84ab79249a3ce5e1$var$ResultType || ($84ab79249a3ce5e1$var$ResultType = {}));
var $84ab79249a3ce5e1$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $84ab79249a3ce5e1$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $84ab79249a3ce5e1$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $3jzhD._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $84ab79249a3ce5e1$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $84ab79249a3ce5e1$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($84ab79249a3ce5e1$var$isIndexRoute(route)) {
            var indexRoute = $84ab79249a3ce5e1$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $84ab79249a3ce5e1$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $84ab79249a3ce5e1$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $84ab79249a3ce5e1$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $84ab79249a3ce5e1$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $84ab79249a3ce5e1$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    var location = typeof locationArg === "string" ? $84ab79249a3ce5e1$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $84ab79249a3ce5e1$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $84ab79249a3ce5e1$var$flattenRoutes(routes);
    $84ab79249a3ce5e1$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        var decoded = $84ab79249a3ce5e1$var$decodePath(pathname);
        matches = $84ab79249a3ce5e1$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $84ab79249a3ce5e1$export$b3fac024fad9e8ff(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $84ab79249a3ce5e1$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $84ab79249a3ce5e1$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $84ab79249a3ce5e1$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $84ab79249a3ce5e1$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $84ab79249a3ce5e1$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $84ab79249a3ce5e1$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $84ab79249a3ce5e1$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $84ab79249a3ce5e1$var$explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $126a3ad0eef7c214$export$e62c166da838fa3)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $84ab79249a3ce5e1$var$explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $3jzhD._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $3jzhD._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $84ab79249a3ce5e1$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $84ab79249a3ce5e1$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $84ab79249a3ce5e1$var$paramRe = /^:[\w-]+$/;
var $84ab79249a3ce5e1$var$dynamicSegmentValue = 3;
var $84ab79249a3ce5e1$var$indexRouteValue = 2;
var $84ab79249a3ce5e1$var$emptySegmentValue = 1;
var $84ab79249a3ce5e1$var$staticSegmentValue = 10;
var $84ab79249a3ce5e1$var$splatPenalty = -2;
var $84ab79249a3ce5e1$var$isSplat = function(s) {
    return s === "*";
};
function $84ab79249a3ce5e1$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($84ab79249a3ce5e1$var$isSplat)) initialScore += $84ab79249a3ce5e1$var$splatPenalty;
    if (index) initialScore += $84ab79249a3ce5e1$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$84ab79249a3ce5e1$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($84ab79249a3ce5e1$var$paramRe.test(segment) ? $84ab79249a3ce5e1$var$dynamicSegmentValue : segment === "" ? $84ab79249a3ce5e1$var$emptySegmentValue : $84ab79249a3ce5e1$var$staticSegmentValue);
    }, initialScore);
}
function $84ab79249a3ce5e1$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $84ab79249a3ce5e1$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $84ab79249a3ce5e1$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $84ab79249a3ce5e1$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $84ab79249a3ce5e1$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $84ab79249a3ce5e1$export$a5c6d149b50c1d86($84ab79249a3ce5e1$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $84ab79249a3ce5e1$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $84ab79249a3ce5e1$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $84ab79249a3ce5e1$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $2MTYX._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            $84ab79249a3ce5e1$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $84ab79249a3ce5e1$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $2MTYX._)($84ab79249a3ce5e1$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $84ab79249a3ce5e1$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $84ab79249a3ce5e1$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $84ab79249a3ce5e1$var$decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        $84ab79249a3ce5e1$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $84ab79249a3ce5e1$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $84ab79249a3ce5e1$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $84ab79249a3ce5e1$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $84ab79249a3ce5e1$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $84ab79249a3ce5e1$var$normalizeSearch(search),
        hash: $84ab79249a3ce5e1$var$normalizeHash(hash)
    };
}
function $84ab79249a3ce5e1$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $84ab79249a3ce5e1$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $84ab79249a3ce5e1$var$getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $84ab79249a3ce5e1$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    var pathMatches = $84ab79249a3ce5e1$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === matches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function $84ab79249a3ce5e1$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $84ab79249a3ce5e1$export$8ccf933b0513f8d0(toArg);
    else {
        to = $84ab79249a3ce5e1$var$_extends({}, toArg);
        $84ab79249a3ce5e1$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $84ab79249a3ce5e1$var$getInvalidPathError("?", "pathname", "search", to));
        $84ab79249a3ce5e1$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $84ab79249a3ce5e1$var$getInvalidPathError("#", "pathname", "hash", to));
        $84ab79249a3ce5e1$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $84ab79249a3ce5e1$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $84ab79249a3ce5e1$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $84ab79249a3ce5e1$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $84ab79249a3ce5e1$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $84ab79249a3ce5e1$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $84ab79249a3ce5e1$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $84ab79249a3ce5e1$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $84ab79249a3ce5e1$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $84ab79249a3ce5e1$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $84ab79249a3ce5e1$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $84ab79249a3ce5e1$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $iNfU4._)(AbortedDeferredError, Error1);
    var _super = (0, $k1NN5._)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $19mwo._)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $etlBe._)(Error));
var $84ab79249a3ce5e1$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $19mwo._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $84ab79249a3ce5e1$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $84ab79249a3ce5e1$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $2MTYX._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $c5rwh._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $6rpfc._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $84ab79249a3ce5e1$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var aborted, onAbort;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $84ab79249a3ce5e1$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $2MTYX._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $c5rwh._)({}, key, $84ab79249a3ce5e1$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $84ab79249a3ce5e1$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $84ab79249a3ce5e1$var$unwrapTrackedPromise(value) {
    if (!$84ab79249a3ce5e1$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $84ab79249a3ce5e1$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $84ab79249a3ce5e1$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $84ab79249a3ce5e1$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $84ab79249a3ce5e1$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $84ab79249a3ce5e1$export$a6cd19cd1951a23c = function(url, init) {
    var response = $84ab79249a3ce5e1$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var $84ab79249a3ce5e1$export$6c6580e81da25755 = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $19mwo._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $84ab79249a3ce5e1$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $84ab79249a3ce5e1$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $84ab79249a3ce5e1$var$validMutationMethods = new Set($84ab79249a3ce5e1$var$validMutationMethodsArr);
var $84ab79249a3ce5e1$var$validRequestMethodsArr = [
    "get"
].concat((0, $3jzhD._)($84ab79249a3ce5e1$var$validMutationMethodsArr));
var $84ab79249a3ce5e1$var$validRequestMethods = new Set($84ab79249a3ce5e1$var$validRequestMethodsArr);
var $84ab79249a3ce5e1$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $84ab79249a3ce5e1$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $84ab79249a3ce5e1$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $84ab79249a3ce5e1$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $84ab79249a3ce5e1$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $84ab79249a3ce5e1$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $84ab79249a3ce5e1$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var $84ab79249a3ce5e1$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $84ab79249a3ce5e1$export$baddd0131ee8c05b(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    $84ab79249a3ce5e1$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $84ab79249a3ce5e1$var$defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = $84ab79249a3ce5e1$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    var dataStrategyImpl = init.unstable_dataStrategy || $84ab79249a3ce5e1$var$defaultDataStrategy;
    var patchRoutesOnMissImpl = init.unstable_patchRoutesOnMiss;
    // Config driven behavior flags
    var future = $84ab79249a3ce5e1$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $84ab79249a3ce5e1$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null && !patchRoutesOnMissImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $84ab79249a3ce5e1$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $84ab79249a3ce5e1$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $c5rwh._)({}, route.id, error);
    }
    var initialized;
    if (!initialMatches) {
        // We need to run patchRoutesOnMiss in initialize()
        initialized = false;
        initialMatches = [];
    } else if (initialMatches.some(function(m) {
        return m.route.lazy;
    })) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some(function(m) {
        return m.route.loader;
    })) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        var isRouteInitialized = function(m) {
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            var idx = initialMatches.findIndex(function(m) {
                return errors[m.route.id] !== undefined;
            });
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $84ab79249a3ce5e1$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Map of pending patchRoutesOnMiss() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    var pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $84ab79249a3ce5e1$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $84ab79249a3ce5e1$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $84ab79249a3ce5e1$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return $84ab79249a3ce5e1$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($84ab79249a3ce5e1$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $84ab79249a3ce5e1$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, $3jzhD._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers.delete(key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $84ab79249a3ce5e1$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $84ab79249a3ce5e1$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $84ab79249a3ce5e1$export$386d57f03f0b2883);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $84ab79249a3ce5e1$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($84ab79249a3ce5e1$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $84ab79249a3ce5e1$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $9OZ9j._)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $84ab79249a3ce5e1$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $84ab79249a3ce5e1$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $84ab79249a3ce5e1$var$createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $84ab79249a3ce5e1$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $84ab79249a3ce5e1$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.unstable_flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $84ab79249a3ce5e1$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.unstable_viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $9OZ9j._)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, request, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $84ab79249a3ce5e1$export$2708184779ceb39d(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $c5rwh._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && $84ab79249a3ce5e1$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $84ab79249a3ce5e1$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $84ab79249a3ce5e1$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingActionResult = [
                            $84ab79249a3ce5e1$var$findNearestBoundary(matches).route.id,
                            {
                                type: $84ab79249a3ce5e1$var$ResultType.error,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $84ab79249a3ce5e1$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        // If we received a 404 from handleAction, it's because we couldn't lazily
                        // discover the destination route so we don't want to call loaders
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, $2MTYX._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if ($84ab79249a3ce5e1$var$isErrorResult(result) && $84ab79249a3ce5e1$export$972111febbeef05b(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, $c5rwh._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = $84ab79249a3ce5e1$var$getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // No need to do fog of war matching again on loader execution
                        fogOfWar.active = false;
                        // Create a GET request for the loaders
                        request = $84ab79249a3ce5e1$var$createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $84ab79249a3ce5e1$var$_extends({
                            matches: updatedMatches || matches
                        }, $84ab79249a3ce5e1$var$getActionDataForCommit(pendingActionResult), {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $9OZ9j._)(function(request, location, submission, matches, isFogOfWar, opts) {
            var navigation, discoverResult, _handleDiscoverRouteError, error, notFoundMatches, route, _handleNavigational404, notFoundMatches1, error1, route1, result, actionMatch, results, replace, _$location, boundaryMatch;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = $84ab79249a3ce5e1$var$getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            _handleDiscoverRouteError = handleDiscoverRouteError(location.pathname, discoverResult), error = _handleDiscoverRouteError.error, notFoundMatches = _handleDiscoverRouteError.notFoundMatches, route = _handleDiscoverRouteError.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route.id,
                                        {
                                            type: $84ab79249a3ce5e1$var$ResultType.error,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches1 = _handleNavigational404.notFoundMatches, error1 = _handleNavigational404.error, route1 = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches1,
                                    pendingActionResult: [
                                        route1.id,
                                        {
                                            type: $84ab79249a3ce5e1$var$ResultType.error,
                                            error: error1
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = $84ab79249a3ce5e1$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: $84ab79249a3ce5e1$var$ResultType.error,
                            error: $84ab79249a3ce5e1$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[0];
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!$84ab79249a3ce5e1$var$isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else {
                            // If the user didn't explicity indicate replace behavior, replace if
                            // we redirected to the exact same location we're currently at to avoid
                            // double back-buttons
                            _$location = $84ab79249a3ce5e1$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                            replace = _$location === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if ($84ab79249a3ce5e1$var$isDeferredResult(result)) throw $84ab79249a3ce5e1$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        if ($84ab79249a3ce5e1$var$isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = $84ab79249a3ce5e1$var$findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions to the current location are REPLACE
                            // navigations, but if the action threw an error that'll be rendered in
                            // an errorElement, we fall back to PUSH so that the user can use the
                            // back button to get back to the pre-submission form location to try
                            // again
                            if ((opts && opts.replace) !== true) pendingAction = $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $9OZ9j._)(function(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, _handleDiscoverRouteError, error, notFoundMatches, route, _handleNavigational404, error1, notFoundMatches1, route1, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || $84ab79249a3ce5e1$var$getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || $84ab79249a3ce5e1$var$getSubmissionFromNavigation(loadingNavigation);
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since it's not a "navigation"
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState($84ab79249a3ce5e1$var$_extends({
                                navigation: loadingNavigation
                            }, actionData !== undefined ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            _handleDiscoverRouteError = handleDiscoverRouteError(location.pathname, discoverResult), error = _handleDiscoverRouteError.error, notFoundMatches = _handleDiscoverRouteError.notFoundMatches, route = _handleDiscoverRouteError.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, $c5rwh._)({}, route.id, error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error1 = _handleNavigational404.error, notFoundMatches1 = _handleNavigational404.notFoundMatches, route1 = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches1,
                                    loaderData: {},
                                    errors: (0, $c5rwh._)({}, route1.id, error1)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $2MTYX._)($84ab79249a3ce5e1$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $84ab79249a3ce5e1$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && $84ab79249a3ce5e1$var$isErrorResult(pendingActionResult[1]) ? (0, $c5rwh._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, $84ab79249a3ce5e1$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                // Only update navigation/actionNData if we didn't already do it above
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== undefined) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = $84ab79249a3ce5e1$var$findRedirect((0, $3jzhD._)(loaderResults).concat((0, $3jzhD._)(fetcherResults)));
                        if (!redirect) return [
                            3,
                            5
                        ];
                        if (redirect.idx >= matchesToLoad.length) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                            fetchRedirectIds.add(fetcherKey);
                        }
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, {
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        // Process and commit output from loaders
                        _processLoaderData = $84ab79249a3ce5e1$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        // During partial hydration, preserve SSR errors for routes that don't re-run
                        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter(function(_ref2) {
                            var _$_ref2 = (0, $2MTYX._)(_ref2, 1), id = _$_ref2[0];
                            return !matchesToLoad.some(function(m) {
                                return m.route.id === id;
                            });
                        }).forEach(function(_ref3) {
                            var _$_ref3 = (0, $2MTYX._)(_ref3, 2), routeId = _$_ref3[0], error = _$_ref3[1];
                            errors = Object.assign(errors || {}, (0, $c5rwh._)({}, routeId, error));
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $84ab79249a3ce5e1$var$_extends({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$84ab79249a3ce5e1$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return (0, $c5rwh._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = state.fetchers.get(rf.key);
            var revalidatingFetcher = $84ab79249a3ce5e1$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var flushSync = (opts && opts.unstable_flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $84ab79249a3ce5e1$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = $84ab79249a3ce5e1$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        var fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $84ab79249a3ce5e1$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = $84ab79249a3ce5e1$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = $84ab79249a3ce5e1$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $84ab79249a3ce5e1$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $9OZ9j._)(function(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, error, originatingLoadId, actionResults, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, doneFetcher;
            function detectAndHandle405Error(m) {
                if (!m.route.action && !m.route.lazy) {
                    var error = $84ab79249a3ce5e1$var$getInternalRouterError(405, {
                        method: submission.formMethod,
                        pathname: path,
                        routeId: routeId
                    });
                    setFetcherError(key, routeId, error, {
                        flushSync: flushSync
                    });
                    return true;
                }
                return false;
            }
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!isFogOfWar && detectAndHandle405Error(match)) return [
                            2
                        ];
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $84ab79249a3ce5e1$var$getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = $84ab79249a3ce5e1$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            error = handleDiscoverRouteError(path, discoverResult).error;
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, $84ab79249a3ce5e1$var$getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            requestMatches = discoverResult.matches;
                            match = $84ab79249a3ce5e1$var$getTargetMatch(requestMatches, path);
                            if (detectAndHandle405Error(match)) return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        // Call the action for the fetcher
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("action", fetchRequest, [
                                match
                            ], requestMatches)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[0];
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if ($84ab79249a3ce5e1$var$isRedirectResult(actionResult) || $84ab79249a3ce5e1$var$isErrorResult(actionResult)) {
                                updateFetcherState(key, $84ab79249a3ce5e1$var$getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if ($84ab79249a3ce5e1$var$isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, $84ab79249a3ce5e1$var$getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, $84ab79249a3ce5e1$var$getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, {
                                            fetcherSubmission: submission
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if ($84ab79249a3ce5e1$var$isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if ($84ab79249a3ce5e1$var$isDeferredResult(actionResult)) throw $84ab79249a3ce5e1$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $84ab79249a3ce5e1$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $84ab79249a3ce5e1$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $84ab79249a3ce5e1$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $84ab79249a3ce5e1$var$getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $2MTYX._)($84ab79249a3ce5e1$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
                            match.route.id,
                            actionResult
                        ]), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = $84ab79249a3ce5e1$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = $84ab79249a3ce5e1$var$findRedirect((0, $3jzhD._)(loaderResults).concat((0, $3jzhD._)(fetcherResults)));
                        if (redirect) {
                            if (redirect.idx >= matchesToLoad.length) {
                                // If this redirect came from a fetcher make sure we mark it in
                                // fetchRedirectIds so it doesn't get revalidated on the next set of
                                // loader executions
                                fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                                fetchRedirectIds.add(fetcherKey);
                            }
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect.result)
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = $84ab79249a3ce5e1$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = $84ab79249a3ce5e1$var$getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $84ab79249a3ce5e1$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: $84ab79249a3ce5e1$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $9OZ9j._)(function(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, error, originatingLoadId, results, result;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $84ab79249a3ce5e1$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = $84ab79249a3ce5e1$var$createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            error = handleDiscoverRouteError(path, discoverResult).error;
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, $84ab79249a3ce5e1$var$getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            matches = discoverResult.matches;
                            match = $84ab79249a3ce5e1$var$getTargetMatch(matches, path);
                        }
                        _state.label = 2;
                    case 2:
                        // Call the loader for this fetcher route match
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("loader", fetchRequest, [
                                match
                            ], matches)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[0];
                        if (!$84ab79249a3ce5e1$var$isDeferredResult(result)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            $84ab79249a3ce5e1$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 4:
                        result = _state.sent() || result;
                        _state.label = 5;
                    case 5:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, $84ab79249a3ce5e1$var$getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!$84ab79249a3ce5e1$var$isRedirectResult(result)) return [
                            3,
                            8
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            6
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, $84ab79249a3ce5e1$var$getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 6:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result)
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2
                        ];
                    case 8:
                        // Process any non-redirect errors thrown
                        if ($84ab79249a3ce5e1$var$isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        $84ab79249a3ce5e1$export$3e9cee6b33872309(!$84ab79249a3ce5e1$var$isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, $84ab79249a3ce5e1$var$getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(request, redirect, _temp2) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $9OZ9j._)(function(request, redirect, _temp2) {
            var _ref, submission, fetcherSubmission, replace, location, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, replace = _ref.replace;
                        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect.response.headers.get("Location");
                        $84ab79249a3ce5e1$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
                        location = $84ab79249a3ce5e1$var$normalizeRedirectLocation(location, new URL(request.url), basename);
                        redirectLocation = $84ab79249a3ce5e1$var$createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if ($84ab79249a3ce5e1$var$ABSOLUTE_URL_REGEX.test(location)) {
                                url = init.history.createURL(location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                $84ab79249a3ce5e1$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Replace : $84ab79249a3ce5e1$export$e19cd5f9376f8cee.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $84ab79249a3ce5e1$var$getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!($84ab79249a3ce5e1$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $84ab79249a3ce5e1$var$isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $84ab79249a3ce5e1$var$_extends({}, activeSubmission, {
                                    formAction: location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = $84ab79249a3ce5e1$var$getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy client-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $9OZ9j._)(function(type, request, matchesToLoad, matches) {
            var results, e;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            $84ab79249a3ce5e1$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties)
                        ];
                    case 1:
                        results = _state.sent();
                        return [
                            4,
                            Promise.all(results.map(function(result, i) {
                                if ($84ab79249a3ce5e1$var$isRedirectHandlerResult(result)) {
                                    var response = result.result;
                                    return {
                                        type: $84ab79249a3ce5e1$var$ResultType.redirect,
                                        response: $84ab79249a3ce5e1$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                                    };
                                }
                                return $84ab79249a3ce5e1$var$convertHandlerResultToDataResult(result);
                            }))
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        e = _state.sent();
                        // If the outer dataStrategy method throws, just return the error for all
                        // matches - and it'll naturally bubble to the root
                        return [
                            2,
                            matchesToLoad.map(function() {
                                return {
                                    type: $84ab79249a3ce5e1$var$ResultType.error,
                                    error: e
                                };
                            })
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $9OZ9j._)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var _ref, loaderResults, fetcherResults;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all([
                                matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : []
                            ].concat((0, $3jzhD._)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) {
                                    var fetcherRequest = $84ab79249a3ce5e1$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                                    return callDataStrategy("loader", fetcherRequest, [
                                        f.match
                                    ], f.matches).then(function(r) {
                                        return r[0];
                                    });
                                } else return Promise.resolve({
                                    type: $84ab79249a3ce5e1$var$ResultType.error,
                                    error: $84ab79249a3ce5e1$var$getInternalRouterError(404, {
                                        pathname: f.path
                                    })
                                });
                            }))))
                        ];
                    case 1:
                        _ref = (0, $126a3ad0eef7c214$export$e62c166da838fa3).apply(void 0, [
                            _state.sent()
                        ]), loaderResults = _ref[0], fetcherResults = _ref.slice(1);
                        return [
                            4,
                            Promise.all([
                                $84ab79249a3ce5e1$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $84ab79249a3ce5e1$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $3jzhD._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = $84ab79249a3ce5e1$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $c5rwh._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $84ab79249a3ce5e1$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            var count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $84ab79249a3ce5e1$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = $84ab79249a3ce5e1$var$getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $84ab79249a3ce5e1$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $2MTYX._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $84ab79249a3ce5e1$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $84ab79249a3ce5e1$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $84ab79249a3ce5e1$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $84ab79249a3ce5e1$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        var currentLocation = _ref4.currentLocation, nextLocation = _ref4.nextLocation, historyAction = _ref4.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $84ab79249a3ce5e1$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $2MTYX._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = $84ab79249a3ce5e1$var$getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var _getShortCircuitMatches = $84ab79249a3ce5e1$var$getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        var matches = discoverResult.partialMatches;
        var route = matches[matches.length - 1].route;
        var error = $84ab79249a3ce5e1$var$getInternalRouterError(400, {
            type: "route-discovery",
            routeId: route.id,
            pathname: pathname,
            message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
        });
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $84ab79249a3ce5e1$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return $84ab79249a3ce5e1$export$b3fac024fad9e8ff(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnMissImpl) {
            if (!matches) {
                var fogMatches = $84ab79249a3ce5e1$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else {
                var leafRoute = matches[matches.length - 1].route;
                if (leafRoute.path === "*") {
                    // If we matched a splat, it might only be because we haven't yet fetched
                    // the children that would match with a higher score, so let's fetch
                    // around and find out
                    var partialMatches = $84ab79249a3ce5e1$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    return {
                        active: true,
                        matches: partialMatches
                    };
                }
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal) {
        return _discoverRoutes.apply(this, arguments);
    }
    function _discoverRoutes() {
        _discoverRoutes = (0, $9OZ9j._)(function(matches, pathname, signal) {
            var partialMatches, route, e, routesToUse, newMatches, matchedSplat, leafRoute, newPartialMatches;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        partialMatches = matches;
                        route = partialMatches.length > 0 ? partialMatches[partialMatches.length - 1].route : null;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            6
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            $84ab79249a3ce5e1$var$loadLazyRouteChildren(patchRoutesOnMissImpl, pathname, partialMatches, dataRoutes || inFlightDataRoutes, manifest, mapRouteProperties, pendingPatchRoutes, signal)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        return [
                            2,
                            {
                                type: "error",
                                error: e,
                                partialMatches: partialMatches
                            }
                        ];
                    case 5:
                        if (signal.aborted) return [
                            2,
                            {
                                type: "aborted"
                            }
                        ];
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        newMatches = $84ab79249a3ce5e1$export$2708184779ceb39d(routesToUse, pathname, basename);
                        matchedSplat = false;
                        if (newMatches) {
                            leafRoute = newMatches[newMatches.length - 1].route;
                            if (leafRoute.index) // If we found an index route, we can stop
                            return [
                                2,
                                {
                                    type: "success",
                                    matches: newMatches
                                }
                            ];
                            if (leafRoute.path && leafRoute.path.length > 0) {
                                if (leafRoute.path === "*") // If we found a splat route, we can't be sure there's not a
                                // higher-scoring route down some partial matches trail so we need
                                // to check that out
                                matchedSplat = true;
                                else // If we found a non-splat route, we can stop
                                return [
                                    2,
                                    {
                                        type: "success",
                                        matches: newMatches
                                    }
                                ];
                            }
                        }
                        newPartialMatches = $84ab79249a3ce5e1$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                        // If we are no longer partially matching anything, this was either a
                        // legit splat match above, or it's a 404.  Also avoid loops if the
                        // second pass results in the same partial matches
                        if (!newPartialMatches || partialMatches.map(function(m) {
                            return m.route.id;
                        }).join("-") === newPartialMatches.map(function(m) {
                            return m.route.id;
                        }).join("-")) return [
                            2,
                            {
                                type: "success",
                                matches: matchedSplat ? newMatches : null
                            }
                        ];
                        partialMatches = newPartialMatches;
                        route = partialMatches[partialMatches.length - 1].route;
                        if (route.path === "*") // The splat is still our most accurate partial, so run with it
                        return [
                            2,
                            {
                                type: "success",
                                matches: partialMatches
                            }
                        ];
                        return [
                            3,
                            1
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _discoverRoutes.apply(this, arguments);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $84ab79249a3ce5e1$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: function(routeId, children) {
            return $84ab79249a3ce5e1$var$patchRoutes(routeId, children, dataRoutes || inFlightDataRoutes, manifest, mapRouteProperties);
        },
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $84ab79249a3ce5e1$export$4d0306f8f6a4585b = Symbol("deferred");
function $84ab79249a3ce5e1$export$3336b097a6fbc59a(routes, opts) {
    $84ab79249a3ce5e1$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $84ab79249a3ce5e1$var$defaultMapRouteProperties;
    // Config driven behavior flags
    var future = $84ab79249a3ce5e1$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    var dataRoutes = $84ab79249a3ce5e1$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp3) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ (0, $9OZ9j._)(function(request, _temp3) {
            var _ref, requestContext, skipLoaderErrorBubbling, unstable_dataStrategy, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, requestContext = _ref.requestContext, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, unstable_dataStrategy = _ref.unstable_dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = $84ab79249a3ce5e1$var$createLocation("", $84ab79249a3ce5e1$export$fe53371bee54353d(url), null, "default");
                        matches = $84ab79249a3ce5e1$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$84ab79249a3ce5e1$var$isValidMethod(method) && method !== "HEAD") {
                            error = $84ab79249a3ce5e1$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $84ab79249a3ce5e1$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $c5rwh._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $84ab79249a3ce5e1$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $84ab79249a3ce5e1$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $c5rwh._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($84ab79249a3ce5e1$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $84ab79249a3ce5e1$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp4) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ (0, $9OZ9j._)(function(request, _temp4) {
            var _ref, routeId, requestContext, unstable_dataStrategy, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext, unstable_dataStrategy = _ref.unstable_dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = $84ab79249a3ce5e1$var$createLocation("", $84ab79249a3ce5e1$export$fe53371bee54353d(url), null, "default");
                        matches = $84ab79249a3ce5e1$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$84ab79249a3ce5e1$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $84ab79249a3ce5e1$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $84ab79249a3ce5e1$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $84ab79249a3ce5e1$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $84ab79249a3ce5e1$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $84ab79249a3ce5e1$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($84ab79249a3ce5e1$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$84ab79249a3ce5e1$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $9OZ9j._)(function(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
            var result, result1, e;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $84ab79249a3ce5e1$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$84ab79249a3ce5e1$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $84ab79249a3ce5e1$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $84ab79249a3ce5e1$var$isResponse(result1) ? result1 : $84ab79249a3ce5e1$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction for a
                        // `queryRoute` call, we throw the `HandlerResult` to bail out early
                        // and then return or throw the raw Response here accordingly
                        if ($84ab79249a3ce5e1$var$isHandlerResult(e) && $84ab79249a3ce5e1$var$isResponse(e.result)) {
                            if (e.type === $84ab79249a3ce5e1$var$ResultType.error) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($84ab79249a3ce5e1$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $9OZ9j._)(function(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
            var result, error, results, error1, loaderRequest, boundaryMatch, context, context1;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $84ab79249a3ce5e1$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $84ab79249a3ce5e1$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches, isRouteRequest, requestContext, unstable_dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[0];
                        if (request.signal.aborted) $84ab79249a3ce5e1$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        _state.label = 3;
                    case 3:
                        if ($84ab79249a3ce5e1$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if ($84ab79249a3ce5e1$var$isDeferredResult(result)) {
                            error1 = $84ab79249a3ce5e1$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $84ab79249a3ce5e1$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($84ab79249a3ce5e1$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $c5rwh._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!$84ab79249a3ce5e1$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $84ab79249a3ce5e1$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                                boundaryMatch.route.id,
                                result
                            ])
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            $84ab79249a3ce5e1$var$_extends({}, context, {
                                statusCode: $84ab79249a3ce5e1$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: $84ab79249a3ce5e1$var$_extends({}, result.headers ? (0, $c5rwh._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $84ab79249a3ce5e1$var$_extends({}, context1, {
                                actionData: (0, $c5rwh._)({}, actionMatch.route.id, result.data)
                            }, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionHeaders: result.headers ? (0, $c5rwh._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $9OZ9j._)(function(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
            var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $84ab79249a3ce5e1$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : pendingActionResult && $84ab79249a3ce5e1$var$isErrorResult(pendingActionResult[1]) ? $84ab79249a3ce5e1$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $c5rwh._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionResult && $84ab79249a3ce5e1$var$isErrorResult(pendingActionResult[1]) ? (0, $c5rwh._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) $84ab79249a3ce5e1$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = $84ab79249a3ce5e1$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $84ab79249a3ce5e1$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy server-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $9OZ9j._)(function(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
            var results;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $84ab79249a3ce5e1$var$callDataStrategyImpl(unstable_dataStrategy || $84ab79249a3ce5e1$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext)
                        ];
                    case 1:
                        results = _state.sent();
                        return [
                            4,
                            Promise.all(results.map(function(result, i) {
                                if ($84ab79249a3ce5e1$var$isRedirectHandlerResult(result)) {
                                    var response = result.result;
                                    // Throw redirects and let the server handle them with an HTTP redirect
                                    throw $84ab79249a3ce5e1$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
                                }
                                if ($84ab79249a3ce5e1$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
                                // directly without unwrapping
                                throw result;
                                return $84ab79249a3ce5e1$var$convertHandlerResultToDataResult(result);
                            }))
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $84ab79249a3ce5e1$export$fec11da027c70692(routes, context, error) {
    var newContext = $84ab79249a3ce5e1$var$_extends({}, context, {
        statusCode: $84ab79249a3ce5e1$export$972111febbeef05b(error) ? error.status : 500,
        errors: (0, $c5rwh._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $84ab79249a3ce5e1$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $84ab79249a3ce5e1$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $84ab79249a3ce5e1$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = $84ab79249a3ce5e1$export$cae722b0cc860f13(to ? to : ".", $84ab79249a3ce5e1$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $84ab79249a3ce5e1$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$84ab79249a3ce5e1$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $84ab79249a3ce5e1$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $84ab79249a3ce5e1$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $84ab79249a3ce5e1$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$84ab79249a3ce5e1$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$84ab79249a3ce5e1$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $84ab79249a3ce5e1$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $84ab79249a3ce5e1$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = $84ab79249a3ce5e1$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$84ab79249a3ce5e1$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref5) {
                var _$_ref5 = (0, $2MTYX._)(_ref5, 2), name = _$_ref5[0], value = _$_ref5[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$84ab79249a3ce5e1$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $84ab79249a3ce5e1$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $84ab79249a3ce5e1$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $84ab79249a3ce5e1$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $84ab79249a3ce5e1$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $84ab79249a3ce5e1$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($84ab79249a3ce5e1$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $84ab79249a3ce5e1$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $84ab79249a3ce5e1$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $84ab79249a3ce5e1$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $84ab79249a3ce5e1$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $84ab79249a3ce5e1$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    var actionResult = pendingActionResult ? $84ab79249a3ce5e1$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingActionResult && $84ab79249a3ce5e1$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    var boundaryMatches = boundaryId ? $84ab79249a3ce5e1$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    var shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($84ab79249a3ce5e1$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $84ab79249a3ce5e1$var$shouldRevalidateLoader(match, $84ab79249a3ce5e1$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $84ab79249a3ce5e1$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = $84ab79249a3ce5e1$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = $84ab79249a3ce5e1$var$getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $84ab79249a3ce5e1$var$shouldRevalidateLoader(fetcherMatch, $84ab79249a3ce5e1$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $84ab79249a3ce5e1$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $84ab79249a3ce5e1$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $84ab79249a3ce5e1$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $84ab79249a3ce5e1$var$loadLazyRouteChildren(patchRoutesOnMissImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    return $84ab79249a3ce5e1$var$_loadLazyRouteChildren.apply(this, arguments);
}
function $84ab79249a3ce5e1$var$_loadLazyRouteChildren() {
    $84ab79249a3ce5e1$var$_loadLazyRouteChildren = /**
 * Idempotent utility to execute route.children() method to lazily load route
 * definitions and update the routes/routeManifest
 */ (0, $9OZ9j._)(function(patchRoutesOnMissImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
        var key, pending;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    key = [
                        path
                    ].concat((0, $3jzhD._)(matches.map(function(m) {
                        return m.route.id;
                    }))).join("-");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        4,
                        5
                    ]);
                    pending = pendingRouteChildren.get(key);
                    if (!pending) {
                        pending = patchRoutesOnMissImpl({
                            path: path,
                            matches: matches,
                            patch: function(routeId, children) {
                                if (!signal.aborted) $84ab79249a3ce5e1$var$patchRoutes(routeId, children, routes, manifest, mapRouteProperties);
                            }
                        });
                        pendingRouteChildren.set(key, pending);
                    }
                    if (!(pending && $84ab79249a3ce5e1$var$isPromise(pending))) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        pending
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        3,
                        5
                    ];
                case 4:
                    pendingRouteChildren.delete(key);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $84ab79249a3ce5e1$var$_loadLazyRouteChildren.apply(this, arguments);
}
function $84ab79249a3ce5e1$var$patchRoutes(routeId, children, routes, manifest, mapRouteProperties) {
    if (routeId) {
        var _route_children;
        var _route$children;
        var route = manifest[routeId];
        $84ab79249a3ce5e1$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        var dataChildren = $84ab79249a3ce5e1$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) (_route_children = route.children).push.apply(_route_children, (0, $3jzhD._)(dataChildren));
        else route.children = dataChildren;
    } else {
        var _routes;
        var dataChildren1 = $84ab79249a3ce5e1$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routes.length || "0")
        ], manifest);
        (_routes = routes).push.apply(_routes, (0, $3jzhD._)(dataChildren1));
    }
}
function $84ab79249a3ce5e1$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return $84ab79249a3ce5e1$var$_loadLazyRouteModule.apply(this, arguments);
}
function $84ab79249a3ce5e1$var$_loadLazyRouteModule() {
    $84ab79249a3ce5e1$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $9OZ9j._)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $84ab79249a3ce5e1$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $84ab79249a3ce5e1$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !$84ab79249a3ce5e1$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $84ab79249a3ce5e1$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $84ab79249a3ce5e1$var$_loadLazyRouteModule.apply(this, arguments);
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $84ab79249a3ce5e1$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map(function(m) {
        return m.resolve();
    }));
}
function $84ab79249a3ce5e1$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    return $84ab79249a3ce5e1$var$_callDataStrategyImpl.apply(this, arguments);
}
function $84ab79249a3ce5e1$var$_callDataStrategyImpl() {
    $84ab79249a3ce5e1$var$_callDataStrategyImpl = (0, $9OZ9j._)(function(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
        var routeIdsToLoad, loadedMatches, results;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routeIdsToLoad = matchesToLoad.reduce(function(acc, m) {
                        return acc.add(m.route.id);
                    }, new Set());
                    loadedMatches = new Set();
                    return [
                        4,
                        dataStrategyImpl({
                            matches: matches.map(function(match) {
                                var shouldLoad = routeIdsToLoad.has(match.route.id);
                                // `resolve` encapsulates the route.lazy, executing the
                                // loader/action, and mapping return values/thrown errors to a
                                // HandlerResult.  Users can pass a callback to take fine-grained control
                                // over the execution of the loader/action
                                var resolve = function(handlerOverride) {
                                    loadedMatches.add(match.route.id);
                                    return shouldLoad ? $84ab79249a3ce5e1$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                                        type: $84ab79249a3ce5e1$var$ResultType.data,
                                        result: undefined
                                    });
                                };
                                return $84ab79249a3ce5e1$var$_extends({}, match, {
                                    shouldLoad: shouldLoad,
                                    resolve: resolve
                                });
                            }),
                            request: request,
                            params: matches[0].params,
                            context: requestContext
                        })
                    ];
                case 1:
                    results = _state.sent();
                    // Throw if any loadRoute implementations not called since they are what
                    // ensures a route is fully loaded
                    matches.forEach(function(m) {
                        return $84ab79249a3ce5e1$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded.");
                    });
                    // Filter out any middleware-only matches for which we didn't need to run handlers
                    return [
                        2,
                        results.filter(function(_, i) {
                            return routeIdsToLoad.has(matches[i].route.id);
                        })
                    ];
            }
        });
    });
    return $84ab79249a3ce5e1$var$_callDataStrategyImpl.apply(this, arguments);
}
function $84ab79249a3ce5e1$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    return $84ab79249a3ce5e1$var$_callLoaderOrAction.apply(this, arguments);
}
function $84ab79249a3ce5e1$var$_callLoaderOrAction() {
    $84ab79249a3ce5e1$var$_callLoaderOrAction = // Default logic for calling a loader/action is the user has no specified a dataStrategy
    (0, $9OZ9j._)(function(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
        var result, onReject, runHandler, handler, handlerError, _ref, value, url, pathname, url1, pathname1, e;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        // This will never resolve so safe to type it as Promise<HandlerResult> to
                        // satisfy the function return value
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    params: match.params,
                                    context: staticContext
                                }
                            ].concat((0, $3jzhD._)(ctx !== undefined ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise;
                        if (handlerOverride) handlerPromise = handlerOverride(function(ctx) {
                            return actualHandler(ctx);
                        });
                        else handlerPromise = (0, $9OZ9j._)(function() {
                            var val, e;
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            actualHandler()
                                        ];
                                    case 1:
                                        val = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "data",
                                                result: val
                                            }
                                        ];
                                    case 2:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "error",
                                                result: e
                                            }
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            $84ab79249a3ce5e1$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    _ref = (0, $2MTYX._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== undefined) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $84ab79249a3ce5e1$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still runs even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $84ab79249a3ce5e1$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $84ab79249a3ce5e1$var$ResultType.data,
                            result: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $84ab79249a3ce5e1$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $84ab79249a3ce5e1$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    // We should already be catching and converting normal handler executions to
                    // HandlerResults and returning them, so anything that throws here is an
                    // unexpected error we still need to wrap
                    return [
                        2,
                        {
                            type: $84ab79249a3ce5e1$var$ResultType.error,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $84ab79249a3ce5e1$var$_callLoaderOrAction.apply(this, arguments);
}
function $84ab79249a3ce5e1$var$convertHandlerResultToDataResult(handlerResult) {
    return $84ab79249a3ce5e1$var$_convertHandlerResultToDataResult.apply(this, arguments);
}
function $84ab79249a3ce5e1$var$_convertHandlerResultToDataResult() {
    $84ab79249a3ce5e1$var$_convertHandlerResultToDataResult = (0, $9OZ9j._)(function(handlerResult) {
        var result, type, status, data, contentType, e, _result$init, _result$init2;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = handlerResult.result, type = handlerResult.type, status = handlerResult.status;
                    if (!$84ab79249a3ce5e1$var$isResponse(result)) return [
                        3,
                        10
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        5
                    ];
                    if (!(result.body == null)) return [
                        3,
                        2
                    ];
                    data = null;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        result.json()
                    ];
                case 3:
                    data = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        result.text()
                    ];
                case 6:
                    data = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: $84ab79249a3ce5e1$var$ResultType.error,
                            error: e
                        }
                    ];
                case 9:
                    if (type === $84ab79249a3ce5e1$var$ResultType.error) return [
                        2,
                        {
                            type: $84ab79249a3ce5e1$var$ResultType.error,
                            error: new $84ab79249a3ce5e1$export$6c6580e81da25755(result.status, result.statusText, data),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $84ab79249a3ce5e1$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 10:
                    if (type === $84ab79249a3ce5e1$var$ResultType.error) return [
                        2,
                        {
                            type: $84ab79249a3ce5e1$var$ResultType.error,
                            error: result,
                            statusCode: $84ab79249a3ce5e1$export$972111febbeef05b(result) ? result.status : status
                        }
                    ];
                    if ($84ab79249a3ce5e1$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $84ab79249a3ce5e1$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $84ab79249a3ce5e1$var$ResultType.data,
                            data: result,
                            statusCode: status
                        }
                    ];
            }
        });
    });
    return $84ab79249a3ce5e1$var$_convertHandlerResultToDataResult.apply(this, arguments);
}
// Support relative routing in internal redirects
function $84ab79249a3ce5e1$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    var location = response.headers.get("Location");
    $84ab79249a3ce5e1$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$84ab79249a3ce5e1$var$ABSOLUTE_URL_REGEX.test(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = $84ab79249a3ce5e1$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $84ab79249a3ce5e1$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($84ab79249a3ce5e1$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        var normalizedLocation = location;
        var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        var isSameBasename = $84ab79249a3ce5e1$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $84ab79249a3ce5e1$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($84ab79249a3ce5e1$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $84ab79249a3ce5e1$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $84ab79249a3ce5e1$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $84ab79249a3ce5e1$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2MTYX._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $84ab79249a3ce5e1$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2MTYX._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $84ab79249a3ce5e1$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && $84ab79249a3ce5e1$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $84ab79249a3ce5e1$export$3e9cee6b33872309(!$84ab79249a3ce5e1$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($84ab79249a3ce5e1$var$isErrorResult(result)) {
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                var boundaryMatch = $84ab79249a3ce5e1$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $84ab79249a3ce5e1$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($84ab79249a3ce5e1$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = (0, $c5rwh._)({}, pendingActionResult[0], pendingError);
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $84ab79249a3ce5e1$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $84ab79249a3ce5e1$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    ), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $84ab79249a3ce5e1$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($84ab79249a3ce5e1$var$isErrorResult(result)) {
            var boundaryMatch = $84ab79249a3ce5e1$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $84ab79249a3ce5e1$var$_extends({}, errors, (0, $c5rwh._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if ($84ab79249a3ce5e1$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $84ab79249a3ce5e1$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($84ab79249a3ce5e1$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $84ab79249a3ce5e1$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = $84ab79249a3ce5e1$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $84ab79249a3ce5e1$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $84ab79249a3ce5e1$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function $84ab79249a3ce5e1$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $84ab79249a3ce5e1$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, $c5rwh._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $84ab79249a3ce5e1$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $3jzhD._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $84ab79249a3ce5e1$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $84ab79249a3ce5e1$var$getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `children()` function for ' + ("route `" + routeId + "` threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $84ab79249a3ce5e1$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $84ab79249a3ce5e1$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($84ab79249a3ce5e1$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $84ab79249a3ce5e1$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $84ab79249a3ce5e1$export$8ccf933b0513f8d0(path) : path;
    return $84ab79249a3ce5e1$export$fe53371bee54353d($84ab79249a3ce5e1$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $84ab79249a3ce5e1$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $84ab79249a3ce5e1$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $84ab79249a3ce5e1$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $84ab79249a3ce5e1$var$ResultType.data || result.type === $84ab79249a3ce5e1$var$ResultType.error);
}
function $84ab79249a3ce5e1$var$isRedirectHandlerResult(result) {
    return $84ab79249a3ce5e1$var$isResponse(result.result) && $84ab79249a3ce5e1$var$redirectStatusCodes.has(result.result.status);
}
function $84ab79249a3ce5e1$var$isDeferredResult(result) {
    return result.type === $84ab79249a3ce5e1$var$ResultType.deferred;
}
function $84ab79249a3ce5e1$var$isErrorResult(result) {
    return result.type === $84ab79249a3ce5e1$var$ResultType.error;
}
function $84ab79249a3ce5e1$var$isRedirectResult(result) {
    return (result && result.type) === $84ab79249a3ce5e1$var$ResultType.redirect;
}
function $84ab79249a3ce5e1$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $84ab79249a3ce5e1$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $84ab79249a3ce5e1$var$isRedirectResponse(result) {
    if (!$84ab79249a3ce5e1$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $84ab79249a3ce5e1$var$isValidMethod(method) {
    return $84ab79249a3ce5e1$var$validRequestMethods.has(method.toLowerCase());
}
function $84ab79249a3ce5e1$var$isMutationMethod(method) {
    return $84ab79249a3ce5e1$var$validMutationMethods.has(method.toLowerCase());
}
function $84ab79249a3ce5e1$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return $84ab79249a3ce5e1$var$_resolveDeferredResults.apply(this, arguments);
}
function $84ab79249a3ce5e1$var$_resolveDeferredResults() {
    $84ab79249a3ce5e1$var$_resolveDeferredResults = (0, $9OZ9j._)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$84ab79249a3ce5e1$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($84ab79249a3ce5e1$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    signal = signals[index];
                                    $84ab79249a3ce5e1$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $84ab79249a3ce5e1$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $lF1I7.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $84ab79249a3ce5e1$var$_resolveDeferredResults.apply(this, arguments);
}
function $84ab79249a3ce5e1$var$resolveDeferredData(result, signal, unwrap) {
    return $84ab79249a3ce5e1$var$_resolveDeferredData.apply(this, arguments);
}
function $84ab79249a3ce5e1$var$_resolveDeferredData() {
    $84ab79249a3ce5e1$var$_resolveDeferredData = (0, $9OZ9j._)(function(result, signal, unwrap) {
        var aborted;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $84ab79249a3ce5e1$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $84ab79249a3ce5e1$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $84ab79249a3ce5e1$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $84ab79249a3ce5e1$var$_resolveDeferredData.apply(this, arguments);
}
function $84ab79249a3ce5e1$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function $84ab79249a3ce5e1$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $84ab79249a3ce5e1$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $84ab79249a3ce5e1$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $84ab79249a3ce5e1$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $84ab79249a3ce5e1$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $84ab79249a3ce5e1$var$getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function $84ab79249a3ce5e1$var$getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $84ab79249a3ce5e1$var$getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function $84ab79249a3ce5e1$var$getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $84ab79249a3ce5e1$var$getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $84ab79249a3ce5e1$var$restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem($84ab79249a3ce5e1$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $2MTYX._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $84ab79249a3ce5e1$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $2MTYX._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $3jzhD._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem($84ab79249a3ce5e1$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $84ab79249a3ce5e1$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.24.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $k1NN5 = parcelRequire("k1NN5");

var $33gHU = parcelRequire("33gHU");

function $89c54c76ed45b63d$var$_extends() {
    $89c54c76ed45b63d$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $89c54c76ed45b63d$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $89c54c76ed45b63d$export$3add0d5dce533e2e = /*#__PURE__*/ $33gHU.createContext(null);
var $89c54c76ed45b63d$export$145dfa71566a64dc = /*#__PURE__*/ $33gHU.createContext(null);
var $89c54c76ed45b63d$var$AwaitContext = /*#__PURE__*/ $33gHU.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $89c54c76ed45b63d$export$26749e8557646306 = /*#__PURE__*/ $33gHU.createContext(null);
var $89c54c76ed45b63d$export$c7914228fb69b0f5 = /*#__PURE__*/ $33gHU.createContext(null);
var $89c54c76ed45b63d$export$9072aa6dd1f93057 = /*#__PURE__*/ $33gHU.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $89c54c76ed45b63d$var$RouteErrorContext = /*#__PURE__*/ $33gHU.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $89c54c76ed45b63d$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$89c54c76ed45b63d$export$9c954a9d03d32f4a() && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    var _React_useContext = $33gHU.useContext($89c54c76ed45b63d$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $89c54c76ed45b63d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $84ab79249a3ce5e1$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $89c54c76ed45b63d$export$9c954a9d03d32f4a() {
    return $33gHU.useContext($89c54c76ed45b63d$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $89c54c76ed45b63d$export$45d76561a5302f2b() {
    !$89c54c76ed45b63d$export$9c954a9d03d32f4a() && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    return $33gHU.useContext($89c54c76ed45b63d$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $89c54c76ed45b63d$export$1b3f31771c5d07c() {
    return $33gHU.useContext($89c54c76ed45b63d$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $89c54c76ed45b63d$export$6c330e8992e8a295(pattern) {
    !$89c54c76ed45b63d$export$9c954a9d03d32f4a() && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    var pathname = $89c54c76ed45b63d$export$45d76561a5302f2b().pathname;
    return $33gHU.useMemo(function() {
        return (0, $84ab79249a3ce5e1$export$81336c211d5ff295)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $89c54c76ed45b63d$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $89c54c76ed45b63d$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $33gHU.useContext($89c54c76ed45b63d$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $33gHU.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $89c54c76ed45b63d$export$9770f232ac06a008() {
    var isDataRoute = $33gHU.useContext($89c54c76ed45b63d$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $89c54c76ed45b63d$var$useNavigateStable() : $89c54c76ed45b63d$var$useNavigateUnstable();
}
function $89c54c76ed45b63d$var$useNavigateUnstable() {
    !$89c54c76ed45b63d$export$9c954a9d03d32f4a() && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    var dataRouterContext = $33gHU.useContext($89c54c76ed45b63d$export$3add0d5dce533e2e);
    var _React_useContext = $33gHU.useContext($89c54c76ed45b63d$export$26749e8557646306), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = $33gHU.useContext($89c54c76ed45b63d$export$9072aa6dd1f93057).matches;
    var _useLocation = $89c54c76ed45b63d$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $84ab79249a3ce5e1$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    var activeRef = $33gHU.useRef(false);
    $89c54c76ed45b63d$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $33gHU.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $84ab79249a3ce5e1$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $84ab79249a3ce5e1$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $89c54c76ed45b63d$var$OutletContext = /*#__PURE__*/ $33gHU.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $89c54c76ed45b63d$export$4138103a3ae699cc() {
    return $33gHU.useContext($89c54c76ed45b63d$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $89c54c76ed45b63d$export$a3be3530d8e40d0b(context) {
    var outlet = $33gHU.useContext($89c54c76ed45b63d$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $89c54c76ed45b63d$export$99eaa27ddbbb95ef() {
    var matches = $33gHU.useContext($89c54c76ed45b63d$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $89c54c76ed45b63d$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = $33gHU.useContext($89c54c76ed45b63d$export$26749e8557646306).future;
    var matches = $33gHU.useContext($89c54c76ed45b63d$export$9072aa6dd1f93057).matches;
    var _useLocation = $89c54c76ed45b63d$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $84ab79249a3ce5e1$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $33gHU.useMemo(function() {
        return (0, $84ab79249a3ce5e1$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $89c54c76ed45b63d$export$5d3fca4a98652595(routes, locationArg) {
    return $89c54c76ed45b63d$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $89c54c76ed45b63d$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$89c54c76ed45b63d$export$9c954a9d03d32f4a() && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    var navigator = $33gHU.useContext($89c54c76ed45b63d$export$26749e8557646306).navigator;
    var _React_useContext = $33gHU.useContext($89c54c76ed45b63d$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $89c54c76ed45b63d$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $84ab79249a3ce5e1$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = (0, $84ab79249a3ce5e1$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $89c54c76ed45b63d$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $84ab79249a3ce5e1$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $84ab79249a3ce5e1$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $89c54c76ed45b63d$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $84ab79249a3ce5e1$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $89c54c76ed45b63d$var$DefaultErrorComponent() {
    var error = $89c54c76ed45b63d$export$ed527bf60f6e05f2();
    var message = (0, $84ab79249a3ce5e1$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $33gHU.createElement($33gHU.Fragment, null, /*#__PURE__*/ $33gHU.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $33gHU.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $33gHU.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $89c54c76ed45b63d$var$defaultErrorElement = /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$var$DefaultErrorComponent, null);
var $89c54c76ed45b63d$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $iNfU4._)(RenderErrorBoundary, _React_Component);
    var _super = (0, $k1NN5._)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $19mwo._)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $6rpfc._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($33gHU.Component);
function $89c54c76ed45b63d$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $33gHU.useContext($89c54c76ed45b63d$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $89c54c76ed45b63d$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined;
        });
        !(errorIndex >= 0) && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $89c54c76ed45b63d$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $89c54c76ed45b63d$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $33gHU.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $89c54c76ed45b63d$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($89c54c76ed45b63d$var$DataRouterHook || {});
var $89c54c76ed45b63d$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($89c54c76ed45b63d$var$DataRouterStateHook || {});
function $89c54c76ed45b63d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $89c54c76ed45b63d$var$useDataRouterContext(hookName) {
    var ctx = $33gHU.useContext($89c54c76ed45b63d$export$3add0d5dce533e2e);
    !ctx && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    return ctx;
}
function $89c54c76ed45b63d$var$useDataRouterState(hookName) {
    var state = $33gHU.useContext($89c54c76ed45b63d$export$145dfa71566a64dc);
    !state && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    return state;
}
function $89c54c76ed45b63d$var$useRouteContext(hookName) {
    var route = $33gHU.useContext($89c54c76ed45b63d$export$9072aa6dd1f93057);
    !route && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $89c54c76ed45b63d$var$useCurrentRouteId(hookName) {
    var route = $89c54c76ed45b63d$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $89c54c76ed45b63d$export$5fc8298006ad9e58() {
    return $89c54c76ed45b63d$var$useCurrentRouteId($89c54c76ed45b63d$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $89c54c76ed45b63d$export$d0fd4b7106de2769() {
    var state = $89c54c76ed45b63d$var$useDataRouterState($89c54c76ed45b63d$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $89c54c76ed45b63d$export$600dc272ed516c15() {
    var dataRouterContext = $89c54c76ed45b63d$var$useDataRouterContext($89c54c76ed45b63d$var$DataRouterHook.UseRevalidator);
    var state = $89c54c76ed45b63d$var$useDataRouterState($89c54c76ed45b63d$var$DataRouterStateHook.UseRevalidator);
    return $33gHU.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $89c54c76ed45b63d$export$2378eb7f5ff86053() {
    var _useDataRouterState = $89c54c76ed45b63d$var$useDataRouterState($89c54c76ed45b63d$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $33gHU.useMemo(function() {
        return matches.map(function(m) {
            return (0, $84ab79249a3ce5e1$export$b3fac024fad9e8ff)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $89c54c76ed45b63d$export$1448a5050d252c4d() {
    var state = $89c54c76ed45b63d$var$useDataRouterState($89c54c76ed45b63d$var$DataRouterStateHook.UseLoaderData);
    var routeId = $89c54c76ed45b63d$var$useCurrentRouteId($89c54c76ed45b63d$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $89c54c76ed45b63d$export$fd5d37484eab868d(routeId) {
    var state = $89c54c76ed45b63d$var$useDataRouterState($89c54c76ed45b63d$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $89c54c76ed45b63d$export$fdc00f3f26066d5e() {
    var state = $89c54c76ed45b63d$var$useDataRouterState($89c54c76ed45b63d$var$DataRouterStateHook.UseActionData);
    var routeId = $89c54c76ed45b63d$var$useCurrentRouteId($89c54c76ed45b63d$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $89c54c76ed45b63d$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $33gHU.useContext($89c54c76ed45b63d$var$RouteErrorContext);
    var state = $89c54c76ed45b63d$var$useDataRouterState($89c54c76ed45b63d$var$DataRouterStateHook.UseRouteError);
    var routeId = $89c54c76ed45b63d$var$useCurrentRouteId($89c54c76ed45b63d$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $89c54c76ed45b63d$export$78a72ddb39bdd145() {
    var value = $33gHU.useContext($89c54c76ed45b63d$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $89c54c76ed45b63d$export$17f53340677d5831() {
    var value = $33gHU.useContext($89c54c76ed45b63d$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $89c54c76ed45b63d$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $89c54c76ed45b63d$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $89c54c76ed45b63d$var$useDataRouterContext($89c54c76ed45b63d$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $89c54c76ed45b63d$var$useDataRouterState($89c54c76ed45b63d$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $2MTYX._)($33gHU.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $33gHU.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $89c54c76ed45b63d$var$_extends({}, currentLocation, {
                pathname: (0, $84ab79249a3ce5e1$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $89c54c76ed45b63d$var$_extends({}, nextLocation, {
                pathname: (0, $84ab79249a3ce5e1$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $33gHU.useEffect(function() {
        var key = String(++$89c54c76ed45b63d$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $33gHU.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $84ab79249a3ce5e1$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $89c54c76ed45b63d$var$useNavigateStable() {
    var router = $89c54c76ed45b63d$var$useDataRouterContext($89c54c76ed45b63d$var$DataRouterHook.UseNavigateStable).router;
    var id = $89c54c76ed45b63d$var$useCurrentRouteId($89c54c76ed45b63d$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $33gHU.useRef(false);
    $89c54c76ed45b63d$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $33gHU.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $89c54c76ed45b63d$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $89c54c76ed45b63d$var$alreadyWarned = {};
function $89c54c76ed45b63d$var$warningOnce(key, cond, message) {
    if (!cond && !$89c54c76ed45b63d$var$alreadyWarned[key]) $89c54c76ed45b63d$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $89c54c76ed45b63d$var$START_TRANSITION = "startTransition";
var $89c54c76ed45b63d$var$startTransitionImpl = $33gHU[$89c54c76ed45b63d$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $89c54c76ed45b63d$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $2MTYX._)($33gHU.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $33gHU.useCallback(function(newState) {
        if (v7_startTransition && $89c54c76ed45b63d$var$startTransitionImpl) $89c54c76ed45b63d$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $33gHU.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $33gHU.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $33gHU.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $33gHU.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $33gHU.createElement($33gHU.Fragment, null, /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $89c54c76ed45b63d$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return $89c54c76ed45b63d$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $89c54c76ed45b63d$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $33gHU.useRef();
    if (historyRef.current == null) historyRef.current = (0, $84ab79249a3ce5e1$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $2MTYX._)($33gHU.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $33gHU.useCallback(function(newState) {
        v7_startTransition && $89c54c76ed45b63d$var$startTransitionImpl ? $89c54c76ed45b63d$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $33gHU.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $89c54c76ed45b63d$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$89c54c76ed45b63d$export$9c954a9d03d32f4a() && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    var _React_useContext = $33gHU.useContext($89c54c76ed45b63d$export$26749e8557646306), future = _React_useContext.future, isStatic = _React_useContext.static;
    var matches = $33gHU.useContext($89c54c76ed45b63d$export$9072aa6dd1f93057).matches;
    var _useLocation = $89c54c76ed45b63d$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $89c54c76ed45b63d$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $84ab79249a3ce5e1$export$cae722b0cc860f13)(to, (0, $84ab79249a3ce5e1$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $33gHU.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $89c54c76ed45b63d$export$910ae8079b2c2852(props) {
    return $89c54c76ed45b63d$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $89c54c76ed45b63d$export$e7b0ac011bb776c6(_props) {
    (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $89c54c76ed45b63d$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $84ab79249a3ce5e1$export$e19cd5f9376f8cee).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!$89c54c76ed45b63d$export$9c954a9d03d32f4a() && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $33gHU.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $89c54c76ed45b63d$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $84ab79249a3ce5e1$export$8ccf933b0513f8d0)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $33gHU.useMemo(function() {
        var trailingPathname = (0, $84ab79249a3ce5e1$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $89c54c76ed45b63d$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $89c54c76ed45b63d$export$5d3fca4a98652595($89c54c76ed45b63d$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $89c54c76ed45b63d$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$var$ResolveAwait, null, children));
}
var $89c54c76ed45b63d$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($89c54c76ed45b63d$var$AwaitRenderStatus || {});
var $89c54c76ed45b63d$var$neverSettledPromise = new Promise(function() {});
var $89c54c76ed45b63d$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $iNfU4._)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $k1NN5._)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $19mwo._)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $6rpfc._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $89c54c76ed45b63d$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $89c54c76ed45b63d$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $89c54c76ed45b63d$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = "_error" in promise ? $89c54c76ed45b63d$var$AwaitRenderStatus.error : "_data" in promise ? $89c54c76ed45b63d$var$AwaitRenderStatus.success : $89c54c76ed45b63d$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $89c54c76ed45b63d$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $89c54c76ed45b63d$var$AwaitRenderStatus.error && promise._error instanceof (0, $84ab79249a3ce5e1$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
                throw $89c54c76ed45b63d$var$neverSettledPromise;
                if (status === $89c54c76ed45b63d$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $89c54c76ed45b63d$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $89c54c76ed45b63d$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $33gHU.createElement($89c54c76ed45b63d$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($33gHU.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $89c54c76ed45b63d$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $89c54c76ed45b63d$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $33gHU.createElement($33gHU.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $89c54c76ed45b63d$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $33gHU.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $33gHU.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $3jzhD._)(parentPath).concat([
            index
        ]);
        if (element.type === $33gHU.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $89c54c76ed45b63d$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $89c54c76ed45b63d$export$e7b0ac011bb776c6) && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $89c54c76ed45b63d$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $89c54c76ed45b63d$export$daf73786167a7f72(matches) {
    return $89c54c76ed45b63d$var$_renderMatches(matches);
}
function $89c54c76ed45b63d$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $33gHU.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $33gHU.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $33gHU.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $89c54c76ed45b63d$export$f30f7e456d254e83(routes, opts) {
    return (0, $84ab79249a3ce5e1$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $89c54c76ed45b63d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $84ab79249a3ce5e1$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $89c54c76ed45b63d$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss
    }).initialize();
}



function $06bbb0d4ad208fb4$var$_extends() {
    $06bbb0d4ad208fb4$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $06bbb0d4ad208fb4$var$_extends.apply(this, arguments);
}
function $06bbb0d4ad208fb4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $06bbb0d4ad208fb4$var$defaultMethod = "get";
var $06bbb0d4ad208fb4$var$defaultEncType = "application/x-www-form-urlencoded";
function $06bbb0d4ad208fb4$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $06bbb0d4ad208fb4$var$isButtonElement(object) {
    return $06bbb0d4ad208fb4$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $06bbb0d4ad208fb4$var$isFormElement(object) {
    return $06bbb0d4ad208fb4$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $06bbb0d4ad208fb4$var$isInputElement(object) {
    return $06bbb0d4ad208fb4$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $06bbb0d4ad208fb4$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $06bbb0d4ad208fb4$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$06bbb0d4ad208fb4$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $06bbb0d4ad208fb4$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $06bbb0d4ad208fb4$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $06bbb0d4ad208fb4$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $06bbb0d4ad208fb4$var$_formDataSupportsSubmitter = null;
function $06bbb0d4ad208fb4$var$isFormDataSubmitterSupported() {
    if ($06bbb0d4ad208fb4$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $06bbb0d4ad208fb4$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $06bbb0d4ad208fb4$var$_formDataSupportsSubmitter = true;
    }
    return $06bbb0d4ad208fb4$var$_formDataSupportsSubmitter;
}
var $06bbb0d4ad208fb4$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $06bbb0d4ad208fb4$var$getFormEncType(encType) {
    if (encType != null && !$06bbb0d4ad208fb4$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $06bbb0d4ad208fb4$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($06bbb0d4ad208fb4$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $84ab79249a3ce5e1$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $06bbb0d4ad208fb4$var$defaultMethod;
        encType = $06bbb0d4ad208fb4$var$getFormEncType(target.getAttribute("enctype")) || $06bbb0d4ad208fb4$var$defaultEncType;
        formData = new FormData(target);
    } else if ($06bbb0d4ad208fb4$var$isButtonElement(target) || $06bbb0d4ad208fb4$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $84ab79249a3ce5e1$export$b69e3301ce081aa3)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $06bbb0d4ad208fb4$var$defaultMethod;
        encType = $06bbb0d4ad208fb4$var$getFormEncType(target.getAttribute("formenctype")) || $06bbb0d4ad208fb4$var$getFormEncType(form.getAttribute("enctype")) || $06bbb0d4ad208fb4$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$06bbb0d4ad208fb4$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($06bbb0d4ad208fb4$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $06bbb0d4ad208fb4$var$defaultMethod;
        action = null;
        encType = $06bbb0d4ad208fb4$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $06bbb0d4ad208fb4$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $06bbb0d4ad208fb4$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $06bbb0d4ad208fb4$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var $06bbb0d4ad208fb4$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $06bbb0d4ad208fb4$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $06bbb0d4ad208fb4$export$1f3f55432a00e06d(routes, opts) {
    return (0, $84ab79249a3ce5e1$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $06bbb0d4ad208fb4$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $84ab79249a3ce5e1$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $06bbb0d4ad208fb4$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $89c54c76ed45b63d$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $06bbb0d4ad208fb4$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $84ab79249a3ce5e1$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $06bbb0d4ad208fb4$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $84ab79249a3ce5e1$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $06bbb0d4ad208fb4$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $89c54c76ed45b63d$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $06bbb0d4ad208fb4$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $06bbb0d4ad208fb4$var$_extends({}, state, {
        errors: $06bbb0d4ad208fb4$var$deserializeErrors(state.errors)
    });
    return state;
}
function $06bbb0d4ad208fb4$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2MTYX._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $84ab79249a3ce5e1$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $06bbb0d4ad208fb4$export$7ad602f0e94e62d1 = /*#__PURE__*/ $33gHU.createContext({
    isTransitioning: false
});
var $06bbb0d4ad208fb4$export$148fd98d095596d4 = /*#__PURE__*/ $33gHU.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $06bbb0d4ad208fb4$var$START_TRANSITION = "startTransition";
var $06bbb0d4ad208fb4$var$startTransitionImpl = $33gHU[$06bbb0d4ad208fb4$var$START_TRANSITION];
var $06bbb0d4ad208fb4$var$FLUSH_SYNC = "flushSync";
var $06bbb0d4ad208fb4$var$flushSyncImpl = $e1a300cc66774841$exports[$06bbb0d4ad208fb4$var$FLUSH_SYNC];
var $06bbb0d4ad208fb4$var$USE_ID = "useId";
var $06bbb0d4ad208fb4$var$useIdImpl = $33gHU[$06bbb0d4ad208fb4$var$USE_ID];
function $06bbb0d4ad208fb4$var$startTransitionSafe(cb) {
    if ($06bbb0d4ad208fb4$var$startTransitionImpl) $06bbb0d4ad208fb4$var$startTransitionImpl(cb);
    else cb();
}
function $06bbb0d4ad208fb4$var$flushSyncSafe(cb) {
    if ($06bbb0d4ad208fb4$var$flushSyncImpl) $06bbb0d4ad208fb4$var$flushSyncImpl(cb);
    else cb();
}
var $06bbb0d4ad208fb4$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $19mwo._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $06bbb0d4ad208fb4$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $2MTYX._)($33gHU.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $2MTYX._)($33gHU.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $2MTYX._)($33gHU.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $2MTYX._)($33gHU.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $2MTYX._)($33gHU.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $2MTYX._)($33gHU.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $33gHU.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $33gHU.useCallback(function(cb) {
        if (v7_startTransition) $06bbb0d4ad208fb4$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $33gHU.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.unstable_flushSync, viewTransitionOpts = _ref2.unstable_viewTransitionOpts;
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        var isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $06bbb0d4ad208fb4$var$flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $06bbb0d4ad208fb4$var$flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                $06bbb0d4ad208fb4$var$flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished.finally(function() {
                $06bbb0d4ad208fb4$var$flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $06bbb0d4ad208fb4$var$flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $33gHU.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $33gHU.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $06bbb0d4ad208fb4$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $33gHU.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, $9OZ9j._)(function() {
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $33gHU.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $33gHU.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $33gHU.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $33gHU.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $33gHU.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $33gHU.createElement($33gHU.Fragment, null, /*#__PURE__*/ $33gHU.createElement((0, $89c54c76ed45b63d$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $33gHU.createElement((0, $89c54c76ed45b63d$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $33gHU.createElement($06bbb0d4ad208fb4$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $33gHU.createElement($06bbb0d4ad208fb4$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $33gHU.createElement((0, $89c54c76ed45b63d$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $33gHU.createElement($06bbb0d4ad208fb4$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $06bbb0d4ad208fb4$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, $89c54c76ed45b63d$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $06bbb0d4ad208fb4$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $33gHU.useRef();
    if (historyRef.current == null) historyRef.current = (0, $84ab79249a3ce5e1$export$719fc203c4e16dee)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $2MTYX._)($33gHU.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $33gHU.useCallback(function(newState) {
        v7_startTransition && $06bbb0d4ad208fb4$var$startTransitionImpl ? $06bbb0d4ad208fb4$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $33gHU.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $33gHU.createElement((0, $89c54c76ed45b63d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $06bbb0d4ad208fb4$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $33gHU.useRef();
    if (historyRef.current == null) historyRef.current = (0, $84ab79249a3ce5e1$export$b71fdd3798280242)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $2MTYX._)($33gHU.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $33gHU.useCallback(function(newState) {
        v7_startTransition && $06bbb0d4ad208fb4$var$startTransitionImpl ? $06bbb0d4ad208fb4$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $33gHU.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $33gHU.createElement((0, $89c54c76ed45b63d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $06bbb0d4ad208fb4$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $2MTYX._)($33gHU.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $33gHU.useCallback(function(newState) {
        v7_startTransition && $06bbb0d4ad208fb4$var$startTransitionImpl ? $06bbb0d4ad208fb4$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $33gHU.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $33gHU.createElement((0, $89c54c76ed45b63d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
var $06bbb0d4ad208fb4$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $06bbb0d4ad208fb4$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $06bbb0d4ad208fb4$export$a6c7ac8248d6e38a = /*#__PURE__*/ $33gHU.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, unstable_viewTransition = _ref7.unstable_viewTransition, rest = $06bbb0d4ad208fb4$var$_objectWithoutPropertiesLoose(_ref7, $06bbb0d4ad208fb4$var$_excluded);
    var basename = $33gHU.useContext((0, $89c54c76ed45b63d$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $06bbb0d4ad208fb4$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($06bbb0d4ad208fb4$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $84ab79249a3ce5e1$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $89c54c76ed45b63d$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $06bbb0d4ad208fb4$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $33gHU.createElement("a", $06bbb0d4ad208fb4$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $06bbb0d4ad208fb4$export$b0d92dbee9b5b60d = /*#__PURE__*/ $33gHU.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, unstable_viewTransition = _ref8.unstable_viewTransition, children = _ref8.children, rest = $06bbb0d4ad208fb4$var$_objectWithoutPropertiesLoose(_ref8, $06bbb0d4ad208fb4$var$_excluded2);
    var path = (0, $89c54c76ed45b63d$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $89c54c76ed45b63d$export$45d76561a5302f2b)();
    var routerState = $33gHU.useContext((0, $89c54c76ed45b63d$export$145dfa71566a64dc));
    var _React_useContext = $33gHU.useContext((0, $89c54c76ed45b63d$export$26749e8557646306)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $06bbb0d4ad208fb4$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $84ab79249a3ce5e1$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $33gHU.createElement($06bbb0d4ad208fb4$export$a6c7ac8248d6e38a, $06bbb0d4ad208fb4$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $06bbb0d4ad208fb4$export$a7fed597f4b8afd8 = /*#__PURE__*/ $33gHU.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $06bbb0d4ad208fb4$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, unstable_viewTransition = _ref9.unstable_viewTransition, props = $06bbb0d4ad208fb4$var$_objectWithoutPropertiesLoose(_ref9, $06bbb0d4ad208fb4$var$_excluded3);
    var submit = $06bbb0d4ad208fb4$export$47c85c6e3a081d3();
    var formAction = $06bbb0d4ad208fb4$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $33gHU.createElement("form", $06bbb0d4ad208fb4$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $06bbb0d4ad208fb4$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $06bbb0d4ad208fb4$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $06bbb0d4ad208fb4$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($06bbb0d4ad208fb4$var$DataRouterHook || ($06bbb0d4ad208fb4$var$DataRouterHook = {}));
var $06bbb0d4ad208fb4$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($06bbb0d4ad208fb4$var$DataRouterStateHook || ($06bbb0d4ad208fb4$var$DataRouterStateHook = {}));
// Internal hooks
function $06bbb0d4ad208fb4$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $06bbb0d4ad208fb4$var$useDataRouterContext(hookName) {
    var ctx = $33gHU.useContext((0, $89c54c76ed45b63d$export$3add0d5dce533e2e));
    !ctx && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    return ctx;
}
function $06bbb0d4ad208fb4$var$useDataRouterState(hookName) {
    var state = $33gHU.useContext((0, $89c54c76ed45b63d$export$145dfa71566a64dc));
    !state && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $06bbb0d4ad208fb4$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, unstable_viewTransition = _ref.unstable_viewTransition;
    var navigate = (0, $89c54c76ed45b63d$export$9770f232ac06a008)();
    var location = (0, $89c54c76ed45b63d$export$45d76561a5302f2b)();
    var path = (0, $89c54c76ed45b63d$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $33gHU.useCallback(function(event) {
        if ($06bbb0d4ad208fb4$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $84ab79249a3ce5e1$export$fe53371bee54353d)(location) === (0, $84ab79249a3ce5e1$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $06bbb0d4ad208fb4$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $33gHU.useRef($06bbb0d4ad208fb4$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $33gHU.useRef(false);
    var location = (0, $89c54c76ed45b63d$export$45d76561a5302f2b)();
    var searchParams = $33gHU.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $06bbb0d4ad208fb4$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $89c54c76ed45b63d$export$9770f232ac06a008)();
    var setSearchParams = $33gHU.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $06bbb0d4ad208fb4$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $06bbb0d4ad208fb4$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $06bbb0d4ad208fb4$var$fetcherId = 0;
var $06bbb0d4ad208fb4$var$getUniqueFetcherId = function() {
    return "__" + String(++$06bbb0d4ad208fb4$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $06bbb0d4ad208fb4$export$47c85c6e3a081d3() {
    var router = $06bbb0d4ad208fb4$var$useDataRouterContext($06bbb0d4ad208fb4$var$DataRouterHook.UseSubmit).router;
    var basename = $33gHU.useContext((0, $89c54c76ed45b63d$export$26749e8557646306)).basename;
    var currentRouteId = (0, $89c54c76ed45b63d$export$5fc8298006ad9e58)();
    return $33gHU.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $06bbb0d4ad208fb4$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $06bbb0d4ad208fb4$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $06bbb0d4ad208fb4$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $06bbb0d4ad208fb4$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $33gHU.useContext((0, $89c54c76ed45b63d$export$26749e8557646306)).basename;
    var routeContext = $33gHU.useContext((0, $89c54c76ed45b63d$export$9072aa6dd1f93057));
    !routeContext && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    var _routeContext_matches_slice = (0, $2MTYX._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $06bbb0d4ad208fb4$var$_extends({}, (0, $89c54c76ed45b63d$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $89c54c76ed45b63d$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $84ab79249a3ce5e1$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $84ab79249a3ce5e1$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $06bbb0d4ad208fb4$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $06bbb0d4ad208fb4$var$useDataRouterContext($06bbb0d4ad208fb4$var$DataRouterHook.UseFetcher).router;
    var state = $06bbb0d4ad208fb4$var$useDataRouterState($06bbb0d4ad208fb4$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $33gHU.useContext($06bbb0d4ad208fb4$export$148fd98d095596d4);
    var route = $33gHU.useContext((0, $89c54c76ed45b63d$export$9072aa6dd1f93057));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    !route && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = $06bbb0d4ad208fb4$var$useIdImpl ? $06bbb0d4ad208fb4$var$useIdImpl() : "";
    var _React_useState = (0, $2MTYX._)($33gHU.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($06bbb0d4ad208fb4$var$getUniqueFetcherId());
    // Registration/cleanup
    $33gHU.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $33gHU.useCallback(function(href, opts) {
        !routeId && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $06bbb0d4ad208fb4$export$47c85c6e3a081d3();
    var submit = $33gHU.useCallback(function(target, opts) {
        submitImpl(target, $06bbb0d4ad208fb4$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $33gHU.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $33gHU.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $33gHU.createElement($06bbb0d4ad208fb4$export$a7fed597f4b8afd8, $06bbb0d4ad208fb4$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $84ab79249a3ce5e1$export$52eace9c284d3585);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $33gHU.useMemo(function() {
        return $06bbb0d4ad208fb4$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $06bbb0d4ad208fb4$export$fa996778a3a31087() {
    var state = $06bbb0d4ad208fb4$var$useDataRouterState($06bbb0d4ad208fb4$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $2MTYX._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $06bbb0d4ad208fb4$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $06bbb0d4ad208fb4$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $06bbb0d4ad208fb4$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $06bbb0d4ad208fb4$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $06bbb0d4ad208fb4$var$useDataRouterContext($06bbb0d4ad208fb4$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $06bbb0d4ad208fb4$var$useDataRouterState($06bbb0d4ad208fb4$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $33gHU.useContext((0, $89c54c76ed45b63d$export$26749e8557646306)).basename;
    var location = (0, $89c54c76ed45b63d$export$45d76561a5302f2b)();
    var matches = (0, $89c54c76ed45b63d$export$2378eb7f5ff86053)();
    var navigation = (0, $89c54c76ed45b63d$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $33gHU.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $06bbb0d4ad208fb4$var$usePageHide($33gHU.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $06bbb0d4ad208fb4$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $06bbb0d4ad208fb4$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($06bbb0d4ad208fb4$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $33gHU.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $06bbb0d4ad208fb4$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $06bbb0d4ad208fb4$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $33gHU.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($06bbb0d4ad208fb4$var$_extends({}, location, {
                    pathname: (0, $84ab79249a3ce5e1$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($06bbb0d4ad208fb4$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $33gHU.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $06bbb0d4ad208fb4$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $33gHU.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $06bbb0d4ad208fb4$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $33gHU.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $06bbb0d4ad208fb4$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $89c54c76ed45b63d$export$b273b3273281a049)(when);
    $33gHU.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $33gHU.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $06bbb0d4ad208fb4$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $33gHU.useContext($06bbb0d4ad208fb4$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $84ab79249a3ce5e1$export$3e9cee6b33872309)(false);
    var basename = $06bbb0d4ad208fb4$var$useDataRouterContext($06bbb0d4ad208fb4$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $89c54c76ed45b63d$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $84ab79249a3ce5e1$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $84ab79249a3ce5e1$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $84ab79249a3ce5e1$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $84ab79249a3ce5e1$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $gnDeW = parcelRequire("gnDeW");

var $b0lSM = parcelRequire("b0lSM");

var $33gHU = parcelRequire("33gHU");

var $b0lSM = parcelRequire("b0lSM");

var $33gHU = parcelRequire("33gHU");
if (!(0, $33gHU.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $b0lSM.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");






var $b0lSM = parcelRequire("b0lSM");
function $0a2ec184387c513f$export$fb2daceae6f5097a(callback) {
    callback();
}
function $0a2ec184387c513f$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $0a2ec184387c513f$export$fb2daceae6f5097a;
    (0, $b0lSM.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $0a2ec184387c513f$export$13ce1459b9a04b51 = function isObserverBatched() {
    return true;
};


var $3ffd577dce7820b3$var$deprecatedMessages = [];
function $3ffd577dce7820b3$export$be38475be17599d(msg) {
    if (!$3ffd577dce7820b3$var$deprecatedMessages.includes(msg)) {
        $3ffd577dce7820b3$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}



var $b0lSM = parcelRequire("b0lSM");

var $33gHU = parcelRequire("33gHU");

var $b0lSM = parcelRequire("b0lSM");
function $cf0b5f0aa25eaa09$export$ef795f1f307682c7(v) {
    return (0, $b0lSM.getDependencyTree)(v);
}


var $c247a499a1aa7eeb$var$globalIsUsingStaticRendering = false;
function $c247a499a1aa7eeb$export$5d52eaa7c0f24c9e(enable) {
    $c247a499a1aa7eeb$var$globalIsUsingStaticRendering = enable;
}
function $c247a499a1aa7eeb$export$55979271896d643e() {
    return $c247a499a1aa7eeb$var$globalIsUsingStaticRendering;
}


var $37418126c1588f1d$export$e901ba0ffe10ba41 = 10000;
var $37418126c1588f1d$export$1ae22ce5a82f26b6 = 10000;
var $37418126c1588f1d$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function value(maxAge) {
                if (maxAge === void 0) maxAge = $37418126c1588f1d$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function value() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $37418126c1588f1d$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $37418126c1588f1d$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $37418126c1588f1d$export$b7a00d372cedeedd;


var $27d463009c41dda0$export$10e8a12fbfd8583c = new (0, $37418126c1588f1d$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $f694b76da4f40399$exports = {};
"use strict";

$f694b76da4f40399$exports = (parcelRequire("7uGlr"));


function $2d4dc388f8913f9e$var$createReaction(adm) {
    adm.reaction = new (0, $b0lSM.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $2d4dc388f8913f9e$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $c247a499a1aa7eeb$export$55979271896d643e)()) return render();
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function subscribe(onStoreChange) {
                // Do NOT access admRef here!
                (0, $27d463009c41dda0$export$10e8a12fbfd8583c).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $2d4dc388f8913f9e$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function getSnapshot() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $2d4dc388f8913f9e$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $27d463009c41dda0$export$10e8a12fbfd8583c).register(admRef, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).useDebugValue(adm.reaction, (0, $cf0b5f0aa25eaa09$export$ef795f1f307682c7));
    (0, $f694b76da4f40399$exports.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}





var $33gHU = parcelRequire("33gHU");


var $620a8c524671f26f$var$_a, $620a8c524671f26f$var$_b;
var $620a8c524671f26f$var$warnObserverOptionsDeprecated = true;
var $620a8c524671f26f$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $620a8c524671f26f$var$isFunctionNameConfigurable = ($620a8c524671f26f$var$_b = ($620a8c524671f26f$var$_a = Object.getOwnPropertyDescriptor(function() {}, "name")) === null || $620a8c524671f26f$var$_a === void 0 ? void 0 : $620a8c524671f26f$var$_a.configurable) !== null && $620a8c524671f26f$var$_b !== void 0 ? $620a8c524671f26f$var$_b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $620a8c524671f26f$var$ReactForwardRefSymbol = $620a8c524671f26f$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $33gHU.forwardRef) === "function" && (0, $33gHU.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $620a8c524671f26f$var$ReactMemoSymbol = $620a8c524671f26f$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $33gHU.memo) === "function" && (0, $33gHU.memo)(function(props) {
    return null;
})["$$typeof"];
function $620a8c524671f26f$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($620a8c524671f26f$var$ReactMemoSymbol && baseComponent["$$typeof"] === $620a8c524671f26f$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $c247a499a1aa7eeb$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($620a8c524671f26f$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $620a8c524671f26f$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function observerComponent(props, ref) {
        return (0, $2d4dc388f8913f9e$export$b9c7ecd090a87b14)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($620a8c524671f26f$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $33gHU.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $33gHU.memo)(observerComponent);
    $620a8c524671f26f$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $620a8c524671f26f$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $620a8c524671f26f$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$620a8c524671f26f$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



var $gnDeW = parcelRequire("gnDeW");

function $4a1f305ecb0b6440$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $2d4dc388f8913f9e$export$b9c7ecd090a87b14)(component);
}
$4a1f305ecb0b6440$export$c1cbdee04e18ea8b.displayName = "Observer";
function $4a1f305ecb0b6440$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + (0, $gnDeW._)(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
}



var $b0lSM = parcelRequire("b0lSM");

var $33gHU = parcelRequire("33gHU");
function $1596cd908b0fec1b$export$aa207039f277c5f(initializer, annotations) {
    return (0, $33gHU.useState)(function() {
        return (0, $b0lSM.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}



var $b0lSM = parcelRequire("b0lSM");

var $33gHU = parcelRequire("33gHU");



var $b0lSM = parcelRequire("b0lSM");

var $33gHU = parcelRequire("33gHU");
function $7a6e60c8c7bfdce3$export$e0ded3646391939c(current) {
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = (0, $33gHU.useState)(function() {
        return (0, $b0lSM.observable)(current, {}, {
            deep: false
        });
    })[0];
    (0, $b0lSM.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $5f2001fd9b12bad7$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $7a6e60c8c7bfdce3$export$e0ded3646391939c)(current);
    return (0, $33gHU.useState)(function() {
        return (0, $b0lSM.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $3231f13db7817dd6$var$_a;
(0, $0a2ec184387c513f$export$294943bbc3c74f4f)((0, $e1a300cc66774841$exports.unstable_batchedUpdates));
var $3231f13db7817dd6$export$469d51fb8d268227 = ($3231f13db7817dd6$var$_a = (0, $27d463009c41dda0$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $3231f13db7817dd6$var$_a !== void 0 ? $3231f13db7817dd6$var$_a : function clearTimers() {};
function $3231f13db7817dd6$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $2d4dc388f8913f9e$export$b9c7ecd090a87b14)(fn, baseComponentName);
}
function $3231f13db7817dd6$export$7613124ee4202834(enable) {
    (0, $c247a499a1aa7eeb$export$5d52eaa7c0f24c9e)(enable);
}


function $7a4bc3291e712a46$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($7a4bc3291e712a46$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$7a4bc3291e712a46$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $7a4bc3291e712a46$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $7a4bc3291e712a46$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    displayName: 1,
    propTypes: 1
};
function $7a4bc3291e712a46$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$7a4bc3291e712a46$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $7a4bc3291e712a46$var$mobxMixins = /*#__PURE__*/ Symbol("patchMixins");
var $7a4bc3291e712a46$var$mobxPatchedDefinition = /*#__PURE__*/ Symbol("patchedDefinition");
function $7a4bc3291e712a46$var$getMixins(target, methodName) {
    var mixins = target[$7a4bc3291e712a46$var$mobxMixins] = target[$7a4bc3291e712a46$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $7a4bc3291e712a46$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $7a4bc3291e712a46$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $7a4bc3291e712a46$var$wrapper.call.apply($7a4bc3291e712a46$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $7a4bc3291e712a46$var$patch(target, methodName, mixinMethod) {
    var mixins = $7a4bc3291e712a46$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$7a4bc3291e712a46$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $7a4bc3291e712a46$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $7a4bc3291e712a46$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $7a4bc3291e712a46$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$7a4bc3291e712a46$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $7a4bc3291e712a46$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $7a4bc3291e712a46$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $7a4bc3291e712a46$var$administrationSymbol = /*#__PURE__*/ Symbol("ObserverAdministration");
var $7a4bc3291e712a46$var$isMobXReactObserverSymbol = /*#__PURE__*/ Symbol("isMobXReactObserver");
var $7a4bc3291e712a46$var$observablePropDescriptors;
function $7a4bc3291e712a46$var$getAdministration(component) {
    var _component$administra;
    // We create administration lazily, because we can't patch constructor
    // and the exact moment of initialization partially depends on React internals.
    // At the time of writing this, the first thing invoked is one of the observable getter/setter (state/props/context).
    return (_component$administra = component[$7a4bc3291e712a46$var$administrationSymbol]) != null ? _component$administra : component[$7a4bc3291e712a46$var$administrationSymbol] = {
        reaction: null,
        mounted: false,
        reactionInvalidatedBeforeMount: false,
        forceUpdate: null,
        name: $7a4bc3291e712a46$var$getDisplayName(component.constructor),
        state: undefined,
        props: undefined,
        context: undefined
    };
}
function $7a4bc3291e712a46$var$makeClassComponentObserver(componentClass) {
    var prototype = componentClass.prototype;
    if (componentClass[$7a4bc3291e712a46$var$isMobXReactObserverSymbol]) {
        var displayName = $7a4bc3291e712a46$var$getDisplayName(componentClass);
        throw new Error("The provided component class (" + displayName + ") has already been declared as an observer component.");
    } else componentClass[$7a4bc3291e712a46$var$isMobXReactObserverSymbol] = true;
    if (prototype.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $33gHU.PureComponent)) {
        if (!prototype.shouldComponentUpdate) prototype.shouldComponentUpdate = $7a4bc3291e712a46$var$observerSCU;
        else if (prototype.shouldComponentUpdate !== $7a4bc3291e712a46$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    }
    var originalRender = prototype.render;
    if (typeof originalRender !== "function") {
        var _displayName = $7a4bc3291e712a46$var$getDisplayName(componentClass);
        throw new Error("[mobx-react] class component (" + _displayName + ") is missing `render` method." + "\n`observer` requires `render` being a function defined on prototype." + "\n`render = () => {}` or `render = function() {}` is not supported.");
    }
    prototype.render = function() {
        Object.defineProperty(this, "render", {
            // There is no safe way to replace render, therefore it's forbidden.
            configurable: false,
            writable: false,
            value: (0, $c247a499a1aa7eeb$export$55979271896d643e)() ? originalRender : $7a4bc3291e712a46$var$createReactiveRender.call(this, originalRender)
        });
        return this.render();
    };
    var originalComponentDidMount = prototype.componentDidMount;
    prototype.componentDidMount = function() {
        var _this = this;
        var _displayName2;
        // `componentDidMount` may not be called at all. React can abandon the instance after `render`.
        // That's why we use finalization registry to dispose reaction created during render.
        // Happens with `<Suspend>` see #3492
        //
        // `componentDidMount` can be called immediately after `componentWillUnmount` without calling `render` in between.
        // Happens with `<StrictMode>`see #3395.
        //
        // If `componentDidMount` is called, it's guaranteed to run synchronously with render (similary to `useLayoutEffect`).
        // Therefore we don't have to worry about external (observable) state being updated before mount (no state version checking).
        //
        // Things may change: "In the future, React will provide a feature that lets components preserve state between unmounts"
        var admin = $7a4bc3291e712a46$var$getAdministration(this);
        admin.mounted = true;
        // Component instance committed, prevent reaction disposal.
        (0, $27d463009c41dda0$export$10e8a12fbfd8583c).unregister(this);
        // We don't set forceUpdate before mount because it requires a reference to `this`,
        // therefore `this` could NOT be garbage collected before mount,
        // preventing reaction disposal by FinalizationRegistry and leading to memory leak.
        // As an alternative we could have `admin.instanceRef = new WeakRef(this)`, but lets avoid it if possible.
        admin.forceUpdate = function() {
            return _this.forceUpdate();
        };
        if (!admin.reaction || admin.reactionInvalidatedBeforeMount) // Missing reaction:
        // 1. Instance was unmounted (reaction disposed) and immediately remounted without running render #3395.
        // 2. Reaction was disposed by finalization registry before mount. Shouldn't ever happen for class components:
        // `componentDidMount` runs synchronously after render, but our registry are deferred (can't run in between).
        // In any case we lost subscriptions to observables, so we have to create new reaction and re-render to resubscribe.
        // The reaction will be created lazily by following render.
        // Reaction invalidated before mount:
        // 1. A descendant's `componenDidMount` invalidated it's parent #3730
        admin.forceUpdate();
        return originalComponentDidMount == null ? void 0 : originalComponentDidMount.apply(this, arguments);
    };
    // TODO@major Overly complicated "patch" is only needed to support the deprecated @disposeOnUnmount
    $7a4bc3291e712a46$var$patch(prototype, "componentWillUnmount", function() {
        var _admin$reaction;
        if ((0, $c247a499a1aa7eeb$export$55979271896d643e)()) return;
        var admin = $7a4bc3291e712a46$var$getAdministration(this);
        (_admin$reaction = admin.reaction) == null || _admin$reaction.dispose();
        admin.reaction = null;
        admin.forceUpdate = null;
        admin.mounted = false;
        admin.reactionInvalidatedBeforeMount = false;
    });
    return componentClass;
}
// Generates a friendly name for debugging
function $7a4bc3291e712a46$var$getDisplayName(componentClass) {
    return componentClass.displayName || componentClass.name || "<component>";
}
function $7a4bc3291e712a46$var$createReactiveRender(originalRender) {
    var boundOriginalRender = originalRender.bind(this);
    var admin = $7a4bc3291e712a46$var$getAdministration(this);
    function reactiveRender() {
        if (!admin.reaction) {
            // Create reaction lazily to support re-mounting #3395
            admin.reaction = $7a4bc3291e712a46$var$createReaction(admin);
            if (!admin.mounted) // React can abandon this instance and never call `componentDidMount`/`componentWillUnmount`,
            // we have to make sure reaction will be disposed.
            (0, $27d463009c41dda0$export$10e8a12fbfd8583c).register(this, admin, this);
        }
        var error = undefined;
        var renderResult = undefined;
        admin.reaction.track(function() {
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                renderResult = (0, $b0lSM._allowStateChanges)(false, boundOriginalRender);
            } catch (e) {
                error = e;
            }
        });
        if (error) throw error;
        return renderResult;
    }
    return reactiveRender;
}
function $7a4bc3291e712a46$var$createReaction(admin) {
    return new (0, $b0lSM.Reaction)(admin.name + ".render()", function() {
        if (!admin.mounted) {
            // This is neccessary to avoid react warning about calling forceUpdate on component that isn't mounted yet.
            // This happens when component is abandoned after render - our reaction is already created and reacts to changes.
            // `componenDidMount` runs synchronously after `render`, so unlike functional component, there is no delay during which the reaction could be invalidated.
            // However `componentDidMount` runs AFTER it's descendants' `componentDidMount`, which CAN invalidate the reaction, see #3730. Therefore remember and forceUpdate on mount.
            admin.reactionInvalidatedBeforeMount = true;
            return;
        }
        try {
            admin.forceUpdate == null || admin.forceUpdate();
        } catch (error) {
            var _admin$reaction2;
            (_admin$reaction2 = admin.reaction) == null || _admin$reaction2.dispose();
            admin.reaction = null;
        }
    });
}
function $7a4bc3291e712a46$var$observerSCU(nextProps, nextState) {
    if ((0, $c247a499a1aa7eeb$export$55979271896d643e)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
    // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$7a4bc3291e712a46$var$shallowEqual(this.props, nextProps);
}
function $7a4bc3291e712a46$var$createObservablePropDescriptor(key) {
    return {
        configurable: true,
        enumerable: true,
        get: function get() {
            var admin = $7a4bc3291e712a46$var$getAdministration(this);
            var derivation = (0, $b0lSM._getGlobalState)().trackingDerivation;
            if (derivation && derivation !== admin.reaction) throw new Error('[mobx-react] Cannot read "' + admin.name + "." + key + "\" in a reactive context, as it isn't observable.\n                    Please use component lifecycle method to copy the value into a local observable first.\n                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations");
            return admin[key];
        },
        set: function set(value) {
            $7a4bc3291e712a46$var$getAdministration(this)[key] = value;
        }
    };
}
function $7a4bc3291e712a46$export$b6ae1bc530f4c149(component, context) {
    if (context && context.kind !== "class") throw new Error("The @observer decorator can be used on classes only");
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`");
    if (Object.prototype.isPrototypeOf.call((0, $33gHU.Component), component) || Object.prototype.isPrototypeOf.call((0, $33gHU.PureComponent), component)) // Class component
    return $7a4bc3291e712a46$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $620a8c524671f26f$export$b6ae1bc530f4c149)(component);
}
function $7a4bc3291e712a46$var$_extends() {
    $7a4bc3291e712a46$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7a4bc3291e712a46$var$_extends.apply(this, arguments);
}
function $7a4bc3291e712a46$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $7a4bc3291e712a46$var$_excluded = [
    "children"
];
var $7a4bc3291e712a46$export$f07786cea590ef31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createContext({});
function $7a4bc3291e712a46$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $7a4bc3291e712a46$var$_objectWithoutPropertiesLoose(props, $7a4bc3291e712a46$var$_excluded);
    var parentValue = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).useContext($7a4bc3291e712a46$export$f07786cea590ef31);
    var mutableProviderRef = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).useRef($7a4bc3291e712a46$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue;
    return (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement($7a4bc3291e712a46$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$7a4bc3291e712a46$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $7a4bc3291e712a46$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).forwardRef(function(props, ref) {
        var newProps = $7a4bc3291e712a46$var$_extends({}, props);
        var context = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).useContext($7a4bc3291e712a46$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement(component, newProps);
    });
    if (makeReactive) Injector = $7a4bc3291e712a46$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $7a4bc3291e712a46$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $7a4bc3291e712a46$var$getInjectName(component, injectNames);
    return Injector;
}
function $7a4bc3291e712a46$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $7a4bc3291e712a46$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $7a4bc3291e712a46$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $7a4bc3291e712a46$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $7a4bc3291e712a46$var$createStoreInjector($7a4bc3291e712a46$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $7a4bc3291e712a46$var$reactMajorVersion = /*#__PURE__*/ Number.parseInt(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).version.split(".")[0]);
var $7a4bc3291e712a46$var$warnedAboutDisposeOnUnmountDeprecated = false;
var $7a4bc3291e712a46$var$protoStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountProto");
var $7a4bc3291e712a46$var$instStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountInst");
function $7a4bc3291e712a46$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$7a4bc3291e712a46$var$protoStoreKey] || [], this[$7a4bc3291e712a46$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
/**
 * @deprecated `disposeOnUnmount` is not compatible with React 18 and higher.
 */ function $7a4bc3291e712a46$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $7a4bc3291e712a46$export$4e749cb731da87a9(target, fn);
    });
    if (!$7a4bc3291e712a46$var$warnedAboutDisposeOnUnmountDeprecated) {
        if ($7a4bc3291e712a46$var$reactMajorVersion >= 18) console.error("[mobx-react] disposeOnUnmount is not compatible with React 18 and higher. Don't use it.");
        else console.warn("[mobx-react] disposeOnUnmount is deprecated. It won't work correctly with React 18 and higher.");
        $7a4bc3291e712a46$var$warnedAboutDisposeOnUnmountDeprecated = true;
    }
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor);
    // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).Component || c === (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).PureComponent || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).Component || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).PureComponent || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).Component || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
    // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string";
    // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$7a4bc3291e712a46$var$protoStoreKey] || !!target[$7a4bc3291e712a46$var$instStoreKey];
    var store = isDecorator ? // decorators are added to the prototype store
    target[$7a4bc3291e712a46$var$protoStoreKey] || (target[$7a4bc3291e712a46$var$protoStoreKey] = []) : // functions are added to the instance store
    target[$7a4bc3291e712a46$var$instStoreKey] || (target[$7a4bc3291e712a46$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction);
    // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $7a4bc3291e712a46$var$patch(target, "componentWillUnmount", $7a4bc3291e712a46$var$runDisposersOnWillUnmount);
    // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
// Copied from React.PropTypes
function $7a4bc3291e712a46$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $b0lSM.untracked)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false);
    // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
// Copied from React.PropTypes
function $7a4bc3291e712a46$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
}
// Copied from React.PropTypes
function $7a4bc3291e712a46$var$getPropType(propValue) {
    var propType = typeof propValue === "undefined" ? "undefined" : (0, $gnDeW._)(propValue);
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($7a4bc3291e712a46$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
}
// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $7a4bc3291e712a46$var$getPreciseType(propValue) {
    var propType = $7a4bc3291e712a46$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $7a4bc3291e712a46$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $7a4bc3291e712a46$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $b0lSM.untracked)(function() {
            if (allowNativeType) {
                if ($7a4bc3291e712a46$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $b0lSM.isObservableArray);
                    break;
                case "Object":
                    mobxChecker = (0, $b0lSM.isObservableObject);
                    break;
                case "Map":
                    mobxChecker = (0, $b0lSM.isObservableMap);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $7a4bc3291e712a46$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $7a4bc3291e712a46$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $7a4bc3291e712a46$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $b0lSM.untracked)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $7a4bc3291e712a46$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $7a4bc3291e712a46$var$observableArray = /*#__PURE__*/ $7a4bc3291e712a46$var$createObservableTypeCheckerCreator(false, "Array");
var $7a4bc3291e712a46$var$observableArrayOf = /*#__PURE__*/ $7a4bc3291e712a46$var$createObservableArrayOfTypeChecker.bind(null, false);
var $7a4bc3291e712a46$var$observableMap = /*#__PURE__*/ $7a4bc3291e712a46$var$createObservableTypeCheckerCreator(false, "Map");
var $7a4bc3291e712a46$var$observableObject = /*#__PURE__*/ $7a4bc3291e712a46$var$createObservableTypeCheckerCreator(false, "Object");
var $7a4bc3291e712a46$var$arrayOrObservableArray = /*#__PURE__*/ $7a4bc3291e712a46$var$createObservableTypeCheckerCreator(true, "Array");
var $7a4bc3291e712a46$var$arrayOrObservableArrayOf = /*#__PURE__*/ $7a4bc3291e712a46$var$createObservableArrayOfTypeChecker.bind(null, true);
var $7a4bc3291e712a46$var$objectOrObservableObject = /*#__PURE__*/ $7a4bc3291e712a46$var$createObservableTypeCheckerCreator(true, "Object");
var $7a4bc3291e712a46$export$e0c95a451cd220b7 = {
    observableArray: $7a4bc3291e712a46$var$observableArray,
    observableArrayOf: $7a4bc3291e712a46$var$observableArrayOf,
    observableMap: $7a4bc3291e712a46$var$observableMap,
    observableObject: $7a4bc3291e712a46$var$observableObject,
    arrayOrObservableArray: $7a4bc3291e712a46$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $7a4bc3291e712a46$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $7a4bc3291e712a46$var$objectOrObservableObject
};
if (!(0, $33gHU.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $b0lSM.observable)) throw new Error("mobx-react requires mobx to be available");


var $6d337e2d15ce5cf7$export$89da14300d534261;
var $6d337e2d15ce5cf7$export$8ce1fd94bee2f412;
var $6d337e2d15ce5cf7$export$f4c5de44377d2946;
$6d337e2d15ce5cf7$export$89da14300d534261 = "_8VIGna_active";
$6d337e2d15ce5cf7$export$8ce1fd94bee2f412 = "_8VIGna_background";
$6d337e2d15ce5cf7$export$f4c5de44377d2946 = "_8VIGna_loader";



var $17dcf6d70f0acee2$export$a530fe7a272dd531 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var assets = (0, $3a3345637c0a5d6f$export$bd973f06e9aaec8c)();
    var shouldBlock = (0, $3a3345637c0a5d6f$export$33ffd74ebf07f060)().shouldBlockUI;
    var loaderSvg = assets.docIcons["loading"];
    var isActive = shouldBlock ? $6d337e2d15ce5cf7$export$89da14300d534261 : "";
    return (0, $978b871a0234f592$exports.jsx)("div", {
        className: $6d337e2d15ce5cf7$export$8ce1fd94bee2f412 + " " + isActive,
        children: (0, $978b871a0234f592$exports.jsx)("div", {
            className: "d-flex justify-content-center",
            children: (0, $978b871a0234f592$exports.jsxs)("svg", {
                className: $6d337e2d15ce5cf7$export$f4c5de44377d2946,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 200 200",
                width: 200,
                height: 200,
                children: [
                    (0, $978b871a0234f592$exports.jsx)("rect", {
                        fill: "#0D6EFD",
                        stroke: "#0D6EFD",
                        "stroke-width": "15",
                        width: "30",
                        height: "30",
                        x: "25",
                        y: "50",
                        children: (0, $978b871a0234f592$exports.jsx)("animate", {
                            attributeName: "y",
                            calcMode: "spline",
                            dur: "2",
                            values: "50;120;50;",
                            keySplines: ".5 0 .5 1;.5 0 .5 1",
                            repeatCount: "indefinite",
                            begin: "-.4"
                        })
                    }),
                    (0, $978b871a0234f592$exports.jsx)("rect", {
                        fill: "#0D6EFD",
                        stroke: "#0D6EFD",
                        "stroke-width": "15",
                        width: "30",
                        height: "30",
                        x: "85",
                        y: "50",
                        children: (0, $978b871a0234f592$exports.jsx)("animate", {
                            attributeName: "y",
                            calcMode: "spline",
                            dur: "2",
                            values: "50;120;50;",
                            keySplines: ".5 0 .5 1;.5 0 .5 1",
                            repeatCount: "indefinite",
                            begin: "-.2"
                        })
                    }),
                    (0, $978b871a0234f592$exports.jsx)("rect", {
                        fill: "#0D6EFD",
                        stroke: "#0D6EFD",
                        "stroke-width": "15",
                        width: "30",
                        height: "30",
                        x: "145",
                        y: "50",
                        children: (0, $978b871a0234f592$exports.jsx)("animate", {
                            attributeName: "y",
                            calcMode: "spline",
                            dur: "2",
                            values: "50;120;50;",
                            keySplines: ".5 0 .5 1;.5 0 .5 1",
                            repeatCount: "indefinite",
                            begin: "0"
                        })
                    })
                ]
            })
        })
    });
});






var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");
var $8bd163097a5514bf$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $8bd163097a5514bf$exports) {
        classNames.default = classNames;
        $8bd163097a5514bf$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $33gHU = parcelRequire("33gHU");

var $33gHU = parcelRequire("33gHU");
function $f76f1451b40a5807$export$2e2bcd8739ae039() {
    var mounted = (0, $33gHU.useRef)(true);
    var isMounted = (0, $33gHU.useRef)(function() {
        return mounted.current;
    });
    (0, $33gHU.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $33gHU = parcelRequire("33gHU");
function $51b5a22e0c0b3b7f$export$2e2bcd8739ae039(value) {
    var valueRef = (0, $33gHU.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $33gHU = parcelRequire("33gHU");
function $2ef4591ec3517cf9$export$2e2bcd8739ae039(fn) {
    var onUnmount = (0, $51b5a22e0c0b3b7f$export$2e2bcd8739ae039)(fn);
    (0, $33gHU.useEffect)(function() {
        return function() {
            return onUnmount.current();
        };
    }, []);
}


/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ var $8f9322bbd294b8af$var$MAX_DELAY_MS = Math.pow(2, 31) - 1;
function $8f9322bbd294b8af$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    var delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $8f9322bbd294b8af$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(function() {
        return $8f9322bbd294b8af$var$setChainedTimeout(handleRef, fn, timeoutAtMs);
    }, $8f9322bbd294b8af$var$MAX_DELAY_MS);
}
function $8f9322bbd294b8af$export$2e2bcd8739ae039() {
    var isMounted = (0, $f76f1451b40a5807$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    var handleRef = (0, $33gHU.useRef)();
    (0, $2ef4591ec3517cf9$export$2e2bcd8739ae039)(function() {
        return clearTimeout(handleRef.current);
    });
    return (0, $33gHU.useMemo)(function() {
        var clear = function() {
            return clearTimeout(handleRef.current);
        };
        function set(fn) {
            var delayMs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            if (!isMounted()) return;
            clear();
            if (delayMs <= $8f9322bbd294b8af$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $8f9322bbd294b8af$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}



var $c5rwh = parcelRequire("c5rwh");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $33gHU = parcelRequire("33gHU");
function $ec72bb6bbc83bb88$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}


function $d96685ee7293921b$export$2e2bcd8739ae039(t, e) {
    return $d96685ee7293921b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, $d96685ee7293921b$export$2e2bcd8739ae039(t, e);
}


function $f68b40d769d616a2$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $d96685ee7293921b$export$2e2bcd8739ae039)(t, o);
}




var $33gHU = parcelRequire("33gHU");

var $1f88d36eb36b239c$export$2e2bcd8739ae039 = {
    disabled: false
};




var $33gHU = parcelRequire("33gHU");
var $cb715cf810df509d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createContext(null);


var $12935dbc1b577d20$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $5a41f7eb3d8f2f2d$export$bb38bb9a1161268 = "unmounted";
var $5a41f7eb3d8f2f2d$export$84cbff306f539230 = "exited";
var $5a41f7eb3d8f2f2d$export$df38205c966be359 = "entering";
var $5a41f7eb3d8f2f2d$export$78e9e6e3e014d60a = "entered";
var $5a41f7eb3d8f2f2d$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $5a41f7eb3d8f2f2d$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $f68b40d769d616a2$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $5a41f7eb3d8f2f2d$export$84cbff306f539230;
                _this.appearStatus = $5a41f7eb3d8f2f2d$export$df38205c966be359;
            } else initialStatus = $5a41f7eb3d8f2f2d$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $5a41f7eb3d8f2f2d$export$bb38bb9a1161268;
        else initialStatus = $5a41f7eb3d8f2f2d$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $5a41f7eb3d8f2f2d$export$bb38bb9a1161268) return {
            status: $5a41f7eb3d8f2f2d$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $5a41f7eb3d8f2f2d$export$df38205c966be359 && status !== $5a41f7eb3d8f2f2d$export$78e9e6e3e014d60a) nextStatus = $5a41f7eb3d8f2f2d$export$df38205c966be359;
            } else if (status === $5a41f7eb3d8f2f2d$export$df38205c966be359 || status === $5a41f7eb3d8f2f2d$export$78e9e6e3e014d60a) nextStatus = $5a41f7eb3d8f2f2d$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $5a41f7eb3d8f2f2d$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($e1a300cc66774841$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $12935dbc1b577d20$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $5a41f7eb3d8f2f2d$export$84cbff306f539230) this.setState({
            status: $5a41f7eb3d8f2f2d$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($e1a300cc66774841$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $1f88d36eb36b239c$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $5a41f7eb3d8f2f2d$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $5a41f7eb3d8f2f2d$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $5a41f7eb3d8f2f2d$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($e1a300cc66774841$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $1f88d36eb36b239c$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $5a41f7eb3d8f2f2d$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $5a41f7eb3d8f2f2d$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $5a41f7eb3d8f2f2d$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($e1a300cc66774841$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $5a41f7eb3d8f2f2d$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $ec72bb6bbc83bb88$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement((0, $cb715cf810df509d$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).Component);
$5a41f7eb3d8f2f2d$var$Transition.contextType = (0, $cb715cf810df509d$export$2e2bcd8739ae039);
$5a41f7eb3d8f2f2d$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $5a41f7eb3d8f2f2d$var$noop() {}
$5a41f7eb3d8f2f2d$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $5a41f7eb3d8f2f2d$var$noop,
    onEntering: $5a41f7eb3d8f2f2d$var$noop,
    onEntered: $5a41f7eb3d8f2f2d$var$noop,
    onExit: $5a41f7eb3d8f2f2d$var$noop,
    onExiting: $5a41f7eb3d8f2f2d$var$noop,
    onExited: $5a41f7eb3d8f2f2d$var$noop
};
$5a41f7eb3d8f2f2d$var$Transition.UNMOUNTED = $5a41f7eb3d8f2f2d$export$bb38bb9a1161268;
$5a41f7eb3d8f2f2d$var$Transition.EXITED = $5a41f7eb3d8f2f2d$export$84cbff306f539230;
$5a41f7eb3d8f2f2d$var$Transition.ENTERING = $5a41f7eb3d8f2f2d$export$df38205c966be359;
$5a41f7eb3d8f2f2d$var$Transition.ENTERED = $5a41f7eb3d8f2f2d$export$78e9e6e3e014d60a;
$5a41f7eb3d8f2f2d$var$Transition.EXITING = $5a41f7eb3d8f2f2d$export$4aacc83d4d59139f;
var $5a41f7eb3d8f2f2d$export$2e2bcd8739ae039 = $5a41f7eb3d8f2f2d$var$Transition;



var $c5rwh = parcelRequire("c5rwh");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");

/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $cb03b130654deaba$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $a9aa5d166d13a472$export$2e2bcd8739ae039(node) {
    var doc = (0, $cb03b130654deaba$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $bb63774a12698c7f$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $a9aa5d166d13a472$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $f8efbd1b1d8a9be0$var$rUpper = /([A-Z])/g;
function $f8efbd1b1d8a9be0$export$2e2bcd8739ae039(string) {
    return string.replace($f8efbd1b1d8a9be0$var$rUpper, "-$1").toLowerCase();
}


var $f10058893718c5ed$var$msPattern = /^ms-/;
function $f10058893718c5ed$export$2e2bcd8739ae039(string) {
    return (0, $f8efbd1b1d8a9be0$export$2e2bcd8739ae039)(string).replace($f10058893718c5ed$var$msPattern, "-ms-");
}


var $edfb6b9719fedecb$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $edfb6b9719fedecb$export$2e2bcd8739ae039(value) {
    return !!(value && $edfb6b9719fedecb$var$supportedTransforms.test(value));
}


function $2743bc2e9a1bad0a$var$style(node, property) {
    var css = "";
    var transforms = "";
    if (typeof property === "string") return node.style.getPropertyValue((0, $f10058893718c5ed$export$2e2bcd8739ae039)(property)) || (0, $bb63774a12698c7f$export$2e2bcd8739ae039)(node).getPropertyValue((0, $f10058893718c5ed$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $f10058893718c5ed$export$2e2bcd8739ae039)(key));
        else if ((0, $edfb6b9719fedecb$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $f10058893718c5ed$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $2743bc2e9a1bad0a$export$2e2bcd8739ae039 = $2743bc2e9a1bad0a$var$style;



/* eslint-disable no-return-assign */ var $64f258eaaf92e603$export$2e2bcd8739ae039 = !!(typeof window !== "undefined" && window.document && window.document.createElement);


var $fe9809a8616a080a$export$63fefd044b2bc624 = false;
var $fe9809a8616a080a$export$a614c6b395900f69 = false;
try {
    var $fe9809a8616a080a$var$options = {
        get passive () {
            return $fe9809a8616a080a$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $fe9809a8616a080a$export$a614c6b395900f69 = $fe9809a8616a080a$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $64f258eaaf92e603$export$2e2bcd8739ae039) {
        window.addEventListener("test", $fe9809a8616a080a$var$options, $fe9809a8616a080a$var$options);
        window.removeEventListener("test", $fe9809a8616a080a$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $fe9809a8616a080a$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== "boolean" && !$fe9809a8616a080a$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$fe9809a8616a080a$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $fe9809a8616a080a$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $fe9809a8616a080a$export$2e2bcd8739ae039 = $fe9809a8616a080a$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $0e5e4de4085acd94$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== "boolean" ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $0e5e4de4085acd94$export$2e2bcd8739ae039 = $0e5e4de4085acd94$var$removeEventListener;


function $709dbe0f51f464e8$var$listen(node, eventName, handler, options) {
    (0, $fe9809a8616a080a$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $0e5e4de4085acd94$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $709dbe0f51f464e8$export$2e2bcd8739ae039 = $709dbe0f51f464e8$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $34f3e4134ad86d5e$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $eb2ed0bd2d792c29$var$parseDuration(node) {
    var str = (0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(node, "transitionDuration") || "";
    var mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $eb2ed0bd2d792c29$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $34f3e4134ad86d5e$export$2e2bcd8739ae039)(element, "transitionend", true);
    }, duration + padding);
    var remove = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(element, "transitionend", function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $eb2ed0bd2d792c29$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $eb2ed0bd2d792c29$var$parseDuration(element) || 0;
    var removeEmulate = $eb2ed0bd2d792c29$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(element, "transitionend", handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $46926e63412c3268$var$parseDuration(node, property) {
    var str = (0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(node, property) || "";
    var mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $46926e63412c3268$export$2e2bcd8739ae039(element, handler) {
    var duration = $46926e63412c3268$var$parseDuration(element, "transitionDuration");
    var delay = $46926e63412c3268$var$parseDuration(element, "transitionDelay");
    var remove = (0, $eb2ed0bd2d792c29$export$2e2bcd8739ae039)(element, function(e) {
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $822988304e59689d$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");


var $33gHU = parcelRequire("33gHU");
var $0bc64fd3b15ed530$var$toFnRef = function(ref) {
    return !ref || typeof ref === "function" ? ref : function(value) {
        ref.current = value;
    };
};
function $0bc64fd3b15ed530$export$c9058316764c140e(refA, refB) {
    var a = $0bc64fd3b15ed530$var$toFnRef(refA);
    var b = $0bc64fd3b15ed530$var$toFnRef(refB);
    return function(value) {
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $0bc64fd3b15ed530$var$useMergedRefs(refA, refB) {
    return (0, $33gHU.useMemo)(function() {
        return $0bc64fd3b15ed530$export$c9058316764c140e(refA, refB);
    }, [
        refA,
        refB
    ]);
}
var $0bc64fd3b15ed530$export$2e2bcd8739ae039 = $0bc64fd3b15ed530$var$useMergedRefs;



function $ef11d43252afadf5$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && "setState" in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($e1a300cc66774841$exports))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
var $7848a75987c84ec4$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).forwardRef(function(_param, ref) {
    var onEnter = _param.onEnter, onEntering = _param.onEntering, onEntered = _param.onEntered, onExit = _param.onExit, onExiting = _param.onExiting, onExited = _param.onExited, addEndListener = _param.addEndListener, children = _param.children, childRef = _param.childRef, props = (0, $6JqHh._)(_param, [
        "onEnter",
        "onEntering",
        "onEntered",
        "onExit",
        "onExiting",
        "onExited",
        "addEndListener",
        "children",
        "childRef"
    ]);
    var nodeRef = (0, $33gHU.useRef)(null);
    var mergedRef = (0, $0bc64fd3b15ed530$export$2e2bcd8739ae039)(nodeRef, childRef);
    var attachRef = function(r) {
        mergedRef((0, $ef11d43252afadf5$export$2e2bcd8739ae039)(r));
    };
    var normalize = function(callback) {
        return function(param) {
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    };
    /* eslint-disable react-hooks/exhaustive-deps */ var handleEnter = (0, $33gHU.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    var handleEntering = (0, $33gHU.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    var handleEntered = (0, $33gHU.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    var handleExit = (0, $33gHU.useCallback)(normalize(onExit), [
        onExit
    ]);
    var handleExiting = (0, $33gHU.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    var handleExited = (0, $33gHU.useCallback)(normalize(onExited), [
        onExited
    ]);
    var handleAddEndListener = (0, $33gHU.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $5a41f7eb3d8f2f2d$export$2e2bcd8739ae039), (0, $ddevm._)((0, $78DQ7._)({
        ref: ref
    }, props), {
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === "function" ? function(status, innerProps) {
            return(// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, (0, $ddevm._)((0, $78DQ7._)({}, innerProps), {
                ref: attachRef
            })));
        } : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).cloneElement(children, {
            ref: attachRef
        })
    }));
});
var $7848a75987c84ec4$export$2e2bcd8739ae039 = $7848a75987c84ec4$var$TransitionWrapper;



var $7639cffc50f5d209$var$_obj;
var $7639cffc50f5d209$var$fadeStyles = ($7639cffc50f5d209$var$_obj = {}, (0, $c5rwh._)($7639cffc50f5d209$var$_obj, (0, $5a41f7eb3d8f2f2d$export$df38205c966be359), "show"), (0, $c5rwh._)($7639cffc50f5d209$var$_obj, (0, $5a41f7eb3d8f2f2d$export$78e9e6e3e014d60a), "show"), $7639cffc50f5d209$var$_obj);
var $7639cffc50f5d209$var$Fade = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, children = _param.children, _param_transitionClasses = _param.transitionClasses, transitionClasses = _param_transitionClasses === void 0 ? {} : _param_transitionClasses, onEnter = _param.onEnter, rest = (0, $6JqHh._)(_param, [
        "className",
        "children",
        "transitionClasses",
        "onEnter"
    ]);
    var props = (0, $78DQ7._)({
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false
    }, rest);
    var handleEnter = (0, $33gHU.useCallback)(function(node, isAppearing) {
        (0, $822988304e59689d$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $7848a75987c84ec4$export$2e2bcd8739ae039), (0, $ddevm._)((0, $78DQ7._)({
        ref: ref,
        addEndListener: (0, $46926e63412c3268$export$2e2bcd8739ae039)
    }, props), {
        onEnter: handleEnter,
        childRef: children.ref,
        children: function(status, innerProps) {
            return /*#__PURE__*/ $33gHU.cloneElement(children, (0, $ddevm._)((0, $78DQ7._)({}, innerProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("fade", className, children.props.className, $7639cffc50f5d209$var$fadeStyles[status], transitionClasses[status])
            }));
        }
    }));
});
$7639cffc50f5d209$var$Fade.displayName = "Fade";
var $7639cffc50f5d209$export$2e2bcd8739ae039 = $7639cffc50f5d209$var$Fade;



var $11ed18420f3e02db$var$_obj;
var $11ed18420f3e02db$var$fadeStyles = ($11ed18420f3e02db$var$_obj = {}, (0, $c5rwh._)($11ed18420f3e02db$var$_obj, (0, $5a41f7eb3d8f2f2d$export$df38205c966be359), "showing"), (0, $c5rwh._)($11ed18420f3e02db$var$_obj, (0, $5a41f7eb3d8f2f2d$export$4aacc83d4d59139f), "showing show"), $11ed18420f3e02db$var$_obj);
var $11ed18420f3e02db$var$ToastFade = /*#__PURE__*/ $33gHU.forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $7639cffc50f5d209$export$2e2bcd8739ae039), (0, $ddevm._)((0, $78DQ7._)({}, props), {
        ref: ref,
        transitionClasses: $11ed18420f3e02db$var$fadeStyles
    }));
});
$11ed18420f3e02db$var$ToastFade.displayName = "ToastFade";
var $11ed18420f3e02db$export$2e2bcd8739ae039 = $11ed18420f3e02db$var$ToastFade;



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");

var $3jzhD = parcelRequire("3jzhD");

var $33gHU = parcelRequire("33gHU");

var $33gHU = parcelRequire("33gHU");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $671c1bffa4e831fb$var$useCommittedRef(value) {
    var ref = (0, $33gHU.useRef)(value);
    (0, $33gHU.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $671c1bffa4e831fb$export$2e2bcd8739ae039 = $671c1bffa4e831fb$var$useCommittedRef;


function $2a722d1c3948cf16$export$2e2bcd8739ae039(fn) {
    var ref = (0, $671c1bffa4e831fb$export$2e2bcd8739ae039)(fn);
    return (0, $33gHU.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _ref;
        return ref.current && (_ref = ref).current.apply(_ref, (0, $3jzhD._)(args));
    }, [
        ref
    ]);
}


function $9615da530229f8e1$export$c90d7ca213038c72() {
    $9615da530229f8e1$export$c90d7ca213038c72 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9615da530229f8e1$export$c90d7ca213038c72.apply(this, arguments);
}


function $0e630e4541c5d3f6$export$cffab43ebdf6037(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $33gHU = parcelRequire("33gHU");

"use client";
var $48ea4dae63926a21$export$666ad80b5007f835 = [
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
var $48ea4dae63926a21$export$ff817e17bad2e091 = "xs";
var $48ea4dae63926a21$var$ThemeContext = /*#__PURE__*/ $33gHU.createContext({
    prefixes: {},
    breakpoints: $48ea4dae63926a21$export$666ad80b5007f835,
    minBreakpoint: $48ea4dae63926a21$export$ff817e17bad2e091
});
var $48ea4dae63926a21$export$b631efc24e9d5e2f = $48ea4dae63926a21$var$ThemeContext.Consumer, $48ea4dae63926a21$var$Provider = $48ea4dae63926a21$var$ThemeContext.Provider;
function $48ea4dae63926a21$var$ThemeProvider(param) {
    var _param_prefixes = param.prefixes, prefixes = _param_prefixes === void 0 ? {} : _param_prefixes, _param_breakpoints = param.breakpoints, breakpoints = _param_breakpoints === void 0 ? $48ea4dae63926a21$export$666ad80b5007f835 : _param_breakpoints, _param_minBreakpoint = param.minBreakpoint, minBreakpoint = _param_minBreakpoint === void 0 ? $48ea4dae63926a21$export$ff817e17bad2e091 : _param_minBreakpoint, dir = param.dir, children = param.children;
    var contextValue = (0, $33gHU.useMemo)(function() {
        return {
            prefixes: (0, $78DQ7._)({}, prefixes),
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        };
    }, [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)($48ea4dae63926a21$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $48ea4dae63926a21$export$7f387860ebffb32c(prefix, defaultPrefix) {
    var prefixes = (0, $33gHU.useContext)($48ea4dae63926a21$var$ThemeContext).prefixes;
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $48ea4dae63926a21$export$8970c8db816a5863() {
    var breakpoints = (0, $33gHU.useContext)($48ea4dae63926a21$var$ThemeContext).breakpoints;
    return breakpoints;
}
function $48ea4dae63926a21$export$d926d6ef38f3fd32() {
    var minBreakpoint = (0, $33gHU.useContext)($48ea4dae63926a21$var$ThemeContext).minBreakpoint;
    return minBreakpoint;
}
function $48ea4dae63926a21$export$35e511eefa30ac5a() {
    var dir = (0, $33gHU.useContext)($48ea4dae63926a21$var$ThemeContext).dir;
    return dir === "rtl";
}
function $48ea4dae63926a21$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === "string") opts = {
        prefix: opts
    };
    var isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    var prefix = opts.prefix, _opts_forwardRefAs = opts.forwardRefAs, forwardRefAs = _opts_forwardRefAs === void 0 ? isClassy ? "ref" : "innerRef" : _opts_forwardRefAs;
    var Wrapped = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
        var props = (0, $9615da530229f8e1$export$c90d7ca213038c72)({}, (0, $0e630e4541c5d3f6$export$cffab43ebdf6037)(_param));
        props[forwardRefAs] = ref;
        var bsPrefix = $48ea4dae63926a21$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({}, props), {
            bsPrefix: bsPrefix
        }));
    });
    Wrapped.displayName = "Bootstrap(".concat(Component.displayName || Component.name, ")");
    return Wrapped;
}
var $48ea4dae63926a21$export$2e2bcd8739ae039 = $48ea4dae63926a21$var$ThemeProvider;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");
var $dbf9032451b6d05a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dbf9032451b6d05a$var$ReactIs, $dbf9032451b6d05a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$dbf9032451b6d05a$exports = (parcelRequire("dNvVv"))();



var $33gHU = parcelRequire("33gHU");


var $b3e1e0a6648925c0$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).oneOf([
        "white"
    ])
};
var $b3e1e0a6648925c0$var$CloseButton = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, variant = _param.variant, tmp = _param["aria-label"], ariaLabel = tmp === void 0 ? "Close" : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "variant",
        "aria-label"
    ]);
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("button", (0, $78DQ7._)({
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("btn-close", variant && "btn-close-".concat(variant), className),
        "aria-label": ariaLabel
    }, props));
});
$b3e1e0a6648925c0$var$CloseButton.displayName = "CloseButton";
$b3e1e0a6648925c0$var$CloseButton.propTypes = $b3e1e0a6648925c0$var$propTypes;
var $b3e1e0a6648925c0$export$2e2bcd8739ae039 = $b3e1e0a6648925c0$var$CloseButton;



var $33gHU = parcelRequire("33gHU");
"use client";
var $524d70ff7daadcad$var$ToastContext = /*#__PURE__*/ $33gHU.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: function() {}
});
var $524d70ff7daadcad$export$2e2bcd8739ae039 = $524d70ff7daadcad$var$ToastContext;



"use client";
var $5fe1be09c7f6092d$var$ToastHeader = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, _param_closeLabel = _param.closeLabel, closeLabel = _param_closeLabel === void 0 ? "Close" : _param_closeLabel, closeVariant = _param.closeVariant, _param_closeButton = _param.closeButton, closeButton = _param_closeButton === void 0 ? true : _param_closeButton, className = _param.className, children = _param.children, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "closeLabel",
        "closeVariant",
        "closeButton",
        "className",
        "children"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "toast-header");
    var context = (0, $33gHU.useContext)((0, $524d70ff7daadcad$export$2e2bcd8739ae039));
    var handleClick = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function(e) {
        context == null || context.onClose == null || context.onClose(e);
    });
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", (0, $ddevm._)((0, $78DQ7._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(bsPrefix, className),
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $b3e1e0a6648925c0$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick,
                "data-dismiss": "toast"
            })
        ]
    }));
});
$5fe1be09c7f6092d$var$ToastHeader.displayName = "ToastHeader";
var $5fe1be09c7f6092d$export$2e2bcd8739ae039 = $5fe1be09c7f6092d$var$ToastHeader;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");



"use client";
var $162643391997db63$var$ToastBody = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? "div" : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "toast-body");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$162643391997db63$var$ToastBody.displayName = "ToastBody";
var $162643391997db63$export$2e2bcd8739ae039 = $162643391997db63$var$ToastBody;





"use client";
var $ed95db87e3f53361$var$Toast = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, tmp = _param.transition, Transition = tmp === void 0 ? (0, $11ed18420f3e02db$export$2e2bcd8739ae039) : tmp, _param_show = _param.show, show = _param_show === void 0 ? true : _param_show, _param_animation = _param.animation, animation = _param_animation === void 0 ? true : _param_animation, _param_delay = _param.delay, delay = _param_delay === void 0 ? 5000 : _param_delay, _param_autohide = _param.autohide, autohide = _param_autohide === void 0 ? false : _param_autohide, onClose = _param.onClose, onEntered = _param.onEntered, onExit = _param.onExit, onExiting = _param.onExiting, onEnter = _param.onEnter, onEntering = _param.onEntering, onExited = _param.onExited, bg = _param.bg, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "transition",
        "show",
        "animation",
        "delay",
        "autohide",
        "onClose",
        "onEntered",
        "onExit",
        "onExiting",
        "onEnter",
        "onEntering",
        "onExited",
        "bg"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "toast");
    // We use refs for these, because we don't want to restart the autohide
    // timer in case these values change.
    var delayRef = (0, $33gHU.useRef)(delay);
    var onCloseRef = (0, $33gHU.useRef)(onClose);
    (0, $33gHU.useEffect)(function() {
        delayRef.current = delay;
        onCloseRef.current = onClose;
    }, [
        delay,
        onClose
    ]);
    var autohideTimeout = (0, $8f9322bbd294b8af$export$2e2bcd8739ae039)();
    var autohideToast = !!(autohide && show);
    var autohideFunc = (0, $33gHU.useCallback)(function() {
        if (autohideToast) onCloseRef.current == null || onCloseRef.current();
    }, [
        autohideToast
    ]);
    (0, $33gHU.useEffect)(function() {
        // Only reset timer if show or autohide changes.
        autohideTimeout.set(autohideFunc, delayRef.current);
    }, [
        autohideTimeout,
        autohideFunc
    ]);
    var toastContext = (0, $33gHU.useMemo)(function() {
        return {
            onClose: onClose
        };
    }, [
        onClose
    ]);
    var hasAnimation = !!(Transition && animation);
    var toast = /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", (0, $ddevm._)((0, $78DQ7._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(bsPrefix, className, bg && "bg-".concat(bg), !hasAnimation && (show ? "show" : "hide")),
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
    }));
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $524d70ff7daadcad$export$2e2bcd8739ae039).Provider, {
        value: toastContext,
        children: hasAnimation && Transition ? /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Transition, {
            in: show,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited,
            unmountOnExit: true,
            children: toast
        }) : toast
    });
});
$ed95db87e3f53361$var$Toast.displayName = "Toast";
var $ed95db87e3f53361$export$2e2bcd8739ae039 = Object.assign($ed95db87e3f53361$var$Toast, {
    Body: (0, $162643391997db63$export$2e2bcd8739ae039),
    Header: (0, $5fe1be09c7f6092d$export$2e2bcd8739ae039)
});


var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");


"use client";
var $5722ea97d726b10a$var$positionClasses = {
    "top-start": "top-0 start-0",
    "top-center": "top-0 start-50 translate-middle-x",
    "top-end": "top-0 end-0",
    "middle-start": "top-50 start-0 translate-middle-y",
    "middle-center": "top-50 start-50 translate-middle",
    "middle-end": "top-50 end-0 translate-middle-y",
    "bottom-start": "bottom-0 start-0",
    "bottom-center": "bottom-0 start-50 translate-middle-x",
    "bottom-end": "bottom-0 end-0"
};
var $5722ea97d726b10a$var$ToastContainer = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, position = _param.position, containerPosition = _param.containerPosition, className = _param.className, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "div" : tmp, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "position",
        "containerPosition",
        "className",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "toast-container");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(bsPrefix, position && $5722ea97d726b10a$var$positionClasses[position], containerPosition && "position-".concat(containerPosition), className)
    }));
});
$5722ea97d726b10a$var$ToastContainer.displayName = "ToastContainer";
var $5722ea97d726b10a$export$2e2bcd8739ae039 = $5722ea97d726b10a$var$ToastContainer;


var $620eb7bcbc122a7c$export$fb98e3a2a4cd92d7 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var toasterStore = (0, $3a3345637c0a5d6f$export$f46171b59bb094f9)();
    return (0, $978b871a0234f592$exports.jsx)((0, $5722ea97d726b10a$export$2e2bcd8739ae039), {
        className: "p-3",
        position: "bottom-start",
        style: {
            zIndex: 1
        },
        children: toasterStore.messages.map(function(m, i) {
            return (0, $978b871a0234f592$exports.jsx)((0, $ed95db87e3f53361$export$2e2bcd8739ae039), {
                children: (0, $978b871a0234f592$exports.jsx)((0, $ed95db87e3f53361$export$2e2bcd8739ae039).Body, {
                    children: m.message
                })
            }, m.message);
        })
    });
});





var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $2MTYX = parcelRequire("2MTYX");


var $33gHU = parcelRequire("33gHU");

var $2MTYX = parcelRequire("2MTYX");

var $33gHU = parcelRequire("33gHU");

var $9c3ffb28ddbab696$var$_excluded = [
    "as",
    "disabled"
];
function $9c3ffb28ddbab696$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9c3ffb28ddbab696$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
function $9c3ffb28ddbab696$export$a0ee72f2c720a5c3(param) {
    var tagName = param.tagName, disabled = param.disabled, href = param.href, target = param.target, rel = param.rel, role = param.role, onClick = param.onClick, _param_tabIndex = param.tabIndex, tabIndex = _param_tabIndex === void 0 ? 0 : _param_tabIndex, type = param.type;
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = "a";
        else tagName = "button";
    }
    var meta = {
        tagName: tagName
    };
    if (tagName === "button") return [
        {
            type: type || "button",
            disabled: disabled
        },
        meta
    ];
    var handleClick = function(event) {
        if (disabled || tagName === "a" && $9c3ffb28ddbab696$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    var handleKeyDown = function(event) {
        if (event.key === " ") {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === "a") {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = "#");
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : "button",
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === "a" ? target : undefined,
            "aria-disabled": !disabled ? undefined : disabled,
            rel: tagName === "a" ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
var $9c3ffb28ddbab696$var$Button = /*#__PURE__*/ $33gHU.forwardRef(function(_ref, ref) {
    var asProp = _ref.as, disabled = _ref.disabled, props = $9c3ffb28ddbab696$var$_objectWithoutPropertiesLoose(_ref, $9c3ffb28ddbab696$var$_excluded);
    var _useButtonProps = (0, $2MTYX._)($9c3ffb28ddbab696$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props)), 2), buttonProps = _useButtonProps[0], _useButtonProps_ = _useButtonProps[1], Component = _useButtonProps_.tagName;
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$9c3ffb28ddbab696$var$Button.displayName = "Button";
var $9c3ffb28ddbab696$export$2e2bcd8739ae039 = $9c3ffb28ddbab696$var$Button;




"use client";
var $91cc833ad6e8123a$var$Button = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var as = _param.as, bsPrefix = _param.bsPrefix, _param_variant = _param.variant, variant = _param_variant === void 0 ? "primary" : _param_variant, size = _param.size, _param_active = _param.active, active = _param_active === void 0 ? false : _param_active, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, className = _param.className, props = (0, $6JqHh._)(_param, [
        "as",
        "bsPrefix",
        "variant",
        "size",
        "active",
        "disabled",
        "className"
    ]);
    var prefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "btn");
    var _useButtonProps = (0, $2MTYX._)((0, $9c3ffb28ddbab696$export$a0ee72f2c720a5c3)((0, $78DQ7._)({
        tagName: as,
        disabled: disabled
    }, props)), 2), buttonProps = _useButtonProps[0], tagName = _useButtonProps[1].tagName;
    var Component = tagName;
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({}, buttonProps, props), {
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix, active && "active", variant && "".concat(prefix, "-").concat(variant), size && "".concat(prefix, "-").concat(size), props.href && disabled && "disabled")
    }));
});
$91cc833ad6e8123a$var$Button.displayName = "Button";
var $91cc833ad6e8123a$export$2e2bcd8739ae039 = $91cc833ad6e8123a$var$Button;



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $2MTYX = parcelRequire("2MTYX");






var $1a02a97bdd063b41$var$size;
function $1a02a97bdd063b41$export$2e2bcd8739ae039(recalc) {
    if (!$1a02a97bdd063b41$var$size && $1a02a97bdd063b41$var$size !== 0 || recalc) {
        if (0, $64f258eaaf92e603$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement("div");
            scrollDiv.style.position = "absolute";
            scrollDiv.style.top = "-9999px";
            scrollDiv.style.width = "50px";
            scrollDiv.style.height = "50px";
            scrollDiv.style.overflow = "scroll";
            document.body.appendChild(scrollDiv);
            $1a02a97bdd063b41$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $1a02a97bdd063b41$var$size;
}



var $33gHU = parcelRequire("33gHU");
function $04457dad5314d7c2$export$2e2bcd8739ae039() {
    return (0, $33gHU.useState)(null);
}







var $33gHU = parcelRequire("33gHU");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

function $607d6e14baa19d0a$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $cb03b130654deaba$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $a784322fcbc350d7$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $33gHU = parcelRequire("33gHU");




var $33gHU = parcelRequire("33gHU");
function $7e4ad4faf3b19879$export$2e2bcd8739ae039(value) {
    var ref = (0, $33gHU.useRef)(null);
    (0, $33gHU.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}




var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $c5rwh = parcelRequire("c5rwh");

var $3jzhD = parcelRequire("3jzhD");

var $162a9cd685a6cce4$export$fd7bcb7e9bef4e8a = "data-rr-ui-";
var $162a9cd685a6cce4$export$635202801f9383a0 = "rrUi";
function $162a9cd685a6cce4$export$5cc3b7b83e34ade7(property) {
    return "".concat($162a9cd685a6cce4$export$fd7bcb7e9bef4e8a).concat(property);
}
function $162a9cd685a6cce4$export$7776c0a7cd2eb3e0(property) {
    return "".concat($162a9cd685a6cce4$export$635202801f9383a0).concat(property);
}


/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $71ecc889acf8d27e$export$2e2bcd8739ae039() {
    var ownerDocument = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    var window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


var $6f204bcdfda032e4$export$1a88c12b8b979fa0 = (0, $162a9cd685a6cce4$export$5cc3b7b83e34ade7)("modal-open");
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ var $6f204bcdfda032e4$var$ModalManager = /*#__PURE__*/ function() {
    "use strict";
    function ModalManager() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ownerDocument = _ref.ownerDocument, _ref_handleContainerOverflow = _ref.handleContainerOverflow, handleContainerOverflow = _ref_handleContainerOverflow === void 0 ? true : _ref_handleContainerOverflow, _ref_isRTL = _ref.isRTL, isRTL = _ref_isRTL === void 0 ? false : _ref_isRTL;
        (0, $19mwo._)(this, ModalManager);
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    (0, $6rpfc._)(ModalManager, [
        {
            key: "getScrollbarWidth",
            value: function getScrollbarWidth() {
                return (0, $71ecc889acf8d27e$export$2e2bcd8739ae039)(this.ownerDocument);
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return (this.ownerDocument || document).body;
            }
        },
        {
            key: "setModalAttributes",
            value: function setModalAttributes(_modal) {
            // For overriding
            }
        },
        {
            key: "removeModalAttributes",
            value: function removeModalAttributes(_modal) {
            // For overriding
            }
        },
        {
            key: "setContainerStyle",
            value: function setContainerStyle(containerState) {
                var style = {
                    overflow: "hidden"
                };
                // we are only interested in the actual `style` here
                // because we will override it
                var paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
                var container = this.getElement();
                containerState.style = (0, $c5rwh._)({
                    overflow: container.style.overflow
                }, paddingProp, container.style[paddingProp]);
                if (containerState.scrollBarWidth) // use computed style, here to get the real padding
                // to add our scrollbar width
                style[paddingProp] = "".concat(parseInt((0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(container, paddingProp) || "0", 10) + containerState.scrollBarWidth, "px");
                container.setAttribute($6f204bcdfda032e4$export$1a88c12b8b979fa0, "");
                (0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(container, style);
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                (0, $3jzhD._)(this.modals).forEach(function(m) {
                    return _this.remove(m);
                });
            }
        },
        {
            key: "removeContainerStyle",
            value: function removeContainerStyle(containerState) {
                var container = this.getElement();
                container.removeAttribute($6f204bcdfda032e4$export$1a88c12b8b979fa0);
                Object.assign(container.style, containerState.style);
            }
        },
        {
            key: "add",
            value: function add(modal) {
                var modalIdx = this.modals.indexOf(modal);
                if (modalIdx !== -1) return modalIdx;
                modalIdx = this.modals.length;
                this.modals.push(modal);
                this.setModalAttributes(modal);
                if (modalIdx !== 0) return modalIdx;
                this.state = {
                    scrollBarWidth: this.getScrollbarWidth(),
                    style: {}
                };
                if (this.handleContainerOverflow) this.setContainerStyle(this.state);
                return modalIdx;
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var modalIdx = this.modals.indexOf(modal);
                if (modalIdx === -1) return;
                this.modals.splice(modalIdx, 1);
                // if that was the last modal in a container,
                // clean up the container
                if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
                this.removeModalAttributes(modal);
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();
var $6f204bcdfda032e4$export$2e2bcd8739ae039 = $6f204bcdfda032e4$var$ModalManager;



var $2MTYX = parcelRequire("2MTYX");



var $33gHU = parcelRequire("33gHU");

var $33gHU = parcelRequire("33gHU");

var $485dbf221aa58992$var$Context = /*#__PURE__*/ (0, $33gHU.createContext)((0, $64f258eaaf92e603$export$2e2bcd8739ae039) ? window : undefined);
var $485dbf221aa58992$export$f7d306aeb1cf5fbc = $485dbf221aa58992$var$Context.Provider;
function $485dbf221aa58992$export$2e2bcd8739ae039() {
    return (0, $33gHU.useContext)($485dbf221aa58992$var$Context);
}


var $a4806560a2a022cc$export$c91fd81e6d65f84a = function(ref, document) {
    if (!(0, $64f258eaaf92e603$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $cb03b130654deaba$export$2e2bcd8739ae039)()).body;
    if (typeof ref === "function") ref = ref();
    if (ref && "current" in ref) ref = ref.current;
    if (ref && ("nodeType" in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $a4806560a2a022cc$export$2e2bcd8739ae039(ref, onResolved) {
    var window = (0, $485dbf221aa58992$export$2e2bcd8739ae039)();
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)(function() {
        return $a4806560a2a022cc$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document);
    }), 2), resolvedRef = _useState[0], setRef = _useState[1];
    if (!resolvedRef) {
        var earlyRef = $a4806560a2a022cc$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $33gHU.useEffect)(function() {
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $33gHU.useEffect)(function() {
        var nextRef = $a4806560a2a022cc$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}




var $2MTYX = parcelRequire("2MTYX");



var $33gHU = parcelRequire("33gHU");
var $5987dd645a9ebdaf$var$isReactNative = typeof $parcel$global !== "undefined" && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === "ReactNative";
var $5987dd645a9ebdaf$var$isDOM = typeof document !== "undefined";
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $5987dd645a9ebdaf$export$2e2bcd8739ae039 = $5987dd645a9ebdaf$var$isDOM || $5987dd645a9ebdaf$var$isReactNative ? (0, $33gHU.useLayoutEffect) : (0, $33gHU.useEffect);



var $33gHU = parcelRequire("33gHU");



var $33gHU = parcelRequire("33gHU");
function $290b23b4e1c92d4c$var$NoopTransition(param) {
    var children = param.children, inProp = param.in, onExited = param.onExited, mountOnEnter = param.mountOnEnter, unmountOnExit = param.unmountOnExit;
    var ref = (0, $33gHU.useRef)(null);
    var hasEnteredRef = (0, $33gHU.useRef)(inProp);
    var handleExited = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(onExited);
    (0, $33gHU.useEffect)(function() {
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    var combinedRef = (0, $0bc64fd3b15ed530$export$2e2bcd8739ae039)(ref, children.ref);
    var child = /*#__PURE__*/ (0, $33gHU.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $290b23b4e1c92d4c$export$2e2bcd8739ae039 = $290b23b4e1c92d4c$var$NoopTransition;



var $33gHU = parcelRequire("33gHU");

var $33gHU = parcelRequire("33gHU");


var $33gHU = parcelRequire("33gHU");
function $d8f868c60be34750$export$806fcc22e55e107d(e) {
    return e.code === "Escape" || e.keyCode === 27;
}
function $d8f868c60be34750$export$13e065f3a74cfe36() {
    var parts = $33gHU.version.split(".");
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}


var $d77b50567ade2ea4$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $d77b50567ade2ea4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d77b50567ade2ea4$export$2e2bcd8739ae039(_ref) {
    var onEnter = _ref.onEnter, onEntering = _ref.onEntering, onEntered = _ref.onEntered, onExit = _ref.onExit, onExiting = _ref.onExiting, onExited = _ref.onExited, addEndListener = _ref.addEndListener, children = _ref.children, props = $d77b50567ade2ea4$var$_objectWithoutPropertiesLoose(_ref, $d77b50567ade2ea4$var$_excluded);
    var major = (0, $d8f868c60be34750$export$13e065f3a74cfe36)().major;
    var childRef = major >= 19 ? children.props.ref : children.ref;
    var nodeRef = (0, $33gHU.useRef)(null);
    var mergedRef = (0, $0bc64fd3b15ed530$export$2e2bcd8739ae039)(nodeRef, typeof children === "function" ? null : childRef);
    var normalize = function(callback) {
        return function(param) {
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    };
    /* eslint-disable react-hooks/exhaustive-deps */ var handleEnter = (0, $33gHU.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    var handleEntering = (0, $33gHU.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    var handleEntered = (0, $33gHU.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    var handleExit = (0, $33gHU.useCallback)(normalize(onExit), [
        onExit
    ]);
    var handleExiting = (0, $33gHU.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    var handleExited = (0, $33gHU.useCallback)(normalize(onExited), [
        onExited
    ]);
    var handleAddEndListener = (0, $33gHU.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === "function" ? function(status, innerProps) {
            return(// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })));
        } : /*#__PURE__*/ (0, $33gHU.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



var $4b72947efa195251$var$_excluded = [
    "component"
];
function $4b72947efa195251$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Normalizes Transition callbacks when nodeRef is used.
var $4b72947efa195251$var$RTGTransition = /*#__PURE__*/ $33gHU.forwardRef(function(_ref, ref) {
    var Component = _ref.component, props = $4b72947efa195251$var$_objectWithoutPropertiesLoose(_ref, $4b72947efa195251$var$_excluded);
    var transitionProps = (0, $d77b50567ade2ea4$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $4b72947efa195251$export$2e2bcd8739ae039 = $4b72947efa195251$var$RTGTransition;



function $728b50f64a2d4bbe$export$7b286972b8d8ccbf(param) {
    var inProp = param.in, onTransition = param.onTransition;
    var ref = (0, $33gHU.useRef)(null);
    var isInitialRef = (0, $33gHU.useRef)(true);
    var handleTransition = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(onTransition);
    (0, $5987dd645a9ebdaf$export$2e2bcd8739ae039)(function() {
        if (!ref.current) return undefined;
        var stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: function() {
                return stale;
            }
        });
        return function() {
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $5987dd645a9ebdaf$export$2e2bcd8739ae039)(function() {
        isInitialRef.current = false;
        // this is for strict mode
        return function() {
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $728b50f64a2d4bbe$export$2e2bcd8739ae039(param) {
    var children = param.children, inProp = param.in, onExited = param.onExited, onEntered = param.onEntered, transition = param.transition;
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)(!inProp), 2), exited = _useState[0], setExited = _useState[1];
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    var ref = $728b50f64a2d4bbe$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: function(options) {
            var onFinish = function() {
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, function(error) {
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    var combinedRef = (0, $0bc64fd3b15ed530$export$2e2bcd8739ae039)(ref, children.ref);
    return exited && !inProp ? null : /*#__PURE__*/ (0, $33gHU.cloneElement)(children, {
        ref: combinedRef
    });
}
function $728b50f64a2d4bbe$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $4b72947efa195251$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)($728b50f64a2d4bbe$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $290b23b4e1c92d4c$export$2e2bcd8739ae039), Object.assign({}, props));
}




var $a1185c45eea1e591$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $a1185c45eea1e591$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a1185c45eea1e591$var$manager;
function $a1185c45eea1e591$var$getManager(window) {
    if (!$a1185c45eea1e591$var$manager) $a1185c45eea1e591$var$manager = new (0, $6f204bcdfda032e4$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $a1185c45eea1e591$var$manager;
}
function $a1185c45eea1e591$var$useModalManager(provided) {
    var window = (0, $485dbf221aa58992$export$2e2bcd8739ae039)();
    var modalManager = provided || $a1185c45eea1e591$var$getManager(window);
    var modal = (0, $33gHU.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: function() {
            return modalManager.add(modal.current);
        },
        remove: function() {
            return modalManager.remove(modal.current);
        },
        isTopModal: function() {
            return modalManager.isTopModal(modal.current);
        },
        setDialogRef: (0, $33gHU.useCallback)(function(ref) {
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $33gHU.useCallback)(function(ref) {
            modal.current.backdrop = ref;
        }, [])
    });
}
var $a1185c45eea1e591$var$Modal = /*#__PURE__*/ (0, $33gHU.forwardRef)(function(_ref, ref) {
    var _ref_show = _ref.show, show = _ref_show === void 0 ? false : _ref_show, _ref_role = _ref.role, role = _ref_role === void 0 ? "dialog" : _ref_role, className = _ref.className, style = _ref.style, children = _ref.children, _ref_backdrop = _ref.backdrop, backdrop = _ref_backdrop === void 0 ? true : _ref_backdrop, _ref_keyboard = _ref.keyboard, keyboard = _ref_keyboard === void 0 ? true : _ref_keyboard, onBackdropClick = _ref.onBackdropClick, onEscapeKeyDown = _ref.onEscapeKeyDown, transition = _ref.transition, runTransition = _ref.runTransition, backdropTransition = _ref.backdropTransition, runBackdropTransition = _ref.runBackdropTransition, _ref_autoFocus = _ref.autoFocus, autoFocus = _ref_autoFocus === void 0 ? true : _ref_autoFocus, _ref_enforceFocus = _ref.enforceFocus, enforceFocus = _ref_enforceFocus === void 0 ? true : _ref_enforceFocus, _ref_restoreFocus = _ref.restoreFocus, restoreFocus = _ref_restoreFocus === void 0 ? true : _ref_restoreFocus, restoreFocusOptions = _ref.restoreFocusOptions, renderDialog = _ref.renderDialog, _ref_renderBackdrop = _ref.renderBackdrop, renderBackdrop = _ref_renderBackdrop === void 0 ? function(props) {
        return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", Object.assign({}, props));
    } : _ref_renderBackdrop, providedManager = _ref.manager, containerRef = _ref.container, onShow = _ref.onShow, _ref_onHide = _ref.onHide, onHide = _ref_onHide === void 0 ? function() {} : _ref_onHide, onExit = _ref.onExit, onExited = _ref.onExited, onExiting = _ref.onExiting, onEnter = _ref.onEnter, onEntering = _ref.onEntering, onEntered = _ref.onEntered, rest = $a1185c45eea1e591$var$_objectWithoutPropertiesLoose(_ref, $a1185c45eea1e591$var$_excluded);
    var ownerWindow = (0, $485dbf221aa58992$export$2e2bcd8739ae039)();
    var container = (0, $a4806560a2a022cc$export$2e2bcd8739ae039)(containerRef);
    var modal = $a1185c45eea1e591$var$useModalManager(providedManager);
    var isMounted = (0, $f76f1451b40a5807$export$2e2bcd8739ae039)();
    var prevShow = (0, $7e4ad4faf3b19879$export$2e2bcd8739ae039)(show);
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)(!show), 2), exited = _useState[0], setExited = _useState[1];
    var lastFocusRef = (0, $33gHU.useRef)(null);
    (0, $33gHU.useImperativeHandle)(ref, function() {
        return modal;
    }, [
        modal
    ]);
    if ((0, $64f258eaaf92e603$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $607d6e14baa19d0a$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    var handleShow = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function() {
        modal.add();
        removeKeydownListenerRef.current = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(document, "keydown", handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(document, "focus", // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        function() {
            return setTimeout(handleEnforceFocus);
        }, true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            var currentActiveElement = (0, $607d6e14baa19d0a$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $a784322fcbc350d7$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    var handleHide = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function() {
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $33gHU.useEffect)(function() {
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $33gHU.useEffect)(function() {
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $2ef4591ec3517cf9$export$2e2bcd8739ae039)(function() {
        handleHide();
    });
    // --------------------------------
    var handleEnforceFocus = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function() {
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        var currentActiveElement = (0, $607d6e14baa19d0a$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $a784322fcbc350d7$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    var handleBackdropClick = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function(e) {
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    var handleDocumentKeyDown = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function(e) {
        if (keyboard && (0, $d8f868c60be34750$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    var removeFocusListenerRef = (0, $33gHU.useRef)();
    var removeKeydownListenerRef = (0, $33gHU.useRef)();
    var handleHidden = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        setExited(true);
        onExited == null || onExited.apply(void 0, (0, $3jzhD._)(args));
    };
    if (!container) return null;
    var dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        "aria-modal": role === "dialog" ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    var dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $33gHU.cloneElement(children, {
            role: "document"
        })
    }));
    dialog = (0, $728b50f64a2d4bbe$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    var backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $728b50f64a2d4bbe$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $978b871a0234f592$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($e1a300cc66774841$exports))).createPortal(/*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)((0, $978b871a0234f592$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$a1185c45eea1e591$var$Modal.displayName = "Modal";
var $a1185c45eea1e591$export$2e2bcd8739ae039 = Object.assign($a1185c45eea1e591$var$Modal, {
    Manager: (0, $6f204bcdfda032e4$export$2e2bcd8739ae039)
});



var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $c5rwh = parcelRequire("c5rwh");

var $jLCbM = parcelRequire("jLCbM");

var $laF8D = parcelRequire("laF8D");

var $iNfU4 = parcelRequire("iNfU4");

var $k1NN5 = parcelRequire("k1NN5");
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $00f98d1dc049abf7$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $238a4fd6ca67df0c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $00f98d1dc049abf7$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}



var $aa7848f343bf09c4$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $aa7848f343bf09c4$export$2e2bcd8739ae039(element, selector) {
    return $aa7848f343bf09c4$var$toArray(element.querySelectorAll(selector));
}


function $62f26c8f9df85416$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $62f26c8f9df85416$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $62f26c8f9df85416$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $62f26c8f9df85416$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



var $77149501eb4f3e63$var$Selector = {
    FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
    STICKY_CONTENT: ".sticky-top",
    NAVBAR_TOGGLER: ".navbar-toggler"
};
var $77149501eb4f3e63$var$BootstrapModalManager = /*#__PURE__*/ function(ModalManager) {
    "use strict";
    (0, $iNfU4._)(BootstrapModalManager, ModalManager);
    var _super = (0, $k1NN5._)(BootstrapModalManager);
    function BootstrapModalManager() {
        (0, $19mwo._)(this, BootstrapModalManager);
        return _super.apply(this, arguments);
    }
    (0, $6rpfc._)(BootstrapModalManager, [
        {
            key: "adjustAndStore",
            value: function adjustAndStore(prop, element, adjust) {
                var actual = element.style[prop];
                // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
                // @ts-ignore
                element.dataset[prop] = actual;
                (0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(element, (0, $c5rwh._)({}, prop, "".concat(parseFloat((0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(element, prop)) + adjust, "px")));
            }
        },
        {
            key: "restore",
            value: function restore(prop, element) {
                var value = element.dataset[prop];
                if (value !== undefined) {
                    delete element.dataset[prop];
                    (0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(element, (0, $c5rwh._)({}, prop, value));
                }
            }
        },
        {
            key: "setContainerStyle",
            value: function setContainerStyle(containerState) {
                var _this = this;
                (0, $jLCbM._)((0, $laF8D._)(BootstrapModalManager.prototype), "setContainerStyle", this).call(this, containerState);
                var container = this.getElement();
                (0, $238a4fd6ca67df0c$export$2e2bcd8739ae039)(container, "modal-open");
                if (!containerState.scrollBarWidth) return;
                var paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
                var marginProp = this.isRTL ? "marginLeft" : "marginRight";
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $77149501eb4f3e63$var$Selector.FIXED_CONTENT).forEach(function(el) {
                    return _this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth);
                });
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $77149501eb4f3e63$var$Selector.STICKY_CONTENT).forEach(function(el) {
                    return _this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth);
                });
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $77149501eb4f3e63$var$Selector.NAVBAR_TOGGLER).forEach(function(el) {
                    return _this.adjustAndStore(marginProp, el, containerState.scrollBarWidth);
                });
            }
        },
        {
            key: "removeContainerStyle",
            value: function removeContainerStyle(containerState) {
                var _this = this;
                (0, $jLCbM._)((0, $laF8D._)(BootstrapModalManager.prototype), "removeContainerStyle", this).call(this, containerState);
                var container = this.getElement();
                (0, $62f26c8f9df85416$export$2e2bcd8739ae039)(container, "modal-open");
                var paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
                var marginProp = this.isRTL ? "marginLeft" : "marginRight";
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $77149501eb4f3e63$var$Selector.FIXED_CONTENT).forEach(function(el) {
                    return _this.restore(paddingProp, el);
                });
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $77149501eb4f3e63$var$Selector.STICKY_CONTENT).forEach(function(el) {
                    return _this.restore(marginProp, el);
                });
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $77149501eb4f3e63$var$Selector.NAVBAR_TOGGLER).forEach(function(el) {
                    return _this.restore(marginProp, el);
                });
            }
        }
    ]);
    return BootstrapModalManager;
}((0, $6f204bcdfda032e4$export$2e2bcd8739ae039));
var $77149501eb4f3e63$var$sharedManager;
function $77149501eb4f3e63$export$a03641438014b436(options) {
    if (!$77149501eb4f3e63$var$sharedManager) $77149501eb4f3e63$var$sharedManager = new $77149501eb4f3e63$var$BootstrapModalManager(options);
    return $77149501eb4f3e63$var$sharedManager;
}
var $77149501eb4f3e63$export$2e2bcd8739ae039 = $77149501eb4f3e63$var$BootstrapModalManager;




var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");



"use client";
var $e08f4918308e2446$var$ModalBody = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? "div" : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "modal-body");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$e08f4918308e2446$var$ModalBody.displayName = "ModalBody";
var $e08f4918308e2446$export$2e2bcd8739ae039 = $e08f4918308e2446$var$ModalBody;



var $33gHU = parcelRequire("33gHU");
"use client";
var $c26d292235a43d65$var$ModalContext = /*#__PURE__*/ $33gHU.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide: function() {}
});
var $c26d292235a43d65$export$2e2bcd8739ae039 = $c26d292235a43d65$var$ModalContext;



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");


"use client";
var $e93f6028724f4d0a$var$ModalDialog = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, contentClassName = _param.contentClassName, centered = _param.centered, size = _param.size, fullscreen = _param.fullscreen, children = _param.children, scrollable = _param.scrollable, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "contentClassName",
        "centered",
        "size",
        "fullscreen",
        "children",
        "scrollable"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "modal");
    var dialogClass = "".concat(bsPrefix, "-dialog");
    var fullScreenClass = typeof fullscreen === "string" ? "".concat(bsPrefix, "-fullscreen-").concat(fullscreen) : "".concat(bsPrefix, "-fullscreen");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", (0, $ddevm._)((0, $78DQ7._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(dialogClass, className, size && "".concat(bsPrefix, "-").concat(size), centered && "".concat(dialogClass, "-centered"), scrollable && "".concat(dialogClass, "-scrollable"), fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("".concat(bsPrefix, "-content"), contentClassName),
            children: children
        })
    }));
});
$e93f6028724f4d0a$var$ModalDialog.displayName = "ModalDialog";
var $e93f6028724f4d0a$export$2e2bcd8739ae039 = $e93f6028724f4d0a$var$ModalDialog;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");



"use client";
var $349e30233ff28dcc$var$ModalFooter = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? "div" : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "modal-footer");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$349e30233ff28dcc$var$ModalFooter.displayName = "ModalFooter";
var $349e30233ff28dcc$export$2e2bcd8739ae039 = $349e30233ff28dcc$var$ModalFooter;



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");


var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");




"use client";
var $f39ba7dd914d8c37$var$AbstractModalHeader = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var _param_closeLabel = _param.closeLabel, closeLabel = _param_closeLabel === void 0 ? "Close" : _param_closeLabel, closeVariant = _param.closeVariant, _param_closeButton = _param.closeButton, closeButton = _param_closeButton === void 0 ? false : _param_closeButton, onHide = _param.onHide, children = _param.children, props = (0, $6JqHh._)(_param, [
        "closeLabel",
        "closeVariant",
        "closeButton",
        "onHide",
        "children"
    ]);
    var context = (0, $33gHU.useContext)((0, $c26d292235a43d65$export$2e2bcd8739ae039));
    var handleClick = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function() {
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", (0, $ddevm._)((0, $78DQ7._)({
        ref: ref
    }, props), {
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $b3e1e0a6648925c0$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    }));
});
var $f39ba7dd914d8c37$export$2e2bcd8739ae039 = $f39ba7dd914d8c37$var$AbstractModalHeader;



"use client";
var $977ebd7f1c5b9610$var$ModalHeader = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, _param_closeLabel = _param.closeLabel, closeLabel = _param_closeLabel === void 0 ? "Close" : _param_closeLabel, _param_closeButton = _param.closeButton, closeButton = _param_closeButton === void 0 ? false : _param_closeButton, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "closeLabel",
        "closeButton"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "modal-header");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $f39ba7dd914d8c37$export$2e2bcd8739ae039), (0, $ddevm._)((0, $78DQ7._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    }));
});
$977ebd7f1c5b9610$var$ModalHeader.displayName = "ModalHeader";
var $977ebd7f1c5b9610$export$2e2bcd8739ae039 = $977ebd7f1c5b9610$var$ModalHeader;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");


var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $33gHU = parcelRequire("33gHU");


var $102b865d7ac21b71$export$2e2bcd8739ae039 = function(className) {
    return /*#__PURE__*/ $33gHU.forwardRef(function(p, ref) {
        return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", (0, $ddevm._)((0, $78DQ7._)({}, p), {
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(p.className, className)
        }));
    });
};




"use client";
var $f630f68d555e226a$var$DivStyledAsH4 = (0, $102b865d7ac21b71$export$2e2bcd8739ae039)("h4");
var $f630f68d555e226a$var$ModalTitle = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? $f630f68d555e226a$var$DivStyledAsH4 : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "modal-title");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$f630f68d555e226a$var$ModalTitle.displayName = "ModalTitle";
var $f630f68d555e226a$export$2e2bcd8739ae039 = $f630f68d555e226a$var$ModalTitle;




"use client";
/* eslint-disable no-use-before-define, react/no-multi-comp */ function $fc5d520cd5b7a226$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $7639cffc50f5d209$export$2e2bcd8739ae039), (0, $ddevm._)((0, $78DQ7._)({}, props), {
        timeout: null
    }));
}
function $fc5d520cd5b7a226$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $7639cffc50f5d209$export$2e2bcd8739ae039), (0, $ddevm._)((0, $78DQ7._)({}, props), {
        timeout: null
    }));
}
/* eslint-enable no-use-before-define */ var $fc5d520cd5b7a226$var$Modal = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, style = _param.style, dialogClassName = _param.dialogClassName, contentClassName = _param.contentClassName, children = _param.children, tmp = _param.dialogAs, Dialog = tmp === void 0 ? (0, $e93f6028724f4d0a$export$2e2bcd8739ae039) : tmp, dataBsTheme = _param["data-bs-theme"], ariaLabelledby = _param["aria-labelledby"], ariaDescribedby = _param["aria-describedby"], ariaLabel = _param["aria-label"], _param_show = _param./* BaseModal props */ show, show = _param_show === void 0 ? false : _param_show, _param_animation = _param.animation, animation = _param_animation === void 0 ? true : _param_animation, _param_backdrop = _param.backdrop, backdrop = _param_backdrop === void 0 ? true : _param_backdrop, _param_keyboard = _param.keyboard, keyboard = _param_keyboard === void 0 ? true : _param_keyboard, onEscapeKeyDown = _param.onEscapeKeyDown, onShow = _param.onShow, onHide = _param.onHide, container = _param.container, _param_autoFocus = _param.autoFocus, autoFocus = _param_autoFocus === void 0 ? true : _param_autoFocus, _param_enforceFocus = _param.enforceFocus, enforceFocus = _param_enforceFocus === void 0 ? true : _param_enforceFocus, _param_restoreFocus = _param.restoreFocus, restoreFocus = _param_restoreFocus === void 0 ? true : _param_restoreFocus, restoreFocusOptions = _param.restoreFocusOptions, onEntered = _param.onEntered, onExit = _param.onExit, onExiting = _param.onExiting, onEnter = _param.onEnter, onEntering = _param.onEntering, onExited = _param.onExited, backdropClassName = _param.backdropClassName, propsManager = _param.manager, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "style",
        "dialogClassName",
        "contentClassName",
        "children",
        "dialogAs",
        "data-bs-theme",
        "aria-labelledby",
        "aria-describedby",
        "aria-label",
        "show",
        "animation",
        "backdrop",
        "keyboard",
        "onEscapeKeyDown",
        "onShow",
        "onHide",
        "container",
        "autoFocus",
        "enforceFocus",
        "restoreFocus",
        "restoreFocusOptions",
        "onEntered",
        "onExit",
        "onExiting",
        "onEnter",
        "onEntering",
        "onExited",
        "backdropClassName",
        "manager"
    ]);
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)({}), 2), modalStyle = _useState[0], setStyle = _useState[1];
    var _useState1 = (0, $2MTYX._)((0, $33gHU.useState)(false), 2), animateStaticModal = _useState1[0], setAnimateStaticModal = _useState1[1];
    var waitingForMouseUpRef = (0, $33gHU.useRef)(false);
    var ignoreBackdropClickRef = (0, $33gHU.useRef)(false);
    var removeStaticModalAnimationRef = (0, $33gHU.useRef)(null);
    var _useCallbackRef = (0, $2MTYX._)((0, $04457dad5314d7c2$export$2e2bcd8739ae039)(), 2), modal = _useCallbackRef[0], setModalRef = _useCallbackRef[1];
    var mergedRef = (0, $0bc64fd3b15ed530$export$2e2bcd8739ae039)(ref, setModalRef);
    var handleHide = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(onHide);
    var isRTL = (0, $48ea4dae63926a21$export$35e511eefa30ac5a)();
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "modal");
    var modalContext = (0, $33gHU.useMemo)(function() {
        return {
            onHide: handleHide
        };
    }, [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $77149501eb4f3e63$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $64f258eaaf92e603$export$2e2bcd8739ae039)) return;
        var containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        var modalIsOverflowing = node.scrollHeight > (0, $cb03b130654deaba$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $1a02a97bdd063b41$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $1a02a97bdd063b41$export$2e2bcd8739ae039)() : undefined
        });
    }
    var handleWindowResize = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function() {
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $2ef4591ec3517cf9$export$2e2bcd8739ae039)(function() {
        (0, $0e5e4de4085acd94$export$2e2bcd8739ae039)(window, "resize", handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    var handleDialogMouseDown = function() {
        waitingForMouseUpRef.current = true;
    };
    var handleMouseUp = function(e) {
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    var handleStaticModalAnimation = function() {
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $eb2ed0bd2d792c29$export$2e2bcd8739ae039)(modal.dialog, function() {
            setAnimateStaticModal(false);
        });
    };
    var handleStaticBackdropClick = function(e) {
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    var handleClick = function(e) {
        if (backdrop === "static") {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    var handleEscapeKeyDown = function(e) {
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === "static") // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    var handleEnter = function(node, isAppearing) {
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    var handleExit = function(node) {
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    var handleEntering = function(node, isAppearing) {
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $fe9809a8616a080a$export$2e2bcd8739ae039)(window, "resize", handleWindowResize);
    };
    var handleExited = function(node) {
        if (node) node.style.display = ""; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $0e5e4de4085acd94$export$2e2bcd8739ae039)(window, "resize", handleWindowResize);
    };
    var renderBackdrop = (0, $33gHU.useCallback)(function(backdropProps) {
        return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", (0, $ddevm._)((0, $78DQ7._)({}, backdropProps), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("".concat(bsPrefix, "-backdrop"), backdropClassName, !animation && "show")
        }));
    }, [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    var baseModalStyle = (0, $78DQ7._)({}, style, modalStyle);
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = "block";
    var renderDialog = function(dialogProps) {
        return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", (0, $ddevm._)((0, $78DQ7._)({
            role: "dialog"
        }, dialogProps), {
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, animateStaticModal && "".concat(bsPrefix, "-static"), !animation && "show"),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Dialog, (0, $ddevm._)((0, $78DQ7._)({}, props), {
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            }))
        }));
    };
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $c26d292235a43d65$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $a1185c45eea1e591$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $fc5d520cd5b7a226$var$DialogTransition : undefined,
            backdropTransition: animation ? $fc5d520cd5b7a226$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$fc5d520cd5b7a226$var$Modal.displayName = "Modal";
var $fc5d520cd5b7a226$export$2e2bcd8739ae039 = Object.assign($fc5d520cd5b7a226$var$Modal, {
    Body: (0, $e08f4918308e2446$export$2e2bcd8739ae039),
    Header: (0, $977ebd7f1c5b9610$export$2e2bcd8739ae039),
    Title: (0, $f630f68d555e226a$export$2e2bcd8739ae039),
    Footer: (0, $349e30233ff28dcc$export$2e2bcd8739ae039),
    Dialog: (0, $e93f6028724f4d0a$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});






var $d752b28197405025$export$c407db72103fecfa;
var $d752b28197405025$export$3aaa4b20d0dc593a;
$d752b28197405025$export$c407db72103fecfa = "_1IENTa_entry";
$d752b28197405025$export$3aaa4b20d0dc593a = "_1IENTa_icons_container";






var $33gHU = parcelRequire("33gHU");
var $189f6ccbde67c327$export$3b4d6962b8b123a9;
var $189f6ccbde67c327$export$1ca1ec8b29a4ce27;
var $189f6ccbde67c327$export$43f9b1f8d3c6a7d1;
var $189f6ccbde67c327$export$93f8e7c9ea696e86;
var $189f6ccbde67c327$export$867118fff8aa9147;
var $189f6ccbde67c327$export$934587b1a6f00472;
var $189f6ccbde67c327$export$3642f561e7de7ca;
$189f6ccbde67c327$export$3b4d6962b8b123a9 = "bR_lya_activate_animation";
$189f6ccbde67c327$export$3b4d6962b8b123a9;
$189f6ccbde67c327$export$1ca1ec8b29a4ce27 = "bR_lya_icon";
$189f6ccbde67c327$export$43f9b1f8d3c6a7d1 = "bR_lya_iconExtraSmall";
$189f6ccbde67c327$export$93f8e7c9ea696e86 = "bR_lya_iconLarge";
$189f6ccbde67c327$export$867118fff8aa9147 = "bR_lya_iconMedium";
$189f6ccbde67c327$export$934587b1a6f00472 = "bR_lya_iconSmall";
$189f6ccbde67c327$export$3642f561e7de7ca = "bR_lya_wiggle";
$189f6ccbde67c327$export$3642f561e7de7ca;





var $33gHU = parcelRequire("33gHU");
var $0c15b6a910398513$export$1bb3d147765683cf;
$0c15b6a910398513$export$1bb3d147765683cf = "iiZZRq_tracker";



var $f999aa122d970e1d$export$53770483ed5ae606 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function(props) {
    var el = (0, $33gHU.useRef)(null);
    var cls = [
        $0c15b6a910398513$export$1bb3d147765683cf,
        props.className
    ].join(" ");
    (0, $33gHU.useEffect)(function() {
        var updatePosition = function() {
            if (el.current) {
                var parent = el.current.parentElement;
                var rect = parent.getBoundingClientRect();
                // console.log(
                //     `PositionTracker: ${props.type}->${props.id} ${rect.left} ${rect.top}`
                // );
                var pos = {
                    x: rect.left + rect.width / 2,
                    y: rect.top + rect.height / 2
                };
                var animStore = (0, $3a3345637c0a5d6f$export$491715d4fdcd0f6b)();
                animStore.reportPosition(props, pos);
            }
        };
        var timer = setInterval(updatePosition, 1000);
        return function() {
            clearInterval(timer);
        };
    }, [
        el.current
    ]);
    return (0, $978b871a0234f592$exports.jsx)("div", {
        ref: el,
        className: $0c15b6a910398513$export$1bb3d147765683cf
    });
});


var $6ca346b03d4e19d6$export$f04a61298a47a40f = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function(props) {
    var clickTimer = (0, $33gHU.useRef)(null);
    var clickStartTime = (0, $33gHU.useRef)(0);
    var id = props.id || "";
    var className = props.className || "";
    var icons = (0, $3a3345637c0a5d6f$export$bd973f06e9aaec8c)();
    var size = props.size || "M";
    var sizeClass = {
        XS: $189f6ccbde67c327$export$43f9b1f8d3c6a7d1,
        S: $189f6ccbde67c327$export$934587b1a6f00472,
        M: $189f6ccbde67c327$export$867118fff8aa9147,
        L: $189f6ccbde67c327$export$93f8e7c9ea696e86
    };
    var iconSrc = null;
    if (props.iconSys) iconSrc = icons.sysIcons[props.iconSys].url;
    else if (props.iconTask) iconSrc = icons.taskIcons[props.iconTask].url;
    else if (props.src) iconSrc = props.src;
    var icon = props.iconSys;
    var clearTimer = function() {
        if (clickTimer.current) {
            clearTimeout(clickTimer.current);
            clickTimer.current = null;
        }
    };
    var onMouseUp = function(e) {
        e.preventDefault();
        var clickEndTime = new Date().getTime();
        if (clickEndTime - clickStartTime.current < 200) {
            clickStartTime.current = 0;
            if (props.onClick) props.onClick();
        }
        clearTimer();
    };
    var onMouseDown = function(e) {
        // if (e.button !== 0) {
        //     return;
        // }
        e.preventDefault();
        clickStartTime.current = new Date().getTime();
        clearTimer();
        clickTimer.current = setTimeout(function() {
            if (props.onHold) props.onHold();
        }, 750);
    };
    return (0, $978b871a0234f592$exports.jsxs)("div", {
        id: id,
        className: $189f6ccbde67c327$export$1ca1ec8b29a4ce27 + " " + sizeClass[size] + " " + className + " d-flex justify-content-center align-items-center",
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        onTouchStart: onMouseDown,
        onTouchEnd: onMouseUp,
        children: [
            (0, $978b871a0234f592$exports.jsx)("img", {
                className: sizeClass[size],
                src: iconSrc
            }),
            props.tracker && (0, $978b871a0234f592$exports.jsx)((0, $f999aa122d970e1d$export$53770483ed5ae606), {
                id: id,
                type: "weekly"
            })
        ]
    });
});


var $012ec664521eefe4$export$33bb5e4115e7fff5 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var modalStore = (0, $3a3345637c0a5d6f$export$33ffd74ebf07f060)();
    var icons = (0, $3a3345637c0a5d6f$export$bd973f06e9aaec8c)().taskIcons;
    var iconKeys = Object.keys(icons).sort();
    return (0, $978b871a0234f592$exports.jsx)((0, $978b871a0234f592$exports.Fragment), {
        children: (0, $978b871a0234f592$exports.jsx)("div", {
            className: $d752b28197405025$export$3aaa4b20d0dc593a,
            children: iconKeys.map(function(key) {
                var icon = icons[key];
                return (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
                    iconTask: icon.name,
                    size: "L",
                    onClick: function() {
                        modalStore.reportIconSelected(icon.name);
                    }
                }, icon.name);
            })
        })
    });
});
var $012ec664521eefe4$export$2e2bcd8739ae039 = $012ec664521eefe4$export$33bb5e4115e7fff5;





var $5c424dab59337ad0$export$463b44d9bf3628be;
var $5c424dab59337ad0$export$278e8ca9e1fa9094;
var $5c424dab59337ad0$export$ac96b34a74de2f22;
$5c424dab59337ad0$export$463b44d9bf3628be = "MWUF8a_img";
$5c424dab59337ad0$export$278e8ca9e1fa9094 = "MWUF8a_pdf";
$5c424dab59337ad0$export$ac96b34a74de2f22 = "MWUF8a_txt";



var $33gHU = parcelRequire("33gHU");
function $3055a4e97dac36e4$var$get_url_extension(url) {
    return url.split(/[#?]/)[0].split(".").pop().trim().toLowerCase();
}
var $3055a4e97dac36e4$export$e9574d71ebaa0658 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var pdfRef = (0, $33gHU.useRef)(null);
    var modalStore = (0, $3a3345637c0a5d6f$export$33ffd74ebf07f060)();
    var asset = modalStore.attachmentUrl;
    var ext = $3055a4e97dac36e4$var$get_url_extension(asset);
    if (ext == "pdf") {
        var src = "https://docs.google.com/viewer?url=" + encodeURIComponent(asset) + "&embedded=true";
        return (0, $978b871a0234f592$exports.jsx)("iframe", {
            src: src,
            height: "600px",
            width: "100%"
        });
    } else if (ext == "txt" || ext == "json") return (0, $978b871a0234f592$exports.jsx)("iframe", {
        src: asset,
        className: $5c424dab59337ad0$export$ac96b34a74de2f22
    });
    else //Image
    return (0, $978b871a0234f592$exports.jsx)("img", {
        src: asset,
        className: $5c424dab59337ad0$export$463b44d9bf3628be
    });
    return "No Preview";
});
var $3055a4e97dac36e4$export$2e2bcd8739ae039 = $3055a4e97dac36e4$export$e9574d71ebaa0658;







var $cdc68b4155305494$export$34e0f9847d4c02dd;
var $cdc68b4155305494$export$c869496b69afe520;
var $cdc68b4155305494$export$4d325103b88b79bf;
var $cdc68b4155305494$export$a715f47ba6042dad;
$cdc68b4155305494$export$34e0f9847d4c02dd = "obzAtW_container";
$cdc68b4155305494$export$c869496b69afe520 = "obzAtW_star";
$cdc68b4155305494$export$4d325103b88b79bf = "obzAtW_starOff";
$cdc68b4155305494$export$a715f47ba6042dad = "obzAtW_starOn";


var $c4905fef9a86a34d$export$5e19b9354e495cb9 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function(props) {
    var _loop = function(i) {
        var isOn = i <= rating;
        var className = isOn ? $cdc68b4155305494$export$a715f47ba6042dad : $cdc68b4155305494$export$4d325103b88b79bf;
        var classes = [
            $cdc68b4155305494$export$c869496b69afe520,
            className
        ].join(" ");
        stars.push((0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
            className: classes,
            iconSys: "star",
            onClick: function() {
                props.onChange(i);
            },
            onHold: function() {
                props.onChange(-1);
            }
        }, i));
    };
    var rating = props.rating, onChange = props.onChange;
    var stars = [];
    for(var i = 1; i <= 5; i++)_loop(i);
    return (0, $978b871a0234f592$exports.jsx)("div", {
        className: $cdc68b4155305494$export$34e0f9847d4c02dd,
        children: stars
    });
});





var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");


var $33gHU = parcelRequire("33gHU");


"use client";
function $83dbfa5be47e34f1$export$2ed43d61a0a9f5a3(_param) {
    var as = _param.as, bsPrefix = _param.bsPrefix, className = _param.className, props = (0, $6JqHh._)(_param, [
        "as",
        "bsPrefix",
        "className"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "col");
    var breakpoints = (0, $48ea4dae63926a21$export$8970c8db816a5863)();
    var minBreakpoint = (0, $48ea4dae63926a21$export$d926d6ef38f3fd32)();
    var spans = [];
    var classes = [];
    breakpoints.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var span;
        var offset;
        var order;
        var ref;
        if (typeof propValue === "object" && propValue != null) ref = propValue, span = ref.span, offset = ref.offset, order = ref.order, ref;
        else span = propValue;
        var infix = brkPoint !== minBreakpoint ? "-".concat(brkPoint) : "";
        if (span) spans.push(span === true ? "".concat(bsPrefix).concat(infix) : "".concat(bsPrefix).concat(infix, "-").concat(span));
        if (order != null) classes.push("order".concat(infix, "-").concat(order));
        if (offset != null) classes.push("offset".concat(infix, "-").concat(offset));
    });
    return [
        (0, $ddevm._)((0, $78DQ7._)({}, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports))).apply(void 0, [
                className
            ].concat((0, $3jzhD._)(spans), (0, $3jzhD._)(classes)))
        }),
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
var $83dbfa5be47e34f1$var$Col = /*#__PURE__*/ $33gHU.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function(props, ref) {
    var _useCol = $83dbfa5be47e34f1$export$2ed43d61a0a9f5a3(props), _useCol1 = (0, $2MTYX._)(_useCol, 2), className = _useCol1[0].className, _useCol_ = _useCol1[1], tmp = _useCol_.as, Component = tmp === void 0 ? "div" : tmp, bsPrefix = _useCol_.bsPrefix, spans = _useCol_.spans, colProps = (0, $6JqHh._)(_useCol[0], [
        "className"
    ]);
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({}, colProps), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, !spans.length && bsPrefix)
    }));
});
$83dbfa5be47e34f1$var$Col.displayName = "Col";
var $83dbfa5be47e34f1$export$2e2bcd8739ae039 = $83dbfa5be47e34f1$var$Col;


var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");


"use client";
var $1bd9a712a9bb924e$var$Container = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, _param_fluid = _param.fluid, fluid = _param_fluid === void 0 ? false : _param_fluid, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "div" : tmp, className = _param.className, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "fluid",
        "as",
        "className"
    ]);
    var prefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "container");
    var suffix = typeof fluid === "string" ? "-".concat(fluid) : "-fluid";
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, fluid ? "".concat(prefix).concat(suffix) : prefix)
    }));
});
$1bd9a712a9bb924e$var$Container.displayName = "Container";
var $1bd9a712a9bb924e$export$2e2bcd8739ae039 = $1bd9a712a9bb924e$var$Container;


var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");



var $33gHU = parcelRequire("33gHU");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");


var $a8e103087c89fcbf$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).elementType
};
var $a8e103087c89fcbf$var$Feedback = /*#__PURE__*/ $33gHU.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function(_param, ref) {
    var tmp = _param.as, Component = tmp === void 0 ? "div" : tmp, className = _param.className, _param_type = _param.type, type = _param_type === void 0 ? "valid" : _param_type, _param_tooltip = _param.tooltip, tooltip = _param_tooltip === void 0 ? false : _param_tooltip, props = (0, $6JqHh._)(_param, [
        "as",
        "className",
        "type",
        "tooltip"
    ]);
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, "".concat(type, "-").concat(tooltip ? "tooltip" : "feedback"))
    }));
});
$a8e103087c89fcbf$var$Feedback.displayName = "Feedback";
$a8e103087c89fcbf$var$Feedback.propTypes = $a8e103087c89fcbf$var$propTypes;
var $a8e103087c89fcbf$export$2e2bcd8739ae039 = $a8e103087c89fcbf$var$Feedback;



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");

var $33gHU = parcelRequire("33gHU");
"use client";
// TODO
var $81be4e0e673b643f$var$FormContext = /*#__PURE__*/ $33gHU.createContext({});
var $81be4e0e673b643f$export$2e2bcd8739ae039 = $81be4e0e673b643f$var$FormContext;




"use client";
var $490176695dbad129$var$FormCheckInput = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var id = _param.id, bsPrefix = _param.bsPrefix, className = _param.className, _param_type = _param.type, type = _param_type === void 0 ? "checkbox" : _param_type, _param_isValid = _param.isValid, isValid = _param_isValid === void 0 ? false : _param_isValid, _param_isInvalid = _param.isInvalid, isInvalid = _param_isInvalid === void 0 ? false : _param_isInvalid, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "input" : tmp, props = (0, $6JqHh._)(_param, [
        "id",
        "bsPrefix",
        "className",
        "type",
        "isValid",
        "isInvalid",
        "as"
    ]);
    var controlId = (0, $33gHU.useContext)((0, $81be4e0e673b643f$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "form-check-input");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({}, props), {
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, isValid && "is-valid", isInvalid && "is-invalid")
    }));
});
$490176695dbad129$var$FormCheckInput.displayName = "FormCheckInput";
var $490176695dbad129$export$2e2bcd8739ae039 = $490176695dbad129$var$FormCheckInput;



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");



"use client";
var $dd27d3826d680501$var$FormCheckLabel = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, htmlFor = _param.htmlFor, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "htmlFor"
    ]);
    var controlId = (0, $33gHU.useContext)((0, $81be4e0e673b643f$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "form-check-label");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("label", (0, $ddevm._)((0, $78DQ7._)({}, props), {
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }));
});
$dd27d3826d680501$var$FormCheckLabel.displayName = "FormCheckLabel";
var $dd27d3826d680501$export$2e2bcd8739ae039 = $dd27d3826d680501$var$FormCheckLabel;





var $33gHU = parcelRequire("33gHU");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $38d6ff3a46253fc4$export$871de8747c9eaa88(children, func) {
    var index = 0;
    return $33gHU.Children.map(children, function(child) {
        return /*#__PURE__*/ $33gHU.isValidElement(child) ? func(child, index++) : child;
    });
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $38d6ff3a46253fc4$export$4b80e395e36b5a56(children, func) {
    var index = 0;
    $33gHU.Children.forEach(children, function(child) {
        if (/*#__PURE__*/ $33gHU.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $38d6ff3a46253fc4$export$500fd6099226ffae(children, type) {
    return $33gHU.Children.toArray(children).some(function(child) {
        return /*#__PURE__*/ $33gHU.isValidElement(child) && child.type === type;
    });
}



"use client";
var $d02f5932f1ea810e$var$FormCheck = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var id = _param.id, bsPrefix = _param.bsPrefix, bsSwitchPrefix = _param.bsSwitchPrefix, _param_inline = _param.inline, inline = _param_inline === void 0 ? false : _param_inline, _param_reverse = _param.reverse, reverse = _param_reverse === void 0 ? false : _param_reverse, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_isValid = _param.isValid, isValid = _param_isValid === void 0 ? false : _param_isValid, _param_isInvalid = _param.isInvalid, isInvalid = _param_isInvalid === void 0 ? false : _param_isInvalid, _param_feedbackTooltip = _param.feedbackTooltip, feedbackTooltip = _param_feedbackTooltip === void 0 ? false : _param_feedbackTooltip, feedback = _param.feedback, feedbackType = _param.feedbackType, className = _param.className, style = _param.style, _param_title = _param.title, title = _param_title === void 0 ? "" : _param_title, _param_type = _param.type, type = _param_type === void 0 ? "checkbox" : _param_type, label = _param.label, children = _param.children, _param_as = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, as = _param_as === void 0 ? "input" : _param_as, props = (0, $6JqHh._)(_param, [
        "id",
        "bsPrefix",
        "bsSwitchPrefix",
        "inline",
        "reverse",
        "disabled",
        "isValid",
        "isInvalid",
        "feedbackTooltip",
        "feedback",
        "feedbackType",
        "className",
        "style",
        "title",
        "type",
        "label",
        "children",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "form-check");
    bsSwitchPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsSwitchPrefix, "form-switch");
    var controlId = (0, $33gHU.useContext)((0, $81be4e0e673b643f$export$2e2bcd8739ae039)).controlId;
    var innerFormContext = (0, $33gHU.useMemo)(function() {
        return {
            controlId: id || controlId
        };
    }, [
        controlId,
        id
    ]);
    var hasLabel = !children && label != null && label !== false || (0, $38d6ff3a46253fc4$export$500fd6099226ffae)(children, (0, $dd27d3826d680501$export$2e2bcd8739ae039));
    var input = /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $490176695dbad129$export$2e2bcd8739ae039), (0, $ddevm._)((0, $78DQ7._)({}, props), {
        type: type === "switch" ? "checkbox" : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    }));
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $81be4e0e673b643f$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, hasLabel && bsPrefix, inline && "".concat(bsPrefix, "-inline"), reverse && "".concat(bsPrefix, "-reverse"), type === "switch" && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)((0, $978b871a0234f592$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $dd27d3826d680501$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $a8e103087c89fcbf$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$d02f5932f1ea810e$var$FormCheck.displayName = "FormCheck";
var $d02f5932f1ea810e$export$2e2bcd8739ae039 = Object.assign($d02f5932f1ea810e$var$FormCheck, {
    Input: (0, $490176695dbad129$export$2e2bcd8739ae039),
    Label: (0, $dd27d3826d680501$export$2e2bcd8739ae039)
});



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");
var $7b1e807e6b1a71ff$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $7b1e807e6b1a71ff$var$__DEV__ = false;
var $7b1e807e6b1a71ff$var$warning = function warning() {};
if ($7b1e807e6b1a71ff$var$__DEV__) {
    var $7b1e807e6b1a71ff$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $7b1e807e6b1a71ff$var$warning = function warning(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $7b1e807e6b1a71ff$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$7b1e807e6b1a71ff$exports = $7b1e807e6b1a71ff$var$warning;






"use client";
var $c797de4a8fd07b82$var$FormControl = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, type = _param.type, size = _param.size, htmlSize = _param.htmlSize, id = _param.id, className = _param.className, _param_isValid = _param.isValid, isValid = _param_isValid === void 0 ? false : _param_isValid, _param_isInvalid = _param.isInvalid, isInvalid = _param_isInvalid === void 0 ? false : _param_isInvalid, plaintext = _param.plaintext, readOnly = _param.readOnly, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "input" : tmp, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "type",
        "size",
        "htmlSize",
        "id",
        "className",
        "isValid",
        "isInvalid",
        "plaintext",
        "readOnly",
        "as"
    ]);
    var controlId = (0, $33gHU.useContext)((0, $81be4e0e673b643f$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "form-control");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({}, props), {
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, plaintext ? "".concat(bsPrefix, "-plaintext") : bsPrefix, size && "".concat(bsPrefix, "-").concat(size), type === "color" && "".concat(bsPrefix, "-color"), isValid && "is-valid", isInvalid && "is-invalid")
    }));
});
$c797de4a8fd07b82$var$FormControl.displayName = "FormControl";
var $c797de4a8fd07b82$export$2e2bcd8739ae039 = Object.assign($c797de4a8fd07b82$var$FormControl, {
    Feedback: (0, $a8e103087c89fcbf$export$2e2bcd8739ae039)
});



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");



"use client";
var $a79acbb91514f5f7$var$FormFloating = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? "div" : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "form-floating");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$a79acbb91514f5f7$var$FormFloating.displayName = "FormFloating";
var $a79acbb91514f5f7$export$2e2bcd8739ae039 = $a79acbb91514f5f7$var$FormFloating;



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");


var $075a32e8f328f094$var$FormGroup = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var controlId = _param.controlId, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "div" : tmp, props = (0, $6JqHh._)(_param, [
        "controlId",
        "as"
    ]);
    var context = (0, $33gHU.useMemo)(function() {
        return {
            controlId: controlId
        };
    }, [
        controlId
    ]);
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $81be4e0e673b643f$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({}, props), {
            ref: ref
        }))
    });
});
$075a32e8f328f094$var$FormGroup.displayName = "FormGroup";
var $075a32e8f328f094$export$2e2bcd8739ae039 = $075a32e8f328f094$var$FormGroup;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");





"use client";
var $af79a2cc19742e66$var$FormLabel = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "label" : tmp, bsPrefix = _param.bsPrefix, _param_column = _param.column, column = _param_column === void 0 ? false : _param_column, _param_visuallyHidden = _param.visuallyHidden, visuallyHidden = _param_visuallyHidden === void 0 ? false : _param_visuallyHidden, className = _param.className, htmlFor = _param.htmlFor, props = (0, $6JqHh._)(_param, [
        "as",
        "bsPrefix",
        "column",
        "visuallyHidden",
        "className",
        "htmlFor"
    ]);
    var controlId = (0, $33gHU.useContext)((0, $81be4e0e673b643f$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "form-label");
    var columnClass = "col-form-label";
    if (typeof column === "string") columnClass = "".concat(columnClass, " ").concat(columnClass, "-").concat(column);
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, visuallyHidden && "visually-hidden", column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), (0, $78DQ7._)({
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor
    }, props));
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: classes,
        htmlFor: htmlFor
    }, props)));
});
$af79a2cc19742e66$var$FormLabel.displayName = "FormLabel";
var $af79a2cc19742e66$export$2e2bcd8739ae039 = $af79a2cc19742e66$var$FormLabel;



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");



"use client";
var $b720cd28057f8032$var$FormRange = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, id = _param.id, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "id"
    ]);
    var controlId = (0, $33gHU.useContext)((0, $81be4e0e673b643f$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "form-range");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("input", (0, $ddevm._)((0, $78DQ7._)({}, props), {
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        id: id || controlId
    }));
});
$b720cd28057f8032$var$FormRange.displayName = "FormRange";
var $b720cd28057f8032$export$2e2bcd8739ae039 = $b720cd28057f8032$var$FormRange;



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");



"use client";
var $60d4ab2ae6861dbb$var$FormSelect = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, size = _param.size, htmlSize = _param.htmlSize, className = _param.className, _param_isValid = _param.isValid, isValid = _param_isValid === void 0 ? false : _param_isValid, _param_isInvalid = _param.isInvalid, isInvalid = _param_isInvalid === void 0 ? false : _param_isInvalid, id = _param.id, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "size",
        "htmlSize",
        "className",
        "isValid",
        "isInvalid",
        "id"
    ]);
    var controlId = (0, $33gHU.useContext)((0, $81be4e0e673b643f$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "form-select");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("select", (0, $ddevm._)((0, $78DQ7._)({}, props), {
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, size && "".concat(bsPrefix, "-").concat(size), isValid && "is-valid", isInvalid && "is-invalid"),
        id: id || controlId
    }));
});
$60d4ab2ae6861dbb$var$FormSelect.displayName = "FormSelect";
var $60d4ab2ae6861dbb$export$2e2bcd8739ae039 = $60d4ab2ae6861dbb$var$FormSelect;



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");


"use client";
var $229587f5e4e4ee8a$var$FormText = /*#__PURE__*/ $33gHU.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, tmp = _param.as, Component = tmp === void 0 ? "small" : tmp, muted = _param.muted, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "as",
        "muted"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "form-text");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, muted && "text-muted")
    }));
});
$229587f5e4e4ee8a$var$FormText.displayName = "FormText";
var $229587f5e4e4ee8a$export$2e2bcd8739ae039 = $229587f5e4e4ee8a$var$FormText;



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $33gHU = parcelRequire("33gHU");


var $ee3ad3a2d03ca4c6$var$Switch = /*#__PURE__*/ $33gHU.forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $d02f5932f1ea810e$export$2e2bcd8739ae039), (0, $ddevm._)((0, $78DQ7._)({}, props), {
        ref: ref,
        type: "switch"
    }));
});
$ee3ad3a2d03ca4c6$var$Switch.displayName = "Switch";
var $ee3ad3a2d03ca4c6$export$2e2bcd8739ae039 = Object.assign($ee3ad3a2d03ca4c6$var$Switch, {
    Input: (0, $d02f5932f1ea810e$export$2e2bcd8739ae039).Input,
    Label: (0, $d02f5932f1ea810e$export$2e2bcd8739ae039).Label
});



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");



"use client";
var $58d39b6a253eccc2$var$FloatingLabel = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, children = _param.children, controlId = _param.controlId, label = _param.label, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "children",
        "controlId",
        "label"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "form-floating");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)((0, $075a32e8f328f094$export$2e2bcd8739ae039), (0, $ddevm._)((0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        controlId: controlId
    }, props), {
        children: [
            children,
            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    }));
});
$58d39b6a253eccc2$var$FloatingLabel.displayName = "FloatingLabel";
var $58d39b6a253eccc2$export$2e2bcd8739ae039 = $58d39b6a253eccc2$var$FloatingLabel;



var $27113019bb4d8c5e$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).elementType
};
var $27113019bb4d8c5e$var$Form = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, validated = _param.validated, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "form" : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "validated",
        "as"
    ]);
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, validated && "was-validated")
    }));
});
$27113019bb4d8c5e$var$Form.displayName = "Form";
$27113019bb4d8c5e$var$Form.propTypes = $27113019bb4d8c5e$var$propTypes;
var $27113019bb4d8c5e$export$2e2bcd8739ae039 = Object.assign($27113019bb4d8c5e$var$Form, {
    Group: (0, $075a32e8f328f094$export$2e2bcd8739ae039),
    Control: (0, $c797de4a8fd07b82$export$2e2bcd8739ae039),
    Floating: (0, $a79acbb91514f5f7$export$2e2bcd8739ae039),
    Check: (0, $d02f5932f1ea810e$export$2e2bcd8739ae039),
    Switch: (0, $ee3ad3a2d03ca4c6$export$2e2bcd8739ae039),
    Label: (0, $af79a2cc19742e66$export$2e2bcd8739ae039),
    Text: (0, $229587f5e4e4ee8a$export$2e2bcd8739ae039),
    Range: (0, $b720cd28057f8032$export$2e2bcd8739ae039),
    Select: (0, $60d4ab2ae6861dbb$export$2e2bcd8739ae039),
    FloatingLabel: (0, $58d39b6a253eccc2$export$2e2bcd8739ae039)
});


var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $3jzhD = parcelRequire("3jzhD");


var $33gHU = parcelRequire("33gHU");


"use client";
var $4e74b20dea0154e3$var$Row = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "div" : tmp, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "as"
    ]);
    var decoratedBsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "row");
    var breakpoints = (0, $48ea4dae63926a21$export$8970c8db816a5863)();
    var minBreakpoint = (0, $48ea4dae63926a21$export$d926d6ef38f3fd32)();
    var sizePrefix = "".concat(decoratedBsPrefix, "-cols");
    var classes = [];
    breakpoints.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var cols;
        if (propValue != null && typeof propValue === "object") cols = propValue.cols;
        else cols = propValue;
        var infix = brkPoint !== minBreakpoint ? "-".concat(brkPoint) : "";
        if (cols != null) classes.push("".concat(sizePrefix).concat(infix, "-").concat(cols));
    });
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports))).apply(void 0, [
            className,
            decoratedBsPrefix
        ].concat((0, $3jzhD._)(classes)))
    }));
});
$4e74b20dea0154e3$var$Row.displayName = "Row";
var $4e74b20dea0154e3$export$2e2bcd8739ae039 = $4e74b20dea0154e3$var$Row;






var $bb3b19e74b904070$export$89da14300d534261;
$bb3b19e74b904070$export$89da14300d534261 = "dp5D1a_active";


var $b66213428011f518$export$950d91f2b2755282 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var icons = (0, $3a3345637c0a5d6f$export$bd973f06e9aaec8c)().contentIcons;
    var types = Object.values(icons);
    var f = (0, $3a3345637c0a5d6f$export$3b5bae399c8431fb)().filterUI;
    return (0, $978b871a0234f592$exports.jsx)("div", {
        className: "d-flex flex-wrap",
        children: types.map(function(icon) {
            var cls = "";
            if (icon.name === f.contentType) cls = $bb3b19e74b904070$export$89da14300d534261;
            return (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
                src: icon.url,
                className: cls,
                onClick: function() {
                    if (f.contentType === icon.name) f.contentType = null;
                    else f.contentType = icon.name;
                }
            }, icon.name);
        })
    });
});


var $b50181f6fa4fa794$export$89da14300d534261;
$b50181f6fa4fa794$export$89da14300d534261 = "oI51yG_active";


var $e15a784e73dfda08$export$2155bf5d7b679f80 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var filter = (0, $3a3345637c0a5d6f$export$3b5bae399c8431fb)().filterUI;
    return (0, $978b871a0234f592$exports.jsxs)((0, $1bd9a712a9bb924e$export$2e2bcd8739ae039), {
        children: [
            (0, $978b871a0234f592$exports.jsx)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                children: (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                    className: "p-3",
                    children: (0, $978b871a0234f592$exports.jsx)((0, $27113019bb4d8c5e$export$2e2bcd8739ae039).Control, {
                        type: "text",
                        placeholder: "Name",
                        value: filter.search,
                        onChange: function(e) {
                            filter.search = e.target.value;
                        }
                    })
                })
            }),
            (0, $978b871a0234f592$exports.jsx)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                children: (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                    className: "p-3",
                    children: (0, $978b871a0234f592$exports.jsx)((0, $b66213428011f518$export$950d91f2b2755282), {})
                })
            }),
            (0, $978b871a0234f592$exports.jsx)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                children: (0, $978b871a0234f592$exports.jsxs)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                    className: "p-3",
                    children: [
                        (0, $978b871a0234f592$exports.jsx)((0, $c4905fef9a86a34d$export$5e19b9354e495cb9), {
                            rating: filter.rating,
                            onChange: function(r) {
                                filter.rating = r;
                            }
                        }),
                        (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
                            className: filter.show_only_not_rated ? $b50181f6fa4fa794$export$89da14300d534261 : "",
                            iconSys: "no",
                            onClick: function() {
                                filter.show_only_not_rated = !filter.show_only_not_rated;
                            }
                        }),
                        (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
                            iconSys: filter.show_watch_soon ? "heart-yes-filled" : "heart-yes",
                            onClick: function() {
                                filter.show_watch_soon = !filter.show_watch_soon;
                            }
                        })
                    ]
                })
            })
        ]
    });
});


var $e39661be72f50399$export$c9554889b3e706cd = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var modalStore = (0, $3a3345637c0a5d6f$export$33ffd74ebf07f060)();
    var icons = (0, $3a3345637c0a5d6f$export$bd973f06e9aaec8c)().taskIcons;
    var iconKeys = Object.keys(icons).sort();
    var show = modalStore.activeModal != "None";
    var modalUILookup = {
        None: (0, $978b871a0234f592$exports.jsx)("div", {}),
        IconSelect: (0, $978b871a0234f592$exports.jsx)((0, $012ec664521eefe4$export$2e2bcd8739ae039), {}),
        ViewAttachment: (0, $978b871a0234f592$exports.jsx)((0, $3055a4e97dac36e4$export$2e2bcd8739ae039), {}),
        ModalFilter: (0, $978b871a0234f592$exports.jsx)((0, $e15a784e73dfda08$export$2155bf5d7b679f80), {})
    };
    var handleClose = function() {
        modalStore.closeModal();
    };
    var uiElem = modalUILookup[modalStore.activeModal];
    return (0, $978b871a0234f592$exports.jsx)((0, $978b871a0234f592$exports.Fragment), {
        children: (0, $978b871a0234f592$exports.jsxs)((0, $fc5d520cd5b7a226$export$2e2bcd8739ae039), {
            show: show,
            onHide: handleClose,
            children: [
                (0, $978b871a0234f592$exports.jsx)((0, $fc5d520cd5b7a226$export$2e2bcd8739ae039).Header, {
                    closeButton: true,
                    children: (0, $978b871a0234f592$exports.jsx)((0, $fc5d520cd5b7a226$export$2e2bcd8739ae039).Title, {
                        children: modalStore.modalTitle
                    })
                }),
                (0, $978b871a0234f592$exports.jsx)((0, $fc5d520cd5b7a226$export$2e2bcd8739ae039).Body, {
                    children: uiElem
                }),
                (0, $978b871a0234f592$exports.jsx)((0, $fc5d520cd5b7a226$export$2e2bcd8739ae039).Footer, {
                    children: (0, $978b871a0234f592$exports.jsx)((0, $91cc833ad6e8123a$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        onClick: handleClose,
                        children: "Close"
                    })
                })
            ]
        })
    });
});
var $e39661be72f50399$export$2e2bcd8739ae039 = $e39661be72f50399$export$c9554889b3e706cd;







var $c5rwh = parcelRequire("c5rwh");

var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $3c47593a1ff7bff1$exports = {};
"use strict";
Object.defineProperty($3c47593a1ff7bff1$exports, "__esModule", {
    value: true
});
$3c47593a1ff7bff1$exports.default = $3c47593a1ff7bff1$var$all;
var $852f889b038baec1$exports = {};
"use strict";
Object.defineProperty($852f889b038baec1$exports, "__esModule", {
    value: true
});
$852f889b038baec1$exports.default = $852f889b038baec1$var$createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ // Mostly taken from ReactPropTypes.
function $852f889b038baec1$var$createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || "<<anonymous>>";
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
            if (isRequired) return new Error("Required " + location + " `" + propFullNameSafe + "` was not specified " + ("in `" + componentNameSafe + "`."));
            return null;
        }
        for(var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)args[_key - 6] = arguments[_key];
        return validate.apply(undefined, [
            props,
            propName,
            componentNameSafe,
            location,
            propFullNameSafe
        ].concat(args));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
$852f889b038baec1$exports = $852f889b038baec1$exports["default"];


var $3c47593a1ff7bff1$var$_createChainableTypeChecker2 = $3c47593a1ff7bff1$var$_interopRequireDefault($852f889b038baec1$exports);
function $3c47593a1ff7bff1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3c47593a1ff7bff1$var$all() {
    for(var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++)validators[_key] = arguments[_key];
    function allPropTypes() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var error = null;
        validators.forEach(function(validator) {
            if (error != null) return;
            var result = validator.apply(undefined, args);
            if (result != null) error = result;
        });
        return error;
    }
    return (0, $3c47593a1ff7bff1$var$_createChainableTypeChecker2.default)(allPropTypes);
}
$3c47593a1ff7bff1$exports = $3c47593a1ff7bff1$exports["default"];



var $33gHU = parcelRequire("33gHU");

var $gnDeW = parcelRequire("gnDeW");
function $5477a86d46e8f81e$export$2e2bcd8739ae039() {
    return $5477a86d46e8f81e$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5477a86d46e8f81e$export$2e2bcd8739ae039.apply(null, arguments);
}




var $33gHU = parcelRequire("33gHU");
var $81648fdbf254d6a1$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $81648fdbf254d6a1$var$invariant = function invariant(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$81648fdbf254d6a1$exports = $81648fdbf254d6a1$var$invariant;


var $e7681817367964c8$var$noop = function noop() {};
function $e7681817367964c8$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $e7681817367964c8$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $e7681817367964c8$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$e7681817367964c8$export$26cbf8c37e721e67(prop)] = $e7681817367964c8$var$noop;
        var handler;
    });
    return propTypes;
}
function $e7681817367964c8$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $e7681817367964c8$export$26cbf8c37e721e67(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $e7681817367964c8$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== "function" || component.prototype && component.prototype.isReactComponent);
}


function $b0f4ffe1e3920233$var$_toPropertyKey(arg) {
    var key = $b0f4ffe1e3920233$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $gnDeW._)(key)) === "symbol" ? key : String(key);
}
function $b0f4ffe1e3920233$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b0f4ffe1e3920233$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $33gHU.useRef)(propValue !== undefined);
    var _useState = (0, $33gHU.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $33gHU.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $b0f4ffe1e3920233$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$e7681817367964c8$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $ec72bb6bbc83bb88$export$2e2bcd8739ae039)(_ref, [
            $e7681817367964c8$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($b0f4ffe1e3920233$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $b0f4ffe1e3920233$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $5477a86d46e8f81e$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}






var $33gHU = parcelRequire("33gHU");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c235d951ddc27ab7$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c235d951ddc27ab7$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c235d951ddc27ab7$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c235d951ddc27ab7$var$componentWillMount.__suppressDeprecationWarning = true;
$c235d951ddc27ab7$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c235d951ddc27ab7$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c235d951ddc27ab7$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $c235d951ddc27ab7$var$componentWillMount;
        prototype.componentWillReceiveProps = $c235d951ddc27ab7$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $c235d951ddc27ab7$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $e3ad9cc861f13472$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $e3ad9cc861f13472$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || "Component";
    var canAcceptRef = $e7681817367964c8$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($e7681817367964c8$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($81648fdbf254d6a1$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $f68b40d769d616a2$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $5477a86d46e8f81e$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$e7681817367964c8$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $5477a86d46e8f81e$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$e7681817367964c8$export$12ae2baa35bd9b8b(props, key) && $e7681817367964c8$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$e7681817367964c8$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $ec72bb6bbc83bb88$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement(Component, (0, $5477a86d46e8f81e$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).Component);
    (0, $c235d951ddc27ab7$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $5477a86d46e8f81e$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $e7681817367964c8$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement(UncontrolledComponent, (0, $5477a86d46e8f81e$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $e3ad9cc861f13472$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $e3ad9cc861f13472$export$2e2bcd8739ae039(newComponent, (0, $5477a86d46e8f81e$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}






var $33gHU = parcelRequire("33gHU");

var $2MTYX = parcelRequire("2MTYX");

var $33gHU = parcelRequire("33gHU");
function $7bd5d7a67f11e31b$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    var _useReducer = (0, $2MTYX._)((0, $33gHU.useReducer)(function(state) {
        return !state;
    }, false), 2), dispatch = _useReducer[1];
    return dispatch;
}




var $33gHU = parcelRequire("33gHU");
var $023d6c7d475cb822$var$NavContext = /*#__PURE__*/ $33gHU.createContext(null);
$023d6c7d475cb822$var$NavContext.displayName = "NavContext";
var $023d6c7d475cb822$export$2e2bcd8739ae039 = $023d6c7d475cb822$var$NavContext;



var $33gHU = parcelRequire("33gHU");
var $8bb37319c3c01fa2$var$SelectableContext = /*#__PURE__*/ $33gHU.createContext(null);
var $8bb37319c3c01fa2$export$eef49b42fde998a3 = function(eventKey) {
    var href = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $8bb37319c3c01fa2$export$2e2bcd8739ae039 = $8bb37319c3c01fa2$var$SelectableContext;



var $33gHU = parcelRequire("33gHU");
var $c9df203f625706fd$var$TabContext = /*#__PURE__*/ $33gHU.createContext(null);
var $c9df203f625706fd$export$2e2bcd8739ae039 = $c9df203f625706fd$var$TabContext;




var $2MTYX = parcelRequire("2MTYX");

var $33gHU = parcelRequire("33gHU");







var $0fa6f5034e31284e$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $0fa6f5034e31284e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0fa6f5034e31284e$export$d7a68693710982a(param) {
    var key = param.key, onClick = param.onClick, active = param.active, id = param.id, role = param.role, disabled = param.disabled;
    var parentOnSelect = (0, $33gHU.useContext)((0, $8bb37319c3c01fa2$export$2e2bcd8739ae039));
    var navContext = (0, $33gHU.useContext)((0, $023d6c7d475cb822$export$2e2bcd8739ae039));
    var tabContext = (0, $33gHU.useContext)((0, $c9df203f625706fd$export$2e2bcd8739ae039));
    var isActive = active;
    var props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === "tablist") props.role = "tab";
        var contextControllerId = navContext.getControllerId(key != null ? key : null);
        var contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $162a9cd685a6cce4$export$5cc3b7b83e34ade7)("event-key")] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props["aria-controls"] = contextControlledId;
    }
    if (props.role === "tab") {
        props["aria-selected"] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props["aria-disabled"] = true;
        }
    }
    props.onClick = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function(e) {
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
var $0fa6f5034e31284e$var$NavItem = /*#__PURE__*/ $33gHU.forwardRef(function(_ref, ref) {
    var tmp = _ref.as, Component = tmp === void 0 ? (0, $9c3ffb28ddbab696$export$2e2bcd8739ae039) : tmp, active = _ref.active, eventKey = _ref.eventKey, options = $0fa6f5034e31284e$var$_objectWithoutPropertiesLoose(_ref, $0fa6f5034e31284e$var$_excluded);
    var _useNavItem = (0, $2MTYX._)($0fa6f5034e31284e$export$d7a68693710982a(Object.assign({
        key: (0, $8bb37319c3c01fa2$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options)), 2), props = _useNavItem[0], meta = _useNavItem[1];
    // @ts-ignore
    props[(0, $162a9cd685a6cce4$export$5cc3b7b83e34ade7)("active")] = meta.isActive;
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$0fa6f5034e31284e$var$NavItem.displayName = "NavItem";
var $0fa6f5034e31284e$export$2e2bcd8739ae039 = $0fa6f5034e31284e$var$NavItem;



var $b78abd43e69ea94a$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $b78abd43e69ea94a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
var $b78abd43e69ea94a$var$noop = function() {};
var $b78abd43e69ea94a$var$EVENT_KEY_ATTR = (0, $162a9cd685a6cce4$export$5cc3b7b83e34ade7)("event-key");
var $b78abd43e69ea94a$var$Nav = /*#__PURE__*/ $33gHU.forwardRef(function(_ref, ref) {
    var tmp = _ref.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "div" : tmp, onSelect = _ref.onSelect, activeKey = _ref.activeKey, role = _ref.role, onKeyDown = _ref.onKeyDown, props = $b78abd43e69ea94a$var$_objectWithoutPropertiesLoose(_ref, $b78abd43e69ea94a$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    var forceUpdate = (0, $7bd5d7a67f11e31b$export$2e2bcd8739ae039)();
    var needsRefocusRef = (0, $33gHU.useRef)(false);
    var parentOnSelect = (0, $33gHU.useContext)((0, $8bb37319c3c01fa2$export$2e2bcd8739ae039));
    var tabContext = (0, $33gHU.useContext)((0, $c9df203f625706fd$export$2e2bcd8739ae039));
    var getControlledId, getControllerId;
    if (tabContext) {
        role = role || "tablist";
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    var listNode = (0, $33gHU.useRef)(null);
    var getNextActiveTab = function(offset) {
        var currentListNode = listNode.current;
        if (!currentListNode) return null;
        var items = (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(currentListNode, "[".concat($b78abd43e69ea94a$var$EVENT_KEY_ATTR, "]:not([aria-disabled=true])"));
        var activeChild = currentListNode.querySelector("[aria-selected=true]");
        if (!activeChild || activeChild !== document.activeElement) return null;
        var index = items.indexOf(activeChild);
        if (index === -1) return null;
        var nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    var handleSelect = function(key, event) {
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    var handleKeyDown = function(event) {
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        var nextActiveChild;
        switch(event.key){
            case "ArrowLeft":
            case "ArrowUp":
                nextActiveChild = getNextActiveTab(-1);
                break;
            case "ArrowRight":
            case "ArrowDown":
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $162a9cd685a6cce4$export$7776c0a7cd2eb3e0)("EventKey")] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $33gHU.useEffect)(function() {
        if (listNode.current && needsRefocusRef.current) {
            var activeChild = listNode.current.querySelector("[".concat($b78abd43e69ea94a$var$EVENT_KEY_ATTR, "][aria-selected=true]"));
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    var mergedRef = (0, $0bc64fd3b15ed530$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $8bb37319c3c01fa2$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $023d6c7d475cb822$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $8bb37319c3c01fa2$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $b78abd43e69ea94a$var$noop,
                getControllerId: getControllerId || $b78abd43e69ea94a$var$noop
            },
            children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$b78abd43e69ea94a$var$Nav.displayName = "Nav";
var $b78abd43e69ea94a$export$2e2bcd8739ae039 = Object.assign($b78abd43e69ea94a$var$Nav, {
    Item: (0, $0fa6f5034e31284e$export$2e2bcd8739ae039)
});




var $33gHU = parcelRequire("33gHU");
"use client";
// TODO: check
var $5f48e6ab02225624$var$context = /*#__PURE__*/ $33gHU.createContext(null);
$5f48e6ab02225624$var$context.displayName = "NavbarContext";
var $5f48e6ab02225624$export$2e2bcd8739ae039 = $5f48e6ab02225624$var$context;



var $33gHU = parcelRequire("33gHU");
"use client";
var $fddc3b669f55ae8e$var$context = /*#__PURE__*/ $33gHU.createContext(null);
$fddc3b669f55ae8e$var$context.displayName = "CardHeaderContext";
var $fddc3b669f55ae8e$export$2e2bcd8739ae039 = $fddc3b669f55ae8e$var$context;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");



"use client";
var $65a94e48ad7cbc52$var$NavItem = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? "div" : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "nav-item");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$65a94e48ad7cbc52$var$NavItem.displayName = "NavItem";
var $65a94e48ad7cbc52$export$2e2bcd8739ae039 = $65a94e48ad7cbc52$var$NavItem;



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $2MTYX = parcelRequire("2MTYX");


var $33gHU = parcelRequire("33gHU");

var $2MTYX = parcelRequire("2MTYX");

var $33gHU = parcelRequire("33gHU");




var $33gHU = parcelRequire("33gHU");

function $99b6c887a840e037$export$2e2bcd8739ae039(eventTarget, event, listener) {
    var capture = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var handler = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(listener);
    (0, $33gHU.useEffect)(function() {
        var target = typeof eventTarget === "function" ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return function() {
            return target.removeEventListener(event, handler, capture);
        };
    }, [
        eventTarget
    ]);
}




var $33gHU = parcelRequire("33gHU");
function $77ca0a07f35e568f$export$2e2bcd8739ae039(event, handler) {
    var capture = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var documentTarget = (0, $33gHU.useCallback)(function() {
        return document;
    }, []);
    return (0, $99b6c887a840e037$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $33gHU = parcelRequire("33gHU");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $2df80af065450450$var$useInterval(fn, ms) {
    var paused = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, runImmediately = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var handle;
    var fnRef = (0, $671c1bffa4e831fb$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    var pausedRef = (0, $671c1bffa4e831fb$export$2e2bcd8739ae039)(paused);
    var tick = function() {
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    var schedule = function() {
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $33gHU.useEffect)(function() {
        if (runImmediately) tick();
        else schedule();
        return function() {
            return clearTimeout(handle);
        };
    }, [
        paused,
        runImmediately
    ]);
}
var $2df80af065450450$export$2e2bcd8739ae039 = $2df80af065450450$var$useInterval;



var $33gHU = parcelRequire("33gHU");

function $aac9bcfdb60ce57d$var$useRafInterval(fn, ms) {
    var paused = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var handle;
    var start = new Date().getTime();
    var fnRef = (0, $671c1bffa4e831fb$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    var pausedRef = (0, $671c1bffa4e831fb$export$2e2bcd8739ae039)(paused);
    function loop() {
        var current = new Date().getTime();
        var delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $33gHU.useEffect)(function() {
        handle = requestAnimationFrame(loop);
        return function() {
            return cancelAnimationFrame(handle);
        };
    }, []);
}
var $aac9bcfdb60ce57d$export$2e2bcd8739ae039 = $aac9bcfdb60ce57d$var$useRafInterval;



var $2MTYX = parcelRequire("2MTYX");

var $33gHU = parcelRequire("33gHU");
function $1c6680cc8f2fce76$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)(initialState), 2), state = _useState[0], setState = _useState[1];
    var updater = (0, $33gHU.useCallback)(function(update) {
        if (update === null) return;
        if (typeof update === "function") setState(function(state) {
            var nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState(function(state) {
            return Object.assign({}, state, update);
        });
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



var $2MTYX = parcelRequire("2MTYX");

function $2fb058f1a7afd48f$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    var _useMergeState = (0, $2MTYX._)((0, $1c6680cc8f2fce76$export$2e2bcd8739ae039)(initialState), 2), state = _useMergeState[0], setState = _useMergeState[1];
    var nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}





var $2MTYX = parcelRequire("2MTYX");

var $33gHU = parcelRequire("33gHU");
function $d4a0ed24d7e3290d$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)({
        image: null,
        error: null
    }), 2), state = _useState[0], setState = _useState[1];
    (0, $33gHU.useEffect)(function() {
        if (!imageOrUrl) return undefined;
        var image;
        if (typeof imageOrUrl === "string") {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener("load", onLoad);
        image.addEventListener("error", onError);
        return function() {
            image.removeEventListener("load", onLoad);
            image.removeEventListener("error", onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $2MTYX = parcelRequire("2MTYX");

var $33gHU = parcelRequire("33gHU");

var $2a173e96f2e15beb$var$targetMap = new WeakMap();
var $2a173e96f2e15beb$var$resizeObserver;
function $2a173e96f2e15beb$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $2a173e96f2e15beb$var$resizeObserver = $2a173e96f2e15beb$var$resizeObserver || new window.ResizeObserver(function(entries) {
        entries.forEach(function(entry) {
            var handler = $2a173e96f2e15beb$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $2a173e96f2e15beb$export$2e2bcd8739ae039(element) {
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)(null), 2), rect = _useState[0], setRect = _useState[1];
    (0, $5987dd645a9ebdaf$export$2e2bcd8739ae039)(function() {
        if (!element) return;
        $2a173e96f2e15beb$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $2a173e96f2e15beb$var$targetMap.set(element, function(rect) {
            setRect(rect);
        });
        return function() {
            $2a173e96f2e15beb$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






var $4e409ba5516ae23a$var$_excluded = [
    "onKeyDown"
];
function $4e409ba5516ae23a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4e409ba5516ae23a$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ var $4e409ba5516ae23a$var$Anchor = /*#__PURE__*/ $33gHU.forwardRef(function(_ref, ref) {
    var onKeyDown = _ref.onKeyDown, props = $4e409ba5516ae23a$var$_objectWithoutPropertiesLoose(_ref, $4e409ba5516ae23a$var$_excluded);
    var _useButtonProps = (0, $2MTYX._)((0, $9c3ffb28ddbab696$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: "a"
    }, props)), 1), buttonProps = _useButtonProps[0];
    var handleKeyDown = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function(e) {
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($4e409ba5516ae23a$export$72369ab2cc99204b(props.href) || props.role === "button") return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$4e409ba5516ae23a$var$Anchor.displayName = "Anchor";
var $4e409ba5516ae23a$export$2e2bcd8739ae039 = $4e409ba5516ae23a$var$Anchor;






"use client";
var $80ac238a4f777c0a$var$NavLink = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, tmp = _param.as, Component = tmp === void 0 ? (0, $4e409ba5516ae23a$export$2e2bcd8739ae039) : tmp, active = _param.active, eventKey = _param.eventKey, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "as",
        "active",
        "eventKey",
        "disabled"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "nav-link");
    var _useNavItem = (0, $2MTYX._)((0, $0fa6f5034e31284e$export$d7a68693710982a)((0, $78DQ7._)({
        key: (0, $8bb37319c3c01fa2$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled
    }, props)), 2), navItemProps = _useNavItem[0], meta = _useNavItem[1];
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({}, props, navItemProps), {
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, disabled && "disabled", meta.isActive && "active")
    }));
});
$80ac238a4f777c0a$var$NavLink.displayName = "NavLink";
var $80ac238a4f777c0a$export$2e2bcd8739ae039 = $80ac238a4f777c0a$var$NavLink;



"use client";
var $02f1267799525acb$var$Nav = /*#__PURE__*/ $33gHU.forwardRef(function(uncontrolledProps, ref) {
    var _useUncontrolled = (0, $b0f4ffe1e3920233$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: "onSelect"
    }), _useUncontrolled_as = _useUncontrolled.as, as = _useUncontrolled_as === void 0 ? "div" : _useUncontrolled_as, initialBsPrefix = _useUncontrolled.bsPrefix, variant = _useUncontrolled.variant, _useUncontrolled_fill = _useUncontrolled.fill, fill = _useUncontrolled_fill === void 0 ? false : _useUncontrolled_fill, _useUncontrolled_justify = _useUncontrolled.justify, justify = _useUncontrolled_justify === void 0 ? false : _useUncontrolled_justify, navbar = _useUncontrolled.navbar, navbarScroll = _useUncontrolled.navbarScroll, className = _useUncontrolled.className, activeKey = _useUncontrolled.activeKey, props = (0, $6JqHh._)(_useUncontrolled, [
        "as",
        "bsPrefix",
        "variant",
        "fill",
        "justify",
        "navbar",
        "navbarScroll",
        "className",
        "activeKey"
    ]);
    var bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(initialBsPrefix, "nav");
    var navbarBsPrefix;
    var cardHeaderBsPrefix;
    var isNavbar = false;
    var navbarContext = (0, $33gHU.useContext)((0, $5f48e6ab02225624$export$2e2bcd8739ae039));
    var cardHeaderContext = (0, $33gHU.useContext)((0, $fddc3b669f55ae8e$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) cardHeaderBsPrefix = cardHeaderContext.cardHeaderBsPrefix;
    var _obj;
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $b78abd43e69ea94a$export$2e2bcd8739ae039), (0, $78DQ7._)({
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, (_obj = {}, (0, $c5rwh._)(_obj, bsPrefix, !isNavbar), (0, $c5rwh._)(_obj, "".concat(navbarBsPrefix, "-nav"), isNavbar), (0, $c5rwh._)(_obj, "".concat(navbarBsPrefix, "-nav-scroll"), isNavbar && navbarScroll), (0, $c5rwh._)(_obj, "".concat(cardHeaderBsPrefix, "-").concat(variant), !!cardHeaderBsPrefix), (0, $c5rwh._)(_obj, "".concat(bsPrefix, "-").concat(variant), !!variant), (0, $c5rwh._)(_obj, "".concat(bsPrefix, "-fill"), fill), (0, $c5rwh._)(_obj, "".concat(bsPrefix, "-justified"), justify), _obj))
    }, props));
});
$02f1267799525acb$var$Nav.displayName = "Nav";
var $02f1267799525acb$export$2e2bcd8739ae039 = Object.assign($02f1267799525acb$var$Nav, {
    Item: (0, $65a94e48ad7cbc52$export$2e2bcd8739ae039),
    Link: (0, $80ac238a4f777c0a$export$2e2bcd8739ae039)
});


var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");


var $c5rwh = parcelRequire("c5rwh");

var $2MTYX = parcelRequire("2MTYX");

var $2MTYX = parcelRequire("2MTYX");


var $33gHU = parcelRequire("33gHU");
var $a15fc843198fae3b$var$matchersByWindow = new WeakMap();
var $a15fc843198fae3b$var$getMatcher = function(query, targetWindow) {
    if (!query || !targetWindow) return undefined;
    var matchers = $a15fc843198fae3b$var$matchersByWindow.get(targetWindow) || new Map();
    $a15fc843198fae3b$var$matchersByWindow.set(targetWindow, matchers);
    var mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $a15fc843198fae3b$export$2e2bcd8739ae039(query) {
    var targetWindow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : typeof window === "undefined" ? undefined : window;
    var mql = $a15fc843198fae3b$var$getMatcher(query, targetWindow);
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)(function() {
        return mql ? mql.matches : false;
    }), 2), matches = _useState[0], setMatches = _useState[1];
    (0, $5987dd645a9ebdaf$export$2e2bcd8739ae039)(function() {
        var mql = $a15fc843198fae3b$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        var matchers = $a15fc843198fae3b$var$matchersByWindow.get(targetWindow);
        var handleChange = function() {
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return function() {
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $33gHU = parcelRequire("33gHU");
function $8afa1e48619b8967$export$9c6950edc251641e(breakpointValues) {
    var names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? "".concat(query, " and ").concat(next) : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        var next = getNext(breakpoint);
        var value = breakpointValues[next];
        if (typeof value === "number") value = "".concat(value - 0.2, "px");
        else value = "calc(".concat(value, " - 0.2px)");
        return "(max-width: ".concat(value, ")");
    }
    function getMinQuery(breakpoint) {
        var value = breakpointValues[breakpoint];
        if (typeof value === "number") value = "".concat(value, "px");
        return "(min-width: ".concat(value, ")");
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        var breakpointMap;
        if (typeof breakpointOrMap === "object") {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = (0, $c5rwh._)({}, breakpointOrMap, direction);
        }
        var query = (0, $33gHU.useMemo)(function() {
            return Object.entries(breakpointMap).reduce(function(query, param) {
                var _param = (0, $2MTYX._)(param, 2), key = _param[0], _$direction = _param[1];
                if (_$direction === "up" || _$direction === true) query = and(query, getMinQuery(key));
                if (_$direction === "down" || _$direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, "");
        }, [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $a15fc843198fae3b$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
var $8afa1e48619b8967$var$useBreakpoint = $8afa1e48619b8967$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $8afa1e48619b8967$export$2e2bcd8739ae039 = $8afa1e48619b8967$var$useBreakpoint;




var $33gHU = parcelRequire("33gHU");



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");



"use client";
var $18063296336c6cdd$var$OffcanvasBody = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? "div" : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "offcanvas-body");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$18063296336c6cdd$var$OffcanvasBody.displayName = "OffcanvasBody";
var $18063296336c6cdd$export$2e2bcd8739ae039 = $18063296336c6cdd$var$OffcanvasBody;



var $c5rwh = parcelRequire("c5rwh");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");





"use client";
var $5deeb29eb256abaa$var$_obj;
var $5deeb29eb256abaa$var$transitionStyles = ($5deeb29eb256abaa$var$_obj = {}, (0, $c5rwh._)($5deeb29eb256abaa$var$_obj, (0, $5a41f7eb3d8f2f2d$export$df38205c966be359), "show"), (0, $c5rwh._)($5deeb29eb256abaa$var$_obj, (0, $5a41f7eb3d8f2f2d$export$78e9e6e3e014d60a), "show"), $5deeb29eb256abaa$var$_obj);
var $5deeb29eb256abaa$var$OffcanvasToggling = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, children = _param.children, tmp = _param.in, inProp = tmp === void 0 ? false : tmp, _param_mountOnEnter = _param.mountOnEnter, mountOnEnter = _param_mountOnEnter === void 0 ? false : _param_mountOnEnter, _param_unmountOnExit = _param.unmountOnExit, unmountOnExit = _param_unmountOnExit === void 0 ? false : _param_unmountOnExit, _param_appear = _param.appear, appear = _param_appear === void 0 ? false : _param_appear, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "children",
        "in",
        "mountOnEnter",
        "unmountOnExit",
        "appear"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "offcanvas");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $7848a75987c84ec4$export$2e2bcd8739ae039), (0, $ddevm._)((0, $78DQ7._)({
        ref: ref,
        addEndListener: (0, $46926e63412c3268$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear
    }, props), {
        childRef: children.ref,
        children: function(status, innerProps) {
            return /*#__PURE__*/ $33gHU.cloneElement(children, (0, $ddevm._)((0, $78DQ7._)({}, innerProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, children.props.className, (status === (0, $5a41f7eb3d8f2f2d$export$df38205c966be359) || status === (0, $5a41f7eb3d8f2f2d$export$4aacc83d4d59139f)) && "".concat(bsPrefix, "-toggling"), $5deeb29eb256abaa$var$transitionStyles[status])
            }));
        }
    }));
});
$5deeb29eb256abaa$var$OffcanvasToggling.displayName = "OffcanvasToggling";
var $5deeb29eb256abaa$export$2e2bcd8739ae039 = $5deeb29eb256abaa$var$OffcanvasToggling;





var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");



"use client";
var $2bfb1fa78d7d74a2$var$OffcanvasHeader = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, _param_closeLabel = _param.closeLabel, closeLabel = _param_closeLabel === void 0 ? "Close" : _param_closeLabel, _param_closeButton = _param.closeButton, closeButton = _param_closeButton === void 0 ? false : _param_closeButton, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "closeLabel",
        "closeButton"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "offcanvas-header");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $f39ba7dd914d8c37$export$2e2bcd8739ae039), (0, $ddevm._)((0, $78DQ7._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    }));
});
$2bfb1fa78d7d74a2$var$OffcanvasHeader.displayName = "OffcanvasHeader";
var $2bfb1fa78d7d74a2$export$2e2bcd8739ae039 = $2bfb1fa78d7d74a2$var$OffcanvasHeader;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");




"use client";
var $ee34b0ed828e7512$var$DivStyledAsH5 = (0, $102b865d7ac21b71$export$2e2bcd8739ae039)("h5");
var $ee34b0ed828e7512$var$OffcanvasTitle = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? $ee34b0ed828e7512$var$DivStyledAsH5 : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "offcanvas-title");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$ee34b0ed828e7512$var$OffcanvasTitle.displayName = "OffcanvasTitle";
var $ee34b0ed828e7512$export$2e2bcd8739ae039 = $ee34b0ed828e7512$var$OffcanvasTitle;





"use client";
function $65100a68433c14fb$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $5deeb29eb256abaa$export$2e2bcd8739ae039), (0, $78DQ7._)({}, props));
}
function $65100a68433c14fb$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $7639cffc50f5d209$export$2e2bcd8739ae039), (0, $78DQ7._)({}, props));
}
var $65100a68433c14fb$var$Offcanvas = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, children = _param.children, ariaLabelledby = _param["aria-labelledby"], _param_placement = _param.placement, placement = _param_placement === void 0 ? "start" : _param_placement, responsive = _param.responsive, _param_show = _param./* BaseModal props */ show, show = _param_show === void 0 ? false : _param_show, _param_backdrop = _param.backdrop, backdrop = _param_backdrop === void 0 ? true : _param_backdrop, _param_keyboard = _param.keyboard, keyboard = _param_keyboard === void 0 ? true : _param_keyboard, _param_scroll = _param.scroll, scroll = _param_scroll === void 0 ? false : _param_scroll, onEscapeKeyDown = _param.onEscapeKeyDown, onShow = _param.onShow, onHide = _param.onHide, container = _param.container, _param_autoFocus = _param.autoFocus, autoFocus = _param_autoFocus === void 0 ? true : _param_autoFocus, _param_enforceFocus = _param.enforceFocus, enforceFocus = _param_enforceFocus === void 0 ? true : _param_enforceFocus, _param_restoreFocus = _param.restoreFocus, restoreFocus = _param_restoreFocus === void 0 ? true : _param_restoreFocus, restoreFocusOptions = _param.restoreFocusOptions, onEntered = _param.onEntered, onExit = _param.onExit, onExiting = _param.onExiting, onEnter = _param.onEnter, onEntering = _param.onEntering, onExited = _param.onExited, backdropClassName = _param.backdropClassName, propsManager = _param.manager, _param_renderStaticNode = _param.renderStaticNode, renderStaticNode = _param_renderStaticNode === void 0 ? false : _param_renderStaticNode, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "children",
        "aria-labelledby",
        "placement",
        "responsive",
        "show",
        "backdrop",
        "keyboard",
        "scroll",
        "onEscapeKeyDown",
        "onShow",
        "onHide",
        "container",
        "autoFocus",
        "enforceFocus",
        "restoreFocus",
        "restoreFocusOptions",
        "onEntered",
        "onExit",
        "onExiting",
        "onEnter",
        "onEntering",
        "onExited",
        "backdropClassName",
        "manager",
        "renderStaticNode"
    ]);
    var modalManager = (0, $33gHU.useRef)();
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "offcanvas");
    var onToggle = ((0, $33gHU.useContext)((0, $5f48e6ab02225624$export$2e2bcd8739ae039)) || {}).onToggle;
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)(false), 2), showOffcanvas = _useState[0], setShowOffcanvas = _useState[1];
    var hideResponsiveOffcanvas = (0, $8afa1e48619b8967$export$2e2bcd8739ae039)(responsive || "xs", "up");
    (0, $33gHU.useEffect)(function() {
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    var handleHide = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function() {
        onToggle == null || onToggle();
        onHide == null || onHide();
    });
    var modalContext = (0, $33gHU.useMemo)(function() {
        return {
            onHide: handleHide
        };
    }, [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $77149501eb4f3e63$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $77149501eb4f3e63$export$a03641438014b436)();
    }
    var handleEnter = function(node) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        if (node) node.style.visibility = "visible";
        onEnter == null || onEnter.apply(void 0, [
            node
        ].concat((0, $3jzhD._)(args)));
    };
    var handleExited = function(node) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        if (node) node.style.visibility = "";
        onExited == null || onExited.apply(void 0, (0, $3jzhD._)(args));
    };
    var renderBackdrop = (0, $33gHU.useCallback)(function(backdropProps) {
        return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", (0, $ddevm._)((0, $78DQ7._)({}, backdropProps), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("".concat(bsPrefix, "-backdrop"), backdropClassName)
        }));
    }, [
        backdropClassName,
        bsPrefix
    ]);
    var renderDialog = function(dialogProps) {
        return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", (0, $ddevm._)((0, $78DQ7._)({}, dialogProps, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, responsive ? "".concat(bsPrefix, "-").concat(responsive) : bsPrefix, "".concat(bsPrefix, "-").concat(placement)),
            "aria-labelledby": ariaLabelledby,
            children: children
        }));
    };
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)((0, $978b871a0234f592$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $c26d292235a43d65$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $a1185c45eea1e591$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $65100a68433c14fb$var$DialogTransition,
                    backdropTransition: $65100a68433c14fb$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$65100a68433c14fb$var$Offcanvas.displayName = "Offcanvas";
var $65100a68433c14fb$export$2e2bcd8739ae039 = Object.assign($65100a68433c14fb$var$Offcanvas, {
    Body: (0, $18063296336c6cdd$export$2e2bcd8739ae039),
    Header: (0, $2bfb1fa78d7d74a2$export$2e2bcd8739ae039),
    Title: (0, $ee34b0ed828e7512$export$2e2bcd8739ae039)
});



var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $gnDeW = parcelRequire("gnDeW");

var $lF1I7 = parcelRequire("lF1I7");

var $lF1I7 = parcelRequire("lF1I7");

var $b0lSM = parcelRequire("b0lSM");
function $9203b0d10388e6fe$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $9203b0d10388e6fe$var$$552a56cc5ff3f479$exports = {};
$9203b0d10388e6fe$var$$parcel$export($9203b0d10388e6fe$var$$552a56cc5ff3f479$exports, "isNumberLetter", function() {
    return $9203b0d10388e6fe$export$df0b442c7f8df5c1;
});
$9203b0d10388e6fe$var$$parcel$export($9203b0d10388e6fe$var$$552a56cc5ff3f479$exports, "textJoin", function() {
    return $9203b0d10388e6fe$export$d977f7cd0cb45fe1;
});
$9203b0d10388e6fe$var$$parcel$export($9203b0d10388e6fe$var$$552a56cc5ff3f479$exports, "parseCookie", function() {
    return $9203b0d10388e6fe$export$d0eaf3e94be578f6;
});
$9203b0d10388e6fe$var$$parcel$export($9203b0d10388e6fe$var$$552a56cc5ff3f479$exports, "setCookie", function() {
    return $9203b0d10388e6fe$export$110700823644f4a6;
});
$9203b0d10388e6fe$var$$parcel$export($9203b0d10388e6fe$var$$552a56cc5ff3f479$exports, "parseLanguageHeader", function() {
    return $9203b0d10388e6fe$export$2557e81a557a81ea;
});
var $9203b0d10388e6fe$export$df0b442c7f8df5c1 = function() {
    var raw = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return new RegExp("\\p{N}", "u").test(raw) || new RegExp("\\p{Ll}", "u").test(raw.toLowerCase());
};
var $9203b0d10388e6fe$export$d977f7cd0cb45fe1 = function() {
    for(var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++){
        parts[_key] = arguments[_key];
    }
    return parts.map(function(raw, index) {
        var _a;
        var isNL = $9203b0d10388e6fe$export$df0b442c7f8df5c1(raw.slice(-1));
        if (index + 1 === parts.length) return raw;
        var diff = isNL !== $9203b0d10388e6fe$export$df0b442c7f8df5c1((_a = parts[index + 1]) === null || _a === void 0 ? void 0 : _a.trim()[0]);
        return raw + (diff || isNL ? " " : "");
    }).join("");
};
var $9203b0d10388e6fe$export$d0eaf3e94be578f6 = function() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : globalThis.document.cookie;
    return value ? Object.fromEntries(value.split(/;\s*/).map(function(item) {
        return item.split("=");
    })) : {};
};
function $9203b0d10388e6fe$export$110700823644f4a6(key, value) {
    var attributes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var data = "".concat(key, "=").concat(value), option = Object.entries(attributes).map(function(param) {
        var _param = (0, $2MTYX._)(param, 2), _$key = _param[0], _$value = _param[1];
        return typeof _$value === "boolean" ? _$value ? _$key : "" : "".concat(_$key, "=").concat(_$value);
    }).filter(Boolean).join("; ");
    document.cookie = "".concat(data, "; expires=").concat(new Date(0));
    return document.cookie = "".concat(data, "; ").concat(option);
}
var $9203b0d10388e6fe$export$2557e81a557a81ea = function(value) {
    return value.split(",").map(function(language) {
        var _language_split = (0, $2MTYX._)(language.split(";"), 2), name = _language_split[0], tmp = _language_split[1], quantity = tmp === void 0 ? "" : tmp;
        var _quantity_split = (0, $2MTYX._)(quantity.split("="), 2), _ = _quantity_split[0], tmp1 = _quantity_split[1], _$value = tmp1 === void 0 ? "1" : tmp1;
        return [
            name.trim(),
            +_$value
        ];
    }).sort(function(param, param1) {
        var _param = (0, $2MTYX._)(param, 2), _ = _param[0], a = _param[1], _param1 = (0, $2MTYX._)(param1, 2), __ = _param1[0], b = _param1[1];
        return b - a;
    }).map(function(param) {
        var _param = (0, $2MTYX._)(param, 1), name = _param[0];
        return name;
    });
};
var $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__runInitializers = function $53eb72fe5615c114$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__esDecorate = function $53eb72fe5615c114$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__awaiter = function $53eb72fe5615c114$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__classPrivateFieldGet = function $53eb72fe5615c114$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__classPrivateFieldSet = function $53eb72fe5615c114$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $9203b0d10388e6fe$export$d91823dfc159395b = function() {
    var _a, _TranslationModel_loading_accessor_storage, _TranslationModel_currentLanguage_accessor_storage, _TranslationModel_currentMap_accessor_storage;
    var _instanceExtraInitializers = [];
    var _loading_decorators;
    var _loading_initializers = [];
    var _currentLanguage_decorators;
    var _currentLanguage_initializers = [];
    var _currentMap_decorators;
    var _currentMap_initializers = [];
    var _get_defaultMap_decorators;
    var _changeLanguage_decorators;
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function TranslationModel(configuration) {
            var _this = this;
            (0, $19mwo._)(this, TranslationModel);
            Object.defineProperty(this, "configuration", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($9203b0d10388e6fe$var$$53eb72fe5615c114$var$__runInitializers(this, _instanceExtraInitializers), configuration)
            });
            _TranslationModel_loading_accessor_storage.set(this, $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__runInitializers(this, _loading_initializers, false));
            Object.defineProperty(this, "defaultLanguage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _TranslationModel_currentLanguage_accessor_storage.set(this, $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__runInitializers(this, _currentLanguage_initializers, ""));
            _TranslationModel_currentMap_accessor_storage.set(this, $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__runInitializers(this, _currentMap_initializers, {}));
            Object.defineProperty(this, "t", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: this.textOf.bind(this)
            });
            for(var name in configuration)if (typeof configuration[name] !== "function") this.defaultLanguage = name;
            if (!this.defaultLanguage) throw ReferenceError("One static language map is required");
            if (!globalThis.window) return;
            var languages = [
                $9203b0d10388e6fe$export$d0eaf3e94be578f6().language
            ].concat((0, $3jzhD._)(navigator.languages || [
                this.defaultLanguage
            ])).filter(Boolean);
            this.loadLanguages(languages);
            window.addEventListener("languagechange", function() {
                return _this.changeLanguage(navigator.language);
            });
        }
        (0, $6rpfc._)(TranslationModel, [
            {
                key: "loading",
                get: function get() {
                    return $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__classPrivateFieldGet(this, _TranslationModel_loading_accessor_storage, "f");
                },
                set: function set(value) {
                    $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__classPrivateFieldSet(this, _TranslationModel_loading_accessor_storage, value, "f");
                }
            },
            {
                key: "currentLanguage",
                get: function get() {
                    return $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__classPrivateFieldGet(this, _TranslationModel_currentLanguage_accessor_storage, "f");
                },
                set: function set(value) {
                    $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__classPrivateFieldSet(this, _TranslationModel_currentLanguage_accessor_storage, value, "f");
                }
            },
            {
                key: "currentMap",
                get: function get() {
                    return $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__classPrivateFieldGet(this, _TranslationModel_currentMap_accessor_storage, "f");
                },
                set: function set(value) {
                    $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__classPrivateFieldSet(this, _TranslationModel_currentMap_accessor_storage, value, "f");
                }
            },
            {
                key: "defaultMap",
                get: function get() {
                    return this.configuration[this.defaultLanguage];
                }
            },
            {
                key: "onLanguageChange",
                value: function onLanguageChange(handler) {
                    var _this = this;
                    (0, $b0lSM.reaction)(function() {
                        return _this.currentLanguage;
                    }, function(currentLanguage, lastLanguage) {
                        if (lastLanguage) handler.call(_this, currentLanguage);
                    });
                }
            },
            {
                key: "setLanguage",
                value: function setLanguage(name) {
                    var _b;
                    this.currentLanguage = name;
                    if ((_b = globalThis.document) === null || _b === void 0 ? void 0 : _b.documentElement) $9203b0d10388e6fe$export$110700823644f4a6("language", document.documentElement.lang = name, {
                        path: "/"
                    });
                }
            },
            {
                key: "changeLanguage",
                value: function changeLanguage(name) {
                    return $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__awaiter(this, void 0, void 0, function() {
                        var language, _ref, map;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    language = this.configuration[name];
                                    if (typeof language !== "function") {
                                        this.setLanguage(name);
                                        return [
                                            2,
                                            this.currentMap = language
                                        ];
                                    }
                                    this.loading = true;
                                    return [
                                        4,
                                        language()
                                    ];
                                case 1:
                                    _ref = _state.sent(), map = _ref.default;
                                    this.loading = false;
                                    this.setLanguage(name);
                                    return [
                                        2,
                                        this.currentMap = this.configuration[name] = map
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "loadLanguages",
                value: function loadLanguages(names) {
                    return $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__awaiter(this, void 0, void 0, function() {
                        var languages, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _this, _loop, _iterator, _step, _ret, err;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    languages = Object.keys(this.configuration).sort(function(param, param1) {
                                        var a = param.length, b = param1.length;
                                        return b - a;
                                    });
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        6,
                                        7,
                                        8
                                    ]);
                                    _this = this, _loop = function() {
                                        var name, language, _tmp, _b;
                                        return (0, $lF1I7.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    name = _step.value;
                                                    language = languages.includes(name) ? name : languages.find(function(language) {
                                                        return name.startsWith(language) || language.startsWith(name);
                                                    });
                                                    if (!language) return [
                                                        3,
                                                        4
                                                    ];
                                                    _state.label = 1;
                                                case 1:
                                                    _state.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    _tmp = {};
                                                    return [
                                                        4,
                                                        _this.changeLanguage(language)
                                                    ];
                                                case 2:
                                                    return [
                                                        2,
                                                        (_tmp.v = _state.sent(), _tmp)
                                                    ];
                                                case 3:
                                                    _b = _state.sent();
                                                    return [
                                                        3,
                                                        4
                                                    ];
                                                case 4:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    };
                                    _iterator = names[Symbol.iterator]();
                                    _state.label = 2;
                                case 2:
                                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                        3,
                                        5
                                    ];
                                    return [
                                        5,
                                        (0, $lF1I7.__values)(_loop())
                                    ];
                                case 3:
                                    _ret = _state.sent();
                                    if ((0, $gnDeW._)(_ret) === "object") return [
                                        2,
                                        _ret.v
                                    ];
                                    _state.label = 4;
                                case 4:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        2
                                    ];
                                case 5:
                                    return [
                                        3,
                                        8
                                    ];
                                case 6:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        8
                                    ];
                                case 7:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 8:
                                    return [
                                        2,
                                        this.changeLanguage(this.defaultLanguage)
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "textOf",
                value: function textOf(key, data) {
                    var value = this.currentMap[key] || this.defaultMap[key];
                    if (typeof value !== "function") return value;
                    if (!data) throw ReferenceError("Input data is required for Translation Resolver");
                    return value(data);
                }
            }
        ]);
        return TranslationModel;
    }(), _TranslationModel_loading_accessor_storage = new WeakMap(), _TranslationModel_currentLanguage_accessor_storage = new WeakMap(), _TranslationModel_currentMap_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _loading_decorators = [
            (0, $b0lSM.observable)
        ];
        _currentLanguage_decorators = [
            (0, $b0lSM.observable)
        ];
        _currentMap_decorators = [
            (0, $b0lSM.observable)
        ];
        _get_defaultMap_decorators = [
            (0, $b0lSM.computed)
        ];
        _changeLanguage_decorators = [
            (0, $b0lSM.action)
        ];
        $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__esDecorate(_a, null, _loading_decorators, {
            kind: "accessor",
            name: "loading",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "loading" in obj;
                },
                get: function(obj) {
                    return obj.loading;
                },
                set: function(obj, value) {
                    obj.loading = value;
                }
            },
            metadata: _metadata
        }, _loading_initializers, _instanceExtraInitializers);
        $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__esDecorate(_a, null, _currentLanguage_decorators, {
            kind: "accessor",
            name: "currentLanguage",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "currentLanguage" in obj;
                },
                get: function(obj) {
                    return obj.currentLanguage;
                },
                set: function(obj, value) {
                    obj.currentLanguage = value;
                }
            },
            metadata: _metadata
        }, _currentLanguage_initializers, _instanceExtraInitializers);
        $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__esDecorate(_a, null, _currentMap_decorators, {
            kind: "accessor",
            name: "currentMap",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "currentMap" in obj;
                },
                get: function(obj) {
                    return obj.currentMap;
                },
                set: function(obj, value) {
                    obj.currentMap = value;
                }
            },
            metadata: _metadata
        }, _currentMap_initializers, _instanceExtraInitializers);
        $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__esDecorate(_a, null, _get_defaultMap_decorators, {
            kind: "getter",
            name: "defaultMap",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "defaultMap" in obj;
                },
                get: function(obj) {
                    return obj.defaultMap;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9203b0d10388e6fe$var$$53eb72fe5615c114$var$__esDecorate(_a, null, _changeLanguage_decorators, {
            kind: "method",
            name: "changeLanguage",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "changeLanguage" in obj;
                },
                get: function(obj) {
                    return obj.changeLanguage;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();


var $9baf2b27258798bf$export$2e2bcd8739ae039 = {
    welcome: "Welcome",
    upstream_projects: "Upstream projects",
    home_page: "Home Page",
    addtask: "Add Task",
    tasks: "Tasks",
    icons: "Icons",
    lists: "Lists",
    ai: "AI"
};


var $50993b47476de2e7$export$a7357cdd1f0b0168 = new (0, $9203b0d10388e6fe$export$d91823dfc159395b)({
    "en-US": (0, $9baf2b27258798bf$export$2e2bcd8739ae039)
});
var $50993b47476de2e7$export$4b3850bcaaad82f1 = {
    "en-US": "English"
};


var $bbbe91238a04fd85$var$t = (0, $50993b47476de2e7$export$a7357cdd1f0b0168).t;
var $bbbe91238a04fd85$export$3baea55415cc8bd1 = function() {
    return [
        {
            href: "#/",
            title: $bbbe91238a04fd85$var$t("home_page")
        },
        {
            href: "#/task/new",
            title: $bbbe91238a04fd85$var$t("addtask")
        },
        {
            href: "#/tasks",
            title: $bbbe91238a04fd85$var$t("tasks")
        },
        {
            href: "#/lists",
            title: $bbbe91238a04fd85$var$t("lists")
        },
        {
            href: "#/ai",
            title: $bbbe91238a04fd85$var$t("ai")
        },
        {
            href: "#/icons",
            title: $bbbe91238a04fd85$var$t("icons")
        }
    ];
};



var $d8891ad0958c2273$export$8d6d009d1f06226e;
var $d8891ad0958c2273$export$db3c28d99448dcff;
var $d8891ad0958c2273$export$2bacab2130704b28;
$d8891ad0958c2273$export$8d6d009d1f06226e = "MgokeW_backButton";
$d8891ad0958c2273$export$db3c28d99448dcff = "MgokeW_logo";
$d8891ad0958c2273$export$2bacab2130704b28 = "MgokeW_menuButton";




var $aca7ac1a0ae40101$export$8b543871300e74c2 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var t = (0, $50993b47476de2e7$export$a7357cdd1f0b0168).t, currentLanguage = (0, $50993b47476de2e7$export$a7357cdd1f0b0168).currentLanguage;
    var ui = (0, $3a3345637c0a5d6f$export$edcd1bf374609759)();
    var handleClose = function() {
        ui.isMenuOpen = false;
    };
    return (0, $978b871a0234f592$exports.jsxs)((0, $978b871a0234f592$exports.Fragment), {
        children: [
            (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
                iconSys: "menu",
                className: $d8891ad0958c2273$export$2bacab2130704b28,
                size: "M",
                onClick: function() {
                    ui.isMenuOpen = true;
                }
            }),
            (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
                iconSys: "back",
                size: "M",
                className: $d8891ad0958c2273$export$8d6d009d1f06226e,
                onClick: function() {
                    history.back();
                }
            }),
            (0, $978b871a0234f592$exports.jsxs)((0, $65100a68433c14fb$export$2e2bcd8739ae039), {
                show: ui.isMenuOpen,
                onHide: handleClose,
                children: [
                    (0, $978b871a0234f592$exports.jsx)((0, $65100a68433c14fb$export$2e2bcd8739ae039).Header, {
                        closeButton: true,
                        children: (0, $978b871a0234f592$exports.jsx)((0, $65100a68433c14fb$export$2e2bcd8739ae039).Title, {
                            children: "Menu"
                        })
                    }),
                    (0, $978b871a0234f592$exports.jsx)((0, $65100a68433c14fb$export$2e2bcd8739ae039).Body, {
                        children: (0, $978b871a0234f592$exports.jsx)((0, $02f1267799525acb$export$2e2bcd8739ae039), {
                            className: "flex-column",
                            onSelect: function() {
                                ui.isMenuOpen = false;
                            },
                            children: (0, $bbbe91238a04fd85$export$3baea55415cc8bd1)().map(function(param) {
                                var title = param.title, href = param.href;
                                return (0, $978b871a0234f592$exports.jsx)((0, $02f1267799525acb$export$2e2bcd8739ae039).Item, {
                                    children: (0, $978b871a0234f592$exports.jsx)((0, $02f1267799525acb$export$2e2bcd8739ae039).Link, {
                                        href: href,
                                        className: "fs-1",
                                        children: title
                                    }, title)
                                }, title);
                            })
                        })
                    })
                ]
            })
        ]
    });
});



var $2MTYX = parcelRequire("2MTYX");

var $lF1I7 = parcelRequire("lF1I7");


var $2MTYX = parcelRequire("2MTYX");

var $lF1I7 = parcelRequire("lF1I7");



var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $lF1I7 = parcelRequire("lF1I7");


var $dSxWp = parcelRequire("dSxWp");

var $3Fd7H = parcelRequire("3Fd7H");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $etlBe = parcelRequire("etlBe");

var $k1NN5 = parcelRequire("k1NN5");

var $gIbDP = parcelRequire("gIbDP");

var $9OZ9j = parcelRequire("9OZ9j");

var $27QSE = parcelRequire("27QSE");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $gnDeW = parcelRequire("gnDeW");

var $e2m1c = parcelRequire("e2m1c");

var $etlBe = parcelRequire("etlBe");

var $k1NN5 = parcelRequire("k1NN5");

var $lF1I7 = parcelRequire("lF1I7");
var $d86ec578a7801a8a$export$a4ad2735b021c132 = "4.56.0"; // x-release-please-version



var $gIbDP = parcelRequire("gIbDP");

var $9OZ9j = parcelRequire("9OZ9j");

var $27QSE = parcelRequire("27QSE");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $c5rwh = parcelRequire("c5rwh");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $e2m1c = parcelRequire("e2m1c");

var $lF1I7 = parcelRequire("lF1I7");
/**
 * Disclaimer: modules in _shims aren't intended to be imported by SDK users.
 */ var $28c79a08ea52e7a5$export$dfb5619354ba860 = false;
var $28c79a08ea52e7a5$export$78062f36b16ed2f8 = undefined;
var $28c79a08ea52e7a5$export$e7aa7bc5c1b3cfb3 = undefined;
var $28c79a08ea52e7a5$export$7fa6c5b6f8193917 = undefined;
var $28c79a08ea52e7a5$export$9f633d56d7ec90d3 = undefined;
var $28c79a08ea52e7a5$export$79b704688b15c0f4 = undefined;
var $28c79a08ea52e7a5$export$3963aa24c930693c = undefined;
var $28c79a08ea52e7a5$export$3b660928c86ff55c = undefined;
var $28c79a08ea52e7a5$export$b6afa8811b7e644e = undefined;
var $28c79a08ea52e7a5$export$5d3e1e5268af5f76 = undefined;
var $28c79a08ea52e7a5$export$2dd6502ab973289e = undefined;
var $28c79a08ea52e7a5$export$4430d10c2e71ce6c = undefined;
var $28c79a08ea52e7a5$export$b7b708b1f2c8118a = undefined;
var $28c79a08ea52e7a5$export$bb863823a5a2fbbe = undefined;
function $28c79a08ea52e7a5$export$12c9a8e00b0aa2d3(shims) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        auto: false
    };
    if ($28c79a08ea52e7a5$export$dfb5619354ba860) throw new Error("you must `import 'openai/shims/".concat(shims.kind, "'` before importing anything else from openai"));
    if ($28c79a08ea52e7a5$export$78062f36b16ed2f8) throw new Error("can't `import 'openai/shims/".concat(shims.kind, "'` after `import 'openai/shims/").concat($28c79a08ea52e7a5$export$78062f36b16ed2f8, "'`"));
    $28c79a08ea52e7a5$export$dfb5619354ba860 = options.auto;
    $28c79a08ea52e7a5$export$78062f36b16ed2f8 = shims.kind;
    $28c79a08ea52e7a5$export$e7aa7bc5c1b3cfb3 = shims.fetch;
    $28c79a08ea52e7a5$export$7fa6c5b6f8193917 = shims.Request;
    $28c79a08ea52e7a5$export$9f633d56d7ec90d3 = shims.Response;
    $28c79a08ea52e7a5$export$79b704688b15c0f4 = shims.Headers;
    $28c79a08ea52e7a5$export$3963aa24c930693c = shims.FormData;
    $28c79a08ea52e7a5$export$3b660928c86ff55c = shims.Blob;
    $28c79a08ea52e7a5$export$b6afa8811b7e644e = shims.File;
    $28c79a08ea52e7a5$export$5d3e1e5268af5f76 = shims.ReadableStream;
    $28c79a08ea52e7a5$export$2dd6502ab973289e = shims.getMultipartRequestOptions;
    $28c79a08ea52e7a5$export$4430d10c2e71ce6c = shims.getDefaultAgent;
    $28c79a08ea52e7a5$export$b7b708b1f2c8118a = shims.fileFromPath;
    $28c79a08ea52e7a5$export$bb863823a5a2fbbe = shims.isFsReadStream;
}



var $9OZ9j = parcelRequire("9OZ9j");

var $19mwo = parcelRequire("19mwo");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $lF1I7 = parcelRequire("lF1I7");
/**
 * Disclaimer: modules in _shims aren't intended to be imported by SDK users.
 */ 
var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");
var $c9ae40b57824e13e$export$c41756c00d9b480d = /*#__PURE__*/ function() {
    "use strict";
    function MultipartBody(body) {
        (0, $19mwo._)(this, MultipartBody);
        this.body = body;
    }
    (0, $6rpfc._)(MultipartBody, [
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "MultipartBody";
            }
        }
    ]);
    return MultipartBody;
}();


function $61a0964d6f206d54$export$5fcd68b67c93ed4a() {
    var manuallyImported = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).manuallyImported;
    var recommendation = manuallyImported ? "You may need to use polyfills" : "Add one of these imports before your first `import \u2026 from 'openai'`:\n- `import 'openai/shims/node'` (if you're running on Node)\n- `import 'openai/shims/web'` (otherwise)\n";
    var _fetch, _Request, _Response, _Headers;
    try {
        // @ts-ignore
        _fetch = fetch;
        // @ts-ignore
        _Request = Request;
        // @ts-ignore
        _Response = Response;
        // @ts-ignore
        _Headers = Headers;
    } catch (error) {
        throw new Error("this environment is missing the following Web Fetch API type: ".concat(error.message, ". ").concat(recommendation));
    }
    return {
        kind: "web",
        fetch: _fetch,
        Request: _Request,
        Response: _Response,
        Headers: _Headers,
        FormData: // @ts-ignore
        typeof FormData !== "undefined" ? FormData : function FormData1() {
            "use strict";
            (0, $19mwo._)(this, FormData1);
            throw new Error("file uploads aren't supported in this environment yet as 'FormData' is undefined. ".concat(recommendation));
        },
        Blob: typeof Blob !== "undefined" ? Blob : function Blob1() {
            "use strict";
            (0, $19mwo._)(this, Blob1);
            throw new Error("file uploads aren't supported in this environment yet as 'Blob' is undefined. ".concat(recommendation));
        },
        File: // @ts-ignore
        typeof File !== "undefined" ? File : function File1() {
            "use strict";
            (0, $19mwo._)(this, File1);
            throw new Error("file uploads aren't supported in this environment yet as 'File' is undefined. ".concat(recommendation));
        },
        ReadableStream: // @ts-ignore
        typeof ReadableStream !== "undefined" ? ReadableStream : function ReadableStream1() {
            "use strict";
            (0, $19mwo._)(this, ReadableStream1);
            throw new Error("streaming isn't supported in this environment yet as 'ReadableStream' is undefined. ".concat(recommendation));
        },
        getMultipartRequestOptions: function() {
            var _ref = (0, $9OZ9j._)(function(// @ts-ignore
            form, opts) {
                return (0, $lF1I7.__generator)(this, function(_state) {
                    return [
                        2,
                        (0, $ddevm._)((0, $78DQ7._)({}, opts), {
                            body: new (0, $c9ae40b57824e13e$export$c41756c00d9b480d)(form)
                        })
                    ];
                });
            });
            return function(form, opts) {
                return _ref.apply(this, arguments);
            };
        }(),
        getDefaultAgent: function(url) {
            return undefined;
        },
        fileFromPath: function() {
            throw new Error("The `fileFromPath` function is only supported in Node. See the README for more details: https://www.github.com/openai/openai-node#file-uploads");
        },
        isFsReadStream: function(value) {
            return false;
        }
    };
}


if (!$28c79a08ea52e7a5$export$78062f36b16ed2f8) $28c79a08ea52e7a5$export$12c9a8e00b0aa2d3($61a0964d6f206d54$export$5fcd68b67c93ed4a(), {
    auto: true
});





var $9iKK3 = parcelRequire("9iKK3");
var $7740b96e0d3c54cb$require$Buffer = $9iKK3.Buffer;
var $7740b96e0d3c54cb$export$6a4eb2e7fc9e8903 = /*#__PURE__*/ function() {
    "use strict";
    function Stream(iterator, controller) {
        (0, $19mwo._)(this, Stream);
        this.iterator = iterator;
        this.controller = controller;
    }
    (0, $6rpfc._)(Stream, [
        {
            key: Symbol.asyncIterator,
            value: function value() {
                return this.iterator();
            }
        },
        {
            /**
     * Splits the stream into two streams which can be
     * independently read from at different speeds.
     */ key: "tee",
            value: function tee() {
                var left = [];
                var right = [];
                var iterator = this.iterator();
                var teeIterator = function(queue) {
                    return {
                        next: function() {
                            if (queue.length === 0) {
                                var result = iterator.next();
                                left.push(result);
                                right.push(result);
                            }
                            return queue.shift();
                        }
                    };
                };
                return [
                    new Stream(function() {
                        return teeIterator(left);
                    }, this.controller),
                    new Stream(function() {
                        return teeIterator(right);
                    }, this.controller)
                ];
            }
        },
        {
            /**
     * Converts this stream to a newline-separated ReadableStream of
     * JSON stringified values in the stream
     * which can be turned back into a Stream with `Stream.fromReadableStream()`.
     */ key: "toReadableStream",
            value: function toReadableStream() {
                var self = this;
                var iter;
                var encoder = new TextEncoder();
                return new (0, $28c79a08ea52e7a5$export$5d3e1e5268af5f76)({
                    start: function() {
                        return (0, $9OZ9j._)(function() {
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                iter = self[Symbol.asyncIterator]();
                                return [
                                    2
                                ];
                            });
                        })();
                    },
                    pull: function(ctrl) {
                        return (0, $9OZ9j._)(function() {
                            var _ref, value, done, bytes, err;
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            iter.next()
                                        ];
                                    case 1:
                                        _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                        if (done) return [
                                            2,
                                            ctrl.close()
                                        ];
                                        bytes = encoder.encode(JSON.stringify(value) + "\n");
                                        ctrl.enqueue(bytes);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        ctrl.error(err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    },
                    cancel: function() {
                        return (0, $9OZ9j._)(function() {
                            var _iter_return;
                            return (0, $lF1I7.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            (_iter_return = iter.return) === null || _iter_return === void 0 ? void 0 : _iter_return.call(iter)
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    }
                });
            }
        }
    ], [
        {
            key: "fromSSEResponse",
            value: function fromSSEResponse(response, controller) {
                var consumed = false;
                function iterator() {
                    return _iterator.apply(this, arguments);
                }
                function _iterator() {
                    _iterator = (0, $e2m1c._)(function() {
                        var done, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _$_iterator, _step, _value, sse, data, data1, err, e;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (consumed) throw new Error("Cannot iterate over a consumed stream, use `.tee()` to split the stream.");
                                    consumed = true;
                                    done = false;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        17,
                                        18,
                                        19
                                    ]);
                                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                                    _state.label = 2;
                                case 2:
                                    _state.trys.push([
                                        2,
                                        10,
                                        11,
                                        16
                                    ]);
                                    _$_iterator = (0, $gIbDP._)($7740b96e0d3c54cb$export$de202fb52edf78c0(response, controller));
                                    _state.label = 3;
                                case 3:
                                    return [
                                        4,
                                        (0, $27QSE._)(_$_iterator.next())
                                    ];
                                case 4:
                                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                        3,
                                        9
                                    ];
                                    _value = _step.value;
                                    sse = _value;
                                    if (done) return [
                                        3,
                                        8
                                    ];
                                    if (sse.data.startsWith("[DONE]")) {
                                        done = true;
                                        return [
                                            3,
                                            8
                                        ];
                                    }
                                    if (!(sse.event === null)) return [
                                        3,
                                        6
                                    ];
                                    data = void 0;
                                    try {
                                        data = JSON.parse(sse.data);
                                    } catch (e) {
                                        console.error("Could not parse message into JSON:", sse.data);
                                        console.error("From chunk:", sse.raw);
                                        throw e;
                                    }
                                    if (data && data.error) throw new (0, $15f6ed5911d7e12b$export$3e5b797e39668f84)(undefined, data.error, undefined, undefined);
                                    return [
                                        4,
                                        data
                                    ];
                                case 5:
                                    _state.sent();
                                    return [
                                        3,
                                        8
                                    ];
                                case 6:
                                    data1 = void 0;
                                    try {
                                        data1 = JSON.parse(sse.data);
                                    } catch (e) {
                                        console.error("Could not parse message into JSON:", sse.data);
                                        console.error("From chunk:", sse.raw);
                                        throw e;
                                    }
                                    // TODO: Is this where the error should be thrown?
                                    if (sse.event == "error") throw new (0, $15f6ed5911d7e12b$export$3e5b797e39668f84)(undefined, data1.error, data1.message, undefined);
                                    return [
                                        4,
                                        {
                                            event: sse.event,
                                            data: data1
                                        }
                                    ];
                                case 7:
                                    _state.sent();
                                    _state.label = 8;
                                case 8:
                                    _iteratorAbruptCompletion = false;
                                    return [
                                        3,
                                        3
                                    ];
                                case 9:
                                    return [
                                        3,
                                        16
                                    ];
                                case 10:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        16
                                    ];
                                case 11:
                                    _state.trys.push([
                                        11,
                                        ,
                                        14,
                                        15
                                    ]);
                                    if (!(_iteratorAbruptCompletion && _$_iterator.return != null)) return [
                                        3,
                                        13
                                    ];
                                    return [
                                        4,
                                        _$_iterator.return()
                                    ];
                                case 12:
                                    _state.sent();
                                    _state.label = 13;
                                case 13:
                                    return [
                                        3,
                                        15
                                    ];
                                case 14:
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                    return [
                                        7
                                    ];
                                case 15:
                                    return [
                                        7
                                    ];
                                case 16:
                                    done = true;
                                    return [
                                        3,
                                        19
                                    ];
                                case 17:
                                    e = _state.sent();
                                    // If the user calls `stream.controller.abort()`, we should exit without throwing.
                                    if (e instanceof Error && e.name === "AbortError") return [
                                        2
                                    ];
                                    throw e;
                                case 18:
                                    // If the user `break`s, abort the ongoing request.
                                    if (!done) controller.abort();
                                    return [
                                        7
                                    ];
                                case 19:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return _iterator.apply(this, arguments);
                }
                return new Stream(iterator, controller);
            }
        },
        {
            key: "fromReadableStream",
            value: /**
     * Generates a Stream from a newline-separated ReadableStream
     * where each item is a JSON value.
     */ function fromReadableStream(readableStream, controller) {
                var consumed = false;
                function iterLines() {
                    return _iterLines.apply(this, arguments);
                }
                function _iterLines() {
                    _iterLines = (0, $e2m1c._)(function() {
                        var lineDecoder, iter, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, _iteratorNormalCompletion, _didIteratorError1, _iteratorError1, _iterator1, _step1, line, err, err1, _iteratorNormalCompletion1, _didIteratorError2, _iteratorError2, _iterator2, _step2, line1, err;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    lineDecoder = new $7740b96e0d3c54cb$var$LineDecoder();
                                    iter = $7740b96e0d3c54cb$export$5ac880445c73c5f8(readableStream);
                                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        13,
                                        14,
                                        19
                                    ]);
                                    _iterator = (0, $gIbDP._)(iter);
                                    _state.label = 2;
                                case 2:
                                    return [
                                        4,
                                        (0, $27QSE._)(_iterator.next())
                                    ];
                                case 3:
                                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                        3,
                                        12
                                    ];
                                    _value = _step.value;
                                    chunk = _value;
                                    _iteratorNormalCompletion = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    _state.label = 4;
                                case 4:
                                    _state.trys.push([
                                        4,
                                        9,
                                        10,
                                        11
                                    ]);
                                    _iterator1 = lineDecoder.decode(chunk)[Symbol.iterator]();
                                    _state.label = 5;
                                case 5:
                                    if (!!(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done)) return [
                                        3,
                                        8
                                    ];
                                    line = _step1.value;
                                    return [
                                        4,
                                        line
                                    ];
                                case 6:
                                    _state.sent();
                                    _state.label = 7;
                                case 7:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        5
                                    ];
                                case 8:
                                    return [
                                        3,
                                        11
                                    ];
                                case 9:
                                    err = _state.sent();
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                    return [
                                        3,
                                        11
                                    ];
                                case 10:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 11:
                                    _iteratorAbruptCompletion = false;
                                    return [
                                        3,
                                        2
                                    ];
                                case 12:
                                    return [
                                        3,
                                        19
                                    ];
                                case 13:
                                    err1 = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err1;
                                    return [
                                        3,
                                        19
                                    ];
                                case 14:
                                    _state.trys.push([
                                        14,
                                        ,
                                        17,
                                        18
                                    ]);
                                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                        3,
                                        16
                                    ];
                                    return [
                                        4,
                                        _iterator.return()
                                    ];
                                case 15:
                                    _state.sent();
                                    _state.label = 16;
                                case 16:
                                    return [
                                        3,
                                        18
                                    ];
                                case 17:
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                    return [
                                        7
                                    ];
                                case 18:
                                    return [
                                        7
                                    ];
                                case 19:
                                    _iteratorNormalCompletion1 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                    _state.label = 20;
                                case 20:
                                    _state.trys.push([
                                        20,
                                        25,
                                        26,
                                        27
                                    ]);
                                    _iterator2 = lineDecoder.flush()[Symbol.iterator]();
                                    _state.label = 21;
                                case 21:
                                    if (!!(_iteratorNormalCompletion1 = (_step2 = _iterator2.next()).done)) return [
                                        3,
                                        24
                                    ];
                                    line1 = _step2.value;
                                    return [
                                        4,
                                        line1
                                    ];
                                case 22:
                                    _state.sent();
                                    _state.label = 23;
                                case 23:
                                    _iteratorNormalCompletion1 = true;
                                    return [
                                        3,
                                        21
                                    ];
                                case 24:
                                    return [
                                        3,
                                        27
                                    ];
                                case 25:
                                    err = _state.sent();
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                    return [
                                        3,
                                        27
                                    ];
                                case 26:
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator2.return != null) {
                                            _iterator2.return();
                                        }
                                    } finally{
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 27:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return _iterLines.apply(this, arguments);
                }
                function iterator() {
                    return _iterator.apply(this, arguments);
                }
                function _iterator() {
                    _iterator = (0, $e2m1c._)(function() {
                        var done, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _$_iterator, _step, _value, line, err, e;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (consumed) throw new Error("Cannot iterate over a consumed stream, use `.tee()` to split the stream.");
                                    consumed = true;
                                    done = false;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        15,
                                        16,
                                        17
                                    ]);
                                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                                    _state.label = 2;
                                case 2:
                                    _state.trys.push([
                                        2,
                                        8,
                                        9,
                                        14
                                    ]);
                                    _$_iterator = (0, $gIbDP._)(iterLines());
                                    _state.label = 3;
                                case 3:
                                    return [
                                        4,
                                        (0, $27QSE._)(_$_iterator.next())
                                    ];
                                case 4:
                                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                        3,
                                        7
                                    ];
                                    _value = _step.value;
                                    line = _value;
                                    if (done) return [
                                        3,
                                        6
                                    ];
                                    if (!line) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        JSON.parse(line)
                                    ];
                                case 5:
                                    _state.sent();
                                    _state.label = 6;
                                case 6:
                                    _iteratorAbruptCompletion = false;
                                    return [
                                        3,
                                        3
                                    ];
                                case 7:
                                    return [
                                        3,
                                        14
                                    ];
                                case 8:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        14
                                    ];
                                case 9:
                                    _state.trys.push([
                                        9,
                                        ,
                                        12,
                                        13
                                    ]);
                                    if (!(_iteratorAbruptCompletion && _$_iterator.return != null)) return [
                                        3,
                                        11
                                    ];
                                    return [
                                        4,
                                        _$_iterator.return()
                                    ];
                                case 10:
                                    _state.sent();
                                    _state.label = 11;
                                case 11:
                                    return [
                                        3,
                                        13
                                    ];
                                case 12:
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                    return [
                                        7
                                    ];
                                case 13:
                                    return [
                                        7
                                    ];
                                case 14:
                                    done = true;
                                    return [
                                        3,
                                        17
                                    ];
                                case 15:
                                    e = _state.sent();
                                    // If the user calls `stream.controller.abort()`, we should exit without throwing.
                                    if (e instanceof Error && e.name === "AbortError") return [
                                        2
                                    ];
                                    throw e;
                                case 16:
                                    // If the user `break`s, abort the ongoing request.
                                    if (!done) controller.abort();
                                    return [
                                        7
                                    ];
                                case 17:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return _iterator.apply(this, arguments);
                }
                return new Stream(iterator, controller);
            }
        }
    ]);
    return Stream;
}();
function $7740b96e0d3c54cb$export$de202fb52edf78c0(response, controller) {
    return $7740b96e0d3c54cb$var$__iterSSEMessages.apply(this, arguments);
}
function $7740b96e0d3c54cb$var$__iterSSEMessages() {
    $7740b96e0d3c54cb$var$__iterSSEMessages = (0, $e2m1c._)(function(response, controller) {
        var sseDecoder, lineDecoder, iter, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, sseChunk, _iteratorNormalCompletion, _didIteratorError1, _iteratorError1, _iterator1, _step1, line, sse, err, err1, _iteratorNormalCompletion1, _didIteratorError2, _iteratorError2, _iterator2, _step2, line1, sse1, err;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!response.body) {
                        controller.abort();
                        throw new (0, $15f6ed5911d7e12b$export$7668a15b8d9a0caa)("Attempted to iterate over a response with no body");
                    }
                    sseDecoder = new $7740b96e0d3c54cb$var$SSEDecoder();
                    lineDecoder = new $7740b96e0d3c54cb$var$LineDecoder();
                    iter = $7740b96e0d3c54cb$export$5ac880445c73c5f8(response.body);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        13,
                        14,
                        19
                    ]);
                    _iterator = (0, $gIbDP._)($7740b96e0d3c54cb$var$iterSSEChunks(iter));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $27QSE._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        12
                    ];
                    _value = _step.value;
                    sseChunk = _value;
                    _iteratorNormalCompletion = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        9,
                        10,
                        11
                    ]);
                    _iterator1 = lineDecoder.decode(sseChunk)[Symbol.iterator]();
                    _state.label = 5;
                case 5:
                    if (!!(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done)) return [
                        3,
                        8
                    ];
                    line = _step1.value;
                    sse = sseDecoder.decode(line);
                    if (!sse) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        sse
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        5
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    err = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                    return [
                        3,
                        11
                    ];
                case 10:
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                    return [
                        7
                    ];
                case 11:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 12:
                    return [
                        3,
                        19
                    ];
                case 13:
                    err1 = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err1;
                    return [
                        3,
                        19
                    ];
                case 14:
                    _state.trys.push([
                        14,
                        ,
                        17,
                        18
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        16
                    ];
                    return [
                        4,
                        _iterator.return()
                    ];
                case 15:
                    _state.sent();
                    _state.label = 16;
                case 16:
                    return [
                        3,
                        18
                    ];
                case 17:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 18:
                    return [
                        7
                    ];
                case 19:
                    _iteratorNormalCompletion1 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    _state.label = 20;
                case 20:
                    _state.trys.push([
                        20,
                        25,
                        26,
                        27
                    ]);
                    _iterator2 = lineDecoder.flush()[Symbol.iterator]();
                    _state.label = 21;
                case 21:
                    if (!!(_iteratorNormalCompletion1 = (_step2 = _iterator2.next()).done)) return [
                        3,
                        24
                    ];
                    line1 = _step2.value;
                    sse1 = sseDecoder.decode(line1);
                    if (!sse1) return [
                        3,
                        23
                    ];
                    return [
                        4,
                        sse1
                    ];
                case 22:
                    _state.sent();
                    _state.label = 23;
                case 23:
                    _iteratorNormalCompletion1 = true;
                    return [
                        3,
                        21
                    ];
                case 24:
                    return [
                        3,
                        27
                    ];
                case 25:
                    err = _state.sent();
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                    return [
                        3,
                        27
                    ];
                case 26:
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                    return [
                        7
                    ];
                case 27:
                    return [
                        2
                    ];
            }
        });
    });
    return $7740b96e0d3c54cb$var$__iterSSEMessages.apply(this, arguments);
}
function $7740b96e0d3c54cb$var$iterSSEChunks(iterator) {
    return $7740b96e0d3c54cb$var$_iterSSEChunks.apply(this, arguments);
}
function $7740b96e0d3c54cb$var$_iterSSEChunks() {
    $7740b96e0d3c54cb$var$_iterSSEChunks = /**
 * Given an async iterable iterator, iterates over it and yields full
 * SSE chunks, i.e. yields when a double new-line is encountered.
 */ (0, $e2m1c._)(function(iterator) {
        var data, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, binaryChunk, newData, patternIndex, err;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = new Uint8Array();
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $gIbDP._)(iterator);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $27QSE._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (chunk == null) return [
                        3,
                        6
                    ];
                    binaryChunk = chunk instanceof ArrayBuffer ? new Uint8Array(chunk) : typeof chunk === "string" ? new TextEncoder().encode(chunk) : chunk;
                    newData = new Uint8Array(data.length + binaryChunk.length);
                    newData.set(data);
                    newData.set(binaryChunk, data.length);
                    data = newData;
                    patternIndex = void 0;
                    _state.label = 4;
                case 4:
                    if (!((patternIndex = $7740b96e0d3c54cb$var$findDoubleNewlineIndex(data)) !== -1)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        data.slice(0, patternIndex)
                    ];
                case 5:
                    _state.sent();
                    data = data.slice(patternIndex);
                    return [
                        3,
                        4
                    ];
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        _iterator.return()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    if (!(data.length > 0)) return [
                        3,
                        16
                    ];
                    return [
                        4,
                        data
                    ];
                case 15:
                    _state.sent();
                    _state.label = 16;
                case 16:
                    return [
                        2
                    ];
            }
        });
    });
    return $7740b96e0d3c54cb$var$_iterSSEChunks.apply(this, arguments);
}
function $7740b96e0d3c54cb$var$findDoubleNewlineIndex(buffer) {
    // This function searches the buffer for the end patterns (\r\r, \n\n, \r\n\r\n)
    // and returns the index right after the first occurrence of any pattern,
    // or -1 if none of the patterns are found.
    var newline = 0x0a; // \n
    var carriage = 0x0d; // \r
    for(var i = 0; i < buffer.length - 2; i++){
        if (buffer[i] === newline && buffer[i + 1] === newline) // \n\n
        return i + 2;
        if (buffer[i] === carriage && buffer[i + 1] === carriage) // \r\r
        return i + 2;
        if (buffer[i] === carriage && buffer[i + 1] === newline && i + 3 < buffer.length && buffer[i + 2] === carriage && buffer[i + 3] === newline) // \r\n\r\n
        return i + 4;
    }
    return -1;
}
var $7740b96e0d3c54cb$var$SSEDecoder = /*#__PURE__*/ function() {
    "use strict";
    function SSEDecoder() {
        (0, $19mwo._)(this, SSEDecoder);
        this.event = null;
        this.data = [];
        this.chunks = [];
    }
    (0, $6rpfc._)(SSEDecoder, [
        {
            key: "decode",
            value: function decode(line) {
                if (line.endsWith("\r")) line = line.substring(0, line.length - 1);
                if (!line) {
                    // empty line and we didn't previously encounter any messages
                    if (!this.event && !this.data.length) return null;
                    var sse = {
                        event: this.event,
                        data: this.data.join("\n"),
                        raw: this.chunks
                    };
                    this.event = null;
                    this.data = [];
                    this.chunks = [];
                    return sse;
                }
                this.chunks.push(line);
                if (line.startsWith(":")) return null;
                var _partition = (0, $2MTYX._)($7740b96e0d3c54cb$var$partition(line, ":"), 3), fieldname = _partition[0], _ = _partition[1], value = _partition[2];
                if (value.startsWith(" ")) value = value.substring(1);
                if (fieldname === "event") this.event = value;
                else if (fieldname === "data") this.data.push(value);
                return null;
            }
        }
    ]);
    return SSEDecoder;
}();
/**
 * A re-implementation of httpx's `LineDecoder` in Python that handles incrementally
 * reading lines from text.
 *
 * https://github.com/encode/httpx/blob/920333ea98118e9cf617f246905d7b202510941c/httpx/_decoders.py#L258
 */ var $7740b96e0d3c54cb$var$LineDecoder = /*#__PURE__*/ function() {
    "use strict";
    function LineDecoder() {
        (0, $19mwo._)(this, LineDecoder);
        this.buffer = [];
        this.trailingCR = false;
    }
    (0, $6rpfc._)(LineDecoder, [
        {
            key: "decode",
            value: function decode(chunk) {
                var text = this.decodeText(chunk);
                if (this.trailingCR) {
                    text = "\r" + text;
                    this.trailingCR = false;
                }
                if (text.endsWith("\r")) {
                    this.trailingCR = true;
                    text = text.slice(0, -1);
                }
                if (!text) return [];
                var trailingNewline = LineDecoder.NEWLINE_CHARS.has(text[text.length - 1] || "");
                var lines = text.split(LineDecoder.NEWLINE_REGEXP);
                // if there is a trailing new line then the last entry will be an empty
                // string which we don't care about
                if (trailingNewline) lines.pop();
                if (lines.length === 1 && !trailingNewline) {
                    this.buffer.push(lines[0]);
                    return [];
                }
                if (this.buffer.length > 0) {
                    lines = [
                        this.buffer.join("") + lines[0]
                    ].concat((0, $3jzhD._)(lines.slice(1)));
                    this.buffer = [];
                }
                if (!trailingNewline) this.buffer = [
                    lines.pop() || ""
                ];
                return lines;
            }
        },
        {
            key: "decodeText",
            value: function decodeText(bytes) {
                if (bytes == null) return "";
                if (typeof bytes === "string") return bytes;
                // Node:
                if (typeof $7740b96e0d3c54cb$require$Buffer !== "undefined") {
                    if (bytes instanceof $7740b96e0d3c54cb$require$Buffer) return bytes.toString();
                    if (bytes instanceof Uint8Array) return $7740b96e0d3c54cb$require$Buffer.from(bytes).toString();
                    throw new (0, $15f6ed5911d7e12b$export$7668a15b8d9a0caa)("Unexpected: received non-Uint8Array (".concat(bytes.constructor.name, ') stream chunk in an environment with a global "Buffer" defined, which this library assumes to be Node. Please report this error.'));
                }
                // Browser
                if (typeof TextDecoder !== "undefined") {
                    if (bytes instanceof Uint8Array || bytes instanceof ArrayBuffer) {
                        var _this_textDecoder;
                        (_this_textDecoder = this.textDecoder) !== null && _this_textDecoder !== void 0 ? _this_textDecoder : this.textDecoder = new TextDecoder("utf8");
                        return this.textDecoder.decode(bytes);
                    }
                    throw new (0, $15f6ed5911d7e12b$export$7668a15b8d9a0caa)("Unexpected: received non-Uint8Array/ArrayBuffer (".concat(bytes.constructor.name, ") in a web platform. Please report this error."));
                }
                throw new (0, $15f6ed5911d7e12b$export$7668a15b8d9a0caa)("Unexpected: neither Buffer nor TextDecoder are available as globals. Please report this error.");
            }
        },
        {
            key: "flush",
            value: function flush() {
                if (!this.buffer.length && !this.trailingCR) return [];
                var lines = [
                    this.buffer.join("")
                ];
                this.buffer = [];
                this.trailingCR = false;
                return lines;
            }
        }
    ]);
    return LineDecoder;
}();
// prettier-ignore
$7740b96e0d3c54cb$var$LineDecoder.NEWLINE_CHARS = new Set([
    "\n",
    "\r"
]);
$7740b96e0d3c54cb$var$LineDecoder.NEWLINE_REGEXP = /\r\n|[\n\r]/g;
function $7740b96e0d3c54cb$export$f277b811aa936137(chunks) {
    var _lines;
    var decoder = new $7740b96e0d3c54cb$var$LineDecoder();
    var lines = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = chunks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var chunk = _step.value;
            (_lines = lines).push.apply(_lines, (0, $3jzhD._)(decoder.decode(chunk)));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return lines;
}
function $7740b96e0d3c54cb$var$partition(str, delimiter) {
    var index = str.indexOf(delimiter);
    if (index !== -1) return [
        str.substring(0, index),
        delimiter,
        str.substring(index + delimiter.length)
    ];
    return [
        str,
        "",
        ""
    ];
}
function $7740b96e0d3c54cb$export$5ac880445c73c5f8(stream) {
    if (stream[Symbol.asyncIterator]) return stream;
    var reader = stream.getReader();
    return (0, $c5rwh._)({
        next: function() {
            return (0, $9OZ9j._)(function() {
                var result, e;
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                reader.read()
                            ];
                        case 1:
                            result = _state.sent();
                            if (result === null || result === void 0 ? void 0 : result.done) reader.releaseLock(); // release lock when stream becomes closed
                            return [
                                2,
                                result
                            ];
                        case 2:
                            e = _state.sent();
                            reader.releaseLock(); // release lock when stream becomes errored
                            throw e;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        return: function() {
            return (0, $9OZ9j._)(function() {
                var cancelPromise;
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cancelPromise = reader.cancel();
                            reader.releaseLock();
                            return [
                                4,
                                cancelPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                {
                                    done: true,
                                    value: undefined
                                }
                            ];
                    }
                });
            })();
        }
    }, Symbol.asyncIterator, function() {
        return this;
    });
}





var $gIbDP = parcelRequire("gIbDP");

var $9OZ9j = parcelRequire("9OZ9j");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $2MTYX = parcelRequire("2MTYX");

var $gnDeW = parcelRequire("gnDeW");

var $lF1I7 = parcelRequire("lF1I7");


var $9iKK3 = parcelRequire("9iKK3");
var $7645c7a3f2dfa151$require$Buffer = $9iKK3.Buffer;
var $7645c7a3f2dfa151$export$db1b38f0e0e0d735 = function(value) {
    return value != null && typeof value === "object" && typeof value.url === "string" && typeof value.blob === "function";
};
var $7645c7a3f2dfa151$export$f523b67034c5a6de = function(value) {
    return value != null && typeof value === "object" && typeof value.name === "string" && typeof value.lastModified === "number" && $7645c7a3f2dfa151$export$5c3b3b90b547c112(value);
};
var $7645c7a3f2dfa151$export$5c3b3b90b547c112 = function(value) {
    return value != null && typeof value === "object" && typeof value.size === "number" && typeof value.type === "string" && typeof value.text === "function" && typeof value.slice === "function" && typeof value.arrayBuffer === "function";
};
var $7645c7a3f2dfa151$export$291c899f7ea4e64e = function(value) {
    return $7645c7a3f2dfa151$export$f523b67034c5a6de(value) || $7645c7a3f2dfa151$export$db1b38f0e0e0d735(value) || (0, $28c79a08ea52e7a5$export$bb863823a5a2fbbe)(value);
};
function $7645c7a3f2dfa151$export$535467f7dab2a044(value, name, options) {
    return $7645c7a3f2dfa151$var$_toFile.apply(this, arguments);
}
function $7645c7a3f2dfa151$var$_toFile() {
    $7645c7a3f2dfa151$var$_toFile = (0, $9OZ9j._)(function(value, name, options) {
        var blob, _pathname_split_pop, bits, _getName, _bits_, type;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        value
                    ];
                case 1:
                    // If it's a promise, resolve it.
                    value = _state.sent();
                    // Use the file's options if there isn't one provided
                    options !== null && options !== void 0 ? options : options = $7645c7a3f2dfa151$export$f523b67034c5a6de(value) ? {
                        lastModified: value.lastModified,
                        type: value.type
                    } : {};
                    if (!$7645c7a3f2dfa151$export$db1b38f0e0e0d735(value)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        value.blob()
                    ];
                case 2:
                    blob = _state.sent();
                    name || (name = (_pathname_split_pop = new URL(value.url).pathname.split(/[\\/]/).pop()) !== null && _pathname_split_pop !== void 0 ? _pathname_split_pop : "unknown_file");
                    return [
                        2,
                        new (0, $28c79a08ea52e7a5$export$b6afa8811b7e644e)([
                            blob
                        ], name, options)
                    ];
                case 3:
                    return [
                        4,
                        $7645c7a3f2dfa151$var$getBytes(value)
                    ];
                case 4:
                    bits = _state.sent();
                    name || (name = (_getName = $7645c7a3f2dfa151$var$getName(value)) !== null && _getName !== void 0 ? _getName : "unknown_file");
                    if (!options.type) {
                        ;
                        type = (_bits_ = bits[0]) === null || _bits_ === void 0 ? void 0 : _bits_.type;
                        if (typeof type === "string") options = (0, $ddevm._)((0, $78DQ7._)({}, options), {
                            type: type
                        });
                    }
                    return [
                        2,
                        new (0, $28c79a08ea52e7a5$export$b6afa8811b7e644e)(bits, name, options)
                    ];
            }
        });
    });
    return $7645c7a3f2dfa151$var$_toFile.apply(this, arguments);
}
function $7645c7a3f2dfa151$var$getBytes(value) {
    return $7645c7a3f2dfa151$var$_getBytes.apply(this, arguments);
}
function $7645c7a3f2dfa151$var$_getBytes() {
    $7645c7a3f2dfa151$var$_getBytes = (0, $9OZ9j._)(function(value) {
        var _value_constructor, parts, _, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    parts = [];
                    if (!(typeof value === "string" || ArrayBuffer.isView(value) || // includes Uint8Array, Buffer, etc.
                    value instanceof ArrayBuffer)) return [
                        3,
                        1
                    ];
                    parts.push(value);
                    return [
                        3,
                        17
                    ];
                case 1:
                    if (!$7645c7a3f2dfa151$export$5c3b3b90b547c112(value)) return [
                        3,
                        3
                    ];
                    _ = parts.push;
                    return [
                        4,
                        value.arrayBuffer()
                    ];
                case 2:
                    _.apply(parts, [
                        _state.sent()
                    ]);
                    return [
                        3,
                        17
                    ];
                case 3:
                    if (!$7645c7a3f2dfa151$var$isAsyncIterableIterator(value) // includes Readable, ReadableStream, etc.
                    ) return [
                        3,
                        16
                    ];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        9,
                        10,
                        15
                    ]);
                    _iterator = (0, $gIbDP._)(value);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 6:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        8
                    ];
                    _value = _step.value;
                    chunk = _value;
                    parts.push(chunk); // TODO, consider validating?
                    _state.label = 7;
                case 7:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        5
                    ];
                case 8:
                    return [
                        3,
                        15
                    ];
                case 9:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        15
                    ];
                case 10:
                    _state.trys.push([
                        10,
                        ,
                        13,
                        14
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        12
                    ];
                    return [
                        4,
                        _iterator.return()
                    ];
                case 11:
                    _state.sent();
                    _state.label = 12;
                case 12:
                    return [
                        3,
                        14
                    ];
                case 13:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 14:
                    return [
                        7
                    ];
                case 15:
                    return [
                        3,
                        17
                    ];
                case 16:
                    throw new Error("Unexpected data type: ".concat(typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value), "; constructor: ").concat(value === null || value === void 0 ? void 0 : (_value_constructor = value.constructor) === null || _value_constructor === void 0 ? void 0 : _value_constructor.name, "; props: ").concat($7645c7a3f2dfa151$var$propsForError(value)));
                case 17:
                    return [
                        2,
                        parts
                    ];
            }
        });
    });
    return $7645c7a3f2dfa151$var$_getBytes.apply(this, arguments);
}
function $7645c7a3f2dfa151$var$propsForError(value) {
    var props = Object.getOwnPropertyNames(value);
    return "[".concat(props.map(function(p) {
        return '"'.concat(p, '"');
    }).join(", "), "]");
}
function $7645c7a3f2dfa151$var$getName(value) {
    var // For fs.ReadStream
    _getStringFromMaybeBuffer;
    return $7645c7a3f2dfa151$var$getStringFromMaybeBuffer(value.name) || $7645c7a3f2dfa151$var$getStringFromMaybeBuffer(value.filename) || ((_getStringFromMaybeBuffer = $7645c7a3f2dfa151$var$getStringFromMaybeBuffer(value.path)) === null || _getStringFromMaybeBuffer === void 0 ? void 0 : _getStringFromMaybeBuffer.split(/[\\/]/).pop());
}
var $7645c7a3f2dfa151$var$getStringFromMaybeBuffer = function(x) {
    if (typeof x === "string") return x;
    if (typeof $7645c7a3f2dfa151$require$Buffer !== "undefined" && x instanceof $7645c7a3f2dfa151$require$Buffer) return String(x);
    return undefined;
};
var $7645c7a3f2dfa151$var$isAsyncIterableIterator = function(value) {
    return value != null && typeof value === "object" && typeof value[Symbol.asyncIterator] === "function";
};
var $7645c7a3f2dfa151$export$669ddb8d269579e7 = function(body) {
    return body && typeof body === "object" && body.body && body[Symbol.toStringTag] === "MultipartBody";
};
var $7645c7a3f2dfa151$export$614988603be7a5f4 = function() {
    var _ref = (0, $9OZ9j._)(function(opts) {
        var form;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$7645c7a3f2dfa151$var$hasUploadableValue(opts.body)) return [
                        2,
                        opts
                    ];
                    return [
                        4,
                        $7645c7a3f2dfa151$export$f681a8129d2e9d28(opts.body)
                    ];
                case 1:
                    form = _state.sent();
                    return [
                        2,
                        (0, $28c79a08ea52e7a5$export$2dd6502ab973289e)(form, opts)
                    ];
            }
        });
    });
    return function maybeMultipartFormRequestOptions(opts) {
        return _ref.apply(this, arguments);
    };
}();
var $7645c7a3f2dfa151$export$6da4f64143a11f47 = function() {
    var _ref = (0, $9OZ9j._)(function(opts) {
        var form;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $7645c7a3f2dfa151$export$f681a8129d2e9d28(opts.body)
                    ];
                case 1:
                    form = _state.sent();
                    return [
                        2,
                        (0, $28c79a08ea52e7a5$export$2dd6502ab973289e)(form, opts)
                    ];
            }
        });
    });
    return function multipartFormRequestOptions(opts) {
        return _ref.apply(this, arguments);
    };
}();
var $7645c7a3f2dfa151$export$f681a8129d2e9d28 = function() {
    var _ref = (0, $9OZ9j._)(function(body) {
        var form;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    form = new (0, $28c79a08ea52e7a5$export$3963aa24c930693c)();
                    return [
                        4,
                        Promise.all(Object.entries(body || {}).map(function(param) {
                            var _param = (0, $2MTYX._)(param, 2), key = _param[0], value = _param[1];
                            return $7645c7a3f2dfa151$var$addFormValue(form, key, value);
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        form
                    ];
            }
        });
    });
    return function createForm(body) {
        return _ref.apply(this, arguments);
    };
}();
var $7645c7a3f2dfa151$var$hasUploadableValue = function(value) {
    if ($7645c7a3f2dfa151$export$291c899f7ea4e64e(value)) return true;
    if (Array.isArray(value)) return value.some($7645c7a3f2dfa151$var$hasUploadableValue);
    if (value && typeof value === "object") for(var k in value){
        if ($7645c7a3f2dfa151$var$hasUploadableValue(value[k])) return true;
    }
    return false;
};
var $7645c7a3f2dfa151$var$addFormValue = function() {
    var _ref = (0, $9OZ9j._)(function(form, key, value) {
        var file;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (value === undefined) return [
                        2
                    ];
                    if (value == null) throw new TypeError('Received null for "'.concat(key, "\"; to pass null in FormData, you must use the string 'null'"));
                    if (!(typeof value === "string" || typeof value === "number" || typeof value === "boolean")) return [
                        3,
                        1
                    ];
                    form.append(key, String(value));
                    return [
                        3,
                        8
                    ];
                case 1:
                    if (!$7645c7a3f2dfa151$export$291c899f7ea4e64e(value)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $7645c7a3f2dfa151$export$535467f7dab2a044(value)
                    ];
                case 2:
                    file = _state.sent();
                    form.append(key, file);
                    return [
                        3,
                        8
                    ];
                case 3:
                    if (!Array.isArray(value)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        Promise.all(value.map(function(entry) {
                            return $7645c7a3f2dfa151$var$addFormValue(form, key + "[]", entry);
                        }))
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 5:
                    if (!(typeof value === "object")) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        Promise.all(Object.entries(value).map(function(param) {
                            var _param = (0, $2MTYX._)(param, 2), name = _param[0], prop = _param[1];
                            return $7645c7a3f2dfa151$var$addFormValue(form, "".concat(key, "[").concat(name, "]"), prop);
                        }))
                    ];
                case 6:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 7:
                    throw new TypeError("Invalid value given to form, expected a string, number, boolean, object, Array, File or Blob but got ".concat(value, " instead"));
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function addFormValue(form, key, value) {
        return _ref.apply(this, arguments);
    };
}();



var $9iKK3 = parcelRequire("9iKK3");
var $29a2c2a4bb9c284e$require$Buffer = $9iKK3.Buffer;

var $hZFWO = parcelRequire("hZFWO");
var $29a2c2a4bb9c284e$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $29a2c2a4bb9c284e$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $29a2c2a4bb9c284e$var$_AbstractPage_client;
function $29a2c2a4bb9c284e$var$defaultParseResponse(props) {
    return $29a2c2a4bb9c284e$var$_defaultParseResponse.apply(this, arguments);
}
function $29a2c2a4bb9c284e$var$_defaultParseResponse() {
    $29a2c2a4bb9c284e$var$_defaultParseResponse = (0, $9OZ9j._)(function(props) {
        var response, contentType, isJSON, json, text;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    response = props.response;
                    if (props.options.stream) {
                        $29a2c2a4bb9c284e$export$1c9f709888824e05("response", response.status, response.url, response.headers, response.body);
                        // Note: there is an invariant here that isn't represented in the type system
                        // that if you set `stream: true` the response type must also be `Stream<T>`
                        if (props.options.__streamClass) return [
                            2,
                            props.options.__streamClass.fromSSEResponse(response, props.controller)
                        ];
                        return [
                            2,
                            (0, $7740b96e0d3c54cb$export$6a4eb2e7fc9e8903).fromSSEResponse(response, props.controller)
                        ];
                    }
                    // fetch refuses to read the body when the status code is 204.
                    if (response.status === 204) return [
                        2,
                        null
                    ];
                    if (props.options.__binaryResponse) return [
                        2,
                        response
                    ];
                    contentType = response.headers.get("content-type");
                    isJSON = (contentType === null || contentType === void 0 ? void 0 : contentType.includes("application/json")) || (contentType === null || contentType === void 0 ? void 0 : contentType.includes("application/vnd.api+json"));
                    if (!isJSON) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 1:
                    json = _state.sent();
                    $29a2c2a4bb9c284e$export$1c9f709888824e05("response", response.status, response.url, response.headers, json);
                    return [
                        2,
                        json
                    ];
                case 2:
                    return [
                        4,
                        response.text()
                    ];
                case 3:
                    text = _state.sent();
                    $29a2c2a4bb9c284e$export$1c9f709888824e05("response", response.status, response.url, response.headers, text);
                    // TODO handle blob, arraybuffer, other content types, etc.
                    return [
                        2,
                        text
                    ];
            }
        });
    });
    return $29a2c2a4bb9c284e$var$_defaultParseResponse.apply(this, arguments);
}
var $29a2c2a4bb9c284e$export$6d81b1be6cb81bf2 = /*#__PURE__*/ function(Promise1) {
    "use strict";
    (0, $iNfU4._)(APIPromise, Promise1);
    var _super = (0, $k1NN5._)(APIPromise);
    function APIPromise(responsePromise) {
        var parseResponse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $29a2c2a4bb9c284e$var$defaultParseResponse;
        (0, $19mwo._)(this, APIPromise);
        var _this;
        _this = _super.call(this, function(resolve) {
            // this is maybe a bit weird but this has to be a no-op to not implicitly
            // parse the response body; instead .then, .catch, .finally are overridden
            // to parse the response
            resolve(null);
        });
        _this.responsePromise = responsePromise;
        _this.parseResponse = parseResponse;
        return _this;
    }
    (0, $6rpfc._)(APIPromise, [
        {
            key: "_thenUnwrap",
            value: function _thenUnwrap(transform) {
                var _this = this;
                return new APIPromise(this.responsePromise, function() {
                    var _ref = (0, $9OZ9j._)(function(props) {
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _this.parseResponse(props)
                                    ];
                                case 1:
                                    return [
                                        2,
                                        transform.apply(void 0, [
                                            _state.sent()
                                        ])
                                    ];
                            }
                        });
                    });
                    return function(props) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            /**
     * Gets the raw `Response` instance instead of parsing the response
     * data.
     *
     * If you want to parse the response body but still get the `Response`
     * instance, you can use {@link withResponse()}.
     *
     * 👋 Getting the wrong TypeScript type for `Response`?
     * Try setting `"moduleResolution": "NodeNext"` if you can,
     * or add one of these imports before your first `import … from 'openai'`:
     * - `import 'openai/shims/node'` (if you're running on Node)
     * - `import 'openai/shims/web'` (otherwise)
     */ key: "asResponse",
            value: function asResponse() {
                return this.responsePromise.then(function(p) {
                    return p.response;
                });
            }
        },
        {
            key: "withResponse",
            value: /**
     * Gets the parsed response data and the raw `Response` instance.
     *
     * If you just want to get the raw `Response` instance without parsing it,
     * you can use {@link asResponse()}.
     *
     *
     * 👋 Getting the wrong TypeScript type for `Response`?
     * Try setting `"moduleResolution": "NodeNext"` if you can,
     * or add one of these imports before your first `import … from 'openai'`:
     * - `import 'openai/shims/node'` (if you're running on Node)
     * - `import 'openai/shims/web'` (otherwise)
     */ function withResponse() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _ref, data, response;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all([
                                        _this.parse(),
                                        _this.asResponse()
                                    ])
                                ];
                            case 1:
                                _ref = (0, $2MTYX._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), data = _ref[0], response = _ref[1];
                                return [
                                    2,
                                    {
                                        data: data,
                                        response: response
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "parse",
            value: function parse() {
                if (!this.parsedPromise) this.parsedPromise = this.responsePromise.then(this.parseResponse);
                return this.parsedPromise;
            }
        },
        {
            key: "then",
            value: function then(onfulfilled, onrejected) {
                return this.parse().then(onfulfilled, onrejected);
            }
        },
        {
            key: "catch",
            value: function _catch(onrejected) {
                return this.parse().catch(onrejected);
            }
        },
        {
            key: "finally",
            value: function _finally(onfinally) {
                return this.parse().finally(onfinally);
            }
        }
    ]);
    return APIPromise;
}((0, $etlBe._)(Promise));
var $29a2c2a4bb9c284e$export$90436f47e91435f2 = /*#__PURE__*/ function() {
    "use strict";
    function APIClient(param) {
        var baseURL = param.baseURL, _param_maxRetries = param.maxRetries, maxRetries = _param_maxRetries === void 0 ? 2 : _param_maxRetries, _param_timeout = param.timeout, timeout = _param_timeout === void 0 ? 600000 : _param_timeout, httpAgent = param.httpAgent, overridenFetch = param.fetch;
        (0, $19mwo._)(this, APIClient);
        this.baseURL = baseURL;
        this.maxRetries = $29a2c2a4bb9c284e$var$validatePositiveInteger("maxRetries", maxRetries);
        this.timeout = $29a2c2a4bb9c284e$var$validatePositiveInteger("timeout", timeout);
        this.httpAgent = httpAgent;
        this.fetch = overridenFetch !== null && overridenFetch !== void 0 ? overridenFetch : (0, $28c79a08ea52e7a5$export$e7aa7bc5c1b3cfb3);
    }
    (0, $6rpfc._)(APIClient, [
        {
            key: "authHeaders",
            value: function authHeaders(opts) {
                return {};
            }
        },
        {
            /**
     * Override this to add your own default headers, for example:
     *
     *  {
     *    ...super.defaultHeaders(),
     *    Authorization: 'Bearer 123',
     *  }
     */ key: "defaultHeaders",
            value: function defaultHeaders(opts) {
                return (0, $78DQ7._)({
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "User-Agent": this.getUserAgent()
                }, $29a2c2a4bb9c284e$var$getPlatformHeaders(), this.authHeaders(opts));
            }
        },
        {
            /**
     * Override this to add your own headers validation:
     */ key: "validateHeaders",
            value: function validateHeaders(headers, customHeaders) {}
        },
        {
            key: "defaultIdempotencyKey",
            value: function defaultIdempotencyKey() {
                return "stainless-node-retry-".concat($29a2c2a4bb9c284e$var$uuid4());
            }
        },
        {
            key: "get",
            value: function get(path, opts) {
                return this.methodRequest("get", path, opts);
            }
        },
        {
            key: "post",
            value: function post(path, opts) {
                return this.methodRequest("post", path, opts);
            }
        },
        {
            key: "patch",
            value: function patch(path, opts) {
                return this.methodRequest("patch", path, opts);
            }
        },
        {
            key: "put",
            value: function put(path, opts) {
                return this.methodRequest("put", path, opts);
            }
        },
        {
            key: "delete",
            value: function _delete(path, opts) {
                return this.methodRequest("delete", path, opts);
            }
        },
        {
            key: "methodRequest",
            value: function methodRequest(method, path, opts) {
                return this.request(Promise.resolve(opts).then(function() {
                    var _ref = (0, $9OZ9j._)(function(opts) {
                        var body, _tmp, _;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!(opts && (0, $7645c7a3f2dfa151$export$5c3b3b90b547c112)(opts === null || opts === void 0 ? void 0 : opts.body))) return [
                                        3,
                                        2
                                    ];
                                    _ = DataView.bind;
                                    return [
                                        4,
                                        opts.body.arrayBuffer()
                                    ];
                                case 1:
                                    _tmp = new (_.apply(DataView, [
                                        void 0,
                                        _state.sent()
                                    ]));
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    _tmp = (opts === null || opts === void 0 ? void 0 : opts.body) instanceof DataView ? opts.body : (opts === null || opts === void 0 ? void 0 : opts.body) instanceof ArrayBuffer ? new DataView(opts.body) : opts && ArrayBuffer.isView(opts === null || opts === void 0 ? void 0 : opts.body) ? new DataView(opts.body.buffer) : opts === null || opts === void 0 ? void 0 : opts.body;
                                    _state.label = 3;
                                case 3:
                                    body = _tmp;
                                    return [
                                        2,
                                        (0, $ddevm._)((0, $78DQ7._)({
                                            method: method,
                                            path: path
                                        }, opts), {
                                            body: body
                                        })
                                    ];
                            }
                        });
                    });
                    return function(opts) {
                        return _ref.apply(this, arguments);
                    };
                }()));
            }
        },
        {
            key: "getAPIList",
            value: function getAPIList(path, Page, opts) {
                return this.requestAPIList(Page, (0, $78DQ7._)({
                    method: "get",
                    path: path
                }, opts));
            }
        },
        {
            key: "calculateContentLength",
            value: function calculateContentLength(body) {
                if (typeof body === "string") {
                    if (typeof $29a2c2a4bb9c284e$require$Buffer !== "undefined") return $29a2c2a4bb9c284e$require$Buffer.byteLength(body, "utf8").toString();
                    if (typeof TextEncoder !== "undefined") {
                        var encoder = new TextEncoder();
                        var encoded = encoder.encode(body);
                        return encoded.length.toString();
                    }
                } else if (ArrayBuffer.isView(body)) return body.byteLength.toString();
                return null;
            }
        },
        {
            key: "buildRequest",
            value: function buildRequest(options) {
                var _httpAgent_options;
                var method = options.method, path = options.path, query = options.query, tmp = options.headers, headers = tmp === void 0 ? {} : tmp;
                var body = ArrayBuffer.isView(options.body) || options.__binaryRequest && typeof options.body === "string" ? options.body : (0, $7645c7a3f2dfa151$export$669ddb8d269579e7)(options.body) ? options.body.body : options.body ? JSON.stringify(options.body, null, 2) : null;
                var contentLength = this.calculateContentLength(body);
                var url = this.buildURL(path, query);
                if ("timeout" in options) $29a2c2a4bb9c284e$var$validatePositiveInteger("timeout", options.timeout);
                var _options_timeout;
                var timeout = (_options_timeout = options.timeout) !== null && _options_timeout !== void 0 ? _options_timeout : this.timeout;
                var _options_httpAgent, _ref;
                var httpAgent = (_ref = (_options_httpAgent = options.httpAgent) !== null && _options_httpAgent !== void 0 ? _options_httpAgent : this.httpAgent) !== null && _ref !== void 0 ? _ref : (0, $28c79a08ea52e7a5$export$4430d10c2e71ce6c)(url);
                var minAgentTimeout = timeout + 1000;
                var _httpAgent_options_timeout;
                if (typeof (httpAgent === null || httpAgent === void 0 ? void 0 : (_httpAgent_options = httpAgent.options) === null || _httpAgent_options === void 0 ? void 0 : _httpAgent_options.timeout) === "number" && minAgentTimeout > ((_httpAgent_options_timeout = httpAgent.options.timeout) !== null && _httpAgent_options_timeout !== void 0 ? _httpAgent_options_timeout : 0)) // Allow any given request to bump our agent active socket timeout.
                // This may seem strange, but leaking active sockets should be rare and not particularly problematic,
                // and without mutating agent we would need to create more of them.
                // This tradeoff optimizes for performance.
                httpAgent.options.timeout = minAgentTimeout;
                if (this.idempotencyHeader && method !== "get") {
                    if (!options.idempotencyKey) options.idempotencyKey = this.defaultIdempotencyKey();
                    headers[this.idempotencyHeader] = options.idempotencyKey;
                }
                var reqHeaders = this.buildHeaders({
                    options: options,
                    headers: headers,
                    contentLength: contentLength
                });
                var _options_signal;
                var req = (0, $ddevm._)((0, $78DQ7._)((0, $ddevm._)((0, $78DQ7._)({
                    method: method
                }, body && {
                    body: body
                }), {
                    headers: reqHeaders
                }), httpAgent && {
                    agent: httpAgent
                }), {
                    // @ts-ignore node-fetch uses a custom AbortSignal type that is
                    // not compatible with standard web types
                    signal: (_options_signal = options.signal) !== null && _options_signal !== void 0 ? _options_signal : null
                });
                return {
                    req: req,
                    url: url,
                    timeout: timeout
                };
            }
        },
        {
            key: "buildHeaders",
            value: function buildHeaders(param) {
                var options = param.options, headers = param.headers, contentLength = param.contentLength;
                var reqHeaders = {};
                if (contentLength) reqHeaders["content-length"] = contentLength;
                var defaultHeaders = this.defaultHeaders(options);
                $29a2c2a4bb9c284e$var$applyHeadersMut(reqHeaders, defaultHeaders);
                $29a2c2a4bb9c284e$var$applyHeadersMut(reqHeaders, headers);
                // let builtin fetch set the Content-Type for multipart bodies
                if ((0, $7645c7a3f2dfa151$export$669ddb8d269579e7)(options.body) && (0, $28c79a08ea52e7a5$export$78062f36b16ed2f8) !== "node") delete reqHeaders["content-type"];
                this.validateHeaders(reqHeaders, headers);
                return reqHeaders;
            }
        },
        {
            key: "prepareOptions",
            value: /**
     * Used as a callback for mutating the given `FinalRequestOptions` object.
     */ function prepareOptions(options) {
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "prepareRequest",
            value: /**
     * Used as a callback for mutating the given `RequestInit` object.
     *
     * This is useful for cases where you want to add certain headers based off of
     * the request properties, e.g. `method` or `url`.
     */ function prepareRequest(request, param) {
                var url = param.url, options = param.options;
                return (0, $9OZ9j._)(function() {
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "parseHeaders",
            value: function parseHeaders(headers) {
                return !headers ? {} : Symbol.iterator in headers ? Object.fromEntries(Array.from(headers).map(function(header) {
                    return (0, $3jzhD._)(header);
                })) : (0, $78DQ7._)({}, headers);
            }
        },
        {
            key: "makeStatusError",
            value: function makeStatusError(status, error, message, headers) {
                return (0, $15f6ed5911d7e12b$export$3e5b797e39668f84).generate(status, error, message, headers);
            }
        },
        {
            key: "request",
            value: function request(options) {
                var remainingRetries = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return new $29a2c2a4bb9c284e$export$6d81b1be6cb81bf2(this.makeRequest(options, remainingRetries));
            }
        },
        {
            key: "makeRequest",
            value: function makeRequest(optionsInput, retriesRemaining) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _options_signal, options, _options_maxRetries, _this_buildRequest, req, url, timeout, controller, response, _options_signal1, responseHeaders, retryMessage, errText, errJSON, errMessage, retryMessage1, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    optionsInput
                                ];
                            case 1:
                                options = _state.sent();
                                if (retriesRemaining == null) retriesRemaining = (_options_maxRetries = options.maxRetries) !== null && _options_maxRetries !== void 0 ? _options_maxRetries : _this.maxRetries;
                                return [
                                    4,
                                    _this.prepareOptions(options)
                                ];
                            case 2:
                                _state.sent();
                                _this_buildRequest = _this.buildRequest(options), req = _this_buildRequest.req, url = _this_buildRequest.url, timeout = _this_buildRequest.timeout;
                                return [
                                    4,
                                    _this.prepareRequest(req, {
                                        url: url,
                                        options: options
                                    })
                                ];
                            case 3:
                                _state.sent();
                                $29a2c2a4bb9c284e$export$1c9f709888824e05("request", url, options, req.headers);
                                if ((_options_signal = options.signal) === null || _options_signal === void 0 ? void 0 : _options_signal.aborted) throw new (0, $15f6ed5911d7e12b$export$2a26fd236aba7348)();
                                controller = new AbortController();
                                return [
                                    4,
                                    _this.fetchWithTimeout(url, req, timeout, controller).catch($29a2c2a4bb9c284e$export$b2c0dd4e7376122b)
                                ];
                            case 4:
                                response = _state.sent();
                                if (response instanceof Error) {
                                    ;
                                    if ((_options_signal1 = options.signal) === null || _options_signal1 === void 0 ? void 0 : _options_signal1.aborted) throw new (0, $15f6ed5911d7e12b$export$2a26fd236aba7348)();
                                    if (retriesRemaining) return [
                                        2,
                                        _this.retryRequest(options, retriesRemaining)
                                    ];
                                    if (response.name === "AbortError") throw new (0, $15f6ed5911d7e12b$export$51181302f6f4bef3)();
                                    throw new (0, $15f6ed5911d7e12b$export$74b830ad1c700a9b)({
                                        cause: response
                                    });
                                }
                                responseHeaders = $29a2c2a4bb9c284e$export$eda8ebdd36f248ed(response.headers);
                                if (!!response.ok) return [
                                    3,
                                    6
                                ];
                                if (retriesRemaining && _this.shouldRetry(response)) {
                                    retryMessage = "retrying, ".concat(retriesRemaining, " attempts remaining");
                                    $29a2c2a4bb9c284e$export$1c9f709888824e05("response (error; ".concat(retryMessage, ")"), response.status, url, responseHeaders);
                                    return [
                                        2,
                                        _this.retryRequest(options, retriesRemaining, responseHeaders)
                                    ];
                                }
                                return [
                                    4,
                                    response.text().catch(function(e) {
                                        return $29a2c2a4bb9c284e$export$b2c0dd4e7376122b(e).message;
                                    })
                                ];
                            case 5:
                                errText = _state.sent();
                                errJSON = $29a2c2a4bb9c284e$export$7c9c6fb6298d9204(errText);
                                errMessage = errJSON ? undefined : errText;
                                retryMessage1 = retriesRemaining ? "(error; no more retries left)" : "(error; not retryable)";
                                $29a2c2a4bb9c284e$export$1c9f709888824e05("response (error; ".concat(retryMessage1, ")"), response.status, url, responseHeaders, errMessage);
                                err = _this.makeStatusError(response.status, errJSON, errMessage, responseHeaders);
                                throw err;
                            case 6:
                                return [
                                    2,
                                    {
                                        response: response,
                                        options: options,
                                        controller: controller
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestAPIList",
            value: function requestAPIList(Page, options) {
                var request = this.makeRequest(options, null);
                return new $29a2c2a4bb9c284e$export$838875a2a6347bb(this, request, Page);
            }
        },
        {
            key: "buildURL",
            value: function buildURL(path, query) {
                var url = $29a2c2a4bb9c284e$var$isAbsoluteURL(path) ? new URL(path) : new URL(this.baseURL + (this.baseURL.endsWith("/") && path.startsWith("/") ? path.slice(1) : path));
                var defaultQuery = this.defaultQuery();
                if (!$29a2c2a4bb9c284e$export$4a2fbc025e4a4a37(defaultQuery)) query = (0, $78DQ7._)({}, defaultQuery, query);
                if (typeof query === "object" && query && !Array.isArray(query)) url.search = this.stringifyQuery(query);
                return url.toString();
            }
        },
        {
            key: "stringifyQuery",
            value: function stringifyQuery(query) {
                return Object.entries(query).filter(function(param) {
                    var _param = (0, $2MTYX._)(param, 2), _ = _param[0], value = _param[1];
                    return typeof value !== "undefined";
                }).map(function(param) {
                    var _param = (0, $2MTYX._)(param, 2), key = _param[0], value = _param[1];
                    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
                    if (value === null) return "".concat(encodeURIComponent(key), "=");
                    throw new (0, $15f6ed5911d7e12b$export$7668a15b8d9a0caa)("Cannot stringify type ".concat(typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value), "; Expected string, number, boolean, or null. If you need to pass nested query parameters, you can manually encode them, e.g. { query: { 'foo[key1]': value1, 'foo[key2]': value2 } }, and please open a GitHub issue requesting better support for your use case."));
                }).join("&");
            }
        },
        {
            key: "fetchWithTimeout",
            value: function fetchWithTimeout(url, init, ms, controller) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var _ref, signal, options, timeout;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        _ref = init || {}, signal = _ref.signal, options = (0, $6JqHh._)(_ref, [
                            "signal"
                        ]);
                        if (signal) signal.addEventListener("abort", function() {
                            return controller.abort();
                        });
                        timeout = setTimeout(function() {
                            return controller.abort();
                        }, ms);
                        return [
                            2,
                            _this.getRequestClient()// use undefined this binding; fetch errors if bound to something else in browser/cloudflare
                            .fetch.call(undefined, url, (0, $78DQ7._)({
                                signal: controller.signal
                            }, options)).finally(function() {
                                clearTimeout(timeout);
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getRequestClient",
            value: function getRequestClient() {
                return {
                    fetch: this.fetch
                };
            }
        },
        {
            key: "shouldRetry",
            value: function shouldRetry(response) {
                // Note this is not a standard header.
                var shouldRetryHeader = response.headers.get("x-should-retry");
                // If the server explicitly says whether or not to retry, obey.
                if (shouldRetryHeader === "true") return true;
                if (shouldRetryHeader === "false") return false;
                // Retry on request timeouts.
                if (response.status === 408) return true;
                // Retry on lock timeouts.
                if (response.status === 409) return true;
                // Retry on rate limits.
                if (response.status === 429) return true;
                // Retry internal errors.
                if (response.status >= 500) return true;
                return false;
            }
        },
        {
            key: "retryRequest",
            value: function retryRequest(options, retriesRemaining, responseHeaders) {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var timeoutMillis, retryAfterMillisHeader, timeoutMs, retryAfterHeader, timeoutSeconds, _options_maxRetries, maxRetries;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Note the `retry-after-ms` header may not be standard, but is a good idea and we'd like proactive support for it.
                                retryAfterMillisHeader = responseHeaders === null || responseHeaders === void 0 ? void 0 : responseHeaders["retry-after-ms"];
                                if (retryAfterMillisHeader) {
                                    timeoutMs = parseFloat(retryAfterMillisHeader);
                                    if (!Number.isNaN(timeoutMs)) timeoutMillis = timeoutMs;
                                }
                                // About the Retry-After header: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After
                                retryAfterHeader = responseHeaders === null || responseHeaders === void 0 ? void 0 : responseHeaders["retry-after"];
                                if (retryAfterHeader && !timeoutMillis) {
                                    timeoutSeconds = parseFloat(retryAfterHeader);
                                    if (!Number.isNaN(timeoutSeconds)) timeoutMillis = timeoutSeconds * 1000;
                                    else timeoutMillis = Date.parse(retryAfterHeader) - Date.now();
                                }
                                // If the API asks us to wait a certain amount of time (and it's a reasonable amount),
                                // just do what it says, but otherwise calculate a default
                                if (!(timeoutMillis && 0 <= timeoutMillis && timeoutMillis < 60000)) {
                                    ;
                                    maxRetries = (_options_maxRetries = options.maxRetries) !== null && _options_maxRetries !== void 0 ? _options_maxRetries : _this.maxRetries;
                                    timeoutMillis = _this.calculateDefaultRetryTimeoutMillis(retriesRemaining, maxRetries);
                                }
                                return [
                                    4,
                                    $29a2c2a4bb9c284e$export$e772c8ff12451969(timeoutMillis)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.makeRequest(options, retriesRemaining - 1)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "calculateDefaultRetryTimeoutMillis",
            value: function calculateDefaultRetryTimeoutMillis(retriesRemaining, maxRetries) {
                var initialRetryDelay = 0.5;
                var maxRetryDelay = 8.0;
                var numRetries = maxRetries - retriesRemaining;
                // Apply exponential backoff, but not more than the max.
                var sleepSeconds = Math.min(initialRetryDelay * Math.pow(2, numRetries), maxRetryDelay);
                // Apply some jitter, take up to at most 25 percent of the retry time.
                var jitter = 1 - Math.random() * 0.25;
                return sleepSeconds * jitter * 1000;
            }
        },
        {
            key: "getUserAgent",
            value: function getUserAgent() {
                return "".concat(this.constructor.name, "/JS ").concat((0, $d86ec578a7801a8a$export$a4ad2735b021c132));
            }
        }
    ]);
    return APIClient;
}();
var $29a2c2a4bb9c284e$export$bc4ec43eb76c64ae = /*#__PURE__*/ function() {
    "use strict";
    function AbstractPage(client, response, body, options) {
        (0, $19mwo._)(this, AbstractPage);
        $29a2c2a4bb9c284e$var$_AbstractPage_client.set(this, void 0);
        $29a2c2a4bb9c284e$var$__classPrivateFieldSet(this, $29a2c2a4bb9c284e$var$_AbstractPage_client, client, "f");
        this.options = options;
        this.response = response;
        this.body = body;
    }
    (0, $6rpfc._)(AbstractPage, [
        {
            key: "hasNextPage",
            value: function hasNextPage() {
                var items = this.getPaginatedItems();
                if (!items.length) return false;
                return this.nextPageInfo() != null;
            }
        },
        {
            key: "getNextPage",
            value: function getNextPage() {
                var _this = this;
                return (0, $9OZ9j._)(function() {
                    var nextInfo, nextOptions, params, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, value;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                nextInfo = _this.nextPageInfo();
                                if (!nextInfo) throw new (0, $15f6ed5911d7e12b$export$7668a15b8d9a0caa)("No next page expected; please check `.hasNextPage()` before calling `.getNextPage()`.");
                                nextOptions = (0, $78DQ7._)({}, _this.options);
                                if ("params" in nextInfo && typeof nextOptions.query === "object") nextOptions.query = (0, $78DQ7._)({}, nextOptions.query, nextInfo.params);
                                else if ("url" in nextInfo) {
                                    params = (0, $3jzhD._)(Object.entries(nextOptions.query || {})).concat((0, $3jzhD._)(nextInfo.url.searchParams.entries()));
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = params[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            _step_value = (0, $2MTYX._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                                            nextInfo.url.searchParams.set(key, value);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    nextOptions.query = undefined;
                                    nextOptions.path = nextInfo.url.toString();
                                }
                                return [
                                    4,
                                    $29a2c2a4bb9c284e$var$__classPrivateFieldGet(_this, $29a2c2a4bb9c284e$var$_AbstractPage_client, "f").requestAPIList(_this.constructor, nextOptions)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "iterPages",
            value: function iterPages() {
                var _this = this;
                return (0, $e2m1c._)(function() {
                    var page;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // eslint-disable-next-line @typescript-eslint/no-this-alias
                                page = _this;
                                return [
                                    4,
                                    page
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                if (!page.hasNextPage()) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    (0, $27QSE._)(page.getNextPage())
                                ];
                            case 3:
                                page = _state.sent();
                                return [
                                    4,
                                    page
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: ($29a2c2a4bb9c284e$var$_AbstractPage_client = new WeakMap(), Symbol.asyncIterator),
            value: function value() {
                var _this = this;
                return (0, $e2m1c._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, page, _iteratorNormalCompletion, _didIteratorError1, _iteratorError1, _iterator1, _step1, item, err, err1;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    13,
                                    14,
                                    19
                                ]);
                                _iterator = (0, $gIbDP._)(_this.iterPages());
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    (0, $27QSE._)(_iterator.next())
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    12
                                ];
                                _value = _step.value;
                                page = _value;
                                _iteratorNormalCompletion = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    9,
                                    10,
                                    11
                                ]);
                                _iterator1 = page.getPaginatedItems()[Symbol.iterator]();
                                _state.label = 5;
                            case 5:
                                if (!!(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    8
                                ];
                                item = _step1.value;
                                return [
                                    4,
                                    item
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    5
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 11:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 12:
                                return [
                                    3,
                                    19
                                ];
                            case 13:
                                err1 = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err1;
                                return [
                                    3,
                                    19
                                ];
                            case 14:
                                _state.trys.push([
                                    14,
                                    ,
                                    17,
                                    18
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    16
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 15:
                                _state.sent();
                                _state.label = 16;
                            case 16:
                                return [
                                    3,
                                    18
                                ];
                            case 17:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 18:
                                return [
                                    7
                                ];
                            case 19:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AbstractPage;
}();
var $29a2c2a4bb9c284e$export$838875a2a6347bb = /*#__PURE__*/ function(APIPromise) {
    "use strict";
    (0, $iNfU4._)(PagePromise, APIPromise);
    var _super = (0, $k1NN5._)(PagePromise);
    function PagePromise(client, request, Page) {
        (0, $19mwo._)(this, PagePromise);
        return _super.call(this, request, function() {
            var _ref = (0, $9OZ9j._)(function(props) {
                var _, _tmp;
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _ = Page.bind;
                            _tmp = [
                                void 0,
                                client,
                                props.response
                            ];
                            return [
                                4,
                                $29a2c2a4bb9c284e$var$defaultParseResponse(props)
                            ];
                        case 1:
                            return [
                                2,
                                new (_.apply(Page, _tmp.concat([
                                    _state.sent(),
                                    props.options
                                ])))
                            ];
                    }
                });
            });
            return function(props) {
                return _ref.apply(this, arguments);
            };
        }());
    }
    (0, $6rpfc._)(PagePromise, [
        {
            key: Symbol.asyncIterator,
            value: /**
     * Allow auto-paginating iteration on an unawaited list call, eg:
     *
     *    for await (const item of client.items.list()) {
     *      console.log(item)
     *    }
     */ function value() {
                var _this = this;
                return (0, $e2m1c._)(function() {
                    var page, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, err;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $27QSE._)(_this)
                                ];
                            case 1:
                                page = _state.sent();
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    8,
                                    9,
                                    14
                                ]);
                                _iterator = (0, $gIbDP._)(page);
                                _state.label = 3;
                            case 3:
                                return [
                                    4,
                                    (0, $27QSE._)(_iterator.next())
                                ];
                            case 4:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    7
                                ];
                                _value = _step.value;
                                item = _value;
                                return [
                                    4,
                                    item
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    3
                                ];
                            case 7:
                                return [
                                    3,
                                    14
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    14
                                ];
                            case 9:
                                _state.trys.push([
                                    9,
                                    ,
                                    12,
                                    13
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    11
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 10:
                                _state.sent();
                                _state.label = 11;
                            case 11:
                                return [
                                    3,
                                    13
                                ];
                            case 12:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 13:
                                return [
                                    7
                                ];
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PagePromise;
}($29a2c2a4bb9c284e$export$6d81b1be6cb81bf2);
var $29a2c2a4bb9c284e$export$eda8ebdd36f248ed = function(headers) {
    return new Proxy(Object.fromEntries(// @ts-ignore
    headers.entries()), {
        get: function(target, name) {
            var key = name.toString();
            return target[key.toLowerCase()] || target[key];
        }
    });
};
// This is required so that we can determine if a given object matches the RequestOptions
// type at runtime. While this requires duplication, it is enforced by the TypeScript
// compiler such that any missing / extraneous keys will cause an error.
var $29a2c2a4bb9c284e$var$requestOptionsKeys = {
    method: true,
    path: true,
    query: true,
    body: true,
    headers: true,
    maxRetries: true,
    stream: true,
    timeout: true,
    httpAgent: true,
    signal: true,
    idempotencyKey: true,
    __binaryRequest: true,
    __binaryResponse: true,
    __streamClass: true
};
var $29a2c2a4bb9c284e$export$3a8c02e2928a14fc = function(obj) {
    return typeof obj === "object" && obj !== null && !$29a2c2a4bb9c284e$export$4a2fbc025e4a4a37(obj) && Object.keys(obj).every(function(k) {
        return $29a2c2a4bb9c284e$export$b5a638e9b3fff9f3($29a2c2a4bb9c284e$var$requestOptionsKeys, k);
    });
};
var $29a2c2a4bb9c284e$var$getPlatformProperties = function() {
    var _Deno_version;
    var _Deno_version_deno;
    if (typeof Deno !== "undefined" && Deno.build != null) return {
        "X-Stainless-Lang": "js",
        "X-Stainless-Package-Version": (0, $d86ec578a7801a8a$export$a4ad2735b021c132),
        "X-Stainless-OS": $29a2c2a4bb9c284e$var$normalizePlatform(Deno.build.os),
        "X-Stainless-Arch": $29a2c2a4bb9c284e$var$normalizeArch(Deno.build.arch),
        "X-Stainless-Runtime": "deno",
        "X-Stainless-Runtime-Version": typeof Deno.version === "string" ? Deno.version : (_Deno_version_deno = (_Deno_version = Deno.version) === null || _Deno_version === void 0 ? void 0 : _Deno_version.deno) !== null && _Deno_version_deno !== void 0 ? _Deno_version_deno : "unknown"
    };
    if (typeof EdgeRuntime !== "undefined") return {
        "X-Stainless-Lang": "js",
        "X-Stainless-Package-Version": (0, $d86ec578a7801a8a$export$a4ad2735b021c132),
        "X-Stainless-OS": "Unknown",
        "X-Stainless-Arch": "other:".concat(EdgeRuntime),
        "X-Stainless-Runtime": "edge",
        "X-Stainless-Runtime-Version": $hZFWO.version
    };
    // Check if Node.js
    if (Object.prototype.toString.call(typeof $hZFWO !== "undefined" ? $hZFWO : 0) === "[object process]") return {
        "X-Stainless-Lang": "js",
        "X-Stainless-Package-Version": (0, $d86ec578a7801a8a$export$a4ad2735b021c132),
        "X-Stainless-OS": $29a2c2a4bb9c284e$var$normalizePlatform($hZFWO.platform),
        "X-Stainless-Arch": $29a2c2a4bb9c284e$var$normalizeArch($hZFWO.arch),
        "X-Stainless-Runtime": "node",
        "X-Stainless-Runtime-Version": $hZFWO.version
    };
    var browserInfo = $29a2c2a4bb9c284e$var$getBrowserInfo();
    if (browserInfo) return {
        "X-Stainless-Lang": "js",
        "X-Stainless-Package-Version": (0, $d86ec578a7801a8a$export$a4ad2735b021c132),
        "X-Stainless-OS": "Unknown",
        "X-Stainless-Arch": "unknown",
        "X-Stainless-Runtime": "browser:".concat(browserInfo.browser),
        "X-Stainless-Runtime-Version": browserInfo.version
    };
    // TODO add support for Cloudflare workers, etc.
    return {
        "X-Stainless-Lang": "js",
        "X-Stainless-Package-Version": (0, $d86ec578a7801a8a$export$a4ad2735b021c132),
        "X-Stainless-OS": "Unknown",
        "X-Stainless-Arch": "unknown",
        "X-Stainless-Runtime": "unknown",
        "X-Stainless-Runtime-Version": "unknown"
    };
};
// Note: modified from https://github.com/JS-DevTools/host-environment/blob/b1ab79ecde37db5d6e163c050e54fe7d287d7c92/src/isomorphic.browser.ts
function $29a2c2a4bb9c284e$var$getBrowserInfo() {
    if (typeof navigator === "undefined" || !navigator) return null;
    // NOTE: The order matters here!
    var browserPatterns = [
        {
            key: "edge",
            pattern: /Edge(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: "ie",
            pattern: /MSIE(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: "ie",
            pattern: /Trident(?:.*rv\:(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: "chrome",
            pattern: /Chrome(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: "firefox",
            pattern: /Firefox(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: "safari",
            pattern: /(?:Version\W+(\d+)\.(\d+)(?:\.(\d+))?)?(?:\W+Mobile\S*)?\W+Safari/
        }
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Find the FIRST matching browser
        for(var _iterator = browserPatterns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, key = _step_value.key, pattern = _step_value.pattern;
            var match = pattern.exec(navigator.userAgent);
            if (match) {
                var major = match[1] || 0;
                var minor = match[2] || 0;
                var patch = match[3] || 0;
                return {
                    browser: key,
                    version: "".concat(major, ".").concat(minor, ".").concat(patch)
                };
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
var $29a2c2a4bb9c284e$var$normalizeArch = function(arch) {
    // Node docs:
    // - https://nodejs.org/api/process.html#processarch
    // Deno docs:
    // - https://doc.deno.land/deno/stable/~/Deno.build
    if (arch === "x32") return "x32";
    if (arch === "x86_64" || arch === "x64") return "x64";
    if (arch === "arm") return "arm";
    if (arch === "aarch64" || arch === "arm64") return "arm64";
    if (arch) return "other:".concat(arch);
    return "unknown";
};
var $29a2c2a4bb9c284e$var$normalizePlatform = function(platform) {
    // Node platforms:
    // - https://nodejs.org/api/process.html#processplatform
    // Deno platforms:
    // - https://doc.deno.land/deno/stable/~/Deno.build
    // - https://github.com/denoland/deno/issues/14799
    platform = platform.toLowerCase();
    // NOTE: this iOS check is untested and may not work
    // Node does not work natively on IOS, there is a fork at
    // https://github.com/nodejs-mobile/nodejs-mobile
    // however it is unknown at the time of writing how to detect if it is running
    if (platform.includes("ios")) return "iOS";
    if (platform === "android") return "Android";
    if (platform === "darwin") return "MacOS";
    if (platform === "win32") return "Windows";
    if (platform === "freebsd") return "FreeBSD";
    if (platform === "openbsd") return "OpenBSD";
    if (platform === "linux") return "Linux";
    if (platform) return "Other:".concat(platform);
    return "Unknown";
};
var $29a2c2a4bb9c284e$var$_platformHeaders;
var $29a2c2a4bb9c284e$var$getPlatformHeaders = function() {
    return $29a2c2a4bb9c284e$var$_platformHeaders !== null && $29a2c2a4bb9c284e$var$_platformHeaders !== void 0 ? $29a2c2a4bb9c284e$var$_platformHeaders : $29a2c2a4bb9c284e$var$_platformHeaders = $29a2c2a4bb9c284e$var$getPlatformProperties();
};
var $29a2c2a4bb9c284e$export$7c9c6fb6298d9204 = function(text) {
    try {
        return JSON.parse(text);
    } catch (err) {
        return undefined;
    }
};
// https://stackoverflow.com/a/19709846
var $29a2c2a4bb9c284e$var$startsWithSchemeRegexp = new RegExp("^(?:[a-z]+:)?//", "i");
var $29a2c2a4bb9c284e$var$isAbsoluteURL = function(url) {
    return $29a2c2a4bb9c284e$var$startsWithSchemeRegexp.test(url);
};
var $29a2c2a4bb9c284e$export$e772c8ff12451969 = function(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
};
var $29a2c2a4bb9c284e$var$validatePositiveInteger = function(name, n) {
    if (typeof n !== "number" || !Number.isInteger(n)) throw new (0, $15f6ed5911d7e12b$export$7668a15b8d9a0caa)("".concat(name, " must be an integer"));
    if (n < 0) throw new (0, $15f6ed5911d7e12b$export$7668a15b8d9a0caa)("".concat(name, " must be a positive integer"));
    return n;
};
var $29a2c2a4bb9c284e$export$b2c0dd4e7376122b = function(err) {
    if (err instanceof Error) return err;
    return new Error(err);
};
var $29a2c2a4bb9c284e$export$af4c7db3845bb1c2 = function(value) {
    if (value == null) throw new (0, $15f6ed5911d7e12b$export$7668a15b8d9a0caa)("Expected a value to be given but received ".concat(value, " instead."));
    return value;
};
var $29a2c2a4bb9c284e$export$ccbbfd667734d5ac = function(env) {
    var _process_env_env, _process_env, _Deno_env_get, _Deno_env_get1, _Deno_env;
    var _process_env_env_trim;
    if (typeof $hZFWO !== "undefined") return (_process_env_env_trim = (_process_env = $hZFWO.env) === null || _process_env === void 0 ? void 0 : (_process_env_env = _process_env[env]) === null || _process_env_env === void 0 ? void 0 : _process_env_env.trim()) !== null && _process_env_env_trim !== void 0 ? _process_env_env_trim : undefined;
    if (typeof Deno !== "undefined") return (_Deno_env = Deno.env) === null || _Deno_env === void 0 ? void 0 : (_Deno_env_get1 = _Deno_env.get) === null || _Deno_env_get1 === void 0 ? void 0 : (_Deno_env_get = _Deno_env_get1.call(_Deno_env, env)) === null || _Deno_env_get === void 0 ? void 0 : _Deno_env_get.trim();
    return undefined;
};
var $29a2c2a4bb9c284e$export$4ecf346c64b3eb34 = function(value) {
    if (typeof value === "number") return Math.round(value);
    if (typeof value === "string") return parseInt(value, 10);
    throw new (0, $15f6ed5911d7e12b$export$7668a15b8d9a0caa)("Could not coerce ".concat(value, " (type: ").concat(typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value), ") into a number"));
};
var $29a2c2a4bb9c284e$export$1b14e584613ce4b7 = function(value) {
    if (typeof value === "number") return value;
    if (typeof value === "string") return parseFloat(value);
    throw new (0, $15f6ed5911d7e12b$export$7668a15b8d9a0caa)("Could not coerce ".concat(value, " (type: ").concat(typeof value === "undefined" ? "undefined" : (0, $gnDeW._)(value), ") into a number"));
};
var $29a2c2a4bb9c284e$export$b69d37584141bf44 = function(value) {
    if (typeof value === "boolean") return value;
    if (typeof value === "string") return value === "true";
    return Boolean(value);
};
var $29a2c2a4bb9c284e$export$ffe3c99a2918ca65 = function(value) {
    if (value === undefined) return undefined;
    return $29a2c2a4bb9c284e$export$4ecf346c64b3eb34(value);
};
var $29a2c2a4bb9c284e$export$5747ea88f091c953 = function(value) {
    if (value === undefined) return undefined;
    return $29a2c2a4bb9c284e$export$1b14e584613ce4b7(value);
};
var $29a2c2a4bb9c284e$export$8f9b66bb1b32b85b = function(value) {
    if (value === undefined) return undefined;
    return $29a2c2a4bb9c284e$export$b69d37584141bf44(value);
};
function $29a2c2a4bb9c284e$export$4a2fbc025e4a4a37(obj) {
    if (!obj) return true;
    for(var _k in obj)return false;
    return true;
}
function $29a2c2a4bb9c284e$export$b5a638e9b3fff9f3(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
/**
 * Copies headers from "newHeaders" onto "targetHeaders",
 * using lower-case for all properties,
 * ignoring any keys with undefined values,
 * and deleting any keys with null values.
 */ function $29a2c2a4bb9c284e$var$applyHeadersMut(targetHeaders, newHeaders) {
    for(var k in newHeaders){
        if (!$29a2c2a4bb9c284e$export$b5a638e9b3fff9f3(newHeaders, k)) continue;
        var lowerKey = k.toLowerCase();
        if (!lowerKey) continue;
        var val = newHeaders[k];
        if (val === null) delete targetHeaders[lowerKey];
        else if (val !== undefined) targetHeaders[lowerKey] = val;
    }
}
function $29a2c2a4bb9c284e$export$1c9f709888824e05(action) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _console;
    var _process_env;
    if (typeof $hZFWO !== "undefined" && ($hZFWO === null || $hZFWO === void 0 ? void 0 : (_process_env = $hZFWO.env) === null || _process_env === void 0 ? void 0 : _process_env["DEBUG"]) === "true") (_console = console).log.apply(_console, [
        "OpenAI:DEBUG:".concat(action)
    ].concat((0, $3jzhD._)(args)));
}
/**
 * https://stackoverflow.com/a/2117523
 */ var $29a2c2a4bb9c284e$var$uuid4 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        var v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
var $29a2c2a4bb9c284e$export$d4d7320082b94e3c = function() {
    return(// @ts-ignore
    typeof window !== "undefined" && // @ts-ignore
    typeof window.document !== "undefined" && // @ts-ignore
    typeof navigator !== "undefined");
};
var $29a2c2a4bb9c284e$export$612d5d4e00056e45 = function(headers) {
    return typeof (headers === null || headers === void 0 ? void 0 : headers.get) === "function";
};
var $29a2c2a4bb9c284e$export$3a1f8923f8f0cd57 = function(headers, header) {
    var lowerCasedHeader = header.toLowerCase();
    if ($29a2c2a4bb9c284e$export$612d5d4e00056e45(headers)) {
        var _header_;
        // to deal with the case where the header looks like Stainless-Event-Id
        var intercapsHeader = ((_header_ = header[0]) === null || _header_ === void 0 ? void 0 : _header_.toUpperCase()) + header.substring(1).replace(/([^\w])(\w)/g, function(_m, g1, g2) {
            return g1 + g2.toUpperCase();
        });
        for(var _i = 0, _iter = [
            header,
            lowerCasedHeader,
            header.toUpperCase(),
            intercapsHeader
        ]; _i < _iter.length; _i++){
            var key = _iter[_i];
            var value = headers.get(key);
            if (value) return value;
        }
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(headers)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2MTYX._)(_step.value, 2), key1 = _step_value[0], value1 = _step_value[1];
            if (key1.toLowerCase() === lowerCasedHeader) {
                if (Array.isArray(value1)) {
                    if (value1.length <= 1) return value1[0];
                    console.warn("Received ".concat(value1.length, " entries for the ").concat(header, " header, using the first entry."));
                    return value1[0];
                }
                return value1;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    throw new Error("Could not find ".concat(header, " header"));
};
var $29a2c2a4bb9c284e$export$37cc283d8fbd3462 = function(str) {
    if (!str) return "";
    if (typeof $29a2c2a4bb9c284e$require$Buffer !== "undefined") return $29a2c2a4bb9c284e$require$Buffer.from(str).toString("base64");
    if (typeof btoa !== "undefined") return btoa(str);
    throw new (0, $15f6ed5911d7e12b$export$7668a15b8d9a0caa)("Cannot generate b64 string; Expected `Buffer` or `btoa` to be defined");
};
function $29a2c2a4bb9c284e$export$b22ca96a1a22bfba(obj) {
    return obj != null && typeof obj === "object" && !Array.isArray(obj);
}


var $15f6ed5911d7e12b$export$7668a15b8d9a0caa = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $iNfU4._)(OpenAIError, Error1);
    var _super = (0, $k1NN5._)(OpenAIError);
    function OpenAIError() {
        (0, $19mwo._)(this, OpenAIError);
        return _super.apply(this, arguments);
    }
    return OpenAIError;
}((0, $etlBe._)(Error));
var $15f6ed5911d7e12b$export$3e5b797e39668f84 = /*#__PURE__*/ function(OpenAIError) {
    "use strict";
    (0, $iNfU4._)(APIError, OpenAIError);
    var _super = (0, $k1NN5._)(APIError);
    function APIError(status, error, message, headers) {
        (0, $19mwo._)(this, APIError);
        var _this;
        _this = _super.call(this, "".concat(APIError.makeMessage(status, error, message)));
        _this.status = status;
        _this.headers = headers;
        _this.request_id = headers === null || headers === void 0 ? void 0 : headers["x-request-id"];
        var data = error;
        _this.error = data;
        _this.code = data === null || data === void 0 ? void 0 : data["code"];
        _this.param = data === null || data === void 0 ? void 0 : data["param"];
        _this.type = data === null || data === void 0 ? void 0 : data["type"];
        return _this;
    }
    (0, $6rpfc._)(APIError, null, [
        {
            key: "makeMessage",
            value: function makeMessage(status, error, message) {
                var msg = (error === null || error === void 0 ? void 0 : error.message) ? typeof error.message === "string" ? error.message : JSON.stringify(error.message) : error ? JSON.stringify(error) : message;
                if (status && msg) return "".concat(status, " ").concat(msg);
                if (status) return "".concat(status, " status code (no body)");
                if (msg) return msg;
                return "(no status code or body)";
            }
        },
        {
            key: "generate",
            value: function generate(status, errorResponse, message, headers) {
                if (!status) return new $15f6ed5911d7e12b$export$74b830ad1c700a9b({
                    cause: (0, $29a2c2a4bb9c284e$export$b2c0dd4e7376122b)(errorResponse)
                });
                var error = errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse["error"];
                if (status === 400) return new $15f6ed5911d7e12b$export$6bfa95453d427b2b(status, error, message, headers);
                if (status === 401) return new $15f6ed5911d7e12b$export$cf0c46b07324e9c5(status, error, message, headers);
                if (status === 403) return new $15f6ed5911d7e12b$export$9c81d48c1e1840ac(status, error, message, headers);
                if (status === 404) return new $15f6ed5911d7e12b$export$78c95b58762d2106(status, error, message, headers);
                if (status === 409) return new $15f6ed5911d7e12b$export$a1d6430d09a06aee(status, error, message, headers);
                if (status === 422) return new $15f6ed5911d7e12b$export$d191fb0a9d005daf(status, error, message, headers);
                if (status === 429) return new $15f6ed5911d7e12b$export$5db8ebadb53b7f77(status, error, message, headers);
                if (status >= 500) return new $15f6ed5911d7e12b$export$2004b0625b599107(status, error, message, headers);
                return new APIError(status, error, message, headers);
            }
        }
    ]);
    return APIError;
}($15f6ed5911d7e12b$export$7668a15b8d9a0caa);
var $15f6ed5911d7e12b$export$2a26fd236aba7348 = /*#__PURE__*/ function(APIError) {
    "use strict";
    (0, $iNfU4._)(APIUserAbortError, APIError);
    var _super = (0, $k1NN5._)(APIUserAbortError);
    function APIUserAbortError() {
        var message = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).message;
        (0, $19mwo._)(this, APIUserAbortError);
        var _this;
        _this = _super.call(this, undefined, undefined, message || "Request was aborted.", undefined);
        _this.status = undefined;
        return _this;
    }
    return APIUserAbortError;
}($15f6ed5911d7e12b$export$3e5b797e39668f84);
var $15f6ed5911d7e12b$export$74b830ad1c700a9b = /*#__PURE__*/ function(APIError) {
    "use strict";
    (0, $iNfU4._)(APIConnectionError, APIError);
    var _super = (0, $k1NN5._)(APIConnectionError);
    function APIConnectionError(param) {
        var message = param.message, cause = param.cause;
        (0, $19mwo._)(this, APIConnectionError);
        var _this;
        _this = _super.call(this, undefined, undefined, message || "Connection error.", undefined);
        _this.status = undefined;
        // in some environments the 'cause' property is already declared
        // @ts-ignore
        if (cause) _this.cause = cause;
        return _this;
    }
    return APIConnectionError;
}($15f6ed5911d7e12b$export$3e5b797e39668f84);
var $15f6ed5911d7e12b$export$51181302f6f4bef3 = /*#__PURE__*/ function(APIConnectionError) {
    "use strict";
    (0, $iNfU4._)(APIConnectionTimeoutError, APIConnectionError);
    var _super = (0, $k1NN5._)(APIConnectionTimeoutError);
    function APIConnectionTimeoutError() {
        var message = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).message;
        (0, $19mwo._)(this, APIConnectionTimeoutError);
        return _super.call(this, {
            message: message !== null && message !== void 0 ? message : "Request timed out."
        });
    }
    return APIConnectionTimeoutError;
}($15f6ed5911d7e12b$export$74b830ad1c700a9b);
var $15f6ed5911d7e12b$export$6bfa95453d427b2b = /*#__PURE__*/ function(APIError) {
    "use strict";
    (0, $iNfU4._)(BadRequestError, APIError);
    var _super = (0, $k1NN5._)(BadRequestError);
    function BadRequestError() {
        (0, $19mwo._)(this, BadRequestError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.status = 400;
        return _this;
    }
    return BadRequestError;
}($15f6ed5911d7e12b$export$3e5b797e39668f84);
var $15f6ed5911d7e12b$export$cf0c46b07324e9c5 = /*#__PURE__*/ function(APIError) {
    "use strict";
    (0, $iNfU4._)(AuthenticationError, APIError);
    var _super = (0, $k1NN5._)(AuthenticationError);
    function AuthenticationError() {
        (0, $19mwo._)(this, AuthenticationError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.status = 401;
        return _this;
    }
    return AuthenticationError;
}($15f6ed5911d7e12b$export$3e5b797e39668f84);
var $15f6ed5911d7e12b$export$9c81d48c1e1840ac = /*#__PURE__*/ function(APIError) {
    "use strict";
    (0, $iNfU4._)(PermissionDeniedError, APIError);
    var _super = (0, $k1NN5._)(PermissionDeniedError);
    function PermissionDeniedError() {
        (0, $19mwo._)(this, PermissionDeniedError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.status = 403;
        return _this;
    }
    return PermissionDeniedError;
}($15f6ed5911d7e12b$export$3e5b797e39668f84);
var $15f6ed5911d7e12b$export$78c95b58762d2106 = /*#__PURE__*/ function(APIError) {
    "use strict";
    (0, $iNfU4._)(NotFoundError, APIError);
    var _super = (0, $k1NN5._)(NotFoundError);
    function NotFoundError() {
        (0, $19mwo._)(this, NotFoundError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.status = 404;
        return _this;
    }
    return NotFoundError;
}($15f6ed5911d7e12b$export$3e5b797e39668f84);
var $15f6ed5911d7e12b$export$a1d6430d09a06aee = /*#__PURE__*/ function(APIError) {
    "use strict";
    (0, $iNfU4._)(ConflictError, APIError);
    var _super = (0, $k1NN5._)(ConflictError);
    function ConflictError() {
        (0, $19mwo._)(this, ConflictError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.status = 409;
        return _this;
    }
    return ConflictError;
}($15f6ed5911d7e12b$export$3e5b797e39668f84);
var $15f6ed5911d7e12b$export$d191fb0a9d005daf = /*#__PURE__*/ function(APIError) {
    "use strict";
    (0, $iNfU4._)(UnprocessableEntityError, APIError);
    var _super = (0, $k1NN5._)(UnprocessableEntityError);
    function UnprocessableEntityError() {
        (0, $19mwo._)(this, UnprocessableEntityError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.status = 422;
        return _this;
    }
    return UnprocessableEntityError;
}($15f6ed5911d7e12b$export$3e5b797e39668f84);
var $15f6ed5911d7e12b$export$5db8ebadb53b7f77 = /*#__PURE__*/ function(APIError) {
    "use strict";
    (0, $iNfU4._)(RateLimitError, APIError);
    var _super = (0, $k1NN5._)(RateLimitError);
    function RateLimitError() {
        (0, $19mwo._)(this, RateLimitError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.status = 429;
        return _this;
    }
    return RateLimitError;
}($15f6ed5911d7e12b$export$3e5b797e39668f84);
var $15f6ed5911d7e12b$export$2004b0625b599107 = /*#__PURE__*/ function(APIError) {
    "use strict";
    (0, $iNfU4._)(InternalServerError, APIError);
    var _super = (0, $k1NN5._)(InternalServerError);
    function InternalServerError() {
        (0, $19mwo._)(this, InternalServerError);
        return _super.apply(this, arguments);
    }
    return InternalServerError;
}($15f6ed5911d7e12b$export$3e5b797e39668f84);
var $15f6ed5911d7e12b$export$64d0ec7d4e7a2858 = /*#__PURE__*/ function(OpenAIError) {
    "use strict";
    (0, $iNfU4._)(LengthFinishReasonError, OpenAIError);
    var _super = (0, $k1NN5._)(LengthFinishReasonError);
    function LengthFinishReasonError() {
        (0, $19mwo._)(this, LengthFinishReasonError);
        return _super.call(this, "Could not parse response content as the length limit was reached");
    }
    return LengthFinishReasonError;
}($15f6ed5911d7e12b$export$7668a15b8d9a0caa);
var $15f6ed5911d7e12b$export$56f1bc7271a4e3c3 = /*#__PURE__*/ function(OpenAIError) {
    "use strict";
    (0, $iNfU4._)(ContentFilterFinishReasonError, OpenAIError);
    var _super = (0, $k1NN5._)(ContentFilterFinishReasonError);
    function ContentFilterFinishReasonError() {
        (0, $19mwo._)(this, ContentFilterFinishReasonError);
        return _super.call(this, "Could not parse response content as the request was rejected by the content filter");
    }
    return ContentFilterFinishReasonError;
}($15f6ed5911d7e12b$export$7668a15b8d9a0caa);


function $aaca55cce8d1c260$export$8571f96912acf365(response_format, parser) {
    var obj = (0, $78DQ7._)({}, response_format);
    Object.defineProperties(obj, {
        $brand: {
            value: "auto-parseable-response-format",
            enumerable: false
        },
        $parseRaw: {
            value: parser,
            enumerable: false
        }
    });
    return obj;
}
function $aaca55cce8d1c260$export$b223966abcefe91c(response_format) {
    return (response_format === null || response_format === void 0 ? void 0 : response_format["$brand"]) === "auto-parseable-response-format";
}
function $aaca55cce8d1c260$export$8c880bd1baec2c2d(tool, param) {
    var parser = param.parser, callback = param.callback;
    var obj = (0, $78DQ7._)({}, tool);
    Object.defineProperties(obj, {
        $brand: {
            value: "auto-parseable-tool",
            enumerable: false
        },
        $parseRaw: {
            value: parser,
            enumerable: false
        },
        $callback: {
            value: callback,
            enumerable: false
        }
    });
    return obj;
}
function $aaca55cce8d1c260$export$cd66731d9ec8496d(tool) {
    return (tool === null || tool === void 0 ? void 0 : tool["$brand"]) === "auto-parseable-tool";
}
function $aaca55cce8d1c260$export$cd39a28c3b357ba1(completion, params) {
    if (!params || !$aaca55cce8d1c260$export$eeede6984aa92019(params)) return (0, $ddevm._)((0, $78DQ7._)({}, completion), {
        choices: completion.choices.map(function(choice) {
            var _choice_message_tool_calls;
            return (0, $ddevm._)((0, $78DQ7._)({}, choice), {
                message: (0, $ddevm._)((0, $78DQ7._)({}, choice.message), {
                    parsed: null,
                    tool_calls: (_choice_message_tool_calls = choice.message.tool_calls) !== null && _choice_message_tool_calls !== void 0 ? _choice_message_tool_calls : []
                })
            });
        })
    });
    return $aaca55cce8d1c260$export$bea40bc252349f06(completion, params);
}
function $aaca55cce8d1c260$export$bea40bc252349f06(completion, params) {
    var choices = completion.choices.map(function(choice) {
        var _choice_message_tool_calls;
        if (choice.finish_reason === "length") throw new (0, $15f6ed5911d7e12b$export$64d0ec7d4e7a2858)();
        if (choice.finish_reason === "content_filter") throw new (0, $15f6ed5911d7e12b$export$56f1bc7271a4e3c3)();
        var _choice_message_tool_calls_map;
        return (0, $ddevm._)((0, $78DQ7._)({}, choice), {
            message: (0, $ddevm._)((0, $78DQ7._)({}, choice.message), {
                tool_calls: (_choice_message_tool_calls_map = (_choice_message_tool_calls = choice.message.tool_calls) === null || _choice_message_tool_calls === void 0 ? void 0 : _choice_message_tool_calls.map(function(toolCall) {
                    return $aaca55cce8d1c260$var$parseToolCall(params, toolCall);
                })) !== null && _choice_message_tool_calls_map !== void 0 ? _choice_message_tool_calls_map : [],
                parsed: choice.message.content && !choice.message.refusal ? $aaca55cce8d1c260$var$parseResponseFormat(params, choice.message.content) : null
            })
        });
    });
    return (0, $ddevm._)((0, $78DQ7._)({}, completion), {
        choices: choices
    });
}
function $aaca55cce8d1c260$var$parseResponseFormat(params, content) {
    var _params_response_format, _params_response_format1;
    if (((_params_response_format = params.response_format) === null || _params_response_format === void 0 ? void 0 : _params_response_format.type) !== "json_schema") return null;
    if (((_params_response_format1 = params.response_format) === null || _params_response_format1 === void 0 ? void 0 : _params_response_format1.type) === "json_schema") {
        if ("$parseRaw" in params.response_format) {
            var response_format = params.response_format;
            return response_format.$parseRaw(content);
        }
        return JSON.parse(content);
    }
    return null;
}
function $aaca55cce8d1c260$var$parseToolCall(params, toolCall) {
    var _params_tools;
    var inputTool = (_params_tools = params.tools) === null || _params_tools === void 0 ? void 0 : _params_tools.find(function(inputTool) {
        var _inputTool_function;
        return ((_inputTool_function = inputTool.function) === null || _inputTool_function === void 0 ? void 0 : _inputTool_function.name) === toolCall.function.name;
    });
    return (0, $ddevm._)((0, $78DQ7._)({}, toolCall), {
        function: (0, $ddevm._)((0, $78DQ7._)({}, toolCall.function), {
            parsed_arguments: $aaca55cce8d1c260$export$cd66731d9ec8496d(inputTool) ? inputTool.$parseRaw(toolCall.function.arguments) : (inputTool === null || inputTool === void 0 ? void 0 : inputTool.function.strict) ? JSON.parse(toolCall.function.arguments) : null
        })
    });
}
function $aaca55cce8d1c260$export$4fe91242709b72e2(params, toolCall) {
    var _params_tools;
    if (!params) return false;
    var inputTool = (_params_tools = params.tools) === null || _params_tools === void 0 ? void 0 : _params_tools.find(function(inputTool) {
        var _inputTool_function;
        return ((_inputTool_function = inputTool.function) === null || _inputTool_function === void 0 ? void 0 : _inputTool_function.name) === toolCall.function.name;
    });
    return $aaca55cce8d1c260$export$cd66731d9ec8496d(inputTool) || (inputTool === null || inputTool === void 0 ? void 0 : inputTool.function.strict) || false;
}
function $aaca55cce8d1c260$export$eeede6984aa92019(params) {
    var _params_tools;
    if ($aaca55cce8d1c260$export$b223966abcefe91c(params.response_format)) return true;
    var _params_tools_some;
    return (_params_tools_some = (_params_tools = params.tools) === null || _params_tools === void 0 ? void 0 : _params_tools.some(function(t) {
        return $aaca55cce8d1c260$export$cd66731d9ec8496d(t) || t.type === "function" && t.function.strict === true;
    })) !== null && _params_tools_some !== void 0 ? _params_tools_some : false;
}
function $aaca55cce8d1c260$export$3ac73b33c2141c0d(tools) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (tools !== null && tools !== void 0 ? tools : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var tool = _step.value;
            if (tool.type !== "function") throw new (0, $15f6ed5911d7e12b$export$7668a15b8d9a0caa)("Currently only `function` tool types support auto-parsing; Received `".concat(tool.type, "`"));
            if (tool.function.strict !== true) throw new (0, $15f6ed5911d7e12b$export$7668a15b8d9a0caa)("The `".concat(tool.function.name, "` tool is not marked with `strict: true`. Only strict function tools can be auto-parsed"));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}



var $c5rwh = parcelRequire("c5rwh");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $3jzhD = parcelRequire("3jzhD");

var $3Fd7H = parcelRequire("3Fd7H");
function $6b95a74d5fbc309c$export$3e2bb967172656aa() {
    return {};
}



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $3jzhD = parcelRequire("3jzhD");

var $3Fd7H = parcelRequire("3Fd7H");

var $c5rwh = parcelRequire("c5rwh");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");
function $2df68c854d564410$export$1824e64235e4b973(res, key, errorMessage, refs) {
    if (!(refs === null || refs === void 0 ? void 0 : refs.errorMessages)) return;
    if (errorMessage) res.errorMessage = (0, $ddevm._)((0, $78DQ7._)({}, res.errorMessage), (0, $c5rwh._)({}, key, errorMessage));
}
function $2df68c854d564410$export$f7d2bce693b08d40(res, key, value, errorMessage, refs) {
    res[key] = value;
    $2df68c854d564410$export$1824e64235e4b973(res, key, errorMessage, refs);
}



function $ddeb210e555bb290$export$9c1a0c7a7667fa87(def, refs) {
    var _def_type__def, _def_type;
    var res = {
        type: "array"
    };
    if (((_def_type = def.type) === null || _def_type === void 0 ? void 0 : (_def_type__def = _def_type._def) === null || _def_type__def === void 0 ? void 0 : _def_type__def.typeName) !== (0, $3Fd7H.ZodFirstPartyTypeKind).ZodAny) res.items = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.type._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
        currentPath: (0, $3jzhD._)(refs.currentPath).concat([
            "items"
        ])
    }));
    if (def.minLength) (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "minItems", def.minLength.value, def.minLength.message, refs);
    if (def.maxLength) (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "maxItems", def.maxLength.value, def.maxLength.message, refs);
    if (def.exactLength) {
        (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "minItems", def.exactLength.value, def.exactLength.message, refs);
        (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "maxItems", def.exactLength.value, def.exactLength.message, refs);
    }
    return res;
}



function $0e4550fa5dbb4d19$export$43aac7d536884cad(def, refs) {
    var res = {
        type: "integer",
        format: "int64"
    };
    if (!def.checks) return res;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var check = _step.value;
            switch(check.kind){
                case "min":
                    if (refs.target === "jsonSchema7") {
                        if (check.inclusive) (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "minimum", check.value, check.message, refs);
                        else (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "exclusiveMinimum", check.value, check.message, refs);
                    } else {
                        if (!check.inclusive) res.exclusiveMinimum = true;
                        (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "minimum", check.value, check.message, refs);
                    }
                    break;
                case "max":
                    if (refs.target === "jsonSchema7") {
                        if (check.inclusive) (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "maximum", check.value, check.message, refs);
                        else (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "exclusiveMaximum", check.value, check.message, refs);
                    } else {
                        if (!check.inclusive) res.exclusiveMaximum = true;
                        (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "maximum", check.value, check.message, refs);
                    }
                    break;
                case "multipleOf":
                    (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "multipleOf", check.value, check.message, refs);
                    break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return res;
}


function $9132c6739764a7a3$export$953fb8456e1b3de0() {
    return {
        type: "boolean"
    };
}



function $006c352723d922c9$export$487a80cbcbb64a8d(_def, refs) {
    return (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(_def.type._def, refs);
}



var $5ec16c0caefbe63d$export$540346d1622aa551 = function(def, refs) {
    return (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.innerType._def, refs);
};



function $cfe35d3e0f1fa59b$export$7ff09a50352abb2f(def, refs, overrideDateStrategy) {
    var strategy = overrideDateStrategy !== null && overrideDateStrategy !== void 0 ? overrideDateStrategy : refs.dateStrategy;
    if (Array.isArray(strategy)) return {
        anyOf: strategy.map(function(item, i) {
            return $cfe35d3e0f1fa59b$export$7ff09a50352abb2f(def, refs, item);
        })
    };
    switch(strategy){
        case "string":
        case "format:date-time":
            return {
                type: "string",
                format: "date-time"
            };
        case "format:date":
            return {
                type: "string",
                format: "date"
            };
        case "integer":
            return $cfe35d3e0f1fa59b$var$integerDateParser(def, refs);
    }
}
var $cfe35d3e0f1fa59b$var$integerDateParser = function(def, refs) {
    var res = {
        type: "integer",
        format: "unix-time"
    };
    if (refs.target === "openApi3") return res;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var check = _step.value;
            switch(check.kind){
                case "min":
                    (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "minimum", check.value, check.message, refs);
                    break;
                case "max":
                    (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "maximum", check.value, check.message, refs);
                    break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return res;
};



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

function $9aebb28384ee9d80$export$e46de3de93f6b4e7(_def, refs) {
    return (0, $ddevm._)((0, $78DQ7._)({}, (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(_def.innerType._def, refs)), {
        default: _def.defaultValue()
    });
}



function $879e23f5bc44ca71$export$8edd16d8c2901277(_def, refs) {
    return refs.effectStrategy === "input" ? (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(_def.schema._def, refs) : {};
}



var $3jzhD = parcelRequire("3jzhD");
function $4426d225cf133d1e$export$73516460e65887be(def) {
    return {
        type: "string",
        enum: (0, $3jzhD._)(def.values)
    };
}



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $3jzhD = parcelRequire("3jzhD");

var $4cb3956a461ebd3d$var$isJsonSchema7AllOfType = function(type) {
    if ("type" in type && type.type === "string") return false;
    return "allOf" in type;
};
function $4cb3956a461ebd3d$export$c12a2394fc457627(def, refs) {
    var allOf = [
        (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.left._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
            currentPath: (0, $3jzhD._)(refs.currentPath).concat([
                "allOf",
                "0"
            ])
        })),
        (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.right._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
            currentPath: (0, $3jzhD._)(refs.currentPath).concat([
                "allOf",
                "1"
            ])
        }))
    ].filter(function(x) {
        return !!x;
    });
    var unevaluatedProperties = refs.target === "jsonSchema2019-09" ? {
        unevaluatedProperties: false
    } : undefined;
    var mergedAllOf = [];
    // If either of the schemas is an allOf, merge them into a single allOf
    allOf.forEach(function(schema) {
        if ($4cb3956a461ebd3d$var$isJsonSchema7AllOfType(schema)) {
            var _mergedAllOf;
            (_mergedAllOf = mergedAllOf).push.apply(_mergedAllOf, (0, $3jzhD._)(schema.allOf));
            if (schema.unevaluatedProperties === undefined) // If one of the schemas has no unevaluatedProperties set,
            // the merged schema should also have no unevaluatedProperties set
            unevaluatedProperties = undefined;
        } else {
            var nestedSchema = schema;
            if ("additionalProperties" in schema && schema.additionalProperties === false) {
                var additionalProperties = schema.additionalProperties, rest = (0, $6JqHh._)(schema, [
                    "additionalProperties"
                ]);
                nestedSchema = rest;
            } else // As soon as one of the schemas has additionalProperties set not to false, we allow unevaluatedProperties
            unevaluatedProperties = undefined;
            mergedAllOf.push(nestedSchema);
        }
    });
    return mergedAllOf.length ? (0, $78DQ7._)({
        allOf: mergedAllOf
    }, unevaluatedProperties) : undefined;
}



var $gnDeW = parcelRequire("gnDeW");
function $8ab4fb92a28941a2$export$81a695a005c19352(def, refs) {
    var parsedType = (0, $gnDeW._)(def.value);
    if (parsedType !== "bigint" && parsedType !== "number" && parsedType !== "boolean" && parsedType !== "string") return {
        type: Array.isArray(def.value) ? "array" : "object"
    };
    if (refs.target === "openApi3") return {
        type: parsedType === "bigint" ? "integer" : parsedType,
        enum: [
            def.value
        ]
    };
    return {
        type: parsedType === "bigint" ? "integer" : parsedType,
        const: def.value
    };
}



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $3jzhD = parcelRequire("3jzhD");


var $c5rwh = parcelRequire("c5rwh");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $3Fd7H = parcelRequire("3Fd7H");


var $78DQ7 = parcelRequire("78DQ7");

var $12f032d24d79347a$var$emojiRegex;
var $12f032d24d79347a$export$999ee5d51ef74217 = {
    /**
     * `c` was changed to `[cC]` to replicate /i flag
     */ cuid: /^[cC][^\s-]{8,}$/,
    cuid2: /^[0-9a-z]+$/,
    ulid: /^[0-9A-HJKMNP-TV-Z]{26}$/,
    /**
     * `a-z` was added to replicate /i flag
     */ email: /^(?!\.)(?!.*\.\.)([a-zA-Z0-9_'+\-\.]*)[a-zA-Z0-9_+-]@([a-zA-Z0-9][a-zA-Z0-9\-]*\.)+[a-zA-Z]{2,}$/,
    /**
     * Constructed a valid Unicode RegExp
     *
     * Lazily instantiate since this type of regex isn't supported
     * in all envs (e.g. React Native).
     *
     * See:
     * https://github.com/colinhacks/zod/issues/2433
     * Fix in Zod:
     * https://github.com/colinhacks/zod/commit/9340fd51e48576a75adc919bff65dbc4a5d4c99b
     */ emoji: function() {
        if ($12f032d24d79347a$var$emojiRegex === undefined) $12f032d24d79347a$var$emojiRegex = RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u");
        return $12f032d24d79347a$var$emojiRegex;
    },
    /**
     * Unused
     */ uuid: /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/,
    /**
     * Unused
     */ ipv4: /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/,
    /**
     * Unused
     */ ipv6: /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/,
    base64: /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/,
    nanoid: /^[a-zA-Z0-9_-]{21}$/
};
function $12f032d24d79347a$export$c6dca604104d35ca(def, refs) {
    var res = {
        type: "string"
    };
    function processPattern(value) {
        return refs.patternStrategy === "escape" ? $12f032d24d79347a$var$escapeNonAlphaNumeric(value) : value;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (def.checks) try {
        for(var _iterator = def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var check = _step.value;
            switch(check.kind){
                case "min":
                    (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "minLength", typeof res.minLength === "number" ? Math.max(res.minLength, check.value) : check.value, check.message, refs);
                    break;
                case "max":
                    (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "maxLength", typeof res.maxLength === "number" ? Math.min(res.maxLength, check.value) : check.value, check.message, refs);
                    break;
                case "email":
                    switch(refs.emailStrategy){
                        case "format:email":
                            $12f032d24d79347a$var$addFormat(res, "email", check.message, refs);
                            break;
                        case "format:idn-email":
                            $12f032d24d79347a$var$addFormat(res, "idn-email", check.message, refs);
                            break;
                        case "pattern:zod":
                            $12f032d24d79347a$var$addPattern(res, $12f032d24d79347a$export$999ee5d51ef74217.email, check.message, refs);
                            break;
                    }
                    break;
                case "url":
                    $12f032d24d79347a$var$addFormat(res, "uri", check.message, refs);
                    break;
                case "uuid":
                    $12f032d24d79347a$var$addFormat(res, "uuid", check.message, refs);
                    break;
                case "regex":
                    $12f032d24d79347a$var$addPattern(res, check.regex, check.message, refs);
                    break;
                case "cuid":
                    $12f032d24d79347a$var$addPattern(res, $12f032d24d79347a$export$999ee5d51ef74217.cuid, check.message, refs);
                    break;
                case "cuid2":
                    $12f032d24d79347a$var$addPattern(res, $12f032d24d79347a$export$999ee5d51ef74217.cuid2, check.message, refs);
                    break;
                case "startsWith":
                    $12f032d24d79347a$var$addPattern(res, RegExp("^".concat(processPattern(check.value))), check.message, refs);
                    break;
                case "endsWith":
                    $12f032d24d79347a$var$addPattern(res, RegExp("".concat(processPattern(check.value), "$")), check.message, refs);
                    break;
                case "datetime":
                    $12f032d24d79347a$var$addFormat(res, "date-time", check.message, refs);
                    break;
                case "date":
                    $12f032d24d79347a$var$addFormat(res, "date", check.message, refs);
                    break;
                case "time":
                    $12f032d24d79347a$var$addFormat(res, "time", check.message, refs);
                    break;
                case "duration":
                    $12f032d24d79347a$var$addFormat(res, "duration", check.message, refs);
                    break;
                case "length":
                    (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "minLength", typeof res.minLength === "number" ? Math.max(res.minLength, check.value) : check.value, check.message, refs);
                    (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "maxLength", typeof res.maxLength === "number" ? Math.min(res.maxLength, check.value) : check.value, check.message, refs);
                    break;
                case "includes":
                    $12f032d24d79347a$var$addPattern(res, RegExp(processPattern(check.value)), check.message, refs);
                    break;
                case "ip":
                    if (check.version !== "v6") $12f032d24d79347a$var$addFormat(res, "ipv4", check.message, refs);
                    if (check.version !== "v4") $12f032d24d79347a$var$addFormat(res, "ipv6", check.message, refs);
                    break;
                case "emoji":
                    $12f032d24d79347a$var$addPattern(res, $12f032d24d79347a$export$999ee5d51ef74217.emoji, check.message, refs);
                    break;
                case "ulid":
                    $12f032d24d79347a$var$addPattern(res, $12f032d24d79347a$export$999ee5d51ef74217.ulid, check.message, refs);
                    break;
                case "base64":
                    switch(refs.base64Strategy){
                        case "format:binary":
                            $12f032d24d79347a$var$addFormat(res, "binary", check.message, refs);
                            break;
                        case "contentEncoding:base64":
                            (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "contentEncoding", "base64", check.message, refs);
                            break;
                        case "pattern:zod":
                            $12f032d24d79347a$var$addPattern(res, $12f032d24d79347a$export$999ee5d51ef74217.base64, check.message, refs);
                            break;
                    }
                    break;
                case "nanoid":
                    $12f032d24d79347a$var$addPattern(res, $12f032d24d79347a$export$999ee5d51ef74217.nanoid, check.message, refs);
                case "toLowerCase":
                case "toUpperCase":
                case "trim":
                    break;
                default:
                    (function(_) {})(check);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return res;
}
var $12f032d24d79347a$var$escapeNonAlphaNumeric = function(value) {
    return Array.from(value).map(function(c) {
        return /[a-zA-Z0-9]/.test(c) ? c : "\\".concat(c);
    }).join("");
};
var $12f032d24d79347a$var$addFormat = function(schema, value, message, refs) {
    var _schema_anyOf;
    if (schema.format || ((_schema_anyOf = schema.anyOf) === null || _schema_anyOf === void 0 ? void 0 : _schema_anyOf.some(function(x) {
        return x.format;
    }))) {
        if (!schema.anyOf) schema.anyOf = [];
        if (schema.format) {
            schema.anyOf.push((0, $78DQ7._)({
                format: schema.format
            }, schema.errorMessage && refs.errorMessages && {
                errorMessage: {
                    format: schema.errorMessage.format
                }
            }));
            delete schema.format;
            if (schema.errorMessage) {
                delete schema.errorMessage.format;
                if (Object.keys(schema.errorMessage).length === 0) delete schema.errorMessage;
            }
        }
        schema.anyOf.push((0, $78DQ7._)({
            format: value
        }, message && refs.errorMessages && {
            errorMessage: {
                format: message
            }
        }));
    } else (0, $2df68c854d564410$export$f7d2bce693b08d40)(schema, "format", value, message, refs);
};
var $12f032d24d79347a$var$addPattern = function(schema, regex, message, refs) {
    var _schema_allOf;
    if (schema.pattern || ((_schema_allOf = schema.allOf) === null || _schema_allOf === void 0 ? void 0 : _schema_allOf.some(function(x) {
        return x.pattern;
    }))) {
        if (!schema.allOf) schema.allOf = [];
        if (schema.pattern) {
            schema.allOf.push((0, $78DQ7._)({
                pattern: schema.pattern
            }, schema.errorMessage && refs.errorMessages && {
                errorMessage: {
                    pattern: schema.errorMessage.pattern
                }
            }));
            delete schema.pattern;
            if (schema.errorMessage) {
                delete schema.errorMessage.pattern;
                if (Object.keys(schema.errorMessage).length === 0) delete schema.errorMessage;
            }
        }
        schema.allOf.push((0, $78DQ7._)({
            pattern: $12f032d24d79347a$var$processRegExp(regex, refs)
        }, message && refs.errorMessages && {
            errorMessage: {
                pattern: message
            }
        }));
    } else (0, $2df68c854d564410$export$f7d2bce693b08d40)(schema, "pattern", $12f032d24d79347a$var$processRegExp(regex, refs), message, refs);
};
// Mutate z.string.regex() in a best attempt to accommodate for regex flags when applyRegexFlags is true
var $12f032d24d79347a$var$processRegExp = function(regexOrFunction, refs) {
    var regex = typeof regexOrFunction === "function" ? regexOrFunction() : regexOrFunction;
    if (!refs.applyRegexFlags || !regex.flags) return regex.source;
    // Currently handled flags
    var flags = {
        i: regex.flags.includes("i"),
        m: regex.flags.includes("m"),
        s: regex.flags.includes("s")
    };
    // The general principle here is to step through each character, one at a time, applying mutations as flags require. We keep track when the current character is escaped, and when it's inside a group /like [this]/ or (also) a range like /[a-z]/. The following is fairly brittle imperative code; edit at your peril!
    var source = flags.i ? regex.source.toLowerCase() : regex.source;
    var pattern = "";
    var isEscaped = false;
    var inCharGroup = false;
    var inCharRange = false;
    for(var i = 0; i < source.length; i++){
        if (isEscaped) {
            pattern += source[i];
            isEscaped = false;
            continue;
        }
        if (flags.i) {
            if (inCharGroup) {
                if (source[i].match(/[a-z]/)) {
                    var _source_;
                    if (inCharRange) {
                        pattern += source[i];
                        pattern += "".concat(source[i - 2], "-").concat(source[i]).toUpperCase();
                        inCharRange = false;
                    } else if (source[i + 1] === "-" && ((_source_ = source[i + 2]) === null || _source_ === void 0 ? void 0 : _source_.match(/[a-z]/))) {
                        pattern += source[i];
                        inCharRange = true;
                    } else pattern += "".concat(source[i]).concat(source[i].toUpperCase());
                    continue;
                }
            } else if (source[i].match(/[a-z]/)) {
                pattern += "[".concat(source[i]).concat(source[i].toUpperCase(), "]");
                continue;
            }
        }
        if (flags.m) {
            if (source[i] === "^") {
                pattern += "(^|(?<=[\r\n]))";
                continue;
            } else if (source[i] === "$") {
                pattern += "($|(?=[\r\n]))";
                continue;
            }
        }
        if (flags.s && source[i] === ".") {
            pattern += inCharGroup ? "".concat(source[i], "\r\n") : "[".concat(source[i], "\r\n]");
            continue;
        }
        pattern += source[i];
        if (source[i] === "\\") isEscaped = true;
        else if (inCharGroup && source[i] === "]") inCharGroup = false;
        else if (!inCharGroup && source[i] === "[") inCharGroup = true;
    }
    try {
        var regexTest = new RegExp(pattern);
    } catch (e) {
        console.warn("Could not convert regex pattern at ".concat(refs.currentPath.join("/"), " to a flag-independent form! Falling back to the flag-ignorant source"));
        return regex.source;
    }
    return pattern;
};


function $d861de743d5a3fc5$export$bab91a30f81817bc(def, refs) {
    var _def_keyType, _def_keyType1, _def_keyType__def_checks, _def_keyType2;
    if (refs.target === "openApi3" && ((_def_keyType = def.keyType) === null || _def_keyType === void 0 ? void 0 : _def_keyType._def.typeName) === (0, $3Fd7H.ZodFirstPartyTypeKind).ZodEnum) return {
        type: "object",
        required: def.keyType._def.values,
        properties: def.keyType._def.values.reduce(function(acc, key) {
            var _parseDef;
            return (0, $ddevm._)((0, $78DQ7._)({}, acc), (0, $c5rwh._)({}, key, (_parseDef = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.valueType._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
                currentPath: (0, $3jzhD._)(refs.currentPath).concat([
                    "properties",
                    key
                ])
            }))) !== null && _parseDef !== void 0 ? _parseDef : {}));
        }, {}),
        additionalProperties: false
    };
    var _parseDef;
    var schema = {
        type: "object",
        additionalProperties: (_parseDef = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.valueType._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
            currentPath: (0, $3jzhD._)(refs.currentPath).concat([
                "additionalProperties"
            ])
        }))) !== null && _parseDef !== void 0 ? _parseDef : {}
    };
    if (refs.target === "openApi3") return schema;
    if (((_def_keyType1 = def.keyType) === null || _def_keyType1 === void 0 ? void 0 : _def_keyType1._def.typeName) === (0, $3Fd7H.ZodFirstPartyTypeKind).ZodString && ((_def_keyType__def_checks = def.keyType._def.checks) === null || _def_keyType__def_checks === void 0 ? void 0 : _def_keyType__def_checks.length)) {
        var keyType = Object.entries((0, $12f032d24d79347a$export$c6dca604104d35ca)(def.keyType._def, refs)).reduce(function(acc, param) {
            var _param = (0, $2MTYX._)(param, 2), key = _param[0], value = _param[1];
            return key === "type" ? acc : (0, $ddevm._)((0, $78DQ7._)({}, acc), (0, $c5rwh._)({}, key, value));
        }, {});
        return (0, $ddevm._)((0, $78DQ7._)({}, schema), {
            propertyNames: keyType
        });
    } else if (((_def_keyType2 = def.keyType) === null || _def_keyType2 === void 0 ? void 0 : _def_keyType2._def.typeName) === (0, $3Fd7H.ZodFirstPartyTypeKind).ZodEnum) return (0, $ddevm._)((0, $78DQ7._)({}, schema), {
        propertyNames: {
            enum: def.keyType._def.values
        }
    });
    return schema;
}


function $3735f1962806a37e$export$cb8e42ab369177cd(def, refs) {
    if (refs.mapStrategy === "record") return (0, $d861de743d5a3fc5$export$bab91a30f81817bc)(def, refs);
    var keys = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.keyType._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
        currentPath: (0, $3jzhD._)(refs.currentPath).concat([
            "items",
            "items",
            "0"
        ])
    })) || {};
    var values = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.valueType._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
        currentPath: (0, $3jzhD._)(refs.currentPath).concat([
            "items",
            "items",
            "1"
        ])
    })) || {};
    return {
        type: "array",
        maxItems: 125,
        items: {
            type: "array",
            items: [
                keys,
                values
            ],
            minItems: 2,
            maxItems: 2
        }
    };
}



var $gnDeW = parcelRequire("gnDeW");
function $510536f28ddd3e79$export$6631cffa548a42cf(def) {
    var object = def.values;
    var actualKeys = Object.keys(def.values).filter(function(key) {
        return typeof object[object[key]] !== "number";
    });
    var actualValues = actualKeys.map(function(key) {
        return object[key];
    });
    var parsedTypes = Array.from(new Set(actualValues.map(function(values) {
        return typeof values === "undefined" ? "undefined" : (0, $gnDeW._)(values);
    })));
    return {
        type: parsedTypes.length === 1 ? parsedTypes[0] === "string" ? "string" : "number" : [
            "string",
            "number"
        ],
        enum: actualValues
    };
}


function $bbbca76d1cb04d1f$export$3490b811136dce94() {
    return {
        not: {}
    };
}


function $0f72b6dd538479c0$export$9dab39b894fea7b(refs) {
    return refs.target === "openApi3" ? {
        enum: [
            "null"
        ],
        nullable: true
    } : {
        type: "null"
    };
}



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $3jzhD = parcelRequire("3jzhD");


var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $3jzhD = parcelRequire("3jzhD");

var $gnDeW = parcelRequire("gnDeW");

var $72b1a1c258a0d5e6$export$53d0c9700414d70b = {
    ZodString: "string",
    ZodNumber: "number",
    ZodBigInt: "integer",
    ZodBoolean: "boolean",
    ZodNull: "null"
};
function $72b1a1c258a0d5e6$export$4fd6ebd75521f86f(def, refs) {
    if (refs.target === "openApi3") return $72b1a1c258a0d5e6$var$asAnyOf(def, refs);
    var options = def.options instanceof Map ? Array.from(def.options.values()) : def.options;
    // This blocks tries to look ahead a bit to produce nicer looking schemas with type array instead of anyOf.
    if (options.every(function(x) {
        return x._def.typeName in $72b1a1c258a0d5e6$export$53d0c9700414d70b && (!x._def.checks || !x._def.checks.length);
    })) {
        // all types in union are primitive and lack checks, so might as well squash into {type: [...]}
        var types = options.reduce(function(types, x) {
            var type = $72b1a1c258a0d5e6$export$53d0c9700414d70b[x._def.typeName]; //Can be safely casted due to row 43
            return type && !types.includes(type) ? (0, $3jzhD._)(types).concat([
                type
            ]) : types;
        }, []);
        return {
            type: types.length > 1 ? types : types[0]
        };
    } else if (options.every(function(x) {
        return x._def.typeName === "ZodLiteral" && !x.description;
    })) {
        // all options literals
        var types1 = options.reduce(function(acc, x) {
            var type = (0, $gnDeW._)(x._def.value);
            switch(type){
                case "string":
                case "number":
                case "boolean":
                    return (0, $3jzhD._)(acc).concat([
                        type
                    ]);
                case "bigint":
                    return (0, $3jzhD._)(acc).concat([
                        "integer"
                    ]);
                case "object":
                    if (x._def.value === null) return (0, $3jzhD._)(acc).concat([
                        "null"
                    ]);
                case "symbol":
                case "undefined":
                case "function":
                default:
                    return acc;
            }
        }, []);
        if (types1.length === options.length) {
            // all the literals are primitive, as far as null can be considered primitive
            var uniqueTypes = types1.filter(function(x, i, a) {
                return a.indexOf(x) === i;
            });
            return {
                type: uniqueTypes.length > 1 ? uniqueTypes : uniqueTypes[0],
                enum: options.reduce(function(acc, x) {
                    return acc.includes(x._def.value) ? acc : (0, $3jzhD._)(acc).concat([
                        x._def.value
                    ]);
                }, [])
            };
        }
    } else if (options.every(function(x) {
        return x._def.typeName === "ZodEnum";
    })) return {
        type: "string",
        enum: options.reduce(function(acc, x) {
            return (0, $3jzhD._)(acc).concat((0, $3jzhD._)(x._def.values.filter(function(x) {
                return !acc.includes(x);
            })));
        }, [])
    };
    return $72b1a1c258a0d5e6$var$asAnyOf(def, refs);
}
var $72b1a1c258a0d5e6$var$asAnyOf = function(def, refs) {
    var anyOf = (def.options instanceof Map ? Array.from(def.options.values()) : def.options).map(function(x, i) {
        return (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(x._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
            currentPath: (0, $3jzhD._)(refs.currentPath).concat([
                "anyOf",
                "".concat(i)
            ])
        }));
    }).filter(function(x) {
        return !!x && (!refs.strictUnions || typeof x === "object" && Object.keys(x).length > 0);
    });
    return anyOf.length ? {
        anyOf: anyOf
    } : undefined;
};


function $654f8ebae80eb2ed$export$5b998cd3cbcce402(def, refs) {
    if ([
        "ZodString",
        "ZodNumber",
        "ZodBigInt",
        "ZodBoolean",
        "ZodNull"
    ].includes(def.innerType._def.typeName) && (!def.innerType._def.checks || !def.innerType._def.checks.length)) {
        if (refs.target === "openApi3" || refs.nullableStrategy === "property") return {
            type: (0, $72b1a1c258a0d5e6$export$53d0c9700414d70b)[def.innerType._def.typeName],
            nullable: true
        };
        return {
            type: [
                (0, $72b1a1c258a0d5e6$export$53d0c9700414d70b)[def.innerType._def.typeName],
                "null"
            ]
        };
    }
    if (refs.target === "openApi3") {
        var base = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.innerType._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
            currentPath: (0, $3jzhD._)(refs.currentPath)
        }));
        if (base && "$ref" in base) return {
            allOf: [
                base
            ],
            nullable: true
        };
        return base && (0, $ddevm._)((0, $78DQ7._)({}, base), {
            nullable: true
        });
    }
    var base1 = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.innerType._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
        currentPath: (0, $3jzhD._)(refs.currentPath).concat([
            "anyOf",
            "0"
        ])
    }));
    return base1 && {
        anyOf: [
            base1,
            {
                type: "null"
            }
        ]
    };
}



function $767e3d030d7d8d8d$export$1c2f9bc71877e9a2(def, refs) {
    var res = {
        type: "number"
    };
    if (!def.checks) return res;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var check = _step.value;
            switch(check.kind){
                case "int":
                    res.type = "integer";
                    (0, $2df68c854d564410$export$1824e64235e4b973)(res, "type", check.message, refs);
                    break;
                case "min":
                    if (refs.target === "jsonSchema7") {
                        if (check.inclusive) (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "minimum", check.value, check.message, refs);
                        else (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "exclusiveMinimum", check.value, check.message, refs);
                    } else {
                        if (!check.inclusive) res.exclusiveMinimum = true;
                        (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "minimum", check.value, check.message, refs);
                    }
                    break;
                case "max":
                    if (refs.target === "jsonSchema7") {
                        if (check.inclusive) (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "maximum", check.value, check.message, refs);
                        else (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "exclusiveMaximum", check.value, check.message, refs);
                    } else {
                        if (!check.inclusive) res.exclusiveMaximum = true;
                        (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "maximum", check.value, check.message, refs);
                    }
                    break;
                case "multipleOf":
                    (0, $2df68c854d564410$export$f7d2bce693b08d40)(res, "multipleOf", check.value, check.message, refs);
                    break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return res;
}



var $c5rwh = parcelRequire("c5rwh");

var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

function $c904626e3bf3c7ae$var$decideAdditionalProperties(def, refs) {
    var _parseDef, _parseDef1;
    if (refs.removeAdditionalStrategy === "strict") return def.catchall._def.typeName === "ZodNever" ? def.unknownKeys !== "strict" : (_parseDef = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.catchall._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
        currentPath: (0, $3jzhD._)(refs.currentPath).concat([
            "additionalProperties"
        ])
    }))) !== null && _parseDef !== void 0 ? _parseDef : true;
    else return def.catchall._def.typeName === "ZodNever" ? def.unknownKeys === "passthrough" : (_parseDef1 = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.catchall._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
        currentPath: (0, $3jzhD._)(refs.currentPath).concat([
            "additionalProperties"
        ])
    }))) !== null && _parseDef1 !== void 0 ? _parseDef1 : true;
}
function $c904626e3bf3c7ae$export$f530ed7e1f9e38cd(def, refs) {
    var result = (0, $ddevm._)((0, $78DQ7._)({
        type: "object"
    }, Object.entries(def.shape()).reduce(function(acc, param) {
        var _param = (0, $2MTYX._)(param, 2), propName = _param[0], propDef = _param[1];
        if (propDef === undefined || propDef._def === undefined) return acc;
        var parsedDef = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(propDef._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
            currentPath: (0, $3jzhD._)(refs.currentPath).concat([
                "properties",
                propName
            ]),
            propertyPath: (0, $3jzhD._)(refs.currentPath).concat([
                "properties",
                propName
            ])
        }));
        if (parsedDef === undefined) return acc;
        return {
            properties: (0, $ddevm._)((0, $78DQ7._)({}, acc.properties), (0, $c5rwh._)({}, propName, parsedDef)),
            required: propDef.isOptional() && !refs.openaiStrictMode ? acc.required : (0, $3jzhD._)(acc.required).concat([
                propName
            ])
        };
    }, {
        properties: {},
        required: []
    })), {
        additionalProperties: $c904626e3bf3c7ae$var$decideAdditionalProperties(def, refs)
    });
    if (!result.required.length) delete result.required;
    return result;
}



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $3jzhD = parcelRequire("3jzhD");

var $0e0c97268a253af9$export$9ebda48a78f86524 = function(def, refs) {
    var _refs_propertyPath;
    if (refs.currentPath.toString() === ((_refs_propertyPath = refs.propertyPath) === null || _refs_propertyPath === void 0 ? void 0 : _refs_propertyPath.toString())) return (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.innerType._def, refs);
    var innerSchema = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.innerType._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
        currentPath: (0, $3jzhD._)(refs.currentPath).concat([
            "anyOf",
            "1"
        ])
    }));
    return innerSchema ? {
        anyOf: [
            {
                not: {}
            },
            innerSchema
        ]
    } : {};
};



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $3jzhD = parcelRequire("3jzhD");

var $5d712a660e5a1b19$export$c5b6cc918b779721 = function(def, refs) {
    if (refs.pipeStrategy === "input") return (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.in._def, refs);
    else if (refs.pipeStrategy === "output") return (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.out._def, refs);
    var a = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.in._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
        currentPath: (0, $3jzhD._)(refs.currentPath).concat([
            "allOf",
            "0"
        ])
    }));
    var b = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.out._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
        currentPath: (0, $3jzhD._)(refs.currentPath).concat([
            "allOf",
            a ? "1" : "0"
        ])
    }));
    return {
        allOf: [
            a,
            b
        ].filter(function(x) {
            return x !== undefined;
        })
    };
};



function $8f65c7d0e7e839fb$export$25adf76733a2a51e(def, refs) {
    return (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.type._def, refs);
}




var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $3jzhD = parcelRequire("3jzhD");


function $d464b6029e7e88ba$export$9bf814691104eb22(def, refs) {
    var items = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.valueType._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
        currentPath: (0, $3jzhD._)(refs.currentPath).concat([
            "items"
        ])
    }));
    var schema = {
        type: "array",
        uniqueItems: true,
        items: items
    };
    if (def.minSize) (0, $2df68c854d564410$export$f7d2bce693b08d40)(schema, "minItems", def.minSize.value, def.minSize.message, refs);
    if (def.maxSize) (0, $2df68c854d564410$export$f7d2bce693b08d40)(schema, "maxItems", def.maxSize.value, def.maxSize.message, refs);
    return schema;
}




var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $3jzhD = parcelRequire("3jzhD");

function $9493d75ba44e4667$export$49b44f845e795a29(def, refs) {
    if (def.rest) return {
        type: "array",
        minItems: def.items.length,
        items: def.items.map(function(x, i) {
            return (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(x._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
                currentPath: (0, $3jzhD._)(refs.currentPath).concat([
                    "items",
                    "".concat(i)
                ])
            }));
        }).reduce(function(acc, x) {
            return x === undefined ? acc : (0, $3jzhD._)(acc).concat([
                x
            ]);
        }, []),
        additionalItems: (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.rest._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
            currentPath: (0, $3jzhD._)(refs.currentPath).concat([
                "additionalItems"
            ])
        }))
    };
    else return {
        type: "array",
        minItems: def.items.length,
        maxItems: def.items.length,
        items: def.items.map(function(x, i) {
            return (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(x._def, (0, $ddevm._)((0, $78DQ7._)({}, refs), {
                currentPath: (0, $3jzhD._)(refs.currentPath).concat([
                    "items",
                    "".concat(i)
                ])
            }));
        }).reduce(function(acc, x) {
            return x === undefined ? acc : (0, $3jzhD._)(acc).concat([
                x
            ]);
        }, [])
    };
}


function $66891e05351a7561$export$1f635862c66c5983() {
    return {
        not: {}
    };
}



function $fc7fcb5567e14a54$export$23cbe91c3e1aee01() {
    return {};
}



var $6dff7192d34fdceb$export$6e7a3d506d6dcac2 = function(def, refs) {
    return (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(def.innerType._def, refs);
};



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");
var $453b492be158c602$export$c23321d057eaf8c4 = Symbol("Let zodToJsonSchema decide on which parser to use");
var $453b492be158c602$var$defaultOptions = {
    name: undefined,
    $refStrategy: "root",
    effectStrategy: "input",
    pipeStrategy: "all",
    dateStrategy: "format:date-time",
    mapStrategy: "entries",
    nullableStrategy: "from-target",
    removeAdditionalStrategy: "passthrough",
    definitionPath: "definitions",
    target: "jsonSchema7",
    strictUnions: false,
    errorMessages: false,
    markdownDescription: false,
    patternStrategy: "escape",
    applyRegexFlags: false,
    emailStrategy: "format:email",
    base64Strategy: "contentEncoding:base64",
    nameStrategy: "ref"
};
var $453b492be158c602$export$430a3269e24b912e = function(options) {
    // We need to add `definitions` here as we may mutate it
    return typeof options === "string" ? (0, $ddevm._)((0, $78DQ7._)({}, $453b492be158c602$var$defaultOptions), {
        basePath: [
            "#"
        ],
        definitions: {},
        name: options
    }) : (0, $78DQ7._)((0, $ddevm._)((0, $78DQ7._)({}, $453b492be158c602$var$defaultOptions), {
        basePath: [
            "#"
        ],
        definitions: {}
    }), options);
};


function $2ff76a169a1ff9c0$export$1063952312e3541c(def, refs) {
    var forceResolution = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var seenItem = refs.seen.get(def);
    if (refs.override) {
        var _refs_override;
        var overrideResult = (_refs_override = refs.override) === null || _refs_override === void 0 ? void 0 : _refs_override.call(refs, def, refs, seenItem, forceResolution);
        if (overrideResult !== (0, $453b492be158c602$export$c23321d057eaf8c4)) return overrideResult;
    }
    if (seenItem && !forceResolution) {
        var seenSchema = $2ff76a169a1ff9c0$var$get$ref(seenItem, refs);
        if (seenSchema !== undefined) {
            if ("$ref" in seenSchema) refs.seenRefs.add(seenSchema.$ref);
            return seenSchema;
        }
    }
    var newItem = {
        def: def,
        path: refs.currentPath,
        jsonSchema: undefined
    };
    refs.seen.set(def, newItem);
    var jsonSchema = $2ff76a169a1ff9c0$var$selectParser(def, def.typeName, refs);
    if (jsonSchema) $2ff76a169a1ff9c0$var$addMeta(def, refs, jsonSchema);
    newItem.jsonSchema = jsonSchema;
    return jsonSchema;
}
var $2ff76a169a1ff9c0$var$get$ref = function(item, refs) {
    switch(refs.$refStrategy){
        case "root":
            return {
                $ref: item.path.join("/")
            };
        // this case is needed as OpenAI strict mode doesn't support top-level `$ref`s, i.e.
        // the top-level schema *must* be `{"type": "object", "properties": {...}}` but if we ever
        // need to define a `$ref`, relative `$ref`s aren't supported, so we need to extract
        // the schema to `#/definitions/` and reference that.
        //
        // e.g. if we need to reference a schema at
        // `["#","definitions","contactPerson","properties","person1","properties","name"]`
        // then we'll extract it out to `contactPerson_properties_person1_properties_name`
        case "extract-to-root":
            var name = item.path.slice(refs.basePath.length + 1).join("_");
            // we don't need to extract the root schema in this case, as it's already
            // been added to the definitions
            if (name !== refs.name && refs.nameStrategy === "duplicate-ref") refs.definitions[name] = item.def;
            return {
                $ref: (0, $3jzhD._)(refs.basePath).concat([
                    refs.definitionPath,
                    name
                ]).join("/")
            };
        case "relative":
            return {
                $ref: $2ff76a169a1ff9c0$var$getRelativePath(refs.currentPath, item.path)
            };
        case "none":
        case "seen":
            if (item.path.length < refs.currentPath.length && item.path.every(function(value, index) {
                return refs.currentPath[index] === value;
            })) {
                console.warn("Recursive reference detected at ".concat(refs.currentPath.join("/"), "! Defaulting to any"));
                return {};
            }
            return refs.$refStrategy === "seen" ? {} : undefined;
    }
};
var $2ff76a169a1ff9c0$var$getRelativePath = function(pathA, pathB) {
    var i = 0;
    for(; i < pathA.length && i < pathB.length; i++){
        if (pathA[i] !== pathB[i]) break;
    }
    return [
        (pathA.length - i).toString()
    ].concat((0, $3jzhD._)(pathB.slice(i))).join("/");
};
var $2ff76a169a1ff9c0$var$selectParser = function(def, typeName, refs) {
    switch(typeName){
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodString:
            return (0, $12f032d24d79347a$export$c6dca604104d35ca)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodNumber:
            return (0, $767e3d030d7d8d8d$export$1c2f9bc71877e9a2)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodObject:
            return (0, $c904626e3bf3c7ae$export$f530ed7e1f9e38cd)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodBigInt:
            return (0, $0e4550fa5dbb4d19$export$43aac7d536884cad)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodBoolean:
            return (0, $9132c6739764a7a3$export$953fb8456e1b3de0)();
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodDate:
            return (0, $cfe35d3e0f1fa59b$export$7ff09a50352abb2f)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodUndefined:
            return (0, $66891e05351a7561$export$1f635862c66c5983)();
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodNull:
            return (0, $0f72b6dd538479c0$export$9dab39b894fea7b)(refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodArray:
            return (0, $ddeb210e555bb290$export$9c1a0c7a7667fa87)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodUnion:
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodDiscriminatedUnion:
            return (0, $72b1a1c258a0d5e6$export$4fd6ebd75521f86f)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodIntersection:
            return (0, $4cb3956a461ebd3d$export$c12a2394fc457627)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodTuple:
            return (0, $9493d75ba44e4667$export$49b44f845e795a29)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodRecord:
            return (0, $d861de743d5a3fc5$export$bab91a30f81817bc)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodLiteral:
            return (0, $8ab4fb92a28941a2$export$81a695a005c19352)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodEnum:
            return (0, $4426d225cf133d1e$export$73516460e65887be)(def);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodNativeEnum:
            return (0, $510536f28ddd3e79$export$6631cffa548a42cf)(def);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodNullable:
            return (0, $654f8ebae80eb2ed$export$5b998cd3cbcce402)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodOptional:
            return (0, $0e0c97268a253af9$export$9ebda48a78f86524)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodMap:
            return (0, $3735f1962806a37e$export$cb8e42ab369177cd)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodSet:
            return (0, $d464b6029e7e88ba$export$9bf814691104eb22)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodLazy:
            return $2ff76a169a1ff9c0$export$1063952312e3541c(def.getter()._def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodPromise:
            return (0, $8f65c7d0e7e839fb$export$25adf76733a2a51e)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodNaN:
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodNever:
            return (0, $bbbca76d1cb04d1f$export$3490b811136dce94)();
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodEffects:
            return (0, $879e23f5bc44ca71$export$8edd16d8c2901277)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodAny:
            return (0, $6b95a74d5fbc309c$export$3e2bb967172656aa)();
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodUnknown:
            return (0, $fc7fcb5567e14a54$export$23cbe91c3e1aee01)();
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodDefault:
            return (0, $9aebb28384ee9d80$export$e46de3de93f6b4e7)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodBranded:
            return (0, $006c352723d922c9$export$487a80cbcbb64a8d)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodReadonly:
            return (0, $6dff7192d34fdceb$export$6e7a3d506d6dcac2)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodCatch:
            return (0, $5ec16c0caefbe63d$export$540346d1622aa551)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodPipeline:
            return (0, $5d712a660e5a1b19$export$c5b6cc918b779721)(def, refs);
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodFunction:
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodVoid:
        case (0, $3Fd7H.ZodFirstPartyTypeKind).ZodSymbol:
            return undefined;
        default:
            return function(_) {
                return undefined;
            }(typeName);
    }
};
var $2ff76a169a1ff9c0$var$addMeta = function(def, refs, jsonSchema) {
    if (def.description) {
        jsonSchema.description = def.description;
        if (refs.markdownDescription) jsonSchema.markdownDescription = def.description;
    }
    return jsonSchema;
};



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $7078fb7d674332dd$export$57f91ba833ce5030 = function(zodSchema) {
    return "_def" in zodSchema ? zodSchema._def : zodSchema;
};
function $7078fb7d674332dd$export$4a2fbc025e4a4a37(obj) {
    if (!obj) return true;
    for(var _k in obj)return false;
    return true;
}


var $fb6e1f5ff678c7dd$export$298f5b3210f877af = function(options) {
    var _options = (0, $453b492be158c602$export$430a3269e24b912e)(options);
    var currentPath = _options.name !== undefined ? (0, $3jzhD._)(_options.basePath).concat([
        _options.definitionPath,
        _options.name
    ]) : _options.basePath;
    return (0, $ddevm._)((0, $78DQ7._)({}, _options), {
        currentPath: currentPath,
        propertyPath: undefined,
        seenRefs: new Set(),
        seen: new Map(Object.entries(_options.definitions).map(function(param) {
            var _param = (0, $2MTYX._)(param, 2), name = _param[0], def = _param[1];
            return [
                (0, $7078fb7d674332dd$export$57f91ba833ce5030)(def),
                {
                    def: (0, $7078fb7d674332dd$export$57f91ba833ce5030)(def),
                    path: (0, $3jzhD._)(_options.basePath).concat([
                        _options.definitionPath,
                        name
                    ]),
                    // Resolution of references will be forced even though seen, so it's ok that the schema is undefined here for now.
                    jsonSchema: undefined
                }
            ];
        }))
    });
};



var $ea3b03f7c6ad1d1d$export$c365928c26d2ef43 = function(schema, options) {
    var refs = (0, $fb6e1f5ff678c7dd$export$298f5b3210f877af)(options);
    var name = typeof options === "string" ? options : (options === null || options === void 0 ? void 0 : options.nameStrategy) === "title" ? undefined : options === null || options === void 0 ? void 0 : options.name;
    var _parseDef;
    var main = (_parseDef = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)(schema._def, name === undefined ? refs : (0, $ddevm._)((0, $78DQ7._)({}, refs), {
        currentPath: (0, $3jzhD._)(refs.basePath).concat([
            refs.definitionPath,
            name
        ])
    }), false)) !== null && _parseDef !== void 0 ? _parseDef : {};
    var title = typeof options === "object" && options.name !== undefined && options.nameStrategy === "title" ? options.name : undefined;
    if (title !== undefined) main.title = title;
    var definitions = function() {
        if ((0, $7078fb7d674332dd$export$4a2fbc025e4a4a37)(refs.definitions)) return undefined;
        var definitions = {};
        var processedDefinitions = new Set();
        // the call to `parseDef()` here might itself add more entries to `.definitions`
        // so we need to continually evaluate definitions until we've resolved all of them
        //
        // we have a generous iteration limit here to avoid blowing up the stack if there
        // are any bugs that would otherwise result in us iterating indefinitely
        for(var i = 0; i < 500; i++){
            var newDefinitions = Object.entries(refs.definitions).filter(function(param) {
                var _param = (0, $2MTYX._)(param, 1), key = _param[0];
                return !processedDefinitions.has(key);
            });
            if (newDefinitions.length === 0) break;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = newDefinitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $2MTYX._)(_step.value, 2), key = _step_value[0], _$schema = _step_value[1];
                    var _parseDef;
                    definitions[key] = (_parseDef = (0, $2ff76a169a1ff9c0$export$1063952312e3541c)((0, $7078fb7d674332dd$export$57f91ba833ce5030)(_$schema), (0, $ddevm._)((0, $78DQ7._)({}, refs), {
                        currentPath: (0, $3jzhD._)(refs.basePath).concat([
                            refs.definitionPath,
                            key
                        ])
                    }), true)) !== null && _parseDef !== void 0 ? _parseDef : {};
                    processedDefinitions.add(key);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return definitions;
    }();
    var combined = name === undefined ? definitions ? (0, $ddevm._)((0, $78DQ7._)({}, main), (0, $c5rwh._)({}, refs.definitionPath, definitions)) : main : refs.nameStrategy === "duplicate-ref" ? (0, $78DQ7._)({}, main, definitions || refs.seenRefs.size ? (0, $c5rwh._)({}, refs.definitionPath, (0, $78DQ7._)({}, definitions, refs.seenRefs.size ? (0, $c5rwh._)({}, name, main) : undefined)) : undefined) : (0, $c5rwh._)({
        $ref: (0, $3jzhD._)(refs.$refStrategy === "relative" ? [] : refs.basePath).concat([
            refs.definitionPath,
            name
        ]).join("/")
    }, refs.definitionPath, (0, $ddevm._)((0, $78DQ7._)({}, definitions), (0, $c5rwh._)({}, name, main)));
    if (refs.target === "jsonSchema7") combined.$schema = "http://json-schema.org/draft-07/schema#";
    else if (refs.target === "jsonSchema2019-09") combined.$schema = "https://json-schema.org/draft/2019-09/schema#";
    return combined;
};


function $5377b02b5f28e18e$var$zodToJsonSchema(schema, options) {
    return (0, $ea3b03f7c6ad1d1d$export$c365928c26d2ef43)(schema, {
        openaiStrictMode: true,
        name: options.name,
        nameStrategy: "duplicate-ref",
        $refStrategy: "extract-to-root",
        nullableStrategy: "property"
    });
}
function $5377b02b5f28e18e$export$5a36c27dc294dc58(zodObject, name, props) {
    return (0, $aaca55cce8d1c260$export$8571f96912acf365)({
        type: "json_schema",
        json_schema: (0, $ddevm._)((0, $78DQ7._)({}, props), {
            name: name,
            strict: true,
            schema: $5377b02b5f28e18e$var$zodToJsonSchema(zodObject, {
                name: name
            })
        })
    }, function(content) {
        return zodObject.parse(JSON.parse(content));
    });
}
function $5377b02b5f28e18e$export$1d2f7ec849832747(options) {
    // @ts-expect-error TODO
    return (0, $aaca55cce8d1c260$export$8c880bd1baec2c2d)({
        type: "function",
        function: (0, $78DQ7._)({
            name: options.name,
            parameters: $5377b02b5f28e18e$var$zodToJsonSchema(options.parameters, {
                name: options.name
            }),
            strict: true
        }, options.description ? {
            description: options.description
        } : undefined)
    }, {
        callback: options.function,
        parser: function(args) {
            return options.parameters.parse(JSON.parse(args));
        }
    });
}


var $41077b5e0f3767fc$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $41077b5e0f3767fc$var$getBase64(file) {
    return $41077b5e0f3767fc$var$__awaiter(this, void 0, void 0, function() {
        return (0, $lF1I7.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = function() {
                        resolve(reader.result);
                    };
                    reader.onerror = function(error) {
                        console.log("Error: ", error);
                        resolve(reader.error);
                    };
                })
            ];
        });
    });
}
var $41077b5e0f3767fc$var$AIAdapter = /*#__PURE__*/ function() {
    "use strict";
    function AIAdapter() {
        (0, $19mwo._)(this, AIAdapter);
        Object.defineProperty(this, "openai", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.openai = new (0, (/*@__PURE__*/$parcel$interopDefault($dSxWp)))({
            apiKey: "sk-cyyrXD97gTbtJNon8wyArslj9T2EhlAxv0vJED_wONT3BlbkFJnrZAlUOvr7wsOAM0R8ycdJLsaV6aoYRZNXs_drst4A",
            dangerouslyAllowBrowser: true
        });
    }
    (0, $6rpfc._)(AIAdapter, [
        {
            key: "generateNewListCategory",
            value: function generateNewListCategory(categoryName) {
                return $41077b5e0f3767fc$var$__awaiter(this, void 0, void 0, function() {
                    var openai, completion, content, js, json;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                openai = this.openai;
                                return [
                                    4,
                                    openai.chat.completions.create({
                                        model: "gpt-4o",
                                        messages: [
                                            {
                                                role: "system",
                                                content: "You are a helpful assistant. I will send you a category name of some type of content. Might be movies or books or something else. Please return a JSON array of upto 20 of the most common categories of that type of content. "
                                            },
                                            {
                                                role: "user",
                                                content: [
                                                    {
                                                        type: "text",
                                                        text: "The type of content I am intrested in is ".concat(categoryName, '. Please return a JSON array of upto 20 of the most common categories of that type of content. Example JSON: ["Action", "Comedy", "Drama", ...]')
                                                    }
                                                ]
                                            }
                                        ],
                                        max_tokens: 1000
                                    })
                                ];
                            case 1:
                                completion = _state.sent();
                                content = completion.choices[0].message.content;
                                js = content.replace("```json\n", "").replace("```", "");
                                json = JSON.parse(js);
                                return [
                                    2,
                                    json
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getTranscript",
            value: function getTranscript(file) {
                return $41077b5e0f3767fc$var$__awaiter(this, void 0, void 0, function() {
                    var modal, openai, transcription;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                modal = (0, $3a3345637c0a5d6f$export$33ffd74ebf07f060)();
                                modal.shouldBlockUI = true;
                                openai = new (0, (/*@__PURE__*/$parcel$interopDefault($dSxWp)))({
                                    apiKey: "sk-cyyrXD97gTbtJNon8wyArslj9T2EhlAxv0vJED_wONT3BlbkFJnrZAlUOvr7wsOAM0R8ycdJLsaV6aoYRZNXs_drst4A",
                                    dangerouslyAllowBrowser: true
                                });
                                return [
                                    4,
                                    openai.audio.transcriptions.create({
                                        file: file,
                                        model: "whisper-1",
                                        response_format: "text"
                                    })
                                ];
                            case 1:
                                transcription = _state.sent();
                                modal.shouldBlockUI = false;
                                return [
                                    2,
                                    transcription
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "sendToOpenAI_Question",
            value: function sendToOpenAI_Question() {
                return $41077b5e0f3767fc$var$__awaiter(this, arguments, void 0, function() {
                    var text, fileObject, modal, openai, content, imageAsBase64, pre_question, completion, msg;
                    var _arguments = arguments;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                text = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : null, fileObject = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null;
                                modal = (0, $3a3345637c0a5d6f$export$33ffd74ebf07f060)();
                                modal.shouldBlockUI = true;
                                openai = new (0, (/*@__PURE__*/$parcel$interopDefault($dSxWp)))({
                                    apiKey: "sk-cyyrXD97gTbtJNon8wyArslj9T2EhlAxv0vJED_wONT3BlbkFJnrZAlUOvr7wsOAM0R8ycdJLsaV6aoYRZNXs_drst4A",
                                    dangerouslyAllowBrowser: true
                                });
                                content = [];
                                if (!fileObject) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    $41077b5e0f3767fc$var$getBase64(fileObject)
                                ];
                            case 1:
                                imageAsBase64 = _state.sent();
                                content.push({
                                    type: "image_url",
                                    image_url: {
                                        url: imageAsBase64
                                    }
                                });
                                _state.label = 2;
                            case 2:
                                if (text) {
                                    pre_question = "This is my question: ";
                                    content.push({
                                        type: "text",
                                        text: pre_question + text
                                    });
                                }
                                return [
                                    4,
                                    openai.chat.completions.create({
                                        model: "gpt-4o-2024-08-06",
                                        messages: [
                                            {
                                                role: "system",
                                                content: "You are a helpful assistant. I will send you a question as text and maybe an attached image.  Please try to answer the question. Textual response. Not too long. Upto 3-5 sentances."
                                            },
                                            {
                                                role: "user",
                                                content: content
                                            }
                                        ],
                                        max_tokens: 1000
                                    })
                                ];
                            case 3:
                                completion = _state.sent();
                                msg = completion.choices[0].message;
                                if (msg.refusal) {
                                    console.log("Open AI: Refusal:", msg.refusal);
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                modal.shouldBlockUI = false;
                                return [
                                    2,
                                    msg.content
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "sendToOpenAI_GetAction",
            value: function sendToOpenAI_GetAction() {
                return $41077b5e0f3767fc$var$__awaiter(this, arguments, void 0, function() {
                    var text, fileObject, modal, openai, prompt, lists, categories, oneAction, listOfActions, content, imageAsBase64, pre_question, completion, msg;
                    var _arguments = arguments;
                    return (0, $lF1I7.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                text = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : null, fileObject = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null;
                                modal = (0, $3a3345637c0a5d6f$export$33ffd74ebf07f060)();
                                modal.shouldBlockUI = true;
                                openai = new (0, (/*@__PURE__*/$parcel$interopDefault($dSxWp)))({
                                    apiKey: "sk-cyyrXD97gTbtJNon8wyArslj9T2EhlAxv0vJED_wONT3BlbkFJnrZAlUOvr7wsOAM0R8ycdJLsaV6aoYRZNXs_drst4A",
                                    dangerouslyAllowBrowser: true
                                });
                                prompt = 'There is 1 type of action. Add \'NewContent\' - There are the types of content: "Movies", "TVShows", "PCGames", "Books", "Music", "FoodReceipes".\n					    Based on the following transcript figure out what type of task this is. Please reply in JSON format.						\n						- NewContent will have a name specifying the content and contentType. Example response: {action: \'NewContent\', name: \'{Name of content in transcript}\', contentType: \'{Type of content in transcript}\', description: \'Description of the content from transcript\'}.\n						\n						If the specific content is part of a franchise include the others as actions.\n\n						Please use their full names, the most common ones used.\n						\n						If an image is included it is most likely a screenshot of a phone. In it there is content I am intrested in. It can be a movie title, book, author, music.\n						Please reply in JSON format. No extra text!';
                                lists = (0, $3a3345637c0a5d6f$export$3b5bae399c8431fb)();
                                categories = lists.categories.map(function(c) {
                                    return c.name;
                                });
                                oneAction = (0, $3Fd7H.z).object({
                                    action: (0, $3Fd7H.z).enum([
                                        "NewTask",
                                        "NewContent"
                                    ]),
                                    name: (0, $3Fd7H.z).string(),
                                    description: (0, $3Fd7H.z).string().optional(),
                                    contentType: (0, $3Fd7H.z).enum([
                                        "Movies",
                                        "TVShows",
                                        "PCGames",
                                        "Books",
                                        "Music",
                                        "FoodReceipes",
                                        "None"
                                    ])
                                });
                                listOfActions = (0, $3Fd7H.z).object({
                                    actions: (0, $3Fd7H.z).array(oneAction)
                                });
                                content = [
                                    {
                                        type: "text",
                                        text: prompt
                                    }
                                ];
                                if (!fileObject) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    $41077b5e0f3767fc$var$getBase64(fileObject)
                                ];
                            case 1:
                                imageAsBase64 = _state.sent();
                                content.push({
                                    type: "image_url",
                                    image_url: {
                                        url: imageAsBase64
                                    }
                                });
                                _state.label = 2;
                            case 2:
                                if (text) {
                                    pre_question = "Extra info: ";
                                    content.push({
                                        type: "text",
                                        text: pre_question + text
                                    });
                                }
                                return [
                                    4,
                                    openai.chat.completions.create({
                                        model: "gpt-4o-2024-08-06",
                                        messages: [
                                            {
                                                role: "system",
                                                content: "You are a helpful assistant. I will send you a text voice transcript of a request of mine. Please return what you infer from it based on the available actions I specify I can take. Reply in JSON. No extra text."
                                            },
                                            {
                                                role: "user",
                                                content: content
                                            }
                                        ],
                                        response_format: (0, $5377b02b5f28e18e$export$5a36c27dc294dc58)(listOfActions, "actions_schema"),
                                        max_tokens: 400
                                    })
                                ];
                            case 3:
                                completion = _state.sent();
                                msg = completion.choices[0].message;
                                if (msg.refusal) {
                                    console.log("Open AI: Refusal:", msg.refusal);
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                modal.shouldBlockUI = false;
                                return [
                                    2,
                                    JSON.parse(msg.content)
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return AIAdapter;
}();
var $41077b5e0f3767fc$var$mAI = new $41077b5e0f3767fc$var$AIAdapter();
function $41077b5e0f3767fc$export$a9ba05c6103248e9() {
    return $41077b5e0f3767fc$var$mAI;
}




var $33gHU = parcelRequire("33gHU");
var $22f7b0f72af94eb4$export$3b4d6962b8b123a9;
var $22f7b0f72af94eb4$export$fa285f252d60a1b;
var $22f7b0f72af94eb4$export$a5a0766953dba635;
var $22f7b0f72af94eb4$export$3642f561e7de7ca;
$22f7b0f72af94eb4$export$3b4d6962b8b123a9 = "EaasIG_activate_animation";
$22f7b0f72af94eb4$export$fa285f252d60a1b = "EaasIG_recordIcon";
$22f7b0f72af94eb4$export$a5a0766953dba635 = "EaasIG_recording";
$22f7b0f72af94eb4$export$3642f561e7de7ca = "EaasIG_wiggle";
$22f7b0f72af94eb4$export$3642f561e7de7ca;


var $226e9ff7925bc4d2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $226e9ff7925bc4d2$export$de95611a92ae0566 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function(props) {
    var mediaStream = (0, $33gHU.useRef)(null);
    var chunks = (0, $33gHU.useRef)([]);
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)(false), 2), isRecording = _useState[0], setIsRecording = _useState[1];
    (0, $33gHU.useEffect)(function() {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            console.log("getUserMedia supported.");
            navigator.mediaDevices.getUserMedia(// constraints - only audio needed for this app
            {
                audio: true
            })// Success callback
            .then(function(stream) {
                var mediaRecorder = new MediaRecorder(stream);
                mediaStream.current = mediaRecorder;
                mediaRecorder.ondataavailable = function(e) {
                    return $226e9ff7925bc4d2$var$__awaiter(void 0, void 0, void 0, function() {
                        var blob, file, ai, res;
                        return (0, $lF1I7.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    chunks.current.push(e.data);
                                    blob = new Blob(chunks.current, {
                                        type: "audio/ogg; codecs=opus"
                                    });
                                    file = new File([
                                        blob
                                    ], "speech.mp3", {
                                        type: "audio/ogg; codecs=opus"
                                    });
                                    ai = (0, $41077b5e0f3767fc$export$a9ba05c6103248e9)();
                                    return [
                                        4,
                                        ai.getTranscript(file)
                                    ];
                                case 1:
                                    res = _state.sent();
                                    props.onTranscript(res);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                };
            })// Error callback
            .catch(function(err) {
                console.error("The following getUserMedia error occurred: ".concat(err));
            });
        } else console.log("getUserMedia not supported on your browser!");
    }, []);
    var iconStyle = isRecording ? $22f7b0f72af94eb4$export$a5a0766953dba635 : "";
    var onClick = function() {
        if (!isRecording) {
            chunks.current = [];
            mediaStream.current.start();
            setIsRecording(true);
        } else {
            mediaStream.current.stop();
            setIsRecording(false);
        }
    };
    var assets = (0, $3a3345637c0a5d6f$export$bd973f06e9aaec8c)();
    var iconSrc = isRecording ? assets.sysIcons["stop-record"] : assets.sysIcons["record"];
    return (0, $978b871a0234f592$exports.jsx)((0, $978b871a0234f592$exports.Fragment), {
        children: (0, $978b871a0234f592$exports.jsx)("img", {
            className: $22f7b0f72af94eb4$export$fa285f252d60a1b + " " + props.className,
            src: iconSrc.url,
            onClick: onClick
        })
    });
});



var $lF1I7 = parcelRequire("lF1I7");


var $6f191d2ec90e71ff$export$2778853eeaa53fa7;
$6f191d2ec90e71ff$export$2778853eeaa53fa7 = "_5XGpBG_taskPageDropZone";



var $33gHU = parcelRequire("33gHU");


var $50b3ec7e1b18edba$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var $15Pju = parcelRequire("15Pju");

var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $iNfU4 = parcelRequire("iNfU4");

var $hSCyS = parcelRequire("hSCyS");

var $k1NN5 = parcelRequire("k1NN5");
var $a41e6e7bc323dc7d$export$2e2bcd8739ae039 = $a41e6e7bc323dc7d$var$extend;
/*
  var obj = {a: 3, b: 5};
  extend(obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 4, b: 5, c: 8}

  var obj = {a: 3, b: 5};
  extend({}, obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 3, b: 5}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3, 4]}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(true, obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3]}

  extend({a: 4, b: 5}); // {a: 4, b: 5}
  extend({a: 4, b: 5}, 3); {a: 4, b: 5}
  extend({a: 4, b: 5}, true); {a: 4, b: 5}
  extend('hello', {a: 4, b: 5}); // throws
  extend(3, {a: 4, b: 5}); // throws
*/ function $a41e6e7bc323dc7d$var$extend() {
    var args = [].slice.call(arguments);
    var deep = false;
    if (typeof args[0] == "boolean") deep = args.shift();
    var result = args[0];
    if ($a41e6e7bc323dc7d$var$isUnextendable(result)) throw new Error("extendee must be an object");
    var extenders = args.slice(1);
    var len = extenders.length;
    for(var i = 0; i < len; i++){
        var extender = extenders[i];
        for(var key in extender)if (Object.prototype.hasOwnProperty.call(extender, key)) {
            var value = extender[key];
            if (deep && $a41e6e7bc323dc7d$var$isCloneable(value)) {
                var base = Array.isArray(value) ? [] : {};
                result[key] = $a41e6e7bc323dc7d$var$extend(true, Object.prototype.hasOwnProperty.call(result, key) && !$a41e6e7bc323dc7d$var$isUnextendable(result[key]) ? result[key] : base, value);
            } else result[key] = value;
        }
    }
    return result;
}
function $a41e6e7bc323dc7d$var$isCloneable(obj) {
    return Array.isArray(obj) || ({}).toString.call(obj) == "[object Object]";
}
function $a41e6e7bc323dc7d$var$isUnextendable(val) {
    return !val || typeof val != "object" && typeof val != "function";
}


function $ab966853eba787d9$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $ab966853eba787d9$var$$4040acfd8584338d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function $4040acfd8584338d$export$2e2bcd8739ae039() {
        (0, $19mwo._)(this, $4040acfd8584338d$export$2e2bcd8739ae039);
    }
    (0, $6rpfc._)($4040acfd8584338d$export$2e2bcd8739ae039, [
        {
            // Add an event listener for given event
            key: "on",
            value: function on(event, fn) {
                this._callbacks = this._callbacks || {};
                // Create namespace for this event
                if (!this._callbacks[event]) this._callbacks[event] = [];
                this._callbacks[event].push(fn);
                return this;
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                this._callbacks = this._callbacks || {};
                var callbacks = this._callbacks[event];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (callbacks) try {
                    for(var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var callback = _step.value;
                        callback.apply(this, args);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // trigger a corresponding DOM event
                if (this.element) this.element.dispatchEvent(this.makeEvent("dropzone:" + event, {
                    args: args
                }));
                return this;
            }
        },
        {
            key: "makeEvent",
            value: function makeEvent(eventName, detail) {
                var params = {
                    bubbles: true,
                    cancelable: true,
                    detail: detail
                };
                if (typeof window.CustomEvent === "function") return new CustomEvent(eventName, params);
                else {
                    // IE 11 support
                    // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
                    var evt = document.createEvent("CustomEvent");
                    evt.initCustomEvent(eventName, params.bubbles, params.cancelable, params.detail);
                    return evt;
                }
            }
        },
        {
            // Remove event listener for given event. If fn is not provided, all event
            // listeners for that event will be removed. If neither is provided, all
            // event listeners will be removed.
            key: "off",
            value: function off(event, fn) {
                if (!this._callbacks || arguments.length === 0) {
                    this._callbacks = {};
                    return this;
                }
                // specific event
                var callbacks = this._callbacks[event];
                if (!callbacks) return this;
                // remove all handlers
                if (arguments.length === 1) {
                    delete this._callbacks[event];
                    return this;
                }
                // remove specific handler
                for(var i = 0; i < callbacks.length; i++){
                    var callback = callbacks[i];
                    if (callback === fn) {
                        callbacks.splice(i, 1);
                        break;
                    }
                }
                return this;
            }
        }
    ]);
    return $4040acfd8584338d$export$2e2bcd8739ae039;
}();
var $ab966853eba787d9$var$$fd6031f88dce2e32$exports = {};
$ab966853eba787d9$var$$fd6031f88dce2e32$exports = '<div class="dz-preview dz-file-preview">\n  <div class="dz-image"><img data-dz-thumbnail=""></div>\n  <div class="dz-details">\n    <div class="dz-size"><span data-dz-size=""></span></div>\n    <div class="dz-filename"><span data-dz-name=""></span></div>\n  </div>\n  <div class="dz-progress">\n    <span class="dz-upload" data-dz-uploadprogress=""></span>\n  </div>\n  <div class="dz-error-message"><span data-dz-errormessage=""></span></div>\n  <div class="dz-success-mark">\n    <svg width="54" height="54" viewBox="0 0 54 54" fill="white" xmlns="http://www.w3.org/2000/svg">\n      <path d="M10.2071 29.7929L14.2929 25.7071C14.6834 25.3166 15.3166 25.3166 15.7071 25.7071L21.2929 31.2929C21.6834 31.6834 22.3166 31.6834 22.7071 31.2929L38.2929 15.7071C38.6834 15.3166 39.3166 15.3166 39.7071 15.7071L43.7929 19.7929C44.1834 20.1834 44.1834 20.8166 43.7929 21.2071L22.7071 42.2929C22.3166 42.6834 21.6834 42.6834 21.2929 42.2929L10.2071 31.2071C9.81658 30.8166 9.81658 30.1834 10.2071 29.7929Z"></path>\n    </svg>\n  </div>\n  <div class="dz-error-mark">\n    <svg width="54" height="54" viewBox="0 0 54 54" fill="white" xmlns="http://www.w3.org/2000/svg">\n      <path d="M26.2929 20.2929L19.2071 13.2071C18.8166 12.8166 18.1834 12.8166 17.7929 13.2071L13.2071 17.7929C12.8166 18.1834 12.8166 18.8166 13.2071 19.2071L20.2929 26.2929C20.6834 26.6834 20.6834 27.3166 20.2929 27.7071L13.2071 34.7929C12.8166 35.1834 12.8166 35.8166 13.2071 36.2071L17.7929 40.7929C18.1834 41.1834 18.8166 41.1834 19.2071 40.7929L26.2929 33.7071C26.6834 33.3166 27.3166 33.3166 27.7071 33.7071L34.7929 40.7929C35.1834 41.1834 35.8166 41.1834 36.2071 40.7929L40.7929 36.2071C41.1834 35.8166 41.1834 35.1834 40.7929 34.7929L33.7071 27.7071C33.3166 27.3166 33.3166 26.6834 33.7071 26.2929L40.7929 19.2071C41.1834 18.8166 41.1834 18.1834 40.7929 17.7929L36.2071 13.2071C35.8166 12.8166 35.1834 12.8166 34.7929 13.2071L27.7071 20.2929C27.3166 20.6834 26.6834 20.6834 26.2929 20.2929Z"></path>\n    </svg>\n  </div>\n</div>\n';
var $ab966853eba787d9$var$$4ca367182776f80b$var$defaultOptions = {
    /**
   * Has to be specified on elements other than form (or when the form doesn't
   * have an `action` attribute).
   *
   * You can also provide a function that will be called with `files` and
   * `dataBlocks`  and must return the url as string.
   */ url: null,
    /**
   * Can be changed to `"put"` if necessary. You can also provide a function
   * that will be called with `files` and must return the method (since `v3.12.0`).
   */ method: "post",
    /**
   * Will be set on the XHRequest.
   */ withCredentials: false,
    /**
   * The timeout for the XHR requests in milliseconds (since `v4.4.0`).
   * If set to null or 0, no timeout is going to be set.
   */ timeout: null,
    /**
   * How many file uploads to process in parallel (See the
   * Enqueuing file uploads documentation section for more info)
   */ parallelUploads: 2,
    /**
   * Whether to send multiple files in one request. If
   * this it set to true, then the fallback file input element will
   * have the `multiple` attribute as well. This option will
   * also trigger additional events (like `processingmultiple`). See the events
   * documentation section for more information.
   */ uploadMultiple: false,
    /**
   * Whether you want files to be uploaded in chunks to your server. This can't be
   * used in combination with `uploadMultiple`.
   *
   * See [chunksUploaded](#config-chunksUploaded) for the callback to finalise an upload.
   */ chunking: false,
    /**
   * If `chunking` is enabled, this defines whether **every** file should be chunked,
   * even if the file size is below chunkSize. This means, that the additional chunk
   * form data will be submitted and the `chunksUploaded` callback will be invoked.
   */ forceChunking: false,
    /**
   * If `chunking` is `true`, then this defines the chunk size in bytes.
   */ chunkSize: 2097152,
    /**
   * If `true`, the individual chunks of a file are being uploaded simultaneously.
   */ parallelChunkUploads: false,
    /**
   * Whether a chunk should be retried if it fails.
   */ retryChunks: false,
    /**
   * If `retryChunks` is true, how many times should it be retried.
   */ retryChunksLimit: 3,
    /**
   * The maximum filesize (in MiB) that is allowed to be uploaded.
   */ maxFilesize: 256,
    /**
   * The name of the file param that gets transferred.
   * **NOTE**: If you have the option  `uploadMultiple` set to `true`, then
   * Dropzone will append `[]` to the name.
   */ paramName: "file",
    /**
   * Whether thumbnails for images should be generated
   */ createImageThumbnails: true,
    /**
   * In MB. When the filename exceeds this limit, the thumbnail will not be generated.
   */ maxThumbnailFilesize: 10,
    /**
   * If `null`, the ratio of the image will be used to calculate it.
   */ thumbnailWidth: 120,
    /**
   * The same as `thumbnailWidth`. If both are null, images will not be resized.
   */ thumbnailHeight: 120,
    /**
   * How the images should be scaled down in case both, `thumbnailWidth` and `thumbnailHeight` are provided.
   * Can be either `contain` or `crop`.
   */ thumbnailMethod: "crop",
    /**
   * If set, images will be resized to these dimensions before being **uploaded**.
   * If only one, `resizeWidth` **or** `resizeHeight` is provided, the original aspect
   * ratio of the file will be preserved.
   *
   * The `options.transformFile` function uses these options, so if the `transformFile` function
   * is overridden, these options don't do anything.
   */ resizeWidth: null,
    /**
   * See `resizeWidth`.
   */ resizeHeight: null,
    /**
   * The mime type of the resized image (before it gets uploaded to the server).
   * If `null` the original mime type will be used. To force jpeg, for example, use `image/jpeg`.
   * See `resizeWidth` for more information.
   */ resizeMimeType: null,
    /**
   * The quality of the resized images. See `resizeWidth`.
   */ resizeQuality: 0.8,
    /**
   * How the images should be scaled down in case both, `resizeWidth` and `resizeHeight` are provided.
   * Can be either `contain` or `crop`.
   */ resizeMethod: "contain",
    /**
   * The base that is used to calculate the **displayed** filesize. You can
   * change this to 1024 if you would rather display kibibytes, mebibytes,
   * etc... 1024 is technically incorrect, because `1024 bytes` are `1 kibibyte`
   * not `1 kilobyte`. You can change this to `1024` if you don't care about
   * validity.
   */ filesizeBase: 1000,
    /**
   * If not `null` defines how many files this Dropzone handles. If it exceeds,
   * the event `maxfilesexceeded` will be called. The dropzone element gets the
   * class `dz-max-files-reached` accordingly so you can provide visual
   * feedback.
   */ maxFiles: null,
    /**
   * An optional object to send additional headers to the server. Eg:
   * `{ "My-Awesome-Header": "header value" }`
   */ headers: null,
    /**
   * Should the default headers be set or not?
   * Accept: application/json <- for requesting json response
   * Cache-Control: no-cache <- Request shouldnt be cached
   * X-Requested-With: XMLHttpRequest <- We sent the request via XMLHttpRequest
   */ defaultHeaders: true,
    /**
   * If `true`, the dropzone element itself will be clickable, if `false`
   * nothing will be clickable.
   *
   * You can also pass an HTML element, a CSS selector (for multiple elements)
   * or an array of those. In that case, all of those elements will trigger an
   * upload when clicked.
   */ clickable: true,
    /**
   * Whether hidden files in directories should be ignored.
   */ ignoreHiddenFiles: true,
    /**
   * The default implementation of `accept` checks the file's mime type or
   * extension against this list. This is a comma separated list of mime
   * types or file extensions.
   *
   * Eg.: `image/*,application/pdf,.psd`
   *
   * If the Dropzone is `clickable` this option will also be used as
   * [`accept`](https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept)
   * parameter on the hidden file input as well.
   */ acceptedFiles: null,
    /**
   * **Deprecated!**
   * Use acceptedFiles instead.
   */ acceptedMimeTypes: null,
    /**
   * If false, files will be added to the queue but the queue will not be
   * processed automatically.
   * This can be useful if you need some additional user input before sending
   * files (or if you want want all files sent at once).
   * If you're ready to send the file simply call `myDropzone.processQueue()`.
   *
   * See the [enqueuing file uploads](#enqueuing-file-uploads) documentation
   * section for more information.
   */ autoProcessQueue: true,
    /**
   * If false, files added to the dropzone will not be queued by default.
   * You'll have to call `enqueueFile(file)` manually.
   */ autoQueue: true,
    /**
   * If `true`, this will add a link to every file preview to remove or cancel (if
   * already uploading) the file. The `dictCancelUpload`, `dictCancelUploadConfirmation`
   * and `dictRemoveFile` options are used for the wording.
   */ addRemoveLinks: false,
    /**
   * Defines where to display the file previews – if `null` the
   * Dropzone element itself is used. Can be a plain `HTMLElement` or a CSS
   * selector. The element should have the `dropzone-previews` class so
   * the previews are displayed properly.
   */ previewsContainer: null,
    /**
   * Set this to `true` if you don't want previews to be shown.
   */ disablePreviews: false,
    /**
   * This is the element the hidden input field (which is used when clicking on the
   * dropzone to trigger file selection) will be appended to. This might
   * be important in case you use frameworks to switch the content of your page.
   *
   * Can be a selector string, or an element directly.
   */ hiddenInputContainer: "body",
    /**
   * If null, no capture type will be specified
   * If camera, mobile devices will skip the file selection and choose camera
   * If microphone, mobile devices will skip the file selection and choose the microphone
   * If camcorder, mobile devices will skip the file selection and choose the camera in video mode
   * On apple devices multiple must be set to false.  AcceptedFiles may need to
   * be set to an appropriate mime type (e.g. "image/*", "audio/*", or "video/*").
   */ capture: null,
    /**
   * **Deprecated**. Use `renameFile` instead.
   */ renameFilename: null,
    /**
   * A function that is invoked before the file is uploaded to the server and renames the file.
   * This function gets the `File` as argument and can use the `file.name`. The actual name of the
   * file that gets used during the upload can be accessed through `file.upload.filename`.
   */ renameFile: null,
    /**
   * If `true` the fallback will be forced. This is very useful to test your server
   * implementations first and make sure that everything works as
   * expected without dropzone if you experience problems, and to test
   * how your fallbacks will look.
   */ forceFallback: false,
    /**
   * The text used before any files are dropped.
   */ dictDefaultMessage: "Drop files here to upload",
    /**
   * The text that replaces the default message text it the browser is not supported.
   */ dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
    /**
   * The text that will be added before the fallback form.
   * If you provide a  fallback element yourself, or if this option is `null` this will
   * be ignored.
   */ dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
    /**
   * If the filesize is too big.
   * `{{filesize}}` and `{{maxFilesize}}` will be replaced with the respective configuration values.
   */ dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
    /**
   * If the file doesn't match the file type.
   */ dictInvalidFileType: "You can't upload files of this type.",
    /**
   * If the server response was invalid.
   * `{{statusCode}}` will be replaced with the servers status code.
   */ dictResponseError: "Server responded with {{statusCode}} code.",
    /**
   * If `addRemoveLinks` is true, the text to be used for the cancel upload link.
   */ dictCancelUpload: "Cancel upload",
    /**
   * The text that is displayed if an upload was manually canceled
   */ dictUploadCanceled: "Upload canceled.",
    /**
   * If `addRemoveLinks` is true, the text to be used for confirmation when cancelling upload.
   */ dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
    /**
   * If `addRemoveLinks` is true, the text to be used to remove a file.
   */ dictRemoveFile: "Remove file",
    /**
   * If this is not null, then the user will be prompted before removing a file.
   */ dictRemoveFileConfirmation: null,
    /**
   * Displayed if `maxFiles` is st and exceeded.
   * The string `{{maxFiles}}` will be replaced by the configuration value.
   */ dictMaxFilesExceeded: "You can not upload any more files.",
    /**
   * Allows you to translate the different units. Starting with `tb` for terabytes and going down to
   * `b` for bytes.
   */ dictFileSizeUnits: {
        tb: "TB",
        gb: "GB",
        mb: "MB",
        kb: "KB",
        b: "b"
    },
    /**
   * Called when dropzone initialized
   * You can add event listeners here
   */ init: function() {},
    /**
   * Can be an **object** of additional parameters to transfer to the server, **or** a `Function`
   * that gets invoked with the `files`, `xhr` and, if it's a chunked upload, `chunk` arguments. In case
   * of a function, this needs to return a map.
   *
   * The default implementation does nothing for normal uploads, but adds relevant information for
   * chunked uploads.
   *
   * This is the same as adding hidden input fields in the form element.
   */ params: function(files, xhr, chunk) {
        if (chunk) return {
            dzuuid: chunk.file.upload.uuid,
            dzchunkindex: chunk.index,
            dztotalfilesize: chunk.file.size,
            dzchunksize: this.options.chunkSize,
            dztotalchunkcount: chunk.file.upload.totalChunkCount,
            dzchunkbyteoffset: chunk.index * this.options.chunkSize
        };
    },
    /**
   * A function that gets a [file](https://developer.mozilla.org/en-US/docs/DOM/File)
   * and a `done` function as parameters.
   *
   * If the done function is invoked without arguments, the file is "accepted" and will
   * be processed. If you pass an error message, the file is rejected, and the error
   * message will be displayed.
   * This function will not be called if the file is too big or doesn't match the mime types.
   */ accept: function(file, done) {
        return done();
    },
    /**
   * The callback that will be invoked when all chunks have been uploaded for a file.
   * It gets the file for which the chunks have been uploaded as the first parameter,
   * and the `done` function as second. `done()` needs to be invoked when everything
   * needed to finish the upload process is done.
   */ chunksUploaded: function chunksUploaded(file, done) {
        done();
    },
    /**
   * Sends the file as binary blob in body instead of form data.
   * If this is set, the `params` option will be ignored.
   * It's an error to set this to `true` along with `uploadMultiple` since
   * multiple files cannot be in a single binary body.
   */ binaryBody: false,
    /**
   * Gets called when the browser is not supported.
   * The default implementation shows the fallback input field and adds
   * a text.
   */ fallback: function() {
        // This code should pass in IE7... :(
        var messageElement;
        this.element.className = "".concat(this.element.className, " dz-browser-not-supported");
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.element.getElementsByTagName("div")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                if (/(^| )dz-message($| )/.test(child.className)) {
                    messageElement = child;
                    child.className = "dz-message"; // Removes the 'dz-default' class
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!messageElement) {
            messageElement = $ab966853eba787d9$export$2e2bcd8739ae039.createElement('<div class="dz-message"><span></span></div>');
            this.element.appendChild(messageElement);
        }
        var span = messageElement.getElementsByTagName("span")[0];
        if (span) {
            if (span.textContent != null) span.textContent = this.options.dictFallbackMessage;
            else if (span.innerText != null) span.innerText = this.options.dictFallbackMessage;
        }
        return this.element.appendChild(this.getFallbackForm());
    },
    /**
   * Gets called to calculate the thumbnail dimensions.
   *
   * It gets `file`, `width` and `height` (both may be `null`) as parameters and must return an object containing:
   *
   *  - `srcWidth` & `srcHeight` (required)
   *  - `trgWidth` & `trgHeight` (required)
   *  - `srcX` & `srcY` (optional, default `0`)
   *  - `trgX` & `trgY` (optional, default `0`)
   *
   * Those values are going to be used by `ctx.drawImage()`.
   */ resize: function(file, width, height, resizeMethod) {
        var info = {
            srcX: 0,
            srcY: 0,
            srcWidth: file.width,
            srcHeight: file.height
        };
        var srcRatio = file.width / file.height;
        // Automatically calculate dimensions if not specified
        if (width == null && height == null) {
            width = info.srcWidth;
            height = info.srcHeight;
        } else if (width == null) width = height * srcRatio;
        else if (height == null) height = width / srcRatio;
        // Make sure images aren't upscaled
        width = Math.min(width, info.srcWidth);
        height = Math.min(height, info.srcHeight);
        var trgRatio = width / height;
        if (info.srcWidth > width || info.srcHeight > height) {
            // Image is bigger and needs rescaling
            if (resizeMethod === "crop") {
                if (srcRatio > trgRatio) {
                    info.srcHeight = file.height;
                    info.srcWidth = info.srcHeight * trgRatio;
                } else {
                    info.srcWidth = file.width;
                    info.srcHeight = info.srcWidth / trgRatio;
                }
            } else if (resizeMethod === "contain") {
                // Method 'contain'
                if (srcRatio > trgRatio) height = width / srcRatio;
                else width = height * srcRatio;
            } else throw new Error("Unknown resizeMethod '".concat(resizeMethod, "'"));
        }
        info.srcX = (file.width - info.srcWidth) / 2;
        info.srcY = (file.height - info.srcHeight) / 2;
        info.trgWidth = width;
        info.trgHeight = height;
        return info;
    },
    /**
   * Can be used to transform the file (for example, resize an image if necessary).
   *
   * The default implementation uses `resizeWidth` and `resizeHeight` (if provided) and resizes
   * images according to those dimensions.
   *
   * Gets the `file` as the first parameter, and a `done()` function as the second, that needs
   * to be invoked with the file when the transformation is done.
   */ transformFile: function(file, done) {
        if ((this.options.resizeWidth || this.options.resizeHeight) && file.type.match(/image.*/)) return this.resizeImage(file, this.options.resizeWidth, this.options.resizeHeight, this.options.resizeMethod, done);
        else return done(file);
    },
    /**
   * A string that contains the template used for each dropped
   * file. Change it to fulfill your needs but make sure to properly
   * provide all elements.
   *
   * If you want to use an actual HTML element instead of providing a String
   * as a config option, you could create a div with the id `tpl`,
   * put the template inside it and provide the element like this:
   *
   *     document
   *       .querySelector('#tpl')
   *       .innerHTML
   *
   */ previewTemplate: /*@__PURE__*/ $ab966853eba787d9$var$$parcel$interopDefault($ab966853eba787d9$var$$fd6031f88dce2e32$exports),
    /*
   Those functions register themselves to the events on init and handle all
   the user interface specific stuff. Overwriting them won't break the upload
   but can break the way it's displayed.
   You can overwrite them if you don't like the default behavior. If you just
   want to add an additional event handler, register it on the dropzone object
   and don't overwrite those options.
   */ // Those are self explanatory and simply concern the DragnDrop.
    drop: function(e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    dragstart: function(e) {},
    dragend: function(e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    dragenter: function(e) {
        return this.element.classList.add("dz-drag-hover");
    },
    dragover: function(e) {
        return this.element.classList.add("dz-drag-hover");
    },
    dragleave: function(e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    paste: function(e) {},
    // Called whenever there are no files left in the dropzone anymore, and the
    // dropzone should be displayed as if in the initial state.
    reset: function() {
        return this.element.classList.remove("dz-started");
    },
    // Called when a file is added to the queue
    // Receives `file`
    addedfile: function(file) {
        var _this = this;
        if (this.element === this.previewsContainer) this.element.classList.add("dz-started");
        if (this.previewsContainer && !this.options.disablePreviews) {
            file.previewElement = $ab966853eba787d9$export$2e2bcd8739ae039.createElement(this.options.previewTemplate.trim());
            file.previewTemplate = file.previewElement; // Backwards compatibility
            this.previewsContainer.appendChild(file.previewElement);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = file.previewElement.querySelectorAll("[data-dz-name]")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var node = _step.value;
                    node.textContent = file.name;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = file.previewElement.querySelectorAll("[data-dz-size]")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    node = _step1.value;
                    node.innerHTML = this.filesize(file.size);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            if (this.options.addRemoveLinks) {
                file._removeLink = $ab966853eba787d9$export$2e2bcd8739ae039.createElement('<a class="dz-remove" href="javascript:undefined;" data-dz-remove>'.concat(this.options.dictRemoveFile, "</a>"));
                file.previewElement.appendChild(file._removeLink);
            }
            var removeFileEvent = function(e) {
                e.preventDefault();
                e.stopPropagation();
                if (file.status === $ab966853eba787d9$export$2e2bcd8739ae039.UPLOADING) return $ab966853eba787d9$export$2e2bcd8739ae039.confirm(_this.options.dictCancelUploadConfirmation, function() {
                    return _this.removeFile(file);
                });
                else {
                    if (_this.options.dictRemoveFileConfirmation) return $ab966853eba787d9$export$2e2bcd8739ae039.confirm(_this.options.dictRemoveFileConfirmation, function() {
                        return _this.removeFile(file);
                    });
                    else return _this.removeFile(file);
                }
            };
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = file.previewElement.querySelectorAll("[data-dz-remove]")[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var removeLink = _step2.value;
                    removeLink.addEventListener("click", removeFileEvent);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    },
    // Called whenever a file is removed.
    removedfile: function(file) {
        if (file.previewElement != null && file.previewElement.parentNode != null) file.previewElement.parentNode.removeChild(file.previewElement);
        return this._updateMaxFilesReachedClass();
    },
    // Called when a thumbnail has been generated
    // Receives `file` and `dataUrl`
    thumbnail: function(file, dataUrl) {
        if (file.previewElement) {
            file.previewElement.classList.remove("dz-file-preview");
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = file.previewElement.querySelectorAll("[data-dz-thumbnail]")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var thumbnailElement = _step.value;
                    thumbnailElement.alt = file.name;
                    thumbnailElement.src = dataUrl;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return setTimeout(function() {
                return file.previewElement.classList.add("dz-image-preview");
            }, 1);
        }
    },
    // Called whenever an error occurs
    // Receives `file` and `message`
    error: function(file, message) {
        if (file.previewElement) {
            file.previewElement.classList.add("dz-error");
            if (typeof message !== "string" && message.error) message = message.error;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = file.previewElement.querySelectorAll("[data-dz-errormessage]")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var node = _step.value;
                    node.textContent = message;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    },
    errormultiple: function() {},
    // Called when a file gets processed. Since there is a cue, not all added
    // files are processed immediately.
    // Receives `file`
    processing: function(file) {
        if (file.previewElement) {
            file.previewElement.classList.add("dz-processing");
            if (file._removeLink) return file._removeLink.innerHTML = this.options.dictCancelUpload;
        }
    },
    processingmultiple: function() {},
    // Called whenever the upload progress gets updated.
    // Receives `file`, `progress` (percentage 0-100) and `bytesSent`.
    // To get the total number of bytes of the file, use `file.size`
    uploadprogress: function(file, progress, bytesSent) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (file.previewElement) try {
            for(var _iterator = file.previewElement.querySelectorAll("[data-dz-uploadprogress]")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                node.nodeName === "PROGRESS" ? node.value = progress : node.style.width = "".concat(progress, "%");
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    },
    // Called whenever the total upload progress gets updated.
    // Called with totalUploadProgress (0-100), totalBytes and totalBytesSent
    totaluploadprogress: function() {},
    // Called just before the file is sent. Gets the `xhr` object as second
    // parameter, so you can modify it (for example to add a CSRF token) and a
    // `formData` object to add additional information.
    sending: function() {},
    sendingmultiple: function() {},
    // When the complete upload is finished and successful
    // Receives `file`
    success: function(file) {
        if (file.previewElement) return file.previewElement.classList.add("dz-success");
    },
    successmultiple: function() {},
    // When the upload is canceled.
    canceled: function(file) {
        return this.emit("error", file, this.options.dictUploadCanceled);
    },
    canceledmultiple: function() {},
    // When the upload is finished, either with success or an error.
    // Receives `file`
    complete: function(file) {
        if (file._removeLink) file._removeLink.innerHTML = this.options.dictRemoveFile;
        if (file.previewElement) return file.previewElement.classList.add("dz-complete");
    },
    completemultiple: function() {},
    maxfilesexceeded: function() {},
    maxfilesreached: function() {},
    queuecomplete: function() {},
    addedfiles: function() {}
};
var $ab966853eba787d9$var$$4ca367182776f80b$export$2e2bcd8739ae039 = $ab966853eba787d9$var$$4ca367182776f80b$var$defaultOptions;
var $ab966853eba787d9$export$2e2bcd8739ae039 = /*#__PURE__*/ function($4040acfd8584338d$export$2e2bcd8739ae0391) {
    "use strict";
    (0, $iNfU4._)($3ed269f2f0fb224b$export$2e2bcd8739ae039, $4040acfd8584338d$export$2e2bcd8739ae0391);
    var _super = (0, $k1NN5._)($3ed269f2f0fb224b$export$2e2bcd8739ae039);
    function $3ed269f2f0fb224b$export$2e2bcd8739ae039(el, options) {
        (0, $19mwo._)(this, $3ed269f2f0fb224b$export$2e2bcd8739ae039);
        var _this;
        _this = _super.call(this);
        var fallback, left;
        _this.element = el;
        _this.clickableElements = [];
        _this.listeners = [];
        _this.files = []; // All files
        if (typeof _this.element === "string") _this.element = document.querySelector(_this.element);
        // Not checking if instance of HTMLElement or Element since IE9 is extremely weird.
        if (!_this.element || _this.element.nodeType == null) throw new Error("Invalid dropzone element.");
        if (_this.element.dropzone) throw new Error("Dropzone already attached.");
        // Now add this dropzone to the instances.
        $3ed269f2f0fb224b$export$2e2bcd8739ae039.instances.push((0, $15Pju._)(_this));
        // Put the dropzone inside the element itself.
        _this.element.dropzone = (0, $15Pju._)(_this);
        var elementOptions = (left = $3ed269f2f0fb224b$export$2e2bcd8739ae039.optionsForElement(_this.element)) != null ? left : {};
        _this.options = (0, $a41e6e7bc323dc7d$export$2e2bcd8739ae039)(true, {}, $ab966853eba787d9$var$$4ca367182776f80b$export$2e2bcd8739ae039, elementOptions, options != null ? options : {});
        _this.options.previewTemplate = _this.options.previewTemplate.replace(/\n*/g, "");
        // If the browser failed, just call the fallback and leave
        if (_this.options.forceFallback || !$3ed269f2f0fb224b$export$2e2bcd8739ae039.isBrowserSupported()) return (0, $hSCyS._)(_this, _this.options.fallback.call((0, $15Pju._)(_this)));
        // @options.url = @element.getAttribute "action" unless @options.url?
        if (_this.options.url == null) _this.options.url = _this.element.getAttribute("action");
        if (!_this.options.url) throw new Error("No URL provided.");
        if (_this.options.acceptedFiles && _this.options.acceptedMimeTypes) throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
        if (_this.options.uploadMultiple && _this.options.chunking) throw new Error("You cannot set both: uploadMultiple and chunking.");
        if (_this.options.binaryBody && _this.options.uploadMultiple) throw new Error("You cannot set both: binaryBody and uploadMultiple.");
        // Backwards compatibility
        if (_this.options.acceptedMimeTypes) {
            _this.options.acceptedFiles = _this.options.acceptedMimeTypes;
            delete _this.options.acceptedMimeTypes;
        }
        // Backwards compatibility
        if (_this.options.renameFilename != null) _this.options.renameFile = function(file) {
            return _this.options.renameFilename.call((0, $15Pju._)(_this), file.name, file);
        };
        if (typeof _this.options.method === "string") _this.options.method = _this.options.method.toUpperCase();
        if ((fallback = _this.getExistingFallback()) && fallback.parentNode) fallback.parentNode.removeChild(fallback);
        // Display previews in the previewsContainer element or the Dropzone element unless explicitly set to false
        if (_this.options.previewsContainer !== false) {
            if (_this.options.previewsContainer) _this.previewsContainer = $3ed269f2f0fb224b$export$2e2bcd8739ae039.getElement(_this.options.previewsContainer, "previewsContainer");
            else _this.previewsContainer = _this.element;
        }
        if (_this.options.clickable) {
            if (_this.options.clickable === true) _this.clickableElements = [
                _this.element
            ];
            else _this.clickableElements = $3ed269f2f0fb224b$export$2e2bcd8739ae039.getElements(_this.options.clickable, "clickable");
        }
        _this.init();
        return _this;
    }
    (0, $6rpfc._)($3ed269f2f0fb224b$export$2e2bcd8739ae039, [
        {
            // Returns all files that have been accepted
            key: "getAcceptedFiles",
            value: function getAcceptedFiles() {
                return this.files.filter(function(file) {
                    return file.accepted;
                }).map(function(file) {
                    return file;
                });
            }
        },
        {
            // Returns all files that have been rejected
            // Not sure when that's going to be useful, but added for completeness.
            key: "getRejectedFiles",
            value: function getRejectedFiles() {
                return this.files.filter(function(file) {
                    return !file.accepted;
                }).map(function(file) {
                    return file;
                });
            }
        },
        {
            key: "getFilesWithStatus",
            value: function getFilesWithStatus(status) {
                return this.files.filter(function(file) {
                    return file.status === status;
                }).map(function(file) {
                    return file;
                });
            }
        },
        {
            // Returns all files that are in the queue
            key: "getQueuedFiles",
            value: function getQueuedFiles() {
                return this.getFilesWithStatus($3ed269f2f0fb224b$export$2e2bcd8739ae039.QUEUED);
            }
        },
        {
            key: "getUploadingFiles",
            value: function getUploadingFiles() {
                return this.getFilesWithStatus($3ed269f2f0fb224b$export$2e2bcd8739ae039.UPLOADING);
            }
        },
        {
            key: "getAddedFiles",
            value: function getAddedFiles() {
                return this.getFilesWithStatus($3ed269f2f0fb224b$export$2e2bcd8739ae039.ADDED);
            }
        },
        {
            // Files that are either queued or uploading
            key: "getActiveFiles",
            value: function getActiveFiles() {
                return this.files.filter(function(file) {
                    return file.status === $3ed269f2f0fb224b$export$2e2bcd8739ae039.UPLOADING || file.status === $3ed269f2f0fb224b$export$2e2bcd8739ae039.QUEUED;
                }).map(function(file) {
                    return file;
                });
            }
        },
        {
            // The function that gets called when Dropzone is initialized. You
            // can (and should) setup event listeners inside this function.
            key: "init",
            value: function init() {
                var _this = this;
                // In case it isn't set already
                if (this.element.tagName === "form") this.element.setAttribute("enctype", "multipart/form-data");
                if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) this.element.appendChild($3ed269f2f0fb224b$export$2e2bcd8739ae039.createElement('<div class="dz-default dz-message"><button class="dz-button" type="button">'.concat(this.options.dictDefaultMessage, "</button></div>")));
                if (this.clickableElements.length) {
                    var setupHiddenFileInput = function() {
                        if (_this.hiddenFileInput) _this.hiddenFileInput.parentNode.removeChild(_this.hiddenFileInput);
                        _this.hiddenFileInput = document.createElement("input");
                        _this.hiddenFileInput.setAttribute("type", "file");
                        if (_this.options.maxFiles === null || _this.options.maxFiles > 1) _this.hiddenFileInput.setAttribute("multiple", "multiple");
                        _this.hiddenFileInput.className = "dz-hidden-input";
                        if (_this.options.acceptedFiles !== null) _this.hiddenFileInput.setAttribute("accept", _this.options.acceptedFiles);
                        if (_this.options.capture !== null) _this.hiddenFileInput.setAttribute("capture", _this.options.capture);
                        // Making sure that no one can "tab" into this field.
                        _this.hiddenFileInput.setAttribute("tabindex", "-1");
                        // Not setting `display="none"` because some browsers don't accept clicks
                        // on elements that aren't displayed.
                        _this.hiddenFileInput.style.visibility = "hidden";
                        _this.hiddenFileInput.style.position = "absolute";
                        _this.hiddenFileInput.style.top = "0";
                        _this.hiddenFileInput.style.left = "0";
                        _this.hiddenFileInput.style.height = "0";
                        _this.hiddenFileInput.style.width = "0";
                        $3ed269f2f0fb224b$export$2e2bcd8739ae039.getElement(_this.options.hiddenInputContainer, "hiddenInputContainer").appendChild(_this.hiddenFileInput);
                        _this.hiddenFileInput.addEventListener("change", function() {
                            var _this_hiddenFileInput = _this.hiddenFileInput, files = _this_hiddenFileInput.files;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            if (files.length) try {
                                for(var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var file = _step.value;
                                    _this.addFile(file);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            _this.emit("addedfiles", files);
                            setupHiddenFileInput();
                        });
                    };
                    setupHiddenFileInput();
                }
                this.URL = window.URL !== null ? window.URL : window.webkitURL;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Setup all event listeners on the Dropzone object itself.
                    // They're not in @setupEventListeners() because they shouldn't be removed
                    // again when the dropzone gets disabled.
                    for(var _iterator = this.events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var eventName = _step.value;
                        this.on(eventName, this.options[eventName]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.on("uploadprogress", function() {
                    return _this.updateTotalUploadProgress();
                });
                this.on("removedfile", function() {
                    return _this.updateTotalUploadProgress();
                });
                this.on("canceled", function(file) {
                    return _this.emit("complete", file);
                });
                // Emit a `queuecomplete` event if all files finished uploading.
                this.on("complete", function(file) {
                    if (_this.getAddedFiles().length === 0 && _this.getUploadingFiles().length === 0 && _this.getQueuedFiles().length === 0) return setTimeout(function() {
                        return _this.emit("queuecomplete");
                    }, 0);
                });
                var containsFiles = function containsFiles(e) {
                    if (e.dataTransfer.types) // IE, we need to iterate like this instead of
                    // using e.dataTransfer.types.some()
                    for(var i = 0; i < e.dataTransfer.types.length; i++){
                        if (e.dataTransfer.types[i] === "Files") return true;
                    }
                    return false;
                };
                var noPropagation = function noPropagation(e) {
                    // If there are no files, we don't want to stop
                    // propagation so we don't interfere with other
                    // drag and drop behaviour.
                    if (!containsFiles(e)) return;
                    e.stopPropagation();
                    if (e.preventDefault) return e.preventDefault();
                    else return e.returnValue = false;
                };
                // Create the listeners
                this.listeners = [
                    {
                        element: this.element,
                        events: {
                            dragstart: function(e) {
                                return _this.emit("dragstart", e);
                            },
                            dragenter: function(e) {
                                noPropagation(e);
                                return _this.emit("dragenter", e);
                            },
                            dragover: function(e) {
                                // Makes it possible to drag files from chrome's download bar
                                // http://stackoverflow.com/questions/19526430/drag-and-drop-file-uploads-from-chrome-downloads-bar
                                // Try is required to prevent bug in Internet Explorer 11 (SCRIPT65535 exception)
                                var efct;
                                try {
                                    efct = e.dataTransfer.effectAllowed;
                                } catch (error) {}
                                e.dataTransfer.dropEffect = "move" === efct || "linkMove" === efct ? "move" : "copy";
                                noPropagation(e);
                                return _this.emit("dragover", e);
                            },
                            dragleave: function(e) {
                                return _this.emit("dragleave", e);
                            },
                            drop: function(e) {
                                noPropagation(e);
                                return _this.drop(e);
                            },
                            dragend: function(e) {
                                return _this.emit("dragend", e);
                            }
                        }
                    }
                ];
                this.clickableElements.forEach(function(clickableElement) {
                    return _this.listeners.push({
                        element: clickableElement,
                        events: {
                            click: function(evt) {
                                // Only the actual dropzone or the message element should trigger file selection
                                if (clickableElement !== _this.element || evt.target === _this.element || $3ed269f2f0fb224b$export$2e2bcd8739ae039.elementInside(evt.target, _this.element.querySelector(".dz-message"))) _this.hiddenFileInput.click(); // Forward the click
                                return true;
                            }
                        }
                    });
                });
                this.enable();
                return this.options.init.call(this);
            }
        },
        {
            // Not fully tested yet
            key: "destroy",
            value: function destroy() {
                this.disable();
                this.removeAllFiles(true);
                if (this.hiddenFileInput != null ? this.hiddenFileInput.parentNode : undefined) {
                    this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
                    this.hiddenFileInput = null;
                }
                delete this.element.dropzone;
                return $3ed269f2f0fb224b$export$2e2bcd8739ae039.instances.splice($3ed269f2f0fb224b$export$2e2bcd8739ae039.instances.indexOf(this), 1);
            }
        },
        {
            key: "updateTotalUploadProgress",
            value: function updateTotalUploadProgress() {
                var totalUploadProgress;
                var totalBytesSent = 0;
                var totalBytes = 0;
                var activeFiles = this.getActiveFiles();
                if (activeFiles.length) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.getActiveFiles()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var file = _step.value;
                            totalBytesSent += file.upload.bytesSent;
                            totalBytes += file.upload.total;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    totalUploadProgress = 100 * totalBytesSent / totalBytes;
                } else totalUploadProgress = 100;
                return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
            }
        },
        {
            // @options.paramName can be a function taking one parameter rather than a string.
            // A parameter name for a file is obtained simply by calling this with an index number.
            key: "_getParamName",
            value: function _getParamName(n) {
                if (typeof this.options.paramName === "function") return this.options.paramName(n);
                else return "".concat(this.options.paramName).concat(this.options.uploadMultiple ? "[".concat(n, "]") : "");
            }
        },
        {
            // If @options.renameFile is a function,
            // the function will be used to rename the file.name before appending it to the formData
            key: "_renameFile",
            value: function _renameFile(file) {
                if (typeof this.options.renameFile !== "function") return file.name;
                return this.options.renameFile(file);
            }
        },
        {
            // Returns a form that can be used as fallback if the browser does not support DragnDrop
            //
            // If the dropzone is already a form, only the input field and button are returned. Otherwise a complete form element is provided.
            // This code has to pass in IE7 :(
            key: "getFallbackForm",
            value: function getFallbackForm() {
                var existingFallback, form;
                if (existingFallback = this.getExistingFallback()) return existingFallback;
                var fieldsString = '<div class="dz-fallback">';
                if (this.options.dictFallbackText) fieldsString += "<p>".concat(this.options.dictFallbackText, "</p>");
                fieldsString += '<input type="file" name="'.concat(this._getParamName(0), '" ').concat(this.options.uploadMultiple ? 'multiple="multiple"' : undefined, ' /><input type="submit" value="Upload!"></div>');
                var fields = $3ed269f2f0fb224b$export$2e2bcd8739ae039.createElement(fieldsString);
                if (this.element.tagName !== "FORM") {
                    form = $3ed269f2f0fb224b$export$2e2bcd8739ae039.createElement('<form action="'.concat(this.options.url, '" enctype="multipart/form-data" method="').concat(this.options.method, '"></form>'));
                    form.appendChild(fields);
                } else {
                    // Make sure that the enctype and method attributes are set properly
                    this.element.setAttribute("enctype", "multipart/form-data");
                    this.element.setAttribute("method", this.options.method);
                }
                return form != null ? form : fields;
            }
        },
        {
            // Returns the fallback elements if they exist already
            //
            // This code has to pass in IE7 :(
            key: "getExistingFallback",
            value: function getExistingFallback() {
                var getFallback = function getFallback(elements) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var el = _step.value;
                            if (/(^| )fallback($| )/.test(el.className)) return el;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                };
                for(var _i = 0, _iter = [
                    "div",
                    "form"
                ]; _i < _iter.length; _i++){
                    var tagName = _iter[_i];
                    var fallback;
                    if (fallback = getFallback(this.element.getElementsByTagName(tagName))) return fallback;
                }
            }
        },
        {
            // Activates all listeners stored in @listeners
            key: "setupEventListeners",
            value: function setupEventListeners() {
                return this.listeners.map(function(elementListeners) {
                    return function() {
                        var result = [];
                        for(var event in elementListeners.events){
                            var listener = elementListeners.events[event];
                            result.push(elementListeners.element.addEventListener(event, listener, false));
                        }
                        return result;
                    }();
                });
            }
        },
        {
            // Deactivates all listeners stored in @listeners
            key: "removeEventListeners",
            value: function removeEventListeners() {
                return this.listeners.map(function(elementListeners) {
                    return function() {
                        var result = [];
                        for(var event in elementListeners.events){
                            var listener = elementListeners.events[event];
                            result.push(elementListeners.element.removeEventListener(event, listener, false));
                        }
                        return result;
                    }();
                });
            }
        },
        {
            // Removes all event listeners and cancels all files in the queue or being processed.
            key: "disable",
            value: function disable() {
                var _this = this;
                this.clickableElements.forEach(function(element) {
                    return element.classList.remove("dz-clickable");
                });
                this.removeEventListeners();
                this.disabled = true;
                return this.files.map(function(file) {
                    return _this.cancelUpload(file);
                });
            }
        },
        {
            key: "enable",
            value: function enable() {
                delete this.disabled;
                this.clickableElements.forEach(function(element) {
                    return element.classList.add("dz-clickable");
                });
                return this.setupEventListeners();
            }
        },
        {
            // Returns a nicely formatted filesize
            key: "filesize",
            value: function filesize(size) {
                var selectedSize = 0;
                var selectedUnit = "b";
                if (size > 0) {
                    var units = [
                        "tb",
                        "gb",
                        "mb",
                        "kb",
                        "b"
                    ];
                    for(var i = 0; i < units.length; i++){
                        var unit = units[i];
                        var cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
                        if (size >= cutoff) {
                            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
                            selectedUnit = unit;
                            break;
                        }
                    }
                    selectedSize = Math.round(10 * selectedSize) / 10; // Cutting of digits
                }
                return "<strong>".concat(selectedSize, "</strong> ").concat(this.options.dictFileSizeUnits[selectedUnit]);
            }
        },
        {
            // Adds or removes the `dz-max-files-reached` class from the form.
            key: "_updateMaxFilesReachedClass",
            value: function _updateMaxFilesReachedClass() {
                if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
                    if (this.getAcceptedFiles().length === this.options.maxFiles) this.emit("maxfilesreached", this.files);
                    return this.element.classList.add("dz-max-files-reached");
                } else return this.element.classList.remove("dz-max-files-reached");
            }
        },
        {
            key: "drop",
            value: function drop(e) {
                if (!e.dataTransfer) return;
                this.emit("drop", e);
                // Convert the FileList to an Array
                // This is necessary for IE11
                var files = [];
                for(var i = 0; i < e.dataTransfer.files.length; i++)files[i] = e.dataTransfer.files[i];
                // Even if it's a folder, files.length will contain the folders.
                if (files.length) {
                    var _e_dataTransfer = e.dataTransfer, items = _e_dataTransfer.items;
                    if (items && items.length && items[0].webkitGetAsEntry != null) this._addFilesFromItems(items);
                    else this.handleFiles(files);
                }
                this.emit("addedfiles", files);
            }
        },
        {
            key: "paste",
            value: function paste(e) {
                if ($ab966853eba787d9$var$$3ed269f2f0fb224b$var$__guard__(e != null ? e.clipboardData : undefined, function(x) {
                    return x.items;
                }) == null) return;
                this.emit("paste", e);
                var _e_clipboardData = e.clipboardData, items = _e_clipboardData.items;
                if (items.length) return this._addFilesFromItems(items);
            }
        },
        {
            key: "handleFiles",
            value: function handleFiles(files) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var file = _step.value;
                        this.addFile(file);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            // When a folder is dropped (or files are pasted), items must be handled
            // instead of files.
            key: "_addFilesFromItems",
            value: function _addFilesFromItems(items) {
                var _this = this;
                return function() {
                    var result = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var item = _step.value;
                            var entry;
                            if (item.webkitGetAsEntry != null && (entry = item.webkitGetAsEntry())) {
                                if (entry.isFile) result.push(_this.addFile(item.getAsFile()));
                                else if (entry.isDirectory) result.push(_this._addFilesFromDirectory(entry, entry.name));
                                else result.push(undefined);
                            } else if (item.getAsFile != null) {
                                if (item.kind == null || item.kind === "file") result.push(_this.addFile(item.getAsFile()));
                                else result.push(undefined);
                            } else result.push(undefined);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return result;
                }();
            }
        },
        {
            // Goes through the directory, and adds each file it finds recursively
            key: "_addFilesFromDirectory",
            value: function _addFilesFromDirectory(directory, path) {
                var _this = this;
                var dirReader = directory.createReader();
                var errorHandler = function(error) {
                    return $ab966853eba787d9$var$$3ed269f2f0fb224b$var$__guardMethod__(console, "log", function(o) {
                        return o.log(error);
                    });
                };
                var readEntries = function() {
                    return dirReader.readEntries(function(entries) {
                        if (entries.length > 0) {
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var entry = _step.value;
                                    if (entry.isFile) entry.file(function(file) {
                                        if (_this.options.ignoreHiddenFiles && file.name.substring(0, 1) === ".") return;
                                        file.fullPath = "".concat(path, "/").concat(file.name);
                                        return _this.addFile(file);
                                    });
                                    else if (entry.isDirectory) _this._addFilesFromDirectory(entry, "".concat(path, "/").concat(entry.name));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            // Recursively call readEntries() again, since browser only handle
                            // the first 100 entries.
                            // See: https://developer.mozilla.org/en-US/docs/Web/API/DirectoryReader#readEntries
                            readEntries();
                        }
                        return null;
                    }, errorHandler);
                };
                return readEntries();
            }
        },
        {
            // If `done()` is called without argument the file is accepted
            // If you call it with an error message, the file is rejected
            // (This allows for asynchronous validation)
            //
            // This function checks the filesize, and if the file.type passes the
            // `acceptedFiles` check.
            key: "accept",
            value: function accept(file, done) {
                if (this.options.maxFilesize && file.size > this.options.maxFilesize * 1048576) done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
                else if (!$3ed269f2f0fb224b$export$2e2bcd8739ae039.isValidFile(file, this.options.acceptedFiles)) done(this.options.dictInvalidFileType);
                else if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
                    done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
                    this.emit("maxfilesexceeded", file);
                } else this.options.accept.call(this, file, done);
            }
        },
        {
            key: "addFile",
            value: function addFile(file) {
                var _this = this;
                file.upload = {
                    uuid: $3ed269f2f0fb224b$export$2e2bcd8739ae039.uuidv4(),
                    progress: 0,
                    // Setting the total upload size to file.size for the beginning
                    // It's actual different than the size to be transmitted.
                    total: file.size,
                    bytesSent: 0,
                    filename: this._renameFile(file)
                };
                this.files.push(file);
                file.status = $3ed269f2f0fb224b$export$2e2bcd8739ae039.ADDED;
                this.emit("addedfile", file);
                this._enqueueThumbnail(file);
                this.accept(file, function(error) {
                    if (error) {
                        file.accepted = false;
                        _this._errorProcessing([
                            file
                        ], error); // Will set the file.status
                    } else {
                        file.accepted = true;
                        if (_this.options.autoQueue) _this.enqueueFile(file);
                    // Will set .accepted = true
                    }
                    _this._updateMaxFilesReachedClass();
                });
            }
        },
        {
            // Wrapper for enqueueFile
            key: "enqueueFiles",
            value: function enqueueFiles(files) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var file = _step.value;
                        this.enqueueFile(file);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return null;
            }
        },
        {
            key: "enqueueFile",
            value: function enqueueFile(file) {
                var _this = this;
                if (file.status === $3ed269f2f0fb224b$export$2e2bcd8739ae039.ADDED && file.accepted === true) {
                    file.status = $3ed269f2f0fb224b$export$2e2bcd8739ae039.QUEUED;
                    if (this.options.autoProcessQueue) return setTimeout(function() {
                        return _this.processQueue();
                    }, 0); // Deferring the call
                } else throw new Error("This file can't be queued because it has already been processed or was rejected.");
            }
        },
        {
            key: "_enqueueThumbnail",
            value: function _enqueueThumbnail(file) {
                var _this = this;
                if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1048576) {
                    this._thumbnailQueue.push(file);
                    return setTimeout(function() {
                        return _this._processThumbnailQueue();
                    }, 0); // Deferring the call
                }
            }
        },
        {
            key: "_processThumbnailQueue",
            value: function _processThumbnailQueue() {
                var _this = this;
                if (this._processingThumbnail || this._thumbnailQueue.length === 0) return;
                this._processingThumbnail = true;
                var file = this._thumbnailQueue.shift();
                return this.createThumbnail(file, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, true, function(dataUrl) {
                    _this.emit("thumbnail", file, dataUrl);
                    _this._processingThumbnail = false;
                    return _this._processThumbnailQueue();
                });
            }
        },
        {
            // Can be called by the user to remove a file
            key: "removeFile",
            value: function removeFile(file) {
                if (file.status === $3ed269f2f0fb224b$export$2e2bcd8739ae039.UPLOADING) this.cancelUpload(file);
                this.files = $ab966853eba787d9$var$$3ed269f2f0fb224b$var$without(this.files, file);
                this.emit("removedfile", file);
                if (this.files.length === 0) return this.emit("reset");
            }
        },
        {
            // Removes all files that aren't currently processed from the list
            key: "removeAllFiles",
            value: function removeAllFiles(cancelIfNecessary) {
                // Create a copy of files since removeFile() changes the @files array.
                if (cancelIfNecessary == null) cancelIfNecessary = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.files.slice()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var file = _step.value;
                        if (file.status !== $3ed269f2f0fb224b$export$2e2bcd8739ae039.UPLOADING || cancelIfNecessary) this.removeFile(file);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return null;
            }
        },
        {
            // Resizes an image before it gets sent to the server. This function is the default behavior of
            // `options.transformFile` if `resizeWidth` or `resizeHeight` are set. The callback is invoked with
            // the resized blob.
            key: "resizeImage",
            value: function resizeImage(file, width, height, resizeMethod, callback) {
                var _this = this;
                return this.createThumbnail(file, width, height, resizeMethod, true, function(dataUrl, canvas) {
                    if (canvas == null) return callback(file);
                    else {
                        var _this_options = _this.options, resizeMimeType = _this_options.resizeMimeType;
                        if (resizeMimeType == null) resizeMimeType = file.type;
                        var resizedDataURL = canvas.toDataURL(resizeMimeType, _this.options.resizeQuality);
                        if (resizeMimeType === "image/jpeg" || resizeMimeType === "image/jpg") resizedDataURL = $ab966853eba787d9$var$$3ed269f2f0fb224b$var$ExifRestore.restore(file.dataURL, resizedDataURL);
                        return callback($3ed269f2f0fb224b$export$2e2bcd8739ae039.dataURItoBlob(resizedDataURL));
                    }
                });
            }
        },
        {
            key: "createThumbnail",
            value: function createThumbnail(file, width, height, resizeMethod, fixOrientation, callback) {
                var _this = this;
                var fileReader = new FileReader();
                fileReader.onload = function() {
                    file.dataURL = fileReader.result;
                    // Don't bother creating a thumbnail for SVG images since they're vector
                    if (file.type === "image/svg+xml") {
                        if (callback != null) callback(fileReader.result);
                        return;
                    }
                    _this.createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback);
                };
                fileReader.readAsDataURL(file);
            }
        },
        {
            // `mockFile` needs to have these attributes:
            //
            //     { name: 'name', size: 12345, imageUrl: '' }
            //
            // `callback` will be invoked when the image has been downloaded and displayed.
            // `crossOrigin` will be added to the `img` tag when accessing the file.
            key: "displayExistingFile",
            value: function displayExistingFile(mockFile, imageUrl, callback, crossOrigin) {
                var _this = this;
                var resizeThumbnail = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
                this.emit("addedfile", mockFile);
                this.emit("complete", mockFile);
                if (!resizeThumbnail) {
                    this.emit("thumbnail", mockFile, imageUrl);
                    if (callback) callback();
                } else {
                    var onDone = function(thumbnail) {
                        _this.emit("thumbnail", mockFile, thumbnail);
                        if (callback) callback();
                    };
                    mockFile.dataURL = imageUrl;
                    this.createThumbnailFromUrl(mockFile, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, this.options.fixOrientation, onDone, crossOrigin);
                }
            }
        },
        {
            key: "createThumbnailFromUrl",
            value: function createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback, crossOrigin) {
                var _this = this;
                // Not using `new Image` here because of a bug in latest Chrome versions.
                // See https://github.com/enyo/dropzone/pull/226
                var img = document.createElement("img");
                if (crossOrigin) img.crossOrigin = crossOrigin;
                // fixOrientation is not needed anymore with browsers handling imageOrientation
                fixOrientation = getComputedStyle(document.body)["imageOrientation"] == "from-image" ? false : fixOrientation;
                img.onload = function() {
                    var loadExif = function(callback) {
                        return callback(1);
                    };
                    if (typeof EXIF !== "undefined" && EXIF !== null && fixOrientation) loadExif = function(callback) {
                        return EXIF.getData(img, function() {
                            return callback(EXIF.getTag(this, "Orientation"));
                        });
                    };
                    return loadExif(function(orientation) {
                        file.width = img.width;
                        file.height = img.height;
                        var resizeInfo = _this.options.resize.call(_this, file, width, height, resizeMethod);
                        var canvas = document.createElement("canvas");
                        var ctx = canvas.getContext("2d");
                        canvas.width = resizeInfo.trgWidth;
                        canvas.height = resizeInfo.trgHeight;
                        if (orientation > 4) {
                            canvas.width = resizeInfo.trgHeight;
                            canvas.height = resizeInfo.trgWidth;
                        }
                        switch(orientation){
                            case 2:
                                // horizontal flip
                                ctx.translate(canvas.width, 0);
                                ctx.scale(-1, 1);
                                break;
                            case 3:
                                // 180° rotate left
                                ctx.translate(canvas.width, canvas.height);
                                ctx.rotate(Math.PI);
                                break;
                            case 4:
                                // vertical flip
                                ctx.translate(0, canvas.height);
                                ctx.scale(1, -1);
                                break;
                            case 5:
                                // vertical flip + 90 rotate right
                                ctx.rotate(0.5 * Math.PI);
                                ctx.scale(1, -1);
                                break;
                            case 6:
                                // 90° rotate right
                                ctx.rotate(0.5 * Math.PI);
                                ctx.translate(0, -canvas.width);
                                break;
                            case 7:
                                // horizontal flip + 90 rotate right
                                ctx.rotate(0.5 * Math.PI);
                                ctx.translate(canvas.height, -canvas.width);
                                ctx.scale(-1, 1);
                                break;
                            case 8:
                                // 90° rotate left
                                ctx.rotate(-0.5 * Math.PI);
                                ctx.translate(-canvas.height, 0);
                                break;
                        }
                        // This is a bugfix for iOS' scaling bug.
                        $ab966853eba787d9$var$$3ed269f2f0fb224b$var$drawImageIOSFix(ctx, img, resizeInfo.srcX != null ? resizeInfo.srcX : 0, resizeInfo.srcY != null ? resizeInfo.srcY : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, resizeInfo.trgX != null ? resizeInfo.trgX : 0, resizeInfo.trgY != null ? resizeInfo.trgY : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
                        var thumbnail = canvas.toDataURL("image/png");
                        if (callback != null) return callback(thumbnail, canvas);
                    });
                };
                if (callback != null) img.onerror = callback;
                return img.src = file.dataURL;
            }
        },
        {
            // Goes through the queue and processes files if there aren't too many already.
            key: "processQueue",
            value: function processQueue() {
                var _this_options = this.options, parallelUploads = _this_options.parallelUploads;
                var processingLength = this.getUploadingFiles().length;
                var i = processingLength;
                // There are already at least as many files uploading than should be
                if (processingLength >= parallelUploads) return;
                var queuedFiles = this.getQueuedFiles();
                if (!(queuedFiles.length > 0)) return;
                if (this.options.uploadMultiple) return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
                else while(i < parallelUploads){
                    if (!queuedFiles.length) return;
                    // Nothing left to process
                    this.processFile(queuedFiles.shift());
                    i++;
                }
            }
        },
        {
            // Wrapper for `processFiles`
            key: "processFile",
            value: function processFile(file) {
                return this.processFiles([
                    file
                ]);
            }
        },
        {
            // Loads the file, then calls finishedLoading()
            key: "processFiles",
            value: function processFiles(files) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var file = _step.value;
                        file.processing = true; // Backwards compatibility
                        file.status = $3ed269f2f0fb224b$export$2e2bcd8739ae039.UPLOADING;
                        this.emit("processing", file);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this.options.uploadMultiple) this.emit("processingmultiple", files);
                return this.uploadFiles(files);
            }
        },
        {
            key: "_getFilesWithXhr",
            value: function _getFilesWithXhr(xhr) {
                var files;
                return files = this.files.filter(function(file) {
                    return file.xhr === xhr;
                }).map(function(file) {
                    return file;
                });
            }
        },
        {
            // Cancels the file upload and sets the status to CANCELED
            // **if** the file is actually being uploaded.
            // If it's still in the queue, the file is being removed from it and the status
            // set to CANCELED.
            key: "cancelUpload",
            value: function cancelUpload(file) {
                if (file.status === $3ed269f2f0fb224b$export$2e2bcd8739ae039.UPLOADING) {
                    var groupedFiles = this._getFilesWithXhr(file.xhr);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = groupedFiles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var groupedFile = _step.value;
                            groupedFile.status = $3ed269f2f0fb224b$export$2e2bcd8739ae039.CANCELED;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (typeof file.xhr !== "undefined") file.xhr.abort();
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = groupedFiles[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var groupedFile1 = _step1.value;
                            this.emit("canceled", groupedFile1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    if (this.options.uploadMultiple) this.emit("canceledmultiple", groupedFiles);
                } else if (file.status === $3ed269f2f0fb224b$export$2e2bcd8739ae039.ADDED || file.status === $3ed269f2f0fb224b$export$2e2bcd8739ae039.QUEUED) {
                    file.status = $3ed269f2f0fb224b$export$2e2bcd8739ae039.CANCELED;
                    this.emit("canceled", file);
                    if (this.options.uploadMultiple) this.emit("canceledmultiple", [
                        file
                    ]);
                }
                if (this.options.autoProcessQueue) return this.processQueue();
            }
        },
        {
            key: "resolveOption",
            value: function resolveOption(option) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (typeof option === "function") return option.apply(this, args);
                return option;
            }
        },
        {
            key: "uploadFile",
            value: function uploadFile(file) {
                return this.uploadFiles([
                    file
                ]);
            }
        },
        {
            key: "uploadFiles",
            value: function uploadFiles(files) {
                var _this = this;
                this._transformFiles(files, function(transformedFiles) {
                    if (_this.options.chunking) {
                        // Chunking is not allowed to be used with `uploadMultiple` so we know
                        // that there is only __one__file.
                        var transformedFile = transformedFiles[0];
                        files[0].upload.chunked = _this.options.chunking && (_this.options.forceChunking || transformedFile.size > _this.options.chunkSize);
                        files[0].upload.totalChunkCount = Math.ceil(transformedFile.size / _this.options.chunkSize);
                    }
                    if (files[0].upload.chunked) {
                        // This file should be sent in chunks!
                        // If the chunking option is set, we **know** that there can only be **one** file, since
                        // uploadMultiple is not allowed with this option.
                        var file = files[0];
                        var transformedFile1 = transformedFiles[0];
                        var startedChunkCount = 0;
                        file.upload.chunks = [];
                        var handleNextChunk = function() {
                            var chunkIndex = 0;
                            // Find the next item in file.upload.chunks that is not defined yet.
                            while(file.upload.chunks[chunkIndex] !== undefined)chunkIndex++;
                            // This means, that all chunks have already been started.
                            if (chunkIndex >= file.upload.totalChunkCount) return;
                            startedChunkCount++;
                            var start = chunkIndex * _this.options.chunkSize;
                            var end = Math.min(start + _this.options.chunkSize, transformedFile1.size);
                            var dataBlock = {
                                name: _this._getParamName(0),
                                data: transformedFile1.webkitSlice ? transformedFile1.webkitSlice(start, end) : transformedFile1.slice(start, end),
                                filename: file.upload.filename,
                                chunkIndex: chunkIndex
                            };
                            file.upload.chunks[chunkIndex] = {
                                file: file,
                                index: chunkIndex,
                                dataBlock: dataBlock,
                                status: $3ed269f2f0fb224b$export$2e2bcd8739ae039.UPLOADING,
                                progress: 0,
                                retries: 0
                            };
                            _this._uploadData(files, [
                                dataBlock
                            ]);
                        };
                        file.upload.finishedChunkUpload = function(chunk, response) {
                            var allFinished = true;
                            chunk.status = $3ed269f2f0fb224b$export$2e2bcd8739ae039.SUCCESS;
                            // Clear the data from the chunk
                            chunk.dataBlock = null;
                            chunk.response = chunk.xhr.responseText;
                            chunk.responseHeaders = chunk.xhr.getAllResponseHeaders();
                            // Leaving this reference to xhr will cause memory leaks.
                            chunk.xhr = null;
                            for(var i = 0; i < file.upload.totalChunkCount; i++){
                                if (file.upload.chunks[i] === undefined) return handleNextChunk();
                                if (file.upload.chunks[i].status !== $3ed269f2f0fb224b$export$2e2bcd8739ae039.SUCCESS) allFinished = false;
                            }
                            if (allFinished) _this.options.chunksUploaded(file, function() {
                                _this._finished(files, response, null);
                            });
                        };
                        if (_this.options.parallelChunkUploads) for(var i = 0; i < file.upload.totalChunkCount; i++)handleNextChunk();
                        else handleNextChunk();
                    } else {
                        var dataBlocks = [];
                        for(var i1 = 0; i1 < files.length; i1++)dataBlocks[i1] = {
                            name: _this._getParamName(i1),
                            data: transformedFiles[i1],
                            filename: files[i1].upload.filename
                        };
                        _this._uploadData(files, dataBlocks);
                    }
                });
            }
        },
        {
            /// Returns the right chunk for given file and xhr
            key: "_getChunk",
            value: function _getChunk(file, xhr) {
                for(var i = 0; i < file.upload.totalChunkCount; i++){
                    if (file.upload.chunks[i] !== undefined && file.upload.chunks[i].xhr === xhr) return file.upload.chunks[i];
                }
            }
        },
        {
            // This function actually uploads the file(s) to the server.
            //
            //  If dataBlocks contains the actual data to upload (meaning, that this could
            // either be transformed files, or individual chunks for chunked upload) then
            // they will be used for the actual data to upload.
            key: "_uploadData",
            value: function _uploadData(files, dataBlocks) {
                var _this = this;
                var xhr = new XMLHttpRequest();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Put the xhr object in the file objects to be able to reference it later.
                    for(var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var file = _step.value;
                        file.xhr = xhr;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (files[0].upload.chunked) // later, and found with _getChunk.
                files[0].upload.chunks[dataBlocks[0].chunkIndex].xhr = xhr;
                var method = this.resolveOption(this.options.method, files, dataBlocks);
                var url = this.resolveOption(this.options.url, files, dataBlocks);
                xhr.open(method, url, true);
                // Setting the timeout after open because of IE11 issue: https://gitlab.com/meno/dropzone/issues/8
                var timeout = this.resolveOption(this.options.timeout, files);
                if (timeout) xhr.timeout = this.resolveOption(this.options.timeout, files);
                // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
                xhr.withCredentials = !!this.options.withCredentials;
                xhr.onload = function(e) {
                    _this._finishedUploading(files, xhr, e);
                };
                xhr.ontimeout = function() {
                    _this._handleUploadError(files, xhr, "Request timedout after ".concat(_this.options.timeout / 1000, " seconds"));
                };
                xhr.onerror = function() {
                    _this._handleUploadError(files, xhr);
                };
                // Some browsers do not have the .upload property
                var progressObj = xhr.upload != null ? xhr.upload : xhr;
                progressObj.onprogress = function(e) {
                    return _this._updateFilesUploadProgress(files, xhr, e);
                };
                var headers = this.options.defaultHeaders ? {
                    Accept: "application/json",
                    "Cache-Control": "no-cache",
                    "X-Requested-With": "XMLHttpRequest"
                } : {};
                if (this.options.binaryBody) headers["Content-Type"] = files[0].type;
                if (this.options.headers) (0, $a41e6e7bc323dc7d$export$2e2bcd8739ae039)(headers, this.options.headers);
                for(var headerName in headers){
                    var headerValue = headers[headerName];
                    if (headerValue) xhr.setRequestHeader(headerName, headerValue);
                }
                if (this.options.binaryBody) {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        // Since the file is going to be sent as binary body, it doesn't make
                        // any sense to generate `FormData` for it.
                        for(var _iterator1 = files[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var file1 = _step1.value;
                            this.emit("sending", file1, xhr);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    if (this.options.uploadMultiple) this.emit("sendingmultiple", files, xhr);
                    this.submitRequest(xhr, null, files);
                } else {
                    var formData = new FormData();
                    // Adding all @options parameters
                    if (this.options.params) {
                        var additionalParams = this.options.params;
                        if (typeof additionalParams === "function") additionalParams = additionalParams.call(this, files, xhr, files[0].upload.chunked ? this._getChunk(files[0], xhr) : null);
                        for(var key in additionalParams){
                            var value = additionalParams[key];
                            if (Array.isArray(value)) // so lets iterate over it to attach each value
                            // individually.
                            for(var i = 0; i < value.length; i++)formData.append(key, value[i]);
                            else formData.append(key, value);
                        }
                    }
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        // Let the user add additional data if necessary
                        for(var _iterator2 = files[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var file2 = _step2.value;
                            this.emit("sending", file2, xhr, formData);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                    if (this.options.uploadMultiple) this.emit("sendingmultiple", files, xhr, formData);
                    this._addFormElementData(formData);
                    // Finally add the files
                    // Has to be last because some servers (eg: S3) expect the file to be the last parameter
                    for(var i1 = 0; i1 < dataBlocks.length; i1++){
                        var dataBlock = dataBlocks[i1];
                        formData.append(dataBlock.name, dataBlock.data, dataBlock.filename);
                    }
                    this.submitRequest(xhr, formData, files);
                }
            }
        },
        {
            // Transforms all files with this.options.transformFile and invokes done with the transformed files when done.
            key: "_transformFiles",
            value: function _transformFiles(files, done) {
                var _this = this, _loop = function(i) {
                    _this.options.transformFile.call(_this, files[i], function(transformedFile) {
                        transformedFiles[i] = transformedFile;
                        if (++doneCounter === files.length) done(transformedFiles);
                    });
                };
                var transformedFiles = [];
                // Clumsy way of handling asynchronous calls, until I get to add a proper Future library.
                var doneCounter = 0;
                for(var i = 0; i < files.length; i++)_loop(i);
            }
        },
        {
            // Takes care of adding other input elements of the form to the AJAX request
            key: "_addFormElementData",
            value: function _addFormElementData(formData) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // Take care of other input elements
                if (this.element.tagName === "FORM") try {
                    for(var _iterator = this.element.querySelectorAll("input, textarea, select, button")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var input = _step.value;
                        var inputName = input.getAttribute("name");
                        var inputType = input.getAttribute("type");
                        if (inputType) inputType = inputType.toLowerCase();
                        // If the input doesn't have a name, we can't use it.
                        if (typeof inputName === "undefined" || inputName === null) continue;
                        if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                // Possibly multiple values
                                for(var _iterator1 = input.options[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var option = _step1.value;
                                    if (option.selected) formData.append(inputName, option.value);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        } else if (!inputType || inputType !== "checkbox" && inputType !== "radio" || input.checked) formData.append(inputName, input.value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            // Invoked when there is new progress information about given files.
            // If e is not provided, it is assumed that the upload is finished.
            key: "_updateFilesUploadProgress",
            value: function _updateFilesUploadProgress(files, xhr, e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (!files[0].upload.chunked) try {
                    for(var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var file = _step.value;
                        if (file.upload.total && file.upload.bytesSent && file.upload.bytesSent == file.upload.total) continue;
                        if (e) {
                            file.upload.progress = 100 * e.loaded / e.total;
                            file.upload.total = e.total;
                            file.upload.bytesSent = e.loaded;
                        } else {
                            // No event, so we're at 100%
                            file.upload.progress = 100;
                            file.upload.bytesSent = file.upload.total;
                        }
                        this.emit("uploadprogress", file, file.upload.progress, file.upload.bytesSent);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                else {
                    // Handle chunked file uploads
                    // Chunked upload is not compatible with uploading multiple files in one
                    // request, so we know there's only one file.
                    var file1 = files[0];
                    // Since this is a chunked upload, we need to update the appropriate chunk
                    // progress.
                    var chunk = this._getChunk(file1, xhr);
                    if (e) {
                        chunk.progress = 100 * e.loaded / e.total;
                        chunk.total = e.total;
                        chunk.bytesSent = e.loaded;
                    } else {
                        // No event, so we're at 100%
                        chunk.progress = 100;
                        chunk.bytesSent = chunk.total;
                    }
                    // Now tally the *file* upload progress from its individual chunks
                    file1.upload.progress = 0;
                    file1.upload.total = 0;
                    file1.upload.bytesSent = 0;
                    for(var i = 0; i < file1.upload.totalChunkCount; i++)if (file1.upload.chunks[i] && typeof file1.upload.chunks[i].progress !== "undefined") {
                        file1.upload.progress += file1.upload.chunks[i].progress;
                        file1.upload.total += file1.upload.chunks[i].total;
                        file1.upload.bytesSent += file1.upload.chunks[i].bytesSent;
                    }
                    // Since the process is a percentage, we need to divide by the amount of
                    // chunks we've used.
                    file1.upload.progress = file1.upload.progress / file1.upload.totalChunkCount;
                    this.emit("uploadprogress", file1, file1.upload.progress, file1.upload.bytesSent);
                }
            }
        },
        {
            key: "_finishedUploading",
            value: function _finishedUploading(files, xhr, e) {
                var response;
                if (files[0].status === $3ed269f2f0fb224b$export$2e2bcd8739ae039.CANCELED) return;
                if (xhr.readyState !== 4) return;
                if (xhr.responseType !== "arraybuffer" && xhr.responseType !== "blob") {
                    response = xhr.responseText;
                    if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) try {
                        response = JSON.parse(response);
                    } catch (error) {
                        e = error;
                        response = "Invalid JSON response from server.";
                    }
                }
                this._updateFilesUploadProgress(files, xhr);
                if (!(200 <= xhr.status && xhr.status < 300)) this._handleUploadError(files, xhr, response);
                else if (files[0].upload.chunked) files[0].upload.finishedChunkUpload(this._getChunk(files[0], xhr), response);
                else this._finished(files, response, e);
            }
        },
        {
            key: "_handleUploadError",
            value: function _handleUploadError(files, xhr, response) {
                if (files[0].status === $3ed269f2f0fb224b$export$2e2bcd8739ae039.CANCELED) return;
                if (files[0].upload.chunked && this.options.retryChunks) {
                    var chunk = this._getChunk(files[0], xhr);
                    if (chunk.retries++ < this.options.retryChunksLimit) {
                        this._uploadData(files, [
                            chunk.dataBlock
                        ]);
                        return;
                    } else console.warn("Retried this chunk too often. Giving up.");
                }
                this._errorProcessing(files, response || this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr);
            }
        },
        {
            key: "submitRequest",
            value: function submitRequest(xhr, formData, files) {
                if (xhr.readyState != 1) {
                    console.warn("Cannot send this request because the XMLHttpRequest.readyState is not OPENED.");
                    return;
                }
                if (this.options.binaryBody) {
                    if (files[0].upload.chunked) {
                        var chunk = this._getChunk(files[0], xhr);
                        xhr.send(chunk.dataBlock.data);
                    } else xhr.send(files[0]);
                } else xhr.send(formData);
            }
        },
        {
            // Called internally when processing is finished.
            // Individual callbacks have to be called in the appropriate sections.
            key: "_finished",
            value: function _finished(files, responseText, e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var file = _step.value;
                        file.status = $3ed269f2f0fb224b$export$2e2bcd8739ae039.SUCCESS;
                        this.emit("success", file, responseText, e);
                        this.emit("complete", file);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this.options.uploadMultiple) {
                    this.emit("successmultiple", files, responseText, e);
                    this.emit("completemultiple", files);
                }
                if (this.options.autoProcessQueue) return this.processQueue();
            }
        },
        {
            // Called internally when processing is finished.
            // Individual callbacks have to be called in the appropriate sections.
            key: "_errorProcessing",
            value: function _errorProcessing(files, message, xhr) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var file = _step.value;
                        file.status = $3ed269f2f0fb224b$export$2e2bcd8739ae039.ERROR;
                        this.emit("error", file, message, xhr);
                        this.emit("complete", file);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this.options.uploadMultiple) {
                    this.emit("errormultiple", files, message, xhr);
                    this.emit("completemultiple", files);
                }
                if (this.options.autoProcessQueue) return this.processQueue();
            }
        }
    ], [
        {
            key: "initClass",
            value: function initClass() {
                // Exposing the emitter class, mainly for tests
                this.prototype.Emitter = $ab966853eba787d9$var$$4040acfd8584338d$export$2e2bcd8739ae039;
                /*
     This is a list of all available events you can register on a dropzone object.

     You can register an event handler like this:

     dropzone.on("dragEnter", function() { });

     */ this.prototype.events = [
                    "drop",
                    "dragstart",
                    "dragend",
                    "dragenter",
                    "dragover",
                    "dragleave",
                    "addedfile",
                    "addedfiles",
                    "removedfile",
                    "thumbnail",
                    "error",
                    "errormultiple",
                    "processing",
                    "processingmultiple",
                    "uploadprogress",
                    "totaluploadprogress",
                    "sending",
                    "sendingmultiple",
                    "success",
                    "successmultiple",
                    "canceled",
                    "canceledmultiple",
                    "complete",
                    "completemultiple",
                    "reset",
                    "maxfilesexceeded",
                    "maxfilesreached",
                    "queuecomplete"
                ];
                this.prototype._thumbnailQueue = [];
                this.prototype._processingThumbnail = false;
            }
        },
        {
            key: "uuidv4",
            value: function uuidv4() {
                return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
                    var r = Math.random() * 16 | 0, v = c === "x" ? r : r & 3 | 8;
                    return v.toString(16);
                });
            }
        }
    ]);
    return $3ed269f2f0fb224b$export$2e2bcd8739ae039;
}($ab966853eba787d9$var$$4040acfd8584338d$export$2e2bcd8739ae039);
$ab966853eba787d9$export$2e2bcd8739ae039.initClass();
// This is a map of options for your different dropzones. Add configurations
// to this object for your different dropzone elemens.
//
// Example:
//
//     Dropzone.options.myDropzoneElementId = { maxFilesize: 1 };
//
// And in html:
//
//     <form action="/upload" id="my-dropzone-element-id" class="dropzone"></form>
$ab966853eba787d9$export$2e2bcd8739ae039.options = {};
// Returns the options for an element or undefined if none available.
$ab966853eba787d9$export$2e2bcd8739ae039.optionsForElement = function(element) {
    // Get the `Dropzone.options.elementId` for this element if it exists
    if (element.getAttribute("id")) return $ab966853eba787d9$export$2e2bcd8739ae039.options[$ab966853eba787d9$var$$3ed269f2f0fb224b$var$camelize(element.getAttribute("id"))];
    else return undefined;
};
// Holds a list of all dropzone instances
$ab966853eba787d9$export$2e2bcd8739ae039.instances = [];
// Returns the dropzone for given element if any
$ab966853eba787d9$export$2e2bcd8739ae039.forElement = function(element) {
    if (typeof element === "string") element = document.querySelector(element);
    if ((element != null ? element.dropzone : undefined) == null) throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
    return element.dropzone;
};
// Looks for all .dropzone elements and creates a dropzone for them
$ab966853eba787d9$export$2e2bcd8739ae039.discover = function() {
    var dropzones;
    if (document.querySelectorAll) dropzones = document.querySelectorAll(".dropzone");
    else {
        dropzones = [];
        // IE :(
        var checkElements = function(elements) {
            return function() {
                var result = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var el = _step.value;
                        if (/(^| )dropzone($| )/.test(el.className)) result.push(dropzones.push(el));
                        else result.push(undefined);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return result;
            }();
        };
        checkElements(document.getElementsByTagName("div"));
        checkElements(document.getElementsByTagName("form"));
    }
    return function() {
        var result = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = dropzones[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var dropzone = _step.value;
                if ($ab966853eba787d9$export$2e2bcd8739ae039.optionsForElement(dropzone) !== false) result.push(new $ab966853eba787d9$export$2e2bcd8739ae039(dropzone));
                else result.push(undefined);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    }();
};
// Some browsers support drag and drog functionality, but not correctly.
//
// So I created a blocklist of userAgents. Yes, yes. Browser sniffing, I know.
// But what to do when browsers *theoretically* support an API, but crash
// when using it.
//
// This is a list of regular expressions tested against navigator.userAgent
//
// ** It should only be used on browser that *do* support the API, but
// incorrectly **
$ab966853eba787d9$export$2e2bcd8739ae039.blockedBrowsers = [
    // The mac os and windows phone version of opera 12 seems to have a problem with the File drag'n'drop API.
    /opera.*(Macintosh|Windows Phone).*version\/12/i
];
// Checks if the browser is supported
$ab966853eba787d9$export$2e2bcd8739ae039.isBrowserSupported = function() {
    var capableBrowser = true;
    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
        if (!("classList" in document.createElement("a"))) capableBrowser = false;
        else {
            if ($ab966853eba787d9$export$2e2bcd8739ae039.blacklistedBrowsers !== undefined) // configuration.
            $ab966853eba787d9$export$2e2bcd8739ae039.blockedBrowsers = $ab966853eba787d9$export$2e2bcd8739ae039.blacklistedBrowsers;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // The browser supports the API, but may be blocked.
                for(var _iterator = $ab966853eba787d9$export$2e2bcd8739ae039.blockedBrowsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var regex = _step.value;
                    if (regex.test(navigator.userAgent)) {
                        capableBrowser = false;
                        continue;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } else capableBrowser = false;
    return capableBrowser;
};
$ab966853eba787d9$export$2e2bcd8739ae039.dataURItoBlob = function(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(",")[1]);
    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for(var i = 0, end = byteString.length, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--)ia[i] = byteString.charCodeAt(i);
    // write the ArrayBuffer to a blob
    return new Blob([
        ab
    ], {
        type: mimeString
    });
};
// Returns an array without the rejected item
var $ab966853eba787d9$var$$3ed269f2f0fb224b$var$without = function(list, rejectedItem) {
    return list.filter(function(item) {
        return item !== rejectedItem;
    }).map(function(item) {
        return item;
    });
};
// abc-def_ghi -> abcDefGhi
var $ab966853eba787d9$var$$3ed269f2f0fb224b$var$camelize = function(str) {
    return str.replace(/[\-_](\w)/g, function(match) {
        return match.charAt(1).toUpperCase();
    });
};
// Creates an element from string
$ab966853eba787d9$export$2e2bcd8739ae039.createElement = function(string) {
    var div = document.createElement("div");
    div.innerHTML = string;
    return div.childNodes[0];
};
// Tests if given element is inside (or simply is) the container
$ab966853eba787d9$export$2e2bcd8739ae039.elementInside = function(element, container) {
    if (element === container) return true;
    // Coffeescript doesn't support do/while loops
    while(element = element.parentNode){
        if (element === container) return true;
    }
    return false;
};
$ab966853eba787d9$export$2e2bcd8739ae039.getElement = function(el, name) {
    var element;
    if (typeof el === "string") element = document.querySelector(el);
    else if (el.nodeType != null) element = el;
    if (element == null) throw new Error("Invalid `".concat(name, "` option provided. Please provide a CSS selector or a plain HTML element."));
    return element;
};
$ab966853eba787d9$export$2e2bcd8739ae039.getElements = function(els, name) {
    var el, elements;
    if (els instanceof Array) {
        elements = [];
        try {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = els[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    el = _step.value;
                    elements.push(this.getElement(el, name));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } catch (e) {
            elements = null;
        }
    } else if (typeof els === "string") {
        elements = [];
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = document.querySelectorAll(els)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                el = _step1.value;
                elements.push(el);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    } else if (els.nodeType != null) elements = [
        els
    ];
    if (elements == null || !elements.length) throw new Error("Invalid `".concat(name, "` option provided. Please provide a CSS selector, a plain HTML element or a list of those."));
    return elements;
};
// Asks the user the question and calls accepted or rejected accordingly
//
// The default implementation just uses `window.confirm` and then calls the
// appropriate callback.
$ab966853eba787d9$export$2e2bcd8739ae039.confirm = function(question, accepted, rejected) {
    if (window.confirm(question)) return accepted();
    else if (rejected != null) return rejected();
};
// Validates the mime type like this:
//
// https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept
$ab966853eba787d9$export$2e2bcd8739ae039.isValidFile = function(file, acceptedFiles) {
    if (!acceptedFiles) return true;
    // If there are no accepted mime types, it's OK
    acceptedFiles = acceptedFiles.split(",");
    var mimeType = file.type;
    var baseMimeType = mimeType.replace(/\/.*$/, "");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = acceptedFiles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var validType = _step.value;
            validType = validType.trim();
            if (validType.charAt(0) === ".") {
                if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) return true;
            } else if (/\/\*$/.test(validType)) {
                // This is something like a image/* mime type
                if (baseMimeType === validType.replace(/\/.*$/, "")) return true;
            } else {
                if (mimeType === validType) return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
};
// Augment jQuery
if (typeof jQuery !== "undefined" && jQuery !== null) jQuery.fn.dropzone = function(options) {
    return this.each(function() {
        return new $ab966853eba787d9$export$2e2bcd8739ae039(this, options);
    });
};
// Dropzone file status codes
$ab966853eba787d9$export$2e2bcd8739ae039.ADDED = "added";
$ab966853eba787d9$export$2e2bcd8739ae039.QUEUED = "queued";
// For backwards compatibility. Now, if a file is accepted, it's either queued
// or uploading.
$ab966853eba787d9$export$2e2bcd8739ae039.ACCEPTED = $ab966853eba787d9$export$2e2bcd8739ae039.QUEUED;
$ab966853eba787d9$export$2e2bcd8739ae039.UPLOADING = "uploading";
$ab966853eba787d9$export$2e2bcd8739ae039.PROCESSING = $ab966853eba787d9$export$2e2bcd8739ae039.UPLOADING; // alias
$ab966853eba787d9$export$2e2bcd8739ae039.CANCELED = "canceled";
$ab966853eba787d9$export$2e2bcd8739ae039.ERROR = "error";
$ab966853eba787d9$export$2e2bcd8739ae039.SUCCESS = "success";
/*

 Bugfix for iOS 6 and 7
 Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
 based on the work of https://github.com/stomita/ios-imagefile-megapixel

 */ // Detecting vertical squash in loaded image.
// Fixes a bug which squash image vertically while drawing into canvas for some images.
// This is a bug in iOS6 devices. This function from https://github.com/stomita/ios-imagefile-megapixel
var $ab966853eba787d9$var$$3ed269f2f0fb224b$var$detectVerticalSquash = function $3ed269f2f0fb224b$var$detectVerticalSquash(img) {
    var iw = img.naturalWidth;
    var ih = img.naturalHeight;
    var canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = ih;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    var _ctx_getImageData = ctx.getImageData(1, 0, 1, ih), data = _ctx_getImageData.data;
    // search image edge pixel position in case it is squashed vertically.
    var sy = 0;
    var ey = ih;
    var py = ih;
    while(py > sy){
        var alpha = data[(py - 1) * 4 + 3];
        if (alpha === 0) ey = py;
        else sy = py;
        py = ey + sy >> 1;
    }
    var ratio = py / ih;
    if (ratio === 0) return 1;
    else return ratio;
};
// A replacement for context.drawImage
// (args are for source and destination).
var $ab966853eba787d9$var$$3ed269f2f0fb224b$var$drawImageIOSFix = function $3ed269f2f0fb224b$var$drawImageIOSFix(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
    var vertSquashRatio = $ab966853eba787d9$var$$3ed269f2f0fb224b$var$detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
};
// Based on MinifyJpeg
// Source: http://www.perry.cz/files/ExifRestorer.js
// http://elicon.blog57.fc2.com/blog-entry-206.html
var $ab966853eba787d9$var$$3ed269f2f0fb224b$var$ExifRestore = /*#__PURE__*/ function() {
    "use strict";
    function $3ed269f2f0fb224b$var$ExifRestore() {
        (0, $19mwo._)(this, $3ed269f2f0fb224b$var$ExifRestore);
    }
    (0, $6rpfc._)($3ed269f2f0fb224b$var$ExifRestore, null, [
        {
            key: "initClass",
            value: function initClass() {
                this.KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            }
        },
        {
            key: "encode64",
            value: function encode64(input) {
                var output = "";
                var chr1 = undefined;
                var chr2 = undefined;
                var chr3 = "";
                var enc1 = undefined;
                var enc2 = undefined;
                var enc3 = undefined;
                var enc4 = "";
                var i = 0;
                while(true){
                    chr1 = input[i++];
                    chr2 = input[i++];
                    chr3 = input[i++];
                    enc1 = chr1 >> 2;
                    enc2 = (chr1 & 3) << 4 | chr2 >> 4;
                    enc3 = (chr2 & 15) << 2 | chr3 >> 6;
                    enc4 = chr3 & 63;
                    if (isNaN(chr2)) enc3 = enc4 = 64;
                    else if (isNaN(chr3)) enc4 = 64;
                    output = output + this.KEY_STR.charAt(enc1) + this.KEY_STR.charAt(enc2) + this.KEY_STR.charAt(enc3) + this.KEY_STR.charAt(enc4);
                    chr1 = chr2 = chr3 = "";
                    enc1 = enc2 = enc3 = enc4 = "";
                    if (!(i < input.length)) break;
                }
                return output;
            }
        },
        {
            key: "restore",
            value: function restore(origFileBase64, resizedFileBase64) {
                if (!origFileBase64.match("data:image/jpeg;base64,")) return resizedFileBase64;
                var rawImage = this.decode64(origFileBase64.replace("data:image/jpeg;base64,", ""));
                var segments = this.slice2Segments(rawImage);
                var image = this.exifManipulation(resizedFileBase64, segments);
                return "data:image/jpeg;base64,".concat(this.encode64(image));
            }
        },
        {
            key: "exifManipulation",
            value: function exifManipulation(resizedFileBase64, segments) {
                var exifArray = this.getExifArray(segments);
                var newImageArray = this.insertExif(resizedFileBase64, exifArray);
                var aBuffer = new Uint8Array(newImageArray);
                return aBuffer;
            }
        },
        {
            key: "getExifArray",
            value: function getExifArray(segments) {
                var seg = undefined;
                var x = 0;
                while(x < segments.length){
                    seg = segments[x];
                    if (seg[0] === 255 & seg[1] === 225) return seg;
                    x++;
                }
                return [];
            }
        },
        {
            key: "insertExif",
            value: function insertExif(resizedFileBase64, exifArray) {
                var imageData = resizedFileBase64.replace("data:image/jpeg;base64,", "");
                var buf = this.decode64(imageData);
                var separatePoint = buf.indexOf(255, 3);
                var mae = buf.slice(0, separatePoint);
                var ato = buf.slice(separatePoint);
                var array = mae;
                array = array.concat(exifArray);
                array = array.concat(ato);
                return array;
            }
        },
        {
            key: "slice2Segments",
            value: function slice2Segments(rawImageArray) {
                var head = 0;
                var segments = [];
                while(true){
                    var length;
                    if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) break;
                    if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) head += 2;
                    else {
                        length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3];
                        var endPoint = head + length + 2;
                        var seg = rawImageArray.slice(head, endPoint);
                        segments.push(seg);
                        head = endPoint;
                    }
                    if (head > rawImageArray.length) break;
                }
                return segments;
            }
        },
        {
            key: "decode64",
            value: function decode64(input) {
                var output = "";
                var chr1 = undefined;
                var chr2 = undefined;
                var chr3 = "";
                var enc1 = undefined;
                var enc2 = undefined;
                var enc3 = undefined;
                var enc4 = "";
                var i = 0;
                var buf = [];
                // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
                var base64test = /[^A-Za-z0-9\+\/\=]/g;
                if (base64test.exec(input)) console.warn("There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding.");
                input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
                while(true){
                    enc1 = this.KEY_STR.indexOf(input.charAt(i++));
                    enc2 = this.KEY_STR.indexOf(input.charAt(i++));
                    enc3 = this.KEY_STR.indexOf(input.charAt(i++));
                    enc4 = this.KEY_STR.indexOf(input.charAt(i++));
                    chr1 = enc1 << 2 | enc2 >> 4;
                    chr2 = (enc2 & 15) << 4 | enc3 >> 2;
                    chr3 = (enc3 & 3) << 6 | enc4;
                    buf.push(chr1);
                    if (enc3 !== 64) buf.push(chr2);
                    if (enc4 !== 64) buf.push(chr3);
                    chr1 = chr2 = chr3 = "";
                    enc1 = enc2 = enc3 = enc4 = "";
                    if (!(i < input.length)) break;
                }
                return buf;
            }
        }
    ]);
    return $3ed269f2f0fb224b$var$ExifRestore;
}();
$ab966853eba787d9$var$$3ed269f2f0fb224b$var$ExifRestore.initClass();
/*
 * contentloaded.js
 *
 * Author: Diego Perini (diego.perini at gmail.com)
 * Summary: cross-browser wrapper for DOMContentLoaded
 * Updated: 20101020
 * License: MIT
 * Version: 1.2
 *
 * URL:
 * http://javascript.nwbox.com/ContentLoaded/
 * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
 */ // @win window reference
// @fn function reference
var $ab966853eba787d9$var$$3ed269f2f0fb224b$var$contentLoaded = function $3ed269f2f0fb224b$var$contentLoaded(win, fn) {
    var done = false;
    var top = true;
    var doc = win.document;
    var root = doc.documentElement;
    var add = doc.addEventListener ? "addEventListener" : "attachEvent";
    var rem = doc.addEventListener ? "removeEventListener" : "detachEvent";
    var pre = doc.addEventListener ? "" : "on";
    var init = function init1(e) {
        if (e.type === "readystatechange" && doc.readyState !== "complete") return;
        (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
        if (!done && (done = true)) return fn.call(win, e.type || e);
    };
    var poll = function poll1() {
        try {
            root.doScroll("left");
        } catch (e) {
            setTimeout(poll, 50);
            return;
        }
        return init("poll");
    };
    if (doc.readyState !== "complete") {
        if (doc.createEventObject && root.doScroll) {
            try {
                top = !win.frameElement;
            } catch (error) {}
            if (top) poll();
        }
        doc[add](pre + "DOMContentLoaded", init, false);
        doc[add](pre + "readystatechange", init, false);
        return win[add](pre + "load", init, false);
    }
};
function $ab966853eba787d9$var$$3ed269f2f0fb224b$var$__guard__(value, transform) {
    return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}
function $ab966853eba787d9$var$$3ed269f2f0fb224b$var$__guardMethod__(obj, methodName, transform) {
    if (typeof obj !== "undefined" && obj !== null && typeof obj[methodName] === "function") return transform(obj, methodName);
    else return undefined;
}


var $50b3ec7e1b18edba$require$Dropzone = $ab966853eba787d9$export$2e2bcd8739ae039;
var $50b3ec7e1b18edba$export$48030d8a30a8103a = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function(props) {
    var dropzoneRef = (0, $33gHU.useRef)(null);
    var assets = (0, $3a3345637c0a5d6f$export$bd973f06e9aaec8c)();
    (0, $33gHU.useEffect)(function() {
        var myDropzone = new $50b3ec7e1b18edba$require$Dropzone(dropzoneRef.current, {
            dictDefaultMessage: "",
            maxFilesize: 2,
            url: "/",
            addRemoveLinks: false,
            method: "put",
            chunking: true,
            forceChunking: true,
            autoQueue: false,
            autoProcessQueue: false,
            disablePreviews: true
        });
        myDropzone.on("addedfile", function(file) {
            return $50b3ec7e1b18edba$var$__awaiter(this, void 0, void 0, function() {
                return (0, $lF1I7.__generator)(this, function(_state) {
                    myDropzone.removeFile(file);
                    myDropzone.emit("complete", file);
                    props.onNewFile(file);
                    setTimeout(function() {
                        myDropzone.removeFile(file);
                    }, 250);
                    return [
                        2
                    ];
                });
            });
        });
        return function() {
            while(myDropzone.files.length > 0)myDropzone.removeFile(myDropzone.files[0]);
            myDropzone.destroy();
        };
    }, [
        dropzoneRef
    ]);
    return (0, $978b871a0234f592$exports.jsx)("div", {
        id: "taskPageDropZone",
        className: $6f191d2ec90e71ff$export$2778853eeaa53fa7 + " " + props.className,
        ref: dropzoneRef,
        children: (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
            iconSys: "upload",
            size: "M",
            onClick: function() {
                dropzoneRef.current.click();
            }
        })
    });
});






var $33gHU = parcelRequire("33gHU");
var $c2ce9fc152d617b5$exports = {};

(function webpackUniversalModuleDefinition(root, factory) {
    $c2ce9fc152d617b5$exports = factory((parcelRequire("33gHU")));
})($c2ce9fc152d617b5$exports, function(__WEBPACK_EXTERNAL_MODULE_react__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = "./src/react-webcam.tsx");
    /******/ }({
        /***/ "./src/react-webcam.tsx": /*!******************************!*\
  !*** ./src/react-webcam.tsx ***!
  \******************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            var __extends = function() {
                var extendStatics = function extendStatics1(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = function __assign1() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __rest = function __rest(s, e) {
                var t = {};
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
                if (s != null && typeof Object.getOwnPropertySymbols === "function") {
                    for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
                }
                return t;
            };
            // polyfill based on https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
            (function polyfillGetUserMedia() {
                if (typeof window === "undefined") return;
                // Older browsers might not implement mediaDevices at all, so we set an empty object first
                if (navigator.mediaDevices === undefined) navigator.mediaDevices = {};
                // Some browsers partially implement mediaDevices. We can't just assign an object
                // with getUserMedia as it would overwrite existing properties.
                // Here, we will just add the getUserMedia property if it's missing.
                if (navigator.mediaDevices.getUserMedia === undefined) navigator.mediaDevices.getUserMedia = function(constraints) {
                    // First get ahold of the legacy getUserMedia, if present
                    var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
                    // Some browsers just don't implement it - return a rejected promise with an error
                    // to keep a consistent interface
                    if (!getUserMedia) return Promise.reject(new Error("getUserMedia is not implemented in this browser"));
                    // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
                    return new Promise(function(resolve, reject) {
                        getUserMedia.call(navigator, constraints, resolve, reject);
                    });
                };
            })();
            function hasGetUserMedia() {
                return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
            }
            var Webcam = /** @class */ function(_super) {
                __extends(Webcam, _super);
                function Webcam(props) {
                    var _this = _super.call(this, props) || this;
                    _this.canvas = null;
                    _this.ctx = null;
                    _this.requestUserMediaId = 0;
                    _this.unmounted = false;
                    _this.state = {
                        hasUserMedia: false
                    };
                    return _this;
                }
                Webcam.prototype.componentDidMount = function() {
                    var _a = this, state = _a.state, props = _a.props;
                    this.unmounted = false;
                    if (!hasGetUserMedia()) {
                        props.onUserMediaError("getUserMedia not supported");
                        return;
                    }
                    if (!state.hasUserMedia) this.requestUserMedia();
                    if (props.children && typeof props.children != "function") console.warn("children must be a function");
                };
                Webcam.prototype.componentDidUpdate = function(nextProps) {
                    var props = this.props;
                    if (!hasGetUserMedia()) {
                        props.onUserMediaError("getUserMedia not supported");
                        return;
                    }
                    var audioConstraintsChanged = JSON.stringify(nextProps.audioConstraints) !== JSON.stringify(props.audioConstraints);
                    var videoConstraintsChanged = JSON.stringify(nextProps.videoConstraints) !== JSON.stringify(props.videoConstraints);
                    var minScreenshotWidthChanged = nextProps.minScreenshotWidth !== props.minScreenshotWidth;
                    var minScreenshotHeightChanged = nextProps.minScreenshotHeight !== props.minScreenshotHeight;
                    if (videoConstraintsChanged || minScreenshotWidthChanged || minScreenshotHeightChanged) {
                        this.canvas = null;
                        this.ctx = null;
                    }
                    if (audioConstraintsChanged || videoConstraintsChanged) {
                        this.stopAndCleanup();
                        this.requestUserMedia();
                    }
                };
                Webcam.prototype.componentWillUnmount = function() {
                    this.unmounted = true;
                    this.stopAndCleanup();
                };
                Webcam.stopMediaStream = function(stream) {
                    if (stream) {
                        if (stream.getVideoTracks && stream.getAudioTracks) {
                            stream.getVideoTracks().map(function(track) {
                                stream.removeTrack(track);
                                track.stop();
                            });
                            stream.getAudioTracks().map(function(track) {
                                stream.removeTrack(track);
                                track.stop();
                            });
                        } else stream.stop();
                    }
                };
                Webcam.prototype.stopAndCleanup = function() {
                    var state = this.state;
                    if (state.hasUserMedia) {
                        Webcam.stopMediaStream(this.stream);
                        if (state.src) window.URL.revokeObjectURL(state.src);
                    }
                };
                Webcam.prototype.getScreenshot = function(screenshotDimensions) {
                    var _a = this, state = _a.state, props = _a.props;
                    if (!state.hasUserMedia) return null;
                    var canvas = this.getCanvas(screenshotDimensions);
                    return canvas && canvas.toDataURL(props.screenshotFormat, props.screenshotQuality);
                };
                Webcam.prototype.getCanvas = function(screenshotDimensions) {
                    var _a = this, state = _a.state, props = _a.props;
                    if (!this.video) return null;
                    if (!state.hasUserMedia || !this.video.videoHeight) return null;
                    if (!this.ctx) {
                        var canvasWidth = this.video.videoWidth;
                        var canvasHeight = this.video.videoHeight;
                        if (!this.props.forceScreenshotSourceSize) {
                            var aspectRatio = canvasWidth / canvasHeight;
                            canvasWidth = props.minScreenshotWidth || this.video.clientWidth;
                            canvasHeight = canvasWidth / aspectRatio;
                            if (props.minScreenshotHeight && canvasHeight < props.minScreenshotHeight) {
                                canvasHeight = props.minScreenshotHeight;
                                canvasWidth = canvasHeight * aspectRatio;
                            }
                        }
                        this.canvas = document.createElement("canvas");
                        this.canvas.width = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.width) || canvasWidth;
                        this.canvas.height = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.height) || canvasHeight;
                        this.ctx = this.canvas.getContext("2d");
                    }
                    var _b = this, ctx = _b.ctx, canvas = _b.canvas;
                    if (ctx && canvas) {
                        // adjust the height and width of the canvas to the given dimensions
                        canvas.width = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.width) || canvas.width;
                        canvas.height = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.height) || canvas.height;
                        // mirror the screenshot
                        if (props.mirrored) {
                            ctx.translate(canvas.width, 0);
                            ctx.scale(-1, 1);
                        }
                        ctx.imageSmoothingEnabled = props.imageSmoothing;
                        ctx.drawImage(this.video, 0, 0, (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.width) || canvas.width, (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.height) || canvas.height);
                        // invert mirroring
                        if (props.mirrored) {
                            ctx.scale(-1, 1);
                            ctx.translate(-canvas.width, 0);
                        }
                    }
                    return canvas;
                };
                Webcam.prototype.requestUserMedia = function() {
                    var _this = this;
                    var props = this.props;
                    var sourceSelected = function sourceSelected(audioConstraints, videoConstraints) {
                        var constraints = {
                            video: typeof videoConstraints !== "undefined" ? videoConstraints : true
                        };
                        if (props.audio) constraints.audio = typeof audioConstraints !== "undefined" ? audioConstraints : true;
                        _this.requestUserMediaId++;
                        var myRequestUserMediaId = _this.requestUserMediaId;
                        navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {
                            if (_this.unmounted || myRequestUserMediaId !== _this.requestUserMediaId) Webcam.stopMediaStream(stream);
                            else _this.handleUserMedia(null, stream);
                        }).catch(function(e) {
                            _this.handleUserMedia(e);
                        });
                    };
                    if ("mediaDevices" in navigator) sourceSelected(props.audioConstraints, props.videoConstraints);
                    else {
                        var optionalSource_1 = function optionalSource_1(id) {
                            return {
                                optional: [
                                    {
                                        sourceId: id
                                    }
                                ]
                            };
                        };
                        var constraintToSourceId_1 = function constraintToSourceId_1(constraint) {
                            var deviceId = constraint.deviceId;
                            if (typeof deviceId === "string") return deviceId;
                            if (Array.isArray(deviceId) && deviceId.length > 0) return deviceId[0];
                            if (typeof deviceId === "object" && deviceId.ideal) return deviceId.ideal;
                            return null;
                        };
                        // @ts-ignore: deprecated api
                        MediaStreamTrack.getSources(function(sources) {
                            var audioSource = null;
                            var videoSource = null;
                            sources.forEach(function(source) {
                                if (source.kind === "audio") audioSource = source.id;
                                else if (source.kind === "video") videoSource = source.id;
                            });
                            var audioSourceId = constraintToSourceId_1(props.audioConstraints);
                            if (audioSourceId) audioSource = audioSourceId;
                            var videoSourceId = constraintToSourceId_1(props.videoConstraints);
                            if (videoSourceId) videoSource = videoSourceId;
                            sourceSelected(optionalSource_1(audioSource), optionalSource_1(videoSource));
                        });
                    }
                };
                Webcam.prototype.handleUserMedia = function(err, stream) {
                    var props = this.props;
                    if (err || !stream) {
                        this.setState({
                            hasUserMedia: false
                        });
                        props.onUserMediaError(err);
                        return;
                    }
                    this.stream = stream;
                    try {
                        if (this.video) this.video.srcObject = stream;
                        this.setState({
                            hasUserMedia: true
                        });
                    } catch (error) {
                        this.setState({
                            hasUserMedia: true,
                            src: window.URL.createObjectURL(stream)
                        });
                    }
                    props.onUserMedia(stream);
                };
                Webcam.prototype.render = function() {
                    var _this = this;
                    var _a = this, state = _a.state, props = _a.props;
                    var audio = props.audio, forceScreenshotSourceSize = props.forceScreenshotSourceSize, disablePictureInPicture = props.disablePictureInPicture, onUserMedia = props.onUserMedia, onUserMediaError = props.onUserMediaError, screenshotFormat = props.screenshotFormat, screenshotQuality = props.screenshotQuality, minScreenshotWidth = props.minScreenshotWidth, minScreenshotHeight = props.minScreenshotHeight, audioConstraints = props.audioConstraints, videoConstraints = props.videoConstraints, imageSmoothing = props.imageSmoothing, mirrored = props.mirrored, _b = props.style, style = _b === void 0 ? {} : _b, children = props.children, rest = __rest(props, [
                        "audio",
                        "forceScreenshotSourceSize",
                        "disablePictureInPicture",
                        "onUserMedia",
                        "onUserMediaError",
                        "screenshotFormat",
                        "screenshotQuality",
                        "minScreenshotWidth",
                        "minScreenshotHeight",
                        "audioConstraints",
                        "videoConstraints",
                        "imageSmoothing",
                        "mirrored",
                        "style",
                        "children"
                    ]);
                    var videoStyle = mirrored ? __assign(__assign({}, style), {
                        transform: (style.transform || "") + " scaleX(-1)"
                    }) : style;
                    var childrenProps = {
                        getScreenshot: this.getScreenshot.bind(this)
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("video", __assign({
                        autoPlay: true,
                        disablePictureInPicture: disablePictureInPicture,
                        src: state.src,
                        muted: !audio,
                        playsInline: true,
                        ref: function ref(ref) {
                            _this.video = ref;
                        },
                        style: videoStyle
                    }, rest)), children && children(childrenProps));
                };
                Webcam.defaultProps = {
                    audio: false,
                    disablePictureInPicture: false,
                    forceScreenshotSourceSize: false,
                    imageSmoothing: true,
                    mirrored: false,
                    onUserMedia: function onUserMedia() {
                        return undefined;
                    },
                    onUserMediaError: function onUserMediaError() {
                        return undefined;
                    },
                    screenshotFormat: "image/webp",
                    screenshotQuality: 0.92
                };
                return Webcam;
            }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
            /* harmony default export */ __webpack_exports__["default"] = Webcam;
        /***/ },
        /***/ "react": /*!**************************************************************************************!*\
  !*** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"} ***!
  \**************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_react__;
        /***/ }
    })["default"];
});



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");


var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");



"use client";
var $315e35ef1f8639b3$var$CardBody = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? "div" : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "card-body");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$315e35ef1f8639b3$var$CardBody.displayName = "CardBody";
var $315e35ef1f8639b3$export$2e2bcd8739ae039 = $315e35ef1f8639b3$var$CardBody;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");



"use client";
var $aec9d97ada81e461$var$CardFooter = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? "div" : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "card-footer");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$aec9d97ada81e461$var$CardFooter.displayName = "CardFooter";
var $aec9d97ada81e461$export$2e2bcd8739ae039 = $aec9d97ada81e461$var$CardFooter;



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");



"use client";
var $338a1f5c4797c4cd$var$CardHeader = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "div" : tmp, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "as"
    ]);
    var prefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "card-header");
    var contextValue = (0, $33gHU.useMemo)(function() {
        return {
            cardHeaderBsPrefix: prefix
        };
    }, [
        prefix
    ]);
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $fddc3b669f55ae8e$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({
            ref: ref
        }, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix)
        }))
    });
});
$338a1f5c4797c4cd$var$CardHeader.displayName = "CardHeader";
var $338a1f5c4797c4cd$export$2e2bcd8739ae039 = $338a1f5c4797c4cd$var$CardHeader;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");


"use client";
var $e369e9e40d9ae7b0$var$CardImg = /*#__PURE__*/ $33gHU.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, variant = _param.variant, tmp = _param.as, Component = tmp === void 0 ? "img" : tmp, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "variant",
        "as"
    ]);
    var prefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "card-img");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(variant ? "".concat(prefix, "-").concat(variant) : prefix, className)
    }, props));
});
$e369e9e40d9ae7b0$var$CardImg.displayName = "CardImg";
var $e369e9e40d9ae7b0$export$2e2bcd8739ae039 = $e369e9e40d9ae7b0$var$CardImg;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");



"use client";
var $58d90a9088fdd0b9$var$CardImgOverlay = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? "div" : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "card-img-overlay");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$58d90a9088fdd0b9$var$CardImgOverlay.displayName = "CardImgOverlay";
var $58d90a9088fdd0b9$export$2e2bcd8739ae039 = $58d90a9088fdd0b9$var$CardImgOverlay;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");



"use client";
var $badd33786cd9b067$var$CardLink = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? "a" : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "card-link");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$badd33786cd9b067$var$CardLink.displayName = "CardLink";
var $badd33786cd9b067$export$2e2bcd8739ae039 = $badd33786cd9b067$var$CardLink;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");




"use client";
var $59b75cff8215526e$var$DivStyledAsH6 = (0, $102b865d7ac21b71$export$2e2bcd8739ae039)("h6");
var $59b75cff8215526e$var$CardSubtitle = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? $59b75cff8215526e$var$DivStyledAsH6 : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "card-subtitle");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$59b75cff8215526e$var$CardSubtitle.displayName = "CardSubtitle";
var $59b75cff8215526e$export$2e2bcd8739ae039 = $59b75cff8215526e$var$CardSubtitle;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");



"use client";
var $ac11c739ca0a627f$var$CardText = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? "p" : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "card-text");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$ac11c739ca0a627f$var$CardText.displayName = "CardText";
var $ac11c739ca0a627f$export$2e2bcd8739ae039 = $ac11c739ca0a627f$var$CardText;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");




"use client";
var $ea055b44f3422068$var$DivStyledAsH5 = (0, $102b865d7ac21b71$export$2e2bcd8739ae039)("h5");
var $ea055b44f3422068$var$CardTitle = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? $ea055b44f3422068$var$DivStyledAsH5 : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "card-title");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$ea055b44f3422068$var$CardTitle.displayName = "CardTitle";
var $ea055b44f3422068$export$2e2bcd8739ae039 = $ea055b44f3422068$var$CardTitle;



"use client";
var $e837d155498b80f2$var$Card = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, bg = _param.bg, text = _param.text, border = _param.border, _param_body = _param.body, body = _param_body === void 0 ? false : _param_body, children = _param.children, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "div" : tmp, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "bg",
        "text",
        "border",
        "body",
        "children",
        "as"
    ]);
    var prefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "card");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix, bg && "bg-".concat(bg), text && "text-".concat(text), border && "border-".concat(border)),
        children: body ? /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $315e35ef1f8639b3$export$2e2bcd8739ae039), {
            children: children
        }) : children
    }));
});
$e837d155498b80f2$var$Card.displayName = "Card";
var $e837d155498b80f2$export$2e2bcd8739ae039 = Object.assign($e837d155498b80f2$var$Card, {
    Img: (0, $e369e9e40d9ae7b0$export$2e2bcd8739ae039),
    Title: (0, $ea055b44f3422068$export$2e2bcd8739ae039),
    Subtitle: (0, $59b75cff8215526e$export$2e2bcd8739ae039),
    Body: (0, $315e35ef1f8639b3$export$2e2bcd8739ae039),
    Link: (0, $badd33786cd9b067$export$2e2bcd8739ae039),
    Text: (0, $ac11c739ca0a627f$export$2e2bcd8739ae039),
    Header: (0, $338a1f5c4797c4cd$export$2e2bcd8739ae039),
    Footer: (0, $aec9d97ada81e461$export$2e2bcd8739ae039),
    ImgOverlay: (0, $58d90a9088fdd0b9$export$2e2bcd8739ae039)
});


var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");

var $2MTYX = parcelRequire("2MTYX");



var $33gHU = parcelRequire("33gHU");

var $c5rwh = parcelRequire("c5rwh");

var $2MTYX = parcelRequire("2MTYX");


var $3jzhD = parcelRequire("3jzhD");

var $gnDeW = parcelRequire("gnDeW");

var $33gHU = parcelRequire("33gHU");
function $f0d1fc6f252c9e47$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f0d1fc6f252c9e47$var$_toPropertyKey(arg) {
    var key = $f0d1fc6f252c9e47$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $gnDeW._)(key)) === "symbol" ? key : String(key);
}
function $f0d1fc6f252c9e47$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f0d1fc6f252c9e47$export$26cbf8c37e721e67(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $f0d1fc6f252c9e47$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $33gHU.useRef)(propValue !== undefined);
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)(defaultValue), 2), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $33gHU.useCallback)(function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _args = (0, $126a3ad0eef7c214$export$e62c166da838fa3)(args), value = _args[0], rest = _args.slice(1);
            var returnValue = handler == null ? void 0 : handler.apply(void 0, [
                value
            ].concat((0, $3jzhD._)(rest)));
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $f0d1fc6f252c9e47$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _ref = result, _defaultKey = $f0d1fc6f252c9e47$export$26cbf8c37e721e67(fieldName), defaultValue = _ref[_defaultKey], propsValue = _ref[fieldName], rest = $f0d1fc6f252c9e47$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($f0d1fc6f252c9e47$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = (0, $2MTYX._)($f0d1fc6f252c9e47$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), 2), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        var _obj;
        return Object.assign({}, rest, (_obj = {}, (0, $c5rwh._)(_obj, fieldName, value), (0, $c5rwh._)(_obj, handlerName, handler), _obj));
    }, props);
}







var $33gHU = parcelRequire("33gHU");
var $9bf1efd506de4be8$var$DropdownContext = /*#__PURE__*/ $33gHU.createContext(null);
var $9bf1efd506de4be8$export$2e2bcd8739ae039 = $9bf1efd506de4be8$var$DropdownContext;



var $2MTYX = parcelRequire("2MTYX");

var $33gHU = parcelRequire("33gHU");



var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");

var $33gHU = parcelRequire("33gHU");
var $e720145b3d6bea34$var$has = Object.prototype.hasOwnProperty;
function $e720145b3d6bea34$var$find(iter, tar, key) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = iter.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            key = _step.value;
            if ($e720145b3d6bea34$export$de8294bb3be0322f(key, tar)) return key;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $e720145b3d6bea34$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $e720145b3d6bea34$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = foo[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    len = _step.value;
                    tmp = len;
                    if (tmp && typeof tmp === "object") {
                        tmp = $e720145b3d6bea34$var$find(bar, tmp);
                        if (!tmp) return false;
                    }
                    if (!bar.has(tmp)) return false;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = foo[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    len = _step1.value;
                    tmp = len[0];
                    if (tmp && typeof tmp === "object") {
                        tmp = $e720145b3d6bea34$var$find(bar, tmp);
                        if (!tmp) return false;
                    }
                    if (!$e720145b3d6bea34$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === "object") {
            len = 0;
            for(ctor in foo){
                if ($e720145b3d6bea34$var$has.call(foo, ctor) && ++len && !$e720145b3d6bea34$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$e720145b3d6bea34$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $33gHU = parcelRequire("33gHU");

/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $9818531b92202df8$var$useSafeState(state) {
    var isMounted = (0, $f76f1451b40a5807$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $33gHU.useCallback)(function(nextState) {
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $9818531b92202df8$export$2e2bcd8739ae039 = $9818531b92202df8$var$useSafeState;



function $f9d884b554ea4bf4$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $1e4f141c0d6b4103$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $bbffdd6323c1f82e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $bbffdd6323c1f82e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $bbffdd6323c1f82e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $72df85f12ea79b54$export$8960430cfd85939f = Math.max;
var $72df85f12ea79b54$export$96ec731ed4dcb222 = Math.min;
var $72df85f12ea79b54$export$2077e0241d6afd3c = Math.round;



function $4637f1b0681fa27a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $b1834fcf2fae3cca$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $4637f1b0681fa27a$export$2e2bcd8739ae039)());
}


function $60809149f86c2179$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(element) ? (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b1834fcf2fae3cca$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $103f1f67b99aec04$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $60809149f86c2179$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $39cf95a59efb4181$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $bbffdd6323c1f82e$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $4a1bdbded0efa4e8$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}



function $3e3b1486c04ee7a8$export$2e2bcd8739ae039(element) {
    return (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $582da07d1f9d6e0d$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(element)) >= 0;
}




function $cff48eaff5e06d70$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $bc26653e17f18903$export$2e2bcd8739ae039(element) {
    if ((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $bbffdd6323c1f82e$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $5f7645d1b576086d$var$getTrueOffsetParent(element) {
    if (!(0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $5f7645d1b576086d$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $4637f1b0681fa27a$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $4637f1b0681fa27a$export$2e2bcd8739ae039)());
    if (isIE && (0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $bc26653e17f18903$export$2e2bcd8739ae039)(element);
    if ((0, $bbffdd6323c1f82e$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $5f7645d1b576086d$export$2e2bcd8739ae039(element) {
    var window = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(element);
    var offsetParent = $5f7645d1b576086d$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $582da07d1f9d6e0d$export$2e2bcd8739ae039)(offsetParent) && (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $5f7645d1b576086d$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $5f7645d1b576086d$var$getContainingBlock(element) || window;
}


function $e0d7cc9881440195$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $a7122274de1cc429$export$f28d906d67a997f3(min, value, max) {
    return (0, $72df85f12ea79b54$export$8960430cfd85939f)(min, (0, $72df85f12ea79b54$export$96ec731ed4dcb222)(value, max));
}
function $a7122274de1cc429$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $a7122274de1cc429$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $55af678c44975866$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $8dd19ddc34578741$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $55af678c44975866$export$2e2bcd8739ae039)(), paddingObject);
}


function $a96029e4eb2bae52$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $22e99ddc6089aa5c$export$1e95b668f3b82d = "top";
var $22e99ddc6089aa5c$export$40e543e69a8b3fbb = "bottom";
var $22e99ddc6089aa5c$export$79ffe56a765070d2 = "right";
var $22e99ddc6089aa5c$export$eabcd2c8791e7bf4 = "left";
var $22e99ddc6089aa5c$export$dfb5619354ba860 = "auto";
var $22e99ddc6089aa5c$export$aec2ce47c367b8c3 = [
    $22e99ddc6089aa5c$export$1e95b668f3b82d,
    $22e99ddc6089aa5c$export$40e543e69a8b3fbb,
    $22e99ddc6089aa5c$export$79ffe56a765070d2,
    $22e99ddc6089aa5c$export$eabcd2c8791e7bf4
];
var $22e99ddc6089aa5c$export$b3571188c770cc5a = "start";
var $22e99ddc6089aa5c$export$bd5df0f255a350f8 = "end";
var $22e99ddc6089aa5c$export$390fd549c5303b4d = "clippingParents";
var $22e99ddc6089aa5c$export$d7b7311ec04a3e8f = "viewport";
var $22e99ddc6089aa5c$export$ae5ab1c730825774 = "popper";
var $22e99ddc6089aa5c$export$ca50aac9f3ba507f = "reference";
var $22e99ddc6089aa5c$export$368f9a87e87fa4e1 = /*#__PURE__*/ $22e99ddc6089aa5c$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $22e99ddc6089aa5c$export$b3571188c770cc5a,
        placement + "-" + $22e99ddc6089aa5c$export$bd5df0f255a350f8
    ]);
}, []);
var $22e99ddc6089aa5c$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($22e99ddc6089aa5c$export$aec2ce47c367b8c3, [
    $22e99ddc6089aa5c$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $22e99ddc6089aa5c$export$b3571188c770cc5a,
        placement + "-" + $22e99ddc6089aa5c$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $22e99ddc6089aa5c$export$421679a7c3d56e = "beforeRead";
var $22e99ddc6089aa5c$export$aafa59e2e03f2942 = "read";
var $22e99ddc6089aa5c$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $22e99ddc6089aa5c$export$c65e99957a05207c = "beforeMain";
var $22e99ddc6089aa5c$export$f22da7240b7add18 = "main";
var $22e99ddc6089aa5c$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $22e99ddc6089aa5c$export$8d4d2d70e7d46032 = "beforeWrite";
var $22e99ddc6089aa5c$export$68d8715fc104d294 = "write";
var $22e99ddc6089aa5c$export$70a6e5159acce2e6 = "afterWrite";
var $22e99ddc6089aa5c$export$d087d3878fdf71d5 = [
    $22e99ddc6089aa5c$export$421679a7c3d56e,
    $22e99ddc6089aa5c$export$aafa59e2e03f2942,
    $22e99ddc6089aa5c$export$6964f6c886723980,
    $22e99ddc6089aa5c$export$c65e99957a05207c,
    $22e99ddc6089aa5c$export$f22da7240b7add18,
    $22e99ddc6089aa5c$export$bab79516f2d662fe,
    $22e99ddc6089aa5c$export$8d4d2d70e7d46032,
    $22e99ddc6089aa5c$export$68d8715fc104d294,
    $22e99ddc6089aa5c$export$70a6e5159acce2e6
];


var $187ac7d7e133663b$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $8dd19ddc34578741$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $a96029e4eb2bae52$export$2e2bcd8739ae039)(padding, (0, $22e99ddc6089aa5c$export$aec2ce47c367b8c3)));
};
function $187ac7d7e133663b$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $e0d7cc9881440195$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4),
        (0, $22e99ddc6089aa5c$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $187ac7d7e133663b$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $103f1f67b99aec04$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $22e99ddc6089aa5c$export$1e95b668f3b82d) : (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb) : (0, $22e99ddc6089aa5c$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5f7645d1b576086d$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $a7122274de1cc429$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $187ac7d7e133663b$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $39cf95a59efb4181$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $187ac7d7e133663b$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $187ac7d7e133663b$var$arrow,
    effect: $187ac7d7e133663b$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $82387fc5bc72ad7c$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $ccbbd6437d6f1dc0$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $ccbbd6437d6f1dc0$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $ccbbd6437d6f1dc0$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4);
    var sideY = (0, $22e99ddc6089aa5c$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5f7645d1b576086d$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(popper);
            if ((0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $22e99ddc6089aa5c$export$1e95b668f3b82d) || (placement === (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4) || placement === (0, $22e99ddc6089aa5c$export$79ffe56a765070d2)) && variation === (0, $22e99ddc6089aa5c$export$bd5df0f255a350f8)) {
            sideY = (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4) || (placement === (0, $22e99ddc6089aa5c$export$1e95b668f3b82d) || placement === (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb)) && variation === (0, $22e99ddc6089aa5c$export$bd5df0f255a350f8)) {
            sideX = (0, $22e99ddc6089aa5c$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $ccbbd6437d6f1dc0$var$unsetSides);
    var _ref4 = roundOffsets === true ? $ccbbd6437d6f1dc0$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $ccbbd6437d6f1dc0$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $ccbbd6437d6f1dc0$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $ccbbd6437d6f1dc0$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ccbbd6437d6f1dc0$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $ccbbd6437d6f1dc0$var$computeStyles,
    data: {}
};



var $ac76324de7a4bf14$var$passive = {
    passive: true
};
function $ac76324de7a4bf14$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $ac76324de7a4bf14$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $ac76324de7a4bf14$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $ac76324de7a4bf14$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $ac76324de7a4bf14$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ac76324de7a4bf14$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $ac76324de7a4bf14$var$effect,
    data: {}
};


var $280b7124a30a8a0e$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $280b7124a30a8a0e$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $280b7124a30a8a0e$var$hash[matched];
    });
}



var $45cb87f5d981a852$var$hash = {
    start: "end",
    end: "start"
};
function $45cb87f5d981a852$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $45cb87f5d981a852$var$hash[matched];
    });
}








function $0457e65694e7b463$export$2e2bcd8739ae039(node) {
    var win = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $82e56b3c9202f1bc$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $60809149f86c2179$export$2e2bcd8739ae039)((0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(element)).left + (0, $0457e65694e7b463$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $ed96f5b6e84ce0d6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(element);
    var html = (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b1834fcf2fae3cca$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $82e56b3c9202f1bc$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $bead1d02fb1ff5b7$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0457e65694e7b463$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $72df85f12ea79b54$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $72df85f12ea79b54$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $82e56b3c9202f1bc$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $72df85f12ea79b54$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $07fcf859739eaae8$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $4af9f5dd66ae033b$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(node) && (0, $07fcf859739eaae8$export$2e2bcd8739ae039)(node)) return node;
    return $4af9f5dd66ae033b$export$2e2bcd8739ae039((0, $bc26653e17f18903$export$2e2bcd8739ae039)(node));
}





function $bdbb9e30d785ac6a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $4af9f5dd66ae033b$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $07fcf859739eaae8$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($bdbb9e30d785ac6a$export$2e2bcd8739ae039((0, $bc26653e17f18903$export$2e2bcd8739ae039)(target)));
}










function $f29ca087f4c184d0$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $4c533b586cbb17f5$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $60809149f86c2179$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $4c533b586cbb17f5$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $22e99ddc6089aa5c$export$d7b7311ec04a3e8f) ? (0, $f29ca087f4c184d0$export$2e2bcd8739ae039)((0, $ed96f5b6e84ce0d6$export$2e2bcd8739ae039)(element, strategy)) : (0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(clippingParent) ? $4c533b586cbb17f5$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $f29ca087f4c184d0$export$2e2bcd8739ae039)((0, $bead1d02fb1ff5b7$export$2e2bcd8739ae039)((0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $4c533b586cbb17f5$var$getClippingParents(element) {
    var clippingParents = (0, $bdbb9e30d785ac6a$export$2e2bcd8739ae039)((0, $bc26653e17f18903$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(element) ? (0, $5f7645d1b576086d$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(clippingParent) && (0, $39cf95a59efb4181$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $4c533b586cbb17f5$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $4c533b586cbb17f5$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $4c533b586cbb17f5$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $72df85f12ea79b54$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $72df85f12ea79b54$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $72df85f12ea79b54$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $72df85f12ea79b54$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $4c533b586cbb17f5$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $c0a524493d0afb7d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $22e99ddc6089aa5c$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $22e99ddc6089aa5c$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $e0d7cc9881440195$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $22e99ddc6089aa5c$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $22e99ddc6089aa5c$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $50ef0f40f7ca922c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $22e99ddc6089aa5c$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $22e99ddc6089aa5c$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $22e99ddc6089aa5c$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $8dd19ddc34578741$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $a96029e4eb2bae52$export$2e2bcd8739ae039)(padding, (0, $22e99ddc6089aa5c$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $22e99ddc6089aa5c$export$ae5ab1c730825774) ? (0, $22e99ddc6089aa5c$export$ca50aac9f3ba507f) : (0, $22e99ddc6089aa5c$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $4c533b586cbb17f5$export$2e2bcd8739ae039)((0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $60809149f86c2179$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $c0a524493d0afb7d$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $f29ca087f4c184d0$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $22e99ddc6089aa5c$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $22e99ddc6089aa5c$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $22e99ddc6089aa5c$export$79ffe56a765070d2),
                (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $22e99ddc6089aa5c$export$1e95b668f3b82d),
                (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $c934dccc7bdf321d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $22e99ddc6089aa5c$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $22e99ddc6089aa5c$export$368f9a87e87fa4e1) : (0, $22e99ddc6089aa5c$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $22e99ddc6089aa5c$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $50ef0f40f7ca922c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $c7ad662b98d4d1dc$var$getExpandedFallbackPlacements(placement) {
    if ((0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement) === (0, $22e99ddc6089aa5c$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $280b7124a30a8a0e$export$2e2bcd8739ae039)(placement);
    return [
        (0, $45cb87f5d981a852$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $45cb87f5d981a852$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $c7ad662b98d4d1dc$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $280b7124a30a8a0e$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $c7ad662b98d4d1dc$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement) === (0, $22e99ddc6089aa5c$export$dfb5619354ba860) ? (0, $c934dccc7bdf321d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(placement) === (0, $22e99ddc6089aa5c$export$b3571188c770cc5a);
        var isVertical = [
            (0, $22e99ddc6089aa5c$export$1e95b668f3b82d),
            (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $50ef0f40f7ca922c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $22e99ddc6089aa5c$export$79ffe56a765070d2) : (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb) : (0, $22e99ddc6089aa5c$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $280b7124a30a8a0e$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $280b7124a30a8a0e$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $c7ad662b98d4d1dc$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $c7ad662b98d4d1dc$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $2d88d9f94be5b0ba$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $2d88d9f94be5b0ba$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $22e99ddc6089aa5c$export$1e95b668f3b82d),
        (0, $22e99ddc6089aa5c$export$79ffe56a765070d2),
        (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb),
        (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $2d88d9f94be5b0ba$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $50ef0f40f7ca922c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $50ef0f40f7ca922c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $2d88d9f94be5b0ba$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $2d88d9f94be5b0ba$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $2d88d9f94be5b0ba$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $2d88d9f94be5b0ba$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $2d88d9f94be5b0ba$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $2d88d9f94be5b0ba$var$hide
};




function $311ce567045aea2b$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4),
        (0, $22e99ddc6089aa5c$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4),
        (0, $22e99ddc6089aa5c$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $311ce567045aea2b$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $22e99ddc6089aa5c$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $311ce567045aea2b$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $311ce567045aea2b$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $311ce567045aea2b$var$offset
};



function $3133aaf1ec566bd5$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $c0a524493d0afb7d$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3133aaf1ec566bd5$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $3133aaf1ec566bd5$var$popperOffsets,
    data: {}
};





function $e4efa183da5e1e17$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $00a8e20b8c0bfbdf$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $50ef0f40f7ca922c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $e0d7cc9881440195$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $e4efa183da5e1e17$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $22e99ddc6089aa5c$export$1e95b668f3b82d) : (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb) : (0, $22e99ddc6089aa5c$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $22e99ddc6089aa5c$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $22e99ddc6089aa5c$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $103f1f67b99aec04$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $55af678c44975866$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $a7122274de1cc429$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5f7645d1b576086d$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $a7122274de1cc429$export$f28d906d67a997f3)(tether ? (0, $72df85f12ea79b54$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $72df85f12ea79b54$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $22e99ddc6089aa5c$export$1e95b668f3b82d) : (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb) : (0, $22e99ddc6089aa5c$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $22e99ddc6089aa5c$export$1e95b668f3b82d),
            (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $a7122274de1cc429$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $a7122274de1cc429$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $00a8e20b8c0bfbdf$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $00a8e20b8c0bfbdf$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};







function $8d58228048724510$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $1112e259f7d2e76a$export$2e2bcd8739ae039(node) {
    if (node === (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(node) || !(0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(node)) return (0, $0457e65694e7b463$export$2e2bcd8739ae039)(node);
    else return (0, $8d58228048724510$export$2e2bcd8739ae039)(node);
}








function $97cb7d18733c60e6$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $97cb7d18733c60e6$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(offsetParent) && $97cb7d18733c60e6$var$isElementScaled(offsetParent);
    var documentElement = (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $60809149f86c2179$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $07fcf859739eaae8$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $1112e259f7d2e76a$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $60809149f86c2179$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $82e56b3c9202f1bc$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $02405386c900bb58$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $02405386c900bb58$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $02405386c900bb58$var$order(modifiers); // order based on phase
    return (0, $22e99ddc6089aa5c$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $dcb610874f96ade2$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f0869ad452512909$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $c029c2062637204e$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $c029c2062637204e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $c029c2062637204e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $c029c2062637204e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $c029c2062637204e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(reference) ? (0, $bdbb9e30d785ac6a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $bdbb9e30d785ac6a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $bdbb9e30d785ac6a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $02405386c900bb58$export$2e2bcd8739ae039)((0, $f0869ad452512909$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$c029c2062637204e$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $97cb7d18733c60e6$export$2e2bcd8739ae039)(_$reference, (0, $5f7645d1b576086d$export$2e2bcd8739ae039)(_$popper), state.options.strategy === "fixed"),
                    popper: (0, $103f1f67b99aec04$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dcb610874f96ade2$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$c029c2062637204e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $c029c2062637204e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $c029c2062637204e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


var $437ad2da9fb5d41c$export$8f7491d57c8f97a9 = (0, $c029c2062637204e$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $2d88d9f94be5b0ba$export$2e2bcd8739ae039),
        (0, $3133aaf1ec566bd5$export$2e2bcd8739ae039),
        (0, $ccbbd6437d6f1dc0$export$2e2bcd8739ae039),
        (0, $ac76324de7a4bf14$export$2e2bcd8739ae039),
        (0, $311ce567045aea2b$export$2e2bcd8739ae039),
        (0, $c7ad662b98d4d1dc$export$2e2bcd8739ae039),
        (0, $00a8e20b8c0bfbdf$export$2e2bcd8739ae039),
        (0, $187ac7d7e133663b$export$2e2bcd8739ae039)
    ]
});


var $c99da2897f34eec5$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $c99da2897f34eec5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $c99da2897f34eec5$var$disabledApplyStylesModifier = {
    name: "applyStyles",
    enabled: false,
    phase: "afterWrite",
    fn: function() {
        return undefined;
    }
};
// until docjs supports type exports...
var $c99da2897f34eec5$var$ariaDescribedByModifier = {
    name: "ariaDescribedBy",
    enabled: true,
    phase: "afterWrite",
    effect: function(param) {
        var state = param.state;
        return function() {
            var _state_elements = state.elements, reference = _state_elements.reference, popper = _state_elements.popper;
            if ("removeAttribute" in reference) {
                var ids = (reference.getAttribute("aria-describedby") || "").split(",").filter(function(id) {
                    return id.trim() !== popper.id;
                });
                if (!ids.length) reference.removeAttribute("aria-describedby");
                else reference.setAttribute("aria-describedby", ids.join(","));
            }
        };
    },
    fn: function(param) {
        var state = param.state;
        var _popper$getAttribute;
        var _state_elements = state.elements, popper = _state_elements.popper, reference = _state_elements.reference;
        var role = (_popper$getAttribute = popper.getAttribute("role")) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === "tooltip" && "setAttribute" in reference) {
            var ids = reference.getAttribute("aria-describedby");
            if (ids && ids.split(",").indexOf(popper.id) !== -1) return;
            reference.setAttribute("aria-describedby", ids ? "".concat(ids, ",").concat(popper.id) : popper.id);
        }
    }
};
var $c99da2897f34eec5$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $c99da2897f34eec5$var$usePopper(referenceElement, popperElement) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _ref_enabled = _ref.enabled, enabled = _ref_enabled === void 0 ? true : _ref_enabled, _ref_placement = _ref.placement, placement = _ref_placement === void 0 ? "bottom" : _ref_placement, _ref_strategy = _ref.strategy, strategy = _ref_strategy === void 0 ? "absolute" : _ref_strategy, _ref_modifiers = _ref.modifiers, modifiers = _ref_modifiers === void 0 ? $c99da2897f34eec5$var$EMPTY_MODIFIERS : _ref_modifiers, config = $c99da2897f34eec5$var$_objectWithoutPropertiesLoose(_ref, $c99da2897f34eec5$var$_excluded);
    var prevModifiers = (0, $33gHU.useRef)(modifiers);
    var popperInstanceRef = (0, $33gHU.useRef)();
    var update = (0, $33gHU.useCallback)(function() {
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    var forceUpdate = (0, $33gHU.useCallback)(function() {
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    var _useSafeState = (0, $2MTYX._)((0, $9818531b92202df8$export$2e2bcd8739ae039)((0, $33gHU.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    })), 2), popperState = _useSafeState[0], setState = _useSafeState[1];
    var updateModifier = (0, $33gHU.useMemo)(function() {
        return {
            name: "updateStateModifier",
            enabled: true,
            phase: "write",
            requires: [
                "computeStyles"
            ],
            fn: function(param) {
                var state = param.state;
                var styles = {};
                var attributes = {};
                Object.keys(state.elements).forEach(function(element) {
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        };
    }, [
        update,
        forceUpdate,
        setState
    ]);
    var nextModifiers = (0, $33gHU.useMemo)(function() {
        if (!(0, $e720145b3d6bea34$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $33gHU.useEffect)(function() {
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: (0, $3jzhD._)(nextModifiers).concat([
                updateModifier,
                $c99da2897f34eec5$var$disabledApplyStylesModifier
            ])
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $33gHU.useEffect)(function() {
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $437ad2da9fb5d41c$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: (0, $3jzhD._)(nextModifiers).concat([
                $c99da2897f34eec5$var$ariaDescribedByModifier,
                updateModifier
            ])
        }));
        return function() {
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState(function(s) {
                    return Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    });
                });
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $c99da2897f34eec5$export$2e2bcd8739ae039 = $c99da2897f34eec5$var$usePopper;






var $33gHU = parcelRequire("33gHU");


var $9640c1c5e4976d67$var$noop = function() {};
function $9640c1c5e4976d67$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $9640c1c5e4976d67$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $9640c1c5e4976d67$export$347601c75fcd4732 = function(ref) {
    return ref && ("current" in ref ? ref.current : ref);
};
var $9640c1c5e4976d67$var$InitialTriggerEvents = {
    click: "mousedown",
    mouseup: "mousedown",
    pointerup: "pointerdown"
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $9640c1c5e4976d67$var$useClickOutside(ref) {
    var onClickOutside = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $9640c1c5e4976d67$var$noop, _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, disabled = _ref.disabled, _ref_clickTrigger = _ref.clickTrigger, clickTrigger = _ref_clickTrigger === void 0 ? "click" : _ref_clickTrigger;
    var preventMouseClickOutsideRef = (0, $33gHU.useRef)(false);
    var waitingForTrigger = (0, $33gHU.useRef)(false);
    var handleMouseCapture = (0, $33gHU.useCallback)(function(e) {
        var currentTarget = $9640c1c5e4976d67$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($7b1e807e6b1a71ff$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $9640c1c5e4976d67$var$isModifiedEvent(e) || !$9640c1c5e4976d67$var$isLeftClickEvent(e) || !!(0, $a784322fcbc350d7$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    var handleInitialMouse = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function(e) {
        var currentTarget = $9640c1c5e4976d67$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $a784322fcbc350d7$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
    });
    var handleMouse = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function(e) {
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $33gHU.useEffect)(function() {
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        var doc = (0, $cb03b130654deaba$export$2e2bcd8739ae039)($9640c1c5e4976d67$export$347601c75fcd4732(ref));
        var ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        var currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        var removeInitialTriggerListener = null;
        if ($9640c1c5e4976d67$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(doc, $9640c1c5e4976d67$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        var removeMouseCaptureListener = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        var removeMouseListener = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(doc, clickTrigger, function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        var mobileSafariHackListeners = [];
        if ("ontouchstart" in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map(function(el) {
            return (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(el, "mousemove", $9640c1c5e4976d67$var$noop);
        });
        return function() {
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach(function(remove) {
                return remove();
            });
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $9640c1c5e4976d67$export$2e2bcd8739ae039 = $9640c1c5e4976d67$var$useClickOutside;


function $9b1686afd4a79021$export$ba6dad097c8f5c38(modifiers) {
    var result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach(function(m) {
        result[m.name] = m;
    });
    return result;
}
function $9b1686afd4a79021$export$af3a999d4a134c86() {
    var map = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (Array.isArray(map)) return map;
    return Object.keys(map).map(function(k) {
        map[k].name = k;
        return map[k];
    });
}
function $9b1686afd4a79021$export$2e2bcd8739ae039(param) {
    var enabled = param.enabled, enableEvents = param.enableEvents, placement = param.placement, flip = param.flip, offset = param.offset, fixed = param.fixed, containerPadding = param.containerPadding, arrowElement = param.arrowElement, _param_popperConfig = param.popperConfig, popperConfig = _param_popperConfig === void 0 ? {} : _param_popperConfig;
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    var modifiers = $9b1686afd4a79021$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? "fixed" : popperConfig.strategy,
        modifiers: $9b1686afd4a79021$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



var $bc5e9bd4f2154de0$var$_excluded = [
    "children",
    "usePopper"
];
function $bc5e9bd4f2154de0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $bc5e9bd4f2154de0$var$noop = function() {};
function $bc5e9bd4f2154de0$export$133c4d08f3775d64() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var context = (0, $33gHU.useContext)((0, $9bf1efd506de4be8$export$2e2bcd8739ae039));
    var _useCallbackRef = (0, $2MTYX._)((0, $04457dad5314d7c2$export$2e2bcd8739ae039)(), 2), arrowElement = _useCallbackRef[0], attachArrowRef = _useCallbackRef[1];
    var hasShownRef = (0, $33gHU.useRef)(false);
    var flip = options.flip, offset = options.offset, rootCloseEvent = options.rootCloseEvent, _options_fixed = options.fixed, fixed = _options_fixed === void 0 ? false : _options_fixed, placementOverride = options.placement, _options_popperConfig = options.popperConfig, popperConfig = _options_popperConfig === void 0 ? {} : _options_popperConfig, _options_enableEventListeners = options.enableEventListeners, enableEventListeners = _options_enableEventListeners === void 0 ? true : _options_enableEventListeners, tmp = options.usePopper, shouldUsePopper = tmp === void 0 ? !!context : tmp;
    var show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    var handleClose = function(e) {
        context == null || context.toggle(false, e);
    };
    var _ref = context || {}, placement = _ref.placement, setMenu = _ref.setMenu, menuElement = _ref.menuElement, toggleElement = _ref.toggleElement;
    var popper = (0, $c99da2897f34eec5$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $9b1686afd4a79021$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || "bottom-start",
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    var menuProps = Object.assign({
        ref: setMenu || $bc5e9bd4f2154de0$var$noop,
        "aria-labelledby": toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    var metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $9640c1c5e4976d67$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $bc5e9bd4f2154de0$var$DropdownMenu(_ref) {
    var children = _ref.children, tmp = _ref.usePopper, usePopperProp = tmp === void 0 ? true : tmp, options = $bc5e9bd4f2154de0$var$_objectWithoutPropertiesLoose(_ref, $bc5e9bd4f2154de0$var$_excluded);
    var _useDropdownMenu = (0, $2MTYX._)($bc5e9bd4f2154de0$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    })), 2), props = _useDropdownMenu[0], meta = _useDropdownMenu[1];
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $978b871a0234f592$exports.Fragment), {
        children: children(props, meta)
    });
}
$bc5e9bd4f2154de0$var$DropdownMenu.displayName = "DropdownMenu";
var /** @component */ $bc5e9bd4f2154de0$export$2e2bcd8739ae039 = $bc5e9bd4f2154de0$var$DropdownMenu;



var $2MTYX = parcelRequire("2MTYX");

var $33gHU = parcelRequire("33gHU");

var $2MTYX = parcelRequire("2MTYX");

var $33gHU = parcelRequire("33gHU");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
var $290dd9e77fea375a$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
var $290dd9e77fea375a$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createContext($290dd9e77fea375a$var$$b5e257d569688ac6$var$defaultContext);
var $290dd9e77fea375a$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createContext(false);
// This is only used in React < 18.
function $290dd9e77fea375a$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    var cur = (0, $33gHU.useContext)($290dd9e77fea375a$var$$b5e257d569688ac6$var$SSRContext);
    var counter = $290dd9e77fea375a$var$$b5e257d569688ac6$var$useCounter(cur === $290dd9e77fea375a$var$$b5e257d569688ac6$var$defaultContext);
    var _$73SJx$useState = (0, $2MTYX._)((0, $33gHU.useState)(true), 2), isSSR = _$73SJx$useState[0], setIsSSR = _$73SJx$useState[1];
    var value = (0, $33gHU.useMemo)(function() {
        return {
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $290dd9e77fea375a$var$$b5e257d569688ac6$var$defaultContext ? "" : "".concat(cur.prefix, "-").concat(counter),
            current: 0
        };
    }, [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, $33gHU.useLayoutEffect)(function() {
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement($290dd9e77fea375a$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement($290dd9e77fea375a$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
var $290dd9e77fea375a$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $290dd9e77fea375a$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($33gHU)))["useId"] === "function") {
        if (!$290dd9e77fea375a$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $290dd9e77fea375a$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement($290dd9e77fea375a$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
var $290dd9e77fea375a$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
var $290dd9e77fea375a$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $290dd9e77fea375a$var$$b5e257d569688ac6$var$useCounter() {
    var isDisabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ctx = (0, $33gHU.useContext)($290dd9e77fea375a$var$$b5e257d569688ac6$var$SSRContext);
    var ref = (0, $33gHU.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        var currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            var prevComponentValue = $290dd9e77fea375a$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $290dd9e77fea375a$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $290dd9e77fea375a$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $290dd9e77fea375a$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    var ctx = (0, $33gHU.useContext)($290dd9e77fea375a$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $290dd9e77fea375a$var$$b5e257d569688ac6$var$defaultContext && !$290dd9e77fea375a$var$$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    var counter = $290dd9e77fea375a$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    var prefix = "react-aria".concat(ctx.prefix);
    return defaultId || "".concat(prefix, "-").concat(counter);
}
function $290dd9e77fea375a$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).useId();
    var _$73SJx$useState = (0, $2MTYX._)((0, $33gHU.useState)($290dd9e77fea375a$export$535bd6ca7f90a273()), 1), didSSR = _$73SJx$useState[0];
    var prefix = didSSR || false ? "react-aria" : "react-aria".concat($290dd9e77fea375a$var$$b5e257d569688ac6$var$defaultContext.prefix);
    return defaultId || "".concat(prefix, "-").concat(id);
}
var $290dd9e77fea375a$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($33gHU)))["useId"] === "function" ? $290dd9e77fea375a$var$$b5e257d569688ac6$var$useModernSSRSafeId : $290dd9e77fea375a$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $290dd9e77fea375a$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $290dd9e77fea375a$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $290dd9e77fea375a$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return function() {};
}
function $290dd9e77fea375a$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($33gHU)))["useSyncExternalStore"] === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($33gHU)))["useSyncExternalStore"]($290dd9e77fea375a$var$$b5e257d569688ac6$var$subscribe, $290dd9e77fea375a$var$$b5e257d569688ac6$var$getSnapshot, $290dd9e77fea375a$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $33gHU.useContext)($290dd9e77fea375a$var$$b5e257d569688ac6$var$IsSSRContext);
}




var $f8bb537433324bfe$export$386b1213cf9779d8 = function(el) {
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute("role")) == null ? void 0 : _el$getAttribute.toLowerCase()) === "menu";
};
var $f8bb537433324bfe$var$noop = function() {};
function $f8bb537433324bfe$export$96df6c7c5036b9a2() {
    var id = (0, $290dd9e77fea375a$export$619500959fc48b26)();
    var _ref = (0, $33gHU.useContext)((0, $9bf1efd506de4be8$export$2e2bcd8739ae039)) || {}, _ref_show = _ref.show, show = _ref_show === void 0 ? false : _ref_show, _ref_toggle = _ref.toggle, toggle = _ref_toggle === void 0 ? $f8bb537433324bfe$var$noop : _ref_toggle, setToggle = _ref.setToggle, menuElement = _ref.menuElement;
    var handleClick = (0, $33gHU.useCallback)(function(e) {
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    var props = {
        id: id,
        ref: setToggle || $f8bb537433324bfe$var$noop,
        onClick: handleClick,
        "aria-expanded": !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $f8bb537433324bfe$export$386b1213cf9779d8(menuElement)) props["aria-haspopup"] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $f8bb537433324bfe$var$DropdownToggle(param) {
    var children = param.children;
    var _useDropdownToggle = (0, $2MTYX._)($f8bb537433324bfe$export$96df6c7c5036b9a2(), 2), props = _useDropdownToggle[0], meta = _useDropdownToggle[1];
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $978b871a0234f592$exports.Fragment), {
        children: children(props, meta)
    });
}
$f8bb537433324bfe$var$DropdownToggle.displayName = "DropdownToggle";
var /** @component */ $f8bb537433324bfe$export$2e2bcd8739ae039 = $f8bb537433324bfe$var$DropdownToggle;



var $c5rwh = parcelRequire("c5rwh");

var $2MTYX = parcelRequire("2MTYX");

var $33gHU = parcelRequire("33gHU");






var $9d5db36dedeee6da$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $9d5db36dedeee6da$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9d5db36dedeee6da$export$522d7e1e4e0e22b2(param) {
    var key = param.key, href = param.href, active = param.active, disabled = param.disabled, onClick = param.onClick;
    var onSelectCtx = (0, $33gHU.useContext)((0, $8bb37319c3c01fa2$export$2e2bcd8739ae039));
    var navContext = (0, $33gHU.useContext)((0, $023d6c7d475cb822$export$2e2bcd8739ae039));
    var activeKey = (navContext || {}).activeKey;
    var eventKey = (0, $8bb37319c3c01fa2$export$eef49b42fde998a3)(key, href);
    var isActive = active == null && key != null ? (0, $8bb37319c3c01fa2$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    var handleClick = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function(event) {
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        (0, $c5rwh._)({
            onClick: handleClick,
            "aria-disabled": disabled || undefined,
            "aria-selected": isActive
        }, (0, $162a9cd685a6cce4$export$5cc3b7b83e34ade7)("dropdown-item"), ""),
        {
            isActive: isActive
        }
    ];
}
var $9d5db36dedeee6da$var$DropdownItem = /*#__PURE__*/ $33gHU.forwardRef(function(_ref, ref) {
    var eventKey = _ref.eventKey, disabled = _ref.disabled, onClick = _ref.onClick, active = _ref.active, tmp = _ref.as, Component = tmp === void 0 ? (0, $9c3ffb28ddbab696$export$2e2bcd8739ae039) : tmp, props = $9d5db36dedeee6da$var$_objectWithoutPropertiesLoose(_ref, $9d5db36dedeee6da$var$_excluded);
    var _useDropdownItem = (0, $2MTYX._)($9d5db36dedeee6da$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    }), 1), dropdownItemProps = _useDropdownItem[0];
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$9d5db36dedeee6da$var$DropdownItem.displayName = "DropdownItem";
var $9d5db36dedeee6da$export$2e2bcd8739ae039 = $9d5db36dedeee6da$var$DropdownItem;






function $0be784168f5b2de1$var$useRefWithUpdate() {
    var forceUpdate = (0, $7bd5d7a67f11e31b$export$2e2bcd8739ae039)();
    var ref = (0, $33gHU.useRef)(null);
    var attachRef = (0, $33gHU.useCallback)(function(element) {
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $0be784168f5b2de1$var$Dropdown(param) {
    var defaultShow = param.defaultShow, rawShow = param.show, onSelect = param.onSelect, rawOnToggle = param.onToggle, _param_itemSelector = param.itemSelector, itemSelector = _param_itemSelector === void 0 ? "* [".concat((0, $162a9cd685a6cce4$export$5cc3b7b83e34ade7)("dropdown-item"), "]") : _param_itemSelector, focusFirstItemOnShow = param.focusFirstItemOnShow, _param_placement = param.placement, placement = _param_placement === void 0 ? "bottom-start" : _param_placement, children = param.children;
    var window = (0, $485dbf221aa58992$export$2e2bcd8739ae039)();
    var _useUncontrolledProp = (0, $2MTYX._)((0, $f0d1fc6f252c9e47$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle), 2), show = _useUncontrolledProp[0], onToggle = _useUncontrolledProp[1];
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    var _useRefWithUpdate = (0, $2MTYX._)($0be784168f5b2de1$var$useRefWithUpdate(), 2), menuRef = _useRefWithUpdate[0], setMenu = _useRefWithUpdate[1];
    var menuElement = menuRef.current;
    var _useRefWithUpdate1 = (0, $2MTYX._)($0be784168f5b2de1$var$useRefWithUpdate(), 2), toggleRef = _useRefWithUpdate1[0], setToggle = _useRefWithUpdate1[1];
    var toggleElement = toggleRef.current;
    var lastShow = (0, $7e4ad4faf3b19879$export$2e2bcd8739ae039)(show);
    var lastSourceEvent = (0, $33gHU.useRef)(null);
    var focusInDropdown = (0, $33gHU.useRef)(false);
    var onSelectCtx = (0, $33gHU.useContext)((0, $8bb37319c3c01fa2$export$2e2bcd8739ae039));
    var toggle = (0, $33gHU.useCallback)(function(nextShow, event) {
        var source = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : event == null ? void 0 : event.type;
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    var handleSelect = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function(key, event) {
        onSelect == null || onSelect(key, event);
        toggle(false, event, "select");
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    var context = (0, $33gHU.useMemo)(function() {
        return {
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        };
    }, [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    var focusToggle = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function() {
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    var maybeFocusFirst = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function() {
        var type = lastSourceEvent.current;
        var focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $f8bb537433324bfe$export$386b1213cf9779d8)(menuRef.current) ? "keyboard" : false;
        if (focusType === false || focusType === "keyboard" && !/^key.+$/.test(type)) return;
        var first = (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $33gHU.useEffect)(function() {
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $33gHU.useEffect)(function() {
        lastSourceEvent.current = null;
    });
    var getNextFocusedChild = function(current, offset) {
        if (!menuRef.current) return null;
        var items = (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        var index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $99b6c887a840e037$export$2e2bcd8739ae039)((0, $33gHU.useCallback)(function() {
        return window.document;
    }, [
        window
    ]), "keydown", function(event) {
        var _menuRef$current, _toggleRef$current;
        var key = event.key;
        var target = event.target;
        var fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        var fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        var isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === " " || key !== "Escape" && fromMenu || key === "Escape" && target.type === "search")) return;
        if (!fromMenu && !fromToggle) return;
        if (key === "Tab" && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        var meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case "ArrowUp":
                {
                    var next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case "ArrowDown":
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    var next1 = getNextFocusedChild(target, 1);
                    if (next1 && next1.focus) next1.focus();
                }
                return;
            case "Tab":
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $fe9809a8616a080a$export$2e2bcd8739ae039)(target.ownerDocument, "keyup", function(e) {
                    var _menuRef$current2;
                    if (e.key === "Tab" && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case "Escape":
                if (key === "Escape") {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $8bb37319c3c01fa2$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $9bf1efd506de4be8$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$0be784168f5b2de1$var$Dropdown.displayName = "Dropdown";
$0be784168f5b2de1$var$Dropdown.Menu = (0, $bc5e9bd4f2154de0$export$2e2bcd8739ae039);
$0be784168f5b2de1$var$Dropdown.Toggle = (0, $f8bb537433324bfe$export$2e2bcd8739ae039);
$0be784168f5b2de1$var$Dropdown.Item = (0, $9d5db36dedeee6da$export$2e2bcd8739ae039);
var $0be784168f5b2de1$export$2e2bcd8739ae039 = $0be784168f5b2de1$var$Dropdown;





var $33gHU = parcelRequire("33gHU");
"use client";
var $1343997f2e8e9505$var$DropdownContext = /*#__PURE__*/ $33gHU.createContext({});
$1343997f2e8e9505$var$DropdownContext.displayName = "DropdownContext";
var $1343997f2e8e9505$export$2e2bcd8739ae039 = $1343997f2e8e9505$var$DropdownContext;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");



"use client";
var $ce960b015cd7ab9f$var$DropdownDivider = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? "hr" : tmp, _param_role = _param.role, role = _param_role === void 0 ? "separator" : _param_role, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as",
        "role"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "dropdown-divider");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        role: role
    }, props));
});
$ce960b015cd7ab9f$var$DropdownDivider.displayName = "DropdownDivider";
var $ce960b015cd7ab9f$export$2e2bcd8739ae039 = $ce960b015cd7ab9f$var$DropdownDivider;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");



"use client";
var $8add908b2d0f66a4$var$DropdownHeader = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? "div" : tmp, _param_role = _param.role, role = _param_role === void 0 ? "heading" : _param_role, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as",
        "role"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "dropdown-header");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        role: role
    }, props));
});
$8add908b2d0f66a4$var$DropdownHeader.displayName = "DropdownHeader";
var $8add908b2d0f66a4$export$2e2bcd8739ae039 = $8add908b2d0f66a4$var$DropdownHeader;



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $2MTYX = parcelRequire("2MTYX");


var $33gHU = parcelRequire("33gHU");




"use client";
var $ca3314c7747f2a7b$var$DropdownItem = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, eventKey = _param.eventKey, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, onClick = _param.onClick, active = _param.active, tmp = _param.as, Component = tmp === void 0 ? (0, $4e409ba5516ae23a$export$2e2bcd8739ae039) : tmp, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "eventKey",
        "disabled",
        "onClick",
        "active",
        "as"
    ]);
    var prefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "dropdown-item");
    var _useDropdownItem = (0, $2MTYX._)((0, $9d5db36dedeee6da$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    }), 2), dropdownItemProps = _useDropdownItem[0], meta = _useDropdownItem[1];
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({}, props, dropdownItemProps), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix, meta.isActive && "active", disabled && "disabled")
    }));
});
$ca3314c7747f2a7b$var$DropdownItem.displayName = "DropdownItem";
var $ca3314c7747f2a7b$export$2e2bcd8739ae039 = $ca3314c7747f2a7b$var$DropdownItem;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");



"use client";
var $1da36d46eaa53050$var$DropdownItemText = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? "span" : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "dropdown-item-text");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$1da36d46eaa53050$var$DropdownItemText.displayName = "DropdownItemText";
var $1da36d46eaa53050$export$2e2bcd8739ae039 = $1da36d46eaa53050$var$DropdownItemText;



var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");


var $33gHU = parcelRequire("33gHU");






var $33gHU = parcelRequire("33gHU");
"use client";
var $e32e9ca885952727$var$context = /*#__PURE__*/ $33gHU.createContext(null);
$e32e9ca885952727$var$context.displayName = "InputGroupContext";
var $e32e9ca885952727$export$2e2bcd8739ae039 = $e32e9ca885952727$var$context;





parcelRequire("33gHU");

function $1d6468d501521f4b$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




"use client";
function $219f829b704e530f$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    var topStart = isRTL ? "top-end" : "top-start";
    var topEnd = isRTL ? "top-start" : "top-end";
    var bottomStart = isRTL ? "bottom-end" : "bottom-start";
    var bottomEnd = isRTL ? "bottom-start" : "bottom-end";
    var leftStart = isRTL ? "right-start" : "left-start";
    var leftEnd = isRTL ? "right-end" : "left-end";
    var rightStart = isRTL ? "left-start" : "right-start";
    var rightEnd = isRTL ? "left-end" : "right-end";
    var placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === "up") placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === "end") placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === "start") placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === "down-centered") placement = "bottom";
    else if (dropDirection === "up-centered") placement = "top";
    return placement;
}
var $219f829b704e530f$var$DropdownMenu = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, align = _param.align, rootCloseEvent = _param.rootCloseEvent, _param_flip = _param.flip, flip = _param_flip === void 0 ? true : _param_flip, showProps = _param.show, renderOnMount = _param.renderOnMount, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "div" : tmp, popperConfig = _param.popperConfig, variant = _param.variant, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "align",
        "rootCloseEvent",
        "flip",
        "show",
        "renderOnMount",
        "as",
        "popperConfig",
        "variant"
    ]);
    var alignEnd = false;
    var isNavbar = (0, $33gHU.useContext)((0, $5f48e6ab02225624$export$2e2bcd8739ae039));
    var prefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "dropdown-menu");
    var _useContext = (0, $33gHU.useContext)((0, $1343997f2e8e9505$export$2e2bcd8739ae039)), contextAlign = _useContext.align, drop = _useContext.drop, isRTL = _useContext.isRTL;
    align = align || contextAlign;
    var isInputGroup = (0, $33gHU.useContext)((0, $e32e9ca885952727$export$2e2bcd8739ae039));
    var alignClasses = [];
    if (align) {
        if (typeof align === "object") {
            var keys = Object.keys(align);
            if (keys.length) {
                var brkPoint = keys[0];
                var direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === "start";
                alignClasses.push("".concat(prefix, "-").concat(brkPoint, "-").concat(direction));
            }
        } else if (align === "end") alignEnd = true;
    }
    var placement = $219f829b704e530f$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    var _useDropdownMenu = (0, $2MTYX._)((0, $bc5e9bd4f2154de0$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    }), 2), menuProps = _useDropdownMenu[0], _useDropdownMenu_ = _useDropdownMenu[1], hasShown = _useDropdownMenu_.hasShown, popper = _useDropdownMenu_.popper, show = _useDropdownMenu_.show, toggle = _useDropdownMenu_.toggle;
    menuProps.ref = (0, $0bc64fd3b15ed530$export$2e2bcd8739ae039)((0, $1d6468d501521f4b$export$2e2bcd8739ae039)(ref, "DropdownMenu"), menuProps.ref);
    (0, $5987dd645a9ebdaf$export$2e2bcd8739ae039)(function() {
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== "string") {
        menuProps.show = show;
        menuProps.close = function() {
            return toggle == null ? void 0 : toggle(false);
        };
        menuProps.align = align;
    }
    var style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = (0, $78DQ7._)({}, props.style, menuProps.style);
        props["x-placement"] = popper.placement;
    }
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)((0, $ddevm._)((0, $78DQ7._)({}, props, menuProps), {
        style: style
    }), (alignClasses.length || isNavbar) && {
        "data-bs-popper": "static"
    }), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports))).apply(void 0, [
            className,
            prefix,
            show && "show",
            alignEnd && "".concat(prefix, "-end"),
            variant && "".concat(prefix, "-").concat(variant)
        ].concat((0, $3jzhD._)(alignClasses)))
    }));
});
$219f829b704e530f$var$DropdownMenu.displayName = "DropdownMenu";
var $219f829b704e530f$export$2e2bcd8739ae039 = $219f829b704e530f$var$DropdownMenu;



var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $2MTYX = parcelRequire("2MTYX");





var $33gHU = parcelRequire("33gHU");




"use client";
var $5c981b03f9098223$var$DropdownToggle = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, split = _param.split, className = _param.className, childBsPrefix = _param.childBsPrefix, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? (0, $91cc833ad6e8123a$export$2e2bcd8739ae039) : tmp, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "split",
        "className",
        "childBsPrefix",
        "as"
    ]);
    var prefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "dropdown-toggle");
    var dropdownContext = (0, $33gHU.useContext)((0, $9bf1efd506de4be8$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    var _useDropdownToggle = (0, $2MTYX._)((0, $f8bb537433324bfe$export$96df6c7c5036b9a2)(), 1), toggleProps = _useDropdownToggle[0];
    toggleProps.ref = (0, $0bc64fd3b15ed530$export$2e2bcd8739ae039)(toggleProps.ref, (0, $1d6468d501521f4b$export$2e2bcd8739ae039)(ref, "DropdownToggle"));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix, split && "".concat(prefix, "-split"), (dropdownContext == null ? void 0 : dropdownContext.show) && "show")
    }, toggleProps, props));
});
$5c981b03f9098223$var$DropdownToggle.displayName = "DropdownToggle";
var $5c981b03f9098223$export$2e2bcd8739ae039 = $5c981b03f9098223$var$DropdownToggle;






"use client";
var $bd394f94f7da712c$var$Dropdown = /*#__PURE__*/ $33gHU.forwardRef(function(pProps, ref) {
    var _useUncontrolled = (0, $b0f4ffe1e3920233$export$2e2bcd8739ae039)(pProps, {
        show: "onToggle"
    }), bsPrefix = _useUncontrolled.bsPrefix, _useUncontrolled_drop = _useUncontrolled.drop, drop = _useUncontrolled_drop === void 0 ? "down" : _useUncontrolled_drop, show = _useUncontrolled.show, className = _useUncontrolled.className, _useUncontrolled_align = _useUncontrolled.align, align = _useUncontrolled_align === void 0 ? "start" : _useUncontrolled_align, onSelect = _useUncontrolled.onSelect, onToggle = _useUncontrolled.onToggle, focusFirstItemOnShow = _useUncontrolled.focusFirstItemOnShow, tmp = _useUncontrolled.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "div" : tmp, _4 = _useUncontrolled.navbar, _useUncontrolled_autoClose = _useUncontrolled.autoClose, autoClose = _useUncontrolled_autoClose === void 0 ? true : _useUncontrolled_autoClose, props = (0, $6JqHh._)(_useUncontrolled, [
        "bsPrefix",
        "drop",
        "show",
        "className",
        "align",
        "onSelect",
        "onToggle",
        "focusFirstItemOnShow",
        "as",
        "navbar",
        "autoClose"
    ]);
    var isInputGroup = (0, $33gHU.useContext)((0, $e32e9ca885952727$export$2e2bcd8739ae039));
    var prefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "dropdown");
    var isRTL = (0, $48ea4dae63926a21$export$35e511eefa30ac5a)();
    var isClosingPermitted = function(source) {
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === "click";
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === "inside") return source !== "rootClose";
        // autoClose=outside doesn't permit close on select
        if (autoClose === "outside") return source !== "select";
        return true;
    };
    var handleToggle = (0, $2a722d1c3948cf16$export$2e2bcd8739ae039)(function(nextShow, meta) {
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ var isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains("dropdown-toggle");
        if (isToggleButton && meta.source === "mousedown") return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== "keydown" || meta.originalEvent.key === "Escape")) meta.source = "rootClose";
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    var alignEnd = align === "end";
    var placement = (0, $219f829b704e530f$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    var contextValue = (0, $33gHU.useMemo)(function() {
        return {
            align: align,
            drop: drop,
            isRTL: isRTL
        };
    }, [
        align,
        drop,
        isRTL
    ]);
    var directionClasses = {
        down: prefix,
        "down-centered": "".concat(prefix, "-center"),
        up: "dropup",
        "up-centered": "dropup-center dropup",
        end: "dropend",
        start: "dropstart"
    };
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $1343997f2e8e9505$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $0be784168f5b2de1$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: ".".concat(prefix, "-item:not(.disabled):not(:disabled)"),
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({}, props), {
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, show && "show", directionClasses[drop])
            }))
        })
    });
});
$bd394f94f7da712c$var$Dropdown.displayName = "Dropdown";
var $bd394f94f7da712c$export$2e2bcd8739ae039 = Object.assign($bd394f94f7da712c$var$Dropdown, {
    Toggle: (0, $5c981b03f9098223$export$2e2bcd8739ae039),
    Menu: (0, $219f829b704e530f$export$2e2bcd8739ae039),
    Item: (0, $ca3314c7747f2a7b$export$2e2bcd8739ae039),
    ItemText: (0, $1da36d46eaa53050$export$2e2bcd8739ae039),
    Divider: (0, $ce960b015cd7ab9f$export$2e2bcd8739ae039),
    Header: (0, $8add908b2d0f66a4$export$2e2bcd8739ae039)
});


var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");





var $32758743411b9d14$var$alignDirection = (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).oneOf([
    "start",
    "end"
]);
var $32758743411b9d14$export$5dd51d61a30477bc = (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).oneOfType([
    $32758743411b9d14$var$alignDirection,
    (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).shape({
        sm: $32758743411b9d14$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).shape({
        md: $32758743411b9d14$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).shape({
        lg: $32758743411b9d14$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).shape({
        xl: $32758743411b9d14$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).shape({
        xxl: $32758743411b9d14$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).object
]);



var $762a6fc3e030bfa7$var$propTypes = {
    /**
   * An html id attribute for the Toggle button, necessary for assistive technologies, such as screen readers.
   * @type {string}
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string,
    /** An `href` passed to the Toggle component */ href: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string,
    /** An `onClick` handler passed to the Toggle component */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).func,
    /** The content of the non-toggle Button.  */ title: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).node.isRequired,
    /** Disables both Buttons  */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    /**
   * Aligns the dropdown menu.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   *
   * @type {"start"|"end"|{ sm: "start"|"end" }|{ md: "start"|"end" }|{ lg: "start"|"end" }|{ xl: "start"|"end"}|{ xxl: "start"|"end"} }
   */ align: (0, $32758743411b9d14$export$5dd51d61a30477bc),
    /** An ARIA accessible role applied to the Menu component. When set to 'menu', The dropdown */ menuRole: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string,
    /** Whether to render the dropdown menu in the DOM before the first time it is shown */ renderMenuOnMount: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    /**
   *  Which event when fired outside the component will cause it to be closed.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   */ rootCloseEvent: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string,
    /**
   * Menu color variant.
   *
   * Omitting this will use the default light color.
   */ menuVariant: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).oneOf([
        "dark"
    ]),
    /**
   * Allow Dropdown to flip in case of an overlapping on the reference element. For more information refer to
   * Popper.js's flip [docs](https://popper.js.org/docs/v2/modifiers/flip/).
   *
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    /** @ignore */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string,
    /** @ignore */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string,
    /** @ignore */ size: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string
};
/**
 * A convenience component for simple or general use dropdowns. Renders a `Button` toggle and all `children`
 * are passed directly to the default `Dropdown.Menu`. This component accepts all of
 * [`Dropdown`'s props](#dropdown-props).
 *
 * _All unknown props are passed through to the `Dropdown` component._ Only
 * the Button `variant`, `size` and `bsPrefix` props are passed to the toggle,
 * along with menu-related props are passed to the `Dropdown.Menu`
 */ var $762a6fc3e030bfa7$var$DropdownButton = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var title = _param.title, children = _param.children, bsPrefix = _param.bsPrefix, rootCloseEvent = _param.rootCloseEvent, variant = _param.variant, size = _param.size, menuRole = _param.menuRole, renderMenuOnMount = _param.renderMenuOnMount, disabled = _param.disabled, href = _param.href, id = _param.id, menuVariant = _param.menuVariant, flip = _param.flip, props = (0, $6JqHh._)(_param, [
        "title",
        "children",
        "bsPrefix",
        "rootCloseEvent",
        "variant",
        "size",
        "menuRole",
        "renderMenuOnMount",
        "disabled",
        "href",
        "id",
        "menuVariant",
        "flip"
    ]);
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)((0, $bd394f94f7da712c$export$2e2bcd8739ae039), (0, $ddevm._)((0, $78DQ7._)({
        ref: ref
    }, props), {
        children: [
            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $5c981b03f9098223$export$2e2bcd8739ae039), {
                id: id,
                href: href,
                size: size,
                variant: variant,
                disabled: disabled,
                childBsPrefix: bsPrefix,
                children: title
            }),
            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $219f829b704e530f$export$2e2bcd8739ae039), {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                variant: menuVariant,
                flip: flip,
                children: children
            })
        ]
    }));
});
$762a6fc3e030bfa7$var$DropdownButton.displayName = "DropdownButton";
$762a6fc3e030bfa7$var$DropdownButton.propTypes = $762a6fc3e030bfa7$var$propTypes;
var $762a6fc3e030bfa7$export$2e2bcd8739ae039 = $762a6fc3e030bfa7$var$DropdownButton;


var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");




var $78DQ7 = parcelRequire("78DQ7");

var $6JqHh = parcelRequire("6JqHh");

var $33gHU = parcelRequire("33gHU");



"use client";
var $678b5276d12462b9$var$InputGroupText = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? "span" : tmp, props = (0, $6JqHh._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "input-group-text");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $78DQ7._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$678b5276d12462b9$var$InputGroupText.displayName = "InputGroupText";
var $678b5276d12462b9$export$2e2bcd8739ae039 = $678b5276d12462b9$var$InputGroupText;



"use client";
var $763424a18f4fe9b9$var$InputGroupCheckbox = function(props) {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $678b5276d12462b9$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $490176695dbad129$export$2e2bcd8739ae039), (0, $78DQ7._)({
            type: "checkbox"
        }, props))
    });
};
var $763424a18f4fe9b9$var$InputGroupRadio = function(props) {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $678b5276d12462b9$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $490176695dbad129$export$2e2bcd8739ae039), (0, $78DQ7._)({
            type: "radio"
        }, props))
    });
};
var $763424a18f4fe9b9$var$InputGroup = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, size = _param.size, hasValidation = _param.hasValidation, className = _param.className, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "div" : tmp, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "size",
        "hasValidation",
        "className",
        "as"
    ]);
    bsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "input-group");
    // Intentionally an empty object. Used in detecting if a dropdown
    // exists under an input group.
    var contextValue = (0, $33gHU.useMemo)(function() {
        return {};
    }, []);
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $e32e9ca885952727$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({
            ref: ref
        }, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, size && "".concat(bsPrefix, "-").concat(size), hasValidation && "has-validation")
        }))
    });
});
$763424a18f4fe9b9$var$InputGroup.displayName = "InputGroup";
var $763424a18f4fe9b9$export$2e2bcd8739ae039 = Object.assign($763424a18f4fe9b9$var$InputGroup, {
    Text: (0, $678b5276d12462b9$export$2e2bcd8739ae039),
    Radio: $763424a18f4fe9b9$var$InputGroupRadio,
    Checkbox: $763424a18f4fe9b9$var$InputGroupCheckbox
});


var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");


"use client";
var $1682d872d0b0712a$var$Table = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, striped = _param.striped, bordered = _param.bordered, borderless = _param.borderless, hover = _param.hover, size = _param.size, variant = _param.variant, responsive = _param.responsive, props = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "className",
        "striped",
        "bordered",
        "borderless",
        "hover",
        "size",
        "variant",
        "responsive"
    ]);
    var decoratedBsPrefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "table");
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, decoratedBsPrefix, variant && "".concat(decoratedBsPrefix, "-").concat(variant), size && "".concat(decoratedBsPrefix, "-").concat(size), striped && "".concat(decoratedBsPrefix, "-").concat(typeof striped === "string" ? "striped-".concat(striped) : "striped"), bordered && "".concat(decoratedBsPrefix, "-bordered"), borderless && "".concat(decoratedBsPrefix, "-borderless"), hover && "".concat(decoratedBsPrefix, "-hover"));
    var table = /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("table", (0, $ddevm._)((0, $78DQ7._)({}, props), {
        className: classes,
        ref: ref
    }));
    if (responsive) {
        var responsiveClass = "".concat(decoratedBsPrefix, "-responsive");
        if (typeof responsive === "string") responsiveClass = "".concat(responsiveClass, "-").concat(responsive);
        return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
var $1682d872d0b0712a$export$2e2bcd8739ae039 = $1682d872d0b0712a$var$Table;


var $eb4814f03261c715$export$63e82393dc8977bf;
var $eb4814f03261c715$export$e68dcb39baf5f164;
var $eb4814f03261c715$export$63777ce727b9cc2a;
var $eb4814f03261c715$export$188c0e4e8fd02eb7;
var $eb4814f03261c715$export$feea6ee10cb6b591;
var $eb4814f03261c715$export$a22c534828ded89d;
var $eb4814f03261c715$export$a5575dbeeffdad98;
$eb4814f03261c715$export$63e82393dc8977bf = "vard4W_imageContainer";
$eb4814f03261c715$export$e68dcb39baf5f164 = "vard4W_imagePreview";
$eb4814f03261c715$export$63777ce727b9cc2a = "vard4W_imageSwitch";
$eb4814f03261c715$export$188c0e4e8fd02eb7 = "vard4W_promptInput";
$eb4814f03261c715$export$feea6ee10cb6b591 = "vard4W_recorder";
$eb4814f03261c715$export$a22c534828ded89d = "vard4W_typeDropdown";
$eb4814f03261c715$export$a5575dbeeffdad98 = "vard4W_uploadFile";







var $2MTYX = parcelRequire("2MTYX");






var $33gHU = parcelRequire("33gHU");

var $b7f7046501e922f8$export$c407db72103fecfa;
var $b7f7046501e922f8$export$7fb14d88b977496e;
$b7f7046501e922f8$export$c407db72103fecfa = "hRUXpq_entry";
$b7f7046501e922f8$export$7fb14d88b977496e = "hRUXpq_image_preview";


var $59e2a228328fd3ff$export$1bc11a519365884e = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function(props) {
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)(new (0, $ddcb476d90fa761b$export$8536aa4ab0b165e5)()), 2), content = _useState[0], setContent = _useState[1];
    var toaster = (0, $3a3345637c0a5d6f$export$f46171b59bb094f9)();
    var lists = (0, $3a3345637c0a5d6f$export$3b5bae399c8431fb)();
    var assets = (0, $3a3345637c0a5d6f$export$bd973f06e9aaec8c)();
    var _useState1 = (0, $2MTYX._)((0, $33gHU.useState)(false), 2), didSave = _useState1[0], setDidSave = _useState1[1];
    (0, $33gHU.useEffect)(function() {
        var contentId = lists.categories.find(function(c) {
            return c.name == props.contentType;
        });
        content.name = props.name;
        content.categoryId = contentId.id;
        content.tryToEnhance();
    }, [
        content
    ]);
    var icon = assets.getContentIconUrl(content.category);
    return (0, $978b871a0234f592$exports.jsx)("tr", {
        children: (0, $978b871a0234f592$exports.jsx)("td", {
            children: (0, $978b871a0234f592$exports.jsx)((0, $1682d872d0b0712a$export$2e2bcd8739ae039), {
                className: $b7f7046501e922f8$export$c407db72103fecfa,
                children: (0, $978b871a0234f592$exports.jsxs)("tbody", {
                    children: [
                        (0, $978b871a0234f592$exports.jsxs)("tr", {
                            children: [
                                (0, $978b871a0234f592$exports.jsx)("td", {
                                    style: {
                                        width: 48,
                                        paddingRight: 2
                                    },
                                    children: (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
                                        iconSys: "content",
                                        size: "S"
                                    })
                                }),
                                (0, $978b871a0234f592$exports.jsx)("td", {
                                    style: {
                                        width: "100%"
                                    },
                                    children: content.name
                                }),
                                (0, $978b871a0234f592$exports.jsx)("td", {
                                    style: {
                                        width: 48
                                    },
                                    children: (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
                                        iconSys: "plus",
                                        size: "S",
                                        onClick: function() {
                                            if (!didSave) {
                                                content.save();
                                                setDidSave(true);
                                                toaster.addMessage("> Content Added: ".concat(props.name, " / ").concat(props.contentType));
                                            }
                                        }
                                    })
                                })
                            ]
                        }),
                        (0, $978b871a0234f592$exports.jsx)("tr", {
                            children: (0, $978b871a0234f592$exports.jsx)("td", {
                                className: $b7f7046501e922f8$export$7fb14d88b977496e,
                                colSpan: 3,
                                children: (0, $978b871a0234f592$exports.jsx)("img", {
                                    src: content.thumbnailURL
                                })
                            })
                        }),
                        (0, $978b871a0234f592$exports.jsx)("tr", {
                            children: (0, $978b871a0234f592$exports.jsx)("td", {
                                colSpan: 3,
                                children: content.overview
                            })
                        })
                    ]
                })
            })
        })
    }, content.name);
});


var $4eec23bac161afc8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4eec23bac161afc8$export$73e1527c1d8c3728 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var fb = (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)();
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)(""), 2), prompt = _useState[0], setPrompt = _useState[1];
    var _useState1 = (0, $2MTYX._)((0, $33gHU.useState)(null), 2), textResults = _useState1[0], setTextResults = _useState1[1];
    var _useState2 = (0, $2MTYX._)((0, $33gHU.useState)(null), 2), actionsResult = _useState2[0], setActionsResult = _useState2[1];
    var _useState3 = (0, $2MTYX._)((0, $33gHU.useState)(null), 2), imageUrl = _useState3[0], setImageUrl = _useState3[1];
    var _useState4 = (0, $2MTYX._)((0, $33gHU.useState)(null), 2), fileObject = _useState4[0], setFileObject = _useState4[1];
    var _useState5 = (0, $2MTYX._)((0, $33gHU.useState)(false), 2), sendImage = _useState5[0], setSendImage = _useState5[1];
    var _useState6 = (0, $2MTYX._)((0, $33gHU.useState)("A"), 2), selectedType = _useState6[0], setSelectedType = _useState6[1];
    var _useState7 = (0, $2MTYX._)((0, $33gHU.useState)("environment"), 2), cameraFaciingMode = _useState7[0], setCameraFacingMode = _useState7[1];
    var videoConstraints = {
        width: 1280,
        height: 720,
        facingMode: cameraFaciingMode
    };
    var webcamRef = (0, $33gHU.useRef)(null);
    var capture = (0, $33gHU.useCallback)(function() {
        return $4eec23bac161afc8$var$__awaiter(void 0, void 0, void 0, function() {
            var imageSrc, res, blob;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        imageSrc = webcamRef.current.getScreenshot();
                        setImageUrl(imageSrc);
                        return [
                            4,
                            fetch(imageSrc)
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            4,
                            res.blob()
                        ];
                    case 2:
                        blob = _state.sent();
                        setFileObject(new File([
                            blob
                        ], "capture", {
                            type: "image/jpeg"
                        }));
                        setSendImage(true);
                        return [
                            2
                        ];
                }
            });
        });
    }, [
        webcamRef,
        cameraFaciingMode
    ]);
    (0, $33gHU.useEffect)(function() {
        var workbox = (0, $3a3345637c0a5d6f$export$bdceb54baf319cd4)();
        var fetchSharedFile = function() {
            return $4eec23bac161afc8$var$__awaiter(void 0, void 0, void 0, function() {
                var _loop, data, i;
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _loop = function() {
                                var f = data.files[i];
                                var t = f.type;
                                if (t.startsWith("image")) onFileAdded(f);
                                else if (t.startsWith("text")) {
                                    var reader = new FileReader();
                                    reader.onload = function() {
                                        setPrompt(reader.result);
                                    };
                                    reader.readAsText(f);
                                }
                            };
                            return [
                                4,
                                workbox.messageSW({
                                    type: "GET_FILES_SHARED"
                                })
                            ];
                        case 1:
                            data = _state.sent();
                            if (!data || !data.files) return [
                                2
                            ];
                            for(i = 0; i < data.files.length; i++)_loop();
                            workbox.messageSW({
                                type: "CLEAR_FILES_SHARED"
                            });
                            return [
                                2
                            ];
                    }
                });
            });
        };
        fetchSharedFile();
    }, []);
    var onFileAdded = function(file) {
        return $4eec23bac161afc8$var$__awaiter(void 0, void 0, void 0, function() {
            return (0, $lF1I7.__generator)(this, function(_state) {
                setFileObject(file);
                setImageUrl(URL.createObjectURL(file));
                setSendImage(true);
                return [
                    2
                ];
            });
        });
    };
    (0, $33gHU.useEffect)(function() {
        var onPaste = function(e) {
            return $4eec23bac161afc8$var$__awaiter(void 0, void 0, void 0, function() {
                return (0, $lF1I7.__generator)(this, function(_state) {
                    try {
                        if (e.clipboardData.files.length == 0) return [
                            2
                        ];
                        onFileAdded(e.clipboardData.files[0]);
                    } catch (e) {
                        console.log(e);
                    }
                    return [
                        2
                    ];
                });
            });
        };
        window.addEventListener("paste", onPaste);
        return function() {
            window.removeEventListener("paste", onPaste);
        };
    }, []);
    var sendTextPrompt = function() {
        return $4eec23bac161afc8$var$__awaiter(void 0, void 0, void 0, function() {
            var ai, result, fo;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ai = (0, $41077b5e0f3767fc$export$a9ba05c6103248e9)();
                        result = null;
                        fo = sendImage ? fileObject : null;
                        switch(selectedType){
                            case "Q":
                                return [
                                    3,
                                    1
                                ];
                            case "A":
                                return [
                                    3,
                                    3
                                ];
                        }
                        return [
                            3,
                            5
                        ];
                    case 1:
                        return [
                            4,
                            ai.sendToOpenAI_Question(prompt, fo)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            ai.sendToOpenAI_GetAction(prompt, fo)
                        ];
                    case 4:
                        result = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 5:
                        if (result) {
                            if (selectedType == "A") setActionsResult(result);
                            else setTextResults(JSON.stringify(result));
                        }
                        return [
                            2
                        ];
                }
            });
        });
    };
    var processAction = function(command) {
        return $4eec23bac161afc8$var$__awaiter(void 0, void 0, void 0, function() {
            var toaster, _, newTask, lists, contentId, content;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        toaster = (0, $3a3345637c0a5d6f$export$f46171b59bb094f9)();
                        _ = command.action;
                        switch(_){
                            case "NewTask":
                                return [
                                    3,
                                    1
                                ];
                            case "NewContent":
                                return [
                                    3,
                                    3
                                ];
                        }
                        return [
                            3,
                            4
                        ];
                    case 1:
                        newTask = new (0, $f858d6a97cc5c220$export$1c98d9bfeea5177c)();
                        newTask.type = (0, $f858d6a97cc5c220$export$1f8b1cab05cab788).ONE_TIME;
                        newTask.name = command.name;
                        newTask.desc = command.description;
                        return [
                            4,
                            (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().saveDoc([
                                (0, $f858d6a97cc5c220$export$1c98d9bfeea5177c).DbSection
                            ], newTask)
                        ];
                    case 2:
                        _state.sent();
                        toaster.addMessage("> Task: ".concat(command.name));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        lists = (0, $3a3345637c0a5d6f$export$3b5bae399c8431fb)();
                        contentId = lists.categories.find(function(c) {
                            return c.name == command.contentType;
                        });
                        if (!contentId) {
                            alert("Invalid content type");
                            return [
                                2
                            ];
                        }
                        content = new (0, $ddcb476d90fa761b$export$8536aa4ab0b165e5)();
                        content.name = command.name;
                        content.categoryId = contentId.id;
                        toaster.addMessage("> Content Added: ".concat(command.name, " / ").concat(command.contentType));
                        content.save();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    var onTranscript = function(transcript) {
        setPrompt(transcript);
    };
    return (0, $978b871a0234f592$exports.jsxs)((0, $978b871a0234f592$exports.Fragment), {
        children: [
            (0, $978b871a0234f592$exports.jsx)((0, $e837d155498b80f2$export$2e2bcd8739ae039), {
                children: (0, $978b871a0234f592$exports.jsx)((0, $e837d155498b80f2$export$2e2bcd8739ae039).Body, {
                    children: (0, $978b871a0234f592$exports.jsxs)((0, $1bd9a712a9bb924e$export$2e2bcd8739ae039), {
                        className: "p-0",
                        children: [
                            (0, $978b871a0234f592$exports.jsx)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                                className: "pb-3",
                                children: (0, $978b871a0234f592$exports.jsxs)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                    xs: 12,
                                    children: [
                                        (0, $978b871a0234f592$exports.jsx)((0, $27113019bb4d8c5e$export$2e2bcd8739ae039).Control, {
                                            className: $eb4814f03261c715$export$188c0e4e8fd02eb7,
                                            as: "textarea",
                                            rows: 4,
                                            wrap: "hard",
                                            placeholder: "Prompt?",
                                            value: prompt,
                                            onChange: function(e) {
                                                return setPrompt(e.target.value);
                                            }
                                        }),
                                        (0, $978b871a0234f592$exports.jsx)((0, $226e9ff7925bc4d2$export$de95611a92ae0566), {
                                            className: $eb4814f03261c715$export$feea6ee10cb6b591,
                                            onTranscript: onTranscript
                                        })
                                    ]
                                })
                            }),
                            (0, $978b871a0234f592$exports.jsxs)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                                className: "pb-3 justify-content-between",
                                children: [
                                    (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                        xs: 2,
                                        children: (0, $978b871a0234f592$exports.jsx)((0, $50b3ec7e1b18edba$export$48030d8a30a8103a), {
                                            className: $eb4814f03261c715$export$a5575dbeeffdad98,
                                            onNewFile: onFileAdded
                                        })
                                    }),
                                    (0, $978b871a0234f592$exports.jsxs)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                        xs: 2,
                                        children: [
                                            (0, $978b871a0234f592$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c2ce9fc152d617b5$exports))), {
                                                audio: false,
                                                height: 720,
                                                ref: webcamRef,
                                                screenshotFormat: "image/jpeg",
                                                width: 1280,
                                                videoConstraints: videoConstraints
                                            }),
                                            (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
                                                iconSys: "camera",
                                                onClick: capture
                                            })
                                        ]
                                    }),
                                    (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                        xs: 3,
                                        className: "flex-fill"
                                    }),
                                    (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                        xs: 5,
                                        children: (0, $978b871a0234f592$exports.jsx)("div", {
                                            className: $eb4814f03261c715$export$a22c534828ded89d,
                                            children: (0, $978b871a0234f592$exports.jsxs)((0, $763424a18f4fe9b9$export$2e2bcd8739ae039), {
                                                children: [
                                                    (0, $978b871a0234f592$exports.jsxs)((0, $762a6fc3e030bfa7$export$2e2bcd8739ae039), {
                                                        variant: "outline-secondary",
                                                        title: selectedType == "Q" ? "Question" : "Action",
                                                        onSelect: function(e) {
                                                            setSelectedType(e);
                                                        },
                                                        children: [
                                                            (0, $978b871a0234f592$exports.jsx)((0, $bd394f94f7da712c$export$2e2bcd8739ae039).Item, {
                                                                eventKey: "Q",
                                                                children: "Question"
                                                            }),
                                                            (0, $978b871a0234f592$exports.jsx)((0, $bd394f94f7da712c$export$2e2bcd8739ae039).Item, {
                                                                eventKey: "A",
                                                                children: "Action"
                                                            })
                                                        ]
                                                    }),
                                                    (0, $978b871a0234f592$exports.jsx)((0, $91cc833ad6e8123a$export$2e2bcd8739ae039), {
                                                        onClick: function() {
                                                            sendTextPrompt();
                                                        },
                                                        children: "Send"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            actionsResult && (0, $978b871a0234f592$exports.jsx)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                                children: (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                    children: (0, $978b871a0234f592$exports.jsx)((0, $1bd9a712a9bb924e$export$2e2bcd8739ae039), {
                                        children: (0, $978b871a0234f592$exports.jsx)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                                            children: (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                                xs: 12,
                                                children: (0, $978b871a0234f592$exports.jsx)((0, $1682d872d0b0712a$export$2e2bcd8739ae039), {
                                                    striped: true,
                                                    bordered: true,
                                                    hover: true,
                                                    size: "sm",
                                                    children: (0, $978b871a0234f592$exports.jsx)("tbody", {
                                                        children: actionsResult.actions.map(function(e) {
                                                            return (0, $978b871a0234f592$exports.jsx)((0, $59e2a228328fd3ff$export$1bc11a519365884e), {
                                                                name: e.name,
                                                                contentType: e.contentType
                                                            }, e.name);
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            }),
                            imageUrl && (0, $978b871a0234f592$exports.jsx)((0, $978b871a0234f592$exports.Fragment), {
                                children: (0, $978b871a0234f592$exports.jsx)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                                    className: "pb-3",
                                    children: (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                        children: (0, $978b871a0234f592$exports.jsxs)("div", {
                                            className: $eb4814f03261c715$export$63e82393dc8977bf,
                                            children: [
                                                (0, $978b871a0234f592$exports.jsx)("img", {
                                                    id: "preview_img",
                                                    src: imageUrl,
                                                    alt: "your image",
                                                    className: $eb4814f03261c715$export$e68dcb39baf5f164
                                                }),
                                                (0, $978b871a0234f592$exports.jsx)((0, $27113019bb4d8c5e$export$2e2bcd8739ae039).Check // prettier-ignore
                                                , {
                                                    type: "switch",
                                                    id: "imageSwitch",
                                                    className: $eb4814f03261c715$export$63777ce727b9cc2a,
                                                    checked: fileObject && sendImage,
                                                    onChange: function(e) {
                                                        return setSendImage(e.target.checked);
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            (0, $978b871a0234f592$exports.jsx)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                                className: "pb-3",
                                children: (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                    children: textResults
                                })
                            })
                        ]
                    })
                })
            }),
            (0, $978b871a0234f592$exports.jsx)("canvas", {
                id: "canvas",
                children: " "
            })
        ]
    });
});






var $e5wYp = parcelRequire("e5wYp");
parcelRequire("33gHU");

function $dc81ed704caa9e3f$export$369b6b2b30582e8e(Class) {
    return function() {
        var location = (0, $89c54c76ed45b63d$export$45d76561a5302f2b)(), params = (0, $89c54c76ed45b63d$export$99eaa27ddbbb95ef)();
        var tmp = location.pathname, pathname = tmp === void 0 ? "/" : tmp, tmp1 = location.search, search = tmp1 === void 0 ? "" : tmp1, tmp2 = location.hash, hash = tmp2 === void 0 ? "" : tmp2;
        var path = pathname + search + hash;
        var match = {
            url: globalThis.location.origin + path,
            path: path,
            params: params
        }, query = (0, $e5wYp.parseURLData)(search);
        return (0, $978b871a0234f592$exports.jsx)(Class, {
            location: location,
            match: match,
            query: query
        });
    };
}





var $19mwo = parcelRequire("19mwo");

var $6rpfc = parcelRequire("6rpfc");

var $9ac934de5bbce2ae$export$28a0d76af7a168a = /*#__PURE__*/ function() {
    "use strict";
    function NavUtils(nav) {
        (0, $19mwo._)(this, NavUtils);
        Object.defineProperty(this, "nav", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: nav
        });
    }
    (0, $6rpfc._)(NavUtils, [
        {
            key: "toLists",
            value: function toLists() {
                this.nav("/lists");
            }
        },
        {
            key: "toContent",
            value: function toContent(contentId) {
                this.nav("/content/".concat(contentId));
            }
        },
        {
            key: "toEditTask",
            value: function toEditTask(taskId) {
                this.nav("/task/".concat(taskId));
            }
        },
        {
            key: "toViewTask",
            value: function toViewTask(taskId) {
                this.nav("/task/".concat(taskId));
            }
        },
        {
            key: "back",
            value: function back() {
                this.nav(-1);
            }
        }
    ]);
    return NavUtils;
}();
function $9ac934de5bbce2ae$export$726c44d912e0140f() {
    var nav = (0, $89c54c76ed45b63d$export$9770f232ac06a008)();
    return new $9ac934de5bbce2ae$export$28a0d76af7a168a(nav);
}



var $e1ba7a61d3bd48aa$export$a3ace71b162de3c8;
var $e1ba7a61d3bd48aa$export$fed04f446fd15195;
var $e1ba7a61d3bd48aa$export$1af2b11ae97e344e;
$e1ba7a61d3bd48aa$export$a3ace71b162de3c8 = "_6YvFKG_activeDay";
$e1ba7a61d3bd48aa$export$fed04f446fd15195 = "_6YvFKG_dayLabel";
$e1ba7a61d3bd48aa$export$1af2b11ae97e344e = "_6YvFKG_weeklyIconCell";




var $2MTYX = parcelRequire("2MTYX");






var $7PvJn = parcelRequire("7PvJn");

var $33gHU = parcelRequire("33gHU");



var $703abe984c2735f3$export$a3ace71b162de3c8;
var $703abe984c2735f3$export$3cbc07cbbf2ac742;
var $703abe984c2735f3$export$bdd23d6ae166559e;
var $703abe984c2735f3$export$fed04f446fd15195;
var $703abe984c2735f3$export$5dd12f6bcbb7a424;
var $703abe984c2735f3$export$f6f42d6320e6d689;
var $703abe984c2735f3$export$7c46c61af7b724fc;
var $703abe984c2735f3$export$1af2b11ae97e344e;
$703abe984c2735f3$export$a3ace71b162de3c8 = "cDk8Kq_activeDay";
$703abe984c2735f3$export$3cbc07cbbf2ac742 = "cDk8Kq_animateIcon";
$703abe984c2735f3$export$bdd23d6ae166559e = "cDk8Kq_dayContainer";
$703abe984c2735f3$export$fed04f446fd15195 = "cDk8Kq_dayLabel";
$703abe984c2735f3$export$5dd12f6bcbb7a424 = "cDk8Kq_dayTitle";
$703abe984c2735f3$export$f6f42d6320e6d689 = "cDk8Kq_fullSizeIcon";
$703abe984c2735f3$export$7c46c61af7b724fc = "cDk8Kq_grow";
$703abe984c2735f3$export$7c46c61af7b724fc;
$703abe984c2735f3$export$1af2b11ae97e344e = "cDk8Kq_weeklyIconCell";


var $761202b74f34e263$export$b07df79c15690501 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var tasksView = (0, $3a3345637c0a5d6f$export$b5afef939be034e8)();
    var tasks = (0, $3a3345637c0a5d6f$export$ed5c3368304694)();
    var nav = (0, $9ac934de5bbce2ae$export$726c44d912e0140f)();
    var ui = (0, $3a3345637c0a5d6f$export$edcd1bf374609759)();
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)(false), 2), triggerDraw = _useState[0], setDraw = _useState[1];
    var itemsRenderedRef = (0, $33gHU.useRef)([]);
    var itemsRendered = itemsRenderedRef.current;
    var selectedDay = ui.selectedDay;
    var firstRender = itemsRendered.length == 0;
    var statsView = tasksView.weeklyStats.map(function(day) {
        var iconsEl = [];
        var sorted = day.list.slice().sort(function(a, b) {
            return a.when.getTime() - b.when.getTime();
        });
        sorted.forEach(function(key) {
            var task = tasks.get(key.taskId);
            if (!task) return;
            var removeEntry = function() {
                var task = tasks.get(key.taskId);
                task.logs.removeEntry(key.id);
                if (task.type == (0, $f858d6a97cc5c220$export$1f8b1cab05cab788).ONE_TIME) task.setTaskState((0, $f858d6a97cc5c220$export$dcf4d221b45abc27).OPEN);
            };
            var iconStyle = [
                $703abe984c2735f3$export$1af2b11ae97e344e
            ];
            if (firstRender || itemsRendered.includes(key.id)) {
                iconStyle.push($703abe984c2735f3$export$f6f42d6320e6d689);
                itemsRendered.push(key.id);
            } else {
                iconStyle.push($703abe984c2735f3$export$3cbc07cbbf2ac742);
                setTimeout(function() {
                    itemsRendered.push(key.id);
                    setDraw(!triggerDraw);
                }, 3000);
            }
            iconsEl.push((0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
                className: iconStyle.join(" "),
                iconTask: task.icon,
                size: "S",
                // onClick={() => {
                //     console.log(key.when.getTime());
                // }}
                onHold: removeEntry
            }, key.id));
        });
        var dayDate = (0, (/*@__PURE__*/$parcel$interopDefault($7PvJn)))(day.date);
        var selectedDate = (0, (/*@__PURE__*/$parcel$interopDefault($7PvJn)))(selectedDay);
        var isSelected = dayDate.isSame(selectedDate, "day");
        return (0, $978b871a0234f592$exports.jsxs)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
            className: "justify-content-center p-0 " + $703abe984c2735f3$export$5dd12f6bcbb7a424,
            children: [
                (0, $978b871a0234f592$exports.jsx)("div", {
                    onClick: function() {
                        return ui.selectedDay = day.date;
                    },
                    className: (isSelected ? $703abe984c2735f3$export$a3ace71b162de3c8 : "") + " " + $703abe984c2735f3$export$fed04f446fd15195,
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($7PvJn)))(day.date).format("ddd")
                }),
                isSelected ? (0, $978b871a0234f592$exports.jsx)((0, $f999aa122d970e1d$export$53770483ed5ae606), {
                    id: "active",
                    type: "reporting_area"
                }) : null,
                (0, $978b871a0234f592$exports.jsx)("div", {
                    className: "d-flex flex-row flex-wrap justify-content-center w-100 align-items-start " + $703abe984c2735f3$export$bdd23d6ae166559e,
                    children: iconsEl
                })
            ]
        }, day.date.getTime());
    });
    return (0, $978b871a0234f592$exports.jsx)((0, $1bd9a712a9bb924e$export$2e2bcd8739ae039), {
        className: "p-3",
        children: (0, $978b871a0234f592$exports.jsx)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
            className: "d-flex justify-content-between",
            children: statsView
        })
    });
});


var $ca93ea259ddc746f$var$t = (0, $50993b47476de2e7$export$a7357cdd1f0b0168).t;
var $ca93ea259ddc746f$var$HomePage = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var store = (0, $3a3345637c0a5d6f$export$6ccbb43953eebf8)();
    var tasks = (0, $3a3345637c0a5d6f$export$ed5c3368304694)();
    var toaster = (0, $3a3345637c0a5d6f$export$f46171b59bb094f9)();
    var nav = (0, $9ac934de5bbce2ae$export$726c44d912e0140f)();
    var tasksView = (0, $3a3345637c0a5d6f$export$b5afef939be034e8)();
    var ui = (0, $3a3345637c0a5d6f$export$edcd1bf374609759)();
    var recurringTasks = tasks.weeklyTasks.map(function(task, i) {
        var onReportTaskDone = function() {
            var anim = (0, $3a3345637c0a5d6f$export$491715d4fdcd0f6b)();
            var from = anim.getPosition("weekly", task.id);
            var to = anim.getPosition("reporting_area", "active");
            if (!from || !to) return;
            var animStore = (0, $3a3345637c0a5d6f$export$491715d4fdcd0f6b)();
            animStore.animation = {
                from: from,
                to: to,
                icon: task.icon
            };
            var when = ui.selectedDay;
            var now = new Date();
            when.setHours(now.getHours());
            when.setMinutes(now.getMinutes());
            when.setSeconds(now.getSeconds());
            task.logs.addEntry(when, "WEEKLY");
        };
        return (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
            className: $e1ba7a61d3bd48aa$export$1af2b11ae97e344e,
            id: task.id,
            iconTask: task.icon,
            size: "L",
            onHold: onReportTaskDone,
            // onClick={() => nav.toViewTask(task.id)}
            tracker: "weekly"
        }, task.id);
    });
    return (0, $978b871a0234f592$exports.jsxs)((0, $1bd9a712a9bb924e$export$2e2bcd8739ae039), {
        className: "p-0",
        children: [
            (0, $978b871a0234f592$exports.jsx)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                children: (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                    className: "pt-2 d-flex flex-wrap",
                    children: recurringTasks
                })
            }),
            (0, $978b871a0234f592$exports.jsx)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                className: "pt-2",
                children: (0, $978b871a0234f592$exports.jsx)((0, $761202b74f34e263$export$b07df79c15690501), {})
            })
        ]
    });
});
var $ca93ea259ddc746f$export$2e2bcd8739ae039 = (0, $dc81ed704caa9e3f$export$369b6b2b30582e8e)($ca93ea259ddc746f$var$HomePage);





var $ecbaf4258c4fcc15$export$7ca21068e737e223 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    return (0, $978b871a0234f592$exports.jsx)((0, $c4905fef9a86a34d$export$5e19b9354e495cb9), {
        rating: 3,
        onChange: function(n) {}
    });
});



var $lF1I7 = parcelRequire("lF1I7");







var $7PvJn = parcelRequire("7PvJn");

var $33gHU = parcelRequire("33gHU");


var $c1de1ec6b15b7476$export$f3cbcc6ad82435d7;
var $c1de1ec6b15b7476$export$48c2d0f2f545ac27;
var $c1de1ec6b15b7476$export$fb184b623420d9be;
$c1de1ec6b15b7476$export$f3cbcc6ad82435d7 = "HUj7nW_overview";
$c1de1ec6b15b7476$export$48c2d0f2f545ac27 = "HUj7nW_preview";
$c1de1ec6b15b7476$export$fb184b623420d9be = "HUj7nW_title";



var $485ca850ecda6288$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var $485ca850ecda6288$require$Dropzone = $ab966853eba787d9$export$2e2bcd8739ae039;
var $485ca850ecda6288$export$c4ab9b8c1d035854 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var lists = (0, $3a3345637c0a5d6f$export$3b5bae399c8431fb)();
    var id = (0, $89c54c76ed45b63d$export$99eaa27ddbbb95ef)().id;
    var navUtils = (0, $9ac934de5bbce2ae$export$726c44d912e0140f)();
    (0, $33gHU.useEffect)(function() {
        var content = lists.contentList.find(function(l) {
            return l.id === id;
        });
        if (content && !content.thumbnailURL) {
            content.tryToEnhance();
            content.save();
        }
    }, [
        id
    ]);
    var onDelete = function() {
        return $485ca850ecda6288$var$__awaiter(void 0, void 0, void 0, function() {
            var content, p;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        content = lists.contentList.find(function(l) {
                            return l.id === id;
                        });
                        p = confirm("Are you sure you want to delete this content?");
                        if (!(p && content)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            content.delete()
                        ];
                    case 1:
                        _state.sent();
                        navUtils.toLists();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    };
    var content = lists.contentList.find(function(l) {
        return l.id === id;
    });
    var html = (0, $978b871a0234f592$exports.jsx)("div", {});
    if (content) {
        var img = content.thumbnailURL ? (0, $978b871a0234f592$exports.jsx)("img", {
            src: content.thumbnailURL,
            className: $c1de1ec6b15b7476$export$48c2d0f2f545ac27
        }) : null;
        var url = content.url ? (0, $978b871a0234f592$exports.jsx)("a", {
            href: content.url,
            target: "_blank",
            children: "Link"
        }) : null;
        var genres = content.genres.map(function(g) {
            return (0, $978b871a0234f592$exports.jsx)("div", {
                children: g
            }, g);
        });
        var formatDate = function(date) {
            if (!date) return "-";
            return (0, (/*@__PURE__*/$parcel$interopDefault($7PvJn)))(date).format("D/MM/YYYY");
        };
        html = (0, $978b871a0234f592$exports.jsxs)((0, $1bd9a712a9bb924e$export$2e2bcd8739ae039), {
            children: [
                (0, $978b871a0234f592$exports.jsx)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                    className: $c1de1ec6b15b7476$export$fb184b623420d9be,
                    children: (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                        children: content.name
                    })
                }),
                (0, $978b871a0234f592$exports.jsx)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                    children: (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                        className: $c1de1ec6b15b7476$export$f3cbcc6ad82435d7,
                        children: content.overview
                    })
                }),
                (0, $978b871a0234f592$exports.jsxs)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                    children: [
                        (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                            children: (0, $978b871a0234f592$exports.jsx)((0, $c4905fef9a86a34d$export$5e19b9354e495cb9), {
                                rating: content.user_rating,
                                onChange: function(rating) {
                                    content.user_rating = rating;
                                    content.user_dating_date = new Date();
                                    content.save();
                                //Move to auto save
                                }
                            })
                        }),
                        (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                            children: (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
                                iconSys: content.watchSoon ? "heart-yes-filled" : "heart-yes",
                                size: "M",
                                onClick: function() {
                                    content.watchSoon = !content.watchSoon;
                                    content.save();
                                }
                            })
                        })
                    ]
                }),
                (0, $978b871a0234f592$exports.jsxs)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                    children: [
                        (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                            xs: 6,
                            children: img
                        }),
                        (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                            xs: 6,
                            children: (0, $978b871a0234f592$exports.jsxs)((0, $1bd9a712a9bb924e$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $978b871a0234f592$exports.jsxs)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                                        children: [
                                            (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                                children: "Genres:"
                                            }),
                                            (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                                children: genres
                                            })
                                        ]
                                    }),
                                    (0, $978b871a0234f592$exports.jsxs)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                                        children: [
                                            (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                                children: "Release:"
                                            }),
                                            (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                                children: formatDate(content.releaseDate)
                                            })
                                        ]
                                    }),
                                    (0, $978b871a0234f592$exports.jsxs)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                                        children: [
                                            (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                                children: "Added:"
                                            }),
                                            (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                                children: formatDate(content.created)
                                            })
                                        ]
                                    }),
                                    (0, $978b871a0234f592$exports.jsxs)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                                        children: [
                                            (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                                children: "URL:"
                                            }),
                                            (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                                children: url
                                            })
                                        ]
                                    }),
                                    (0, $978b871a0234f592$exports.jsx)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                                        children: (0, $978b871a0234f592$exports.jsxs)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                            children: [
                                                (0, $978b871a0234f592$exports.jsx)((0, $27113019bb4d8c5e$export$2e2bcd8739ae039).Control, {
                                                    as: "textarea",
                                                    rows: 4,
                                                    wrap: "hard",
                                                    placeholder: "Your thoughts?",
                                                    value: content.user_notes,
                                                    onChange: function(e) {
                                                        content.user_notes = e.target.value;
                                                        content.save();
                                                    }
                                                }),
                                                (0, $978b871a0234f592$exports.jsx)((0, $226e9ff7925bc4d2$export$de95611a92ae0566), {
                                                    onTranscript: function(text) {
                                                        content.user_notes = text;
                                                        content.save();
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    (0, $978b871a0234f592$exports.jsx)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                                        children: (0, $978b871a0234f592$exports.jsxs)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                            children: [
                                                (0, $978b871a0234f592$exports.jsx)((0, $91cc833ad6e8123a$export$2e2bcd8739ae039), {
                                                    onClick: function() {
                                                        content.tryToEnhance();
                                                    },
                                                    children: "Enhance"
                                                }),
                                                (0, $978b871a0234f592$exports.jsx)((0, $91cc833ad6e8123a$export$2e2bcd8739ae039), {
                                                    onClick: onDelete,
                                                    children: "Delete"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    } else html = (0, $978b871a0234f592$exports.jsx)("div", {
        children: "Content not found"
    });
    return (0, $978b871a0234f592$exports.jsxs)((0, $e837d155498b80f2$export$2e2bcd8739ae039), {
        children: [
            (0, $978b871a0234f592$exports.jsx)((0, $e837d155498b80f2$export$2e2bcd8739ae039).Body, {
                className: "p-1 pt-3",
                children: html
            }),
            "."
        ]
    });
});



var $lF1I7 = parcelRequire("lF1I7");






var $b0lSM = parcelRequire("b0lSM");


var $dSxWp = parcelRequire("dSxWp");

var $33gHU = parcelRequire("33gHU");



var $b4a8bffbc728ae1e$export$cd37a9f26d44d7d1;
var $b4a8bffbc728ae1e$export$bb75d8e9c1af397c;
$b4a8bffbc728ae1e$export$cd37a9f26d44d7d1 = "VBpHGq_contentItem";
$b4a8bffbc728ae1e$export$bb75d8e9c1af397c = "VBpHGq_starContainer";





var $7af101438c942005$export$fe34ec5df90a97ec = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function(param) {
    var entry = param.entry;
    var nav = (0, $9ac934de5bbce2ae$export$726c44d912e0140f)();
    var assets = (0, $3a3345637c0a5d6f$export$bd973f06e9aaec8c)();
    var i = entry;
    var icon = assets.getContentIconUrl(i.category);
    var rating = i.user_rating;
    var stars = [];
    for(var i1 = 1; i1 <= rating; i1++)stars.push((0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
        iconSys: "star",
        size: "XS"
    }, i1));
    return (0, $978b871a0234f592$exports.jsxs)("div", {
        className: $b4a8bffbc728ae1e$export$cd37a9f26d44d7d1,
        onClick: function() {
            nav.toContent(i.id);
        },
        children: [
            i.thumbnailURL && (0, $978b871a0234f592$exports.jsx)("img", {
                className: "thumb",
                src: i.thumbnailURL
            }),
            i.name,
            i.watchSoon && (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
                className: "watch_soon",
                iconSys: "heart-yes-filled",
                size: "S"
            }),
            (0, $978b871a0234f592$exports.jsx)("img", {
                className: "icon",
                src: icon
            }),
            (0, $978b871a0234f592$exports.jsx)("div", {
                className: $b4a8bffbc728ae1e$export$bb75d8e9c1af397c,
                children: stars
            })
        ]
    }, i.id);
});


var $99ad9f4374701b7f$export$eca6714bee4a543d;
var $99ad9f4374701b7f$export$f9c0e93686763a70;
var $99ad9f4374701b7f$export$64796c58ca8c33ef;
var $99ad9f4374701b7f$export$2778853eeaa53fa7;
var $99ad9f4374701b7f$export$e789e90053a546bb;
$99ad9f4374701b7f$export$eca6714bee4a543d = "_6f08rq_categoryEntry";
$99ad9f4374701b7f$export$f9c0e93686763a70 = "_6f08rq_contentItemsContainer";
$99ad9f4374701b7f$export$64796c58ca8c33ef = "_6f08rq_filterButton";
$99ad9f4374701b7f$export$2778853eeaa53fa7 = "_6f08rq_taskPageDropZone";
$99ad9f4374701b7f$export$e789e90053a546bb = "_6f08rq_uploadIcon";


var $137dafa0ca91d037$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var $137dafa0ca91d037$require$Dropzone = $ab966853eba787d9$export$2e2bcd8739ae039;
var $137dafa0ca91d037$export$4546797870416e9b = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var lists = (0, $3a3345637c0a5d6f$export$3b5bae399c8431fb)();
    var dropzoneRef = (0, $33gHU.useRef)();
    var imagePrev = (0, $33gHU.useRef)();
    var assets = (0, $3a3345637c0a5d6f$export$bd973f06e9aaec8c)();
    var nav = (0, $9ac934de5bbce2ae$export$726c44d912e0140f)();
    var modal = (0, $3a3345637c0a5d6f$export$33ffd74ebf07f060)();
    (0, $33gHU.useEffect)(function() {
        lists.filterUI.reset();
    }, []);
    var addCatgeory = function() {
        return $137dafa0ca91d037$var$__awaiter(void 0, void 0, void 0, function() {
            var listName, list, categories;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        listName = prompt("Enter a new type of category");
                        if (!listName) return [
                            2
                        ];
                        list = new (0, $ddcb476d90fa761b$export$c46be51aa96896da)();
                        list.name = listName;
                        return [
                            4,
                            sendToOpenAI_NewCategory(listName)
                        ];
                    case 1:
                        categories = _state.sent();
                        list.categories = categories;
                        list.save();
                        return [
                            2
                        ];
                }
            });
        });
    };
    var sendToOpenAI_NewCategory = function(categoryName) {
        return $137dafa0ca91d037$var$__awaiter(void 0, void 0, void 0, function() {
            var openai, completion, content, js, json;
            return (0, $lF1I7.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        openai = new (0, (/*@__PURE__*/$parcel$interopDefault($dSxWp)))({
                            apiKey: "sk-cyyrXD97gTbtJNon8wyArslj9T2EhlAxv0vJED_wONT3BlbkFJnrZAlUOvr7wsOAM0R8ycdJLsaV6aoYRZNXs_drst4A",
                            dangerouslyAllowBrowser: true
                        });
                        return [
                            4,
                            openai.chat.completions.create({
                                model: "gpt-4o-mini",
                                messages: [
                                    {
                                        role: "system",
                                        content: "You are a helpful assistant. I will send you a category name of some type of content. Might be movies or books or something else. Please return a JSON array of upto 20 of the most common categories of that type of content. "
                                    },
                                    {
                                        role: "user",
                                        content: [
                                            {
                                                type: "text",
                                                text: "The type of content I am intrested in is ".concat(categoryName, '. Please return a JSON array of upto 20 of the most common categories of that type of content. Example JSON: ["Action", "Comedy", "Drama", ...]')
                                            }
                                        ]
                                    }
                                ],
                                max_tokens: 1000
                            })
                        ];
                    case 1:
                        completion = _state.sent();
                        content = completion.choices[0].message.content;
                        js = content.replace("```json\n", "").replace("```", "");
                        json = JSON.parse(js);
                        return [
                            2,
                            json
                        ];
                }
            });
        });
    };
    var items = [];
    var copy = (0, $b0lSM.values)(lists.contentList);
    var sorted = copy.slice().sort(function(a, b) {
        return b.created.getTime() - a.created.getTime();
    });
    var filter = lists.filterUI;
    sorted.forEach(function(i) {
        if (filter.rating > -1 && i.user_rating != filter.rating) return;
        if (filter.contentType != null && i.category != filter.contentType) return;
        if (filter.search != "") {
            if (i.name.toLowerCase().indexOf(filter.search.toLowerCase()) == -1) return;
        }
        if (filter.show_watch_soon && i.watchSoon == false) return;
        if (filter.show_only_not_rated && i.user_rating != -1) return;
        if (items.length < 42) items.push((0, $978b871a0234f592$exports.jsx)((0, $7af101438c942005$export$fe34ec5df90a97ec), {
            entry: i
        }, i.id));
    });
    return (0, $978b871a0234f592$exports.jsxs)((0, $978b871a0234f592$exports.Fragment), {
        children: [
            (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
                iconSys: "menu",
                size: "M",
                className: $99ad9f4374701b7f$export$64796c58ca8c33ef,
                onClick: function() {
                    modal.openContentFilter();
                }
            }),
            (0, $978b871a0234f592$exports.jsx)((0, $e837d155498b80f2$export$2e2bcd8739ae039), {
                children: (0, $978b871a0234f592$exports.jsx)((0, $e837d155498b80f2$export$2e2bcd8739ae039).Body, {
                    className: "p-1 pt-3",
                    children: (0, $978b871a0234f592$exports.jsx)("div", {
                        className: "d-flex w-100 flex-wrap",
                        children: (0, $978b871a0234f592$exports.jsx)("div", {
                            className: $99ad9f4374701b7f$export$f9c0e93686763a70,
                            children: items
                        })
                    })
                })
            })
        ]
    });
});



var $2MTYX = parcelRequire("2MTYX");

var $lF1I7 = parcelRequire("lF1I7");






var $33gHU = parcelRequire("33gHU");





var $78DQ7 = parcelRequire("78DQ7");

var $ddevm = parcelRequire("ddevm");

var $6JqHh = parcelRequire("6JqHh");


var $33gHU = parcelRequire("33gHU");


"use client";
var $16ef49a284ca35d4$var$ButtonGroup = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, size = _param.size, _param_vertical = _param.vertical, vertical = _param_vertical === void 0 ? false : _param_vertical, className = _param.className, _param_role = _param.role, role = _param_role === void 0 ? "group" : _param_role, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "div" : tmp, rest = (0, $6JqHh._)(_param, [
        "bsPrefix",
        "size",
        "vertical",
        "className",
        "role",
        "as"
    ]);
    var prefix = (0, $48ea4dae63926a21$export$7f387860ebffb32c)(bsPrefix, "btn-group");
    var baseClass = prefix;
    if (vertical) baseClass = "".concat(prefix, "-vertical");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $ddevm._)((0, $78DQ7._)({}, rest), {
        ref: ref,
        role: role,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, baseClass, size && "".concat(prefix, "-").concat(size))
    }));
});
$16ef49a284ca35d4$var$ButtonGroup.displayName = "ButtonGroup";
var $16ef49a284ca35d4$export$2e2bcd8739ae039 = $16ef49a284ca35d4$var$ButtonGroup;


var $62b30a721f563851$export$f04dfce1ac49e056 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function(props) {
    var _a, _b;
    var buttons = props.buttons.map(function(i) {
        var _a;
        // let butVar = task.repeatCount == i ? 'primary' : 'secondary';
        var cls = props.selected == i.value ? "primary" : "secondary";
        return (0, $978b871a0234f592$exports.jsx)((0, $bd394f94f7da712c$export$2e2bcd8739ae039).Item, {
            eventKey: i.value,
            children: (_a = i.display) !== null && _a !== void 0 ? _a : i.value
        }, i.value);
    });
    var onClick = function(value) {
        props.onChange(value);
    };
    var displayName = (_b = (_a = props.buttons.find(function(i) {
        return i.value == props.selected;
    })) === null || _a === void 0 ? void 0 : _a.display) !== null && _b !== void 0 ? _b : props.selected;
    return (0, $978b871a0234f592$exports.jsx)((0, $16ef49a284ca35d4$export$2e2bcd8739ae039), {
        children: (0, $978b871a0234f592$exports.jsx)((0, $762a6fc3e030bfa7$export$2e2bcd8739ae039), {
            onSelect: onClick,
            as: (0, $16ef49a284ca35d4$export$2e2bcd8739ae039),
            title: displayName,
            id: "bg-nested-dropdown",
            children: buttons
        })
    });
});





var $728f7d1c13a57c94$export$e193bccf3290c2a0 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function(props) {
    var task = props.task;
    var specific = task.getSpecific();
    var buttons = [
        {
            value: "start",
            display: "Start"
        },
        {
            value: "end",
            display: "End"
        }
    ];
    var onClick = function(val) {
        specific.monthly = val;
    };
    return (0, $978b871a0234f592$exports.jsx)((0, $978b871a0234f592$exports.Fragment), {});
});





var $ae9fba32d7f41985$export$82809efc4efb4e8 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function(props) {
    var task = props.task;
    var specific = task.getSpecific();
    var setStartDate = function(date) {
        specific.date = date;
    };
    return (0, $978b871a0234f592$exports.jsxs)((0, $978b871a0234f592$exports.Fragment), {
        children: [
            " ",
            (0, $978b871a0234f592$exports.jsx)("div", {})
        ]
    });
});




var $c2f5920b253ce82e$export$9d5f3e881a13da74 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function(props) {
    var task = props.task;
    var buttons = [
        {
            value: "1"
        },
        {
            value: "2"
        },
        {
            value: "3"
        }
    ];
    var specific = task.getSpecific();
    var onClick = function(e) {
        specific.repeatCount = parseInt(e);
    };
    return (0, $978b871a0234f592$exports.jsx)("div", {});
});


var $4cd83de164fec632$export$6caeae1669fbe908;
var $4cd83de164fec632$export$c90635b7bab06cff;
var $4cd83de164fec632$export$b57ba65eeada763a;
var $4cd83de164fec632$export$a7221d5760176504;
var $4cd83de164fec632$export$19e23a65a93e8155;
var $4cd83de164fec632$export$27ae5c21fcfb00d4;
var $4cd83de164fec632$export$dc3577888ebaffd2;
var $4cd83de164fec632$export$2778853eeaa53fa7;
var $4cd83de164fec632$export$e789e90053a546bb;
$4cd83de164fec632$export$6caeae1669fbe908 = "USc6DG_attachedFile";
$4cd83de164fec632$export$c90635b7bab06cff = "USc6DG_attachedFilesList";
$4cd83de164fec632$export$b57ba65eeada763a = "USc6DG_attachmentBox";
$4cd83de164fec632$export$a7221d5760176504 = "USc6DG_taskIcon";
$4cd83de164fec632$export$19e23a65a93e8155 = "USc6DG_taskInfo";
$4cd83de164fec632$export$27ae5c21fcfb00d4 = "USc6DG_taskInfoTextaArea";
$4cd83de164fec632$export$dc3577888ebaffd2 = "USc6DG_taskName";
$4cd83de164fec632$export$2778853eeaa53fa7 = "USc6DG_taskPageDropZone";
$4cd83de164fec632$export$e789e90053a546bb = "USc6DG_uploadIcon";






var $e09e1340b101e8f4$export$b07e517d22efa1ca;
$e09e1340b101e8f4$export$b07e517d22efa1ca = "P20Nwa_checkbox";


var $5076fb5ff2e3f76c$export$fdce88d064487bf8 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function(props) {
    var onClick = function() {
        props.onChange(!props.value);
    };
    return (0, $978b871a0234f592$exports.jsx)("div", {
        className: $e09e1340b101e8f4$export$b07e517d22efa1ca,
        children: (0, $978b871a0234f592$exports.jsxs)("label", {
            children: [
                (0, $978b871a0234f592$exports.jsx)("input", {
                    type: "checkbox",
                    checked: props.value,
                    onChange: onClick
                }),
                (0, $978b871a0234f592$exports.jsx)("div", {})
            ]
        })
    });
});



var $1e6b269606fa6ade$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var $1e6b269606fa6ade$require$Dropzone = $ab966853eba787d9$export$2e2bcd8739ae039;
var $1e6b269606fa6ade$export$769631fca829aca8 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var _a;
    var taskStore = (0, $3a3345637c0a5d6f$export$ed5c3368304694)();
    var assets = (0, $3a3345637c0a5d6f$export$bd973f06e9aaec8c)();
    var toaster = (0, $3a3345637c0a5d6f$export$f46171b59bb094f9)();
    var dropzoneRef = (0, $33gHU.useRef)();
    var nav = (0, $9ac934de5bbce2ae$export$726c44d912e0140f)();
    var id = (0, $89c54c76ed45b63d$export$99eaa27ddbbb95ef)().id;
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)(null), 2), task = _useState[0], setTask = _useState[1];
    var onToggle = function(v) {
        if (v) {
            task.setTaskState((0, $f858d6a97cc5c220$export$dcf4d221b45abc27).COMPLETE);
            toaster.addMessage("Task reported as completed");
        } else {
            task.setTaskState((0, $f858d6a97cc5c220$export$dcf4d221b45abc27).OPEN);
            toaster.addMessage("Task set as open");
        }
    };
    var onMonthlyReportYes = function() {
        task.logs.addEntry(new Date(), "MONTHLY");
    };
    (0, $33gHU.useEffect)(function() {
        if (!task) return;
        var uploadFile = function(file) {
            return $1e6b269606fa6ade$var$__awaiter(void 0, void 0, void 0, function() {
                var path, url, entry;
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            path = task.getUserStoragePath(file.name);
                            return [
                                4,
                                (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().uploadFile(path, file, task.id, function(progress) {
                                    console.log("from share", progress);
                                })
                            ];
                        case 1:
                            url = _state.sent();
                            entry = {
                                url: url,
                                name: file.name,
                                type: file.type
                            };
                            task.files.push(entry);
                            console.log("Uploaded: ", file.name);
                            return [
                                2
                            ];
                    }
                });
            });
        };
        var startUpload = function() {
            return $1e6b269606fa6ade$var$__awaiter(void 0, void 0, void 0, function() {
                var data, i;
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0, $3a3345637c0a5d6f$export$2e2bcd8739ae039).workbox.messageSW({
                                    type: "GET_FILES_SHARED"
                                })
                            ];
                        case 1:
                            data = _state.sent();
                            if (!data || !data.files) return [
                                2
                            ];
                            i = 0;
                            _state.label = 2;
                        case 2:
                            if (!(i < data.files.length)) return [
                                3,
                                5
                            ];
                            return [
                                4,
                                uploadFile(data.files[i])
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            i++;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            (0, $3a3345637c0a5d6f$export$2e2bcd8739ae039).workbox.messageSW({
                                type: "CLEAR_FILES_SHARED"
                            });
                            return [
                                2
                            ];
                    }
                });
            });
        };
        startUpload();
    }, [
        task
    ]);
    (0, $33gHU.useEffect)(function() {
        var task = null;
        if (id == "new") task = new (0, $f858d6a97cc5c220$export$1c98d9bfeea5177c)();
        else task = taskStore.getCopy(id);
        setTask(task);
        task.enableAutoSave();
    }, [
        id
    ]);
    (0, $33gHU.useEffect)(function() {
        if (!task) return;
        if (task.ioState == (0, $f858d6a97cc5c220$export$ade9b241dfa4a5e7).SAVED && id == "new") nav.toEditTask(task.id);
    }, [
        task,
        task === null || task === void 0 ? void 0 : task.ioState
    ]);
    (0, $33gHU.useEffect)(function() {
        if (task == null) return;
        var myDropzone = new $1e6b269606fa6ade$require$Dropzone(dropzoneRef.current, {
            dictDefaultMessage: "",
            maxFilesize: 2,
            url: "/",
            addRemoveLinks: false,
            method: "put",
            chunking: true,
            forceChunking: true,
            autoQueue: false,
            autoProcessQueue: false,
            disablePreviews: true
        });
        myDropzone.on("addedfile", function(file) {
            return $1e6b269606fa6ade$var$__awaiter(this, void 0, void 0, function() {
                var path, url, entry;
                return (0, $lF1I7.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            path = task.getUserStoragePath(file.name);
                            myDropzone.removeFile(file);
                            return [
                                4,
                                (0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().uploadFile(path, file, task.id, function(progress) {
                                    console.log("progress", progress);
                                    myDropzone.emit("uploadprogress", file, progress);
                                })
                            ];
                        case 1:
                            url = _state.sent();
                            myDropzone.emit("complete", file);
                            entry = {
                                url: url,
                                name: file.name,
                                type: file.type
                            };
                            task.files.push(entry);
                            setTimeout(function() {
                                myDropzone.removeFile(file);
                            }, 250);
                            return [
                                2
                            ];
                    }
                });
            });
        });
        return function() {
            while(myDropzone.files.length > 0)myDropzone.removeFile(myDropzone.files[0]);
            myDropzone.destroy();
        };
    }, [
        dropzoneRef,
        task
    ]);
    var showStore = function() {
        (0, $3a3345637c0a5d6f$export$2e2bcd8739ae039).modal.openSelectIcon(function(icon) {
            task.icon = icon;
        });
    };
    var onChangeTask = function(v) {
        task.type = v;
    };
    var tasksUILoookup = {
        ONE_TIME: (0, $978b871a0234f592$exports.jsx)((0, $ae9fba32d7f41985$export$82809efc4efb4e8), {
            task: task
        }),
        WEEKLY: (0, $978b871a0234f592$exports.jsx)((0, $c2f5920b253ce82e$export$9d5f3e881a13da74), {
            task: task
        }),
        MONTHLY: (0, $978b871a0234f592$exports.jsx)((0, $728f7d1c13a57c94$export$e193bccf3290c2a0), {
            task: task
        })
    };
    var tasksButtons = [
        {
            value: "ONE_TIME",
            display: "Once"
        },
        {
            value: "WEEKLY",
            display: "Week"
        },
        {
            value: "MONTHLY",
            display: "Month"
        }
    ];
    var createAttachment = function(file, i) {
        var imageSrc = file.url;
        var docTypes = {
            "application/pdf": "pdf",
            "application/msword": "doc",
            "text/plain": "txt"
        };
        //['pdf', 'doc', 'txt'];
        if (file.type.includes("image")) imageSrc = file.url;
        else {
            for(var key in docTypes)if (file.type.includes(key)) {
                imageSrc = assets.docIcons[docTypes[key]].url;
                break;
            }
        }
        if (!file.type.startsWith("image")) {
            var docType = "doc";
            for(var key in docTypes)if (file.name.includes(docTypes[key])) {
                docType = docTypes[key];
                break;
            }
            imageSrc = assets.docIcons[docType].url;
        }
        var showAttachment = function() {
            (0, $3a3345637c0a5d6f$export$2e2bcd8739ae039).modal.openViewAttachment(file.url);
        };
        return (0, $978b871a0234f592$exports.jsx)("div", {
            className: $4cd83de164fec632$export$6caeae1669fbe908,
            onClick: showAttachment,
            children: (0, $978b871a0234f592$exports.jsx)("img", {
                src: imageSrc,
                alt: "file"
            })
        }, i);
    };
    if (!task) return (0, $978b871a0234f592$exports.jsx)("div", {
        children: "Loading..."
    });
    var taskUI = tasksUILoookup[task.type];
    var iconPath = (_a = task.icon) !== null && _a !== void 0 ? _a : "";
    var attachments = (0, $978b871a0234f592$exports.jsx)("div", {
        className: $4cd83de164fec632$export$c90635b7bab06cff,
        children: task.files.map(function(file, i) {
            return createAttachment(file, i);
        })
    });
    var dropzone = (0, $978b871a0234f592$exports.jsx)("div", {
        ref: dropzoneRef,
        id: "taskPageDropZone",
        className: $4cd83de164fec632$export$2778853eeaa53fa7,
        children: (0, $978b871a0234f592$exports.jsx)("img", {
            className: $4cd83de164fec632$export$e789e90053a546bb,
            src: assets.sysIcons["upload"].url,
            alt: "upload"
        })
    });
    var tagLogs = task.logs.entries.map(function(log, i) {
        return log.toJS();
    });
    return (0, $978b871a0234f592$exports.jsx)((0, $e837d155498b80f2$export$2e2bcd8739ae039), {
        style: {
            width: "400px"
        },
        children: (0, $978b871a0234f592$exports.jsxs)((0, $e837d155498b80f2$export$2e2bcd8739ae039).Body, {
            children: [
                (0, $978b871a0234f592$exports.jsx)((0, $e837d155498b80f2$export$2e2bcd8739ae039).Title, {}),
                (0, $978b871a0234f592$exports.jsx)((0, $e837d155498b80f2$export$2e2bcd8739ae039).Body, {
                    children: (0, $978b871a0234f592$exports.jsxs)((0, $27113019bb4d8c5e$export$2e2bcd8739ae039), {
                        onSubmit: function(e) {
                            return e.preventDefault();
                        },
                        children: [
                            (0, $978b871a0234f592$exports.jsxs)((0, $763424a18f4fe9b9$export$2e2bcd8739ae039), {
                                className: "mb-3",
                                children: [
                                    (0, $978b871a0234f592$exports.jsx)("img", {
                                        className: $4cd83de164fec632$export$a7221d5760176504,
                                        onClick: showStore,
                                        src: task.iconUrl,
                                        alt: "icon"
                                    }),
                                    (0, $978b871a0234f592$exports.jsx)((0, $27113019bb4d8c5e$export$2e2bcd8739ae039).Control, {
                                        type: "text",
                                        placeholder: "Task Name",
                                        value: task.name,
                                        className: $4cd83de164fec632$export$dc3577888ebaffd2,
                                        onChange: function(e) {
                                            task.name = e.target.value;
                                        }
                                    }),
                                    (0, $978b871a0234f592$exports.jsx)((0, $62b30a721f563851$export$f04dfce1ac49e056), {
                                        selected: task.type,
                                        buttons: tasksButtons,
                                        onChange: onChangeTask,
                                        label: "Task Type"
                                    })
                                ]
                            }),
                            (0, $978b871a0234f592$exports.jsx)((0, $27113019bb4d8c5e$export$2e2bcd8739ae039).Group, {
                                className: "mb-3",
                                children: taskUI
                            }),
                            (0, $978b871a0234f592$exports.jsx)((0, $1bd9a712a9bb924e$export$2e2bcd8739ae039), {
                                children: (0, $978b871a0234f592$exports.jsxs)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                                    children: [
                                        (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                            xs: 10,
                                            className: "container p-0 ",
                                            children: attachments
                                        }),
                                        (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                            xs: 2,
                                            className: "p-0",
                                            children: dropzone
                                        })
                                    ]
                                })
                            }),
                            (0, $978b871a0234f592$exports.jsx)((0, $27113019bb4d8c5e$export$2e2bcd8739ae039).Group, {
                                children: (0, $978b871a0234f592$exports.jsx)("div", {
                                    id: "taskInfo",
                                    className: $4cd83de164fec632$export$19e23a65a93e8155,
                                    children: (0, $978b871a0234f592$exports.jsx)((0, $27113019bb4d8c5e$export$2e2bcd8739ae039).Control, {
                                        as: "textarea",
                                        rows: 4,
                                        wrap: "hard",
                                        className: $4cd83de164fec632$export$27ae5c21fcfb00d4,
                                        value: task.desc,
                                        onChange: function(e) {
                                            task.desc = e.target.value;
                                        }
                                    })
                                })
                            }),
                            (0, $978b871a0234f592$exports.jsx)((0, $1bd9a712a9bb924e$export$2e2bcd8739ae039), {
                                className: "pt-3",
                                children: (0, $978b871a0234f592$exports.jsxs)((0, $4e74b20dea0154e3$export$2e2bcd8739ae039), {
                                    children: [
                                        (0, $978b871a0234f592$exports.jsxs)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                            xs: 4,
                                            children: [
                                                task.type == (0, $f858d6a97cc5c220$export$1f8b1cab05cab788).ONE_TIME && (0, $978b871a0234f592$exports.jsx)((0, $5076fb5ff2e3f76c$export$fdce88d064487bf8), {
                                                    value: task.state == (0, $f858d6a97cc5c220$export$dcf4d221b45abc27).COMPLETE,
                                                    onChange: function(v) {
                                                        onToggle(v);
                                                    }
                                                }),
                                                task.type == (0, $f858d6a97cc5c220$export$1f8b1cab05cab788).MONTHLY && (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
                                                    iconSys: "yes",
                                                    onClick: onMonthlyReportYes,
                                                    size: "S"
                                                })
                                            ]
                                        }),
                                        (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                            xs: 6
                                        }),
                                        (0, $978b871a0234f592$exports.jsx)((0, $83dbfa5be47e34f1$export$2e2bcd8739ae039), {
                                            xs: 2,
                                            children: task.ioState != (0, $f858d6a97cc5c220$export$ade9b241dfa4a5e7).NOT_SAVED && (0, $978b871a0234f592$exports.jsx)((0, $6ca346b03d4e19d6$export$f04a61298a47a40f), {
                                                iconSys: "saved",
                                                size: "S"
                                            })
                                        })
                                    ]
                                })
                            }),
                            JSON.stringify(tagLogs)
                        ]
                    })
                })
            ]
        })
    });
});







var $c01522b603c3f979$export$a2a376b40393fa9 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var tasks = (0, $3a3345637c0a5d6f$export$2e2bcd8739ae039).tasks.entries;
    var nav = (0, $9ac934de5bbce2ae$export$726c44d912e0140f)();
    return (0, $978b871a0234f592$exports.jsxs)((0, $1682d872d0b0712a$export$2e2bcd8739ae039), {
        striped: true,
        bordered: true,
        hover: true,
        children: [
            (0, $978b871a0234f592$exports.jsx)("thead", {
                children: (0, $978b871a0234f592$exports.jsxs)("tr", {
                    children: [
                        (0, $978b871a0234f592$exports.jsx)("th", {
                            children: "#"
                        }),
                        (0, $978b871a0234f592$exports.jsx)("th", {
                            children: "Icon"
                        }),
                        (0, $978b871a0234f592$exports.jsx)("th", {
                            children: "Name"
                        }),
                        (0, $978b871a0234f592$exports.jsx)("th", {
                            children: "Type"
                        }),
                        (0, $978b871a0234f592$exports.jsx)("th", {
                            children: "State"
                        }),
                        (0, $978b871a0234f592$exports.jsx)("th", {
                            children: "JS"
                        }),
                        (0, $978b871a0234f592$exports.jsx)("th", {
                            children: "Id"
                        }),
                        (0, $978b871a0234f592$exports.jsx)("th", {
                            children: "Edit"
                        }),
                        (0, $978b871a0234f592$exports.jsx)("th", {
                            children: "View"
                        }),
                        (0, $978b871a0234f592$exports.jsx)("th", {
                            children: "Delete"
                        })
                    ]
                })
            }),
            (0, $978b871a0234f592$exports.jsx)("tbody", {
                children: tasks.map(function(task, i) {
                    return (0, $978b871a0234f592$exports.jsxs)("tr", {
                        children: [
                            (0, $978b871a0234f592$exports.jsx)("td", {
                                children: i
                            }),
                            (0, $978b871a0234f592$exports.jsx)("td", {
                                children: (0, $978b871a0234f592$exports.jsx)("img", {
                                    style: {
                                        width: 48
                                    },
                                    src: task.iconUrl
                                })
                            }),
                            (0, $978b871a0234f592$exports.jsx)("td", {
                                children: task.name
                            }),
                            (0, $978b871a0234f592$exports.jsx)("td", {
                                children: task.type
                            }),
                            (0, $978b871a0234f592$exports.jsx)("td", {
                                children: task.state
                            }),
                            (0, $978b871a0234f592$exports.jsx)("td", {
                                style: {
                                    maxWidth: 800,
                                    overflow: "hidden"
                                },
                                children: JSON.stringify(task.toJS())
                            }),
                            (0, $978b871a0234f592$exports.jsx)("td", {
                                children: task.id
                            }),
                            (0, $978b871a0234f592$exports.jsx)("td", {
                                children: (0, $978b871a0234f592$exports.jsx)("button", {
                                    onClick: function() {
                                        nav.toEditTask(task.id);
                                    },
                                    children: "Edit"
                                })
                            }),
                            (0, $978b871a0234f592$exports.jsx)("td", {
                                children: (0, $978b871a0234f592$exports.jsx)("button", {
                                    onClick: function() {
                                        nav.toViewTask(task.id);
                                    },
                                    children: "View"
                                })
                            }),
                            (0, $978b871a0234f592$exports.jsx)("td", {
                                children: (0, $978b871a0234f592$exports.jsx)("button", {
                                    onClick: function() {
                                        if (window.confirm("Are you sure?")) (0, $3a3345637c0a5d6f$export$2e2bcd8739ae039).tasks.delete(task.id);
                                    },
                                    children: "Delete"
                                })
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
});



var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");


var $19mwo = parcelRequire("19mwo");

var $78DQ7 = parcelRequire("78DQ7");

var $2MTYX = parcelRequire("2MTYX");

var $3jzhD = parcelRequire("3jzhD");
function $098a3b28da8c359e$var$t(t, s, i) {
    return s in t ? Object.defineProperty(t, s, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[s] = i, t;
}
var $098a3b28da8c359e$var$s = {
    A: {
        args: [
            "rx",
            "ry",
            "rotation",
            "arc",
            "sweep",
            "ex",
            "ey"
        ]
    },
    a: {
        args: [
            "rx",
            "ry",
            "rotation",
            "arc",
            "sweep",
            "ex",
            "ey"
        ]
    },
    C: {
        args: [
            "cx1",
            "cy1",
            "cx2",
            "cy2",
            "ex",
            "ey"
        ]
    },
    c: {
        args: [
            "cx1",
            "cy1",
            "cx2",
            "cy2",
            "ex",
            "ey"
        ]
    },
    H: {
        args: [
            "x"
        ]
    },
    h: {
        args: [
            "x"
        ]
    },
    L: {
        args: [
            "x",
            "y"
        ]
    },
    l: {
        args: [
            "x",
            "y"
        ]
    },
    M: {
        args: [
            "x",
            "y"
        ]
    },
    m: {
        args: [
            "x",
            "y"
        ]
    },
    Q: {
        args: [
            "cx",
            "cy",
            "ex",
            "ey"
        ]
    },
    q: {
        args: [
            "cx",
            "cy",
            "ex",
            "ey"
        ]
    },
    S: {
        args: [
            "cx",
            "cy",
            "ex",
            "ey"
        ]
    },
    s: {
        args: [
            "cx",
            "cy",
            "ex",
            "ey"
        ]
    },
    T: {
        args: [
            "ex",
            "ey"
        ]
    },
    t: {
        args: [
            "ex",
            "ey"
        ]
    },
    V: {
        args: [
            "y"
        ]
    },
    v: {
        args: [
            "y"
        ]
    },
    z: {
        args: []
    }
};
var $098a3b28da8c359e$export$2e2bcd8739ae039 = function i() {
    "use strict";
    var _this = this;
    var _this1 = this;
    (0, $19mwo._)(this, i);
    return $098a3b28da8c359e$var$t(this, "attr", function(t, s) {
        return _this.attributes[t] = s, _this;
    }), $098a3b28da8c359e$var$t(this, "fill", function(t) {
        return _this.attr("fill", t);
    }), $098a3b28da8c359e$var$t(this, "stroke", function(t) {
        return _this.attr("stroke", t);
    }), $098a3b28da8c359e$var$t(this, "strokeWidth", function(t) {
        return _this.attr("stroke-width", t);
    }), $098a3b28da8c359e$var$t(this, "style", function(t) {
        return _this.attr("style", t);
    }), $098a3b28da8c359e$var$t(this, "m", function(t, s) {
        return _this.moveTo(t, s, !0);
    }), $098a3b28da8c359e$var$t(this, "M", function(t, s) {
        return _this.moveTo(t, s);
    }), $098a3b28da8c359e$var$t(this, "moveTo", function(t, s) {
        var _$i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
        return _this1.pathData.push("".concat(_$i ? "m" : "M").concat(t, " ").concat(s)), _this1;
    }), $098a3b28da8c359e$var$t(this, "l", function(t, s) {
        return _this.lineTo(t, s, !0);
    }), $098a3b28da8c359e$var$t(this, "L", function(t, s) {
        return _this.lineTo(t, s);
    }), $098a3b28da8c359e$var$t(this, "lineTo", function(t, s) {
        var _$i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
        return _this1.pathData.push("".concat(_$i ? "l" : "L").concat(t, " ").concat(s)), _this1;
    }), $098a3b28da8c359e$var$t(this, "H", function(t) {
        return _this.horizontalTo(t);
    }), $098a3b28da8c359e$var$t(this, "h", function(t) {
        return _this.horizontalTo(t, !0);
    }), $098a3b28da8c359e$var$t(this, "horizontalTo", function(t) {
        var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        return _this1.pathData.push("".concat(s ? "h" : "H").concat(t)), _this1;
    }), $098a3b28da8c359e$var$t(this, "V", function(t) {
        return _this.verticalTo(t);
    }), $098a3b28da8c359e$var$t(this, "v", function(t) {
        return _this.verticalTo(t, !0);
    }), $098a3b28da8c359e$var$t(this, "verticalTo", function(t) {
        var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        return _this1.pathData.push("".concat(s ? "v" : "V").concat(t)), _this1;
    }), $098a3b28da8c359e$var$t(this, "Q", function(t, s, i, r) {
        return _this.qCurve(t, s, i, r);
    }), $098a3b28da8c359e$var$t(this, "q", function(t, s, i, r) {
        return _this.qCurve(t, s, i, r, !0);
    }), $098a3b28da8c359e$var$t(this, "qCurve", function(t, s, i, r) {
        var h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
        return _this1.pathData.push("".concat(h ? "q" : "Q").concat(t, " ").concat(s, " ").concat(i, " ").concat(r)), _this1;
    }), $098a3b28da8c359e$var$t(this, "T", function(t, s) {
        return _this.tCurveTo(t, s);
    }), $098a3b28da8c359e$var$t(this, "t", function(t, s) {
        return _this.tCurveTo(t, s, !0);
    }), $098a3b28da8c359e$var$t(this, "tCurveTo", function(t, s) {
        var _$i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
        return _this1.pathData.push("".concat(_$i ? "t" : "T").concat(t, " ").concat(s)), _this1;
    }), $098a3b28da8c359e$var$t(this, "C", function(t, s, i, r, h, o) {
        return _this.cCurve(t, s, i, r, h, o);
    }), $098a3b28da8c359e$var$t(this, "c", function(t, s, i, r, h, o) {
        return _this.cCurve(t, s, i, r, h, o, !0);
    }), $098a3b28da8c359e$var$t(this, "cCurve", function(t, s, i, r, h, o) {
        var n = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : !1;
        return _this1.pathData.push("".concat(n ? "c" : "C").concat(t, " ").concat(s, " ").concat(i, " ").concat(r, " ").concat(h, " ").concat(o)), _this1;
    }), $098a3b28da8c359e$var$t(this, "S", function(t, s, i, r) {
        return _this.sCurveTo(t, s, i, r);
    }), $098a3b28da8c359e$var$t(this, "s", function(t, s, i, r) {
        return _this.sCurveTo(t, s, i, r, !0);
    }), $098a3b28da8c359e$var$t(this, "sCurveTo", function(t, s, i, r) {
        var h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
        return _this1.pathData.push("".concat(h ? "s" : "S").concat(t, " ").concat(s, " ").concat(i, " ").concat(r)), _this1;
    }), $098a3b28da8c359e$var$t(this, "A", function(t, s, i, r, h, o, n) {
        return _this.arc(t, s, i, r, h, o, n);
    }), $098a3b28da8c359e$var$t(this, "a", function(t, s, i, r, h, o, n) {
        return _this.arc(t, s, i, r, h, o, n, !0);
    }), $098a3b28da8c359e$var$t(this, "arc", function(t, s, i, r, h, o, n) {
        var a = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : !1;
        return _this1.pathData.push("".concat(a ? "a" : "A").concat(t, " ").concat(s, " ").concat(i, " ").concat(r, " ").concat(h, " ").concat(o, " ").concat(n)), _this1;
    }), $098a3b28da8c359e$var$t(this, "down", function(t) {
        return _this.v(t);
    }), $098a3b28da8c359e$var$t(this, "up", function(t) {
        return _this.v(-1 * t);
    }), $098a3b28da8c359e$var$t(this, "right", function(t) {
        return _this.h(t);
    }), $098a3b28da8c359e$var$t(this, "left", function(t) {
        return _this.h(-1 * t);
    }), $098a3b28da8c359e$var$t(this, "close", function() {
        return _this.pathData.push("z"), _this;
    }), $098a3b28da8c359e$var$t(this, "toArray", function() {
        return _this.pathData;
    }), $098a3b28da8c359e$var$t(this, "toString", function() {
        return _this.pathData.join("");
    }), $098a3b28da8c359e$var$t(this, "toCommands", function() {
        return _this.pathData.map(function(t) {
            var _s;
            var s = [
                t.substr(0, 1)
            ], _$i = t.substr(1);
            return _$i.length && (_s = s).push.apply(_s, (0, $3jzhD._)(_$i.split(" ").map(Number))), s;
        });
    }), $098a3b28da8c359e$var$t(this, "toAnnotatedCommands", function() {
        return _this.toCommands().map(function(t) {
            var _$i = t.shift(), r = $098a3b28da8c359e$var$s[_$i].args;
            return r.length ? {
                fn: _$i,
                args: t.reduce(function(t, s, i) {
                    return t[r[i]] = s, t;
                }, {})
            } : {
                fn: _$i
            };
        });
    }), $098a3b28da8c359e$var$t(this, "toElement", function() {
        var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var s = (0, $78DQ7._)({}, _this1.attributes, _$t), _$i = document.createElementNS("http://www.w3.org/2000/svg", "path");
        return Object.keys(s).forEach(function(t) {
            _$i.setAttribute(t, s[t]);
        }), _$i.setAttribute("d", _this1.toString()), _$i;
    }), this.pathData = [], this.attributes = {}, this;
};
$098a3b28da8c359e$var$t($098a3b28da8c359e$export$2e2bcd8739ae039, "angleInRadians", function(t) {
    return t * Math.PI / 180;
}), $098a3b28da8c359e$var$t($098a3b28da8c359e$export$2e2bcd8739ae039, "polarToCartesian", function(t, s, r, h) {
    var o = $098a3b28da8c359e$export$2e2bcd8739ae039.angleInRadians(h);
    return {
        x: t + r * Math.cos(o),
        y: s + r * Math.sin(o)
    };
}), $098a3b28da8c359e$var$t($098a3b28da8c359e$export$2e2bcd8739ae039, "clockwisePoint", function(t, s, r, h) {
    var o = h - 90;
    return $098a3b28da8c359e$export$2e2bcd8739ae039.polarToCartesian(t, s, r, o);
}), $098a3b28da8c359e$var$t($098a3b28da8c359e$export$2e2bcd8739ae039, "radialPoints", function(t, s, i, r, h) {
    var o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 1;
    h = h || -0.5 * Math.PI, t = t || 1e-10;
    var n = 2 * Math.PI * o / r, a = Array.from(Array(r >= 0 ? r : 0).keys()), e = Math.max(0, 4 - Math.floor(Math.log10(t)));
    return a.map(function(r, o) {
        var a = o * n + h;
        return [
            (s + t * Math.cos(a)).toFixed(e),
            (i + t * Math.sin(a)).toFixed(e)
        ];
    });
}), $098a3b28da8c359e$var$t($098a3b28da8c359e$export$2e2bcd8739ae039, "positionByArray", function(t, s, i, r) {
    var h = [], o = t / 2;
    return s.forEach(function(s, n) {
        s.forEach(function(s, a) {
            s && h.push({
                size: t,
                cx: a * t + o + i,
                cy: n * t + o + r,
                ri: n,
                ci: a,
                value: s
            });
        });
    }), h;
}), $098a3b28da8c359e$var$t($098a3b28da8c359e$export$2e2bcd8739ae039, "macro", function(t, s) {
    $098a3b28da8c359e$export$2e2bcd8739ae039.prototype[t] = s;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("rect", function(t, s, i, r) {
    var h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0;
    return this.M(i - t / 2, r - s / 2).right(t).down(s).left(t).up(s), h && this.M(i, r), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("square", function(t, s, i) {
    var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
    return this.rect(t, t, s, i, r);
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("roundedSquare", function(t, s, i, r) {
    var h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0;
    return this.roundedRect(t, t, s, i, r, h);
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("roundedRect", function(t, s, i, r, h) {
    var o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !0;
    var n = h - s / 2, a = r - t / 2, e = a + t, c = n + s;
    var u = Math.min(i, t / 2);
    u = u < 0 ? 0 : u;
    var l = Math.min(i, s / 2);
    l = l < 0 ? 0 : l;
    var p = Math.max(t - 2 * u, 0), y = Math.max(s - 2 * l, 0);
    return this.M(a + u, n).right(p).A(u, l, 0, 0, 1, e, n + l).down(y).A(u, l, 0, 0, 1, e - u, c).left(p).A(u, l, 0, 0, 1, a, c - l).up(y).A(u, l, 0, 0, 1, a + u, n).M(a, n), o && this.M(r, h), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("circle", function(t, s, i) {
    var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
    return this.ellipse(t, t, s, i, r);
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("ellipse", function(t, s, i, r) {
    var h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0;
    var o = t / 2, n = s / 2;
    return this.M(i + o, r).A(o, n, 0, 0, 1, i - o, r).A(o, n, 0, 0, 1, i + o, r).close(), h && this.M(i, r), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("kite", function(t, s, i, r, h) {
    var o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !0;
    i = i || parseInt(.33 * s, 10);
    var _this_constructor_radialPoints = (0, $2MTYX._)(this.constructor.radialPoints(s / 2, r, h, 4), 3), n = _this_constructor_radialPoints[0], a = _this_constructor_radialPoints[1], e = _this_constructor_radialPoints[2], c = parseInt(n[1], 10) + i, u = [
        n,
        [
            r - t / 2,
            c
        ],
        e,
        [
            r + t / 2,
            c
        ]
    ];
    return this.polyline(u).close();
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("lens", function(t, s, i, r) {
    var h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0;
    return this.M(i - t / 2, r).Q(i, r - s, i + t / 2, r).Q(i, r + s, i - t / 2, r), h && this.M(i, r), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("polyline", function(t) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    var i = (0, $3jzhD._)(t), r = i.shift(), h = s ? this.m : this.M, o = s ? this.l : this.L;
    return h.apply(null, r), i.forEach(function(t) {
        o.apply(null, t);
    }), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("polygon", function(t) {
    return this.polyline(t).close(), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("regPolygon", function(t, s, i, r) {
    var h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0;
    return this.polygon(this.constructor.radialPoints(t / 2, i, r, s)), h && this.M(i, r), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("polygram", function(t, s, i, r) {
    var h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 2, o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !0;
    return this.polygon(this.constructor.radialPoints(t / 2, i, r, s, null, h)), o && this.M(i, r), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("radialLines", function(t, s, i, r, h) {
    var _this = this;
    var o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !0;
    var n = this.constructor.radialPoints(s / 2, r, h, i), a = this.constructor.radialPoints(t / 2, r, h, i);
    return n.forEach(function(t, s) {
        _this.M(t[0], t[1]).L(a[s][0], a[s][1]);
    }), o && this.M(r, h), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("star", function(t, s, i, r, h) {
    var _this = this;
    var o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !0;
    var n = s / 2, a = t / 2, e = 360 / (2 * i), c = Array.from({
        length: 2 * i
    }).map(function(t, s) {
        var _$i = s % 2 == 0 ? a : n, c = e * s;
        var _this_constructor_clockwisePoint = _this.constructor.clockwisePoint(r, h, _$i, c, o), u = _this_constructor_clockwisePoint.x, l = _this_constructor_clockwisePoint.y;
        return [
            u,
            l
        ];
    });
    return this.polygon(c), o && this.M(r, h), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("triangle", function(t, s, i) {
    var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
    var h = Math.sqrt(3), o = [
        s,
        i - h / 3 * t
    ], n = [
        s - t / 2,
        i + h / 6 * t
    ], a = [
        s + t / 2,
        i + h / 6 * t
    ];
    return this.polygon([
        o,
        n,
        a
    ]), r && this.M(s, i), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("sector", function(t, s, i, r, h) {
    var o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !0;
    var n = i / 2, a = this.constructor.clockwisePoint(t, s, n, h), e = this.constructor.clockwisePoint(t, s, n, r), c = h - r <= 180 ? 0 : 1;
    return this.M(a.x, a.y).A(n, n, 0, c, 0, e.x, e.y).L(t, s).L(a.x, a.y), o && this.M(t, s), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("segment", function(t, s, i, r, h) {
    var o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !0;
    var n = i / 2, a = this.constructor.clockwisePoint(t, s, n, h), e = this.constructor.clockwisePoint(t, s, n, r), c = h - r <= 180 ? 0 : 1;
    return this.M(a.x, a.y).A(n, n, 0, c, 0, e.x, e.y), o && this.M(t, s), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("cross", function(t, s, i, r) {
    var h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0;
    var o = i - t / 2, n = o + t, a = r - s / 2, e = a + s;
    return this.M(o, r).L(n, r).M(i, e).L(i, a), h && this.M(i, r), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("symH", function(t, s, i, r) {
    var h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0;
    var o = i - t / 2, n = o + t, a = r - s / 2, e = a + s;
    return this.M(o, a).L(o, e).M(o, r).L(n, r).M(n, a).L(n, e), h && this.M(i, r), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("symI", function(t, s, i, r) {
    var h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0;
    var o = i - t / 2, n = o + t, a = r - s / 2, e = a + s;
    return this.M(o, a).L(n, a).M(i, a).L(i, e).M(o, e).L(n, e), h && this.M(i, r), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("symX", function(t, s, i, r) {
    var h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0;
    var o = i - t / 2, n = o + t, a = r - s / 2, e = a + s;
    return this.M(o, a).L(n, e).M(o, e).L(n, a), h && this.M(i, r), this;
}), $098a3b28da8c359e$export$2e2bcd8739ae039.macro("omino", function(t, s, i, r) {
    var _this = this;
    var h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
    return this.constructor.positionByArray(t, s, i, r).forEach(function(t, s, i) {
        var _$r = t.cx, o = t.cy, n = t.ri, a = t.ci, e = t.size, c = e / 2, u = i.find(function(t) {
            return t.ri === n && t.ci === a - 1;
        }), l = i.find(function(t) {
            return t.ri === n && t.ci === a + 1;
        }), p = i.find(function(t) {
            return t.ri === n - 1 && t.ci === a;
        }), y = i.find(function(t) {
            return t.ri === n + 1 && t.ci === a;
        }), m = _$r - c, M = _$r + c, f = o - c, g = o + c;
        u && !h || (_this.M(m, f), _this.v(e)), l || (_this.M(M, f), _this.v(e)), p && !h || (_this.M(m, f), _this.h(e)), y || (_this.M(m, g), _this.h(e));
    }), this;
});



var $33gHU = parcelRequire("33gHU");
var $bfcc64a00560c522$export$7caffd61f21a155c;
var $bfcc64a00560c522$export$4dc339535e27518;
var $bfcc64a00560c522$export$255bc63e439fa612;
var $bfcc64a00560c522$export$518692242cd9cf73;
var $bfcc64a00560c522$export$c123a1412f215ba7;
$bfcc64a00560c522$export$7caffd61f21a155c = "g-X3cG_AnimationLayer";
$bfcc64a00560c522$export$4dc339535e27518 = "g-X3cG_OffsetAnimation";
$bfcc64a00560c522$export$4dc339535e27518;
$bfcc64a00560c522$export$255bc63e439fa612 = "g-X3cG_PlaneContainer";
$bfcc64a00560c522$export$518692242cd9cf73 = "g-X3cG_PlaneScaleAnim";
$bfcc64a00560c522$export$c123a1412f215ba7 = "g-X3cG_ScaleAnimation";
$bfcc64a00560c522$export$c123a1412f215ba7;




var $231cfdceee7dea95$var$globalId = 0;
var $231cfdceee7dea95$var$AnimationLayer = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function(props) {
    var anim = (0, $3a3345637c0a5d6f$export$491715d4fdcd0f6b)();
    (0, $33gHU.useEffect)(function() {
        if (anim.animation) addAnimation(anim.animation.from, anim.animation.to, anim.animation.icon);
        anim.animation = null;
    }, [
        anim.animation
    ]);
    //const [animations, setAnimations] = useState<{ [id: string]: ReactNode }>({});
    var _useState = (0, $2MTYX._)((0, $33gHU.useState)([]), 2), animations = _useState[0], setAnimations = _useState[1];
    var setAnimFromOutside = (0, $33gHU.useCallback)(function(fn) {
        setAnimations(fn);
    }, []);
    var addAnimation = function(fromPos, toPos, icon) {
        var id = "id_" + $231cfdceee7dea95$var$globalId.toString();
        $231cfdceee7dea95$var$globalId++;
        var a = fromPos.x - toPos.x;
        var b = fromPos.y - toPos.y;
        var dist = Math.sqrt(a * a + b * b) / 160;
        dist = Math.max(dist, 2.0);
        dist = Math.min(dist, 2.5);
        // if (dist < 2.2) {
        // 	dist = 2.2;
        // }
        var time = dist.toFixed(2).toString() + "s";
        //console.log('ANIM TIME:' + time);
        var planeContainer = [
            $bfcc64a00560c522$export$255bc63e439fa612
        ].join(" ");
        var planeScaleAnim = [
            $bfcc64a00560c522$export$518692242cd9cf73
        ].join(" ");
        var assets = (0, $3a3345637c0a5d6f$export$bd973f06e9aaec8c)();
        var iconPath = assets.taskIcons[icon].url;
        var anim = (0, $978b871a0234f592$exports.jsx)("div", {
            className: planeContainer,
            style: {
                offsetPath: PathMaker(fromPos, toPos),
                animationDuration: time
            },
            children: (0, $978b871a0234f592$exports.jsx)("img", {
                src: iconPath,
                className: planeScaleAnim,
                style: {
                    animationDuration: time,
                    position: "absolute",
                    width: "32px",
                    height: "32px"
                }
            })
        }, id);
        setAnimFromOutside(function(arr) {
            var copy = (0, $3jzhD._)(arr);
            copy.push(anim);
            return copy;
        });
        console.log("ADD ANIM");
        setTimeout(function() {
            setAnimFromOutside(function(a) {
                var r = a.filter(function(anim) {
                    return anim.key != id;
                });
                return r;
            });
        }, 5000);
    };
    var PMaker2 = function(from, to) {
        var path = new (0, $098a3b28da8c359e$export$2e2bcd8739ae039)().M(from.x, from.y).L(to.x, to.y);
        var ret = "path('" + path.toString() + "')";
        return ret;
    };
    var PathMaker = function(from, to) {
        var mpx = (to.x + from.x) * 0.5;
        var mpy = (to.y + from.y) * 0.5;
        var theta = Math.atan2(to.y - from.y, to.x - from.x) - Math.PI / 2;
        //const range = 30;
        var offset = (Math.random() * 140 - 70) * 2;
        var c1x = mpx + offset * Math.cos(theta);
        var c1y = mpy + offset * Math.sin(theta);
        var path = new (0, $098a3b28da8c359e$export$2e2bcd8739ae039)().M(from.x, from.y).C(from.x, from.y, c1x, c1y, to.x, to.y);
        var ret = "path('" + path.toString() + "')";
        //console.log(ret);
        //return "path('M 239 17 C 142 17 48.5 103 48.5 213.5 C 48.5 324 126 408 244 408 C 362 408 412 319 412 213.5 C 412 108 334 68.5 244 68.5 C 154 68.5 102.68 135.079 99 213.5 C 95.32 291.921 157 350 231 345.5 C 305 341 357.5 290 357.5 219.5 C 357.5 149 314 121 244 121 C 174 121 151.5 167 151.5 213.5 C 151.5 260 176 286.5 224.5 286.5 C 273 286.5 296.5 253 296.5 218.5 C 296.5 184 270 177 244 177 C 218 177 197 198 197 218.5 C 197 239 206 250.5 225.5 250.5 C 245 250.5 253 242 253 218.5')"
        //return "path('M20,20 C20,100 200,0 200,100')"
        return ret;
    };
    var animLayer = [
        $bfcc64a00560c522$export$7caffd61f21a155c
    ].join(" ");
    return (0, $978b871a0234f592$exports.jsx)("div", {
        className: animLayer,
        children: animations
    });
});
var $231cfdceee7dea95$export$2e2bcd8739ae039 = $231cfdceee7dea95$var$AnimationLayer;


var $94a964d0ae980490$export$953c2efc134d7f79 = (0, $7a4bc3291e712a46$export$b6ae1bc530f4c149)(function() {
    var store = (0, $3a3345637c0a5d6f$export$6ccbb43953eebf8)();
    if (!store.isLoaded) return (0, $978b871a0234f592$exports.jsx)("div", {
        children: "Loading.."
    });
    return (0, $978b871a0234f592$exports.jsxs)((0, $978b871a0234f592$exports.Fragment), {
        children: [
            (0, $978b871a0234f592$exports.jsx)((0, $17dcf6d70f0acee2$export$a530fe7a272dd531), {}),
            (0, $978b871a0234f592$exports.jsx)((0, $aca7ac1a0ae40101$export$8b543871300e74c2), {}),
            (0, $978b871a0234f592$exports.jsx)((0, $e39661be72f50399$export$2e2bcd8739ae039), {}),
            (0, $978b871a0234f592$exports.jsx)((0, $620eb7bcbc122a7c$export$fb98e3a2a4cd92d7), {}),
            (0, $978b871a0234f592$exports.jsx)((0, $231cfdceee7dea95$export$2e2bcd8739ae039), {}),
            (0, $978b871a0234f592$exports.jsx)((0, $06bbb0d4ad208fb4$export$7221d69dcfc8e36b), {
                children: (0, $978b871a0234f592$exports.jsxs)((0, $89c54c76ed45b63d$export$3565eb3d00ca5a74), {
                    children: [
                        (0, $978b871a0234f592$exports.jsx)((0, $89c54c76ed45b63d$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: (0, $978b871a0234f592$exports.jsx)((0, $ca93ea259ddc746f$export$2e2bcd8739ae039), {})
                        }),
                        (0, $978b871a0234f592$exports.jsx)((0, $89c54c76ed45b63d$export$e7b0ac011bb776c6), {
                            path: "/task/:id",
                            element: (0, $978b871a0234f592$exports.jsx)((0, $1e6b269606fa6ade$export$769631fca829aca8), {})
                        }),
                        (0, $978b871a0234f592$exports.jsx)((0, $89c54c76ed45b63d$export$e7b0ac011bb776c6), {
                            path: "/tasks",
                            element: (0, $978b871a0234f592$exports.jsx)((0, $c01522b603c3f979$export$a2a376b40393fa9), {})
                        }),
                        (0, $978b871a0234f592$exports.jsx)((0, $89c54c76ed45b63d$export$e7b0ac011bb776c6), {
                            path: "/lists",
                            element: (0, $978b871a0234f592$exports.jsx)((0, $137dafa0ca91d037$export$4546797870416e9b), {})
                        }),
                        (0, $978b871a0234f592$exports.jsx)((0, $89c54c76ed45b63d$export$e7b0ac011bb776c6), {
                            path: "/content/:id",
                            element: (0, $978b871a0234f592$exports.jsx)((0, $485ca850ecda6288$export$c4ab9b8c1d035854), {})
                        }),
                        (0, $978b871a0234f592$exports.jsx)((0, $89c54c76ed45b63d$export$e7b0ac011bb776c6), {
                            path: "/ai",
                            element: (0, $978b871a0234f592$exports.jsx)((0, $4eec23bac161afc8$export$73e1527c1d8c3728), {})
                        }),
                        (0, $978b871a0234f592$exports.jsx)((0, $89c54c76ed45b63d$export$e7b0ac011bb776c6), {
                            path: "/icons",
                            element: (0, $978b871a0234f592$exports.jsx)((0, $ecbaf4258c4fcc15$export$7ca21068e737e223), {})
                        })
                    ]
                })
            })
        ]
    });
});



var $gnDeW = parcelRequire("gnDeW");
try {
    self["workbox:window:7.0.0"] && _();
} catch (n) {}
function $298177c8d02d9ab1$export$3a89f7c6642e8f16(n, t) {
    return new Promise(function(r) {
        var e = new MessageChannel;
        e.port1.onmessage = function(n) {
            r(n.data);
        }, n.postMessage(t, [
            e.port2
        ]);
    });
}
function $298177c8d02d9ab1$var$t(n) {
    var t = function(n, t) {
        if ("object" != typeof n || !n) return n;
        var r = n[Symbol.toPrimitive];
        if (void 0 !== r) {
            var e = r.call(n, t || "default");
            if ("object" != typeof e) return e;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === t ? String : Number)(n);
    }(n, "string");
    return "symbol" == (typeof t === "undefined" ? "undefined" : (0, $gnDeW._)(t)) ? t : t + "";
}
function $298177c8d02d9ab1$var$r(n, r) {
    for(var e = 0; e < r.length; e++){
        var i = r[e];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(n, $298177c8d02d9ab1$var$t(i.key), i);
    }
}
function $298177c8d02d9ab1$var$e(n, t) {
    return $298177c8d02d9ab1$var$e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function e(n, t) {
        return n.__proto__ = t, n;
    }, $298177c8d02d9ab1$var$e(n, t);
}
function $298177c8d02d9ab1$var$i(n, t) {
    (null == t || t > n.length) && (t = n.length);
    for(var r = 0, e = new Array(t); r < t; r++)e[r] = n[r];
    return e;
}
function $298177c8d02d9ab1$var$o(n, t) {
    var r = "undefined" != typeof Symbol && n[Symbol.iterator] || n["@@iterator"];
    if (r) return (r = r.call(n)).next.bind(r);
    if (Array.isArray(n) || (r = function(n, t) {
        if (n) {
            if ("string" == typeof n) return $298177c8d02d9ab1$var$i(n, t);
            var r = Object.prototype.toString.call(n).slice(8, -1);
            return "Object" === r && n.constructor && (r = n.constructor.name), "Map" === r || "Set" === r ? Array.from(n) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? $298177c8d02d9ab1$var$i(n, t) : void 0;
        }
    }(n)) || t && n && "number" == typeof n.length) {
        r && (n = r);
        var e = 0;
        return function() {
            return e >= n.length ? {
                done: !0
            } : {
                done: !1,
                value: n[e++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
try {
    self["workbox:core:7.0.0"] && _();
} catch (n) {}
var $298177c8d02d9ab1$var$u = function u() {
    var n = this;
    this.promise = new Promise(function(t, r) {
        n.resolve = t, n.reject = r;
    });
};
function $298177c8d02d9ab1$var$a(n, t) {
    var r = location.href;
    return new URL(n, r).href === new URL(t, r).href;
}
var $298177c8d02d9ab1$export$207d7db167ba3e92 = function c(n, t) {
    this.type = n, Object.assign(this, t);
};
function $298177c8d02d9ab1$var$f(n, t, r) {
    return r ? t ? t(n) : n : (n && n.then || (n = Promise.resolve(n)), t ? n.then(t) : n);
}
function $298177c8d02d9ab1$var$s() {}
var $298177c8d02d9ab1$var$v = {
    type: "SKIP_WAITING"
};
function $298177c8d02d9ab1$var$h(n, t) {
    if (!t) return n && n.then ? n.then($298177c8d02d9ab1$var$s) : Promise.resolve();
}
var $298177c8d02d9ab1$export$7e2ffb4f33d5ddf0 = function(t) {
    function i(n, r) {
        var _$e, _$i;
        return void 0 === r && (r = {}), (_$e = t.call(this) || this).nn = {}, _$e.tn = 0, _$e.rn = new $298177c8d02d9ab1$var$u, _$e.en = new $298177c8d02d9ab1$var$u, _$e.on = new $298177c8d02d9ab1$var$u, _$e.un = 0, _$e.an = new Set, _$e.cn = function() {
            var _$n = _$e.fn, _$t = _$n.installing;
            _$e.tn > 0 || !$298177c8d02d9ab1$var$a(_$t.scriptURL, _$e.sn.toString()) || performance.now() > _$e.un + 6e4 ? (_$e.vn = _$t, _$n.removeEventListener("updatefound", _$e.cn)) : (_$e.hn = _$t, _$e.an.add(_$t), _$e.rn.resolve(_$t)), ++_$e.tn, _$t.addEventListener("statechange", _$e.ln);
        }, _$e.ln = function(n) {
            var _$t = _$e.fn, _$r = n.target, _$i = _$r.state, o = _$r === _$e.vn, u = {
                sw: _$r,
                isExternal: o,
                originalEvent: n
            };
            !o && _$e.mn && (u.isUpdate = !0), _$e.dispatchEvent(new $298177c8d02d9ab1$export$207d7db167ba3e92(_$i, u)), "installed" === _$i ? _$e.wn = self.setTimeout(function() {
                "installed" === _$i && _$t.waiting === _$r && _$e.dispatchEvent(new $298177c8d02d9ab1$export$207d7db167ba3e92("waiting", u));
            }, 200) : "activating" === _$i && (clearTimeout(_$e.wn), o || _$e.en.resolve(_$r));
        }, _$e.yn = function(n) {
            var _$t = _$e.hn, _$r = _$t !== navigator.serviceWorker.controller;
            _$e.dispatchEvent(new $298177c8d02d9ab1$export$207d7db167ba3e92("controlling", {
                isExternal: _$r,
                originalEvent: n,
                sw: _$t,
                isUpdate: _$e.mn
            })), _$r || _$e.on.resolve(_$t);
        }, _$e.gn = (_$i = function i(n) {
            var _$t = n.data, _$r = n.ports, _$i = n.source;
            return $298177c8d02d9ab1$var$f(_$e.getSW(), function() {
                _$e.an.has(_$i) && _$e.dispatchEvent(new $298177c8d02d9ab1$export$207d7db167ba3e92("message", {
                    data: _$t,
                    originalEvent: n,
                    ports: _$r,
                    sw: _$i
                }));
            });
        }, function() {
            for(var _$n = [], _$t = 0; _$t < arguments.length; _$t++)_$n[_$t] = arguments[_$t];
            try {
                return Promise.resolve(_$i.apply(this, _$n));
            } catch (n) {
                return Promise.reject(n);
            }
        }), _$e.sn = n, _$e.nn = r, navigator.serviceWorker.addEventListener("message", _$e.gn), _$e;
    }
    var o, s;
    s = t, (o = i).prototype = Object.create(s.prototype), o.prototype.constructor = o, $298177c8d02d9ab1$var$e(o, s);
    var l, m, w, y = i.prototype;
    return y.register = function(n) {
        var _$t = (void 0 === n ? {} : n).immediate, _$r = void 0 !== _$t && _$t;
        try {
            var _$e = this;
            return $298177c8d02d9ab1$var$f(function(n, t) {
                var _$r = n();
                if (_$r && _$r.then) return _$r.then(t);
                return t(_$r);
            }(function() {
                if (!_$r && "complete" !== document.readyState) return $298177c8d02d9ab1$var$h(new Promise(function(n) {
                    return window.addEventListener("load", n);
                }));
            }, function() {
                return _$e.mn = Boolean(navigator.serviceWorker.controller), _$e.dn = _$e.pn(), $298177c8d02d9ab1$var$f(_$e.bn(), function(n) {
                    _$e.fn = n, _$e.dn && (_$e.hn = _$e.dn, _$e.en.resolve(_$e.dn), _$e.on.resolve(_$e.dn), _$e.dn.addEventListener("statechange", _$e.ln, {
                        once: !0
                    }));
                    var _$t = _$e.fn.waiting;
                    return _$t && $298177c8d02d9ab1$var$a(_$t.scriptURL, _$e.sn.toString()) && (_$e.hn = _$t, Promise.resolve().then(function() {
                        _$e.dispatchEvent(new $298177c8d02d9ab1$export$207d7db167ba3e92("waiting", {
                            sw: _$t,
                            wasWaitingBeforeRegister: !0
                        }));
                    }).then(function() {})), _$e.hn && (_$e.rn.resolve(_$e.hn), _$e.an.add(_$e.hn)), _$e.fn.addEventListener("updatefound", _$e.cn), navigator.serviceWorker.addEventListener("controllerchange", _$e.yn), _$e.fn;
                });
            }));
        } catch (n) {
            return Promise.reject(n);
        }
    }, y.update = function() {
        try {
            return this.fn ? $298177c8d02d9ab1$var$f($298177c8d02d9ab1$var$h(this.fn.update())) : $298177c8d02d9ab1$var$f();
        } catch (n) {
            return Promise.reject(n);
        }
    }, y.getSW = function() {
        return void 0 !== this.hn ? Promise.resolve(this.hn) : this.rn.promise;
    }, y.messageSW = function(t) {
        try {
            return $298177c8d02d9ab1$var$f(this.getSW(), function(r) {
                return $298177c8d02d9ab1$export$3a89f7c6642e8f16(r, t);
            });
        } catch (n) {
            return Promise.reject(n);
        }
    }, y.messageSkipWaiting = function() {
        this.fn && this.fn.waiting && $298177c8d02d9ab1$export$3a89f7c6642e8f16(this.fn.waiting, $298177c8d02d9ab1$var$v);
    }, y.pn = function() {
        var n = navigator.serviceWorker.controller;
        return n && $298177c8d02d9ab1$var$a(n.scriptURL, this.sn.toString()) ? n : void 0;
    }, y.bn = function() {
        try {
            var _$n = this;
            return $298177c8d02d9ab1$var$f(function(n, t) {
                try {
                    var _$r = n();
                } catch (n) {
                    return t(n);
                }
                if (_$r && _$r.then) return _$r.then(void 0, t);
                return _$r;
            }(function() {
                return $298177c8d02d9ab1$var$f(navigator.serviceWorker.register(_$n.sn, _$n.nn), function(t) {
                    return _$n.un = performance.now(), t;
                });
            }, function(n) {
                throw n;
            }));
        } catch (n) {
            return Promise.reject(n);
        }
    }, l = i, m = [
        {
            key: "active",
            get: function get() {
                return this.en.promise;
            }
        },
        {
            key: "controlling",
            get: function get() {
                return this.on.promise;
            }
        }
    ], $298177c8d02d9ab1$var$r(l.prototype, m), w && $298177c8d02d9ab1$var$r(l, w), Object.defineProperty(l, "prototype", {
        writable: !1
    }), l;
}(function() {
    function n() {
        this.Pn = new Map;
    }
    var t = n.prototype;
    return t.addEventListener = function(n, t) {
        this.jn(n).add(t);
    }, t.removeEventListener = function(n, t) {
        this.jn(n).delete(t);
    }, t.dispatchEvent = function(n) {
        n.target = this;
        for(var t, r = $298177c8d02d9ab1$var$o(this.jn(n.type)); !(t = r()).done;)(0, t.value)(n);
    }, t.jn = function(n) {
        return this.Pn.has(n) || this.Pn.set(n, new Set), this.Pn.get(n);
    }, n;
}());



var $55c3e9599dcfbee0$export$882461b6382ed46c;
var $55c3e9599dcfbee0$export$757ceba2d55c277e;
"use strict";

var $55c3e9599dcfbee0$var$i;
$55c3e9599dcfbee0$export$882461b6382ed46c = $e1a300cc66774841$exports.createRoot;
$55c3e9599dcfbee0$export$757ceba2d55c277e = $e1a300cc66774841$exports.hydrateRoot;


var $4d6b8652bfb48509$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4d6b8652bfb48509$var$wb = new (0, $298177c8d02d9ab1$export$7e2ffb4f33d5ddf0)("/sw.js");
(0, $3a3345637c0a5d6f$export$6ccbb43953eebf8)().workbox = $4d6b8652bfb48509$var$wb;
self.addEventListener("message", function(param) {
    var data = param.data;
    console.log("Browser Worker message:", data);
});
var $4d6b8652bfb48509$var$messageTest = function() {
    return $4d6b8652bfb48509$var$__awaiter(void 0, void 0, void 0, function() {
        var swVersion;
        return (0, $lF1I7.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $4d6b8652bfb48509$var$wb.messageSW({
                            type: "GET_VERSION"
                        })
                    ];
                case 1:
                    swVersion = _state.sent();
                    console.log("Service Worker version:", swVersion);
                    return [
                        2
                    ];
            }
        });
    });
};
$4d6b8652bfb48509$var$messageTest();
$4d6b8652bfb48509$var$wb.addEventListener("message", function(param) {
    var data = param.data;
    console.log("Browser #2 Worker message:", data);
});
$4d6b8652bfb48509$var$wb.register();
$4d6b8652bfb48509$var$wb.messageSW({
    type: "ping_test"
});
(0, $fe3694ddba3770ae$export$7a667d08ed65fa47)().init();
(0, $3959ba5a3cb8c567$export$dfb5619354ba860)();
(0, $b0lSM.configure)({
    enforceActions: "never"
});
self.addEventListener("unhandledrejection", function(param) {
    var reason = param.reason;
    var message = reason.message;
    if (message) self.alert(message);
});
var $4d6b8652bfb48509$var$serviceWorker = window.navigator.serviceWorker, $4d6b8652bfb48509$var$NODE_ENV = "production";
if ($4d6b8652bfb48509$var$NODE_ENV !== "development") $4d6b8652bfb48509$var$serviceWorker === null || $4d6b8652bfb48509$var$serviceWorker === void 0 || $4d6b8652bfb48509$var$serviceWorker.register("sw.js").then((0, $e5wYp.serviceWorkerUpdate)).then(function(worker) {
    if (window.confirm("New version of this Web App detected, update now?")) worker.postMessage({
        type: "SKIP_WAITING"
    });
});
$4d6b8652bfb48509$var$serviceWorker === null || $4d6b8652bfb48509$var$serviceWorker === void 0 || $4d6b8652bfb48509$var$serviceWorker.addEventListener("controllerchange", function() {
    return window.location.reload();
});
var $4d6b8652bfb48509$var$root = (0, $55c3e9599dcfbee0$export$882461b6382ed46c)(document.querySelector("#app"));
$4d6b8652bfb48509$var$root.render((0, $978b871a0234f592$exports.jsx)((0, $94a964d0ae980490$export$953c2efc134d7f79), {}));

})();
//# sourceMappingURL=index.9f9b31be.js.map
